/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 363);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(31);
var hide = __webpack_require__(23);
var redefine = __webpack_require__(24);
var ctx = __webpack_require__(32);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(574);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(572)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(68)('wks');
var uid = __webpack_require__(53);
var Symbol = __webpack_require__(6).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(34);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51), __webpack_require__(567).setImmediate))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(630));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(147);
var toPrimitive = __webpack_require__(38);
var dP = Object.defineProperty;

exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(39);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("VueLoading",[],e):"object"==typeof exports?exports.VueLoading=e():t.VueLoading=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=1)}([function(t,e,i){},function(t,e,i){"use strict";i.r(e);var n="undefined"!=typeof window?window.HTMLElement:Object,r={mounted:function(){document.addEventListener("focusin",this.focusIn)},methods:{focusIn:function(t){if(this.isActive&&t.target!==this.$el&&!this.$el.contains(t.target)){var e=this.container?this.container:this.isFullPage?null:this.$el.parentElement;(this.isFullPage||e&&e.contains(t.target))&&(t.preventDefault(),this.$el.focus())}}},beforeDestroy:function(){document.removeEventListener("focusin",this.focusIn)}};function a(t,e,i,n,r,a,o,s){var u,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=i,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),o?(u=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),u)if(l.functional){l._injectStyles=u;var c=l.render;l.render=function(t,e){return u.call(e),c(t,e)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,u):[u]}return{exports:t,options:l}}var o=a({name:"spinner",props:{color:{type:String,default:"#000"},height:{type:Number,default:64},width:{type:Number,default:64}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{viewBox:"0 0 38 38",xmlns:"http://www.w3.org/2000/svg",width:this.width,height:this.height,stroke:this.color}},[e("g",{attrs:{fill:"none","fill-rule":"evenodd"}},[e("g",{attrs:{transform:"translate(1 1)","stroke-width":"2"}},[e("circle",{attrs:{"stroke-opacity":".25",cx:"18",cy:"18",r:"18"}}),e("path",{attrs:{d:"M36 18c0-9.94-8.06-18-18-18"}},[e("animateTransform",{attrs:{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.8s",repeatCount:"indefinite"}})],1)])])])},[],!1,null,null,null).exports,s=a({name:"dots",props:{color:{type:String,default:"#000"},height:{type:Number,default:240},width:{type:Number,default:60}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{viewBox:"0 0 120 30",xmlns:"http://www.w3.org/2000/svg",fill:this.color,width:this.width,height:this.height}},[e("circle",{attrs:{cx:"15",cy:"15",r:"15"}},[e("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),e("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})]),e("circle",{attrs:{cx:"60",cy:"15",r:"9","fill-opacity":"0.3"}},[e("animate",{attrs:{attributeName:"r",from:"9",to:"9",begin:"0s",dur:"0.8s",values:"9;15;9",calcMode:"linear",repeatCount:"indefinite"}}),e("animate",{attrs:{attributeName:"fill-opacity",from:"0.5",to:"0.5",begin:"0s",dur:"0.8s",values:".5;1;.5",calcMode:"linear",repeatCount:"indefinite"}})]),e("circle",{attrs:{cx:"105",cy:"15",r:"15"}},[e("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),e("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})])])},[],!1,null,null,null).exports,u=a({name:"bars",props:{color:{type:String,default:"#000"},height:{type:Number,default:40},width:{type:Number,default:40}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 30 30",height:this.height,width:this.width,fill:this.color}},[e("rect",{attrs:{x:"0",y:"13",width:"4",height:"5"}},[e("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}}),e("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}})]),e("rect",{attrs:{x:"10",y:"13",width:"4",height:"5"}},[e("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}}),e("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}})]),e("rect",{attrs:{x:"20",y:"13",width:"4",height:"5"}},[e("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}}),e("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}})])])},[],!1,null,null,null).exports,l=a({name:"vue-loading",mixins:[r],props:{active:Boolean,programmatic:Boolean,container:[Object,Function,n],isFullPage:{type:Boolean,default:!0},transition:{type:String,default:"fade"},canCancel:Boolean,onCancel:{type:Function,default:function(){}},color:String,backgroundColor:String,opacity:Number,width:Number,height:Number,zIndex:Number,loader:{type:String,default:"spinner"}},data:function(){return{isActive:this.active}},components:{Spinner:o,Dots:s,Bars:u},beforeMount:function(){this.programmatic&&(this.container?(this.isFullPage=!1,this.container.appendChild(this.$el)):document.body.appendChild(this.$el))},mounted:function(){this.programmatic&&(this.isActive=!0),document.addEventListener("keyup",this.keyPress)},methods:{cancel:function(){this.canCancel&&this.isActive&&(this.hide(),this.onCancel.apply(null,arguments))},hide:function(){var t=this;this.$emit("hide"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){var e;t.$destroy(),void 0!==(e=t.$el).remove?e.remove():e.parentNode.removeChild(e)},150))},keyPress:function(t){27===t.keyCode&&this.cancel()}},watch:{active:function(t){this.isActive=t}},beforeDestroy:function(){document.removeEventListener("keyup",this.keyPress)}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:t.transition}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isActive,expression:"isActive"}],staticClass:"vld-overlay is-active",class:{"is-full-page":t.isFullPage},style:{zIndex:this.zIndex},attrs:{tabindex:"0","aria-busy":t.isActive,"aria-label":"Loading"}},[i("div",{staticClass:"vld-background",style:{background:this.backgroundColor,opacity:this.opacity},on:{click:function(e){return e.preventDefault(),t.cancel(e)}}}),i("div",{staticClass:"vld-icon"},[t._t("before"),t._t("default",[i(t.loader,{tag:"component",attrs:{color:t.color,width:t.width,height:t.height}})]),t._t("after")],2)])])},[],!1,null,null,null).exports,c=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return{show:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i,a=Object.assign({},e,n,{programmatic:!0}),o=new(t.extend(l))({el:document.createElement("div"),propsData:a}),s=Object.assign({},i,r);return Object.keys(s).map(function(t){o.$slots[t]=s[t]}),o}}};i(0);l.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=c(t,e,i);t.$loading=n,t.prototype.$loading=n};e.default=l}]).default});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d7348b76", content, true, {});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TEXTBOX_INPUT_TYPE; });
var FORM_TYPE = {
  TEXTBOX: 1,
  TEXTAREA: 2,
  CHECKBOX: 3,
  RADIO: 4,
  DROPDOWN: 5,
  DATEPICKER: 6,
  ARRAY_OBJECT: 7,
  SLOT: 8,
  DAY_HOURS_SELECTOR: 9,
  SALARY_RANGE: 10,
  HEADER: 11
};

var ACTION_TYPE = {
  ADD: 1,
  UPDATE: 2,
  DELETE: 3
};

var TEXTBOX_INPUT_TYPE = {
  TEXT: "TEXT",
  INTEGER: "INTEGER",
  POSITIVE_INTEGER: "POSITIVE_INTEGER",
  POSITIVE_DOUBLE: "POSITIVE_DOUBLE",
  DOUBLE: "DOUBLE"
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Doc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Editor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditorContent; });
/* unused harmony export EditorFloatingMenu */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditorMenuBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EditorMenuBubble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Extension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Mark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Node; });
/* unused harmony export Paragraph */
/* unused harmony export Text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(21);
/* unused harmony reexport NodeSelection */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]; });
/* unused harmony reexport TextSelection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_dropcursor__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_keymap__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prosemirror_commands__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prosemirror_inputrules__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiptap_utils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tiptap_commands__ = __webpack_require__(230);

    /*!
    * tiptap v1.26.4
    * (c) 2019 Scrumpy UG (limited liability)
    * @license MIT
    */
  













function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function camelCase (str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

var ComponentView =
/*#__PURE__*/
function () {
  function ComponentView(component, _ref) {
    var editor = _ref.editor,
        extension = _ref.extension,
        parent = _ref.parent,
        node = _ref.node,
        view = _ref.view,
        decorations = _ref.decorations,
        getPos = _ref.getPos;

    _classCallCheck(this, ComponentView);

    this.component = component;
    this.editor = editor;
    this.extension = extension;
    this.parent = parent;
    this.node = node;
    this.view = view;
    this.decorations = decorations;
    this.isNode = !!this.node.marks;
    this.isMark = !this.isNode;
    this.getPos = this.isMark ? this.getMarkPos : getPos;
    this.captureEvents = true;
    this.dom = this.createDOM();
    this.contentDOM = this.vm.$refs.content;
  }

  _createClass(ComponentView, [{
    key: "createDOM",
    value: function createDOM() {
      var _this = this;

      var Component = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].extend(this.component);
      var props = {
        editor: this.editor,
        node: this.node,
        view: this.view,
        getPos: function getPos() {
          return _this.getPos();
        },
        decorations: this.decorations,
        selected: false,
        options: this.extension.options,
        updateAttrs: function updateAttrs(attrs) {
          return _this.updateAttrs(attrs);
        }
      };

      if (typeof this.extension.setSelection === 'function') {
        this.setSelection = this.extension.setSelection;
      }

      this.vm = new Component({
        parent: this.parent,
        propsData: props
      }).$mount();
      return this.vm.$el;
    }
  }, {
    key: "update",
    value: function update(node, decorations) {
      if (node.type !== this.node.type) {
        return false;
      }

      if (node === this.node && this.decorations === decorations) {
        return true;
      }

      this.node = node;
      this.decorations = decorations;
      this.updateComponentProps({
        node: node,
        decorations: decorations
      });
      return true;
    }
  }, {
    key: "updateComponentProps",
    value: function updateComponentProps(props) {
      var _this2 = this;

      if (!this.vm._props) {
        return;
      } // Update props in component
      // TODO: Avoid mutating a prop directly.
      // Maybe there is a better way to do this?


      var originalSilent = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.silent;
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.silent = true;
      Object.entries(props).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        _this2.vm._props[key] = value;
      }); // this.vm._props.node = node
      // this.vm._props.decorations = decorations

      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.silent = originalSilent;
    }
  }, {
    key: "updateAttrs",
    value: function updateAttrs(attrs) {
      if (!this.view.editable) {
        return;
      }

      var state = this.view.state;
      var type = this.node.type;
      var pos = this.getPos();

      var newAttrs = _objectSpread2({}, this.node.attrs, {}, attrs);

      var transaction = this.isMark ? state.tr.removeMark(pos.from, pos.to, type).addMark(pos.from, pos.to, type.create(newAttrs)) : state.tr.setNodeMarkup(pos, null, newAttrs);
      this.view.dispatch(transaction);
    } // prevent a full re-render of the vue component on update
    // we'll handle prop updates in `update()`

  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      // allow leaf nodes to be selected
      if (mutation.type === 'selection') {
        return false;
      }

      if (!this.contentDOM) {
        return true;
      }

      return !this.contentDOM.contains(mutation.target);
    } // disable (almost) all prosemirror event listener for node views

  }, {
    key: "stopEvent",
    value: function stopEvent(event) {
      var _this3 = this;

      if (typeof this.extension.stopEvent === 'function') {
        return this.extension.stopEvent(event);
      }

      var draggable = !!this.extension.schema.draggable; // support a custom drag handle

      if (draggable && event.type === 'mousedown') {
        var dragHandle = event.target.closest && event.target.closest('[data-drag-handle]');
        var isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));

        if (isValidDragHandle) {
          this.captureEvents = false;
          document.addEventListener('dragend', function () {
            _this3.captureEvents = true;
          }, {
            once: true
          });
        }
      }

      var isCopy = event.type === 'copy';
      var isPaste = event.type === 'paste';
      var isCut = event.type === 'cut';
      var isDrag = event.type.startsWith('drag') || event.type === 'drop';

      if (draggable && isDrag || isCopy || isPaste || isCut) {
        return false;
      }

      return this.captureEvents;
    }
  }, {
    key: "selectNode",
    value: function selectNode() {
      this.updateComponentProps({
        selected: true
      });
    }
  }, {
    key: "deselectNode",
    value: function deselectNode() {
      this.updateComponentProps({
        selected: false
      });
    }
  }, {
    key: "getMarkPos",
    value: function getMarkPos() {
      var pos = this.view.posAtDOM(this.dom);
      var resolvedPos = this.view.state.doc.resolve(pos);
      var range = Object(__WEBPACK_IMPORTED_MODULE_8_tiptap_utils__["b" /* getMarkRange */])(resolvedPos, this.node.type);
      return range;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.vm.$destroy();
    }
  }]);

  return ComponentView;
}();

var Emitter =
/*#__PURE__*/
function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: "on",
    // Add an event listener for given event
    value: function on(event, fn) {
      this._callbacks = this._callbacks || {}; // Create namespace for this event

      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }

      this._callbacks[event].push(fn);

      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this._callbacks = this._callbacks || {};
      var callbacks = this._callbacks[event];

      if (callbacks) {
        callbacks.forEach(function (callback) {
          return callback.apply(_this, args);
        });
      }

      return this;
    } // Remove event listener for given event.
    // If fn is not provided, all event listeners for that event will be removed.
    // If neither is provided, all event listeners will be removed.

  }, {
    key: "off",
    value: function off(event, fn) {
      if (!arguments.length) {
        this._callbacks = {};
      } else {
        // event listeners for the given event
        var callbacks = this._callbacks ? this._callbacks[event] : null;

        if (callbacks) {
          if (fn) {
            this._callbacks[event] = callbacks.filter(function (cb) {
              return cb !== fn;
            }); // remove specific handler
          } else {
            delete this._callbacks[event]; // remove all handlers
          }
        }
      }

      return this;
    }
  }]);

  return Emitter;
}();

var Extension =
/*#__PURE__*/
function () {
  function Extension() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Extension);

    this.options = _objectSpread2({}, this.defaultOptions, {}, options);
  }

  _createClass(Extension, [{
    key: "init",
    value: function init() {
      return null;
    }
  }, {
    key: "bindEditor",
    value: function bindEditor() {
      var editor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.editor = editor;
    }
  }, {
    key: "inputRules",
    value: function inputRules() {
      return [];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules() {
      return [];
    }
  }, {
    key: "keys",
    value: function keys() {
      return {};
    }
  }, {
    key: "name",
    get: function get() {
      return null;
    }
  }, {
    key: "type",
    get: function get() {
      return 'extension';
    }
  }, {
    key: "update",
    get: function get() {
      return function () {};
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {};
    }
  }, {
    key: "plugins",
    get: function get() {
      return [];
    }
  }]);

  return Extension;
}();

var ExtensionManager =
/*#__PURE__*/
function () {
  function ExtensionManager() {
    var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var editor = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, ExtensionManager);

    extensions.forEach(function (extension) {
      extension.bindEditor(editor);
      extension.init();
    });
    this.extensions = extensions;
  }

  _createClass(ExtensionManager, [{
    key: "keymaps",
    value: function keymaps(_ref) {
      var schema = _ref.schema;
      var extensionKeymaps = this.extensions.filter(function (extension) {
        return ['extension'].includes(extension.type);
      }).filter(function (extension) {
        return extension.keys;
      }).map(function (extension) {
        return extension.keys({
          schema: schema
        });
      });
      var nodeMarkKeymaps = this.extensions.filter(function (extension) {
        return ['node', 'mark'].includes(extension.type);
      }).filter(function (extension) {
        return extension.keys;
      }).map(function (extension) {
        return extension.keys({
          type: schema["".concat(extension.type, "s")][extension.name],
          schema: schema
        });
      });
      return [].concat(_toConsumableArray(extensionKeymaps), _toConsumableArray(nodeMarkKeymaps)).map(function (keys) {
        return Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_keymap__["b" /* keymap */])(keys);
      });
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var schema = _ref2.schema,
          excludedExtensions = _ref2.excludedExtensions;
      if (!(excludedExtensions instanceof Array) && excludedExtensions) return [];
      var allowedExtensions = excludedExtensions instanceof Array ? this.extensions.filter(function (extension) {
        return !excludedExtensions.includes(extension.name);
      }) : this.extensions;
      var extensionInputRules = allowedExtensions.filter(function (extension) {
        return ['extension'].includes(extension.type);
      }).filter(function (extension) {
        return extension.inputRules;
      }).map(function (extension) {
        return extension.inputRules({
          schema: schema
        });
      });
      var nodeMarkInputRules = allowedExtensions.filter(function (extension) {
        return ['node', 'mark'].includes(extension.type);
      }).filter(function (extension) {
        return extension.inputRules;
      }).map(function (extension) {
        return extension.inputRules({
          type: schema["".concat(extension.type, "s")][extension.name],
          schema: schema
        });
      });
      return [].concat(_toConsumableArray(extensionInputRules), _toConsumableArray(nodeMarkInputRules)).reduce(function (allInputRules, inputRules) {
        return [].concat(_toConsumableArray(allInputRules), _toConsumableArray(inputRules));
      }, []);
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref3) {
      var schema = _ref3.schema,
          excludedExtensions = _ref3.excludedExtensions;
      if (!(excludedExtensions instanceof Array) && excludedExtensions) return [];
      var allowedExtensions = excludedExtensions instanceof Array ? this.extensions.filter(function (extension) {
        return !excludedExtensions.includes(extension.name);
      }) : this.extensions;
      var extensionPasteRules = allowedExtensions.filter(function (extension) {
        return ['extension'].includes(extension.type);
      }).filter(function (extension) {
        return extension.pasteRules;
      }).map(function (extension) {
        return extension.pasteRules({
          schema: schema
        });
      });
      var nodeMarkPasteRules = allowedExtensions.filter(function (extension) {
        return ['node', 'mark'].includes(extension.type);
      }).filter(function (extension) {
        return extension.pasteRules;
      }).map(function (extension) {
        return extension.pasteRules({
          type: schema["".concat(extension.type, "s")][extension.name],
          schema: schema
        });
      });
      return [].concat(_toConsumableArray(extensionPasteRules), _toConsumableArray(nodeMarkPasteRules)).reduce(function (allPasteRules, pasteRules) {
        return [].concat(_toConsumableArray(allPasteRules), _toConsumableArray(pasteRules));
      }, []);
    }
  }, {
    key: "commands",
    value: function commands(_ref4) {
      var schema = _ref4.schema,
          view = _ref4.view;
      return this.extensions.filter(function (extension) {
        return extension.commands;
      }).reduce(function (allCommands, extension) {
        var name = extension.name,
            type = extension.type;
        var commands = {};
        var value = extension.commands(_objectSpread2({
          schema: schema
        }, ['node', 'mark'].includes(type) ? {
          type: schema["".concat(type, "s")][name]
        } : {}));

        var apply = function apply(cb, attrs) {
          if (!view.editable) {
            return false;
          }

          view.focus();
          return cb(attrs)(view.state, view.dispatch, view);
        };

        var handle = function handle(_name, _value) {
          if (Array.isArray(_value)) {
            commands[_name] = function (attrs) {
              return _value.forEach(function (callback) {
                return apply(callback, attrs);
              });
            };
          } else if (typeof _value === 'function') {
            commands[_name] = function (attrs) {
              return apply(_value, attrs);
            };
          }
        };

        if (_typeof(value) === 'object') {
          Object.entries(value).forEach(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                commandName = _ref6[0],
                commandValue = _ref6[1];

            handle(commandName, commandValue);
          });
        } else {
          handle(name, value);
        }

        return _objectSpread2({}, allCommands, {}, commands);
      }, {});
    }
  }, {
    key: "nodes",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return extension.type === 'node';
      }).reduce(function (nodes, _ref7) {
        var name = _ref7.name,
            schema = _ref7.schema;
        return _objectSpread2({}, nodes, _defineProperty({}, name, schema));
      }, {});
    }
  }, {
    key: "options",
    get: function get() {
      var view = this.view;
      return this.extensions.reduce(function (nodes, extension) {
        return _objectSpread2({}, nodes, _defineProperty({}, extension.name, new Proxy(extension.options, {
          set: function set(obj, prop, value) {
            var changed = obj[prop] !== value;
            Object.assign(obj, _defineProperty({}, prop, value));

            if (changed) {
              extension.update(view);
            }

            return true;
          }
        })));
      }, {});
    }
  }, {
    key: "marks",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return extension.type === 'mark';
      }).reduce(function (marks, _ref8) {
        var name = _ref8.name,
            schema = _ref8.schema;
        return _objectSpread2({}, marks, _defineProperty({}, name, schema));
      }, {});
    }
  }, {
    key: "plugins",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return extension.plugins;
      }).reduce(function (allPlugins, _ref9) {
        var plugins = _ref9.plugins;
        return [].concat(_toConsumableArray(allPlugins), _toConsumableArray(plugins));
      }, []);
    }
  }]);

  return ExtensionManager;
}();

function injectCSS (css) {
  if (true) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = css;
    var _document = document,
        head = _document.head;
    var firstChild = head.firstChild;

    if (firstChild) {
      head.insertBefore(style, firstChild);
    } else {
      head.appendChild(style);
    }
  }
}

var Mark =
/*#__PURE__*/
function (_Extension) {
  _inherits(Mark, _Extension);

  function Mark() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Mark);

    return _possibleConstructorReturn(this, _getPrototypeOf(Mark).call(this, options));
  }

  _createClass(Mark, [{
    key: "command",
    value: function command() {
      return function () {};
    }
  }, {
    key: "type",
    get: function get() {
      return 'mark';
    }
  }, {
    key: "view",
    get: function get() {
      return null;
    }
  }, {
    key: "schema",
    get: function get() {
      return null;
    }
  }]);

  return Mark;
}(Extension);

function minMax() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.min(Math.max(parseInt(value, 10), min), max);
}

var Node =
/*#__PURE__*/
function (_Extension) {
  _inherits(Node, _Extension);

  function Node() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Node);

    return _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this, options));
  }

  _createClass(Node, [{
    key: "command",
    value: function command() {
      return function () {};
    }
  }, {
    key: "type",
    get: function get() {
      return 'node';
    }
  }, {
    key: "view",
    get: function get() {
      return null;
    }
  }, {
    key: "schema",
    get: function get() {
      return null;
    }
  }]);

  return Node;
}(Extension);

var Doc =
/*#__PURE__*/
function (_Node) {
  _inherits(Doc, _Node);

  function Doc() {
    _classCallCheck(this, Doc);

    return _possibleConstructorReturn(this, _getPrototypeOf(Doc).apply(this, arguments));
  }

  _createClass(Doc, [{
    key: "name",
    get: function get() {
      return 'doc';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'block+'
      };
    }
  }]);

  return Doc;
}(Node);

var Paragraph =
/*#__PURE__*/
function (_Node) {
  _inherits(Paragraph, _Node);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, _getPrototypeOf(Paragraph).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_10_tiptap_commands__["k" /* setBlockType */])(type);
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'paragraph';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'inline*',
        group: 'block',
        draggable: false,
        parseDOM: [{
          tag: 'p'
        }],
        toDOM: function toDOM() {
          return ['p', 0];
        }
      };
    }
  }]);

  return Paragraph;
}(Node);

var Text =
/*#__PURE__*/
function (_Node) {
  _inherits(Text, _Node);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, _getPrototypeOf(Text).apply(this, arguments));
  }

  _createClass(Text, [{
    key: "name",
    get: function get() {
      return 'text';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: 'inline'
      };
    }
  }]);

  return Text;
}(Node);

var css = ".ProseMirror {\n  position: relative;\n}\n\n.ProseMirror {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  -webkit-font-variant-ligatures: none;\n  font-variant-ligatures: none;\n}\n\n.ProseMirror pre {\n  white-space: pre-wrap;\n}\n\n.ProseMirror-gapcursor {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n}\n\n.ProseMirror-gapcursor:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;\n}\n\n@keyframes ProseMirror-cursor-blink {\n  to {\n    visibility: hidden;\n  }\n}\n\n.ProseMirror-hideselection *::selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection *::-moz-selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection * {\n  caret-color: transparent;\n}\n\n.ProseMirror-focused .ProseMirror-gapcursor {\n  display: block;\n}\n";

var Editor =
/*#__PURE__*/
function (_Emitter) {
  _inherits(Editor, _Emitter);

  function Editor() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Editor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Editor).call(this));
    _this.defaultOptions = {
      editorProps: {},
      editable: true,
      autoFocus: null,
      extensions: [],
      content: '',
      topNode: 'doc',
      emptyDocument: {
        type: 'doc',
        content: [{
          type: 'paragraph'
        }]
      },
      useBuiltInExtensions: true,
      disableInputRules: false,
      disablePasteRules: false,
      dropCursor: {},
      parseOptions: {},
      injectCSS: true,
      onInit: function onInit() {},
      onTransaction: function onTransaction() {},
      onUpdate: function onUpdate() {},
      onFocus: function onFocus() {},
      onBlur: function onBlur() {},
      onPaste: function onPaste() {},
      onDrop: function onDrop() {}
    };
    _this.events = ['init', 'transaction', 'update', 'focus', 'blur', 'paste', 'drop'];

    _this.init(options);

    return _this;
  }

  _createClass(Editor, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.setOptions(_objectSpread2({}, this.defaultOptions, {}, options));
      this.focused = false;
      this.selection = {
        from: 0,
        to: 0
      };
      this.element = document.createElement('div');
      this.extensions = this.createExtensions();
      this.nodes = this.createNodes();
      this.marks = this.createMarks();
      this.schema = this.createSchema();
      this.plugins = this.createPlugins();
      this.keymaps = this.createKeymaps();
      this.inputRules = this.createInputRules();
      this.pasteRules = this.createPasteRules();
      this.view = this.createView();
      this.commands = this.createCommands();
      this.setActiveNodesAndMarks();

      if (this.options.injectCSS) {
        injectCSS(css);
      }

      if (this.options.autoFocus !== null) {
        this.focus(this.options.autoFocus);
      }

      this.events.forEach(function (name) {
        _this2.on(name, _this2.options[camelCase("on ".concat(name))] || function () {});
      });
      this.emit('init', {
        view: this.view,
        state: this.state
      }); // give extension manager access to our view

      this.extensions.view = this.view;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread2({}, this.options, {}, options);

      if (this.view && this.state) {
        this.view.updateState(this.state);
      }
    }
  }, {
    key: "createExtensions",
    value: function createExtensions() {
      return new ExtensionManager([].concat(_toConsumableArray(this.builtInExtensions), _toConsumableArray(this.options.extensions)), this);
    }
  }, {
    key: "createPlugins",
    value: function createPlugins() {
      return this.extensions.plugins;
    }
  }, {
    key: "createKeymaps",
    value: function createKeymaps() {
      return this.extensions.keymaps({
        schema: this.schema
      });
    }
  }, {
    key: "createInputRules",
    value: function createInputRules() {
      return this.extensions.inputRules({
        schema: this.schema,
        excludedExtensions: this.options.disableInputRules
      });
    }
  }, {
    key: "createPasteRules",
    value: function createPasteRules() {
      return this.extensions.pasteRules({
        schema: this.schema,
        excludedExtensions: this.options.disablePasteRules
      });
    }
  }, {
    key: "createCommands",
    value: function createCommands() {
      return this.extensions.commands({
        schema: this.schema,
        view: this.view
      });
    }
  }, {
    key: "createNodes",
    value: function createNodes() {
      return this.extensions.nodes;
    }
  }, {
    key: "createMarks",
    value: function createMarks() {
      return this.extensions.marks;
    }
  }, {
    key: "createSchema",
    value: function createSchema() {
      return new __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Schema"]({
        topNode: this.options.topNode,
        nodes: this.nodes,
        marks: this.marks
      });
    }
  }, {
    key: "createState",
    value: function createState() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["EditorState"].create({
        schema: this.schema,
        doc: this.createDocument(this.options.content),
        plugins: [].concat(_toConsumableArray(this.plugins), [Object(__WEBPACK_IMPORTED_MODULE_7_prosemirror_inputrules__["b" /* inputRules */])({
          rules: this.inputRules
        })], _toConsumableArray(this.pasteRules), _toConsumableArray(this.keymaps), [Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_keymap__["b" /* keymap */])({
          Backspace: __WEBPACK_IMPORTED_MODULE_7_prosemirror_inputrules__["d" /* undoInputRule */]
        }), Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_keymap__["b" /* keymap */])(__WEBPACK_IMPORTED_MODULE_6_prosemirror_commands__["a" /* baseKeymap */]), Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_dropcursor__["a" /* dropCursor */])(this.options.dropCursor), Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__["a" /* gapCursor */])(), new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
          key: new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('editable'),
          props: {
            editable: function editable() {
              return _this3.options.editable;
            }
          }
        }), new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
          props: {
            attributes: {
              tabindex: 0
            },
            handleDOMEvents: {
              focus: function focus(view, event) {
                _this3.focused = true;

                _this3.emit('focus', {
                  event: event,
                  state: view.state,
                  view: view
                });

                var transaction = _this3.state.tr.setMeta('focused', true);

                _this3.view.dispatch(transaction);
              },
              blur: function blur(view, event) {
                _this3.focused = false;

                _this3.emit('blur', {
                  event: event,
                  state: view.state,
                  view: view
                });

                var transaction = _this3.state.tr.setMeta('focused', false);

                _this3.view.dispatch(transaction);
              }
            }
          }
        }), new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
          props: this.options.editorProps
        })])
      });
    }
  }, {
    key: "createDocument",
    value: function createDocument(content) {
      var parseOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.parseOptions;

      if (content === null) {
        return this.schema.nodeFromJSON(this.options.emptyDocument);
      }

      if (_typeof(content) === 'object') {
        try {
          return this.schema.nodeFromJSON(content);
        } catch (error) {
          console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
          return this.schema.nodeFromJSON(this.options.emptyDocument);
        }
      }

      if (typeof content === 'string') {
        var element = document.createElement('div');
        element.innerHTML = content.trim();
        return __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMParser"].fromSchema(this.schema).parse(element, parseOptions);
      }

      return false;
    }
  }, {
    key: "createView",
    value: function createView() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["c" /* EditorView */](this.element, {
        state: this.createState(),
        handlePaste: function handlePaste() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this4.emit.apply(_this4, ['paste'].concat(args));
        },
        handleDrop: function handleDrop() {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          _this4.emit.apply(_this4, ['drop'].concat(args));
        },
        dispatchTransaction: this.dispatchTransaction.bind(this)
      });
    }
  }, {
    key: "setParentComponent",
    value: function setParentComponent() {
      var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!component) {
        return;
      }

      this.view.setProps({
        nodeViews: this.initNodeViews({
          parent: component,
          extensions: [].concat(_toConsumableArray(this.builtInExtensions), _toConsumableArray(this.options.extensions))
        })
      });
    }
  }, {
    key: "initNodeViews",
    value: function initNodeViews(_ref) {
      var _this5 = this;

      var parent = _ref.parent,
          extensions = _ref.extensions;
      return extensions.filter(function (extension) {
        return ['node', 'mark'].includes(extension.type);
      }).filter(function (extension) {
        return extension.view;
      }).reduce(function (nodeViews, extension) {
        var nodeView = function nodeView(node, view, getPos, decorations) {
          var component = extension.view;
          return new ComponentView(component, {
            editor: _this5,
            extension: extension,
            parent: parent,
            node: node,
            view: view,
            getPos: getPos,
            decorations: decorations
          });
        };

        return _objectSpread2({}, nodeViews, _defineProperty({}, extension.name, nodeView));
      }, {});
    }
  }, {
    key: "dispatchTransaction",
    value: function dispatchTransaction(transaction) {
      var newState = this.state.apply(transaction);
      this.view.updateState(newState);
      this.selection = {
        from: this.state.selection.from,
        to: this.state.selection.to
      };
      this.setActiveNodesAndMarks();
      this.emit('transaction', {
        getHTML: this.getHTML.bind(this),
        getJSON: this.getJSON.bind(this),
        state: this.state,
        transaction: transaction
      });

      if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
        return;
      }

      this.emitUpdate(transaction);
    }
  }, {
    key: "emitUpdate",
    value: function emitUpdate(transaction) {
      this.emit('update', {
        getHTML: this.getHTML.bind(this),
        getJSON: this.getJSON.bind(this),
        state: this.state,
        transaction: transaction
      });
    }
  }, {
    key: "resolveSelection",
    value: function resolveSelection() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.selection && position === null) {
        return this.selection;
      }

      if (position === 'start' || position === true) {
        return {
          from: 0,
          to: 0
        };
      }

      if (position === 'end') {
        var doc = this.state.doc;
        return {
          from: doc.content.size,
          to: doc.content.size
        };
      }

      return {
        from: position,
        to: position
      };
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this6 = this;

      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.view.focused && position === null || position === false) {
        return;
      }

      var _this$resolveSelectio = this.resolveSelection(position),
          from = _this$resolveSelectio.from,
          to = _this$resolveSelectio.to;

      this.setSelection(from, to);
      setTimeout(function () {
        return _this6.view.focus();
      }, 10);
    }
  }, {
    key: "setSelection",
    value: function setSelection() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$state = this.state,
          doc = _this$state.doc,
          tr = _this$state.tr;
      var resolvedFrom = minMax(from, 0, doc.content.size);
      var resolvedEnd = minMax(to, 0, doc.content.size);
      var selection = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(doc, resolvedFrom, resolvedEnd);
      var transaction = tr.setSelection(selection);
      this.view.dispatch(transaction);
    }
  }, {
    key: "blur",
    value: function blur() {
      this.view.dom.blur();
    }
  }, {
    key: "getSchemaJSON",
    value: function getSchemaJSON() {
      return JSON.parse(JSON.stringify({
        nodes: this.extensions.nodes,
        marks: this.extensions.marks
      }));
    }
  }, {
    key: "getHTML",
    value: function getHTML() {
      var div = document.createElement('div');
      var fragment = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMSerializer"].fromSchema(this.schema).serializeFragment(this.state.doc.content);
      div.appendChild(fragment);
      return div.innerHTML;
    }
  }, {
    key: "getJSON",
    value: function getJSON() {
      return this.state.doc.toJSON();
    }
  }, {
    key: "setContent",
    value: function setContent() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var emitUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var parseOptions = arguments.length > 2 ? arguments[2] : undefined;
      var _this$state2 = this.state,
          doc = _this$state2.doc,
          tr = _this$state2.tr;
      var document = this.createDocument(content, parseOptions);
      var selection = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(doc, 0, doc.content.size);
      var transaction = tr.setSelection(selection).replaceSelectionWith(document, false).setMeta('preventUpdate', !emitUpdate);
      this.view.dispatch(transaction);
    }
  }, {
    key: "clearContent",
    value: function clearContent() {
      var emitUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.setContent(this.options.emptyDocument, emitUpdate);
    }
  }, {
    key: "setActiveNodesAndMarks",
    value: function setActiveNodesAndMarks() {
      var _this7 = this;

      this.activeMarks = Object.entries(this.schema.marks).reduce(function (marks, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            name = _ref3[0],
            mark = _ref3[1];

        return _objectSpread2({}, marks, _defineProperty({}, name, function () {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Object(__WEBPACK_IMPORTED_MODULE_8_tiptap_utils__["c" /* markIsActive */])(_this7.state, mark, attrs);
        }));
      }, {});
      this.activeMarkAttrs = Object.entries(this.schema.marks).reduce(function (marks, _ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            name = _ref5[0],
            mark = _ref5[1];

        return _objectSpread2({}, marks, _defineProperty({}, name, Object(__WEBPACK_IMPORTED_MODULE_8_tiptap_utils__["a" /* getMarkAttrs */])(_this7.state, mark)));
      }, {});
      this.activeNodes = Object.entries(this.schema.nodes).reduce(function (nodes, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            name = _ref7[0],
            node = _ref7[1];

        return _objectSpread2({}, nodes, _defineProperty({}, name, function () {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Object(__WEBPACK_IMPORTED_MODULE_8_tiptap_utils__["e" /* nodeIsActive */])(_this7.state, node, attrs);
        }));
      }, {});
    }
  }, {
    key: "getMarkAttrs",
    value: function getMarkAttrs() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.activeMarkAttrs[type];
    }
  }, {
    key: "registerPlugin",
    value: function registerPlugin() {
      var plugin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!plugin) {
        return;
      }

      var newState = this.state.reconfigure({
        plugins: this.state.plugins.concat([plugin])
      });
      this.view.updateState(newState);
    }
  }, {
    key: "unregisterPlugin",
    value: function unregisterPlugin() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!name || !this.view.docView) {
        return;
      }

      var newState = this.state.reconfigure({
        plugins: this.state.plugins.filter(function (plugin) {
          return !plugin.key.startsWith("".concat(name, "$"));
        })
      });
      this.view.updateState(newState);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.view) {
        return;
      }

      this.view.destroy();
    }
  }, {
    key: "builtInExtensions",
    get: function get() {
      if (!this.options.useBuiltInExtensions) {
        return [];
      }

      return [new Doc(), new Text(), new Paragraph()];
    }
  }, {
    key: "state",
    get: function get() {
      return this.view ? this.view.state : null;
    }
  }, {
    key: "isActive",
    get: function get() {
      return Object.entries(_objectSpread2({}, this.activeMarks, {}, this.activeNodes)).reduce(function (types, _ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            name = _ref9[0],
            value = _ref9[1];

        return _objectSpread2({}, types, _defineProperty({}, name, function () {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return value(attrs);
        }));
      }, {});
    }
  }]);

  return Editor;
}(Emitter);

var EditorContent = {
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this = this;

        if (editor && editor.element) {
          this.$nextTick(function () {
            _this.$el.appendChild(editor.element.firstChild);

            editor.setParentComponent(_this);
          });
        }
      }
    }
  },
  render: function render(createElement) {
    return createElement('div');
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.element = this.$el;
  }
};

var Menu =
/*#__PURE__*/
function () {
  function Menu(_ref) {
    var _this = this;

    var options = _ref.options;

    _classCallCheck(this, Menu);

    this.options = options;
    this.preventHide = false; // the mousedown event is fired before blur so we can prevent it

    this.mousedownHandler = this.handleClick.bind(this);
    this.options.element.addEventListener('mousedown', this.mousedownHandler);
    this.options.editor.on('blur', function () {
      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      _this.options.editor.emit('menubar:focusUpdate', false);
    });
  }

  _createClass(Menu, [{
    key: "handleClick",
    value: function handleClick() {
      this.preventHide = true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.options.element.removeEventListener('mousedown', this.mousedownHandler);
    }
  }]);

  return Menu;
}();

function MenuBar (options) {
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('menu_bar'),
    view: function view(editorView) {
      return new Menu({
        editorView: editorView,
        options: options
      });
    }
  });
}

var EditorMenuBar = {
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  data: function data() {
    return {
      focused: false
    };
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this = this;

        if (editor) {
          this.$nextTick(function () {
            editor.registerPlugin(MenuBar({
              editor: editor,
              element: _this.$el
            }));
            _this.focused = editor.focused;
            editor.on('focus', function () {
              _this.focused = true;
            });
            editor.on('menubar:focusUpdate', function (focused) {
              _this.focused = focused;
            });
          });
        }
      }
    }
  },
  render: function render() {
    if (!this.editor) {
      return null;
    }

    return this.$scopedSlots.default({
      focused: this.focused,
      focus: this.editor.focus,
      commands: this.editor.commands,
      isActive: this.editor.isActive,
      getMarkAttrs: this.editor.getMarkAttrs.bind(this.editor)
    });
  }
};

function textRange(node, from, to) {
  var range = document.createRange();
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range;
}

function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1];
}

function coordsAtPos(view, pos) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var _view$docView$domFrom = view.docView.domFromPos(pos),
      node = _view$docView$domFrom.node,
      offset = _view$docView$domFrom.offset;

  var side;
  var rect;

  if (node.nodeType === 3) {
    if (end && offset < node.nodeValue.length) {
      rect = singleRect(textRange(node, offset - 1, offset), -1);
      side = 'right';
    } else if (offset < node.nodeValue.length) {
      rect = singleRect(textRange(node, offset, offset + 1), -1);
      side = 'left';
    }
  } else if (node.firstChild) {
    if (offset < node.childNodes.length) {
      var child = node.childNodes[offset];
      rect = singleRect(child.nodeType === 3 ? textRange(child) : child, -1);
      side = 'left';
    }

    if ((!rect || rect.top === rect.bottom) && offset) {
      var _child = node.childNodes[offset - 1];
      rect = singleRect(_child.nodeType === 3 ? textRange(_child) : _child, 1);
      side = 'right';
    }
  } else {
    rect = node.getBoundingClientRect();
    side = 'left';
  }

  var x = rect[side];
  return {
    top: rect.top,
    bottom: rect.bottom,
    left: x,
    right: x
  };
}

var Menu$1 =
/*#__PURE__*/
function () {
  function Menu(_ref) {
    var _this = this;

    var options = _ref.options,
        editorView = _ref.editorView;

    _classCallCheck(this, Menu);

    this.options = _objectSpread2({}, {
      element: null,
      keepInBounds: true,
      onUpdate: function onUpdate() {
        return false;
      }
    }, {}, options);
    this.editorView = editorView;
    this.isActive = false;
    this.left = 0;
    this.bottom = 0;
    this.top = 0;
    this.preventHide = false; // the mousedown event is fired before blur so we can prevent it

    this.mousedownHandler = this.handleClick.bind(this);
    this.options.element.addEventListener('mousedown', this.mousedownHandler);
    this.options.editor.on('focus', function (_ref2) {
      var view = _ref2.view;

      _this.update(view);
    });
    this.options.editor.on('blur', function (_ref3) {
      var event = _ref3.event;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      _this.hide(event);
    });
  }

  _createClass(Menu, [{
    key: "handleClick",
    value: function handleClick() {
      this.preventHide = true;
    }
  }, {
    key: "update",
    value: function update(view, lastState) {
      var state = view.state;

      if (view.composing) {
        return;
      } // Don't do anything if the document/selection didn't change


      if (lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
        return;
      } // Hide the tooltip if the selection is empty


      if (state.selection.empty) {
        this.hide();
        return;
      } // Otherwise, reposition it and update its content


      var _state$selection = state.selection,
          from = _state$selection.from,
          to = _state$selection.to; // These are in screen coordinates
      // We can't use EditorView.cordsAtPos here because it can't handle linebreaks correctly
      // See: https://github.com/ProseMirror/prosemirror-view/pull/47

      var start = coordsAtPos(view, from);
      var end = coordsAtPos(view, to, true); // The box in which the tooltip is positioned, to use as base

      var parent = this.options.element.offsetParent;

      if (!parent) {
        this.hide();
        return;
      }

      var box = parent.getBoundingClientRect();
      var el = this.options.element.getBoundingClientRect(); // Find a center-ish x position from the selection endpoints (when
      // crossing lines, end may be more to the left)

      var left = (start.left + end.left) / 2 - box.left; // Keep the menuBubble in the bounding box of the offsetParent i

      this.left = Math.round(this.options.keepInBounds ? Math.min(box.width - el.width / 2, Math.max(left, el.width / 2)) : left);
      this.bottom = Math.round(box.bottom - start.top);
      this.top = Math.round(end.bottom - box.top);
      this.isActive = true;
      this.sendUpdate();
    }
  }, {
    key: "sendUpdate",
    value: function sendUpdate() {
      this.options.onUpdate({
        isActive: this.isActive,
        left: this.left,
        bottom: this.bottom,
        top: this.top
      });
    }
  }, {
    key: "hide",
    value: function hide(event) {
      if (event && event.relatedTarget && this.options.element.parentNode.contains(event.relatedTarget)) {
        return;
      }

      this.isActive = false;
      this.sendUpdate();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.options.element.removeEventListener('mousedown', this.mousedownHandler);
    }
  }]);

  return Menu;
}();

function MenuBubble (options) {
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('menu_bubble'),
    view: function view(editorView) {
      return new Menu$1({
        editorView: editorView,
        options: options
      });
    }
  });
}

var EditorMenuBubble = {
  props: {
    editor: {
      default: null,
      type: Object
    },
    keepInBounds: {
      default: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      menu: {
        isActive: false,
        left: 0,
        bottom: 0
      }
    };
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this = this;

        if (editor) {
          this.$nextTick(function () {
            editor.registerPlugin(MenuBubble({
              editor: editor,
              element: _this.$el,
              keepInBounds: _this.keepInBounds,
              onUpdate: function onUpdate(menu) {
                // the second check ensures event is fired only once
                if (menu.isActive && _this.menu.isActive === false) {
                  _this.$emit('show', menu);
                } else if (!menu.isActive && _this.menu.isActive === true) {
                  _this.$emit('hide', menu);
                }

                _this.menu = menu;
              }
            }));
          });
        }
      }
    }
  },
  render: function render() {
    if (!this.editor) {
      return null;
    }

    return this.$scopedSlots.default({
      focused: this.editor.view.focused,
      focus: this.editor.focus,
      commands: this.editor.commands,
      isActive: this.editor.isActive,
      getMarkAttrs: this.editor.getMarkAttrs.bind(this.editor),
      menu: this.menu
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.unregisterPlugin('menu_bubble');
  }
};

var Menu$2 =
/*#__PURE__*/
function () {
  function Menu(_ref) {
    var _this = this;

    var options = _ref.options,
        editorView = _ref.editorView;

    _classCallCheck(this, Menu);

    this.options = _objectSpread2({}, {
      resizeObserver: true,
      element: null,
      onUpdate: function onUpdate() {
        return false;
      }
    }, {}, options);
    this.preventHide = false;
    this.editorView = editorView;
    this.isActive = false;
    this.top = 0; // the mousedown event is fired before blur so we can prevent it

    this.mousedownHandler = this.handleClick.bind(this);
    this.options.element.addEventListener('mousedown', this.mousedownHandler);
    this.options.editor.on('focus', function (_ref2) {
      var view = _ref2.view;

      _this.update(view);
    });
    this.options.editor.on('blur', function (_ref3) {
      var event = _ref3.event;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      _this.hide(event);
    }); // sometimes we have to update the position
    // because of a loaded images for example

    if (this.options.resizeObserver && window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(function () {
        if (_this.isActive) {
          _this.update(_this.editorView);
        }
      });
      this.resizeObserver.observe(this.editorView.dom);
    }
  }

  _createClass(Menu, [{
    key: "handleClick",
    value: function handleClick() {
      this.preventHide = true;
    }
  }, {
    key: "update",
    value: function update(view, lastState) {
      var state = view.state; // Don't do anything if the document/selection didn't change

      if (lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
        return;
      }

      if (!state.selection.empty) {
        this.hide();
        return;
      }

      var currentDom = view.domAtPos(state.selection.anchor);
      var isActive = currentDom.node.innerHTML === '<br>' && currentDom.node.tagName === 'P' && currentDom.node.parentNode === view.dom;

      if (!isActive) {
        this.hide();
        return;
      }

      var parent = this.options.element.offsetParent;

      if (!parent) {
        this.hide();
        return;
      }

      var editorBoundings = parent.getBoundingClientRect();
      var cursorBoundings = view.coordsAtPos(state.selection.anchor);
      var top = cursorBoundings.top - editorBoundings.top;
      this.isActive = true;
      this.top = top;
      this.sendUpdate();
    }
  }, {
    key: "sendUpdate",
    value: function sendUpdate() {
      this.options.onUpdate({
        isActive: this.isActive,
        top: this.top
      });
    }
  }, {
    key: "hide",
    value: function hide(event) {
      if (event && event.relatedTarget && this.options.element.parentNode.contains(event.relatedTarget)) {
        return;
      }

      this.isActive = false;
      this.sendUpdate();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.options.element.removeEventListener('mousedown', this.mousedownHandler);

      if (this.resizeObserver) {
        this.resizeObserver.unobserve(this.editorView.dom);
      }
    }
  }]);

  return Menu;
}();

function FloatingMenu (options) {
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('floating_menu'),
    view: function view(editorView) {
      return new Menu$2({
        editorView: editorView,
        options: options
      });
    }
  });
}

var EditorFloatingMenu = {
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  data: function data() {
    return {
      menu: {
        isActive: false,
        left: 0,
        bottom: 0
      }
    };
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this = this;

        if (editor) {
          this.$nextTick(function () {
            editor.registerPlugin(FloatingMenu({
              editor: editor,
              element: _this.$el,
              onUpdate: function onUpdate(menu) {
                // the second check ensures event is fired only once
                if (menu.isActive && _this.menu.isActive === false) {
                  _this.$emit('show', menu);
                } else if (!menu.isActive && _this.menu.isActive === true) {
                  _this.$emit('hide', menu);
                }

                _this.menu = menu;
              }
            }));
          });
        }
      }
    }
  },
  render: function render() {
    if (!this.editor) {
      return null;
    }

    return this.$scopedSlots.default({
      focused: this.editor.view.focused,
      focus: this.editor.focus,
      commands: this.editor.commands,
      isActive: this.editor.isActive,
      getMarkAttrs: this.editor.getMarkAttrs.bind(this.editor),
      menu: this.menu
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.unregisterPlugin('floating_menu');
  }
};




/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AllSelection", function() { return AllSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorState", function() { return EditorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NodeSelection", function() { return NodeSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Plugin", function() { return Plugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginKey", function() { return PluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Selection", function() { return Selection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionRange", function() { return SelectionRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextSelection", function() { return TextSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return Transaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__ = __webpack_require__(50);



var classesById = Object.create(null);

// ::- Superclass for editor selections. Every selection type should
// extend this. Should not be instantiated directly.
var Selection = function Selection($anchor, $head, ranges) {
  // :: [SelectionRange]
  // The ranges covered by the selection.
  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  // :: ResolvedPos
  // The resolved anchor of the selection (the side that stays in
  // place when the selection is modified).
  this.$anchor = $anchor;
  // :: ResolvedPos
  // The resolved head of the selection (the side that moves when
  // the selection is modified).
  this.$head = $head;
};

var prototypeAccessors = { anchor: { configurable: true },head: { configurable: true },from: { configurable: true },to: { configurable: true },$from: { configurable: true },$to: { configurable: true },empty: { configurable: true } };

// :: number
// The selection's anchor, as an unresolved position.
prototypeAccessors.anchor.get = function () { return this.$anchor.pos };

// :: number
// The selection's head.
prototypeAccessors.head.get = function () { return this.$head.pos };

// :: number
// The lower bound of the selection's main range.
prototypeAccessors.from.get = function () { return this.$from.pos };

// :: number
// The upper bound of the selection's main range.
prototypeAccessors.to.get = function () { return this.$to.pos };

// :: ResolvedPos
// The resolved lowerbound of the selection's main range.
prototypeAccessors.$from.get = function () {
  return this.ranges[0].$from
};

// :: ResolvedPos
// The resolved upper bound of the selection's main range.
prototypeAccessors.$to.get = function () {
  return this.ranges[0].$to
};

// :: bool
// Indicates whether the selection contains any content.
prototypeAccessors.empty.get = function () {
  var ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++)
    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
  return true
};

// eq:: (Selection) → bool
// Test whether the selection is the same as another selection.

// map:: (doc: Node, mapping: Mappable) → Selection
// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
// should be the new document to which we are mapping.

// :: () → Slice
// Get the content of this selection as a slice.
Selection.prototype.content = function content () {
  return this.$from.node(0).slice(this.from, this.to, true)
};

// :: (Transaction, ?Slice)
// Replace the selection with a slice or, if no slice is given,
// delete the selection. Will append to the given transaction.
Selection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty;

  // Put the new selection at the position after the inserted
  // content. When that ended in an inline node, search backwards,
  // to get the position after that node. If not, search forward.
  var lastNode = content.content.lastChild, lastParent = null;
  for (var i = 0; i < content.openEnd; i++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }

  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref = ranges[i$1];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty : content);
    if (i$1 == 0)
      { selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
  }
};

// :: (Transaction, Node)
// Replace the selection with the given node, appending the changes
// to the given transaction.
Selection.prototype.replaceWith = function replaceWith (tr, node) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++) {
    var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    var from = mapping.map($from.pos), to = mapping.map($to.pos);
    if (i) {
      tr.deleteRange(from, to);
    } else {
      tr.replaceRangeWith(from, to, node);
      selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
    }
  }
};

// toJSON:: () → Object
// Convert the selection to a JSON representation. When implementing
// this for a custom selection class, make sure to give the object a
// `type` property whose value matches the ID under which you
// [registered](#state.Selection^jsonID) your class.

// :: (ResolvedPos, number, ?bool) → ?Selection
// Find a valid cursor or leaf node selection starting at the given
// position and searching back if `dir` is negative, and forward if
// positive. When `textOnly` is true, only consider cursor
// selections. Will return null when no valid selection position is
// found.
Selection.findFrom = function findFrom ($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new TextSelection($pos)
      : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) { return inner }

  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found = dir < 0
        ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
        : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found) { return found }
  }
};

// :: (ResolvedPos, ?number) → Selection
// Find a valid cursor or leaf node selection near the given
// position. Searches forward first by default, but if `bias` is
// negative, it will search backwards first.
Selection.near = function near ($pos, bias) {
    if ( bias === void 0 ) bias = 1;

  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0))
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the start of
// the given document. Will return an
// [`AllSelection`](#state.AllSelection) if no valid position
// exists.
Selection.atStart = function atStart (doc) {
  return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc)
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the end of the
// given document.
Selection.atEnd = function atEnd (doc) {
  return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc)
};

// :: (Node, Object) → Selection
// Deserialize the JSON representation of a selection. Must be
// implemented for custom classes (as a static class method).
Selection.fromJSON = function fromJSON (doc, json) {
  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
  var cls = classesById[json.type];
  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
  return cls.fromJSON(doc, json)
};

// :: (string, constructor<Selection>)
// To be able to deserialize selections from JSON, custom selection
// classes must register themselves with an ID string, so that they
// can be disambiguated. Try to pick something that's unlikely to
// clash with classes from other modules.
Selection.jsonID = function jsonID (id, selectionClass) {
  if (id in classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
  classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass
};

// :: () → SelectionBookmark
// Get a [bookmark](#state.SelectionBookmark) for this selection,
// which is a value that can be mapped without having access to a
// current document, and later resolved to a real selection for a
// given document again. (This is used mostly by the history to
// track and restore old selections.) The default implementation of
// this method just converts the selection to a text selection and
// returns the bookmark for that.
Selection.prototype.getBookmark = function getBookmark () {
  return TextSelection.between(this.$anchor, this.$head).getBookmark()
};

Object.defineProperties( Selection.prototype, prototypeAccessors );

// :: bool
// Controls whether, when a selection of this type is active in the
// browser, the selected range should be visible to the user. Defaults
// to `true`.
Selection.prototype.visible = true;

// SelectionBookmark:: interface
// A lightweight, document-independent representation of a selection.
// You can define a custom bookmark type for a custom selection class
// to make the history handle it well.
//
//   map:: (mapping: Mapping) → SelectionBookmark
//   Map the bookmark through a set of changes.
//
//   resolve:: (doc: Node) → Selection
//   Resolve the bookmark to a real selection again. This may need to
//   do some error checking and may fall back to a default (usually
//   [`TextSelection.between`](#state.TextSelection^between)) if
//   mapping made the bookmark invalid.

// ::- Represents a selected range in a document.
var SelectionRange = function SelectionRange($from, $to) {
  // :: ResolvedPos
  // The lower bound of the range.
  this.$from = $from;
  // :: ResolvedPos
  // The upper bound of the range.
  this.$to = $to;
};

// ::- A text selection represents a classical editor selection, with
// a head (the moving side) and anchor (immobile side), both of which
// point into textblock nodes. It can be empty (a regular cursor
// position).
var TextSelection = /*@__PURE__*/(function (Selection) {
  function TextSelection($anchor, $head) {
    if ( $head === void 0 ) $head = $anchor;

    Selection.call(this, $anchor, $head);
  }

  if ( Selection ) TextSelection.__proto__ = Selection;
  TextSelection.prototype = Object.create( Selection && Selection.prototype );
  TextSelection.prototype.constructor = TextSelection;

  var prototypeAccessors$1 = { $cursor: { configurable: true } };

  // :: ?ResolvedPos
  // Returns a resolved position if this is a cursor selection (an
  // empty text selection), and null otherwise.
  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };

  TextSelection.prototype.map = function map (doc, mapping) {
    var $head = doc.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) { return Selection.near($head) }
    var $anchor = doc.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
  };

  TextSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty;

    Selection.prototype.replace.call(this, tr, content);
    if (content == __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty) {
      var marks = this.$from.marksAcross(this.$to);
      if (marks) { tr.ensureMarks(marks); }
    }
  };

  TextSelection.prototype.eq = function eq (other) {
    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
  };

  TextSelection.prototype.getBookmark = function getBookmark () {
    return new TextBookmark(this.anchor, this.head)
  };

  TextSelection.prototype.toJSON = function toJSON () {
    return {type: "text", anchor: this.anchor, head: this.head}
  };

  TextSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → TextSelection
  // Create a text selection from non-resolved positions.
  TextSelection.create = function create (doc, anchor, head) {
    if ( head === void 0 ) head = anchor;

    var $anchor = doc.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
  };

  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
  // Return a text selection that spans the given positions or, if
  // they aren't text positions, find a text selection near them.
  // `bias` determines whether the method searches forward (default)
  // or backwards (negative number) first. Will fall back to calling
  // [`Selection.near`](#state.Selection^near) when the document
  // doesn't contain a valid text position.
  TextSelection.between = function between ($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
    if (!$head.parent.inlineContent) {
      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found) { $head = found.$head; }
      else { return Selection.near($head, bias) }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
      }
    }
    return new TextSelection($anchor, $head)
  };

  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );

  return TextSelection;
}(Selection));

Selection.jsonID("text", TextSelection);

var TextBookmark = function TextBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
TextBookmark.prototype.map = function map (mapping) {
  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
TextBookmark.prototype.resolve = function resolve (doc) {
  return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
};

// ::- A node selection is a selection that points at a single node.
// All nodes marked [selectable](#model.NodeSpec.selectable) can be
// the target of a node selection. In such a selection, `from` and
// `to` point directly before and after the selected node, `anchor`
// equals `from`, and `head` equals `to`..
var NodeSelection = /*@__PURE__*/(function (Selection) {
  function NodeSelection($pos) {
    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    Selection.call(this, $pos, $end);
    // :: Node The selected node.
    this.node = node;
  }

  if ( Selection ) NodeSelection.__proto__ = Selection;
  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
  NodeSelection.prototype.constructor = NodeSelection;

  NodeSelection.prototype.map = function map (doc, mapping) {
    var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
    var $pos = doc.resolve(pos);
    if (deleted) { return Selection.near($pos) }
    return new NodeSelection($pos)
  };

  NodeSelection.prototype.content = function content () {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(this.node), 0, 0)
  };

  NodeSelection.prototype.eq = function eq (other) {
    return other instanceof NodeSelection && other.anchor == this.anchor
  };

  NodeSelection.prototype.toJSON = function toJSON () {
    return {type: "node", anchor: this.anchor}
  };

  NodeSelection.prototype.getBookmark = function getBookmark () { return new NodeBookmark(this.anchor) };

  NodeSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number")
      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
    return new NodeSelection(doc.resolve(json.anchor))
  };

  // :: (Node, number) → NodeSelection
  // Create a node selection from non-resolved positions.
  NodeSelection.create = function create (doc, from) {
    return new this(doc.resolve(from))
  };

  // :: (Node) → bool
  // Determines whether the given node may be selected as a node
  // selection.
  NodeSelection.isSelectable = function isSelectable (node) {
    return !node.isText && node.type.spec.selectable !== false
  };

  return NodeSelection;
}(Selection));

NodeSelection.prototype.visible = false;

Selection.jsonID("node", NodeSelection);

var NodeBookmark = function NodeBookmark(anchor) {
  this.anchor = anchor;
};
NodeBookmark.prototype.map = function map (mapping) {
  var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos)
};
NodeBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
  if (node && NodeSelection.isSelectable(node)) { return new NodeSelection($pos) }
  return Selection.near($pos)
};

// ::- A selection type that represents selecting the whole document
// (which can not necessarily be expressed with a text selection, when
// there are for example leaf block nodes at the start or end of the
// document).
var AllSelection = /*@__PURE__*/(function (Selection) {
  function AllSelection(doc) {
    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  if ( Selection ) AllSelection.__proto__ = Selection;
  AllSelection.prototype = Object.create( Selection && Selection.prototype );
  AllSelection.prototype.constructor = AllSelection;

  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };

  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };

  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };

  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };

  AllSelection.prototype.getBookmark = function getBookmark () { return AllBookmark };

  return AllSelection;
}(Selection));

Selection.jsonID("all", AllSelection);

var AllBookmark = {
  map: function map() { return this },
  resolve: function resolve(doc) { return new AllSelection(doc) }
};

// FIXME we'll need some awareness of text direction when scanning for selections

// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text) {
  if (node.inlineContent) { return TextSelection.create(doc, pos) }
  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);
    if (!child.isAtom) {
      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) { return inner }
    } else if (!text && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
    }
    pos += child.nodeSize * dir;
  }
}

function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) { return }
  var step = tr.steps[last];
  if (!(step instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["c" /* ReplaceStep */] || step instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["b" /* ReplaceAroundStep */])) { return }
  var map = tr.mapping.maps[last], end;
  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;

// ::- An editor state transaction, which can be applied to a state to
// create an updated state. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
//
// Transactions track changes to the document (they are a subclass of
// [`Transform`](#transform.Transform)), but also other state changes,
// like selection updates and adjustments of the set of [stored
// marks](#state.EditorState.storedMarks). In addition, you can store
// metadata properties in a transaction, which are extra pieces of
// information that client code or plugins can use to describe what a
// transacion represents, so that they can update their [own
// state](#state.StateField) accordingly.
//
// The [editor view](#view.EditorView) uses a few metadata properties:
// it will attach a property `"pointer"` with the value `true` to
// selection transactions directly caused by mouse or touch input, and
// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
var Transaction = /*@__PURE__*/(function (Transform) {
  function Transaction(state) {
    Transform.call(this, state.doc);
    // :: number
    // The timestamp associated with this transaction, in the same
    // format as `Date.now()`.
    this.time = Date.now();
    this.curSelection = state.selection;
    // The step count for which the current selection is valid.
    this.curSelectionFor = 0;
    // :: ?[Mark]
    // The stored marks set by this transaction, if any.
    this.storedMarks = state.storedMarks;
    // Bitfield to track which aspects of the state were updated by
    // this transaction.
    this.updated = 0;
    // Object used to store metadata properties for the transaction.
    this.meta = Object.create(null);
  }

  if ( Transform ) Transaction.__proto__ = Transform;
  Transaction.prototype = Object.create( Transform && Transform.prototype );
  Transaction.prototype.constructor = Transaction;

  var prototypeAccessors = { selection: { configurable: true },selectionSet: { configurable: true },storedMarksSet: { configurable: true },isGeneric: { configurable: true },scrolledIntoView: { configurable: true } };

  // :: Selection
  // The transaction's current selection. This defaults to the editor
  // selection [mapped](#state.Selection.map) through the steps in the
  // transaction, but can be overwritten with
  // [`setSelection`](#state.Transaction.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection
  };

  // :: (Selection) → Transaction
  // Update the transaction's current selection. Will determine the
  // selection that the editor gets when the transaction is applied.
  Transaction.prototype.setSelection = function setSelection (selection) {
    if (selection.$from.doc != this.doc)
      { throw new RangeError("Selection passed to setSelection must point at the current document") }
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this
  };

  // :: bool
  // Whether the selection was explicitly updated by this transaction.
  prototypeAccessors.selectionSet.get = function () {
    return (this.updated & UPDATED_SEL) > 0
  };

  // :: (?[Mark]) → Transaction
  // Set the current stored marks.
  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this
  };

  // :: ([Mark]) → Transaction
  // Make sure the current stored marks or, if that is null, the marks
  // at the selection, match the given set of marks. Does nothing if
  // this is already the case.
  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
    if (!__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Mark"].sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      { this.setStoredMarks(marks); }
    return this
  };

  // :: (Mark) → Transaction
  // Add a mark to the set of stored marks.
  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: (union<Mark, MarkType>) → Transaction
  // Remove a mark or mark type from the set of stored marks.
  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: bool
  // Whether the stored marks were explicitly set for this transaction.
  prototypeAccessors.storedMarksSet.get = function () {
    return (this.updated & UPDATED_MARKS) > 0
  };

  Transaction.prototype.addStep = function addStep (step, doc) {
    Transform.prototype.addStep.call(this, step, doc);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  };

  // :: (number) → Transaction
  // Update the timestamp for the transaction.
  Transaction.prototype.setTime = function setTime (time) {
    this.time = time;
    return this
  };

  // :: (Slice) → Transaction
  // Replace the current selection with the given slice.
  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
    this.selection.replace(this, slice);
    return this
  };

  // :: (Node, ?bool) → Transaction
  // Replace the selection with the given node. When `inheritMarks` is
  // true and the content is inline, it inherits the marks from the
  // place where it is inserted.
  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false)
      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Mark"].none))); }
    selection.replaceWith(this, node);
    return this
  };

  // :: () → Transaction
  // Delete the selection.
  Transaction.prototype.deleteSelection = function deleteSelection () {
    this.selection.replace(this);
    return this
  };

  // :: (string, from: ?number, to: ?number) → Transaction
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  Transaction.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var schema = this.doc.type.schema;
    if (from == null) {
      if (!text) { return this.deleteSelection() }
      return this.replaceSelectionWith(schema.text(text), true)
    } else {
      if (!text) { return this.deleteRange(from, to) }
      var marks = this.storedMarks;
      if (!marks) {
        var $from = this.doc.resolve(from);
        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      this.replaceRangeWith(from, to, schema.text(text, marks));
      if (!this.selection.empty) { this.setSelection(Selection.near(this.selection.$to)); }
      return this
    }
  };

  // :: (union<string, Plugin, PluginKey>, any) → Transaction
  // Store a metadata property in this transaction, keyed either by
  // name or by plugin.
  Transaction.prototype.setMeta = function setMeta (key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this
  };

  // :: (union<string, Plugin, PluginKey>) → any
  // Retrieve a metadata property for a given name or plugin.
  Transaction.prototype.getMeta = function getMeta (key) {
    return this.meta[typeof key == "string" ? key : key.key]
  };

  // :: bool
  // Returns true if this transaction doesn't contain any metadata,
  // and can thus safely be extended.
  prototypeAccessors.isGeneric.get = function () {
    for (var _ in this.meta) { return false }
    return true
  };

  // :: () → Transaction
  // Indicate that the editor should scroll the selection into view
  // when updated to the state produced by this transaction.
  Transaction.prototype.scrollIntoView = function scrollIntoView () {
    this.updated |= UPDATED_SCROLL;
    return this
  };

  prototypeAccessors.scrolledIntoView.get = function () {
    return (this.updated & UPDATED_SCROLL) > 0
  };

  Object.defineProperties( Transaction.prototype, prototypeAccessors );

  return Transaction;
}(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["d" /* Transform */]));

function bind(f, self) {
  return !self || !f ? f : f.bind(self)
}

var FieldDesc = function FieldDesc(name, desc, self) {
  this.name = name;
  this.init = bind(desc.init, self);
  this.apply = bind(desc.apply, self);
};

var baseFields = [
  new FieldDesc("doc", {
    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
    apply: function apply(tr) { return tr.doc }
  }),

  new FieldDesc("selection", {
    init: function init(config, instance) { return config.selection || Selection.atStart(instance.doc) },
    apply: function apply(tr) { return tr.selection }
  }),

  new FieldDesc("storedMarks", {
    init: function init(config) { return config.storedMarks || null },
    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
  }),

  new FieldDesc("scrollToSelection", {
    init: function init() { return 0 },
    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
  })
];

// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
var Configuration = function Configuration(schema, plugins) {
  var this$1 = this;

  this.schema = schema;
  this.fields = baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  if (plugins) { plugins.forEach(function (plugin) {
    if (this$1.pluginsByKey[plugin.key])
      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
    this$1.plugins.push(plugin);
    this$1.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state)
      { this$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin)); }
  }); }
};

// ::- The state of a ProseMirror editor is represented by an object
// of this type. A state is a persistent data structure—it isn't
// updated, but rather a new state value is computed from an old one
// using the [`apply`](#state.EditorState.apply) method.
//
// A state holds a number of built-in fields, and plugins can
// [define](#state.PluginSpec.state) additional fields.
var EditorState = function EditorState(config) {
  this.config = config;
};

var prototypeAccessors$1 = { schema: { configurable: true },plugins: { configurable: true },tr: { configurable: true } };

// doc:: Node
// The current document.

// selection:: Selection
// The selection.

// storedMarks:: ?[Mark]
// A set of marks to apply to the next input. Will be null when
// no explicit marks have been set.

// :: Schema
// The schema of the state's document.
prototypeAccessors$1.schema.get = function () {
  return this.config.schema
};

// :: [Plugin]
// The plugins that are active in this state.
prototypeAccessors$1.plugins.get = function () {
  return this.config.plugins
};

// :: (Transaction) → EditorState
// Apply the given transaction to produce a new state.
EditorState.prototype.apply = function apply (tr) {
  return this.applyTransaction(tr).state
};

// : (Transaction) → bool
EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
    if ( ignore === void 0 ) ignore = -1;

  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
    var plugin = this.config.plugins[i];
    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this))
      { return false }
  } }
  return true
};

// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
// Verbose variant of [`apply`](#state.EditorState.apply) that
// returns the precise transactions that were applied (which might
// be influenced by the [transaction
// hooks](#state.PluginSpec.filterTransaction) of
// plugins) along with the new state.
EditorState.prototype.applyTransaction = function applyTransaction (rootTr) {
  if (!this.filterTransaction(rootTr)) { return {state: this, transactions: []} }

  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
  // This loop repeatedly gives plugins a chance to respond to
  // transactions as new transactions are added, making sure to only
  // pass the transactions the plugin did not see before.
   for (;;) {
    var haveNew = false;
    for (var i = 0; i < this.config.plugins.length; i++) {
      var plugin = this.config.plugins[i];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
        var tr = n < trs.length &&
            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr && newState.filterTransaction(tr, i)) {
          tr.setMeta("appendedTransaction", rootTr);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++)
              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this, n: 0}); }
          }
          trs.push(tr);
          newState = newState.applyInner(tr);
          haveNew = true;
        }
        if (seen) { seen[i] = {state: newState, n: trs.length}; }
      }
    }
    if (!haveNew) { return {state: newState, transactions: trs} }
  }
};

// : (Transaction) → EditorState
EditorState.prototype.applyInner = function applyInner (tr) {
  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
  var newInstance = new EditorState(this.config), fields = this.config.fields;
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
  }
  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) { applyListeners[i$1](this, tr, newInstance); }
  return newInstance
};

// :: Transaction
// Start a [transaction](#state.Transaction) from this state.
prototypeAccessors$1.tr.get = function () { return new Transaction(this) };

// :: (Object) → EditorState
// Create a new state.
//
// config::- Configuration options. Must contain `schema` or `doc` (or both).
//
//    schema:: ?Schema
//    The schema to use.
//
//    doc:: ?Node
//    The starting document.
//
//    selection:: ?Selection
//    A valid selection in the document.
//
//    storedMarks:: ?[Mark]
//    The initial set of [stored marks](#state.EditorState.storedMarks).
//
//    plugins:: ?[Plugin]
//    The plugins that should be active in this state.
EditorState.create = function create (config) {
  var $config = new Configuration(config.schema || config.doc.type.schema, config.plugins);
  var instance = new EditorState($config);
  for (var i = 0; i < $config.fields.length; i++)
    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
  return instance
};

// :: (Object) → EditorState
// Create a new state based on this one, but with an adjusted set of
// active plugins. State fields that exist in both sets of plugins
// are kept unchanged. Those that no longer exist are dropped, and
// those that are new are initialized using their
// [`init`](#state.StateField.init) method, passing in the new
// configuration object..
//
// config::- configuration options
//
//   schema:: ?Schema
//   New schema to use.
//
//   plugins:: ?[Plugin]
//   New set of active plugins.
EditorState.prototype.reconfigure = function reconfigure (config) {
  var $config = new Configuration(config.schema || this.schema, config.plugins);
  var fields = $config.fields, instance = new EditorState($config);
  for (var i = 0; i < fields.length; i++) {
    var name = fields[i].name;
    instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
  }
  return instance
};

// :: (?union<Object<Plugin>, string, number>) → Object
// Serialize this state to JSON. If you want to serialize the state
// of plugins, pass an object mapping property names to use in the
// resulting JSON object to plugin objects. The argument may also be
// a string or number, in which case it is ignored, to support the
// way `JSON.stringify` calls `toString` methods.
EditorState.prototype.toJSON = function toJSON (pluginFields) {
  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
    if (prop == "doc" || prop == "selection")
      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
    var plugin = pluginFields[prop], state = plugin.spec.state;
    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this[plugin.key]); }
  } }
  return result
};

// :: (Object, Object, ?Object<Plugin>) → EditorState
// Deserialize a JSON representation of a state. `config` should
// have at least a `schema` field, and should contain array of
// plugins to initialize the state with. `pluginFields` can be used
// to deserialize the state of plugins, by associating plugin
// instances with the property names they use in the JSON object.
//
// config::- configuration options
//
//   schema:: Schema
//   The schema to use.
//
//   plugins:: ?[Plugin]
//   The set of active plugins.
EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
  var $config = new Configuration(config.schema, config.plugins);
  var instance = new EditorState($config);
  $config.fields.forEach(function (field) {
    if (field.name == "doc") {
      instance.doc = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Node"].fromJSON(config.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
    } else {
      if (pluginFields) { for (var prop in pluginFields) {
        var plugin = pluginFields[prop], state = plugin.spec.state;
        if (plugin.key == field.name && state && state.fromJSON &&
            Object.prototype.hasOwnProperty.call(json, prop)) {
          // This field belongs to a plugin mapped to a JSON field, read it from there.
          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
          return
        }
      } }
      instance[field.name] = field.init(config, instance);
    }
  });
  return instance
};

// Kludge to allow the view to track mappings between different
// instances of a state.
//
// FIXME this is no longer needed as of prosemirror-view 1.9.0,
// though due to backwards-compat we should probably keep it around
// for a while (if only as a no-op)
EditorState.addApplyListener = function addApplyListener (f) {
  applyListeners.push(f);
};
EditorState.removeApplyListener = function removeApplyListener (f) {
  var found = applyListeners.indexOf(f);
  if (found > -1) { applyListeners.splice(found, 1); }
};

Object.defineProperties( EditorState.prototype, prototypeAccessors$1 );

var applyListeners = [];

// PluginSpec:: interface
//
// This is the type passed to the [`Plugin`](#state.Plugin)
// constructor. It provides a definition for a plugin.
//
//   props:: ?EditorProps
//   The [view props](#view.EditorProps) added by this plugin. Props
//   that are functions will be bound to have the plugin instance as
//   their `this` binding.
//
//   state:: ?StateField<any>
//   Allows a plugin to define a [state field](#state.StateField), an
//   extra slot in the state object in which it can keep its own data.
//
//   key:: ?PluginKey
//   Can be used to make this a keyed plugin. You can have only one
//   plugin with a given key in a given state, but it is possible to
//   access the plugin's configuration and state through the key,
//   without having access to the plugin instance object.
//
//   view:: ?(EditorView) → Object
//   When the plugin needs to interact with the editor view, or
//   set something up in the DOM, use this field. The function
//   will be called when the plugin's state is associated with an
//   editor view.
//
//     return::-
//     Should return an object with the following optional
//     properties:
//
//       update:: ?(view: EditorView, prevState: EditorState)
//       Called whenever the view's state is updated.
//
//       destroy:: ?()
//       Called when the view is destroyed or receives a state
//       with different plugins.
//
//   filterTransaction:: ?(Transaction, EditorState) → bool
//   When present, this will be called before a transaction is
//   applied by the state, allowing the plugin to cancel it (by
//   returning false).
//
//   appendTransaction:: ?(transactions: [Transaction], oldState: EditorState, newState: EditorState) → ?Transaction
//   Allows the plugin to append another transaction to be applied
//   after the given array of transactions. When another plugin
//   appends a transaction after this was called, it is called again
//   with the new state and new transactions—but only the new
//   transactions, i.e. it won't be passed transactions that it
//   already saw.

function bindProps(obj, self, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) { val = val.bind(self); }
    else if (prop == "handleDOMEvents") { val = bindProps(val, self, {}); }
    target[prop] = val;
  }
  return target
}

// ::- Plugins bundle functionality that can be added to an editor.
// They are part of the [editor state](#state.EditorState) and
// may influence that state and the view that contains it.
var Plugin = function Plugin(spec) {
  // :: EditorProps
  // The [props](#view.EditorProps) exported by this plugin.
  this.props = {};
  if (spec.props) { bindProps(spec.props, this, this.props); }
  // :: Object
  // The plugin's [spec object](#state.PluginSpec).
  this.spec = spec;
  this.key = spec.key ? spec.key.key : createKey("plugin");
};

// :: (EditorState) → any
// Extract the plugin's state field from an editor state.
Plugin.prototype.getState = function getState (state) { return state[this.key] };

// StateField:: interface<T>
// A plugin spec may provide a state field (under its
// [`state`](#state.PluginSpec.state) property) of this type, which
// describes the state it wants to keep. Functions provided here are
// always called with the plugin instance as their `this` binding.
//
//   init:: (config: Object, instance: EditorState) → T
//   Initialize the value of the field. `config` will be the object
//   passed to [`EditorState.create`](#state.EditorState^create). Note
//   that `instance` is a half-initialized state instance, and will
//   not have values for plugin fields initialized after this one.
//
//   apply:: (tr: Transaction, value: T, oldState: EditorState, newState: EditorState) → T
//   Apply the given transaction to this state field, producing a new
//   field value. Note that the `newState` argument is again a partially
//   constructed state does not yet contain the state from plugins
//   coming after this one.
//
//   toJSON:: ?(value: T) → *
//   Convert this field to JSON. Optional, can be left off to disable
//   JSON serialization for the field.
//
//   fromJSON:: ?(config: Object, value: *, state: EditorState) → T
//   Deserialize the JSON representation of this field. Note that the
//   `state` argument is again a half-initialized state.

var keys = Object.create(null);

function createKey(name) {
  if (name in keys) { return name + "$" + ++keys[name] }
  keys[name] = 0;
  return name + "$"
}

// ::- A key is used to [tag](#state.PluginSpec.key)
// plugins in a way that makes it possible to find them, given an
// editor state. Assigning a key does mean only one plugin of that
// type can be active in a state.
var PluginKey = function PluginKey(name) {
if ( name === void 0 ) name = "key";
 this.key = createKey(name); };

// :: (EditorState) → ?Plugin
// Get the active plugin with this key, if any, from an editor
// state.
PluginKey.prototype.get = function get (state) { return state.config.pluginsByKey[this.key] };

// :: (EditorState) → ?any
// Get the plugin's state from an editor state.
PluginKey.prototype.getState = function getState (state) { return state[this.key] };


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Blockquote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Bold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BulletList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Code; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CodeBlock; });
/* unused harmony export CodeBlockHighlight */
/* unused harmony export Collaboration */
/* unused harmony export Focus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HardBreak; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Heading; });
/* unused harmony export Highlight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return History; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HorizontalRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Italic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ListItem; });
/* unused harmony export Mention */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return OrderedList; });
/* unused harmony export Placeholder */
/* unused harmony export Search */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Strike; });
/* unused harmony export Suggestions */
/* unused harmony export Table */
/* unused harmony export TableCell */
/* unused harmony export TableHeader */
/* unused harmony export TableRow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TodoItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TodoList; });
/* unused harmony export TrailingNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return Underline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap_commands__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lowlight_lib_core__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lowlight_lib_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lowlight_lib_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiptap_utils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prosemirror_transform__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prosemirror_collab__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__ = __webpack_require__(681);

    /*!
    * tiptap-extensions v1.28.4
    * (c) 2019 Scrumpy UG (limited liability)
    * @license MIT
    */
  












function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var Blockquote =
/*#__PURE__*/
function (_Node) {
  _inherits(Blockquote, _Node);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, _getPrototypeOf(Blockquote).apply(this, arguments));
  }

  _createClass(Blockquote, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["s" /* toggleWrap */])(type, schema.nodes.paragraph);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        'Ctrl->': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["s" /* toggleWrap */])(type)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["u" /* wrappingInputRule */])(/^\s*>\s$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'blockquote';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'block*',
        group: 'block',
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'blockquote'
        }],
        toDOM: function toDOM() {
          return ['blockquote', 0];
        }
      };
    }
  }]);

  return Blockquote;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var BulletList =
/*#__PURE__*/
function (_Node) {
  _inherits(BulletList, _Node);

  function BulletList() {
    _classCallCheck(this, BulletList);

    return _possibleConstructorReturn(this, _getPrototypeOf(BulletList).apply(this, arguments));
  }

  _createClass(BulletList, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["q" /* toggleList */])(type, schema.nodes.list_item);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        'Shift-Ctrl-8': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["q" /* toggleList */])(type, schema.nodes.list_item)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["u" /* wrappingInputRule */])(/^\s*([-+*])\s$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'bullet_list';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'list_item+',
        group: 'block',
        parseDOM: [{
          tag: 'ul'
        }],
        toDOM: function toDOM() {
          return ['ul', 0];
        }
      };
    }
  }]);

  return BulletList;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var CodeBlock =
/*#__PURE__*/
function (_Node) {
  _inherits(CodeBlock, _Node);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodeBlock).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["p" /* toggleBlockType */])(type, schema.nodes.paragraph);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        'Shift-Ctrl-\\': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["k" /* setBlockType */])(type)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["o" /* textblockTypeInputRule */])(/^```$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'code_block';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'text*',
        marks: '',
        group: 'block',
        code: true,
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'pre',
          preserveWhitespace: 'full'
        }],
        toDOM: function toDOM() {
          return ['pre', ['code', 0]];
        }
      };
    }
  }]);

  return CodeBlock;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

function getDecorations(_ref) {
  var doc = _ref.doc,
      name = _ref.name;
  var decorations = [];
  var blocks = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findBlockNodes"])(doc).filter(function (item) {
    return item.node.type.name === name;
  });

  var flatten = function flatten(list) {
    return list.reduce(function (a, b) {
      return a.concat(Array.isArray(b) ? flatten(b) : b);
    }, []);
  };

  function parseNodes(nodes) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return nodes.map(function (node) {
      var classes = [].concat(_toConsumableArray(className), _toConsumableArray(node.properties ? node.properties.className : []));

      if (node.children) {
        return parseNodes(node.children, classes);
      }

      return {
        text: node.value,
        classes: classes
      };
    });
  }

  blocks.forEach(function (block) {
    var startPos = block.pos + 1;
    var nodes = __WEBPACK_IMPORTED_MODULE_2_lowlight_lib_core___default.a.highlightAuto(block.node.textContent).value;
    flatten(parseNodes(nodes)).map(function (node) {
      var from = startPos;
      var to = from + node.text.length;
      startPos = to;
      return _objectSpread2({}, node, {
        from: from,
        to: to
      });
    }).forEach(function (node) {
      var decoration = __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].inline(node.from, node.to, {
        class: node.classes.join(' ')
      });
      decorations.push(decoration);
    });
  });
  return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(doc, decorations);
}

function HighlightPlugin(_ref2) {
  var name = _ref2.name;
  return new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
    name: new __WEBPACK_IMPORTED_MODULE_0_tiptap__["i" /* PluginKey */]('highlight'),
    state: {
      init: function init(_, _ref3) {
        var doc = _ref3.doc;
        return getDecorations({
          doc: doc,
          name: name
        });
      },
      apply: function apply(transaction, decorationSet, oldState, state) {
        // TODO: find way to cache decorations
        // see: https://discuss.prosemirror.net/t/how-to-update-multiple-inline-decorations-on-node-change/1493
        var nodeName = state.selection.$head.parent.type.name;
        var previousNodeName = oldState.selection.$head.parent.type.name;

        if (transaction.docChanged && [nodeName, previousNodeName].includes(name)) {
          return getDecorations({
            doc: transaction.doc,
            name: name
          });
        }

        return decorationSet.map(transaction.mapping, transaction.doc);
      }
    },
    props: {
      decorations: function decorations(state) {
        return this.getState(state);
      }
    }
  });
}

var CodeBlockHighlight =
/*#__PURE__*/
function (_Node) {
  _inherits(CodeBlockHighlight, _Node);

  function CodeBlockHighlight() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CodeBlockHighlight);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CodeBlockHighlight).call(this, options));

    try {
      Object.entries(_this.options.languages).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            mapping = _ref2[1];

        __WEBPACK_IMPORTED_MODULE_2_lowlight_lib_core___default.a.registerLanguage(name, mapping);
      });
    } catch (err) {
      throw new Error('Invalid syntax highlight definitions: define at least one highlight.js language mapping');
    }

    return _this;
  }

  _createClass(CodeBlockHighlight, [{
    key: "commands",
    value: function commands(_ref3) {
      var type = _ref3.type,
          schema = _ref3.schema;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["p" /* toggleBlockType */])(type, schema.nodes.paragraph);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref4) {
      var type = _ref4.type;
      return {
        'Shift-Ctrl-\\': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["k" /* setBlockType */])(type)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref5) {
      var type = _ref5.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["o" /* textblockTypeInputRule */])(/^```$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'code_block';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        languages: {}
      };
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'text*',
        marks: '',
        group: 'block',
        code: true,
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'pre',
          preserveWhitespace: 'full'
        }],
        toDOM: function toDOM() {
          return ['pre', ['code', 0]];
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      return [HighlightPlugin({
        name: this.name
      })];
    }
  }]);

  return CodeBlockHighlight;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var HardBreak =
/*#__PURE__*/
function (_Node) {
  _inherits(HardBreak, _Node);

  function HardBreak() {
    _classCallCheck(this, HardBreak);

    return _possibleConstructorReturn(this, _getPrototypeOf(HardBreak).apply(this, arguments));
  }

  _createClass(HardBreak, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      var command = Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["a" /* chainCommands */])(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["b" /* exitCode */], function (state, dispatch) {
        dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
        return true;
      });
      return {
        'Mod-Enter': command,
        'Shift-Enter': command
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'hard_break';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        inline: true,
        group: 'inline',
        selectable: false,
        parseDOM: [{
          tag: 'br'
        }],
        toDOM: function toDOM() {
          return ['br'];
        }
      };
    }
  }]);

  return HardBreak;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var Heading =
/*#__PURE__*/
function (_Node) {
  _inherits(Heading, _Node);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, _getPrototypeOf(Heading).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function (attrs) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["p" /* toggleBlockType */])(type, schema.nodes.paragraph, attrs);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return this.options.levels.reduce(function (items, level) {
        return _objectSpread2({}, items, {}, _defineProperty({}, "Shift-Ctrl-".concat(level), Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["k" /* setBlockType */])(type, {
          level: level
        })));
      }, {});
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return this.options.levels.map(function (level) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["o" /* textblockTypeInputRule */])(new RegExp("^(#{1,".concat(level, "})\\s$")), type, function () {
          return {
            level: level
          };
        });
      });
    }
  }, {
    key: "name",
    get: function get() {
      return 'heading';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        levels: [1, 2, 3, 4, 5, 6]
      };
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          level: {
            default: 1
          }
        },
        content: 'inline*',
        group: 'block',
        defining: true,
        draggable: false,
        parseDOM: this.options.levels.map(function (level) {
          return {
            tag: "h".concat(level),
            attrs: {
              level: level
            }
          };
        }),
        toDOM: function toDOM(node) {
          return ["h".concat(node.attrs.level), 0];
        }
      };
    }
  }]);

  return Heading;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var HorizontalRule =
/*#__PURE__*/
function (_Node) {
  _inherits(HorizontalRule, _Node);

  function HorizontalRule() {
    _classCallCheck(this, HorizontalRule);

    return _possibleConstructorReturn(this, _getPrototypeOf(HorizontalRule).apply(this, arguments));
  }

  _createClass(HorizontalRule, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function () {
        return function (state, dispatch) {
          return dispatch(state.tr.replaceSelectionWith(type.create()));
        };
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var type = _ref2.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["g" /* nodeInputRule */])(/^(?:---|___\s|\*\*\*\s)$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'horizontal_rule';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: 'block',
        parseDOM: [{
          tag: 'hr'
        }],
        toDOM: function toDOM() {
          return ['hr'];
        }
      };
    }
  }]);

  return HorizontalRule;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

/**
 * Matches following attributes in Markdown-typed image: [, alt, src, title]
 *
 * Example:
 * ![Lorem](image.jpg) -> [, "Lorem", "image.jpg"]
 * ![](image.jpg "Ipsum") -> [, "", "image.jpg", "Ipsum"]
 * ![Lorem](image.jpg "Ipsum") -> [, "Lorem", "image.jpg", "Ipsum"]
 */

var IMAGE_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/;

var Image =
/*#__PURE__*/
function (_Node) {
  _inherits(Image, _Node);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, _getPrototypeOf(Image).apply(this, arguments));
  }

  _createClass(Image, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function (attrs) {
        return function (state, dispatch) {
          var selection = state.selection;
          var position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
          var node = type.create(attrs);
          var transaction = state.tr.insert(position, node);
          dispatch(transaction);
        };
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var type = _ref2.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["g" /* nodeInputRule */])(IMAGE_INPUT_REGEX, type, function (match) {
        var _match = _slicedToArray(match, 4),
            alt = _match[1],
            src = _match[2],
            title = _match[3];

        return {
          src: src,
          alt: alt,
          title: title
        };
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'image';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        inline: true,
        attrs: {
          src: {},
          alt: {
            default: null
          },
          title: {
            default: null
          }
        },
        group: 'inline',
        draggable: true,
        parseDOM: [{
          tag: 'img[src]',
          getAttrs: function getAttrs(dom) {
            return {
              src: dom.getAttribute('src'),
              title: dom.getAttribute('title'),
              alt: dom.getAttribute('alt')
            };
          }
        }],
        toDOM: function toDOM(node) {
          return ['img', node.attrs];
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      return [new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
        props: {
          handleDOMEvents: {
            drop: function drop(view, event) {
              var hasFiles = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length;

              if (!hasFiles) {
                return;
              }

              var images = Array.from(event.dataTransfer.files).filter(function (file) {
                return /image/i.test(file.type);
              });

              if (images.length === 0) {
                return;
              }

              event.preventDefault();
              var schema = view.state.schema;
              var coordinates = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
              });
              images.forEach(function (image) {
                var reader = new FileReader();

                reader.onload = function (readerEvent) {
                  var node = schema.nodes.image.create({
                    src: readerEvent.target.result
                  });
                  var transaction = view.state.tr.insert(coordinates.pos, node);
                  view.dispatch(transaction);
                };

                reader.readAsDataURL(image);
              });
            }
          }
        }
      })];
    }
  }]);

  return Image;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var ListItem =
/*#__PURE__*/
function (_Node) {
  _inherits(ListItem, _Node);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListItem).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        Enter: Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["m" /* splitListItem */])(type),
        Tab: Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["l" /* sinkListItem */])(type),
        'Shift-Tab': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["d" /* liftListItem */])(type)
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'list_item';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: 'paragraph block*',
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'li'
        }],
        toDOM: function toDOM() {
          return ['li', 0];
        }
      };
    }
  }]);

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

function triggerCharacter(_ref) {
  var _ref$char = _ref.char,
      char = _ref$char === void 0 ? '@' : _ref$char,
      _ref$allowSpaces = _ref.allowSpaces,
      allowSpaces = _ref$allowSpaces === void 0 ? false : _ref$allowSpaces,
      _ref$startOfLine = _ref.startOfLine,
      startOfLine = _ref$startOfLine === void 0 ? false : _ref$startOfLine;
  return function ($position) {
    // cancel if top level node
    if ($position.depth <= 0) {
      return false;
    } // Matching expressions used for later


    var escapedChar = "\\".concat(char);
    var suffix = new RegExp("\\s".concat(escapedChar, "$"));
    var prefix = startOfLine ? '^' : '';
    var regexp = allowSpaces ? new RegExp("".concat(prefix).concat(escapedChar, ".*?(?=\\s").concat(escapedChar, "|$)"), 'gm') : new RegExp("".concat(prefix, "(?:^)?").concat(escapedChar, "[^\\s").concat(escapedChar, "]*"), 'gm'); // Lookup the boundaries of the current node

    var textFrom = $position.before();
    var textTo = $position.end();
    var text = $position.doc.textBetween(textFrom, textTo, '\0', '\0');
    var match = regexp.exec(text);
    var position;

    while (match !== null) {
      // JavaScript doesn't have lookbehinds; this hacks a check that first character is " "
      // or the line beginning
      var matchPrefix = match.input.slice(Math.max(0, match.index - 1), match.index);

      if (/^[\s\0]?$/.test(matchPrefix)) {
        // The absolute position of the match in the document
        var from = match.index + $position.start();
        var to = from + match[0].length; // Edge case handling; if spaces are allowed and we're directly in between
        // two triggers

        if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
          match[0] += ' ';
          to += 1;
        } // If the $position is located within the matched substring, return that range


        if (from < $position.pos && to >= $position.pos) {
          position = {
            range: {
              from: from,
              to: to
            },
            query: match[0].slice(char.length),
            text: match[0]
          };
        }
      }

      match = regexp.exec(text);
    }

    return position;
  };
}

function SuggestionsPlugin(_ref2) {
  var _ref2$matcher = _ref2.matcher,
      matcher = _ref2$matcher === void 0 ? {
    char: '@',
    allowSpaces: false,
    startOfLine: false
  } : _ref2$matcher,
      _ref2$appendText = _ref2.appendText,
      appendText = _ref2$appendText === void 0 ? null : _ref2$appendText,
      _ref2$suggestionClass = _ref2.suggestionClass,
      suggestionClass = _ref2$suggestionClass === void 0 ? 'suggestion' : _ref2$suggestionClass,
      _ref2$command = _ref2.command,
      _command = _ref2$command === void 0 ? function () {
    return false;
  } : _ref2$command,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      _ref2$onEnter = _ref2.onEnter,
      onEnter = _ref2$onEnter === void 0 ? function () {
    return false;
  } : _ref2$onEnter,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {
    return false;
  } : _ref2$onChange,
      _ref2$onExit = _ref2.onExit,
      onExit = _ref2$onExit === void 0 ? function () {
    return false;
  } : _ref2$onExit,
      _ref2$onKeyDown = _ref2.onKeyDown,
      onKeyDown = _ref2$onKeyDown === void 0 ? function () {
    return false;
  } : _ref2$onKeyDown,
      _ref2$onFilter = _ref2.onFilter,
      onFilter = _ref2$onFilter === void 0 ? function (searchItems, query) {
    if (!query) {
      return searchItems;
    }

    return searchItems.filter(function (item) {
      return JSON.stringify(item).toLowerCase().includes(query.toLowerCase());
    });
  } : _ref2$onFilter;

  return new __WEBPACK_IMPORTED_MODULE_5_prosemirror_state__["Plugin"]({
    key: new __WEBPACK_IMPORTED_MODULE_5_prosemirror_state__["PluginKey"]('suggestions'),
    view: function view() {
      var _this = this;

      return {
        update: function update(view, prevState) {
          var prev = _this.key.getState(prevState);

          var next = _this.key.getState(view.state); // See how the state changed


          var moved = prev.active && next.active && prev.range.from !== next.range.from;
          var started = !prev.active && next.active;
          var stopped = prev.active && !next.active;
          var changed = !started && !stopped && prev.query !== next.query;
          var handleStart = started || moved;
          var handleChange = changed && !moved;
          var handleExit = stopped || moved; // Cancel when suggestion isn't active

          if (!handleStart && !handleChange && !handleExit) {
            return;
          }

          var state = handleExit ? prev : next;
          var decorationNode = document.querySelector("[data-decoration-id=\"".concat(state.decorationId, "\"]")); // build a virtual node for popper.js or tippy.js
          // this can be used for building popups without a DOM node

          var virtualNode = decorationNode ? {
            getBoundingClientRect: function getBoundingClientRect() {
              return decorationNode.getBoundingClientRect();
            },
            clientWidth: decorationNode.clientWidth,
            clientHeight: decorationNode.clientHeight
          } : null;
          var props = {
            view: view,
            range: state.range,
            query: state.query,
            text: state.text,
            decorationNode: decorationNode,
            virtualNode: virtualNode,
            items: onFilter(Array.isArray(items) ? items : items(), state.query),
            command: function command(_ref3) {
              var range = _ref3.range,
                  attrs = _ref3.attrs;

              _command({
                range: range,
                attrs: attrs,
                schema: view.state.schema
              })(view.state, view.dispatch, view);

              if (appendText) {
                Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["c" /* insertText */])(appendText)(view.state, view.dispatch, view);
              }
            }
          }; // Trigger the hooks when necessary

          if (handleExit) {
            onExit(props);
          }

          if (handleChange) {
            onChange(props);
          }

          if (handleStart) {
            onEnter(props);
          }
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init: function init() {
        return {
          active: false,
          range: {},
          query: null,
          text: null
        };
      },
      // Apply changes to the plugin state from a view transaction.
      apply: function apply(tr, prev) {
        var selection = tr.selection;

        var next = _objectSpread2({}, prev); // We can only be suggesting if there is no selection


        if (selection.from === selection.to) {
          // Reset active state if we just left the previous suggestion range
          if (selection.from < prev.range.from || selection.from > prev.range.to) {
            next.active = false;
          } // Try to match against where our cursor currently is


          var $position = selection.$from;
          var match = triggerCharacter(matcher)($position);
          var decorationId = (Math.random() + 1).toString(36).substr(2, 5); // If we found a match, update the current state to show it

          if (match) {
            next.active = true;
            next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
            next.range = match.range;
            next.query = match.query;
            next.text = match.text;
          } else {
            next.active = false;
          }
        } else {
          next.active = false;
        } // Make sure to empty the range if suggestion is inactive


        if (!next.active) {
          next.decorationId = null;
          next.range = {};
          next.query = null;
          next.text = null;
        }

        return next;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown: function handleKeyDown(view, event) {
        var _this$getState = this.getState(view.state),
            active = _this$getState.active,
            range = _this$getState.range;

        if (!active) return false;
        return onKeyDown({
          view: view,
          event: event,
          range: range
        });
      },
      // Setup decorator on the currently active suggestion.
      decorations: function decorations(editorState) {
        var _this$getState2 = this.getState(editorState),
            active = _this$getState2.active,
            range = _this$getState2.range,
            decorationId = _this$getState2.decorationId;

        if (!active) return null;
        return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(editorState.doc, [__WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].inline(range.from, range.to, {
          nodeName: 'span',
          class: suggestionClass,
          'data-decoration-id': decorationId
        })]);
      }
    }
  });
}

var Mention =
/*#__PURE__*/
function (_Node) {
  _inherits(Mention, _Node);

  function Mention() {
    _classCallCheck(this, Mention);

    return _possibleConstructorReturn(this, _getPrototypeOf(Mention).apply(this, arguments));
  }

  _createClass(Mention, [{
    key: "commands",
    value: function commands(_ref) {
      var _this = this;

      var schema = _ref.schema;
      return function (attrs) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["j" /* replaceText */])(null, schema.nodes[_this.name], attrs);
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'mention';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        matcher: {
          char: '@',
          allowSpaces: false,
          startOfLine: false
        },
        mentionClass: 'mention',
        suggestionClass: 'mention-suggestion'
      };
    }
  }, {
    key: "schema",
    get: function get() {
      var _this2 = this;

      return {
        attrs: {
          id: {},
          label: {}
        },
        group: 'inline',
        inline: true,
        selectable: false,
        atom: true,
        toDOM: function toDOM(node) {
          return ['span', {
            class: _this2.options.mentionClass,
            'data-mention-id': node.attrs.id
          }, "".concat(_this2.options.matcher.char).concat(node.attrs.label)];
        },
        parseDOM: [{
          tag: 'span[data-mention-id]',
          getAttrs: function getAttrs(dom) {
            var id = dom.getAttribute('data-mention-id');
            var label = dom.innerText.split(_this2.options.matcher.char).join('');
            return {
              id: id,
              label: label
            };
          }
        }]
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this3 = this;

      return [SuggestionsPlugin({
        command: function command(_ref2) {
          var range = _ref2.range,
              attrs = _ref2.attrs,
              schema = _ref2.schema;
          return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["j" /* replaceText */])(range, schema.nodes[_this3.name], attrs);
        },
        appendText: ' ',
        matcher: this.options.matcher,
        items: this.options.items,
        onEnter: this.options.onEnter,
        onChange: this.options.onChange,
        onExit: this.options.onExit,
        onKeyDown: this.options.onKeyDown,
        onFilter: this.options.onFilter,
        suggestionClass: this.options.suggestionClass
      })];
    }
  }]);

  return Mention;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var OrderedList =
/*#__PURE__*/
function (_Node) {
  _inherits(OrderedList, _Node);

  function OrderedList() {
    _classCallCheck(this, OrderedList);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrderedList).apply(this, arguments));
  }

  _createClass(OrderedList, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["q" /* toggleList */])(type, schema.nodes.list_item);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        'Shift-Ctrl-9': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["q" /* toggleList */])(type, schema.nodes.list_item)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["u" /* wrappingInputRule */])(/^(\d+)\.\s$/, type, function (match) {
        return {
          order: +match[1]
        };
      }, function (match, node) {
        return node.childCount + node.attrs.order === +match[1];
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'ordered_list';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          order: {
            default: 1
          }
        },
        content: 'list_item+',
        group: 'block',
        parseDOM: [{
          tag: 'ol',
          getAttrs: function getAttrs(dom) {
            return {
              order: dom.hasAttribute('start') ? +dom.getAttribute('start') : 1
            };
          }
        }],
        toDOM: function toDOM(node) {
          return node.attrs.order === 1 ? ['ol', 0] : ['ol', {
            start: node.attrs.order
          }, 0];
        }
      };
    }
  }]);

  return OrderedList;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var TableNodes = Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["tableNodes"])({
  tableGroup: 'block',
  cellContent: 'block+',
  cellAttributes: {
    background: {
      default: null,
      getFromDOM: function getFromDOM(dom) {
        return dom.style.backgroundColor || null;
      },
      setDOMAttr: function setDOMAttr(value, attrs) {
        if (value) {
          var style = {
            style: "".concat(attrs.style || '', "background-color: ").concat(value, ";")
          };
          Object.assign(attrs, style);
        }
      }
    }
  }
});

var Table =
/*#__PURE__*/
function (_Node) {
  _inherits(Table, _Node);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, _getPrototypeOf(Table).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "commands",
    value: function commands(_ref) {
      var schema = _ref.schema;
      return {
        createTable: function createTable$1(_ref2) {
          var rowsCount = _ref2.rowsCount,
              colsCount = _ref2.colsCount,
              withHeaderRow = _ref2.withHeaderRow;
          return function (state, dispatch) {
            var offset = state.tr.selection.anchor + 1;

            var nodes = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["createTable"])(schema, rowsCount, colsCount, withHeaderRow);

            var tr = state.tr.replaceSelectionWith(nodes).scrollIntoView();
            var resolvedPos = tr.doc.resolve(offset);
            tr.setSelection(__WEBPACK_IMPORTED_MODULE_5_prosemirror_state__["TextSelection"].near(resolvedPos));
            dispatch(tr);
          };
        },
        addColumnBefore: function addColumnBefore$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["addColumnBefore"];
        },
        addColumnAfter: function addColumnAfter$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["addColumnAfter"];
        },
        deleteColumn: function deleteColumn$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["deleteColumn"];
        },
        addRowBefore: function addRowBefore$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["addRowBefore"];
        },
        addRowAfter: function addRowAfter$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["addRowAfter"];
        },
        deleteRow: function deleteRow$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["deleteRow"];
        },
        deleteTable: function deleteTable$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["deleteTable"];
        },
        toggleCellMerge: function toggleCellMerge() {
          return function (state, dispatch) {
            if (Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["mergeCells"])(state, dispatch)) {
              return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["splitCell"])(state, dispatch);
          };
        },
        mergeCells: function mergeCells$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["mergeCells"];
        },
        splitCell: function splitCell$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["splitCell"];
        },
        toggleHeaderColumn: function toggleHeaderColumn$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["toggleHeaderColumn"];
        },
        toggleHeaderRow: function toggleHeaderRow$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["toggleHeaderRow"];
        },
        toggleHeaderCell: function toggleHeaderCell$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["toggleHeaderCell"];
        },
        setCellAttr: function setCellAttr$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["setCellAttr"];
        },
        fixTables: function fixTables$1() {
          return __WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["fixTables"];
        }
      };
    }
  }, {
    key: "keys",
    value: function keys() {
      return {
        Tab: Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["goToNextCell"])(1),
        'Shift-Tab': Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["goToNextCell"])(-1)
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'table';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        resizable: false
      };
    }
  }, {
    key: "schema",
    get: function get() {
      return TableNodes.table;
    }
  }, {
    key: "plugins",
    get: function get() {
      return [].concat(_toConsumableArray(this.options.resizable ? [Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["columnResizing"])()] : []), [Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_tables__["tableEditing"])()]);
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var TableHeader =
/*#__PURE__*/
function (_Node) {
  _inherits(TableHeader, _Node);

  function TableHeader() {
    _classCallCheck(this, TableHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableHeader).apply(this, arguments));
  }

  _createClass(TableHeader, [{
    key: "name",
    get: function get() {
      return 'table_header';
    }
  }, {
    key: "schema",
    get: function get() {
      return TableNodes.table_header;
    }
  }]);

  return TableHeader;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var TableCell =
/*#__PURE__*/
function (_Node) {
  _inherits(TableCell, _Node);

  function TableCell() {
    _classCallCheck(this, TableCell);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableCell).apply(this, arguments));
  }

  _createClass(TableCell, [{
    key: "name",
    get: function get() {
      return 'table_cell';
    }
  }, {
    key: "schema",
    get: function get() {
      return TableNodes.table_cell;
    }
  }]);

  return TableCell;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var TableRow =
/*#__PURE__*/
function (_Node) {
  _inherits(TableRow, _Node);

  function TableRow() {
    _classCallCheck(this, TableRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableRow).apply(this, arguments));
  }

  _createClass(TableRow, [{
    key: "name",
    get: function get() {
      return 'table_row';
    }
  }, {
    key: "schema",
    get: function get() {
      return TableNodes.table_row;
    }
  }]);

  return TableRow;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var TodoItem =
/*#__PURE__*/
function (_Node) {
  _inherits(TodoItem, _Node);

  function TodoItem() {
    _classCallCheck(this, TodoItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(TodoItem).apply(this, arguments));
  }

  _createClass(TodoItem, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        Enter: Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["n" /* splitToDefaultListItem */])(type),
        Tab: this.options.nested ? Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["l" /* sinkListItem */])(type) : function () {},
        'Shift-Tab': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["d" /* liftListItem */])(type)
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'todo_item';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        nested: false
      };
    }
  }, {
    key: "view",
    get: function get() {
      return {
        props: ['node', 'updateAttrs', 'view'],
        methods: {
          onChange: function onChange() {
            this.updateAttrs({
              done: !this.node.attrs.done
            });
          }
        },
        template: "\n        <li :data-type=\"node.type.name\" :data-done=\"node.attrs.done.toString()\" data-drag-handle>\n          <span class=\"todo-checkbox\" contenteditable=\"false\" @click=\"onChange\"></span>\n          <div class=\"todo-content\" ref=\"content\" :contenteditable=\"view.editable.toString()\"></div>\n        </li>\n      "
      };
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        attrs: {
          done: {
            default: false
          }
        },
        draggable: true,
        content: this.options.nested ? '(paragraph|todo_list)+' : 'paragraph+',
        toDOM: function toDOM(node) {
          var done = node.attrs.done;
          return ['li', {
            'data-type': _this.name,
            'data-done': done.toString()
          }, ['span', {
            class: 'todo-checkbox',
            contenteditable: 'false'
          }], ['div', {
            class: 'todo-content'
          }, 0]];
        },
        parseDOM: [{
          priority: 51,
          tag: "[data-type=\"".concat(this.name, "\"]"),
          getAttrs: function getAttrs(dom) {
            return {
              done: dom.getAttribute('data-done') === 'true'
            };
          }
        }]
      };
    }
  }]);

  return TodoItem;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var TodoList =
/*#__PURE__*/
function (_Node) {
  _inherits(TodoList, _Node);

  function TodoList() {
    _classCallCheck(this, TodoList);

    return _possibleConstructorReturn(this, _getPrototypeOf(TodoList).apply(this, arguments));
  }

  _createClass(TodoList, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["q" /* toggleList */])(type, schema.nodes.todo_item);
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var type = _ref2.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["u" /* wrappingInputRule */])(/^\s*(\[ \])\s$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'todo_list';
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        group: 'block',
        content: 'todo_item+',
        toDOM: function toDOM() {
          return ['ul', {
            'data-type': _this.name
          }, 0];
        },
        parseDOM: [{
          priority: 51,
          tag: "[data-type=\"".concat(this.name, "\"]")
        }]
      };
    }
  }]);

  return TodoList;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["g" /* Node */]);

var Bold =
/*#__PURE__*/
function (_Mark) {
  _inherits(Bold, _Mark);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, _getPrototypeOf(Bold).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-b': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type);
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["e" /* markInputRule */])(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type)];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["f" /* markPasteRule */])(/(?:\*\*|__)([^*_]+)(?:\*\*|__)/g, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'bold';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: 'strong'
        }, {
          tag: 'b',
          getAttrs: function getAttrs(node) {
            return node.style.fontWeight !== 'normal' && null;
          }
        }, {
          style: 'font-weight',
          getAttrs: function getAttrs(value) {
            return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null;
          }
        }],
        toDOM: function toDOM() {
          return ['strong', 0];
        }
      };
    }
  }]);

  return Bold;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["f" /* Mark */]);

var Code =
/*#__PURE__*/
function (_Mark) {
  _inherits(Code, _Mark);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, _getPrototypeOf(Code).apply(this, arguments));
  }

  _createClass(Code, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-`': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type);
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["e" /* markInputRule */])(/(?:`)([^`]+)(?:`)$/, type)];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["f" /* markPasteRule */])(/(?:`)([^`]+)(?:`)/g, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'code';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        excludes: '_',
        parseDOM: [{
          tag: 'code'
        }],
        toDOM: function toDOM() {
          return ['code', 0];
        }
      };
    }
  }]);

  return Code;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["f" /* Mark */]);

var Italic =
/*#__PURE__*/
function (_Mark) {
  _inherits(Italic, _Mark);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, _getPrototypeOf(Italic).apply(this, arguments));
  }

  _createClass(Italic, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-i': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type);
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["e" /* markInputRule */])(/(?:^|[^_])(_([^_]+)_)$/, type), Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["e" /* markInputRule */])(/(?:^|[^*])(\*([^*]+)\*)$/, type)];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["f" /* markPasteRule */])(/_([^_]+)_/g, type), Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["f" /* markPasteRule */])(/\*([^*]+)\*/g, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'italic';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: 'i'
        }, {
          tag: 'em'
        }, {
          style: 'font-style=italic'
        }],
        toDOM: function toDOM() {
          return ['em', 0];
        }
      };
    }
  }]);

  return Italic;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["f" /* Mark */]);

var Link =
/*#__PURE__*/
function (_Mark) {
  _inherits(Link, _Mark);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, _getPrototypeOf(Link).apply(this, arguments));
  }

  _createClass(Link, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function (attrs) {
        if (attrs.href) {
          return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["t" /* updateMark */])(type, attrs);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["i" /* removeMark */])(type);
      };
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref2) {
      var type = _ref2.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["h" /* pasteRule */])(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g, type, function (url) {
        return {
          href: url
        };
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'link';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        openOnClick: true
      };
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          href: {
            default: null
          }
        },
        inclusive: false,
        parseDOM: [{
          tag: 'a[href]',
          getAttrs: function getAttrs(dom) {
            return {
              href: dom.getAttribute('href')
            };
          }
        }],
        toDOM: function toDOM(node) {
          return ['a', _objectSpread2({}, node.attrs, {
            rel: 'noopener noreferrer nofollow'
          }), 0];
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      if (!this.options.openOnClick) {
        return [];
      }

      return [new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
        props: {
          handleClick: function handleClick(view, pos, event) {
            var schema = view.state.schema;
            var attrs = Object(__WEBPACK_IMPORTED_MODULE_7_tiptap_utils__["a" /* getMarkAttrs */])(view.state, schema.marks.link);

            if (attrs.href && event.target instanceof HTMLAnchorElement) {
              event.stopPropagation();
              window.open(attrs.href);
            }
          }
        }
      })];
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["f" /* Mark */]);

var Strike =
/*#__PURE__*/
function (_Mark) {
  _inherits(Strike, _Mark);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, _getPrototypeOf(Strike).apply(this, arguments));
  }

  _createClass(Strike, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-d': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type);
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["e" /* markInputRule */])(/~([^~]+)~$/, type)];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["f" /* markPasteRule */])(/~([^~]+)~/g, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'strike';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: 's'
        }, {
          tag: 'del'
        }, {
          tag: 'strike'
        }, {
          style: 'text-decoration',
          getAttrs: function getAttrs(value) {
            return value === 'line-through';
          }
        }],
        toDOM: function toDOM() {
          return ['s', 0];
        }
      };
    }
  }]);

  return Strike;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["f" /* Mark */]);

var Underline =
/*#__PURE__*/
function (_Mark) {
  _inherits(Underline, _Mark);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, _getPrototypeOf(Underline).apply(this, arguments));
  }

  _createClass(Underline, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-u': Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tiptap_commands__["r" /* toggleMark */])(type);
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'underline';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: 'u'
        }, {
          style: 'text-decoration',
          getAttrs: function getAttrs(value) {
            return value === 'underline';
          }
        }],
        toDOM: function toDOM() {
          return ['u', 0];
        }
      };
    }
  }]);

  return Underline;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["f" /* Mark */]);

var Collaboration =
/*#__PURE__*/
function (_Extension) {
  _inherits(Collaboration, _Extension);

  function Collaboration() {
    _classCallCheck(this, Collaboration);

    return _possibleConstructorReturn(this, _getPrototypeOf(Collaboration).apply(this, arguments));
  }

  _createClass(Collaboration, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.getSendableSteps = this.debounce(function (state) {
        var sendable = Object(__WEBPACK_IMPORTED_MODULE_9_prosemirror_collab__["d" /* sendableSteps */])(state);

        if (sendable) {
          _this.options.onSendable({
            editor: _this.editor,
            sendable: {
              version: sendable.version,
              steps: sendable.steps.map(function (step) {
                return step.toJSON();
              }),
              clientID: sendable.clientID
            }
          });
        }
      }, this.options.debounce);
      this.editor.on('transaction', function (_ref) {
        var state = _ref.state;

        _this.getSendableSteps(state);
      });
    }
  }, {
    key: "debounce",
    value: function debounce(fn, delay) {
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (timeout) {
          clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
          fn.apply(void 0, args);
          timeout = null;
        }, delay);
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'collaboration';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      var _this2 = this;

      return {
        version: 0,
        clientID: Math.floor(Math.random() * 0xFFFFFFFF),
        debounce: 250,
        onSendable: function onSendable() {},
        update: function update(_ref2) {
          var steps = _ref2.steps,
              version = _ref2.version;
          var _this2$editor = _this2.editor,
              state = _this2$editor.state,
              view = _this2$editor.view,
              schema = _this2$editor.schema;

          if (Object(__WEBPACK_IMPORTED_MODULE_9_prosemirror_collab__["b" /* getVersion */])(state) > version) {
            return;
          }

          view.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_prosemirror_collab__["c" /* receiveTransaction */])(state, steps.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_8_prosemirror_transform__["a" /* Step */].fromJSON(schema, item.step);
          }), steps.map(function (item) {
            return item.clientID;
          })));
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      return [Object(__WEBPACK_IMPORTED_MODULE_9_prosemirror_collab__["a" /* collab */])({
        version: this.options.version,
        clientID: this.options.clientID
      })];
    }
  }]);

  return Collaboration;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["e" /* Extension */]);

var Focus =
/*#__PURE__*/
function (_Extension) {
  _inherits(Focus, _Extension);

  function Focus() {
    _classCallCheck(this, Focus);

    return _possibleConstructorReturn(this, _getPrototypeOf(Focus).apply(this, arguments));
  }

  _createClass(Focus, [{
    key: "name",
    get: function get() {
      return 'focus';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        className: 'has-focus',
        nested: false
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
        props: {
          decorations: function decorations(_ref) {
            var doc = _ref.doc,
                plugins = _ref.plugins,
                selection = _ref.selection;
            var editablePlugin = plugins.find(function (plugin) {
              return plugin.key.startsWith('editable$');
            });
            var editable = editablePlugin.props.editable();
            var active = editable && _this.options.className;
            var focused = _this.editor.focused;
            var anchor = selection.anchor;
            var decorations = [];

            if (!active || !focused) {
              return false;
            }

            doc.descendants(function (node, pos) {
              var hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize;

              if (hasAnchor && !node.isText) {
                var decoration = __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].node(pos, pos + node.nodeSize, {
                  class: _this.options.className
                });
                decorations.push(decoration);
              }

              return _this.options.nested;
            });
            return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(doc, decorations);
          }
        }
      })];
    }
  }]);

  return Focus;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["e" /* Extension */]);

var History =
/*#__PURE__*/
function (_Extension) {
  _inherits(History, _Extension);

  function History() {
    _classCallCheck(this, History);

    return _possibleConstructorReturn(this, _getPrototypeOf(History).apply(this, arguments));
  }

  _createClass(History, [{
    key: "keys",
    value: function keys() {
      var keymap = {
        'Mod-z': __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["d" /* undo */],
        'Mod-y': __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["b" /* redo */],
        'Shift-Mod-z': __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["b" /* redo */]
      };
      return keymap;
    }
  }, {
    key: "commands",
    value: function commands() {
      return {
        undo: function undo$1() {
          return __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["d" /* undo */];
        },
        redo: function redo$1() {
          return __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["b" /* redo */];
        },
        undoDepth: function undoDepth$1() {
          return __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["e" /* undoDepth */];
        },
        redoDepth: function redoDepth$1() {
          return __WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["c" /* redoDepth */];
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'history';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        depth: '',
        newGroupDelay: ''
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      return [Object(__WEBPACK_IMPORTED_MODULE_10_prosemirror_history__["a" /* history */])({
        depth: this.options.depth,
        newGroupDelay: this.options.newGroupDelay
      })];
    }
  }]);

  return History;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["e" /* Extension */]);

var Placeholder =
/*#__PURE__*/
function (_Extension) {
  _inherits(Placeholder, _Extension);

  function Placeholder() {
    _classCallCheck(this, Placeholder);

    return _possibleConstructorReturn(this, _getPrototypeOf(Placeholder).apply(this, arguments));
  }

  _createClass(Placeholder, [{
    key: "name",
    get: function get() {
      return 'placeholder';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        emptyEditorClass: 'is-editor-empty',
        emptyNodeClass: 'is-empty',
        emptyNodeText: 'Write something …',
        showOnlyWhenEditable: true,
        showOnlyCurrent: true
      };
    }
  }, {
    key: "update",
    get: function get() {
      return function (view) {
        view.updateState(view.state);
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
        props: {
          decorations: function decorations(_ref) {
            var doc = _ref.doc,
                plugins = _ref.plugins,
                selection = _ref.selection;
            var editablePlugin = plugins.find(function (plugin) {
              return plugin.key.startsWith('editable$');
            });
            var editable = editablePlugin.props.editable();
            var active = editable || !_this.options.showOnlyWhenEditable;
            var anchor = selection.anchor;
            var decorations = [];
            var isEditorEmpty = doc.textContent.length === 0;

            if (!active) {
              return false;
            }

            doc.descendants(function (node, pos) {
              var hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize;
              var isNodeEmpty = node.content.size === 0;

              if ((hasAnchor || !_this.options.showOnlyCurrent) && isNodeEmpty) {
                var classes = [_this.options.emptyNodeClass];

                if (isEditorEmpty) {
                  classes.push(_this.options.emptyEditorClass);
                }

                var decoration = __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].node(pos, pos + node.nodeSize, {
                  class: classes.join(' '),
                  'data-empty-text': typeof _this.options.emptyNodeText === 'function' ? _this.options.emptyNodeText(node) : _this.options.emptyNodeText
                });
                decorations.push(decoration);
              }

              return false;
            });
            return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(doc, decorations);
          }
        }
      })];
    }
  }]);

  return Placeholder;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["e" /* Extension */]);

var Search =
/*#__PURE__*/
function (_Extension) {
  _inherits(Search, _Extension);

  function Search() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, options));
    _this.results = [];
    _this.searchTerm = null;
    _this._updating = false;
    return _this;
  }

  _createClass(Search, [{
    key: "commands",
    value: function commands() {
      var _this2 = this;

      return {
        find: function find(attrs) {
          return _this2.find(attrs);
        },
        replace: function replace(attrs) {
          return _this2.replace(attrs);
        },
        replaceAll: function replaceAll(attrs) {
          return _this2.replaceAll(attrs);
        },
        clearSearch: function clearSearch() {
          return _this2.clear();
        }
      };
    }
  }, {
    key: "_search",
    value: function _search(doc) {
      var _this3 = this;

      this.results = [];
      var mergedTextNodes = [];
      var index = 0;

      if (!this.searchTerm) {
        return;
      }

      doc.descendants(function (node, pos) {
        if (node.isText) {
          if (mergedTextNodes[index]) {
            mergedTextNodes[index] = {
              text: mergedTextNodes[index].text + node.text,
              pos: mergedTextNodes[index].pos
            };
          } else {
            mergedTextNodes[index] = {
              text: node.text,
              pos: pos
            };
          }
        } else {
          index += 1;
        }
      });
      mergedTextNodes.forEach(function (_ref) {
        var text = _ref.text,
            pos = _ref.pos;
        var search = _this3.findRegExp;
        var m; // eslint-disable-next-line no-cond-assign

        while (m = search.exec(text)) {
          if (m[0] === '') {
            break;
          }

          _this3.results.push({
            from: pos + m.index,
            to: pos + m.index + m[0].length
          });
        }
      });
    }
  }, {
    key: "replace",
    value: function replace(_replace) {
      var _this4 = this;

      return function (state, dispatch) {
        var firstResult = _this4.results[0];

        if (!firstResult) {
          return;
        }

        var _this4$results$ = _this4.results[0],
            from = _this4$results$.from,
            to = _this4$results$.to;
        dispatch(state.tr.insertText(_replace, from, to));

        _this4.editor.commands.find(_this4.searchTerm);
      };
    }
  }, {
    key: "rebaseNextResult",
    value: function rebaseNextResult(replace, index) {
      var lastOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var nextIndex = index + 1;

      if (!this.results[nextIndex]) {
        return null;
      }

      var _this$results$index = this.results[index],
          currentFrom = _this$results$index.from,
          currentTo = _this$results$index.to;
      var offset = currentTo - currentFrom - replace.length + lastOffset;
      var _this$results$nextInd = this.results[nextIndex],
          from = _this$results$nextInd.from,
          to = _this$results$nextInd.to;
      this.results[nextIndex] = {
        to: to - offset,
        from: from - offset
      };
      return offset;
    }
  }, {
    key: "replaceAll",
    value: function replaceAll(replace) {
      var _this5 = this;

      return function (_ref2, dispatch) {
        var tr = _ref2.tr;
        var offset;

        if (!_this5.results.length) {
          return;
        }

        _this5.results.forEach(function (_ref3, index) {
          var from = _ref3.from,
              to = _ref3.to;
          tr.insertText(replace, from, to);
          offset = _this5.rebaseNextResult(replace, index, offset);
        });

        dispatch(tr);

        _this5.editor.commands.find(_this5.searchTerm);
      };
    }
  }, {
    key: "find",
    value: function find(searchTerm) {
      var _this6 = this;

      return function (state, dispatch) {
        _this6.searchTerm = _this6.options.disableRegex ? searchTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') : searchTerm;

        _this6.updateView(state, dispatch);
      };
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this7 = this;

      return function (state, dispatch) {
        _this7.searchTerm = null;

        _this7.updateView(state, dispatch);
      };
    }
  }, {
    key: "updateView",
    value: function updateView(_ref4, dispatch) {
      var tr = _ref4.tr;
      this._updating = true;
      dispatch(tr);
      this._updating = false;
    }
  }, {
    key: "createDeco",
    value: function createDeco(doc) {
      this._search(doc);

      return this.decorations ? __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(doc, this.decorations) : [];
    }
  }, {
    key: "name",
    get: function get() {
      return 'search';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        autoSelectNext: true,
        findClass: 'find',
        searching: false,
        caseSensitive: false,
        disableRegex: true,
        alwaysSearch: false
      };
    }
  }, {
    key: "findRegExp",
    get: function get() {
      return RegExp(this.searchTerm, !this.options.caseSensitive ? 'gui' : 'gu');
    }
  }, {
    key: "decorations",
    get: function get() {
      var _this8 = this;

      return this.results.map(function (deco) {
        return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].inline(deco.from, deco.to, {
          class: _this8.options.findClass
        });
      });
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this9 = this;

      return [new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
        state: {
          init: function init() {
            return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].empty;
          },
          apply: function apply(tr, old) {
            if (_this9._updating || _this9.options.searching || tr.docChanged && _this9.options.alwaysSearch) {
              return _this9.createDeco(tr.doc);
            }

            if (tr.docChanged) {
              return old.map(tr.mapping, tr.doc);
            }

            return old;
          }
        },
        props: {
          decorations: function decorations(state) {
            return this.getState(state);
          }
        }
      })];
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["e" /* Extension */]);

var TrailingNode =
/*#__PURE__*/
function (_Extension) {
  _inherits(TrailingNode, _Extension);

  function TrailingNode() {
    _classCallCheck(this, TrailingNode);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrailingNode).apply(this, arguments));
  }

  _createClass(TrailingNode, [{
    key: "name",
    get: function get() {
      return 'trailing_node';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        node: 'paragraph',
        notAfter: ['paragraph']
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      var plugin = new __WEBPACK_IMPORTED_MODULE_0_tiptap__["i" /* PluginKey */](this.name);
      var disabledNodes = Object.entries(this.editor.schema.nodes).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[1];

        return value;
      }).filter(function (node) {
        return _this.options.notAfter.includes(node.name);
      });
      return [new __WEBPACK_IMPORTED_MODULE_0_tiptap__["h" /* Plugin */]({
        key: plugin,
        view: function view() {
          return {
            update: function update(view) {
              var state = view.state;
              var insertNodeAtEnd = plugin.getState(state);

              if (!insertNodeAtEnd) {
                return;
              }

              var doc = state.doc,
                  schema = state.schema,
                  tr = state.tr;
              var type = schema.nodes[_this.options.node];
              var transaction = tr.insert(doc.content.size, type.create());
              view.dispatch(transaction);
            }
          };
        },
        state: {
          init: function init(_, state) {
            var lastNode = state.tr.doc.lastChild;
            return !Object(__WEBPACK_IMPORTED_MODULE_7_tiptap_utils__["d" /* nodeEqualsType */])({
              node: lastNode,
              types: disabledNodes
            });
          },
          apply: function apply(tr, value) {
            if (!tr.docChanged) {
              return value;
            }

            var lastNode = tr.doc.lastChild;
            return !Object(__WEBPACK_IMPORTED_MODULE_7_tiptap_utils__["d" /* nodeEqualsType */])({
              node: lastNode,
              types: disabledNodes
            });
          }
        }
      })];
    }
  }]);

  return TrailingNode;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap__["e" /* Extension */]);




/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var createDesc = __webpack_require__(52);
module.exports = __webpack_require__(12) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(23);
var has = __webpack_require__(27);
var SRC = __webpack_require__(53)('src');
var $toString = __webpack_require__(367);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(31).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(7);
var defined = __webpack_require__(39);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(186);
var isBuffer = __webpack_require__(575);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(69);
var defined = __webpack_require__(39);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(70);
var createDesc = __webpack_require__(52);
var toIObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(38);
var has = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(147);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(27);
var toObject = __webpack_require__(15);
var IE_PROTO = __webpack_require__(100)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "edit_icon_simple.svg?2e97c93184357c40c527633b8f6f81a4";

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentMatch", function() { return ContentMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMParser", function() { return DOMParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMSerializer", function() { return DOMSerializer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fragment", function() { return Fragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mark", function() { return Mark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarkType", function() { return MarkType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Node", function() { return Node; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NodeRange", function() { return NodeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NodeType", function() { return NodeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaceError", function() { return ReplaceError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolvedPos", function() { return ResolvedPos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Schema", function() { return Schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slice", function() { return Slice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_orderedmap__ = __webpack_require__(671);


function findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (!childA.sameMarkup(childB)) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A fragment represents a node's collection of child nodes.
//
// Like nodes, fragments are persistent data structures, and you
// should not mutate them or their content. Rather, you create new
// instances whenever needed. The API tries to make this easy.
var Fragment = function Fragment(content, size) {
  this.content = content;
  // :: number
  // The size of the fragment, which is the total of the size of its
  // content nodes.
  this.size = size || 0;
  if (size == null) { for (var i = 0; i < content.length; i++)
    { this.size += content[i].nodeSize; } }
};

var prototypeAccessors = { firstChild: { configurable: true },lastChild: { configurable: true },childCount: { configurable: true } };

// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes between the given two
// positions (relative to start of this fragment). Doesn't descend
// into a node when the callback returns `false`.
Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
    if ( nodeStart === void 0 ) nodeStart = 0;

  for (var i = 0, pos = 0; pos < to; i++) {
    var child = this.content[i], end = pos + child.nodeSize;
    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
      var start = pos + 1;
      child.nodesBetween(Math.max(0, from - start),
                         Math.min(child.content.size, to - start),
                         f, nodeStart + start);
    }
    pos = end;
  }
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. The callback
// may return `false` to prevent traversal of a given node's children.
Fragment.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.size, f);
};

// : (number, number, ?string, ?string) → string
Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  var text = "", separated = true;
  this.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
      separated = !blockSeparator;
    } else if (node.isLeaf && leafText) {
      text += leafText;
      separated = !blockSeparator;
    } else if (!separated && node.isBlock) {
      text += blockSeparator;
      separated = true;
    }
  }, 0);
  return text
};

// :: (Fragment) → Fragment
// Create a new fragment containing the combined content of this
// fragment and the other.
Fragment.prototype.append = function append (other) {
  if (!other.size) { return this }
  if (!this.size) { return other }
  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
  if (last.isText && last.sameMarkup(first)) {
    content[content.length - 1] = last.withText(last.text + first.text);
    i = 1;
  }
  for (; i < other.content.length; i++) { content.push(other.content[i]); }
  return new Fragment(content, this.size + other.size)
};

// :: (number, ?number) → Fragment
// Cut out the sub-fragment between the two given positions.
Fragment.prototype.cut = function cut (from, to) {
  if (to == null) { to = this.size; }
  if (from == 0 && to == this.size) { return this }
  var result = [], size = 0;
  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
    var child = this.content[i], end = pos + child.nodeSize;
    if (end > from) {
      if (pos < from || end > to) {
        if (child.isText)
          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
        else
          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
      }
      result.push(child);
      size += child.nodeSize;
    }
    pos = end;
  } }
  return new Fragment(result, size)
};

Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
  if (from == to) { return Fragment.empty }
  if (from == 0 && to == this.content.length) { return this }
  return new Fragment(this.content.slice(from, to))
};

// :: (number, Node) → Fragment
// Create a new fragment in which the node at the given index is
// replaced by the given node.
Fragment.prototype.replaceChild = function replaceChild (index, node) {
  var current = this.content[index];
  if (current == node) { return this }
  var copy = this.content.slice();
  var size = this.size + node.nodeSize - current.nodeSize;
  copy[index] = node;
  return new Fragment(copy, size)
};

// : (Node) → Fragment
// Create a new fragment by prepending the given node to this
// fragment.
Fragment.prototype.addToStart = function addToStart (node) {
  return new Fragment([node].concat(this.content), this.size + node.nodeSize)
};

// : (Node) → Fragment
// Create a new fragment by appending the given node to this
// fragment.
Fragment.prototype.addToEnd = function addToEnd (node) {
  return new Fragment(this.content.concat(node), this.size + node.nodeSize)
};

// :: (Fragment) → bool
// Compare this fragment to another one.
Fragment.prototype.eq = function eq (other) {
  if (this.content.length != other.content.length) { return false }
  for (var i = 0; i < this.content.length; i++)
    { if (!this.content[i].eq(other.content[i])) { return false } }
  return true
};

// :: ?Node
// The first child of the fragment, or `null` if it is empty.
prototypeAccessors.firstChild.get = function () { return this.content.length ? this.content[0] : null };

// :: ?Node
// The last child of the fragment, or `null` if it is empty.
prototypeAccessors.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };

// :: number
// The number of child nodes in this fragment.
prototypeAccessors.childCount.get = function () { return this.content.length };

// :: (number) → Node
// Get the child node at the given index. Raise an error when the
// index is out of range.
Fragment.prototype.child = function child (index) {
  var found = this.content[index];
  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
  return found
};

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Fragment.prototype.maybeChild = function maybeChild (index) {
  return this.content[index]
};

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Fragment.prototype.forEach = function forEach (f) {
  for (var i = 0, p = 0; i < this.content.length; i++) {
    var child = this.content[i];
    f(child, p, i);
    p += child.nodeSize;
  }
};

// :: (Fragment) → ?number
// Find the first position at which this fragment and another
// fragment differ, or `null` if they are the same.
Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
    if ( pos === void 0 ) pos = 0;

  return findDiffStart(this, other, pos)
};

// :: (Fragment) → ?{a: number, b: number}
// Find the first position, searching from the end, at which this
// fragment and the given fragment differ, or `null` if they are the
// same. Since this position will not be the same in both nodes, an
// object with two separate positions is returned.
Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
    if ( pos === void 0 ) pos = this.size;
    if ( otherPos === void 0 ) otherPos = other.size;

  return findDiffEnd(this, other, pos, otherPos)
};

// : (number, ?number) → {index: number, offset: number}
// Find the index and inner offset corresponding to a given relative
// position in this fragment. The result object will be reused
// (overwritten) the next time the function is called. (Not public.)
Fragment.prototype.findIndex = function findIndex (pos, round) {
    if ( round === void 0 ) round = -1;

  if (pos == 0) { return retIndex(0, pos) }
  if (pos == this.size) { return retIndex(this.content.length, pos) }
  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
  for (var i = 0, curPos = 0;; i++) {
    var cur = this.child(i), end = curPos + cur.nodeSize;
    if (end >= pos) {
      if (end == pos || round > 0) { return retIndex(i + 1, end) }
      return retIndex(i, curPos)
    }
    curPos = end;
  }
};

// :: () → string
// Return a debugging string that describes this fragment.
Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };

Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };

// :: () → ?Object
// Create a JSON-serializeable representation of this fragment.
Fragment.prototype.toJSON = function toJSON () {
  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
};

// :: (Schema, ?Object) → Fragment
// Deserialize a fragment from its JSON representation.
Fragment.fromJSON = function fromJSON (schema, value) {
  if (!value) { return Fragment.empty }
  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
  return new Fragment(value.map(schema.nodeFromJSON))
};

// :: ([Node]) → Fragment
// Build a fragment from an array of nodes. Ensures that adjacent
// text nodes with the same marks are joined together.
Fragment.fromArray = function fromArray (array) {
  if (!array.length) { return Fragment.empty }
  var joined, size = 0;
  for (var i = 0; i < array.length; i++) {
    var node = array[i];
    size += node.nodeSize;
    if (i && node.isText && array[i - 1].sameMarkup(node)) {
      if (!joined) { joined = array.slice(0, i); }
      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
    } else if (joined) {
      joined.push(node);
    }
  }
  return new Fragment(joined || array, size)
};

// :: (?union<Fragment, Node, [Node]>) → Fragment
// Create a fragment from something that can be interpreted as a set
// of nodes. For `null`, it returns the empty fragment. For a
// fragment, the fragment itself. For a node or array of nodes, a
// fragment containing those nodes.
Fragment.from = function from (nodes) {
  if (!nodes) { return Fragment.empty }
  if (nodes instanceof Fragment) { return nodes }
  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
  if (nodes.attrs) { return new Fragment([nodes], nodes.nodeSize) }
  throw new RangeError("Can not convert " + nodes + " to a Fragment" +
                       (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""))
};

Object.defineProperties( Fragment.prototype, prototypeAccessors );

var found = {index: 0, offset: 0};
function retIndex(index, offset) {
  found.index = index;
  found.offset = offset;
  return found
}

// :: Fragment
// An empty fragment. Intended to be reused whenever a node doesn't
// contain anything (rather than allocating a new empty fragment for
// each leaf node).
Fragment.empty = new Fragment([], 0);

function compareDeep(a, b) {
  if (a === b) { return true }
  if (!(a && typeof a == "object") ||
      !(b && typeof b == "object")) { return false }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) { return false }
  if (array) {
    if (a.length != b.length) { return false }
    for (var i = 0; i < a.length; i++) { if (!compareDeep(a[i], b[i])) { return false } }
  } else {
    for (var p in a) { if (!(p in b) || !compareDeep(a[p], b[p])) { return false } }
    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  }
  return true
}

// ::- A mark is a piece of information that can be attached to a node,
// such as it being emphasized, in code font, or a link. It has a type
// and optionally a set of attributes that provide further information
// (such as the target of the link). Marks are created through a
// `Schema`, which controls which types exist and which
// attributes they have.
var Mark = function Mark(type, attrs) {
  // :: MarkType
  // The type of this mark.
  this.type = type;
  // :: Object
  // The attributes associated with this mark.
  this.attrs = attrs;
};

// :: ([Mark]) → [Mark]
// Given a set of marks, create a new set which contains this one as
// well, in the right position. If this mark is already in the set,
// the set itself is returned. If any marks that are set to be
// [exclusive](#model.MarkSpec.excludes) with this mark are present,
// those are replaced by this one.
Mark.prototype.addToSet = function addToSet (set) {
  var copy, placed = false;
  for (var i = 0; i < set.length; i++) {
    var other = set[i];
    if (this.eq(other)) { return set }
    if (this.type.excludes(other.type)) {
      if (!copy) { copy = set.slice(0, i); }
    } else if (other.type.excludes(this.type)) {
      return set
    } else {
      if (!placed && other.type.rank > this.type.rank) {
        if (!copy) { copy = set.slice(0, i); }
        copy.push(this);
        placed = true;
      }
      if (copy) { copy.push(other); }
    }
  }
  if (!copy) { copy = set.slice(); }
  if (!placed) { copy.push(this); }
  return copy
};

// :: ([Mark]) → [Mark]
// Remove this mark from the given set, returning a new set. If this
// mark is not in the set, the set itself is returned.
Mark.prototype.removeFromSet = function removeFromSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (this.eq(set[i]))
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → bool
// Test whether this mark is in the given set of marks.
Mark.prototype.isInSet = function isInSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (this.eq(set[i])) { return true } }
  return false
};

// :: (Mark) → bool
// Test whether this mark has the same type and attributes as
// another mark.
Mark.prototype.eq = function eq (other) {
  return this == other ||
    (this.type == other.type && compareDeep(this.attrs, other.attrs))
};

// :: () → Object
// Convert this mark to a JSON-serializeable representation.
Mark.prototype.toJSON = function toJSON () {
  var obj = {type: this.type.name};
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break
  }
  return obj
};

// :: (Schema, Object) → Mark
Mark.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
  var type = schema.marks[json.type];
  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
  return type.create(json.attrs)
};

// :: ([Mark], [Mark]) → bool
// Test whether two sets of marks are identical.
Mark.sameSet = function sameSet (a, b) {
  if (a == b) { return true }
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++)
    { if (!a[i].eq(b[i])) { return false } }
  return true
};

// :: (?union<Mark, [Mark]>) → [Mark]
// Create a properly sorted mark set from null, a single mark, or an
// unsorted array of marks.
Mark.setFrom = function setFrom (marks) {
  if (!marks || marks.length == 0) { return Mark.none }
  if (marks instanceof Mark) { return [marks] }
  var copy = marks.slice();
  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
  return copy
};

// :: [Mark] The empty set of marks.
Mark.none = [];

// ReplaceError:: class extends Error
// Error type raised by [`Node.replace`](#model.Node.replace) when
// given an invalid replacement.

function ReplaceError(message) {
  var err = Error.call(this, message);
  err.__proto__ = ReplaceError.prototype;
  return err
}

ReplaceError.prototype = Object.create(Error.prototype);
ReplaceError.prototype.constructor = ReplaceError;
ReplaceError.prototype.name = "ReplaceError";

// ::- A slice represents a piece cut out of a larger document. It
// stores not only a fragment, but also the depth up to which nodes on
// both side are ‘open’ (cut through).
var Slice = function Slice(content, openStart, openEnd) {
  // :: Fragment The slice's content.
  this.content = content;
  // :: number The open depth at the start.
  this.openStart = openStart;
  // :: number The open depth at the end.
  this.openEnd = openEnd;
};

var prototypeAccessors$1 = { size: { configurable: true } };

// :: number
// The size this slice would add when inserted into a document.
prototypeAccessors$1.size.get = function () {
  return this.content.size - this.openStart - this.openEnd
};

Slice.prototype.insertAt = function insertAt (pos, fragment) {
  var content = insertInto(this.content, pos + this.openStart, fragment, null);
  return content && new Slice(content, this.openStart, this.openEnd)
};

Slice.prototype.removeBetween = function removeBetween (from, to) {
  return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
};

// :: (Slice) → bool
// Tests whether this slice is equal to another slice.
Slice.prototype.eq = function eq (other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
};

Slice.prototype.toString = function toString () {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
};

// :: () → ?Object
// Convert a slice to a JSON-serializable representation.
Slice.prototype.toJSON = function toJSON () {
  if (!this.content.size) { return null }
  var json = {content: this.content.toJSON()};
  if (this.openStart > 0) { json.openStart = this.openStart; }
  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
  return json
};

// :: (Schema, ?Object) → Slice
// Deserialize a slice from its JSON representation.
Slice.fromJSON = function fromJSON (schema, json) {
  if (!json) { return Slice.empty }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number")
    { throw new RangeError("Invalid input for Slice.fromJSON") }
  return new Slice(Fragment.fromJSON(schema, json.content), json.openStart || 0, json.openEnd || 0)
};

// :: (Fragment, ?bool) → Slice
// Create a slice from a fragment by taking the maximum possible
// open value on both side of the fragment.
Slice.maxOpen = function maxOpen (fragment, openIsolating) {
    if ( openIsolating === void 0 ) openIsolating=true;

  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
  return new Slice(fragment, openStart, openEnd)
};

Object.defineProperties( Slice.prototype, prototypeAccessors$1 );

function removeRange(content, from, to) {
  var ref = content.findIndex(from);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  var ref$1 = content.findIndex(to);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
    return content.cut(0, from).append(content.cut(to))
  }
  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)))
}

function insertInto(content, dist, insert, parent) {
  var ref = content.findIndex(dist);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) { return null }
    return content.cut(0, dist).append(insert).append(content.cut(dist))
  }
  var inner = insertInto(child.content, dist - offset - 1, insert);
  return inner && content.replaceChild(index, child.copy(inner))
}

// :: Slice
// The empty slice.
Slice.empty = new Slice(Fragment.empty, 0, 0);

function replace($from, $to, slice) {
  if (slice.openStart > $from.depth)
    { throw new ReplaceError("Inserted content deeper than insertion position") }
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
    { throw new ReplaceError("Inconsistent open depths") }
  return replaceOuter($from, $to, slice, 0)
}

function replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth), node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner))
  } else if (!slice.content.size) {
    return close(node, replaceTwoWay($from, $to, depth))
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
    var parent = $from.parent, content = parent.content;
    return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
  } else {
    var ref = prepareSliceForReplace(slice, $from);
    var start = ref.start;
    var end = ref.end;
    return close(node, replaceThreeWay($from, start, end, $to, depth))
  }
}

function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    { throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
}

function joinable($before, $after, depth) {
  var node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node
}

function addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    { target[last] = child.withText(target[last].text + child.text); }
  else
    { target.push(child); }
}

function addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) { addNode(node.child(i), target); }
  if ($end && $end.depth == depth && $end.textOffset)
    { addNode($end.nodeBefore, target); }
}

function close(node, content) {
  if (!node.type.validContent(content))
    { throw new ReplaceError("Invalid content for node " + node.type.name) }
  return node.copy(content)
}

function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);

  var content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      { addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content); }
    addRange($start, $end, depth, content);
    if (openEnd)
      { addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content); }
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function replaceTwoWay($from, $to, depth) {
  var content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = joinable($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--)
    { node = $along.node(i).copy(Fragment.from(node)); }
  return {start: node.resolveNoCache(slice.openStart + extra),
          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
}

// ::- You can [_resolve_](#model.Node.resolve) a position to get more
// information about it. Objects of this class represent such a
// resolved position, providing various pieces of context information,
// and some helper methods.
//
// Throughout this interface, methods that take an optional `depth`
// parameter will interpret undefined as `this.depth` and negative
// numbers as `this.depth + value`.
var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
  // :: number The position that was resolved.
  this.pos = pos;
  this.path = path;
  // :: number
  // The number of levels the parent node is from the root. If this
  // position points directly into the root node, it is 0. If it
  // points into a top-level paragraph, 1, and so on.
  this.depth = path.length / 3 - 1;
  // :: number The offset this position has into its parent node.
  this.parentOffset = parentOffset;
};

var prototypeAccessors$2 = { parent: { configurable: true },doc: { configurable: true },textOffset: { configurable: true },nodeAfter: { configurable: true },nodeBefore: { configurable: true } };

ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
  if (val == null) { return this.depth }
  if (val < 0) { return this.depth + val }
  return val
};

// :: Node
// The parent node that the position points into. Note that even if
// a position points into a text node, that node is not considered
// the parent—text nodes are ‘flat’ in this model, and have no content.
prototypeAccessors$2.parent.get = function () { return this.node(this.depth) };

// :: Node
// The root node in which the position was resolved.
prototypeAccessors$2.doc.get = function () { return this.node(0) };

// :: (?number) → Node
// The ancestor node at the given level. `p.node(p.depth)` is the
// same as `p.parent`.
ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };

// :: (?number) → number
// The index into the ancestor at the given level. If this points at
// the 3rd node in the 2nd paragraph on the top level, for example,
// `p.index(0)` is 1 and `p.index(1)` is 2.
ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };

// :: (?number) → number
// The index pointing after this position into the ancestor at the
// given level.
ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
};

// :: (?number) → number
// The (absolute) position at the start of the node at the given
// level.
ResolvedPos.prototype.start = function start (depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
};

// :: (?number) → number
// The (absolute) position at the end of the node at the given
// level.
ResolvedPos.prototype.end = function end (depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size
};

// :: (?number) → number
// The (absolute) position directly before the wrapping node at the
// given level, or, when `depth` is `this.depth + 1`, the original
// position.
ResolvedPos.prototype.before = function before (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position before the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
};

// :: (?number) → number
// The (absolute) position directly after the wrapping node at the
// given level, or the original position when `depth` is `this.depth + 1`.
ResolvedPos.prototype.after = function after (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position after the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
};

// :: number
// When this position points into a text node, this returns the
// distance between the position and the start of the text node.
// Will be zero for positions that point between nodes.
prototypeAccessors$2.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };

// :: ?Node
// Get the node directly after the position, if any. If the position
// points into a text node, only the part of that node after the
// position is returned.
prototypeAccessors$2.nodeAfter.get = function () {
  var parent = this.parent, index = this.index(this.depth);
  if (index == parent.childCount) { return null }
  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
  return dOff ? parent.child(index).cut(dOff) : child
};

// :: ?Node
// Get the node directly before the position, if any. If the
// position points into a text node, only the part of that node
// before the position is returned.
prototypeAccessors$2.nodeBefore.get = function () {
  var index = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) { return this.parent.child(index).cut(0, dOff) }
  return index == 0 ? null : this.parent.child(index - 1)
};

// :: () → [Mark]
// Get the marks at this position, factoring in the surrounding
// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
// position is at the start of a non-empty node, the marks of the
// node after it (if any) are returned.
ResolvedPos.prototype.marks = function marks () {
  var parent = this.parent, index = this.index();

  // In an empty parent, return the empty array
  if (parent.content.size == 0) { return Mark.none }

  // When inside a text node, just return the text node's marks
  if (this.textOffset) { return parent.child(index).marks }

  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
  // If the `after` flag is true of there is no node before, make
  // the node after this position the main reference.
  if (!main) { var tmp = main; main = other; other = tmp; }

  // Use all marks in the main node, except those that have
  // `inclusive` set to false and are not present in the other node.
  var marks = main.marks;
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
      { marks = marks[i--].removeFromSet(marks); } }

  return marks
};

// :: (ResolvedPos) → ?[Mark]
// Get the marks after the current position, if any, except those
// that are non-inclusive and not present at position `$end`. This
// is mostly useful for getting the set of marks to preserve after a
// deletion. Will return `null` if this position is at the end of
// its parent node or its parent node isn't a textblock (in which
// case no marks should be preserved).
ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
  var after = this.parent.maybeChild(this.index());
  if (!after || !after.isInline) { return null }

  var marks = after.marks, next = $end.parent.maybeChild($end.index());
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
      { marks = marks[i--].removeFromSet(marks); } }
  return marks
};

// :: (number) → number
// The depth up to which this position and the given (non-resolved)
// position share the same parent nodes.
ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
  for (var depth = this.depth; depth > 0; depth--)
    { if (this.start(depth) <= pos && this.end(depth) >= pos) { return depth } }
  return 0
};

// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
// Returns a range based on the place where this position and the
// given position diverge around block content. If both point into
// the same textblock, for example, a range around that textblock
// will be returned. If they point into different blocks, the range
// around those blocks in their shared ancestor is returned. You can
// pass in an optional predicate that will be called with a parent
// node to see if a range into that parent is acceptable.
ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
    if ( other === void 0 ) other = this;

  if (other.pos < this.pos) { return other.blockRange(this) }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
    { if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
      { return new NodeRange(this, other, d) } }
};

// :: (ResolvedPos) → bool
// Query whether the given position shares the same parent node.
ResolvedPos.prototype.sameParent = function sameParent (other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset
};

// :: (ResolvedPos) → ResolvedPos
// Return the greater of this and the given position.
ResolvedPos.prototype.max = function max (other) {
  return other.pos > this.pos ? other : this
};

// :: (ResolvedPos) → ResolvedPos
// Return the smaller of this and the given position.
ResolvedPos.prototype.min = function min (other) {
  return other.pos < this.pos ? other : this
};

ResolvedPos.prototype.toString = function toString () {
  var str = "";
  for (var i = 1; i <= this.depth; i++)
    { str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1); }
  return str + ":" + this.parentOffset
};

ResolvedPos.resolve = function resolve (doc, pos) {
  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
  var path = [];
  var start = 0, parentOffset = pos;
  for (var node = doc;;) {
    var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
    var rem = parentOffset - offset;
    path.push(node, index, start + offset);
    if (!rem) { break }
    node = node.child(index);
    if (node.isText) { break }
    parentOffset = rem - 1;
    start += offset + 1;
  }
  return new ResolvedPos(pos, path, parentOffset)
};

ResolvedPos.resolveCached = function resolveCached (doc, pos) {
  for (var i = 0; i < resolveCache.length; i++) {
    var cached = resolveCache[i];
    if (cached.pos == pos && cached.doc == doc) { return cached }
  }
  var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
  return result
};

Object.defineProperties( ResolvedPos.prototype, prototypeAccessors$2 );

var resolveCache = [], resolveCachePos = 0, resolveCacheSize = 12;

// ::- Represents a flat range of content, i.e. one that starts and
// ends in the same node.
var NodeRange = function NodeRange($from, $to, depth) {
  // :: ResolvedPos A resolved position along the start of the
  // content. May have a `depth` greater than this object's `depth`
  // property, since these are the positions that were used to
  // compute the range, not re-resolved positions directly at its
  // boundaries.
  this.$from = $from;
  // :: ResolvedPos A position along the end of the content. See
  // caveat for [`$from`](#model.NodeRange.$from).
  this.$to = $to;
  // :: number The depth of the node that this range points into.
  this.depth = depth;
};

var prototypeAccessors$1$1 = { start: { configurable: true },end: { configurable: true },parent: { configurable: true },startIndex: { configurable: true },endIndex: { configurable: true } };

// :: number The position at the start of the range.
prototypeAccessors$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
// :: number The position at the end of the range.
prototypeAccessors$1$1.end.get = function () { return this.$to.after(this.depth + 1) };

// :: Node The parent node that the range points into.
prototypeAccessors$1$1.parent.get = function () { return this.$from.node(this.depth) };
// :: number The start index of the range in the parent node.
prototypeAccessors$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
// :: number The end index of the range in the parent node.
prototypeAccessors$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };

Object.defineProperties( NodeRange.prototype, prototypeAccessors$1$1 );

var emptyAttrs = Object.create(null);

// ::- This class represents a node in the tree that makes up a
// ProseMirror document. So a document is an instance of `Node`, with
// children that are also instances of `Node`.
//
// Nodes are persistent data structures. Instead of changing them, you
// create new ones with the content you want. Old ones keep pointing
// at the old document shape. This is made cheaper by sharing
// structure between the old and new data as much as possible, which a
// tree shape like this (without back pointers) makes easy.
//
// **Do not** directly mutate the properties of a `Node` object. See
// [the guide](/docs/guide/#doc) for more information.
var Node = function Node(type, attrs, content, marks) {
  // :: NodeType
  // The type of node that this is.
  this.type = type;

  // :: Object
  // An object mapping attribute names to values. The kind of
  // attributes allowed and required are
  // [determined](#model.NodeSpec.attrs) by the node type.
  this.attrs = attrs;

  // :: Fragment
  // A container holding the node's children.
  this.content = content || Fragment.empty;

  // :: [Mark]
  // The marks (things like whether it is emphasized or part of a
  // link) applied to this node.
  this.marks = marks || Mark.none;
};

var prototypeAccessors$3 = { nodeSize: { configurable: true },childCount: { configurable: true },textContent: { configurable: true },firstChild: { configurable: true },lastChild: { configurable: true },isBlock: { configurable: true },isTextblock: { configurable: true },inlineContent: { configurable: true },isInline: { configurable: true },isText: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true } };

// text:: ?string
// For text nodes, this contains the node's text content.

// :: number
// The size of this node, as defined by the integer-based [indexing
// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
// amount of characters. For other leaf nodes, it is one. For
// non-leaf nodes, it is the size of the content plus two (the start
// and end token).
prototypeAccessors$3.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };

// :: number
// The number of children that the node has.
prototypeAccessors$3.childCount.get = function () { return this.content.childCount };

// :: (number) → Node
// Get the child node at the given index. Raises an error when the
// index is out of range.
Node.prototype.child = function child (index) { return this.content.child(index) };

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };

// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes recursively between
// the given two positions that are relative to start of this node's
// content. The callback is invoked with the node, its
// parent-relative position, its parent node, and its child index.
// When the callback returns false for a given node, that node's
// children will not be recursed over. The last parameter can be
// used to specify a starting position to count from.
Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
    if ( startPos === void 0 ) startPos = 0;

  this.content.nodesBetween(from, to, f, startPos, this);
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. Doesn't
// descend into a node when the callback returns `false`.
Node.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.content.size, f);
};

// :: string
// Concatenates all the text nodes found in this fragment and its
// children.
prototypeAccessors$3.textContent.get = function () { return this.textBetween(0, this.content.size, "") };

// :: (number, number, ?string, ?string) → string
// Get all text between positions `from` and `to`. When
// `blockSeparator` is given, it will be inserted whenever a new
// block node is started. When `leafText` is given, it'll be
// inserted for every non-text leaf node encountered.
Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  return this.content.textBetween(from, to, blockSeparator, leafText)
};

// :: ?Node
// Returns this node's first child, or `null` if there are no
// children.
prototypeAccessors$3.firstChild.get = function () { return this.content.firstChild };

// :: ?Node
// Returns this node's last child, or `null` if there are no
// children.
prototypeAccessors$3.lastChild.get = function () { return this.content.lastChild };

// :: (Node) → bool
// Test whether two nodes represent the same piece of document.
Node.prototype.eq = function eq (other) {
  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
};

// :: (Node) → bool
// Compare the markup (type, attributes, and marks) of this node to
// those of another. Returns `true` if both have the same markup.
Node.prototype.sameMarkup = function sameMarkup (other) {
  return this.hasMarkup(other.type, other.attrs, other.marks)
};

// :: (NodeType, ?Object, ?[Mark]) → bool
// Check whether this node's markup correspond to the given type,
// attributes, and marks.
Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
  return this.type == type &&
    compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
    Mark.sameSet(this.marks, marks || Mark.none)
};

// :: (?Fragment) → Node
// Create a new node with the same markup as this node, containing
// the given content (or empty, if no content is given).
Node.prototype.copy = function copy (content) {
    if ( content === void 0 ) content = null;

  if (content == this.content) { return this }
  return new this.constructor(this.type, this.attrs, content, this.marks)
};

// :: ([Mark]) → Node
// Create a copy of this node, with the given set of marks instead
// of the node's own marks.
Node.prototype.mark = function mark (marks) {
  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
};

// :: (number, ?number) → Node
// Create a copy of this node with only the content between the
// given positions. If `to` is not given, it defaults to the end of
// the node.
Node.prototype.cut = function cut (from, to) {
  if (from == 0 && to == this.content.size) { return this }
  return this.copy(this.content.cut(from, to))
};

// :: (number, ?number) → Slice
// Cut out the part of the document between the given positions, and
// return it as a `Slice` object.
Node.prototype.slice = function slice (from, to, includeParents) {
    if ( to === void 0 ) to = this.content.size;
    if ( includeParents === void 0 ) includeParents = false;

  if (from == to) { return Slice.empty }

  var $from = this.resolve(from), $to = this.resolve(to);
  var depth = includeParents ? 0 : $from.sharedDepth(to);
  var start = $from.start(depth), node = $from.node(depth);
  var content = node.content.cut($from.pos - start, $to.pos - start);
  return new Slice(content, $from.depth - depth, $to.depth - depth)
};

// :: (number, number, Slice) → Node
// Replace the part of the document between the given positions with
// the given slice. The slice must 'fit', meaning its open sides
// must be able to connect to the surrounding content, and its
// content nodes must be valid children for the node they are placed
// into. If any of this is violated, an error of type
// [`ReplaceError`](#model.ReplaceError) is thrown.
Node.prototype.replace = function replace$1 (from, to, slice) {
  return replace(this.resolve(from), this.resolve(to), slice)
};

// :: (number) → ?Node
// Find the node directly after the given position.
Node.prototype.nodeAt = function nodeAt (pos) {
  for (var node = this;;) {
    var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
    node = node.maybeChild(index);
    if (!node) { return null }
    if (offset == pos || node.isText) { return node }
    pos -= offset + 1;
  }
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node after the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childAfter = function childAfter (pos) {
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  return {node: this.content.maybeChild(index), index: index, offset: offset}
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node before the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childBefore = function childBefore (pos) {
  if (pos == 0) { return {node: null, index: 0, offset: 0} }
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
  var node = this.content.child(index - 1);
  return {node: node, index: index - 1, offset: offset - node.nodeSize}
};

// :: (number) → ResolvedPos
// Resolve the given position in the document, returning an
// [object](#model.ResolvedPos) with information about its context.
Node.prototype.resolve = function resolve (pos) { return ResolvedPos.resolveCached(this, pos) };

Node.prototype.resolveNoCache = function resolveNoCache (pos) { return ResolvedPos.resolve(this, pos) };

// :: (number, number, MarkType) → bool
// Test whether a mark of the given type occurs in this document
// between the two given positions.
Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
  var found = false;
  if (to > from) { this.nodesBetween(from, to, function (node) {
    if (type.isInSet(node.marks)) { found = true; }
    return !found
  }); }
  return found
};

// :: bool
// True when this is a block (non-inline node)
prototypeAccessors$3.isBlock.get = function () { return this.type.isBlock };

// :: bool
// True when this is a textblock node, a block node with inline
// content.
prototypeAccessors$3.isTextblock.get = function () { return this.type.isTextblock };

// :: bool
// True when this node allows inline content.
prototypeAccessors$3.inlineContent.get = function () { return this.type.inlineContent };

// :: bool
// True when this is an inline node (a text node or a node that can
// appear among text).
prototypeAccessors$3.isInline.get = function () { return this.type.isInline };

// :: bool
// True when this is a text node.
prototypeAccessors$3.isText.get = function () { return this.type.isText };

// :: bool
// True when this is a leaf node.
prototypeAccessors$3.isLeaf.get = function () { return this.type.isLeaf };

// :: bool
// True when this is an atom, i.e. when it does not have directly
// editable content. This is usually the same as `isLeaf`, but can
// be configured with the [`atom` property](#model.NodeSpec.atom) on
// a node's spec (typically used when the node is displayed as an
// uneditable [node view](#view.NodeView)).
prototypeAccessors$3.isAtom.get = function () { return this.type.isAtom };

// :: () → string
// Return a string representation of this node for debugging
// purposes.
Node.prototype.toString = function toString () {
  if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
  var name = this.type.name;
  if (this.content.size)
    { name += "(" + this.content.toStringInner() + ")"; }
  return wrapMarks(this.marks, name)
};

// :: (number) → ContentMatch
// Get the content match in this node at the given index.
Node.prototype.contentMatchAt = function contentMatchAt (index) {
  var match = this.type.contentMatch.matchFragment(this.content, 0, index);
  if (!match) { throw new Error("Called contentMatchAt on a node with invalid content") }
  return match
};

// :: (number, number, ?Fragment, ?number, ?number) → bool
// Test whether replacing the range between `from` and `to` (by
// child index) with the given replacement fragment (which defaults
// to the empty fragment) would leave the node's content valid. You
// can optionally pass `start` and `end` indices into the
// replacement fragment.
Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
    if ( replacement === void 0 ) replacement = Fragment.empty;
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = replacement.childCount;

  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
  var two = one && one.matchFragment(this.content, to);
  if (!two || !two.validEnd) { return false }
  for (var i = start; i < end; i++) { if (!this.type.allowsMarks(replacement.child(i).marks)) { return false } }
  return true
};

// :: (number, number, NodeType, ?[Mark]) → bool
// Test whether replacing the range `from` to `to` (by index) with a
// node of the given type would leave the node's content valid.
Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
  if (marks && !this.type.allowsMarks(marks)) { return false }
  var start = this.contentMatchAt(from).matchType(type);
  var end = start && start.matchFragment(this.content, to);
  return end ? end.validEnd : false
};

// :: (Node) → bool
// Test whether the given node's content could be appended to this
// node. If that node is empty, this will only return true if there
// is at least one node type that can appear in both nodes (to avoid
// merging completely incompatible nodes).
Node.prototype.canAppend = function canAppend (other) {
  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
  else { return this.type.compatibleContent(other.type) }
};

// Unused. Left for backwards compatibility.
Node.prototype.defaultContentType = function defaultContentType (at) {
  return this.contentMatchAt(at).defaultType
};

// :: ()
// Check whether this node and its descendants conform to the
// schema, and raise error when they do not.
Node.prototype.check = function check () {
  if (!this.type.validContent(this.content))
    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
  this.content.forEach(function (node) { return node.check(); });
};

// :: () → Object
// Return a JSON-serializeable representation of this node.
Node.prototype.toJSON = function toJSON () {
  var obj = {type: this.type.name};
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break
  }
  if (this.content.size)
    { obj.content = this.content.toJSON(); }
  if (this.marks.length)
    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
  return obj
};

// :: (Schema, Object) → Node
// Deserialize a node from its JSON representation.
Node.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
  var marks = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
    marks = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
    return schema.text(json.text, marks)
  }
  var content = Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content, marks)
};

Object.defineProperties( Node.prototype, prototypeAccessors$3 );

var TextNode = /*@__PURE__*/(function (Node) {
  function TextNode(type, attrs, content, marks) {
    Node.call(this, type, attrs, null, marks);

    if (!content) { throw new RangeError("Empty text nodes are not allowed") }

    this.text = content;
  }

  if ( Node ) TextNode.__proto__ = Node;
  TextNode.prototype = Object.create( Node && Node.prototype );
  TextNode.prototype.constructor = TextNode;

  var prototypeAccessors$1 = { textContent: { configurable: true },nodeSize: { configurable: true } };

  TextNode.prototype.toString = function toString () {
    if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
    return wrapMarks(this.marks, JSON.stringify(this.text))
  };

  prototypeAccessors$1.textContent.get = function () { return this.text };

  TextNode.prototype.textBetween = function textBetween (from, to) { return this.text.slice(from, to) };

  prototypeAccessors$1.nodeSize.get = function () { return this.text.length };

  TextNode.prototype.mark = function mark (marks) {
    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks)
  };

  TextNode.prototype.withText = function withText (text) {
    if (text == this.text) { return this }
    return new TextNode(this.type, this.attrs, text, this.marks)
  };

  TextNode.prototype.cut = function cut (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.text.length;

    if (from == 0 && to == this.text.length) { return this }
    return this.withText(this.text.slice(from, to))
  };

  TextNode.prototype.eq = function eq (other) {
    return this.sameMarkup(other) && this.text == other.text
  };

  TextNode.prototype.toJSON = function toJSON () {
    var base = Node.prototype.toJSON.call(this);
    base.text = this.text;
    return base
  };

  Object.defineProperties( TextNode.prototype, prototypeAccessors$1 );

  return TextNode;
}(Node));

function wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--)
    { str = marks[i].type.name + "(" + str + ")"; }
  return str
}

// ::- Instances of this class represent a match state of a node
// type's [content expression](#model.NodeSpec.content), and can be
// used to find out whether further content matches here, and whether
// a given position is a valid end of the node.
var ContentMatch = function ContentMatch(validEnd) {
  // :: bool
  // True when this match state represents a valid end of the node.
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};

var prototypeAccessors$4 = { inlineContent: { configurable: true },defaultType: { configurable: true },edgeCount: { configurable: true } };

ContentMatch.parse = function parse (string, nodeTypes) {
  var stream = new TokenStream(string, nodeTypes);
  if (stream.next == null) { return ContentMatch.empty }
  var expr = parseExpr(stream);
  if (stream.next) { stream.err("Unexpected trailing text"); }
  var match = dfa(nfa(expr));
  checkForDeadEnds(match, stream);
  return match
};

// :: (NodeType) → ?ContentMatch
// Match a node type, returning a match after that node if
// successful.
ContentMatch.prototype.matchType = function matchType (type) {
  for (var i = 0; i < this.next.length; i += 2)
    { if (this.next[i] == type) { return this.next[i + 1] } }
  return null
};

// :: (Fragment, ?number, ?number) → ?ContentMatch
// Try to match a fragment. Returns the resulting match when
// successful.
ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = frag.childCount;

  var cur = this;
  for (var i = start; cur && i < end; i++)
    { cur = cur.matchType(frag.child(i).type); }
  return cur
};

prototypeAccessors$4.inlineContent.get = function () {
  var first = this.next[0];
  return first ? first.isInline : false
};

// :: ?NodeType
// Get the first matching node type at this match position that can
// be generated.
prototypeAccessors$4.defaultType.get = function () {
  for (var i = 0; i < this.next.length; i += 2) {
    var type = this.next[i];
    if (!(type.isText || type.hasRequiredAttrs())) { return type }
  }
};

ContentMatch.prototype.compatible = function compatible (other) {
  for (var i = 0; i < this.next.length; i += 2)
    { for (var j = 0; j < other.next.length; j += 2)
      { if (this.next[i] == other.next[j]) { return true } } }
  return false
};

// :: (Fragment, bool, ?number) → ?Fragment
// Try to match the given fragment, and if that fails, see if it can
// be made to match by inserting nodes in front of it. When
// successful, return a fragment of inserted nodes (which may be
// empty if nothing had to be inserted). When `toEnd` is true, only
// return a fragment if the resulting match goes to the end of the
// content expression.
ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
    if ( toEnd === void 0 ) toEnd = false;
    if ( startIndex === void 0 ) startIndex = 0;

  var seen = [this];
  function search(match, types) {
    var finished = match.matchFragment(after, startIndex);
    if (finished && (!toEnd || finished.validEnd))
      { return Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }

    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i], next = match.next[i + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found = search(next, types.concat(type));
        if (found) { return found }
      }
    }
  }

  return search(this, [])
};

// :: (NodeType) → ?[NodeType]
// Find a set of wrapping node types that would allow a node of the
// given type to appear at this position. The result may be empty
// (when it fits directly) and will be null when no such wrapping
// exists.
ContentMatch.prototype.findWrapping = function findWrapping (target) {
  for (var i = 0; i < this.wrapCache.length; i += 2)
    { if (this.wrapCache[i] == target) { return this.wrapCache[i + 1] } }
  var computed = this.computeWrapping(target);
  this.wrapCache.push(target, computed);
  return computed
};

ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result = [];
      for (var obj = current; obj.type; obj = obj.via)
        { result.push(obj.type); }
      return result.reverse()
    }
    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i];
      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
        active.push({match: type.contentMatch, type: type, via: current});
        seen[type.name] = true;
      }
    }
  }
};

// :: number
// The number of outgoing edges this node has in the finite
// automaton that describes the content expression.
prototypeAccessors$4.edgeCount.get = function () {
  return this.next.length >> 1
};

// :: (number) → {type: NodeType, next: ContentMatch}
// Get the _n_​th outgoing edge from this node in the finite
// automaton that describes the content expression.
ContentMatch.prototype.edge = function edge (n) {
  var i = n << 1;
  if (i >= this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
  return {type: this.next[i], next: this.next[i + 1]}
};

ContentMatch.prototype.toString = function toString () {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i = 1; i < m.next.length; i += 2)
      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
  }
  scan(this);
  return seen.map(function (m, i) {
    var out = i + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
    return out
  }).join("\n")
};

Object.defineProperties( ContentMatch.prototype, prototypeAccessors$4 );

ContentMatch.empty = new ContentMatch(true);

var TokenStream = function TokenStream(string, nodeTypes) {
  this.string = string;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
  if (this.tokens[0] == "") { this.tokens.unshift(); }
};

var prototypeAccessors$1$2 = { next: { configurable: true } };

prototypeAccessors$1$2.next.get = function () { return this.tokens[this.pos] };

TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };

TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };

Object.defineProperties( TokenStream.prototype, prototypeAccessors$1$2 );

function parseExpr(stream) {
  var exprs = [];
  do { exprs.push(parseExprSeq(stream)); }
  while (stream.eat("|"))
  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
}

function parseExprSeq(stream) {
  var exprs = [];
  do { exprs.push(parseExprSubscript(stream)); }
  while (stream.next && stream.next != ")" && stream.next != "|")
  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
}

function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+"))
      { expr = {type: "plus", expr: expr}; }
    else if (stream.eat("*"))
      { expr = {type: "star", expr: expr}; }
    else if (stream.eat("?"))
      { expr = {type: "opt", expr: expr}; }
    else if (stream.eat("{"))
      { expr = parseExprRange(stream, expr); }
    else { break }
  }
  return expr
}

function parseNum(stream) {
  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
  var result = Number(stream.next);
  stream.pos++;
  return result
}

function parseExprRange(stream, expr) {
  var min = parseNum(stream), max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") { max = parseNum(stream); }
    else { max = -1; }
  }
  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
  return {type: "range", min: min, max: max, expr: expr}
}

function resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) { return [type] }
  var result = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
  }
  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
  return result
}

function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
    return expr
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) { stream.inline = type.isInline; }
      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
      return {type: "name", value: type}
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}

// The code below helps compile a regular-expression-like language
// into a deterministic finite automaton. For a good introduction to
// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html

// : (Object) → [[{term: ?any, to: number}]]
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa

  function node() { return nfa.push([]) - 1 }
  function edge(from, to, term) {
    var edge = {term: term, to: to};
    nfa[from].push(edge);
    return edge
  }
  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }

  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) { return next }
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)]
    } else if (expr.type == "plus") {
      var loop$1 = node();
      connect(compile(expr.expr, from), loop$1);
      connect(compile(expr.expr, loop$1), loop$1);
      return [edge(loop$1)]
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from))
    } else if (expr.type == "range") {
      var cur = from;
      for (var i$1 = 0; i$1 < expr.min; i$1++) {
        var next$1 = node();
        connect(compile(expr.expr, cur), next$1);
        cur = next$1;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
          var next$2 = node();
          edge(cur, next$2);
          connect(compile(expr.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge(cur)]
    } else if (expr.type == "name") {
      return [edge(from, null, expr.value)]
    }
  }
}

function cmp(a, b) { return b - a }

// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(cmp)

  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var ref = edges[i];
      var term = ref.term;
      var to = ref.to;
      if (!term && result.indexOf(to) == -1) { scan(to); }
    }
  }
}

// : ([[{term: ?any, to: number}]]) → ContentMatch
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
  var labeled = Object.create(null);
  return explore(nullFrom(nfa, 0))

  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (ref) {
        var term = ref.term;
        var to = ref.to;

        if (!term) { return }
        var known = out.indexOf(term), set = known > -1 && out[known + 1];
        nullFrom(nfa, to).forEach(function (node) {
          if (!set) { out.push(term, set = []); }
          if (set.indexOf(node) == -1) { set.push(node); }
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i += 2) {
      var states$1 = out[i + 1].sort(cmp);
      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
    }
    return state
  }
}

function checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node = state.next[j], next = state.next[j + 1];
      nodes.push(node.name);
      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
      if (work.indexOf(next) == -1) { work.push(next); }
    }
    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position"); }
  }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) { return null }
    defaults[attrName] = attr.default;
  }
  return defaults
}

function computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) { given = attr.default; }
      else { throw new RangeError("No value supplied for attribute " + name) }
    }
    built[name] = given;
  }
  return built
}

function initAttrs(attrs) {
  var result = Object.create(null);
  if (attrs) { for (var name in attrs) { result[name] = new Attribute(attrs[name]); } }
  return result
}

// ::- Node types are objects allocated once per `Schema` and used to
// [tag](#model.Node.type) `Node` instances. They contain information
// about the node type, such as its name and what kind of node it
// represents.
var NodeType = function NodeType(name, schema, spec) {
  // :: string
  // The name the node type has in this schema.
  this.name = name;

  // :: Schema
  // A link back to the `Schema` the node type belongs to.
  this.schema = schema;

  // :: NodeSpec
  // The spec that this type is based on
  this.spec = spec;

  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = initAttrs(spec.attrs);

  this.defaultAttrs = defaultAttrs(this.attrs);

  // :: ContentMatch
  // The starting match of the node type's content expression.
  this.contentMatch = null;

  // : ?[MarkType]
  // The set of marks allowed in this node. `null` means all marks
  // are allowed.
  this.markSet = null;

  // :: bool
  // True if this node type has inline content.
  this.inlineContent = null;

  // :: bool
  // True if this is a block type
  this.isBlock = !(spec.inline || name == "text");

  // :: bool
  // True if this is the text node type.
  this.isText = name == "text";
};

var prototypeAccessors$5 = { isInline: { configurable: true },isTextblock: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true } };

// :: bool
// True if this is an inline type.
prototypeAccessors$5.isInline.get = function () { return !this.isBlock };

// :: bool
// True if this is a textblock type, a block that contains inline
// content.
prototypeAccessors$5.isTextblock.get = function () { return this.isBlock && this.inlineContent };

// :: bool
// True for node types that allow no content.
prototypeAccessors$5.isLeaf.get = function () { return this.contentMatch == ContentMatch.empty };

// :: bool
// True when this node is an atom, i.e. when it does not have
// directly editable content.
prototypeAccessors$5.isAtom.get = function () { return this.isLeaf || this.spec.atom };

NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs (ignore) {
  for (var n in this.attrs)
    { if (this.attrs[n].isRequired && (!ignore || !(n in ignore))) { return true } }
  return false
};

NodeType.prototype.compatibleContent = function compatibleContent (other) {
  return this == other || this.contentMatch.compatible(other.contentMatch)
};

NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
  else { return computeAttrs(this.attrs, attrs) }
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a `Node` of this type. The given attributes are
// checked and defaulted (you can pass `null` to use the type's
// defaults entirely, if no required attributes exist). `content`
// may be a `Fragment`, a node, an array of nodes, or
// `null`. Similarly `marks` may be `null` to default to the empty
// set of marks.
NodeType.prototype.create = function create (attrs, content, marks) {
  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
  return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Like [`create`](#model.NodeType.create), but check the given content
// against the node type's content restrictions, and throw an error
// if it doesn't match.
NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
  content = Fragment.from(content);
  if (!this.validContent(content))
    { throw new RangeError("Invalid content for node " + this.name) }
  return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
// Like [`create`](#model.NodeType.create), but see if it is necessary to
// add nodes to the start or end of the given fragment to make it
// fit the node. If no fitting wrapping can be found, return null.
// Note that, due to the fact that required nodes can always be
// created, this will always succeed if you pass null or
// `Fragment.empty` as content.
NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
  attrs = this.computeAttrs(attrs);
  content = Fragment.from(content);
  if (content.size) {
    var before = this.contentMatch.fillBefore(content);
    if (!before) { return null }
    content = before.append(content);
  }
  var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);
  if (!after) { return null }
  return new Node(this, attrs, content.append(after), Mark.setFrom(marks))
};

// :: (Fragment) → bool
// Returns true if the given fragment is valid content for this node
// type with the given attributes.
NodeType.prototype.validContent = function validContent (content) {
  var result = this.contentMatch.matchFragment(content);
  if (!result || !result.validEnd) { return false }
  for (var i = 0; i < content.childCount; i++)
    { if (!this.allowsMarks(content.child(i).marks)) { return false } }
  return true
};

// :: (MarkType) → bool
// Check whether the given mark type is allowed in this node.
NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1
};

// :: ([Mark]) → bool
// Test whether the given set of marks are allowed in this node.
NodeType.prototype.allowsMarks = function allowsMarks (marks) {
  if (this.markSet == null) { return true }
  for (var i = 0; i < marks.length; i++) { if (!this.allowsMarkType(marks[i].type)) { return false } }
  return true
};

// :: ([Mark]) → [Mark]
// Removes the marks that are not allowed in this node from the given set.
NodeType.prototype.allowedMarks = function allowedMarks (marks) {
  if (this.markSet == null) { return marks }
  var copy;
  for (var i = 0; i < marks.length; i++) {
    if (!this.allowsMarkType(marks[i].type)) {
      if (!copy) { copy = marks.slice(0, i); }
    } else if (copy) {
      copy.push(marks[i]);
    }
  }
  return !copy ? marks : copy.length ? copy : Mark.empty
};

NodeType.compile = function compile (nodes, schema) {
  var result = Object.create(null);
  nodes.forEach(function (name, spec) { return result[name] = new NodeType(name, schema, spec); });

  var topType = schema.spec.topNode || "doc";
  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }

  return result
};

Object.defineProperties( NodeType.prototype, prototypeAccessors$5 );

// Attribute descriptors

var Attribute = function Attribute(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};

var prototypeAccessors$1$3 = { isRequired: { configurable: true } };

prototypeAccessors$1$3.isRequired.get = function () {
  return !this.hasDefault
};

Object.defineProperties( Attribute.prototype, prototypeAccessors$1$3 );

// Marks

// ::- Like nodes, marks (which are associated with nodes to signify
// things like emphasis or being part of a link) are
// [tagged](#model.Mark.type) with type objects, which are
// instantiated once per `Schema`.
var MarkType = function MarkType(name, rank, schema, spec) {
  // :: string
  // The name of the mark type.
  this.name = name;

  // :: Schema
  // The schema that this mark type instance is part of.
  this.schema = schema;

  // :: MarkSpec
  // The spec on which the type is based.
  this.spec = spec;

  this.attrs = initAttrs(spec.attrs);

  this.rank = rank;
  this.excluded = null;
  var defaults = defaultAttrs(this.attrs);
  this.instance = defaults && new Mark(this, defaults);
};

// :: (?Object) → Mark
// Create a mark of this type. `attrs` may be `null` or an object
// containing only some of the mark's attributes. The others, if
// they have defaults, will be added.
MarkType.prototype.create = function create (attrs) {
  if (!attrs && this.instance) { return this.instance }
  return new Mark(this, computeAttrs(this.attrs, attrs))
};

MarkType.compile = function compile (marks, schema) {
  var result = Object.create(null), rank = 0;
  marks.forEach(function (name, spec) { return result[name] = new MarkType(name, rank++, schema, spec); });
  return result
};

// :: ([Mark]) → [Mark]
// When there is a mark of this type in the given set, a new set
// without it is returned. Otherwise, the input set is returned.
MarkType.prototype.removeFromSet = function removeFromSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this)
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → ?Mark
// Tests whether there is a mark of this type in the given set.
MarkType.prototype.isInSet = function isInSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this) { return set[i] } }
};

// :: (MarkType) → bool
// Queries whether a given mark type is
// [excluded](#model.MarkSpec.excludes) by this one.
MarkType.prototype.excludes = function excludes (other) {
  return this.excluded.indexOf(other) > -1
};

// SchemaSpec:: interface
// An object describing a schema, as passed to the [`Schema`](#model.Schema)
// constructor.
//
//   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
//   The node types in this schema. Maps names to
//   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
//   associated with that name. Their order is significant—it
//   determines which [parse rules](#model.NodeSpec.parseDOM) take
//   precedence by default, and which nodes come first in a given
//   [group](#model.NodeSpec.group).
//
//   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
//   The mark types that exist in this schema. The order in which they
//   are provided determines the order in which [mark
//   sets](#model.Mark.addToSet) are sorted and in which [parse
//   rules](#model.MarkSpec.parseDOM) are tried.
//
//   topNode:: ?string
//   The name of the default top-level node for the schema. Defaults
//   to `"doc"`.

// NodeSpec:: interface
//
//   content:: ?string
//   The content expression for this node, as described in the [schema
//   guide](/docs/guide/#schema.content_expressions). When not given,
//   the node does not allow any content.
//
//   marks:: ?string
//   The marks that are allowed inside of this node. May be a
//   space-separated string referring to mark names or groups, `"_"`
//   to explicitly allow all marks, or `""` to disallow marks. When
//   not given, nodes with inline content default to allowing all
//   marks, other nodes default to not allowing marks.
//
//   group:: ?string
//   The group or space-separated groups to which this node belongs,
//   which can be referred to in the content expressions for the
//   schema.
//
//   inline:: ?bool
//   Should be set to true for inline nodes. (Implied for text nodes.)
//
//   atom:: ?bool
//   Can be set to true to indicate that, though this isn't a [leaf
//   node](#model.NodeType.isLeaf), it doesn't have directly editable
//   content and should be treated as a single unit in the view.
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that nodes of this type get.
//
//   selectable:: ?bool
//   Controls whether nodes of this type can be selected as a [node
//   selection](#state.NodeSelection). Defaults to true for non-text
//   nodes.
//
//   draggable:: ?bool
//   Determines whether nodes of this type can be dragged without
//   being selected. Defaults to false.
//
//   code:: ?bool
//   Can be used to indicate that this node contains code, which
//   causes some commands to behave differently.
//
//   defining:: ?bool
//   Determines whether this node is considered an important parent
//   node during replace operations (such as paste). Non-defining (the
//   default) nodes get dropped when their entire content is replaced,
//   whereas defining nodes persist and wrap the inserted content.
//   Likewise, in _inserted_ content the defining parents of the
//   content are preserved when possible. Typically,
//   non-default-paragraph textblock types, and possibly list items,
//   are marked as defining.
//
//   isolating:: ?bool
//   When enabled (default is false), the sides of nodes of this type
//   count as boundaries that regular editing operations, like
//   backspacing or lifting, won't cross. An example of a node that
//   should probably have this enabled is a table cell.
//
//   toDOM:: ?(node: Node) → DOMOutputSpec
//   Defines the default way a node of this type should be serialized
//   to DOM/HTML (as used by
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
//   Should return a DOM node or an [array
//   structure](#model.DOMOutputSpec) that describes one, with an
//   optional number zero (“hole”) in it to indicate where the node's
//   content should be inserted.
//
//   For text nodes, the default is to create a text DOM node. Though
//   it is possible to create a serializer where text is rendered
//   differently, this is not supported inside the editor, so you
//   shouldn't override that in your text node spec.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this node, which can be
//   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
//   automatically derive a parser. The `node` field in the rules is
//   implied (the name of this node will be filled in automatically).
//   If you supply your own parser, you do not need to also specify
//   parsing rules in your schema.
//
//   toDebugString:: ?(node: Node) -> string
//   Defines the default way a node of this type should be serialized
//   to a string representation for debugging (e.g. in error messages).

// MarkSpec:: interface
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that marks of this type get.
//
//   inclusive:: ?bool
//   Whether this mark should be active when the cursor is positioned
//   at its end (or at its start when that is also the start of the
//   parent node). Defaults to true.
//
//   excludes:: ?string
//   Determines which other marks this mark can coexist with. Should
//   be a space-separated strings naming other marks or groups of marks.
//   When a mark is [added](#model.Mark.addToSet) to a set, all marks
//   that it excludes are removed in the process. If the set contains
//   any mark that excludes the new mark but is not, itself, excluded
//   by the new mark, the mark can not be added an the set. You can
//   use the value `"_"` to indicate that the mark excludes all
//   marks in the schema.
//
//   Defaults to only being exclusive with marks of the same type. You
//   can set it to an empty string (or any string not containing the
//   mark's own name) to allow multiple marks of a given type to
//   coexist (as long as they have different attributes).
//
//   group:: ?string
//   The group or space-separated groups to which this mark belongs.
//
//   spanning:: ?bool
//   Determines whether marks of this type can span multiple adjacent
//   nodes when serialized to DOM/HTML. Defaults to true.
//
//   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
//   Defines the default way marks of this type should be serialized
//   to DOM/HTML. When the resulting spec contains a hole, that is
//   where the marked content is placed. Otherwise, it is appended to
//   the top node.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this mark (see the
//   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
//   `mark` field in the rules is implied.

// AttributeSpec:: interface
//
// Used to [define](#model.NodeSpec.attrs) attributes on nodes or
// marks.
//
//   default:: ?any
//   The default value for this attribute, to use when no explicit
//   value is provided. Attributes that have no default must be
//   provided whenever a node or mark of a type that has them is
//   created.

// ::- A document schema. Holds [node](#model.NodeType) and [mark
// type](#model.MarkType) objects for the nodes and marks that may
// occur in conforming documents, and provides functionality for
// creating and deserializing such documents.
var Schema = function Schema(spec) {
  // :: SchemaSpec
  // The [spec](#model.SchemaSpec) on which the schema is based,
  // with the added guarantee that its `nodes` and `marks`
  // properties are
  // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
  // (not raw objects).
  this.spec = {};
  for (var prop in spec) { this.spec[prop] = spec[prop]; }
  this.spec.nodes = __WEBPACK_IMPORTED_MODULE_0_orderedmap__["a" /* default */].from(spec.nodes);
  this.spec.marks = __WEBPACK_IMPORTED_MODULE_0_orderedmap__["a" /* default */].from(spec.marks);

  // :: Object<NodeType>
  // An object mapping the schema's node names to node type objects.
  this.nodes = NodeType.compile(this.spec.nodes, this);

  // :: Object<MarkType>
  // A map from mark names to mark type objects.
  this.marks = MarkType.compile(this.spec.marks, this);

  var contentExprCache = Object.create(null);
  for (var prop$1 in this.nodes) {
    if (prop$1 in this.marks)
      { throw new RangeError(prop$1 + " can not be both a node and a mark") }
    var type = this.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
    type.contentMatch = contentExprCache[contentExpr] ||
      (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
    type.inlineContent = type.contentMatch.inlineContent;
    type.markSet = markExpr == "_" ? null :
      markExpr ? gatherMarks(this, markExpr.split(" ")) :
      markExpr == "" || !type.inlineContent ? [] : null;
  }
  for (var prop$2 in this.marks) {
    var type$1 = this.marks[prop$2], excl = type$1.spec.excludes;
    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
  }

  this.nodeFromJSON = this.nodeFromJSON.bind(this);
  this.markFromJSON = this.markFromJSON.bind(this);

  // :: NodeType
  // The type of the [default top node](#model.SchemaSpec.topNode)
  // for this schema.
  this.topNodeType = this.nodes[this.spec.topNode || "doc"];

  // :: Object
  // An object for storing whatever values modules may want to
  // compute and cache per schema. (If you want to store something
  // in it, try to use property names unlikely to clash.)
  this.cached = Object.create(null);
  this.cached.wrappings = Object.create(null);
};

// :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a node in this schema. The `type` may be a string or a
// `NodeType` instance. Attributes will be extended
// with defaults, `content` may be a `Fragment`,
// `null`, a `Node`, or an array of nodes.
Schema.prototype.node = function node (type, attrs, content, marks) {
  if (typeof type == "string")
    { type = this.nodeType(type); }
  else if (!(type instanceof NodeType))
    { throw new RangeError("Invalid node type: " + type) }
  else if (type.schema != this)
    { throw new RangeError("Node type from different schema used (" + type.name + ")") }

  return type.createChecked(attrs, content, marks)
};

// :: (string, ?[Mark]) → Node
// Create a text node in the schema. Empty text nodes are not
// allowed.
Schema.prototype.text = function text (text$1, marks) {
  var type = this.nodes.text;
  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks))
};

// :: (union<string, MarkType>, ?Object) → Mark
// Create a mark with the given type and attributes.
Schema.prototype.mark = function mark (type, attrs) {
  if (typeof type == "string") { type = this.marks[type]; }
  return type.create(attrs)
};

// :: (Object) → Node
// Deserialize a node from its JSON representation. This method is
// bound.
Schema.prototype.nodeFromJSON = function nodeFromJSON (json) {
  return Node.fromJSON(this, json)
};

// :: (Object) → Mark
// Deserialize a mark from its JSON representation. This method is
// bound.
Schema.prototype.markFromJSON = function markFromJSON (json) {
  return Mark.fromJSON(this, json)
};

Schema.prototype.nodeType = function nodeType (name) {
  var found = this.nodes[name];
  if (!found) { throw new RangeError("Unknown node type: " + name) }
  return found
};

function gatherMarks(schema, marks) {
  var found = [];
  for (var i = 0; i < marks.length; i++) {
    var name = marks[i], mark = schema.marks[name], ok = mark;
    if (mark) {
      found.push(mark);
    } else {
      for (var prop in schema.marks) {
        var mark$1 = schema.marks[prop];
        if (name == "_" || (mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1))
          { found.push(ok = mark$1); }
      }
    }
    if (!ok) { throw new SyntaxError("Unknown mark type: '" + marks[i] + "'") }
  }
  return found
}

// ParseOptions:: interface
// These are the options recognized by the
// [`parse`](#model.DOMParser.parse) and
// [`parseSlice`](#model.DOMParser.parseSlice) methods.
//
//   preserveWhitespace:: ?union<bool, "full">
//   By default, whitespace is collapsed as per HTML's rules. Pass
//   `true` to preserve whitespace, but normalize newlines to
//   spaces, and `"full"` to preserve whitespace entirely.
//
//   findPositions:: ?[{node: dom.Node, offset: number}]
//   When given, the parser will, beside parsing the content,
//   record the document positions of the given DOM positions. It
//   will do so by writing to the objects, adding a `pos` property
//   that holds the document position. DOM positions that are not
//   in the parsed content will not be written to.
//
//   from:: ?number
//   The child node index to start parsing from.
//
//   to:: ?number
//   The child node index to stop parsing at.
//
//   topNode:: ?Node
//   By default, the content is parsed into the schema's default
//   [top node type](#model.Schema.topNodeType). You can pass this
//   option to use the type and attributes from a different node
//   as the top container.
//
//   topMatch:: ?ContentMatch
//   Provide the starting content match that content parsed into the
//   top node is matched against.
//
//   context:: ?ResolvedPos
//   A set of additional nodes to count as
//   [context](#model.ParseRule.context) when parsing, above the
//   given [top node](#model.ParseOptions.topNode).

// ParseRule:: interface
// A value that describes how to parse a given DOM node or inline
// style as a ProseMirror node or mark.
//
//   tag:: ?string
//   A CSS selector describing the kind of DOM elements to match. A
//   single rule should have _either_ a `tag` or a `style` property.
//
//   namespace:: ?string
//   The namespace to match. This should be used with `tag`.
//   Nodes are only matched when the namespace matches or this property
//   is null.
//
//   style:: ?string
//   A CSS property name to match. When given, this rule matches
//   inline styles that list that property. May also have the form
//   `"property=value"`, in which case the rule only matches if the
//   propery's value exactly matches the given value. (For more
//   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
//   and return false to indicate that the match failed.)
//
//   priority:: ?number
//   Can be used to change the order in which the parse rules in a
//   schema are tried. Those with higher priority come first. Rules
//   without a priority are counted as having priority 50. This
//   property is only meaningful in a schema—when directly
//   constructing a parser, the order of the rule array is used.
//
//   context:: ?string
//   When given, restricts this rule to only match when the current
//   context—the parent nodes into which the content is being
//   parsed—matches this expression. Should contain one or more node
//   names or node group names followed by single or double slashes.
//   For example `"paragraph/"` means the rule only matches when the
//   parent node is a paragraph, `"blockquote/paragraph/"` restricts
//   it to be in a paragraph that is inside a blockquote, and
//   `"section//"` matches any position inside a section—a double
//   slash matches any sequence of ancestor nodes. To allow multiple
//   different contexts, they can be separated by a pipe (`|`)
//   character, as in `"blockquote/|list_item/"`.
//
//   node:: ?string
//   The name of the node type to create when this rule matches. Only
//   valid for rules with a `tag` property, not for style rules. Each
//   rule should have one of a `node`, `mark`, or `ignore` property
//   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
//   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
//   or `mark` property will be derived from its position).
//
//   mark:: ?string
//   The name of the mark type to wrap the matched content in.
//
//   ignore:: ?bool
//   When true, ignore content that matches this rule.
//
//   skip:: ?bool
//   When true, ignore the node that matches this rule, but do parse
//   its content.
//
//   attrs:: ?Object
//   Attributes for the node or mark created by this rule. When
//   `getAttrs` is provided, it takes precedence.
//
//   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
//   A function used to compute the attributes for the node or mark
//   created by this rule. Can also be used to describe further
//   conditions the DOM element or style must match. When it returns
//   `false`, the rule won't match. When it returns null or undefined,
//   that is interpreted as an empty/default set of attributes.
//
//   Called with a DOM Element for `tag` rules, and with a string (the
//   style's value) for `style` rules.
//
//   contentElement:: ?union<string, (dom.Node) → dom.Node>
//   For `tag` rules that produce non-leaf nodes or marks, by default
//   the content of the DOM element is parsed as content of the mark
//   or node. If the child nodes are in a descendent node, this may be
//   a CSS selector string that the parser must use to find the actual
//   content element, or a function that returns the actual content
//   element to the parser.
//
//   getContent:: ?(dom.Node, schema: Schema) → Fragment
//   Can be used to override the content of a matched node. When
//   present, instead of parsing the node's child nodes, the result of
//   this function is used.
//
//   preserveWhitespace:: ?union<bool, "full">
//   Controls whether whitespace should be preserved when parsing the
//   content inside the matched element. `false` means whitespace may
//   be collapsed, `true` means that whitespace should be preserved
//   but newlines normalized to spaces, and `"full"` means that
//   newlines should also be preserved.

// ::- A DOM parser represents a strategy for parsing DOM content into
// a ProseMirror document conforming to a given schema. Its behavior
// is defined by an array of [rules](#model.ParseRule).
var DOMParser = function DOMParser(schema, rules) {
  var this$1 = this;

  // :: Schema
  // The schema into which the parser parses.
  this.schema = schema;
  // :: [ParseRule]
  // The set of [parse rules](#model.ParseRule) that the parser
  // uses, in order of precedence.
  this.rules = rules;
  this.tags = [];
  this.styles = [];

  rules.forEach(function (rule) {
    if (rule.tag) { this$1.tags.push(rule); }
    else if (rule.style) { this$1.styles.push(rule); }
  });
};

// :: (dom.Node, ?ParseOptions) → Node
// Parse a document from the content of a DOM node.
DOMParser.prototype.parse = function parse (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, false);
  context.addAll(dom, null, options.from, options.to);
  return context.finish()
};

// :: (dom.Node, ?ParseOptions) → Slice
// Parses the content of the given DOM node, like
// [`parse`](#model.DOMParser.parse), and takes the same set of
// options. But unlike that method, which produces a whole node,
// this one returns a slice that is open at the sides, meaning that
// the schema constraints aren't applied to the start of nodes to
// the left of the input and the end of nodes at the end.
DOMParser.prototype.parseSlice = function parseSlice (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, true);
  context.addAll(dom, null, options.from, options.to);
  return Slice.maxOpen(context.finish())
};

DOMParser.prototype.matchTag = function matchTag (dom, context) {
  for (var i = 0; i < this.tags.length; i++) {
    var rule = this.tags[i];
    if (matches(dom, rule.tag) &&
        (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
        (!rule.context || context.matchesContext(rule.context))) {
      if (rule.getAttrs) {
        var result = rule.getAttrs(dom);
        if (result === false) { continue }
        rule.attrs = result;
      }
      return rule
    }
  }
};

DOMParser.prototype.matchStyle = function matchStyle (prop, value, context) {
  for (var i = 0; i < this.styles.length; i++) {
    var rule = this.styles[i];
    if (rule.style.indexOf(prop) != 0 ||
        rule.context && !context.matchesContext(rule.context) ||
        // Test that the style string either precisely matches the prop,
        // or has an '=' sign after the prop, followed by the given
        // value.
        rule.style.length > prop.length &&
        (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value))
      { continue }
    if (rule.getAttrs) {
      var result = rule.getAttrs(value);
      if (result === false) { continue }
      rule.attrs = result;
    }
    return rule
  }
};

// : (Schema) → [ParseRule]
DOMParser.schemaRules = function schemaRules (schema) {
  var result = [];
  function insert(rule) {
    var priority = rule.priority == null ? 50 : rule.priority, i = 0;
    for (; i < result.length; i++) {
      var next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
      if (nextPriority < priority) { break }
    }
    result.splice(i, 0, rule);
  }

  var loop = function ( name ) {
    var rules = schema.marks[name].spec.parseDOM;
    if (rules) { rules.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.mark = name;
    }); }
  };

    for (var name in schema.marks) loop( name );
  var loop$1 = function ( name ) {
    var rules$1 = schema.nodes[name$1].spec.parseDOM;
    if (rules$1) { rules$1.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.node = name$1;
    }); }
  };

    for (var name$1 in schema.nodes) loop$1();
  return result
};

// :: (Schema) → DOMParser
// Construct a DOM parser using the parsing rules listed in a
// schema's [node specs](#model.NodeSpec.parseDOM), reordered by
// [priority](#model.ParseRule.priority).
DOMParser.fromSchema = function fromSchema (schema) {
  return schema.cached.domParser ||
    (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)))
};

// : Object<bool> The block-level tags in HTML5
var blockTags = {
  address: true, article: true, aside: true, blockquote: true, canvas: true,
  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};

// : Object<bool> The tags that we normally ignore.
var ignoreTags = {
  head: true, noscript: true, object: true, script: true, style: true, title: true
};

// : Object<bool> List tags.
var listTags = {ol: true, ul: true};

// Using a bitfield for node context options
var OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;

function wsOptionsFor(preserveWhitespace) {
  return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0)
}

var NodeContext = function NodeContext(type, attrs, marks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  this.marks = marks;
  this.activeMarks = Mark.none;
};

NodeContext.prototype.findWrapping = function findWrapping (node) {
  if (!this.match) {
    if (!this.type) { return [] }
    var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start = this.type.contentMatch, wrap;
      if (wrap = start.findWrapping(node.type)) {
        this.match = start;
        return wrap
      } else {
        return null
      }
    }
  }
  return this.match.findWrapping(node.type)
};

NodeContext.prototype.finish = function finish (openEnd) {
  if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
      if (last.text.length == m[0].length) { this.content.pop(); }
      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
    }
  }
  var content = Fragment.from(this.content);
  if (!openEnd && this.match)
    { content = content.append(this.match.fillBefore(Fragment.empty, true)); }
  return this.type ? this.type.create(this.attrs, content, this.marks) : content
};

var ParseContext = function ParseContext(parser, options, open) {
  // : DOMParser The parser we are using.
  this.parser = parser;
  // : Object The options passed to this parse.
  this.options = options;
  this.isOpen = open;
  this.pendingMarks = [];
  var topNode = options.topNode, topContext;
  var topOptions = wsOptionsFor(options.preserveWhitespace) | (open ? OPT_OPEN_LEFT : 0);
  if (topNode)
    { topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true,
                                 options.topMatch || topNode.type.contentMatch, topOptions); }
  else if (open)
    { topContext = new NodeContext(null, null, Mark.none, true, null, topOptions); }
  else
    { topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions); }
  this.nodes = [topContext];
  // : [Mark] The current set of marks
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};

var prototypeAccessors$6 = { top: { configurable: true },currentPos: { configurable: true } };

prototypeAccessors$6.top.get = function () {
  return this.nodes[this.open]
};

// : (dom.Node)
// Add a DOM node to the content. Text is inserted as text node,
// otherwise, the node is passed to `addElement` or, if it has a
// `style` attribute, `addElementWithStyles`.
ParseContext.prototype.addDOM = function addDOM (dom) {
  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    var marks = style ? this.readStyles(parseStyles(style)) : null;
    if (marks != null) { for (var i = 0; i < marks.length; i++) { this.addPendingMark(marks[i]); } }
    this.addElement(dom);
    if (marks != null) { for (var i$1 = 0; i$1 < marks.length; i$1++) { this.removePendingMark(marks[i$1]); } }
  }
};

ParseContext.prototype.addTextNode = function addTextNode (dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if ((top.type ? top.type.inlineContent : top.content.length && top.content[0].isInline) || /[^ \t\r\n\u000c]/.test(value)) {
    if (!(top.options & OPT_PRESERVE_WS)) {
      value = value.replace(/[ \t\r\n\u000c]+/g, " ");
      // If this starts with whitespace, and there is no node before it, or
      // a hard break, or a text node that ends with whitespace, strip the
      // leading space.
      if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        var domNodeBefore = dom.previousSibling;
        if (!nodeBefore ||
            (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
            (nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)))
          { value = value.slice(1); }
      }
    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    }
    if (value) { this.insertNode(this.parser.schema.text(value)); }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};

// : (dom.Element)
// Try to find a handler for the given tag and use that to parse. If
// none is found, the element's content nodes are added directly.
ParseContext.prototype.addElement = function addElement (dom) {
  var name = dom.nodeName.toLowerCase();
  if (listTags.hasOwnProperty(name)) { normalizeList(dom); }
  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) || this.parser.matchTag(dom, this);
  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
  } else if (!rule || rule.skip) {
    if (rule && rule.skip.nodeType) { dom = rule.skip; }
    var sync, top = this.top, oldNeedsBlock = this.needsBlock;
    if (blockTags.hasOwnProperty(name)) {
      sync = true;
      if (!top.type) { this.needsBlock = true; }
    } else if (!dom.firstChild) {
      this.leafFallback(dom);
      return
    }
    this.addAll(dom);
    if (sync) { this.sync(top); }
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule);
  }
};

// Called for leaf DOM nodes that would otherwise be ignored
ParseContext.prototype.leafFallback = function leafFallback (dom) {
  if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
    { this.addTextNode(dom.ownerDocument.createTextNode("\n")); }
};

// Run any style parser associated with the node's styles. Either
// return an array of marks, or null to indicate some of the styles
// had a rule with `ignore` set.
ParseContext.prototype.readStyles = function readStyles (styles) {
  var marks = Mark.none;
  for (var i = 0; i < styles.length; i += 2) {
    var rule = this.parser.matchStyle(styles[i], styles[i + 1], this);
    if (!rule) { continue }
    if (rule.ignore) { return null }
    marks = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
  }
  return marks
};

// : (dom.Element, ParseRule) → bool
// Look up a handler for the given node. If none are found, return
// false. Otherwise, apply it, use its return value to drive the way
// the node's content is wrapped, and return true.
ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule) {
    var this$1 = this;

  var sync, nodeType, markType, mark;
  if (rule.node) {
    nodeType = this.parser.schema.nodes[rule.node];
    if (!nodeType.isLeaf) {
      sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace);
    } else if (!this.insertNode(nodeType.create(rule.attrs))) {
      this.leafFallback(dom);
    }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark = markType.create(rule.attrs);
    this.addPendingMark(mark);
  }
  var startIn = this.top;

  if (nodeType && nodeType.isLeaf) {
    this.findInside(dom);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1.insertNode(node); });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
    if (!contentDOM) { contentDOM = dom; }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync);
  }
  if (sync) { this.sync(startIn); this.open--; }
  if (mark) { this.removePendingMark(mark); }
};

// : (dom.Node, ?NodeBuilder, ?number, ?number)
// Add all child nodes between `startIndex` and `endIndex` (or the
// whole node, if not given). If `sync` is passed, use it to
// synchronize after every block element.
ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
  var index = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
           end = endIndex == null ? null : parent.childNodes[endIndex];
       dom != end; dom = dom.nextSibling, ++index) {
    this.findAtPoint(parent, index);
    this.addDOM(dom);
    if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
      { this.sync(sync); }
  }
  this.findAtPoint(parent, index);
};

// Try to find a way to fit the given node type into the current
// context. May add intermediate wrappers and/or leave non-solid
// nodes that we're in.
ParseContext.prototype.findPlace = function findPlace (node) {
  var route, sync;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this.nodes[depth];
    var found = cx.findWrapping(node);
    if (found && (!route || route.length > found.length)) {
      route = found;
      sync = cx;
      if (!found.length) { break }
    }
    if (cx.solid) { break }
  }
  if (!route) { return false }
  this.sync(sync);
  for (var i = 0; i < route.length; i++)
    { this.enterInner(route[i], null, false); }
  return true
};

// : (Node) → ?Node
// Try to insert the given node, adjusting the context when needed.
ParseContext.prototype.insertNode = function insertNode (node) {
  if (node.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) { this.enterInner(block); }
  }
  if (this.findPlace(node)) {
    this.closeExtra();
    var top = this.top;
    this.applyPendingMarks(top);
    if (top.match) { top.match = top.match.matchType(node.type); }
    var marks = top.activeMarks;
    for (var i = 0; i < node.marks.length; i++)
      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
        { marks = node.marks[i].addToSet(marks); } }
    top.content.push(node.mark(marks));
    return true
  }
  return false
};

ParseContext.prototype.applyPendingMarks = function applyPendingMarks (top) {
  for (var i = 0; i < this.pendingMarks.length; i++) {
    var mark = this.pendingMarks[i];
    if ((!top.type || top.type.allowsMarkType(mark.type)) && !mark.isInSet(top.activeMarks)) {
      top.activeMarks = mark.addToSet(top.activeMarks);
      this.pendingMarks.splice(i--, 1);
    }
  }
};

// : (NodeType, ?Object) → bool
// Try to start a node of the given type, adjusting the context when
// necessary.
ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
  var ok = this.findPlace(type.create(attrs));
  if (ok) {
    this.applyPendingMarks(this.top);
    this.enterInner(type, attrs, true, preserveWS);
  }
  return ok
};

// Open a node of the given type
ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.match = top.match && top.match.matchType(type, attrs);
  var options = preserveWS == null ? top.options & ~OPT_OPEN_LEFT : wsOptionsFor(preserveWS);
  if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0) { options |= OPT_OPEN_LEFT; }
  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, solid, null, options));
  this.open++;
};

// Make sure all nodes above this.open are finished and added to
// their parents
ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
  var i = this.nodes.length - 1;
  if (i > this.open) {
    for (; i > this.open; i--) { this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd)); }
    this.nodes.length = this.open + 1;
  }
};

ParseContext.prototype.finish = function finish () {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
};

ParseContext.prototype.sync = function sync (to) {
  for (var i = this.open; i >= 0; i--) { if (this.nodes[i] == to) {
    this.open = i;
    return
  } }
};

ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
  this.pendingMarks.push(mark);
};

ParseContext.prototype.removePendingMark = function removePendingMark (mark) {
  var found = this.pendingMarks.lastIndexOf(mark);
  if (found > -1) {
    this.pendingMarks.splice(found, 1);
  } else {
    var top = this.top;
    top.activeMarks = mark.removeFromSet(top.activeMarks);
  }
};

prototypeAccessors$6.currentPos.get = function () {
  this.closeExtra();
  var pos = 0;
  for (var i = this.open; i >= 0; i--) {
    var content = this.nodes[i].content;
    for (var j = content.length - 1; j >= 0; j--)
      { pos += content[j].nodeSize; }
    if (i) { pos++; }
  }
  return pos
};

ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].node == parent && this.find[i].offset == offset)
      { this.find[i].pos = this.currentPos; }
  } }
};

ParseContext.prototype.findInside = function findInside (parent) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
      { this.find[i].pos = this.currentPos; }
  } }
};

ParseContext.prototype.findAround = function findAround (parent, content, before) {
  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
      var pos = content.compareDocumentPosition(this.find[i].node);
      if (pos & (before ? 2 : 4))
        { this.find[i].pos = this.currentPos; }
    }
  } }
};

ParseContext.prototype.findInText = function findInText (textNode) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].node == textNode)
      { this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset); }
  } }
};

// : (string) → bool
// Determines whether the given [context
// string](#ParseRule.context) matches this context.
ParseContext.prototype.matchesContext = function matchesContext (context) {
    var this$1 = this;

  if (context.indexOf("|") > -1)
    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }

  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function (i, depth) {
    for (; i >= 0; i--) {
      var part = parts[i];
      if (part == "") {
        if (i == parts.length - 1 || i == 0) { continue }
        for (; depth >= minDepth; depth--)
          { if (match(i - 1, depth)) { return true } }
        return false
      } else {
        var next = depth > 0 || (depth == 0 && useRoot) ? this$1.nodes[depth].type
            : option && depth >= minDepth ? option.node(depth - minDepth).type
            : null;
        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
          { return false }
        depth--;
      }
    }
    return true
  };
  return match(parts.length - 1, this.open)
};

ParseContext.prototype.textblockFromContext = function textblockFromContext () {
  var $context = this.options.context;
  if ($context) { for (var d = $context.depth; d >= 0; d--) {
    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
  } }
  for (var name in this.parser.schema.nodes) {
    var type = this.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) { return type }
  }
};

Object.defineProperties( ParseContext.prototype, prototypeAccessors$6 );

// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}

// Apply a CSS selector.
function matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector)
}

// : (string) → [string]
// Tokenize a style attribute into property/value pairs.
function parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
  return result
}

function copy(obj) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  return copy
}

// DOMOutputSpec:: interface
// A description of a DOM structure. Can be either a string, which is
// interpreted as a text node, a DOM node, which is interpreted as
// itself, or an array.
//
// An array describes a DOM element. The first value in the array
// should be a string—the name of the DOM element. If the second
// element is plain object, it is interpreted as a set of attributes
// for the element. Any elements after that (including the 2nd if it's
// not an attribute object) are interpreted as children of the DOM
// elements, and must either be valid `DOMOutputSpec` values, or the
// number zero.
//
// The number zero (pronounced “hole”) is used to indicate the place
// where a node's child nodes should be inserted. If it occurs in an
// output spec, it should be the only child element in its parent
// node.

// ::- A DOM serializer knows how to convert ProseMirror nodes and
// marks of various types to DOM nodes.
var DOMSerializer = function DOMSerializer(nodes, marks) {
  // :: Object<(node: Node) → DOMOutputSpec>
  // The node serialization functions.
  this.nodes = nodes || {};
  // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
  // The mark serialization functions.
  this.marks = marks || {};
};

// :: (Fragment, ?Object) → dom.DocumentFragment
// Serialize the content of this fragment to a DOM fragment. When
// not in the browser, the `document` option, containing a DOM
// document, should be passed so that the serializer can create
// nodes.
DOMSerializer.prototype.serializeFragment = function serializeFragment (fragment, options, target) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  if (!target) { target = doc(options).createDocumentFragment(); }

  var top = target, active = null;
  fragment.forEach(function (node) {
    if (active || node.marks.length) {
      if (!active) { active = []; }
      var keep = 0, rendered = 0;
      while (keep < active.length && rendered < node.marks.length) {
        var next = node.marks[rendered];
        if (!this$1.marks[next.type.name]) { rendered++; continue }
        if (!next.eq(active[keep]) || next.type.spec.spanning === false) { break }
        keep += 2; rendered++;
      }
      while (keep < active.length) {
        top = active.pop();
        active.pop();
      }
      while (rendered < node.marks.length) {
        var add = node.marks[rendered++];
        var markDOM = this$1.serializeMark(add, node.isInline, options);
        if (markDOM) {
          active.push(add, top);
          top.appendChild(markDOM.dom);
          top = markDOM.contentDOM || markDOM.dom;
        }
      }
    }
    top.appendChild(this$1.serializeNode(node, options));
  });

  return target
};

// :: (Node, ?Object) → dom.Node
// Serialize this node to a DOM node. This can be useful when you
// need to serialize a part of a document, as opposed to the whole
// document. To serialize a whole document, use
// [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
// its [content](#model.Node.content).
DOMSerializer.prototype.serializeNode = function serializeNode (node, options) {
    if ( options === void 0 ) options = {};

  var ref =
      DOMSerializer.renderSpec(doc(options), this.nodes[node.type.name](node));
    var dom = ref.dom;
    var contentDOM = ref.contentDOM;
  if (contentDOM) {
    if (node.isLeaf)
      { throw new RangeError("Content hole not allowed in a leaf node spec") }
    if (options.onContent)
      { options.onContent(node, contentDOM, options); }
    else
      { this.serializeFragment(node.content, options, contentDOM); }
  }
  return dom
};

DOMSerializer.prototype.serializeNodeAndMarks = function serializeNodeAndMarks (node, options) {
    if ( options === void 0 ) options = {};

  var dom = this.serializeNode(node, options);
  for (var i = node.marks.length - 1; i >= 0; i--) {
    var wrap = this.serializeMark(node.marks[i], node.isInline, options);
    if (wrap) {
(wrap.contentDOM || wrap.dom).appendChild(dom);
      dom = wrap.dom;
    }
  }
  return dom
};

DOMSerializer.prototype.serializeMark = function serializeMark (mark, inline, options) {
    if ( options === void 0 ) options = {};

  var toDOM = this.marks[mark.type.name];
  return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark, inline))
};

// :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
// Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
// the spec has a hole (zero) in it, `contentDOM` will point at the
// node with the hole.
DOMSerializer.renderSpec = function renderSpec (doc, structure) {
  if (typeof structure == "string")
    { return {dom: doc.createTextNode(structure)} }
  if (structure.nodeType != null)
    { return {dom: structure} }
  var dom = doc.createElement(structure[0]), contentDOM = null;
  var attrs = structure[1], start = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start = 2;
    for (var name in attrs) {
      if (attrs[name] != null) { dom.setAttribute(name, attrs[name]); }
    }
  }
  for (var i = start; i < structure.length; i++) {
    var child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start)
        { throw new RangeError("Content hole must be the only child of its parent node") }
      return {dom: dom, contentDOM: dom}
    } else {
      var ref = DOMSerializer.renderSpec(doc, child);
        var inner = ref.dom;
        var innerContent = ref.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) { throw new RangeError("Multiple content holes") }
        contentDOM = innerContent;
      }
    }
  }
  return {dom: dom, contentDOM: contentDOM}
};

// :: (Schema) → DOMSerializer
// Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
// properties in a schema's node and mark specs.
DOMSerializer.fromSchema = function fromSchema (schema) {
  return schema.cached.domSerializer ||
    (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)))
};

// : (Schema) → Object<(node: Node) → DOMOutputSpec>
// Gather the serializers in a schema's node specs into an object.
// This can be useful as a base to build a custom serializer from.
DOMSerializer.nodesFromSchema = function nodesFromSchema (schema) {
  var result = gatherToDOM(schema.nodes);
  if (!result.text) { result.text = function (node) { return node.text; }; }
  return result
};

// : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
// Gather the serializers in a schema's mark specs into an object.
DOMSerializer.marksFromSchema = function marksFromSchema (schema) {
  return gatherToDOM(schema.marks)
};

function gatherToDOM(obj) {
  var result = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) { result[name] = toDOM; }
  }
  return result
}

function doc(options) {
  // declare global: window
  return options.document || window.document
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(31);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(32);
var IObject = __webpack_require__(69);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(10);
var asc = __webpack_require__(116);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var Language =
/*#__PURE__*/
function () {
  function Language(language, months, monthsAbbr, days) {
    _classCallCheck(this, Language);

    this.language = language;
    this.months = months;
    this.monthsAbbr = monthsAbbr;
    this.days = days;
    this.rtl = false;
    this.ymd = false;
    this.yearSuffix = '';
  }

  _createClass(Language, [{
    key: "language",
    get: function get() {
      return this._language;
    },
    set: function set(language) {
      if (typeof language !== 'string') {
        throw new TypeError('Language must be a string');
      }

      this._language = language;
    }
  }, {
    key: "months",
    get: function get() {
      return this._months;
    },
    set: function set(months) {
      if (months.length !== 12) {
        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
      }

      this._months = months;
    }
  }, {
    key: "monthsAbbr",
    get: function get() {
      return this._monthsAbbr;
    },
    set: function set(monthsAbbr) {
      if (monthsAbbr.length !== 12) {
        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
      }

      this._monthsAbbr = monthsAbbr;
    }
  }, {
    key: "days",
    get: function get() {
      return this._days;
    },
    set: function set(days) {
      if (days.length !== 7) {
        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
      }

      this._days = days;
    }
  }]);

  return Language;
}(); // eslint-disable-next-line

var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']) // eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,

  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear(date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth(date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth();
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate(date) {
    return this.useUtc ? date.getUTCDate() : date.getDate();
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay(date) {
    return this.useUtc ? date.getUTCDay() : date.getDay();
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours(date) {
    return this.useUtc ? date.getUTCHours() : date.getHours();
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes(date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear(date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth(date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate(date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates(date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }

    return d1.getTime() === d2.getTime();
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }

    return !isNaN(date.getTime());
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if (_typeof(date) !== 'object') {
      throw TypeError('Invalid Type');
    }

    return days[this.getDay(date)];
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }

    if (_typeof(month) === 'object') {
      return months[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return months[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }

    if (_typeof(month) === 'object') {
      return monthsAbbr[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return monthsAbbr[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth(year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31;
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';

      case 2:
      case 22:
        return 'nd';

      case 3:
      case 23:
        return 'rd';

      default:
        return 'th';
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray(start, end) {
    var dates = [];

    while (start <= end) {
      dates.push(new Date(start));
      start = this.setDate(new Date(start), this.getDate(new Date(start)) + 1);
    }

    return dates;
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput(val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
  }
};
var makeDateUtils = function makeDateUtils(useUtc) {
  return _objectSpread({}, utils, {
    useUtc: useUtc
  });
};
var utils$1 = _objectSpread({}, utils) // eslint-disable-next-line
;

var script = {
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }

      if (this.typedDate) {
        return this.typedDate;
      }

      return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
    },
    computedInputClass: function computedInputClass() {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ');
        }

        return _objectSpread({
          'form-control': true
        }, this.inputClass);
      }

      return this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate() {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar() {
      this.$emit('showCalendar');
    },

    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate(event) {
      // close calendar if escape or enter are pressed
      if ([27, // escape
      13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);

        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred() {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },

    /**
     * emit a clearDate event
     */
    clearDate: function clearDate() {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted() {
    this.input = this.$el.querySelector('input');
  }
} // eslint-disable-next-line
;

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: { "input-group": _vm.bootstrapStyling } },
    [
      _vm.calendarButton
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__calendar-button",
              class: { "input-group-prepend": _vm.bootstrapStyling },
              style: { "cursor:not-allowed;": _vm.disabled },
              on: { click: _vm.showCalendar }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.calendarButtonIcon }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.calendarButtonIconContent) +
                        "\n        "
                    ),
                    !_vm.calendarButtonIcon
                      ? _c("span", [_vm._v("…")])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: _vm.refName,
        class: _vm.computedInputClass,
        attrs: {
          type: _vm.inline ? "hidden" : "text",
          name: _vm.name,
          id: _vm.id,
          "open-date": _vm.openDate,
          placeholder: _vm.placeholder,
          "clear-button": _vm.clearButton,
          disabled: _vm.disabled,
          required: _vm.required,
          readonly: !_vm.typeable,
          autocomplete: "off"
        },
        domProps: { value: _vm.formattedValue },
        on: {
          click: _vm.showCalendar,
          keyup: _vm.parseTypedDate,
          blur: _vm.inputBlurred
        }
      }),
      _vm._v(" "),
      _vm.clearButton && _vm.selectedDate
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__clear-button",
              class: { "input-group-append": _vm.bootstrapStyling },
              on: {
                click: function($event) {
                  return _vm.clearDate()
                }
              }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.clearButtonIcon }, [
                    !_vm.clearButtonIcon ? _c("span", [_vm._v("×")]) : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("afterDateInput")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DateInput = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      "default": function _default(day) {
        return day.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }

      return this.translation.days;
    },

    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = this.pageDate;
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());

      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
      }

      return this.utils.getDay(dObj);
    },

    /**
     * @return {Object[]}
     */
    days: function days() {
      var d = this.pageDate;
      var days = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));

      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj),
          isHighlightStart: this.isHighlightStart(dObj),
          isHighlightEnd: this.isHighlightEnd(dObj),
          isToday: this.utils.compareDates(dObj, new Date()),
          isWeekend: this.utils.getDay(dObj) === 0 || this.utils.getDay(dObj) === 6,
          isSaturday: this.utils.getDay(dObj) === 6,
          isSunday: this.utils.getDay(dObj) === 0
        });
        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
      }

      return days;
    },

    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName() {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
    },

    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd() {
      return this.translation.ymd && this.translation.ymd === true;
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function selectDate(date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false;
      }

      this.$emit('selectDate', date);
    },

    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth() {
      return this.utils.getMonth(this.pageDate);
    },

    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar() {
      this.$emit('showMonthCalendar');
    },

    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth(incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },

    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth() {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },

    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
    },

    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth() {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },

    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
    },

    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
    },

    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate(date) {
      var _this = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (_this.utils.compareDates(date, d)) {
            disabledDates = true;
            return true;
          }
        });
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true;
            }
          }
        });
      }

      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    },

    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate(date) {
      var _this2 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (_this2.utils.compareDates(date, d)) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted;
    },
    dayClasses: function dayClasses(day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      };
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart(date) {
      return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd(date) {
      return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
    },

    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDayView,
          expression: "showDayView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "day__month_btn",
            class: _vm.allowedToShowView("month") ? "up" : "",
            on: { click: _vm.showMonthCalendar }
          },
          [
            _vm._v(
              _vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) +
                " " +
                _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.isRtl ? "flex-rtl" : "" },
        [
          _vm._l(_vm.daysOfWeek, function(d) {
            return _c(
              "span",
              { key: d.timestamp, staticClass: "cell day-header" },
              [_vm._v(_vm._s(d))]
            )
          }),
          _vm._v(" "),
          _vm.blankDays > 0
            ? _vm._l(_vm.blankDays, function(d) {
                return _c("span", {
                  key: d.timestamp,
                  staticClass: "cell day blank"
                })
              })
            : _vm._e(),
          _vm._l(_vm.days, function(day) {
            return _c("span", {
              key: day.timestamp,
              staticClass: "cell day",
              class: _vm.dayClasses(day),
              domProps: { innerHTML: _vm._s(_vm.dayCellContent(day)) },
              on: {
                click: function($event) {
                  return _vm.selectDate(day)
                }
              }
            })
          })
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerDay = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
var script$2 = {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    months: function months() {
      var d = this.pageDate;
      var months = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 12; i++) {
        months.push({
          month: this.utils.getMonthName(i, this.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
      }

      return months;
    },

    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }

      this.$emit('selectMonth', month);
    },

    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },

    /**
     * Decrements the year
     */
    previousYear: function previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },

    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Increments the year
     */
    nextYear: function nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },

    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar() {
      this.$emit('showYearCalendar');
    },

    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMonthView,
          expression: "showMonthView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "month__year_btn",
            class: _vm.allowedToShowView("year") ? "up" : "",
            on: { click: _vm.showYearCalendar }
          },
          [_vm._v(_vm._s(_vm.pageYearName))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.months, function(month) {
        return _c(
          "span",
          {
            key: month.timestamp,
            staticClass: "cell month",
            class: { selected: month.isSelected, disabled: month.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectMonth(month)
              }
            }
          },
          [_vm._v(_vm._s(month.month))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerMonth = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years() {
      var d = this.pageDate;
      var years = []; // set up a new date object to the beginning of the current 'page'7

      var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 10; i++) {
        years.push({
          year: this.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
      }

      return years;
    },

    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade() {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(decadeStart, " - ").concat(decadeEnd).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  methods: {
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }

      this.$emit('selectYear', year);
    },
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade() {
      if (this.isPreviousDecadeDisabled()) {
        return false;
      }

      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage;
    },
    nextDecade: function nextDecade() {
      if (this.isNextDecadeDisabled()) {
        return false;
      }

      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage;
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
    },

    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showYearView,
          expression: "showYearView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.getPageDecade))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.years, function(year) {
        return _c(
          "span",
          {
            key: year.timestamp,
            staticClass: "cell year",
            class: { selected: year.isSelected, disabled: year.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectYear(year)
              }
            }
          },
          [_vm._v(_vm._s(year.year))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerYear = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
var script$4 = {
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      "default": 'dd MMM yyyy'
    },
    language: {
      type: Object,
      "default": function _default() {
        return en;
      }
    },
    openDate: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      "default": 'day'
    },
    maximumView: {
      type: String,
      "default": 'year'
    }
  },
  data: function data() {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,

      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,

      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,

      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    };
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView() {
      if (!this.initialView) {
        return this.minimumView;
      }

      return this.initialView;
    },
    pageDate: function pageDate() {
      return new Date(this.pageTimestamp);
    },
    translation: function translation() {
      return this.language;
    },
    calendarStyle: function calendarStyle() {
      return {
        position: this.isInline ? 'static' : undefined
      };
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return !!this.inline;
    },
    isRtl: function isRtl() {
      return this.translation.rtl === true;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }

      this.setPageDate(this.selectedDate);
    },

    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar() {
      if (this.disabled || this.isInline) {
        return false;
      }

      if (this.isOpen) {
        return this.close(true);
      }

      this.setInitialView();
    },

    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView() {
      var initialView = this.computedInitialView;

      if (!this.allowedToShowView(initialView)) {
        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
      }

      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break;

        case 'month':
          this.showMonthCalendar();
          break;

        default:
          this.showDayCalendar();
          break;
      }
    },

    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView(view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);
      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
    },

    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar() {
      if (!this.allowedToShowView('day')) {
        return false;
      }

      this.close();
      this.showDayView = true;
      return true;
    },

    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar() {
      if (!this.allowedToShowView('month')) {
        return false;
      }

      this.close();
      this.showMonthView = true;
      return true;
    },

    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar() {
      if (!this.allowedToShowView('year')) {
        return false;
      }

      this.close();
      this.showYearView = true;
      return true;
    },

    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate(timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },

    /**
     * Clear the selected date
     */
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },

    /**
     * @param {Object} date
     */
    selectDate: function selectDate(date) {
      this.setDate(date.timestamp);

      if (!this.isInline) {
        this.close(true);
      }

      this.resetTypedDate = new Date();
    },

    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate(date) {
      this.$emit('selectedDisabled', date);
    },

    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      var date = new Date(month.timestamp);

      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },

    /**
     * @param {Object} year
     */
    selectYear: function selectYear(year) {
      var date = new Date(year.timestamp);

      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },

    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue(date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }

      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return;
      }

      this.selectedDate = date;
      this.setPageDate(date);
    },

    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate(date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }

      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },

    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },

    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate(date) {
      this.setDate(date.getTime());
    },

    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close(emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;

      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }

        document.removeEventListener('click', this.clickOutside, false);
      }
    },

    /**
     * Initiate the component
     */
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }

      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
} // eslint-disable-next-line
;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vdp-datepicker",
      class: [_vm.wrapperClass, _vm.isRtl ? "rtl" : ""]
    },
    [
      _c(
        "date-input",
        {
          attrs: {
            selectedDate: _vm.selectedDate,
            resetTypedDate: _vm.resetTypedDate,
            format: _vm.format,
            translation: _vm.translation,
            inline: _vm.inline,
            id: _vm.id,
            name: _vm.name,
            refName: _vm.refName,
            openDate: _vm.openDate,
            placeholder: _vm.placeholder,
            inputClass: _vm.inputClass,
            typeable: _vm.typeable,
            clearButton: _vm.clearButton,
            clearButtonIcon: _vm.clearButtonIcon,
            calendarButton: _vm.calendarButton,
            calendarButtonIcon: _vm.calendarButtonIcon,
            calendarButtonIconContent: _vm.calendarButtonIconContent,
            disabled: _vm.disabled,
            required: _vm.required,
            bootstrapStyling: _vm.bootstrapStyling,
            "use-utc": _vm.useUtc
          },
          on: {
            showCalendar: _vm.showCalendar,
            closeCalendar: _vm.close,
            typedDate: _vm.setTypedDate,
            clearDate: _vm.clearDate
          }
        },
        [_vm._t("afterDateInput", null, { slot: "afterDateInput" })],
        2
      ),
      _vm._v(" "),
      _vm.allowedToShowView("day")
        ? _c(
            "picker-day",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showDayView: _vm.showDayView,
                fullMonthName: _vm.fullMonthName,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                highlighted: _vm.highlighted,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                pageTimestamp: _vm.pageTimestamp,
                isRtl: _vm.isRtl,
                mondayFirst: _vm.mondayFirst,
                dayCellContent: _vm.dayCellContent,
                "use-utc": _vm.useUtc
              },
              on: {
                changedMonth: _vm.handleChangedMonthFromDayPicker,
                selectDate: _vm.selectDate,
                showMonthCalendar: _vm.showMonthCalendar,
                selectedDisabled: _vm.selectDisabledDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("month")
        ? _c(
            "picker-month",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showMonthView: _vm.showMonthView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: {
                selectMonth: _vm.selectMonth,
                showYearCalendar: _vm.showYearCalendar,
                changedYear: _vm.setPageDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("year")
        ? _c(
            "picker-year",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showYearView: _vm.showYearView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: { selectYear: _vm.selectYear, changedDecade: _vm.setPageDate }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-64ca2bb5_0", { source: ".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n", map: {"version":3,"sources":["Datepicker.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB","file":"Datepicker.vue","sourcesContent":[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  

  
  var Datepicker = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    browser,
    undefined
  );

/* harmony default export */ __webpack_exports__["a"] = (Datepicker);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (options) {
  var mappedProps = options.mappedProps,
      name = options.name,
      ctr = options.ctr,
      ctrArgs = options.ctrArgs,
      events = options.events,
      beforeCreate = options.beforeCreate,
      afterCreate = options.afterCreate,
      props = options.props,
      rest = _objectWithoutProperties(options, ['mappedProps', 'name', 'ctr', 'ctrArgs', 'events', 'beforeCreate', 'afterCreate', 'props']);

  var promiseName = '$' + name + 'Promise';
  var instanceName = '$' + name + 'Object';

  assert(!(rest.props instanceof Array), '`props` should be an object, not Array');

  return _extends({}, typeof GENERATE_DOC !== 'undefined' ? { $vgmOptions: options } : {}, {
    mixins: [_mapElementMixin2.default],
    props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
    render: function render() {
      return '';
    },
    provide: function provide() {
      var _this = this;

      var promise = this.$mapPromise.then(function (map) {
        // Infowindow needs this to be immediately available
        _this.$map = map;

        // Initialize the maps with the given options
        var options = _extends({}, _this.options, {
          map: map
        }, (0, _bindProps.getPropsValues)(_this, mappedProps));
        delete options.options; // delete the extra options

        if (beforeCreate) {
          var result = beforeCreate.bind(_this)(options);

          if (result instanceof Promise) {
            return result.then(function () {
              return { options: options };
            });
          }
        }
        return { options: options };
      }).then(function (_ref) {
        var _Function$prototype$b;

        var options = _ref.options;

        var ConstructorObject = ctr();
        // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
        _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [ConstructorObject, null].concat(_toConsumableArray(ctrArgs(options, (0, _bindProps.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);

        (0, _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
        (0, _bindEvents2.default)(_this, _this[instanceName], events);

        if (afterCreate) {
          afterCreate.bind(_this)(_this[instanceName]);
        }
        return _this[instanceName];
      });
      this[promiseName] = promise;
      return _defineProperty({}, promiseName, promise);
    },
    destroyed: function destroyed() {
      // Note: not all Google Maps components support maps
      if (this[instanceName] && this[instanceName].setMap) {
        this[instanceName].setMap(null);
      }
    }
  }, rest);
};

exports.mappedPropsToVueProps = mappedPropsToVueProps;

var _bindEvents = __webpack_require__(143);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(76);

var _mapElementMixin = __webpack_require__(355);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */


function assert(v, message) {
  if (!v) throw new Error(message);
}

/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */
function mappedPropsToVueProps(mappedProps) {
  return Object.entries(mappedProps).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        prop = _ref4[1];

    var value = {};

    if ('type' in prop) value.type = prop.type;
    if ('default' in prop) value.default = prop.default;
    if ('required' in prop) value.required = prop.required;

    return [key, value];
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    acc[key] = val;
    return acc;
  }, {});
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(12)) {
  var LIBRARY = __webpack_require__(47);
  var global = __webpack_require__(6);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(87);
  var $buffer = __webpack_require__(124);
  var ctx = __webpack_require__(32);
  var anInstance = __webpack_require__(59);
  var propertyDesc = __webpack_require__(52);
  var hide = __webpack_require__(23);
  var redefineAll = __webpack_require__(61);
  var toInteger = __webpack_require__(34);
  var toLength = __webpack_require__(10);
  var toIndex = __webpack_require__(175);
  var toAbsoluteIndex = __webpack_require__(55);
  var toPrimitive = __webpack_require__(38);
  var has = __webpack_require__(27);
  var classof = __webpack_require__(65);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(15);
  var isArrayIter = __webpack_require__(113);
  var create = __webpack_require__(56);
  var getPrototypeOf = __webpack_require__(30);
  var gOPN = __webpack_require__(57).f;
  var getIterFn = __webpack_require__(115);
  var uid = __webpack_require__(53);
  var wks = __webpack_require__(9);
  var createArrayMethod = __webpack_require__(41);
  var createArrayIncludes = __webpack_require__(77);
  var speciesConstructor = __webpack_require__(72);
  var ArrayIterators = __webpack_require__(118);
  var Iterators = __webpack_require__(67);
  var $iterDetect = __webpack_require__(82);
  var setSpecies = __webpack_require__(58);
  var arrayFill = __webpack_require__(117);
  var arrayCopyWithin = __webpack_require__(164);
  var $DP = __webpack_require__(14);
  var $GOPD = __webpack_require__(29);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(170);
var $export = __webpack_require__(1);
var shared = __webpack_require__(68)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(173))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GoogleMapRaw_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Landing_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_vue__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_authentication_Logout_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_candidates_CandidateRegistration_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_candidates_Dashboard_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_candidates_ApplicationForm__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_employers_Registration_vue__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_employers_Dashboard_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_employers_profile_PublicProfile_vue__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_employers_applications_FamilyForm_vue__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_employers_applications_PermanentNanny_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_employers_applications_NannyOnCall_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_employers_applications_InterimCare_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_employers_documents_MedicalRelease__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_agents_Dashboard_vue__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_agents_StripeConnectConfirmation__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_jobBoard_JobBoard_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_jobBoard_Job_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_employers_jobs_JobForm_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_organizationBoard_OrganizationBoard_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_blog_Blog_vue__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_blog_BlogPost_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_blog_NewBlogPost_vue__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_blog_BlogPostForm_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_blog_EditBlogPost_vue__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_events_EventBoard_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_events_Event_vue__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_events_EventForm_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_general_About_vue__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_general_Team_vue__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_general_What_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_general_Privacy_vue__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_general_Terms_vue__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_general_Contact_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_general_Content_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_general_CreateContent_vue__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_password_PasswordResetRequest_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_password_PasswordReset_vue__ = __webpack_require__(934);










// import CandidateProfile from './components/candidates/CandidateProfile.vue';












































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_3__components_Landing_vue__["a" /* default */], name: 'Home' }, { path: '/map', component: __WEBPACK_IMPORTED_MODULE_2__components_GoogleMapRaw_vue__["a" /* default */] },

// { path: '/opportunities', component: GoogleMapRaw },

{ path: '/login', component: __WEBPACK_IMPORTED_MODULE_4__components_Login_vue__["a" /* default */], name: 'Login' }, { path: '/logout', component: __WEBPACK_IMPORTED_MODULE_5__components_authentication_Logout_vue__["a" /* default */], name: 'Logout' }, { path: '/candidate-registration', component: __WEBPACK_IMPORTED_MODULE_6__components_candidates_CandidateRegistration_vue__["a" /* default */], name: 'Candidate Registration' },
// { path: '/user', component: CandidateProfile, name: 'Candidate Dashboard' },
{ path: '/user', component: __WEBPACK_IMPORTED_MODULE_7__components_candidates_Dashboard_vue__["a" /* default */], name: 'Candidate Dashboard' }, { path: '/user/:id', component: __WEBPACK_IMPORTED_MODULE_7__components_candidates_Dashboard_vue__["a" /* default */], name: 'Candidate Viewable Dashboard' }, { path: '/nanny-application-form', component: __WEBPACK_IMPORTED_MODULE_8__components_candidates_ApplicationForm__["a" /* default */], name: 'Candidate Application Form' }, { path: '/employer-registration', component: __WEBPACK_IMPORTED_MODULE_9__components_employers_Registration_vue__["a" /* default */], name: 'Employer Registration' }, { path: '/family-dashboard', component: __WEBPACK_IMPORTED_MODULE_10__components_employers_Dashboard_vue__["a" /* default */], name: 'Employer Dashboard' }, { path: '/organization/:id', component: __WEBPACK_IMPORTED_MODULE_11__components_employers_profile_PublicProfile_vue__["a" /* default */], name: 'Employer Public Profile' }, { path: '/family-form', component: __WEBPACK_IMPORTED_MODULE_12__components_employers_applications_FamilyForm_vue__["a" /* default */], name: 'Employer Application Form' }, { path: '/client-application-permanent-nanny', component: __WEBPACK_IMPORTED_MODULE_13__components_employers_applications_PermanentNanny_vue__["a" /* default */], name: 'Client Application Permanent Nanny' }, { path: '/client-application-nanny-on-call', component: __WEBPACK_IMPORTED_MODULE_14__components_employers_applications_NannyOnCall_vue__["a" /* default */], name: 'Client Application Nanny on Call' }, { path: '/client-application-interim-care', component: __WEBPACK_IMPORTED_MODULE_15__components_employers_applications_InterimCare_vue__["a" /* default */], name: 'Client Application Interim Care' }, { path: '/medical-release', component: __WEBPACK_IMPORTED_MODULE_16__components_employers_documents_MedicalRelease__["a" /* default */], name: 'Medical Release' }, { path: '/agent-dashboard', component: __WEBPACK_IMPORTED_MODULE_17__components_agents_Dashboard_vue__["a" /* default */], name: 'Agent Dashboard' }, { path: '/stripe-connect-confirmation', component: __WEBPACK_IMPORTED_MODULE_18__components_agents_StripeConnectConfirmation__["a" /* default */], name: 'Stripe Connect Confirmation' },

// { path: '/opportunities', component: JobBoard, name: 'Job Board' },
{ path: '/jobs', component: __WEBPACK_IMPORTED_MODULE_19__components_jobBoard_JobBoard_vue__["a" /* default */], name: 'Job Board' }, { path: '/opportunities/:type/:country/:topic', component: __WEBPACK_IMPORTED_MODULE_19__components_jobBoard_JobBoard_vue__["a" /* default */], name: 'Search Job Board' },
// { path: '/opportunity/:id', component: Job, name: 'Job' },
{ path: '/job/:id', component: __WEBPACK_IMPORTED_MODULE_20__components_jobBoard_Job_vue__["a" /* default */], name: 'Job' }, { path: '/edit-opportunity/:id', component: __WEBPACK_IMPORTED_MODULE_21__components_employers_jobs_JobForm_vue__["a" /* default */], name: 'Edit Job' }, { path: '/organizations', component: __WEBPACK_IMPORTED_MODULE_22__components_organizationBoard_OrganizationBoard_vue__["a" /* default */], name: 'Organization Board' }, { path: '/organizations/:type/:country/:topic', component: __WEBPACK_IMPORTED_MODULE_22__components_organizationBoard_OrganizationBoard_vue__["a" /* default */], name: 'Search Organization Board' }, { path: '/global-health-events', component: __WEBPACK_IMPORTED_MODULE_28__components_events_EventBoard_vue__["a" /* default */], name: 'Events' }, { path: '/events/:type/:country/:topic', component: __WEBPACK_IMPORTED_MODULE_28__components_events_EventBoard_vue__["a" /* default */], name: 'Search Events' }, { path: '/event/:id', component: __WEBPACK_IMPORTED_MODULE_29__components_events_Event_vue__["a" /* default */], name: 'Event' }, { path: '/edit-event/:id', component: __WEBPACK_IMPORTED_MODULE_30__components_events_EventForm_vue__["a" /* default */], name: 'Edit Event' },

// { path: '/blog', component: Blog, name: 'Blog' },
{ path: '/global-health-news-career-advice', component: __WEBPACK_IMPORTED_MODULE_23__components_blog_Blog_vue__["a" /* default */], name: 'Blog' }, { path: '/blog-post/:id', component: __WEBPACK_IMPORTED_MODULE_24__components_blog_BlogPost_vue__["a" /* default */], name: 'Blog Post' }, { path: '/new-blog-post', component: __WEBPACK_IMPORTED_MODULE_25__components_blog_NewBlogPost_vue__["a" /* default */], name: 'New Blog Post' }, { path: '/edit-blog-post/:id', component: __WEBPACK_IMPORTED_MODULE_27__components_blog_EditBlogPost_vue__["a" /* default */], name: 'Edit Blog Post' }, { path: '/about-us', component: __WEBPACK_IMPORTED_MODULE_31__components_general_About_vue__["a" /* default */], name: 'About Us' }, { path: '/team', component: __WEBPACK_IMPORTED_MODULE_32__components_general_Team_vue__["a" /* default */], name: 'Team' },
// { path: '/what-is-global-health', component: What, name: 'What is Global Health' },
{ path: '/privacy-policy', component: __WEBPACK_IMPORTED_MODULE_34__components_general_Privacy_vue__["a" /* default */], name: 'Privacy Policy' }, { path: '/terms-and-conditions', component: __WEBPACK_IMPORTED_MODULE_35__components_general_Terms_vue__["a" /* default */], name: 'Terms and Conditions' }, { path: '/contact', component: __WEBPACK_IMPORTED_MODULE_36__components_general_Contact_vue__["a" /* default */], name: 'Contact' }, { path: '/reset-password', component: __WEBPACK_IMPORTED_MODULE_39__components_password_PasswordResetRequest_vue__["a" /* default */], name: 'Password Reset Request' }, { path: '/reset-password/:token', component: __WEBPACK_IMPORTED_MODULE_40__components_password_PasswordReset_vue__["a" /* default */], name: 'Password Reset' }, { path: '/create-content', component: __WEBPACK_IMPORTED_MODULE_38__components_general_CreateContent_vue__["a" /* default */], name: 'Create Content' }, { path: '/:slug', component: __WEBPACK_IMPORTED_MODULE_37__components_general_Content_vue__["a" /* default */], name: 'Content' }];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ mode: 'history', routes: routes }));

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(53)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(27);
var setDesc = __webpack_require__(14).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(9)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(23)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddMarkStep */
/* unused harmony export MapResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mapping; });
/* unused harmony export RemoveMarkStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReplaceAroundStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ReplaceStep; });
/* unused harmony export Step */
/* unused harmony export StepMap */
/* unused harmony export StepResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Transform; });
/* unused harmony export TransformError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return canJoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return canSplit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dropPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return findWrapping; });
/* unused harmony export insertPoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return joinPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return liftTarget; });
/* unused harmony export replaceStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(37);


// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);

function makeRecover(index, offset) { return index + offset * factor16 }
function recoverIndex(value) { return value & lower16 }
function recoverOffset(value) { return (value - (value & lower16)) / factor16 }

// ::- An object representing a mapped position with extra
// information.
var MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  this.ranges = ranges;
  this.inverted = inverted;
};

StepMap.prototype.recover = function recover (value) {
  var diff = 0, index = recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + recoverOffset(value)
};

// : (number, ?number) → MapResult
StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

StepMap.prototype._map = function _map (pos, assoc, simple) {
  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = makeRecover(i / 3, pos - start);
      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new MapResult(pos + diff)
};

StepMap.prototype.touches = function touches (pos, recover) {
  var diff = 0, index = recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
StepMap.prototype.forEach = function forEach (f) {
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
StepMap.prototype.invert = function invert () {
  return new StepMap(this.ranges, !this.inverted)
};

StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
StepMap.offset = function offset (n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

StepMap.empty = new StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new Mapping(this.maps, this.mirror, from, to)
};

Mapping.prototype.copy = function copy () {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
Mapping.prototype.appendMapping = function appendMapping (mapping) {
  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
Mapping.prototype.getMirror = function getMirror (n) {
  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this.mirror[i] == n) { return this.mirror[i + (i % 2 ? -1 : 1)] } } }
};

Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// :: () → Mapping
// Create an inverted version of this mapping.
Mapping.prototype.invert = function invert () {
  var inverse = new Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
Mapping.prototype.map = function map (pos, assoc) {
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

Mapping.prototype._map = function _map (pos, assoc, simple) {
  var deleted = false, recoverables = null;

  for (var i = this.from; i < this.to; i++) {
    var map = this.maps[i], rec = recoverables && recoverables[i];
    if (rec != null && map.touches(pos, rec)) {
      pos = map.recover(rec);
      continue
    }

    var result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this.getMirror(i);
      if (corr != null && corr > i && corr < this.to) {
        if (result.deleted) {
          i = corr;
          pos = this.maps[corr].recover(result.recover);
          continue
        } else {
(recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
        }
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new MapResult(pos, deleted)
};

function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err
}

TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new Mapping;
};

var prototypeAccessors = { before: { configurable: true },docChanged: { configurable: true } };

// :: Node The starting document.
prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
prototypeAccessors.docChanged.get = function () {
  return this.steps.length > 0
};

Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( Transform.prototype, prototypeAccessors );

function mustOverride() { throw new Error("Override me") }

var stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var Step = function Step () {};

Step.prototype.apply = function apply (_doc) { return mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
Step.prototype.getMap = function getMap () { return StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
Step.prototype.invert = function invert (_doc) { return mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
Step.prototype.map = function map (_mapping) { return mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
Step.prototype.toJSON = function toJSON () { return mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
Step.jsonID = function jsonID (id, stepClass) {
  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
StepResult.ok = function ok (doc) { return new StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
StepResult.fail = function fail (message) { return new StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["ReplaceError"]) { return StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var ReplaceStep = /*@__PURE__*/(function (Step) {
  function ReplaceStep(from, to, slice, structure) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceStep.__proto__ = Step;
  ReplaceStep.prototype = Object.create( Step && Step.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && contentBetween(doc, this.from, this.to))
      { return StepResult.fail("Structure replace would overwrite content") }
    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure != this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty
          : new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty
          : new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(Step));

Step.jsonID("replace", ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var ReplaceAroundStep = /*@__PURE__*/(function (Step) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice;
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceAroundStep.__proto__ = Step;
  ReplaceAroundStep.prototype = Object.create( Step && Step.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
                           contentBetween(doc, this.gapTo, this.to)))
      { return StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
    return StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(Step));

Step.jsonID("replaceAround", ReplaceAroundStep);

function contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) &&
    (end == node.childCount || node.canReplace(0, end))
}

// :: (NodeRange) → ?number
// Try to find a target depth to which the content in the given range
// can be lifted. Will not go across
// [isolating](#model.NodeSpec.isolating) parent nodes.
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content))
      { return depth }
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
  }
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
// Try to find a valid way to wrap the content in the given range in a
// node of the given type. May introduce extra nodes around and inside
// the wrapper node, if necessary. Returns null if no valid wrapping
// could be found. When `innerRange` is given, that range's content is
// used as the content to fit into the wrapping, instead of the
// content of `range`.
function findWrapping(range, nodeType, attrs, innerRange) {
  if ( innerRange === void 0 ) innerRange = range;

  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) { return null }
  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
}

function withAttrs(type) { return {type: type, attrs: null} }

function findWrappingOutside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) { return null }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
}

function findWrappingInside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) { return null }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++)
    { innerMatch = innerMatch.matchType(parent.child(i).type); }
  if (!innerMatch || !innerMatch.validEnd) { return null }
  return inside
}

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
Transform.prototype.wrap = function(range, wrappers) {
  var content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  var start = range.start, end = range.end;
  return this.step(new ReplaceAroundStep(start, end, start, end, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(newNode), 0, 0), 1, true))
};

// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
// Check whether splitting at the given position is allowed.
function canSplit(doc, pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = doc.resolve(pos), base = $pos.depth - depth;
  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating ||
      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    { return false }
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d), index$1 = $pos.index(d);
    if (node.type.spec.isolating) { return false }
    var rest = node.content.cutByIndex(index$1, node.childCount);
    var after = (typesAfter && typesAfter[i]) || node;
    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
      { return false }
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
}

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new ReplaceStep(pos, pos, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](before.append(after), depth, depth), true))
};

// :: (Node, number) → bool
// Test whether the blocks before and after a given position can be
// joined.
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) &&
    $pos.parent.canReplace(index, index + 1)
}

function joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b)
}

// :: (Node, number, ?number) → ?number
// Find an ancestor of the given position that can be joined to the
// block before (or after if `dir` is positive). Returns the joinable
// point, if any.
function joinPoint(doc, pos, dir) {
  if ( dir === void 0 ) dir = -1;

  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = (void 0), after = (void 0);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      after = $pos.node(d).maybeChild($pos.index(d) + 1);
    } else {
      before = $pos.node(d).maybeChild($pos.index(d) - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable(before, after)) { return pos }
    if (d == 0) { break }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new ReplaceStep(pos - depth, pos + depth, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

// :: (Node, number, Slice) → ?number
// Finds a position at or around the given position where the given
// slice can be inserted. Will look at parent nodes' nearest boundary
// and try there, even if the original position wasn't directly at the
// start or end of that node. Returns null when no position was found.
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) { return pos }
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      if (pass == 1
          ? $pos.node(d).canReplace(insertPos, insertPos, content)
          : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type))
        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
    }
  }
  return null
}

function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var AddMarkStep = /*@__PURE__*/(function (Step) {
  function AddMarkStep(from, to, mark) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step ) AddMarkStep.__proto__ = Step;
  AddMarkStep.prototype = Object.create( Step && Step.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](mapFragment(oldSlice.content, function (node, parent) {
      if (!parent.type.allowsMarkType(this$1.mark.type)) { return node }
      return node.mark(this$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(Step));

Step.jsonID("addMark", AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var RemoveMarkStep = /*@__PURE__*/(function (Step) {
  function RemoveMarkStep(from, to, mark) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step ) RemoveMarkStep.__proto__ = Step;
  RemoveMarkStep.prototype = Object.create( Step && Step.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(Step));

Step.jsonID("removeMark", RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
Transform.prototype.addMark = function(from, to, mark) {
  var this$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1.step(s); });
  added.forEach(function (s) { return this$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
Transform.prototype.removeMark = function(from, to, mark) {
  var this$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["MarkType"]) {
      var found = mark.isInSet(node.marks);
      if (found) { toRemove = [found]; }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1.step(new RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new ReplaceStep(cur, end, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this.step(new RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true);
    this.replace(cur, cur, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (fitsTrivially($from, $to, slice)) { return new ReplaceStep(from, to, slice) }
  var placed = placeSlice($from, slice);

  var fittedLeft = fitLeft($from, placed);
  var fitted = fitRight($from, $to, fittedLeft);
  if (!fitted) { return null }
  if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
    var d = $to.depth, after = $to.after(d);
    while (d > 1 && after == $to.end(--d)) { ++after; }
    var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);
    if (fittedAfter)
      { return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size) }
  }
  return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty;

  var step = replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};



function fitLeftInner($from, depth, placed, placedBelow) {
  var content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, openEnd = 0, placedHere = placed[depth];
  if ($from.depth > depth) {
    var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
    openEnd = inner.openEnd + 1;
    content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($from.node(depth + 1).copy(inner.content));
  }

  if (placedHere) {
    content = content.append(placedHere.content);
    openEnd = placedHere.openEnd;
  }
  if (placedBelow) {
    content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true));
    openEnd = 0;
  }

  return {content: content, openEnd: openEnd}
}

function fitLeft($from, placed) {
  var ref = fitLeftInner($from, 0, placed, false);
  var content = ref.content;
  var openEnd = ref.openEnd;
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](content, $from.depth, openEnd || 0)
}

function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
  var match, count = content.childCount, matchCount = count - (openEnd > 0 ? 1 : 0);
  var parentNode = openStart < 0 ? parent : $from.node(depth);
  if (openStart < 0)
    { match = parentNode.contentMatchAt(matchCount); }
  else if (count == 1 && openEnd > 0)
    { match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth)); }
  else
    { match = parentNode.contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount); }

  var toNode = $to.node(depth);
  if (openEnd > 0 && depth < $to.depth) {
    var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
    var joinable$1 = match.fillBefore(after, true);
    // Can't insert content if there's a single node stretched across this gap
    if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) { joinable$1 = null; }

    if (joinable$1) {
      var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to,
                               depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);
      if (inner) {
        var last = content.lastChild.copy(inner);
        if (joinable$1.size)
          { return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last) }
        else
          { return content.replaceChild(count - 1, last) }
      }
    }
  }
  if (openEnd > 0)
    { match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type); }

  // If we're here, the next level can't be joined, so we see what
  // happens if we leave it open.
  var toIndex = $to.index(depth);
  if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) { return null }
  var joinable = match.fillBefore(toNode.content, true, toIndex);
  for (var i = toIndex; joinable && i < toNode.content.childCount; i++)
    { if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) { joinable = null; } }
  if (!joinable) { return null }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }
  content = content.append(joinable);
  if ($to.depth > depth)
    { content = content.addToEnd(fitRightSeparate($to, depth + 1)); }
  return content
}

function fitRightClosed(node, openEnd, $from, depth, openStart) {
  var match, content = node.content, count = content.childCount;
  if (openStart >= 0)
    { match = $from.node(depth).contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, openStart > 0 ? 1 : 0, count); }
  else
    { match = node.contentMatchAt(count); }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }

  return node.copy(content.append(match.fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true)))
}

function fitRightSeparate($to, depth) {
  var node = $to.node(depth);
  var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));
  if ($to.depth > depth) { fill = fill.addToEnd(fitRightSeparate($to, depth + 1)); }
  return node.copy(fill)
}

function normalizeSlice(content, openStart, openEnd) {
  while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
    content = content.firstChild.content;
    openStart--;
    openEnd--;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](content, openStart, openEnd)
}

// : (ResolvedPos, ResolvedPos, number, Slice) → Slice
function fitRight($from, $to, slice) {
  var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);
  if (!fitted) { return null }
  return normalizeSlice(fitted, slice.openStart, $to.depth)
}

function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

function canMoveText($from, $to, slice) {
  if (!$to.parent.isTextblock) { return false }

  var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd)
      : $from.node($from.depth - (slice.openStart - slice.openEnd));
  if (!parent.isTextblock) { return false }
  for (var i = $to.index(); i < $to.parent.childCount; i++)
    { if (!parent.type.allowsMarks($to.parent.child(i).marks)) { return false } }
  var match;
  if (slice.openEnd) {
    match = parent.contentMatchAt(parent.childCount);
  } else {
    match = parent.contentMatchAt(parent.childCount);
    if (slice.size) { match = match.matchFragment(slice.content, slice.openStart ? 1 : 0); }
  }
  match = match.matchFragment($to.parent.content, $to.index());
  return match && match.validEnd
}

function nodeRight(content, depth) {
  for (var i = 1; i < depth; i++) { content = content.lastChild.content; }
  return content.lastChild
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// So placeSlice splits up a slice into a number of sub-slices,
// along with information on where they can be placed on the given
// left-side edge. It works by walking the open side of the slice,
// from the inside out, and trying to find a landing spot for each
// element, by simultaneously scanning over the gap side. When no
// place is found for an open node's content, it is left in that node.

// : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]
function placeSlice($from, slice) {
  var frontier = new Frontier($from);
  for (var pass = 1; slice.size && pass <= 3; pass++) {
    var value = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass);
    if (pass == 3 && value != slice && value.size) { pass = 0; } // Restart if the 3rd pass made progress but left content
    slice = value;
  }
  while (frontier.open.length) { frontier.closeNode(); }
  return frontier.placed
}

// Helper class that models the open side of the insert position,
// keeping track of the content match and already inserted content
// at each depth.
var Frontier = function Frontier($pos) {
  // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]
  this.open = [];
  for (var d = 0; d <= $pos.depth; d++) {
    var parent = $pos.node(d), match = parent.contentMatchAt($pos.indexAfter(d));
    this.open.push({parent: parent, match: match, content: __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, wrapper: false, openEnd: 0, depth: d});
  }
  this.placed = [];
};

// : (Fragment, number, number, number, ?Node) → Slice
// Tries to place the content of the given slice, and returns a
// slice containing unplaced content.
//
// pass 1: try to fit directly
// pass 2: allow wrapper nodes to be introduced
// pass 3: allow unwrapping of nodes that aren't open
Frontier.prototype.placeSlice = function placeSlice (fragment, openStart, openEnd, pass, parent) {
  if (openStart > 0) {
    var first = fragment.firstChild;
    var inner = this.placeSlice(first.content, Math.max(0, openStart - 1),
                                openEnd && fragment.childCount == 1 ? openEnd - 1 : 0,
                                pass, first);
    if (inner.content != first.content) {
      if (inner.content.size) {
        fragment = fragment.replaceChild(0, first.copy(inner.content));
        openStart = inner.openStart + 1;
      } else {
        if (fragment.childCount == 1) { openEnd = 0; }
        fragment = fragment.cutByIndex(1);
        openStart = 0;
      }
    }
  }
  var result = this.placeContent(fragment, openStart, openEnd, pass, parent);
  if (pass > 2 && result.size && openStart == 0) {
    var child = result.content.firstChild, single = result.content.childCount == 1;
    this.placeContent(child.content, 0, openEnd && single ? openEnd - 1 : 0, pass, child);
    result = single ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty : new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](result.content.cutByIndex(1), 0, openEnd);
  }
  return result
};

Frontier.prototype.placeContent = function placeContent (fragment, openStart, openEnd, pass, parent) {
  var i = 0;
  // Go over the fragment's children
  for (; i < fragment.childCount; i++) {
    var child = fragment.child(i), placed = false, last = i == fragment.childCount - 1;
    // Try each open node in turn, starting from the innermost
    for (var d = this.open.length - 1; d >= 0; d--) {
      var open = this.open[d], wrap = (void 0);

      // If pass > 1, it is allowed to wrap the node to help find a
      // fit, so if findWrapping returns something, we add open
      // nodes to the frontier for that wrapping.
      if (pass > 1 && (wrap = open.match.findWrapping(child.type)) &&
          !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
        while (this.open.length - 1 > d) { this.closeNode(); }
        for (var w = 0; w < wrap.length; w++) {
          open.match = open.match.matchType(wrap[w]);
          d++;
          open = {parent: wrap[w].create(),
                  match: wrap[w].contentMatch,
                  content: __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, wrapper: true, openEnd: 0, depth: d + w};
          this.open.push(open);
        }
      }

      // See if the child fits here
      var match = open.match.matchType(child.type);
      if (!match) {
        var fill = open.match.fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(child));
        if (fill) {
          for (var j = 0; j < fill.childCount; j++) {
            var ch = fill.child(j);
            this.addNode(open, ch, 0);
            match = open.match.matchFragment(ch);
          }
        } else if (parent && open.match.matchType(parent.type)) {
          // Don't continue looking further up if the parent node
          // would fit here.
          break
        } else {
          continue
        }
      }

      // Close open nodes above this one, since we're starting to
      // add to this.
      while (this.open.length - 1 > d) { this.closeNode(); }
      // Strip marks from the child or close its start when necessary
      child = child.mark(open.parent.type.allowedMarks(child.marks));
      if (openStart) {
        child = closeNodeStart(child, openStart, last ? openEnd : 0);
        openStart = 0;
      }
      // Add the child to this open node and adjust its metadata
      this.addNode(open, child, last ? openEnd : 0);
      open.match = match;
      if (last) { openEnd = 0; }
      placed = true;
      break
    }
    // As soon as we've failed to place a node we stop looking at
    // later nodes
    if (!placed) { break }
  }
  // Close the current open node if it's not the the root and we
  // either placed up to the end of the node or the the current
  // slice depth's node type matches the open node's type
  if (this.open.length > 1 &&
      (i > 0 && i == fragment.childCount ||
       parent && this.open[this.open.length - 1].parent.type == parent.type))
    { this.closeNode(); }

  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](fragment.cutByIndex(i), openStart, openEnd)
};

Frontier.prototype.addNode = function addNode (open, node, openEnd) {
  open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
  open.openEnd = openEnd;
};

Frontier.prototype.closeNode = function closeNode () {
  var open = this.open.pop();
  if (open.content.size == 0) ; else if (open.wrapper) {
    this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
  } else {
    this.placed[open.depth] = {depth: open.depth, content: open.content, openEnd: open.openEnd};
  }
};

function closeNodeStart(node, openStart, openEnd) {
  var content = node.content;
  if (openStart > 1) {
    var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
    content = node.content.replaceChild(0, first);
  }
  var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
  return node.copy(fill.append(content))
}

function closeNodeEnd(node, depth) {
  var content = node.content;
  if (depth > 1) {
    var last = closeNodeEnd(node.lastChild, depth - 1);
    content = node.content.replaceChild(node.childCount - 1, last);
  }
  var fill = node.contentMatchAt(node.childCount).fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true);
  return node.copy(content.append(fill))
}

function closeFragmentEnd(fragment, depth) {
  return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining](#model.NodeSpec.defining), or
// including an open parent node from the slice that _is_ marked as
// [defining](#model.NodeSpec.defining).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
Transform.prototype.replaceRange = function(from, to, slice) {
  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (fitsTrivially($from, $to, slice))
    { return this.step(new ReplaceStep(from, to, slice)) }

  var targetDepths = coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  var startSteps = this.steps.length;
  for (var i$2 = targetDepths.length - 1; i$2 >= 0; i$2--) {
    this.replace(from, to, slice);
    if (this.steps.length > startSteps) { break }
    var depth = targetDepths[i$2];
    if (i$2 < 0) { continue }
    from = $from.before(depth); to = $to.after(depth);
  }
  return this
};

function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen) {
    var match = parent.contentMatchAt(0);
    var start = match.fillBefore(fragment).append(fragment);
    fragment = start.append(match.matchFragment(start).fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true));
  }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
Transform.prototype.deleteRange = function(from, to) {
  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth && d <= $to.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d)
      { return this.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d)) { result.push(d); }
  }
  return result
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(149);
var enumBugKeys = __webpack_require__(101);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(34);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(5);
var dPs = __webpack_require__(150);
var enumBugKeys = __webpack_require__(101);
var IE_PROTO = __webpack_require__(100)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(98)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(102).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(149);
var hiddenKeys = __webpack_require__(101).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var dP = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(12);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var call = __webpack_require__(162);
var isArrayIter = __webpack_require__(113);
var anObject = __webpack_require__(5);
var toLength = __webpack_require__(10);
var getIterFn = __webpack_require__(115);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(24);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./GoldCoastNannies_Logo_FullColor-01.png": 596,
	"./NAN_logomark_RGB_Evergreen.png": 597,
	"./NAN_logomark_RGB_Evergreen_trim.png": 598,
	"./PinkNannies-Circle.svg": 599,
	"./PinkNannies-RGB-Horizontal.svg": 74,
	"./ttnyc-logo-hires.jpg": 600,
	"./ttnyc-logo-old.jpg": 601,
	"./ttnyc-logo.jpg": 602
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(14).f;
var has = __webpack_require__(27);
var TAG = __webpack_require__(9)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(33);
var TAG = __webpack_require__(9)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(39);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(104);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(31);
var global = __webpack_require__(6);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(47) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(33);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(5);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(19);
var SPECIES = __webpack_require__(9)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
// https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/

// Your personal API key.
// Get it here: https://console.cloud.google.com/google/maps-apis
var API_KEY = 'AIzaSyAjRmYdMmC9yr1dP8Kqi7FPS_8_CsvT2qc';
var CALLBACK_NAME = 'gmapsCallback';

var initialized = !!window.google;
var resolveInitPromise = void 0;
var rejectInitPromise = void 0;
// This promise handles the initialization
// status of the google maps script.
var initPromise = new Promise(function (resolve, reject) {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

function init() {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (initialized) return initPromise;

  initialized = true;
  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window[CALLBACK_NAME] = function () {
    return resolveInitPromise(window.google);
  };

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  var script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + API_KEY + '&callback=' + CALLBACK_NAME;
  script.onerror = rejectInitPromise;
  document.querySelector('head').appendChild(script);

  return initPromise;
}
// google.maps.event.addDomListener(window, "load", initialize);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "PinkNannies-RGB-Horizontal.svg?e649088f91402cc4d83f78ac4316a338";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(629));

var _alphaNum = _interopRequireDefault(__webpack_require__(632));

var _numeric = _interopRequireDefault(__webpack_require__(633));

var _between = _interopRequireDefault(__webpack_require__(634));

var _email = _interopRequireDefault(__webpack_require__(635));

var _ipAddress = _interopRequireDefault(__webpack_require__(636));

var _macAddress = _interopRequireDefault(__webpack_require__(637));

var _maxLength = _interopRequireDefault(__webpack_require__(638));

var _minLength = _interopRequireDefault(__webpack_require__(639));

var _required = _interopRequireDefault(__webpack_require__(640));

var _requiredIf = _interopRequireDefault(__webpack_require__(641));

var _requiredUnless = _interopRequireDefault(__webpack_require__(642));

var _sameAs = _interopRequireDefault(__webpack_require__(643));

var _url = _interopRequireDefault(__webpack_require__(644));

var _or = _interopRequireDefault(__webpack_require__(645));

var _and = _interopRequireDefault(__webpack_require__(646));

var _not = _interopRequireDefault(__webpack_require__(647));

var _minValue = _interopRequireDefault(__webpack_require__(648));

var _maxValue = _interopRequireDefault(__webpack_require__(649));

var _integer = _interopRequireDefault(__webpack_require__(650));

var _decimal = _interopRequireDefault(__webpack_require__(651));

var helpers = _interopRequireWildcard(__webpack_require__(13));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsValues = getPropsValues;
exports.bindProps = bindProps;

var _WatchPrimitiveProperties = __webpack_require__(144);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPropsValues(vueInst, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (vueInst[prop] !== undefined) {
      acc[prop] = vueInst[prop];
    }
    return acc;
  }, {});
}

/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */
function bindProps(vueInst, googleMapsInst, props) {
  var _loop = function (attribute) {
    var _props$attribute = props[attribute],
        twoWay = _props$attribute.twoWay,
        type = _props$attribute.type,
        trackProperties = _props$attribute.trackProperties,
        noBind = _props$attribute.noBind;


    if (noBind) return 'continue';

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueInst[attribute];

    if (typeof googleMapsInst[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueInst.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueInst.$watch(attribute, function () {
        var attributeValue = vueInst[attribute];

        googleMapsInst[setMethodName](attributeValue);
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      (0, _WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function (prop) {
        return attribute + '.' + prop;
      }), function () {
        googleMapsInst[setMethodName](vueInst[attribute]);
      }, vueInst[attribute] !== undefined);
    }

    if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) {
      googleMapsInst.addListener(eventName, function () {
        // eslint-disable-line no-unused-vars
        vueInst.$emit(eventName, googleMapsInst[getMethodName]());
      });
    }
  };

  for (var attribute in props) {
    var _ret = _loop(attribute);

    if (_ret === 'continue') continue;
  }
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(28);
var toLength = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(55);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(33);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(34);
var defined = __webpack_require__(39);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(33);
var MATCH = __webpack_require__(9)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(9)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(65);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(166);
var redefine = __webpack_require__(24);
var hide = __webpack_require__(23);
var fails = __webpack_require__(7);
var defined = __webpack_require__(39);
var wks = __webpack_require__(9);
var regexpExec = __webpack_require__(119);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(24);
var redefineAll = __webpack_require__(61);
var meta = __webpack_require__(48);
var forOf = __webpack_require__(60);
var anInstance = __webpack_require__(59);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(82);
var setToStringTag = __webpack_require__(64);
var inheritIfRequired = __webpack_require__(105);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(23);
var uid = __webpack_require__(53);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(47) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(6)[K];
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var ctx = __webpack_require__(32);
var forOf = __webpack_require__(60);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Decoration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DecorationSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditorView; });
/* unused harmony export __endComposition */
/* unused harmony export __parseFromClipboard */
/* unused harmony export __serializeForClipboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__ = __webpack_require__(50);




var result = {};

if (typeof navigator != "undefined" && typeof document != "undefined") {
  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

  result.mac = /Mac/.test(navigator.platform);
  var ie = result.ie = !!(ie_upto10 || ie_11up || ie_edge);
  result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
  result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
  result.gecko_version = result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
  result.chrome = !!chrome;
  result.chrome_version = chrome && +chrome[1];
  result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
  result.android = /Android \d/.test(navigator.userAgent);
  result.webkit = !ie && 'WebkitAppearance' in document.documentElement.style;
  result.safari = /Apple Computer/.test(navigator.vendor);
  result.webkit_version = result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}

var domIndex = function(node) {
  for (var index = 0;; index++) {
    node = node.previousSibling;
    if (!node) { return index }
  }
};

var parentNode = function(node) {
  var parent = node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent
};

var textRange = function(node, from, to) {
  var range = document.createRange();
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range
};

// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
                        scanFor(node, off, targetNode, targetOff, 1))
};

var atomElements = /^(img|br|input|textarea|hr)$/i;

function scanFor(node, off, targetNode, targetOff, dir) {
  for (;;) {
    if (node == targetNode && off == targetOff) { return true }
    if (off == (dir < 0 ? 0 : nodeSize(node))) {
      var parent = node.parentNode;
      if (parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false")
        { return false }
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
      off = dir < 0 ? nodeSize(node) : 0;
    } else {
      return false
    }
  }
}

function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function hasBlockDesc(dom) {
  var desc;
  for (var cur = dom; cur; cur = cur.parentNode) { if (desc = cur.pmViewDesc) { break } }
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom)
}

// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
var selectionCollapsed = function(domSel) {
  var collapsed = domSel.isCollapsed;
  if (collapsed && result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed)
    { collapsed = false; }
  return collapsed
};

function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event
}

function windowRect(win) {
  return {left: 0, right: win.innerWidth,
          top: 0, bottom: win.innerHeight}
}

function getSide(value, side) {
  return typeof value == "number" ? value : value[side]
}

function scrollRectIntoView(view, rect, startDOM) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  var doc = view.dom.ownerDocument, win = doc.defaultView;
  for (var parent = startDOM || view.dom;; parent = parentNode(parent)) {
    if (!parent) { break }
    if (parent.nodeType != 1) { continue }
    var atTop = parent == doc.body || parent.nodeType != 1;
    var bounding = atTop ? windowRect(win) : parent.getBoundingClientRect();
    var moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
      { moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top")); }
    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
      { moveY = rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom"); }
    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
      { moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left")); }
    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
      { moveX = rect.right - bounding.right + getSide(scrollMargin, "right"); }
    if (moveX || moveY) {
      if (atTop) {
        win.scrollBy(moveX, moveY);
      } else {
        if (moveY) { parent.scrollTop += moveY; }
        if (moveX) { parent.scrollLeft += moveX; }
      }
    }
    if (atTop) { break }
  }
}

// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  var refDOM, refTop;
  for (var x = (rect.left + rect.right) / 2, y = startY + 1;
       y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x, y);
    if (dom == view.dom || !view.dom.contains(dom)) { continue }
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break
    }
  }
  return {refDOM: refDOM, refTop: refTop, stack: scrollStack(view.dom)}
}

function scrollStack(dom) {
  var stack = [], doc = dom.ownerDocument;
  for (; dom; dom = parentNode(dom)) {
    stack.push({dom: dom, top: dom.scrollTop, left: dom.scrollLeft});
    if (dom == doc) { break }
  }
  return stack
}

// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos(ref) {
  var refDOM = ref.refDOM;
  var refTop = ref.refTop;
  var stack = ref.stack;

  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}

function restoreScrollStack(stack, dTop) {
  for (var i = 0; i < stack.length; i++) {
    var ref = stack[i];
    var dom = ref.dom;
    var top = ref.top;
    var left = ref.left;
    if (dom.scrollTop != top + dTop) { dom.scrollTop = top + dTop; }
    if (dom.scrollLeft != left) { dom.scrollLeft = left; }
  }
}

var preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function focusPreventScroll(dom) {
  if (dom.setActive) { return dom.setActive() } // in IE
  if (preventScrollSupported) { return dom.focus(preventScrollSupported) }

  var stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = {preventScroll: true};
      return true
    }
  } : undefined);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}

function findOffsetInNode(node, coords) {
  var closest, dxClosest = 2e8, coordsClosest, offset = 0;
  var rowBot = coords.top, rowTop = coords.top;
  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    var rects = (void 0);
    if (child.nodeType == 1) { rects = child.getClientRects(); }
    else if (child.nodeType == 3) { rects = textRange(child).getClientRects(); }
    else { continue }

    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left
            : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {left: rect.right < coords.left ? rect.right : rect.left, top: coords.top} : coords;
          if (child.nodeType == 1 && dx)
            { offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0); }
          continue
        }
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                       coords.left >= rect.left && coords.top >= rect.bottom))
        { offset = childIndex + 1; }
    }
  }
  if (closest && closest.nodeType == 3) { return findOffsetInText(closest, coordsClosest) }
  if (!closest || (dxClosest && closest.nodeType == 1)) { return {node: node, offset: offset} }
  return findOffsetInNode(closest, coordsClosest)
}

function findOffsetInText(node, coords) {
  var len = node.nodeValue.length;
  var range = document.createRange();
  for (var i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    var rect = singleRect(range, 1);
    if (rect.top == rect.bottom) { continue }
    if (inRect(coords, rect))
      { return {node: node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)} }
  }
  return {node: node, offset: 0}
}

function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1&&
    coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1
}

function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
    { return parent }
  return dom
}

function posFromElement(view, elt, coords) {
  var ref = findOffsetInNode(elt, coords);
  var node = ref.node;
  var offset = ref.offset;
  var bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    var rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset, bias)
}

function posFromCaret(view, node, offset, coords) {
  // Browser (in caretPosition/RangeFromPoint) will agressively
  // normalize towards nearby inline nodes. Since we are interested in
  // positions between block nodes too, we first walk up the hierarchy
  // of nodes to see if there are block nodes that the coordinates
  // fall outside of. If so, we take the position before/after that
  // block. If not, we call `posFromDOM` on the raw node/offset.
  var outside = -1;
  for (var cur = node;;) {
    if (cur == view.dom) { break }
    var desc = view.docView.nearestDesc(cur, true);
    if (!desc) { return null }
    if (desc.node.isBlock && desc.parent) {
      var rect = desc.dom.getBoundingClientRect();
      if (rect.left > coords.left || rect.top > coords.top) { outside = desc.posBefore; }
      else if (rect.right < coords.left || rect.bottom < coords.top) { outside = desc.posAfter; }
      else { break }
    }
    cur = desc.dom.parentNode;
  }
  return outside > -1 ? outside : view.docView.posFromDOM(node, offset)
}

function elementFromPoint(element, coords, box) {
  var len = element.childNodes.length;
  if (len && box.top < box.bottom) {
    for (var startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;) {
      var child = element.childNodes[i];
      if (child.nodeType == 1) {
        var rects = child.getClientRects();
        for (var j = 0; j < rects.length; j++) {
          var rect = rects[j];
          if (inRect(coords, rect)) { return elementFromPoint(child, coords, rect) }
        }
      }
      if ((i = (i + 1) % len) == startI) { break }
    }
  }
  return element
}

// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
  var assign, assign$1;

  var root = view.root, node, offset;
  if (root.caretPositionFromPoint) {
    try { // Firefox throws for this call in hard-to-predict circumstances (#994)
      var pos$1 = root.caretPositionFromPoint(coords.left, coords.top);
      if (pos$1) { ((assign = pos$1, node = assign.offsetNode, offset = assign.offset)); }
    } catch (_) {}
  }
  if (!node && root.caretRangeFromPoint) {
    var range = root.caretRangeFromPoint(coords.left, coords.top);
    if (range) { ((assign$1 = range, node = assign$1.startContainer, offset = assign$1.startOffset)); }
  }

  var elt = root.elementFromPoint(coords.left, coords.top + 1), pos;
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    var box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box)) { return null }
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt) { return null }
  }
  elt = targetKludge(elt, coords);
  if (node) {
    if (result.gecko && node.nodeType == 1) {
      // Firefox will sometimes return offsets into <input> nodes, which
      // have no actual children, from caretPositionFromPoint (#953)
      offset = Math.min(offset, node.childNodes.length);
      // It'll also move the returned position before image nodes,
      // even if those are behind it.
      if (offset < node.childNodes.length) {
        var next = node.childNodes[offset], box$1;
        if (next.nodeName == "IMG" && (box$1 = next.getBoundingClientRect()).right <= coords.left &&
            box$1.bottom > coords.top)
          { offset++; }
      }
    }
    // Suspiciously specific kludge to work around caret*FromPoint
    // never returning a position at the end of the document
    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
        coords.top > node.lastChild.getBoundingClientRect().bottom)
      { pos = view.state.doc.content.size; }
    // Ignore positions directly after a BR, since caret*FromPoint
    // 'round up' positions that would be more accurately placed
    // before the BR node.
    else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
      { pos = posFromCaret(view, node, offset, coords); }
  }
  if (pos == null) { pos = posFromElement(view, elt, coords); }

  var desc = view.docView.nearestDesc(elt, true);
  return {pos: pos, inside: desc ? desc.posAtStart - desc.border : -1}
}

function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
}

// : (EditorView, number) → {left: number, top: number, right: number, bottom: number}
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;

  // These browsers support querying empty text ranges
  if (node.nodeType == 3 && (result.chrome || result.gecko)) {
    var rect = singleRect(textRange(node, offset, offset), 0);
    // Firefox returns bad results (the position before the space)
    // when querying a position directly after line-broken
    // whitespace. Detect this situation and and kludge around it
    if (result.gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
      var rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
      if (Math.abs(rectBefore.left - rect.left) < 1 && rectBefore.top == rect.top) {
        var rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
        return flattenV(rectAfter, rectAfter.left < rectBefore.left)
      }
    }
    return rect
  }

  if (node.nodeType == 1 && !view.state.doc.resolve(pos).parent.inlineContent) {
    // Return a horizontal line in block context
    var top = true, rect$1;
    if (offset < node.childNodes.length) {
      var after = node.childNodes[offset];
      if (after.nodeType == 1) { rect$1 = after.getBoundingClientRect(); }
    }
    if (!rect$1 && offset) {
      var before = node.childNodes[offset - 1];
      if (before.nodeType == 1) { rect$1 = before.getBoundingClientRect(); top = false; }
    }
    return flattenH(rect$1 || node.getBoundingClientRect(), top)
  }

  // Not Firefox/Chrome, or not in a text node, so we have to use
  // actual element/character rectangles to get a solution (this part
  // is not very bidi-safe)
  //
  // Try the left side first, fall back to the right one if that
  // doesn't work.
  for (var dir = -1; dir < 2; dir += 2) {
    if (dir < 0 && offset) {
      var prev = (void 0), target = node.nodeType == 3 ? textRange(node, offset - 1, offset)
          : (prev = node.childNodes[offset - 1]).nodeType == 3 ? textRange(prev)
          : prev.nodeType == 1 && prev.nodeName != "BR" ? prev : null; // BR nodes tend to only return the rectangle before them
      if (target) {
        var rect$2 = singleRect(target, 1);
        if (rect$2.top < rect$2.bottom) { return flattenV(rect$2, false) }
      }
    } else if (dir > 0 && offset < nodeSize(node)) {
      var next = (void 0), target$1 = node.nodeType == 3 ? textRange(node, offset, offset + 1)
          : (next = node.childNodes[offset]).nodeType == 3 ? textRange(next)
          : next.nodeType == 1 ? next : null;
      if (target$1) {
        var rect$3 = singleRect(target$1, -1);
        if (rect$3.top < rect$3.bottom) { return flattenV(rect$3, true) }
      }
    }
  }
  // All else failed, just try to get a rectangle for the target node
  return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, 0), false)
}

function flattenV(rect, left) {
  if (rect.width == 0) { return rect }
  var x = left ? rect.left : rect.right;
  return {top: rect.top, bottom: rect.bottom, left: x, right: x}
}

function flattenH(rect, top) {
  if (rect.height == 0) { return rect }
  var y = top ? rect.top : rect.bottom;
  return {top: y, bottom: y, left: rect.left, right: rect.right}
}

function withFlushedState(view, state, f) {
  var viewState = view.state, active = view.root.activeElement;
  if (viewState != state) { view.updateState(state); }
  if (active != view.dom) { view.focus(); }
  try {
    return f()
  } finally {
    if (viewState != state) { view.updateState(viewState); }
    if (active != view.dom) { active.focus(); }
  }
}

// : (EditorView, number, number)
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$anchor.min(sel.$head) : sel.$anchor.max(sel.$head);
  return withFlushedState(view, state, function () {
    var ref = view.docView.domFromPos($pos.pos);
    var dom = ref.node;
    for (;;) {
      var nearest = view.docView.nearestDesc(dom, true);
      if (!nearest) { break }
      if (nearest.node.isBlock) { dom = nearest.dom; break }
      dom = nearest.dom.parentNode;
    }
    var coords = coordsAtPos(view, $pos.pos);
    for (var child = dom.firstChild; child; child = child.nextSibling) {
      var boxes = (void 0);
      if (child.nodeType == 1) { boxes = child.getClientRects(); }
      else if (child.nodeType == 3) { boxes = textRange(child, 0, child.nodeValue.length).getClientRects(); }
      else { continue }
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        if (box.bottom > box.top && (dir == "up" ? box.bottom < coords.top + 1 : box.top > coords.bottom - 1))
          { return false }
      }
    }
    return true
  })
}

var maybeRTL = /[\u0590-\u08ac]/;

function endOfTextblockHorizontal(view, state, dir) {
  var ref = state.selection;
  var $head = ref.$head;
  if (!$head.parent.isTextblock) { return false }
  var offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
  var sel = getSelection();
  // If the textblock is all LTR, or the browser doesn't support
  // Selection.modify (Edge), fall back to a primitive approach
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    { return dir == "left" || dir == "backward" ? atStart : atEnd }

  return withFlushedState(view, state, function () {
    // This is a huge hack, but appears to be the best we can
    // currently do: use `Selection.modify` to move the selection by
    // one character, and see if that moves the cursor out of the
    // textblock (or doesn't move it at all, when at the start/end of
    // the document).
    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
    var oldBidiLevel = sel.caretBidiLevel; // Only for Firefox
    sel.modify("move", dir, "character");
    var parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    var result = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) ||
        (oldNode == sel.focusNode && oldOff == sel.focusOffset);
    // Restore the previous selection
    sel.removeAllRanges();
    sel.addRange(oldRange);
    if (oldBidiLevel != null) { sel.caretBidiLevel = oldBidiLevel; }
    return result
  })
}

var cachedState = null, cachedDir = null, cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) { return cachedResult }
  cachedState = state; cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down"
    ? endOfTextblockVertical(view, state, dir)
    : endOfTextblockHorizontal(view, state, dir)
}

// NodeView:: interface
//
// By default, document nodes are rendered using the result of the
// [`toDOM`](#model.NodeSpec.toDOM) method of their spec, and managed
// entirely by the editor. For some use cases, such as embedded
// node-specific editing interfaces, you want more control over
// the behavior of a node's in-editor representation, and need to
// [define](#view.EditorProps.nodeViews) a custom node view.
//
// Objects returned as node views must conform to this interface.
//
//   dom:: ?dom.Node
//   The outer DOM node that represents the document node. When not
//   given, the default strategy is used to create a DOM node.
//
//   contentDOM:: ?dom.Node
//   The DOM node that should hold the node's content. Only meaningful
//   if the node view also defines a `dom` property and if its node
//   type is not a leaf node type. When this is present, ProseMirror
//   will take care of rendering the node's children into it. When it
//   is not present, the node view itself is responsible for rendering
//   (or deciding not to render) its child nodes.
//
//   update:: ?(node: Node, decorations: [Decoration]) → bool
//   When given, this will be called when the view is updating itself.
//   It will be given a node (possibly of a different type), and an
//   array of active decorations (which are automatically drawn, and
//   the node view may ignore if it isn't interested in them), and
//   should return true if it was able to update to that node, and
//   false otherwise. If the node view has a `contentDOM` property (or
//   no `dom` property), updating its child nodes will be handled by
//   ProseMirror.
//
//   selectNode:: ?()
//   Can be used to override the way the node's selected status (as a
//   node selection) is displayed.
//
//   deselectNode:: ?()
//   When defining a `selectNode` method, you should also provide a
//   `deselectNode` method to remove the effect again.
//
//   setSelection:: ?(anchor: number, head: number, root: dom.Document)
//   This will be called to handle setting the selection inside the
//   node. The `anchor` and `head` positions are relative to the start
//   of the node. By default, a DOM selection will be created between
//   the DOM positions corresponding to those positions, but if you
//   override it you can do something else.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to prevent the editor view from trying to handle some
//   or all DOM events that bubble up from the node view. Events for
//   which this returns true are not handled by the editor.
//
//   ignoreMutation:: ?(dom.MutationRecord) → bool
//   Called when a DOM
//   [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver)
//   or a selection change happens within the view. When the change is
//   a selection change, the record will have a `type` property of
//   `"selection"` (which doesn't occur for native mutation records).
//   Return false if the editor should re-read the selection or
//   re-parse the range around the mutation, true if it can safely be
//   ignored.
//
//   destroy:: ?()
//   Called when the node view is removed from the editor or the whole
//   editor is destroyed.

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.

var NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;

// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
var ViewDesc = function ViewDesc(parent, children, dom, contentDOM) {
  this.parent = parent;
  this.children = children;
  this.dom = dom;
  // An expando property on the DOM node provides a link back to its
  // description.
  dom.pmViewDesc = this;
  // This is the node that holds the child views. It may be null for
  // descs that don't have children.
  this.contentDOM = contentDOM;
  this.dirty = NOT_DIRTY;
};

var prototypeAccessors = { beforePosition: { configurable: true },size: { configurable: true },border: { configurable: true },posBefore: { configurable: true },posAtStart: { configurable: true },posAfter: { configurable: true },posAtEnd: { configurable: true },contentLost: { configurable: true } };

// Used to check whether a given description corresponds to a
// widget/mark/node.
ViewDesc.prototype.matchesWidget = function matchesWidget () { return false };
ViewDesc.prototype.matchesMark = function matchesMark () { return false };
ViewDesc.prototype.matchesNode = function matchesNode () { return false };
ViewDesc.prototype.matchesHack = function matchesHack () { return false };

prototypeAccessors.beforePosition.get = function () { return false };

// : () → ?ParseRule
// When parsing in-editor content (in domchange.js), we allow
// descriptions to determine the parse rules that should be used to
// parse them.
ViewDesc.prototype.parseRule = function parseRule () { return null };

// : (dom.Event) → bool
// Used by the editor's event handler to ignore events that come
// from certain descs.
ViewDesc.prototype.stopEvent = function stopEvent () { return false };

// The size of the content represented by this desc.
prototypeAccessors.size.get = function () {
  var size = 0;
  for (var i = 0; i < this.children.length; i++) { size += this.children[i].size; }
  return size
};

// For block nodes, this represents the space taken up by their
// start/end tokens.
prototypeAccessors.border.get = function () { return 0 };

ViewDesc.prototype.destroy = function destroy () {
  this.parent = null;
  if (this.dom.pmViewDesc == this) { this.dom.pmViewDesc = null; }
  for (var i = 0; i < this.children.length; i++)
    { this.children[i].destroy(); }
};

ViewDesc.prototype.posBeforeChild = function posBeforeChild (child) {
  for (var i = 0, pos = this.posAtStart; i < this.children.length; i++) {
    var cur = this.children[i];
    if (cur == child) { return pos }
    pos += cur.size;
  }
};

prototypeAccessors.posBefore.get = function () {
  return this.parent.posBeforeChild(this)
};

prototypeAccessors.posAtStart.get = function () {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0
};

prototypeAccessors.posAfter.get = function () {
  return this.posBefore + this.size
};

prototypeAccessors.posAtEnd.get = function () {
  return this.posAtStart + this.size - 2 * this.border
};

// : (dom.Node, number, ?number) → number
ViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
  // If the DOM position is in the content, use the child desc after
  // it to figure out a position.
  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
    if (bias < 0) {
      var domBefore, desc;
      if (dom == this.contentDOM) {
        domBefore = dom.childNodes[offset - 1];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domBefore = dom.previousSibling;
      }
      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) { domBefore = domBefore.previousSibling; }
      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart
    } else {
      var domAfter, desc$1;
      if (dom == this.contentDOM) {
        domAfter = dom.childNodes[offset];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domAfter = dom.nextSibling;
      }
      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) { domAfter = domAfter.nextSibling; }
      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd
    }
  }
  // Otherwise, use various heuristics, falling back on the bias
  // parameter, to determine whether to return the position at the
  // start or at the end of this view desc.
  var atEnd;
  if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
    atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
  } else if (this.dom.firstChild) {
    if (offset == 0) { for (var search = dom;; search = search.parentNode) {
      if (search == this.dom) { atEnd = false; break }
      if (search.parentNode.firstChild != search) { break }
    } }
    if (atEnd == null && offset == dom.childNodes.length) { for (var search$1 = dom;; search$1 = search$1.parentNode) {
      if (search$1 == this.dom) { atEnd = true; break }
      if (search$1.parentNode.lastChild != search$1) { break }
    } }
  }
  return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart
};

// Scan up the dom finding the first desc that is a descendant of
// this one.
ViewDesc.prototype.nearestDesc = function nearestDesc (dom, onlyNodes) {
  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
    var desc = this.getDesc(cur);
    if (desc && (!onlyNodes || desc.node)) {
      // If dom is outside of this desc's nodeDOM, don't count it.
      if (first && desc.nodeDOM && !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom) : desc.nodeDOM == dom)) { first = false; }
      else { return desc }
    }
  }
};

ViewDesc.prototype.getDesc = function getDesc (dom) {
  var desc = dom.pmViewDesc;
  for (var cur = desc; cur; cur = cur.parent) { if (cur == this) { return desc } }
};

ViewDesc.prototype.posFromDOM = function posFromDOM (dom, offset, bias) {
  for (var scan = dom;; scan = scan.parentNode) {
    var desc = this.getDesc(scan);
    if (desc) { return desc.localPosFromDOM(dom, offset, bias) }
  }
};

// : (number) → ?NodeViewDesc
// Find the desc for the node after the given pos, if any. (When a
// parent node overrode rendering, there might not be one.)
ViewDesc.prototype.descAt = function descAt (pos) {
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (offset == pos && end != offset) {
      while (!child.border && child.children.length) { child = child.children[0]; }
      return child
    }
    if (pos < end) { return child.descAt(pos - offset - child.border) }
    offset = end;
  }
};

// : (number) → {node: dom.Node, offset: number}
ViewDesc.prototype.domFromPos = function domFromPos (pos) {
  if (!this.contentDOM) { return {node: this.dom, offset: 0} }
  for (var offset = 0, i = 0;; i++) {
    if (offset == pos) {
      while (i < this.children.length && (this.children[i].beforePosition || this.children[i].dom.parentNode != this.contentDOM)) { i++; }
      return {node: this.contentDOM,
              offset: i == this.children.length ? this.contentDOM.childNodes.length : domIndex(this.children[i].dom)}
    }
    if (i == this.children.length) { throw new Error("Invalid position " + pos) }
    var child = this.children[i], end = offset + child.size;
    if (pos < end) { return child.domFromPos(pos - offset - child.border) }
    offset = end;
  }
};

// Used to find a DOM range in a single parent for a given changed
// range.
ViewDesc.prototype.parseRange = function parseRange (from, to, base) {
    if ( base === void 0 ) base = 0;

  if (this.children.length == 0)
    { return {node: this.contentDOM, from: from, to: to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length} }

  var fromOffset = -1, toOffset = -1;
  for (var offset = base, i = 0;; i++) {
    var child = this.children[i], end = offset + child.size;
    if (fromOffset == -1 && from <= end) {
      var childBase = offset + child.border;
      // FIXME maybe descend mark views to parse a narrower range?
      if (from >= childBase && to <= end - child.border && child.node &&
          child.contentDOM && this.contentDOM.contains(child.contentDOM))
        { return child.parseRange(from, to, childBase) }

      from = offset;
      for (var j = i; j > 0; j--) {
        var prev = this.children[j - 1];
        if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
          fromOffset = domIndex(prev.dom) + 1;
          break
        }
        from -= prev.size;
      }
      if (fromOffset == -1) { fromOffset = 0; }
    }
    if (fromOffset > -1 && to <= end) {
      to = end;
      for (var j$1 = i + 1; j$1 < this.children.length; j$1++) {
        var next = this.children[j$1];
        if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
          toOffset = domIndex(next.dom);
          break
        }
        to += next.size;
      }
      if (toOffset == -1) { toOffset = this.contentDOM.childNodes.length; }
      break
    }
    offset = end;
  }
  return {node: this.contentDOM, from: from, to: to, fromOffset: fromOffset, toOffset: toOffset}
};

ViewDesc.prototype.emptyChildAt = function emptyChildAt (side) {
  if (this.border || !this.contentDOM || !this.children.length) { return false }
  var child = this.children[side < 0 ? 0 : this.children.length - 1];
  return child.size == 0 || child.emptyChildAt(side)
};

// : (number) → dom.Node
ViewDesc.prototype.domAfterPos = function domAfterPos (pos) {
  var ref = this.domFromPos(pos);
    var node = ref.node;
    var offset = ref.offset;
  if (node.nodeType != 1 || offset == node.childNodes.length)
    { throw new RangeError("No node after pos " + pos) }
  return node.childNodes[offset]
};

// : (number, number, dom.Document)
// View descs are responsible for setting any selection that falls
// entirely inside of them, so that custom implementations can do
// custom things with the selection. Note that this falls apart when
// a selection starts in such a node and ends in another, in which
// case we just use whatever domFromPos produces as a best effort.
ViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
  // If the selection falls entirely in a child, give it to that child
  var from = Math.min(anchor, head), to = Math.max(anchor, head);
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (from > offset && to < end)
      { return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force) }
    offset = end;
  }

  var anchorDOM = this.domFromPos(anchor), headDOM = this.domFromPos(head);
  var domSel = root.getSelection(), range = document.createRange();
  if (!force &&
      isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) &&
      isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset))
    { return }

  // Selection.extend can be used to create an 'inverted' selection
  // (one where the focus is before the anchor), but not all
  // browsers support it yet.
  if (domSel.extend) {
    range.setEnd(anchorDOM.node, anchorDOM.offset);
    range.collapse(false);
  } else {
    if (anchor > head) { var tmp = anchorDOM; anchorDOM = headDOM; headDOM = tmp; }
    range.setEnd(headDOM.node, headDOM.offset);
    range.setStart(anchorDOM.node, anchorDOM.offset);
  }
  domSel.removeAllRanges();
  domSel.addRange(range);
  if (domSel.extend)
    { domSel.extend(headDOM.node, headDOM.offset); }
};

// : (dom.MutationRecord) → bool
ViewDesc.prototype.ignoreMutation = function ignoreMutation (_mutation) {
  return !this.contentDOM
};

prototypeAccessors.contentLost.get = function () {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM)
};

// Remove a subtree of the element tree that has been touched
// by a DOM change, so that the next update will redraw it.
ViewDesc.prototype.markDirty = function markDirty (from, to) {
  for (var offset = 0, i = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
      var startInside = offset + child.border, endInside = end - child.border;
      if (from >= startInside && to <= endInside) {
        this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
        if (from == startInside && to == endInside &&
            (child.contentLost || child.dom.parentNode != this.contentDOM)) { child.dirty = NODE_DIRTY; }
        else { child.markDirty(from - startInside, to - startInside); }
        return
      } else {
        child.dirty = NODE_DIRTY;
      }
    }
    offset = end;
  }
  this.dirty = CONTENT_DIRTY;
};

ViewDesc.prototype.markParentsDirty = function markParentsDirty () {
  for (var node = this.parent; node; node = node.parent) {
    var dirty =  CONTENT_DIRTY ;
    if (node.dirty < dirty) { node.dirty = dirty; }
  }
};

Object.defineProperties( ViewDesc.prototype, prototypeAccessors );

// Reused array to avoid allocating fresh arrays for things that will
// stay empty anyway.
var nothing = [];

// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
var WidgetViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function WidgetViewDesc(parent, widget, view, pos) {
    var self, dom = widget.type.toDOM;
    if (typeof dom == "function") { dom = dom(view, function () {
      if (!self) { return pos }
      if (self.parent) { return self.parent.posBeforeChild(self) }
    }); }
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = false;
      dom.classList.add("ProseMirror-widget");
    }
    ViewDesc.call(this, parent, nothing, dom, null);
    this.widget = widget;
    self = this;
  }

  if ( ViewDesc ) WidgetViewDesc.__proto__ = ViewDesc;
  WidgetViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  WidgetViewDesc.prototype.constructor = WidgetViewDesc;

  var prototypeAccessors$1 = { beforePosition: { configurable: true } };

  prototypeAccessors$1.beforePosition.get = function () {
    return this.widget.type.side < 0
  };

  WidgetViewDesc.prototype.matchesWidget = function matchesWidget (widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type)
  };

  WidgetViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };

  WidgetViewDesc.prototype.stopEvent = function stopEvent (event) {
    var stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false
  };

  Object.defineProperties( WidgetViewDesc.prototype, prototypeAccessors$1 );

  return WidgetViewDesc;
}(ViewDesc));

var CompositionViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function CompositionViewDesc(parent, dom, textDOM, text) {
    ViewDesc.call(this, parent, nothing, dom, null);
    this.textDOM = textDOM;
    this.text = text;
  }

  if ( ViewDesc ) CompositionViewDesc.__proto__ = ViewDesc;
  CompositionViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  CompositionViewDesc.prototype.constructor = CompositionViewDesc;

  var prototypeAccessors$2 = { size: { configurable: true } };

  prototypeAccessors$2.size.get = function () { return this.text.length };

  CompositionViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset) {
    if (dom != this.textDOM) { return this.posAtStart + (offset ? this.size : 0) }
    return this.posAtStart + offset
  };

  CompositionViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.textDOM, offset: pos}
  };

  CompositionViewDesc.prototype.ignoreMutation = function ignoreMutation (mut) {
    return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue
   };

  Object.defineProperties( CompositionViewDesc.prototype, prototypeAccessors$2 );

  return CompositionViewDesc;
}(ViewDesc));

// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
var MarkViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function MarkViewDesc(parent, mark, dom, contentDOM) {
    ViewDesc.call(this, parent, [], dom, contentDOM);
    this.mark = mark;
  }

  if ( ViewDesc ) MarkViewDesc.__proto__ = ViewDesc;
  MarkViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  MarkViewDesc.prototype.constructor = MarkViewDesc;

  MarkViewDesc.create = function create (parent, mark, inline, view) {
    var custom = view.nodeViews[mark.type.name];
    var spec = custom && custom(mark, view, inline);
    if (!spec || !spec.dom)
      { spec = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["DOMSerializer"].renderSpec(document, mark.type.spec.toDOM(mark, inline)); }
    return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom)
  };

  MarkViewDesc.prototype.parseRule = function parseRule () { return {mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM} };

  MarkViewDesc.prototype.matchesMark = function matchesMark (mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark) };

  MarkViewDesc.prototype.markDirty = function markDirty (from, to) {
    ViewDesc.prototype.markDirty.call(this, from, to);
    // Move dirty info to nearest node view
    if (this.dirty != NOT_DIRTY) {
      var parent = this.parent;
      while (!parent.node) { parent = parent.parent; }
      if (parent.dirty < this.dirty) { parent.dirty = this.dirty; }
      this.dirty = NOT_DIRTY;
    }
  };

  MarkViewDesc.prototype.slice = function slice (from, to, view) {
    var copy = MarkViewDesc.create(this.parent, this.mark, true, view);
    var nodes = this.children, size = this.size;
    if (to < size) { nodes = replaceNodes(nodes, to, size, view); }
    if (from > 0) { nodes = replaceNodes(nodes, 0, from, view); }
    for (var i = 0; i < nodes.length; i++) { nodes[i].parent = copy; }
    copy.children = nodes;
    return copy
  };

  return MarkViewDesc;
}(ViewDesc));

// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
var NodeViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    ViewDesc.call(this, parent, node.isLeaf ? nothing : [], dom, contentDOM);
    this.nodeDOM = nodeDOM;
    this.node = node;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    if (contentDOM) { this.updateChildren(view, pos); }
  }

  if ( ViewDesc ) NodeViewDesc.__proto__ = ViewDesc;
  NodeViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  NodeViewDesc.prototype.constructor = NodeViewDesc;

  var prototypeAccessors$3 = { size: { configurable: true },border: { configurable: true } };

  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finnicky
  // implementation details to the user code that they probably will
  // never need.)
  NodeViewDesc.create = function create (parent, node, outerDeco, innerDeco, view, pos) {
    var assign;

    var custom = view.nodeViews[node.type.name], descObj;
    var spec = custom && custom(node, view, function () {
      // (This is a function that allows the custom view to find its
      // own position)
      if (!descObj) { return pos }
      if (descObj.parent) { return descObj.parent.posBeforeChild(descObj) }
    }, outerDeco);

    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node.isText) {
      if (!dom) { dom = document.createTextNode(node.text); }
      else if (dom.nodeType != 3) { throw new RangeError("Text must be rendered as a DOM text node") }
    } else if (!dom) {
((assign = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["DOMSerializer"].renderSpec(document, node.type.spec.toDOM(node)), dom = assign.dom, contentDOM = assign.contentDOM));
    }
    if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
      if (!dom.hasAttribute("contenteditable")) { dom.contentEditable = false; }
      if (node.type.spec.draggable) { dom.draggable = true; }
    }

    var nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node);

    if (spec)
      { return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM,
                                              spec, view, pos + 1) }
    else if (node.isText)
      { return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) }
    else
      { return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos + 1) }
  };

  NodeViewDesc.prototype.parseRule = function parseRule () {
    var this$1 = this;

    // Experimental kludge to allow opt-in re-parsing of nodes
    if (this.node.type.spec.reparseInView) { return null }
    // FIXME the assumption that this can always return the current
    // attrs means that if the user somehow manages to change the
    // attrs in the dom, that won't be picked up. Not entirely sure
    // whether this is a problem
    var rule = {node: this.node.type.name, attrs: this.node.attrs};
    if (this.node.type.spec.code) { rule.preserveWhitespace = "full"; }
    if (this.contentDOM && !this.contentLost) { rule.contentElement = this.contentDOM; }
    else { rule.getContent = function () { return this$1.contentDOM ? __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty : this$1.node.content; }; }
    return rule
  };

  NodeViewDesc.prototype.matchesNode = function matchesNode (node, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node.eq(this.node) &&
      sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco)
  };

  prototypeAccessors$3.size.get = function () { return this.node.nodeSize };

  prototypeAccessors$3.border.get = function () { return this.node.isLeaf ? 0 : 1 };

  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  NodeViewDesc.prototype.updateChildren = function updateChildren (view, pos) {
    var this$1 = this;

    var inline = this.node.inlineContent, off = pos;
    var composition = inline && view.composing && this.localCompositionNode(view, pos);
    var updater = new ViewTreeUpdater(this, composition && composition.node);
    iterDeco(this.node, this.innerDeco, function (widget, i) {
      if (widget.spec.marks)
        { updater.syncToMarks(widget.spec.marks, inline, view); }
      else if (widget.type.side >= 0)
        { updater.syncToMarks(i == this$1.node.childCount ? __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Mark"].none : this$1.node.child(i).marks, inline, view); }
      // If the next node is a desc matching this widget, reuse it,
      // otherwise insert the widget as a new view desc.
      updater.placeWidget(widget, view, off);
    }, function (child, outerDeco, innerDeco, i) {
      // Make sure the wrapping mark descs match the node's marks.
      updater.syncToMarks(child.marks, inline, view);
      // Either find an existing desc that exactly matches this node,
      // and drop the descs before it.
      updater.findNodeMatch(child, outerDeco, innerDeco, i) ||
        // Or try updating the next desc to reflect this node.
        updater.updateNextNode(child, outerDeco, innerDeco, view, i) ||
        // Or just add it as a new desc.
        updater.addNode(child, outerDeco, innerDeco, view, off);
      off += child.nodeSize;
    });
    // Drop all remaining descs after the current position.
    updater.syncToMarks(nothing, inline, view);
    if (this.node.isTextblock) { updater.addTextblockHacks(); }
    updater.destroyRest();

    // Sync the DOM if anything changed
    if (updater.changed || this.dirty == CONTENT_DIRTY) {
      // May have to protect focused DOM from being changed if a composition is active
      if (composition) { this.protectLocalComposition(view, composition); }
      this.renderChildren();
    }
  };

  NodeViewDesc.prototype.renderChildren = function renderChildren () {
    renderDescs(this.contentDOM, this.children);
    if (result.ios) { iosHacks(this.dom); }
  };

  NodeViewDesc.prototype.localCompositionNode = function localCompositionNode (view, pos) {
    // Only do something if both the selection and a focused text node
    // are inside of this node, and the node isn't already part of a
    // view that's a child of this view
    var ref = view.state.selection;
    var from = ref.from;
    var to = ref.to;
    if (!(view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) || from < pos || to > pos + this.node.content.size) { return }
    var sel = view.root.getSelection();
    var textNode = nearbyTextNode(sel.focusNode, sel.focusOffset);
    if (!textNode || !this.dom.contains(textNode.parentNode)) { return }

    // Find the text in the focused node in the node, stop if it's not
    // there (may have been modified through other means, in which
    // case it should overwritten)
    var text = textNode.nodeValue;
    var textPos = findTextInFragment(this.node.content, text, from - pos, to - pos);

    return textPos < 0 ? null : {node: textNode, pos: textPos, text: text}
  };

  NodeViewDesc.prototype.protectLocalComposition = function protectLocalComposition (view, ref) {
    var node = ref.node;
    var pos = ref.pos;
    var text = ref.text;

    // The node is already part of a local view desc, leave it there
    if (this.getDesc(node)) { return }

    // Create a composition view for the orphaned nodes
    var topNode = node;
    for (;; topNode = topNode.parentNode) {
      if (topNode.parentNode == this.contentDOM) { break }
      while (topNode.previousSibling) { topNode.parentNode.removeChild(topNode.previousSibling); }
      while (topNode.nextSibling) { topNode.parentNode.removeChild(topNode.nextSibling); }
      if (topNode.pmViewDesc) { topNode.pmViewDesc = null; }
    }
    var desc = new CompositionViewDesc(this, topNode, node, text);
    view.compositionNodes.push(desc);

    // Patch up this.children to contain the composition view
    this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
  };

  // : (Node, [Decoration], DecorationSet, EditorView) → bool
  // If this desc be updated to match the given node decoration,
  // do so and return true.
  NodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY ||
        !node.sameMarkup(this.node)) { return false }
    this.updateInner(node, outerDeco, innerDeco, view);
    return true
  };

  NodeViewDesc.prototype.updateInner = function updateInner (node, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node;
    this.innerDeco = innerDeco;
    if (this.contentDOM) { this.updateChildren(view, this.posAtStart); }
    this.dirty = NOT_DIRTY;
  };

  NodeViewDesc.prototype.updateOuterDeco = function updateOuterDeco (outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco)) { return }
    var needsWrap = this.nodeDOM.nodeType != 1;
    var oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM,
                              computeOuterDeco(this.outerDeco, this.node, needsWrap),
                              computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = null;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  };

  // Mark this node as being the selected node.
  NodeViewDesc.prototype.selectNode = function selectNode () {
    this.nodeDOM.classList.add("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.draggable = true; }
  };

  // Remove selected node marking from this node.
  NodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.nodeDOM.classList.remove("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.draggable = false; }
  };

  Object.defineProperties( NodeViewDesc.prototype, prototypeAccessors$3 );

  return NodeViewDesc;
}(ViewDesc));

// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc);
  return new NodeViewDesc(null, doc, outerDeco, innerDeco, dom, dom, dom, view, 0)
}

var TextViewDesc = /*@__PURE__*/(function (NodeViewDesc) {
  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view);
  }

  if ( NodeViewDesc ) TextViewDesc.__proto__ = NodeViewDesc;
  TextViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  TextViewDesc.prototype.constructor = TextViewDesc;

  TextViewDesc.prototype.parseRule = function parseRule () {
    return {skip: this.nodeDOM.parentNode || true}
  };

  TextViewDesc.prototype.update = function update (node, outerDeco) {
    if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
        !node.sameMarkup(this.node)) { return false }
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue)
      { this.nodeDOM.nodeValue = node.text; }
    this.node = node;
    this.dirty = NOT_DIRTY;
    return true
  };

  TextViewDesc.prototype.inParent = function inParent () {
    var parentDOM = this.parent.contentDOM;
    for (var n = this.nodeDOM; n; n = n.parentNode) { if (n == parentDOM) { return true } }
    return false
  };

  TextViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.nodeDOM, offset: pos}
  };

  TextViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    if (dom == this.nodeDOM) { return this.posAtStart + Math.min(offset, this.node.text.length) }
    return NodeViewDesc.prototype.localPosFromDOM.call(this, dom, offset, bias)
  };

  TextViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "characterData" && mutation.type != "selection"
  };

  TextViewDesc.prototype.slice = function slice (from, to, view) {
    var node = this.node.cut(from, to), dom = document.createTextNode(node.text);
    return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view)
  };

  return TextViewDesc;
}(NodeViewDesc));

// A dummy desc used to tag trailing BR or span nodes created to work
// around contentEditable terribleness.
var BRHackViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function BRHackViewDesc () {
    ViewDesc.apply(this, arguments);
  }

  if ( ViewDesc ) BRHackViewDesc.__proto__ = ViewDesc;
  BRHackViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  BRHackViewDesc.prototype.constructor = BRHackViewDesc;

  BRHackViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
  BRHackViewDesc.prototype.matchesHack = function matchesHack () { return this.dirty == NOT_DIRTY };

  return BRHackViewDesc;
}(ViewDesc));

// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
var CustomNodeViewDesc = /*@__PURE__*/(function (NodeViewDesc) {
  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    this.spec = spec;
  }

  if ( NodeViewDesc ) CustomNodeViewDesc.__proto__ = NodeViewDesc;
  CustomNodeViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  CustomNodeViewDesc.prototype.constructor = CustomNodeViewDesc;

  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  CustomNodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY) { return false }
    if (this.spec.update) {
      var result = this.spec.update(node, outerDeco);
      if (result) { this.updateInner(node, outerDeco, innerDeco, view); }
      return result
    } else if (!this.contentDOM && !node.isLeaf) {
      return false
    } else {
      return NodeViewDesc.prototype.update.call(this, node, outerDeco, innerDeco, view)
    }
  };

  CustomNodeViewDesc.prototype.selectNode = function selectNode () {
    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc.prototype.selectNode.call(this);
  };

  CustomNodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc.prototype.deselectNode.call(this);
  };

  CustomNodeViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, root)
      : NodeViewDesc.prototype.setSelection.call(this, anchor, head, root, force);
  };

  CustomNodeViewDesc.prototype.destroy = function destroy () {
    if (this.spec.destroy) { this.spec.destroy(); }
    NodeViewDesc.prototype.destroy.call(this);
  };

  CustomNodeViewDesc.prototype.stopEvent = function stopEvent (event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false
  };

  CustomNodeViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc.prototype.ignoreMutation.call(this, mutation)
  };

  return CustomNodeViewDesc;
}(NodeViewDesc));

// : (dom.Node, [ViewDesc])
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs) {
  var dom = parentDOM.firstChild;
  for (var i = 0; i < descs.length; i++) {
    var desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) { dom = rm(dom); }
      dom = dom.nextSibling;
    } else {
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) { dom = rm(dom); }
}

function OuterDecoLevel(nodeName) {
  if (nodeName) { this.nodeName = nodeName; }
}
OuterDecoLevel.prototype = Object.create(null);

var noDeco = [new OuterDecoLevel];

function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0) { return noDeco }

  var top = needsWrap ? noDeco[0] : new OuterDecoLevel, result = [top];

  for (var i = 0; i < outerDeco.length; i++) {
    var attrs = outerDeco[i].type.attrs, cur = top;
    if (!attrs) { continue }
    if (attrs.nodeName)
      { result.push(cur = new OuterDecoLevel(attrs.nodeName)); }

    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) { continue }
      if (needsWrap && result.length == 1)
        { result.push(cur = top = new OuterDecoLevel(node.isInline ? "span" : "div")); }
      if (name == "class") { cur.class = (cur.class ? cur.class + " " : "") + val; }
      else if (name == "style") { cur.style = (cur.style ? cur.style + ";" : "") + val; }
      else if (name != "nodeName") { cur[name] = val; }
    }
  }

  return result
}

function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  // Shortcut for trivial case
  if (prevComputed == noDeco && curComputed == noDeco) { return nodeDOM }

  var curDOM = nodeDOM;
  for (var i = 0; i < curComputed.length; i++) {
    var deco = curComputed[i], prev = prevComputed[i];
    if (i) {
      var parent = (void 0);
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
          (parent = nodeDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.appendChild(curDOM);
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM
}

function patchAttributes(dom, prev, cur) {
  for (var name in prev)
    { if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
      { dom.removeAttribute(name); } }
  for (var name$1 in cur)
    { if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1])
      { dom.setAttribute(name$1, cur[name$1]); } }
  if (prev.class != cur.class) {
    var prevList = prev.class ? prev.class.split(" ") : nothing;
    var curList = cur.class ? cur.class.split(" ") : nothing;
    for (var i = 0; i < prevList.length; i++) { if (curList.indexOf(prevList[i]) == -1)
      { dom.classList.remove(prevList[i]); } }
    for (var i$1 = 0; i$1 < curList.length; i$1++) { if (prevList.indexOf(curList[i$1]) == -1)
      { dom.classList.add(curList[i$1]); } }
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style))
        { dom.style[m[1].toLowerCase()] = ""; }
    }
    if (cur.style)
      { dom.style.cssText += cur.style; }
  }
}

function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1))
}

// : ([Decoration], [Decoration]) → bool
function sameOuterDeco(a, b) {
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++) { if (!a[i].type.eq(b[i].type)) { return false } }
  return true
}

// Remove a DOM node and return its next sibling.
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next
}

// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
var ViewTreeUpdater = function ViewTreeUpdater(top, lockedNode) {
  this.top = top;
  this.lock = lockedNode;
  // Index into `this.top`'s child array, represents the current
  // update position.
  this.index = 0;
  // When entering a mark, the current top and index are pushed
  // onto this.
  this.stack = [];
  // Tracks whether anything was changed
  this.changed = false;

  var pre = preMatch(top.node.content, top.children);
  this.preMatched = pre.nodes;
  this.preMatchOffset = pre.offset;
};

ViewTreeUpdater.prototype.getPreMatch = function getPreMatch (index) {
  return index >= this.preMatchOffset ? this.preMatched[index - this.preMatchOffset] : null
};

// Destroy and remove the children between the given indices in
// `this.top`.
ViewTreeUpdater.prototype.destroyBetween = function destroyBetween (start, end) {
  if (start == end) { return }
  for (var i = start; i < end; i++) { this.top.children[i].destroy(); }
  this.top.children.splice(start, end - start);
  this.changed = true;
};

// Destroy all remaining children in `this.top`.
ViewTreeUpdater.prototype.destroyRest = function destroyRest () {
  this.destroyBetween(this.index, this.top.children.length);
};

// : ([Mark], EditorView)
// Sync the current stack of mark descs with the given array of
// marks, reusing existing mark descs when possible.
ViewTreeUpdater.prototype.syncToMarks = function syncToMarks (marks, inline, view) {
  var keep = 0, depth = this.stack.length >> 1;
  var maxKeep = Math.min(depth, marks.length);
  while (keep < maxKeep &&
         (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
    { keep++; }

  while (keep < depth) {
    this.destroyRest();
    this.top.dirty = NOT_DIRTY;
    this.index = this.stack.pop();
    this.top = this.stack.pop();
    depth--;
  }
  while (depth < marks.length) {
    this.stack.push(this.top, this.index + 1);
    var found = -1;
    for (var i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
      if (this.top.children[i].matchesMark(marks[depth])) { found = i; break }
    }
    if (found > -1) {
      if (found > this.index) {
        this.changed = true;
        this.destroyBetween(this.index, found);
      }
      this.top = this.top.children[this.index];
    } else {
      var markDesc = MarkViewDesc.create(this.top, marks[depth], inline, view);
      this.top.children.splice(this.index, 0, markDesc);
      this.top = markDesc;
      this.changed = true;
    }
    this.index = 0;
    depth++;
  }
};

// : (Node, [Decoration], DecorationSet) → bool
// Try to find a node desc matching the given data. Skip over it and
// return true when successful.
ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch (node, outerDeco, innerDeco, index) {
  var found = -1, preMatch = index < 0 ? undefined : this.getPreMatch(index), children = this.top.children;
  if (preMatch && preMatch.matchesNode(node, outerDeco, innerDeco)) {
    found = children.indexOf(preMatch);
  } else {
    for (var i = this.index, e = Math.min(children.length, i + 5); i < e; i++) {
      var child = children[i];
      if (child.matchesNode(node, outerDeco, innerDeco) && this.preMatched.indexOf(child) < 0) {
        found = i;
        break
      }
    }
  }
  if (found < 0) { return false }
  this.destroyBetween(this.index, found);
  this.index++;
  return true
};

// : (Node, [Decoration], DecorationSet, EditorView, Fragment, number) → bool
// Try to update the next node, if any, to the given data. Checks
// pre-matches to avoid overwriting nodes that could still be used.
ViewTreeUpdater.prototype.updateNextNode = function updateNextNode (node, outerDeco, innerDeco, view, index) {
  if (this.index == this.top.children.length) { return false }
  var next = this.top.children[this.index];
  if (next instanceof NodeViewDesc) {
    var preMatch = this.preMatched.indexOf(next);
    if (preMatch > -1 && preMatch + this.preMatchOffset != index) { return false }
    var nextDOM = next.dom;

    // Can't update if nextDOM is or contains this.lock, except if
    // it's a text node whose content already matches the new text
    // and whose decorations match the new ones.
    var locked = this.lock && (nextDOM == this.lock || nextDOM.nodeType == 1 && nextDOM.contains(this.lock.parentNode)) &&
        !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text &&
          next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
    if (!locked && next.update(node, outerDeco, innerDeco, view)) {
      if (next.dom != nextDOM) { this.changed = true; }
      this.index++;
      return true
    }
  }
  return false
};

// : (Node, [Decoration], DecorationSet, EditorView)
// Insert the node as a newly created node desc.
ViewTreeUpdater.prototype.addNode = function addNode (node, outerDeco, innerDeco, view, pos) {
  this.top.children.splice(this.index++, 0, NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos));
  this.changed = true;
};

ViewTreeUpdater.prototype.placeWidget = function placeWidget (widget, view, pos) {
  if (this.index < this.top.children.length && this.top.children[this.index].matchesWidget(widget)) {
    this.index++;
  } else {
    var desc = new WidgetViewDesc(this.top, widget, view, pos);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
};

// Make sure a textblock looks and behaves correctly in
// contentEditable.
ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks () {
  var lastChild = this.top.children[this.index - 1];
  while (lastChild instanceof MarkViewDesc) { lastChild = lastChild.children[lastChild.children.length - 1]; }

  if (!lastChild || // Empty textblock
      !(lastChild instanceof TextViewDesc) ||
      /\n$/.test(lastChild.node.text)) {
    if (this.index < this.top.children.length && this.top.children[this.index].matchesHack()) {
      this.index++;
    } else {
      var dom = document.createElement("br");
      this.top.children.splice(this.index++, 0, new BRHackViewDesc(this.top, nothing, dom, null));
      this.changed = true;
    }
  }
};

// : (Fragment, [ViewDesc]) → [ViewDesc]
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing
// those for other nodes. Returns an array whose positions correspond
// to node positions in the fragment, and whose elements are either
// descs matched to the child at that index, or empty.
function preMatch(frag, descs) {
  var result = [], end = frag.childCount;
  for (var i = descs.length - 1; end > 0 && i >= 0; i--) {
    var desc = descs[i], node = desc.node;
    if (!node) { continue }
    if (node != frag.child(end - 1)) { break }
    result.push(desc);
    --end;
  }
  return {nodes: result.reverse(), offset: end}
}

function compareSide(a, b) { return a.type.side - b.type.side }

// : (ViewDesc, DecorationSet, (Decoration, number), (Node, [Decoration], DecorationSet, number))
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
  var locals = deco.locals(parent), offset = 0;
  // Simple, cheap variant for when there are no local decorations
  if (locals.length == 0) {
    for (var i = 0; i < parent.childCount; i++) {
      var child = parent.child(i);
      onNode(child, locals, deco.forChild(offset, child), i);
      offset += child.nodeSize;
    }
    return
  }

  var decoIndex = 0, active = [], restNode = null;
  for (var parentIndex = 0;;) {
    if (decoIndex < locals.length && locals[decoIndex].to == offset) {
      var widget = locals[decoIndex++], widgets = (void 0);
      while (decoIndex < locals.length && locals[decoIndex].to == offset)
        { (widgets || (widgets = [widget])).push(locals[decoIndex++]); }
      if (widgets) {
        widgets.sort(compareSide);
        for (var i$1 = 0; i$1 < widgets.length; i$1++) { onWidget(widgets[i$1], parentIndex); }
      } else {
        onWidget(widget, parentIndex);
      }
    }

    var child$1 = (void 0), index = (void 0);
    if (restNode) {
      index = -1;
      child$1 = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      index = parentIndex;
      child$1 = parent.child(parentIndex++);
    } else {
      break
    }

    for (var i$2 = 0; i$2 < active.length; i$2++) { if (active[i$2].to <= offset) { active.splice(i$2--, 1); } }
    while (decoIndex < locals.length && locals[decoIndex].from == offset) { active.push(locals[decoIndex++]); }

    var end = offset + child$1.nodeSize;
    if (child$1.isText) {
      var cutAt = end;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) { cutAt = locals[decoIndex].from; }
      for (var i$3 = 0; i$3 < active.length; i$3++) { if (active[i$3].to < cutAt) { cutAt = active[i$3].to; } }
      if (cutAt < end) {
        restNode = child$1.cut(cutAt - offset);
        child$1 = child$1.cut(0, cutAt - offset);
        end = cutAt;
        index = -1;
      }
    }

    onNode(child$1, active.length ? active.slice() : nothing, deco.forChild(offset, child$1), index);
    offset = end;
  }
}

// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}

function nearbyTextNode(node, offset) {
  for (;;) {
    if (node.nodeType == 3) { return node }
    if (node.nodeType == 1 && offset > 0) {
      if (node.childNodes.length > offset && node.childNodes[offset].nodeType == 3)
        { return node.childNodes[offset] }
      node = node.childNodes[offset - 1];
      offset = nodeSize(node);
    } else if (node.nodeType == 1 && offset < node.childNodes.length) {
      node = node.childNodes[offset];
      offset = 0;
    } else {
      return null
    }
  }
}

// Find a piece of text in an inline fragment, overlapping from-to
function findTextInFragment(frag, text, from, to) {
  for (var str = "", i = 0, childPos = 0; i < frag.childCount; i++) {
    var child = frag.child(i), end = childPos + child.nodeSize;
    if (child.isText) {
      str += child.text;
      if (end >= to) {
        var strStart = end - str.length, found = str.lastIndexOf(text);
        while (found > -1 && strStart + found > from) { found = str.lastIndexOf(text, found - 1); }
        if (found > -1 && strStart + found + text.length >= to) {
          return strStart + found
        } else if (end > to) {
          break
        }
      }
    } else {
      str = "";
    }
    childPos = end;
  }
  return -1
}

// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function replaceNodes(nodes, from, to, view, replacement) {
  var result = [];
  for (var i = 0, off = 0; i < nodes.length; i++) {
    var child = nodes[i], start = off, end = off += child.size;
    if (start >= to || end <= from) {
      result.push(child);
    } else {
      if (start < from) { result.push(child.slice(0, from - start, view)); }
      if (replacement) {
        result.push(replacement);
        replacement = null;
      }
      if (end > to) { result.push(child.slice(to - start, child.size, view)); }
    }
  }
  return result
}

function moveSelectionBlock(state, dir) {
  var ref = state.selection;
  var $anchor = ref.$anchor;
  var $head = ref.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].findFrom($start, dir)
}

function apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true
}

function selectHorizontally(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) {
    if (!sel.empty || mods.indexOf("s") > -1) {
      return false
    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && (next instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"])) { return apply(view, next) }
      return false
    } else {
      var $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (!node || node.isText) { return false }
      var nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
      if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) { return false }
      if (__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].isSelectable(node)) {
        return apply(view, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"](dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head))
      } else if (result.webkit) {
        // Chrome and Safari will introduce extra pointless cursor
        // positions around inline uneditable nodes, so we have to
        // take over and move the cursor past them (#937)
        return apply(view, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"](view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)))
      } else {
        return false
      }
    }
  } else if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] && sel.node.isInline) {
    return apply(view, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"](dir > 0 ? sel.$to : sel.$from))
  } else {
    var next$1 = moveSelectionBlock(view.state, dir);
    if (next$1) { return apply(view, next$1) }
    return false
  }
}

function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isIgnorable(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR")
}

// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesLeft(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var moveNode, moveOffset, force = false;
  // Gecko will do odd things when the selection is directly in front
  // of a non-editable node, so in that case, move it into the next
  // node if possible. Issue prosemirror/prosemirror#832.
  if (result.gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset])) { force = true; }
  for (;;) {
    if (offset > 0) {
      if (node.nodeType != 1) {
        break
      } else {
        var before = node.childNodes[offset - 1];
        if (isIgnorable(before)) {
          moveNode = node;
          moveOffset = --offset;
        } else if (before.nodeType == 3) {
          node = before;
          offset = node.nodeValue.length;
        } else { break }
      }
    } else if (isBlockNode(node)) {
      break
    } else {
      var prev = node.previousSibling;
      while (prev && isIgnorable(prev)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = 0;
      } else {
        node = prev;
        offset = nodeLen(node);
      }
    }
  }
  if (force) { setSelFocus(view, sel, node, offset); }
  else if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesRight(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var len = nodeLen(node);
  var moveNode, moveOffset;
  for (;;) {
    if (offset < len) {
      if (node.nodeType != 1) { break }
      var after = node.childNodes[offset];
      if (isIgnorable(after)) {
        moveNode = node;
        moveOffset = ++offset;
      }
      else { break }
    } else if (isBlockNode(node)) {
      break
    } else {
      var next = node.nextSibling;
      while (next && isIgnorable(next)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = len = 0;
      } else {
        node = next;
        offset = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

function setSelFocus(view, sel, node, offset) {
  if (selectionCollapsed(sel)) {
    var range = document.createRange();
    range.setEnd(node, offset);
    range.setStart(node, offset);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset);
  }
  view.domObserver.setCurSelection();
}

// : (EditorState, number)
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"] && !sel.empty || mods.indexOf("s") > -1) { return false }
  var $from = sel.$from;
  var $to = sel.$to;

  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && (next instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"]))
      { return apply(view, next) }
  }
  if (!$from.parent.inlineContent) {
    var beyond = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].findFrom(dir < 0 ? $from : $to, dir);
    return beyond ? apply(view, beyond) : true
  }
  return false
}

function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"])) { return true }
  var ref = view.state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var empty = ref.empty;
  if (!$head.sameParent($anchor)) { return true }
  if (!empty) { return false }
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) { return true }
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) { tr.delete($head.pos - nextNode.nodeSize, $head.pos); }
    else { tr.delete($head.pos, $head.pos + nextNode.nodeSize); }
    view.dispatch(tr);
    return true
  }
  return false
}

function switchEditable(view, node, state) {
  view.domObserver.stop();
  node.contentEditable = state;
  view.domObserver.start();
}

// Issue #867 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Chrome does really wrong things when the down arrow is
// pressed when the cursor is directly at the start of a textblock and
// has an uneditable node after it
function chromeDownArrowBug(view) {
  if (!result.chrome || view.state.selection.$head.parentOffset > 0) { return }
  var ref = view.root.getSelection();
  var focusNode = ref.focusNode;
  var focusOffset = ref.focusOffset;
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
      focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    var child = focusNode.firstChild;
    switchEditable(view, child, true);
    setTimeout(function () { return switchEditable(view, child, false); }, 20);
  }
}

// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.

function getMods(event) {
  var result = "";
  if (event.ctrlKey) { result += "c"; }
  if (event.metaKey) { result += "m"; }
  if (event.altKey) { result += "a"; }
  if (event.shiftKey) { result += "s"; }
  return result
}

function captureKeyDown(view, event) {
  var code = event.keyCode, mods = getMods(event);
  if (code == 8 || (result.mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 46 || (result.mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 13 || code == 27) { // Enter, Esc
    return true
  } else if (code == 37) { // Left arrow
    return selectHorizontally(view, -1, mods) || skipIgnoredNodesLeft(view)
  } else if (code == 39) { // Right arrow
    return selectHorizontally(view, 1, mods) || skipIgnoredNodesRight(view)
  } else if (code == 38) { // Up arrow
    return selectVertically(view, -1, mods) || skipIgnoredNodesLeft(view)
  } else if (code == 40) { // Down arrow
    return chromeDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodesRight(view)
  } else if (mods == (result.mac ? "m" : "c") &&
             (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
    return true
  }
  return false
}

function selectionFromDOM(view, origin) {
  var domSel = view.root.getSelection(), doc = view.state.doc;
  var nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
  var head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
  var $head = doc.resolve(head), $anchor, selection;
  if (selectionCollapsed(domSel)) {
    $anchor = $head;
    while (nearestDesc && !nearestDesc.node) { nearestDesc = nearestDesc.parent; }
    if (nearestDesc && nearestDesc.node.isAtom && __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].isSelectable(nearestDesc.node) && nearestDesc.parent) {
      var pos = nearestDesc.posBefore;
      selection = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"](head == pos ? $head : doc.resolve(pos));
    }
  } else {
    $anchor = doc.resolve(view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset));
  }

  if (!selection) {
    var bias = origin == "pointer" || (view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection
}

function selectionToDOM(view, force) {
  var sel = view.state.selection;
  syncNodeSelection(view, sel);

  if (view.editable ? !view.hasFocus() : !(hasSelection(view) && document.activeElement.contains(view.dom))) { return }

  view.domObserver.disconnectSelection();

  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor;
    var head = sel.head;
    var resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"])) {
      if (!sel.$from.parent.inlineContent)
        { resetEditableFrom = temporarilyEditableNear(view, sel.from); }
      if (!sel.empty && !sel.$from.parent.inlineContent)
        { resetEditableTo = temporarilyEditableNear(view, sel.to); }
    }
    view.docView.setSelection(anchor, head, view.root, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) { resetEditableFrom.contentEditable = "false"; }
      if (resetEditableTo) { resetEditableTo.contentEditable = "false"; }
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else if (anchor != head) {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) { removeClassOnSelectionChange(view); }
    }
  }

  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}

// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.

var brokenSelectBetweenUneditable = result.safari || result.chrome && result.chrome_version < 63;

function temporarilyEditableNear(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;
  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
  var before = offset ? node.childNodes[offset - 1] : null;
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after) {
      after.contentEditable = "true";
      return after
    } else if (before) {
      before.contentEditable = "true";
      return before
    }
  }
}

function removeClassOnSelectionChange(view) {
  var doc = view.dom.ownerDocument;
  doc.removeEventListener("selectionchange", view.hideSelectionGuard);
  var domSel = view.root.getSelection();
  var node = domSel.anchorNode, offset = domSel.anchorOffset;
  doc.addEventListener("selectionchange", view.hideSelectionGuard = function () {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
      doc.removeEventListener("selectionchange", view.hideSelectionGuard);
      view.dom.classList.remove("ProseMirror-hideselection");
    }
  });
}

function selectCursorWrapper(view) {
  var domSel = view.root.getSelection(), range = document.createRange();
  var node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
  if (img) { range.setEnd(node.parentNode, domIndex(node) + 1); }
  else { range.setEnd(node, 0); }
  range.collapse(false);
  domSel.removeAllRanges();
  domSel.addRange(range);
  // Kludge to kill 'control selection' in IE11 when selecting an
  // invisible cursor wrapper, since that would result in those weird
  // resize handles and a selection that considers the absolutely
  // positioned wrapper, rather than the root editable node, the
  // focused element.
  if (!img && !view.state.selection.visible && result.ie && result.ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}

function syncNodeSelection(view, sel) {
  if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"]) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) { desc.selectNode(); }
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}

// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent)
      { view.lastSelectedViewDesc.deselectNode(); }
    view.lastSelectedViewDesc = null;
  }
}

function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function (f) { return f(view, $anchor, $head); })
    || __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].between($anchor, $head, bias)
}

function hasFocusAndSelection(view) {
  if (view.editable && view.root.activeElement != view.dom) { return false }
  return hasSelection(view)
}

function hasSelection(view) {
  var sel = view.root.getSelection();
  if (!sel.anchorNode) { return false }
  try {
    // Firefox will raise 'permission denied' errors when accessing
    // properties of `sel.anchorNode` when it's in a generated CSS
    // element.
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
      (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode))
  } catch(_) {
    return false
  }
}

function anchorInRightPlace(view) {
  var anchorDOM = view.docView.domFromPos(view.state.selection.anchor);
  var domSel = view.root.getSelection();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset)
}

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.

function parseBetween(view, from_, to_) {
  var ref = view.docView.parseRange(from_, to_);
  var parent = ref.node;
  var fromOffset = ref.fromOffset;
  var toOffset = ref.toOffset;
  var from = ref.from;
  var to = ref.to;

  var domSel = view.root.getSelection(), find = null, anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find = [{node: anchor, offset: domSel.anchorOffset}];
    if (!selectionCollapsed(domSel))
      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}); }
  }
  // Work around issue in Chrome where backspacing sometimes replaces
  // the deleted content with a random BR node (issues #799, #831)
  if (result.chrome && view.lastKeyCode === 8) {
    for (var off = toOffset; off > fromOffset; off--) {
      var node = parent.childNodes[off - 1], desc = node.pmViewDesc;
      if (node.nodeType == "BR" && !desc) { toOffset = off; break }
      if (!desc || desc.size) { break }
    }
  }
  var startDoc = view.state.doc;
  var parser = view.someProp("domParser") || __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["DOMParser"].fromSchema(view.state.schema);
  var $from = startDoc.resolve(from);

  var sel = null, doc = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.spec.code ? "full" : true,
    editableContent: true,
    findPositions: find,
    ruleFromNode: ruleFromNode(parser, $from),
    context: $from
  });
  if (find && find[0].pos != null) {
    var anchor$1 = find[0].pos, head = find[1] && find[1].pos;
    if (head == null) { head = anchor$1; }
    sel = {anchor: anchor$1 + from, head: head + from};
  }
  return {doc: doc, sel: sel, from: from, to: to}
}

function ruleFromNode(parser, context) {
  return function (dom) {
    var desc = dom.pmViewDesc;
    if (desc) {
      return desc.parseRule()
    } else if (dom.nodeName == "BR" && dom.parentNode) {
      // Safari replaces the list item or table cell with a BR
      // directly in the list node (?!) if you delete the last
      // character in a list item or table cell (#708, #862)
      if (result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName))
        { return parser.matchTag(document.createElement("li"), context) }
      else if (dom.parentNode.lastChild == dom || result.safari && /^(tr|table)$/i.test(dom.parentNode.nodeName))
        { return {ignore: true} }
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
      return {ignore: true}
    }
  }
}

function readDOMChange(view, from, to, typeOver) {
  if (from < 0) {
    var origin = view.lastSelectionTime > Date.now() - 50 ? view.lastSelectionOrigin : null;
    var newSel = selectionFromDOM(view, origin);
    if (!view.state.selection.eq(newSel)) {
      var tr$1 = view.state.tr.setSelection(newSel);
      if (origin == "pointer") { tr$1.setMeta("pointer", true); }
      else if (origin == "key") { tr$1.scrollIntoView(); }
      view.dispatch(tr$1);
    }
    return
  }

  var $before = view.state.doc.resolve(from);
  var shared = $before.sharedDepth(to);
  from = $before.before(shared + 1);
  to = view.state.doc.resolve(to).after(shared + 1);

  var sel = view.state.selection;
  var parse = parseBetween(view, from, to);

  var doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
  var preferredPos, preferredSide;
  // Prefer anchoring to end when Backspace is pressed
  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.lastKeyCode = null;

  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
  if (!change) {
    if (typeOver && sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"] && !sel.empty && sel.$head.sameParent(sel.$anchor) &&
        !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) {
      change = {start: sel.from, endA: sel.to, endB: sel.to};
    } else {
      if (parse.sel) {
        var sel$1 = resolveSelection(view, view.state.doc, parse.sel);
        if (sel$1 && !sel$1.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel$1)); }
      }
      return
    }
  }
  view.domChangeCount++;
  // Handle the case where overwriting a selection by typing matches
  // the start or end of the selected content, creating a change
  // that's smaller than what was actually overwritten.
  if (view.state.selection.from < view.state.selection.to &&
      change.start == change.endB &&
      view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2) {
      change.endB += (view.state.selection.to - change.endA);
      change.endA = view.state.selection.to;
    }
  }

  // IE11 will insert a non-breaking space _ahead_ of the space after
  // the cursor space when adding a space before another space. When
  // that happened, adjust the change to cover the space instead.
  if (result.ie && result.ie_version <= 11 && change.endB == change.start + 1 &&
      change.endA == change.start && change.start > parse.from &&
      parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
    change.start--;
    change.endA--;
    change.endB--;
  }

  var $from = parse.doc.resolveNoCache(change.start - parse.from);
  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
  var nextSel;
  // If this looks like the effect of pressing Enter, just dispatch an
  // Enter key instead.
  if (!$from.sameParent($to) && $from.pos < parse.doc.content.size &&
      (nextSel = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
      nextSel.head == $to.pos &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); }))
    { return }
  // Same for backspace
  if (view.state.selection.anchor > change.start &&
      looksLikeJoin(doc, change.start, change.endA, $from, $to) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) {
    if (result.android && result.chrome) { view.domObserver.suppressSelectionUpdates(); } // #820
    return
  }

  var chFrom = change.start, chTo = change.endA;

  var tr, storedMarks, markChange, $from1;
  if ($from.sameParent($to) && $from.parent.inlineContent) {
    if ($from.pos == $to.pos) { // Deletion
      // IE11 sometimes weirdly moves the DOM selection around after
      // backspacing out the first element in a textblock
      if (result.ie && result.ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(function () { return selectionToDOM(view); }, 20);
      }
      tr = view.state.tr.delete(chFrom, chTo);
      storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
    } else if ( // Adding or removing a mark
      change.endA == change.endB && ($from1 = doc.resolve(change.start)) &&
      (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset),
                                 $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))
    ) {
      tr = view.state.tr;
      if (markChange.type == "add") { tr.addMark(chFrom, chTo, markChange.mark); }
      else { tr.removeMark(chFrom, chTo, markChange.mark); }
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      // Both positions in the same text node -- simply insert text
      var text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      if (view.someProp("handleTextInput", function (f) { return f(view, chFrom, chTo, text); })) { return }
      tr = view.state.tr.insertText(text, chFrom, chTo);
    }
  }

  if (!tr)
    { tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from)); }
  if (parse.sel) {
    var sel$2 = resolveSelection(view, tr.doc, parse.sel);
    // Chrome Android will sometimes, during composition, report the
    // selection in the wrong place. If it looks like that is
    // happening, don't update the selection.
    // Edge just doesn't move the cursor forward when you start typing
    // in an empty block or between br nodes.
    if (sel$2 && !(result.chrome && result.android && view.composing && sel$2.empty && sel$2.head == chFrom ||
                 result.ie && sel$2.empty && sel$2.head == chFrom))
      { tr.setSelection(sel$2); }
  }
  if (storedMarks) { tr.ensureMarks(storedMarks); }
  view.dispatch(tr.scrollIntoView());
}

function resolveSelection(view, doc, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) { return null }
  return selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head))
}

// : (Fragment, Fragment) → ?{mark: Mark, type: string}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  var added = curMarks, removed = prevMarks, type, mark, update;
  for (var i = 0; i < prevMarks.length; i++) { added = prevMarks[i].removeFromSet(added); }
  for (var i$1 = 0; i$1 < curMarks.length; i$1++) { removed = curMarks[i$1].removeFromSet(removed); }
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = function (node) { return node.mark(mark.addToSet(node.marks)); };
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = function (node) { return node.mark(mark.removeFromSet(node.marks)); };
  } else {
    return null
  }
  var updated = [];
  for (var i$2 = 0; i$2 < prev.childCount; i$2++) { updated.push(update(prev.child(i$2))); }
  if (__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(updated).eq(cur)) { return {mark: mark, type: type} }
}

function looksLikeJoin(old, start, end, $newStart, $newEnd) {
  if (!$newStart.parent.isTextblock ||
      // The content must have shrunk
      end - start <= $newEnd.pos - $newStart.pos ||
      // newEnd must point directly at or after the end of the block that newStart points into
      skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
    { return false }

  var $start = old.resolve(start);
  // Start must be at the end of a block
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    { return false }
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  // The next textblock must start before end and end near it
  if (!$next.parent.isTextblock || $next.pos > end ||
      skipClosingAndOpening($next, true, false) < end)
    { return false }

  // The fragments after the join point must match
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content)
}

function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end++;
    }
  }
  return end
}

function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start = a.findDiffStart(b, pos);
  if (start == null) { return null }
  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref.a;
  var endB = ref.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start - Math.min(endA, endB));
    preferredPos -= endA + adjust - start;
  }
  if (endA < start && a.size < b.size) {
    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
    start -= move;
    endB = start + (endB - endA);
    endA = start;
  } else if (endB < start) {
    var move$1 = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
    start -= move$1;
    endA = start + (endA - endB);
    endB = start;
  }
  return {start: start, endA: endA, endB: endB}
}

function serializeForClipboard(view, slice) {
  var context = [];
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node = content.firstChild;
    context.push(node.type.name, node.type.hasRequiredAttrs() ? node.attrs : null);
    content = node.content;
  }

  var serializer = view.someProp("clipboardSerializer") || __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["DOMSerializer"].fromSchema(view.state.schema);
  var doc = detachedDoc(), wrap = doc.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content, {document: doc}));

  var firstChild = wrap.firstChild, needsWrap;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i = needsWrap.length - 1; i >= 0; i--) {
      var wrapper = doc.createElement(needsWrap[i]);
      while (wrap.firstChild) { wrapper.appendChild(wrap.firstChild); }
      wrap.appendChild(wrapper);
    }
    firstChild = wrap.firstChild;
  }

  if (firstChild && firstChild.nodeType == 1)
    { firstChild.setAttribute("data-pm-slice", (openStart + " " + openEnd + " " + (JSON.stringify(context)))); }

  var text = view.someProp("clipboardTextSerializer", function (f) { return f(slice); }) ||
      slice.content.textBetween(0, slice.content.size, "\n\n");

  return {dom: wrap, text: text}
}

// : (EditorView, string, string, ?bool, ResolvedPos) → ?Slice
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
  var dom, inCode = $context.parent.type.spec.code, slice;
  if (!html && !text) { return null }
  var asText = text && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", function (f) { text = f(text); });
    if (inCode) { return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(view.state.schema.text(text)), 0, 0) }
    var parsed = view.someProp("clipboardTextParser", function (f) { return f(text, $context); });
    if (parsed) {
      slice = parsed;
    } else {
      dom = document.createElement("div");
      text.trim().split(/(?:\r\n?|\n)+/).forEach(function (block) {
        dom.appendChild(document.createElement("p")).textContent = block;
      });
    }
  } else {
    view.someProp("transformPastedHTML", function (f) { html = f(html); });
    dom = readHTML(html);
  }

  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
  if (!slice) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["DOMParser"].fromSchema(view.state.schema);
    slice = parser.parseSlice(dom, {preserveWhitespace: !!(asText || sliceData), context: $context});
  }
  if (sliceData)
    { slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[3]); }
  else // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
    { slice = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"].maxOpen(normalizeSiblings(slice.content, $context), false); }

  view.someProp("transformPasted", function (f) { slice = f(slice); });
  return slice
}

// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) { return fragment }
  var loop = function ( d ) {
    var parent = $context.node(d);
    var match = parent.contentMatchAt($context.index(d));
    var lastWrap = (void 0), result = [];
    fragment.forEach(function (node) {
      if (!result) { return }
      var wrap = match.findWrapping(node.type), inLast;
      if (!wrap) { return result = null }
      if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length) { result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length); }
        var wrapped = withWrappers(node, wrap);
        result.push(wrapped);
        match = match.matchType(wrapped.type, wrapped.attrs);
        lastWrap = wrap;
      }
    });
    if (result) { return { v: __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(result) } }
  };

  for (var d = $context.depth; d >= 0; d--) {
    var returned = loop( d );

    if ( returned ) return returned.v;
  }
  return fragment
}

function withWrappers(node, wrap, from) {
  if ( from === void 0 ) from = 0;

  for (var i = wrap.length - 1; i >= from; i--)
    { node = wrap[i].create(null, __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(node)); }
  return node
}

// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner) { return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner)) }
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
      { return sibling.copy(sibling.content.append(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(withWrappers(node, wrap, depth + 1)))) }
  }
}

function closeRight(node, depth) {
  if (depth == 0) { return node }
  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  var fill = node.contentMatchAt(node.childCount).fillBefore(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty, true);
  return node.copy(fragment.append(fill))
}

function closeRange(fragment, side, from, to, depth, openEnd) {
  var node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
  if (depth < to - 1) { inner = closeRange(inner, side, from, to, depth + 1, openEnd); }
  if (depth >= from)
    { inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, fragment.childCount > 1 || openEnd <= depth).append(inner)
      : inner.append(node.contentMatchAt(node.childCount).fillBefore(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty, true)); }
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner))
}

function closeSlice(slice, openStart, openEnd) {
  if (openStart < slice.openStart)
    { slice = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd); }
  if (openEnd < slice.openEnd)
    { slice = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd); }
  return slice
}

// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
var wrapMap = {thead: ["table"], colgroup: ["table"], col: ["table", "colgroup"],
                 tr: ["table", "tbody"], td: ["table", "tbody", "tr"], th: ["table", "tbody", "tr"]};

var _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"))
}

function readHTML(html) {
  var metas = /(\s*<meta [^>]*>)*/.exec(html);
  if (metas) { html = html.slice(metas[0].length); }
  var elt = detachedDoc().createElement("div");
  var firstTag = /(?:<meta [^>]*>)*<([a-z][^>\s]+)/i.exec(html), wrap, depth = 0;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) {
    html = wrap.map(function (n) { return "<" + n + ">"; }).join("") + html + wrap.map(function (n) { return "</" + n + ">"; }).reverse().join("");
    depth = wrap.length;
  }
  elt.innerHTML = html;
  for (var i = 0; i < depth; i++) { elt = elt.firstChild; }
  return elt
}

function addContext(slice, context) {
  if (!slice.size) { return slice }
  var schema = slice.content.firstChild.type.schema, array;
  try { array = JSON.parse(context); }
  catch(e) { return slice }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  for (var i = array.length - 2; i >= 0; i -= 2) {
    var type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs()) { break }
    content = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(type.create(array[i + 1], content));
    openStart++; openEnd++;
  }
  return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](content, openStart, openEnd)
}

var observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
var useCharData = result.ie && result.ie_version <= 11;

var SelectionState = function SelectionState() {
  this.anchorNode = this.anchorOffset = this.focusNode = this.focusOffset = null;
};

SelectionState.prototype.set = function set (sel) {
  this.anchorNode = sel.anchorNode; this.anchorOffset = sel.anchorOffset;
  this.focusNode = sel.focusNode; this.focusOffset = sel.focusOffset;
};

SelectionState.prototype.eq = function eq (sel) {
  return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset &&
    sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset
};

var DOMObserver = function DOMObserver(view, handleDOMChange) {
  var this$1 = this;

  this.view = view;
  this.handleDOMChange = handleDOMChange;
  this.queue = [];
  this.flushingSoon = false;
  this.observer = window.MutationObserver &&
    new window.MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) { this$1.queue.push(mutations[i]); }
      // IE11 will sometimes (on backspacing out a single character
      // text node after a BR node) call the observer callback
      // before actually updating the DOM, which will cause
      // ProseMirror to miss the change (see #930)
      if (result.ie && result.ie_version <= 11 && mutations.some(
        function (m) { return m.type == "childList" && m.removedNodes.length ||
             m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length; }))
        { this$1.flushSoon(); }
      else
        { this$1.flush(); }
    });
  this.currentSelection = new SelectionState;
  if (useCharData) {
    this.onCharData = function (e) {
      this$1.queue.push({target: e.target, type: "characterData", oldValue: e.prevValue});
      this$1.flushSoon();
    };
  }
  this.onSelectionChange = this.onSelectionChange.bind(this);
  this.suppressingSelectionUpdates = false;
};

DOMObserver.prototype.flushSoon = function flushSoon () {
    var this$1 = this;

  if (!this.flushingSoon) {
    this.flushingSoon = true;
    window.setTimeout(function () { this$1.flushingSoon = false; this$1.flush(); }, 20);
  }
};

DOMObserver.prototype.start = function start () {
  if (this.observer)
    { this.observer.observe(this.view.dom, observeOptions); }
  if (useCharData)
    { this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData); }
  this.connectSelection();
};

DOMObserver.prototype.stop = function stop () {
    var this$1 = this;

  if (this.observer) {
    var take = this.observer.takeRecords();
    if (take.length) {
      for (var i = 0; i < take.length; i++) { this.queue.push(take[i]); }
      window.setTimeout(function () { return this$1.flush(); }, 20);
    }
    this.observer.disconnect();
  }
  if (useCharData) { this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData); }
  this.disconnectSelection();
};

DOMObserver.prototype.connectSelection = function connectSelection () {
  this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
};

DOMObserver.prototype.disconnectSelection = function disconnectSelection () {
  this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
};

DOMObserver.prototype.suppressSelectionUpdates = function suppressSelectionUpdates () {
    var this$1 = this;

  this.suppressingSelectionUpdates = true;
  setTimeout(function () { return this$1.suppressingSelectionUpdates = false; }, 50);
};

DOMObserver.prototype.onSelectionChange = function onSelectionChange () {
  if (!hasFocusAndSelection(this.view)) { return }
  if (this.suppressingSelectionUpdates) { return selectionToDOM(this.view) }
  // Deletions on IE11 fire their events in the wrong order, giving
  // us a selection change event before the DOM changes are
  // reported.
  if (result.ie && result.ie_version <= 11 && !this.view.state.selection.empty) {
    var sel = this.view.root.getSelection();
    // Selection.isCollapsed isn't reliable on IE
    if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
      { return this.flushSoon() }
  }
  this.flush();
};

DOMObserver.prototype.setCurSelection = function setCurSelection () {
  this.currentSelection.set(this.view.root.getSelection());
};

DOMObserver.prototype.ignoreSelectionChange = function ignoreSelectionChange (sel) {
  if (sel.rangeCount == 0) { return true }
  var container = sel.getRangeAt(0).commonAncestorContainer;
  var desc = this.view.docView.nearestDesc(container);
  return desc && desc.ignoreMutation({type: "selection", target: container.nodeType == 3 ? container.parentNode : container})
};

DOMObserver.prototype.flush = function flush () {
  if (!this.view.docView || this.flushingSoon) { return }
  var mutations = this.observer ? this.observer.takeRecords() : [];
  if (this.queue.length) {
    mutations = this.queue.concat(mutations);
    this.queue.length = 0;
  }

  var sel = this.view.root.getSelection();
  var newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasSelection(this.view) && !this.ignoreSelectionChange(sel);

  var from = -1, to = -1, typeOver = false, added = [];
  if (this.view.editable) {
    for (var i = 0; i < mutations.length; i++) {
      var result = this.registerMutation(mutations[i], added);
      if (result) {
        from = from < 0 ? result.from : Math.min(result.from, from);
        to = to < 0 ? result.to : Math.max(result.to, to);
        if (result.typeOver && !this.view.composing) { typeOver = true; }
      }
    }
  }

  if (from > -1 || newSel) {
    if (from > -1) {
      this.view.docView.markDirty(from, to);
      checkCSS(this.view);
    }
    this.handleDOMChange(from, to, typeOver);
    if (this.view.docView.dirty) { this.view.updateState(this.view.state); }
    else if (!this.currentSelection.eq(sel)) { selectionToDOM(this.view); }
  }
};

DOMObserver.prototype.registerMutation = function registerMutation (mut, added) {
  // Ignore mutations inside nodes that were already noted as inserted
  if (added.indexOf(mut.target) > -1) { return null }
  var desc = this.view.docView.nearestDesc(mut.target);
  if (mut.type == "attributes" &&
      (desc == this.view.docView || mut.attributeName == "contenteditable" ||
       // Firefox sometimes fires spurious events for null/empty styles
       (mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))))
    { return null }
  if (!desc || desc.ignoreMutation(mut)) { return null }

  if (mut.type == "childList") {
    var prev = mut.previousSibling, next = mut.nextSibling;
    if (result.ie && result.ie_version <= 11 && mut.addedNodes.length) {
      // IE11 gives us incorrect next/prev siblings for some
      // insertions, so if there are added nodes, recompute those
      for (var i = 0; i < mut.addedNodes.length; i++) {
        var ref = mut.addedNodes[i];
          var previousSibling = ref.previousSibling;
          var nextSibling = ref.nextSibling;
        if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) { prev = previousSibling; }
        if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) { next = nextSibling; }
      }
    }
    var fromOffset = prev && prev.parentNode == mut.target
        ? domIndex(prev) + 1 : 0;
    var from = desc.localPosFromDOM(mut.target, fromOffset, -1);
    var toOffset = next && next.parentNode == mut.target
        ? domIndex(next) : mut.target.childNodes.length;
    for (var i$1 = 0; i$1 < mut.addedNodes.length; i$1++) { added.push(mut.addedNodes[i$1]); }
    var to = desc.localPosFromDOM(mut.target, toOffset, 1);
    return {from: from, to: to}
  } else if (mut.type == "attributes") {
    return {from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border}
  } else { // "characterData"
    return {
      from: desc.posAtStart,
      to: desc.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: mut.target.nodeValue == mut.oldValue
    }
  }
};

var cssChecked = false;

function checkCSS(view) {
  if (cssChecked) { return }
  cssChecked = true;
  if (getComputedStyle(view.dom).whiteSpace == "normal")
    { console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."); }
}

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
var handlers = {}, editHandlers = {};

function initInput(view) {
  view.shiftKey = false;
  view.mouseDown = null;
  view.lastKeyCode = null;
  view.lastKeyCodeTime = 0;
  view.lastClick = {time: 0, x: 0, y: 0, type: ""};
  view.lastSelectionOrigin = null;
  view.lastSelectionTime = 0;

  view.composing = false;
  view.composingTimeout = null;
  view.compositionNodes = [];
  view.compositionEndedAt = -2e8;

  view.domObserver = new DOMObserver(view, function (from, to, typeOver) { return readDOMChange(view, from, to, typeOver); });
  view.domObserver.start();
  // Used by hacks like the beforeinput handler to check whether anything happened in the DOM
  view.domChangeCount = 0;

  view.eventHandlers = Object.create(null);
  var loop = function ( event ) {
    var handler = handlers[event];
    view.dom.addEventListener(event, view.eventHandlers[event] = function (event) {
      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
          (view.editable || !(event.type in editHandlers)))
        { handler(view, event); }
    });
  };

  for (var event in handlers) loop( event );
  // On Safari, for reasons beyond my understanding, adding an input
  // event handler makes an issue where the composition vanishes when
  // you press enter go away.
  if (result.safari) { view.dom.addEventListener("input", function () { return null; }); }

  ensureListeners(view);
}

function setSelectionOrigin(view, origin) {
  view.lastSelectionOrigin = origin;
  view.lastSelectionTime = Date.now();
}

function destroyInput(view) {
  view.domObserver.stop();
  for (var type in view.eventHandlers)
    { view.dom.removeEventListener(type, view.eventHandlers[type]); }
  clearTimeout(view.composingTimeout);
}

function ensureListeners(view) {
  view.someProp("handleDOMEvents", function (currentHandlers) {
    for (var type in currentHandlers) { if (!view.eventHandlers[type])
      { view.dom.addEventListener(type, view.eventHandlers[type] = function (event) { return runCustomHandler(view, event); }); } }
  });
}

function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function (handlers) {
    var handler = handlers[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false
  })
}

function eventBelongsToView(view, event) {
  if (!event.bubbles) { return true }
  if (event.defaultPrevented) { return false }
  for (var node = event.target; node != view.dom; node = node.parentNode)
    { if (!node || node.nodeType == 11 ||
        (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
      { return false } }
  return true
}

function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] &&
      (view.editable || !(event.type in editHandlers)))
    { handlers[event.type](view, event); }
}

editHandlers.keydown = function (view, event) {
  view.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event)) { return }
  view.lastKeyCode = event.keyCode;
  view.lastKeyCodeTime = Date.now();
  if (view.someProp("handleKeyDown", function (f) { return f(view, event); }) || captureKeyDown(view, event))
    { event.preventDefault(); }
  else
    { setSelectionOrigin(view, "key"); }
};

editHandlers.keyup = function (view, e) {
  if (e.keyCode == 16) { view.shiftKey = false; }
};

editHandlers.keypress = function (view, event) {
  if (inOrNearComposition(view, event) || !event.charCode ||
      event.ctrlKey && !event.altKey || result.mac && event.metaKey) { return }

  if (view.someProp("handleKeyPress", function (f) { return f(view, event); })) {
    event.preventDefault();
    return
  }

  var sel = view.state.selection;
  if (!(sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) || !sel.$from.sameParent(sel.$to)) {
    var text = String.fromCharCode(event.charCode);
    if (!view.someProp("handleTextInput", function (f) { return f(view, sel.$from.pos, sel.$to.pos, text); }))
      { view.dispatch(view.state.tr.insertText(text).scrollIntoView()); }
    event.preventDefault();
  }
};

function eventCoords(event) { return {left: event.clientX, top: event.clientY} }

function isNear(event, click) {
  var dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100
}

function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside);
  var loop = function ( i ) {
    if (view.someProp(propName, function (f) { return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
                                                    : f(view, pos, $pos.node(i), $pos.before(i), event, false); }))
      { return { v: true } }
  };

  for (var i = $pos.depth + 1; i > 0; i--) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

function updateSelection(view, selection, origin) {
  if (!view.focused) { view.focus(); }
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") { tr.setMeta("pointer", true); }
  view.dispatch(tr);
}

function selectClickedLeaf(view, inside) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
  if (node && node.isAtom && __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].isSelectable(node)) {
    updateSelection(view, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"]($pos), "pointer");
    return true
  }
  return false
}

function selectClickedNode(view, inside) {
  if (inside == -1) { return false }
  var sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"]) { selectedNode = sel.node; }

  var $pos = view.state.doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 &&
          i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        { selectAt = $pos.before(sel.$from.depth); }
      else
        { selectAt = $pos.before(i); }
      break
    }
  }

  if (selectAt != null) {
    updateSelection(view, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].create(view.state.doc, selectAt), "pointer");
    return true
  } else {
    return false
  }
}

function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
    view.someProp("handleClick", function (f) { return f(view, pos, event); }) ||
    (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside))
}

function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
    view.someProp("handleDoubleClick", function (f) { return f(view, pos, event); })
}

function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
    view.someProp("handleTripleClick", function (f) { return f(view, pos, event); }) ||
    defaultTripleClick(view, inside)
}

function defaultTripleClick(view, inside) {
  var doc = view.state.doc;
  if (inside == -1) {
    if (doc.inlineContent) {
      updateSelection(view, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(doc, 0, doc.content.size), "pointer");
      return true
    }
    return false
  }

  var $pos = doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    var nodePos = $pos.before(i);
    if (node.inlineContent)
      { updateSelection(view, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer"); }
    else if (__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].isSelectable(node))
      { updateSelection(view, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].create(doc, nodePos), "pointer"); }
    else
      { continue }
    return true
  }
}

function forceDOMFlush(view) {
  return endComposition(view)
}

var selectNodeModifier = result.mac ? "metaKey" : "ctrlKey";

handlers.mousedown = function (view, event) {
  view.shiftKey = event.shiftKey;
  var flushed = forceDOMFlush(view);
  var now = Date.now(), type = "singleClick";
  if (now - view.lastClick.time < 500 && isNear(event, view.lastClick) && !event[selectNodeModifier]) {
    if (view.lastClick.type == "singleClick") { type = "doubleClick"; }
    else if (view.lastClick.type == "doubleClick") { type = "tripleClick"; }
  }
  view.lastClick = {time: now, x: event.clientX, y: event.clientY, type: type};

  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) { return }

  if (type == "singleClick")
    { view.mouseDown = new MouseDown(view, pos, event, flushed); }
  else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event))
    { event.preventDefault(); }
  else
    { setSelectionOrigin(view, "pointer"); }
};

var MouseDown = function MouseDown(view, pos, event, flushed) {
  var this$1 = this;

  this.view = view;
  this.startDoc = view.state.doc;
  this.pos = pos;
  this.event = event;
  this.flushed = flushed;
  this.selectNode = event[selectNodeModifier];
  this.allowDefault = event.shiftKey;

  var targetNode, targetPos;
  if (pos.inside > -1) {
    targetNode = view.state.doc.nodeAt(pos.inside);
    targetPos = pos.inside;
  } else {
    var $pos = view.state.doc.resolve(pos.pos);
    targetNode = $pos.parent;
    targetPos = $pos.depth ? $pos.before() : 0;
  }

  this.mightDrag = null;

  var target = flushed ? null : event.target;
  var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
  this.target = targetDesc ? targetDesc.dom : null;

  if (targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
      view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] && targetPos == view.state.selection.from)
    { this.mightDrag = {node: targetNode,
                      pos: targetPos,
                      addAttr: this.target && !this.target.draggable,
                      setUneditable: this.target && result.gecko && !this.target.hasAttribute("contentEditable")}; }

  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = true; }
    if (this.mightDrag.setUneditable)
      { setTimeout(function () { return this$1.target.setAttribute("contentEditable", "false"); }, 20); }
    this.view.domObserver.start();
  }

  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
  setSelectionOrigin(view, "pointer");
};

MouseDown.prototype.done = function done () {
  this.view.root.removeEventListener("mouseup", this.up);
  this.view.root.removeEventListener("mousemove", this.move);
  if (this.mightDrag && this.target) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = false; }
    if (this.mightDrag.setUneditable) { this.target.removeAttribute("contentEditable"); }
    this.view.domObserver.start();
  }
  this.view.mouseDown = null;
};

MouseDown.prototype.up = function up (event) {
  this.done();

  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target))
    { return }

  var pos = this.pos;
  if (this.view.state.doc != this.startDoc) { pos = this.view.posAtCoords(eventCoords(event)); }

  if (this.allowDefault || !pos) {
    setSelectionOrigin(this.view, "pointer");
  } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
    event.preventDefault();
  } else if (this.flushed ||
             // Chrome will sometimes treat a node selection as a
             // cursor, but still report that the node is selected
             // when asked through getSelection. You'll then get a
             // situation where clicking at the point where that
             // (hidden) cursor is doesn't change the selection, and
             // thus doesn't get a reaction from ProseMirror. This
             // works around that.
             (result.chrome && !(this.view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) &&
              (pos.pos == this.view.state.selection.from || pos.pos == this.view.state.selection.to))) {
    updateSelection(this.view, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(this.view.state.doc.resolve(pos.pos)), "pointer");
    event.preventDefault();
  } else {
    setSelectionOrigin(this.view, "pointer");
  }
};

MouseDown.prototype.move = function move (event) {
  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
                             Math.abs(this.event.y - event.clientY) > 4))
    { this.allowDefault = true; }
  setSelectionOrigin(this.view, "pointer");
};

handlers.touchdown = function (view) {
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};

handlers.contextmenu = function (view) { return forceDOMFlush(view); };

function inOrNearComposition(view, event) {
  if (view.composing) { return true }
  // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
  // On Japanese input method editors (IMEs), the Enter key is used to confirm character
  // selection. On Safari, when Enter is pressed, compositionend and keydown events are
  // emitted. The keydown event triggers newline insertion, which we don't want.
  // This method returns true if the keydown event should be ignored.
  // We only ignore it once, as pressing Enter a second time *should* insert a newline.
  // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
  // This guards against the case where compositionend is triggered without the keyboard
  // (e.g. character confirmation may be done with the mouse), and keydown is triggered
  // afterwards- we wouldn't want to ignore the keydown event in this case.
  if (result.safari && Math.abs(event.timeStamp - view.compositionEndedAt) < 500) {
    view.compositionEndedAt = -2e8;
    return true
  }
  return false
}

// Drop active composition after 5 seconds of inactivity on Android
var timeoutComposition = result.android ? 5000 : -1;

editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
  if (!view.composing) {
    view.domObserver.flush();
    var state = view.state;
    var $pos = state.selection.$from;
    if (state.selection.empty &&
        (state.storedMarks || (!$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(function (m) { return m.type.spec.inclusive === false; })))) {
      // Need to wrap the cursor in mark nodes different from the ones in the DOM context
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view);
      // In firefox, if the cursor is after but outside a marked node,
      // the inserted text won't inherit the marks. So this moves it
      // inside if necessary.
      if (result.gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        var sel = view.root.getSelection();
        for (var node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
          var before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
          if (before.nodeType == 3) {
            sel.collapse(before, before.nodeValue.length);
            break
          } else {
            node = before;
            offset = -1;
          }
        }
      }
    }
    view.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};

editHandlers.compositionend = function (view, event) {
  if (view.composing) {
    view.composing = false;
    view.compositionEndedAt = event.timeStamp;
    scheduleComposeEnd(view, 20);
  }
};

function scheduleComposeEnd(view, delay) {
  clearTimeout(view.composingTimeout);
  if (delay > -1) { view.composingTimeout = setTimeout(function () { return endComposition(view); }, delay); }
}

function endComposition(view, forceUpdate) {
  view.composing = false;
  while (view.compositionNodes.length > 0) { view.compositionNodes.pop().markParentsDirty(); }
  if (forceUpdate || view.docView.dirty) {
    view.updateState(view.state);
    return true
  }
  return false
}

function captureCopy(view, dom) {
  // The extra wrapper is somehow necessary on IE/Edge to prevent the
  // content from being mangled when it is put onto the clipboard
  var doc = view.dom.ownerDocument;
  var wrap = doc.body.appendChild(doc.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(), range = doc.createRange();
  range.selectNodeContents(dom);
  // Done because IE will fire a selectionchange moving the selection
  // to its start when removeAllRanges is called and the editor still
  // has focus (which will mess up the editor's selection state).
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(function () {
    doc.body.removeChild(wrap);
    view.focus();
  }, 50);
}

// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
var brokenClipboardAPI = (result.ie && result.ie_version < 15) ||
      (result.ios && result.webkit_version < 604);

handlers.copy = editHandlers.cut = function (view, e) {
  var sel = view.state.selection, cut = e.type == "cut";
  if (sel.empty) { return }

  // IE and Edge's clipboard interface is completely broken
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var slice = sel.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  if (data) {
    e.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut) { view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut")); }
};

function sliceSingleNode(slice) {
  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null
}

function capturePaste(view, e) {
  var doc = view.dom.ownerDocument;
  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = doc.body.appendChild(doc.createElement(plainText ? "textarea" : "div"));
  if (!plainText) { target.contentEditable = "true"; }
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(function () {
    view.focus();
    doc.body.removeChild(target);
    if (plainText) { doPaste(view, target.value, null, e); }
    else { doPaste(view, target.textContent, target.innerHTML, e); }
  }, 50);
}

function doPaste(view, text, html, e) {
  var slice = parseFromClipboard(view, text, html, view.shiftKey, view.state.selection.$from);
  if (view.someProp("handlePaste", function (f) { return f(view, e, slice || __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"].empty); }) || !slice) { return }

  var singleNode = sliceSingleNode(slice);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
}

editHandlers.paste = function (view, e) {
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var html = data && data.getData("text/html"), text = data && data.getData("text/plain");
  if (data && (html || text || data.files.length)) {
    doPaste(view, text, html, e);
    e.preventDefault();
  } else {
    capturePaste(view, e);
  }
};

var Dragging = function Dragging(slice, move) {
  this.slice = slice;
  this.move = move;
};

var dragCopyModifier = result.mac ? "altKey" : "ctrlKey";

handlers.dragstart = function (view, e) {
  var mouseDown = view.mouseDown;
  if (mouseDown) { mouseDown.done(); }
  if (!e.dataTransfer) { return }

  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] ? sel.to - 1: sel.to)) ; else if (mouseDown && mouseDown.mightDrag) {
    view.dispatch(view.state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].create(view.state.doc, mouseDown.mightDrag.pos)));
  } else if (e.target && e.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(e.target, true);
    if (!desc || !desc.node.type.spec.draggable || desc == view.docView) { return }
    view.dispatch(view.state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].create(view.state.doc, desc.posBefore)));
  }
  var slice = view.state.selection.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  e.dataTransfer.clearData();
  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  if (!brokenClipboardAPI) { e.dataTransfer.setData("text/plain", text); }
  view.dragging = new Dragging(slice, !e[dragCopyModifier]);
};

handlers.dragend = function (view) {
  window.setTimeout(function () { return view.dragging = null; }, 50);
};

editHandlers.dragover = editHandlers.dragenter = function (_, e) { return e.preventDefault(); };

editHandlers.drop = function (view, e) {
  var dragging = view.dragging;
  view.dragging = null;

  if (!e.dataTransfer) { return }

  var eventPos = view.posAtCoords(eventCoords(e));
  if (!eventPos) { return }
  var $mouse = view.state.doc.resolve(eventPos.pos);
  if (!$mouse) { return }
  var slice = dragging && dragging.slice ||
      parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"),
                         brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
  if (!slice) { return }

  e.preventDefault();
  if (view.someProp("handleDrop", function (f) { return f(view, e, slice, dragging && dragging.move); })) { return }
  var insertPos = slice ? Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["g" /* dropPoint */])(view.state.doc, $mouse.pos, slice) : $mouse.pos;
  if (insertPos == null) { insertPos = $mouse.pos; }

  var tr = view.state.tr;
  if (dragging && dragging.move) { tr.deleteSelection(); }

  var pos = tr.mapping.map(insertPos);
  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode)
    { tr.replaceRangeWith(pos, pos, slice.content.firstChild); }
  else
    { tr.replaceRange(pos, pos, slice); }
  if (tr.doc.eq(beforeInsert)) { return }

  var $pos = tr.doc.resolve(pos);
  if (isNode && __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].isSelectable(slice.content.firstChild) &&
      $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild))
    { tr.setSelection(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"]($pos)); }
  else
    { tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(tr.mapping.map(insertPos)))); }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};

handlers.focus = function (view) {
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
  }
};

handlers.blur = function (view) {
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    view.domObserver.currentSelection.set({});
    view.focused = false;
  }
};

handlers.beforeinput = function (view, event) {
  // We should probably do more with beforeinput events, but support
  // is so spotty that I'm still waiting to see where they are going.

  // Very specific hack to deal with backspace sometimes failing on
  // Chrome Android when after an uneditable node.
  if (result.chrome && result.android && event.inputType == "deleteContentBackward") {
    var domChangeCount = view.domChangeCount;
    setTimeout(function () {
      if (view.domChangeCount != domChangeCount) { return } // Event already had some effect
      // This bug tends to close the virtual keyboard, so we refocus
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) { return }
      var ref = view.state.selection;
      var $cursor = ref.$cursor;
      // Crude approximation of backspace behavior when no command handled it
      if ($cursor && $cursor.pos > 0) { view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView()); }
    }, 50);
  }
};

// Make sure all handlers get registered
for (var prop in editHandlers) { handlers[prop] = editHandlers[prop]; }

function compareObjs(a, b) {
  if (a == b) { return true }
  for (var p in a) { if (a[p] !== b[p]) { return false } }
  for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  return true
}

var WidgetType = function WidgetType(toDOM, spec) {
  this.spec = spec || noSpec;
  this.side = this.spec.side || 0;
  this.toDOM = toDOM;
};

WidgetType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var ref = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    var pos = ref.pos;
    var deleted = ref.deleted;
  return deleted ? null : new Decoration(pos - offset, pos - offset, this)
};

WidgetType.prototype.valid = function valid () { return true };

WidgetType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof WidgetType &&
     (this.spec.key && this.spec.key == other.spec.key ||
      this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)))
};

var InlineType = function InlineType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

InlineType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
  var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
  return from >= to ? null : new Decoration(from, to, this)
};

InlineType.prototype.valid = function valid (_, span) { return span.from < span.to };

InlineType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

InlineType.is = function is (span) { return span.type instanceof InlineType };

var NodeType = function NodeType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

NodeType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.mapResult(span.from + oldOffset, 1);
  if (from.deleted) { return null }
  var to = mapping.mapResult(span.to + oldOffset, -1);
  if (to.deleted || to.pos <= from.pos) { return null }
  return new Decoration(from.pos - offset, to.pos - offset, this)
};

NodeType.prototype.valid = function valid (node, span) {
  var ref = node.content.findIndex(span.from);
    var index = ref.index;
    var offset = ref.offset;
  return offset == span.from && offset + node.child(index).nodeSize == span.to
};

NodeType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof NodeType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

// ::- Decoration objects can be provided to the view through the
// [`decorations` prop](#view.EditorProps.decorations). They come in
// several variants—see the static members of this class for details.
var Decoration = function Decoration(from, to, type) {
  // :: number
  // The start position of the decoration.
  this.from = from;
  // :: number
  // The end position. Will be the same as `from` for [widget
  // decorations](#view.Decoration^widget).
  this.to = to;
  this.type = type;
};

var prototypeAccessors$1 = { spec: { configurable: true } };

Decoration.prototype.copy = function copy (from, to) {
  return new Decoration(from, to, this.type)
};

Decoration.prototype.eq = function eq (other) {
  return this.type.eq(other.type) && this.from == other.from && this.to == other.to
};

Decoration.prototype.map = function map (mapping, offset, oldOffset) {
  return this.type.map(mapping, this, offset, oldOffset)
};

// :: (number, union<(view: EditorView, getPos: () → number) → dom.Node, dom.Node>, ?Object) → Decoration
// Creates a widget decoration, which is a DOM node that's shown in
// the document at the given position. It is recommended that you
// delay rendering the widget by passing a function that will be
// called when the widget is actually drawn in a view, but you can
// also directly pass a DOM node. `getPos` can be used to find the
// widget's current document position.
//
// spec::- These options are supported:
//
//   side:: ?number
//   Controls which side of the document position this widget is
//   associated with. When negative, it is drawn before a cursor
//   at its position, and content inserted at that position ends
//   up after the widget. When zero (the default) or positive, the
//   widget is drawn after the cursor and content inserted there
//   ends up before the widget.
//
//   When there are multiple widgets at a given position, their
//   `side` values determine the order in which they appear. Those
//   with lower values appear first. The ordering of widgets with
//   the same `side` value is unspecified.
//
//   When `marks` is null, `side` also determines the marks that
//   the widget is wrapped in—those of the node before when
//   negative, those of the node after when positive.
//
//   marks:: ?[Mark]
//   The precise set of marks to draw around the widget.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to control which DOM events, when they bubble out
//   of this widget, the editor view should ignore.
//
//   key:: ?string
//   When comparing decorations of this type (in order to decide
//   whether it needs to be redrawn), ProseMirror will by default
//   compare the widget DOM node by identity. If you pass a key,
//   that key will be compared instead, which can be useful when
//   you generate decorations on the fly and don't want to store
//   and reuse DOM nodes. Make sure that any widgets with the same
//   key are interchangeable—if widgets differ in, for example,
//   the behavior of some event handler, they should get
//   different keys.
Decoration.widget = function widget (pos, toDOM, spec) {
  return new Decoration(pos, pos, new WidgetType(toDOM, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates an inline decoration, which adds the given attributes to
// each inline node between `from` and `to`.
//
// spec::- These options are recognized:
//
//   inclusiveStart:: ?bool
//   Determines how the left side of the decoration is
//   [mapped](#transform.Position_Mapping) when content is
//   inserted directly at that position. By default, the decoration
//   won't include the new content, but you can set this to `true`
//   to make it inclusive.
//
//   inclusiveEnd:: ?bool
//   Determines how the right side of the decoration is mapped.
//   See
//   [`inclusiveStart`](#view.Decoration^inline^spec.inclusiveStart).
Decoration.inline = function inline (from, to, attrs, spec) {
  return new Decoration(from, to, new InlineType(attrs, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates a node decoration. `from` and `to` should point precisely
// before and after a node in the document. That node, and only that
// node, will receive the given attributes.
//
// spec::-
//
// Optional information to store with the decoration. It
// is also used when comparing decorators for equality.
Decoration.node = function node (from, to, attrs, spec) {
  return new Decoration(from, to, new NodeType(attrs, spec))
};

// :: Object
// The spec provided when creating this decoration. Can be useful
// if you've stored extra information in that object.
prototypeAccessors$1.spec.get = function () { return this.type.spec };

Object.defineProperties( Decoration.prototype, prototypeAccessors$1 );

// DecorationAttrs:: interface
// A set of attributes to add to a decorated node. Most properties
// simply directly correspond to DOM attributes of the same name,
// which will be set to the property's value. These are exceptions:
//
//   class:: ?string
//   A CSS class name or a space-separated set of class names to be
//   _added_ to the classes that the node already had.
//
//   style:: ?string
//   A string of CSS to be _added_ to the node's existing `style` property.
//
//   nodeName:: ?string
//   When non-null, the target node is wrapped in a DOM element of
//   this type (and the other attributes are applied to this element).

var none = [], noSpec = {};

// ::- A collection of [decorations](#view.Decoration), organized in
// such a way that the drawing algorithm can efficiently use and
// compare them. This is a persistent data structure—it is not
// modified, updates create a new value.
var DecorationSet = function DecorationSet(local, children) {
  this.local = local && local.length ? local : none;
  this.children = children && children.length ? children : none;
};

// :: (Node, [Decoration]) → DecorationSet
// Create a set of decorations, using the structure of the given
// document.
DecorationSet.create = function create (doc, decorations) {
  return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty
};

// :: (?number, ?number, ?(spec: Object) → bool) → [Decoration]
// Find all decorations in this set which touch the given range
// (including decorations that start or end directly at the
// boundaries) and match the given predicate on their spec. When
// `start` and `end` are omitted, all decorations in the set are
// considered. When `predicate` isn't given, all decorations are
// assumed to match.
DecorationSet.prototype.find = function find (start, end, predicate) {
  var result = [];
  this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
  return result
};

DecorationSet.prototype.findInner = function findInner (start, end, result, offset, predicate) {
  for (var i = 0; i < this.local.length; i++) {
    var span = this.local[i];
    if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
      { result.push(span.copy(span.from + offset, span.to + offset)); }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this.children[i$1] < end && this.children[i$1 + 1] > start) {
      var childOff = this.children[i$1] + 1;
      this.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
    }
  }
};

// :: (Mapping, Node, ?Object) → DecorationSet
// Map the set of decorations in response to a change in the
// document.
//
// options::- An optional set of options.
//
//   onRemove:: ?(decorationSpec: Object)
//   When given, this function will be called for each decoration
//   that gets dropped as a result of the mapping, passing the
//   spec of that decoration.
DecorationSet.prototype.map = function map (mapping, doc, options) {
  if (this == empty || mapping.maps.length == 0) { return this }
  return this.mapInner(mapping, doc, 0, 0, options || noSpec)
};

DecorationSet.prototype.mapInner = function mapInner (mapping, node, offset, oldOffset, options) {
  var newLocal;
  for (var i = 0; i < this.local.length; i++) {
    var mapped = this.local[i].map(mapping, offset, oldOffset);
    if (mapped && mapped.type.valid(node, mapped)) { (newLocal || (newLocal = [])).push(mapped); }
    else if (options.onRemove) { options.onRemove(this.local[i].spec); }
  }

  if (this.children.length)
    { return mapChildren(this.children, newLocal, mapping, node, offset, oldOffset, options) }
  else
    { return newLocal ? new DecorationSet(newLocal.sort(byPos)) : empty }
};

// :: (Node, [Decoration]) → DecorationSet
// Add the given array of decorations to the ones in the set,
// producing a new set. Needs access to the current document to
// create the appropriate tree structure.
DecorationSet.prototype.add = function add (doc, decorations) {
  if (!decorations.length) { return this }
  if (this == empty) { return DecorationSet.create(doc, decorations) }
  return this.addInner(doc, decorations, 0)
};

DecorationSet.prototype.addInner = function addInner (doc, decorations, offset) {
    var this$1 = this;

  var children, childIndex = 0;
  doc.forEach(function (childNode, childOffset) {
    var baseOffset = childOffset + offset, found;
    if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) { return }

    if (!children) { children = this$1.children.slice(); }
    while (childIndex < children.length && children[childIndex] < childOffset) { childIndex += 3; }
    if (children[childIndex] == childOffset)
      { children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1); }
    else
      { children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec)); }
    childIndex += 3;
  });

  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local,
                           children || this.children)
};

// :: ([Decoration]) → DecorationSet
// Create a new set that contains the decorations in this set, minus
// the ones in the given array.
DecorationSet.prototype.remove = function remove (decorations) {
  if (decorations.length == 0 || this == empty) { return this }
  return this.removeInner(decorations, 0)
};

DecorationSet.prototype.removeInner = function removeInner (decorations, offset) {
  var children = this.children, local = this.local;
  for (var i = 0; i < children.length; i += 3) {
    var found = (void 0), from = children[i] + offset, to = children[i + 1] + offset;
    for (var j = 0, span = (void 0); j < decorations.length; j++) { if (span = decorations[j]) {
      if (span.from > from && span.to < to) {
        decorations[j] = null
        ;(found || (found = [])).push(span);
      }
    } }
    if (!found) { continue }
    if (children == this.children) { children = this.children.slice(); }
    var removed = children[i + 2].removeInner(found, from + 1);
    if (removed != empty) {
      children[i + 2] = removed;
    } else {
      children.splice(i, 3);
      i -= 3;
    }
  }
  if (local.length) { for (var i$1 = 0, span$1 = (void 0); i$1 < decorations.length; i$1++) { if (span$1 = decorations[i$1]) {
    for (var j$1 = 0; j$1 < local.length; j$1++) { if (local[j$1].type.eq(span$1.type)) {
      if (local == this.local) { local = this.local.slice(); }
      local.splice(j$1--, 1);
    } }
  } } }
  if (children == this.children && local == this.local) { return this }
  return local.length || children.length ? new DecorationSet(local, children) : empty
};

DecorationSet.prototype.forChild = function forChild (offset, node) {
  if (this == empty) { return this }
  if (node.isLeaf) { return DecorationSet.empty }

  var child, local;
  for (var i = 0; i < this.children.length; i += 3) { if (this.children[i] >= offset) {
    if (this.children[i] == offset) { child = this.children[i + 2]; }
    break
  } }
  var start = offset + 1, end = start + node.content.size;
  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
    var dec = this.local[i$1];
    if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
      var from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
      if (from < to) { (local || (local = [])).push(dec.copy(from, to)); }
    }
  }
  if (local) {
    var localSet = new DecorationSet(local.sort(byPos));
    return child ? new DecorationGroup([localSet, child]) : localSet
  }
  return child || empty
};

DecorationSet.prototype.eq = function eq (other) {
  if (this == other) { return true }
  if (!(other instanceof DecorationSet) ||
      this.local.length != other.local.length ||
      this.children.length != other.children.length) { return false }
  for (var i = 0; i < this.local.length; i++)
    { if (!this.local[i].eq(other.local[i])) { return false } }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3)
    { if (this.children[i$1] != other.children[i$1] ||
        this.children[i$1 + 1] != other.children[i$1 + 1] ||
        !this.children[i$1 + 2].eq(other.children[i$1 + 2])) { return false } }
  return true
};

DecorationSet.prototype.locals = function locals (node) {
  return removeOverlap(this.localsInner(node))
};

DecorationSet.prototype.localsInner = function localsInner (node) {
  if (this == empty) { return none }
  if (node.inlineContent || !this.local.some(InlineType.is)) { return this.local }
  var result = [];
  for (var i = 0; i < this.local.length; i++) {
    if (!(this.local[i].type instanceof InlineType))
      { result.push(this.local[i]); }
  }
  return result
};

var empty = new DecorationSet();

// :: DecorationSet
// The empty set of decorations.
DecorationSet.empty = empty;

DecorationSet.removeOverlap = removeOverlap;

// :- An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
var DecorationGroup = function DecorationGroup(members) {
  this.members = members;
};

DecorationGroup.prototype.forChild = function forChild (offset, child) {
  if (child.isLeaf) { return DecorationSet.empty }
  var found = [];
  for (var i = 0; i < this.members.length; i++) {
    var result = this.members[i].forChild(offset, child);
    if (result == empty) { continue }
    if (result instanceof DecorationGroup) { found = found.concat(result.members); }
    else { found.push(result); }
  }
  return DecorationGroup.from(found)
};

DecorationGroup.prototype.eq = function eq (other) {
  if (!(other instanceof DecorationGroup) ||
      other.members.length != this.members.length) { return false }
  for (var i = 0; i < this.members.length; i++)
    { if (!this.members[i].eq(other.members[i])) { return false } }
  return true
};

DecorationGroup.prototype.locals = function locals (node) {
  var result, sorted = true;
  for (var i = 0; i < this.members.length; i++) {
    var locals = this.members[i].localsInner(node);
    if (!locals.length) { continue }
    if (!result) {
      result = locals;
    } else {
      if (sorted) {
        result = result.slice();
        sorted = false;
      }
      for (var j = 0; j < locals.length; j++) { result.push(locals[j]); }
    }
  }
  return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none
};

// : ([DecorationSet]) → union<DecorationSet, DecorationGroup>
// Create a group for the given array of decoration sets, or return
// a single set when possible.
DecorationGroup.from = function from (members) {
  switch (members.length) {
    case 0: return empty
    case 1: return members[0]
    default: return new DecorationGroup(members)
  }
};

function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
  var children = oldChildren.slice();

  // Mark the children that are directly touched by changes, and
  // move those that are after the changes.
  var shift = function (oldStart, oldEnd, newStart, newEnd) {
    for (var i = 0; i < children.length; i += 3) {
      var end = children[i + 1], dSize = (void 0);
      if (end == -1 || oldStart > end + oldOffset) { continue }
      if (oldEnd >= children[i] + oldOffset) {
        children[i + 1] = -1;
      } else if (dSize = (newEnd - newStart) - (oldEnd - oldStart) + (oldOffset - offset)) {
        children[i] += dSize;
        children[i + 1] += dSize;
      }
    }
  };
  for (var i = 0; i < mapping.maps.length; i++) { mapping.maps[i].forEach(shift); }

  // Find the child nodes that still correspond to a single node,
  // recursively call mapInner on them and update their positions.
  var mustRebuild = false;
  for (var i$1 = 0; i$1 < children.length; i$1 += 3) { if (children[i$1 + 1] == -1) { // Touched nodes
    var from = mapping.map(children[i$1] + oldOffset), fromLocal = from - offset;
    if (fromLocal < 0 || fromLocal >= node.content.size) {
      mustRebuild = true;
      continue
    }
    // Must read oldChildren because children was tagged with -1
    var to = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to - offset;
    var ref = node.content.findIndex(fromLocal);
    var index = ref.index;
    var childOffset = ref.offset;
    var childNode = node.maybeChild(index);
    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
      var mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, children[i$1] + oldOffset + 1, options);
      if (mapped != empty) {
        children[i$1] = fromLocal;
        children[i$1 + 1] = toLocal;
        children[i$1 + 2] = mapped;
      } else {
        children[i$1 + 1] = -2;
        mustRebuild = true;
      }
    } else {
      mustRebuild = true;
    }
  } }

  // Remaining children must be collected and rebuilt into the appropriate structure
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal || [], mapping,
                                                       offset, oldOffset, options);
    var built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (var i$2 = 0; i$2 < children.length; i$2 += 3) { if (children[i$2 + 1] < 0) {
      children.splice(i$2, 3);
      i$2 -= 3;
    } }
    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
      var from$1 = built.children[i$3];
      while (j < children.length && children[j] < from$1) { j += 3; }
      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
    }
  }

  return new DecorationSet(newLocal && newLocal.sort(byPos), children)
}

function moveSpans(spans, offset) {
  if (!offset || !spans.length) { return spans }
  var result = [];
  for (var i = 0; i < spans.length; i++) {
    var span = spans[i];
    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
  }
  return result
}

function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
  // Gather all decorations from the remaining marked children
  function gather(set, oldOffset) {
    for (var i = 0; i < set.local.length; i++) {
      var mapped = set.local[i].map(mapping, offset, oldOffset);
      if (mapped) { decorations.push(mapped); }
      else if (options.onRemove) { options.onRemove(set.local[i].spec); }
    }
    for (var i$1 = 0; i$1 < set.children.length; i$1 += 3)
      { gather(set.children[i$1 + 2], set.children[i$1] + oldOffset + 1); }
  }
  for (var i = 0; i < children.length; i += 3) { if (children[i + 1] == -1)
    { gather(children[i + 2], oldChildren[i] + oldOffset + 1); } }

  return decorations
}

function takeSpansForNode(spans, node, offset) {
  if (node.isLeaf) { return null }
  var end = offset + node.nodeSize, found = null;
  for (var i = 0, span = (void 0); i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset && span.to < end) {
(found || (found = [])).push(span);
      spans[i] = null;
    }
  }
  return found
}

function withoutNulls(array) {
  var result = [];
  for (var i = 0; i < array.length; i++)
    { if (array[i] != null) { result.push(array[i]); } }
  return result
}

// : ([Decoration], Node, number) → DecorationSet
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtractet from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
  var children = [], hasNulls = false;
  node.forEach(function (childNode, localStart) {
    var found = takeSpansForNode(spans, childNode, localStart + offset);
    if (found) {
      hasNulls = true;
      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
      if (subtree != empty)
        { children.push(localStart, localStart + childNode.nodeSize, subtree); }
    }
  });
  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
  for (var i = 0; i < locals.length; i++) { if (!locals[i].type.valid(node, locals[i])) {
    if (options.onRemove) { options.onRemove(locals[i].spec); }
    locals.splice(i--, 1);
  } }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty
}

// : (Decoration, Decoration) → number
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
  return a.from - b.from || a.to - b.to
}

// : ([Decoration]) → [Decoration]
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
  var working = spans;
  for (var i = 0; i < working.length - 1; i++) {
    var span = working[i];
    if (span.from != span.to) { for (var j = i + 1; j < working.length; j++) {
      var next = working[j];
      if (next.from == span.from) {
        if (next.to != span.to) {
          if (working == spans) { working = spans.slice(); }
          // Followed by a partially overlapping larger span. Split that
          // span.
          working[j] = next.copy(next.from, span.to);
          insertAhead(working, j + 1, next.copy(span.to, next.to));
        }
        continue
      } else {
        if (next.from < span.to) {
          if (working == spans) { working = spans.slice(); }
          // The end of this one overlaps with a subsequent span. Split
          // this one.
          working[i] = span.copy(span.from, next.from);
          insertAhead(working, j, span.copy(next.from, span.to));
        }
        break
      }
    } }
  }
  return working
}

function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0) { i++; }
  array.splice(i, 0, deco);
}

// : (EditorView) → union<DecorationSet, DecorationGroup>
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
  var found = [];
  view.someProp("decorations", function (f) {
    var result = f(view.state);
    if (result && result != empty) { found.push(result); }
  });
  if (view.cursorWrapper)
    { found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco])); }
  return DecorationGroup.from(found)
}

// ::- An editor view manages the DOM structure that represents an
// editable document. Its state and behavior are determined by its
// [props](#view.DirectEditorProps).
var EditorView = function EditorView(place, props) {
  this._props = props;
  // :: EditorState
  // The view's current [state](#state.EditorState).
  this.state = props.state;

  this.dispatch = this.dispatch.bind(this);

  this._root = null;
  this.focused = false;

  // :: dom.Element
  // An editable DOM node containing the document. (You probably
  // should not directly interfere with its content.)
  this.dom = (place && place.mount) || document.createElement("div");
  if (place) {
    if (place.appendChild) { place.appendChild(this.dom); }
    else if (place.apply) { place(this.dom); }
    else if (place.mount) { this.mounted = true; }
  }

  // :: bool
  // Indicates whether the editor is currently [editable](#view.EditorProps.editable).
  this.editable = getEditable(this);
  this.markCursor = null;
  this.cursorWrapper = null;
  updateCursorWrapper(this);
  this.nodeViews = buildNodeViews(this);
  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);

  this.lastSelectedViewDesc = null;
  // :: ?{slice: Slice, move: bool}
  // When editor content is being dragged, this object contains
  // information about the dragged slice and whether it is being
  // copied or moved. At any other time, it is null.
  this.dragging = null;

  initInput(this);

  this.pluginViews = [];
  this.updatePluginViews();
};

var prototypeAccessors$2 = { props: { configurable: true },root: { configurable: true } };

// composing:: boolean
// Holds `true` when a
// [composition](https://developer.mozilla.org/en-US/docs/Mozilla/IME_handling_guide)
// is active.

// :: DirectEditorProps
// The view's current [props](#view.EditorProps).
prototypeAccessors$2.props.get = function () {
  if (this._props.state != this.state) {
    var prev = this._props;
    this._props = {};
    for (var name in prev) { this._props[name] = prev[name]; }
    this._props.state = this.state;
  }
  return this._props
};

// :: (DirectEditorProps)
// Update the view's props. Will immediately cause an update to
// the DOM.
EditorView.prototype.update = function update (props) {
  if (props.handleDOMEvents != this._props.handleDOMEvents) { ensureListeners(this); }
  this._props = props;
  this.updateStateInner(props.state, true);
};

// :: (DirectEditorProps)
// Update the view by updating existing props object with the object
// given as argument. Equivalent to `view.update(Object.assign({},
// view.props, props))`.
EditorView.prototype.setProps = function setProps (props) {
  var updated = {};
  for (var name in this._props) { updated[name] = this._props[name]; }
  updated.state = this.state;
  for (var name$1 in props) { updated[name$1] = props[name$1]; }
  this.update(updated);
};

// :: (EditorState)
// Update the editor's `state` prop, without touching any of the
// other props.
EditorView.prototype.updateState = function updateState (state) {
  this.updateStateInner(state, this.state.plugins != state.plugins);
};

EditorView.prototype.updateStateInner = function updateStateInner (state, reconfigured) {
    var this$1 = this;

  var prev = this.state, redraw = false;
  this.state = state;
  if (reconfigured) {
    var nodeViews = buildNodeViews(this);
    if (changedNodeViews(nodeViews, this.nodeViews)) {
      this.nodeViews = nodeViews;
      redraw = true;
    }
    ensureListeners(this);
  }

  this.editable = getEditable(this);
  updateCursorWrapper(this);
  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);

  var scroll = reconfigured ? "reset"
      : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
  var updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
  var updateSel = updateDoc || !state.selection.eq(prev.selection);
  var oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);

  if (updateSel) {
    this.domObserver.stop();
    var forceSelUpdate = false;
    if (updateDoc) {
      // Work around an issue in Chrome where changing the DOM
      // around the active selection puts it into a broken state
      // where the thing the user sees differs from the selection
      // reported by the Selection object (#710)
      var startSelContext = result.chrome && selectionContext(this.root);
      if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
        this.docView.destroy();
        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
      }
      if (startSelContext)
        { forceSelUpdate = !this.composing && needChromeSelectionForce(startSelContext, this.root); }
      // IE11 will sometimes _report_ the selection as being in the
      // right place but actually draw/use a different selection
      // after a deletion (#973).
      if (result.ie && result.ie_version <= 11 && !prev.selection.empty && state.selection.empty &&
          state.doc.content.size < prev.doc.content.size)
        { forceSelUpdate = true; }
    }
    // Work around for an issue where an update arriving right between
    // a DOM selection change and the "selectionchange" event for it
    // can cause a spurious DOM selection update, disrupting mouse
    // drag selection.
    if (forceSelUpdate ||
        !(this.mouseDown && this.domObserver.currentSelection.eq(this.root.getSelection()) && anchorInRightPlace(this))) {
      selectionToDOM(this, forceSelUpdate);
    } else {
      syncNodeSelection(this, state.selection);
      this.domObserver.setCurSelection();
    }
    this.domObserver.start();
  }

  this.updatePluginViews(prev);

  if (scroll == "reset") {
    this.dom.scrollTop = 0;
  } else if (scroll == "to selection") {
    var startDOM = this.root.getSelection().focusNode;
    if (this.someProp("handleScrollToSelection", function (f) { return f(this$1); }))
      ; // Handled
    else if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"])
      { scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect(), startDOM); }
    else
      { scrollRectIntoView(this, this.coordsAtPos(state.selection.head), startDOM); }
  } else if (oldScrollPos) {
    resetScrollPos(oldScrollPos);
  }
};

EditorView.prototype.destroyPluginViews = function destroyPluginViews () {
  var view;
  while (view = this.pluginViews.pop()) { if (view.destroy) { view.destroy(); } }
};

EditorView.prototype.updatePluginViews = function updatePluginViews (prevState) {
  if (!prevState || prevState.plugins != this.state.plugins) {
    this.destroyPluginViews();
    for (var i = 0; i < this.state.plugins.length; i++) {
      var plugin = this.state.plugins[i];
      if (plugin.spec.view) { this.pluginViews.push(plugin.spec.view(this)); }
    }
  } else {
    for (var i$1 = 0; i$1 < this.pluginViews.length; i$1++) {
      var pluginView = this.pluginViews[i$1];
      if (pluginView.update) { pluginView.update(this, prevState); }
    }
  }
};

// :: (string, ?(prop: *) → *) → *
// Goes over the values of a prop, first those provided directly,
// then those from plugins (in order), and calls `f` every time a
// non-undefined value is found. When `f` returns a truthy value,
// that is immediately returned. When `f` isn't provided, it is
// treated as the identity function (the prop value is returned
// directly).
EditorView.prototype.someProp = function someProp (propName, f) {
  var prop = this._props && this._props[propName], value;
  if (prop != null && (value = f ? f(prop) : prop)) { return value }
  var plugins = this.state.plugins;
  if (plugins) { for (var i = 0; i < plugins.length; i++) {
    var prop$1 = plugins[i].props[propName];
    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) { return value }
  } }
};

// :: () → bool
// Query whether the view has focus.
EditorView.prototype.hasFocus = function hasFocus () {
  return this.root.activeElement == this.dom
};

// :: ()
// Focus the editor.
EditorView.prototype.focus = function focus () {
  this.domObserver.stop();
  if (this.editable) { focusPreventScroll(this.dom); }
  selectionToDOM(this);
  this.domObserver.start();
};

// :: union<dom.Document, dom.DocumentFragment>
// Get the document root in which the editor exists. This will
// usually be the top-level `document`, but might be a [shadow
// DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
// root if the editor is inside one.
prototypeAccessors$2.root.get = function () {
  var cached = this._root;
  if (cached == null) { for (var search = this.dom.parentNode; search; search = search.parentNode) {
    if (search.nodeType == 9 || (search.nodeType == 11 && search.host))
      { return this._root = search }
  } }
  return cached || document
};

// :: ({left: number, top: number}) → ?{pos: number, inside: number}
// Given a pair of viewport coordinates, return the document
// position that corresponds to them. May return null if the given
// coordinates aren't inside of the editor. When an object is
// returned, its `pos` property is the position nearest to the
// coordinates, and its `inside` property holds the position of the
// inner node that the position falls inside of, or -1 if it is at
// the top level, not in any node.
EditorView.prototype.posAtCoords = function posAtCoords$1 (coords) {
  return posAtCoords(this, coords)
};

// :: (number) → {left: number, right: number, top: number, bottom: number}
// Returns the viewport rectangle at a given document position. `left`
// and `right` will be the same number, as this returns a flat
// cursor-ish rectangle.
EditorView.prototype.coordsAtPos = function coordsAtPos$1 (pos) {
  return coordsAtPos(this, pos)
};

// :: (number) → {node: dom.Node, offset: number}
// Find the DOM position that corresponds to the given document
// position. Note that you should **not** mutate the editor's
// internal DOM, only inspect it (and even that is usually not
// necessary).
EditorView.prototype.domAtPos = function domAtPos (pos) {
  return this.docView.domFromPos(pos)
};

// :: (number) → ?dom.Node
// Find the DOM node that represents the document node after the
// given position. May return `null` when the position doesn't point
// in front of a node or if the node is inside an opaque node view.
//
// This is intended to be able to call things like
// `getBoundingClientRect` on that DOM node. Do **not** mutate the
// editor DOM directly, or add styling this way, since that will be
// immediately overriden by the editor as it redraws the node.
EditorView.prototype.nodeDOM = function nodeDOM (pos) {
  var desc = this.docView.descAt(pos);
  return desc ? desc.nodeDOM : null
};

// :: (dom.Node, number, ?number) → number
// Find the document position that corresponds to a given DOM
// position. (Whenever possible, it is preferable to inspect the
// document structure directly, rather than poking around in the
// DOM, but sometimes—for example when interpreting an event
// target—you don't have a choice.)
//
// The `bias` parameter can be used to influence which side of a DOM
// node to use when the position is inside a leaf node.
EditorView.prototype.posAtDOM = function posAtDOM (node, offset, bias) {
    if ( bias === void 0 ) bias = -1;

  var pos = this.docView.posFromDOM(node, offset, bias);
  if (pos == null) { throw new RangeError("DOM position not inside the editor") }
  return pos
};

// :: (union<"up", "down", "left", "right", "forward", "backward">, ?EditorState) → bool
// Find out whether the selection is at the end of a textblock when
// moving in a given direction. When, for example, given `"left"`,
// it will return true if moving left from the current cursor
// position would leave that position's parent textblock. Will apply
// to the view's current state by default, but it is possible to
// pass a different state.
EditorView.prototype.endOfTextblock = function endOfTextblock$1 (dir, state) {
  return endOfTextblock(this, state || this.state, dir)
};

// :: ()
// Removes the editor from the DOM and destroys all [node
// views](#view.NodeView).
EditorView.prototype.destroy = function destroy () {
  if (!this.docView) { return }
  destroyInput(this);
  this.destroyPluginViews();
  if (this.mounted) {
    this.docView.update(this.state.doc, [], viewDecorations(this), this);
    this.dom.textContent = "";
  } else if (this.dom.parentNode) {
    this.dom.parentNode.removeChild(this.dom);
  }
  this.docView.destroy();
  this.docView = null;
};

// Used for testing.
EditorView.prototype.dispatchEvent = function dispatchEvent$1 (event) {
  return dispatchEvent(this, event)
};

// :: (Transaction)
// Dispatch a transaction. Will call
// [`dispatchTransaction`](#view.DirectEditorProps.dispatchTransaction)
// when given, and otherwise defaults to applying the transaction to
// the current state and calling
// [`updateState`](#view.EditorView.updateState) with the result.
// This method is bound to the view instance, so that it can be
// easily passed around.
EditorView.prototype.dispatch = function dispatch (tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) { dispatchTransaction.call(this, tr); }
  else { this.updateState(this.state.apply(tr)); }
};

Object.defineProperties( EditorView.prototype, prototypeAccessors$2 );

function computeDocDeco(view) {
  var attrs = Object.create(null);
  attrs.class = "ProseMirror";
  attrs.contenteditable = String(view.editable);

  view.someProp("attributes", function (value) {
    if (typeof value == "function") { value = value(view.state); }
    if (value) { for (var attr in value) {
      if (attr == "class")
        { attrs.class += " " + value[attr]; }
      else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
        { attrs[attr] = String(value[attr]); }
    } }
  });

  return [Decoration.node(0, view.state.doc.content.size, attrs)]
}

function updateCursorWrapper(view) {
  var ref = view.state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var visible = ref.visible;
  if (view.markCursor) {
    var dom = document.createElement("img");
    dom.setAttribute("mark-placeholder", "true");
    view.cursorWrapper = {dom: dom, deco: Decoration.widget($head.pos, dom, {raw: true, marks: view.markCursor})};
  } else if (visible || $head.pos != $anchor.pos) {
    view.cursorWrapper = null;
  } else {
    var dom$1;
    if (!view.cursorWrapper || view.cursorWrapper.dom.childNodes.length) {
      dom$1 = document.createElement("div");
      dom$1.style.position = "absolute";
      dom$1.style.left = "-100000px";
    } else if (view.cursorWrapper.deco.pos != $head.pos) {
      dom$1 = view.cursorWrapper.dom;
    }
    if (dom$1)
      { view.cursorWrapper = {dom: dom$1, deco: Decoration.widget($head.pos, dom$1, {raw: true})}; }
  }
}

function getEditable(view) {
  return !view.someProp("editable", function (value) { return value(view.state) === false; })
}

function selectionContext(root) {
  var ref = root.getSelection();
  var offset = ref.focusOffset;
  var node = ref.focusNode;
  if (!node || node.nodeType == 3) { return null }
  return [node, offset,
          node.nodeType == 1 ? node.childNodes[offset - 1] : null,
          node.nodeType == 1 ? node.childNodes[offset] : null]
}

function needChromeSelectionForce(context, root) {
  var newContext = selectionContext(root);
  if (!newContext || newContext[0].nodeType == 3) { return false }
  for (var i = 0; i < context.length; i++) { if (newContext[i] != context[i]) { return true } }
  return false
}

function buildNodeViews(view) {
  var result = {};
  view.someProp("nodeViews", function (obj) {
    for (var prop in obj) { if (!Object.prototype.hasOwnProperty.call(result, prop))
      { result[prop] = obj[prop]; } }
  });
  return result
}

function changedNodeViews(a, b) {
  var nA = 0, nB = 0;
  for (var prop in a) {
    if (a[prop] != b[prop]) { return true }
    nA++;
  }
  for (var _ in b) { nB++; }
  return nA != nB
}

// EditorProps:: interface
//
// Props are configuration values that can be passed to an editor view
// or included in a plugin. This interface lists the supported props.
//
// The various event-handling functions may all return `true` to
// indicate that they handled the given event. The view will then take
// care to call `preventDefault` on the event, except with
// `handleDOMEvents`, where the handler itself is responsible for that.
//
// How a prop is resolved depends on the prop. Handler functions are
// called one at a time, starting with the base props and then
// searching through the plugins (in order of appearance) until one of
// them returns true. For some props, the first plugin that yields a
// value gets precedence.
//
//   handleDOMEvents:: ?Object<(view: EditorView, event: dom.Event) → bool>
//   Can be an object mapping DOM event type names to functions that
//   handle them. Such functions will be called before any handling
//   ProseMirror does of events fired on the editable DOM element.
//   Contrary to the other event handling props, when returning true
//   from such a function, you are responsible for calling
//   `preventDefault` yourself (or not, if you want to allow the
//   default behavior).
//
//   handleKeyDown:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Called when the editor receives a `keydown` event.
//
//   handleKeyPress:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Handler for `keypress` events.
//
//   handleTextInput:: ?(view: EditorView, from: number, to: number, text: string) → bool
//   Whenever the user directly input text, this handler is called
//   before the input is applied. If it returns `true`, the default
//   behavior of actually inserting the text is suppressed.
//
//   handleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a click, from the inside out. The
//   `direct` flag will be true for the inner node.
//
//   handleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is clicked, after `handleClickOn` handlers
//   have been called.
//
//   handleDoubleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a double click.
//
//   handleDoubleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is double-clicked, after `handleDoubleClickOn`.
//
//   handleTripleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a triple click.
//
//   handleTripleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is triple-clicked, after `handleTripleClickOn`.
//
//   handlePaste:: ?(view: EditorView, event: dom.Event, slice: Slice) → bool
//   Can be used to override the behavior of pasting. `slice` is the
//   pasted content parsed by the editor, but you can directly access
//   the event to get at the raw content.
//
//   handleDrop:: ?(view: EditorView, event: dom.Event, slice: Slice, moved: bool) → bool
//   Called when something is dropped on the editor. `moved` will be
//   true if this drop moves from the current selection (which should
//   thus be deleted).
//
//   handleScrollToSelection:: ?(view: EditorView) → bool
//   Called when the view, after updating its state, tries to scroll
//   the selection into view. A handler function may return false to
//   indicate that it did not handle the scrolling and further
//   handlers or the default behavior should be tried.
//
//   createSelectionBetween:: ?(view: EditorView, anchor: ResolvedPos, head: ResolvedPos) → ?Selection
//   Can be used to override the way a selection is created when
//   reading a DOM selection between the given anchor and head.
//
//   domParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading editor changes
//   from the DOM. Defaults to calling
//   [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) on the
//   editor's schema.
//
//   transformPastedHTML:: ?(html: string) → string
//   Can be used to transform pasted HTML text, _before_ it is parsed,
//   for example to clean it up.
//
//   clipboardParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading content from
//   the clipboard. When not given, the value of the
//   [`domParser`](#view.EditorProps.domParser) prop is used.
//
//   transformPastedText:: ?(text: string) → string
//   Transform pasted plain text.
//
//   clipboardTextParser:: ?(text: string, $context: ResolvedPos) → Slice
//   A function to parse text from the clipboard into a document
//   slice. Called after
//   [`transformPastedText`](#view.EditorProps.transformPastedText).
//   The default behavior is to split the text into lines, wrap them
//   in `<p>` tags, and call
//   [`clipboardParser`](#view.EditorProps.clipboardParser) on it.
//
//   transformPasted:: ?(Slice) → Slice
//   Can be used to transform pasted content before it is applied to
//   the document.
//
//   nodeViews:: ?Object<(node: Node, view: EditorView, getPos: () → number, decorations: [Decoration]) → NodeView>
//   Allows you to pass custom rendering and behavior logic for nodes
//   and marks. Should map node and mark names to constructor
//   functions that produce a [`NodeView`](#view.NodeView) object
//   implementing the node's display behavior. For nodes, the third
//   argument `getPos` is a function that can be called to get the
//   node's current position, which can be useful when creating
//   transactions to update it. For marks, the third argument is a
//   boolean that indicates whether the mark's content is inline.
//
//   `decorations` is an array of node or inline decorations that are
//   active around the node. They are automatically drawn in the
//   normal way, and you will usually just want to ignore this, but
//   they can also be used as a way to provide context information to
//   the node view without adding it to the document itself.
//
//   clipboardSerializer:: ?DOMSerializer
//   The DOM serializer to use when putting content onto the
//   clipboard. If not given, the result of
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)
//   will be used.
//
//   clipboardTextSerializer:: ?(Slice) → string
//   A function that will be called to get the text for the current
//   selection when copying text to the clipboard. By default, the
//   editor will use [`textBetween`](#model.Node.textBetween) on the
//   selected range.
//
//   decorations:: ?(state: EditorState) → ?DecorationSet
//   A set of [document decorations](#view.Decoration) to show in the
//   view.
//
//   editable:: ?(state: EditorState) → bool
//   When this returns false, the content of the view is not directly
//   editable.
//
//   attributes:: ?union<Object<string>, (EditorState) → ?Object<string>>
//   Control the DOM attributes of the editable element. May be either
//   an object or a function going from an editor state to an object.
//   By default, the element will get a class `"ProseMirror"`, and
//   will have its `contentEditable` attribute determined by the
//   [`editable` prop](#view.EditorProps.editable). Additional classes
//   provided here will be added to the class. For other attributes,
//   the value provided first (as in
//   [`someProp`](#view.EditorView.someProp)) will be used.
//
//   scrollThreshold:: ?union<number, {top: number, right: number, bottom: number, left: number}>
//   Determines the distance (in pixels) between the cursor and the
//   end of the visible viewport at which point, when scrolling the
//   cursor into view, scrolling takes place. Defaults to 0.
//
//   scrollMargin:: ?union<number, {top: number, right: number, bottom: number, left: number}>
//   Determines the extra space (in pixels) that is left above or
//   below the cursor when it is scrolled into view. Defaults to 5.

// DirectEditorProps:: interface extends EditorProps
//
// The props object given directly to the editor view supports two
// fields that can't be used in plugins:
//
//   state:: EditorState
//   The current state of the editor.
//
//   dispatchTransaction:: ?(tr: Transaction)
//   The callback over which to send transactions (state updates)
//   produced by the view. If you specify this, you probably want to
//   make sure this ends up calling the view's
//   [`updateState`](#view.EditorView.updateState) method with a new
//   state that has the transaction
//   [applied](#state.EditorState.apply). The callback will be bound to have
//   the view instance as its `this` binding.


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["CalendarView"] = factory();
	else
		root["CalendarView"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0273":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("c1b2");
var definePropertyModule = __webpack_require__("4180");
var createPropertyDescriptor = __webpack_require__("2c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "0363":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("3ac6");
var shared = __webpack_require__("d659");
var has = __webpack_require__("78e7");
var uid = __webpack_require__("3e80");
var NATIVE_SYMBOL = __webpack_require__("1e63");
var USE_SYMBOL_AS_UID = __webpack_require__("62d0");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "06fa":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "0b11":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("2f74");

/***/ }),

/***/ "0b7b":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("8f95");
var Iterators = __webpack_require__("7463");
var wellKnownSymbol = __webpack_require__("0363");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "1316":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("9cd3");

/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1561":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "1875":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "194a":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("cc94");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("d63b");
var classof = __webpack_require__("8f95");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1e63":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("06fa");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "21b8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("a5eb");
var bind = __webpack_require__("e9d9");

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], "{").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    for (var i = 0; i < this.length; i++) {
      // eslint-disable-next-line prefer-destructuring
      var id = this[i][0];

      if (id != null) {
        alreadyImportedModules[id] = true;
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = modules[_i]; // skip already imported module
      // this implementation is not 100% perfect for weird media query combinations
      // when a module is imported multiple times with different media queries.
      // I hope this will never occur (Hey this way we have smaller bundles)

      if (item[0] == null || !alreadyImportedModules[item[0]]) {
        if (mediaQuery && !item[2]) {
          item[2] = mediaQuery;
        } else if (mediaQuery) {
          item[2] = "(".concat(item[2], ") and (").concat(mediaQuery, ")");
        }

        list.push(item);
      }
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot).concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2616":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("0363");
var Iterators = __webpack_require__("7463");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "2874":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("d63b");
var defineProperty = __webpack_require__("4180").f;
var createNonEnumerableProperty = __webpack_require__("0273");
var has = __webpack_require__("78e7");
var toString = __webpack_require__("1c0a");
var wellKnownSymbol = __webpack_require__("0363");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),

/***/ "2af1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

// `Math.sign` method
// https://tc39.github.io/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ "2c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "2dc0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("588c");

/***/ }),

/***/ "2f5a":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("96e9");
var global = __webpack_require__("3ac6");
var isObject = __webpack_require__("dfdb");
var createNonEnumerableProperty = __webpack_require__("0273");
var objectHas = __webpack_require__("78e7");
var sharedKey = __webpack_require__("b2ed");
var hiddenKeys = __webpack_require__("6e9a");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "2f74":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("68ec");


/***/ }),

/***/ "2f97":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dfdb");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3327":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("21b8");
var entryVirtual = __webpack_require__("a169");

module.exports = entryVirtual('Function').bind;


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3ac6":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3e47":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("cbd0").charAt;
var InternalStateModule = __webpack_require__("2f5a");
var defineIterator = __webpack_require__("4056");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3e80":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "4056":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("a5eb");
var createIteratorConstructor = __webpack_require__("f575");
var getPrototypeOf = __webpack_require__("5779");
var setPrototypeOf = __webpack_require__("ec62");
var setToStringTag = __webpack_require__("2874");
var createNonEnumerableProperty = __webpack_require__("0273");
var redefine = __webpack_require__("d666");
var wellKnownSymbol = __webpack_require__("0363");
var IS_PURE = __webpack_require__("7042");
var Iterators = __webpack_require__("7463");
var IteratorsCore = __webpack_require__("bb83");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "4180":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("c1b2");
var IE8_DOM_DEFINE = __webpack_require__("77b2");
var anObject = __webpack_require__("6f8d");
var toPrimitive = __webpack_require__("7168");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "41eb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("6326");


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("da84");


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44ba":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("c1b2");
var propertyIsEnumerableModule = __webpack_require__("7043");
var createPropertyDescriptor = __webpack_require__("2c6c");
var toIndexedObject = __webpack_require__("a421");
var toPrimitive = __webpack_require__("7168");
var has = __webpack_require__("78e7");
var IE8_DOM_DEFINE = __webpack_require__("77b2");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var createNonEnumerableProperty = __webpack_require__("9112");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4508":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("1561");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "46c8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".cv-header{display:flex;flex:0 1 auto;flex-flow:row nowrap;align-items:center;min-height:2.5em;border-width:1px 1px 0 1px}.cv-header .periodLabel{display:flex;flex:1 1 auto;flex-flow:row nowrap;min-height:1.5em;line-height:1;font-size:1.5em}.cv-header,.cv-header button{border-style:solid;border-color:#ddd}.cv-header-nav,.cv-header .periodLabel{margin:.1em .6em}.cv-header-nav button,.cv-header .periodLabel{padding:.4em .6em}.cv-header button{box-sizing:border-box;line-height:1em;font-size:1em;border-width:1px}", ""]);


/***/ }),

/***/ "471b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("194a");
var toObject = __webpack_require__("4fff");
var callWithSafeIterationClosing = __webpack_require__("faaa");
var isArrayIteratorMethod = __webpack_require__("2616");
var toLength = __webpack_require__("6725");
var createProperty = __webpack_require__("6c15");
var getIteratorMethod = __webpack_require__("0b7b");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty(result, index, mapping
        ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "484e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("a5eb");
var from = __webpack_require__("471b");
var checkCorrectnessOfIteration = __webpack_require__("7de7");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "4896":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("6f8d");
var defineProperties = __webpack_require__("c230");
var enumBugKeys = __webpack_require__("9e57");
var hiddenKeys = __webpack_require__("6e9a");
var html = __webpack_require__("edbd");
var documentCreateElement = __webpack_require__("7a37");
var sharedKey = __webpack_require__("b2ed");
var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('filter') }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4fff":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1875");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5145":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("9103");
var DOMIterables = __webpack_require__("78a2");
var global = __webpack_require__("3ac6");
var createNonEnumerableProperty = __webpack_require__("0273");
var Iterators = __webpack_require__("7463");
var wellKnownSymbol = __webpack_require__("0363");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && !CollectionPrototype[TO_STRING_TAG]) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56c5":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("a5eb");
var setPrototypeOf = __webpack_require__("ec62");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5779":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("78e7");
var toObject = __webpack_require__("4fff");
var sharedKey = __webpack_require__("b2ed");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("f5fb");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "588c":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("5145");
__webpack_require__("3e47");

module.exports = __webpack_require__("59d7");


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "59d7":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("8f95");
var wellKnownSymbol = __webpack_require__("0363");
var Iterators = __webpack_require__("7463");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "5ab9":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("e519");
var path = __webpack_require__("764b");

module.exports = path.Array.isArray;


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "608f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e412");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "60ae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("b39a");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "6220":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("fc48");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "62d0":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("1e63");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';


/***/ }),

/***/ "6326":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("f8b4");
var path = __webpack_require__("764b");

module.exports = path.Reflect.construct;


/***/ }),

/***/ "6386":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("a421");
var toLength = __webpack_require__("6725");
var toAbsoluteIndex = __webpack_require__("4508");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "638c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("06fa");
var classof = __webpack_require__("fc48");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6725":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("1561");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "68ec":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("56c5");
var path = __webpack_require__("764b");

module.exports = path.Object.setPrototypeOf;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6c15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("7168");
var definePropertyModule = __webpack_require__("4180");
var createPropertyDescriptor = __webpack_require__("2c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "6e77":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8cfd");


/***/ }),

/***/ "6e9a":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var nativeFunctionToString = __webpack_require__("9e81");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(nativeFunctionToString).split('toString');

shared('inspectSource', function (it) {
  return nativeFunctionToString.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
});


/***/ }),

/***/ "6f8d":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dfdb");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "7042":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "7043":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7168":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dfdb");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7463":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "74e7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("bc59");


/***/ }),

/***/ "764b":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "7685":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("3ac6");
var setGlobal = __webpack_require__("8fad");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "77b2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("c1b2");
var fails = __webpack_require__("06fa");
var createElement = __webpack_require__("7a37");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "78a2":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "78e7":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "7a37":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("3ac6");
var isObject = __webpack_require__("dfdb");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");
var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7de7":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("0363");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var nativeFunctionToString = __webpack_require__("9e81");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "88ff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("6e77");

/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8cfd":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("3327");

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind : own;
};


/***/ }),

/***/ "8f95":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("d63b");
var classofRaw = __webpack_require__("fc48");
var wellKnownSymbol = __webpack_require__("0363");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "8fad":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("3ac6");
var createNonEnumerableProperty = __webpack_require__("0273");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9103":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("a421");
var addToUnscopables = __webpack_require__("c44e");
var Iterators = __webpack_require__("7463");
var InternalStateModule = __webpack_require__("2f5a");
var defineIterator = __webpack_require__("4056");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "96e9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("3ac6");
var nativeFunctionToString = __webpack_require__("ab85");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));


/***/ }),

/***/ "9883":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("764b");
var global = __webpack_require__("3ac6");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9cd3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5ab9");


/***/ }),

/***/ "9e57":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "9e81":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");

module.exports = shared('native-function-to-string', Function.toString);


/***/ }),

/***/ "a016":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("b323");
var enumBugKeys = __webpack_require__("9e57");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "a06f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("74e7");

/***/ }),

/***/ "a0e5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("06fa");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var sloppyArrayMethod = __webpack_require__("b301");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var SLOPPY_METHOD = sloppyArrayMethod('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || SLOPPY_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a169":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("764b");

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),

/***/ "a421":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("638c");
var requireObjectCoercible = __webpack_require__("1875");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "a45d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6ad");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a5eb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("3ac6");
var getOwnPropertyDescriptor = __webpack_require__("44ba").f;
var isForced = __webpack_require__("a0e5");
var path = __webpack_require__("764b");
var bind = __webpack_require__("194a");
var createNonEnumerableProperty = __webpack_require__("0273");
var has = __webpack_require__("78e7");

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ab85":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("d659");

module.exports = shared('native-function-to-string', Function.toString);


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "b2ed":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("d659");
var uid = __webpack_require__("3e80");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "b301":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "b323":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("78e7");
var toIndexedObject = __webpack_require__("a421");
var indexOf = __webpack_require__("6386").indexOf;
var hiddenKeys = __webpack_require__("6e9a");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("f8c2");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "bb83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("5779");
var createNonEnumerableProperty = __webpack_require__("0273");
var has = __webpack_require__("78e7");
var wellKnownSymbol = __webpack_require__("0363");
var IS_PURE = __webpack_require__("7042");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "bc59":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3e47");
__webpack_require__("484e");
var path = __webpack_require__("764b");

module.exports = path.Array.from;


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c1b2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("06fa");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c230":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("c1b2");
var definePropertyModule = __webpack_require__("4180");
var anObject = __webpack_require__("6f8d");
var objectKeys = __webpack_require__("a016");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "c23c":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".cv-wrapper{display:flex;flex-direction:column;flex-grow:1;height:100%;min-height:100%;max-height:100%;overflow-x:hidden;overflow-y:hidden}.cv-wrapper,.cv-wrapper div{box-sizing:border-box;line-height:1em;font-size:1em}.cv-header-days{flex-grow:0;flex-basis:auto;border-width:0 0 0 1px}.cv-header-day,.cv-header-days{display:flex;flex-shrink:0;flex-flow:row nowrap}.cv-header-day{flex-grow:1;flex-basis:0;align-items:center;justify-content:center;text-align:center;border-width:1px 1px 0 0}.cv-weeks{flex-shrink:1;flex-basis:auto;flex-flow:column nowrap;border-width:0 0 1px 1px}.cv-week,.cv-weeks{display:flex;flex-grow:1;overflow-y:auto;-ms-overflow-style:none}.cv-week{flex-flow:row nowrap;min-height:3em;border-width:0;position:relative;width:100%}.cv-day,.cv-week{flex-shrink:0;flex-basis:0;direction:ltr}.cv-day{display:flex;flex-grow:1;position:relative;position:-webkit-sticky;position:sticky;top:0;border-width:1px 1px 0 0}.cv-day,_:-ms-lang(x){position:relative}/ .cv-day-number{position:absolute;right:0}.cv-event{position:absolute;white-space:nowrap;overflow:hidden;background-color:#f7f7f7;border-width:1px;direction:ltr}.cv-wrapper.wrap-event-title-on-hover .cv-event:hover{white-space:normal;z-index:1}.cv-day,.cv-event,.cv-header-day,.cv-header-days,.cv-week,.cv-weeks{border-style:solid;border-color:#ddd}.cv-event .endTime:before{content:\"-\"}.cv-day-number,.cv-event,.cv-header-day{padding:.2em}.cv-day-number:before{margin-right:.5em}.cv-event.offset0{left:0}.cv-event.offset1{left:14.28571%}.cv-event.offset2{left:28.57143%}.cv-event.offset3{left:42.85714%}.cv-event.offset4{left:57.14286%}.cv-event.offset5{left:71.42857%}.cv-event.offset6{left:85.71429%}.cv-event.span1{width:calc(14.28571% - .05em)}.cv-event.span2{width:calc(28.57143% - .05em)}.cv-event.span3{width:calc(42.85714% - .05em);text-align:center}.cv-event.span4{width:calc(57.14286% - .05em);text-align:center}.cv-event.span5{width:calc(71.42857% - .05em);text-align:center}.cv-event.span6{width:calc(85.71429% - .05em);text-align:center}.cv-event.span7{width:calc(100% - .05em);text-align:center}.cv-week::-webkit-scrollbar,.cv-weeks::-webkit-scrollbar{width:0;background:transparent}", ""]);


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c44e":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "c6ad":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c23c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("78370484", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cbd0":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("1561");
var requireObjectCoercible = __webpack_require__("1875");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc94":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d63b":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("0363");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "d659":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("7042");
var store = __webpack_require__("7685");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "d666":
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__("0273");

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('map') }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "dfdb":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "e412":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("46c8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2953b5c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e519":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("a5eb");
var isArray = __webpack_require__("6220");

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e9d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("cc94");
var isObject = __webpack_require__("dfdb");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "ec62":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("6f8d");
var aPossiblePrototype = __webpack_require__("2f97");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "edbd":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("9883");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "f575":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("bb83").IteratorPrototype;
var create = __webpack_require__("4896");
var createPropertyDescriptor = __webpack_require__("2c6c");
var setToStringTag = __webpack_require__("2874");
var Iterators = __webpack_require__("7463");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "f5fb":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("06fa");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f748":
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.github.io/ecma262/#sec-math.sign
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f846":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("41eb");

/***/ }),

/***/ "f8b4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("a5eb");
var getBuiltIn = __webpack_require__("9883");
var aFunction = __webpack_require__("cc94");
var anObject = __webpack_require__("6f8d");
var isObject = __webpack_require__("dfdb");
var create = __webpack_require__("4896");
var bind = __webpack_require__("e9d9");
var fails = __webpack_require__("06fa");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.github.io/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "f8c2":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "faaa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("6f8d");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"3bee7d96-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarView.vue?vue&type=template&id=22c75bca&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'cv-wrapper',
		'locale-' + _vm.languageCode(_vm.displayLocale),
		'locale-' + _vm.displayLocale,
		'y' + _vm.periodStart.getFullYear(),
		'm' + _vm.paddedMonth(_vm.periodStart),
		'period-' + _vm.displayPeriodUom,
		'periodCount-' + _vm.displayPeriodCount,
		{
			past: _vm.isPastMonth(_vm.periodStart),
			future: _vm.isFutureMonth(_vm.periodStart),
			noIntl: !_vm.supportsIntl,
		} ]},[_vm._t("header",null,{"headerProps":_vm.headerProps}),_c('div',{staticClass:"cv-header-days"},[_vm._l((_vm.weekdayNames),function(label,index){return [_vm._t("dayHeader",[_c('div',{key:_vm.getColumnDOWClass(index),staticClass:"cv-header-day",class:_vm.getColumnDOWClass(index)},[_vm._v(" "+_vm._s(label)+" ")])],{"index":_vm.getColumnDOWClass(index),"label":label})]})],2),_c('div',{staticClass:"cv-weeks"},_vm._l((_vm.weeksOfPeriod),function(weekStart,weekIndex){return _c('div',{key:(weekIndex + "-week"),class:[
				'cv-week',
				'week' + (weekIndex + 1),
				'ws' + _vm.isoYearMonthDay(weekStart) ]},[_vm._l((_vm.daysOfWeek(weekStart)),function(day,dayIndex){return _c('div',{key:_vm.getColumnDOWClass(dayIndex),class:[
					'cv-day',
					_vm.getColumnDOWClass(dayIndex),
					'd' + _vm.isoYearMonthDay(day),
					'd' + _vm.isoMonthDay(day),
					'd' + _vm.paddedDay(day),
					'instance' + _vm.instanceOfMonth(day),
					{
						today: _vm.isSameDate(day, _vm.today()),
						outsideOfMonth: !_vm.isSameMonth(day, _vm.defaultedShowDate),
						past: _vm.isInPast(day),
						future: _vm.isInFuture(day),
						last: _vm.isLastDayOfMonth(day),
						lastInstance: _vm.isLastInstanceOfMonth(day),
					} ].concat( ((_vm.dateClasses && _vm.dateClasses[_vm.isoYearMonthDay(day)]) || null) ),on:{"click":function($event){return _vm.onClickDay(day)},"drop":function($event){$event.preventDefault();return _vm.onDrop(day, $event)},"dragover":function($event){$event.preventDefault();return _vm.onDragOver(day)},"dragenter":function($event){$event.preventDefault();return _vm.onDragEnter(day, $event)},"dragleave":function($event){$event.preventDefault();return _vm.onDragLeave(day, $event)}}},[_c('div',{staticClass:"cv-day-number"},[_vm._v(_vm._s(day.getDate()))]),_vm._t("dayContent",null,{"day":day})],2)}),_vm._l((_vm.getWeekItems(weekStart)),function(e){return [_vm._t("event",[_c('div',{key:e.id,staticClass:"cv-event",class:e.classes,style:(("top:" + (_vm.getItemTop(e)) + ";" + (e.originalEvent.style))),attrs:{"draggable":_vm.enableDragDrop,"title":e.title},domProps:{"innerHTML":_vm._s(_vm.getItemTitle(e))},on:{"dragstart":function($event){return _vm.onDragStart(e, $event)},"mouseenter":function($event){return _vm.onMouseEnterItem(e, $event)},"mouseleave":function($event){return _vm.onMouseLeaveItem(e, $event)},"click":function($event){$event.stopPropagation();return _vm.onClickItem(e, $event)}}})],{"event":e,"weekStartDate":weekStart,"top":_vm.getItemTop(e)})]})],2)}),0)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CalendarView.vue?vue&type=template&id=22c75bca&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__("2af1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js
var is_array = __webpack_require__("1316");
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (is_array_default()(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/array/from.js
var from = __webpack_require__("a06f");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/is-iterable.js
var is_iterable = __webpack_require__("2dc0");
var is_iterable_default = /*#__PURE__*/__webpack_require__.n(is_iterable);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArray.js


function _iterableToArray(iter) {
  if (is_iterable_default()(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return from_default()(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/toConsumableArray.js



function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/bind.js
var bind = __webpack_require__("88ff");
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/reflect/construct.js
var construct = __webpack_require__("f846");
var construct_default = /*#__PURE__*/__webpack_require__.n(construct);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js
var set_prototype_of = __webpack_require__("0b11");
var set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(set_prototype_of);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/setPrototypeOf.js

function _setPrototypeOf(o, p) {
  _setPrototypeOf = set_prototype_of_default.a || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/construct.js




function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !construct_default.a) return false;
  if (construct_default.a.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(construct_default()(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function construct_construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct_construct = construct_default.a;
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);

      var Constructor = bind_default()(Function).apply(Parent, a);

      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: ./src/components/CalendarMathMixin.js











/*
***********************************************************
This mix-in includes a computed properties and methods that
are useful in displaying a calendar. It has no state.
***********************************************************
*/
/* harmony default export */ var CalendarMathMixin = ({
  methods: {
    // ******************************
    // Series
    // ******************************
    today: function today() {
      return this.dateOnly(new Date());
    },
    beginningOfPeriod: function beginningOfPeriod(d, periodUom, startDow) {
      switch (periodUom) {
        case "year":
          return new Date(d.getFullYear(), 0);

        case "month":
          return new Date(d.getFullYear(), d.getMonth());

        case "week":
          return this.beginningOfWeek(d, startDow);

        default:
          return null;
      }
    },
    daysOfWeek: function daysOfWeek(weekStart) {
      var _this = this;

      return Array(7).fill().map(function (_, i) {
        return _this.addDays(weekStart, i);
      });
    },
    // ********************************************
    // Date transforms that retain time of day
    // ********************************************
    addDays: function addDays(d, days) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() + days, d.getHours(), d.getMinutes(), d.getSeconds());
    },
    beginningOfWeek: function beginningOfWeek(d, startDow) {
      return this.addDays(d, (startDow - d.getDay() - 7) % -7);
    },
    endOfWeek: function endOfWeek(d, startDow) {
      return this.addDays(this.beginningOfWeek(d, startDow), 7);
    },
    // ********************************************
    // Date transforms that ignore/wipe time of day
    // ********************************************
    beginningOfMonth: function beginningOfMonth(d) {
      return new Date(d.getFullYear(), d.getMonth());
    },
    instanceOfMonth: function instanceOfMonth(d) {
      return Math.ceil(d.getDate() / 7);
    },
    // This function increments a date by a given number of date units. Accepted units are: year, month, week. For year and month,
    // the day of the month is unchanged. This could cause an unexpected result if the units are "month" and the starting day is
    // higher than the number of days in the destination month. The count can be positive or negative.
    incrementPeriod: function incrementPeriod(d, uom, count) {
      return new Date(d.getFullYear() + (uom == "year" ? count : 0), d.getMonth() + (uom == "month" ? count : 0), d.getDate() + (uom == "week" ? count * 7 : 0));
    },
    // ******************************
    // Date formatting
    // ******************************
    paddedMonth: function paddedMonth(d) {
      return ("0" + String(d.getMonth() + 1)).slice(-2);
    },
    paddedDay: function paddedDay(d) {
      return ("0" + String(d.getDate())).slice(-2);
    },
    isoYearMonth: function isoYearMonth(d) {
      return d.getFullYear() + "-" + this.paddedMonth(d);
    },
    isoYearMonthDay: function isoYearMonthDay(d) {
      return this.isoYearMonth(d) + "-" + this.paddedDay(d);
    },
    isoMonthDay: function isoMonthDay(d) {
      return this.paddedMonth(d) + "-" + this.paddedDay(d);
    },
    formattedTime: function formattedTime(d, locale, options) {
      // Assume midnight = "all day" or indeterminate time
      if (d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0) return ""; // If Intl is not supported, send back the 24-hour, zero-padded
      // hours and minutes, expressed as local time.

      if (!this.supportsIntl()) {
        var ms = new Date().getTimezoneOffset() * 60000; // TZ offset in milliseconds

        return new Date(d - ms).toISOString().slice(11, 16);
      }

      return d.toLocaleTimeString(locale, options);
    },
    // Formats a date period in long English style. Examples supported:
    // May 2018
    // May – June 2018
    // December 2018 – January 2019
    // May 6 – 26, 2018
    // May 13 – June 2, 2018
    // December 16, 2018 – January 5, 2019
    formattedPeriod: function formattedPeriod(startDate, endDate, periodUom, monthNames) {
      var singleYear = startDate.getFullYear() === endDate.getFullYear();
      var singleMonth = this.isSameMonth(startDate, endDate);
      var isYear = periodUom === "year";
      var isMonth = periodUom === "month";
      var isWeek = !isYear && !isMonth;
      var s = [];
      s.push(monthNames[startDate.getMonth()]);

      if (isWeek) {
        s.push(" ");
        s.push(startDate.getDate());
      }

      if (!singleYear) {
        s.push(isWeek ? ", " : " ");
        s.push(startDate.getFullYear());
      }

      if (!singleMonth || !singleYear) {
        s.push(" \u2013 ");

        if (!singleMonth) {
          s.push(monthNames[endDate.getMonth()]);
        }

        if (isWeek) s.push(" ");
      } else if (isWeek) {
        s.push(" \u2013 ");
      }

      if (isWeek) {
        s.push(endDate.getDate());
        s.push(", ");
      } else {
        s.push(" ");
      }

      s.push(endDate.getFullYear());
      return s.join("");
    },
    // ******************************
    // Date comparisons
    // ******************************
    // Number of whole days between two dates. If present, time of day is ignored.
    // Have to use setUTCHours to ensure that DST changes between these dates don't
    // result in a fractional answer.
    dayDiff: function dayDiff(d1, d2) {
      var endDate = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate()),
          startDate = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
      endDate.setUTCHours(0, 0, 0, 0);
      startDate.setUTCHours(0, 0, 0, 0);
      return (endDate - startDate) / 86400000;
    },
    isSameDate: function isSameDate(d1, d2) {
      // http://stackoverflow.com/questions/492994/compare-two-dates-with-javascript
      return this.dayDiff(d1, d2) === 0;
    },
    isSameDateTime: function isSameDateTime(d1, d2) {
      return d1.getTime() === d2.getTime();
    },
    isSameMonth: function isSameMonth(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
    },
    isPastMonth: function isPastMonth(d) {
      return this.beginningOfMonth(d) < this.beginningOfMonth(this.today());
    },
    isFutureMonth: function isFutureMonth(d) {
      return this.beginningOfMonth(d) > this.beginningOfMonth(this.today());
    },
    isInFuture: function isInFuture(d) {
      return this.dateOnly(d) > this.today();
    },
    isInPast: function isInPast(d) {
      return this.dateOnly(d) < this.today();
    },
    isLastInstanceOfMonth: function isLastInstanceOfMonth(d) {
      return d.getMonth() !== this.addDays(d, 7).getMonth();
    },
    isLastDayOfMonth: function isLastDayOfMonth(d) {
      return d.getMonth() !== this.addDays(d, 1).getMonth();
    },
    isSelectedDay: function isSelectedDay(d) {
      var _this2 = this;

      var day = Object.keys(this.dateClasses).find(function (day) {
        return _this2.isSameDate(_this2.fromIsoStringToLocalDate(day), d);
      });
      return day ? this.dateClasses[day] : undefined;
    },
    // Courtesy https://stackoverflow.com/questions/33908299/javascript-parse-a-string-to-date-as-local-time-zone/42626876#42626876
    fromIsoStringToLocalDate: function fromIsoStringToLocalDate(s) {
      var ds = s.split(/\D/).map(function (s) {
        return Number(s);
      });
      ds[1]--; // adjust month

      return construct_construct(Date, _toConsumableArray(ds));
    },
    toLocalDate: function toLocalDate(d) {
      return typeof d === "string" ? this.fromIsoStringToLocalDate(d) : new Date(d);
    },
    dateOnly: function dateOnly(d) {
      // Always use a copy, setHours mutates argument
      var d2 = new Date(d);
      d2.setHours(0, 0, 0, 0);
      return d2;
    },
    // ******************************
    // Localization
    // ******************************
    languageCode: function languageCode(l) {
      return l.substring(0, 2);
    },
    supportsIntl: function supportsIntl() {
      return typeof Intl !== "undefined";
    },
    getFormattedMonthNames: function getFormattedMonthNames(locale, format) {
      // Use the provided locale and format if possible to obtain the name of the month
      if (!this.supportsIntl()) return Array(12).fill("");
      var formatter = new Intl.DateTimeFormat(locale, {
        month: format
      }); // The year doesn't matter, using 2017 for convenience

      return Array(12).fill().map(function (_, i) {
        return formatter.format(new Date(2017, i, 1));
      });
    },
    getFormattedWeekdayNames: function getFormattedWeekdayNames(locale, format, startingDayOfWeek) {
      // Use the provided locale and format if possible to obtain the name of the days of the week
      if (!this.supportsIntl()) return Array(7).fill("");
      var formatter = new Intl.DateTimeFormat(locale, {
        weekday: format
      }); // 2017 starts on Sunday, so use it as the baseline date

      return Array(7).fill().map(function (_, i) {
        return formatter.format(new Date(2017, 0, (i + 1 + startingDayOfWeek) % 7));
      });
    },
    getDefaultBrowserLocale: function getDefaultBrowserLocale() {
      // If not running in the browser, cannot determine a default, return the code for unknown (blank is invalid)
      if (typeof navigator === "undefined") return "unk"; // Return the browser's language setting, implementation is browser-specific

      return (navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.browserLanguage).toLowerCase();
    },
    // ******************************
    // Events
    // ******************************
    normalizeEvent: function normalizeEvent(event, isHovered) {
      // Classes may be a string, an array, or null. Normalize to an array
      var eventClasses = event.classes ? Array.isArray(event.classes) ? _toConsumableArray(event.classes) : [event.classes] : []; // Provides support for pseudo-hover of entire event when one part of it is hovered

      if (isHovered) eventClasses.push("isHovered");
      return {
        originalEvent: event,
        startDate: this.toLocalDate(event.startDate),
        // For an event without an end date, the end date is the start date
        endDate: this.toLocalDate(event.endDate || event.startDate),
        classes: eventClasses,
        // Events without a title are untitled
        title: event.title || "Untitled",
        // An ID is *required*. Auto-generating leads to weird bugs because these are used as keys and passed in events
        id: event.id
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarView.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CalendarViewvue_type_script_lang_js_ = ({
  name: "CalendarView",
  mixins: [CalendarMathMixin],
  props: {
    showDate: {
      type: Date,
      default: undefined
    },
    displayPeriodUom: {
      type: String,
      default: "month"
    },
    displayPeriodCount: {
      type: Number,
      default: 1
    },
    locale: {
      type: String,
      default: undefined
    },
    monthNameFormat: {
      type: String,
      default: "long"
    },
    weekdayNameFormat: {
      type: String,
      default: "short"
    },
    showEventTimes: {
      type: Boolean,
      default: false
    },
    timeFormatOptions: {
      type: Object,
      default: function _default() {}
    },
    disablePast: {
      type: Boolean,
      default: false
    },
    disableFuture: {
      type: Boolean,
      default: false
    },
    enableDragDrop: {
      type: Boolean,
      default: false
    },
    startingDayOfWeek: {
      type: Number,
      default: 0
    },
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dateClasses: {
      type: Object,
      default: function _default() {}
    },
    eventTop: {
      type: String,
      default: "1.4em"
    },
    eventContentHeight: {
      type: String,
      default: "1.4em"
    },
    eventBorderHeight: {
      type: String,
      default: "2px"
    },
    periodChangedCallback: {
      type: Function,
      default: undefined
    },
    currentPeriodLabel: {
      type: String,
      default: ""
    },
    currentPeriodLabelIcons: {
      type: String,
      default: "⇤-⇥"
    },
    doEmitItemMouseEvents: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentDragItem: null,
      currentHoveredItemId: undefined
    };
  },
  computed: {
    /*
    Props cannot default to computed/method returns, so create defaulted version of this
    property and use it rather than the bare prop (Vue Issue #6013).
    */
    displayLocale: function displayLocale() {
      return this.locale || this.getDefaultBrowserLocale();
    },

    /*
    ShowDate, but defaulted to today. Needed both for periodStart below and for the
    "outside of month" class. Any time component passed as part of showDate is discarded.
    */
    defaultedShowDate: function defaultedShowDate() {
      if (this.showDate) return this.dateOnly(this.showDate);
      return this.today();
    },

    /*
    Given the showDate, defaulted to today, computes the beginning and end of the period
    that the date falls within.
    */
    periodStart: function periodStart() {
      return this.beginningOfPeriod(this.defaultedShowDate, this.displayPeriodUom, this.startingDayOfWeek);
    },
    periodEnd: function periodEnd() {
      return this.addDays(this.incrementPeriod(this.periodStart, this.displayPeriodUom, this.displayPeriodCount), -1);
    },

    /*
    For month and year views, the first and last dates displayed in the grid may not
    be the same as the intended period, since the period may not start and stop evenly
    on the starting day of the week.
    */
    displayFirstDate: function displayFirstDate() {
      return this.beginningOfWeek(this.periodStart, this.startingDayOfWeek);
    },
    displayLastDate: function displayLastDate() {
      return this.endOfWeek(this.periodEnd, this.startingDayOfWeek);
    },

    /*
    Create an array of dates, where each date represents the beginning of a week that
    should be rendered in the view for the current period.
    */
    weeksOfPeriod: function weeksOfPeriod() {
      var _this = this;

      // Returns an array of object representing the date of the beginning of each week
      // included in the view.
      var numWeeks = Math.floor((this.dayDiff(this.displayFirstDate, this.displayLastDate) + 1) / 7);
      return Array(numWeeks).fill().map(function (_, i) {
        return _this.addDays(_this.displayFirstDate, i * 7);
      });
    },
    // Cache the names based on current locale and format settings
    monthNames: function monthNames() {
      return this.getFormattedMonthNames(this.displayLocale, this.monthNameFormat);
    },
    weekdayNames: function weekdayNames() {
      return this.getFormattedWeekdayNames(this.displayLocale, this.weekdayNameFormat, this.startingDayOfWeek);
    },
    // Ensure all item properties have suitable default
    fixedItems: function fixedItems() {
      var self = this;
      return this.events.map(function (e) {
        return self.normalizeEvent(e, self.currentHoveredItemId && e.id === self.currentHoveredItemId);
      });
    },
    // Creates the HTML to render the date range for the calendar header.
    periodLabel: function periodLabel() {
      return this.formattedPeriod(this.periodStart, this.periodEnd, this.displayPeriodUom, this.monthNames);
    },
    // Period that today's date sits within
    currentPeriodStart: function currentPeriodStart() {
      return this.beginningOfPeriod(this.today(), this.displayPeriodUom, this.startingDayOfWeek);
    },
    currentPeriodEnd: function currentPeriodEnd() {
      return this.addDays(this.incrementPeriod(this.currentPeriodStart, this.displayPeriodUom, this.displayPeriodCount), -1);
    },
    currentPeriodLabelFinal: function currentPeriodLabelFinal() {
      var c = this.currentPeriodStart;
      var s = this.periodStart;
      if (!this.currentPeriodLabel) return this.formattedPeriod(c, this.currentPeriodEnd, this.displayPeriodUom, this.monthNames);
      if (this.currentPeriodLabel === "icons") return this.currentPeriodLabelIcons[Math.sign(c - s) + 1];
      return this.currentPeriodLabel;
    },
    headerProps: function headerProps() {
      return {
        // Dates for UI navigation
        previousYear: this.getIncrementedPeriod(-12),
        previousPeriod: this.getIncrementedPeriod(-1),
        nextPeriod: this.getIncrementedPeriod(1),
        previousFullPeriod: this.getIncrementedPeriod(-this.displayPeriodCount),
        nextFullPeriod: this.getIncrementedPeriod(this.displayPeriodCount),
        nextYear: this.getIncrementedPeriod(12),
        currentPeriod: this.currentPeriodStart,
        currentPeriodLabel: this.currentPeriodLabelFinal,
        // Dates for header display
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        // Extra information that could be useful to a custom header
        displayLocale: this.displayLocale,
        displayFirstDate: this.displayFirstDate,
        displayLastDate: this.displayLastDate,
        monthNames: this.monthNames,
        fixedEvents: this.fixedItems,
        periodLabel: this.periodLabel
      };
    },
    periodRange: function periodRange() {
      return {
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        displayFirstDate: this.displayFirstDate,
        displayLastDate: this.displayLastDate
      };
    }
  },
  watch: {
    periodRange: {
      immediate: true,
      handler: function handler(newVal) {
        if (this.periodChangedCallback) {
          this.$emit("period-changed");
          this.periodChangedCallback(newVal, "watch");
        }
      }
    }
  },
  methods: {
    // ******************************
    // UI Events
    // ******************************
    onClickDay: function onClickDay(day, windowEvent) {
      if (this.disablePast && this.isInPast(day)) return;
      if (this.disableFuture && this.isInFuture(day)) return;
      this.$emit("click-date", day, windowEvent);
    },
    onClickItem: function onClickItem(calendarItem, windowEvent) {
      this.$emit("click-event", calendarItem, windowEvent);
    },

    /*
    The day name header needs to know the dow for class assignment, and this value should
    not change based on startingDayOfWeek (i.e., Sunday is always 0). This function
    computes the dow for a given day index.
    */
    getColumnDOWClass: function getColumnDOWClass(dayIndex) {
      return "dow" + (dayIndex + this.startingDayOfWeek) % 7;
    },
    // ******************************
    // Date Periods
    // ******************************

    /*
    Returns a date for the current display date moved forward or backward by a given
    number of the current display units. Returns null if said move would result in a
    disallowed display period.
    */
    getIncrementedPeriod: function getIncrementedPeriod(count) {
      var newStartDate = this.incrementPeriod(this.periodStart, this.displayPeriodUom, count);
      var newEndDate = this.incrementPeriod(newStartDate, this.displayPeriodUom, this.displayPeriodCount);
      if (this.disablePast && newEndDate <= this.today()) return null;
      if (this.disableFuture && newStartDate > this.today()) return null;
      return newStartDate;
    },
    // ******************************
    // Hover items (#95, #136)
    // ******************************
    onMouseEnterItem: function onMouseEnterItem(calendarItem, windowEvent) {
      this.currentHoveredItemId = calendarItem.id;

      if (this.doEmitItemMouseEvents) {
        this.$emit("item-mouseenter", calendarItem, windowEvent);
      }
    },
    onMouseLeaveItem: function onMouseLeaveItem(calendarItem, windowEvent) {
      this.currentHoveredItemId = undefined;

      if (this.doEmitItemMouseEvents) {
        this.$emit("item-mouseleave", calendarItem, windowEvent);
      }
    },
    // ******************************
    // Drag and drop items
    // ******************************
    onDragStart: function onDragStart(calendarItem, windowEvent) {
      if (!this.enableDragDrop) return false; // Not using dataTransfer.setData to store the item ID because it (a) doesn't allow access to the data being
      // dragged during dragover, dragenter, and dragleave events, and because storing an ID requires an unnecessary
      // lookup. This does limit the drop zones to areas within this instance of this component.

      this.currentDragItem = calendarItem; // Firefox and possibly other browsers require dataTransfer to be set, even if the value is not used. IE11
      // requires that the first argument be exactly "text" (not "text/plain", etc.).

      windowEvent.dataTransfer.setData("text", "foo");
      this.$emit("drag-start", calendarItem);
      return true;
    },
    handleDragEvent: function handleDragEvent(bubbleEventName, bubbleParam) {
      if (!this.enableDragDrop) return false;

      if (!this.currentDragItem) {
        // shouldn't happen
        // If current drag item is not set, check if user has set its own slot for items
        if (!this.$scopedSlots["event"]) return false;
      }

      this.$emit(bubbleEventName, this.currentDragItem, bubbleParam);
      return true;
    },
    onDragOver: function onDragOver(day) {
      this.handleDragEvent("drag-over-date", day);
    },
    onDragEnter: function onDragEnter(day, windowEvent) {
      if (!this.handleDragEvent("drag-enter-date", day)) return;
      windowEvent.target.classList.add("draghover");
    },
    onDragLeave: function onDragLeave(day, windowEvent) {
      if (!this.handleDragEvent("drag-leave-date", day)) return;
      windowEvent.target.classList.remove("draghover");
    },
    onDrop: function onDrop(day, windowEvent) {
      if (!this.handleDragEvent("drop-on-date", day)) return;
      windowEvent.target.classList.remove("draghover");
    },
    // ******************************
    // Calendar Items
    // ******************************
    findAndSortItemsInWeek: function findAndSortItemsInWeek(weekStart) {
      var _this2 = this;

      // Return a list of items that INCLUDE any day of a week starting on a
      // particular day. Sorted so the items that start earlier are always
      // shown first.
      var items = this.fixedItems.filter(function (item) {
        return item.startDate < _this2.addDays(weekStart, 7) && item.endDate >= weekStart;
      }, this).sort(function (a, b) {
        if (a.startDate < b.startDate) return -1;
        if (b.startDate < a.startDate) return 1;
        if (a.endDate > b.endDate) return -1;
        if (b.endDate > a.endDate) return 1;
        return a.id < b.id ? -1 : 1;
      });
      return items;
    },
    getWeekItems: function getWeekItems(weekStart) {
      // Return a list of items that CONTAIN the week starting on a day.
      // Sorted so the items that start earlier are always shown first.
      var items = this.findAndSortItemsInWeek(weekStart);
      var results = [];
      var itemRows = [[], [], [], [], [], [], []];

      for (var i = 0; i < items.length; i++) {
        var ep = Object.assign({}, items[i], {
          classes: _toConsumableArray(items[i].classes),
          eventRow: 0
        });
        var continued = ep.startDate < weekStart;
        var startOffset = continued ? 0 : this.dayDiff(weekStart, ep.startDate);
        var span = Math.min(7 - startOffset, this.dayDiff(this.addDays(weekStart, startOffset), ep.endDate) + 1);
        if (continued) ep.classes.push("continued");
        if (this.dayDiff(weekStart, ep.endDate) > 6) ep.classes.push("toBeContinued");
        if (this.isInPast(ep.endDate)) ep.classes.push("past");
        if (ep.originalEvent.url) ep.classes.push("hasUrl");

        for (var d = 0; d < 7; d++) {
          if (d === startOffset) {
            var s = 0;

            while (itemRows[d][s]) {
              s++;
            }

            ep.eventRow = s;
            itemRows[d][s] = true;
          } else if (d < startOffset + span) {
            itemRows[d][ep.eventRow] = true;
          }
        }

        ep.classes.push("offset".concat(startOffset));
        ep.classes.push("span".concat(span));
        results.push(ep);
      }

      return results;
    },

    /*
    Creates the HTML to prefix the item title showing the item's start and/or
    end time. Midnight is not displayed.
    */
    getFormattedTimeRange: function getFormattedTimeRange(e) {
      var startTime = this.formattedTime(e.startDate, this.displayLocale, this.timeFormatOptions);
      var endTime = "";

      if (!this.isSameDateTime(e.startDate, e.endDate)) {
        endTime = this.formattedTime(e.endDate, this.displayLocale, this.timeFormatOptions);
      }

      return (startTime !== "" ? "<span class=\"startTime\">".concat(startTime, "</span>") : "") + (endTime !== "" ? "<span class=\"endTime\">".concat(endTime, "</span>") : "");
    },
    getItemTitle: function getItemTitle(e) {
      if (!this.showEventTimes) return e.title;
      return this.getFormattedTimeRange(e) + " " + e.title;
    },
    getItemTop: function getItemTop(e) {
      // Compute the top position of the item based on its assigned row within the given week.
      var r = e.eventRow;
      var h = this.eventContentHeight;
      var b = this.eventBorderHeight;
      return "calc(".concat(this.eventTop, " + ").concat(r, "*").concat(h, " + ").concat(r, "*").concat(b, ")");
    }
  }
});
// CONCATENATED MODULE: ./src/components/CalendarView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarViewvue_type_script_lang_js_ = (CalendarViewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarView.vue?vue&type=style&index=0&lang=css&
var CalendarViewvue_type_style_index_0_lang_css_ = __webpack_require__("a45d");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/CalendarView.vue






/* normalize component */

var component = normalizeComponent(
  components_CalendarViewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarView = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"3bee7d96-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarViewHeader.vue?vue&type=template&id=1b0c0f08&
var CalendarViewHeadervue_type_template_id_1b0c0f08_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cv-header"},[_c('div',{staticClass:"cv-header-nav"},[_c('button',{staticClass:"previousYear",attrs:{"disabled":!_vm.headerProps.previousYear},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.previousYear)}}},[_vm._v(" << ")]),_c('button',{staticClass:"previousPeriod",attrs:{"disabled":!_vm.headerProps.previousPeriod},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.previousPeriod)}}},[_vm._v(" < ")]),_c('button',{staticClass:"currentPeriod",on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.currentPeriod)}}},[_vm._v(" "+_vm._s(_vm.headerProps.currentPeriodLabel)+" ")]),_c('button',{staticClass:"nextPeriod",attrs:{"disabled":!_vm.headerProps.nextPeriod},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.nextPeriod)}}},[_vm._v(" > ")]),_c('button',{staticClass:"nextYear",attrs:{"disabled":!_vm.headerProps.nextYear},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.nextYear)}}},[_vm._v(" >> ")])]),_c('div',{staticClass:"periodLabel"},[_vm._t("label",[_vm._v(_vm._s(_vm.headerProps.periodLabel))])],2)])}
var CalendarViewHeadervue_type_template_id_1b0c0f08_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CalendarViewHeader.vue?vue&type=template&id=1b0c0f08&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarViewHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CalendarViewHeadervue_type_script_lang_js_ = ({
  name: "CalendarViewHeader",
  props: {
    headerProps: {
      type: Object,
      required: true
    }
  },
  methods: {
    onInput: function onInput(d) {
      this.$emit("input", d);
    }
  }
});
// CONCATENATED MODULE: ./src/components/CalendarViewHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarViewHeadervue_type_script_lang_js_ = (CalendarViewHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarViewHeader.vue?vue&type=style&index=0&lang=css&
var CalendarViewHeadervue_type_style_index_0_lang_css_ = __webpack_require__("608f");

// CONCATENATED MODULE: ./src/components/CalendarViewHeader.vue






/* normalize component */

var CalendarViewHeader_component = normalizeComponent(
  components_CalendarViewHeadervue_type_script_lang_js_,
  CalendarViewHeadervue_type_template_id_1b0c0f08_render,
  CalendarViewHeadervue_type_template_id_1b0c0f08_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarViewHeader = (CalendarViewHeader_component.exports);
// CONCATENATED MODULE: ./src/components/bundle.js


 // Export the compiled Vue components, and also the mixin for those who wish to use
// those methods in their own custom headers, etc.


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js
/* concated harmony reexport CalendarView */__webpack_require__.d(__webpack_exports__, "CalendarView", function() { return CalendarView; });
/* concated harmony reexport CalendarViewHeader */__webpack_require__.d(__webpack_exports__, "CalendarViewHeader", function() { return CalendarViewHeader; });
/* concated harmony reexport CalendarMathMixin */__webpack_require__.d(__webpack_exports__, "CalendarMathMixin", function() { return CalendarMathMixin; });




/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc48":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';


/***/ })

/******/ });
});
//# sourceMappingURL=CalendarView.umd.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(727);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3823eaca", content, true, {});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb73fdb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGroupRowLayout_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bb73fdb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb73fdb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGroupRowLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd211030_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailSectionRowLayout_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd211030"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd211030_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailSectionRowLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERVICE_TYPE; });
var SERVICE_TYPE = {
  NEW_BORN: "Newborn Care Specialist",
  SITTER: "Sitter",
  NANNY: "Nanny",
  PRIVATE_EDUCATOR: "Private Educator"
};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPostForm_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05848381_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPostForm_vue__ = __webpack_require__(896);
function injectStyle (ssrContext) {
  __webpack_require__(894)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPostForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05848381_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPostForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(6).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(31);
var LIBRARY = __webpack_require__(47);
var wksExt = __webpack_require__(148);
var defineProperty = __webpack_require__(14).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(68)('keys');
var uid = __webpack_require__(53);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(6).document;
module.exports = document && document.documentElement;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(5);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(32)(Function.call, __webpack_require__(29).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(103).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(34);
var defined = __webpack_require__(39);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(47);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(24);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(67);
var $iterCreate = __webpack_require__(110);
var setToStringTag = __webpack_require__(64);
var getPrototypeOf = __webpack_require__(30);
var ITERATOR = __webpack_require__(9)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(56);
var descriptor = __webpack_require__(52);
var setToStringTag = __webpack_require__(64);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(23)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(81);
var defined = __webpack_require__(39);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(9)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(67);
var ITERATOR = __webpack_require__(9)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(14);
var createDesc = __webpack_require__(52);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(65);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(67);
module.exports = __webpack_require__(31).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(456);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(10);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(49);
var step = __webpack_require__(165);
var Iterators = __webpack_require__(67);
var toIObject = __webpack_require__(28);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(109)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(71);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(80)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var invoke = __webpack_require__(155);
var html = __webpack_require__(102);
var cel = __webpack_require__(98);
var global = __webpack_require__(6);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(33)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var macrotask = __webpack_require__(121).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(33)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(19);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(12);
var LIBRARY = __webpack_require__(47);
var $typed = __webpack_require__(87);
var hide = __webpack_require__(23);
var redefineAll = __webpack_require__(61);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(59);
var toInteger = __webpack_require__(34);
var toLength = __webpack_require__(10);
var toIndex = __webpack_require__(175);
var gOPN = __webpack_require__(57).f;
var dP = __webpack_require__(14).f;
var arrayFill = __webpack_require__(117);
var setToStringTag = __webpack_require__(64);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url http://closure-compiler.googlecode.com/svn/trunk/contrib/externs/maps/google_maps_api_v3_3.js
// ==/ClosureCompiler==

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0.3
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'imagePath': (string) The base URL where the images representing
 *                  clusters will be found. The full URL will be:
 *                  {imagePath}[1-5].{imageExtension}
 *                  Default: '../images/m'.
 *     'imageExtension': (string) The suffix for images URL representing
 *                       clusters will be found. See _imagePath_ for details.
 *                       Default: 'png'.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);
  this.map_ = map;

  /**
   * @type {Array.<google.maps.Marker>}
   * @private
   */
  this.markers_ = [];

  /**
   *  @type {Array.<Cluster>}
   */
  this.clusters_ = [];

  this.sizes = [53, 56, 66, 78, 90];

  /**
   * @private
   */
  this.styles_ = [];

  /**
   * @type {boolean}
   * @private
   */
  this.ready_ = false;

  var options = opt_options || {};

  /**
   * @type {number}
   * @private
   */
  this.gridSize_ = options['gridSize'] || 60;

  /**
   * @private
   */
  this.minClusterSize_ = options['minimumClusterSize'] || 2;


  /**
   * @type {?number}
   * @private
   */
  this.maxZoom_ = options['maxZoom'] || null;

  this.styles_ = options['styles'] || [];

  /**
   * @type {string}
   * @private
   */
  this.imagePath_ = options['imagePath'] ||
      this.MARKER_CLUSTER_IMAGE_PATH_;

  /**
   * @type {string}
   * @private
   */
  this.imageExtension_ = options['imageExtension'] ||
      this.MARKER_CLUSTER_IMAGE_EXTENSION_;

  /**
   * @type {boolean}
   * @private
   */
  this.zoomOnClick_ = true;

  if (options['zoomOnClick'] != undefined) {
    this.zoomOnClick_ = options['zoomOnClick'];
  }

  /**
   * @type {boolean}
   * @private
   */
  this.averageCenter_ = false;

  if (options['averageCenter'] != undefined) {
    this.averageCenter_ = options['averageCenter'];
  }

  this.setupStyles_();

  this.setMap(map);

  /**
   * @type {number}
   * @private
   */
  this.prevZoom_ = this.map_.getZoom();

  // Add the map event listeners
  var that = this;
  google.maps.event.addListener(this.map_, 'zoom_changed', function() {
    // Determines map type and prevent illegal zoom levels
    var zoom = that.map_.getZoom();
    var minZoom = that.map_.minZoom || 0;
    var maxZoom = Math.min(that.map_.maxZoom || 100,
                         that.map_.mapTypes[that.map_.getMapTypeId()].maxZoom);
    zoom = Math.min(Math.max(zoom,minZoom),maxZoom);

    if (that.prevZoom_ != zoom) {
      that.prevZoom_ = zoom;
      that.resetViewport();
    }
  });

  google.maps.event.addListener(this.map_, 'idle', function() {
    that.redraw();
  });

  // Finally, add the markers
  if (opt_markers && (opt_markers.length || Object.keys(opt_markers).length)) {
    this.addMarkers(opt_markers, false);
  }
}


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';


/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function(obj1, obj2) {
  return (function(object) {
    for (var property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function() {
  this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function() {};

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function() {
  if (this.styles_.length) {
    return;
  }

  for (var i = 0, size; size = this.sizes[i]; i++) {
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
      height: size,
      width: size
    });
  }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function() {
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }

  this.map_.fitBounds(bounds);
};


/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function(styles) {
  this.styles_ = styles;
};


/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function() {
  return this.styles_;
};


/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function() {
  return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function() {
  return this.averageCenter_;
};


/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function() {
  return this.markers_.length;
};


/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function() {
  return this.maxZoom_;
};


/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function(markers, numStyles) {
  var index = 0;
  var count = markers.length;
  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index
  };
};


/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function(calculator) {
  this.calculator_ = calculator;
};


/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function() {
  return this.calculator_;
};


/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
  if (markers.length) {
    for (var i = 0, marker; marker = markers[i]; i++) {
      this.pushMarkerTo_(marker);
    }
  } else if (Object.keys(markers).length) {
    for (var marker in markers) {
      this.pushMarkerTo_(markers[marker]);
    }
  }
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
  marker.isAdded = false;
  if (marker['draggable']) {
    // If the marker is draggable add a listener so we update the clusters on
    // the drag end.
    var that = this;
    google.maps.event.addListener(marker, 'dragend', function() {
      marker.isAdded = false;
      that.repaint();
    });
  }
  this.markers_.push(marker);
};


/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function(marker) {
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        index = i;
        break;
      }
    }
  }

  if (index == -1) {
    // Marker is not in our list of markers.
    return false;
  }

  marker.setMap(null);

  this.markers_.splice(index, 1);

  return true;
};


/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  } else {
   return false;
  }
};


/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
  // create a local copy of markers if required
  // (removeMarker_ modifies the getMarkers() array in place)
  var markersCopy = markers === this.getMarkers() ? markers.slice() : markers;
  var removed = false;

  for (var i = 0, marker; marker = markersCopy[i]; i++) {
    var r = this.removeMarker_(marker);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  }
};


/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function(ready) {
  if (!this.ready_) {
    this.ready_ = ready;
    this.createClusters_();
  }
};


/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function() {
  return this.clusters_.length;
};


/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function() {
  return this.map_;
};


/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function(map) {
  this.map_ = map;
};


/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function() {
  return this.gridSize_;
};


/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function(size) {
  this.gridSize_ = size;
};


/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function() {
  return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function(size) {
  this.minClusterSize_ = size;
};


/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function() {
  this.resetViewport(true);

  // Set the markers a empty array.
  this.markers_ = [];
};


/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function(opt_hide) {
  // Remove all the clusters
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    cluster.remove();
  }

  // Reset the markers to not be added and to be invisible.
  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }

  this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function() {
  var oldClusters = this.clusters_.slice();
  this.clusters_.length = 0;
  this.resetViewport();
  this.redraw();

  // Remove the old clusters.
  // Do it in a timeout so the other clusters have been drawn first.
  window.setTimeout(function() {
    for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
      cluster.remove();
    }
  }, 0);
};


/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function() {
  this.createClusters_();
};


/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
  if (!p1 || !p2) {
    return 0;
  }

  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  var pos = marker.getPosition();
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    var center = cluster.getCenter();
    if (center) {
      var d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    var cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function() {
  if (!this.ready_) {
    return;
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
      this.map_.getBounds().getNorthEast());
  var bounds = this.getExtendedBounds(mapBounds);

  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      this.addToClosestCluster_(marker);
    }
  }
};


/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
  this.markerClusterer_ = markerClusterer;
  this.map_ = markerClusterer.getMap();
  this.gridSize_ = markerClusterer.getGridSize();
  this.minClusterSize_ = markerClusterer.getMinClusterSize();
  this.averageCenter_ = markerClusterer.isAverageCenter();
  this.center_ = null;
  this.markers_ = [];
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(),
      markerClusterer.getGridSize());
}

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) != -1;
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        return true;
      }
    }
  }
  return false;
};


/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function(marker) {
  if (this.isMarkerAlreadyAdded(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l-1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l-1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  var len = this.markers_.length;
  if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
    // Min cluster size not reached so show the marker.
    marker.setMap(this.map_);
  }

  if (len == this.minClusterSize_) {
    // Hide the markers that were showing.
    for (var i = 0; i < len; i++) {
      this.markers_[i].setMap(null);
    }
  }

  if (len >= this.minClusterSize_) {
    marker.setMap(null);
  }

  this.updateIcon();
  return true;
};


/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function() {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster
 */
Cluster.prototype.remove = function() {
  this.clusterIcon_.remove();
  this.markers_.length = 0;
  delete this.markers_;
};


/**
 * Returns the number of markers in the cluster.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function() {
  return this.markers_.length;
};


/**
 * Returns a list of the markers in the cluster.
 *
 * @return {Array.<google.maps.Marker>} The markers in the cluster.
 */
Cluster.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function() {
  return this.center_;
};


/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function(marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function() {
  return this.map_;
};


/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function() {
  var zoom = this.map_.getZoom();
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz && zoom > mz) {
    // The zoom is greater than our max zoom so show all the markers in cluster.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      marker.setMap(this.map_);
    }
    return;
  }

  if (this.markers_.length < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.setSums(sums);
  this.clusterIcon_.show();
};


/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.styles_ = styles;
  this.padding_ = opt_padding || 0;
  this.cluster_ = cluster;
  this.center_ = null;
  this.map_ = cluster.getMap();
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(this.map_);
}


/**
 * Triggers the clusterclick event and zoom's if the option is set.
 */
ClusterIcon.prototype.triggerClusterClick = function() {
  var markerClusterer = this.cluster_.getMarkerClusterer();

  // Trigger the clusterclick event.
  google.maps.event.trigger(markerClusterer.map_, 'clusterclick', this.cluster_);

  if (markerClusterer.isZoomOnClick()) {
    // Zoom into the cluster.
    this.map_.fitBounds(this.cluster_.getBounds());
  }
};


/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function() {
  this.div_ = document.createElement('DIV');
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.innerHTML = this.sums_.text;
  }

  var panes = this.getPanes();
  panes.overlayMouseTarget.appendChild(this.div_);

  var that = this;
  google.maps.event.addDomListener(this.div_, 'click', function() {
    that.triggerClusterClick();
  });
};


/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= parseInt(this.width_ / 2, 10);
  pos.y -= parseInt(this.height_ / 2, 10);
  return pos;
};


/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function() {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + 'px';
    this.div_.style.left = pos.x + 'px';
    this.div_.style.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
  }
};


/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function() {
  if (this.div_) {
    this.div_.style.display = 'none';
  }
  this.visible_ = false;
};


/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function() {
  if (this.div_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.style.display = '';
  }
  this.visible_ = true;
};


/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function() {
  this.setMap(null);
};


/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function() {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function(sums) {
  this.sums_ = sums;
  this.text_ = sums.text;
  this.index_ = sums.index;
  if (this.div_) {
    this.div_.innerHTML = sums.text;
  }

  this.useStyle();
};


/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function() {
  var index = Math.max(0, this.sums_.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style['url'];
  this.height_ = style['height'];
  this.width_ = style['width'];
  this.textColor_ = style['textColor'];
  this.anchor_ = style['anchor'];
  this.textSize_ = style['textSize'];
  this.backgroundPosition_ = style['backgroundPosition'];
};


/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function(center) {
  this.center_ = center;
};


/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function(pos) {
  var style = [];
  style.push('background-image:url(' + this.url_ + ');');
  var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
  style.push('background-position:' + backgroundPosition + ';');

  if (typeof this.anchor_ === 'object') {
    if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 &&
        this.anchor_[0] < this.height_) {
      style.push('height:' + (this.height_ - this.anchor_[0]) +
          'px; padding-top:' + this.anchor_[0] + 'px;');
    } else {
      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ +
          'px;');
    }
    if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 &&
        this.anchor_[1] < this.width_) {
      style.push('width:' + (this.width_ - this.anchor_[1]) +
          'px; padding-left:' + this.anchor_[1] + 'px;');
    } else {
      style.push('width:' + this.width_ + 'px; text-align:center;');
    }
  } else {
    style.push('height:' + this.height_ + 'px; line-height:' +
        this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
  }

  var txtColor = this.textColor_ ? this.textColor_ : 'black';
  var txtSize = this.textSize_ ? this.textSize_ : 11;

  style.push('cursor:pointer; top:' + pos.y + 'px; left:' +
      pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' +
      txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
  return style.join('');
};


// Export Symbols for Closure
// If you are not going to compile with closure then you can remove the
// code below.
var window = window || {};
window['MarkerClusterer'] = MarkerClusterer;
MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
MarkerClusterer.prototype['clearMarkers'] =
    MarkerClusterer.prototype.clearMarkers;
MarkerClusterer.prototype['fitMapToMarkers'] =
    MarkerClusterer.prototype.fitMapToMarkers;
MarkerClusterer.prototype['getCalculator'] =
    MarkerClusterer.prototype.getCalculator;
MarkerClusterer.prototype['getGridSize'] =
    MarkerClusterer.prototype.getGridSize;
MarkerClusterer.prototype['getExtendedBounds'] =
    MarkerClusterer.prototype.getExtendedBounds;
MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
MarkerClusterer.prototype['getTotalClusters'] =
    MarkerClusterer.prototype.getTotalClusters;
MarkerClusterer.prototype['getTotalMarkers'] =
    MarkerClusterer.prototype.getTotalMarkers;
MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
MarkerClusterer.prototype['removeMarker'] =
    MarkerClusterer.prototype.removeMarker;
MarkerClusterer.prototype['removeMarkers'] =
    MarkerClusterer.prototype.removeMarkers;
MarkerClusterer.prototype['resetViewport'] =
    MarkerClusterer.prototype.resetViewport;
MarkerClusterer.prototype['repaint'] =
    MarkerClusterer.prototype.repaint;
MarkerClusterer.prototype['setCalculator'] =
    MarkerClusterer.prototype.setCalculator;
MarkerClusterer.prototype['setGridSize'] =
    MarkerClusterer.prototype.setGridSize;
MarkerClusterer.prototype['setMaxZoom'] =
    MarkerClusterer.prototype.setMaxZoom;
MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;

Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
Cluster.prototype['getSize'] = Cluster.prototype.getSize;
Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;

ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;

Object.keys = Object.keys || function(o) {
    var result = [];
    for(var name in o) {
        if (o.hasOwnProperty(name))
          result.push(name);
    }
    return result;
};

if (true) {
  module.exports = MarkerClusterer;
}


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionColumnLayout_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1490d11c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailSectionColumnLayout_vue__ = __webpack_require__(654);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionColumnLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1490d11c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailSectionColumnLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8eed7fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBoxWithLabel_vue__ = __webpack_require__(657);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8eed7fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBoxWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2de1bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioGroup_vue__ = __webpack_require__(660);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2de1bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keydownHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keymap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_w3c_keyname__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(21);



// declare global: navigator

var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
  if (result == "Space") { result = " "; }
  var alt, ctrl, shift, meta;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { meta = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else if (/^mod$/i.test(mod)) { if (mac) { meta = true; } else { ctrl = true; } }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { result = "Alt-" + result; }
  if (ctrl) { result = "Ctrl-" + result; }
  if (meta) { result = "Meta-" + result; }
  if (shift) { result = "Shift-" + result; }
  return result
}

function normalize(map) {
  var copy = Object.create(null);
  for (var prop in map) { copy[normalizeKeyName(prop)] = map[prop]; }
  return copy
}

function modifiers(name, event, shift) {
  if (event.altKey) { name = "Alt-" + name; }
  if (event.ctrlKey) { name = "Ctrl-" + name; }
  if (event.metaKey) { name = "Meta-" + name; }
  if (shift !== false && event.shiftKey) { name = "Shift-" + name; }
  return name
}

// :: (Object) → Plugin
// Create a keymap plugin for the given set of bindings.
//
// Bindings should map key names to [command](#commands)-style
// functions, which will be called with `(EditorState, dispatch,
// EditorView)` arguments, and should return true when they've handled
// the key. Note that the view argument isn't part of the command
// protocol, but can be used as an escape hatch if a binding needs to
// directly interact with the UI.
//
// Key names may be strings like `"Shift-Ctrl-Enter"`—a key
// identifier prefixed with zero or more modifiers. Key identifiers
// are based on the strings that can appear in
// [`KeyEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
// Use lowercase letters to refer to letter keys (or uppercase letters
// if you want shift to be held). You may use `"Space"` as an alias
// for the `" "` name.
//
// Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
// `a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
// `Meta-`) are recognized. For characters that are created by holding
// shift, the `Shift-` prefix is implied, and should not be added
// explicitly.
//
// You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
// other platforms.
//
// You can add multiple keymap plugins to an editor. The order in
// which they appear determines their precedence (the ones early in
// the array get to dispatch first).
function keymap(bindings) {
  return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({props: {handleKeyDown: keydownHandler(bindings)}})
}

// :: (Object) → (view: EditorView, event: dom.Event) → bool
// Given a set of bindings (using the same format as
// [`keymap`](#keymap.keymap), return a [keydown
// handler](#view.EditorProps.handleKeyDown) that handles them.
function keydownHandler(bindings) {
  var map = normalize(bindings);
  return function(view, event) {
    var name = Object(__WEBPACK_IMPORTED_MODULE_0_w3c_keyname__["b" /* keyName */])(event), isChar = name.length == 1 && name != " ", baseName;
    var direct = map[modifiers(name, event, !isChar)];
    if (direct && direct(view.state, view.dispatch, view)) { return true }
    if (isChar && (event.shiftKey || event.altKey || event.metaKey) &&
        (baseName = __WEBPACK_IMPORTED_MODULE_0_w3c_keyname__["a" /* base */][event.keyCode]) && baseName != name) {
      var fromCode = map[modifiers(baseName, event, true)];
      if (fromCode && fromCode(view.state, view.dispatch, view)) { return true }
    } else if (isChar && event.shiftKey) {
      var withShift = map[modifiers(name, event, true)];
      if (withShift && withShift(view.state, view.dispatch, view)) { return true }
    }
    return false
  }
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export autoJoin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseKeymap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chainCommands; });
/* unused harmony export createParagraphNear */
/* unused harmony export deleteSelection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exitCode; });
/* unused harmony export joinBackward */
/* unused harmony export joinDown */
/* unused harmony export joinForward */
/* unused harmony export joinUp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lift; });
/* unused harmony export liftEmptyBlock */
/* unused harmony export macBaseKeymap */
/* unused harmony export newlineInCode */
/* unused harmony export pcBaseKeymap */
/* unused harmony export selectAll */
/* unused harmony export selectNodeBackward */
/* unused harmony export selectNodeForward */
/* unused harmony export selectParentNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setBlockType; });
/* unused harmony export splitBlock */
/* unused harmony export splitBlockKeepMarks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return wrapIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(21);




// :: (EditorState, ?(tr: Transaction)) → bool
// Delete the selection, if there is one.
function deleteSelection(state, dispatch) {
  if (state.selection.empty) { return false }
  if (dispatch) { dispatch(state.tr.deleteSelection().scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and at the start of a textblock, try to
// reduce the distance between that block and the one before it—if
// there's a block directly before it that can be joined, join them.
// If not, try to move the selected block closer to the next one in
// the document structure by lifting it out of its parent or moving it
// into a parent of the previous block. Will use the view for accurate
// (bidi-aware) start-of-textblock detection if given.
function joinBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor);

  // If there is no node before this, try to lift
  if (!$cut) {
    var range = $cursor.blockRange(), target = range && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["j" /* liftTarget */])(range);
    if (target == null) { return false }
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  var before = $cut.nodeBefore;
  // Apply the joining algorithm
  if (!before.type.spec.isolating && deleteBarrier(state, $cut, dispatch))
    { return true }

  // If the node below has no content and the node above is
  // selectable, delete the node below and select the one above.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(before, "end") || __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].isSelectable(before))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(before, "end") ? __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                      : __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(tr.doc, $cut.pos - before.nodeSize));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the node before is an atom, delete it
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView()); }
    return true
  }

  return false
}

function textblockAt(node, side) {
  for (; node; node = (side == "start" ? node.firstChild : node.lastChild))
    { if (node.isTextblock) { return true } }
  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the start of a textblock, select
// the node before that textblock, if possible. This is intended to be
// bound to keys like backspace, after
// [`joinBackward`](#commands.joinBackward) or other deleting
// commands, as a fall-back behavior when the schema doesn't allow
// deletion at the selected point.
function selectNodeBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor), node = $cut && $cut.nodeBefore;
  if (!node || !__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView()); }
  return true
}

function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    if ($pos.index(i) > 0) { return $pos.doc.resolve($pos.before(i + 1)) }
    if ($pos.node(i).type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and the cursor is at the end of a
// textblock, try to reduce or remove the boundary between that block
// and the one after it, either by joining them or by moving the other
// block closer to this one in the tree structure. Will use the view
// for accurate start-of-textblock detection if given.
function joinForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor);

  // If there is no node after this, there's nothing to do
  if (!$cut) { return false }

  var after = $cut.nodeAfter;
  // Try the joining algorithm
  if (deleteBarrier(state, $cut, dispatch)) { return true }

  // If the node above has no content and the node below is
  // selectable, delete the node above and select the one below.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(after, "start") || __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].isSelectable(after))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(after, "start") ? __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                      : __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(tr.doc, tr.mapping.map($cut.pos)));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the next node is an atom, delete it
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView()); }
    return true
  }

  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the end of a textblock, select
// the node coming after that textblock, if possible. This is intended
// to be bound to keys like delete, after
// [`joinForward`](#commands.joinForward) and similar deleting
// commands, to provide a fall-back behavior when the schema doesn't
// allow deletion at the selected point.
function selectNodeForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor), node = $cut && $cut.nodeAfter;
  if (!node || !__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(state.doc, $cut.pos)).scrollIntoView()); }
  return true
}

function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    var parent = $pos.node(i);
    if ($pos.index(i) + 1 < parent.childCount) { return $pos.doc.resolve($pos.after(i + 1)) }
    if (parent.type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block or, if there is a text selection, the
// closest ancestor block of the selection that can be joined, with
// the sibling above it.
function joinUp(state, dispatch) {
  var sel = state.selection, nodeSel = sel instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"], point;
  if (nodeSel) {
    if (sel.node.isTextblock || !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["e" /* canJoin */])(state.doc, sel.from)) { return false }
    point = sel.from;
  } else {
    point = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["i" /* joinPoint */])(state.doc, sel.from, -1);
    if (point == null) { return false }
  }
  if (dispatch) {
    var tr = state.tr.join(point);
    if (nodeSel) { tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize)); }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block, or the closest ancestor of the selection
// that can be joined, with the sibling after it.
function joinDown(state, dispatch) {
  var sel = state.selection, point;
  if (sel instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"]) {
    if (sel.node.isTextblock || !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["e" /* canJoin */])(state.doc, sel.to)) { return false }
    point = sel.to;
  } else {
    point = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["i" /* joinPoint */])(state.doc, sel.to, 1);
    if (point == null) { return false }
  }
  if (dispatch)
    { dispatch(state.tr.join(point).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Lift the selected block, or the closest ancestor block of the
// selection that can be lifted, out of its parent node.
function lift(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  var range = $from.blockRange($to), target = range && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["j" /* liftTarget */])(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the selection is in a node whose type has a truthy
// [`code`](#model.NodeSpec.code) property in its spec, replace the
// selection with a newline character.
function newlineInCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  if (dispatch) { dispatch(state.tr.insertText("\n").scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// When the selection is in a node with a truthy
// [`code`](#model.NodeSpec.code) property in its spec, create a
// default block after the code block, and move the cursor there.
function exitCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  var above = $head.node(-1), after = $head.indexAfter(-1), type = above.contentMatchAt(after).defaultType;
  if (!above.canReplaceWith(after, after, type)) { return false }
  if (dispatch) {
    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If a block node is selected, create an empty paragraph before (if
// it is its parent's first child) or after it.
function createParagraphNear(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if ($from.parent.inlineContent || $to.parent.inlineContent) { return false }
  var type = $from.parent.contentMatchAt($to.indexAfter()).defaultType;
  if (!type || !type.isTextblock) { return false }
  if (dispatch) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"].create(tr.doc, side + 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the cursor is in an empty textblock that can be lifted, lift the
// block.
function liftEmptyBlock(state, dispatch) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || $cursor.parent.content.size) { return false }
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before = $cursor.before();
    if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["f" /* canSplit */])(state.doc, before)) {
      if (dispatch) { dispatch(state.tr.split(before).scrollIntoView()); }
      return true
    }
  }
  var range = $cursor.blockRange(), target = range && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["j" /* liftTarget */])(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Split the parent block of the selection. If the selection is a text
// selection, also delete its content.
function splitBlock(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"] && state.selection.node.isBlock) {
    if (!$from.parentOffset || !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["f" /* canSplit */])(state.doc, $from.pos)) { return false }
    if (dispatch) { dispatch(state.tr.split($from.pos).scrollIntoView()); }
    return true
  }

  if (!$from.parent.isBlock) { return false }

  if (dispatch) {
    var atEnd = $to.parentOffset == $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"]) { tr.deleteSelection(); }
    var deflt = $from.depth == 0 ? null : $from.node(-1).contentMatchAt($from.indexAfter(-1)).defaultType;
    var types = atEnd && deflt ? [{type: deflt}] : null;
    var can = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["f" /* canSplit */])(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types && !can && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["f" /* canSplit */])(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{type: deflt}])) {
      types = [{type: deflt}];
      can = true;
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types);
      if (!atEnd && !$from.parentOffset && $from.parent.type != deflt &&
          $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(deflt.create(), $from.parent)))
        { tr.setNodeMarkup(tr.mapping.map($from.before()), deflt); }
    }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Acts like [`splitBlock`](#commands.splitBlock), but without
// resetting the set of active marks at the cursor.
function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && (function (tr) {
    var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) { tr.ensureMarks(marks); }
    dispatch(tr);
  }))
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Move the selection to the node wrapping the current selection, if
// any. (Will not select the document node.)
function selectParentNode(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var to = ref.to;
  var pos;
  var same = $from.sharedDepth(to);
  if (same == 0) { return false }
  pos = $from.before(same);
  if (dispatch) { dispatch(state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(state.doc, pos))); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Select the whole document.
function selectAll(state, dispatch) {
  if (dispatch) { dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["AllSelection"](state.doc))); }
  return true
}

function joinMaybeClear(state, $pos, dispatch) {
  var before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type)) { return false }
  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
    if (dispatch) { dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView()); }
    return true
  }
  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["e" /* canJoin */])(state.doc, $pos.pos)))
    { return false }
  if (dispatch)
    { dispatch(state.tr
             .clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount))
             .join($pos.pos)
             .scrollIntoView()); }
  return true
}

function deleteBarrier(state, $cut, dispatch) {
  var before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
  if (before.type.spec.isolating || after.type.spec.isolating) { return false }
  if (joinMaybeClear(state, $cut, dispatch)) { return true }

  if ($cut.parent.canReplace($cut.index(), $cut.index() + 1) &&
      (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
      match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      var end = $cut.pos + after.nodeSize, wrap = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty;
      for (var i = conn.length - 1; i >= 0; i--)
        { wrap = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(conn[i].create(null, wrap)); }
      wrap = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(before.copy(wrap));
      var tr = state.tr.step(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["b" /* ReplaceAroundStep */]($cut.pos - 1, end, $cut.pos, end, new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](wrap, 1, 0), conn.length, true));
      var joinAt = end + 2 * conn.length;
      if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["e" /* canJoin */])(tr.doc, joinAt)) { tr.join(joinAt); }
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  var selAfter = __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].findFrom($cut, 1);
  var range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["j" /* liftTarget */])(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  return false
}

// Parameterized commands

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Wrap the selection in a node of the given type with the given
// attributes.
function wrapIn(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), wrapping = range && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["h" /* findWrapping */])(range, nodeType, attrs);
    if (!wrapping) { return false }
    if (dispatch) { dispatch(state.tr.wrap(range, wrapping).scrollIntoView()); }
    return true
  }
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that tries to set the selected textblocks to the
// given node type with the given attributes.
function setBlockType(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var from = ref.from;
    var to = ref.to;
    var applicable = false;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (applicable) { return false }
      if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) { return }
      if (node.type == nodeType) {
        applicable = true;
      } else {
        var $pos = state.doc.resolve(pos), index = $pos.index();
        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
      }
    });
    if (!applicable) { return false }
    if (dispatch) { dispatch(state.tr.setBlockType(from, to, nodeType, attrs).scrollIntoView()); }
    return true
  }
}

function markApplies(doc, ranges, type) {
  var loop = function ( i ) {
    var ref = ranges[i];
    var $from = ref.$from;
    var $to = ref.$to;
    var can = $from.depth == 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (can) { return false }
      can = node.inlineContent && node.type.allowsMarkType(type);
    });
    if (can) { return { v: true } }
  };

  for (var i = 0; i < ranges.length; i++) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

// :: (MarkType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command function that toggles the given mark with the
// given attributes. Will return `false` when the current selection
// doesn't support that mark. This will remove the mark if any marks
// of that type exist in the selection, or add it otherwise. If the
// selection is empty, this applies to the [stored
// marks](#state.EditorState.storedMarks) instead of a range of the
// document.
function toggleMark(markType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var empty = ref.empty;
    var $cursor = ref.$cursor;
    var ranges = ref.ranges;
    if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType)) { return false }
    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks()))
          { dispatch(state.tr.removeStoredMark(markType)); }
        else
          { dispatch(state.tr.addStoredMark(markType.create(attrs))); }
      } else {
        var has = false, tr = state.tr;
        for (var i = 0; !has && i < ranges.length; i++) {
          var ref$1 = ranges[i];
          var $from = ref$1.$from;
          var $to = ref$1.$to;
          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
          var ref$2 = ranges[i$1];
          var $from$1 = ref$2.$from;
          var $to$1 = ref$2.$to;
          if (has) { tr.removeMark($from$1.pos, $to$1.pos, markType); }
          else { tr.addMark($from$1.pos, $to$1.pos, markType.create(attrs)); }
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true
  }
}

function wrapDispatchForJoin(dispatch, isJoinable) {
  return function (tr) {
    if (!tr.isGeneric) { return dispatch(tr) }

    var ranges = [];
    for (var i = 0; i < tr.mapping.maps.length; i++) {
      var map = tr.mapping.maps[i];
      for (var j = 0; j < ranges.length; j++)
        { ranges[j] = map.map(ranges[j]); }
      map.forEach(function (_s, _e, from, to) { return ranges.push(from, to); });
    }

    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    var joinable = [];
    for (var i$1 = 0; i$1 < ranges.length; i$1 += 2) {
      var from = ranges[i$1], to = ranges[i$1 + 1];
      var $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
        var after = parent.maybeChild(index);
        if (!after) { break }
        if (index && joinable.indexOf(pos) == -1) {
          var before = parent.child(index - 1);
          if (before.type == after.type && isJoinable(before, after))
            { joinable.push(pos); }
        }
        pos += after.nodeSize;
      }
    }
    // Join the joinable points
    joinable.sort(function (a, b) { return a - b; });
    for (var i$2 = joinable.length - 1; i$2 >= 0; i$2--) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["e" /* canJoin */])(tr.doc, joinable[i$2])) { tr.join(joinable[i$2]); }
    }
    dispatch(tr);
  }
}

// :: ((state: EditorState, ?(tr: Transaction)) → bool, union<(before: Node, after: Node) → bool, [string]>) → (state: EditorState, ?(tr: Transaction)) → bool
// Wrap a command so that, when it produces a transform that causes
// two joinable nodes to end up next to each other, those are joined.
// Nodes are considered joinable when they are of the same type and
// when the `isJoinable` predicate returns true for them or, if an
// array of strings was passed, if their node type name is in that
// array.
function autoJoin(command, isJoinable) {
  if (Array.isArray(isJoinable)) {
    var types = isJoinable;
    isJoinable = function (node) { return types.indexOf(node.type.name) > -1; };
  }
  return function (state, dispatch) { return command(state, dispatch && wrapDispatchForJoin(dispatch, isJoinable)); }
}

// :: (...[(EditorState, ?(tr: Transaction), ?EditorView) → bool]) → (EditorState, ?(tr: Transaction), ?EditorView) → bool
// Combine a number of command functions into a single function (which
// calls them one by one until one returns true).
function chainCommands() {
  var commands = [], len = arguments.length;
  while ( len-- ) commands[ len ] = arguments[ len ];

  return function(state, dispatch, view) {
    for (var i = 0; i < commands.length; i++)
      { if (commands[i](state, dispatch, view)) { return true } }
    return false
  }
}

var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);

// :: Object
// A basic keymap containing bindings not specific to any schema.
// Binds the following keys (when multiple commands are listed, they
// are chained with [`chainCommands`](#commands.chainCommands)):
//
// * **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
// * **Mod-Enter** to `exitCode`
// * **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
// * **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-a** to `selectAll`
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};

// :: Object
// A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
// **Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
// **Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
// Ctrl-Delete.
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"]
};
for (var key in pcBaseKeymap) { macBaseKeymap[key] = pcBaseKeymap[key]; }

// declare global: os, navigator
var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform)
          : typeof os != "undefined" ? os.platform() == "darwin" : false;

// :: Object
// Depending on the detected platform, this will hold
// [`pcBasekeymap`](#commands.pcBaseKeymap) or
// [`macBaseKeymap`](#commands.macBaseKeymap).
var baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputRule; });
/* unused harmony export closeDoubleQuote */
/* unused harmony export closeSingleQuote */
/* unused harmony export ellipsis */
/* unused harmony export emDash */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inputRules; });
/* unused harmony export openDoubleQuote */
/* unused harmony export openSingleQuote */
/* unused harmony export smartQuotes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return textblockTypeInputRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return undoInputRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return wrappingInputRule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__ = __webpack_require__(50);



// ::- Input rules are regular expressions describing a piece of text
// that, when typed, causes something to happen. This might be
// changing two dashes into an emdash, wrapping a paragraph starting
// with `"> "` into a blockquote, or something entirely different.
var InputRule = function InputRule(match, handler) {
  this.match = match;
  this.handler = typeof handler == "string" ? stringHandler(handler) : handler;
};

function stringHandler(string) {
  return function(state, match, start, end) {
    var insert = string;
    if (match[1]) {
      var offset = match[0].lastIndexOf(match[1]);
      insert += match[0].slice(offset + match[1].length);
      start += offset;
      var cutOff = start - end;
      if (cutOff > 0) {
        insert = match[0].slice(offset - cutOff, offset) + insert;
        start = end;
      }
    }
    return state.tr.insertText(insert, start, end)
  }
}

var MAX_MATCH = 500;

// :: (config: {rules: [InputRule]}) → Plugin
// Create an input rules plugin. When enabled, it will cause text
// input that matches any of the given rules to trigger the rule's
// action.
function inputRules(ref) {
  var rules = ref.rules;

  var plugin = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    state: {
      init: function init() { return null },
      apply: function apply(tr, prev) {
        var stored = tr.getMeta(this);
        if (stored) { return stored }
        return tr.selectionSet || tr.docChanged ? null : prev
      }
    },

    props: {
      handleTextInput: function handleTextInput(view, from, to, text) {
        return run(view, from, to, text, rules, plugin)
      },
      handleDOMEvents: {
        compositionend: function (view) {
          setTimeout(function () {
            var ref = view.state.selection;
            var $cursor = ref.$cursor;
            if ($cursor) { run(view, $cursor.pos, $cursor.pos, "", rules, plugin); }
          });
        }
      }
    },

    isInputRules: true
  });
  return plugin
}

function run(view, from, to, text, rules, plugin) {
  if (view.composing) { return false }
  var state = view.state, $from = state.doc.resolve(from);
  if ($from.parent.type.spec.code) { return false }
  var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset,
                                            null, "\ufffc") + text;
  for (var i = 0; i < rules.length; i++) {
    var match = rules[i].match.exec(textBefore);
    var tr = match && rules[i].handler(state, match, from - (match[0].length - text.length), to);
    if (!tr) { continue }
    view.dispatch(tr.setMeta(plugin, {transform: tr, from: from, to: to, text: text}));
    return true
  }
  return false
}

// :: (EditorState, ?(Transaction)) → bool
// This is a command that will undo an input rule, if applying such a
// rule was the last thing that the user did.
function undoInputRule(state, dispatch) {
  var plugins = state.plugins;
  for (var i = 0; i < plugins.length; i++) {
    var plugin = plugins[i], undoable = (void 0);
    if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
      if (dispatch) {
        var tr = state.tr, toUndo = undoable.transform;
        for (var j = toUndo.steps.length - 1; j >= 0; j--)
          { tr.step(toUndo.steps[j].invert(toUndo.docs[j])); }
        var marks = tr.doc.resolve(undoable.from).marks();
        dispatch(tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks)));
      }
      return true
    }
  }
  return false
}

// :: InputRule Converts double dashes to an emdash.
var emDash = new InputRule(/--$/, "—");
// :: InputRule Converts three dots to an ellipsis character.
var ellipsis = new InputRule(/\.\.\.$/, "…");
// :: InputRule “Smart” opening double quotes.
var openDoubleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "“");
// :: InputRule “Smart” closing double quotes.
var closeDoubleQuote = new InputRule(/"$/, "”");
// :: InputRule “Smart” opening single quotes.
var openSingleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "‘");
// :: InputRule “Smart” closing single quotes.
var closeSingleQuote = new InputRule(/'$/, "’");

// :: [InputRule] Smart-quote related input rules.
var smartQuotes = [openDoubleQuote, closeDoubleQuote, openSingleQuote, closeSingleQuote];

// :: (RegExp, NodeType, ?union<Object, ([string]) → ?Object>, ?([string], Node) → bool) → InputRule
// Build an input rule for automatically wrapping a textblock when a
// given string is typed. The `regexp` argument is
// directly passed through to the `InputRule` constructor. You'll
// probably want the regexp to start with `^`, so that the pattern can
// only occur at the start of a textblock.
//
// `nodeType` is the type of node to wrap in. If it needs attributes,
// you can either pass them directly, or pass a function that will
// compute them from the regular expression match.
//
// By default, if there's a node with the same type above the newly
// wrapped node, the rule will try to [join](#transform.Transform.join) those
// two nodes. You can pass a join predicate, which takes a regular
// expression match and the node before the wrapped node, and can
// return a boolean to indicate whether a join should happen.
function wrappingInputRule(regexp, nodeType, getAttrs, joinPredicate) {
  return new InputRule(regexp, function (state, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr.delete(start, end);
    var $start = tr.doc.resolve(start), range = $start.blockRange(), wrapping = range && Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["h" /* findWrapping */])(range, nodeType, attrs);
    if (!wrapping) { return null }
    tr.wrap(range, wrapping);
    var before = tr.doc.resolve(start - 1).nodeBefore;
    if (before && before.type == nodeType && Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["e" /* canJoin */])(tr.doc, start - 1) &&
        (!joinPredicate || joinPredicate(match, before)))
      { tr.join(start - 1); }
    return tr
  })
}

// :: (RegExp, NodeType, ?union<Object, ([string]) → ?Object>) → InputRule
// Build an input rule that changes the type of a textblock when the
// matched text is typed into it. You'll usually want to start your
// regexp with `^` to that it is only matched at the start of a
// textblock. The optional `getAttrs` parameter can be used to compute
// the new node's attributes, and works the same as in the
// `wrappingInputRule` function.
function textblockTypeInputRule(regexp, nodeType, getAttrs) {
  return new InputRule(regexp, function (state, match, start, end) {
    var $start = state.doc.resolve(start);
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) { return null }
    return state.tr
      .delete(start, end)
      .setBlockType(start, start, nodeType, attrs)
  })
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMarkAttrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMarkRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return markIsActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return nodeEqualsType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return nodeIsActive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);

    /*!
    * tiptap-utils v1.8.2
    * (c) 2019 Scrumpy UG (limited liability)
    * @license MIT
    */
  


function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function getMarkAttrs(state, type) {
  var _state$selection = state.selection,
      from = _state$selection.from,
      to = _state$selection.to;
  var marks = [];
  state.doc.nodesBetween(from, to, function (node) {
    marks = [].concat(_toConsumableArray(marks), _toConsumableArray(node.marks));
  });
  var mark = marks.find(function (markItem) {
    return markItem.type.name === type.name;
  });

  if (mark) {
    return mark.attrs;
  }

  return {};
}

function getMarkRange() {
  var $pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!$pos || !type) {
    return false;
  }

  var start = $pos.parent.childAfter($pos.parentOffset);

  if (!start.node) {
    return false;
  }

  var link = start.node.marks.find(function (mark) {
    return mark.type === type;
  });

  if (!link) {
    return false;
  }

  var startIndex = $pos.index();
  var startPos = $pos.start() + start.offset;
  var endIndex = startIndex + 1;
  var endPos = startPos + start.node.nodeSize;

  while (startIndex > 0 && link.isInSet($pos.parent.child(startIndex - 1).marks)) {
    startIndex -= 1;
    startPos -= $pos.parent.child(startIndex).nodeSize;
  }

  while (endIndex < $pos.parent.childCount && link.isInSet($pos.parent.child(endIndex).marks)) {
    endPos += $pos.parent.child(endIndex).nodeSize;
    endIndex += 1;
  }

  return {
    from: startPos,
    to: endPos
  };
}

function markIsActive(state, type) {
  var _state$selection = state.selection,
      from = _state$selection.from,
      $from = _state$selection.$from,
      to = _state$selection.to,
      empty = _state$selection.empty;

  if (empty) {
    return !!type.isInSet(state.storedMarks || $from.marks());
  }

  return !!state.doc.rangeHasMark(from, to, type);
}

function nodeEqualsType(_ref) {
  var types = _ref.types,
      node = _ref.node;
  return Array.isArray(types) && types.includes(node.type) || node.type === types;
}

function nodeIsActive(state, type) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var predicate = function predicate(node) {
    return node.type === type;
  };

  var node = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findSelectedNodeOfType"])(type)(state.selection) || Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNode"])(predicate)(state.selection);

  if (!Object.keys(attrs).length || !node) {
    return !!node;
  }

  return node.node.hasMarkup(type, attrs);
}




/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = __webpack_require__(21);
var prosemirrorModel = __webpack_require__(37);
var prosemirrorTables = __webpack_require__(229);

// :: (nodeType: union<NodeType, [NodeType]>) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a node of a given `nodeType`. It will return an original transaction if parent node hasn't been found.
//
// ```javascript
// dispatch(
//   removeParentNodeOfType(schema.nodes.table)(tr)
// );
// ```
var removeParentNodeOfType = function removeParentNodeOfType(nodeType) {
  return function (tr) {
    var parent = findParentNodeOfType(nodeType)(tr.selection);
    if (parent) {
      return removeNodeAtPos(parent.pos)(tr);
    }
    return tr;
  };
};

// :: (nodeType: union<NodeType, [NodeType]>, content: union<ProseMirrorNode, Fragment>) → (tr: Transaction) → Transaction
// Returns a new transaction that replaces parent node of a given `nodeType` with the given `content`. It will return an original transaction if either parent node hasn't been found or replacing is not possible.
//
// ```javascript
// const node = schema.nodes.paragraph.createChecked({}, schema.text('new'));
//
// dispatch(
//  replaceParentNodeOfType(schema.nodes.table, node)(tr)
// );
// ```
var replaceParentNodeOfType = function replaceParentNodeOfType(nodeType, content) {
  return function (tr) {
    if (!Array.isArray(nodeType)) {
      nodeType = [nodeType];
    }
    for (var i = 0, count = nodeType.length; i < count; i++) {
      var parent = findParentNodeOfType(nodeType[i])(tr.selection);
      if (parent) {
        var newTr = replaceNodeAtPos(parent.pos, content)(tr);
        if (newTr !== tr) {
          return newTr;
        }
      }
    }
    return tr;
  };
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes selected node. It will return an original transaction if current selection is not a `NodeSelection`.
//
// ```javascript
// dispatch(
//   removeSelectedNode(tr)
// );
// ```
var removeSelectedNode = function removeSelectedNode(tr) {
  if (isNodeSelection(tr.selection)) {
    var from = tr.selection.$from.pos;
    var to = tr.selection.$to.pos;
    return cloneTr(tr.delete(from, to));
  }
  return tr;
};

// :: (content: union<ProseMirrorNode, ProseMirrorFragment>) → (tr: Transaction) → Transaction
// Returns a new transaction that replaces selected node with a given `node`, keeping NodeSelection on the new `node`.
// It will return the original transaction if either current selection is not a NodeSelection or replacing is not possible.
//
// ```javascript
// const node = schema.nodes.paragraph.createChecked({}, schema.text('new'));
// dispatch(
//   replaceSelectedNode(node)(tr)
// );
// ```
var replaceSelectedNode = function replaceSelectedNode(content) {
  return function (tr) {
    if (isNodeSelection(tr.selection)) {
      var _tr$selection = tr.selection,
          $from = _tr$selection.$from,
          $to = _tr$selection.$to;

      if (content instanceof prosemirrorModel.Fragment && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) {
        return cloneTr(tr.replaceWith($from.pos, $to.pos, content)
        // restore node selection
        .setSelection(new prosemirrorState.NodeSelection(tr.doc.resolve($from.pos))));
      }
    }
    return tr;
  };
};

// :: (position: number, dir: ?number) → (tr: Transaction) → Transaction
// Returns a new transaction that tries to find a valid cursor selection starting at the given `position`
// and searching back if `dir` is negative, and forward if positive.
// If a valid cursor position hasn't been found, it will return the original transaction.
//
// ```javascript
// dispatch(
//   setTextSelection(5)(tr)
// );
// ```
var setTextSelection = function setTextSelection(position) {
  var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (tr) {
    var nextSelection = prosemirrorState.Selection.findFrom(tr.doc.resolve(position), dir, true);
    if (nextSelection) {
      return tr.setSelection(nextSelection);
    }
    return tr;
  };
};

var isSelectableNode = function isSelectableNode(node) {
  return node.type && node.type.spec.selectable;
};
var shouldSelectNode = function shouldSelectNode(node) {
  return isSelectableNode(node) && node.type.isLeaf;
};

var setSelection = function setSelection(node, pos, tr) {
  if (shouldSelectNode(node)) {
    return tr.setSelection(new prosemirrorState.NodeSelection(tr.doc.resolve(pos)));
  }
  return setTextSelection(pos)(tr);
};

// :: (content: union<ProseMirrorNode, Fragment>, position: ?number, tryToReplace?: boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that inserts a given `content` at the current cursor position, or at a given `position`, if it is allowed by schema. If schema restricts such nesting, it will try to find an appropriate place for a given node in the document, looping through parent nodes up until the root document node.
// If `tryToReplace` is true and current selection is a NodeSelection, it will replace selected node with inserted content if its allowed by schema.
// If cursor is inside of an empty paragraph, it will try to replace that paragraph with the given content. If insertion is successful and inserted node has content, it will set cursor inside of that content.
// It will return an original transaction if the place for insertion hasn't been found.
//
// ```javascript
// const node = schema.nodes.extension.createChecked({});
// dispatch(
//   safeInsert(node)(tr)
// );
// ```
var safeInsert = function safeInsert(content, position, tryToReplace) {
  return function (tr) {
    var hasPosition = typeof position === 'number';
    var $from = tr.selection.$from;

    var $insertPos = hasPosition ? tr.doc.resolve(position) : isNodeSelection(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
    var parent = $insertPos.parent;

    // try to replace selected node

    if (isNodeSelection(tr.selection) && tryToReplace) {
      var oldTr = tr;
      tr = replaceSelectedNode(content)(tr);
      if (oldTr !== tr) {
        return tr;
      }
    }

    // try to replace an empty paragraph
    if (isEmptyParagraph(parent)) {
      var _oldTr = tr;
      tr = replaceParentNodeOfType(parent.type, content)(tr);
      if (_oldTr !== tr) {
        var pos = isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
        $insertPos.before($insertPos.depth) : $insertPos.pos;
        return setSelection(content, pos, tr);
      }
    }

    // given node is allowed at the current cursor position
    if (canInsert($insertPos, content)) {
      tr.insert($insertPos.pos, content);
      var _pos = hasPosition ? $insertPos.pos : isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
      tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
      return cloneTr(setSelection(content, _pos, tr));
    }

    // looking for a place in the doc where the node is allowed
    for (var i = $insertPos.depth; i > 0; i--) {
      var _pos2 = $insertPos.after(i);
      var $pos = tr.doc.resolve(_pos2);
      if (canInsert($pos, content)) {
        tr.insert(_pos2, content);
        return cloneTr(setSelection(content, _pos2, tr));
      }
    }
    return tr;
  };
};

// :: (nodeType: union<NodeType, [NodeType]>, type: ?union<NodeType, null>, attrs: ?union<Object, null>, marks?: [Mark]) → (tr: Transaction) → Transaction
// Returns a transaction that changes the type, attributes, and/or marks of the parent node of a given `nodeType`.
//
// ```javascript
// const node = schema.nodes.extension.createChecked({});
// dispatch(
//   setParentNodeMarkup(schema.nodes.panel, null, { panelType })(tr);
// );
// ```
var setParentNodeMarkup = function setParentNodeMarkup(nodeType, type, attrs, marks) {
  return function (tr) {
    var parent = findParentNodeOfType(nodeType)(tr.selection);
    if (parent) {
      return cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
    }
    return tr;
  };
};

// :: (nodeType: union<NodeType, [NodeType]>) → (tr: Transaction) → Transaction
// Returns a new transaction that sets a `NodeSelection` on a parent node of a `given nodeType`.
//
// ```javascript
// dispatch(
//   selectParentNodeOfType([tableCell, tableHeader])(state.tr)
// );
// ```
var selectParentNodeOfType = function selectParentNodeOfType(nodeType) {
  return function (tr) {
    if (!isNodeSelection(tr.selection)) {
      var parent = findParentNodeOfType(nodeType)(tr.selection);
      if (parent) {
        return cloneTr(tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, parent.pos)));
      }
    }
    return tr;
  };
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that deletes previous node.
//
// ```javascript
// dispatch(
//   removeNodeBefore(state.tr)
// );
// ```
var removeNodeBefore = function removeNodeBefore(tr) {
  var position = findPositionOfNodeBefore(tr.selection);
  if (typeof position === 'number') {
    return removeNodeAtPos(position)(tr);
  }
  return tr;
};

// :: (selection: Selection) → boolean
// Checks if current selection is a `NodeSelection`.
//
// ```javascript
// if (isNodeSelection(tr.selection)) {
//   // ...
// }
// ```
var isNodeSelection = function isNodeSelection(selection) {
  return selection instanceof prosemirrorState.NodeSelection;
};

// (nodeType: union<NodeType, [NodeType]>) → boolean
// Checks if the type a given `node` equals to a given `nodeType`.
var equalNodeType = function equalNodeType(nodeType, node) {
  return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};

// (tr: Transaction) → Transaction
// Creates a new transaction object from a given transaction
var cloneTr = function cloneTr(tr) {
  return Object.assign(Object.create(tr), tr).setTime(Date.now());
};

// (position: number, content: union<ProseMirrorNode, Fragment>) → (tr: Transaction) → Transaction
// Returns a `replace` transaction that replaces a node at a given position with the given `content`.
// It will return the original transaction if replacing is not possible.
// `position` should point at the position immediately before the node.
var replaceNodeAtPos = function replaceNodeAtPos(position, content) {
  return function (tr) {
    var node = tr.doc.nodeAt(position);
    var $pos = tr.doc.resolve(position);
    if (canReplace($pos, content)) {
      tr = tr.replaceWith(position, position + node.nodeSize, content);
      var start = tr.selection.$from.pos - 1;
      // put cursor inside of the inserted node
      tr = setTextSelection(Math.max(start, 0), -1)(tr);
      // move cursor to the start of the node
      tr = setTextSelection(tr.selection.$from.start())(tr);
      return cloneTr(tr);
    }
    return tr;
  };
};

// ($pos: ResolvedPos, doc: ProseMirrorNode, content: union<ProseMirrorNode, Fragment>, ) → boolean
// Checks if replacing a node at a given `$pos` inside of the `doc` node with the given `content` is possible.
var canReplace = function canReplace($pos, content) {
  var node = $pos.node($pos.depth);
  return node && node.type.validContent(content instanceof prosemirrorModel.Fragment ? content : prosemirrorModel.Fragment.from(content));
};

// (position: number) → (tr: Transaction) → Transaction
// Returns a `delete` transaction that removes a node at a given position with the given `node`.
// `position` should point at the position immediately before the node.
var removeNodeAtPos = function removeNodeAtPos(position) {
  return function (tr) {
    var node = tr.doc.nodeAt(position);
    return cloneTr(tr.delete(position, position + node.nodeSize));
  };
};

// (schema: Schema) → {[key: string]: NodeType}
// Returns a map where keys are tableRoles and values are NodeTypes.
var tableNodeTypes = function tableNodeTypes(schema) {
  if (schema.cached.tableNodeTypes) {
    return schema.cached.tableNodeTypes;
  }
  var roles = {};
  Object.keys(schema.nodes).forEach(function (type) {
    var nodeType = schema.nodes[type];
    if (nodeType.spec.tableRole) {
      roles[nodeType.spec.tableRole] = nodeType;
    }
  });
  schema.cached.tableNodeTypes = roles;
  return roles;
};

// :: ($pos: ResolvedPos, content: union<ProseMirrorNode, Fragment>) → boolean
// Checks if a given `content` can be inserted at the given `$pos`
//
// ```javascript
// const { selection: { $from } } = state;
// const node = state.schema.nodes.atom.createChecked();
// if (canInsert($from, node)) {
//   // ...
// }
// ```
var canInsert = function canInsert($pos, content) {
  var index = $pos.index();

  if (content instanceof prosemirrorModel.Fragment) {
    return $pos.parent.canReplace(index, index, content);
  } else if (content instanceof prosemirrorModel.Node) {
    return $pos.parent.canReplaceWith(index, index, content.type);
  }
  return false;
};

// (node: ProseMirrorNode) → boolean
// Checks if a given `node` is an empty paragraph
var isEmptyParagraph = function isEmptyParagraph(node) {
  return !node || node.type.name === 'paragraph' && node.nodeSize === 2;
};

// ($pos: ResolvedPos) → ?{pos: number, start: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning a table node closest to a given `$pos`.
//
// ```javascript
// const table = findTableClosestToPos(state.doc.resolve(10));
// ```
var findTableClosestToPos = function findTableClosestToPos($pos) {
  var predicate = function predicate(node) {
    return node.type.spec.tableRole && /table/i.test(node.type.spec.tableRole);
  };
  return findParentNodeClosestToPos($pos, predicate);
};

var createCell = function createCell(cellType) {
  var cellContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (cellContent) {
    return cellType.createChecked(null, cellContent);
  }

  return cellType.createAndFill();
};

// (rect: {left: number, right: number, top: number, bottom: number}) → (selection: Selection) → boolean
// Checks if a given CellSelection rect is selected
var isRectSelected = function isRectSelected(rect) {
  return function (selection) {
    var map = prosemirrorTables.TableMap.get(selection.$anchorCell.node(-1));
    var start = selection.$anchorCell.start(-1);
    var cells = map.cellsInRect(rect);
    var selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));

    for (var i = 0, count = cells.length; i < count; i++) {
      if (selectedCells.indexOf(cells[i]) === -1) {
        return false;
      }
    }

    return true;
  };
};

// This function transposes an array of array flipping the columns for rows,
// transposition is a familiar algebra concept;
// you can get more details here:
// https://en.wikipedia.org/wiki/Transpose
//
// ```javascript
//
//  const arr = [
//    ['a1', 'a2', 'a3'],
//    ['b1', 'b2', 'b3'],
//    ['c1', 'c2', 'c3'],
//    ['d1', 'd2', 'd3'],
//  ];
//
//  const result = transpose(arr);
//
//  result === [
//    ['a1', 'b1', 'c1', 'd1'],
//    ['a2', 'b2', 'c2', 'd2'],
//    ['a3', 'b3', 'c3', 'd3'],
//  ]
// ```
var transpose = function transpose(array) {
  return array[0].map(function (_, i) {
    return array.map(function (column) {
      return column[i];
    });
  });
};

// :: (tableNode: Node) -> Array<Node>
// This function will transform the table node
// into a matrix of rows and columns respecting merged cells,
// for example this table will be convert to the below:
//
// ```
//  ____________________________
// |      |      |             |
// |  A1  |  B1  |     C1      |
// |______|______|______ ______|
// |      |             |      |
// |  A2  |     B2      |      |
// |______|______ ______|      |
// |      |      |      |  D1  |
// |  A3  |  B3  |  C2  |      |
// |______|______|______|______|
// ```
//
//
// ```javascript
// array = [
//   [A1, B1, C1, null],
//   [A2, B2, null, D1],
//   [A3. B3, C2, null],
// ]
// ```
var convertTableNodeToArrayOfRows = function convertTableNodeToArrayOfRows(tableNode) {
  var map = prosemirrorTables.TableMap.get(tableNode);
  var rows = [];
  for (var rowIndex = 0; rowIndex < map.height; rowIndex++) {
    var rowCells = [];
    var seen = {};

    for (var colIndex = 0; colIndex < map.width; colIndex++) {
      var cellPos = map.map[rowIndex * map.width + colIndex];
      var cell = tableNode.nodeAt(cellPos);
      var rect = map.findCell(cellPos);
      if (seen[cellPos] || rect.top !== rowIndex) {
        rowCells.push(null);
        continue;
      }
      seen[cellPos] = true;

      rowCells.push(cell);
    }

    rows.push(rowCells);
  }

  return rows;
};

// :: (tableNode: Node, tableArray: Array<Node>) -> Node
// This function will transform a matrix of nodes
// into table node respecting merged cells and rows configurations,
// for example this array will be convert to the table below:
//
// ```javascript
// array = [
//   [A1, B1, C1, null],
//   [A2, B2, null, D1],
//   [A3. B3, C2, null],
// ]
// ```
//
// ```
//  ____________________________
// |      |      |             |
// |  A1  |  B1  |     C1      |
// |______|______|______ ______|
// |      |             |      |
// |  A2  |     B2      |      |
// |______|______ ______|      |
// |      |      |      |  D1  |
// |  A3  |  B3  |  C2  |      |
// |______|______|______|______|
// ```
//
var convertArrayOfRowsToTableNode = function convertArrayOfRowsToTableNode(tableNode, arrayOfNodes) {
  var rowsPM = [];
  var map = prosemirrorTables.TableMap.get(tableNode);
  for (var rowIndex = 0; rowIndex < map.height; rowIndex++) {
    var row = tableNode.child(rowIndex);
    var rowCells = [];

    for (var colIndex = 0; colIndex < map.width; colIndex++) {
      if (!arrayOfNodes[rowIndex][colIndex]) {
        continue;
      }
      var cellPos = map.map[rowIndex * map.width + colIndex];

      var cell = arrayOfNodes[rowIndex][colIndex];
      var oldCell = tableNode.nodeAt(cellPos);
      var newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
      rowCells.push(newCell);
    }

    rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
  }

  var newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);

  return newTable;
};

var moveTableColumn = function moveTableColumn(table, indexesOrigin, indexesTarget, direction) {
  var rows = transpose(convertTableNodeToArrayOfRows(table.node));

  rows = moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
  rows = transpose(rows);

  return convertArrayOfRowsToTableNode(table.node, rows);
};

var moveTableRow = function moveTableRow(table, indexesOrigin, indexesTarget, direction) {
  var rows = convertTableNodeToArrayOfRows(table.node);

  rows = moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);

  return convertArrayOfRowsToTableNode(table.node, rows);
};

var moveRowInArrayOfRows = function moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, directionOverride) {
  var direction = indexesOrigin[0] > indexesTarget[0] ? -1 : 1;

  var rowsExtracted = rows.splice(indexesOrigin[0], indexesOrigin.length);
  var positionOffset = rowsExtracted.length % 2 === 0 ? 1 : 0;
  var target = void 0;

  if (directionOverride === -1 && direction === 1) {
    target = indexesTarget[0] - 1;
  } else if (directionOverride === 1 && direction === -1) {
    target = indexesTarget[indexesTarget.length - 1] - positionOffset + 1;
  } else {
    target = direction === -1 ? indexesTarget[0] : indexesTarget[indexesTarget.length - 1] - positionOffset;
  }

  rows.splice.apply(rows, [target, 0].concat(rowsExtracted));
  return rows;
};

var checkInvalidMovements = function checkInvalidMovements(originIndex, targetIndex, targets, type) {
  var direction = originIndex > targetIndex ? -1 : 1;
  var errorMessage = 'Target position is invalid, you can\'t move the ' + type + ' ' + originIndex + ' to ' + targetIndex + ', the target can\'t be split. You could use tryToFit option.';

  if (direction === 1) {
    if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) {
      throw new Error(errorMessage);
    }
  } else {
    if (targets.slice(1).indexOf(targetIndex) !== -1) {
      throw new Error(errorMessage);
    }
  }

  return true;
};

// :: (predicate: (node: ProseMirrorNode) → boolean) → (selection: Selection) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning the closest node and its start position `predicate` returns truthy for. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const predicate = node => node.type === schema.nodes.blockquote;
// const parent = findParentNode(predicate)(selection);
// ```
var findParentNode = function findParentNode(predicate) {
  return function (_ref) {
    var $from = _ref.$from;
    return findParentNodeClosestToPos($from, predicate);
  };
};

// :: ($pos: ResolvedPos, predicate: (node: ProseMirrorNode) → boolean) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes starting from the given `$pos`, returning the closest node and its start position `predicate` returns truthy for. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const predicate = node => node.type === schema.nodes.blockquote;
// const parent = findParentNodeClosestToPos(state.doc.resolve(5), predicate);
// ```
var findParentNodeClosestToPos = function findParentNodeClosestToPos($pos, predicate) {
  for (var i = $pos.depth; i > 0; i--) {
    var node = $pos.node(i);
    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node: node
      };
    }
  }
};

// :: (predicate: (node: ProseMirrorNode) → boolean, domAtPos: (pos: number) → {node: dom.Node, offset: number}) → (selection: Selection) → ?dom.Node
// Iterates over parent nodes, returning DOM reference of the closest node `predicate` returns truthy for.
//
// ```javascript
// const domAtPos = view.domAtPos.bind(view);
// const predicate = node => node.type === schema.nodes.table;
// const parent = findParentDomRef(predicate, domAtPos)(selection); // <table>
// ```
var findParentDomRef = function findParentDomRef(predicate, domAtPos) {
  return function (selection) {
    var parent = findParentNode(predicate)(selection);
    if (parent) {
      return findDomRefAtPos(parent.pos, domAtPos);
    }
  };
};

// :: (predicate: (node: ProseMirrorNode) → boolean) → (selection: Selection) → boolean
// Checks if there's a parent node `predicate` returns truthy for.
//
// ```javascript
// if (hasParentNode(node => node.type === schema.nodes.table)(selection)) {
//   // ....
// }
// ```
var hasParentNode = function hasParentNode(predicate) {
  return function (selection) {
    return !!findParentNode(predicate)(selection);
  };
};

// :: (nodeType: union<NodeType, [NodeType]>) → (selection: Selection) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning closest node of a given `nodeType`. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const parent = findParentNodeOfType(schema.nodes.paragraph)(selection);
// ```
var findParentNodeOfType = function findParentNodeOfType(nodeType) {
  return function (selection) {
    return findParentNode(function (node) {
      return equalNodeType(nodeType, node);
    })(selection);
  };
};

// :: ($pos: ResolvedPos, nodeType: union<NodeType, [NodeType]>) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes starting from the given `$pos`, returning closest node of a given `nodeType`. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const parent = findParentNodeOfTypeClosestToPos(state.doc.resolve(10), schema.nodes.paragraph);
// ```
var findParentNodeOfTypeClosestToPos = function findParentNodeOfTypeClosestToPos($pos, nodeType) {
  return findParentNodeClosestToPos($pos, function (node) {
    return equalNodeType(nodeType, node);
  });
};

// :: (nodeType: union<NodeType, [NodeType]>) → (selection: Selection) → boolean
// Checks if there's a parent node of a given `nodeType`.
//
// ```javascript
// if (hasParentNodeOfType(schema.nodes.table)(selection)) {
//   // ....
// }
// ```
var hasParentNodeOfType = function hasParentNodeOfType(nodeType) {
  return function (selection) {
    return hasParentNode(function (node) {
      return equalNodeType(nodeType, node);
    })(selection);
  };
};

// :: (nodeType: union<NodeType, [NodeType]>, domAtPos: (pos: number) → {node: dom.Node, offset: number}) → (selection: Selection) → ?dom.Node
// Iterates over parent nodes, returning DOM reference of the closest node of a given `nodeType`.
//
// ```javascript
// const domAtPos = view.domAtPos.bind(view);
// const parent = findParentDomRefOfType(schema.nodes.codeBlock, domAtPos)(selection); // <pre>
// ```
var findParentDomRefOfType = function findParentDomRefOfType(nodeType, domAtPos) {
  return function (selection) {
    return findParentDomRef(function (node) {
      return equalNodeType(nodeType, node);
    }, domAtPos)(selection);
  };
};

// :: (nodeType: union<NodeType, [NodeType]>) → (selection: Selection) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Returns a node of a given `nodeType` if it is selected. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const { extension, inlineExtension, bodiedExtension } = schema.nodes;
// const selectedNode = findSelectedNodeOfType([
//   extension,
//   inlineExtension,
//   bodiedExtension,
// ])(selection);
// ```
var findSelectedNodeOfType = function findSelectedNodeOfType(nodeType) {
  return function (selection) {
    if (isNodeSelection(selection)) {
      var node = selection.node,
          $from = selection.$from;

      if (equalNodeType(nodeType, node)) {
        return { node: node, pos: $from.pos, depth: $from.depth };
      }
    }
  };
};

// :: (selection: Selection) → ?number
// Returns position of the previous node.
//
// ```javascript
// const pos = findPositionOfNodeBefore(tr.selection);
// ```
var findPositionOfNodeBefore = function findPositionOfNodeBefore(selection) {
  var nodeBefore = selection.$from.nodeBefore;

  var maybeSelection = prosemirrorState.Selection.findFrom(selection.$from, -1);
  if (maybeSelection && nodeBefore) {
    // leaf node
    var parent = findParentNodeOfType(nodeBefore.type)(maybeSelection);
    if (parent) {
      return parent.pos;
    }
    return maybeSelection.$from.pos;
  }
};

// :: (position: number, domAtPos: (pos: number) → {node: dom.Node, offset: number}) → dom.Node
// Returns DOM reference of a node at a given `position`. If the node type is of type `TEXT_NODE` it will return the reference of the parent node.
//
// ```javascript
// const domAtPos = view.domAtPos.bind(view);
// const ref = findDomRefAtPos($from.pos, domAtPos);
// ```
var findDomRefAtPos = function findDomRefAtPos(position, domAtPos) {
  var dom = domAtPos(position);
  var node = dom.node.childNodes[dom.offset];

  if (dom.node.nodeType === Node.TEXT_NODE) {
    return dom.node.parentNode;
  }

  if (!node || node.nodeType === Node.TEXT_NODE) {
    return dom.node;
  }

  return node;
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Flattens descendants of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const children = flatten(node);
// ```
var flatten = function flatten(node) {
  var descend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!node) {
    throw new Error('Invalid "node" parameter');
  }
  var result = [];
  node.descendants(function (child, pos) {
    result.push({ node: child, pos: pos });
    if (!descend) {
      return false;
    }
  });
  return result;
};

// :: (node: ProseMirrorNode, predicate: (node: ProseMirrorNode) → boolean, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes predicate returns truthy for. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const textNodes = findChildren(node, child => child.isText, false);
// ```
var findChildren = function findChildren(node, predicate, descend) {
  if (!node) {
    throw new Error('Invalid "node" parameter');
  } else if (!predicate) {
    throw new Error('Invalid "predicate" parameter');
  }
  return flatten(node, descend).filter(function (child) {
    return predicate(child.node);
  });
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Returns text nodes of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const textNodes = findTextNodes(node);
// ```
var findTextNodes = function findTextNodes(node, descend) {
  return findChildren(node, function (child) {
    return child.isText;
  }, descend);
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Returns inline nodes of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const inlineNodes = findInlineNodes(node);
// ```
var findInlineNodes = function findInlineNodes(node, descend) {
  return findChildren(node, function (child) {
    return child.isInline;
  }, descend);
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Returns block descendants of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const blockNodes = findBlockNodes(node);
// ```
var findBlockNodes = function findBlockNodes(node, descend) {
  return findChildren(node, function (child) {
    return child.isBlock;
  }, descend);
};

// :: (node: ProseMirrorNode, predicate: (attrs: ?Object) → boolean, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes predicate returns truthy for. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const mergedCells = findChildrenByAttr(table, attrs => attrs.colspan === 2);
// ```
var findChildrenByAttr = function findChildrenByAttr(node, predicate, descend) {
  return findChildren(node, function (child) {
    return !!predicate(child.attrs);
  }, descend);
};

// :: (node: ProseMirrorNode, nodeType: NodeType, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes of a given nodeType. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const cells = findChildrenByType(table, schema.nodes.tableCell);
// ```
var findChildrenByType = function findChildrenByType(node, nodeType, descend) {
  return findChildren(node, function (child) {
    return child.type === nodeType;
  }, descend);
};

// :: (node: ProseMirrorNode, markType: markType, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes that have a mark of a given markType. It doesn't descend into a `node` when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const nodes = findChildrenByMark(state.doc, schema.marks.strong);
// ```
var findChildrenByMark = function findChildrenByMark(node, markType, descend) {
  return findChildren(node, function (child) {
    return markType.isInSet(child.marks);
  }, descend);
};

// :: (node: ProseMirrorNode, nodeType: NodeType) → boolean
// Returns `true` if a given node contains nodes of a given `nodeType`
//
// ```javascript
// if (contains(panel, schema.nodes.listItem)) {
//   // ...
// }
// ```
var contains = function contains(node, nodeType) {
  return !!findChildrenByType(node, nodeType).length;
};

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// :: (selection: Selection) → ?{pos: number, start: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning the closest table node.
//
// ```javascript
// const table = findTable(selection);
// ```
var findTable = function findTable(selection) {
  return findParentNode(function (node) {
    return node.type.spec.tableRole && node.type.spec.tableRole === 'table';
  })(selection);
};

// :: (selection: Selection) → boolean
// Checks if current selection is a `CellSelection`.
//
// ```javascript
// if (isCellSelection(selection)) {
//   // ...
// }
// ```
var isCellSelection = function isCellSelection(selection) {
  return selection instanceof prosemirrorTables.CellSelection;
};

// :: (selection: Selection) → ?{left: number, right: number, top: number, bottom: number}
// Get the selection rectangle. Returns `undefined` if selection is not a CellSelection.
//
// ```javascript
// const rect = getSelectionRect(selection);
// ```
var getSelectionRect = function getSelectionRect(selection) {
  if (!isCellSelection(selection)) {
    return;
  }
  var start = selection.$anchorCell.start(-1);
  var map = prosemirrorTables.TableMap.get(selection.$anchorCell.node(-1));
  return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

// :: (columnIndex: number) → (selection: Selection) → boolean
// Checks if entire column at index `columnIndex` is selected.
//
// ```javascript
// const className = isColumnSelected(i)(selection) ? 'selected' : '';
// ```
var isColumnSelected = function isColumnSelected(columnIndex) {
  return function (selection) {
    if (isCellSelection(selection)) {
      var map = prosemirrorTables.TableMap.get(selection.$anchorCell.node(-1));
      return isRectSelected({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
      })(selection);
    }

    return false;
  };
};

// :: (rowIndex: number) → (selection: Selection) → boolean
// Checks if entire row at index `rowIndex` is selected.
//
// ```javascript
// const className = isRowSelected(i)(selection) ? 'selected' : '';
// ```
var isRowSelected = function isRowSelected(rowIndex) {
  return function (selection) {
    if (isCellSelection(selection)) {
      var map = prosemirrorTables.TableMap.get(selection.$anchorCell.node(-1));
      return isRectSelected({
        left: 0,
        right: map.width,
        top: rowIndex,
        bottom: rowIndex + 1
      })(selection);
    }

    return false;
  };
};

// :: (selection: Selection) → boolean
// Checks if entire table is selected
//
// ```javascript
// const className = isTableSelected(selection) ? 'selected' : '';
// ```
var isTableSelected = function isTableSelected(selection) {
  if (isCellSelection(selection)) {
    var map = prosemirrorTables.TableMap.get(selection.$anchorCell.node(-1));
    return isRectSelected({
      left: 0,
      right: map.width,
      top: 0,
      bottom: map.height
    })(selection);
  }

  return false;
};

// :: (columnIndex: union<number, [number]>) → (selection: Selection) → ?[{pos: number, start: number, node: ProseMirrorNode}]
// Returns an array of cells in a column(s), where `columnIndex` could be a column index or an array of column indexes.
//
// ```javascript
// const cells = getCellsInColumn(i)(selection); // [{node, pos}, {node, pos}]
// ```
var getCellsInColumn = function getCellsInColumn(columnIndex) {
  return function (selection) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var indexes = Array.isArray(columnIndex) ? columnIndex : Array.from([columnIndex]);
      return indexes.reduce(function (acc, index) {
        if (index >= 0 && index <= map.width - 1) {
          var cells = map.cellsInRect({
            left: index,
            right: index + 1,
            top: 0,
            bottom: map.height
          });
          return acc.concat(cells.map(function (nodePos) {
            var node = table.node.nodeAt(nodePos);
            var pos = nodePos + table.start;
            return { pos: pos, start: pos + 1, node: node };
          }));
        }
      }, []);
    }
  };
};

// :: (rowIndex: union<number, [number]>) → (selection: Selection) → ?[{pos: number, start: number, node: ProseMirrorNode}]
// Returns an array of cells in a row(s), where `rowIndex` could be a row index or an array of row indexes.
//
// ```javascript
// const cells = getCellsInRow(i)(selection); // [{node, pos}, {node, pos}]
// ```
var getCellsInRow = function getCellsInRow(rowIndex) {
  return function (selection) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var indexes = Array.isArray(rowIndex) ? rowIndex : Array.from([rowIndex]);
      return indexes.reduce(function (acc, index) {
        if (index >= 0 && index <= map.height - 1) {
          var cells = map.cellsInRect({
            left: 0,
            right: map.width,
            top: index,
            bottom: index + 1
          });
          return acc.concat(cells.map(function (nodePos) {
            var node = table.node.nodeAt(nodePos);
            var pos = nodePos + table.start;
            return { pos: pos, start: pos + 1, node: node };
          }));
        }
      }, []);
    }
  };
};

// :: (selection: Selection) → ?[{pos: number, start: number, node: ProseMirrorNode}]
// Returns an array of all cells in a table.
//
// ```javascript
// const cells = getCellsInTable(selection); // [{node, pos}, {node, pos}]
// ```
var getCellsInTable = function getCellsInTable(selection) {
  var table = findTable(selection);
  if (table) {
    var map = prosemirrorTables.TableMap.get(table.node);
    var cells = map.cellsInRect({
      left: 0,
      right: map.width,
      top: 0,
      bottom: map.height
    });
    return cells.map(function (nodePos) {
      var node = table.node.nodeAt(nodePos);
      var pos = nodePos + table.start;
      return { pos: pos, start: pos + 1, node: node };
    });
  }
};

var select = function select(type) {
  return function (index, expand) {
    return function (tr) {
      var table = findTable(tr.selection);
      var isRowSelection = type === 'row';
      if (table) {
        var map = prosemirrorTables.TableMap.get(table.node);

        // Check if the index is valid
        if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
          var left = isRowSelection ? 0 : index;
          var top = isRowSelection ? index : 0;
          var right = isRowSelection ? map.width : index + 1;
          var bottom = isRowSelection ? index + 1 : map.height;

          if (expand) {
            var cell = findCellClosestToPos(tr.selection.$from);
            if (!cell) {
              return tr;
            }

            var selRect = map.findCell(cell.pos - table.start);
            if (isRowSelection) {
              top = Math.min(top, selRect.top);
              bottom = Math.max(bottom, selRect.bottom);
            } else {
              left = Math.min(left, selRect.left);
              right = Math.max(right, selRect.right);
            }
          }

          var cellsInFirstRow = map.cellsInRect({
            left: left,
            top: top,
            right: isRowSelection ? right : left + 1,
            bottom: isRowSelection ? top + 1 : bottom
          });

          var cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
            left: isRowSelection ? left : right - 1,
            top: isRowSelection ? bottom - 1 : top,
            right: right,
            bottom: bottom
          });

          var head = table.start + cellsInFirstRow[0];
          var anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
          var $head = tr.doc.resolve(head);
          var $anchor = tr.doc.resolve(anchor);

          return cloneTr(tr.setSelection(new prosemirrorTables.CellSelection($anchor, $head)));
        }
      }
      return tr;
    };
  };
};

// :: (columnIndex: number, expand: ?boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that creates a `CellSelection` on a column at index `columnIndex`.
// Use the optional `expand` param to extend from current selection.
//
// ```javascript
// dispatch(
//   selectColumn(i)(state.tr)
// );
// ```
var selectColumn = select('column');

// :: (rowIndex: number, expand: ?boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that creates a `CellSelection` on a column at index `rowIndex`.
// Use the optional `expand` param to extend from current selection.
//
// ```javascript
// dispatch(
//   selectRow(i)(state.tr)
// );
// ```
var selectRow = select('row');

// :: (selection: Selection) → (tr: Transaction) → Transaction
// Returns a new transaction that creates a `CellSelection` on the entire table.
//
// ```javascript
// dispatch(
//   selectTable(i)(state.tr)
// );
// ```
var selectTable = function selectTable(tr) {
  var table = findTable(tr.selection);
  if (table) {
    var _TableMap$get = prosemirrorTables.TableMap.get(table.node),
        map = _TableMap$get.map;

    if (map && map.length) {
      var head = table.start + map[0];
      var anchor = table.start + map[map.length - 1];
      var $head = tr.doc.resolve(head);
      var $anchor = tr.doc.resolve(anchor);

      return cloneTr(tr.setSelection(new prosemirrorTables.CellSelection($anchor, $head)));
    }
  }
  return tr;
};

// :: (cell: {pos: number, node: ProseMirrorNode}, schema: Schema) → (tr: Transaction) → Transaction
// Returns a new transaction that clears the content of a given `cell`.
//
// ```javascript
// const $pos = state.doc.resolve(13);
// dispatch(
//   emptyCell(findCellClosestToPos($pos), state.schema)(state.tr)
// );
// ```
var emptyCell = function emptyCell(cell, schema) {
  return function (tr) {
    if (cell) {
      var _tableNodeTypes$cell$ = tableNodeTypes(schema).cell.createAndFill(),
          content = _tableNodeTypes$cell$.content;

      if (!cell.node.content.eq(content)) {
        tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, content);
        return cloneTr(tr);
      }
    }
    return tr;
  };
};

// :: (columnIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that adds a new column at index `columnIndex`.
//
// ```javascript
// dispatch(
//   addColumnAt(i)(state.tr)
// );
// ```
var addColumnAt = function addColumnAt(columnIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      if (columnIndex >= 0 && columnIndex <= map.width) {
        return cloneTr(prosemirrorTables.addColumn(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, columnIndex));
      }
    }
    return tr;
  };
};

// :: (originRowIndex: number, targetRowIndex: targetColumnIndex, options?: MovementOptions) → (tr: Transaction) → Transaction
// Returns a new transaction that moves the origin row to the target index;
//
// by default "tryToFit" is false, that means if you try to move a row to a place
// where we will need to split a row with merged cells it'll throw an exception, for example:
//
// ```
//      ____________________________
//     |      |      |             |
//  0  |  A1  |  B1  |     C1      |
//     |______|______|______ ______|
//     |      |             |      |
//  1  |  A2  |     B2      |      |
//     |______|______ ______|      |
//     |      |      |      |  D1  |
//  2  |  A3  |  B3  |  C2  |      |
//     |______|______|______|______|
// ```
//
// if you try to move the row 0 to the row index 1 with tryToFit false,
// it'll throw an exception since you can't split the row 1;
// but if "tryToFit" is true, it'll move the row using the current direction.
//
// We defined current direction using the target and origin values
// if the origin is greater than the target, that means the course is `bottom-to-top`,
// so the `tryToFit` logic will use this direction to determine
// if we should move the column to the right or the left.
//
// for example, if you call the function using `moveRow(0, 1, { tryToFit: true })`
// the result will be:
// ```
//      ____________________________
//     |      |             |      |
//  0  |  A2  |     B2      |      |
//     |______|______ ______|      |
//     |      |      |      |  D1  |
//  1  |  A3  |  B3  |  C2  |      |
//     |______|______|______|______|
//     |      |      |             |
//  2  |  A1  |  B1  |     C1      |
//     |______|______|______ ______|
// ```
//
// since we could put the row zero on index one,
// we pushed to the best place to fit the row index 0,
// in this case, row index 2.
//
//
// -------- HOW TO OVERRIDE DIRECTION --------
//
// If you set "tryToFit" to "true", it will try to figure out the best direction
// place to fit using the origin and target index, for example:
//
//
// ```
//      ____________________________
//     |      |      |             |
//  0  |  A1  |  B1  |     C1      |
//     |______|______|______ ______|
//     |      |             |      |
//  1  |  A2  |     B2      |      |
//     |______|______ ______|      |
//     |      |      |      |  D1  |
//  2  |  A3  |  B3  |  C2  |      |
//     |______|______|______|______|
//     |      |             |      |
//  3  |  A4  |     B4      |      |
//     |______|______ ______|      |
//     |      |      |      |  D2  |
//  4  |  A5  |  B5  |  C3  |      |
//     |______|______|______|______|
// ```
//
//
// If you try to move the row 0 to row index 4 with "tryToFit" enabled, by default,
// the code will put it on after the merged rows,
// but you can override it using the "direction" option.
//
// -1: Always put the origin before the target
// ```
//      ____________________________
//     |      |             |      |
//  0  |  A2  |     B2      |      |
//     |______|______ ______|      |
//     |      |      |      |  D1  |
//  1  |  A3  |  B3  |  C2  |      |
//     |______|______|______|______|
//     |      |      |             |
//  2  |  A1  |  B1  |     C1      |
//     |______|______|______ ______|
//     |      |             |      |
//  3  |  A4  |     B4      |      |
//     |______|______ ______|      |
//     |      |      |      |  D2  |
//  4  |  A5  |  B5  |  C3  |      |
//     |______|______|______|______|
// ```
//
//  0: Automatically decide the best place to fit
// ```
//      ____________________________
//     |      |             |      |
//  0  |  A2  |     B2      |      |
//     |______|______ ______|      |
//     |      |      |      |  D1  |
//  1  |  A3  |  B3  |  C2  |      |
//     |______|______|______|______|
//     |      |             |      |
//  2  |  A4  |     B4      |      |
//     |______|______ ______|      |
//     |      |      |      |  D2  |
//  3  |  A5  |  B5  |  C3  |      |
//     |______|______|______|______|
//     |      |      |             |
//  4  |  A1  |  B1  |     C1      |
//     |______|______|______ ______|
// ```
//
//  1: Always put the origin after the target
// ```
//      ____________________________
//     |      |             |      |
//  0  |  A2  |     B2      |      |
//     |______|______ ______|      |
//     |      |      |      |  D1  |
//  1  |  A3  |  B3  |  C2  |      |
//     |______|______|______|______|
//     |      |             |      |
//  2  |  A4  |     B4      |      |
//     |______|______ ______|      |
//     |      |      |      |  D2  |
//  3  |  A5  |  B5  |  C3  |      |
//     |______|______|______|______|
//     |      |      |             |
//  4  |  A1  |  B1  |     C1      |
//     |______|______|______ ______|
// ```
//
// ```javascript
// dispatch(
//   moveRow(x, y, options)(state.tr)
// );
// ```
var moveRow = function moveRow(originRowIndex, targetRowIndex, opts) {
  return function (tr) {
    var defaultOptions = { tryToFit: false, direction: 0 };
    var options = Object.assign(defaultOptions, opts);
    var table = findTable(tr.selection);
    if (!table) {
      return tr;
    }

    var _getSelectionRangeInR = getSelectionRangeInRow(originRowIndex)(tr),
        indexesOriginRow = _getSelectionRangeInR.indexes;

    var _getSelectionRangeInR2 = getSelectionRangeInRow(targetRowIndex)(tr),
        indexesTargetRow = _getSelectionRangeInR2.indexes;

    if (indexesOriginRow.indexOf(targetRowIndex) > -1) {
      return tr;
    }

    if (!options.tryToFit && indexesTargetRow.length > 1) {
      checkInvalidMovements(originRowIndex, targetRowIndex, indexesTargetRow, 'row');
    }

    var newTable = moveTableRow(table, indexesOriginRow, indexesTargetRow, options.direction);

    return cloneTr(tr).replaceWith(table.pos, table.pos + table.node.nodeSize, newTable);
  };
};

// :: (originColumnIndex: number, targetColumnIndex: targetColumnIndex, options?: MovementOptions) → (tr: Transaction) → Transaction
// Returns a new transaction that moves the origin column to the target index;
//
// by default "tryToFit" is false, that means if you try to move a column to a place
// where we will need to split a column with merged cells it'll throw an exception, for example:
//
// ```
//    0      1         2
//  ____________________________
// |      |      |             |
// |  A1  |  B1  |     C1      |
// |______|______|______ ______|
// |      |             |      |
// |  A2  |     B2      |      |
// |______|______ ______|      |
// |      |      |      |  D1  |
// |  A3  |  B3  |  C2  |      |
// |______|______|______|______|
// ```
//
//
// if you try to move the column 0 to the column index 1 with tryToFit false,
// it'll throw an exception since you can't split the column 1;
// but if "tryToFit" is true, it'll move the column using the current direction.
//
// We defined current direction using the target and origin values
// if the origin is greater than the target, that means the course is `right-to-left`,
// so the `tryToFit` logic will use this direction to determine
// if we should move the column to the right or the left.
//
// for example, if you call the function using `moveColumn(0, 1, { tryToFit: true })`
// the result will be:
//
// ```
//    0       1             2
// _____________________ _______
// |      |             |      |
// |  B1  |     C1      |  A1  |
// |______|______ ______|______|
// |             |      |      |
// |     B2      |      |  A2  |
// |______ ______|      |______|
// |      |      |  D1  |      |
// |  B3  |  C2  |      |  A3  |
// |______|______|______|______|
// ```
//
// since we could put the column zero on index one,
// we pushed to the best place to fit the column 0, in this case, column index 2.
//
// -------- HOW TO OVERRIDE DIRECTION --------
//
// If you set "tryToFit" to "true", it will try to figure out the best direction
// place to fit using the origin and target index, for example:
//
//
// ```
//     0      1       2     3      4      5       6
//   _________________________________________________
//  |      |      |             |      |             |
//  |  A1  |  B1  |     C1      |  E1  |     F1      |
//  |______|______|______ ______|______|______ ______|
//  |      |             |      |             |      |
//  |  A2  |     B2      |      |     E2      |      |
//  |______|______ ______|      |______ ______|      |
//  |      |      |      |  D1  |      |      |  G2  |
//  |  A3  |  B3  |  C3  |      |  E3  |  F3  |      |
//  |______|______|______|______|______|______|______|
// ```
//
//
// If you try to move the column 0 to column index 5 with "tryToFit" enabled, by default,
// the code will put it on after the merged columns,
// but you can override it using the "direction" option.
//
// -1: Always put the origin before the target
//
// ```
//     0      1       2     3      4      5       6
//   _________________________________________________
//  |      |             |      |      |             |
//  |  B1  |     C1      |  A1  |  E1  |     F1      |
//  |______|______ ______|______|______|______ ______|
//  |             |      |      |             |      |
//  |     B2      |      |  A2  |     E2      |      |
//  |______ ______|      |______|______ ______|      |
//  |      |      |  D1  |      |      |      |  G2  |
//  |  B3  |  C3  |      |  A3  |  E3  |  F3  |      |
//  |______|______|______|______|______|______|______|
// ```
//
//  0: Automatically decide the best place to fit
//
// ```
//     0      1       2     3      4      5       6
//   _________________________________________________
//  |      |             |      |             |      |
//  |  B1  |     C1      |  E1  |     F1      |  A1  |
//  |______|______ ______|______|______ ______|______|
//  |             |      |             |      |      |
//  |     B2      |      |     E2      |      |  A2  |
//  |______ ______|      |______ ______|      |______|
//  |      |      |  D1  |      |      |  G2  |      |
//  |  B3  |  C3  |      |  E3  |  F3  |      |  A3  |
//  |______|______|______|______|______|______|______|
// ```
//
//  1: Always put the origin after the target
//
// ```
//     0      1       2     3      4      5       6
//   _________________________________________________
//  |      |             |      |             |      |
//  |  B1  |     C1      |  E1  |     F1      |  A1  |
//  |______|______ ______|______|______ ______|______|
//  |             |      |             |      |      |
//  |     B2      |      |     E2      |      |  A2  |
//  |______ ______|      |______ ______|      |______|
//  |      |      |  D1  |      |      |  G2  |      |
//  |  B3  |  C3  |      |  E3  |  F3  |      |  A3  |
//  |______|______|______|______|______|______|______|
// ```
//
// ```javascript
// dispatch(
//   moveColumn(x, y, options)(state.tr)
// );
// ```
var moveColumn = function moveColumn(originColumnIndex, targetColumnIndex, opts) {
  return function (tr) {
    var defaultOptions = { tryToFit: false, direction: 0 };
    var options = Object.assign(defaultOptions, opts);
    var table = findTable(tr.selection);
    if (!table) {
      return tr;
    }

    var _getSelectionRangeInC = getSelectionRangeInColumn(originColumnIndex)(tr),
        indexesOriginColumn = _getSelectionRangeInC.indexes;

    var _getSelectionRangeInC2 = getSelectionRangeInColumn(targetColumnIndex)(tr),
        indexesTargetColumn = _getSelectionRangeInC2.indexes;

    if (indexesOriginColumn.indexOf(targetColumnIndex) > -1) {
      return tr;
    }

    if (!options.tryToFit && indexesTargetColumn.length > 1) {
      checkInvalidMovements(originColumnIndex, targetColumnIndex, indexesTargetColumn, 'column');
    }

    var newTable = moveTableColumn(table, indexesOriginColumn, indexesTargetColumn, options.direction);

    return cloneTr(tr).replaceWith(table.pos, table.pos + table.node.nodeSize, newTable);
  };
};

// :: (rowIndex: number, clonePreviousRow?: boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that adds a new row at index `rowIndex`. Optionally clone the previous row.
//
// ```javascript
// dispatch(
//   addRowAt(i)(state.tr)
// );
// ```
//
// ```javascript
// dispatch(
//   addRowAt(i, true)(state.tr)
// );
// ```
var addRowAt = function addRowAt(rowIndex, clonePreviousRow) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var cloneRowIndex = rowIndex - 1;

      if (clonePreviousRow && cloneRowIndex >= 0) {
        return cloneTr(cloneRowAt(cloneRowIndex)(tr));
      }

      if (rowIndex >= 0 && rowIndex <= map.height) {
        return cloneTr(prosemirrorTables.addRow(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, rowIndex));
      }
    }
    return tr;
  };
};

// :: (cloneRowIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that adds a new row after `cloneRowIndex`, cloning the row attributes at `cloneRowIndex`.
//
// ```javascript
// dispatch(
//   cloneRowAt(i)(state.tr)
// );
// ```
var cloneRowAt = function cloneRowAt(rowIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);

      if (rowIndex >= 0 && rowIndex <= map.height) {
        var tableNode = table.node;
        var tableNodes = tableNodeTypes(tableNode.type.schema);

        var rowPos = table.start;
        for (var i = 0; i < rowIndex + 1; i++) {
          rowPos += tableNode.child(i).nodeSize;
        }

        var cloneRow = tableNode.child(rowIndex);
        // Re-create the same nodes with same attrs, dropping the node content.
        var cells = [];
        var rowWidth = 0;
        cloneRow.forEach(function (cell) {
          // If we're copying a row with rowspan somewhere, we dont want to copy that cell
          // We'll increment its span below.
          if (cell.attrs.rowspan === 1) {
            rowWidth += cell.attrs.colspan;
            cells.push(tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, cell.marks));
          }
        });

        // If a higher row spans past our clone row, bump the higher row to cover this new row too.
        if (rowWidth < map.width) {
          var rowSpanCells = [];

          var _loop = function _loop(_i) {
            var foundCells = filterCellsInRow(_i, function (cell, tr) {
              var rowspan = cell.node.attrs.rowspan;
              var spanRange = _i + rowspan;
              return rowspan > 1 && spanRange > rowIndex;
            })(tr);
            rowSpanCells.push.apply(rowSpanCells, _toConsumableArray(foundCells));
          };

          for (var _i = rowIndex; _i >= 0; _i--) {
            _loop(_i);
          }

          if (rowSpanCells.length) {
            rowSpanCells.forEach(function (cell) {
              tr = setCellAttrs(cell, {
                rowspan: cell.node.attrs.rowspan + 1
              })(tr);
            });
          }
        }

        return safeInsert(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
      }
    }
    return tr;
  };
};

// :: (columnIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a column at index `columnIndex`. If there is only one column left, it will remove the entire table.
//
// ```javascript
// dispatch(
//   removeColumnAt(i)(state.tr)
// );
// ```
var removeColumnAt = function removeColumnAt(columnIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      if (columnIndex === 0 && map.width === 1) {
        return removeTable(tr);
      } else if (columnIndex >= 0 && columnIndex <= map.width) {
        prosemirrorTables.removeColumn(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, columnIndex);
        return cloneTr(tr);
      }
    }
    return tr;
  };
};

// :: (rowIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a row at index `rowIndex`. If there is only one row left, it will remove the entire table.
//
// ```javascript
// dispatch(
//   removeRowAt(i)(state.tr)
// );
// ```
var removeRowAt = function removeRowAt(rowIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      if (rowIndex === 0 && map.height === 1) {
        return removeTable(tr);
      } else if (rowIndex >= 0 && rowIndex <= map.height) {
        prosemirrorTables.removeRow(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, rowIndex);
        return cloneTr(tr);
      }
    }
    return tr;
  };
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes a table node if the cursor is inside of it.
//
// ```javascript
// dispatch(
//   removeTable(state.tr)
// );
// ```
var removeTable = function removeTable(tr) {
  var $from = tr.selection.$from;

  for (var depth = $from.depth; depth > 0; depth--) {
    var node = $from.node(depth);
    if (node.type.spec.tableRole === 'table') {
      return cloneTr(tr.delete($from.before(depth), $from.after(depth)));
    }
  }
  return tr;
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes selected columns.
//
// ```javascript
// dispatch(
//   removeSelectedColumns(state.tr)
// );
// ```
var removeSelectedColumns = function removeSelectedColumns(tr) {
  var selection = tr.selection;

  if (isTableSelected(selection)) {
    return removeTable(tr);
  }
  if (isCellSelection(selection)) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var rect = map.rectBetween(selection.$anchorCell.pos - table.start, selection.$headCell.pos - table.start);

      if (rect.left == 0 && rect.right == map.width) {
        return false;
      }

      var pmTableRect = Object.assign({}, rect, {
        map: map,
        table: table.node,
        tableStart: table.start
      });

      for (var i = pmTableRect.right - 1;; i--) {
        prosemirrorTables.removeColumn(tr, pmTableRect, i);
        if (i === pmTableRect.left) {
          break;
        }
        pmTableRect.table = pmTableRect.tableStart ? tr.doc.nodeAt(pmTableRect.tableStart - 1) : tr.doc;
        pmTableRect.map = prosemirrorTables.TableMap.get(pmTableRect.table);
      }
      return cloneTr(tr);
    }
  }
  return tr;
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes selected rows.
//
// ```javascript
// dispatch(
//   removeSelectedRows(state.tr)
// );
// ```
var removeSelectedRows = function removeSelectedRows(tr) {
  var selection = tr.selection;

  if (isTableSelected(selection)) {
    return removeTable(tr);
  }
  if (isCellSelection(selection)) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var rect = map.rectBetween(selection.$anchorCell.pos - table.start, selection.$headCell.pos - table.start);

      if (rect.top == 0 && rect.bottom == map.height) {
        return false;
      }

      var pmTableRect = Object.assign({}, rect, {
        map: map,
        table: table.node,
        tableStart: table.start
      });

      for (var i = pmTableRect.bottom - 1;; i--) {
        prosemirrorTables.removeRow(tr, pmTableRect, i);
        if (i === pmTableRect.top) {
          break;
        }
        pmTableRect.table = pmTableRect.tableStart ? tr.doc.nodeAt(pmTableRect.tableStart - 1) : tr.doc;
        pmTableRect.map = prosemirrorTables.TableMap.get(pmTableRect.table);
      }

      return cloneTr(tr);
    }
  }
  return tr;
};

// :: ($pos: ResolvedPos) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a column closest to a given `$pos`.
//
// ```javascript
// dispatch(
//   removeColumnClosestToPos(state.doc.resolve(3))(state.tr)
// );
// ```
var removeColumnClosestToPos = function removeColumnClosestToPos($pos) {
  return function (tr) {
    var rect = findCellRectClosestToPos($pos);
    if (rect) {
      return removeColumnAt(rect.left)(setTextSelection($pos.pos)(tr));
    }
    return tr;
  };
};

// :: ($pos: ResolvedPos) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a row closest to a given `$pos`.
//
// ```javascript
// dispatch(
//   removeRowClosestToPos(state.doc.resolve(3))(state.tr)
// );
// ```
var removeRowClosestToPos = function removeRowClosestToPos($pos) {
  return function (tr) {
    var rect = findCellRectClosestToPos($pos);
    if (rect) {
      return removeRowAt(rect.top)(setTextSelection($pos.pos)(tr));
    }
    return tr;
  };
};

// :: (columnIndex: number, cellTransform: (cell: {pos: number, start: number, node: ProseMirrorNode}, tr: Transaction) → Transaction, setCursorToLastCell: ?boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that maps a given `cellTransform` function to each cell in a column at a given `columnIndex`.
// It will set the selection into the last cell of the column if `setCursorToLastCell` param is set to `true`.
//
// ```javascript
// dispatch(
//   forEachCellInColumn(0, (cell, tr) => emptyCell(cell, state.schema)(tr))(state.tr)
// );
// ```
var forEachCellInColumn = function forEachCellInColumn(columnIndex, cellTransform, setCursorToLastCell) {
  return function (tr) {
    var cells = getCellsInColumn(columnIndex)(tr.selection);
    if (cells) {
      for (var i = cells.length - 1; i >= 0; i--) {
        tr = cellTransform(cells[i], tr);
      }
      if (setCursorToLastCell) {
        var $pos = tr.doc.resolve(tr.mapping.map(cells[cells.length - 1].pos));
        tr.setSelection(prosemirrorState.Selection.near($pos));
      }
      return cloneTr(tr);
    }
    return tr;
  };
};

// :: (rowIndex: number, cellTransform: (cell: {pos: number, start: number, node: ProseMirrorNode}, tr: Transaction) → Transaction, setCursorToLastCell: ?boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that maps a given `cellTransform` function to each cell in a row at a given `rowIndex`.
// It will set the selection into the last cell of the row if `setCursorToLastCell` param is set to `true`.
//
// ```javascript
// dispatch(
//   forEachCellInRow(0, (cell, tr) => setCellAttrs(cell, { background: 'red' })(tr))(state.tr)
// );
// ```
var forEachCellInRow = function forEachCellInRow(rowIndex, cellTransform, setCursorToLastCell) {
  return function (tr) {
    var cells = getCellsInRow(rowIndex)(tr.selection);
    if (cells) {
      for (var i = cells.length - 1; i >= 0; i--) {
        tr = cellTransform(cells[i], tr);
      }
      if (setCursorToLastCell) {
        var $pos = tr.doc.resolve(tr.mapping.map(cells[cells.length - 1].pos));
        tr.setSelection(prosemirrorState.Selection.near($pos));
      }
    }
    return tr;
  };
};

// :: (cell: {pos: number, start: number, node: ProseMirrorNode}, attrs: Object) → (tr: Transaction) → Transaction
// Returns a new transaction that sets given `attrs` to a given `cell`.
//
// ```javascript
// dispatch(
//   setCellAttrs(findCellClosestToPos($pos), { background: 'blue' })(tr);
// );
// ```
var setCellAttrs = function setCellAttrs(cell, attrs) {
  return function (tr) {
    if (cell) {
      tr.setNodeMarkup(cell.pos, null, Object.assign({}, cell.node.attrs, attrs));
      return cloneTr(tr);
    }
    return tr;
  };
};

// :: (schema: Schema, rowsCount: ?number, colsCount: ?number, withHeaderRow: ?boolean, cellContent: ?Node) → Node
// Returns a table node of a given size.
// `withHeaderRow` defines whether the first row of the table will be a header row.
// `cellContent` defines the content of each cell.
//
// ```javascript
// const table = createTable(state.schema); // 3x3 table node
// dispatch(
//   tr.replaceSelectionWith(table).scrollIntoView()
// );
// ```
var createTable = function createTable(schema) {
  var rowsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var colsCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var withHeaderRow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cellContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var _tableNodeTypes = tableNodeTypes(schema),
      tableCell = _tableNodeTypes.cell,
      tableHeader = _tableNodeTypes.header_cell,
      tableRow = _tableNodeTypes.row,
      table = _tableNodeTypes.table;

  var cells = [];
  var headerCells = [];
  for (var i = 0; i < colsCount; i++) {
    cells.push(createCell(tableCell, cellContent));

    if (withHeaderRow) {
      headerCells.push(createCell(tableHeader, cellContent));
    }
  }

  var rows = [];
  for (var _i2 = 0; _i2 < rowsCount; _i2++) {
    rows.push(tableRow.createChecked(null, withHeaderRow && _i2 === 0 ? headerCells : cells));
  }

  return table.createChecked(null, rows);
};

// :: ($pos: ResolvedPos) → ?{pos: number, start: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning a table cell or a table header node closest to a given `$pos`.
//
// ```javascript
// const cell = findCellClosestToPos(state.selection.$from);
// ```
var findCellClosestToPos = function findCellClosestToPos($pos) {
  var predicate = function predicate(node) {
    return node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
  };
  return findParentNodeClosestToPos($pos, predicate);
};

// :: ($pos: ResolvedPos) → ?{left: number, top: number, right: number, bottom: number}
// Returns the rectangle spanning a cell closest to a given `$pos`.
//
// ```javascript
// dispatch(
//   findCellRectClosestToPos(state.selection.$from)
// );
// ```
var findCellRectClosestToPos = function findCellRectClosestToPos($pos) {
  var cell = findCellClosestToPos($pos);
  if (cell) {
    var table = findTableClosestToPos($pos);
    var map = prosemirrorTables.TableMap.get(table.node);
    var cellPos = cell.pos - table.start;
    return map.rectBetween(cellPos, cellPos);
  }
};

var filterCellsInRow = function filterCellsInRow(rowIndex, predicate) {
  return function (tr) {
    var foundCells = [];
    var cells = getCellsInRow(rowIndex)(tr.selection);
    if (cells) {
      for (var j = cells.length - 1; j >= 0; j--) {
        if (predicate(cells[j], tr)) {
          foundCells.push(cells[j]);
        }
      }
    }

    return foundCells;
  };
};

// :: (columnIndex: number) → (tr: Transaction) → {$anchor: ResolvedPos, $head: ResolvedPos, indexes: [number]}
// Returns a range of rectangular selection spanning all merged cells around a column at index `columnIndex`.
//
// ```javascript
// const range = getSelectionRangeInColumn(3)(state.tr);
// ```
var getSelectionRangeInColumn = function getSelectionRangeInColumn(columnIndex) {
  return function (tr) {
    var startIndex = columnIndex;
    var endIndex = columnIndex;

    // looking for selection start column (startIndex)

    var _loop2 = function _loop2(i) {
      var cells = getCellsInColumn(i)(tr.selection);
      if (cells) {
        cells.forEach(function (cell) {
          var maybeEndIndex = cell.node.attrs.colspan + i - 1;
          if (maybeEndIndex >= startIndex) {
            startIndex = i;
          }
          if (maybeEndIndex > endIndex) {
            endIndex = maybeEndIndex;
          }
        });
      }
    };

    for (var i = columnIndex; i >= 0; i--) {
      _loop2(i);
    }
    // looking for selection end column (endIndex)

    var _loop3 = function _loop3(i) {
      var cells = getCellsInColumn(i)(tr.selection);
      if (cells) {
        cells.forEach(function (cell) {
          var maybeEndIndex = cell.node.attrs.colspan + i - 1;
          if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) {
            endIndex = maybeEndIndex;
          }
        });
      }
    };

    for (var i = columnIndex; i <= endIndex; i++) {
      _loop3(i);
    }

    // filter out columns without cells (where all rows have colspan > 1 in the same column)
    var indexes = [];
    for (var i = startIndex; i <= endIndex; i++) {
      var maybeCells = getCellsInColumn(i)(tr.selection);
      if (maybeCells && maybeCells.length) {
        indexes.push(i);
      }
    }
    startIndex = indexes[0];
    endIndex = indexes[indexes.length - 1];

    var firstSelectedColumnCells = getCellsInColumn(startIndex)(tr.selection);
    var firstRowCells = getCellsInRow(0)(tr.selection);
    var $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);

    var headCell = void 0;
    for (var _i3 = endIndex; _i3 >= startIndex; _i3--) {
      var columnCells = getCellsInColumn(_i3)(tr.selection);
      if (columnCells && columnCells.length) {
        for (var j = firstRowCells.length - 1; j >= 0; j--) {
          if (firstRowCells[j].pos === columnCells[0].pos) {
            headCell = columnCells[0];
            break;
          }
        }
        if (headCell) {
          break;
        }
      }
    }

    var $head = tr.doc.resolve(headCell.pos);
    return { $anchor: $anchor, $head: $head, indexes: indexes };
  };
};

// :: (rowIndex: number) → (tr: Transaction) → {$anchor: ResolvedPos, $head: ResolvedPos, indexes: [number]}
// Returns a range of rectangular selection spanning all merged cells around a row at index `rowIndex`.
//
// ```javascript
// const range = getSelectionRangeInRow(3)(state.tr);
// ```
var getSelectionRangeInRow = function getSelectionRangeInRow(rowIndex) {
  return function (tr) {
    var startIndex = rowIndex;
    var endIndex = rowIndex;
    // looking for selection start row (startIndex)

    var _loop4 = function _loop4(i) {
      var cells = getCellsInRow(i)(tr.selection);
      cells.forEach(function (cell) {
        var maybeEndIndex = cell.node.attrs.rowspan + i - 1;
        if (maybeEndIndex >= startIndex) {
          startIndex = i;
        }
        if (maybeEndIndex > endIndex) {
          endIndex = maybeEndIndex;
        }
      });
    };

    for (var i = rowIndex; i >= 0; i--) {
      _loop4(i);
    }
    // looking for selection end row (endIndex)

    var _loop5 = function _loop5(i) {
      var cells = getCellsInRow(i)(tr.selection);
      cells.forEach(function (cell) {
        var maybeEndIndex = cell.node.attrs.rowspan + i - 1;
        if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) {
          endIndex = maybeEndIndex;
        }
      });
    };

    for (var i = rowIndex; i <= endIndex; i++) {
      _loop5(i);
    }

    // filter out rows without cells (where all columns have rowspan > 1 in the same row)
    var indexes = [];
    for (var i = startIndex; i <= endIndex; i++) {
      var maybeCells = getCellsInRow(i)(tr.selection);
      if (maybeCells && maybeCells.length) {
        indexes.push(i);
      }
    }
    startIndex = indexes[0];
    endIndex = indexes[indexes.length - 1];

    var firstSelectedRowCells = getCellsInRow(startIndex)(tr.selection);
    var firstColumnCells = getCellsInColumn(0)(tr.selection);
    var $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);

    var headCell = void 0;
    for (var _i4 = endIndex; _i4 >= startIndex; _i4--) {
      var rowCells = getCellsInRow(_i4)(tr.selection);
      if (rowCells && rowCells.length) {
        for (var j = firstColumnCells.length - 1; j >= 0; j--) {
          if (firstColumnCells[j].pos === rowCells[0].pos) {
            headCell = rowCells[0];
            break;
          }
        }
        if (headCell) {
          break;
        }
      }
    }

    var $head = tr.doc.resolve(headCell.pos);
    return { $anchor: $anchor, $head: $head, indexes: indexes };
  };
};

exports.isNodeSelection = isNodeSelection;
exports.canInsert = canInsert;
exports.convertTableNodeToArrayOfRows = convertTableNodeToArrayOfRows;
exports.convertArrayOfRowsToTableNode = convertArrayOfRowsToTableNode;
exports.findParentNode = findParentNode;
exports.findParentNodeClosestToPos = findParentNodeClosestToPos;
exports.findParentDomRef = findParentDomRef;
exports.hasParentNode = hasParentNode;
exports.findParentNodeOfType = findParentNodeOfType;
exports.findParentNodeOfTypeClosestToPos = findParentNodeOfTypeClosestToPos;
exports.hasParentNodeOfType = hasParentNodeOfType;
exports.findParentDomRefOfType = findParentDomRefOfType;
exports.findSelectedNodeOfType = findSelectedNodeOfType;
exports.findPositionOfNodeBefore = findPositionOfNodeBefore;
exports.findDomRefAtPos = findDomRefAtPos;
exports.flatten = flatten;
exports.findChildren = findChildren;
exports.findTextNodes = findTextNodes;
exports.findInlineNodes = findInlineNodes;
exports.findBlockNodes = findBlockNodes;
exports.findChildrenByAttr = findChildrenByAttr;
exports.findChildrenByType = findChildrenByType;
exports.findChildrenByMark = findChildrenByMark;
exports.contains = contains;
exports.findTable = findTable;
exports.isCellSelection = isCellSelection;
exports.getSelectionRect = getSelectionRect;
exports.isColumnSelected = isColumnSelected;
exports.isRowSelected = isRowSelected;
exports.isTableSelected = isTableSelected;
exports.getCellsInColumn = getCellsInColumn;
exports.getCellsInRow = getCellsInRow;
exports.getCellsInTable = getCellsInTable;
exports.selectColumn = selectColumn;
exports.selectRow = selectRow;
exports.selectTable = selectTable;
exports.emptyCell = emptyCell;
exports.addColumnAt = addColumnAt;
exports.moveRow = moveRow;
exports.moveColumn = moveColumn;
exports.addRowAt = addRowAt;
exports.cloneRowAt = cloneRowAt;
exports.removeColumnAt = removeColumnAt;
exports.removeRowAt = removeRowAt;
exports.removeTable = removeTable;
exports.removeSelectedColumns = removeSelectedColumns;
exports.removeSelectedRows = removeSelectedRows;
exports.removeColumnClosestToPos = removeColumnClosestToPos;
exports.removeRowClosestToPos = removeRowClosestToPos;
exports.forEachCellInColumn = forEachCellInColumn;
exports.forEachCellInRow = forEachCellInRow;
exports.setCellAttrs = setCellAttrs;
exports.createTable = createTable;
exports.findCellClosestToPos = findCellClosestToPos;
exports.findCellRectClosestToPos = findCellRectClosestToPos;
exports.getSelectionRangeInColumn = getSelectionRangeInColumn;
exports.getSelectionRangeInRow = getSelectionRangeInRow;
exports.removeParentNodeOfType = removeParentNodeOfType;
exports.replaceParentNodeOfType = replaceParentNodeOfType;
exports.removeSelectedNode = removeSelectedNode;
exports.replaceSelectedNode = replaceSelectedNode;
exports.setTextSelection = setTextSelection;
exports.safeInsert = safeInsert;
exports.setParentNodeMarkup = setParentNodeMarkup;
exports.selectParentNodeOfType = selectParentNodeOfType;
exports.removeNodeBefore = removeNodeBefore;
//# sourceMappingURL=index.js.map


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobForm_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2649cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobForm_vue__ = __webpack_require__(719);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2649cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76be82de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(725);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76be82de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventForm_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cf9d30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventForm_vue__ = __webpack_require__(802);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cf9d30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "website_squircle_charcoal.svg?c54b7c9743627e2f30d480cb1e9f8c3c";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "facebook_squircle_charcoal.svg?2a0529a6092f9a8dbedfb3ec722d5d93";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "instagram_squircle_charcoal.svg?821c0f5270f337715e636a501e9873fb";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "twitter_squircle_charcoal.svg?9e07ba974f570fd7b406d3a2816741b2";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "linkedin_squircle_charcoal.svg?fcd596d6d2e7415b540d8227c28c126d";

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f5da2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__(832);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f5da2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (vueInst, googleMapsInst, events) {
  var _loop = function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */
function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
  var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isHandled = false;

  function requestHandle() {
    if (!isHandled) {
      isHandled = true;
      vueInst.$nextTick(function () {
        isHandled = false;
        handler();
      });
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      vueInst.$watch(prop, requestHandle, { immediate: immediate });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_authentication__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_communication__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_documents__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_candidates__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_employers__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_agency__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_general__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialogs__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dialogContent__ = __webpack_require__(990);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    // menuState: '',
    skills: ["Administration", "Advocacy/Public Engagement", "Business", "Clinical Work", "Education & Skills Training", "Event Planning", "Finance", "Fundraising", "Grant Development", "Human Resources", "Information Technology", "Knowledge Translation", "Monitoring, Evaluation & Research", "Partnership Building", "Policy", "Program Management/Coordination", "Project Planning", "Public Relations/Communications", "Quality Improvement", "Stakeholder Engagement", "Strategy Development", "Supervision"],
    focusAreas: [
    // 'Chronic Diseases',
    "Climate Change", "Education", "Emergency Response", "Environmental Health", "Epidemiology", "Food Security & Nutrition", "Indigenous Health", "Infectious Diseases", "International Development", "Medicine", "Mental Health", "Migration and Refugee Health", "Non-Infectious Diseases", "Public Health", "Sexual & Reproductive Health", "Vision Care", "Water & Sanitation", "Women’s and/or Children’s Health", "Youth Health"],
    jobTypes: ["Contract", "Fellowship", "Full-Time", "Internship", "Part-Time", "Volunteer"],
    organizationTypes: ["Charity", "For-Profit", "Non-Profit/NGO", "Hospital", "Multilateral Agency", "Governmental Organization", "University/Research Lab"],
    organizationSizes: ["1-10", "11-50", "51-100", "101-200", "201-500", "500+"],
    organizationStatures: ["Well known with an established brand", "Smaller, less well known"],
    // https://css-tricks.com/snippets/javascript/array-of-country-names/
    countries: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"],
    // countries: [
    //   {"name": "Afghanistan", "code": "AF"},
    //   {"name": "land Islands", "code": "AX"},
    //   {"name": "Albania", "code": "AL"},
    //   {"name": "Algeria", "code": "DZ"},
    //   {"name": "American Samoa", "code": "AS"},
    //   {"name": "AndorrA", "code": "AD"},
    //   {"name": "Angola", "code": "AO"},
    //   {"name": "Anguilla", "code": "AI"},
    //   {"name": "Antarctica", "code": "AQ"},
    //   {"name": "Antigua and Barbuda", "code": "AG"},
    //   {"name": "Argentina", "code": "AR"},
    //   {"name": "Armenia", "code": "AM"},
    //   {"name": "Aruba", "code": "AW"},
    //   {"name": "Australia", "code": "AU"},
    //   {"name": "Austria", "code": "AT"},
    //   {"name": "Azerbaijan", "code": "AZ"},
    //   {"name": "Bahamas", "code": "BS"},
    //   {"name": "Bahrain", "code": "BH"},
    //   {"name": "Bangladesh", "code": "BD"},
    //   {"name": "Barbados", "code": "BB"},
    //   {"name": "Belarus", "code": "BY"},
    //   {"name": "Belgium", "code": "BE"},
    //   {"name": "Belize", "code": "BZ"},
    //   {"name": "Benin", "code": "BJ"},
    //   {"name": "Bermuda", "code": "BM"},
    //   {"name": "Bhutan", "code": "BT"},
    //   {"name": "Bolivia", "code": "BO"},
    //   {"name": "Bosnia and Herzegovina", "code": "BA"},
    //   {"name": "Botswana", "code": "BW"},
    //   {"name": "Bouvet Island", "code": "BV"},
    //   {"name": "Brazil", "code": "BR"},
    //   {"name": "British Indian Ocean Territory", "code": "IO"},
    //   {"name": "Brunei Darussalam", "code": "BN"},
    //   {"name": "Bulgaria", "code": "BG"},
    //   {"name": "Burkina Faso", "code": "BF"},
    //   {"name": "Burundi", "code": "BI"},
    //   {"name": "Cambodia", "code": "KH"},
    //   {"name": "Cameroon", "code": "CM"},
    //   {"name": "Canada", "code": "CA"},
    //   {"name": "Cape Verde", "code": "CV"},
    //   {"name": "Cayman Islands", "code": "KY"},
    //   {"name": "Central African Republic", "code": "CF"},
    //   {"name": "Chad", "code": "TD"},
    //   {"name": "Chile", "code": "CL"},
    //   {"name": "China", "code": "CN"},
    //   {"name": "Christmas Island", "code": "CX"},
    //   {"name": "Cocos (Keeling) Islands", "code": "CC"},
    //   {"name": "Colombia", "code": "CO"},
    //   {"name": "Comoros", "code": "KM"},
    //   {"name": "Congo", "code": "CG"},
    //   {"name": "Congo, The Democratic Republic of the", "code": "CD"},
    //   {"name": "Cook Islands", "code": "CK"},
    //   {"name": "Costa Rica", "code": "CR"},
    //   {"name": "Cote D"Ivoire", "code": "CI"},
    //   {"name": "Croatia", "code": "HR"},
    //   {"name": "Cuba", "code": "CU"},
    //   {"name": "Cyprus", "code": "CY"},
    //   {"name": "Czech Republic", "code": "CZ"},
    //   {"name": "Denmark", "code": "DK"},
    //   {"name": "Djibouti", "code": "DJ"},
    //   {"name": "Dominica", "code": "DM"},
    //   {"name": "Dominican Republic", "code": "DO"},
    //   {"name": "Ecuador", "code": "EC"},
    //   {"name": "Egypt", "code": "EG"},
    //   {"name": "El Salvador", "code": "SV"},
    //   {"name": "Equatorial Guinea", "code": "GQ"},
    //   {"name": "Eritrea", "code": "ER"},
    //   {"name": "Estonia", "code": "EE"},
    //   {"name": "Ethiopia", "code": "ET"},
    //   {"name": "Falkland Islands (Malvinas)", "code": "FK"},
    //   {"name": "Faroe Islands", "code": "FO"},
    //   {"name": "Fiji", "code": "FJ"},
    //   {"name": "Finland", "code": "FI"},
    //   {"name": "France", "code": "FR"},
    //   {"name": "French Guiana", "code": "GF"},
    //   {"name": "French Polynesia", "code": "PF"},
    //   {"name": "French Southern Territories", "code": "TF"},
    //   {"name": "Gabon", "code": "GA"},
    //   {"name": "Gambia", "code": "GM"},
    //   {"name": "Georgia", "code": "GE"},
    //   {"name": "Germany", "code": "DE"},
    //   {"name": "Ghana", "code": "GH"},
    //   {"name": "Gibraltar", "code": "GI"},
    //   {"name": "Greece", "code": "GR"},
    //   {"name": "Greenland", "code": "GL"},
    //   {"name": "Grenada", "code": "GD"},
    //   {"name": "Guadeloupe", "code": "GP"},
    //   {"name": "Guam", "code": "GU"},
    //   {"name": "Guatemala", "code": "GT"},
    //   {"name": "Guernsey", "code": "GG"},
    //   {"name": "Guinea", "code": "GN"},
    //   {"name": "Guinea-Bissau", "code": "GW"},
    //   {"name": "Guyana", "code": "GY"},
    //   {"name": "Haiti", "code": "HT"},
    //   {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
    //   {"name": "Holy See (Vatican City State)", "code": "VA"},
    //   {"name": "Honduras", "code": "HN"},
    //   {"name": "Hong Kong", "code": "HK"},
    //   {"name": "Hungary", "code": "HU"},
    //   {"name": "Iceland", "code": "IS"},
    //   {"name": "India", "code": "IN"},
    //   {"name": "Indonesia", "code": "ID"},
    //   {"name": "Iran, Islamic Republic Of", "code": "IR"},
    //   {"name": "Iraq", "code": "IQ"},
    //   {"name": "Ireland", "code": "IE"},
    //   {"name": "Isle of Man", "code": "IM"},
    //   {"name": "Israel", "code": "IL"},
    //   {"name": "Italy", "code": "IT"},
    //   {"name": "Jamaica", "code": "JM"},
    //   {"name": "Japan", "code": "JP"},
    //   {"name": "Jersey", "code": "JE"},
    //   {"name": "Jordan", "code": "JO"},
    //   {"name": "Kazakhstan", "code": "KZ"},
    //   {"name": "Kenya", "code": "KE"},
    //   {"name": "Kiribati", "code": "KI"},
    //   {"name": "Korea, Democratic People"S Republic of", "code": "KP"},
    //   {"name": "Korea, Republic of", "code": "KR"},
    //   {"name": "Kuwait", "code": "KW"},
    //   {"name": "Kyrgyzstan", "code": "KG"},
    //   {"name": "Lao People"S Democratic Republic", "code": "LA"},
    //   {"name": "Latvia", "code": "LV"},
    //   {"name": "Lebanon", "code": "LB"},
    //   {"name": "Lesotho", "code": "LS"},
    //   {"name": "Liberia", "code": "LR"},
    //   {"name": "Libyan Arab Jamahiriya", "code": "LY"},
    //   {"name": "Liechtenstein", "code": "LI"},
    //   {"name": "Lithuania", "code": "LT"},
    //   {"name": "Luxembourg", "code": "LU"},
    //   {"name": "Macao", "code": "MO"},
    //   {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
    //   {"name": "Madagascar", "code": "MG"},
    //   {"name": "Malawi", "code": "MW"},
    //   {"name": "Malaysia", "code": "MY"},
    //   {"name": "Maldives", "code": "MV"},
    //   {"name": "Mali", "code": "ML"},
    //   {"name": "Malta", "code": "MT"},
    //   {"name": "Marshall Islands", "code": "MH"},
    //   {"name": "Martinique", "code": "MQ"},
    //   {"name": "Mauritania", "code": "MR"},
    //   {"name": "Mauritius", "code": "MU"},
    //   {"name": "Mayotte", "code": "YT"},
    //   {"name": "Mexico", "code": "MX"},
    //   {"name": "Micronesia, Federated States of", "code": "FM"},
    //   {"name": "Moldova, Republic of", "code": "MD"},
    //   {"name": "Monaco", "code": "MC"},
    //   {"name": "Mongolia", "code": "MN"},
    //   {"name": "Montenegro", "code": "ME"},
    //   {"name": "Montserrat", "code": "MS"},
    //   {"name": "Morocco", "code": "MA"},
    //   {"name": "Mozambique", "code": "MZ"},
    //   {"name": "Myanmar", "code": "MM"},
    //   {"name": "Namibia", "code": "NA"},
    //   {"name": "Nauru", "code": "NR"},
    //   {"name": "Nepal", "code": "NP"},
    //   {"name": "Netherlands", "code": "NL"},
    //   {"name": "Netherlands Antilles", "code": "AN"},
    //   {"name": "New Caledonia", "code": "NC"},
    //   {"name": "New Zealand", "code": "NZ"},
    //   {"name": "Nicaragua", "code": "NI"},
    //   {"name": "Niger", "code": "NE"},
    //   {"name": "Nigeria", "code": "NG"},
    //   {"name": "Niue", "code": "NU"},
    //   {"name": "Norfolk Island", "code": "NF"},
    //   {"name": "Northern Mariana Islands", "code": "MP"},
    //   {"name": "Norway", "code": "NO"},
    //   {"name": "Oman", "code": "OM"},
    //   {"name": "Pakistan", "code": "PK"},
    //   {"name": "Palau", "code": "PW"},
    //   {"name": "Palestinian Territory, Occupied", "code": "PS"},
    //   {"name": "Panama", "code": "PA"},
    //   {"name": "Papua New Guinea", "code": "PG"},
    //   {"name": "Paraguay", "code": "PY"},
    //   {"name": "Peru", "code": "PE"},
    //   {"name": "Philippines", "code": "PH"},
    //   {"name": "Pitcairn", "code": "PN"},
    //   {"name": "Poland", "code": "PL"},
    //   {"name": "Portugal", "code": "PT"},
    //   {"name": "Puerto Rico", "code": "PR"},
    //   {"name": "Qatar", "code": "QA"},
    //   {"name": "Reunion", "code": "RE"},
    //   {"name": "Romania", "code": "RO"},
    //   {"name": "Russian Federation", "code": "RU"},
    //   {"name": "RWANDA", "code": "RW"},
    //   {"name": "Saint Helena", "code": "SH"},
    //   {"name": "Saint Kitts and Nevis", "code": "KN"},
    //   {"name": "Saint Lucia", "code": "LC"},
    //   {"name": "Saint Pierre and Miquelon", "code": "PM"},
    //   {"name": "Saint Vincent and the Grenadines", "code": "VC"},
    //   {"name": "Samoa", "code": "WS"},
    //   {"name": "San Marino", "code": "SM"},
    //   {"name": "Sao Tome and Principe", "code": "ST"},
    //   {"name": "Saudi Arabia", "code": "SA"},
    //   {"name": "Senegal", "code": "SN"},
    //   {"name": "Serbia", "code": "RS"},
    //   {"name": "Seychelles", "code": "SC"},
    //   {"name": "Sierra Leone", "code": "SL"},
    //   {"name": "Singapore", "code": "SG"},
    //   {"name": "Slovakia", "code": "SK"},
    //   {"name": "Slovenia", "code": "SI"},
    //   {"name": "Solomon Islands", "code": "SB"},
    //   {"name": "Somalia", "code": "SO"},
    //   {"name": "South Africa", "code": "ZA"},
    //   {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
    //   {"name": "Spain", "code": "ES"},
    //   {"name": "Sri Lanka", "code": "LK"},
    //   {"name": "Sudan", "code": "SD"},
    //   {"name": "Suriname", "code": "SR"},
    //   {"name": "Svalbard and Jan Mayen", "code": "SJ"},
    //   {"name": "Swaziland", "code": "SZ"},
    //   {"name": "Sweden", "code": "SE"},
    //   {"name": "Switzerland", "code": "CH"},
    //   {"name": "Syrian Arab Republic", "code": "SY"},
    //   {"name": "Taiwan, Province of China", "code": "TW"},
    //   {"name": "Tajikistan", "code": "TJ"},
    //   {"name": "Tanzania, United Republic of", "code": "TZ"},
    //   {"name": "Thailand", "code": "TH"},
    //   {"name": "Timor-Leste", "code": "TL"},
    //   {"name": "Togo", "code": "TG"},
    //   {"name": "Tokelau", "code": "TK"},
    //   {"name": "Tonga", "code": "TO"},
    //   {"name": "Trinidad and Tobago", "code": "TT"},
    //   {"name": "Tunisia", "code": "TN"},
    //   {"name": "Turkey", "code": "TR"},
    //   {"name": "Turkmenistan", "code": "TM"},
    //   {"name": "Turks and Caicos Islands", "code": "TC"},
    //   {"name": "Tuvalu", "code": "TV"},
    //   {"name": "Uganda", "code": "UG"},
    //   {"name": "Ukraine", "code": "UA"},
    //   {"name": "United Arab Emirates", "code": "AE"},
    //   {"name": "United Kingdom", "code": "GB"},
    //   {"name": "United States", "code": "US"},
    //   {"name": "United States Minor Outlying Islands", "code": "UM"},
    //   {"name": "Uruguay", "code": "UY"},
    //   {"name": "Uzbekistan", "code": "UZ"},
    //   {"name": "Vanuatu", "code": "VU"},
    //   {"name": "Venezuela", "code": "VE"},
    //   {"name": "Viet Nam", "code": "VN"},
    //   {"name": "Virgin Islands, British", "code": "VG"},
    //   {"name": "Virgin Islands, U.S.", "code": "VI"},
    //   {"name": "Wallis and Futuna", "code": "WF"},
    //   {"name": "Western Sahara", "code": "EH"},
    //   {"name": "Yemen", "code": "YE"},
    //   {"name": "Zambia", "code": "ZM"},
    //   {"name": "Zimbabwe", "code": "ZW"}
    // ],
    compensationTypes: ["per hour", "per year"],
    salaryRanges: ["$0 (i.e. volunteer)", "$1-15,000", "$15,001-30,000", "$30,001-45,000", "$45,001-60,000", "$60,001-75,000", "$75,000-100,000", "$100,001-150,000", "$150,001+"],
    values: [
    // 'Person-centred',
    // 'Commitment to Sustainability',
    // 'Commitment to Sustainability',
    // 'Collaboration / Partnership',
    // 'Accountability',
    // 'Transparency',
    // 'Integrity',
    // 'Learning',
    // 'Innovation',
    // 'Inclusiveness/Diversity',
    // 'Evidence-based Research',
    // 'Humility',
    // 'Mentorship',
    // 'Efficiency',
    // 'Neutrality & Non-judgement',
    // 'Religious',
    "Equity", "Transparency", "Integrity", "Collaboration", "Sustainability", "Innovation", "Accountability", "Humility", "Mentorship", "Efficiency", "Evidence-based work"],
    qualities: [
    // 'Passionate',
    // 'Alignment with Organization',
    // 'Competency',
    // 'Team Player',
    // 'Interpersonal Skills',
    // 'Adaptability',
    // 'Flexibility',
    // 'Open-minded',
    // 'Enthusiasm',
    // 'Autonomous & Self-motivated',
    // 'Accountable',
    // 'Reliable',
    // 'Experience Working Internationally',
    // 'Able to work Internationally',
    // 'Communication Skills',
    // 'Solution-oriented',
    // 'Creative & Innovative',
    // 'Leadership',
    // 'Integrity',
    // 'Detail-oriented',
    // 'Respect',
    // 'Professionalism',
    // 'Emotional Intelligence',
    // 'Organized',
    // 'Resourceful',
    "Competency", "Alignment with organization (values, mission, etc.)", "Passion", "Interpersonal skills", "Adaptability", "Open-minded", "Enthusiastic", "Team player", "Self-motivated", "Accountable", "Reliable", "Experience working internationally", "Communication skills (oral and/or written)", "Solution-oriented", "Creative / innovative", "Integrity", "Detail-oriented", "Respect", "Professionalism", "Emotional intelligence", "Organized", "Resourceful"],
    perks: ["Networking Opportunities", "Professional Development Opportunities", "Remote Work Options", "Flexible Schedule",
    // 'Conference Cost Coverage',
    "Travel Opportunities", "Travel Expense Coverage",
    // 'Accommodation Provided',
    // 'Monthly Living Allowance',
    "Health Benefits/Insurance", "Paid Vacation", "Pension Plan",
    // 'Vaccination Coverage',
    // 'Travel Opportunities',
    // 'Inclusive Workplace',
    // 'Diversity in Hiring',
    // 'Supportive Work Team',
    "Sick Leave", "Parental Leave"],
    blogCategories: ["Career Advice", "Global Health Recent News",
    // 'Opportunities, Grants, Prizes and More',
    "Webinar Series"],
    eventTypes: ["Conference", "Webinar", "In-person Seminar/Gathering"],

    statusOptions: ["New", "Personal Information", "Profile Complete"],
    // candidateStatuses: [
    //   'Applied', 'Interview Booked', 'Interview Complete', 'Accepted', 'Rejected', 'Background Check Complete', 'Reference Check Complete', 'Hired',
    // ],
    // employerStatuses: [
    //   'Applied', 'Welcome Call Complete', 'Application Approved', 'Package Selected', 'Payment Info Entered', 'Consultation Booked', 'Consultation Complete', 'Nanny Assigned',
    //   'Documents Signed', 'Active', 'Placement Fee Paid', 'Inactive',
    // ],
    candidateEmployerRelationshipStatuses: ["Under Consideration", "Interested", "Not Interested", "Offer Extended", "Assigned"],
    jobStatuses: ["Requested", "Pending", "Approved", "Completed"],
    ages: ["Newborn (0-6 months)", "Infant (6 months - 12 months)", "Toddler (1-2 years)", "Preschool (3-5 years)", "Gradeschool (6-12 years)", "Teenager (13+ years)"],
    experiences: ["Private Babysitting (non-relatives)", "Private Babysitting (only-relatives)", "Daycare Center", "Preschool", "Church Nursery", "Camp Counsellor", "Nanny"],
    comfortableWith: ["Drive/Transport children to/from activities", "Overnight Care", "Animals", "Parents who work from home", "Supervising Swimming", "Light housekeeping", "Caring for sick children", "Meal prepping", "Running light errands"],
    documentsOptions: ["Child Abuse Check", "Criminal Record Check with Vulnerable Sector Check", "Standard CPR/First Aid Level C", "Drivers Abstract Report"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    referrer: ["Google", "Social Media", "Fox 8 News", "NEO Parenting Magazine"],
    // commitmentOptions: [
    //   'Long Term (longer than 1 year)', 'Short Term (1 year or less)', 'Temporary',
    // ],
    // availabilityOptions: [
    //   'Full Time', 'Part Time', 'Come and Go', 'Live In'
    // ],
    // drvingStatuses: [
    //   'D.L. and Car', 'Driver\'s License only', 'Neither',
    // ],
    // certificationStatuses: [
    //   'Yes', 'Willing to get certified', 'No',
    // ],
    // vaccinationStatuses: [
    //   'Yes', 'Willing to get', 'No'
    // ],
    // petsOptions: [
    //   'Dog', 'Cat', 'Neither',
    // ],
    // travelOptions: [
    //   'Domestic', 'International', 'No travel',
    // ],
    yesNoOptions: ["Yes", "No"],
    // website: 'https://www.tinytreasuresnyc.com/',
    logo: "ttnyc-logo.jpg",
    logoHeight: 90,
    acceptedImageTypes: ["image/jpeg", "image/png"],
    acceptResumeType: ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
  },
  mutations: {
    // storeMenuState (state, menuState) {
    //   state.menuState = menuState
    // }
  },
  actions: {
    // setMenuState ({commit}, menuState) {
    //   commit(storeMenuState, menuState)
    // }
  },
  getters: {
    // menuState (state) {
    //   return state.menuState
    // },
    skills: function skills(state) {
      return state.skills;
    },
    focusAreas: function focusAreas(state) {
      return state.focusAreas;
    },
    jobTypes: function jobTypes(state) {
      return state.jobTypes;
    },
    organizationTypes: function organizationTypes(state) {
      return state.organizationTypes;
    },
    organizationSizes: function organizationSizes(state) {
      return state.organizationSizes;
    },
    organizationStatures: function organizationStatures(state) {
      return state.organizationStatures;
    },
    countries: function countries(state) {
      return state.countries;
    },
    compensationTypes: function compensationTypes(state) {
      return state.compensationTypes;
    },
    salaryRanges: function salaryRanges(state) {
      return state.salaryRanges;
    },
    values: function values(state) {
      return state.values;
    },
    qualities: function qualities(state) {
      return state.qualities;
    },
    perks: function perks(state) {
      return state.perks;
    },
    blogCategories: function blogCategories(state) {
      return state.blogCategories;
    },
    eventTypes: function eventTypes(state) {
      return state.eventTypes;
    },
    statusOptions: function statusOptions(state) {
      return state.statusOptions;
    },


    // candidateStatuses (state) {
    //   return state.candidateStatuses
    // },
    // employerStatuses (state) {
    //   return state.employerStatuses
    // },
    jobStatuses: function jobStatuses(state) {
      return state.jobStatuses;
    },
    ages: function ages(state) {
      return state.ages;
    },
    experiences: function experiences(state) {
      return state.experiences;
    },
    comfortableWith: function comfortableWith(state) {
      return state.comfortableWith;
    },
    documentsOptions: function documentsOptions(state) {
      return state.documentsOptions;
    },
    days: function days(state) {
      return state.days;
    },
    candidateEmployerRelationshipStatuses: function candidateEmployerRelationshipStatuses(state) {
      return state.candidateEmployerRelationshipStatuses;
    },
    yesNoOptions: function yesNoOptions(state) {
      return state.yesNoOptions;
    },
    referrer: function referrer(state) {
      return state.referrer;
    },

    // website(state) {
    //   return state.website;
    // },
    logo: function logo(state) {
      return state.logo;
    },
    logoHeight: function logoHeight(state) {
      return state.logoHeight;
    },
    acceptedImageTypes: function acceptedImageTypes(state) {
      return state.acceptedImageTypes;
    },
    acceptResumeType: function acceptResumeType(state) {
      return state.acceptResumeType;
    }
  },
  modules: {
    authentication: __WEBPACK_IMPORTED_MODULE_2__modules_authentication__["a" /* default */],
    communication: __WEBPACK_IMPORTED_MODULE_3__modules_communication__["a" /* default */],
    documents: __WEBPACK_IMPORTED_MODULE_4__modules_documents__["a" /* default */],
    candidates: __WEBPACK_IMPORTED_MODULE_5__modules_candidates__["a" /* default */],
    employers: __WEBPACK_IMPORTED_MODULE_6__modules_employers__["a" /* default */],
    agency: __WEBPACK_IMPORTED_MODULE_7__modules_agency__["a" /* default */],
    general: __WEBPACK_IMPORTED_MODULE_8__modules_general__["a" /* default */],
    dialogs: __WEBPACK_IMPORTED_MODULE_9__modules_dialogs__["a" /* default */],
    dialogContent: __WEBPACK_IMPORTED_MODULE_10__modules_dialogContent__["a" /* default */]
  }
}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(12) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(98)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(9);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(27);
var toIObject = __webpack_require__(28);
var arrayIndexOf = __webpack_require__(77)(false);
var IE_PROTO = __webpack_require__(100)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var anObject = __webpack_require__(5);
var getKeys = __webpack_require__(54);

module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(28);
var gOPN = __webpack_require__(57).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(12);
var getKeys = __webpack_require__(54);
var gOPS = __webpack_require__(78);
var pIE = __webpack_require__(70);
var toObject = __webpack_require__(15);
var IObject = __webpack_require__(69);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(19);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(155);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(6).parseInt;
var $trim = __webpack_require__(66).trim;
var ws = __webpack_require__(104);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(6).parseFloat;
var $trim = __webpack_require__(66).trim;

module.exports = 1 / $parseFloat(__webpack_require__(104) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(33);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(107);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(5);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(15);
var IObject = __webpack_require__(69);
var toLength = __webpack_require__(10);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(10);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(119);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(14).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(71)
});


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(123);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(171);
var validate = __webpack_require__(62);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(86)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(14).f;
var create = __webpack_require__(56);
var redefineAll = __webpack_require__(61);
var ctx = __webpack_require__(32);
var anInstance = __webpack_require__(59);
var forOf = __webpack_require__(60);
var $iterDefine = __webpack_require__(109);
var step = __webpack_require__(165);
var setSpecies = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(12);
var fastKey = __webpack_require__(48).fastKey;
var validate = __webpack_require__(62);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(171);
var validate = __webpack_require__(62);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(86)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var each = __webpack_require__(41)(0);
var redefine = __webpack_require__(24);
var meta = __webpack_require__(48);
var assign = __webpack_require__(152);
var weak = __webpack_require__(174);
var isObject = __webpack_require__(8);
var validate = __webpack_require__(62);
var NATIVE_WEAK_MAP = __webpack_require__(62);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(86)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(61);
var getWeak = __webpack_require__(48).getWeak;
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(59);
var forOf = __webpack_require__(60);
var createArrayMethod = __webpack_require__(41);
var $has = __webpack_require__(27);
var validate = __webpack_require__(62);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(34);
var toLength = __webpack_require__(10);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(57);
var gOPS = __webpack_require__(78);
var anObject = __webpack_require__(5);
var Reflect = __webpack_require__(6).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(79);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(10);
var ctx = __webpack_require__(32);
var IS_CONCAT_SPREADABLE = __webpack_require__(9)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(10);
var repeat = __webpack_require__(106);
var defined = __webpack_require__(39);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(12);
var getKeys = __webpack_require__(54);
var toIObject = __webpack_require__(28);
var isEnum = __webpack_require__(70).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(65);
var from = __webpack_require__(181);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(60);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_markerclusterer__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_markerclusterer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__google_markerclusterer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoogleMap__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GoogleMapRaw__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_gmaps__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_Footer_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_ErrorDialog__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ConfirmDialog__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_ResultDialog__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















// Import stylesheet


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      msg: "Welcome to Your Vue.js App",
      map: null,

      user: {},
      userID: null,
      // isCandidate: false,
      // isEmployer: false,

      showMobileNav: false
    };
  },
  created: function created() {
    this.setupInterceptor();
    this.$store.dispatch("tryAutoLogin");

    this.userID = this.$store.getters.userID;
    if (this.userID) {
      this.getUser();
    }

    // Bugsnag.notify(new Error('Test error'))
  },
  mounted: function mounted() {
    document.addEventListener("click", this.onClick);
    document.title = this.$store.getters.agencyHumanName;
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("click", this.onClick);
  },

  components: {
    GoogleMap: __WEBPACK_IMPORTED_MODULE_1__components_GoogleMap__["a" /* default */],
    GoogleMapRaw: __WEBPACK_IMPORTED_MODULE_2__components_GoogleMapRaw__["a" /* default */],
    ErrorDialog: __WEBPACK_IMPORTED_MODULE_7__components_common_ErrorDialog__["a" /* default */],
    ConfirmDialog: __WEBPACK_IMPORTED_MODULE_8__components_common_ConfirmDialog__["a" /* default */],
    ResultDialog: __WEBPACK_IMPORTED_MODULE_9__components_common_ResultDialog__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_4__components_global_Footer_vue__["a" /* default */]
  },
  computed: {
    // auth () { // Lecture 363
    //   return this.$store.getters.isAuthenticated
    // },
    // isCandidate() {
    //   if (this.user.is_candidate) {
    //     return true
    //   }
    //   else {
    //     return false
    //   }
    // },
    // isEmployer() {
    //   if (this.user.is_employer) {
    //     return true
    //   }
    //   else {
    //     return false
    //   }
    // },
    title: {
      get: function get() {
        document.title = this.remaining;
        return this.remaining;
      },
      set: function set(val) {
        // console.log(val)
        document.title = val;
      }
    },
    isLoading: function isLoading() {
      return this.$store.getters.loadingReqNumber > 0;
    }
  },
  methods: {
    setupInterceptor: function setupInterceptor() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.request.use(function (config) {
        _this.showLoading();
        if (localStorage.getItem("token")) {
          config.headers["Authorization"] = "Token " + localStorage.getItem("token");
        }
        // https://stackoverflow.com/questions/48173717/enabling-cors-on-a-nginx-server-in-elasticbeanstalk/48721443
        config.headers["Access-Control-Allow-Origin"] = "*";
        return config;
      }, function (error) {
        console.log(error);
        _this.hideLoading();
        return Promise.reject(error);
      });
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.response.use(function (response) {
        _this.hideLoading();
        return response;
      }, function (error) {
        _this.hideLoading();
        console.log(error);
        _this.handleError(error);
      });
    },
    handleError: function handleError(error) {
      console.log(error);
      if (error.response.data) {
        this.showErrorDialog({
          title: "There is an error",
          errorObj: error.response.data
        });
      } else {
        this.showErrorDialog({
          title: "There is an error",
          message: error.toString()
        });
      }
      throw error;
    },
    onClick: function onClick() {
      // Adding event handler to document:
      // https://stackoverflow.com/questions/41950432/vue-js-call-the-click-event-for-whole-page-document
      if (this.showMobileNav === true) {
        this.showMobileNav = false;
      }
    },

    // logout() {
    //   this.$store.dispatch("logout");
    // },
    getUser: function getUser() {
      var _this2 = this;

      console.log(this.userID);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/api/people/?id=".concat(this.userID)).then(function (res) {
        console.log(res.data);
        _this2.user = res.data[0];

        // this.isCandidate = this.user.is_candidate
        // this.isEmployer = this.user.is_employer
      }).catch(function (error) {
        console.log(error);
      });
    }
    // dashboardRedirect() {
    //   this.userID = this.$store.getters.userID
    //   axios.get('/api/people/?id='.concat(this.userID))
    //     .then(res => {
    //       console.log(res.data)
    //       this.user = res.data[0]

    //       if (this.user.is_candidate) {
    //         router.replace({name: 'Candidate Dashboard'})
    //       }
    //       else if (this.user.is_employer) {
    //         router.replace({name: 'Employer Dashboard'})
    //       }
    //       else if (this.user.is_agent) {
    //         router.replace({name: 'Agent Dashboard'})
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // }

  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GoogleMap",
  data: function data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      // center: { lat: 45.508, lng: -73.587 },
      center: { lat: 20.0, lng: 0.0 },
      markers: [],
      places: [],
      currentPlace: null,

      jobs: []
    };
  },
  mounted: function mounted() {
    // this.geolocate();
    this.getJobs();
  },


  methods: {
    // receives a place object via the autocomplete component
    setPlace: function setPlace(place) {
      this.currentPlace = place;
    },
    addMarker: function addMarker() {
      if (this.currentPlace) {
        var marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },

    geolocate: function geolocate() {
      var _this = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        _this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    getJobs: function getJobs() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?agency=4').then(function (res) {
        console.log(res);
        _this2.jobs = res.data;

        for (var job in res.data) {
          // console.log(res.data[job])
          var marker = {
            lat: res.data[job].job_latitude,
            lng: res.data[job].job_longitude
          };
          _this2.markers.push({ position: marker });
        }
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(26);
var normalizeHeaderName = __webpack_require__(580);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  // Only Node.JS has a process variable that is of [[Class]] process
  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(190);
  } else if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(190);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var settle = __webpack_require__(581);
var buildURL = __webpack_require__(187);
var parseHeaders = __webpack_require__(583);
var isURLSameOrigin = __webpack_require__(584);
var createError = __webpack_require__(191);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(585);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(582);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach([
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
    'socketPath'
  ], function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMapRaw_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a96c9f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMapRaw_vue__ = __webpack_require__(591);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMapRaw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a96c9f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMapRaw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_markerclusterer__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_markerclusterer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__google_markerclusterer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_gmaps__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      jobs: [],
      jobListings: []
      // jobListing: new google.maps.LatLng(41.5050175, -73.0682531),
    };
  },
  created: function created() {
    this.getJobs();
  },

  // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var google, map, markerClickHandler, jobListings, infowindow, markers;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_1__utils_gmaps__["a" /* default */])();

            case 3:
              google = _context.sent;
              map = new google.maps.Map(document.getElementById('map'), {
                // zoom: 12,
                zoom: 3,
                // center: {lat: 52.520, lng: 13.410}
                center: { lat: 15.0, lng: 0.0 }
              });

              // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/

              markerClickHandler = function markerClickHandler(marker) {
                map.setZoom(11);
                map.setCenter(marker.getPosition());
              };

              // Markers:
              // https://developers.google.com/maps/documentation/javascript/custom-markers
              // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/icon-complex
              // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/marker-animations-iteration


              jobListings = [{
                position: new google.maps.LatLng(13.524834, 2.109823),
                icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png'
              }, {
                position: new google.maps.LatLng(49.884017, -97.168579),
                icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png'
              }, {
                position: new google.maps.LatLng(45.421106, -75.690308),
                icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png'
              },
              // {
              //   position: new google.maps.LatLng(45.421106, -75.690308),
              //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
              // },
              {
                position: new google.maps.LatLng(41.5050175, -73.0682531),
                icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png'
              }];

              // var marker1 = new google.maps.Marker({
              //   // position: features[i].position,
              //   position: new google.maps.LatLng(13.524834, 2.109823),
              //   // icon: icons[features[i].type].icon,
              //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png',
              //   map: map
              // });
              // marker1.addListener(`click`, () => markerClickHandler(marker1));

              // var marker2 = new google.maps.Marker({
              //   // position: features[i].position,
              //   position: new google.maps.LatLng(49.884017, -97.168579),
              //   // icon: icons[features[i].type].icon,
              //   // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
              //   map: map
              // });

              // var marker3 = new google.maps.Marker({
              //   // position: features[i].position,
              //   position: new google.maps.LatLng(45.421106, -75.690308),
              //   // icon: icons[features[i].type].icon,
              //   // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
              //   map: map
              // });

              // var marker4 = new google.maps.Marker({
              //   // position: features[i].position,
              //   position: new google.maps.LatLng(45.421106, -75.690308),
              //   // icon: icons[features[i].type].icon,
              //   // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
              //   map: map
              // });

              // var marker5 = new google.maps.Marker({
              //   // position: features[i].position,
              //   position: new google.maps.LatLng(41.5050175, -73.0682531),
              //   // icon: icons[features[i].type].icon,
              //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
              //   map: map
              // });

              // https://developers.google.com/maps/documentation/javascript/infowindows, https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/infowindow-simple, https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/infowindow-simple-max

              infowindow = new google.maps.InfoWindow({
                // content: contentString
                content: 'dude'
              });

              // https://developers.google.com/maps/documentation/javascript/custom-markers

              markers = jobListings.map(function (jobListing) {
                // return new google.maps.Marker({
                var marker = new google.maps.Marker({
                  position: jobListing.position,
                  // label: labels[i % labels.length]
                  icon: jobListing.icon
                  // title: 'test'
                });
                marker.addListener('click', function () {
                  // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
                  markerClickHandler(marker);
                });
                return marker;
              });


              new __WEBPACK_IMPORTED_MODULE_0__google_markerclusterer___default.a(map, markers, {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
              });

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 12]]);
    }))();
  },

  methods: {
    // initMap() {
    //   map = new google.maps.Map(document.getElementById('map'), {
    //     zoom: 12,
    //     center: {lat: 52.520, lng: 13.410}
    //   });
    // },
    getJobs: function getJobs() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/jobs/?agency=4').then(function (res) {
        console.log(res);
        _this2.jobs = res.data;

        // for (var job in res.data) {
        //   // console.log(res.data[job])
        //   const marker = {
        //     lat: res.data[job].job_latitude,
        //     lng: res.data[job].job_longitude
        //   };
        //   this.markers.push({ position: marker });
        // }

        // for (var job in res.data) {
        //   this.jobListings.push({res.data[job].title})
        //   // {res.data[job].job_latitude, res.data[job].job_longitude}
        // }

        // for (var job in this.jobs) {
        //   this.jobListings.push(
        //     { position: new google.maps.LatLng(this.jobs[job].job_latitude, this.jobs[job].job_longitude)}
        //   )
        // }

        // this.loadMap
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      emailEmployer: '',
      emailCandidate: '',
      justSubscribed: false
    };
  },

  methods: {
    subscribeMailinglist: function subscribeMailinglist(category) {
      var _this = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2000);

      var email = '';
      if (category == 'Employer') {
        email = this.emailEmployer;
      }
      if (category == 'Candidate') {
        email = this.emailCandidate;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/mailinglist/', {
        // email: this.email,
        email: email,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
        category: category
      }).then(function (res) {
        console.log(res);
        _this.justSubscribed = true;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showstep1: false,
      showstep2: false,
      showstep3: false,
      showstep4: false,
      show: false,

      editing: false,
      pageTemplate: {},
      heroText: ''
    };
  },
  created: function created() {
    // this.getPageTemplate()
  },

  methods: {
    // getPageTemplate() {
    //   axios.get('/api/nannyhomepages/1')
    //     .then(res => {
    //       this.pageTemplate = res.data
    //       this.heroText = this.pageTemplate.hero_text
    //     })
    // },
    // updateTemplate() {
    //   axios.patch('/api/nannyhomepages/1/', {
    //     hero_text: this.heroText
    //   })
    //     .then(res => {
    //       this.getPageTemplate()
    //       this.editing = false
    //     })
    // }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios';
 // Don't have to name it axios, can name it anything - Lecture 348

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',

      loginError: false
    };
  },
  created: function created() {
    // this.$store.dispatch('tryAutoLogin')
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var formData = {
        email: this.email,
        password: this.password
      };
      console.log(formData);
      // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
      // axios.post('/users.json', formData)
      // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
      // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
      // axios.post('http://127.0.0.1:8000/api-token-auth/', {
      //   username: formData.email,
      //   password: formData.password,
      // })
      //   .then(res => console.log(res))
      //   .catch(error => console.log(error))
      this.$store.dispatch('login', { email: this.email, password: this.password }).then(function () {
        console.log('Successful login!');
      }).catch(function (error) {
        console.log('problemoo');
        console.log(error);
        // this.loginError = true

        // Some people register with capitalized emails, if we fail to log them in normally, try again with capitalized entries
        _this.$store.dispatch('login', { email: _this.capitalizeFirstLetter(_this.email), password: _this.capitalizeFirstLetter(_this.password) }).then(function () {
          console.log('Successful login with caps!');
        }).catch(function (error) {
          console.log('problemoo even with caps');
          console.log(error);
          _this.loginError = true;
        });
      });
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch('logout');
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import axios from '../../axios'; // Don't have to name it axios, can name it anything - Lecture 348

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      phone: '',
      password: '',

      consent: false,

      aakashid: 4 // Used for holding the id of the user with the email aakash@enginehire.ca, this is so I can send myself update emails when things happen
    };
  },
  created: function created() {
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var formData = {
        email: this.email,
        password: this.password
      };
      console.log(formData);
      // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
      // axios.post('/users.json', formData)
      // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
      // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
      // axios.post('http://127.0.0.1:8000/optimum/create-candidate/', {
      //   email: formData.email,
      //   password: formData.password,
      //   // returnSecureToken: true,
      //   agency: 2,
      // })
      //   .then(res => console.log(res))
      //   .catch(error => console.log(error))

      // https://vuex.vuejs.org/guide/actions.html
      // Once the user has been registered then we log them in
      // this.$store.dispatch('registerCandidate', {email: this.email, password: this.password}).then(() => {

      // THIS IS CAUSING PROBLEMS - CAN'T DO API CALL WITHOUT AUTHENTICATION
      // Get the id of the aakash@enginehire.ca user
      // this is necessary because the user changes depending on whether we are using the dev or production database
      // axios.get('/api/people/?email=aakash@enginehire.ca')
      //   .then(res => {
      //     console.log('Getting aakashid')
      //     console.log(res)
      //     console.log(res.data)
      //     console.log(res.data[0].id)
      //     this.aakashid = res.data[0].id
      //   })
      //   .catch(error => console.log(error))

      this.$store.dispatch('registerUser', { email: this.email, password: this.password, user_type: 'candidate', status: '', phone: this.phone }).then(function () {
        // this.$store.dispatch('testAction')
        // this.$store.dispatch('login', {email: this.email, password: this.password}).then(() => {
        //   this.$store.dispatch('getUser')
        // })
        console.log('Done registration');

        // Send myself an email notification that a new candidate registered
        _this.$store.dispatch('sendEmails', {
          subject: 'New Nanny Registration',
          message: 'Hi,\n\nA new nanny has just created an account with the email: ' + _this.email + '\nIf you would like to view their profile please log in with your administrator account at: https://pinknannies.enginehire.io/login\n\nThanks!',
          from: _this.$store.getters.agencyFromEmail,
          emails: [_this.$store.getters.enginehireLoggingEmail],
          // emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
          reply: _this.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });

        // // Get the id of the aakash@enginehire.ca user
        // // this is necessary because the user changes depending on whether we are using the dev or production database
        // axios.get('/api/people/?email=aakash@enginehire.ca')
        //   .then(res => {
        //     console.log('Getting aakashid')
        //     console.log(res)
        //     console.log(res.data)
        //     console.log(res.data[0].id)
        //     this.aakashid = res.data[0].id

        //     // Send myself an email notification that a new candidate registered
        //     this.$store.dispatch('sendEmail',
        //       {
        //         subject: 'New ThriveHire Candidate Registration!',
        //         message: 'New ThriveHire Candidate Registration!',
        //         // from: 'info@thrivehire.co',
        //         from: 'info@dameunamano.co',
        //         email: 'aakash@enginehire.ca',
        //         reply: 'info@thrivehire.co',
        //         userID: this.aakashid,
        //       }
        //     )
        //   })
        //   .catch(error => console.log(error))
      });
      // this.$store.dispatch('test')
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51dc5caa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(729);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51dc5caa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile_ProfileView__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jobs_MyJobs__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jobBoard_JobBoard__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373




// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userID'],
  data: function data() {
    return {
      user: {},
      tab: 'profile'
    };
  },

  components: {
    appProfileView: __WEBPACK_IMPORTED_MODULE_1__profile_ProfileView__["a" /* default */],
    MyJobs: __WEBPACK_IMPORTED_MODULE_2__jobs_MyJobs__["a" /* default */],
    JobBoard: __WEBPACK_IMPORTED_MODULE_3__jobBoard_JobBoard__["a" /* default */]
  },
  computed: {
    auth: function auth() {
      // Lecture 363
      return this.$store.getters.isAuthenticated;
    },
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    if (!this.userID) {
      // Don't want to scroll the page up if viewing the profile via the admin dashboard
      // Scroll the window up
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    }

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
    }, 2000);

    this.getUser();
  },
  mounted: function mounted() {
    // document.title = this.$refs.pageTitle.innerHTML
  },

  methods: {
    getUser: function getUser() {
      var _this = this;

      var userID = null;
      if (this.userID) {
        userID = this.userID;
      } else if (this.$route.params.id) {
        userID = this.$route.params.id;
      } else {
        userID = this.$store.getters.userID;
      }
      // console.log(this.$store.getters.userID)

      // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + userID.toString()).then(function (res) {
        // console.log(res)
        _this.user = res.data[0];
      }).catch(function (error) {
        return console.log(error);
      });
    },
    userUpdated: function userUpdated() {
      this.getUser();
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileView_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eefb0f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileView_vue__ = __webpack_require__(714);
function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eefb0f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasicInfo__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasicInfoForm__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProfessionalInfo__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProfessionalInfoForm__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DesiredRole__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DesiredRoleForm__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__References__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Documents__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NotesForm__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Experiences__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PersonalSummaryForm__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_Feedback__ = __webpack_require__(243);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a);













// Users
// import Resources from "../../users/Resources";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  components: {
    BasicInfo: __WEBPACK_IMPORTED_MODULE_4__BasicInfo__["a" /* default */],
    BasicInfoForm: __WEBPACK_IMPORTED_MODULE_5__BasicInfoForm__["a" /* default */],
    ProfessionalInfo: __WEBPACK_IMPORTED_MODULE_6__ProfessionalInfo__["a" /* default */],
    ProfessionalInfoForm: __WEBPACK_IMPORTED_MODULE_7__ProfessionalInfoForm__["a" /* default */],
    DesiredRole: __WEBPACK_IMPORTED_MODULE_8__DesiredRole__["a" /* default */],
    DesiredRoleForm: __WEBPACK_IMPORTED_MODULE_9__DesiredRoleForm__["a" /* default */],
    References: __WEBPACK_IMPORTED_MODULE_10__References__["a" /* default */],
    Documents: __WEBPACK_IMPORTED_MODULE_11__Documents__["a" /* default */],
    NotesForm: __WEBPACK_IMPORTED_MODULE_12__NotesForm__["a" /* default */],
    Experiences: __WEBPACK_IMPORTED_MODULE_13__Experiences__["a" /* default */],
    PersonalSummaryForm: __WEBPACK_IMPORTED_MODULE_14__PersonalSummaryForm__["a" /* default */],
    Feedback: __WEBPACK_IMPORTED_MODULE_15__users_Feedback__["a" /* default */]
  },
  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },

    // viewOnlyAccess() {
    //   if (this.$store.getters.isEmployer === 'true') {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    adminOrEmployer: function adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function data() {
    return {
      // user: {},
      // passedID: null,
    };
  },
  created: function created() {
    // this.user = this.passedUser
    // this.passedID = this.$route.params.id
    // if (this.passedID) {
    //   this.getUser()
    // }
  },

  methods: {
    // getUser() {
    //   axios.get('/api/people/?id='.concat(this.passedID.toString()))
    //   .then(res => {
    //     console.log(res.data)
    //     this.user = res.data[0]
    //   })
    //     .catch(error => console.log(error))
    // },
    editBasicInfo: function editBasicInfo() {
      this.$modal.show('basic-info-modal');
    },
    editPersonalSummary: function editPersonalSummary() {
      this.$modal.show('personal-summary-modal');
    },
    editProfessionalInfo: function editProfessionalInfo() {
      this.$modal.show('professional-info-modal');
    },
    editDesiredRole: function editDesiredRole() {
      this.$modal.show('desired-role-modal');
    },
    editNotes: function editNotes() {
      this.$modal.show('notes-modal');
    },
    basicInfoSaved: function basicInfoSaved() {
      this.$modal.hide('basic-info-modal');
      // this.getUser()
      this.$emit('userUpdated');
    },
    professionalInfoSaved: function professionalInfoSaved() {
      this.$modal.hide('professional-info-modal');
      this.$emit('userUpdated');
    },
    infoSaved: function infoSaved() {
      this.$modal.hide('basic-info-modal');
      this.$modal.hide('professional-info-modal');
      this.$modal.hide('desired-role-modal');
      this.$modal.hide('notes-modal');
      this.$modal.hide('personal-summary-modal');
      this.$emit('userUpdated');
    },
    submitApplication: function submitApplication() {
      var _this = this;

      // // Empty the list of missing fields from previous submits
      // this.missingFields = []

      // // Get the amount of references this candidate has submitted
      // axios.get('/api/references/?user='+this.user.id)
      //   .then(res => {
      //     // console.log(res.data)
      //     this.references = res.data.length
      //     console.log(this.references)
      //   })
      //   .catch(error => console.log(error))

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.formContainer,
      //   // container: this.$refs.formContainer,
      //   // canCancel: true,
      //   canCancel: false,
      //   // onCancel: this.onCancel,
      // });
      // // simulate AJAX
      // setTimeout(() => {
      //   loader.hide()

      //   // Check if required fields are filled in
      //   if (this.user.first_name && this.user.last_name && this.user.email && this.user.phone
      //       && this.user.boolean_selector1 && this.user.boolean_selector4
      //       && this.user.text2 && this.user.text4 && this.user.text10 && this.user.preferences.length >= 1
      //       && this.user.skills.length >= 1 && this.user.skills2.length >= 1
      //       && this.user.features.length >= 1 && this.user.preferences2.length >= 1 && this.user.available_date
      //       && this.user.text1 && this.user.text7 && this.user.text8
      //       && this.references >= 3
      //   )
      //   {
      //     // Change the local saved status to hide button to prevent duplicate emails being sent
      //     this.status = 'Application Pending Review'

      //     // Send email to notify of application profile completion
      //     this.$store.dispatch('sendEmails',
      //       {
      //         subject: 'Candidate Profile Completed ' + this.user.first_name + ' ' + this.user.last_name,
      //         message: 'Candidate Application completed by: ' + this.user.first_name + ' ' + this.user.last_name + ' | ' + this.user.email,
      //         from: this.$store.getters.agencyFromEmail,
      //         emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail3],
      //         // emails: [this.$store.getters.enginehireLoggingEmail],
      //         reply: this.$store.getters.agencyReplyEmail,
      //         // userID: this.aakashid,
      //         userID: 4,
      //       }
      //     )

      //     // Update the status of the candidate in the database
      //     axios.patch('/api/people/' + this.user.id + '/', {
      //       status: this.status,
      //     })

      //     this.submissionType = 'application'
      //     this.$modal.show('completed-application-modal')

      //   } else {
      //     // console.log('Missing fields')
      //     this.$modal.show('missing-fields-modal')

      //     // Check each to see which required fields are missing and add them to list to display to candidate
      //     if (!this.user.first_name) {
      //       // console.log('Need first name')
      //       this.missingFields.push('First name')
      //     }
      //     if (!this.user.last_name) {
      //       // console.log('Need last name')
      //       this.missingFields.push('Last name')
      //     }
      //     if (!this.user.email) {
      //       // console.log('Need email')
      //       this.missingFields.push('Email')
      //     }
      //     if (!this.user.phone) {
      //       // console.log('Need phone')
      //       this.missingFields.push('Phone number')
      //     }
      //     if (this.user.preferences.length < 1) {
      //       // console.log('Need positions')
      //       this.missingFields.push('Positions applying for')
      //     }
      //     if (!this.user.boolean_selector1) {
      //       // console.log('Need license')
      //       this.missingFields.push('Drivers license check')
      //     }
      //     if (!this.user.boolean_selector4) {
      //       // console.log('Need graduated')
      //       this.missingFields.push('High school graduation check')
      //     }
      //     if (!this.user.text2) {
      //       // console.log('Need vehicle')
      //       this.missingFields.push('Vehicle year, make & model')
      //     }
      //     if (!this.user.text10) {
      //       // console.log('Need high school')
      //       this.missingFields.push('High school name')
      //     }
      //     if (this.user.skills.length < 1) {
      //       // console.log('Need ages')
      //       this.missingFields.push('Ages you have experience with')
      //     }
      //     if (this.user.skills2.length < 1) {
      //       // console.log('Need experiences')
      //       this.missingFields.push('Types of experiences you have had')
      //     }
      //     if (!this.user.text4) {
      //       // console.log('Need languages')
      //       this.missingFields.push('Languages you speak fluently')
      //     }
      //     if (this.user.features.length < 1) {
      //       // console.log('Need documents')
      //       this.missingFields.push('Check documents you can provide')
      //     }
      //     if (this.user.preferences2.length < 1) {
      //       // console.log('Need days available')
      //       this.missingFields.push('Days of the week you are available')
      //     }
      //     if (!this.user.available_date) {
      //       // console.log('Need start date')
      //       this.missingFields.push('Date you can start')
      //     }
      //     if (!this.user.text7) {
      //       // console.log('Need hours per week')
      //       this.missingFields.push('How many hours you are looking to work per week')
      //     }
      //     if (!this.user.text8) {
      //       // console.log('Need schedule considerations')
      //       this.missingFields.push('Any schedule considerations')
      //     }
      //     if (!this.user.text1) {
      //       // console.log('Need ideal family')
      //       this.missingFields.push('Your ideal nanny family')
      //     }
      //     if (this.references < 3) {
      //       this.missingFields.push('Three references required')
      //     }
      //   }
      // },3000)

      // Send email to notify of application profile completion
      this.$store.dispatch('sendEmails', {
        subject: 'Candidate Profile Completed ' + this.user.first_name + ' ' + this.user.last_name,
        message: 'Candidate Application completed by: ' + this.user.first_name + ' ' + this.user.last_name + ' | ' + this.user.email,
        from: this.$store.getters.agencyFromEmail,
        emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail2],
        reply: this.$store.getters.agencyReplyEmail,
        // userID: this.aakashid,
        userID: 4
      });

      // Update the status of the candidate in the database
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        status: 'Profile Pending Review'
      }).then(function (res) {
        _this.user.status = 'Profile Pending Review';
        _this.$emit('userUpdated');
        _this.$modal.show('completed-application-modal');
      });
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess: function viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    },
    adminOrEmployer: function adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    editBasicInfo: function editBasicInfo() {
      this.$emit('editBasicInfo');
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // Validators pre built into vuelidate - lecture 373
// import ProfileView from './profile/ProfileView'

// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    var _ref;

    return _ref = {
      editing: false,

      // user: {},
      // users: [],
      currentStep: 1,

      summary: '',
      profilePic: '',
      name: '',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      city: '',
      provinceState: '',
      // cities: ['Bogotá', 'Medellin', 'Cali', 'Barranquilla', 'Cartagena', 'Cúcuta', 'Soledad', 'Ibagué', 'Soacha', 'Bucaramanga'],
      country: '',
      address1: '',
      address2: '',
      postalCode: '',
      linkedin: '',

      organizationTypes: [],
      organizationTypesOptions: [],
      focusAreas: [],
      focusAreasOptions: [],

      // organizationStatures: [],
      // organizationStaturesOptions: [],
      sizes: [],
      sizesOptions: [],
      countries: [],
      countriesOptions: [],
      salaryRange: '',
      salaryRangeOptions: [],
      jobTypes: [],
      jobTypesOptions: [],

      pep: null,
      experiences: [],
      availability: [],
      title: '',
      reference: '',
      step1saveClicked: false,
      step2saveClicked: false,
      // --
      randomRenderer: []

    }, _defineProperty(_ref, 'title', ''), _defineProperty(_ref, 'titleOptions', []), _defineProperty(_ref, 'facebook', ''), _defineProperty(_ref, 'instagram', ''), _defineProperty(_ref, 'overview', ''), _defineProperty(_ref, 'textField1', ''), _defineProperty(_ref, 'selector1', ''), _defineProperty(_ref, 'personality', ''), _defineProperty(_ref, 'talents', ''), _defineProperty(_ref, 'weekends', ''), _defineProperty(_ref, 'subject', ''), _ref;
  },

  components: {
    // appProfileView: ProfileView,
  },
  validations: { // Lecture 373
    // name: {
    //   required,
    // },
    firstName: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    lastName: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    // phone: {
    //   required,
    // },
    city: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    country: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    address1: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    postalCode: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    auth: function auth() {
      // Lecture 363
      return this.$store.getters.isAuthenticated;
    }
  },
  created: function created() {
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    // this.getUser()

    this.sizesOptions = this.$store.getters.organizationSizes;
    this.organizationTypesOptions = this.$store.getters.organizationTypes;
    this.focusAreasOptions = this.$store.getters.focusAreas;
    this.countriesOptions = this.$store.getters.countries;
    this.skillsOptions = this.$store.getters.skills;
    this.salaryRangeOptions = this.$store.getters.salaryRanges;
    this.jobTypesOptions = this.$store.getters.jobTypes;

    this.selector1Options = this.$store.getters.selector1Options;
    this.selector2Options = this.$store.getters.selector2Options;
    this.selector3Options = this.$store.getters.selector3Options;

    this.skillsOptions = this.$store.getters.skills;
    this.skills2Options = this.$store.getters.skills2;
    this.skills3Options = this.$store.getters.skills3;

    this.preferencesOptions = this.$store.getters.preferences;

    this.titleOptions = this.$store.getters.titles;

    // ----------------

    this.summary = this.user.overview;
    // this.name = this.user.name
    this.firstName = this.user.first_name;
    this.lastName = this.user.last_name;
    this.phone = this.user.phone;
    this.email = this.user.email;
    this.city = this.user.city;
    this.provinceState = this.user.provincestate;
    this.country = this.user.country;
    this.postalCode = this.user.postal_code;
    this.address1 = this.user.address1;
    this.address2 = this.user.address2;
    this.linkedin = this.user.linkedin;

    // this.facebook = this.user.facebook
    this.facebook = this.user.text12;
    // this.instagram = this.user.instagram
    this.instagram = this.user.text13;
    this.overview = this.user.overview;
    this.textField1 = this.user.text_field1;
    // this.textField2 = this.user.text2
    this.selector1 = this.user.selector1;

    this.personality = this.user.text7;
    this.talents = this.user.text8;
    this.weekends = this.user.text9;
    this.subject = this.user.text10;
  },

  methods: {
    // getUser() {
    //   console.log(this.$store.getters.userID)
    //   // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
    //   axios.get('/api/people/?id='.concat(this.user.id))
    //     .then(res => {
    //       // console.log(res)
    //       this.user = res.data[0]

    //       this.summary = this.user.overview
    //       // this.name = this.user.name
    //       this.firstName = this.user.first_name
    //       this.lastName = this.user.last_name
    //       this.phone = this.user.phone
    //       this.email = this.user.email
    //       this.city = this.user.city
    //       this.provinceState = this.user.provincestate
    //       this.country = this.user.country
    //       this.postalCode = this.user.postal_code
    //       this.address1 = this.user.address1
    //       this.address2 = this.user.address2
    //       this.linkedin = this.user.linkedin

    //       // this.focusAreas = this.user.sectors
    //       // this.jobTypes = this.user.job_types
    //       // this.organizationTypes = this.user.preferences3
    //       // this.countries = this.user.preferences2
    //       // this.sizes = this.user.preferences

    //       // this.salaryRange = this.user.salary_range
    //       // this.selector1 = this.user.selector1
    //       // this.selector2 = this.user.selector2
    //       // this.selector3 = this.user.selector3

    //       // this.skills = this.user.skills
    //       // this.skills2 = this.user.skills2
    //       // this.skills3 = this.user.skills3

    //       // this.preferences = this.user.preferences

    //       // this.title = this.user.title

    //       // this.facebook = this.user.facebook
    //       this.facebook = this.user.text12
    //       // this.instagram = this.user.instagram
    //       this.instagram = this.user.text13
    //       this.overview = this.user.overview
    //       this.textField1 = this.user.text_field1
    //       // this.textField2 = this.user.text2
    //       this.selector1 = this.user.selector1

    //       this.personality = this.user.text7
    //       this.talents = this.user.text8
    //       this.weekends = this.user.text9
    //       this.subject = this.user.text10
    //     })
    //     .catch(error => console.log(error))
    // },
    // https://serversideup.net/uploading-files-vuejs-axios/
    handleFileUpload: function handleFileUpload() {
      this.profilePic = this.$refs.profile_pic.files[0];
    },
    saveStep1: function saveStep1() {
      var _this = this;

      console.log('Saving Step 1');
      // $v.name.$touch();
      this.$v.$touch();
      // this.step1saveClicked = true
      // console.log(this.$store.getters.userAPIURL)
      // axios.patch(this.$store.getters.userAPIURL, {name: this.name})
      //   .then(res => console.log(res))
      //   .catch(error => console.log(error))

      // Only write to the database if all the fields have been filled
      // pep needs to be filled and be a number - https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
      // if (this.name && this.city && this.country && this.address1 && this.pep && !isNaN(this.pep)) {
      // if (!this.$v.firstName.$error && !this.$v.lastName.$error && !this.$v.address1.$error && !this.$v.city.$error && !this.$v.country.$error && !this.$v.postalCode.$error) {
      if (!this.$v.firstName.$error && !this.$v.lastName.$error) {

        // console.log(this.user.status)
        // let new_status = this.user.status
        // if (this.user.status == '' || this.user.status == 'New') { // We only want to update the status if the user is at an earlier status
        //   new_status = 'Personal Information'
        // }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(this.user.id.toString()).concat('/'), {
          // name: this.name,
          overview: this.summary,
          first_name: this.firstName,
          last_name: this.lastName,
          phone: this.phone,
          email: this.email,
          city: this.city,
          provincestate: this.provinceState,
          country: this.country,
          address1: this.address1,
          address2: this.address2,
          postal_code: this.postalCode,
          // linkedin: this.linkedin,
          // facebook: this.facebook,
          // instagram: this.instagram,

          // text12: this.facebook,
          // text13: this.instagram,
          // overview: this.overview,
          // text_field1: this.textField1,
          // selector1: this.selector1,

          text7: this.personality,
          text8: this.talents,
          text9: this.weekends,
          text10: this.subject
        }).then(function (res) {
          console.log(res);

          var formData = new FormData();
          if (_this.profilePic) {
            formData.append('profile_pic', _this.profilePic);
          }

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(_this.user.id.toString()).concat('/'), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (res) {
            // Scroll the window back up after saving the step
            window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

            // this.getUser()
            // this.editing = false

            _this.$emit('basicInfoSaved'); // Lecture 112

            // https://www.npmjs.com/package/vue-loading-overlay
            var loader = _this.$loading.show({
              // Optional parameters
              container: _this.fullPage ? null : _this.$refs.formContainer,
              // container: this.$refs.formContainer,
              // canCancel: true,
              canCancel: false
              // onCancel: this.onCancel,
            });
            // simulate AJAX
            setTimeout(function () {
              loader.hide();
            }, 2000);
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          return console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;
exports._setTarget = exports.target = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var stack = [];
var target = null;
exports.target = target;

var _setTarget = function _setTarget(x) {
  exports.target = target = x;
};

exports._setTarget = _setTarget;

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }

  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;

  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }

    newTarget.$sub.push(lastTarget);
  }

  return lastTarget;
}

function addParams(params) {
  if (_typeof(params) === 'object' && !Array.isArray(params)) {
    exports.target = target = _objectSpread({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();

    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }

  return withParamsClosure(paramsOrClosure);
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_DetailSectionColumnLayout__ = __webpack_require__(126);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DetailSectionColumnLayout: __WEBPACK_IMPORTED_MODULE_0__common_DetailSectionColumnLayout__["a" /* default */]
  },
  mounted: function mounted() {
    console.log(this.user);
  },

  props: ["user"],
  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess: function viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to detail information of fields by columns*/

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DetailSectionColumnLayout",
  props: {
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listExcludeFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelData: Object,
    labelKey: {
      type: String,
      default: "label"
    },
    itemPerColumns: Array
  },
  computed: {
    listFieldsByColumn: function listFieldsByColumn() {
      var _this = this;

      return this.listFields.reduce(function (accResult, cur) {
        if (accResult.length === 0) {
          return [[cur]];
        }
        var lastEl = accResult[accResult.length - 1];
        if (lastEl.length === _this.itemPerColumns[accResult.length - 1]) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  },
  methods: {
    isDisplayItem: function isDisplayItem(item) {
      if (this.listExcludeFields.includes(item.model)) {
        return false;
      }
      if (!this.isItemShow(this.modelData, item)) {
        return false;
      }
      if (this.isMissingField(this.modelData, item.model, item.type)) {
        return false;
      }
      if (item.keyNotNull) {
        if (this.modelData[item.keyNotNull] == null) {
          return false;
        }
      }
      if (item.keyNull) {
        if (this.modelData[item.keyNull] != null) {
          return false;
        }
      }
      return true;
    },
    getDisplayValue: function getDisplayValue(key) {
      var value = this.getValueOfObjectKey(this.modelData, key);
      if (Array.isArray(value)) {
        return value.map(function (item) {
          return "<li class=\"list-detail-item\">" + item + "</li>";
        }).join("");
      }
      if (typeof value === "boolean") {
        return value ? "Yes" : "No";
      }
      return value;
    },
    getDisplayLabel: function getDisplayLabel(item) {
      var result = item.label;
      if (item[this.labelKey]) {
        result = item[this.labelKey];
      }
      result = result.trim();
      if (result && result.length > 0) {
        if (result[result.length - 1] === "*") {
          result = result.substring(0, result.length - 1).trim();
        }
      }
      return result;
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FormGroupColumnLayout__ = __webpack_require__(211);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormGroupColumnLayout: __WEBPACK_IMPORTED_MODULE_1__common_FormGroupColumnLayout__["a" /* default */]
  },
  props: ["user"],
  data: function data() {
    return {
      submitClicked: false,
      professionalInfo: this.extractSelectedFields(this.user, this.$store.getters.professionalInfoFields)
    };
  },

  methods: {
    save: function save() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.professionalInfo, this.$store.getters.professionalInfoFields)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        this.updateProfessionalInfo();
      }
    },
    updateProfessionalInfo: function updateProfessionalInfo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/".concat(this.user.id.toString()).concat("/"), this.professionalInfo).then(function (res) {
        _this.$emit("infoSaved");
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupColumnLayout_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c77a39_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGroupColumnLayout_vue__ = __webpack_require__(663);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupColumnLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c77a39_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGroupColumnLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextBoxWithLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextAreaWithLabel__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePickerWithLabel__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RadioGroup__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownWithLabel__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckboxGroup__ = __webpack_require__(222);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show for a list of form (textbox, radio button, checkbox, datepicker ...) 
Elements of form group will be layout into multiple columns*/








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FormGroupRowLayout",
  components: {
    TextBoxWithLabel: __WEBPACK_IMPORTED_MODULE_1__TextBoxWithLabel__["a" /* default */],
    TextAreaWithLabel: __WEBPACK_IMPORTED_MODULE_2__TextAreaWithLabel__["a" /* default */],
    DatePickerWithLabel: __WEBPACK_IMPORTED_MODULE_3__DatePickerWithLabel__["a" /* default */],
    RadioGroup: __WEBPACK_IMPORTED_MODULE_4__RadioGroup__["a" /* default */],
    DropdownWithLabel: __WEBPACK_IMPORTED_MODULE_5__DropdownWithLabel__["a" /* default */],
    CheckboxGroup: __WEBPACK_IMPORTED_MODULE_6__CheckboxGroup__["a" /* default */]
  },
  props: {
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelData: Object,
    submitClicked: {
      type: Boolean,
      default: false
    },
    itemPerColumns: Array
  },
  data: function data() {
    return {
      FORM_TYPE: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */]
    };
  },
  computed: {
    listFieldsByColumn: function listFieldsByColumn() {
      var _this = this;

      return this.listFields.reduce(function (accResult, cur) {
        if (accResult.length === 0) {
          return [[cur]];
        }
        var lastEl = accResult[accResult.length - 1];
        if (lastEl.length === _this.itemPerColumns[accResult.length - 1]) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_regex__ = __webpack_require__(214);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a textbox
Any error of textbox (for example: required field, invalid character, exceed length ...) is showed in this component */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TextBoxWithLabel",
  props: {
    /* Name of the textbox component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // Type of input: text or number
    type: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["c" /* TEXTBOX_INPUT_TYPE */].TEXT
    },
    // Validation for input
    validation: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    // Max length of input
    maxLength: {
      type: Number
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  // created() {
  //   this.$emit("input", this.label);
  // },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    },
    validationErrorMessage: function validationErrorMessage() {
      if (!this.inputVal) {
        return;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.validation[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var validateItem = _step.value;

          if (validateItem.regex) {
            if (!validateItem.regex.test(this.inputVal)) {
              return validateItem.message;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  methods: {
    handleOnInput: function handleOnInput() {
      var _this = this;

      if (this.type && __WEBPACK_IMPORTED_MODULE_1__constants_regex__["b" /* REGEX_VALID_NUMBER */][this.type]) {
        var oldVal = this.inputVal;
        this.$nextTick(function () {
          if (!__WEBPACK_IMPORTED_MODULE_1__constants_regex__["b" /* REGEX_VALID_NUMBER */][_this.type].test(_this.inputVal)) {
            _this.inputVal = oldVal;
            _this.$refs.input.blur();
            setTimeout(function () {
              _this.$refs.input.focus();
            });
          }
        });
      }
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGEX_VALID_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REGEX_EXTRACT_TAG_CONTENT; });
var REGEX_VALID_NUMBER = {
  INTEGER: new RegExp("^\\-?\\d*$"),
  POSITIVE_INTEGER: new RegExp("^\\d*$"),
  DOUBLE: new RegExp("^\\-?(\\d+\\.)?\\d*$"),
  POSITIVE_DOUBLE: new RegExp("^(\\d+\\.)?\\d*$")
};

var REGEX_EXTRACT_TAG_CONTENT = new RegExp("<.*>([^<>]*)<.*>");

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a323ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAreaWithLabel_vue__ = __webpack_require__(658);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a323ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAreaWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a textarea
Any error of textarea (for example: required field, invalid character, exceed length ...) is showed in this component */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TextAreaWithLabel",
  props: {
    /* Name of the textarea component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: String,
    // Number of rows of textarea
    rows: {
      type: Number,
      default: 4
    },
    // Max length of input
    maxLength: {
      type: Number
    },
    placeholder: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  // created() {
  //   this.$emit("input", this.label);
  // },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c9eed8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePickerWithLabel_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c9eed8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePickerWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a date picker
Any error of user input for the date picker (for example: required field, invalid day ...) is showed in this component */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DatePickerWithLabel",
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */]
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Date],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // Initial view: year or month
    initialView: {
      type: String,
      default: "year"
    },
    // Allow to input date in the past
    allowPastDate: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  // created() {
  //   this.$emit("input", this.dateInDjangoFormat(new Date()));
  // },
  computed: {
    inputVal: {
      get: function get() {
        if (this.value == null) {
          return null;
        }
        return this.value + "T00:00:00"; // This is to prevent the date from going one day behind
      },
      set: function set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    },
    disabledPastDates: function disabledPastDates() {
      if (this.allowPastDate) {
        return {};
      }
      var today = new Date();
      return {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a radio group, which includes radio buttons and its label
Any error of the radio group (for example: required field) is showed in this component */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "RadioGroup",
  props: {
    /* Name of the radio component, it is used in id of each radio button,
    therefore it need to be different between RadioGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: [String, Boolean],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for radio buttons (the label of each radio buttons)
    optionList: {
      type: Array,
      default: function _default() {
        return ["Yes", "No"];
      }
    },
    hasOther: {
      type: Boolean,
      default: false
    },
    // TODO, inital selected option
    initialSelection: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Option to use 'Yes', 'No' for boolean model instead of true, false (in case out of boolean_selector)
    isBooleanModel: {
      type: Boolean,
      default: true
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    if (this.initialSelection && this.value == null) {
      this.$emit("input", this.initialSelection);
    }
  },

  // created() {
  //   if (this.isBooleanRadioGroup()) {
  //     this.$emit("input", true);
  //   } else {
  //     this.$emit("input", this.optionList[0]);
  //   }
  // },
  computed: {
    getOtherValue: function getOtherValue() {
      if (!this.optionListExcludeOther.includes(this.value)) {
        return this.value;
      }
    },
    optionListExcludeOther: function optionListExcludeOther() {
      return this.optionList.slice(0, -1);
    }
  },
  methods: {
    isCheck: function isCheck(option, index) {
      if (this.isBooleanRadioGroup()) {
        if (this.value === true) {
          return option === "Yes";
        } else if (this.value === false) {
          return option === "No";
        }
        return false;
      } else {
        if (this.hasOther && this.value != null) {
          if (index === this.optionList.length - 1) {
            if (!this.optionListExcludeOther.includes(this.value)) {
              return true;
            }
          }
        }
        return option === this.value;
      }
    },
    handleOnChange: function handleOnChange(option, index) {
      if (this.isBooleanRadioGroup()) {
        this.$emit("input", option === "Yes");
      } else {
        if (this.hasOther && index === this.optionList.length - 1) {
          this.$emit("input", "");
        } else {
          this.$emit("input", option);
        }
      }
    },
    handleOtherTextboxInput: function handleOtherTextboxInput(event) {
      this.$emit("input", event.target.value);
    },
    isBooleanRadioGroup: function isBooleanRadioGroup() {
      if (!this.isBooleanModel) {
        return false;
      }
      return this.optionList.length === 2 && this.optionList[0] === "Yes" && this.optionList[1] === "No";
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8281a1b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownWithLabel_vue__ = __webpack_require__(661);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8281a1b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a dropdown list
Any error of the dropdown list (for example: required field) is showed in this component */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DropdownWithLabel",
  props: {
    /* Name of the dropdown component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    optionList: Array
  },
  // created() {
  //   this.$emit("input", this.optionList[0]);
  // },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6078e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroup_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6078e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a checkbox group, which includes  checkboxes and its label
Any error of the checkbox group (for example: required field) is showed in this component */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CheckboxGroup",
  props: {
    /* Name of the checkbox component, it is used in id of each checkbox, 
    therefore it need to be different between CheckboxGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: Array
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      listCheckedOption: this.value
    };
  },

  // created() {
  //   this.listCheckedOption.push(this.optionList[0]);
  //   this.$emit("input", this.listCheckedOption);
  // },
  methods: {
    onChangeCheck: function onChangeCheck(option, isCheck) {
      if (isCheck) {
        this.listCheckedOption.push(option);
      } else {
        this.listCheckedOption = this.listCheckedOption.filter(function (checkedOption) {
          return checkedOption !== option;
        });
      }
      this.$emit("input", this.listCheckedOption);
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess: function viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // https://www.npmjs.com/package/vuejs-datepicker

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  props: ['user'],
  data: function data() {
    return {
      documents: [],
      documentsOptions: [],
      startDate: null,
      days: [],
      daysOptions: [],
      committment: '',
      hours: '',
      schedule: '',
      familyDescription: '',
      activeProfile: false,
      jobSite: '',
      marketingSource: ''
    };
  },
  created: function created() {
    this.documentsOptions = this.$store.getters.documentsOptions;
    this.daysOptions = this.$store.getters.days;

    this.documents = this.user.features;
    if (this.user.available_date) {
      this.startDate = new Date(this.user.available_date);
    }
    this.days = this.user.preferences2;
    this.committment = this.user.text6;
    this.hours = this.user.text7;
    this.schedule = this.user.text8;
    this.familyDescription = this.user.text1;
    this.activeProfile = this.user.boolean_selector3;
    this.jobSite = this.user.text9;
    this.marketingSource = this.user.marketing_source;
  },

  computed: {
    disabledDates: function disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      var today = new Date();
      var disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
      return disabledDates;
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      if (this.startDate) {
        this.startDate = this.dateInDjangoFormat(this.startDate);
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(this.user.id.toString()).concat('/'), {
        features: this.documents,
        available_date: this.startDate,
        preferences2: this.days,
        text6: this.committment,
        text7: this.hours,
        text8: this.schedule,
        text1: this.familyDescription,
        boolean_selector3: this.activeProfile,
        text9: this.jobSite,
        marketing_source: this.marketingSource
      }).then(function (res) {
        // this.$emit('professionalInfoSaved')
        _this.$emit('infoSaved');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_DetailSectionColumnLayout__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialogs_ReferenceFormDialog__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["user"],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_3_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_3_tiptap__["c" /* EditorMenuBar */],
    DetailSectionColumnLayout: __WEBPACK_IMPORTED_MODULE_1__common_DetailSectionColumnLayout__["a" /* default */],
    ReferenceFormDialog: __WEBPACK_IMPORTED_MODULE_2__dialogs_ReferenceFormDialog__["a" /* default */]
  },
  data: function data() {
    return {
      references: [],
      reference: {},
      firstName: "",
      lastName: "",
      relationship: "",
      phone: "",
      phone2: "",
      email: "",

      // numChildren: '',
      // ageChildren: '',
      // years: '',
      // frequency: '',
      // jobDescription: '',
      description: "",

      descriptionEditor: null,
      referenceInterviewNotes: "",
      contactHistory: "",
      isShowReferenceFormDialog: false,
      isAddReferenceDialog: false
    };
  },

  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess: function viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    },
    adminOrEmployer: function adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.getReferences();
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_3_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: "",
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["j" /* Image */]() // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.referenceInterviewNotes = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
  },

  methods: {
    isReferenceNote: function isReferenceNote(ref) {
      return ref.reference_note != null && ref.reference_note !== "";
    },
    getReferences: function getReferences() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/references/?user=" + this.user.id).then(function (res) {
        _this2.references = res.data;
        _this2.references = _this2.references.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    showAddReferenceDialog: function showAddReferenceDialog() {
      this.isAddReferenceDialog = true;
      this.reference = {};
      this.isShowReferenceFormDialog = true;
    },
    showEditReferenceDialog: function showEditReferenceDialog(ref) {
      this.isAddReferenceDialog = false;
      this.reference = _extends({}, ref);
      this.isShowReferenceFormDialog = true;
    },
    showReferenceInterviewNotesModal: function showReferenceInterviewNotesModal(reference) {
      var _this3 = this;

      this.reference = reference;
      // this.referenceInterviewNotes = reference.reference_note
      // console.log(reference.reference_note)
      if (reference.reference_note) {
        this.descriptionEditor.setContent(reference.reference_note);
        this.referenceInterviewNotes = reference.reference_note;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/richtemplates/?agency=" + this.$store.getters.agencyID + "&selector2=Reference Check").then(function (res) {
          console.log(res);
          if (res.data.length) {
            _this3.descriptionEditor.setContent(res.data[0].body);
            _this3.referenceInterviewNotes = res.data[0].body;
          } else {
            _this3.descriptionEditor.setContent('');
            _this3.referenceInterviewNotes = '';
          }
        });
      }

      this.contactHistory = reference.text2;

      this.$modal.show("reference-interview-notes-modal");
    },
    saveReferenceInterviewNotes: function saveReferenceInterviewNotes(reference) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/references/" + this.reference.id + "/", {
        reference_note: this.referenceInterviewNotes
        // text2: this.contactHistory
      }).then(function (res) {
        _this4.getReferences();
        _this4.$modal.hide("reference-interview-notes-modal");
        _this4.$modal.show("reference-interview-notes-updated-modal");
      });
    },
    showViewReferenceInterviewNotesModal: function showViewReferenceInterviewNotesModal(reference) {
      this.reference = reference;
      this.$modal.show("view-reference-interview-notes-modal");
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferenceFormDialog_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d440da22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferenceFormDialog_vue__ = __webpack_require__(670);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferenceFormDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d440da22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferenceFormDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FormGroupColumnLayout__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ReferenceFormDialog",
  components: {
    FormGroupColumnLayout: __WEBPACK_IMPORTED_MODULE_1__common_FormGroupColumnLayout__["a" /* default */]
  },
  props: {
    user: Object,
    reference: Object,
    value: Boolean,
    isAdd: Boolean,
    isSendRequest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      submitClicked: false,
      ACTION_TYPE: __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */]
    };
  },

  methods: {
    hideModal: function hideModal() {
      this.$modal.hide("reference-form-modal");
      this.$emit("input", false);
    },
    showModal: function showModal() {
      console.log("show");
      this.$modal.show("reference-form-modal");
    },
    handleClickSaveButton: function handleClickSaveButton() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.reference, this.$store.getters.referenceListFields)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        if (this.isSendRequest) {
          if (this.isAdd) {
            this.postReference();
          } else {
            this.patchReference();
          }
        } else {
          this.hideModal();
          this.$emit("saved", this.isAdd ? __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */].ADD : __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */].UPDATE);
        }
      }
    },
    postReference: function postReference() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/references/", _extends({}, this.reference, {
        user: this.user.id
      })).then(function (res) {
        _this.hideModal();
        _this.$emit("saved");
      }).catch(function (error) {
        console.log(error);
      });
    },
    patchReference: function patchReference() {
      var _this2 = this;

      var splitRefName = this.getFirstNameAndLastName(this.reference.name);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/references/" + this.reference.id + "/", _extends({}, this.reference, {
        user: this.user.id
      })).then(function (res) {
        _this2.hideModal();
        _this2.$emit("saved");
      }).catch(function (error) {
        console.log(error);
      });
    },
    showDeleteReferenceConfirmDialog: function showDeleteReferenceConfirmDialog() {
      this.showConfirmDialog(_extends({}, this.$store.getters.deleteReferenceConfirmDialog, {
        onAcceptCallback: this.deleteReference
      }));
    },
    deleteReference: function deleteReference() {
      var _this3 = this;

      if (this.isSendRequest) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/api/references/" + this.reference.id + "/").then(function (res) {
          _this3.hideModal();
          _this3.$emit("saved");
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.hideModal();
        this.$emit("saved", __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */].DELETE);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        if (value === true) {
          console.log("show?");
          this.submitClicked = false;
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellSelection", function() { return CellSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableMap", function() { return TableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__clipCells", function() { return clipCells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__insertCells", function() { return insertCells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__pastedCells", function() { return pastedCells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addColumn", function() { return addColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addColumnAfter", function() { return addColumnAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addColumnBefore", function() { return addColumnBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRow", function() { return addRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRowAfter", function() { return addRowAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRowBefore", function() { return addRowBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cellAround", function() { return cellAround; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colCount", function() { return colCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columnResizing", function() { return columnResizing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columnResizingPluginKey", function() { return key$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteColumn", function() { return deleteColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteRow", function() { return deleteRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTable", function() { return deleteTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findCell", function() { return findCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixTables", function() { return fixTables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixTablesKey", function() { return fixTablesKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToNextCell", function() { return goToNextCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePaste", function() { return handlePaste; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inSameTable", function() { return inSameTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInTable", function() { return isInTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeCells", function() { return mergeCells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moveCellForward", function() { return moveCellForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextCell", function() { return nextCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeColumn", function() { return removeColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeRow", function() { return removeRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rowIsHeader", function() { return rowIsHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedRect", function() { return selectedRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectionCell", function() { return selectionCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCellAttr", function() { return setCellAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitCell", function() { return splitCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitCellWithType", function() { return splitCellWithType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tableEditing", function() { return tableEditing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tableEditingKey", function() { return key; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tableNodes", function() { return tableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleHeader", function() { return toggleHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleHeaderCell", function() { return toggleHeaderCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleHeaderColumn", function() { return toggleHeaderColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleHeaderRow", function() { return toggleHeaderRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateColumnsOnResize", function() { return updateColumns; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__ = __webpack_require__(50);






// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.

var readFromCache, addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap != "undefined") {
  var cache = new WeakMap;
  readFromCache = function (key) { return cache.get(key); };
  addToCache = function (key, value) {
    cache.set(key, value);
    return value
  };
} else {
  var cache$1 = [], cacheSize = 10, cachePos = 0;
  readFromCache = function (key) {
    for (var i = 0; i < cache$1.length; i += 2)
      { if (cache$1[i] == key) { return cache$1[i + 1] } }
  };
  addToCache = function (key, value) {
    if (cachePos == cacheSize) { cachePos = 0; }
    cache$1[cachePos++] = key;
    return cache$1[cachePos++] = value
  };
}

var Rect = function Rect(left, top, right, bottom) {
  this.left = left; this.top = top; this.right = right; this.bottom = bottom;
};

// ::- A table map describes the structore of a given table. To avoid
// recomputing them all the time, they are cached per table node. To
// be able to do that, positions saved in the map are relative to the
// start of the table, rather than the start of the document.
var TableMap = function TableMap(width, height, map, problems) {
  // :: number The width of the table
  this.width = width;
  // :: number The table's height
  this.height = height;
  // :: [number] A width * height array with the start position of
  // the cell covering that part of the table in each slot
  this.map = map;
  // An optional array of problems (cell overlap or non-rectangular
  // shape) for the table, used by the table normalizer.
  this.problems = problems;
};

// :: (number) → Rect
// Find the dimensions of the cell at the given position.
TableMap.prototype.findCell = function findCell (pos) {
  for (var i = 0; i < this.map.length; i++) {
    var curPos = this.map[i];
    if (curPos != pos) { continue }
    var left = i % this.width, top = (i / this.width) | 0;
    var right = left + 1, bottom = top + 1;
    for (var j = 1; right < this.width && this.map[i + j] == curPos; j++) { right++; }
    for (var j$1 = 1; bottom < this.height && this.map[i + (this.width * j$1)] == curPos; j$1++) { bottom++; }
    return new Rect(left, top, right, bottom)
  }
  throw new RangeError("No cell with offset " + pos + " found")
};

// :: (number) → number
// Find the left side of the cell at the given position.
TableMap.prototype.colCount = function colCount (pos) {
  for (var i = 0; i < this.map.length; i++)
    { if (this.map[i] == pos) { return i % this.width } }
  throw new RangeError("No cell with offset " + pos + " found")
};

// :: (number, string, number) → ?number
// Find the next cell in the given direction, starting from the cell
// at `pos`, if any.
TableMap.prototype.nextCell = function nextCell (pos, axis, dir) {
  var ref = this.findCell(pos);
    var left = ref.left;
    var right = ref.right;
    var top = ref.top;
    var bottom = ref.bottom;
  if (axis == "horiz") {
    if (dir < 0 ? left == 0 : right == this.width) { return null }
    return this.map[top * this.width + (dir < 0 ? left - 1 : right)]
  } else {
    if (dir < 0 ? top == 0 : bottom == this.height) { return null }
    return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)]
  }
};

// :: (number, number) → Rect
// Get the rectangle spanning the two given cells.
TableMap.prototype.rectBetween = function rectBetween (a, b) {
  var ref = this.findCell(a);
    var leftA = ref.left;
    var rightA = ref.right;
    var topA = ref.top;
    var bottomA = ref.bottom;
  var ref$1 = this.findCell(b);
    var leftB = ref$1.left;
    var rightB = ref$1.right;
    var topB = ref$1.top;
    var bottomB = ref$1.bottom;
  return new Rect(Math.min(leftA, leftB), Math.min(topA, topB),
                  Math.max(rightA, rightB), Math.max(bottomA, bottomB))
};

// :: (Rect) → [number]
// Return the position of all cells that have the top left corner in
// the given rectangle.
TableMap.prototype.cellsInRect = function cellsInRect (rect) {
  var result = [], seen = {};
  for (var row = rect.top; row < rect.bottom; row++) {
    for (var col = rect.left; col < rect.right; col++) {
      var index = row * this.width + col, pos = this.map[index];
      if (seen[pos]) { continue }
      seen[pos] = true;
      if ((col != rect.left || !col || this.map[index - 1] != pos) &&
          (row != rect.top || !row || this.map[index - this.width] != pos))
        { result.push(pos); }
    }
  }
  return result
};

// :: (number, number, Node) → number
// Return the position at which the cell at the given row and column
// starts, or would start, if a cell started there.
TableMap.prototype.positionAt = function positionAt (row, col, table) {
  for (var i = 0, rowStart = 0;; i++) {
    var rowEnd = rowStart + table.child(i).nodeSize;
    if (i == row) {
      var index = col + row * this.width, rowEndIndex = (row + 1) * this.width;
      // Skip past cells from previous rows (via rowspan)
      while (index < rowEndIndex && this.map[index] < rowStart) { index++; }
      return index == rowEndIndex ? rowEnd - 1 : this.map[index]
    }
    rowStart = rowEnd;
  }
};

// :: (Node) → TableMap
// Find the table map for the given table node.
TableMap.get = function get (table) {
  return readFromCache(table) || addToCache(table, computeMap(table))
};

// Compute a table map.
function computeMap(table) {
  if (table.type.spec.tableRole != "table") { throw new RangeError("Not a table node: " + table.type.name) }
  var width = findWidth(table), height = table.childCount;
  var map = [], mapPos = 0, problems = null, colWidths = [];
  for (var i = 0, e = width * height; i < e; i++) { map[i] = 0; }

  for (var row = 0, pos = 0; row < height; row++) {
    var rowNode = table.child(row);
    pos++;
    for (var i$1 = 0;; i$1++) {
      while (mapPos < map.length && map[mapPos] != 0) { mapPos++; }
      if (i$1 == rowNode.childCount) { break }
      var cellNode = rowNode.child(i$1);
      var ref = cellNode.attrs;
      var colspan = ref.colspan;
      var rowspan = ref.rowspan;
      var colwidth = ref.colwidth;
      for (var h = 0; h < rowspan; h++) {
        if (h + row >= height) {
          (problems || (problems = [])).push({type: "overlong_rowspan", pos: pos, n: rowspan - h});
          break
        }
        var start = mapPos + (h * width);
        for (var w = 0; w < colspan; w++) {
          if (map[start + w] == 0)
            { map[start + w] = pos; }
          else
            { (problems || (problems = [])).push({type: "collision", row: row, pos: pos, n: colspan - w}); }
          var colW = colwidth && colwidth[w];
          if (colW) {
            var widthIndex = ((start + w) % width) * 2, prev = colWidths[widthIndex];
            if (prev == null || (prev != colW && colWidths[widthIndex + 1] == 1)) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }
      mapPos += colspan;
      pos += cellNode.nodeSize;
    }
    var expectedPos = (row + 1) * width, missing = 0;
    while (mapPos < expectedPos) { if (map[mapPos++] == 0) { missing++; } }
    if (missing) { (problems || (problems = [])).push({type: "missing", row: row, n: missing}); }
    pos++;
  }

  var tableMap = new TableMap(width, height, map, problems), badWidths = false;

  // For columns that have defined widths, but whose widths disagree
  // between rows, fix up the cells whose width doesn't match the
  // computed one.
  for (var i$2 = 0; !badWidths && i$2 < colWidths.length; i$2 += 2)
    { if (colWidths[i$2] != null && colWidths[i$2 + 1] < height) { badWidths = true; } }
  if (badWidths) { findBadColWidths(tableMap, colWidths, table); }

  return tableMap
}

function findWidth(table) {
  var width = -1, hasRowSpan = false;
  for (var row = 0; row < table.childCount; row++) {
    var rowNode = table.child(row), rowWidth = 0;
    if (hasRowSpan) { for (var j = 0; j < row; j++) {
      var prevRow = table.child(j);
      for (var i = 0; i < prevRow.childCount; i++) {
        var cell = prevRow.child(i);
        if (j + cell.attrs.rowspan > row) { rowWidth += cell.attrs.colspan; }
      }
    } }
    for (var i$1 = 0; i$1 < rowNode.childCount; i$1++) {
      var cell$1 = rowNode.child(i$1);
      rowWidth += cell$1.attrs.colspan;
      if (cell$1.attrs.rowspan > 1) { hasRowSpan = true; }
    }
    if (width == -1)
      { width = rowWidth; }
    else if (width != rowWidth)
      { width = Math.max(width, rowWidth); }
  }
  return width
}

function findBadColWidths(map, colWidths, table) {
  if (!map.problems) { map.problems = []; }
  for (var i = 0, seen = {}; i < map.map.length; i++) {
    var pos = map.map[i];
    if (seen[pos]) { continue }
    seen[pos] = true;
    var node = table.nodeAt(pos), updated = null;
    for (var j = 0; j < node.attrs.colspan; j++) {
      var col = (i + j) % map.width, colWidth = colWidths[col * 2];
      if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] != colWidth))
        { (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth; }
    }
    if (updated) { map.problems.unshift({type: "colwidth mismatch", pos: pos, colwidth: updated}); }
  }
}

function freshColWidth(attrs) {
  if (attrs.colwidth) { return attrs.colwidth.slice() }
  var result = [];
  for (var i = 0; i < attrs.colspan; i++) { result.push(0); }
  return result
}

// Various helper function for working with tables

var key = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]("selectingCells");

function cellAround($pos) {
  for (var d = $pos.depth - 1; d > 0; d--)
    { if ($pos.node(d).type.spec.tableRole == "row") { return $pos.node(0).resolve($pos.before(d + 1)) } }
  return null
}

function cellWrapping($pos) {
  for (var d = $pos.depth; d > 0; d--) { // Sometimes the cell can be in the same depth.
    var role = $pos.node(d).type.spec.tableRole;
    if (role === "cell" || role === 'header_cell') { return $pos.node(d) }
  }
  return null
}

function isInTable(state) {
  var $head = state.selection.$head;
  for (var d = $head.depth; d > 0; d--) { if ($head.node(d).type.spec.tableRole == "row") { return true } }
  return false
}

function selectionCell(state) {
  var sel = state.selection;
  if (sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  } else if (sel.node && sel.node.type.spec.tableRole == "cell") {
    return sel.$anchor
  }
  return cellAround(sel.$head) || cellNear(sel.$head)
}

function cellNear($pos) {
  for (var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    var role = after.type.spec.tableRole;
    if (role == "cell" || role == "header_cell") { return $pos.doc.resolve(pos) }
  }
  for (var before = $pos.nodeBefore, pos$1 = $pos.pos; before; before = before.lastChild, pos$1--) {
    var role$1 = before.type.spec.tableRole;
    if (role$1 == "cell" || role$1 == "header_cell") { return $pos.doc.resolve(pos$1 - before.nodeSize) }
  }
}

function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole == "row" && $pos.nodeAfter
}

function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize)
}

function inSameTable($a, $b) {
  return $a.depth == $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1)
}

function findCell($pos) {
  return TableMap.get($pos.node(-1)).findCell($pos.pos - $pos.start(-1))
}

function colCount($pos) {
  return TableMap.get($pos.node(-1)).colCount($pos.pos - $pos.start(-1))
}

function nextCell($pos, axis, dir) {
  var start = $pos.start(-1), map = TableMap.get($pos.node(-1));
  var moved = map.nextCell($pos.pos - start, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(start + moved)
}

function setAttr(attrs, name, value) {
  var result = {};
  for (var prop in attrs) { result[prop] = attrs[prop]; }
  result[name] = value;
  return result
}

function rmColSpan(attrs, pos, n) {
  if ( n === void 0 ) n=1;

  var result = setAttr(attrs, "colspan", attrs.colspan - n);
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some(function (w) { return w > 0; })) { result.colwidth = null; }
  }
  return result
}

function addColSpan(attrs, pos, n) {
  if ( n === void 0 ) n=1;

  var result = setAttr(attrs, "colspan", attrs.colspan + n);
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    for (var i = 0; i < n; i++) { result.colwidth.splice(pos, 0, 0); }
  }
  return result
}

// This file defines a ProseMirror selection subclass that models

// ::- A [`Selection`](http://prosemirror.net/docs/ref/#state.Selection)
// subclass that represents a cell selection spanning part of a table.
// With the plugin enabled, these will be created when the user
// selects across cells, and will be drawn by giving selected cells a
// `selectedCell` CSS class.
var CellSelection = /*@__PURE__*/(function (Selection) {
  function CellSelection($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var table = $anchorCell.node(-1), map = TableMap.get(table), start = $anchorCell.start(-1);
    var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    var doc = $anchorCell.node(0);
    var cells = map.cellsInRect(rect).filter(function (p) { return p != $headCell.pos - start; });
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    var ranges = cells.map(function (pos) {
      var cell = table.nodeAt(pos), from = pos + start + 1;
      return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["SelectionRange"](doc.resolve(from), doc.resolve(from + cell.content.size))
    });
    Selection.call(this, ranges[0].$from, ranges[0].$to, ranges);
    // :: ResolvedPos
    // A resolved position pointing _in front of_ the anchor cell (the one
    // that doesn't move when extending the selection).
    this.$anchorCell = $anchorCell;
    // :: ResolvedPos
    // A resolved position pointing in front of the head cell (the one
    // moves when extending the selection).
    this.$headCell = $headCell;
  }

  if ( Selection ) CellSelection.__proto__ = Selection;
  CellSelection.prototype = Object.create( Selection && Selection.prototype );
  CellSelection.prototype.constructor = CellSelection;

  CellSelection.prototype.map = function map (doc, mapping) {
    var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
    var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
    if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
      var tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
      if (tableChanged && this.isRowSelection())
        { return CellSelection.rowSelection($anchorCell, $headCell) }
      else if (tableChanged && this.isColSelection())
        { return CellSelection.colSelection($anchorCell, $headCell) }
      else
        { return new CellSelection($anchorCell, $headCell) }
    }
    return __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].between($anchorCell, $headCell)
  };

  // :: () → Slice
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  CellSelection.prototype.content = function content () {
    var table = this.$anchorCell.node(-1), map = TableMap.get(table), start = this.$anchorCell.start(-1);
    var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
    var seen = {}, rows = [];
    for (var row = rect.top; row < rect.bottom; row++) {
      var rowContent = [];
      for (var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
        var pos = map.map[index];
        if (!seen[pos]) {
          seen[pos] = true;
          var cellRect = map.findCell(pos), cell = table.nodeAt(pos);
          var extraLeft = rect.left - cellRect.left, extraRight = cellRect.right - rect.right;
          if (extraLeft > 0 || extraRight > 0) {
            var attrs = cell.attrs;
            if (extraLeft > 0) { attrs = rmColSpan(attrs, 0, extraLeft); }
            if (extraRight > 0) { attrs = rmColSpan(attrs, attrs.colspan - extraRight, extraRight); }
            if (cellRect.left < rect.left) { cell = cell.type.createAndFill(attrs); }
            else { cell = cell.type.create(attrs, cell.content); }
          }
          if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
            var attrs$1 = setAttr(cell.attrs, "rowspan", Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
            if (cellRect.top < rect.top) { cell = cell.type.createAndFill(attrs$1); }
            else { cell = cell.type.create(attrs$1, cell.content); }
          }
          rowContent.push(cell);
        }
      }
      rows.push(table.child(row).copy(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(rowContent)));
    }

    var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(fragment), 1, 1)
  };

  CellSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"].empty;

    var mapFrom = tr.steps.length, ranges = this.ranges;
    for (var i = 0; i < ranges.length; i++) {
      var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
      tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"].empty : content);
    }
    var sel = Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
    if (sel) { tr.setSelection(sel); }
  };

  CellSelection.prototype.replaceWith = function replaceWith (tr, node) {
    this.replace(tr, new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(node), 0, 0));
  };

  CellSelection.prototype.forEachCell = function forEachCell (f) {
    var table = this.$anchorCell.node(-1), map = TableMap.get(table), start = this.$anchorCell.start(-1);
    var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
    for (var i = 0; i < cells.length; i++)
      { f(table.nodeAt(cells[i]), start + cells[i]); }
  };

  // :: () → bool
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  CellSelection.prototype.isColSelection = function isColSelection () {
    var anchorTop = this.$anchorCell.index(-1), headTop = this.$headCell.index(-1);
    if (Math.min(anchorTop, headTop) > 0) { return false }
    var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan,
        headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(anchorBot, headBot) == this.$headCell.node(-1).childCount
  };

  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  CellSelection.colSelection = function colSelection ($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var map = TableMap.get($anchorCell.node(-1)), start = $anchorCell.start(-1);
    var anchorRect = map.findCell($anchorCell.pos - start), headRect = map.findCell($headCell.pos - start);
    var doc = $anchorCell.node(0);
    if (anchorRect.top <= headRect.top) {
      if (anchorRect.top > 0)
        { $anchorCell = doc.resolve(start + map.map[anchorRect.left]); }
      if (headRect.bottom < map.height)
        { $headCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]); }
    } else {
      if (headRect.top > 0)
        { $headCell = doc.resolve(start + map.map[headRect.left]); }
      if (anchorRect.bottom < map.height)
        { $anchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]); }
    }
    return new CellSelection($anchorCell, $headCell)
  };

  // :: () → bool
  // True if this selection goes all the way from the left to the
  // right of the table.
  CellSelection.prototype.isRowSelection = function isRowSelection () {
    var map = TableMap.get(this.$anchorCell.node(-1)), start = this.$anchorCell.start(-1);
    var anchorLeft = map.colCount(this.$anchorCell.pos - start),
        headLeft = map.colCount(this.$headCell.pos - start);
    if (Math.min(anchorLeft, headLeft) > 0) { return false }
    var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan,
        headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(anchorRight, headRight) == map.width
  };

  CellSelection.prototype.eq = function eq (other) {
    return other instanceof CellSelection && other.$anchorCell.pos == this.$anchorCell.pos &&
      other.$headCell.pos == this.$headCell.pos
  };

  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  CellSelection.rowSelection = function rowSelection ($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var map = TableMap.get($anchorCell.node(-1)), start = $anchorCell.start(-1);
    var anchorRect = map.findCell($anchorCell.pos - start), headRect = map.findCell($headCell.pos - start);
    var doc = $anchorCell.node(0);
    if (anchorRect.left <= headRect.left) {
      if (anchorRect.left > 0)
        { $anchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]); }
      if (headRect.right < map.width)
        { $headCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]); }
    } else {
      if (headRect.left > 0)
        { $headCell = doc.resolve(start + map.map[headRect.top * map.width]); }
      if (anchorRect.right < map.width)
        { $anchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]); }
    }
    return new CellSelection($anchorCell, $headCell)
  };

  CellSelection.prototype.toJSON = function toJSON () {
    return {type: "cell", anchor: this.$anchorCell.pos, head: this.$headCell.pos}
  };

  CellSelection.fromJSON = function fromJSON (doc, json) {
    return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → CellSelection
  CellSelection.create = function create (doc, anchorCell, headCell) {
    if ( headCell === void 0 ) headCell = anchorCell;

    return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell))
  };

  CellSelection.prototype.getBookmark = function getBookmark () { return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos) };

  return CellSelection;
}(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"]));

CellSelection.prototype.visible = false;

__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].jsonID("cell", CellSelection);

var CellBookmark = function CellBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
CellBookmark.prototype.map = function map (mapping) {
  return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
CellBookmark.prototype.resolve = function resolve (doc) {
  var $anchorCell = doc.resolve(this.anchor), $headCell = doc.resolve(this.head);
  if ($anchorCell.parent.type.spec.tableRole == "row" &&
      $headCell.parent.type.spec.tableRole == "row" &&
      $anchorCell.index() < $anchorCell.parent.childCount &&
      $headCell.index() < $headCell.parent.childCount &&
      inSameTable($anchorCell, $headCell))
    { return new CellSelection($anchorCell, $headCell) }
  else
    { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near($headCell, 1) }
};

function drawCellSelection(state) {
  if (!(state.selection instanceof CellSelection)) { return null }
  var cells = [];
  state.selection.forEachCell(function (node, pos) {
    cells.push(__WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].node(pos, pos + node.nodeSize, {class: "selectedCell"}));
  });
  return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(state.doc, cells)
}

function isCellBoundarySelection(ref) {
  var $from = ref.$from;
  var $to = ref.$to;

  if ($from.pos == $to.pos || $from.pos < $from.pos - 6) { return false } // Cheap elimination
  var afterFrom = $from.pos, beforeTo = $to.pos, depth = $from.depth;
  for (; depth >= 0; depth--, afterFrom++)
    { if ($from.after(depth + 1) < $from.end(depth)) { break } }
  for (var d = $to.depth; d >= 0; d--, beforeTo--)
    { if ($to.before(d + 1) > $to.start(d)) { break } }
  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole)
}

function isTextSelectionAcrossCells(ref) {
  var $from = ref.$from;
  var $to = ref.$to;

  var fromCellBoundaryNode;
  var toCellBoundaryNode;

  for (var i = $from.depth; i > 0; i--) {
    var node = $from.node(i);
    if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
      fromCellBoundaryNode = node;
      break;
    }
  }

  for (var i$1 = $to.depth; i$1 > 0; i$1--) {
    var node$1 = $to.node(i$1);
    if (node$1.type.spec.tableRole === 'cell' || node$1.type.spec.tableRole === 'header_cell') {
      toCellBoundaryNode = node$1;
      break;
    }
  }

  return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0
}

function normalizeSelection(state, tr, allowTableNodeSelection) {
  var sel = (tr || state).selection, doc = (tr || state).doc, normalize, role;
  if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] && (role = sel.node.type.spec.tableRole)) {
    if (role == "cell" || role == "header_cell") {
      normalize = CellSelection.create(doc, sel.from);
    } else if (role == "row") {
      var $cell = doc.resolve(sel.from + 1);
      normalize = CellSelection.rowSelection($cell, $cell);
    } else if (!allowTableNodeSelection) {
      var map = TableMap.get(sel.node), start = sel.from + 1;
      var lastCell = start + map.map[map.width * map.height - 1];
      normalize = CellSelection.create(doc, start + 1, lastCell);
    }
  } else if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"] && isCellBoundarySelection(sel)) {
    normalize = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(doc, sel.from);
  } else if (sel instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"] && isTextSelectionAcrossCells(sel)) {
    normalize = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(doc, sel.$from.start(), sel.$from.end());
  }
  if (normalize)
    { (tr || (tr = state.tr)).setSelection(normalize); }
  return tr
}

// Helper for creating a schema that supports tables.

function getCellAttrs(dom, extraAttrs) {
  var widthAttr = dom.getAttribute("data-colwidth");
  var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function (s) { return Number(s); }) : null;
  var colspan = Number(dom.getAttribute("colspan") || 1);
  var result = {
    colspan: colspan,
    rowspan: Number(dom.getAttribute("rowspan") || 1),
    colwidth: widths && widths.length == colspan ? widths : null
  };
  for (var prop in extraAttrs) {
    var getter = extraAttrs[prop].getFromDOM;
    var value = getter && getter(dom);
    if (value != null) { result[prop] = value; }
  }
  return result
}

function setCellAttrs(node, extraAttrs) {
  var attrs = {};
  if (node.attrs.colspan != 1) { attrs.colspan = node.attrs.colspan; }
  if (node.attrs.rowspan != 1) { attrs.rowspan = node.attrs.rowspan; }
  if (node.attrs.colwidth)
    { attrs["data-colwidth"] = node.attrs.colwidth.join(","); }
  for (var prop in extraAttrs) {
    var setter = extraAttrs[prop].setDOMAttr;
    if (setter) { setter(node.attrs[prop], attrs); }
  }
  return attrs
}

// :: (Object) → Object
//
// This function creates a set of [node
// specs](http://prosemirror.net/docs/ref/#model.SchemaSpec.nodes) for
// `table`, `table_row`, and `table_cell` nodes types as used by this
// module. The result can then be added to the set of nodes when
// creating a a schema.
//
//   options::- The following options are understood:
//
//     tableGroup:: ?string
//     A group name (something like `"block"`) to add to the table
//     node type.
//
//     cellContent:: string
//     The content expression for table cells.
//
//     cellAttributes:: ?Object
//     Additional attributes to add to cells. Maps attribute names to
//     objects with the following properties:
//
//       default:: any
//       The attribute's default value.
//
//       getFromDOM:: ?(dom.Node) → any
//       A function to read the attribute's value from a DOM node.
//
//       setDOMAttr:: ?(value: any, attrs: Object)
//       A function to add the attribute's value to an attribute
//       object that's used to render the cell's DOM.
function tableNodes(options) {
  var extraAttrs = options.cellAttributes || {};
  var cellAttrs = {
    colspan: {default: 1},
    rowspan: {default: 1},
    colwidth: {default: null}
  };
  for (var prop in extraAttrs)
    { cellAttrs[prop] = {default: extraAttrs[prop].default}; }

  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: true,
      group: options.tableGroup,
      parseDOM: [{tag: "table"}],
      toDOM: function toDOM() { return ["table", ["tbody", 0]] }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{tag: "tr"}],
      toDOM: function toDOM() { return ["tr", 0] }
    },
    table_cell: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "cell",
      isolating: true,
      parseDOM: [{tag: "td", getAttrs: function (dom) { return getCellAttrs(dom, extraAttrs); }}],
      toDOM: function toDOM(node) { return ["td", setCellAttrs(node, extraAttrs), 0] }
    },
    table_header: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "header_cell",
      isolating: true,
      parseDOM: [{tag: "th", getAttrs: function (dom) { return getCellAttrs(dom, extraAttrs); }}],
      toDOM: function toDOM(node) { return ["th", setCellAttrs(node, extraAttrs), 0] }
    }
  }
}

function tableNodeTypes(schema) {
  var result = schema.cached.tableNodeTypes;
  if (!result) {
    result = schema.cached.tableNodeTypes = {};
    for (var name in schema.nodes) {
      var type = schema.nodes[name], role = type.spec.tableRole;
      if (role) { result[role] = type; }
    }
  }
  return result
}

// Utilities used for copy/paste handling.

// Utilities to help with copying and pasting table cells

// : (Slice) → ?{width: number, height: number, rows: [Fragment]}
// Get a rectangular area of cells from a slice, or null if the outer
// nodes of the slice aren't table cells or rows.
function pastedCells(slice) {
  if (!slice.size) { return null }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (content.childCount == 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole == "table")) {
    openStart--;
    openEnd--;
    content = content.firstChild.content;
  }
  var first = content.firstChild, role = first.type.spec.tableRole;
  var schema = first.type.schema, rows = [];
  if (role == "row") {
    for (var i = 0; i < content.childCount; i++) {
      var cells = content.child(i).content;
      var left = i ? 0 : Math.max(0, openStart - 1);
      var right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left || right) { cells = fitSlice(tableNodeTypes(schema).row, new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](cells, left, right)).content; }
      rows.push(cells);
    }
  } else if (role == "cell" || role == "header_cell") {
    rows.push(openStart || openEnd ? fitSlice(tableNodeTypes(schema).row, new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](content, openStart, openEnd)).content : content);
  } else {
    return null
  }
  return ensureRectangular(schema, rows)
}

// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function ensureRectangular(schema, rows) {
  var widths = [];
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    for (var j = row.childCount - 1; j >= 0; j--) {
      var ref = row.child(j).attrs;
      var rowspan = ref.rowspan;
      var colspan = ref.colspan;
      for (var r = i; r < i + rowspan; r++)
        { widths[r] = (widths[r] || 0) + colspan; }
    }
  }
  var width = 0;
  for (var r$1 = 0; r$1 < widths.length; r$1++) { width = Math.max(width, widths[r$1]); }
  for (var r$2 = 0; r$2 < widths.length; r$2++) {
    if (r$2 >= rows.length) { rows.push(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty); }
    if (widths[r$2] < width) {
      var empty = tableNodeTypes(schema).cell.createAndFill(), cells = [];
      for (var i$1 = widths[r$2]; i$1 < width; i$1++) { cells.push(empty); }
      rows[r$2] = rows[r$2].append(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(cells));
    }
  }
  return {height: rows.length, width: width, rows: rows}
}

function fitSlice(nodeType, slice) {
  var node = nodeType.createAndFill();
  var tr = new __WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__["d" /* Transform */](node).replace(0, node.content.size, slice);
  return tr.doc
}

// : ({width: number, height: number, rows: [Fragment]}, number, number) → {width: number, height: number, rows: [Fragment]}
// Clip or extend (repeat) the given set of cells to cover the given
// width and height. Will clip rowspan/colspan cells at the edges when
// they stick out.
function clipCells(ref, newWidth, newHeight) {
  var width = ref.width;
  var height = ref.height;
  var rows = ref.rows;

  if (width != newWidth) {
    var added = [], newRows = [];
    for (var row = 0; row < rows.length; row++) {
      var frag = rows[row], cells = [];
      for (var col = added[row] || 0, i = 0; col < newWidth; i++) {
        var cell = frag.child(i % frag.childCount);
        if (col + cell.attrs.colspan > newWidth)
          { cell = cell.type.create(rmColSpan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content); }
        cells.push(cell);
        col += cell.attrs.colspan;
        for (var j = 1; j < cell.attrs.rowspan; j++)
          { added[row + j] = (added[row + j] || 0) + cell.attrs.colspan; }
      }
      newRows.push(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(cells));
    }
    rows = newRows;
    width = newWidth;
  }

  if (height != newHeight) {
    var newRows$1 = [];
    for (var row$1 = 0, i$1 = 0; row$1 < newHeight; row$1++, i$1++) {
      var cells$1 = [], source = rows[i$1 % height];
      for (var j$1 = 0; j$1 < source.childCount; j$1++) {
        var cell$1 = source.child(j$1);
        if (row$1 + cell$1.attrs.rowspan > newHeight)
          { cell$1 = cell$1.type.create(setAttr(cell$1.attrs, "rowspan", newHeight - cell$1.attrs.rowspan), cell$1.content); }
        cells$1.push(cell$1);
      }
      newRows$1.push(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(cells$1));
    }
    rows = newRows$1;
    height = newHeight;
  }

  return {width: width, height: height, rows: rows}
}

// Make sure a table has at least the given width and height. Return
// true if something was changed.
function growTable(tr, map, table, start, width, height, mapFrom) {
  var schema = tr.doc.type.schema, types = tableNodeTypes(schema), empty, emptyHead;
  if (width > map.width) {
    for (var row = 0, rowEnd = 0; row < map.height; row++) {
      var rowNode = table.child(row);
      rowEnd += rowNode.nodeSize;
      var cells = [], add = (void 0);
      if (rowNode.lastChild == null || rowNode.lastChild.type == types.cell)
        { add = empty || (empty = types.cell.createAndFill()); }
      else
        { add = emptyHead || (emptyHead = types.header_cell.createAndFill()); }
      for (var i = map.width; i < width; i++) { cells.push(add); }
      tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
  }
  if (height > map.height) {
    var cells$1 = [];
    for (var i$1 = 0, start$1 = (map.height - 1) * map.width; i$1 < Math.max(map.width, width); i$1++) {
      var header = i$1 >= map.width ? false :
          table.nodeAt(map.map[start$1 + i$1]).type == types.header_cell;
      cells$1.push(header
                 ? (emptyHead || (emptyHead = types.header_cell.createAndFill()))
                 : (empty || (empty = types.cell.createAndFill())));
    }

    var emptyRow = types.row.create(null, __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(cells$1)), rows = [];
    for (var i$2 = map.height; i$2 < height; i$2++) { rows.push(emptyRow); }
    tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
  }
  return !!(empty || emptyHead)
}

// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
  if (top == 0 || top == map.height) { return false }
  var found = false;
  for (var col = left; col < right; col++) {
    var index = top * map.width + col, pos = map.map[index];
    if (map.map[index - map.width] == pos) {
      found = true;
      var cell = table.nodeAt(pos);
      var ref = map.findCell(pos);
      var cellTop = ref.top;
      var cellLeft = ref.left;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, setAttr(cell.attrs, "rowspan", top - cellTop));
      tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)),
                cell.type.createAndFill(setAttr(cell.attrs, "rowspan", (cellTop + cell.attrs.rowspan) - top)));
      col += cell.attrs.colspan - 1;
    }
  }
  return found
}

// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
  if (left == 0 || left == map.width) { return false }
  var found = false;
  for (var row = top; row < bottom; row++) {
    var index = row * map.width + left, pos = map.map[index];
    if (map.map[index - 1] == pos) {
      found = true;
      var cell = table.nodeAt(pos), cellLeft = map.colCount(pos);
      var updatePos = tr.mapping.slice(mapFrom).map(pos + start);
      tr.setNodeMarkup(updatePos, null, rmColSpan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
      tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(rmColSpan(cell.attrs, 0, left - cellLeft)));
      row += cell.attrs.rowspan - 1;
    }
  }
  return found
}

// Insert the given set of cells (as returned by `pastedCells`) into a
// table, at the position pointed at by rect.
function insertCells(state, dispatch, tableStart, rect, cells) {
  var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc, map = TableMap.get(table);
  var top = rect.top;
  var left = rect.left;
  var right = left + cells.width, bottom = top + cells.height;
  var tr = state.tr, mapFrom = 0;
  function recomp() {
    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
    map = TableMap.get(table);
    mapFrom = tr.mapping.maps.length;
  }
  // Prepare the table to be large enough and not have any cells
  // crossing the boundaries of the rectangle that we want to
  // insert into. If anything about it changes, recompute the table
  // map so that subsequent operations can see the current shape.
  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) { recomp(); }
  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) { recomp(); }
  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) { recomp(); }
  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) { recomp(); }
  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) { recomp(); }

  for (var row = top; row < bottom; row++) {
    var from = map.positionAt(row, left, table), to = map.positionAt(row, right, table);
    tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart),
               new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](cells.rows[row - top], 0, 0));
  }
  recomp();
  tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)),
                                    tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
  dispatch(tr);
}

// This file defines a number of helpers for wiring up user input to

var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__["a" /* keydownHandler */])({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1),

  "Shift-ArrowLeft": shiftArrow("horiz", -1),
  "Shift-ArrowRight": shiftArrow("horiz", 1),
  "Shift-ArrowUp": shiftArrow("vert", -1),
  "Shift-ArrowDown": shiftArrow("vert", 1),

  "Backspace": deleteCellSelection,
  "Mod-Backspace": deleteCellSelection,
  "Delete": deleteCellSelection,
  "Mod-Delete": deleteCellSelection
});

function maybeSetSelection(state, dispatch, selection) {
  if (selection.eq(state.selection)) { return false }
  if (dispatch) { dispatch(state.tr.setSelection(selection).scrollIntoView()); }
  return true
}

function arrow(axis, dir) {
  return function (state, dispatch, view) {
    var sel = state.selection;
    if (sel instanceof CellSelection) {
      return maybeSetSelection(state, dispatch, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(sel.$headCell, dir))
    }
    if (axis != "horiz" && !sel.empty) { return false }
    var end = atEndOfCell(view, axis, dir);
    if (end == null) { return false }
    if (axis == "horiz") {
      return maybeSetSelection(state, dispatch, __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(state.doc.resolve(sel.head + dir), dir))
    } else {
      var $cell = state.doc.resolve(end), $next = nextCell($cell, axis, dir), newSel;
      if ($next) { newSel = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near($next, 1); }
      else if (dir < 0) { newSel = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(state.doc.resolve($cell.before(-1)), -1); }
      else { newSel = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(state.doc.resolve($cell.after(-1)), 1); }
      return maybeSetSelection(state, dispatch, newSel)
    }
  }
}

function shiftArrow(axis, dir) {
  return function (state, dispatch, view) {
    var sel = state.selection;
    if (!(sel instanceof CellSelection)) {
      var end = atEndOfCell(view, axis, dir);
      if (end == null) { return false }
      sel = new CellSelection(state.doc.resolve(end));
    }
    var $head = nextCell(sel.$headCell, axis, dir);
    if (!$head) { return false }
    return maybeSetSelection(state, dispatch, new CellSelection(sel.$anchorCell, $head))
  }
}

function deleteCellSelection(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof CellSelection)) { return false }
  if (dispatch) {
    var tr = state.tr, baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
    sel.forEachCell(function (cell, pos) {
      if (!cell.content.eq(baseContent))
        { tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1),
                   new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](baseContent, 0, 0)); }
    });
    if (tr.docChanged) { dispatch(tr); }
  }
  return true
}

function handleTripleClick(view, pos) {
  var doc = view.state.doc, $cell = cellAround(doc.resolve(pos));
  if (!$cell) { return false }
  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
  return true
}

function handlePaste(view, _, slice) {
  if (!isInTable(view.state)) { return false }
  var cells = pastedCells(slice), sel = view.state.selection;
  if (sel instanceof CellSelection) {
    if (!cells) { cells = {width: 1, height: 1, rows: [__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(fitSlice(tableNodeTypes(view.state.schema).cell, slice))]}; }
    var table = sel.$anchorCell.node(-1), start = sel.$anchorCell.start(-1);
    var rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start, rect, cells);
    return true
  } else if (cells) {
    var $cell = selectionCell(view.state), start$1 = $cell.start(-1);
    insertCells(view.state, view.dispatch, start$1, TableMap.get($cell.node(-1)).findCell($cell.pos - start$1), cells);
    return true
  } else {
    return false
  }
}

function handleMouseDown(view, startEvent) {
  if (startEvent.ctrlKey || startEvent.metaKey) { return }

  var startDOMCell = domInCell(view, startEvent.target), $anchor;
  if (startEvent.shiftKey && (view.state.selection instanceof CellSelection)) {
    // Adding to an existing cell selection
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell &&
             ($anchor = cellAround(view.state.selection.$anchor)) != null &&
             cellUnderMouse(view, startEvent).pos != $anchor.pos) {
    // Adding to a selection that starts in another cell (causing a
    // cell selection to be created).
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    // Not in a cell, let the default behavior happen.
    return
  }

  // Create and dispatch a cell selection between the given anchor and
  // the position under the mouse.
  function setCellSelection($anchor, event) {
    var $head = cellUnderMouse(view, event);
    var starting = key.getState(view.state) == null;
    if (!$head || !inSameTable($anchor, $head)) {
      if (starting) { $head = $anchor; }
      else { return }
    }
    var selection = new CellSelection($anchor, $head);
    if (starting || !view.state.selection.eq(selection)) {
      var tr = view.state.tr.setSelection(selection);
      if (starting) { tr.setMeta(key, $anchor.pos); }
      view.dispatch(tr);
    }
  }

  // Stop listening to mouse motion events.
  function stop() {
    view.root.removeEventListener("mouseup", stop);
    view.root.removeEventListener("dragstart", stop);
    view.root.removeEventListener("mousemove", move);
    if (key.getState(view.state) != null) { view.dispatch(view.state.tr.setMeta(key, -1)); }
  }

  function move(event) {
    var anchor = key.getState(view.state), $anchor;
    if (anchor != null) {
      // Continuing an existing cross-cell selection
      $anchor = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      // Moving out of the initial cell -- start a new cell selection
      $anchor = cellUnderMouse(view, startEvent);
      if (!$anchor) { return stop() }
    }
    if ($anchor) { setCellSelection($anchor, event); }
  }
  view.root.addEventListener("mouseup", stop);
  view.root.addEventListener("dragstart", stop);
  view.root.addEventListener("mousemove", move);
}

// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"])) { return null }
  var ref = view.state.selection;
  var $head = ref.$head;
  for (var d = $head.depth - 1; d >= 0; d--) {
    var parent = $head.node(d), index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
    if (index != (dir < 0 ? 0 : parent.childCount)) { return null }
    if (parent.type.spec.tableRole == "cell" || parent.type.spec.tableRole == "header_cell") {
      var cellPos = $head.before(d);
      var dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
      return view.endOfTextblock(dirStr) ? cellPos : null
    }
  }
  return null
}

function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode)
    { if (dom.nodeName == "TD" || dom.nodeName == "TH") { return dom } }
}

function cellUnderMouse(view, event) {
  var mousePos = view.posAtCoords({left: event.clientX, top: event.clientY});
  if (!mousePos) { return null }
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null
}

// This file defines helpers for normalizing tables, making sure no

var fixTablesKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]("fix-tables");

// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function changedDescendants(old, cur, offset, f) {
  var oldSize = old.childCount, curSize = cur.childCount;
  outer: for (var i = 0, j = 0; i < curSize; i++) {
    var child = cur.child(i);
    for (var scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j = scan + 1;
        offset += child.nodeSize;
        continue outer
      }
    }
    f(child, offset);
    if (j < oldSize && old.child(j).sameMarkup(child))
      { changedDescendants(old.child(j), child, offset + 1, f); }
    else
      { child.nodesBetween(0, child.content.size, f, offset + 1); }
    offset += child.nodeSize;
  }
}

// :: (EditorState, ?EditorState) → ?Transaction
// Inspect all tables in the given state's document and return a
// transaction that fixes them, if necessary. If `oldState` was
// provided, that is assumed to hold a previous, known-good state,
// which will be used to avoid re-scanning unchanged parts of the
// document.
function fixTables(state, oldState) {
  var tr, check = function (node, pos) {
    if (node.type.spec.tableRole == "table") { tr = fixTable(state, node, pos, tr); }
  };
  if (!oldState) { state.doc.descendants(check); }
  else if (oldState.doc != state.doc) { changedDescendants(oldState.doc, state.doc, 0, check); }
  return tr
}

// : (EditorState, Node, number, ?Transaction) → ?Transaction
// Fix the given table, if necessary. Will append to the transaction
// it was given, if non-null, or create a new one if necessary.
function fixTable(state, table, tablePos, tr) {
  var map = TableMap.get(table);
  if (!map.problems) { return tr }
  if (!tr) { tr = state.tr; }

  // Track which rows we must add cells to, so that we can adjust that
  // when fixing collisions.
  var mustAdd = [];
  for (var i = 0; i < map.height; i++) { mustAdd.push(0); }
  for (var i$1 = 0; i$1 < map.problems.length; i$1++) {
    var prob = map.problems[i$1];
    if (prob.type == "collision") {
      var cell = table.nodeAt(prob.pos);
      for (var j = 0; j < cell.attrs.rowspan; j++) { mustAdd[prob.row + j] += prob.n; }
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, rmColSpan(cell.attrs, cell.attrs.colspan - prob.n, prob.n));
    } else if (prob.type == "missing") {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == "overlong_rowspan") {
      var cell$1 = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell$1.attrs, "rowspan", cell$1.attrs.rowspan - prob.n));
    } else if (prob.type == "colwidth mismatch") {
      var cell$2 = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell$2.attrs, "colwidth", prob.colwidth));
    }
  }
  var first, last;
  for (var i$2 = 0; i$2 < mustAdd.length; i$2++) { if (mustAdd[i$2]) {
    if (first == null) { first = i$2; }
    last = i$2;
  } }
  // Add the necessary cells, using a heuristic for whether to add the
  // cells at the start or end of the rows (if it looks like a 'bite'
  // was taken out of the table, add cells at the start of the row
  // after the bite. Otherwise add them at the end).
  for (var i$3 = 0, pos = tablePos + 1; i$3 < map.height; i$3++) {
    var row = table.child(i$3);
    var end = pos + row.nodeSize;
    var add = mustAdd[i$3];
    if (add > 0) {
      var tableNodeType = 'cell';
      if (row.firstChild) {
        tableNodeType = row.firstChild.type.spec.tableRole;
      }
      var nodes = [];
      for (var j$1 = 0; j$1 < add; j$1++)
        { nodes.push(tableNodeTypes(state.schema)[tableNodeType].createAndFill()); }
      var side = (i$3 == 0 || first == i$3 - 1) && last == i$3 ? pos + 1 : end - 1;
      tr.insert(tr.mapping.map(side), nodes);
    }
    pos = end;
  }
  return tr.setMeta(fixTablesKey, { fixTables: true })
}

// This file defines a number of table-related commands.

// Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for
// convenience.
function selectedRect(state) {
  var sel = state.selection, $pos = selectionCell(state);
  var table = $pos.node(-1), tableStart = $pos.start(-1), map = TableMap.get(table);
  var rect;
  if (sel instanceof CellSelection)
    { rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart); }
  else
    { rect = map.findCell($pos.pos - tableStart); }
  rect.tableStart = tableStart;
  rect.map = map;
  rect.table = table;
  return rect
}

function columnIsHeader(map, table, col) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var row = 0; row < map.height; row++)
    { if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      { return false } }
  return true
}

// Add a column at the given position in a table.
function addColumn(tr, ref, col) {
  var map = ref.map;
  var tableStart = ref.tableStart;
  var table = ref.table;

  var refColumn = col > 0 ? -1 : 0;
  if (columnIsHeader(map, table, col + refColumn))
    { refColumn = col == 0 || col == map.width ? null : 0; }

  for (var row = 0; row < map.height; row++) {
    var index = row * map.width + col;
    // If this position falls inside a col-spanning cell
    if (col > 0 && col < map.width && map.map[index - 1] == map.map[index]) {
      var pos = map.map[index], cell = table.nodeAt(pos);
      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null,
                       addColSpan(cell.attrs, col - map.colCount(pos)));
      // Skip ahead if rowspan > 1
      row += cell.attrs.rowspan - 1;
    } else {
      var type = refColumn == null ? tableNodeTypes(table.type.schema).cell
          : table.nodeAt(map.map[index + refColumn]).type;
      var pos$1 = map.positionAt(row, col, table);
      tr.insert(tr.mapping.map(tableStart + pos$1), type.createAndFill());
    }
  }
  return tr
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command to add a column before the column with the selection.
function addColumnBefore(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.left));
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command to add a column after the column with the selection.
function addColumnAfter(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.right));
  }
  return true
}

function removeColumn(tr, ref, col) {
  var map = ref.map;
  var table = ref.table;
  var tableStart = ref.tableStart;

  var mapStart = tr.mapping.maps.length;
  for (var row = 0; row < map.height;) {
    var index = row * map.width + col, pos = map.map[index], cell = table.nodeAt(pos);
    // If this is part of a col-spanning cell
    if ((col > 0 && map.map[index - 1] == pos) || (col < map.width - 1 && map.map[index + 1] == pos)) {
      tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null,
                       rmColSpan(cell.attrs, col - map.colCount(pos)));
    } else {
      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
      tr.delete(start, start + cell.nodeSize);
    }
    row += cell.attrs.rowspan;
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command function that removes the selected columns from a table.
function deleteColumn(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state), tr = state.tr;
    if (rect.left == 0 && rect.right == rect.map.width) { return false }
    for (var i = rect.right - 1;; i--) {
      removeColumn(tr, rect, i);
      if (i == rect.left) { break }
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true
}

function rowIsHeader(map, table, row) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var col = 0; col < map.width; col++)
    { if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      { return false } }
  return true
}

function addRow(tr, ref, row) {
  var map = ref.map;
  var tableStart = ref.tableStart;
  var table = ref.table;

  var rowPos = tableStart;
  for (var i = 0; i < row; i++) { rowPos += table.child(i).nodeSize; }
  var cells = [], refRow = row > 0 ? -1 : 0;
  if (rowIsHeader(map, table, row + refRow))
    { refRow = row == 0 || row == map.height ? null : 0; }
  for (var col = 0, index = map.width * row; col < map.width; col++, index++) {
    // Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] == map.map[index - map.width]) {
      var pos = map.map[index], attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, "rowspan", attrs.rowspan + 1));
      col += attrs.colspan - 1;
    } else {
      var type = refRow == null ? tableNodeTypes(table.type.schema).cell
          : table.nodeAt(map.map[index + refRow * map.width]).type;
      cells.push(type.createAndFill());
    }
  }
  tr.insert(rowPos, tableNodeTypes(table.type.schema).row.create(null, cells));
  return tr
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Add a table row before the selection.
function addRowBefore(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.top));
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Add a table row after the selection.
function addRowAfter(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.bottom));
  }
  return true
}

function removeRow(tr, ref, row) {
  var map = ref.map;
  var table = ref.table;
  var tableStart = ref.tableStart;

  var rowPos = 0;
  for (var i = 0; i < row; i++) { rowPos += table.child(i).nodeSize; }
  var nextRow = rowPos + table.child(row).nodeSize;

  var mapFrom = tr.mapping.maps.length;
  tr.delete(rowPos + tableStart, nextRow + tableStart);

  for (var col = 0, index = row * map.width; col < map.width; col++, index++) {
    var pos = map.map[index];
    if (row > 0 && pos == map.map[index - map.width]) {
      // If this cell starts in the row above, simply reduce its rowspan
      var attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, "rowspan", attrs.rowspan - 1));
      col += attrs.colspan - 1;
    } else if (row < map.width && pos == map.map[index + map.width]) {
      // Else, if it continues in the row below, it has to be moved down
      var cell = table.nodeAt(pos);
      var copy = cell.type.create(setAttr(cell.attrs, "rowspan", cell.attrs.rowspan - 1), cell.content);
      var newPos = map.positionAt(row + 1, col, table);
      tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
      col += cell.attrs.colspan - 1;
    }
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Remove the selected rows from a table.
function deleteRow(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state), tr = state.tr;
    if (rect.top == 0 && rect.bottom == rect.map.height) { return false }
    for (var i = rect.bottom - 1;; i--) {
      removeRow(tr, rect, i);
      if (i == rect.top) { break }
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true
}

function isEmpty(cell) {
  var c = cell.content;
  return c.childCount == 1 && c.firstChild.isTextblock && c.firstChild.childCount == 0
}

function cellsOverlapRectangle(ref, rect) {
  var width = ref.width;
  var height = ref.height;
  var map = ref.map;

  var indexTop = rect.top * width + rect.left, indexLeft = indexTop;
  var indexBottom = (rect.bottom - 1) * width + rect.left, indexRight = indexTop + (rect.right - rect.left - 1);
  for (var i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map[indexLeft] == map[indexLeft - 1] ||
        rect.right < width && map[indexRight] == map[indexRight + 1]) { return true }
    indexLeft += width; indexRight += width;
  }
  for (var i$1 = rect.left; i$1 < rect.right; i$1++) {
    if (rect.top > 0 && map[indexTop] == map[indexTop - width] ||
        rect.bottom < height && map[indexBottom] == map[indexBottom + width]) { return true }
    indexTop++; indexBottom++;
  }
  return false
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Merge the selected cells into a single cell. Only available when
// the selected cells' outline forms a rectangle.
function mergeCells(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos) { return false }
  var rect = selectedRect(state);
  var map = rect.map;
  if (cellsOverlapRectangle(map, rect)) { return false }
  if (dispatch) {
    var tr = state.tr, seen = {}, content = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty, mergedPos, mergedCell;
    for (var row = rect.top; row < rect.bottom; row++) {
      for (var col = rect.left; col < rect.right; col++) {
        var cellPos = map.map[row * map.width + col], cell = rect.table.nodeAt(cellPos);
        if (seen[cellPos]) { continue }
        seen[cellPos] = true;
        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!isEmpty(cell)) { content = content.append(cell.content); }
          var mapped = tr.mapping.map(cellPos + rect.tableStart);
          tr.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }
    tr.setNodeMarkup(mergedPos + rect.tableStart, null,
                     setAttr(addColSpan(mergedCell.attrs, mergedCell.attrs.colspan, (rect.right - rect.left) - mergedCell.attrs.colspan),
                             "rowspan", rect.bottom - rect.top));
    if (content.size) {
      var end = mergedPos + 1 + mergedCell.content.size;
      var start = isEmpty(mergedCell) ? mergedPos + 1 : end;
      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
    }
    tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
    dispatch(tr);
  }
  return true
}
// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells. Use the first cell type for the new cells.
function splitCell(state, dispatch) {
  var nodeTypes = tableNodeTypes(state.schema);
  return splitCellWithType(function (ref) {
    var node = ref.node;

    return nodeTypes[node.type.spec.tableRole]
  })(state, dispatch)
}

// :: (getCellType: ({ row: number, col: number, node: Node}) → NodeType) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells with the cell type (th, td) returned by getType function.
function splitCellWithType(getCellType) {
  return function (state, dispatch) {
    var sel = state.selection;
    var cellNode, cellPos;
    if (!(sel instanceof CellSelection)) {
      cellNode = cellWrapping(sel.$from);
      if (!cellNode) { return false }
      cellPos = cellAround(sel.$from).pos;
    } else {
      if (sel.$anchorCell.pos != sel.$headCell.pos) { return false }
      cellNode = sel.$anchorCell.nodeAfter;
      cellPos = sel.$anchorCell.pos;
    }
    if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) {return false}
    if (dispatch) {
      var baseAttrs = cellNode.attrs, attrs = [], colwidth = baseAttrs.colwidth;
      if (baseAttrs.rowspan > 1) { baseAttrs = setAttr(baseAttrs, "rowspan", 1); }
      if (baseAttrs.colspan > 1) { baseAttrs = setAttr(baseAttrs, "colspan", 1); }
      var rect = selectedRect(state), tr = state.tr;
      for (var i = 0; i < rect.right - rect.left; i++)
        { attrs.push(colwidth ? setAttr(baseAttrs, "colwidth", colwidth && colwidth[i] ? [colwidth[i]] : null) : baseAttrs); }
      var lastCell;
      for (var row = rect.top; row < rect.bottom; row++) {
        var pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row == rect.top) { pos += cellNode.nodeSize; }
        for (var col = rect.left, i$1 = 0; col < rect.right; col++, i$1++) {
          if (col == rect.left && row == rect.top) { continue }
          tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), getCellType({ node: cellNode, row: row, col: col}).createAndFill(attrs[i$1]));
        }
      }
      tr.setNodeMarkup(cellPos, getCellType({ node: cellNode, row: rect.top, col: rect.left}), attrs[0]);
      if (sel instanceof CellSelection)
        { tr.setSelection(new CellSelection(tr.doc.resolve(sel.$anchorCell.pos),
                                          lastCell && tr.doc.resolve(lastCell))); }
      dispatch(tr);
    }
    return true
  }
}

// :: (string, any) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that sets the given attribute to the given value,
// and is only available when the currently selected cell doesn't
// already have that attribute set to that value.
function setCellAttr(name, value) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    var $cell = selectionCell(state);
    if ($cell.nodeAfter.attrs[name] === value) { return false }
    if (dispatch) {
      var tr = state.tr;
      if (state.selection instanceof CellSelection)
        { state.selection.forEachCell(function (node, pos) {
          if (node.attrs[name] !== value)
            { tr.setNodeMarkup(pos, null, setAttr(node.attrs, name, value)); }
        }); }
      else
        { tr.setNodeMarkup($cell.pos, null, setAttr($cell.nodeAfter.attrs, name, value)); }
      dispatch(tr);
    }
    return true
  }
}

function deprecated_toggleHeader(type) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state), tr = state.tr;
      var cells = rect.map.cellsInRect(type == "column" ? new Rect(rect.left, 0, rect.right, rect.map.height) :
                                       type == "row" ? new Rect(0, rect.top, rect.map.width, rect.bottom) : rect);
      var nodes = cells.map(function (pos) { return rect.table.nodeAt(pos); });
      for (var i = 0; i < cells.length; i++) // Remove headers, if any
        { if (nodes[i].type == types.header_cell)
          { tr.setNodeMarkup(rect.tableStart + cells[i], types.cell, nodes[i].attrs); } }
      if (tr.steps.length == 0) { for (var i$1 = 0; i$1 < cells.length; i$1++) // No headers removed, add instead
        { tr.setNodeMarkup(rect.tableStart + cells[i$1], types.header_cell, nodes[i$1].attrs); } }
      dispatch(tr);
    }
    return true
  }
}

function isHeaderEnabledByType(type, rect, types) {
  // Get cell positions for first row or first column
  var cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type == "row" ? rect.map.width : 1,
    bottom: type == "column" ? rect.map.height : 1,
  });

  for (var i = 0; i < cellPositions.length; i++) {
    var cell = rect.table.nodeAt(cellPositions[i]);
    if (cell && cell.type !== types.header_cell) {
      return false
    }
  }

  return true
}

// :: (string, ?{ useDeprecatedLogic: bool }) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles between row/column header and normal cells (Only applies to first row/column).
// For deprecated behavior pass `useDeprecatedLogic` in options with true.
function toggleHeader(type, options) {
  options = options || { useDeprecatedLogic: false };

  if (options.useDeprecatedLogic)
    { return deprecated_toggleHeader(type) }

  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state), tr = state.tr;

      var isHeaderRowEnabled = isHeaderEnabledByType("row", rect, types);
      var isHeaderColumnEnabled = isHeaderEnabledByType("column", rect, types);

      var isHeaderEnabled = type === "column" ? isHeaderRowEnabled :
                            type === "row"    ? isHeaderColumnEnabled : false;

      var selectionStartsAt = isHeaderEnabled ? 1 : 0;

      var cellsRect = type == "column" ? new Rect(0, selectionStartsAt, 1, rect.map.height) :
                      type == "row" ? new Rect(selectionStartsAt, 0, rect.map.width, 1) : rect;

      var newType = type == "column" ? isHeaderColumnEnabled ? types.cell : types.header_cell :
                    type == "row" ? isHeaderRowEnabled ? types.cell : types.header_cell : types.cell;

      rect.map.cellsInRect(cellsRect).forEach(function (relativeCellPos) {
        var cellPos = relativeCellPos + rect.tableStart;
        var cell = tr.doc.nodeAt(cellPos);

        if (cell) {
          tr.setNodeMarkup(cellPos, newType, cell.attrs);
        }
      });

      dispatch(tr);
    }
    return true
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected row contains header cells.
var toggleHeaderRow = toggleHeader("row", { useDeprecatedLogic: true });

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected column contains header cells.
var toggleHeaderColumn = toggleHeader("column", { useDeprecatedLogic: true });

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected cells are header cells.
var toggleHeaderCell = toggleHeader("cell", { useDeprecatedLogic: true });

function findNextCell($cell, dir) {
  if (dir < 0) {
    var before = $cell.nodeBefore;
    if (before) { return $cell.pos - before.nodeSize }
    for (var row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      var rowNode = $cell.node(-1).child(row);
      if (rowNode.childCount) { return rowEnd - 1 - rowNode.lastChild.nodeSize }
      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) { return $cell.pos + $cell.nodeAfter.nodeSize }
    var table = $cell.node(-1);
    for (var row$1 = $cell.indexAfter(-1), rowStart = $cell.after(); row$1 < table.childCount; row$1++) {
      var rowNode$1 = table.child(row$1);
      if (rowNode$1.childCount) { return rowStart + 1 }
      rowStart += rowNode$1.nodeSize;
    }
  }
}

// :: (number) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command for selecting the next (direction=1) or previous
// (direction=-1) cell in a table.
function goToNextCell(direction) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    var cell = findNextCell(selectionCell(state), direction);
    if (cell == null) { return }
    if (dispatch) {
      var $cell = state.doc.resolve(cell);
      dispatch(state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].between($cell, moveCellForward($cell))).scrollIntoView());
    }
    return true
  }
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Deletes the table around the selection, if any.
function deleteTable(state, dispatch) {
  var $pos = state.selection.$anchor;
  for (var d = $pos.depth; d > 0; d--) {
    var node = $pos.node(d);
    if (node.type.spec.tableRole == "table") {
      if (dispatch) { dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView()); }
      return true
    }
  }
  return false
}

var TableView = function TableView(node, cellMinWidth) {
  this.node = node;
  this.cellMinWidth = cellMinWidth;
  this.dom = document.createElement("div");
  this.dom.className = "tableWrapper";
  this.table = this.dom.appendChild(document.createElement("table"));
  this.colgroup = this.table.appendChild(document.createElement("colgroup"));
  updateColumns(node, this.colgroup, this.table, cellMinWidth);
  this.contentDOM = this.table.appendChild(document.createElement("tbody"));
};

TableView.prototype.update = function update (node) {
  if (node.type != this.node.type) { return false }
  this.node = node;
  updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
  return true
};

TableView.prototype.ignoreMutation = function ignoreMutation (record) {
  return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target))
};

function updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
  var totalWidth = 0, fixedWidth = true;
  var nextDOM = colgroup.firstChild, row = node.firstChild;
  for (var i = 0, col = 0; i < row.childCount; i++) {
    var ref = row.child(i).attrs;
    var colspan = ref.colspan;
    var colwidth = ref.colwidth;
    for (var j = 0; j < colspan; j++, col++) {
      var hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j];
      var cssWidth = hasWidth ? hasWidth + "px" : "";
      totalWidth += hasWidth || cellMinWidth;
      if (!hasWidth) { fixedWidth = false; }
      if (!nextDOM) {
        colgroup.appendChild(document.createElement("col")).style.width = cssWidth;
      } else {
        if (nextDOM.style.width != cssWidth) { nextDOM.style.width = cssWidth; }
        nextDOM = nextDOM.nextSibling;
      }
    }
  }

  while (nextDOM) {
    var after = nextDOM.nextSibling;
    nextDOM.parentNode.removeChild(nextDOM);
    nextDOM = after;
  }

  if (fixedWidth) {
    table.style.width = totalWidth + "px";
    table.style.minWidth = "";
  } else {
    table.style.width = "";
    table.style.minWidth = totalWidth + "px";
  }
}

var key$1 = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]("tableColumnResizing");

function columnResizing(ref) {
  if ( ref === void 0 ) ref = {};
  var handleWidth = ref.handleWidth; if ( handleWidth === void 0 ) handleWidth = 5;
  var cellMinWidth = ref.cellMinWidth; if ( cellMinWidth === void 0 ) cellMinWidth = 25;
  var View = ref.View; if ( View === void 0 ) View = TableView;
  var lastColumnResizable = ref.lastColumnResizable; if ( lastColumnResizable === void 0 ) lastColumnResizable = true;

  var plugin = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: key$1,
    state: {
      init: function init(_, state) {
        this.spec.props.nodeViews[tableNodeTypes(state.schema).table.name] =
          function (node, view) { return new View(node, cellMinWidth, view); };
        return new ResizeState(-1, false)
      },
      apply: function apply(tr, prev) {
        return prev.apply(tr)
      }
    },
    props: {
      attributes: function attributes(state) {
        var pluginState = key$1.getState(state);
        return pluginState.activeHandle > -1 ? {class: "resize-cursor"} : null
      },

      handleDOMEvents: {
        mousemove: function mousemove(view, event) { handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable); },
        mouseleave: function mouseleave(view) { handleMouseLeave(view); },
        mousedown: function mousedown(view, event) { handleMouseDown$1(view, event, cellMinWidth); }
      },

      decorations: function decorations(state) {
        var pluginState = key$1.getState(state);
        if (pluginState.activeHandle > -1) { return handleDecorations(state, pluginState.activeHandle) }
      },

      nodeViews: {}
    }
  });
  return plugin
}

var ResizeState = function ResizeState(activeHandle, dragging) {
  this.activeHandle = activeHandle;
  this.dragging = dragging;
};

ResizeState.prototype.apply = function apply (tr) {
  var state = this, action = tr.getMeta(key$1);
  if (action && action.setHandle != null)
    { return new ResizeState(action.setHandle, null) }
  if (action && action.setDragging !== undefined)
    { return new ResizeState(state.activeHandle, action.setDragging) }
  if (state.activeHandle > -1 && tr.docChanged) {
    var handle = tr.mapping.map(state.activeHandle, -1);
    if (!pointsAtCell(tr.doc.resolve(handle))) { handle = null; }
    state = new ResizeState(handle, state.dragging);
  }
  return state
};

function handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable) {
  var pluginState = key$1.getState(view.state);

  if (!pluginState.dragging) {
    var target = domCellAround(event.target), cell = -1;
    if (target) {
      var ref = target.getBoundingClientRect();
      var left = ref.left;
      var right = ref.right;
      if (event.clientX - left <= handleWidth)
        { cell = edgeCell(view, event, "left"); }
      else if (right - event.clientX <= handleWidth)
        { cell = edgeCell(view, event, "right"); }
    }

    if (cell != pluginState.activeHandle) {
      if (!lastColumnResizable && cell !== -1) {
        var $cell = view.state.doc.resolve(cell);
        var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
        var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;

        if (col == map.width - 1) {
          return
        }
      }

      updateHandle(view, cell);
    }
  }
}

function handleMouseLeave(view) {
  var pluginState = key$1.getState(view.state);
  if (pluginState.activeHandle > -1 && !pluginState.dragging) { updateHandle(view, -1); }
}

function handleMouseDown$1(view, event, cellMinWidth) {
  var pluginState = key$1.getState(view.state);
  if (pluginState.activeHandle == -1 || pluginState.dragging) { return false }

  var cell = view.state.doc.nodeAt(pluginState.activeHandle);
  var width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
  view.dispatch(view.state.tr.setMeta(key$1, {setDragging: {startX: event.clientX, startWidth: width}}));

  function finish(event) {
    window.removeEventListener("mouseup", finish);
    window.removeEventListener("mousemove", move);
    var pluginState = key$1.getState(view.state);
    if (pluginState.dragging) {
      updateColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, event, cellMinWidth));
      view.dispatch(view.state.tr.setMeta(key$1, {setDragging: null}));
    }
  }
  function move(event) {
    if (!event.which) { return finish(event) }
    var pluginState = key$1.getState(view.state);
    var dragged = draggedWidth(pluginState.dragging, event, cellMinWidth);
    displayColumnWidth(view, pluginState.activeHandle, dragged, cellMinWidth);
  }

  window.addEventListener("mouseup", finish);
  window.addEventListener("mousemove", move);
  event.preventDefault();
  return true
}

function currentColWidth(view, cellPos, ref) {
  var colspan = ref.colspan;
  var colwidth = ref.colwidth;

  var width = colwidth && colwidth[colwidth.length - 1];
  if (width) { return width }
  var dom = view.domAtPos(cellPos);
  var node = dom.node.childNodes[dom.offset];
  var domWidth = node.offsetWidth, parts = colspan;
  if (colwidth) { for (var i = 0; i < colspan; i++) { if (colwidth[i]) {
    domWidth -= colwidth[i];
    parts--;
  } } }
  return domWidth / parts
}

function domCellAround(target) {
  while (target && target.nodeName != "TD" && target.nodeName != "TH")
    { target = target.classList.contains("ProseMirror") ? null : target.parentNode; }
  return target
}

function edgeCell(view, event, side) {
  var ref = view.posAtCoords({left: event.clientX, top: event.clientY});
  var pos = ref.pos;
  var $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) { return -1 }
  if (side == "right") { return $cell.pos }
  var map = TableMap.get($cell.node(-1)), start = $cell.start(-1);
  var index = map.map.indexOf($cell.pos - start);
  return index % map.width == 0 ? -1 : start + map.map[index - 1]
}

function draggedWidth(dragging, event, cellMinWidth) {
  var offset = event.clientX - dragging.startX;
  return Math.max(cellMinWidth, dragging.startWidth + offset)
}

function updateHandle(view, value) {
  view.dispatch(view.state.tr.setMeta(key$1, {setHandle: value}));
}

function updateColumnWidth(view, cell, width) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var tr = view.state.tr;
  for (var row = 0; row < map.height; row++) {
    var mapIndex = row * map.width + col;
    // Rowspanning cell that has already been handled
    if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) { continue }
    var pos = map.map[mapIndex];
    var ref = table.nodeAt(pos);
    var attrs = ref.attrs;
    var index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index] == width) { continue }
    var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index] = width;
    tr.setNodeMarkup(start + pos, null, setAttr(attrs, "colwidth", colwidth));
  }
  if (tr.docChanged) { view.dispatch(tr); }
}

function displayColumnWidth(view, cell, width, cellMinWidth) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1), start = $cell.start(-1);
  var col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var dom = view.domAtPos($cell.start(-1)).node;
  while (dom.nodeName != "TABLE") { dom = dom.parentNode; }
  updateColumns(table, dom.firstChild, dom, cellMinWidth, col, width);
}

function zeroes(n) {
  var result = [];
  for (var i = 0; i < n; i++) { result.push(0); }
  return result
}

function handleDecorations(state, cell) {
  var decorations = [];
  var $cell = state.doc.resolve(cell);
  var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;
  for (var row = 0; row < map.height; row++) {
    var index = col + row * map.width - 1;
    // For positions that are have either a different cell or the end
    // of the table to their right, and either the top of the table or
    // a different cell above them, add a decoration
    if ((col == map.width || map.map[index] != map.map[index + 1]) &&
        (row == 0 || map.map[index - 1] != map.map[index - 1 - map.width])) {
      var cellPos = map.map[index];
      var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
      var dom = document.createElement("div");
      dom.className = "column-resize-handle";
      decorations.push(__WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["a" /* Decoration */].widget(pos, dom));
    }
  }
  return __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["b" /* DecorationSet */].create(state.doc, decorations)
}

// This file defines a plugin that handles the drawing of cell

// :: () → Plugin
//
// Creates a [plugin](http://prosemirror.net/docs/ref/#state.Plugin)
// that, when added to an editor, enables cell-selection, handles
// cell-based copy/paste, and makes sure tables stay well-formed (each
// row has the same width, and cells don't overlap).
//
// You should probably put this plugin near the end of your array of
// plugins, since it handles mouse and arrow key events in tables
// rather broadly, and other plugins, like the gap cursor or the
// column-width dragging plugin, might want to get a turn first to
// perform more specific behavior.
function tableEditing(ref) {
  if ( ref === void 0 ) ref = {};
  var allowTableNodeSelection = ref.allowTableNodeSelection; if ( allowTableNodeSelection === void 0 ) allowTableNodeSelection = false;

  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: key,

    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init: function init() { return null },
      apply: function apply(tr, cur) {
        var set = tr.getMeta(key);
        if (set != null) { return set == -1 ? null : set }
        if (cur == null || !tr.docChanged) { return cur }
        var ref = tr.mapping.mapResult(cur);
        var deleted = ref.deleted;
        var pos = ref.pos;
        return deleted ? null : pos
      }
    },

    props: {
      decorations: drawCellSelection,

      handleDOMEvents: {
        mousedown: handleMouseDown
      },

      createSelectionBetween: function createSelectionBetween(view) {
        if (key.getState(view.state) != null) { return view.state.selection }
      },

      handleTripleClick: handleTripleClick,

      handleKeyDown: handleKeyDown,

      handlePaste: handlePaste
    },

    appendTransaction: function appendTransaction(_, oldState, state) {
      return normalizeSelection(state, fixTables(state, oldState), allowTableNodeSelection)
    }
  })
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return markInputRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return markPasteRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return nodeInputRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pasteRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return replaceText; });
/* unused harmony export setInlineBlockType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return splitToDefaultListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleBlockType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return toggleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return toggleWrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateMark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__ = __webpack_require__(130);
/* unused harmony reexport autoJoin */
/* unused harmony reexport baseKeymap */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["b"]; });
/* unused harmony reexport createParagraphNear */
/* unused harmony reexport deleteSelection */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["c"]; });
/* unused harmony reexport joinBackward */
/* unused harmony reexport joinDown */
/* unused harmony reexport joinForward */
/* unused harmony reexport joinUp */
/* unused harmony reexport lift */
/* unused harmony reexport liftEmptyBlock */
/* unused harmony reexport macBaseKeymap */
/* unused harmony reexport newlineInCode */
/* unused harmony reexport pcBaseKeymap */
/* unused harmony reexport selectAll */
/* unused harmony reexport selectNodeBackward */
/* unused harmony reexport selectNodeForward */
/* unused harmony reexport selectParentNode */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["e"]; });
/* unused harmony reexport splitBlock */
/* unused harmony reexport splitBlockKeepMarks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["f"]; });
/* unused harmony reexport wrapIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__ = __webpack_require__(231);
/* unused harmony reexport addListNodes */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["c"]; });
/* unused harmony reexport wrapInList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_inputrules__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2_prosemirror_inputrules__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2_prosemirror_inputrules__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiptap_utils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prosemirror_utils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prosemirror_utils__);

    /*!
    * tiptap-commands v1.12.4
    * (c) 2019 Scrumpy UG (limited liability)
    * @license MIT
    */
  











function insertText () {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function (state, dispatch) {
    var $from = state.selection.$from;
    var pos = $from.pos.pos;
    dispatch(state.tr.insertText(text, pos));
    return true;
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function getMarksBetween(start, end, state) {
  var marks = [];
  state.doc.nodesBetween(start, end, function (node, pos) {
    marks = [].concat(_toConsumableArray(marks), _toConsumableArray(node.marks.map(function (mark) {
      return {
        start: pos,
        end: pos + node.nodeSize,
        mark: mark
      };
    })));
  });
  return marks;
}

function markInputRule (regexp, markType, getAttrs) {
  return new __WEBPACK_IMPORTED_MODULE_2_prosemirror_inputrules__["a" /* InputRule */](regexp, function (state, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr;
    var m = match.length - 1;
    var markEnd = end;
    var markStart = start;

    if (match[m]) {
      var matchStart = start + match[0].indexOf(match[m - 1]);
      var matchEnd = matchStart + match[m - 1].length - 1;
      var textStart = matchStart + match[m - 1].lastIndexOf(match[m]);
      var textEnd = textStart + match[m].length;
      var excludedMarks = getMarksBetween(start, end, state).filter(function (item) {
        var excluded = item.mark.type.excluded;
        return excluded.find(function (type) {
          return type.name === markType.name;
        });
      }).filter(function (item) {
        return item.end > matchStart;
      });

      if (excludedMarks.length) {
        return false;
      }

      if (textEnd < matchEnd) {
        tr.delete(textEnd, matchEnd);
      }

      if (textStart > matchStart) {
        tr.delete(matchStart, textStart);
      }

      markStart = matchStart;
      markEnd = markStart + match[m].length;
    }

    tr.addMark(markStart, markEnd, markType.create(attrs));
    tr.removeStoredMark(markType);
    return tr;
  });
}

function nodeInputRule (regexp, type, getAttrs) {
  return new __WEBPACK_IMPORTED_MODULE_2_prosemirror_inputrules__["a" /* InputRule */](regexp, function (state, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr;

    if (match[0]) {
      tr.replaceWith(start - 1, end, type.create(attrs));
    }

    return tr;
  });
}

function pasteRule (regexp, type, getAttrs) {
  var handler = function handler(fragment) {
    var nodes = [];
    fragment.forEach(function (child) {
      if (child.isText) {
        var text = child.text;
        var pos = 0;
        var match;

        do {
          match = regexp.exec(text);

          if (match) {
            var start = match.index;
            var end = start + match[0].length;
            var attrs = getAttrs instanceof Function ? getAttrs(match[0]) : getAttrs;

            if (start > 0) {
              nodes.push(child.cut(pos, start));
            }

            nodes.push(child.cut(start, end).mark(type.create(attrs).addToSet(child.marks)));
            pos = end;
          }
        } while (match);

        if (pos < text.length) {
          nodes.push(child.cut(pos));
        }
      } else {
        nodes.push(child.copy(handler(child.content)));
      }
    });
    return __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Fragment"].fromArray(nodes);
  };

  return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
    props: {
      transformPasted: function transformPasted(slice) {
        return new __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Slice"](handler(slice.content), slice.openStart, slice.openEnd);
      }
    }
  });
}

function markPasteRule (regexp, type, getAttrs) {
  var handler = function handler(fragment) {
    var nodes = [];
    fragment.forEach(function (child) {
      if (child.isText) {
        var text = child.text,
            marks = child.marks;
        var pos = 0;
        var match;
        var isLink = !!marks.filter(function (x) {
          return x.type.name === 'link';
        })[0]; // eslint-disable-next-line

        while (!isLink && (match = regexp.exec(text)) !== null) {
          if (match[1]) {
            var start = match.index;
            var end = start + match[0].length;
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs; // adding text before markdown to nodes

            if (start > 0) {
              nodes.push(child.cut(pos, start));
            } // adding the markdown part to nodes


            nodes.push(child.cut(textStart, textEnd).mark(type.create(attrs).addToSet(child.marks)));
            pos = end;
          }
        } // adding rest of text to nodes


        if (pos < text.length) {
          nodes.push(child.cut(pos));
        }
      } else {
        nodes.push(child.copy(handler(child.content)));
      }
    });
    return __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Fragment"].fromArray(nodes);
  };

  return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
    props: {
      transformPasted: function transformPasted(slice) {
        return new __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Slice"](handler(slice.content), slice.openStart, slice.openEnd);
      }
    }
  });
}

function removeMark (type) {
  return function (state, dispatch) {
    var tr = state.tr,
        selection = state.selection;
    var from = selection.from,
        to = selection.to;
    var $from = selection.$from,
        empty = selection.empty;

    if (empty) {
      var range = Object(__WEBPACK_IMPORTED_MODULE_5_tiptap_utils__["b" /* getMarkRange */])($from, type);
      from = range.from;
      to = range.to;
    }

    tr.removeMark(from, to, type);
    return dispatch(tr);
  };
}

function replaceText () {
  var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var type = arguments.length > 1 ? arguments[1] : undefined;
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (state, dispatch) {
    var _state$selection = state.selection,
        $from = _state$selection.$from,
        $to = _state$selection.$to;
    var index = $from.index();
    var from = range ? range.from : $from.pos;
    var to = range ? range.to : $to.pos;

    if (!$from.parent.canReplaceWith(index, index, type)) {
      return false;
    }

    if (dispatch) {
      dispatch(state.tr.replaceWith(from, to, type.create(attrs)));
    }

    return true;
  };
}

function setInlineBlockType (type) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (state, dispatch) {
    var $from = state.selection.$from;
    var index = $from.index();

    if (!$from.parent.canReplaceWith(index, index, type)) {
      return false;
    }

    if (dispatch) {
      dispatch(state.tr.replaceSelectionWith(type.create(attrs)));
    }

    return true;
  };
}

// see https://github.com/ProseMirror/prosemirror-transform/blob/master/src/structure.js
// Since this piece of code was "borrowed" from prosemirror, ESLint rules are ignored.

/* eslint-disable max-len, no-plusplus, no-undef, eqeqeq */

function canSplit(doc, pos) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var typesAfter = arguments.length > 3 ? arguments[3] : undefined;
  var $pos = doc.resolve(pos);
  var base = $pos.depth - depth;
  var innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;

  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d);

    var _index = $pos.index(d);

    if (node.type.spec.isolating) return false;
    var rest = node.content.cutByIndex(_index, node.childCount);
    var after = typesAfter && typesAfter[i] || node;
    if (after != node) rest = rest.replaceChild(0, after.type.create(after.attrs));
    /* Change starts from here */
    // if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest))
    //   return false

    if (!node.canReplace(_index + 1, node.childCount)) return false;
    /* Change ends here */
  }

  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
} // this is a copy of splitListItem
// see https://github.com/ProseMirror/prosemirror-schema-list/blob/master/src/schema-list.js


function splitToDefaultListItem(itemType) {
  return function (state, dispatch) {
    var _state$selection = state.selection,
        $from = _state$selection.$from,
        $to = _state$selection.$to,
        node = _state$selection.node;
    if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) return false;

    if ($from.parent.content.size == 0) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth == 2 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;

      if (dispatch) {
        var wrap = __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Fragment"].empty;
        var keepItem = $from.index(-1) > 0; // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor

        for (var d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--) {
          wrap = __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Fragment"].from($from.node(d).copy(wrap));
        } // Add a second list item with an empty default start node


        wrap = wrap.append(__WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Fragment"].from(itemType.createAndFill()));

        var _tr = state.tr.replace($from.before(keepItem ? null : -1), $from.after(-3), new __WEBPACK_IMPORTED_MODULE_4_prosemirror_model__["Slice"](wrap, keepItem ? 3 : 2, 2));

        _tr.setSelection(state.selection.constructor.near(_tr.doc.resolve($from.pos + (keepItem ? 3 : 2))));

        dispatch(_tr.scrollIntoView());
      }

      return true;
    }

    var nextType = $to.pos == $from.end() ? grandParent.contentMatchAt($from.indexAfter(-1)).defaultType : null;
    var tr = state.tr.delete($from.pos, $to.pos);
    /* Change starts from here */
    // let types = nextType && [null, {type: nextType}]

    var types = nextType && [{
      type: itemType
    }, {
      type: nextType
    }];
    if (!types) types = [{
      type: itemType
    }, null];
    /* Change ends here */

    if (!canSplit(tr.doc, $from.pos, 2, types)) return false;
    if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
    return true;
  };
}
/* eslint-enable max-len, no-plusplus, no-undef, eqeqeq */

function toggleBlockType (type, toggletype) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (state, dispatch, view) {
    var isActive = Object(__WEBPACK_IMPORTED_MODULE_5_tiptap_utils__["e" /* nodeIsActive */])(state, type, attrs);

    if (isActive) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["e" /* setBlockType */])(toggletype)(state, dispatch, view);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["e" /* setBlockType */])(type, attrs)(state, dispatch, view);
  };
}

function isList(node, schema) {
  return node.type === schema.nodes.bullet_list || node.type === schema.nodes.ordered_list || node.type === schema.nodes.todo_list;
}

function toggleList(listType, itemType) {
  return function (state, dispatch, view) {
    var schema = state.schema,
        selection = state.selection;
    var $from = selection.$from,
        $to = selection.$to;
    var range = $from.blockRange($to);

    if (!range) {
      return false;
    }

    var parentList = Object(__WEBPACK_IMPORTED_MODULE_6_prosemirror_utils__["findParentNode"])(function (node) {
      return isList(node, schema);
    })(selection);

    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
      if (parentList.node.type === listType) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["a" /* liftListItem */])(itemType)(state, dispatch, view);
      }

      if (isList(parentList.node, schema) && listType.validContent(parentList.node.content)) {
        var tr = state.tr;
        tr.setNodeMarkup(parentList.pos, listType);

        if (dispatch) {
          dispatch(tr);
        }

        return false;
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["d" /* wrapInList */])(listType)(state, dispatch, view);
  };
}

function toggleWrap (type) {
  return function (state, dispatch, view) {
    var isActive = Object(__WEBPACK_IMPORTED_MODULE_5_tiptap_utils__["e" /* nodeIsActive */])(state, type);

    if (isActive) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["d" /* lift */])(state, dispatch);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["g" /* wrapIn */])(type)(state, dispatch, view);
  };
}

function updateMark (type, attrs) {
  return function (state, dispatch) {
    var tr = state.tr,
        selection = state.selection,
        doc = state.doc;
    var from = selection.from,
        to = selection.to;
    var $from = selection.$from,
        empty = selection.empty;

    if (empty) {
      var range = Object(__WEBPACK_IMPORTED_MODULE_5_tiptap_utils__["b" /* getMarkRange */])($from, type);
      from = range.from;
      to = range.to;
    }

    var hasMark = doc.rangeHasMark(from, to, type);

    if (hasMark) {
      tr.removeMark(from, to, type);
    }

    tr.addMark(from, to, type.create(attrs));
    return dispatch(tr);
  };
}




/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addListNodes */
/* unused harmony export bulletList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return liftListItem; });
/* unused harmony export listItem */
/* unused harmony export orderedList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sinkListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return splitListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wrapInList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(37);



var olDOM = ["ol", 0], ulDOM = ["ul", 0], liDOM = ["li", 0];

// :: NodeSpec
// An ordered list [node spec](#model.NodeSpec). Has a single
// attribute, `order`, which determines the number at which the list
// starts counting, and defaults to 1. Represented as an `<ol>`
// element.
var orderedList = {
  attrs: {order: {default: 1}},
  parseDOM: [{tag: "ol", getAttrs: function getAttrs(dom) {
    return {order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1}
  }}],
  toDOM: function toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {start: node.attrs.order}, 0]
  }
};

// :: NodeSpec
// A bullet list node spec, represented in the DOM as `<ul>`.
var bulletList = {
  parseDOM: [{tag: "ul"}],
  toDOM: function toDOM() { return ulDOM }
};

// :: NodeSpec
// A list item (`<li>`) spec.
var listItem = {
  parseDOM: [{tag: "li"}],
  toDOM: function toDOM() { return liDOM },
  defining: true
};

function add(obj, props) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  for (var prop$1 in props) { copy[prop$1] = props[prop$1]; }
  return copy
}

// :: (OrderedMap<NodeSpec>, string, ?string) → OrderedMap<NodeSpec>
// Convenience function for adding list-related node types to a map
// specifying the nodes for a schema. Adds
// [`orderedList`](#schema-list.orderedList) as `"ordered_list"`,
// [`bulletList`](#schema-list.bulletList) as `"bullet_list"`, and
// [`listItem`](#schema-list.listItem) as `"list_item"`.
//
// `itemContent` determines the content expression for the list items.
// If you want the commands defined in this module to apply to your
// list structure, it should have a shape like `"paragraph block*"` or
// `"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
// given to assign a group name to the list node types, for example
// `"block"`.
function addListNodes(nodes, itemContent, listGroup) {
  return nodes.append({
    ordered_list: add(orderedList, {content: "list_item+", group: listGroup}),
    bullet_list: add(bulletList, {content: "list_item+", group: listGroup}),
    list_item: add(listItem, {content: itemContent})
  })
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function wrapInList(listType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), doJoin = false, outerRange = range;
    if (!range) { return false }
    // This is at the top of an existing list item
    if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
      // Don't do anything if this is the top of the list
      if ($from.index(range.depth - 1) == 0) { return false }
      var $insert = state.doc.resolve(range.start - 2);
      outerRange = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["NodeRange"]($insert, $insert, range.depth);
      if (range.endIndex < range.parent.childCount)
        { range = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["NodeRange"]($from, state.doc.resolve($to.end(range.depth)), range.depth); }
      doJoin = true;
    }
    var wrap = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["h" /* findWrapping */])(outerRange, listType, attrs, range);
    if (!wrap) { return false }
    if (dispatch) { dispatch(doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView()); }
    return true
  }
}

function doWrapInList(tr, range, wrappers, joinBefore, listType) {
  var content = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  tr.step(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["b" /* ReplaceAroundStep */](range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end,
                                new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](content, 0, 0), wrappers.length, true));

  var found = 0;
  for (var i$1 = 0; i$1 < wrappers.length; i$1++) { if (wrappers[i$1].type == listType) { found = i$1 + 1; } }
  var splitDepth = wrappers.length - found;

  var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
  for (var i$2 = range.startIndex, e = range.endIndex, first = true; i$2 < e; i$2++, first = false) {
    if (!first && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["f" /* canSplit */])(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i$2).nodeSize;
  }
  return tr
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Build a command that splits a non-empty textblock at the top level
// of a list item by also splitting that list item.
function splitListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var node = ref.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) { return false }
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) { return false }
    if ($from.parent.content.size == 0) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth == 2 || $from.node(-3).type != itemType ||
          $from.index(-2) != $from.node(-2).childCount - 1) { return false }
      if (dispatch) {
        var wrap = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty, keepItem = $from.index(-1) > 0;
        // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor
        for (var d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)
          { wrap = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from($from.node(d).copy(wrap)); }
        // Add a second list item with an empty default start node
        wrap = wrap.append(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(itemType.createAndFill()));
        var tr$1 = state.tr.replace($from.before(keepItem ? null : -1), $from.after(-3), new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](wrap, keepItem ? 3 : 2, 2));
        tr$1.setSelection(state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
        dispatch(tr$1.scrollIntoView());
      }
      return true
    }
    var nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    var tr = state.tr.delete($from.pos, $to.pos);
    var types = nextType && [null, {type: nextType}];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["f" /* canSplit */])(tr.doc, $from.pos, 2, types)) { return false }
    if (dispatch) { dispatch(tr.split($from.pos, 2, types).scrollIntoView()); }
    return true
  }
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function liftListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    if (!dispatch) { return true }
    if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
      { return liftToOuterList(state, dispatch, itemType, range) }
    else // Outer list node
      { return liftOutOfList(state, dispatch, range) }
  }
}

function liftToOuterList(state, dispatch, itemType, range) {
  var tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
  if (end < endOfList) {
    // There are siblings after the lifted items, which must become
    // children of the last item
    tr.step(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["b" /* ReplaceAroundStep */](end - 1, endOfList, end, endOfList,
                                  new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["NodeRange"](tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
  }
  dispatch(tr.lift(range, Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["j" /* liftTarget */])(range)).scrollIntoView());
  return true
}

function liftOutOfList(state, dispatch, range) {
  var tr = state.tr, list = range.parent;
  // Merge the list items into a single big item
  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr.delete(pos - 1, pos + 1);
  }
  var $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
  var atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
  var parent = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1,
                         item.content.append(atEnd ? __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty : __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(list))))
    { return false }
  var start = $start.pos, end = start + item.nodeSize;
  // Strip off the surrounding list. At the sides where we're not at
  // the end of the list, the existing list is closed. At sides where
  // this is the end, it is overwritten to its end.
  tr.step(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["b" /* ReplaceAroundStep */](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1,
                                new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"]((atStart ? __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty : __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(list.copy(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty)))
                                          .append(atEnd ? __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty : __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(list.copy(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty))),
                                          atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr.scrollIntoView());
  return true
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to sink the list item around the selection down
// into an inner list.
function sinkListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    var startIndex = range.startIndex;
    if (startIndex == 0) { return false }
    var parent = range.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType) { return false }

    if (dispatch) {
      var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      var inner = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(nestedBefore ? itemType.create() : null);
      var slice = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(itemType.create(null, __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(parent.type.create(null, inner)))),
                            nestedBefore ? 3 : 1, 0);
      var before = range.start, after = range.end;
      dispatch(state.tr.step(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["b" /* ReplaceAroundStep */](before - (nestedBefore ? 3 : 1), after,
                                                   before, after, slice, 1, true))
               .scrollIntoView());
    }
    return true
  }
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__documents_CodeOfConduct__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__documents_BackgroundCheck__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__documents_CovidPolicies__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__documents_DistractedDriving__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__documents_NannyHandbook__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document__ = __webpack_require__(238);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  components: {
    CodeOfConduct: __WEBPACK_IMPORTED_MODULE_1__documents_CodeOfConduct__["a" /* default */],
    BackgroundCheck: __WEBPACK_IMPORTED_MODULE_2__documents_BackgroundCheck__["a" /* default */],
    CovidPolicies: __WEBPACK_IMPORTED_MODULE_3__documents_CovidPolicies__["a" /* default */],
    DistractedDriving: __WEBPACK_IMPORTED_MODULE_4__documents_DistractedDriving__["a" /* default */],
    NannyHandbook: __WEBPACK_IMPORTED_MODULE_5__documents_NannyHandbook__["a" /* default */],
    Document: __WEBPACK_IMPORTED_MODULE_6__Document__["a" /* default */]
  },
  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess: function viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function data() {
    return {
      documents: [],
      document: {},

      files: [],
      file: '',
      fileName: '',
      selectedFile: {}
    };
  },
  created: function created() {
    this.getDocuments();
    this.getFiles();
  },

  methods: {
    getDocuments: function getDocuments() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/documents/?signing_user=' + this.user.id).then(function (res) {
        console.log(res);
        _this.documents = res.data;
        _this.documents = _this.documents.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        });
      });
    },
    showCodeOfConductModal: function showCodeOfConductModal(document) {
      this.document = document;
      this.$modal.show('code-of-conduct-modal');
    },
    showBackgroundCheckModal: function showBackgroundCheckModal(document) {
      this.document = document;
      this.$modal.show('background-check-modal');
    },
    showNannyHandbookModal: function showNannyHandbookModal(document) {
      this.document = document;
      this.$modal.show('nanny-handbook-modal');
    },
    showDistractedDrivingModal: function showDistractedDrivingModal(document) {
      this.document = document;
      this.$modal.show('distracted-driving-modal');
    },
    showCovidPoliciesModal: function showCovidPoliciesModal(document) {
      this.document = document;
      this.$modal.show('covid-policies-modal');
    },
    showDocumentModal: function showDocumentModal(document) {
      this.document = document;
      this.$modal.show('document-modal');
    },
    documentSigned: function documentSigned() {
      this.getDocuments();
      this.$modal.hide('code-of-conduct-modal');
      this.$modal.hide('background-check-modal');
      this.$modal.hide('nanny-handbook-modal');
      this.$modal.hide('distracted-driving-modal');
      this.$modal.hide('covid-policies-modal');
      this.$modal.hide('document-modal');
      this.$modal.show('document-signed-modal');

      this.$store.dispatch('sendEmails', {
        subject: 'Document Signed - ' + this.user.first_name + ' ' + this.user.last_name + ' | ' + this.document.title,
        message: 'Hello,' + '\n\n' + ('The candidate ' + this.user.first_name + ' ' + this.user.last_name + ' just signed the following document: ' + this.document.title + '\n\n') + 'Cheers!',
        from: this.$store.getters.agencyFromEmail,
        emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail2],
        reply: this.$store.getters.agencyAdminEmail2,
        // userID: this.aakashid,
        userID: 4
      });
    },
    showUploadDocumentsModal: function showUploadDocumentsModal() {
      this.$modal.show('upload-documents-modal');
    },
    handleFileUpload: function handleFileUpload() {
      this.resume = this.$refs.resume.files[0];
      this.file1 = this.$refs.file1.files[0];
      this.file2 = this.$refs.file2.files[0];
      this.file3 = this.$refs.file3.files[0];
      this.file4 = this.$refs.file4.files[0];
      this.file5 = this.$refs.file5.files[0];
    },
    uploadDocuments: function uploadDocuments() {
      var _this2 = this;

      var formData = new FormData();
      if (this.resume) {
        formData.append("resume", this.resume);
      }
      if (this.file1) {
        formData.append("file1", this.file1);
      }
      if (this.file2) {
        formData.append("file2", this.file2);
      }
      if (this.file3) {
        formData.append("file3", this.file3);
      }
      if (this.file4) {
        formData.append("file4", this.file4);
      }
      if (this.file5) {
        formData.append("file5", this.file5);
      }

      this.$modal.hide('upload-documents-modal');
      this.$modal.show('documents-uploaded-modal');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/".concat(this.user.id.toString()).concat("/"), formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (res) {
        // console.log(res);
        // this.$modal.hide('upload-documents-modal')
        // this.$modal.show('documents-uploaded-modal')
        _this2.$emit('infoSaved');

        _this2.$store.dispatch('sendEmails', {
          subject: 'Documents Uploaded - ' + _this2.user.first_name + ' ' + _this2.user.last_name,
          message: 'Hello,' + '\n\n' + ('The nanny ' + _this2.user.first_name + ' ' + _this2.user.last_name + ' just uploaded new documents!\n\n') + 'Cheers!',
          from: _this2.$store.getters.agencyFromEmail,
          emails: [_this2.$store.getters.enginehireLoggingEmail, _this2.$store.getters.agencyAdminEmail2],
          reply: _this2.$store.getters.agencyAdminEmail2,
          // userID: this.aakashid,
          userID: 4
        });

        // if (this.file3) {
        //   this.$store.dispatch('sendEmails',
        //     {
        //       subject: `Agency Resume Uploaded - ${this.user.first_name} ${this.user.last_name}`,
        //       message: 'Hello,' + '\n\n' +
        //       `The nanny ${this.user.first_name} ${this.user.last_name} just uploaded their agency resume!\n\n`+
        //       'Cheers!',
        //       from: this.$store.getters.agencyFromEmail,
        //       emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail3],
        //       reply: this.$store.getters.agencyReplyEmail,
        //       // userID: this.aakashid,
        //       userID: 4,
        //     }
        //   )
        // }
      }).catch(function (error) {
        console.log(error);
      });
    },
    showDeleteDocumentModal: function showDeleteDocumentModal(document) {
      this.document = document;
      this.$modal.show('delete-document-modal');
    },
    deleteDocument: function deleteDocument(document) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + document.id + '/').then(function (res) {
        _this3.getDocuments();
        _this3.$modal.hide('delete-document-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    },
    unsignDocument: function unsignDocument(document) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + document.id + '/', {
        status: 'Unsigned',
        signing_name: ''
      }).then(function (res) {
        _this4.getDocuments();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    handleSingleFileUpload: function handleSingleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    getFiles: function getFiles() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/files/?user=' + this.user.id).then(function (res) {
        _this5.files = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showUploadFileModal: function showUploadFileModal() {
      this.file = '';
      this.fileName = '';
      this.$modal.show('upload-file-modal');
    },
    uploadFile: function uploadFile() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/files/', {
        user: this.user.id,
        name: this.fileName
      }).then(function (res) {
        var formData = new FormData();
        if (_this6.file) {
          formData.append("file_link", _this6.file);
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/files/' + res.data.id + '/', formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(function (res) {
          _this6.getFiles();
          _this6.$modal.hide('upload-file-modal');
        }).catch(function (error) {
          return console.log(error);
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showDeleteFileModal: function showDeleteFileModal(file) {
      this.selectedFile = file;
      this.$modal.show('delete-file-modal');
    },
    deleteFile: function deleteFile(file) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/files/' + file.id).then(function (res) {
        _this7.$modal.hide('delete-file-modal');
        _this7.getFiles();
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteDocument: function deleteDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + this.document.id + '/').then(function (res) {
        console.log(res);
        _this2.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      field1: '',
      field2: '',
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      signature: ''
    };
  },
  created: function created() {
    this.field1 = this.document.field1;
    this.field2 = this.document.field2;
    this.field3 = this.document.field3;
    this.field4 = this.document.field4;
    this.field5 = this.document.field5;
    this.field6 = this.document.field6;
    this.field7 = this.document.field7;
    this.field8 = this.document.field8;
    this.field9 = this.document.field9;
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        field1: this.field1,
        field2: this.field2,
        field3: this.field3,
        field4: this.field4,
        field5: this.field5,
        field6: this.field6,
        field7: this.field7,
        field8: this.field8,
        field9: this.field9,
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteDocument: function deleteDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + this.document.id + '/').then(function (res) {
        console.log(res);
        _this2.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteDocument: function deleteDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + this.document.id + '/').then(function (res) {
        console.log(res);
        _this2.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteDocument: function deleteDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + this.document.id + '/').then(function (res) {
        console.log(res);
        _this2.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteDocument: function deleteDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + this.document.id + '/').then(function (res) {
        console.log(res);
        _this2.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Document_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299a501c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Document_vue__ = __webpack_require__(705);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Document_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299a501c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Document_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  // title: template.name,
  // template: template.id,
  // signing_user: this.user.id,
  // status: 'Unsigned',
  // body: template.body,
  // fields_labels: template.fields,
  // fields_required: template.fields_required,
  // edit_access: template.edit_access,
  // organization_signer: template.organization_signer,
  // signer_labels: template.signer_labels,
  // agency_owner: this.$store.getters.agencyName,
  // agency: this.$store.getters.agencyID,

  props: ['user', 'document'],
  data: function data() {
    return {
      template: {},
      signatures: [],
      signature: '',
      fields: []
    };
  },
  created: function created() {
    this.getTemplate();

    if (this.document.fields.length) {
      this.fields = this.document.fields;
    } else {
      // If the document is not already filled, want to prepopulate the fields array with blanks for use with v-model
      for (var label in this.document.fields_labels) {
        this.fields.push('');
      }
    }

    // this.document.body.replace('[[firstname]]', this.user.first_name)
    // this.document.body.replace('[[lastname]]', this.user.last_name)
  },

  computed: {
    // documentBody() {
    //   let documentBody = this.document.body
    //   documentBody = documentBody.replace('[[firstname]]', this.user.first_name)
    //   documentBody = documentBody.replace('[[lastname]]', this.user.last_name)
    //   // documentBody.replace('NOTICE', 'blah')

    //   return documentBody
    // },

    documentBody: function documentBody() {
      this.document.body = this.document.body.replace('[[firstname]]', this.user.first_name);
      this.document.body = this.document.body.replace('[[lastname]]', this.user.last_name);

      var documentBody = null;
      if (this.fields.length) {
        if (this.document.status == 'Signed' || this.document.edit_access == 'Admin' && this.document.signing_user == this.$store.getters.userID) {
          documentBody = this.document.body;
          // console.log(documentBody)
        } else if (this.document.status == 'Unsigned' || this.document.status == 'Saved') {
          documentBody = [];
          documentBody[0] = this.document.body;
          console.log(this.document.body);
        }
        var num = 0;
        var thing = '[[field' + num + ']]';
        // documentBody = documentBody.replace(`[[field1]]`, this.fields[1])
        for (var field in this.fields) {
          // if (this.document.status == 'Signed') { // If the document is filled/signed, we want to replace all the [field] references with whatever was entered
          if (this.document.status == 'Signed' || this.document.edit_access == 'Admin' && this.document.signing_user == this.$store.getters.userID) {
            // If the document is filled/signed, we want to replace all the [field] references with whatever was entered
            console.log('[[field' + field + ']]');
            // documentBody = documentBody.replace(`[[field${field}]]`, this.fields[field])
            // https://stackoverflow.com/questions/13340131/javascript-replaceall-not-working
            documentBody = documentBody.split('[[field' + field + ']]').join(this.fields[field]);
          } else if (this.document.status == 'Unsigned' || this.document.status == 'Saved') {
            // If the document has not been signed or is not one that needs to be signed, we want to split it into pieces at each of the [field] references, so we can display inline text boxes to fill it
            // documentBody[field] = documentBody[field].split(`[[field${field}]]`)
            var remainingDocument = documentBody.pop(); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
            documentBody = documentBody.concat(remainingDocument.split('[[field' + field + ']]')); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat
          }
        }
        // documentBody = documentBody.replace(thing, 'blahhblah')
      } else {
        documentBody = this.document.body;
      }

      return documentBody;
    },
    allSigned: function allSigned() {
      if (this.signatures.length) {
        for (var signature in this.signatures) {
          if (this.signatures[signature] == '') {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    getTemplate: function getTemplate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/documenttemplates/?id=' + this.document.template).then(function (res) {
        _this.template = res.data[0];

        if (_this.document.status == 'Unsigned') {
          for (var signer_label in _this.template.signer_labels) {
            _this.signatures.push('');
          }
        } else if (_this.document.status == 'Signed') {
          _this.signatures = _this.document.signers;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    sign: function sign() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signers: this.signatures,
        signing_date: this.todayDatetimeDjangoFormat,
        fields: this.fields,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this2.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    },
    save: function save() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        fields: this.fields,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this3.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      notes: ''
    };
  },
  created: function created() {
    this.notes = this.user.text20;
  },

  methods: {
    update: function update() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        text20: this.notes
      }).then(function (res) {
        _this.$emit('infoSaved');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      experiences: [],
      experience: {},
      title: '',
      employmentType: '',
      employmentTypes: [],
      company: '',
      months: [],
      monthsNumeric: [],
      monthsShort: [],
      startDate: null,
      startMonth: null,
      startYear: null,
      endDate: null,
      endMonth: null,
      endYear: null,
      city: '',
      country: '',
      countries: [],
      states: [],
      description: '',
      currentRole: false,

      numChildren: '',
      ageChildren: '',
      years: '',
      frequency: ''
    };
  },

  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess: function viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    },
    adminOrEmployer: function adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.getExperiences();

    this.months = this.$store.getters.months;
    // https://stackoverflow.com/questions/19590865/from-an-array-of-objects-extract-value-of-a-property-as-array
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
    this.monthsNumeric = this.months.map(function (month) {
      return month.number;
    });
    this.monthsShort = this.months.map(function (month) {
      return month.short;
    });
  },

  methods: {
    getExperiences: function getExperiences() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/experiences/?user=' + this.user.id).then(function (res) {
        _this.experiences = res.data;
        _this.experiences = _this.experiences.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    showExperienceModal: function showExperienceModal(experience) {
      if (experience) {
        this.experience = experience;
        this.title = experience.title;
        this.employmentType = experience.employment_type;
        this.company = experience.company_name;
        this.city = experience.city;
        this.country = experience.country;
        this.description = experience.note;
        this.currentRole = experience.current_role;
        this.startDate = experience.start_date;
        this.endDate = experience.end_date;

        if (experience.start_date) {
          // https://www.w3schools.com/jsref/jsref_split.asp
          this.startYear = experience.start_date.split('-')[0];
          this.startMonth = experience.start_date.split('-')[1];
        }
        if (experience.end_date) {
          // https://www.w3schools.com/jsref/jsref_split.asp
          this.endYear = experience.end_date.split('-')[0];
          this.endMonth = experience.end_date.split('-')[1];
        }

        this.numChildren = experience.text1;
        this.ageChildren = experience.text2;
        this.years = experience.text3;
        this.frequency = experience.text4;
      } else {
        this.experience = {};
        this.title = '';
        this.employmentType = '';
        this.company = '';
        this.startDate = null;
        this.endDate = null;
        this.city = '';
        this.country = 'United States';
        this.description = '';
        this.currentRole = false;

        this.numChildren = '';
        this.ageChildren = '';
        this.years = '';
        this.frequency = '';
      }
      this.$modal.show('experience-modal');
    },
    hideExperienceModal: function hideExperienceModal() {
      this.$modal.hide('experience-modal');
    },
    postExperience: function postExperience() {
      var _this2 = this;

      if (this.startMonth && this.startYear) {
        this.startDate = this.startYear + '-' + this.startMonth + '-01';
      }
      if (this.endMonth && this.endYear && !this.currentRole) {
        this.endDate = this.endYear + '-' + this.endMonth + '-01';
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/experiences/', {
        user: this.user.id,
        title: this.title,
        company_name: this.company,
        employment_type: this.employmentType,
        start_date: this.startDate,
        end_date: this.endDate,
        city: this.city,
        country: this.country,
        note: this.description,
        current_role: this.currentRole,

        text1: this.numChildren,
        text2: this.ageChildren,
        text3: this.years,
        text4: this.frequency,

        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        console.log(res);
        _this2.hideExperienceModal();
        _this2.getExperiences();
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateExperience: function updateExperience(experience) {
      var _this3 = this;

      if (this.startMonth && this.startYear) {
        this.startDate = this.startYear + '-' + this.startMonth + '-01';
      }
      if (this.endMonth && this.endYear && !this.currentRole) {
        this.endDate = this.endYear + '-' + this.endMonth + '-01';
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/experiences/' + experience.id.toString() + '/', {
        title: this.title,
        // company_name: this.company,
        employment_type: this.employmentType,
        start_date: this.startDate,
        end_date: this.endDate,
        city: this.city,
        country: this.country,
        note: this.description,
        current_role: this.currentRole,

        text1: this.numChildren,
        text2: this.ageChildren,
        text3: this.years,
        text4: this.frequency
      }).then(function (res) {
        console.log(res);
        _this3.hideExperienceModal();
        _this3.getExperiences();
      }).catch(function (error) {
        console.log(error);
      });
    },
    showDeleteExperienceModal: function showDeleteExperienceModal() {
      this.$modal.show('delete-experience-modal');
    },
    deleteExperience: function deleteExperience(experience) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/experiences/' + experience.id.toString() + '/').then(function (res) {
        console.log(res);
        _this4.getExperiences();
        _this4.hideExperienceModal();
        _this4.$modal.hide('delete-experience-modal');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      notes: ''
    };
  },
  created: function created() {
    this.notes = this.user.text15;
  },

  methods: {
    update: function update() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        text15: this.notes
      }).then(function (res) {
        _this.$emit('infoSaved');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8354604e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(713);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8354604e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      rating: '',
      ratingOptions: ['5', '4', '3', '2', '1'],
      body: ''
    };
  },

  methods: {
    submitFeedback: function submitFeedback() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/feedback/', {
        user: this.user.id,
        body: this.body,
        rating: this.rating,
        giver_name: this.user.first_name + ' ' + this.user.last_name,
        giver_email: this.user.email,
        is_candidate: this.$store.getters.isCandidate,
        is_employer: this.$store.getters.isEmployer,
        is_agent: this.$store.getters.isAgent,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        _this.$modal.show('feedback-submitted-modal');

        _this.$store.dispatch("sendEmails", {
          subject: "FEEDBACK " + (' ' + _this.$store.getters.agencyName),
          message: "Feedback: " + ('' + _this.body) + "\n\nRating: " + ('' + _this.rating) + "\n\n" + ('Agency: ' + _this.$store.getters.agencyName + ' \nName: ' + _this.user.first_name + ' ' + _this.user.last_name + ' \nCandidate? ' + _this.$store.getters.isCandidate + ' Client? ' + _this.$store.getters.isEmployer + ' \nEmail: ' + _this.user.email),
          from: 'feedback@enginehire.io',
          emails: [_this.$store.getters.enginehireLoggingEmail, _this.$store.getters.enginehireAdminEmail, 'amisra26@gmail.com'],
          reply: _this.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4
        });

        _this.body = '';
        _this.rating = '';
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      jobs: [],
      job: {},
      notes: '',

      currentTime: new Date() // https://stackoverflow.com/questions/57249466/getting-current-time-and-date-in-vue-js
    };
  },
  created: function created() {
    this.getJobs();

    setInterval(this.getCurrentTime, 1000); // Keep updating the current time every second
  },

  methods: {
    getJobs: function getJobs() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?agency=' + this.$store.getters.agencyID + '&filler=' + this.user.id).then(function (res) {
        console.log(res);
        _this.jobs = res.data;

        // this.calendarJobs = []
        // for (var job in this.jobs) {
        //   console.log('dsgjaklsjl;kds')
        //   // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
        //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
        // }
      }).catch(function (error) {
        console.log(error);
      });
    },
    showClockInModal: function showClockInModal(job) {
      this.job = job;
      this.$modal.show('clockin-modal');
    },
    clockin: function clockin() {
      var _this2 = this;

      var now = new Date();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + this.job.id + '/', {
        actual_start_time: now.getHours().toString() + ":" + now.getMinutes().toString() + ":00",
        status: "In Progress",
        text3: this.notes
      }).then(function (res) {
        _this2.getJobs();
        _this2.$modal.hide('clockin-modal');
        _this2.$modal.show('successful-clockin-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showClockOutModal: function showClockOutModal(job) {
      this.job = job;
      this.notes = job.notes;
      this.$modal.show('clockout-modal');
    },
    clockout: function clockout() {
      var _this3 = this;

      var now = new Date();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + this.job.id + '/', {
        actual_end_time: now.getHours().toString() + ":" + now.getMinutes().toString() + ":00",
        status: "Completed",
        text3: this.notes
      }).then(function (res) {
        _this3.getJobs();
        _this3.$modal.hide('clockout-modal');
        _this3.$modal.show('successful-clockout-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getCurrentTime: function getCurrentTime() {
      // https://stackoverflow.com/questions/57249466/getting-current-time-and-date-in-vue-js
      this.currentTime = new Date();
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBoard_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95fd0d68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBoard_vue__ = __webpack_require__(728);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95fd0d68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__employers_jobs_JobList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_MapBoard__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Job__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_calendar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_simple_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(93);

// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      jobsLongTerm: [],

      jobs: [],
      calendarJobs: [],
      job: {},
      jobPoster: {},
      showDate: new Date(),
      selectedDateObj: {}
    };
  },

  components: {
    appJobList: __WEBPACK_IMPORTED_MODULE_1__employers_jobs_JobList__["a" /* default */],
    appMapBoard: __WEBPACK_IMPORTED_MODULE_2__global_MapBoard__["a" /* default */],
    CalendarView: __WEBPACK_IMPORTED_MODULE_4_vue_simple_calendar__["CalendarView"],
    CalendarViewHeader: __WEBPACK_IMPORTED_MODULE_4_vue_simple_calendar__["CalendarViewHeader"],
    Job: __WEBPACK_IMPORTED_MODULE_3__Job__["a" /* default */]
  },
  created: function created() {
    // console.log('Job Board Created')
    this.getJobs();

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
    }, 3500);

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },

  // mounted() {
  //   document.title = this.$refs.pageTitle.innerHTML
  // },
  methods: {
    getJobs: function getJobs() {
      var _this = this;

      // Long Term Jobs
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?job_type=Long Term&agency=' + this.$store.getters.agencyID).then(function (res) {
        _this.jobsLongTerm = res.data;
        _this.jobsLongTerm = _this.jobsLongTerm.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        });

        // Only want to show jobs where the application deadline hasn't passed
        var activePostings = [];
        var rightNow = new Date();
        for (var job in _this.jobsLongTerm) {
          // if (this.jobs[job].application_deadline) {
          // if (((new Date(this.jobs[job].application_deadline)) >= rightNow) && this.jobs[job].status !== 'draft') {
          if (_this.jobsLongTerm[job].status != 'Closed') {
            activePostings.push(_this.jobsLongTerm[job]);
          }
          // }
        }
        _this.jobsLongTerm = activePostings;

        // console.log(this.jobs)
      }).catch(function (error) {
        return console.log(error);
      });

      // Short term calendar jobs
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?job_type=Short Term&agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res);
        _this.jobs = res.data;
        _this.jobs = _this.jobs.sort(function (a, b) {
          return a.date < b.date ? 1 : -1;
        });

        _this.calendarJobs = [];

        for (var job in _this.jobs) {
          // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
          // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})

          // if (!(this.filterFamilyOptions.includes(this.jobs[job].poster_name))){
          //   this.filterFamilyOptions.push(this.jobs[job].poster_name)
          // }
          // this.filterFamilyOptions= this.filterFamilyOptions.sort()

          // If the job is filled, get the candidate who is filling the job
          // let candidate = null
          // if (this.jobs[job].filler) {
          //   candidate = this.candidates.filter(element => {
          //     return element.id == this.jobs[job].filler;
          //   })[0];
          // }

          if (_this.jobs[job].status == 'Requested') {
            _this.calendarJobs.push({ 'id': _this.jobs[job].id, 'startDate': _this.jobs[job].date + ' ' + _this.jobs[job].start_time, 'endDate': _this.jobs[job].date + ' ' + _this.jobs[job].end_time, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': _this.jobs[job].poster_name + ' ' + _this.djangotimeformatAMPM(_this.jobs[job].start_time) + ' - ' + _this.djangotimeformatAMPM(_this.jobs[job].end_time) });
          } else if (_this.jobs[job].status == 'Pending') {
            _this.calendarJobs.push({ 'id': _this.jobs[job].id, 'startDate': _this.jobs[job].date + ' ' + _this.jobs[job].start_time, 'endDate': _this.jobs[job].date + ' ' + _this.jobs[job].end_time, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': _this.jobs[job].poster_name + ' ' + _this.djangotimeformatAMPM(_this.jobs[job].start_time) + ' - ' + _this.djangotimeformatAMPM(_this.jobs[job].end_time) });
          }
          // else if (this.jobs[job].status == 'Assigned') {
          //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; ', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})
          //   // let candidate = this.candidates.filter(element => {
          //   //   return element.id == this.jobs[job].filler;
          //   // })[0];
          //   // console.log(candidate)
          //   // console.log(this.candidates.indexOf(candidate))
          //   // console.log(this.candidates[this.candidates.indexOf(candidate)])
          //   this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; ', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          // }
          // else if (this.jobs[job].status == 'In Progress') {
          //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})
          //   // let candidate = this.candidates.filter(element => {
          //   //   return element.id == this.jobs[job].filler;
          //   // })[0];
          //   this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          // }
          // else if (this.jobs[job].status == 'Completed') {
          //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})

          //   this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          // }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setShowDate: function setShowDate(d) {
      this.showDate = d;
    },
    onClickDate: function onClickDate(d) {
      console.log('date clicked');
      console.log(d);
      this.selectedDate = d;

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    getJobPoster: function getJobPoster() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + this.job.poster).then(function (res) {
        _this2.jobPoster = res.data[0];
      }).catch(function (error) {
        return console.log(error);
      });
    },
    onClickEvent: function onClickEvent(event) {
      var _this3 = this;

      // console.log(event)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?id=' + event.id).then(function (res) {
        // console.log(res)
        _this3.job = res.data[0];
        _this3.job.date = _this3.addCurrentTimeToDate(_this3.job.date);
        _this3.status = _this3.job.status;

        // this.getApplications(this.job)
        // axios.get(`/api/jobapplications/?job=${this.job.id}`)
        //   .then(res => {
        //     console.log(res)
        //     this.applications = res.data

        //     this.$modal.show('job-modal')
        //   })
        //   .catch(error => console.log(error))
        _this3.getJobPoster();
        _this3.$modal.show('job-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobList_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e373e0e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobList_vue__ = __webpack_require__(720);
function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e373e0e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JobForm__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['posterID', 'jobs'],
  data: function data() {
    return {
      // jobs: [],
      loggedinUser: null,

      jobTypeOptions: [],
      typeFilters: [],
      skillsOptions: [],
      skillsFilters: [],
      focusAreaFilters: [],
      focusAreaOptions: [],
      countryFilters: [],
      countries: []
    };
  },

  components: {
    appJobEdit: __WEBPACK_IMPORTED_MODULE_2__JobForm__["a" /* default */]
  },
  computed: {
    filteredJobs: function filteredJobs() {
      var typeFilteredJobs = [];
      if (this.typeFilters.length > 0) {
        for (var job in this.jobs) {
          if (this.typeFilters.includes(this.jobs[job].job_type)) {
            typeFilteredJobs.push(this.jobs[job]);
          }
        }
      } else {
        typeFilteredJobs = this.jobs;
      }

      var countryFilteredJobs = [];
      if (this.countryFilters.length > 0) {
        for (var job in typeFilteredJobs) {
          if (this.countryFilters.includes(typeFilteredJobs[job].country)) {
            countryFilteredJobs.push(typeFilteredJobs[job]);
          }
        }
      } else {
        countryFilteredJobs = typeFilteredJobs;
      }

      var skillsFilteredJobs = [];
      if (this.skillsFilters.length > 0) {
        for (var job in countryFilteredJobs) {
          // if (this.skillsFilters.every(val => countryFilteredJobs[job].skills.includes(val))) {
          //   skillsFilteredJobs.push(countryFilteredJobs[job])
          // }
          for (var skill in this.skillsFilters) {
            if (countryFilteredJobs[job].skills.includes(this.skillsFilters[skill])) {
              skillsFilteredJobs.push(countryFilteredJobs[job]);
              break;
            }
          }
        }
      } else {
        skillsFilteredJobs = countryFilteredJobs;
      }

      var focusAreaFilteredJobs = [];
      if (this.focusAreaFilters.length > 0) {
        for (var job in skillsFilteredJobs) {
          for (var focusArea in this.focusAreaFilters) {
            if (skillsFilteredJobs[job].skills2.includes(this.focusAreaFilters[focusArea])) {
              focusAreaFilteredJobs.push(skillsFilteredJobs[job]);
              break;
            }
          }
        }
      } else {
        focusAreaFilteredJobs = skillsFilteredJobs;
      }

      return focusAreaFilteredJobs;
    }
  },
  created: function created() {
    this.loggedinUser = this.$store.getters.userID;
    // this.getJobs()

    // // https://www.npmjs.com/package/vue-loading-overlay
    // let loader = this.$loading.show({
    //   // Optional parameters
    //   container: this.fullPage ? null : this.$refs.formContainer,
    //   // container: this.$refs.formContainer,
    //   // canCancel: true,
    //   canCancel: false,
    //   // onCancel: this.onCancel,
    // });
    // // simulate AJAX
    // setTimeout(() => {
    //   loader.hide()
    // },2000)

    this.jobTypeOptions = this.$store.getters.jobTypes;
    this.skillsOptions = this.$store.getters.skills;
    this.countries = this.$store.getters.countries;
    this.focusAreaOptions = this.$store.getters.focusAreas;

    if (this.$route.params.type && this.$route.params.type != 'All Job Types') {
      this.typeFilters.push(this.$route.params.type);
    }
    if (this.$route.params.country && this.$route.params.country != 'All Countries') {
      this.countryFilters.push(this.$route.params.country);
    }
    if (this.$route.params.topic && this.$route.params.topic != 'All Topic Areas') {
      this.focusAreaFilters.push(this.$route.params.topic);
    }
  },

  methods: {
    // getJobs() {
    //   if (this.posterID) {
    //     axios.get('/api/jobs?poster='.concat(this.posterID))
    //       .then(res => {
    //         this.jobs = res.data
    //       })
    //       .catch(error => console.log(error))
    //   }
    //   else {
    //     axios.get('/api/jobs/?agency=4')
    //       .then(res => {
    //         this.jobs = res.data
    //       })
    //       .catch(error => console.log(error))
    //   }
    // },
    showJob: function showJob(jobID) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: 'Job', params: { id: jobID } });
    },
    editJob: function editJob(job) {
      console.log('Edit Job Icon Clicked');
      this.$emit('editJob', job); // Lecture 112
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // Validators pre built into vuelidate - lecture 373
 // https://www.npmjs.com/package/vuejs-datepicker

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['userID'],
  props: ['userID', 'jobID'],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_3_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_3_tiptap__["c" /* EditorMenuBar */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      user: {},

      title: '',
      description: '',
      descriptionEditor: null,
      status: '',
      skills: [],
      skillsOptions: [],
      jobType: '',
      jobTypeOptions: [],
      compensation: '',
      compensationType: '',
      compensationTypeOptions: [],
      focusAreas: [],
      focusAreaOptions: [],
      applicationDeadline: null,
      applicationLink: '',

      city: '',
      provinceState: '',
      country: '',
      countries: [],
      address1: '',
      address2: '',
      postalCode: '',

      // jobID: null,
      jobToEdit: {}
    };
  },

  validations: {
    title: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  },
  created: function created() {
    this.getUser();

    this.skillsOptions = this.$store.getters.skills;
    this.jobTypeOptions = this.$store.getters.jobTypes;
    this.compensationTypeOptions = this.$store.getters.compensationTypes;
    this.countries = this.$store.getters.countries;
    this.focusAreaOptions = this.$store.getters.focusAreas;
    this.salaryRangeOptions = this.$store.getters.salaryRanges;

    // this is for a unique route for editing a job /edit-job/id
    if (this.$route.params.id) {
      this.jobID = this.$route.params.id;
    }

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_3_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '\
<h4>Summary</h4><p></p><hr>\
<h4>Roles and Responsibilities</h4><p></p><hr>\
<h4>Required Qualifications</h4><p></p><hr>\
<h4>Preferred Qualifications</h4><p></p><hr>\
<h4>Additional Information</h4><p></p>',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.description = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
  },

  methods: {
    getUser: function getUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id='.concat(this.userID)).then(function (res) {
        // console.log(res)
        _this2.user = res.data[0];

        _this2.address1 = _this2.user.address1;
        _this2.address2 = _this2.user.address2;
        _this2.postalCode = _this2.user.postal_code;
        _this2.city = _this2.user.city;
        _this2.provinceState = _this2.user.provincestate;
        _this2.country = _this2.user.country;

        // If jobID is not null, that means we are editing an existing job
        if (_this2.jobID) {
          console.log('Editing Job');
          console.log(_this2.jobID);
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?id='.concat(_this2.jobID.toString())).then(function (res) {
            console.log(res.data[0]);
            _this2.jobToEdit = res.data[0];

            _this2.title = _this2.jobToEdit.title;
            _this2.status = _this2.jobToEdit.status;
            _this2.descriptionEditor.setContent(_this2.jobToEdit.description);
            _this2.description = _this2.jobToEdit.description;
            _this2.skills = _this2.jobToEdit.skills;
            _this2.focusAreas = _this2.jobToEdit.skills2;
            _this2.jobType = _this2.jobToEdit.job_type;
            _this2.compensationType = _this2.jobToEdit.compensation_type;
            _this2.compensation = _this2.jobToEdit.compensation;
            _this2.applicationDeadline = _this2.jobToEdit.application_deadline;
            _this2.applicationLink = _this2.jobToEdit.link;

            _this2.address1 = _this2.jobToEdit.address1;
            _this2.address2 = _this2.jobToEdit.address2;
            _this2.postalCode = _this2.jobToEdit.postal_code;
            _this2.city = _this2.jobToEdit.city;
            _this2.provinceState = _this2.jobToEdit.provincestate;
            _this2.country = _this2.jobToEdit.country;
          }).catch(function (error) {
            return console.log(error);
          });
        } else {
          // If we are posting a new job, want to automatically set the application deadline to 6 weeks in the future
          var numWeeks = 6;
          _this2.applicationDeadline = new Date();
          _this2.applicationDeadline = _this2.applicationDeadline.setDate(_this2.applicationDeadline.getDate() + numWeeks * 7); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
          // The above produces a date in the format 1588691516867, but that can't be written to the database, need a date like Tue May 05 2020 11:11:56 GMT-0400 (Eastern Daylight Time)
          _this2.applicationDeadline = new Date(_this2.applicationDeadline);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    post: function post(val) {
      var _this3 = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2500);

      // Need to strip the compensation down to only numbers?
      // Will the application deadline work directly?

      console.log(this.userID);
      console.log(this.user.employer_name);
      console.log(this.title);
      console.log(this.status);
      console.log(this.description);
      console.log(this.skills);
      console.log(this.jobType);
      console.log(this.compensationType);
      console.log(this.compensation);
      console.log(this.applicationDeadline);
      console.log(this.applicationLink);
      console.log(this.address1);
      console.log(this.address2);
      console.log(this.postalCode);
      console.log(this.city);
      console.log(this.provinceState);
      console.log(this.country);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/jobs/', {
        poster: this.userID,
        poster_name: this.user.employer_name,
        status: val,
        title: this.title,
        description: this.description,
        skills: this.skills,
        skills2: this.focusAreas,
        job_type: this.jobType,
        compensation_type: this.compensationType,
        compensation: this.compensation,
        salaryRangeOptions: [],
        application_deadline: this.applicationDeadline,
        link: this.applicationLink,

        address1: this.address1,
        address2: this.address2,
        postal_code: this.postalCode,
        city: this.city,
        provincestate: this.provinceState,
        country: this.country,

        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      }).then(function (res) {
        console.log(res);

        // broadcast to the parent compoenent that a job has been posted
        // this.$emit('jobPosted', true) // Lecture 112
        _this3.$emit('jobPosted'); // Lecture 112

        if (_this3.status === 'live') {
          _this3.sendEmail();
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    update: function update(val) {
      var _this4 = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2500);

      // Changes a 'draft' post to a live one by updating the status
      if (val === 'live') {
        this.status = val;
        this.sendEmail();
      }

      // Need to strip the compensation down to only numbers?
      // Will the application deadline work directly?

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/'.concat(this.jobID.toString()).concat('/'), {
        // poster: this.userID,
        // poster_name: this.user.employer_name,
        status: this.status,
        title: this.title,
        description: this.description,
        skills: this.skills,
        skills2: this.focusAreas,
        job_type: this.jobType,
        compensation_type: this.compensationType,
        compensation: this.compensation,
        application_deadline: this.applicationDeadline,
        link: this.applicationLink,

        address1: this.address1,
        address2: this.address2,
        postal_code: this.postalCode,
        city: this.city,
        provincestate: this.provinceState,
        country: this.country
      }).then(function (res) {
        console.log(res);

        // broadcast to the parent compoenent that a job has been posted
        // this.$emit('jobPosted', true) // Lecture 112
        _this4.$emit('jobUpdated'); // Lecture 112
      }).catch(function (error) {
        return console.log(error);
      });
    },
    sendEmail: function sendEmail() {
      // Email to inform Hayley and I of new job posts
      // this.$store.dispatch('sendEmail',
      //   {
      //     subject: 'New Job Post!',
      //     message: 'New job posted with the title: '+this.title+'\nOrganization: '+this.user.employer_name,
      //     // from: 'info@thrivehire.co',
      //     from: 'info@thrivehire.co',
      //     // email: 'aakash@enginehire.ca',
      //     email: 'info@thrivehire.org',
      //     reply: 'info@thrivehire.co',
      //     // userID: this.aakashid,
      //     userID: this.$store.getters.agencyID
      //   }
      // )
      this.$store.dispatch('sendEmail', {
        subject: 'New Job Post!',
        message: 'New job posted with the title: ' + this.title + '\nOrganization: ' + this.user.employer_name,
        // from: 'info@thrivehire.co',
        from: 'info@thrivehire.co',
        email: 'aakash@enginehire.ca',
        reply: 'info@thrivehire.co',
        // userID: this.aakashid,
        userID: this.$store.getters.agencyID
      });
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_gmaps__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__google_markerclusterer__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__google_markerclusterer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__google_markerclusterer__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items'],
  data: function data() {
    return {
      itemLocations: [],
      google: null,
      geoencoder: null,
      map: null
    };
  },


  // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var marker1;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_0__utils_gmaps__["a" /* default */])();

            case 3:
              _this.google = _context.sent;

              _this.geocoder = new _this.google.maps.Geocoder();
              // const map = new google.maps.Map(document.getElementById('map'), {
              //   // zoom: 12,
              //   zoom: 3,
              //   // center: {lat: 52.520, lng: 13.410}
              //   center: {lat: 15.0, lng: 0.0}
              // });
              _this.map = new _this.google.maps.Map(document.getElementById('map'), {
                zoom: 2,
                center: { lat: 15.0, lng: 0.0 }
              });

              _this.getLocations();

              _this.geocoder.geocode({ address: 'Austria' }, function (results, status) {

                // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
                if (status !== 'OK' || !results[0]) {
                  console.log('Error with geoencoder');
                  throw new Error(status);
                } else {
                  console.log('geoencoded fine');
                }

                // map.setCenter(results[0].geometry.location);
                // map.fitBounds(results[0].geometry.viewport);
              });

              // for (var item in this.items) {

              //   // https://developers.google.com/maps/documentation/geocoding/intro
              //   // https://developers.google.com/maps/faq#geocoder_queryformat
              //   // if (this.items[item].address1 && this.items[item].city && this.items[item].country) {
              //   if (this.items[item].city && this.items[item].country && item < 4) {
              //     console.log(this.items[item].city)
              //     console.log('Trying marker')
              //     // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
              //     geocoder.geocode({ address: this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
              //       if (status !== 'OK' || !results[0]) {
              //         console.log('Error with address geoencoder')
              //         throw new Error(status);
              //       }
              //       else {
              //         console.log('Got marker')
              //         console.log(results[0].geometry.location)
              //         // console.log(results[0].geometry.location.lat)
              //         this.itemLocations.push({position: results[0].geometry.location})
              //       }
              //     });
              //   } else {
              //     // console.log('No proper address')
              //   }
              // }

              // // this.itemLocations = [
              // //   {
              // //     position: new google.maps.LatLng(13.524834, 2.109823),
              // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png',
              // //   },
              // //   {
              // //     position: new google.maps.LatLng(49.884017, -97.168579),
              // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
              // //   },
              // //   {
              // //     position: new google.maps.LatLng(45.421106, -75.690308),
              // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
              // //   },
              // //   // {
              // //   //   position: new google.maps.LatLng(45.421106, -75.690308),
              // //   //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
              // //   // },
              // //   {
              // //     position: new google.maps.LatLng(41.5050175, -73.0682531),
              // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
              // //   }
              // // ]

              // console.log('Creating markers')
              // // https://developers.google.com/maps/documentation/javascript/custom-markers
              // var markers = this.itemLocations.map(function(itemLocation) {
              //   // return new google.maps.Marker({
              //   var marker = new google.maps.Marker({
              //     position: itemLocation.position,
              //     // position: new google.maps.LatLng(itemLocation.position),
              //     // position: new google.maps.LatLng(13.524834, 2.109823),
              //     // label: labels[i % labels.length]
              //     // icon: jobListing.icon,
              //     // title: 'test'
              //   });
              //   // marker.addListener('click', function() {
              //   //   // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
              //   //   markerClickHandler(marker);
              //   // });
              //   return marker;
              // });

              // new MarkerClusterer(map, markers, {
              //   imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
              // });

              marker1 = new _this.google.maps.Marker({
                // position: results[0].geometry.location,
                position: new _this.google.maps.LatLng(49.884017, -97.168579),
                // label: labels[i % labels.length]
                // icon: jobListing.icon,
                // title: 'test'
                map: _this.map
              });
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

              console.log('Error with map');
              console.error(_context.t0);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 11]]);
    }))();
  },

  methods: {
    getLocations: function getLocations() {
      var _this2 = this;

      // let google = await gmapsInit();
      // let geocoder = new google.maps.Geocoder();

      for (var item in this.items) {
        // console.log(this.items[item].city)

        // https://developers.google.com/maps/documentation/geocoding/intro
        // https://developers.google.com/maps/faq#geocoder_queryformat
        // if (this.items[item].address1 && this.items[item].city && this.items[item].country) {
        if (this.items[item].city && this.items[item].country && item < 4) {
          console.log('Trying marker');
          // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
          this.geocoder.geocode({ address: this.items[item].city + ', ' + this.items[item].country }, function (results, status) {
            if (status !== 'OK' || !results[0]) {
              console.log('Error with address geoencoder');
              throw new Error(status);
            } else {
              console.log('Got marker');
              console.log(results[0].geometry.location);
              _this2.itemLocations.push({ position: results[0].geometry.location });
              if (_this2.itemLocations.length == 4) {
                // this.addMarkers()
              }
            }
          });
        } else {
          console.log('No proper address');
        }
      }
      // this.addMarkers()
    },
    addMarkers: function addMarkers() {
      // if (this.itemLocations.length > 0) {

      var marker2 = new this.google.maps.Marker({
        // position: results[0].geometry.location,
        // position: new this.google.maps.LatLng(19.884017, -97.168579),
        position: this.itemLocations[0].position,
        // label: labels[i % labels.length]
        // icon: jobListing.icon,
        // title: 'test'
        map: this.map
      });
      var marker3 = new this.google.maps.Marker({
        // position: results[0].geometry.location,
        // position: new this.google.maps.LatLng(19.884017, -97.168579),
        position: this.itemLocations[2].position,
        // label: labels[i % labels.length]
        // icon: jobListing.icon,
        // title: 'test'
        map: this.map
      });

      console.log('Adding markers');
      console.log(this.itemLocations);
      console.log(this.itemLocations[0]);
      console.log(this.itemLocations[0].position);

      // console.log('Creating markers')
      // // https://developers.google.com/maps/documentation/javascript/custom-markers
      // var markers = this.itemLocations.map(function(itemLocation) {
      //   // return new google.maps.Marker({
      //   var marker = new this.google.maps.Marker({
      //     // position: itemLocation.position,
      //     // position: new google.maps.LatLng(itemLocation.position),
      //     position: new this.google.maps.LatLng(13.524834, 2.109823),
      //     // label: labels[i % labels.length]
      //     // icon: jobListing.icon,
      //     // title: 'test'
      //   });
      //   // marker.addListener('click', function() {
      //   //   // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
      //   //   markerClickHandler(marker);
      //   // });
      //   return marker;
      // });

      // new MarkerClusterer(this.map, markers, {
      //   imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      // });

      // }
    }
  },
  computed: {
    showMarkers: function showMarkers() {

      // if (this.itemLocations) {
      //   // https://developers.google.com/maps/documentation/javascript/custom-markers
      //   var markers = this.itemLocations.map(function(itemLocation) {
      //     // return new google.maps.Marker({
      //     var marker = new this.google.maps.Marker({
      //       // position: itemLocation.position,
      //       // position: new google.maps.LatLng(itemLocation.position),
      //       position: new this.google.maps.LatLng(13.524834, 2.109823),
      //       // label: labels[i % labels.length]
      //       // icon: jobListing.icon,
      //       // title: 'test'
      //     });
      //     // marker.addListener('click', function() {
      //     //   // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
      //     //   markerClickHandler(marker);
      //     // });
      //     return marker;
      //   });

      //   new MarkerClusterer(this.map, markers, {
      //     imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      //   });
      // }
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Job_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65deb0b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Job_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(723)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Job_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65deb0b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Job_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Map_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['passedID'],
  data: function data() {
    return {
      jobID: null,
      job: {},
      publicEmployer: {},
      employer: {},
      // loggedinUser: null,
      loggedinUser: {},
      jobTitle: '',
      application: {},

      status: '',

      timeToLoad: false
    };
  },

  components: {
    appMap: __WEBPACK_IMPORTED_MODULE_2__global_Map_vue__["a" /* default */]
  },
  computed: {
    fullAccess: function fullAccess() {
      if (this.$store.getters.userID == this.job.filler || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    if (this.passedID) {
      this.jobID = this.passedID;
    } else {
      this.jobID = this.$route.params.id;
    }

    // this.loggedinUser = this.$store.getters.userID
    if (this.$store.getters.userID) {
      this.getLoggedinUser();
    }
    this.getJob();

    // If someone is logged in and is a candidate
    if (this.$store.getters.isCandidate === true) {
      this.getApplication();
    }

    // // https://www.npmjs.com/package/vue-loading-overlay
    // let loader = this.$loading.show({
    //   // Optional parameters
    //   container: this.fullPage ? null : this.$refs.formContainer,
    //   // container: this.$refs.formContainer,
    //   // canCancel: true,
    //   canCancel: false,
    //   // onCancel: this.onCancel,
    // });
    // // simulate AJAX
    // setTimeout(() => {
    //   loader.hide()
    //   this.timeToLoad = true
    // },2000)
  },

  methods: {
    getJob: function getJob() {
      var _this = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
        _this.timeToLoad = true;
      }, 3000);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?id='.concat(this.jobID.toString())).then(function (res) {
        console.log(res.data);
        _this.job = res.data[0];

        // console.log(this.job.title.concat(" (Draft)"))
        // this.job.title.concat(" (Draft)")

        //Changes page title to match job title
        // document.title = this.job.title

        //Updates the URL to show the job posting company and job title
        // this.$router.replace({ name: 'Job', params: {id: this.jobID.toString()}, query: {title: this.job.poster_name.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,' ').split(/\s+/).join('-').concat('-'+this.job.title.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,' ').split(/\s+/).join('-'))} })

        // axios.get('/api/people/'.concat(this.job.poster.toString()))
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicemployers/'.concat(_this.job.poster.toString())).then(function (res) {
          // console.log(this.job.title.concat(" (Draft)"))
          // this.job.title.concat(' (Draft)')
          console.log(res.data);
          _this.publicEmployer = res.data;
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getApplication: function getApplication() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobapplications/?job=' + this.jobID + '&applicant=' + this.$store.getters.userID).then(function (res) {
        if (res.data.length) {
          _this2.application = res.data[0];
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getLoggedinUser: function getLoggedinUser() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + this.$store.getters.userID).then(function (res) {
        _this3.loggedinUser = res.data[0];
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setApplicationStatus: function setApplicationStatus(status) {
      this.submitApplication(status);

      // // axios.patch(`/api/jobapplications/${this.application.id}/`, {
      // //   status: status,
      // // })
      // axios.post(`/api/jobapplications/`, {
      //   applicant: this.loggedinUser.id,
      //   applicant_name: `${this.loggedinUser.first_name} ${this.loggedinUser.last_name}`,
      //   job: this.job.id,
      //   job_title: this.job.title,
      //   status: status,
      //   agency_owner: this.$store.getters.agencyName,
      //   agency: this.$store.getters.agencyID,
      // })
      //   .then(res => {
      //     // console.log(res)
      //     this.getApplication()
      //     this.status = status
      //     this.$modal.show('application-status-updated-modal')

      //     this.$store.dispatch('sendEmails',
      //       {
      //         subject: `${this.job.title} - ${this.loggedinUser.first_name} (${status})`,
      //         message: '<p>Hello,' + '</p>' +
      //         `<p>New application submitted.</p>` +
      //         `<p>Job: ${this.job.title}</p>` +
      //         `<p>Nanny: ${this.loggedinUser.first_name} ${this.loggedinUser.last_name}</p>` +
      //         `<p style="color: #e70d7b;"><strong>Status: ${status}</strong></p>`,
      //         from: this.$store.getters.agencyFromEmail,
      //         emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
      //         reply: this.$store.getters.agencyReplyEmail,
      //         userID: 4,
      //         html: true,
      //       }
      //     )

      //     this.$store.dispatch('sendEmails',
      //       {
      //         subject: `Application Received for ${this.job.title}`,
      //         message: '<p>Hi ' + this.loggedinUser.first_name + ',</p>' +
      //         `<p>Thanks for your interest in the job: ${this.job.title}</p>` +
      //         `<p>We will be in touch if the family would like to meet with you! If you don’t hear from us, don’t get discouraged, just keep applying!</p>`,
      //         from: this.$store.getters.agencyFromEmail,
      //         emails: [this.$store.getters.enginehireLoggingEmail, this.loggedinUser.email],
      //         reply: this.$store.getters.agencyReplyEmail,
      //         userID: this.loggedinUser.id,
      //         html: true,
      //       }
      //     )

      //     // Increment the count on the number of declines or maybes
      //     // let statsArray = this.loggedinUser.numberArray
      //     // if (status == 'Not Interested') {
      //     //   statsArray[2] += 1
      //     // }
      //     // else if (status == 'Maybe') {
      //     //   statsArray[3] += 1
      //     // }
      //     // axios.patch(`/api/people/${this.loggedinUser.id}/`, {
      //     //   numberArray: statsArray
      //     // })
      //     //   .catch(error => console.log(error))
      //   })
      //   .catch(error => console.log(error))
    },
    submitApplication: function submitApplication(status) {
      var _this4 = this;

      ///
      /// Submitting an application for a long term job
      ///
      // axios.patch(`/api/jobapplications/${this.application.id}/`, {
      //   status: status,
      // })
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/jobapplications/', {
        applicant: this.loggedinUser.id,
        applicant_name: this.loggedinUser.first_name + ' ' + this.loggedinUser.last_name,
        job: this.job.id,
        job_title: this.job.title,
        status: status,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        // console.log(res)
        _this4.getApplication();
        _this4.$modal.show('application-status-updated-modal');

        if (status == 'Interested') {
          _this4.$store.dispatch('sendEmails', {
            subject: _this4.job.poster_name + ' ' + _this4.job.title + ' ' + new Date(_this4.addCurrentTimeToDate(_this4.job.date)).toDateString() + ' - ' + _this4.loggedinUser.first_name + ' (' + status + ')',
            message: 'Hello,' + '\n\n' + 'New application submitted.\n' + ('Client: ' + _this4.job.poster_name + '\n') + ('Job: ' + _this4.job.title + '\n') + ('Date: ' + new Date(_this4.addCurrentTimeToDate(_this4.job.date)).toDateString() + '\n') + ('Nanny: ' + _this4.loggedinUser.first_name + ' ' + _this4.loggedinUser.last_name + '\n') + ('Status: ' + status),
            from: _this4.$store.getters.agencyFromEmail,
            emails: [_this4.$store.getters.enginehireLoggingEmail, _this4.$store.getters.agencyAdminEmail2],
            reply: _this4.$store.getters.agencyReplyEmail,
            userID: 4
          });
        }

        // Increment the count on the number of declines or maybes
        // let statsArray = this.loggedinUser.numberArray
        // if (status == 'Not Interested') {
        //   statsArray[2] += 1
        // }
        // else if (status == 'Maybe') {
        //   statsArray[3] += 1
        // }
        // axios.patch(`/api/people/${this.loggedinUser.id}/`, {
        //   numberArray: statsArray
        // })
        //   .catch(error => console.log(error))
      }).catch(function (error) {
        return console.log(error);
      });
    },
    acceptJob: function acceptJob() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobapplications/' + this.application.id + '/', {
        status: 'Accepted'
      }).then(function (res) {
        _this5.getApplication();
        _this5.$modal.show('job-accepted-modal');
      }).catch(function (error) {
        return console.log(error);
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + this.jobID + '/', {
        status: 'Approved',
        filled: true,
        filler: this.$store.getters.userID,
        filler_name: this.application.applicant_name,
        filled_date: new Date()
      }).then(function (res) {
        _this5.getJob();
      }).catch(function (error) {
        return console.log(error);
      });

      // Increment the count on the number of acceptances
      var statsArray = this.loggedinUser.numberArray;
      statsArray[1] += 1;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.loggedinUser.id + '/', {
        numberArray: statsArray
      }).catch(function (error) {
        return console.log(error);
      });
    },
    deleteJob: function deleteJob() {
      // router.replace({name: 'Employer Dashboard'})
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/jobs/'.concat(this.jobID.toString()).concat('/')).then(function (res) {
        console.log(res);
        // router.replace('/organization')
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: 'Employer Dashboard' });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    broadcastJob: function broadcastJob() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?is_candidate=true&agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res);
        for (var user in res.data) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/optimum/message/", {
            message: 'New Afternoon Nanny opportunity available, please go to nannyagency.ca/job/1345 to learn more.',
            phone: res.data[user].phone,
            user_id: res.data[user].id
          });
        }
      });
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_gmaps__ = __webpack_require__(73);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['locationObject', 'accessLevel'],
  data: function data() {
    return {
      // google: null,
    };
  },


  // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var google, geocoder, map;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('ran');
              // console.log(this.user)
              // var mapExists = document.getElementById("map");
              // if (mapExists) {

              if (!_this.locationObject.city) {
                _context.next = 17;
                break;
              }

              console.log(_this.locationObject.city);
              _context.prev = 3;
              _context.next = 6;
              return Object(__WEBPACK_IMPORTED_MODULE_0__utils_gmaps__["a" /* default */])();

            case 6:
              google = _context.sent;
              geocoder = new google.maps.Geocoder();
              // const map = new google.maps.Map(document.getElementById('map'), {
              //   // zoom: 12,
              //   zoom: 3,
              //   // center: {lat: 52.520, lng: 13.410}
              //   center: {lat: 15.0, lng: 0.0}
              // });

              map = new google.maps.Map(document.getElementById('map'), {
                zoom: 13
              });

              // geocoder.geocode({ address: 'Austria' }, (results, status) => {

              geocoder.geocode({ address: _this.locationObject.address1 + ', ' + _this.locationObject.city + ', ' + _this.locationObject.country }, function (results, status) {
                if (status !== 'OK' || !results[0]) {
                  console.log('Error with geoencoder');
                  throw new Error(status);
                }

                map.setCenter(results[0].geometry.location);
                // map.fitBounds(results[0].geometry.viewport);
              });

              // var marker = new google.maps.Marker({
              //       // position: results[0].geometry.location,
              //       position: new google.maps.LatLng(49.884017, -97.168579),
              //       // label: labels[i % labels.length]
              //       // icon: jobListing.icon,
              //       // title: 'test'
              //       map: map
              //     });

              // https://developers.google.com/maps/documentation/geocoding/intro
              // https://developers.google.com/maps/faq#geocoder_queryformat
              // if (this.locationObject.address1 && this.locationObject.city && this.locationObject.country) {
              if (_this.accessLevel == 'full') {
                console.log('Trying marker');
                geocoder.geocode({ address: _this.locationObject.address1 + ', ' + _this.locationObject.city + ', ' + _this.locationObject.country }, function (results, status) {
                  if (status !== 'OK' || !results[0]) {
                    console.log('Error with address geoencoder');
                    throw new Error(status);
                  } else {
                    console.log('Got marker');
                    console.log(results[0].geometry.location);
                  }

                  var marker = new google.maps.Marker({
                    position: results[0].geometry.location,
                    // position: new google.maps.LatLng(49.884017, -97.168579),
                    // label: labels[i % labels.length]
                    // icon: jobListing.icon,
                    // title: 'test'
                    map: map
                  });
                });
              }

              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](3);

              console.log('Error with map');
              console.error(_context.t0);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 13]]);
    }))();
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FormGroupRowLayout__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialogs_ReferenceFormDialog__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_DetailSectionColumnLayout__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_custom_define_type__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormGroupRowLayout: __WEBPACK_IMPORTED_MODULE_1__common_FormGroupRowLayout__["a" /* default */],
    ReferenceFormDialog: __WEBPACK_IMPORTED_MODULE_2__dialogs_ReferenceFormDialog__["a" /* default */],
    DetailSectionColumnLayout: __WEBPACK_IMPORTED_MODULE_3__common_DetailSectionColumnLayout__["a" /* default */]
  },
  data: function data() {
    return {
      submitClicked: false,
      applicationData: {},
      isShowReferenceFormDialog: false,
      reference: {},
      listReferences: [],
      isAddReferenceDialog: false,
      resume: null,
      profilePic: null,
      numberSubmitSuccess: 0,
      indexOfEdittingRef: 0
    };
  },
  created: function created() {
    window.location.href = 'https://agency.enginehire.io/application-form/33/432';
  },

  methods: {
    showAddReferenceDialog: function showAddReferenceDialog() {
      this.isAddReferenceDialog = true;
      this.reference = {};
      this.isShowReferenceFormDialog = true;
    },
    showEditReferenceDialog: function showEditReferenceDialog(ref, index) {
      this.indexOfEdittingRef = index;
      this.isAddReferenceDialog = false;
      this.reference = _extends({}, ref);
      this.isShowReferenceFormDialog = true;
    },
    handleUpdateReferences: function handleUpdateReferences(actionType) {
      if (actionType === __WEBPACK_IMPORTED_MODULE_4__constants_custom_define_type__["a" /* ACTION_TYPE */].ADD) {
        this.listReferences.push(_extends({}, this.reference, { id: 0 }));
      } else if (actionType === __WEBPACK_IMPORTED_MODULE_4__constants_custom_define_type__["a" /* ACTION_TYPE */].UPDATE) {
        this.listReferences[this.indexOfEdittingRef] = this.reference;
      } else if (actionType === __WEBPACK_IMPORTED_MODULE_4__constants_custom_define_type__["a" /* ACTION_TYPE */].DELETE) {
        this.listReferences.splice(this.indexOfEdittingRef, 1);
      }
    },
    handleUploadResume: function handleUploadResume() {
      this.resume = this.$refs.resume.files[0];
      if (this.resume) {
        if (!this.$store.getters.acceptResumeType.includes(this.resume["type"])) {
          this.resume = null;
          this.$refs.resume.value = "";
          this.showErrorDialog(this.$store.getters.invalidResumeFileError);
        }
      }
    },
    handleUploadProfilePhoto: function handleUploadProfilePhoto() {
      this.profilePic = this.$refs.profile_pic.files[0];
      if (this.profilePic) {
        if (!this.$store.getters.acceptedImageTypes.includes(this.profilePic["type"])) {
          this.profilePic = null;
          this.$refs.profile_pic.value = "";
          this.showErrorDialog(this.$store.getters.invalidImageFileError);
        }
      }
    },
    submitApplication: function submitApplication() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.applicationData, this.$store.getters.candidatePersonalInfoListFields)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        window.scroll(0, 0); // Scroll the window up so they have to scroll down the application to see what's missing
      } else if (this.listReferences.length < 3) {
        this.showErrorDialog(this.$store.getters.missingReferenceError);
      } else if (this.resume == null) {
        this.showErrorDialog(this.$store.getters.missingResumeError);
      } else if (this.profilePic == null) {
        this.showErrorDialog(this.$store.getters.missingProfilePictureError);
      } else {
        this.registerUser();
      }
    },
    registerUser: function registerUser() {
      var _this = this;

      this.$store.dispatch("registerUser", {
        email: this.applicationData.email,
        password: this.applicationData.email,
        user_type: "candidate",
        status: "Applied",
        phone: this.applicationData.phone
      }).then(function () {
        _this.patchDetails();

        // Send myself an email notification that a new client started a quote
        _this.$store.dispatch("sendEmails", {
          subject: "New Nanny Application",
          message: "New nanny application form submitted by: " + _this.applicationData.first_name + " " + _this.applicationData.last_name + " | " + _this.applicationData.email + "\nPlease log into the administrator dashboard to view it!",
          from: _this.$store.getters.agencyFromEmail,
          emails: [_this.$store.getters.enginehireLoggingEmail, _this.$store.getters.agencyAdminEmail2],
          reply: _this.$store.getters.agencyReplyEmail,
          userID: 4
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    patchDetails: function patchDetails() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/" + this.$store.getters.userID.toString() + "/", this.applicationData).then(function (res) {
        console.log(res);
        _this2.showResultDialog(_this2.$store.getters.submitSuccess);
        _this2.uploadDocument();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this2.listReferences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ref = _step.value;

            _this2.postReference(ref);
          }

          // Send applicant a confirmation email
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this2.$store.dispatch("sendEmails", {
          subject: "We have received your application",
          message: "Hi " + _this2.applicationData.first_name + ", \n\n" + "Thank you for your application to join the TinyTreasureNYC Family!\n" + "We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the nannies we select. Thanks for your understanding!\n\n" + "Sincerely,\nThe TinyTreasureNYC Team",
          from: _this2.$store.getters.agencyFromEmail,
          emails: [_this2.$store.getters.enginehireLoggingEmail, _this2.applicationData.email],
          reply: _this2.$store.getters.agencyReplyEmail,
          userID: _this2.$store.getters.userID
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    uploadDocument: function uploadDocument() {
      var _this3 = this;

      var formData = new FormData();
      if (this.profilePic) {
        formData.append("profile_pic", this.profilePic);
      }
      if (this.resume) {
        formData.append("resume", this.resume);
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/" + this.$store.getters.userID.toString() + "/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (res) {
        _this3.numberSubmitSuccess += 1;
        _this3.handleSubmittedReference();
      }).catch(function (error) {
        console.log(error);
      });
    },
    postReference: function postReference(reference) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/references/", _extends({}, reference, {
        user: this.$store.getters.userID,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      })).then(function (res) {
        _this4.numberSubmitSuccess += 1;
        _this4.handleSubmittedReference();
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleSubmittedReference: function handleSubmittedReference() {
      if (this.numberSubmitSuccess === this.listReferences.length + 1) {
        // this.showResultDialog(this.$store.getters.submitSuccess);
      }
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextBoxWithLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextAreaWithLabel__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePickerWithLabel__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RadioGroup__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownWithLabel__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckboxGroup__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DayHoursSelector__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalaryRange__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_data_model_length__ = __webpack_require__(750);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show for a list of form (textbox, radio button, checkbox, datepicker ...) 
Each element of form group will be layout by each row, from top to bottom
*/











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FormGroupRowLayout",
  components: {
    TextBoxWithLabel: __WEBPACK_IMPORTED_MODULE_1__TextBoxWithLabel__["a" /* default */],
    TextAreaWithLabel: __WEBPACK_IMPORTED_MODULE_2__TextAreaWithLabel__["a" /* default */],
    DatePickerWithLabel: __WEBPACK_IMPORTED_MODULE_3__DatePickerWithLabel__["a" /* default */],
    RadioGroup: __WEBPACK_IMPORTED_MODULE_4__RadioGroup__["a" /* default */],
    DropdownWithLabel: __WEBPACK_IMPORTED_MODULE_5__DropdownWithLabel__["a" /* default */],
    CheckboxGroup: __WEBPACK_IMPORTED_MODULE_6__CheckboxGroup__["a" /* default */],
    DayHoursSelector: __WEBPACK_IMPORTED_MODULE_7__DayHoursSelector__["a" /* default */],
    SalaryRange: __WEBPACK_IMPORTED_MODULE_8__SalaryRange__["a" /* default */]
  },
  props: {
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelData: Object,
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      FORM_TYPE: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */]
    };
  },
  computed: {
    listRowInput: function listRowInput() {
      return this.listFields.reduce(function (accResult, cur) {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        var lastEl = accResult[accResult.length - 1];
        var numberOfitemPerRow = lastEl[0].itemPerRow ? lastEl[0].itemPerRow : 1;
        if (numberOfitemPerRow === lastEl.length) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  },
  methods: {
    getClassList: function getClassList(itemPerRow) {
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    getMaxLength: function getMaxLength(el) {
      if (el.maxLength) {
        return el.maxLength;
      }
      if (Object.keys(__WEBPACK_IMPORTED_MODULE_9__constants_data_model_length__["a" /* DATA_MODEL_MAX_LENGTH */]).includes(el.model)) {
        return __WEBPACK_IMPORTED_MODULE_9__constants_data_model_length__["a" /* DATA_MODEL_MAX_LENGTH */][el.model];
      }
      if (el.model.includes("selector")) {
        return 255;
      }
      return null;
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimePickerWithLabel__ = __webpack_require__(738);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to select working hours (from ... to ...) for each working day (From Monday to Friday)*/


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DayHoursSelector",
  components: {
    TimePickerWithLabel: __WEBPACK_IMPORTED_MODULE_0__TimePickerWithLabel__["a" /* default */]
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: Array,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // true if disable the timepicker
    listDays: Array
  },
  data: function data() {
    return {
      listDayCheck: this.getListDayCheck(),
      listFrom: this.getListFrom(),
      listTo: this.getListTo()
    };
  },

  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    }
  },
  methods: {
    getListDayCheck: function getListDayCheck() {
      if (this.value == null || this.value.length === 0) {
        return [];
      }
      var listDayCheck = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          if (val == null || val === "") {
            listDayCheck.push(null);
          } else {
            listDayCheck.push(true);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return listDayCheck;
    },
    getListFrom: function getListFrom() {
      if (this.value == null || this.value.length === 0) {
        return [];
      }
      var listFrom = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.value[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var val = _step2.value;

          if (val == null) {
            listFrom.push(null);
          } else {
            var fromToTokens = val.split(",");
            var fromToken = fromToTokens[0].split(":");
            if (fromToken.length != 2) {
              listFrom.push(null);
            } else {
              listFrom.push({ HH: fromToken[0], mm: fromToken[1] });
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return listFrom;
    },
    getListTo: function getListTo() {
      if (this.value == null || this.value.length === 0) {
        return [];
      }
      var listTo = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.value[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var val = _step3.value;

          if (val == null) {
            listTo.push(null);
          } else {
            var fromToTokens = val.split(",");
            if (fromToTokens.length < 2) {
              listTo.push(null);
              continue;
            }
            var toToken = fromToTokens[1].split(":");
            if (toToken.length != 2) {
              listTo.push(null);
            } else {
              listTo.push({ HH: toToken[0], mm: toToken[1] });
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return listTo;
    },
    handleDataChange: function handleDataChange() {
      var result = [];
      for (var index = 0; index < this.listDays.length; index++) {
        var dayCheck = this.listDayCheck[index];
        if (dayCheck !== true) {
          result.push("");
          continue;
        }
        var fromTo = "";
        var from = this.listFrom[index];
        if (from != null) {
          fromTo += from.HH + ":" + from.mm;
        }
        fromTo = fromTo + ",";
        var to = this.listTo[index];
        if (to != null) {
          fromTo += to.HH + ":" + to.mm;
        }
        result.push(fromTo);
      }
      this.$emit("input", result);
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_timepicker_dist_VueTimepicker_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a time picker
Any error of user input for the time picker (for example: required field, invalid time ...) is showed in this component */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TimePickerWithLabel",
  components: {
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default.a
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Object],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // true if disable the timepicker
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextBoxWithLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RadioGroup__ = __webpack_require__(128);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to select working hours (from ... to ...) for each working day (From Monday to Friday)*/




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SalaryRange",
  components: {
    TextBoxWithLabel: __WEBPACK_IMPORTED_MODULE_1__TextBoxWithLabel__["a" /* default */],
    RadioGroup: __WEBPACK_IMPORTED_MODULE_2__RadioGroup__["a" /* default */]
  },
  props: {
    // Label at the top of component
    label: String,
    // Input value, which is used for v-model
    value: Array,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var rangeMin = "";
    var rangeMax = "";
    var salaryOption = "";
    if (this.value != null && this.value.length >= 3) {
      rangeMin = this.value[0];
      rangeMax = this.value[1];
      salaryOption = this.value[2];
    }
    return {
      rangeMin: rangeMin,
      rangeMax: rangeMax,
      salaryOption: salaryOption,
      TEXTBOX_INPUT_TYPE: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["c" /* TEXTBOX_INPUT_TYPE */]
    };
  },

  methods: {
    handleDataChange: function handleDataChange() {
      this.$emit("input", [this.rangeMin, this.rangeMax, this.salaryOption]);
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import axios from '../../axios'; // Don't have to name it axios, can name it anything - Lecture 348

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      phone: '',
      password: '',

      consent: false,

      registrationError: false,

      aakashid: 4 // Used for holding the id of the user with the email aakash@enginehire.ca, this is so I can send myself update emails when things happen
    };
  },
  created: function created() {
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var formData = {
        email: this.email,
        password: this.password
      };
      console.log(formData);
      // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
      // axios.post('/users.json', formData)
      // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
      // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
      // axios.post('http://127.0.0.1:8000/optimum/create-candidate/', {
      //   email: formData.email,
      //   password: formData.password,
      //   // returnSecureToken: true,
      //   agency: 2,
      // })
      //   .then(res => console.log(res))
      //   .catch(error => console.log(error))

      // https://vuex.vuejs.org/guide/actions.html
      // Once the user has been registered then we log them in
      // this.$store.dispatch('registerCandidate', {email: this.email, password: this.password}).then(() => {

      // THIS IS CAUSING PROBLEMS - CAN'T DO API CALL WITHOUT AUTHENTICATION
      // Get the id of the aakash@enginehire.ca user
      // this is necessary because the user changes depending on whether we are using the dev or production database
      // axios.get('/api/people/?email=aakash@enginehire.ca')
      //   .then(res => {
      //     console.log('Getting aakashid')
      //     console.log(res)
      //     console.log(res.data)
      //     console.log(res.data[0].id)
      //     this.aakashid = res.data[0].id
      //   })
      //   .catch(error => console.log(error))

      this.$store.dispatch('registerUser', { email: this.email, password: this.password, user_type: 'employer', status: '', phone: this.phone }).then(function () {
        // this.$store.dispatch('testAction')
        // this.$store.dispatch('login', {email: this.email, password: this.password}).then(() => {
        //   this.$store.dispatch('getUser')
        // })
        console.log('Done registration');
        // Send myself an email notification that a new candidate registered
        _this.$store.dispatch('sendEmail', {
          subject: 'New ThriveHire Employer Registration!',
          message: 'Email: ' + _this.email,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          email: 'aakash@enginehire.ca',
          reply: 'info@thrivehire.co',
          userID: _this.aakashid
        });

        //           this.$store.dispatch('sendEmail', {
        //                   subject: 'Welcome',
        //                   message: '\
        // Welcome to ThriveHire!\n\n\
        // Thank you for joining our community. We’re looking forward to working with you and sharing your organization’s impactful work and opportunities.\n\n\
        // We would be happy to set up a short call with you to learn more about your needs, to highlight ways that ThriveHire may benefit you, and to clarify any questions you may have.\n\n\
        // Please schedule a time that is convenient for you for this call here: calendly.com/hmundeva/30min?back=1&month=2020-01\n\n\
        // We’re looking forward to speaking with you!\n\n\
        // Kind regards,\n\n\
        // Hayley Mundeva\n\
        // Founder/CEO, ThriveHire',
        //                   from: 'info@dameunamano.co',
        //                   email: authData.email,
        //                   reply: 'hmundeva@thrivehire.org',
        //                   userID: res.data.pk,
        //                 })
      })
      // this.$store.dispatch('test')

      .catch(function (error) {
        console.log('problemoo with reg');
        _this.registrationError = true;
      });
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c1c13f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(805);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c1c13f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile_Profile__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jobs_Jobs__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_MyEvents__ = __webpack_require__(290);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['employerID'],
  data: function data() {
    return {
      tab: 'opportunities',

      // editing: false,
      user: {},
      employerName: ''
    };
  },

  components: {
    appProfile: __WEBPACK_IMPORTED_MODULE_1__profile_Profile__["a" /* default */],
    appJobs: __WEBPACK_IMPORTED_MODULE_2__jobs_Jobs__["a" /* default */],
    appMyEvents: __WEBPACK_IMPORTED_MODULE_3__events_MyEvents__["a" /* default */]
  },
  created: function created() {
    this.getUser();

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },

  methods: {
    getUser: function getUser() {
      var _this = this;

      var userID = null;
      if (this.employerID) {
        userID = this.employerID;
      } else {
        userID = this.$store.getters.userID;
      }
      // console.log(this.$store.getters.userID)
      // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + userID.toString()).then(function (res) {
        // console.log(res)
        _this.user = res.data[0];

        _this.employerName = _this.user.employer_name;
        // this.firstName = this.user.first_name
        // this.lastName = this.user.last_name
        // this.phone = this.user.phone
        // this.city = this.user.city
        // this.provinceState = this.user.provincestate
        // this.country = this.user.country
        // this.postalCode = this.user.postal_code
        // this.address1 = this.user.address1
        // this.address2 = this.user.address2

        // The idea here is the first time someone logs in, or if they haven't yet filled in step 1, they should immediately be in edit mode
        if (!_this.employerName) {
          // this.editing = true
          _this.tab = 'profile';
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    logout: function logout() {
      this.$store.dispatch('logout');
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__applications_ApplicationView__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__applications_FamilyFormEdit__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Payments__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_ChangePassword__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PackageSelection__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__documents_Documents__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MyCandidates__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jobs_WeekScheduler__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__jobs_Scheduler__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Resources__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_Feedback__ = __webpack_require__(243);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// Users
// import Resources from "../../users/Resources";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["userID"],
  components: {
    Application: __WEBPACK_IMPORTED_MODULE_1__applications_ApplicationView__["a" /* default */],
    FamilyFormEdit: __WEBPACK_IMPORTED_MODULE_2__applications_FamilyFormEdit__["a" /* default */],
    Payments: __WEBPACK_IMPORTED_MODULE_3__Payments__["a" /* default */],
    ChangePassword: __WEBPACK_IMPORTED_MODULE_4__general_ChangePassword__["a" /* default */],
    PackageSelection: __WEBPACK_IMPORTED_MODULE_5__PackageSelection__["a" /* default */],
    Documents: __WEBPACK_IMPORTED_MODULE_6__documents_Documents__["a" /* default */],
    MyCandidates: __WEBPACK_IMPORTED_MODULE_7__MyCandidates__["a" /* default */],
    WeekScheduler: __WEBPACK_IMPORTED_MODULE_8__jobs_WeekScheduler__["a" /* default */],
    Scheduler: __WEBPACK_IMPORTED_MODULE_9__jobs_Scheduler__["a" /* default */],
    Resources: __WEBPACK_IMPORTED_MODULE_10__Resources__["a" /* default */],
    Feedback: __WEBPACK_IMPORTED_MODULE_11__users_Feedback__["a" /* default */]
  },
  data: function data() {
    return {
      user: {},
      statuses: []
    };
  },
  created: function created() {
    this.getUser();
    this.statuses = this.$store.getters.employerStatuses;
  },

  methods: {
    getUser: function getUser() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/people/?id=" + _this.userID);

              case 2:
                res = _context.sent;

                if (res != null) {
                  _this.user = res.data[0];
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getUserAndChildren: function getUserAndChildren() {
      var _this2 = this;

      return new Promise(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/people/?id=" + _this2.userID);

                case 2:
                  res = _context2.sent;

                  if (!res) {
                    reject();
                  }
                  _this2.user = res.data[0];
                  _context2.next = 7;
                  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/children/?user=" + _this2.user.id);

                case 7:
                  res = _context2.sent;

                  if (!res) {
                    reject();
                  }
                  _this2.user.children = res.data;
                  _this2.user.children.sort(function (child1, child2) {
                    return child1.id - child2.id;
                  });
                  resolve();

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    showApplicationModal: function showApplicationModal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getUserAndChildren();

              case 2:
                _this3.$modal.show("application-modal");

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showUpdateApplicationModal: function showUpdateApplicationModal() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.getUserAndChildren();

              case 2:
                _this4.$modal.show("update-aplication-modal");

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    infoSaved: function infoSaved() {
      this.$modal.hide("update-aplication-modal");
      this.userUpdated();
    },
    subscribed: function subscribed() {
      var _this5 = this;

      //
      // Triggered when payment info entered
      //

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        // container: this.fullPage ? null : this.$refs.formContainer,
        container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
        // this.$emit('subscribed')
      }, 2000);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/" + this.user.id.toString() + "/", {
        status: "Payment Info Entered"
      }).then(function (res) {
        console.log(res);

        _this5.getUser();
        _this5.$modal.show("payment-info-entered-modal");

        _this5.$store.dispatch("sendEmails", {
          subject: "Payment Info Entered - " + _this5.user.first_name + " " + _this5.user.last_name,
          message: "Hello," + "\n\n" + ("The client " + _this5.user.first_name + " " + _this5.user.last_name + " just entered their payment information.\n\n") + "Cheers!",
          from: _this5.$store.getters.agencyFromEmail,
          emails: [_this5.$store.getters.enginehireLoggingEmail, _this5.$store.getters.agencyAdminEmail],
          reply: _this5.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4
        });
      }).catch(function (error) {
        console.log(error);
      });
      // this.getUser()
      // this.$modal.show('payment-info-entered-modal')
    },
    clearStripeID: function clearStripeID() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/" + this.user.id.toString() + "/", {
        stripe_customer_id: ""
        // stripe_customer_id: 'acct_1GDYUZIcCA8L7IlD',
      }).then(function (res) {
        console.log(res);
      }).catch(function (error) {
        console.log(error);
      });
    },
    showChangePasswordModal: function showChangePasswordModal() {
      this.$modal.show("change-password-modal");
    },
    passwordChanged: function passwordChanged() {
      this.$modal.hide("change-password-modal");
      this.$modal.show("password-changed-confirmation-modal");
    },
    userUpdated: function userUpdated() {
      this.getUser();
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_DetailSectionRowLayout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_employer__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DetailSectionRowLayout: __WEBPACK_IMPORTED_MODULE_0__common_DetailSectionRowLayout__["a" /* default */]
  },
  props: ["user"],
  computed: {
    listChildrenFields: function listChildrenFields() {
      if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN) {
        return this.$store.getters.childrenListFieldsNewBorn;
      } else if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].SITTER) {
        return this.$store.getters.childrenListFieldsSitter;
      } else if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY) {
        return this.$store.getters.childrenListFieldsNanny;
      } else if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR) {
        return this.$store.getters.childrenListFieldsPrivateEducator;
      }
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to detail information of fields by rows*/


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DetailSectionRowLayout",
  props: {
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelData: Object,
    labelKey: {
      type: String,
      default: "label"
    },
    listExcludeFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      FORM_TYPE: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */]
    };
  },
  computed: {
    listRowInput: function listRowInput() {
      return this.listFields.reduce(function (accResult, cur) {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        var lastEl = accResult[accResult.length - 1];
        var numberOfitemPerRow = lastEl[0].itemPerRow ? lastEl[0].itemPerRow : 1;
        if (numberOfitemPerRow === lastEl.length) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  },
  methods: {
    getClassList: function getClassList(itemPerRow) {
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    isDisplayItem: function isDisplayItem(item) {
      if (this.listExcludeFields.includes(item.model)) {
        return false;
      }
      if (item.model == null) {
        return false;
      }
      if (!this.isItemShow(this.modelData, item)) {
        return false;
      }
      if (this.isMissingField(this.modelData, item.model, item.type)) {
        return false;
      }
      if (item.keyNotNull) {
        if (this.modelData[item.keyNotNull] == null) {
          return false;
        }
      }
      if (item.keyNull) {
        if (this.modelData[item.keyNull] != null) {
          return false;
        }
      }
      return true;
    },
    getDisplayValue: function getDisplayValue(item, key) {
      var value = this.getValueOfObjectKey(this.modelData, key);
      if (item.type === __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].DAY_HOURS_SELECTOR) {
        if (value == null || value.length === 0) {
          return "";
        }
        var listWorkingDays = this.$store.getters.workingDays;
        var result = "";
        for (var index = 0; index < listWorkingDays.length; index++) {
          if (value[index] == null || value[index].length === 0) {
            continue;
          }
          result = result + "\n" + listWorkingDays[index] + ": From " + value[index].replace(",", " To ");
        }
        return result.trim();
      }
      if (item.type === __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].SALARY_RANGE) {
        if (value == null || value.length < 3) {
          return "";
        }
        return "From: $" + value[0] + " To: $" + value[1] + " per " + value[2];
      }
      if (Array.isArray(value)) {
        return value.join("\n");
      }
      if (typeof value === "boolean") {
        return value ? "Yes" : "No";
      }
      return value;
    },
    getDisplayLabel: function getDisplayLabel(item) {
      var result = item.label;
      if (item[this.labelKey]) {
        result = item[this.labelKey];
      }
      result = result.trim();
      if (result && result.length > 0) {
        if (result[result.length - 1] === "*") {
          result = result.substring(0, result.length - 1).trim();
        }
      }
      return result;
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FamilyFormEdit_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5a3094_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FamilyFormEdit_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(765)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FamilyFormEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5a3094_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FamilyFormEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FormGroupRowLayout__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_DetailSectionRowLayout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ApplicationSectionWithDialog__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_employer__ = __webpack_require__(96);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["user"],
  components: {
    FormGroupRowLayout: __WEBPACK_IMPORTED_MODULE_1__common_FormGroupRowLayout__["a" /* default */],
    DetailSectionRowLayout: __WEBPACK_IMPORTED_MODULE_3__common_DetailSectionRowLayout__["a" /* default */],
    ApplicationSectionWithDialog: __WEBPACK_IMPORTED_MODULE_4__common_ApplicationSectionWithDialog__["a" /* default */]
  },
  data: function data() {
    return {
      listOriginalChild: JSON.parse(JSON.stringify(this.user.children)),
      submitClicked: false,
      numberRequestOfChildrenApi: 0,
      numberResponseOfChildrenApi: 0
    };
  },

  computed: {
    listChildrenFields: function listChildrenFields() {
      return this.getListChildrenFields();
    },
    serviceType: function serviceType() {
      return this.user.selector1;
    }
  },
  watch: {
    serviceType: function serviceType(value) {
      var _this = this;

      // Find all field which corresponding with new service type
      var listModelOfServiceType = this.getListFieldModelForOption(this.$store.getters.familyInformationListFields, value).map(function (field) {
        return field.model;
      });
      // Get all model of family field list
      var listAllModel = this.$store.getters.familyInformationListFields.filter(function (field) {
        return field.model != null;
      }).map(function (field) {
        return field.model;
      });
      var listUnusedKey = listAllModel.filter(function (model) {
        return !listModelOfServiceType.includes(model);
      });
      // Keep the common data between old service type and new service type,
      // Remove other information
      listUnusedKey.forEach(function (key) {
        return delete _this.user[key];
      });
    }
  },
  methods: {
    getListChildrenFields: function getListChildrenFields() {
      if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_5__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN) {
        return this.$store.getters.childrenListFieldsNewBorn;
      } else if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_5__constants_employer__["a" /* SERVICE_TYPE */].SITTER) {
        return this.$store.getters.childrenListFieldsSitter;
      } else if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_5__constants_employer__["a" /* SERVICE_TYPE */].NANNY) {
        return this.$store.getters.childrenListFieldsNanny;
      } else if (this.user.selector1 === __WEBPACK_IMPORTED_MODULE_5__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR) {
        return this.$store.getters.childrenListFieldsPrivateEducator;
      }
    },
    checkInvalidFields: function checkInvalidFields() {
      if (this.hasInvalidField(this.user, this.$store.getters.familyInformationListFields)) {
        return true;
      }
      return false;
    },
    submitApplication: function submitApplication() {
      this.submitClicked = true;
      if (this.checkInvalidFields()) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        this.updateFamilyFormInfo();
      }
    },
    updateFamilyFormInfo: function updateFamilyFormInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, listCurrentChildId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, _loop, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _child;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch(
                // "/api/people/" + this.$store.getters.userID.toString() + "/",
                "/api/people/" + _this2.user.id.toString() + "/", _this2.extractSelectedFields(_this2.user, _this2.$store.getters.familyInformationListFields));

              case 2:
                res = _context.sent;

                if (res) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                listCurrentChildId = _this2.user.children.map(function (child) {
                  return child.id;
                });

                _this2.listRemovedChild = _this2.listOriginalChild.filter(function (child) {
                  return !listCurrentChildId.includes(child.id);
                });
                _this2.numberRequestOfChildrenApi = _this2.listRemovedChild.length + _this2.user.children.length;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 11;
                for (_iterator = _this2.listRemovedChild[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  child = _step.value;

                  _this2.deleteChild(child.id);
                }
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 19:
                _context.prev = 19;
                _context.prev = 20;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 22:
                _context.prev = 22;

                if (!_didIteratorError) {
                  _context.next = 25;
                  break;
                }

                throw _iteratorError;

              case 25:
                return _context.finish(22);

              case 26:
                return _context.finish(19);

              case 27:
                _loop = function _loop(_child) {
                  if (_child.id) {
                    var originalChild = _this2.listOriginalChild.find(function (oriChild) {
                      return oriChild.id === _child.id;
                    });
                    if (_this2.isUnchangedObject(originalChild, _child, _this2.getListChildrenFields())) {
                      _this2.numberRequestOfChildrenApi -= 1;
                    } else {
                      _this2.updateChild(_child);
                    }
                  } else {
                    _this2.addChild(_child);
                  }
                };

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 31;
                for (_iterator2 = _this2.user.children[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _child = _step2.value;

                  _loop(_child);
                }
                _context.next = 39;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context["catch"](31);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 39:
                _context.prev = 39;
                _context.prev = 40;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 42:
                _context.prev = 42;

                if (!_didIteratorError2) {
                  _context.next = 45;
                  break;
                }

                throw _iteratorError2;

              case 45:
                return _context.finish(42);

              case 46:
                return _context.finish(39);

              case 47:
                _this2.handleFinishSubmitChildrenInfo();

              case 48:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 15, 19, 27], [20,, 22, 26], [31, 35, 39, 47], [40,, 42, 46]]);
      }))();
    },
    addChild: function addChild(child) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/children/", _extends({
                  user: _this3.$store.getters.userID,
                  type: "Child"
                }, child, {
                  agency: _this3.$store.getters.agencyID,
                  agency_owner: _this3.$store.getters.agencyName
                }));

              case 2:
                _this3.numberResponseOfChildrenApi += 1;
                _this3.handleFinishSubmitChildrenInfo();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    deleteChild: function deleteChild(childId) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/api/children/" + childId);

              case 2:
                _this4.numberResponseOfChildrenApi += 1;
                _this4.handleFinishSubmitChildrenInfo();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    updateChild: function updateChild(child) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/children/" + child.id, _this5.extractSelectedFields(child, _this5.getListChildrenFields()));

              case 2:
                _this5.numberResponseOfChildrenApi += 1;
                _this5.handleFinishSubmitChildrenInfo();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    handleFinishSubmitChildrenInfo: function handleFinishSubmitChildrenInfo() {
      if (this.numberRequestOfChildrenApi === this.numberResponseOfChildrenApi) {
        this.$emit("infoSaved");
      }
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d86c48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationSectionWithDialog_vue__ = __webpack_require__(769);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d86c48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationSectionWithDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailSectionRowLayout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileSectionDialog__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_custom_define_type__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * The component is used to show for the section like reference or experience or education
 * in the application form
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    sectionTitle: String,
    name: String,
    listFields: Array,
    keyTitles: {
      type: Array,
      default: function _default() {
        return ["name"];
      }
    },
    data: Array
  },
  components: {
    DetailSectionRowLayout: __WEBPACK_IMPORTED_MODULE_1__DetailSectionRowLayout__["a" /* default */],
    ProfileSectionDialog: __WEBPACK_IMPORTED_MODULE_2__ProfileSectionDialog__["a" /* default */]
  },
  data: function data() {
    return {
      isShowObjectFormDialog: false,
      object: {},
      isAddObjectDialog: false,
      indexOfEdittingObject: 0
    };
  },

  methods: {
    showAddObjectDialog: function showAddObjectDialog() {
      this.isAddObjectDialog = true;
      this.object = {};
      this.isShowObjectFormDialog = true;
    },
    showEditObjectDialog: function showEditObjectDialog(ref, index) {
      this.indexOfEdittingObject = index;
      this.isAddObjectDialog = false;
      this.object = _extends({}, ref);
      this.isShowObjectFormDialog = true;
    },
    handleUpdateObjects: function handleUpdateObjects(actionType) {
      if (actionType === __WEBPACK_IMPORTED_MODULE_3__constants_custom_define_type__["a" /* ACTION_TYPE */].ADD) {
        this.data.push(_extends({}, this.object, { id: 0 }));
      } else if (actionType === __WEBPACK_IMPORTED_MODULE_3__constants_custom_define_type__["a" /* ACTION_TYPE */].UPDATE) {
        this.data[this.indexOfEdittingObject] = this.object;
      } else if (actionType === __WEBPACK_IMPORTED_MODULE_3__constants_custom_define_type__["a" /* ACTION_TYPE */].DELETE) {
        this.data.splice(this.indexOfEdittingObject, 1);
      }
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroupRowLayout__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
This component is used for a dialog (add/edit) objects (reference/children/experience/education...)
 */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ProfileSectionDialog",
  components: {
    FormGroupRowLayout: __WEBPACK_IMPORTED_MODULE_1__FormGroupRowLayout__["a" /* default */]
  },
  props: {
    name: String,
    user: Object,
    data: Object,
    keyTitles: {
      type: Array,
      default: function _default() {
        return ["name"];
      }
    },
    value: Boolean,
    isAdd: Boolean,
    listFields: Array,
    isSendRequest: {
      type: Boolean,
      default: false
    },
    api: String
  },
  data: function data() {
    return {
      submitClicked: false,
      ACTION_TYPE: __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */]
    };
  },

  computed: {
    getObjectTitle: function getObjectTitle() {
      var _this = this;

      return this.keyTitles.map(function (titleKey) {
        return _this.data[titleKey];
      }).join(" ");
    }
  },
  methods: {
    hideModal: function hideModal() {
      this.$modal.hide(this.name + "-form-modal");
      this.$emit("input", false);
    },
    showModal: function showModal() {
      console.log("show");
      this.$modal.show(this.name + "-form-modal");
    },
    handleClickSaveButton: function handleClickSaveButton() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.data, this.listFields)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        if (this.isSendRequest) {
          if (this.isAdd) {
            this.postData();
          } else {
            this.patchData();
          }
        } else {
          this.hideModal();
          this.$emit("saved", this.isAdd ? __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */].ADD : __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */].UPDATE);
        }
      }
    },
    postData: function postData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.api, _extends({}, this.data, {
        user: this.user.id
      })).then(function (res) {
        _this2.hideModal();
        _this2.$emit("saved");
      }).catch(function (error) {
        console.log(error);
      });
    },
    patchData: function patchData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("" + this.api + this.data.id + "/", _extends({}, this.data, {
        user: this.user.id
      })).then(function (res) {
        _this3.hideModal();
        _this3.$emit("saved");
      }).catch(function (error) {
        console.log(error);
      });
    },
    showDeleteDataConfirmDialog: function showDeleteDataConfirmDialog() {
      console.log("delete" + this.name + "ConfirmDialog");
      this.showConfirmDialog(_extends({}, this.$store.getters["delete" + this.name + "ConfirmDialog"], {
        onAcceptCallback: this.deleteData
      }));
    },
    deleteData: function deleteData() {
      var _this4 = this;

      if (this.isSendRequest) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("" + this.api + this.data.id + "/").then(function (res) {
          _this4.hideModal();
          _this4.$emit("saved");
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.hideModal();
        this.$emit("saved", __WEBPACK_IMPORTED_MODULE_2__constants_custom_define_type__["a" /* ACTION_TYPE */].DELETE);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        if (value === true) {
          console.log("show?");
          this.submitClicked = false;
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ee7e9ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__ = __webpack_require__(771);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ee7e9ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['email', 'user'],
  data: function data() {
    return {
      stripe: null,
      elements: null,
      card: null,

      cardError: false,
      paymentIntentKey: null,

      // subscription: '',
      justSubscribed: false
    };
  },

  computed: {
    cardComplete: function cardComplete() {
      if (this.card) {
        return this.card._complete;
      } else {
        return null;
      }
    }
  },
  created: function created() {
    // Scroll the window to top on load
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    this.setUpStripe();
  },
  mounted: function mounted() {
    this.setUpStripe();
  },

  methods: {
    setUpStripe: function setUpStripe() {
      var _this = this;

      var vm = this;

      this.stripe = Stripe('pk_live_uQWLhWijqTDmzPz1heFX42gd00M0Oov1EL', {
        //   // stripeAccount: "acct_1GDXlTE7jOFBALyf" // Test account
        stripeAccount: vm.$store.getters.stripeAccountID
        // stripeAccount: 'acct_1GDZdaDZMNxDtGP7' // Express
        // stripeAccount: 'acct_1Bg1iOJgWhWzU0rX', // Standard
        // stripeAccount: 'acct_1EBYhTFiJiOD1ROq', // Standard
      });
      this.elements = this.stripe.elements();
      // this.elements = stripe.elements();

      var style = {
        base: {
          // border: '1px solid #D8D8D8',
          // borderRadius: '4px',
          // color: "#000",

          // color: "#32325d",

          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },

        invalid: {
          // All of the error styles go inside of here.

          color: '#fa755a',
          iconColor: '#fa755a'
        }

      };

      // var card = elements.create('card');
      this.card = this.elements.create('card', { style: style });
      // this.card = elements.create('card', { style: style });
      // card.mount(this.$refs.card);
      this.card.mount("#card-element");
      // this.card.mount("#card-element");

      this.card.addEventListener('change', function (_ref) {
        var error = _ref.error;

        var displayError = document.getElementById('card-errors');
        if (error) {
          displayError.textContent = error.message;
          _this.cardError = true;
        } else {
          displayError.textContent = '';
          _this.cardError = false;
        }
      });
    },
    createCustomer: function createCustomer() {
      var _this2 = this;

      console.log(this.user);

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        // container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        container: this.fullPage,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
        _this2.$emit('subscribed');
      }, 10000);

      // let userEmail = this.user.email
      var userEmail = this.email;
      var stripeAccount = this.$store.getters.stripeAccountID;
      var userID = this.user.id;
      // let userID = this.$store.getters.userID
      // let stripeCustomerID = this.user.stripe_customer_id // Don't have the stripe customer ID off the bat, we are creating the customer below!
      var subscription = this.subscription;

      var fee_percentage = 0.0;
      // if (this.subscription == this.monthlyPlanID) {
      //   fee_percentage = 6.66 // 1/15
      // }
      // else if (this.subscription == this.threeMonthPlanID) {
      //   fee_percentage = 10 // 3/30
      // }
      // else if (this.subscription == this.sixMonthPlanID) {
      //   fee_percentage = 13.33 // 6/45
      // }

      var vm = this;

      this.stripe.createPaymentMethod({
        type: 'card',
        // card: cardElement,
        card: this.card,
        billing_details: {
          // email: 'jenny.rosen@example.com',
          // email: this.user.email,
          email: this.email
        }
      })
      // .then(stripePaymentMethodHandler);
      // .then(res => {
      //   console.log(res)
      // })
      // .then(console.log('Payment method created'))
      .then(function (result) {
        if (result.error) {
          // showCardError(result.error);
          console.log(result.error);
        } else {
          // createCustomer(result.paymentMethod.id, cardholderEmail);

          console.log(result);

          console.log(userEmail);
          console.log(stripeAccount);
          console.log(userID);
          console.log(result.paymentMethod.id);

          // axios.post('/stripe-create-customer-test/', {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/stripe-create-customer/', {
            // email: authData.email,
            // email: this.user.email,
            email: userEmail,
            // stripe_account: state.stripeAccountID,
            // stripe_account: this.$store.getters.stripeAccountID,
            stripe_account: stripeAccount,
            // enginehire_id: res.data.pk,
            // enginehire_id: this.user.id,
            enginehire_id: userID,
            payment_method_id: result.paymentMethod.id
            // payment_method_id: 'sdkf',
          }).then(function (res) {
            console.log('Stripe Customer Created');
            console.log(res.data);

            // // axios.post('/stripe-create-subscription-test/', {
            // axios.post('/stripe-create-subscription/', {
            //   stripe_account: stripeAccount,
            //   // customer_id: stripeCustomerID,
            //   customer_id: res.data.stripe_customer.id,
            //   plan_id: subscription,
            //   fee_percentage: fee_percentage,
            //   tax_percentage: 13,
            //   start_time: 1588334400, // https://www.epochconverter.com/, https://stripe.com/docs/billing/subscriptions/trials
            // })
            //   .then(res => {
            //     console.log('Stripe Subscription Created')
            //     console.log(res.data)

            //     // axios.patch('/api/people/'+userID.toString()+'/', {
            //     //   status: 'Subscribed',
            //     // })
            //     //   .then(res => {
            //     //     console.log(res)
            //     //     // this.justSubscribed = true // Want to show that the user has subscribed, without actually grbabing an updated user object
            //     //   })
            //     //   .catch(error => {
            //     //     console.log(error)
            //     //   })
            //   })
            //   .catch(error => {
            //     console.log(error)
            //   })

            if (vm.user.selector1 != 'Sitter') {
              // Don't collect a deposit from Sitter clients
              var amount = 100;
              if (vm.user.selector1 == 'Nanny' || vm.user.selector1 == 'Newborn Care Specialist') {
                amount = 25000;
              } else if (vm.user.selector1 == 'Private Educator') {
                amount = 50000;
              }

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/stripe-collect-payment-from-existing-customer/', {
                // stripe_payer_account: 'cus_HAi1VQH6AqOcLU',
                // stripe_payer_account: this.user.stripe_customer_id,
                stripe_payer_account: res.data.stripe_customer.id,
                // stripe_payee_account: 'acct_1GJgJzCnTKhNI2s2', // LocalStudent account ID through Enginehire Stripe connect
                stripe_payee_account: stripeAccount,
                // stripe_payee_account: this.jobFiller.stripe_connect_id,
                // organization: 'LocalStudent',
                // amount: Math.round(parseFloat(this.totalPrice).toFixed(2) * 100),
                // amount: 25000,
                // amount: 100,
                amount: amount,
                // fee: Math.round((parseFloat(this.totalPrice) - parseFloat(this.studentPay)).toFixed(2) * 100),
                receipt_email: vm.email,
                // receipt_email: 'enginehire@gmail.com',
                currency: 'usd'
              }).then(function (res) {
                // console.log(res)
              }).catch(function (error) {
                console.log(error);
              });
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['userID'],
    data: function data() {
        return {

            PassUpdate: false,
            updateInput: '',
            updateInput2: '',
            matchingInput: true,
            passwordFieldType: 'password',
            user: ''

        };
    },
    created: function created() {
        this.user = this.userID;
    },


    methods: {
        updatePassword: function updatePassword() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/optimum/manual-reset-password/', {
                user_id: this.user,
                password: this.updateInput2
            }).then(function (res) {
                console.log(res);
                _this.$modal.show('password-reset-modal');

                _this.$emit('passwordchanged');
            }).catch(function (error) {
                console.log(error);
            });
        },


        //only checks if the passwords match, funtionality can be expanded for various password restrictions
        checkMatching: function checkMatching() {
            if (this.updateInput == this.updateInput2) {
                this.matchingInput = true;
            } else {
                this.matchingInput = false;
            }
        },
        verifiedUpdate: function verifiedUpdate() {
            this.checkMatching();
            if (this.matchingInput) {
                this.updatePassword();
                //this line will collapse the input boxes and return the initial update button
                this.PassUpdate = false;
            }
        }
    }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageSelection_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a1cde0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageSelection_vue__ = __webpack_require__(774);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a1cde0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      packageSelection: ''
    };
  },

  methods: {
    showPackageSelectionModal: function showPackageSelectionModal() {
      this.$modal.show('package-selection-modal');
    },
    showConfirmPackageSelectionModal: function showConfirmPackageSelectionModal(packageSelection) {
      this.packageSelection = packageSelection;
      this.$modal.show('confirm-package-selection-modal');
    },
    selectPackage: function selectPackage() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        selector8: this.packageSelection,
        status: 'Package Selected'
      }).then(function (res) {
        console.log(res);
        _this.$modal.hide('package-selection-modal');
        _this.$modal.hide('confirm-package-selection-modal');
        _this.$emit('userUpdated');

        _this.$store.dispatch('sendEmails', {
          subject: 'Package Selected - ' + _this.user.first_name + ' ' + _this.user.last_name + ' | ' + _this.packageSelection,
          message: '<p>Hello,' + '\n\n</p>' + ('<p>The client ' + _this.user.first_name + ' ' + _this.user.last_name + ' just selected the following package: <strong style="color: #e70d7b;">' + _this.packageSelection + '</strong>\n\n</p>') + '<p>Cheers!</p>',
          from: _this.$store.getters.agencyFromEmail,
          emails: [_this.$store.getters.enginehireLoggingEmail, _this.$store.getters.agencyAdminEmail],
          reply: _this.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4,
          html: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    resetPackage: function resetPackage() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        selector8: ''
        // status: 'Interview Complete',
      }).then(function (res) {
        console.log(res);
        _this2.$modal.hide('package-selection-modal');
        _this2.$modal.hide('confirm-package-selection-modal');
        _this2.$emit('userUpdated');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755dfc2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__ = __webpack_require__(786);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755dfc2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransportationConsent__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UseofClientVehicle__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransportChildrenEmployeeVehicle__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MedicalRelease__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FamilyAgencyContract__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__candidates_profile_Document__ = __webpack_require__(238);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  components: {
    TransportationConsent: __WEBPACK_IMPORTED_MODULE_1__TransportationConsent__["a" /* default */],
    UseofClientVehicle: __WEBPACK_IMPORTED_MODULE_2__UseofClientVehicle__["a" /* default */],
    TransportChildrenEmployeeVehicle: __WEBPACK_IMPORTED_MODULE_3__TransportChildrenEmployeeVehicle__["a" /* default */],
    MedicalRelease: __WEBPACK_IMPORTED_MODULE_4__MedicalRelease__["a" /* default */],

    FamilyAgencyContract: __WEBPACK_IMPORTED_MODULE_5__FamilyAgencyContract__["a" /* default */],

    Document: __WEBPACK_IMPORTED_MODULE_6__candidates_profile_Document__["a" /* default */]
  },
  data: function data() {
    return {
      documents: [],
      document: {},

      files: [],
      file: '',
      fileName: '',
      selectedFile: {}
    };
  },
  created: function created() {
    this.getDocuments();
    this.getFiles();
  },

  methods: {
    getDocuments: function getDocuments() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/documents/?signing_user=' + this.user.id).then(function (res) {
        console.log(res);
        _this.documents = res.data;
        _this.documents = _this.documents.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        });
      });
    },
    showTransportationConsentModal: function showTransportationConsentModal(document) {
      this.document = document;
      this.$modal.show('transportation-consent-modal');
    },
    showUseofClientVehicleModal: function showUseofClientVehicleModal(document) {
      this.document = document;
      this.$modal.show('useof-client-vehicle-modal');
    },
    showTransportChildrenEmployeeVehicleModal: function showTransportChildrenEmployeeVehicleModal(document) {
      this.document = document;
      this.$modal.show('transport-children-employee-vehicle-modal');
    },
    showMedicalReleaseModal: function showMedicalReleaseModal(document) {
      this.document = document;
      this.$modal.show('medical-release-modal');
    },
    showFamilyAgencyContractModal: function showFamilyAgencyContractModal(document) {
      this.document = document;
      this.$modal.show('family-agency-contract-modal');
    },
    showDocumentModal: function showDocumentModal(document) {
      this.document = document;
      this.$modal.show('document-modal');
    },
    documentSigned: function documentSigned() {
      this.getDocuments();
      // this.$modal.hide('transportation-consent-modal')
      // this.$modal.hide('useof-client-vehicle-modal')
      // this.$modal.hide('transport-children-employee-vehicle-modal')
      // this.$modal.hide('medical-release-modal')
      // this.$modal.hide('family-agency-contract-modal')

      this.$modal.hide('document-modal');
      this.$modal.show('document-signed-modal');
    },
    documentSaved: function documentSaved() {
      this.getDocuments();
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    getFiles: function getFiles() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/files/?user=' + this.user.id).then(function (res) {
        _this2.files = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showUploadFileModal: function showUploadFileModal() {
      this.$modal.show('upload-file-modal');
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/files/', {
        user: this.user.id,
        name: this.fileName
      }).then(function (res) {
        var formData = new FormData();
        if (_this3.file) {
          formData.append("file_link", _this3.file);
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/files/' + res.data.id + '/', formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(function (res) {
          _this3.getFiles();
          _this3.$modal.hide('upload-file-modal');
        }).catch(function (error) {
          return console.log(error);
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showDeleteFileModal: function showDeleteFileModal(file) {
      this.selectedFile = file;
      this.$modal.show('delete-file-modal');
    },
    deleteFile: function deleteFile(file) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/files/' + file.id + '/').then(function (res) {
        _this4.getFiles();
        _this4.$modal.hide('delete-file-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showDeleteDocumentModal: function showDeleteDocumentModal(document) {
      this.document = document;
      this.$modal.show('delete-document-modal');
    },
    deleteDocument: function deleteDocument(document) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/documents/' + document.id + '/').then(function (res) {
        _this5.getDocuments();
        _this5.$modal.hide('delete-document-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    },
    unsignDocument: function unsignDocument(document) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + document.id + '/', {
        status: 'Unsigned',
        signing_name: ''
      }).then(function (res) {
        _this6.getDocuments();
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalRelease_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c04ae9bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalRelease_vue__ = __webpack_require__(783);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalRelease_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c04ae9bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalRelease_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      field10: '',
      field11: '',
      field12: '',
      field13: '',
      field14: '',
      field15: '',
      signature: ''
    };
  },
  created: function created() {
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',

        field3: this.field3,
        field4: this.field4,
        field5: this.field5,
        field6: this.field6,
        field7: this.field7,
        field8: this.field8,
        field9: this.field9,
        field10: this.field10,
        field11: this.field11,
        field12: this.field12,
        field13: this.field13,
        field14: this.field14
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document'],
  data: function data() {
    return {
      field1: '',
      field2: '',
      field3: '',
      signature: ''
    };
  },
  created: function created() {
    this.field1 = this.document.field1;
    this.field2 = this.document.field2;
    this.field3 = this.document.field3;
    this.signature = this.document.signing_name;
  },

  methods: {
    sign: function sign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documents/' + this.document.id + '/', {
        field1: this.field1,
        field2: this.field2,
        field3: this.field3,
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed'
      }).then(function (res) {
        console.log(res);
        _this.$emit('documentSigned');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      relationships: [],
      relationship: {},
      relationshipCandidates: [],

      videoOrInPerson: '',
      availability: '',

      feedback: '',

      payRate: '',
      contractDuration: '',
      daysHours: '',
      paidTimeOff: '',
      paidVacation: '',
      paidSickDays: '',
      paymentFrequency: '',
      healthInsurance: '',
      mileageReimbursement: ''
      // startDate: '',
    };
  },
  created: function created() {
    // this.candidateEmployerRelationshipStatuses = this.$store.getters.candidateEmployerRelationshipStatuses
    this.getRelationships();
  },

  methods: {
    getRelationships: function getRelationships() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/relationships/?employer=' + this.user.id).then(function (res) {
        console.log(res);
        _this.relationships = res.data;
        _this.relationships = _this.relationships.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        });

        // this.relationshipCandidates = []
        // for (var relationship in this.relationships) {
        //   axios.get(`/api/people/?id=${this.relationships[relationship].candidate}`)
        //     .then(res => {
        //       console.log(res)
        //       // this.relationshipCandidates.push(res.data[0])
        //       // https://stackoverflow.com/questions/35817565/how-to-filter-array-when-object-key-value-is-in-array
        //       // let correspondingRelationship = this.relationships.filter( x => x.candidate == res.data[0].id )[0]
        //       // console.log(correspondingRelationship)
        //       // this
        //     })
        //     .catch(error => console.log(error));
        // }
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateRelationshipStatus: function updateRelationshipStatus(status, relationship) {
      var _this2 = this;

      console.log(status);
      console.log(relationship);

      if (status == 'Interested') {
        this.relationship = relationship;
        this.$modal.show('schedule-interview-modal');

        this.$store.dispatch('sendEmails', {
          subject: 'Client ' + this.relationship.employer_name + ' Interested in ' + this.relationship.candidate_name,
          message: 'Hello,' + '\n\n' + ('The client ' + this.relationship.employer_name + ' is interested in the nanny ' + this.relationship.candidate_name + '!\n') + '\n' + 'Cheers!',
          from: this.$store.getters.agencyFromEmail,
          emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
          reply: this.$store.getters.agencyReplyEmail,
          userID: 4
        });
      } else {
        this.relationship = relationship;
        this.$modal.show('not-interested-feedback-modal');

        this.$store.dispatch('sendEmails', {
          subject: 'Client ' + this.relationship.employer_name + ' NOT Interested in ' + this.relationship.candidate_name,
          message: 'Hello,' + '\n\n' + ('The client ' + this.relationship.employer_name + ' is NOT interested in the nanny ' + this.relationship.candidate_name + '!\n'),
          from: this.$store.getters.agencyFromEmail,
          emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
          reply: this.$store.getters.agencyReplyEmail,
          userID: 4
        });
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + relationship.id + '/', {
        status: status
      }).then(function (res) {
        console.log(res);
        _this2.getRelationships();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    submitScheduleForm: function submitScheduleForm() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + this.relationship.id + '/', {
        text1: this.videoOrInPerson,
        text2: this.availability
      }).then(function (res) {
        _this3.$modal.hide('schedule-interview-modal');
        _this3.$modal.show('submitted-modal');

        _this3.$store.dispatch('sendEmails', {
          subject: 'Client ' + _this3.relationship.employer_name + ' Interested in ' + _this3.relationship.candidate_name,
          message: 'Hello,' + '\n\n' + ('The client ' + _this3.relationship.employer_name + ' is interested in the nanny ' + _this3.relationship.candidate_name + '!\n') + ('Client meeting preference: ' + _this3.videoOrInPerson + '\n') + ('Client availability: ' + _this3.availability + '\n\n') + 'Cheers!',
          from: _this3.$store.getters.agencyFromEmail,
          emails: [_this3.$store.getters.enginehireLoggingEmail, _this3.$store.getters.agencyAdminEmail],
          reply: _this3.$store.getters.agencyReplyEmail,
          userID: 4
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    submitFeedbackForm: function submitFeedbackForm() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + this.relationship.id + '/', {
        text7: this.feedback
      }).then(function (res) {
        _this4.$modal.hide('not-interested-feedback-modal');
        _this4.$modal.show('submitted-modal');

        _this4.$store.dispatch('sendEmails', {
          subject: 'Client Feedback - ' + _this4.relationship.employer_name + ' NOT Interested in ' + _this4.relationship.candidate_name,
          message: 'Hello,' + '\n\n' + ('The client ' + _this4.relationship.employer_name + ' is NOT interested in the nanny ' + _this4.relationship.candidate_name + '\n') + ('Client feedback: ' + _this4.feedback + '\n'),
          from: _this4.$store.getters.agencyFromEmail,
          emails: [_this4.$store.getters.enginehireLoggingEmail, _this4.$store.getters.agencyAdminEmail],
          reply: _this4.$store.getters.agencyReplyEmail,
          userID: 4
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showOfferModal: function showOfferModal(relationship) {
      this.relationship = relationship;
      this.$modal.show('extend-offer-modal');
    },
    extendOffer: function extendOffer() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + this.relationship.id + '/', {
        text3: this.daysHours,
        text4: this.payRate,
        text5: this.paidTimeOff,
        // text6: this.startDate,
        text6: this.contractDuration,
        // text7 got taken by admin notes for client
        text8: this.paidVacation,
        text9: this.paidSickDays,
        text10: this.paymentFrequency,
        text11: this.healthInsurance,
        text12: this.mileageReimbursement,
        status: 'Offer Extended'
      }).then(function (res) {
        _this5.$modal.hide('extend-offer-modal');
        _this5.$modal.show('submitted-modal');
        _this5.getRelationships();

        _this5.$store.dispatch('sendEmails', {
          subject: 'Client ' + _this5.relationship.employer_name + ' extended offer to ' + _this5.relationship.candidate_name,
          message: 'Hello,' + '\n\n' + ('The client ' + _this5.relationship.employer_name + ' has extended an offer to the nanny ' + _this5.relationship.candidate_name + '!\n') + ('Pay rate: ' + _this5.payRate + '\n') + ('Contract Duration: ' + _this5.contractDuration + '\n') + ('Schedule/hours: ' + _this5.daysHours + '\n') + ('Paid Holidays: ' + _this5.paidTimeOff + '\n') + ('Paid Vacation: ' + _this5.paidVacation + '\n') + ('Paid Sick Days: ' + _this5.paidSickDays + '\n') + ('Payment Frequency: ' + _this5.paymentFrequency + '\n') + ('Health Insurance Stipend: ' + _this5.healthInsurance + '\n') + ('Mileage Reimbursement: ' + _this5.mileageReimbursement + '\n\n') + 'Cheers!',
          from: _this5.$store.getters.agencyFromEmail,
          emails: [_this5.$store.getters.enginehireLoggingEmail, _this5.$store.getters.agencyAdminEmail],
          reply: _this5.$store.getters.agencyReplyEmail,
          userID: 4
        });

        // axios.get(`/api/people/?id=${this.relationship.candidate}`)
        //   .then(res => {
        //     let candidate = res.data[0]

        //     this.$store.dispatch('sendEmails',
        //       {
        //         subject: `Client ${this.relationship.employer_name} extended offer to ${this.relationship.candidate_name}`,
        //         message: `Hi ${candidate.first_name},` + '\n\n' +
        //         `Thank you for being such a wonderful nanny candidate! We are so excited to inform you that you have been offered the nanny position for ${this.relationship.employer_name}. They really enjoyed meeting you and feel that with your personality and skills that you would be a wonderful fit in their home and an asset to their family. \n` +
        //         `Pay rate: ${this.payRate}\n` +
        //         `Contract Duration: ${this.contractDuration}\n` +
        //         `Schedule/hours: ${this.daysHours}\n` +
        //         `Paid Holidays: ${this.paidTimeOff}\n` +
        //         `Paid Vacation: ${this.paidVacation}\n` +
        //         `Paid Sick Days: ${this.paidSickDays}\n` +
        //         `Payment Frequency: ${this.paymentFrequency}\n` +
        //         `Health Insurance Stipend: ${this.healthInsurance}\n` +
        //         `Mileage Reimbursement: ${this.mileageReimbursement}\n\n` +
        //         `Cheers!`,
        //         from: this.$store.getters.agencyFromEmail,
        //         emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
        //         reply: this.$store.getters.agencyReplyEmail,
        //         userID: 4,
        //       }
        //     )
        //   })
        //   .catch(error => console.log(error))
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeekScheduler_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6a27ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeekScheduler_vue__ = __webpack_require__(792);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeekScheduler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6a27ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeekScheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component_theme_default_css__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component_theme_default_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://nightcatsama.github.io/vue-slider-component/#/



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  data: function data() {
    return {
      // showDate: new Date(),
      // selectedDate: null,
      // schedule: ['HH', 'MM', 'HH', 'MM', 'HH', 'MM', 'HH', 'MM'],
      // days: [],
      // schedule: [],
      // day: {},
      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // minuteOptions: ['00', '30'],
      // sundayRange: ['00:30', '01:30'],
      sundayRange: ['00:00', '00:00'],
      mondayRange: ['00:00', '00:00'],
      tuesdayRange: ['00:00', '00:00'],
      wednesdayRange: ['00:00', '00:00'],
      thursdayRange: ['00:00', '00:00'],
      fridayRange: ['00:00', '00:00'],
      saturdayRange: ['00:00', '00:00'],
      // mondayStart: '00:30',
      // mondayEnd: '01:30',
      timeOptions: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30']
      // timeStatuses: ['Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable'],
      // availableTimes: [],
      // selectedTimes: [],
      // events: [],
    };
  },
  created: function created() {
    // this.schedule = this.listing.multiselect1
    if (this.user.preferences2.length) {
      this.schedule = this.user.preferences2;
    } else {
      this.schedule = ['00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00'];
    }
    this.sundayRange = this.schedule.slice(0, 2);
    this.mondayRange = this.schedule.slice(2, 4);
    this.tuesdayRange = this.schedule.slice(4, 6);
    this.wednesdayRange = this.schedule.slice(6, 8);
    this.thursdayRange = this.schedule.slice(8, 10);
    this.fridayRange = this.schedule.slice(10, 12);
    this.saturdayRange = this.schedule.slice(12, 14);
  },

  methods: {
    updateSchedule: function updateSchedule() {
      var _this = this;

      this.schedule[0] = this.sundayRange[0];
      this.schedule[1] = this.sundayRange[1];
      this.schedule[2] = this.mondayRange[0];
      this.schedule[3] = this.mondayRange[1];
      this.schedule[4] = this.tuesdayRange[0];
      this.schedule[5] = this.tuesdayRange[1];
      this.schedule[6] = this.wednesdayRange[0];
      this.schedule[7] = this.wednesdayRange[1];
      this.schedule[8] = this.thursdayRange[0];
      this.schedule[9] = this.thursdayRange[1];
      this.schedule[10] = this.fridayRange[0];
      this.schedule[11] = this.fridayRange[1];
      this.schedule[12] = this.saturdayRange[0];
      this.schedule[13] = this.saturdayRange[1];
      console.log(this.schedule);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        preferences2: this.schedule
      }).then(function (res) {
        console.log(res);
        _this.$modal.show('schedule-updated-modal');
        // this.listing.multiselect1 = this.schedule
        console.log(_this.schedule);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(93);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  components: {
    CalendarView: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarView"],
    CalendarViewHeader: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarViewHeader"]
  },
  data: function data() {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      // startHour: 'HH',
      // startMinute: 'MM',
      // startHour: '01',
      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: '01',
      endHour: 1,
      endMinute: '00',
      endTime: null,
      endAMPM: 'AM',

      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // hourOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      // hourOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM'],

      notes: '',
      preferredNanny: '',

      // events: [{id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family'}, {id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family'}, {id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family'}],

      jobs: [],
      calendarJobs: [],
      job: {}
    };
  },
  created: function created() {
    this.getJobs();
  },

  methods: {
    setShowDate: function setShowDate(d) {
      this.showDate = d;
    },
    onClickDate: function onClickDate(d) {
      console.log('date clicked');
      console.log(d);
      this.selectedDate = d;

      this.startHour = 1;
      this.startMinute = '00';
      this.startAMPM = 'AM';
      // startTime: null,
      // endHour: '01',
      this.endHour = 1;
      this.endMinute = '00';
      // this.endTime = null
      this.endAMPM = 'AM';

      this.notes = '';

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    onClickEvent: function onClickEvent(event) {
      var _this = this;

      console.log(event);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/jobs/?id=" + event.id).then(function (res) {
        console.log(res);
        _this.job = res.data[0];
        _this.$modal.show('job-modal');
      });
    },
    getJobs: function getJobs() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/jobs/?poster=" + this.user.id).then(function (res) {
        console.log(res);
        _this2.jobs = res.data;

        _this2.calendarJobs = [];
        for (var job in _this2.jobs) {
          if (_this2.jobs[job].job_type == 'Short Term') {
            // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
            if (_this2.jobs[job].status == 'Requested') {
              _this2.calendarJobs.push({ 'id': _this2.jobs[job].id, 'startDate': _this2.jobs[job].date + " " + _this2.jobs[job].start_time, 'endDate': _this2.jobs[job].date + " " + _this2.jobs[job].end_time, 'style': 'white-space: normal; border-color: #ff6969; background-color: #ff6969;', 'title': _this2.djangotimeformatAMPM(_this2.jobs[job].start_time) + " - " + _this2.djangotimeformatAMPM(_this2.jobs[job].end_time) + " (" + _this2.jobs[job].status + ")" });
            } else if (_this2.jobs[job].status == 'Pending') {
              _this2.calendarJobs.push({ 'id': _this2.jobs[job].id, 'startDate': _this2.jobs[job].date + " " + _this2.jobs[job].start_time, 'endDate': _this2.jobs[job].date + " " + _this2.jobs[job].end_time, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': _this2.djangotimeformatAMPM(_this2.jobs[job].start_time) + " - " + _this2.djangotimeformatAMPM(_this2.jobs[job].end_time) + " (" + _this2.jobs[job].status + ")" });
            } else if (_this2.jobs[job].status == 'Assigned') {
              _this2.calendarJobs.push({ 'id': _this2.jobs[job].id, 'startDate': _this2.jobs[job].date + " " + _this2.jobs[job].start_time, 'endDate': _this2.jobs[job].date + " " + _this2.jobs[job].end_time, 'style': 'white-space: normal; ', 'title': _this2.djangotimeformatAMPM(_this2.jobs[job].start_time) + " - " + _this2.djangotimeformatAMPM(_this2.jobs[job].end_time) + " (" + _this2.jobs[job].status + " - " + _this2.jobs[job].filler_name + ")" });
            } else if (_this2.jobs[job].status == 'In Progress') {
              _this2.calendarJobs.push({ 'id': _this2.jobs[job].id, 'startDate': _this2.jobs[job].date + " " + _this2.jobs[job].start_time, 'endDate': _this2.jobs[job].date + " " + _this2.jobs[job].end_time, 'style': 'white-space: normal; border-color: #85d485; background-color: #85d485;', 'title': _this2.djangotimeformatAMPM(_this2.jobs[job].start_time) + " - " + _this2.djangotimeformatAMPM(_this2.jobs[job].end_time) + " (" + _this2.jobs[job].status + " - " + _this2.jobs[job].filler_name + ")" });
            } else if (_this2.jobs[job].status == 'Completed') {
              _this2.calendarJobs.push({ 'id': _this2.jobs[job].id, 'startDate': _this2.jobs[job].date + " " + _this2.jobs[job].start_time, 'endDate': _this2.jobs[job].date + " " + _this2.jobs[job].end_time, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': _this2.djangotimeformatAMPM(_this2.jobs[job].start_time) + " - " + _this2.djangotimeformatAMPM(_this2.jobs[job].end_time) + " (" + _this2.jobs[job].status + " - " + _this2.jobs[job].filler_name + ")" });
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    postJob: function postJob() {
      var _this3 = this;

      console.log('Posting job');

      this.startHour = parseInt(this.startHour);
      if (this.startHour == 12) {
        this.startHour -= 12;
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        console.log(this.startHour);
        this.startHour += 12;
        console.log(this.startHour);
      }
      this.startHour = ("0" + this.startHour).slice(-2);
      console.log(this.startHour);

      this.endHour = parseInt(this.endHour);
      if (this.endHour == 12) {
        this.endHour -= 12;
      }
      // else {
      //   this.endHour -= 1
      // }
      if (this.endAMPM == 'PM') {
        this.endHour += 12;
      }
      this.endHour = ("0" + this.endHour).slice(-2);

      // this.events.push({id: 4, startDate: this.selectedDate, title: 'Enginehire Family'})
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/jobs/', {
        poster: this.user.id,
        poster_name: this.user.first_name + " " + this.user.last_name,
        date: this.dateInDjangoFormat(this.selectedDate),
        // start_time: this.convertTimeFormat(`${this.startHour}:${this.startMinute}${this.startAMPM}`),
        // end_time: this.convertTimeFormat(`${this.endHour}:${this.endMinute}${this.endAMPM}`),
        start_time: this.startHour + ":" + this.startMinute + ":00",
        end_time: this.endHour + ":" + this.endMinute + ":00",
        text: this.notes,
        text2: this.preferredNanny,
        status: 'Requested',

        address1: this.user.address1,
        address2: this.user.address2,
        postal_code: this.user.postal_code,
        city: this.user.city,
        provincestate: this.user.provincestate,
        country: this.user.country,
        multiselect1: this.user.features2, // Array with info about children

        job_type: 'Short Term',

        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        console.log(res);
        _this3.getJobs();
        _this3.$modal.show('request-submitted-modal');
        _this3.selectedDate = null;

        _this3.$store.dispatch('sendEmails', {
          subject: "New Sitter Request for " + new Date(_this3.addCurrentTimeToDate(res.data.date)).toDateString() + " from " + _this3.user.first_name + " " + _this3.user.last_name,
          message: 'Hello,' + '\n\n' + ("New Sitter Request from " + _this3.user.first_name + " " + _this3.user.last_name + " \n") + ("Date: " + new Date(_this3.addCurrentTimeToDate(res.data.date)).toDateString() + "\n") + ("Start Time: " + _this3.djangotimeformatAMPM(res.data.start_time) + "\n") + ("End Time: " + _this3.djangotimeformatAMPM(res.data.end_time) + "\n") + ("Preferred Sitter: " + res.data.text2 + "\n") + ("Notes: " + res.data.text + "\n\n") + 'Cheers!',
          from: _this3.$store.getters.agencyFromEmail,
          emails: [_this3.$store.getters.enginehireLoggingEmail, _this3.$store.getters.agencyAdminEmail3],
          reply: _this3.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteJob: function deleteJob() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/api/jobs/" + this.job.id).then(function (res) {
        console.log(res);
        _this4.getJobs();
        _this4.$modal.hide('job-modal');
        _this4.$modal.hide('delete-job-modal');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      files: []
    };
  },

  computed: {
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },

    // viewOnlyAccess() {
    //   if (this.$store.getters.isEmployer === true) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    adminOrEmployer: function adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.getFiles();
  },

  methods: {
    getFiles: function getFiles() {
      var _this = this;

      // axios.get(`/api/files/?selector1=Resource&selector2=Candidate`)
      //   .then(res => {
      //     this.candidateFiles = res.data
      //   })
      //   .catch(error => console.log(error))

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/files/?agency=' + this.$store.getters.agencyID + '&selector1=Resource&selector2=Employer').then(function (res) {
        _this.files = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JobList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JobForm__ = __webpack_require__(134);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import PostEdit from './PostEdit';


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userID'],
  data: function data() {
    return {
      state: 'joblist',
      jobToEdit: {},
      jobs: []
    };
  },

  components: {
    appJobList: __WEBPACK_IMPORTED_MODULE_1__JobList__["a" /* default */],
    appJobForm: __WEBPACK_IMPORTED_MODULE_2__JobForm__["a" /* default */]
  },
  created: function created() {
    this.getJobs();

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },

  methods: {
    getJobs: function getJobs() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?poster='.concat(this.userID)).then(function (res) {
        _this.jobs = res.data;
        _this.jobs = _this.jobs.sort(function (a, b) {
          return a.created_date < b.created_date ? 1 : -1;
        });

        // // Only want to show jobs where the application deadline hasn't passed
        // var futureDeadlineJobs = []
        // for (var job in this.jobs) {
        //   if ((new Date(this.jobs[job].application_deadline.concat('T00:00:00'))) >= (new Date())) {
        //     futureDeadlineJobs.push(this.jobs[job])
        //   }
        // }
        // this.jobs = futureDeadlineJobs
      }).catch(function (error) {
        return console.log(error);
      });
    },
    postState: function postState() {
      this.state = 'post';
    },
    cancelPost: function cancelPost() {
      this.state = 'joblist';
    },
    jobPosted: function jobPosted() {
      this.state = 'joblist';
      this.getJobs();

      // Scroll the window back up after saving the step
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    editJob: function editJob(job) {
      console.log(job);
      this.jobToEdit = job;
      this.state = 'edit';
    },
    jobUpdated: function jobUpdated() {
      this.state = 'joblist';
      this.jobToEdit = {};
      this.getJobs();

      // Scroll the window back up after saving the step
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    cancelEdit: function cancelEdit() {
      this.state = 'joblist';
      this.jobToEdit = {};
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyEvents_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420eab88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyEvents_vue__ = __webpack_require__(804);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420eab88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyEvents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventForm__ = __webpack_require__(136);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userID'],
  data: function data() {
    return {
      state: 'list',
      listingToEdit: {},
      listings: []
    };
  },

  components: {
    appList: __WEBPACK_IMPORTED_MODULE_1__EventList__["a" /* default */],
    appForm: __WEBPACK_IMPORTED_MODULE_2__EventForm__["a" /* default */]
  },
  created: function created() {
    this.getListings();

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },

  methods: {
    getListings: function getListings() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/events/?poster='.concat(this.userID)).then(function (res) {
        console.log('Got my events');
        console.log(res);
        _this.listings = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    postState: function postState() {
      this.state = 'post';
    },
    cancelPost: function cancelPost() {
      this.state = 'list';
    },
    listingPosted: function listingPosted() {
      this.state = 'list';
      this.getListings();

      // Scroll the window back up after saving the step
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    editListing: function editListing(listing) {
      console.log(listing);
      this.listingToEdit = listing;
      this.state = 'edit';
    },
    listingUpdated: function listingUpdated() {
      this.state = 'list';
      this.listingToEdit = {};
      this.getListings();

      // Scroll the window back up after saving the step
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    cancelEdit: function cancelEdit() {
      this.state = 'list';
      this.listingToEdit = {};
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventList_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d51330a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventList_vue__ = __webpack_require__(803);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d51330a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventForm__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // https://www.npmjs.com/package/vuejs-datepicker



// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['posterID', 'listings'],
  data: function data() {
    return {
      // jobs: [],
      loggedinUser: null,

      typeOptions: [],
      typeFilters: [],
      countryFilters: [],
      countries: [],
      focusAreaFilters: [],
      focusAreaOptions: [],
      dateFilter: null
    };
  },

  components: {
    appListingEdit: __WEBPACK_IMPORTED_MODULE_3__EventForm__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  created: function created() {
    this.loggedinUser = this.$store.getters.userID;

    this.typeOptions = this.$store.getters.eventTypes;
    this.countries = this.$store.getters.countries;
    this.focusAreaOptions = this.$store.getters.focusAreas;

    // This is used to pre-apply filters when someone arrives on the event list by searching on the home page
    if (this.$route.params.type && this.$route.params.type != 'All Event Types') {
      this.typeFilters.push(this.$route.params.type);
    }
    if (this.$route.params.country && this.$route.params.country != 'All Countries') {
      this.countryFilters.push(this.$route.params.country);
    }
    if (this.$route.params.topic && this.$route.params.topic != 'All Topic Areas') {
      this.focusAreaFilters.push(this.$route.params.topic);
    }
  },

  computed: {
    filteredListings: function filteredListings() {
      var typeFilteredListings = [];
      if (this.typeFilters.length > 0) {
        for (var listing in this.listings) {
          if (this.typeFilters.includes(this.listings[listing].event_type)) {
            typeFilteredListings.push(this.listings[listing]);
          }
        }
      } else {
        typeFilteredListings = this.listings;
      }

      var countryFilteredListings = [];
      if (this.countryFilters.length > 0) {
        for (var listing in typeFilteredListings) {
          if (this.countryFilters.includes(typeFilteredListings[listing].country)) {
            countryFilteredListings.push(typeFilteredListings[listing]);
          }
        }
      } else {
        countryFilteredListings = typeFilteredListings;
      }

      var focusAreaFilteredListings = [];
      if (this.focusAreaFilters.length > 0) {
        for (var listing in countryFilteredListings) {
          for (var focusArea in this.focusAreaFilters) {
            if (countryFilteredListings[listing].categories.includes(this.focusAreaFilters[focusArea])) {
              focusAreaFilteredListings.push(countryFilteredListings[listing]);
              break;
            }
          }
        }
      } else {
        focusAreaFilteredListings = countryFilteredListings;
      }

      var dateFilteredListings = [];
      if (this.dateFilter) {
        var djangoFilterDate = this.dateFilter.getFullYear().toString() +
        // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
        '-' + ('0' + (this.dateFilter.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + this.dateFilter.getDate().toString()).slice(-2);
        for (var listing in focusAreaFilteredListings) {
          if (focusAreaFilteredListings[listing].date == djangoFilterDate) {
            dateFilteredListings.push(focusAreaFilteredListings[listing]);
          }
        }
      } else {
        dateFilteredListings = focusAreaFilteredListings;
      }

      return dateFilteredListings;
    }
  },
  methods: {
    showListing: function showListing(listingID) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: 'Event', params: { id: listingID } });
    },
    editListing: function editListing(listing) {
      console.log('Edit Icon Clicked');
      this.$emit('editListing', listing); // Lecture 112
    },
    clearDateFilter: function clearDateFilter() {
      this.dateFilter = null;
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_compact_timezone_list__ = __webpack_require__(801);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // Validators pre built into vuelidate - lecture 373
 // https://www.npmjs.com/package/vuejs-datepicker

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'




/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['userID'],
  props: ['userID', 'listingID'],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_3_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_3_tiptap__["c" /* EditorMenuBar */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      user: {},

      title: '',
      description: '',
      descriptionEditor: null,
      focusAreas: [],
      focusAreasOptions: [],
      type: '',
      typeOptions: [],
      virtual: false,
      fee: '',
      isFee: 'No',
      compensationTypeOptions: [],
      date: null,
      // disabledDates: {
      //   to: new Date(),
      // },
      multiday: false,
      endDate: null,
      startHour: 'HH',
      startMinute: 'MM',
      startTime: null,
      endHour: 'HH',
      endMinute: 'MM',
      endTime: null,
      link: '',

      city: '',
      provinceState: '',
      country: '',
      countries: [],
      address1: '',
      address2: '',
      postalCode: '',

      // jobID: null,
      listingToEdit: {},

      hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],

      timezone: '',
      timezones: []
    };
  },

  validations: {
    title: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  },
  created: function created() {
    this.getUser();

    this.focusAreasOptions = this.$store.getters.focusAreas;
    this.typeOptions = this.$store.getters.eventTypes;
    this.compensationTypeOptions = this.$store.getters.compensationTypes;
    this.countries = this.$store.getters.countries;

    // this is for a unique route for editing a job /edit-job/id
    if (this.$route.params.id) {
      this.jobID = this.$route.params.id;
    }

    this.timezones = __WEBPACK_IMPORTED_MODULE_5_compact_timezone_list__["a" /* default */];
    // https://stackoverflow.com/questions/19590865/from-an-array-of-objects-extract-value-of-a-property-as-array
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
    this.timezones = this.timezones.map(function (timezone) {
      return timezone.label;
    });

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_3_tiptap__["a" /* Editor */]({
      // content: this.description,
      //         content: '\
      // <h4>Summary</h4><p></p><hr>\
      // <h4>Roles and Responsibilities</h4><p></p><hr>\
      // <h4>Required Qualifications</h4><p></p><hr>\
      // <h4>Preferred Qualifications</h4><p></p><hr>\
      // <h4>Additional Information</h4><p></p>',
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_4_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.description = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
  },

  computed: {
    disabledDates: function disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      var today = new Date();
      var disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
      return disabledDates;
    }
  },
  methods: {
    getUser: function getUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id='.concat(this.userID)).then(function (res) {
        // console.log(res)
        _this2.user = res.data[0];

        _this2.address1 = _this2.user.address1;
        _this2.address2 = _this2.user.address2;
        _this2.postalCode = _this2.user.postal_code;
        _this2.city = _this2.user.city;
        _this2.provinceState = _this2.user.provincestate;
        _this2.country = _this2.user.country;

        // If jobID is not null, that means we are editing an existing job
        if (_this2.listingID) {
          console.log('Editing Job');
          console.log(_this2.listingID);
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/events/?id='.concat(_this2.listingID.toString())).then(function (res) {
            console.log(res.data[0]);
            _this2.listingToEdit = res.data[0];

            _this2.title = _this2.listingToEdit.title;
            _this2.descriptionEditor.setContent(_this2.listingToEdit.description);
            _this2.description = _this2.listingToEdit.description;
            _this2.focusAreas = _this2.listingToEdit.categories;
            _this2.type = _this2.listingToEdit.event_type;
            // this.compensationType = this.jobToEdit.compensation_type
            _this2.fee = _this2.listingToEdit.fee;
            if (_this2.fee) {
              _this2.isFee = 'Yes';
            }
            // this.applicationDeadline = this.jobToEdit.application_deadline

            if (_this2.listingToEdit.date) {
              _this2.date = new Date(_this2.listingToEdit.date.concat('T00:00:00')); // The date was showing as one day previous, because it was being set as 00:00:00 UTC, and then subtracting 5 hours for ET, which made it one day early
            }
            if (_this2.listingToEdit.end_date) {
              _this2.date = new Date(_this2.listingToEdit.end_date.concat('T00:00:00')); // The date was showing as one day previous, because it was being set as 00:00:00 UTC, and then subtracting 5 hours for ET, which made it one day early
            }
            if (_this2.listingToEdit.start_time) {
              _this2.startHour = _this2.listingToEdit.start_time.split(':')[0];
              _this2.startMinute = _this2.listingToEdit.start_time.split(':')[1];
            }
            if (_this2.listingToEdit.end_time) {
              _this2.endHour = _this2.listingToEdit.end_time.split(':')[0];
              _this2.endMinute = _this2.listingToEdit.end_time.split(':')[1];
            }

            _this2.timezone = _this2.listingToEdit.timezone;

            _this2.link = _this2.listingToEdit.link;

            _this2.address1 = _this2.listingToEdit.address1;
            _this2.address2 = _this2.listingToEdit.address2;
            _this2.postalCode = _this2.listingToEdit.postal_code;
            _this2.city = _this2.listingToEdit.city;
            _this2.provinceState = _this2.listingToEdit.provincestate;
            _this2.country = _this2.listingToEdit.country;
          }).catch(function (error) {
            return console.log(error);
          });
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    prepBeforeSaving: function prepBeforeSaving() {
      console.log('Prepping before saving');

      console.log(this.userID);
      console.log(this.user.employer_name);
      console.log(this.title);
      console.log(this.description);
      console.log(this.skills);
      console.log(this.jobType);
      // console.log(this.compensationType)
      console.log(this.fee);
      console.log(this.date);
      console.log(this.startHour);
      console.log(this.startMinute);
      console.log(this.endHour);
      console.log(this.endMinute);
      console.log(this.link);
      console.log(this.address1);
      console.log(this.address2);
      console.log(this.postalCode);
      console.log(this.city);
      console.log(this.provinceState);
      console.log(this.country);

      // If the event is virtual we want to clear all the address fields
      // This way when we retrieve it later, we know a blank address means virtual
      if (this.virtual) {
        this.address1 = '';
        this.address2 = '';
        this.postalCode = '';
        this.city = '';
        this.provinceState = '';
        this.country = '';
      }

      // Need to get the time into the format hh:mm:ss
      if (this.startHour != 'HH') {
        this.startTime = this.startHour;
        if (this.startMinute != 'MM') {
          this.startTime += ':' + this.startMinute + ':00';
        } else {
          this.startTime += ':00:00';
        }
      }
      if (this.endHour != 'HH') {
        this.endTime = this.endHour;
        if (this.endMinute != 'MM') {
          this.endTime += ':' + this.endMinute + ':00';
        } else {
          this.endTime += ':00:00';
        }
      }

      // Need to get the date in the format YYYY-MM-DD
      if (this.date) {
        this.date = this.date.getFullYear().toString() +
        // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
        '-' + ('0' + (this.date.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + this.date.getDate().toString()).slice(-2);
      }
      if (this.endDate) {
        this.endDate = this.endDate.getFullYear().toString() +
        // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
        '-' + ('0' + (this.endDate.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + this.endDate.getDate().toString()).slice(-2);
      }
    },
    test: function test() {
      console.log('skjlghfjdlakj');
    },
    post: function post() {
      var _this3 = this;

      this.prepBeforeSaving();
      // // Need to strip the compensation down to only numbers?
      // // Will the application deadline work directly?

      // // If the event is virtual we want to clear all the address fields
      // // This way when we retrieve it later, we know a blank address means virtual
      // if (this.virtual) {
      //   this.address1 = ''
      //   this.address2 = ''
      //   this.postalCode = ''
      //   this.city = ''
      //   this.provinceState = ''
      //   this.country = ''
      // }

      // let startTime = null
      // let endTime = null
      // // Need to get the time into the format hh:mm:ss
      // if (this.startHour != 'HH') {
      //   startTime = this.startHour
      //   if (this.startMinute != 'MM') {
      //     startTime += (':' + this.startMinute + ':00')
      //   }
      //   else {
      //     startTime += (':00:00')
      //   }
      // }
      // if (this.endHour != 'HH') {
      //   endTime = this.endHour
      //   if (this.endMinute != 'MM') {
      //     endTime += (':' + this.endMinute + ':00')
      //   }
      //   else {
      //     endTime += (':00:00')
      //   }
      // }

      // let date = null
      // // Need to get the date in the format YYYY-MM-DD
      // if (this.date) {
      //   date =
      //   this.date.getFullYear().toString() +
      //   // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
      //   '-' + ('0' + (this.date.getMonth()+1).toString()).slice(-2) +
      //   '-' + ('0' + this.date.getDate().toString()).slice(-2)
      // }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/events/', {
        poster: this.userID,
        poster_name: this.user.employer_name,
        title: this.title,
        description: this.description,
        categories: this.focusAreas,
        event_type: this.type,
        // compensation_type: this.compensationType,
        fee: this.fee,
        // application_deadline: this.applicationDeadline,
        link: this.link,

        // date: date,
        date: this.date,
        end_date: this.endDate,
        // start_time: startTime,
        // end_time: endTime,
        start_time: this.startTime,
        end_time: this.endTime,
        timezone: this.timezone,

        address1: this.address1,
        address2: this.address2,
        postal_code: this.postalCode,
        city: this.city,
        provincestate: this.provinceState,
        country: this.country,

        // agency: 4,
        agency: this.$store.getters.agencyID,
        // agency_owner: 'ThriveHire',
        agency_owner: this.$store.getters.agencyName
      }).then(function (res) {
        console.log('Event Posted');
        console.log(res);

        // broadcast to the parent compoenent that a job has been posted
        // this.$emit('jobPosted', true) // Lecture 112
        _this3.$emit('eventPosted'); // Lecture 112

        // Email to inform Hayley and I of new job posts
        _this3.$store.dispatch('sendEmail', {
          subject: 'New Event Post!',
          message: 'New event posted with the title: ' + _this3.title + '\nOrganization: ' + _this3.user.employer_name,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          // email: 'aakash@enginehire.ca',
          email: 'info@thrivehire.org',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });
        _this3.$store.dispatch('sendEmail', {
          subject: 'New Event Post!',
          message: 'New event posted with the title: ' + _this3.title + '\nPosted By: ' + _this3.user.email,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          email: 'aakash@enginehire.ca',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    update: function update() {
      var _this4 = this;

      this.test();
      this.prepBeforeSaving();

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/events/'.concat(this.listingID.toString()).concat('/'), {
        // poster: this.userID,
        // poster_name: this.user.employer_name,
        title: this.title,
        description: this.description,
        categories: this.focusAreas,
        event_type: this.type,
        fee: this.fee,
        link: this.link,

        date: this.date,
        start_time: this.startTime,
        end_time: this.endTime,
        timezone: this.timezone,

        address1: this.address1,
        address2: this.address2,
        postal_code: this.postalCode,
        city: this.city,
        provincestate: this.provinceState,
        country: this.country
      }).then(function (res) {
        console.log(res);

        // broadcast to the parent compoenent that a job has been posted
        // this.$emit('jobPosted', true) // Lecture 112
        _this4.$emit('eventUpdated'); // Lecture 112
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfileView_vue__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//





// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appProfileView: __WEBPACK_IMPORTED_MODULE_1__ProfileView_vue__["a" /* default */]
  },
  data: function data() {
    return {
      userID: null,
      user: {}
    };
  },
  created: function created() {
    var _this = this;

    this.userID = this.$route.params.id;
    this.getUser();

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
      _this.timeToLoad = true;
    }, 1000);
  },

  methods: {
    getUser: function getUser() {
      var _this2 = this;

      // axios.get('/api/people?id='.concat(this.userID.toString()))
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicemployers/?agency=4&id='.concat(this.userID.toString())).then(function (res) {
        console.log(res.data);
        _this2.user = res.data[0];
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_gmaps__ = __webpack_require__(73);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user', 'city'],
  data: function data() {
    return {
      // google: null,
    };
  },

  computed: {
    videoId: function videoId() {
      //   try {
      //     return getIdFromURL(this.user.video) // https://www.npmjs.com/package/vue-youtube-embed
      //   } catch (error) {
      //     console.log('Error with video id')
      //     console.error(error);
      //     return null
      //   }
      return Object(__WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__["b" /* getIdFromURL */])(this.user.video); // https://www.npmjs.com/package/vue-youtube-embed
    }
  },
  // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var google, geocoder, map;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('ran');
              // console.log(this.user)
              // var mapExists = document.getElementById("map");
              // if (mapExists) {

              if (!_this.user.city) {
                _context.next = 17;
                break;
              }

              console.log(_this.user.city);
              _context.prev = 3;
              _context.next = 6;
              return Object(__WEBPACK_IMPORTED_MODULE_1__utils_gmaps__["a" /* default */])();

            case 6:
              google = _context.sent;
              geocoder = new google.maps.Geocoder();
              // const map = new google.maps.Map(document.getElementById('map'), {
              //   // zoom: 12,
              //   zoom: 3,
              //   // center: {lat: 52.520, lng: 13.410}
              //   center: {lat: 15.0, lng: 0.0}
              // });

              map = new google.maps.Map(document.getElementById('map'), {
                zoom: 13
              });

              // geocoder.geocode({ address: 'Austria' }, (results, status) => {

              geocoder.geocode({ address: _this.user.address1 + ', ' + _this.user.city + ', ' + _this.user.country }, function (results, status) {
                if (status !== 'OK' || !results[0]) {
                  console.log('Error with geoencoder');
                  throw new Error(status);
                }

                map.setCenter(results[0].geometry.location);
                // map.fitBounds(results[0].geometry.viewport);
              });

              // var marker = new google.maps.Marker({
              //       // position: results[0].geometry.location,
              //       position: new google.maps.LatLng(49.884017, -97.168579),
              //       // label: labels[i % labels.length]
              //       // icon: jobListing.icon,
              //       // title: 'test'
              //       map: map
              //     });

              // https://developers.google.com/maps/documentation/geocoding/intro
              // https://developers.google.com/maps/faq#geocoder_queryformat
              if (_this.user.address1 && _this.user.city && _this.user.country) {
                console.log('Trying marker');
                geocoder.geocode({ address: _this.user.address1 + ', ' + _this.user.city + ', ' + _this.user.country }, function (results, status) {
                  if (status !== 'OK' || !results[0]) {
                    console.log('Error with address geoencoder');
                    throw new Error(status);
                  } else {
                    console.log('Got marker');
                    console.log(results[0].geometry.location);
                  }

                  var marker = new google.maps.Marker({
                    position: results[0].geometry.location,
                    // position: new google.maps.LatLng(49.884017, -97.168579),
                    // label: labels[i % labels.length]
                    // icon: jobListing.icon,
                    // title: 'test'
                    map: map
                  });
                });
              }

              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](3);

              console.log('Error with map');
              console.error(_context.t0);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 13]]);
    }))();
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export YouTubePlayer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIdFromURL; });
/* unused harmony export getTimeFromURL */
/*!
 * Vue YouTube Embed version 2.2.2
 * under MIT License copyright 2019 kaorun343
 */
// fork from https://github.com/brandly/angular-youtube-embed

if (!String.prototype.includes) {
  String.prototype.includes = function () {
    return String.prototype.indexOf.apply(this, arguments) !== -1
  };
}

var youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
var timeRegexp = /t=(\d+)[ms]?(\d+)?s?/;

/**
 * get id from url
 * @param  {string} url url
 * @return {string}     id
 */
function getIdFromURL (url) {
  var id = url.replace(youtubeRegexp, '$1');

  if (id.includes(';')) {
    var pieces = id.split(';');

    if (pieces[1].includes('%')) {
      var uriComponent = decodeURIComponent(pieces[1]);
      id = ("http://youtube.com" + uriComponent).replace(youtubeRegexp, '$1');
    } else {
      id = pieces[0];
    }
  } else if (id.includes('#')) {
    id = id.split('#')[0];
  }

  return id
}

/**
 * get time from url
 * @param  {string} url url
 * @return {number}     time
 */
function getTimeFromURL (url) {
  if ( url === void 0 ) url = '';

  var times = url.match(timeRegexp);

  if (!times) {
    return 0
  }

  var full = times[0];
  var minutes = times[1];
  var seconds = times[2];

  if (typeof seconds !== 'undefined') {
    seconds = parseInt(seconds, 10);
    minutes = parseInt(minutes, 10);
  } else if (full.includes('m')) {
    minutes = parseInt(minutes, 10);
    seconds = 0;
  } else {
    seconds = parseInt(minutes, 10);
    minutes = 0;
  }

  return seconds + (minutes * 60)
}

var container = {
  scripts: [],
  events: {},

  run: function run () {
    var this$1 = this;

    this.scripts.forEach(function (callback) {
      callback(this$1.YT);
    });
    this.scripts = [];
  },

  register: function register (callback) {
    var this$1 = this;

    if (this.YT) {
      this.Vue.nextTick(function () {
        callback(this$1.YT);
      });
    } else {
      this.scripts.push(callback);
    }
  }
};

var pid = 0;

var YouTubePlayer = {
  name: 'YoutubeEmbed',
  props: {
    playerHeight: {
      type: [String, Number],
      default: '360'
    },
    playerWidth: {
      type: [String, Number],
      default: '640'
    },
    playerVars: {
      type: Object,
      default: function () { return ({ autoplay: 0, time: 0 }); }
    },
    videoId: {
      type: String
    },
    mute: {
      type: Boolean,
      default: false
    },
    host: {
      type: String,
      default: 'https://www.youtube.com'
    }
  },
  render: function render (h) {
    return h('div', [
      h('div', { attrs: { id: this.elementId }})
    ])
  },
  template: '<div><div :id="elementId"></div></div>',
  watch: {
    playerWidth: 'setSize',
    playerHeight: 'setSize',
    videoId: 'update',
    mute: 'setMute'
  },
  data: function data () {
    pid += 1;
    return {
      elementId: ("youtube-player-" + pid),
      player: {}
    }
  },
  methods: {
    setSize: function setSize () {
      this.player.setSize(this.playerWidth, this.playerHeight);
    },
    setMute: function setMute (value) {
      if (value) {
        this.player.mute();
      } else {
        this.player.unMute();
      }
    },
    update: function update (videoId) {
      var name = (this.playerVars.autoplay ? 'load' : 'cue') + "VideoById";
      if (this.player.hasOwnProperty(name)) {
        this.player[name](videoId);
      } else {
        setTimeout(function () {
          this.update(videoId);
        }.bind(this), 100);
      }
    }
  },
  mounted: function mounted () {
    var this$1 = this;

    container.register(function (YouTube) {
      var ref = this$1;
      var playerHeight = ref.playerHeight;
      var playerWidth = ref.playerWidth;
      var playerVars = ref.playerVars;
      var videoId = ref.videoId;
      var host = ref.host;

      this$1.player = new YouTube.Player(this$1.elementId, {
        height: playerHeight,
        width: playerWidth,
        playerVars: playerVars,
        videoId: videoId,
        host: host,
        events: {
          onReady: function (event) {
            this$1.setMute(this$1.mute);
            this$1.$emit('ready', event);
          },
          onStateChange: function (event) {
            if (event.data !== -1) {
              this$1.$emit(container.events[event.data], event);
            }
          },
          onError: function (event) {
            this$1.$emit('error', event);
          }
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy () {
    if (this.player !== null && this.player.destroy) {
      this.player.destroy();
    }
    delete this.player;
  }
};

var index = {
  install: function install (Vue, options) {
    if ( options === void 0 ) options = {};

    container.Vue = Vue;
    YouTubePlayer.ready = YouTubePlayer.mounted;
    var global = options.global; if ( global === void 0 ) global = true;
    var componentId = options.componentId; if ( componentId === void 0 ) componentId = 'youtube';

    if (global) {
      // if there is a global component with "youtube" identifier already taken
      // then we should let user to pass a new identifier.
      Vue.component(componentId, YouTubePlayer);
    }
    Vue.prototype.$youtube = { getIdFromURL: getIdFromURL, getTimeFromURL: getTimeFromURL };

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/player_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = function () {
        container.YT = YT;
        var PlayerState = YT.PlayerState;

        container.events[PlayerState.ENDED] = 'ended';
        container.events[PlayerState.PLAYING] = 'playing';
        container.events[PlayerState.PAUSED] = 'paused';
        container.events[PlayerState.BUFFERING] = 'buffering';
        container.events[PlayerState.CUED] = 'cued';

        container.Vue.nextTick(function () {
          container.run();
        });
      };
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "youtube_squircle_charcoal.svg?b36e0a6cbfaea031ea366c597a15012c";

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FormGroupRowLayout__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_DetailSectionRowLayout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ApplicationSectionWithDialog__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_employer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profile_Payments__ = __webpack_require__(271);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormGroupRowLayout: __WEBPACK_IMPORTED_MODULE_1__common_FormGroupRowLayout__["a" /* default */],
    DetailSectionRowLayout: __WEBPACK_IMPORTED_MODULE_2__common_DetailSectionRowLayout__["a" /* default */],
    ApplicationSectionWithDialog: __WEBPACK_IMPORTED_MODULE_3__common_ApplicationSectionWithDialog__["a" /* default */],
    Payments: __WEBPACK_IMPORTED_MODULE_7__profile_Payments__["a" /* default */]
  },
  data: function data() {
    return {
      submitClicked: false,
      familyFormData: {},
      numberChildrenSubmitSuccess: 0,
      SERVICE_TYPE: __WEBPACK_IMPORTED_MODULE_6__constants_employer__["a" /* SERVICE_TYPE */],
      listChildren: []
    };
  },

  computed: {
    listChildrenFields: function listChildrenFields() {
      return this.getListChildrenFields();
    },
    serviceType: function serviceType() {
      return this.familyFormData.selector1;
    }
  },
  watch: {
    serviceType: function serviceType(value) {
      // Find all field which corresponding with new service type
      var listFieldOfServiceType = this.getListFieldModelForOption(this.$store.getters.familyInformationListFields, value);
      // Keep the common data between old service type and new service type,
      // Remove other information
      this.familyFormData = this.extractSelectedFields(this.familyFormData, listFieldOfServiceType);
    }
  },
  methods: {
    getListChildrenFields: function getListChildrenFields() {
      if (this.familyFormData.selector1 === __WEBPACK_IMPORTED_MODULE_6__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN) {
        return this.$store.getters.childrenListFieldsNewBorn;
      } else if (this.familyFormData.selector1 === __WEBPACK_IMPORTED_MODULE_6__constants_employer__["a" /* SERVICE_TYPE */].SITTER) {
        return this.$store.getters.childrenListFieldsSitter;
      } else if (this.familyFormData.selector1 === __WEBPACK_IMPORTED_MODULE_6__constants_employer__["a" /* SERVICE_TYPE */].NANNY) {
        return this.$store.getters.childrenListFieldsNanny;
      } else if (this.familyFormData.selector1 === __WEBPACK_IMPORTED_MODULE_6__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR) {
        return this.$store.getters.childrenListFieldsPrivateEducator;
      }
    },
    checkInvalidFields: function checkInvalidFields() {
      if (this.hasInvalidField(this.familyFormData, this.$store.getters.familyInformationListFields)) {
        return true;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.listChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (this.hasInvalidField(child, this.getListChildrenFields())) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    submitApplication: function submitApplication() {
      this.submitClicked = true;
      if (this.checkInvalidFields()) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        // this.sendConfirmationEmail()
        window.scroll(0, 0); // Scroll the window up so they have to scroll down the application to see what's missing
      } else {
        this.registerUser();
      }
    },
    registerUser: function registerUser() {
      var _this = this;

      this.$store.dispatch("registerUser", {
        email: this.familyFormData.email,
        password: this.familyFormData.email,
        user_type: "employer",
        status: "Applied",
        phone: this.familyFormData.phone
      }).then(function () {
        // Send myself an email notification that a new client started a quote
        _this.$store.dispatch("sendEmails", {
          subject: "New Family Form Submission",
          message: "New Family Form submitted by: " + _this.familyFormData.first_name + " " + _this.familyFormData.last_name + " | " + _this.familyFormData.email + "\nPlease log into the administrator dashboard to view it!",
          from: _this.$store.getters.agencyFromEmail,
          emails: [_this.$store.getters.enginehireLoggingEmail, _this.$store.getters.agencyAdminEmail],
          reply: _this.$store.getters.agencyReplyEmail,
          userID: 4
        });
        _this.patchDetails();
      }).catch(function (error) {
        console.log(error);
        _this.showErrorDialog(_this.$store.getters.submitError);
      });
    },
    patchDetails: function patchDetails() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, child, resChild;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/" + _this2.$store.getters.userID.toString() + "/", _this2.familyFormData);

              case 2:
                res = _context.sent;

                if (!(res == null)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                if (!(_this2.listChildren.length === 0)) {
                  _context.next = 8;
                  break;
                }

                _this2.showResultDialog(_this2.$store.getters.submitSuccessFamilyForm);
                return _context.abrupt("return");

              case 8:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 11;
                _iterator2 = _this2.listChildren[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 25;
                  break;
                }

                child = _step2.value;
                _context.next = 17;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/children/", _extends({
                  user: _this2.$store.getters.userID,
                  type: "Child"
                }, child, {
                  agency: _this2.$store.getters.agencyID,
                  agency_owner: _this2.$store.getters.agencyName
                }));

              case 17:
                resChild = _context.sent;

                if (!(resChild == null)) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return");

              case 20:
                _this2.numberChildrenSubmitSuccess += 1;
                _this2.handleSubmittedChildren();

              case 22:
                _iteratorNormalCompletion2 = true;
                _context.next = 13;
                break;

              case 25:
                _context.next = 31;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](11);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 31:
                _context.prev = 31;
                _context.prev = 32;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 34:
                _context.prev = 34;

                if (!_didIteratorError2) {
                  _context.next = 37;
                  break;
                }

                throw _iteratorError2;

              case 37:
                return _context.finish(34);

              case 38:
                return _context.finish(31);

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    handleSubmittedChildren: function handleSubmittedChildren() {
      if (this.numberChildrenSubmitSuccess === this.listChildren.length) {
        this.showResultDialog(this.$store.getters.submitSuccessFamilyForm);
        this.sendConfirmationEmail();
      }
    },
    dashboardRedirect: function dashboardRedirect() {
      var _this3 = this;

      var userID = this.$store.getters.userID;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/people/?id=".concat(userID)).then(function (res) {
        console.log(res.data);
        _this3.user = res.data[0];

        if (_this3.user.is_candidate) {
          __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ name: "Candidate Dashboard" });
        } else if (_this3.user.is_employer) {
          __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ name: "Employer Dashboard" });
        } else if (_this3.user.is_agent) {
          __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ name: "Agent Dashboard" });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    sendConfirmationEmail: function sendConfirmationEmail() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/emailtemplates/?agency=" + this.$store.getters.agencyID + "&type=Registration&selector1=Employer&deactivated=false") // Get the email template corresponding to employer registration
      .then(function (res) {
        console.log(res);
        if (res.data.length) {
          // If there is an email template for this new status
          var emailTemplate = res.data[0];

          var agencyEmail = _this4.$store.getters.agencyFromEmail;

          console.log(emailTemplate);
          _this4.$store.dispatch('sendEmails', {
            subject: emailTemplate.subject,
            message: emailTemplate.body.replace('[[fname]]', _this4.familyFormData.first_name), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
            // from: this.$store.getters.agencyFromEmail,
            from: agencyEmail,
            emails: [_this4.$store.getters.enginehireLoggingEmail, _this4.familyFormData.email],
            // reply: this.$store.getters.agencyReplyEmail,
            reply: agencyEmail,
            userID: _this4.$store.getters.userID ? _this4.$store.getters.userID : 4,
            html: true
          });
        }
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
 // https://www.npmjs.com/package/vuejs-datepicker

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      familyName: '',
      motherFirst: '',
      motherLast: '',
      motherEmail: '',
      motherPhone: '',
      fatherFirst: '',
      fatherLast: '',
      fatherEmail: '',
      fatherPhone: '',
      address: '',
      city: '',
      postalCode: '',
      preferredComm: '',
      child1: '',
      birthday1: '',
      child2: '',
      birthday2: '',
      child3: '',
      birthday3: '',
      child4: '',
      birthday4: '',
      schedule: '',
      positions: [],
      duration: '',
      startDate: '',
      notes: '',
      referrer: '',
      referee: '',

      submitClicked: false,
      requiredMissing: false
    };
  },

  computed: {
    disabledDates: function disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      var today = new Date();
      var disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
      return disabledDates;
    }
  },
  methods: {
    submitApplication: function submitApplication() {
      var _this = this;

      this.submitClicked = true;

      if (this.familyName && this.motherFirst && this.motherLast && this.motherEmail && this.motherPhone && this.fatherFirst && this.fatherLast && this.fatherEmail && this.fatherPhone && this.address && this.city && this.postalCode && this.child1 && this.birthday1 && this.schedule && this.positions[0] && this.duration && this.startDate && this.referrer) {
        // https://www.npmjs.com/package/vue-loading-overlay
        var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(function () {
          loader.hide();
        }, 4000);

        // axios.post('/create-user/', {
        //   email: this.motherEmail,
        //   password: this.motherEmail,
        // })
        //   .then(res => {
        //     console.log('User resgistered!')
        //     console.log(res)
        //     console.log(res.data.pk)

        //     console.log(this.$store.getters.agencyID)
        //     console.log(this.$store.getters.agencyName)

        //     axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
        //       {
        //         agency: this.$store.getters.agencyID,
        //         agency_owner: this.$store.getters.agencyName,
        //         is_employer: true,
        //         status: 'Applied',
        //       }
        //     )
        //       .then(res => {
        //         console.log(res)
        //       })
        //       .catch(error => console.log(error))
        //   })
        //   .catch(error => console.log(error))

        this.$store.dispatch('registerUser', { email: this.motherEmail, password: this.motherEmail, user_type: 'employer', status: 'Applied', phone: this.motherPhone }).then(function () {
          console.log('Done registration');
          // Send myself an email notification that a new client started a quote
          _this.$store.dispatch('sendEmail', {
            subject: 'New TNC Permanent Nanny Client Application',
            message: 'New Permanent Nanny Application submitted by: ' + _this.motherFirst + ' ' + _this.motherLast + ' | ' + _this.motherEmail,
            // from: 'info@thrivehire.co',
            from: _this.$store.getters.agencyFromEmail,
            email: _this.$store.getters.enginehireAdminEmail,
            reply: _this.$store.getters.agencyReplyEmail,
            // userID: this.aakashid,
            userID: 4
          });
          _this.$store.dispatch('sendEmail', {
            subject: 'New TNC Permanent Nanny Client Application',
            message: 'New Permanent Nanny Application submitted by: ' + _this.motherFirst + ' ' + _this.motherLast + ' | ' + _this.motherEmail,
            // from: 'info@thrivehire.co',
            from: _this.$store.getters.agencyFromEmail,
            email: _this.$store.getters.agencyAdminEmail,
            reply: _this.$store.getters.agencyReplyEmail,
            // userID: this.aakashid,
            userID: 4
          });

          if (_this.startDate) {
            _this.startDate = _this.dateInDjangoFormat(_this.startDate);
          }
          // if (!this.birthday2) {
          //   this.birthday2 = ''
          // }
          // if (!this.birthday3) {
          //   this.birthday3 = ''
          // }
          // if (!this.birthday4) {
          //   this.birthday4 = ''
          // }

          // Need to store all the contact info after creating the user
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + _this.$store.getters.userID.toString() + '/', {
            selector1: 'Permanent',
            employer_name: _this.familyName,
            first_name: _this.motherFirst,
            last_name: _this.motherLast,
            phone: _this.motherPhone,
            features: [_this.fatherFirst, _this.fatherLast, _this.fatherEmail, _this.fatherPhone],
            address1: _this.address,
            postal_code: _this.postalCode,
            city: _this.city,
            selector2: _this.preferredComm,
            features2: [_this.child1, _this.birthday1, _this.child2, _this.birthday2, _this.child3, _this.birthday3, _this.child4, _this.birthday4],
            overview: _this.schedule,
            preferences: _this.positions,
            selector3: _this.duration,
            available_date: _this.startDate,
            about_us: _this.notes,
            marketing_source: _this.referrer,
            selector4: _this.referee
          }).then(function (res) {
            console.log(res);
            _this.$modal.show('application-submitted-modal');

            _this.$store.dispatch('logout', 'no-redirect');

            // axios.post('/api/jobs/', {
            //   poster: this.$store.getters.userID,
            //   poster_name: this.firstName + ' ' + this.lastName,
            //   status: 'Quoted',
            //   // title: 'Mowing',
            //   description: this.note,
            //   job_type: 'Mowing',
            //   selector1: this.size,
            //   selector2: this.frequency,
            //   // date: this.startDate,
            //   // end_date: this.endDate,
            //   date: startDate,
            //   end_date: endDate,

            //   address1: this.address1,
            //   // address2: this.address2,
            //   postal_code: this.postalCode,
            //   city: this.city,
            //   provincestate: this.provinceState,
            //   country: this.country,

            //   agency: this.$store.getters.agencyID,
            //   agency_owner: this.$store.getters.agencyName,
            // })
            //   .then(res => {
            //     console.log(res)
            //     this.currentStep = 4
            //   })
            //   .catch(error => {
            //     console.log(error)
            //   })
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          console.log(error);
          _this.$modal.show('duplicate-email-modal');
        });
      } else {
        // this.requiredMissing = true
        this.$modal.show('required-missing-modal');
      }
    },
    hideApplicationSubmittedModal: function hideApplicationSubmittedModal() {
      // window.location.href = 'https://www.thenannycompany.ca/';
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
 // https://www.npmjs.com/package/vuejs-datepicker

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      familyName: '',
      motherFirst: '',
      motherLast: '',
      motherEmail: '',
      motherPhone: '',
      fatherFirst: '',
      fatherLast: '',
      fatherEmail: '',
      fatherPhone: '',
      address: '',
      city: '',
      postalCode: '',
      preferredComm: '',
      child1: '',
      birthday1: '',
      child2: '',
      birthday2: '',
      child3: '',
      birthday3: '',
      child4: '',
      birthday4: '',
      schedule: '',
      positions: [],
      duration: '',
      startDate: '',
      notes: '',
      referrer: '',
      referee: '',

      submitClicked: false,
      requiredMissing: false
    };
  },

  computed: {
    disabledDates: function disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      var today = new Date();
      var disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
      return disabledDates;
    }
  },
  methods: {
    submitApplication: function submitApplication() {
      var _this = this;

      this.submitClicked = true;

      if (this.familyName && this.motherFirst && this.motherLast && this.motherEmail && this.motherPhone && this.fatherFirst && this.fatherLast && this.fatherEmail && this.fatherPhone && this.address && this.city && this.postalCode && this.child1 && this.birthday1
      // && this.positions[0] && this.duration
      && this.startDate && this.referrer) {
        // https://www.npmjs.com/package/vue-loading-overlay
        var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(function () {
          loader.hide();
        }, 4000);

        // axios.post('/create-user/', {
        //   email: this.motherEmail,
        //   password: this.motherEmail,
        // })
        //   .then(res => {
        //     console.log('User resgistered!')
        //     console.log(res)
        //     console.log(res.data.pk)

        //     console.log(this.$store.getters.agencyID)
        //     console.log(this.$store.getters.agencyName)

        //     axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
        //       {
        //         agency: this.$store.getters.agencyID,
        //         agency_owner: this.$store.getters.agencyName,
        //         is_employer: true,
        //         status: 'Applied',
        //       }
        //     )
        //       .then(res => {
        //         console.log(res)
        //       })
        //       .catch(error => console.log(error))
        //   })
        //   .catch(error => console.log(error))

        this.$store.dispatch('registerUser', { email: this.motherEmail, password: this.motherEmail, user_type: 'employer', status: 'Applied', phone: this.motherPhone }).then(function () {
          console.log('Done registration');
          // Send myself an email notification that a new client started a quote
          _this.$store.dispatch('sendEmail', {
            subject: 'New GCN Nanny on Call Client Application',
            message: 'New Nanny on Call Client Application submitted by: ' + _this.motherFirst + ' ' + _this.motherLast + ' | ' + _this.motherEmail,
            // from: 'info@thrivehire.co',
            from: _this.$store.getters.agencyFromEmail,
            email: _this.$store.getters.enginehireAdminEmail,
            reply: _this.$store.getters.agencyReplyEmail,
            // userID: this.aakashid,
            userID: 4
          });
          // this.$store.dispatch('sendEmail',
          //   {
          //     subject: 'New TNC Nanny on Call Client Application',
          //     message: 'New Nanny on Call Client Application submitted by: ' + this.motherFirst + ' ' + this.motherLast + ' | ' + this.motherEmail,
          //     // from: 'info@thrivehire.co',
          //     from: this.$store.getters.agencyFromEmail,
          //     // email: this.$store.getters.agencyAdminEmail,
          //     email: 'casualplacements@thenannycompany.ca',
          //     reply: this.$store.getters.agencyReplyEmail,
          //     // userID: this.aakashid,
          //     userID: 4,
          //   }
          // )

          if (_this.startDate) {
            _this.startDate = _this.dateInDjangoFormat(_this.startDate);
          }
          // if (!this.birthday2) {
          //   this.birthday2 = ''
          // }
          // if (!this.birthday3) {
          //   this.birthday3 = ''
          // }
          // if (!this.birthday4) {
          //   this.birthday4 = ''
          // }

          // Need to store all the contact info after creating the user
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + _this.$store.getters.userID.toString() + '/', {
            selector1: 'Nanny on Call',
            employer_name: _this.familyName,
            first_name: _this.motherFirst,
            last_name: _this.motherLast,
            phone: _this.motherPhone,
            features: [_this.fatherFirst, _this.fatherLast, _this.fatherEmail, _this.fatherPhone],
            address1: _this.address,
            postal_code: _this.postalCode,
            city: _this.city,
            selector2: _this.preferredComm,
            features2: [_this.child1, _this.birthday1, _this.child2, _this.birthday2, _this.child3, _this.birthday3, _this.child4, _this.birthday4],
            overview: _this.schedule,
            preferences: _this.positions,
            selector3: _this.duration,
            available_date: _this.startDate,
            about_us: _this.notes,
            marketing_source: _this.referrer,
            selector4: _this.referee
          }).then(function (res) {
            console.log(res);
            _this.$modal.show('application-submitted-modal');

            _this.$store.dispatch('logout', 'no-redirect');

            // axios.post('/api/jobs/', {
            //   poster: this.$store.getters.userID,
            //   poster_name: this.firstName + ' ' + this.lastName,
            //   status: 'Quoted',
            //   // title: 'Mowing',
            //   description: this.note,
            //   job_type: 'Mowing',
            //   selector1: this.size,
            //   selector2: this.frequency,
            //   // date: this.startDate,
            //   // end_date: this.endDate,
            //   date: startDate,
            //   end_date: endDate,

            //   address1: this.address1,
            //   // address2: this.address2,
            //   postal_code: this.postalCode,
            //   city: this.city,
            //   provincestate: this.provinceState,
            //   country: this.country,

            //   agency: this.$store.getters.agencyID,
            //   agency_owner: this.$store.getters.agencyName,
            // })
            //   .then(res => {
            //     console.log(res)
            //     this.currentStep = 4
            //   })
            //   .catch(error => {
            //     console.log(error)
            //   })
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          console.log(error);
          _this.$modal.show('duplicate-email-modal');
        });
      } else {
        // this.requiredMissing = true
        this.$modal.show('required-missing-modal');
      }
    },
    hideApplicationSubmittedModal: function hideApplicationSubmittedModal() {
      // window.location.href = 'https://www.thenannycompany.ca/';
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
 // https://www.npmjs.com/package/vuejs-datepicker

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      familyName: '',
      motherFirst: '',
      motherLast: '',
      motherEmail: '',
      motherPhone: '',
      fatherFirst: '',
      fatherLast: '',
      fatherEmail: '',
      fatherPhone: '',
      address: '',
      city: '',
      postalCode: '',
      preferredComm: '',
      child1: '',
      birthday1: '',
      child2: '',
      birthday2: '',
      child3: '',
      birthday3: '',
      child4: '',
      birthday4: '',
      schedule: '',
      positions: [],
      duration: '',
      startDate: '',
      pets: '',
      notes: '',
      referrer: '',
      referee: '',

      submitClicked: false,
      requiredMissing: false
    };
  },

  computed: {
    disabledDates: function disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      var today = new Date();
      var disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
      return disabledDates;
    }
  },
  methods: {
    submitApplication: function submitApplication() {
      var _this = this;

      this.submitClicked = true;

      if (this.familyName && this.motherFirst && this.motherLast && this.motherEmail && this.motherPhone && this.fatherFirst && this.fatherLast && this.fatherEmail && this.fatherPhone && this.address && this.city && this.postalCode && this.child1 && this.birthday1
      // && this.positions[0] && this.duration
      && this.startDate && this.pets && this.referrer) {
        // https://www.npmjs.com/package/vue-loading-overlay
        var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(function () {
          loader.hide();
        }, 4000);

        // axios.post('/create-user/', {
        //   email: this.motherEmail,
        //   password: this.motherEmail,
        // })
        //   .then(res => {
        //     console.log('User resgistered!')
        //     console.log(res)
        //     console.log(res.data.pk)

        //     console.log(this.$store.getters.agencyID)
        //     console.log(this.$store.getters.agencyName)

        //     axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
        //       {
        //         agency: this.$store.getters.agencyID,
        //         agency_owner: this.$store.getters.agencyName,
        //         is_employer: true,
        //         status: 'Applied',
        //       }
        //     )
        //       .then(res => {
        //         console.log(res)
        //       })
        //       .catch(error => console.log(error))
        //   })
        //   .catch(error => console.log(error))

        this.$store.dispatch('registerUser', { email: this.motherEmail, password: this.motherEmail, user_type: 'employer', status: 'Applied', phone: this.motherPhone }).then(function () {
          console.log('Done registration');
          // Send myself an email notification that a new client started a quote
          _this.$store.dispatch('sendEmail', {
            subject: 'New TNC Interim Care Client Application',
            message: 'New Interim Care Client Application submitted by: ' + _this.motherFirst + ' ' + _this.motherLast + ' | ' + _this.motherEmail,
            // from: 'info@thrivehire.co',
            from: _this.$store.getters.agencyFromEmail,
            email: _this.$store.getters.enginehireAdminEmail,
            reply: _this.$store.getters.agencyReplyEmail,
            // userID: this.aakashid,
            userID: 4
          });
          // this.$store.dispatch('sendEmail',
          //   {
          //     subject: 'New TNC Interim Care Client Application',
          //     message: 'New Interim Care Client Application submitted by: ' + this.motherFirst + ' ' + this.motherLast + ' | ' + this.motherEmail,
          //     // from: 'info@thrivehire.co',
          //     from: this.$store.getters.agencyFromEmail,
          //     // email: this.$store.getters.agencyAdminEmail,
          //     email: 'casualplacements@thenannycompany.ca',
          //     reply: this.$store.getters.agencyReplyEmail,
          //     // userID: this.aakashid,
          //     userID: 4,
          //   }
          // )

          if (_this.startDate) {
            _this.startDate = _this.dateInDjangoFormat(_this.startDate);
          }
          // if (!this.birthday2) {
          //   this.birthday2 = ''
          // }
          // if (!this.birthday3) {
          //   this.birthday3 = ''
          // }
          // if (!this.birthday4) {
          //   this.birthday4 = ''
          // }

          // Need to store all the contact info after creating the user
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + _this.$store.getters.userID.toString() + '/', {
            selector1: 'Interim',
            employer_name: _this.familyName,
            first_name: _this.motherFirst,
            last_name: _this.motherLast,
            phone: _this.motherPhone,
            features: [_this.fatherFirst, _this.fatherLast, _this.fatherEmail, _this.fatherPhone],
            address1: _this.address,
            postal_code: _this.postalCode,
            city: _this.city,
            selector2: _this.preferredComm,
            features2: [_this.child1, _this.birthday1, _this.child2, _this.birthday2, _this.child3, _this.birthday3, _this.child4, _this.birthday4],
            overview: _this.schedule,
            preferences: _this.positions,
            selector3: _this.duration,
            available_date: _this.startDate,
            text_field1: _this.pets,
            about_us: _this.notes,
            marketing_source: _this.referrer,
            selector4: _this.referee
          }).then(function (res) {
            console.log(res);
            _this.$modal.show('application-submitted-modal');

            _this.$store.dispatch('logout', 'no-redirect');

            // axios.post('/api/jobs/', {
            //   poster: this.$store.getters.userID,
            //   poster_name: this.firstName + ' ' + this.lastName,
            //   status: 'Quoted',
            //   // title: 'Mowing',
            //   description: this.note,
            //   job_type: 'Mowing',
            //   selector1: this.size,
            //   selector2: this.frequency,
            //   // date: this.startDate,
            //   // end_date: this.endDate,
            //   date: startDate,
            //   end_date: endDate,

            //   address1: this.address1,
            //   // address2: this.address2,
            //   postal_code: this.postalCode,
            //   city: this.city,
            //   provincestate: this.provinceState,
            //   country: this.country,

            //   agency: this.$store.getters.agencyID,
            //   agency_owner: this.$store.getters.agencyName,
            // })
            //   .then(res => {
            //     console.log(res)
            //     this.currentStep = 4
            //   })
            //   .catch(error => {
            //     console.log(error)
            //   })
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          console.log(error);
          _this.$modal.show('duplicate-email-modal');
        });
      } else {
        // this.requiredMissing = true
        this.$modal.show('required-missing-modal');
      }
    },
    hideApplicationSubmittedModal: function hideApplicationSubmittedModal() {
      window.location.href = 'https://www.goldcoastnannies.company/';
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Blog__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__candidates_CandidateProfile__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__candidates_Dashboard__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CandidateInterview__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__employers_Dashboard__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__events_MyEvents__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Events__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tables_Agents__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MailingList__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Panel__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Scheduler__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ApplicationView__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__InternalProfile__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StatusStats__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EmailLog__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__employers_documents_Documents__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__employers_jobs_WeekScheduler__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__employers_profile_PackageSelection__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MasterCalendar__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CandidateEmployerRelationshipManager__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__functions_JobPosting__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__systems_EmailTemplates__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__systems_EmailFooters__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__systems_InterviewTemplates__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__systems_ResourceManager__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__systems_DocumentTemplates__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__systems_DocumentManager__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables_Jobs__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tables_JobApplications__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__employers_applications_FamilyFormEdit__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__functions_AddUser__ = __webpack_require__(883);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



































/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appBlog: __WEBPACK_IMPORTED_MODULE_1__Blog__["a" /* default */],
    appCandidateProfile: __WEBPACK_IMPORTED_MODULE_2__candidates_CandidateProfile__["a" /* default */],
    CandidateDashboard: __WEBPACK_IMPORTED_MODULE_3__candidates_Dashboard__["a" /* default */],
    CandidateInterview: __WEBPACK_IMPORTED_MODULE_4__CandidateInterview__["a" /* default */],
    appEmployerDashboard: __WEBPACK_IMPORTED_MODULE_5__employers_Dashboard__["a" /* default */],
    appMyEvents: __WEBPACK_IMPORTED_MODULE_6__events_MyEvents__["a" /* default */],
    appEvents: __WEBPACK_IMPORTED_MODULE_7__Events__["a" /* default */],
    appAgents: __WEBPACK_IMPORTED_MODULE_8__tables_Agents__["a" /* default */],
    appMailingList: __WEBPACK_IMPORTED_MODULE_9__MailingList__["a" /* default */],
    Panel: __WEBPACK_IMPORTED_MODULE_10__Panel__["a" /* default */],
    Scheduler: __WEBPACK_IMPORTED_MODULE_11__Scheduler__["a" /* default */],
    ApplicationView: __WEBPACK_IMPORTED_MODULE_12__ApplicationView__["a" /* default */],
    InternalProfile: __WEBPACK_IMPORTED_MODULE_13__InternalProfile__["a" /* default */],
    StatusStats: __WEBPACK_IMPORTED_MODULE_14__StatusStats__["a" /* default */],
    EmailLog: __WEBPACK_IMPORTED_MODULE_15__EmailLog__["a" /* default */],
    EmailTemplates: __WEBPACK_IMPORTED_MODULE_22__systems_EmailTemplates__["a" /* default */],
    EmailFooters: __WEBPACK_IMPORTED_MODULE_23__systems_EmailFooters__["a" /* default */],
    InterviewTemplates: __WEBPACK_IMPORTED_MODULE_24__systems_InterviewTemplates__["a" /* default */],
    EmployerDocuments: __WEBPACK_IMPORTED_MODULE_16__employers_documents_Documents__["a" /* default */],
    EmployerWeekScheduler: __WEBPACK_IMPORTED_MODULE_17__employers_jobs_WeekScheduler__["a" /* default */],
    PackageSelection: __WEBPACK_IMPORTED_MODULE_18__employers_profile_PackageSelection__["a" /* default */],
    MasterCalendar: __WEBPACK_IMPORTED_MODULE_19__MasterCalendar__["a" /* default */],
    CandidateEmployerRelationshipManager: __WEBPACK_IMPORTED_MODULE_20__CandidateEmployerRelationshipManager__["a" /* default */],
    JobPosting: __WEBPACK_IMPORTED_MODULE_21__functions_JobPosting__["a" /* default */],
    Jobs: __WEBPACK_IMPORTED_MODULE_28__tables_Jobs__["a" /* default */],
    JobApplications: __WEBPACK_IMPORTED_MODULE_29__tables_JobApplications__["a" /* default */],
    ResourceManager: __WEBPACK_IMPORTED_MODULE_25__systems_ResourceManager__["a" /* default */],
    DocumentTemplates: __WEBPACK_IMPORTED_MODULE_26__systems_DocumentTemplates__["a" /* default */],
    DocumentManager: __WEBPACK_IMPORTED_MODULE_27__systems_DocumentManager__["a" /* default */],
    FamilyForm: __WEBPACK_IMPORTED_MODULE_30__employers_applications_FamilyFormEdit__["a" /* default */],
    AddUser: __WEBPACK_IMPORTED_MODULE_31__functions_AddUser__["a" /* default */]
  },
  data: function data() {
    return {
      agent: {},

      candidates: [],
      employers: [],
      employerEmails: [],
      user: {},
      blogposts: [],

      // selector: 'Master Calendar',
      selector: 'Clients',
      selectorOptions: [
      // 'Snapshot',
      'Master Calendar', 'Nannies', 'Clients', 'Jobs', 'Email Templates', 'Document Templates',
      // 'Email Footers',
      'Email Log', 'Interview Templates', 'Resource Manager', 'Administrators', 'Payments'],
      selectorOptions2: ['Nannies',
      // 'Clients',
      'Email Templates', 'Email Log', 'Interview Templates'],
      tab: '',

      statusFilters: [],
      statusOptions: [],
      tagFilters: [],
      // tagOptions: [],
      positionFilters: [],
      liveinoutFilters: [],
      hideRejected: true,
      hideCompleted: true,

      employerStatusFilters: [],
      // employerStatusOptions: [],

      mailingList: [],
      fromEmail: "",
      emailSubject: "",
      emailMessage: "",
      logMessage: true,

      candidateSearch: "",
      clientSearch: "",
      languageSearch: "",
      stateSearch: ""
    };
  },
  created: function created() {
    this.getAgent();
    this.getCandidates();
    this.getEmployers();
    // this.getBlogposts()

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
    }, 3000);

    this.statusOptions = this.$store.getters.statusOptions;
    // this.employerStatusOptions = this.$store.getters.employerStatuses
    // this.tagOptions = this.$store.getters.focusAreas
  },

  computed: {
    filteredCandidates: function filteredCandidates() {
      var _this = this;

      var statusFilteredUsers = [];
      // if (this.countryFilter != 'All') {
      if (this.statusFilters.length > 0) {
        for (var user in this.candidates) {
          // if (focusFilteredUsers[user].country == this.countryFilter) {
          if (this.statusFilters.includes(this.candidates[user].status)) {
            statusFilteredUsers.push(this.candidates[user]);
          }
        }
      } else {
        statusFilteredUsers = this.candidates;
      }

      var positionFilteredUsers = [];
      if (this.positionFilters.length > 0) {
        for (var user in statusFilteredUsers) {
          for (var position in this.positionFilters) {
            if (statusFilteredUsers[user].multiselect2.includes(this.positionFilters[position])) {
              positionFilteredUsers.push(statusFilteredUsers[user]);
              break;
            }
          }
        }
      } else {
        positionFilteredUsers = statusFilteredUsers;
      }

      var rejectionFilteredUsers = [];
      if (this.hideRejected) {
        for (var user in positionFilteredUsers) {
          if (positionFilteredUsers[user].status != 'Rejected') {
            rejectionFilteredUsers.push(positionFilteredUsers[user]);
          }
        }
      } else {
        rejectionFilteredUsers = positionFilteredUsers;
      }

      // Filters by name or Email
      if (this.candidateSearch) {
        rejectionFilteredUsers = rejectionFilteredUsers.filter(function (user) {
          return (user.first_name + ' ' + user.last_name + ' ' + user.email).toLowerCase().includes(_this.candidateSearch.toLowerCase());
        });
      }

      // Filters by language
      if (this.languageSearch) {
        rejectionFilteredUsers = rejectionFilteredUsers.filter(function (user) {
          return user.selector2.toLowerCase().includes(_this.languageSearch.toLowerCase());
        });
      }

      // Filters by state
      if (this.stateSearch) {
        rejectionFilteredUsers = rejectionFilteredUsers.filter(function (user) {
          return user.provincestate.toLowerCase().includes(_this.stateSearch.toLowerCase());
        });
      }

      // Filter by live in or out
      if (this.liveinoutFilters.length > 0) {
        rejectionFilteredUsers = rejectionFilteredUsers.filter(function (user) {
          return _this.liveinoutFilters.includes(user.selector3);
        });
      }

      return rejectionFilteredUsers;
    },
    filteredEmployers: function filteredEmployers() {
      var _this2 = this;

      var statusFilteredUsers = [];
      // if (this.countryFilter != 'All') {
      if (this.employerStatusFilters.length > 0) {
        for (var user in this.employers) {
          // if (focusFilteredUsers[user].country == this.countryFilter) {
          if (this.employerStatusFilters.includes(this.employers[user].status)) {
            statusFilteredUsers.push(this.employers[user]);
          }
        }
      } else {
        statusFilteredUsers = this.employers;
      }

      var rejectionFilteredUsers = [];
      if (this.hideRejected) {
        for (var user in statusFilteredUsers) {
          if (statusFilteredUsers[user].status != 'Inactive' && statusFilteredUsers[user].status != 'Lost') {
            rejectionFilteredUsers.push(statusFilteredUsers[user]);
          }
        }
      } else {
        rejectionFilteredUsers = statusFilteredUsers;
      }

      var completionFilteredUsers = [];
      if (this.hideCompleted) {
        for (var user in rejectionFilteredUsers) {
          if (rejectionFilteredUsers[user].status != 'Placement Fee Paid') {
            completionFilteredUsers.push(rejectionFilteredUsers[user]);
          }
        }
      } else {
        completionFilteredUsers = rejectionFilteredUsers;
      }

      // Filters by name or Email
      if (this.clientSearch) {
        completionFilteredUsers = completionFilteredUsers.filter(function (user) {
          return (user.first_name + ' ' + user.last_name + ' ' + user.email).toLowerCase().includes(_this2.clientSearch.toLowerCase());
        });
      }

      // return this.employers
      return completionFilteredUsers;
    }
  },
  methods: {
    getAgent: function getAgent() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + this.$store.getters.userID).then(function (res) {
        console.log(res);
        _this3.agent = res.data[0];

        if (_this3.agent.category == 'candidates') {
          _this3.selector = 'Nannies';
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCandidates: function getCandidates() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?is_candidate=true&agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res);
        _this4.candidates = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getEmployers: function getEmployers() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?is_employer=true&agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res);
        _this5.employers = res.data;

        _this5.employerEmails = _this5.employers.map(function (employer) {
          return employer.employer_name + ' (' + employer.email + ')';
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },

    // getBlogposts() {
    //   axios.get('/api/blogposts/?agency=4')
    //     .then(res => {
    //       console.log(res)
    //       this.blogposts = res.data
    //     })
    //     .catch(error => console.log(error))
    // },
    showCandidateModal: function showCandidateModal(user) {
      this.user = user;
      this.$modal.show('candidate-modal');
      this.tab = 'profile';
    },
    showEmployerModal: function showEmployerModal(user) {
      this.user = user;
      this.tab = 'application';
      this.$modal.show('employer-modal');
    },
    hideUserModal: function hideUserModal() {
      this.$modal.hide('candidate-modal');
      this.$modal.hide('employer-modal');
    },
    showDeleteUserModal: function showDeleteUserModal(user) {
      this.user = user;
      this.$modal.show('delete-user-modal');
    },
    hideDeleteUserModal: function hideDeleteUserModal() {
      this.$modal.hide('delete-user-modal');
    },
    deleteUser: function deleteUser(user) {
      var _this6 = this;

      console.log('Deleting User: '.concat(user.id.toString()));
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/people/'.concat(user.id.toString()).concat('/')).then(function (res) {
        console.log(res);
        if (user.is_candidate) {
          _this6.getCandidates();
        } else if (user.is_employer) {
          _this6.getEmployers();
        }
        // this.hideDeleteModal()
        // this.closeCandidateModal()
        _this6.$modal.hide('candidate-modal');
        _this6.$modal.hide('employer-modal');
        _this6.hideDeleteUserModal();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    approveUser: function approveUser(user) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(user.id.toString()).concat('/'), {
        status: 'Active'
      }).then(function (res) {
        console.log(res);
        _this7.getEmployers();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    disapproveUser: function disapproveUser(user) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(user.id.toString()).concat('/'), {
        status: 'New'
      }).then(function (res) {
        console.log(res);
        _this8.getEmployers();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    resetPassword: function resetPassword(user) {},
    userUpdated: function userUpdated() {
      this.getCandidates();
      // this.getEmployers()
    },
    updateUser: function updateUser() {
      var _this9 = this;

      this.getEmployers();
      this.getCandidates();

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + this.user.id).then(function (res) {
        _this9.user = res.data[0];
        // this.$modal.hide('employer-application-form-modal')
        _this9.$modal.hide('employer-summary-form-modal');
        // this.$modal.show('employer-modal')
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showEmailModal: function showEmailModal() {
      this.mailingList = this.filteredCandidates.map(function (candidate) {
        return '' + candidate.email;
      });
      this.$modal.show('email-modal');
    },

    // showEmployerApplicationFormModal() {
    //   this.$modal.show('employer-application-form-modal')
    // },
    refresh: function refresh() {
      this.getCandidates();
      this.getEmployers();
    },
    adminify: function adminify(user) {
      var _this10 = this;

      //
      // Function for converting a candidate account into an admin account (just a workaround, not in production use)
      //
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + user.id.toString() + '/', {
        is_agent: true,
        is_candidate: false
      }).then(function (res) {
        console.log(res);
        _this10.getCandidates();
      }).catch(function (error) {
        console.log(error);
      });
    },
    setteam: function setteam(user) {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + user.id.toString() + '/', {
        status: 'team'
        // first_name: 'Annalise',
        // last_name: 'Mathers',
      }).then(function (res) {
        console.log(res);
        _this11.getCandidates();
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeEmail: function changeEmail(user) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + user.id.toString() + '/', {
        // email: 'myrundash@gmail.com'
        email: 'pihcanada@pih.org'
      }).then(function (res) {
        console.log(res);
        _this12.getEmployers();
      }).catch(function (error) {
        console.log(error);
      });
    },
    clearStripeID: function clearStripeID() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.agent.id.toString() + '/', {
        stripe_customer_id: ''
        // stripe_customer_id: 'acct_1GDYUZIcCA8L7IlD',
      }).then(function (res) {
        console.log(res);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateStats: function updateStats() {
      for (var candidate in this.candidates) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.candidates[candidate].id + '/', {
          numberArray: [0, 0, 0, 0]
        });
      }
    },
    sortAlpha: function sortAlpha(userType) {
      // Function sorts candidates/employers by last name

      function compare(a, b) {
        var nameA = a.last_name.toUpperCase();
        var nameB = b.last_name.toUpperCase();

        var comparison = 0;
        if (nameA > nameB) {
          comparison = 1;
        } else if (nameA < nameB) {
          comparison = -1;
        }
        return comparison;
      }

      userType.sort(compare);
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blog_BlogPost__ = __webpack_require__(142);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appBlogPost: __WEBPACK_IMPORTED_MODULE_1__blog_BlogPost__["a" /* default */]
  },
  data: function data() {
    return {
      blogs: [],
      blog: {}
    };
  },

  computed: {
    filteredBlogs: function filteredBlogs() {
      return this.blogs;
    }
  },
  created: function created() {
    this.getBlogs();
  },

  methods: {
    getBlogs: function getBlogs() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogposts/?agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res);
        _this.blogs = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showBlogModal: function showBlogModal(blog) {
      this.blog = blog;
      this.$modal.show('blog-modal');
    },
    hideBlogModal: function hideBlogModal() {
      this.$modal.hide('blog-modal');
    },
    publish: function publish() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogposts/' + this.blog.id.toString() + '/', {
        published: true
      }).then(function (res) {
        console.log(res);
        _this2.getBlogs();
        _this2.hideBlogModal();
      }).catch(function (error) {
        console.log(error);
      });
    },
    unpublish: function unpublish() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogposts/' + this.blog.id.toString() + '/', {
        published: false
      }).then(function (res) {
        console.log(res);
        _this3.getBlogs();
        _this3.hideBlogModal();
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Comments__ = __webpack_require__(830);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'], // We pass the id in to view blog post from the admin dash
  data: function data() {
    return {
      blogPost: {},
      postID: null,
      poster: {},
      related: []
    };
  },

  components: {
    appComments: __WEBPACK_IMPORTED_MODULE_2__Comments__["a" /* default */]
  },
  created: function created() {
    if (this.id) {
      this.postID = this.id;
    } else {
      this.postID = this.$route.params.id;
    }

    this.getPost();
  },

  methods: {
    getPost: function getPost() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogposts/'.concat(this.postID.toString())).then(function (res) {
        // console.log(res.data)
        _this.blogPost = res.data;

        //Changes page title to match blog post title
        document.title = _this.blogPost.title;

        // Need to check if we passed in the id prop, which means we are viewing the post from the admin dash, don't want to re route
        if (!_this.id) {
          //Updates the URL to show the blog post title
          _this.$router.replace({ name: 'Blog Post', params: { id: _this.postID.toString() }, query: { title: _this.blogPost.title.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, ' ').split(/\s+/).join('-') } });
        }

        // axios.get('/api/people/'.concat(this.blogPost.poster.toString()))
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicusers/?id='.concat(_this.blogPost.poster.toString())).then(function (res) {
          // console.log('Got blog poster')
          _this.poster = res.data[0];

          // Find blog posts using author ID
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogposts/?poster='.concat(_this.poster.id.toString())).then(function (res) {
            // Empty container to store additional blog post titles
            var posts = [];
            // A loop to collect every post from the returned data
            for (var i = 0; i < res.data.length; i++) {
              // Create a new object for every article title found
              var article = {};
              article = {
                title: res.data[i].title,
                id: res.data[i].id
                // Conditional to make sure blogs belong to right organization and is not the current article
              };if (res.data[i].agency_owner === "ThriveHire" && res.data[i].id !== _this.blogPost.id) {
                posts.push(article);
              }
            }
            _this.related = posts;
          }).catch(function (error) {
            return console.log(error);
          });
        }).catch(function (error) {
          return console.log(error);
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    editPost: function editPost() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: 'Edit Blog Post', params: { id: this.blogPost.id } });
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['postID', 'blogPost'],
  data: function data() {
    return {
      comments: [],
      unpublishedComments: [],
      commentText: '',
      user: {}
    };
  },
  created: function created() {
    this.getComments();

    if (this.$store.getters.userID) {
      this.getUser();
    }
  },

  methods: {
    getComments: function getComments() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogcomments/?published=true&blog_post=' + this.postID.toString()).then(function (res) {
        console.log(res);
        _this.comments = res.data;
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogcomments/?published=false&blog_post=' + this.postID.toString()).then(function (res) {
        console.log(res);
        _this.unpublishedComments = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getUser: function getUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/' + this.$store.getters.userID.toString()).then(function (res) {
        console.log(res);
        _this2.user = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showCommentModal: function showCommentModal() {
      this.$modal.show('comment-modal');
    },
    hideCommentModal: function hideCommentModal() {
      this.$modal.hide('comment-modal');
    },
    submitComment: function submitComment() {
      var _this3 = this;

      var name = '';
      if (this.user.is_candidate) {
        name = this.user.first_name + ' ' + this.user.last_name;
      }
      if (this.user.is_employer) {
        name = this.user.employer_name;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/blogcomments/', {
        poster: this.$store.getters.userID,
        poster_name: name,
        blog_post: this.postID,
        content: this.commentText,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      }).then(function (res) {
        console.log(res);
        _this3.hideCommentModal();
        _this3.$modal.show('comment-submitted-modal');

        _this3.$store.dispatch('sendEmail', {
          subject: 'New Blog Comment',
          message: 'New comment on blog post with the title: ' + _this3.blogPost.title + '\n' + 'https://www.thrivehire.co/blog-post/' + _this3.blogPost.id.toString() + '\n\n' + _this3.commentText + '\n\nPosted By: ' + name,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          email: 'info@thrivehire.org',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });
        _this3.$store.dispatch('sendEmail', {
          subject: 'New Blog Comment',
          message: 'New comment on blog post with the title: ' + _this3.blogPost.title + '\n' + 'https://www.thrivehire.co/blog-post/' + _this3.blogPost.id.toString() + '\n\n' + _this3.commentText + '\n\nPosted By: ' + name,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          email: 'aakash@enginehire.ca',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    hideCommentSubmittedModal: function hideCommentSubmittedModal() {
      this.$modal.hide('comment-submitted-modal');
    },
    publishComment: function publishComment(comment) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogcomments/' + comment.id.toString() + '/', {
        published: true
      }).then(function (res) {
        console.log(res);
        _this4.getComments();
      }).catch(function (error) {
        console.log(error);
      });
    },
    unpublishComment: function unpublishComment(comment) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogcomments/' + comment.id.toString() + '/', {
        published: false
      }).then(function (res) {
        console.log(res);
        _this5.getComments();
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteComment: function deleteComment(comment) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/blogcomments/' + comment.id.toString() + '/').then(function (res) {
        console.log(res);
        _this6.getComments();
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_ProfileView__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//


 // Validators pre built into vuelidate - lecture 373


// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userID'],
  data: function data() {
    var _ref;

    return _ref = {
      editing: false,

      user: {},
      // users: [],
      currentStep: 1,

      summary: '',
      profilePic: '',
      name: '',
      firstName: '',
      lastName: '',
      phone: '',
      city: '',
      provinceState: '',
      // cities: ['Bogotá', 'Medellin', 'Cali', 'Barranquilla', 'Cartagena', 'Cúcuta', 'Soledad', 'Ibagué', 'Soacha', 'Bucaramanga'],
      country: '',
      address1: '',
      address2: '',
      postalCode: '',

      organizationTypes: [],
      organizationTypesOptions: [],
      focusAreas: [],
      focusAreasOptions: [],
      skills: [],
      skillsOptions: [],
      // organizationStatures: [],
      // organizationStaturesOptions: [],
      sizes: [],
      sizesOptions: [],
      countries: [],
      countriesOptions: [],
      salaryRange: '',
      salaryRangeOptions: [],
      jobTypes: [],
      jobTypesOptions: [],

      pep: null,
      experiences: [],
      availability: [],
      title: '',
      reference: '',
      step1saveClicked: false,
      step2saveClicked: false
    }, _defineProperty(_ref, 'title', ''), _defineProperty(_ref, 'randomRenderer', []), _defineProperty(_ref, 'resume', ''), _ref;
  },

  components: {
    appProfileView: __WEBPACK_IMPORTED_MODULE_2__profile_ProfileView__["a" /* default */]
  },
  validations: { // Lecture 373
    // name: {
    //   required,
    // },
    firstName: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    lastName: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    // phone: {
    //   required,
    // },
    city: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    country: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    address1: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    postalCode: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      // address2: {
      //   required,
      // },
      // pep: {
      //   required,
      //   numeric,
      // },
    } },
  computed: {
    auth: function auth() {
      // Lecture 363
      return this.$store.getters.isAuthenticated;
    }
  },
  created: function created() {
    if (!this.userID) {
      // Don't want to scroll the page up if viewing the profile via the admin dashboard
      // Scroll the window up
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    }

    this.getUser();

    this.sizesOptions = this.$store.getters.organizationSizes;
    this.organizationTypesOptions = this.$store.getters.organizationTypes;
    this.focusAreasOptions = this.$store.getters.focusAreas;
    this.countriesOptions = this.$store.getters.countries;
    this.skillsOptions = this.$store.getters.skills;
    this.salaryRangeOptions = this.$store.getters.salaryRanges;
    this.jobTypesOptions = this.$store.getters.jobTypes;
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  methods: {
    getUser: function getUser() {
      var _this = this;

      var userID = null;
      if (this.userID) {
        userID = this.userID;
      } else {
        userID = this.$store.getters.userID;
      }
      // console.log(this.$store.getters.userID)

      // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + userID.toString()).then(function (res) {
        // console.log(res)
        _this.user = res.data[0];

        _this.summary = _this.user.overview;
        // this.name = this.user.name
        _this.firstName = _this.user.first_name;
        _this.lastName = _this.user.last_name;
        _this.phone = _this.user.phone;
        _this.city = _this.user.city;
        _this.provinceState = _this.user.provincestate;
        _this.country = _this.user.country;
        _this.postalCode = _this.user.postal_code;
        _this.address1 = _this.user.address1;
        _this.address2 = _this.user.address2;

        _this.skills = _this.user.skills;
        _this.focusAreas = _this.user.sectors;
        _this.jobTypes = _this.user.job_types;
        _this.organizationTypes = _this.user.preferences3;
        _this.countries = _this.user.preferences2;
        _this.sizes = _this.user.preferences;

        _this.salaryRange = _this.user.salary_range;

        // The idea here is the first time someone logs in, or if they haven't yet filled in step 1, they should immediately be in edit mode
        // if (!this.firstName) {
        //   this.editing = true
        // }
      }).catch(function (error) {
        return console.log(error);
      });
    },

    // https://serversideup.net/uploading-files-vuejs-axios/
    handleFileUpload: function handleFileUpload() {
      this.profilePic = this.$refs.profile_pic.files[0];
      this.resume = this.$refs.resume.files[0];
    },
    saveStep1: function saveStep1() {
      var _this2 = this;

      console.log('Saving Step 1');
      // $v.name.$touch();
      this.$v.$touch();
      // this.step1saveClicked = true
      // console.log(this.$store.getters.userAPIURL)
      // axios.patch(this.$store.getters.userAPIURL, {name: this.name})
      //   .then(res => console.log(res))
      //   .catch(error => console.log(error))

      // Only write to the database if all the fields have been filled
      // pep needs to be filled and be a number - https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
      // if (this.name && this.city && this.country && this.address1 && this.pep && !isNaN(this.pep)) {
      // if (!this.$v.firstName.$error && !this.$v.lastName.$error && !this.$v.address1.$error && !this.$v.city.$error && !this.$v.country.$error && !this.$v.postalCode.$error) {
      if (!this.$v.firstName.$error && !this.$v.lastName.$error) {

        console.log(this.user.status);
        var new_status = this.user.status;
        if (this.user.status == '' || this.user.status == 'New') {
          // We only want to update the status if the user is at an earlier status
          new_status = 'Personal Information';
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(this.user.id.toString()).concat('/'), {
          // name: this.name,
          overview: this.summary,
          first_name: this.firstName,
          last_name: this.lastName,
          phone: this.phone,
          city: this.city,
          provincestate: this.provinceState,
          country: this.country,
          address1: this.address1,
          address2: this.address2,
          postal_code: this.postalCode,
          status: new_status,

          skills: this.skills,
          job_types: this.jobTypes,
          sectors: this.focusAreas,
          preferences: this.sizes,
          preferences2: this.countries,
          preferences3: this.organizationTypes,

          salary_range: this.salaryRange
        }).then(function (res) {
          console.log('Step 1 Saved');
          console.log(res);

          var formData = new FormData();
          if (_this2.profilePic) {
            formData.append('profile_pic', _this2.profilePic);
          }
          if (_this2.resume) {
            formData.append('resume', _this2.resume);
          }

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(_this2.user.id.toString()).concat('/'), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (res) {
            // Scroll the window back up after saving the step
            window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

            _this2.getUser();
            _this2.editing = false;

            // https://www.npmjs.com/package/vue-loading-overlay
            var loader = _this2.$loading.show({
              // Optional parameters
              container: _this2.fullPage ? null : _this2.$refs.formContainer,
              // container: this.$refs.formContainer,
              // canCancel: true,
              canCancel: false
              // onCancel: this.onCancel,
            });
            // simulate AJAX
            setTimeout(function () {
              loader.hide();
            }, 2000);
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          return console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['user'],
  props: ['userID'],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */]
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      description: '',
      descriptionEditor: null,

      richField2: '',
      richEditor2: null,

      user: {},

      score: null,
      scores: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.description = getHTML();
      }
    });

    this.richEditor2 = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref2) {
        var getJSON = _ref2.getJSON,
            getHTML = _ref2.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.richField2 = getHTML();
      }
    });

    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h5>1. Family Name</h5><p></p><hr>\
    //     <h5>2. Family Address</h5><p></p><hr>\
    //     <h5>3. Mom’s full name / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>4. Dad’s full name  / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>5. Children’s Full Name & Birthday</h5><p></p><hr>\
    //     <h5>6. Allergies / Special Needs regarding the children</h5><p></p><hr>\
    //     <h5>7. Pets (kind – temperament – indoor/outdoor – care needed)</h5><p></p><hr>\
    //     <h5>8. Children’s interests/hobbies</h5><p></p><hr>\
    //     <h5>9. Behaviour modification strategies</h5><p></p><hr>\
    //     <h5>10. Emergency contact (name, relation & number)</h5><p></p><hr>\
    //     <h5>11. Days & Times required</h5><p></p><hr>\
    //     <h5>12. Start day/end day (contract duration)</h5><p></p><hr>\
    //     <h5>13. Driver’s license/vehicle required?</h5><p></p><hr>\
    //     <h5>14. Open to the Nanny taking the children to activities?</h5><p></p><hr>\
    //     <h5>15. Car Seats provided?</h5><p></p><hr>\
    //     <h5>16. Expectations for your Nanny</h5><p></p><hr>\
    //     <h5>17. Daily Routine for the Nanny</h5><p></p><hr>\
    //     <h5>Process going forward: </h5><p>Medical Release & Transportation Consent must be completed prior to the first shift</p><p>Client to email dates and times – 1-2 weeks in advance</p><p></p><hr>\
    //     <h5>TNC</h5><p>Communication Log to be completed & sent with first shift</p><p>Once the shift is filled send the NOC profile to client</p><p>Build the NOC Family spec sheet – send to Nanny </p><p></p><hr>\
    //     '
    //   )
    // }
    this.getUser();
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
    this.richEditor2.destroy();
  },
  created: function created() {
    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h4>1. Family Name</h4><p></p><hr>\
    //     '
    //   )
    // }
  },

  methods: {
    getUser: function getUser() {
      var _this2 = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2000);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + this.userID).then(function (res) {
        _this2.user = res.data[0];

        if (_this2.user.richtext1) {
          _this2.descriptionEditor.setContent(_this2.user.richtext1);
          _this2.description = _this2.user.richtext1;
        } else {
          // this.descriptionEditor.setContent(
          //   '<h5>Why do you want to be a nanny?</h5><p></p><hr>\
          //   <h5>How would your best friend describe your personality?</h5><p></p><hr>\
          //   '
          // )

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/richtemplates/?agency=' + _this2.$store.getters.agencyID + '&selector2=Candidate Interview 1').then(function (res) {
            console.log(res);
            if (res.data.length) {
              _this2.descriptionEditor.setContent(res.data[0].body);
            } else {
              _this2.descriptionEditor.setContent('');
            }
          });
        }

        if (_this2.user.richtext2) {
          _this2.richEditor2.setContent(_this2.user.richtext2);
          _this2.richField2 = _this2.user.richtext2;
        } else {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/richtemplates/?agency=' + _this2.$store.getters.agencyID + '&selector2=Candidate Interview 2').then(function (res) {
            console.log(res);
            if (res.data.length) {
              _this2.richEditor2.setContent(res.data[0].body);
            } else {
              _this2.richEditor2.setContent('');
            }
          });
        }

        _this2.score = _this2.user.integer1;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    save: function save() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        richtext1: this.description,
        richtext2: this.richField2,
        integer1: this.score
      }).then(function (res) {
        console.log(res);
        _this3.getUser();
        _this3.$modal.show('notes-saved-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blog_BlogPost__ = __webpack_require__(142);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appBlogPost: __WEBPACK_IMPORTED_MODULE_1__blog_BlogPost__["a" /* default */]
  },
  data: function data() {
    return {
      events: [],
      event: {}
    };
  },

  computed: {
    filteredEvents: function filteredEvents() {
      return this.events;
    }
  },
  created: function created() {
    this.getEvents();
  },

  methods: {
    getEvents: function getEvents() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/events/?agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res);
        _this.events = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Panel__ = __webpack_require__(311);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Panel: __WEBPACK_IMPORTED_MODULE_1__Panel__["a" /* default */]
  },
  data: function data() {
    return {
      agents: {},
      agent: {},
      tab: '',

      email: '',
      firstName: '',
      lastName: '',
      categories: ['global', 'candidates'],
      category: ''
    };
  },
  created: function created() {
    this.getAgents();
  },

  methods: {
    getAgents: function getAgents() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?is_agent=true&agency=' + this.$store.getters.agencyID.toString()).then(function (res) {
        console.log(res);
        _this.agents = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    setteam: function setteam(user) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + user.id.toString() + '/', {
        status: 'team'
      }).then(function (res) {
        console.log(res);
        _this2.getAgents();
      }).catch(function (error) {
        console.log(error);
      });
    },
    showAgentModal: function showAgentModal(agent) {
      this.agent = agent;
      this.tab = 'admin';
      this.$modal.show('admin-panel-modal');
    },
    showAddAdminModal: function showAddAdminModal() {
      this.email = '';
      this.category = '';
      this.$modal.show('add-admin-modal');
    },
    unadminify: function unadminify(user) {
      var _this3 = this;

      //
      // Function for converting an admin account into a candidate account (just a workaround, not in production use)
      //
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + user.id.toString() + '/', {
        is_agent: false,
        is_candidate: true
      }).then(function (res) {
        console.log(res);
        _this3.getAgents();
      }).catch(function (error) {
        console.log(error);
      });
    },
    setCategory: function setCategory(user) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + user.id.toString() + '/', {
        category: 'global'
        // category: 'candidates'
      }).then(function (res) {
        console.log(res);
        _this4.getAgents();
      }).catch(function (error) {
        console.log(error);
      });
    },
    addAdmin: function addAdmin() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/create-user/', {
        email: this.email,
        password: this.email,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(res.data.pk.toString()) + '/', {
          agency: _this5.$store.getters.agencyID,
          agency_owner: _this5.$store.getters.agencyName,
          // user_type: authData.user_type,
          // is_employer: this.is_employer,
          // is_candidate: this.is_candidate,
          is_agent: true,
          // status: 'New',
          // status: authData.status,
          // numberArray: [0, 0, 0, 0],
          category: _this5.category,
          first_name: _this5.firstName,
          last_name: _this5.lastName
        }).then(function (res) {
          console.log(res);

          _this5.getAgents();
          _this5.$modal.hide('add-admin-modal');
        }).catch(function (error) {
          return console.log(error);
        });
      });
    },
    setPassword: function setPassword(user) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/optimum/manual-reset-password/', {
        user_id: user.id,
        password: 'ChyanneRox@2020'
      }).then(function (res) {
        console.log(res);
        // this.$modal.show('password-reset-modal')
      }).catch(function (error) {
        console.log(error);
      });
    },
    showDeleteUserModal: function showDeleteUserModal(user) {
      this.agent = user;
      this.$modal.show('delete-agent-modal');
    },
    hideDeleteUserModal: function hideDeleteUserModal() {
      this.$modal.hide('delete-agent-modal');
    },
    deleteUser: function deleteUser(user) {
      var _this6 = this;

      console.log('Deleting User: '.concat(user.id.toString()));
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/people/'.concat(user.id.toString()).concat('/')).then(function (res) {
        console.log(res);
        // if (user.is_candidate) {
        //   this.getCandidates()
        // }
        // else if (user.is_employer) {
        //   this.getEmployers()
        // }
        _this6.getAgents();

        // this.hideDeleteModal()
        // this.closeCandidateModal()
        // this.$modal.hide('candidate-modal')
        _this6.$modal.hide('admin-panel-modal');
        _this6.hideDeleteUserModal();
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panel_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05eeaf2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panel_vue__ = __webpack_require__(845);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05eeaf2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions_InterviewScheduler__ = __webpack_require__(843);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['passedUser'],
  components: {
    InterviewScheduler: __WEBPACK_IMPORTED_MODULE_1__functions_InterviewScheduler__["a" /* default */]
  },
  data: function data() {
    return {
      agency: {},

      user: {},
      status: '',
      statuses: [],
      tags: [],
      tagsOptions: [],

      notes: [],
      note: {},
      noteText: '',
      noteType: '',

      fromEmail: '',
      emailSubject: "",
      emailMessage: "",
      textMessage: "",
      logMessage: true,

      password: ''
    };
  },
  created: function created() {
    this.user = this.passedUser;

    if (this.user.is_candidate) {
      this.statuses = this.$store.getters.candidateStatuses;
      // this.fromEmail = this.$store.getters.agencyFromEmail
      this.fromEmail = this.$store.getters.agencyAdminEmail2;
    }

    if (this.user.is_employer) {
      this.statuses = this.$store.getters.employerStatuses;
      this.fromEmail = this.$store.getters.agencyFromEmail;
    }

    this.getNotes();
    // this.fromEmail = this.$store.getters.agencyFromEmail
    this.status = this.user.status;
    this.tagsOptions = this.$store.getters.focusAreas;
    this.tags = this.user.sectors;

    this.getAgency();
  },

  methods: {
    getAgency: function getAgency() {
      // axios.get()
    },
    updateTags: function updateTags() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        sectors: this.tags
      }).then(function (res) {
        _this.user.sectors = _this.tags;
        _this.$emit('userUpdated'); // Lecture 112
      });
    },
    getNotes: function getNotes() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/notes?user=' + this.user.id).then(function (res) {
        _this2.notes = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showAddNoteModal: function showAddNoteModal() {
      this.note = {};
      this.noteText = '';
      this.$modal.show('note-modal');
    },
    showEditNoteModal: function showEditNoteModal(note) {
      this.note = note;
      this.noteText = note.note;
      this.$modal.show('note-modal');
    },
    hideNoteModal: function hideNoteModal() {
      this.note = {};
      this.noteText = '';
      this.$modal.hide('note-modal');
    },
    addNote: function addNote() {
      var _this3 = this;

      console.log(this.user.id);
      console.log(this.$store.getters.userID);
      console.log(this.noteText);
      console.log(this.$store.getters.agencyName);
      console.log(this.$store.getters.agencyID);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/notes/', {
        user: this.user.id,
        enterer: this.$store.getters.userID,
        note: this.noteText,
        type: this.noteType,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        console.log(res);
        _this3.hideNoteModal();
        _this3.getNotes();
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateNote: function updateNote() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/notes/' + this.note.id + '/', {
        note: this.noteText
      }).then(function (res) {
        console.log(res);
        _this4.hideNoteModal();
        _this4.getNotes();
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteNote: function deleteNote() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/notes/' + this.note.id + '/').then(function (res) {
        console.log(res);
        _this5.hideNoteModal();
        _this5.getNotes();
      }).catch(function (error) {
        console.log(error);
      });
    },
    sendEmail: function sendEmail() {
      this.$modal.show('message-sent-modal');

      this.$store.dispatch('sendEmails', {
        subject: this.emailSubject,
        message: this.emailMessage,
        from: this.fromEmail,
        emails: [this.$store.getters.enginehireLoggingEmail, this.user.email],
        reply: this.fromEmail,
        userID: this.user.id
      });
      this.user.last_contacted_date = new Date();
      if (this.logMessage) {
        this.noteType = 'Email';
        this.noteText = 'Subject: ' + this.emailSubject + '\n\n' + this.emailMessage;
        this.addNote();
        this.emailSubject = '';
        this.emailMessage = '';
      } else {
        this.emailSubject = '';
        this.emailMessage = '';
      }

      // axios
      //   .post("/optimum/email/", {
      //     subject: this.emailSubject,
      //     message: this.emailMessage,
      //     from_address: this.fromEmail,
      //     to_address: this.user.email,
      //     reply_address: this.fromEmail,
      //     user_id: this.user.id
      //   })
      //   .then(res => {
      //     console.log(res);
      //     this.user.last_contacted_date = new Date()

      //     if (this.logMessage) {
      //       this.noteType = 'Email'
      //       this.noteText = 'Subject: ' + this.emailSubject + '\n\n' + this.emailMessage
      //       this.addNote()
      //       this.emailSubject = ''
      //       this.emailMessage = ''
      //     }
      //     else {
      //       this.emailSubject = ''
      //       this.emailMessage = ''
      //     }
      //   })
      //   .catch(error => console.log(error));
    },
    sendSMS: function sendSMS() {
      var _this6 = this;

      this.$modal.show('message-sent-modal');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/optimum/message/", {
        message: this.textMessage,
        phone: this.user.phone,
        user_id: this.user.id
      }).then(function (res) {
        console.log(res);
        _this6.user.last_contacted_date = new Date();

        if (_this6.logMessage) {
          _this6.noteType = 'SMS';
          _this6.noteText = _this6.textMessage;
          _this6.addNote();
          _this6.textMessage = '';
        } else {
          _this6.textMessage = '';
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    updateStatus: function updateStatus() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        status: this.status
      }).then(function (res) {
        _this7.user.status = _this7.status;
        _this7.$emit('userUpdated'); // Lecture 112

        _this7.$modal.show('status-updated-modal');

        var selector1 = '';
        if (_this7.user.is_candidate) {
          selector1 = 'Candidate';
        } else if (_this7.user.is_employer) {
          selector1 = 'Employer';
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emailtemplates/?agency=' + _this7.$store.getters.agencyID + '&status=' + _this7.status + '&type=Status Change Notification&selector1=' + selector1 + '&deactivated=false') // Get the email template corresponding to the new status
        .then(function (res) {
          console.log(res);
          if (res.data.length) {
            // If there is an email template for this new status
            var emailTemplate = res.data[0];

            var agencyEmail = '';
            if (emailTemplate.from_email) {
              agencyEmail = emailTemplate.from_email;
            } else {
              agencyEmail = _this7.$store.getters.agencyAdminEmail;
              // if (this.user.is_candidate) {
              //   agencyEmail = this.$store.getters.agencyAdminEmail3
              // }
            }
            console.log(agencyEmail);
            // let agencyEmail = this.$store.getters.agencyFromEmail

            console.log(emailTemplate);
            // if (emailTemplate.type == 'Status Change Notification') { // If the email template triggers on
            _this7.$store.dispatch('sendEmails', {
              subject: emailTemplate.subject,
              message: emailTemplate.body.replace('[[fname]]', _this7.user.first_name), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
              // from: this.$store.getters.agencyFromEmail,
              from: agencyEmail,
              emails: [_this7.$store.getters.enginehireLoggingEmail, _this7.user.email],
              // reply: this.$store.getters.agencyReplyEmail,
              reply: agencyEmail,
              userID: _this7.user.id,
              html: true
            });
            // }
          }
        }).catch(function (error) {
          return console.log(error);
        });

        // Get any document templates that trigger on a change to this status
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/documenttemplates/?agency=' + _this7.$store.getters.agencyID + '&status_trigger=' + _this7.status + '&type=' + selector1).then(function (res) {
          console.log(res);
          var templates = res.data;
          for (var template in templates) {
            // axios.get(`/api/documents/?signing_user=${this.user.id}&title=${templates[template].name}`)
            //   .then(res => {
            //     console.log(res)
            //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
            //       // console.log(this.$store.getters.transportationConsent)

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/documents/', {
              template: templates[template].id,
              title: templates[template].name,
              signing_user: _this7.user.id,
              status: 'Unsigned',
              // field1: `${this.user.first_name} ${this.user.last_name} & ${this.user.features[0]} ${this.user.features[1]}`,
              // field2: children,
              body: templates[template].body,
              fields_labels: templates[template].fields,
              fields_required: templates[template].fields_required,
              edit_access: templates[template].edit_access,
              organization_signer: templates[template].organization_signer,
              signer_labels: templates[template].signer_labels,
              agency_owner: _this7.$store.getters.agencyName,
              agency: _this7.$store.getters.agencyID
            }).then(function (res) {
              console.log(res);
            }).catch(function (error) {
              console.log(error);
            });
            //   }
            // })
            // .catch(error => console.log(error))
          }
        }).catch(function (error) {
          return console.log(error);
        });
      });
    },
    updatePassword: function updatePassword() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/optimum/manual-reset-password/', {
        user_id: this.user.id,
        password: this.password
      }).then(function (res) {
        console.log(res);
        _this8.$modal.show('password-reset-modal');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // https://www.npmjs.com/package/vuejs-datepicker

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      date: null,
      time: '',
      interview: null,

      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: 1,
      // endMinute: '00',
      // endTime: null,
      // endAMPM: 'AM',
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM']
    };
  },

  computed: {
    disabledDates: function disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      var today = new Date();
      var disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
      return disabledDates;
    }
  },
  created: function created() {
    // this.date = this.user.date1
    // this.time = this.user.text16
    this.interview = this.user.interview;
  },

  methods: {
    setInterview: function setInterview() {
      var _this = this;

      this.startHour = parseInt(this.startHour);
      if (this.startHour == 12) {
        this.startHour -= 12;
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        console.log(this.startHour);
        this.startHour += 12;
        console.log(this.startHour);
      }
      this.startHour = ("0" + this.startHour).slice(-2);
      console.log(this.startHour);

      var interview = this.dateInDjangoFormat(this.date) + 'T' + this.startHour + ':' + this.startMinute + ':00';

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        // interview: this.date,
        interview: interview
      }).then(function (res) {
        // this.interview = this.date
        _this.interview = interview;
      });
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mailingList: []
    };
  },
  created: function created() {
    this.getMailingList();
  },

  methods: {
    getMailingList: function getMailingList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/mailinglist/?agency=' + this.$store.getters.agencyID.toString()).then(function (res) {
        console.log(res);
        _this.mailingList = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(93);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['employers'],
  data: function data() {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      startHour: 'HH',
      startMinute: 'MM',
      startTime: null,
      endHour: 'HH',
      endMinute: 'MM',
      endTime: null,

      hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],

      events: [{ id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family' }, { id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family' }, { id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family' }]
    };
  },

  components: {
    CalendarView: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarView"],
    CalendarViewHeader: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarViewHeader"]
  },
  methods: {
    setShowDate: function setShowDate(d) {
      this.showDate = d;
    },
    onClickDate: function onClickDate(d) {
      console.log('date clicked');
      console.log(d);
      this.selectedDate = d;

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    postJob: function postJob() {
      console.log('Posting job');
      this.events.push({ id: 4, startDate: this.selectedDate, title: 'Enginehire Family' });
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      children: []
    };
  },
  created: function created() {
    this.getChildren();
  },

  methods: {
    // update() {
    //   axios.patch(`/api/people/${this.user.id}/`, {
    //     address1: '47 Hove St',
    //     city: 'Toronto',
    //     postal_code: 'M3H 4Y8'
    //   })
    //     .catch(error => console.log(error))
    // },
    getChildren: function getChildren() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/children/?user=' + this.user.id).then(function (res) {
        _this.children = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['user'],
  props: ['userID'],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */]
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      description: '',
      descriptionEditor: null,

      richField2: '',
      richEditor2: null,

      user: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.description = getHTML();
      }
    });

    this.richEditor2 = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref2) {
        var getJSON = _ref2.getJSON,
            getHTML = _ref2.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.richField2 = getHTML();
      }
    });

    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h5>1. Family Name</h5><p></p><hr>\
    //     <h5>2. Family Address</h5><p></p><hr>\
    //     <h5>3. Mom’s full name / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>4. Dad’s full name  / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>5. Children’s Full Name & Birthday</h5><p></p><hr>\
    //     <h5>6. Allergies / Special Needs regarding the children</h5><p></p><hr>\
    //     <h5>7. Pets (kind – temperament – indoor/outdoor – care needed)</h5><p></p><hr>\
    //     <h5>8. Children’s interests/hobbies</h5><p></p><hr>\
    //     <h5>9. Behaviour modification strategies</h5><p></p><hr>\
    //     <h5>10. Emergency contact (name, relation & number)</h5><p></p><hr>\
    //     <h5>11. Days & Times required</h5><p></p><hr>\
    //     <h5>12. Start day/end day (contract duration)</h5><p></p><hr>\
    //     <h5>13. Driver’s license/vehicle required?</h5><p></p><hr>\
    //     <h5>14. Open to the Nanny taking the children to activities?</h5><p></p><hr>\
    //     <h5>15. Car Seats provided?</h5><p></p><hr>\
    //     <h5>16. Expectations for your Nanny</h5><p></p><hr>\
    //     <h5>17. Daily Routine for the Nanny</h5><p></p><hr>\
    //     <h5>Process going forward: </h5><p>Medical Release & Transportation Consent must be completed prior to the first shift</p><p>Client to email dates and times – 1-2 weeks in advance</p><p></p><hr>\
    //     <h5>TNC</h5><p>Communication Log to be completed & sent with first shift</p><p>Once the shift is filled send the NOC profile to client</p><p>Build the NOC Family spec sheet – send to Nanny </p><p></p><hr>\
    //     '
    //   )
    // }
    this.getUser();
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
    this.richEditor2.destroy();
  },
  created: function created() {
    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h4>1. Family Name</h4><p></p><hr>\
    //     '
    //   )
    // }
  },

  methods: {
    getUser: function getUser() {
      var _this2 = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2000);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + this.userID).then(function (res) {
        _this2.user = res.data[0];

        if (_this2.user.richtext1) {
          _this2.descriptionEditor.setContent(_this2.user.richtext1);
          _this2.description = _this2.user.richtext1;
        } else {
          // this.descriptionEditor.setContent(
          //   '<h5>Why do you want to be a nanny?</h5><p></p><hr>\
          //   <h5>How would your best friend describe your personality?</h5><p></p><hr>\
          //   '
          // )

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/richtemplates/?agency=' + _this2.$store.getters.agencyID + '&selector2=Client Interview 1').then(function (res) {
            console.log(res);
            if (res.data.length) {
              _this2.descriptionEditor.setContent(res.data[0].body);
            } else {
              _this2.descriptionEditor.setContent('');
            }
          });
        }

        if (_this2.user.richtext2) {
          _this2.richEditor2.setContent(_this2.user.richtext2);
          _this2.richField2 = _this2.user.richtext2;
        } else {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/richtemplates/?agency=' + _this2.$store.getters.agencyID + '&selector2=Client Interview 2').then(function (res) {
            console.log(res);
            if (res.data.length) {
              _this2.richEditor2.setContent(res.data[0].body);
            } else {
              _this2.richEditor2.setContent('');
            }
          });
        }
      });
    },
    save: function save() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.user.id + '/', {
        richtext1: this.description,
        richtext2: this.richField2
      }).then(function (res) {
        console.log(res);
        _this3.getUser();
        _this3.$modal.show('notes-saved-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['users', 'statuses'],
    data: function data() {
        return {
            //statArray will be a multi dimensional array [[status1,[users in status1],], [status2,users in status2]...]
            statArray: [],
            total: 0
        };
    },
    created: function created() {
        //each element in statusArray is another array where the first element is the status name and second element is an array of users associated with that status
        for (var status in this.statuses) {
            this.statArray.push([this.statuses[status], []]);
        };
        for (var user in this.users) {
            for (var stat in this.statuses) {
                if (this.users[user].status == this.statuses[stat]) {
                    this.statArray[stat][1].push(this.users[user]);
                    break;
                }
            }
        }

        this.total = 0;

        for (var item in this.statArray) {
            this.total += this.statArray[item][1].length;
        }

        console.log("total is " + this.total);
        console.log(this.statArray);
    }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['recipient'],
  data: function data() {
    return {
      emails: [],
      email: {}
    };
  },
  created: function created() {
    this.getEmails();
  },

  methods: {
    getEmails: function getEmails() {
      var _this = this;

      if (this.recipient) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emaillogs/?agency=' + this.$store.getters.agencyID + '&recipient=' + this.recipient.id).then(function (res) {
          // console.log(res)
          _this.emails = res.data;
          _this.emails = _this.emails.sort(function (a, b) {
            return a.timestamp < b.timestamp ? 1 : -1;
          });
        }).catch(function (error) {
          return console.log(error);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emaillogs/?agency=' + this.$store.getters.agencyID).then(function (res) {
          // console.log(res)
          _this.emails = res.data;
          _this.emails = _this.emails.sort(function (a, b) {
            return a.timestamp < b.timestamp ? 1 : -1;
          });
        }).catch(function (error) {
          return console.log(error);
        });
      }
    },
    showEmailModal: function showEmailModal(email) {
      this.email = email;
      this.$modal.show('email-details-modal');
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Map_vue__ = __webpack_require__(135);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(93);



/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['user'],
  components: {
    CalendarView: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarView"],
    CalendarViewHeader: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarViewHeader"],
    appMap: __WEBPACK_IMPORTED_MODULE_2__global_Map_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      // startHour: 'HH',
      // startMinute: 'MM',
      // startHour: '01',
      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: '01',
      endHour: 1,
      endMinute: '00',
      endTime: null,
      endAMPM: 'AM',

      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // hourOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      // hourOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM'],

      // events: [{id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family'}, {id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family'}, {id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family'}],

      jobs: [],
      calendarJobs: [],
      job: {},
      jobPoster: {},

      applications: [],

      status: '',
      statuses: [],

      candidates: [],
      candidateEmails: [],
      selectedCandidates: [],

      filterFamilyOptions: [],
      filterNannyOptions: [],
      filterNanny: [],
      filterFamily: [],
      filterStatus: [],
      filterStart: '',
      filterEnd: '',

      candidateSelection: '',

      tab: 'month'
    };
  },
  created: function created() {
    // this.getJobs() // Going to get the jobs initially in the getCandidates method so that the candidates load first, so we can sort jobs by candidate
    this.getCandidates();
    this.statuses = this.$store.getters.jobStatuses;
  },

  methods: {
    setShowDate: function setShowDate(d) {
      this.showDate = d;
    },
    onClickDate: function onClickDate(d) {
      console.log('date clicked');
      console.log(d);
      this.selectedDate = d;

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    onClickEvent: function onClickEvent(event) {
      var _this = this;

      console.log(event);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/jobs/?id=" + event.id).then(function (res) {
        console.log(res);
        _this.job = res.data[0];
        _this.status = _this.job.status;

        _this.getApplications(_this.job);
        // axios.get(`/api/jobapplications/?job=${this.job.id}`)
        //   .then(res => {
        //     console.log(res)
        //     this.applications = res.data

        //     this.$modal.show('job-modal')
        //   })
        //   .catch(error => console.log(error))
        _this.getJobPoster();
        _this.$modal.show('job-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getJob: function getJob(jobID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/jobs/?id=" + jobID).then(function (res) {
        console.log(res);
        _this2.job = res.data[0];
        _this2.status = _this2.job.status;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getJobPoster: function getJobPoster() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/people/?id=" + this.job.poster).then(function (res) {
        _this3.jobPoster = res.data[0];
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getJobs: function getJobs() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/jobs/?agency=" + this.$store.getters.agencyID + "&job_type=Short Term").then(function (res) {
        console.log(res);
        _this4.jobs = res.data;
        _this4.jobs = _this4.jobs.sort(function (a, b) {
          return a.date < b.date ? 1 : -1;
        });

        _this4.calendarJobs = [];

        for (var job in _this4.jobs) {
          // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
          // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          if (!_this4.filterFamilyOptions.includes(_this4.jobs[job].poster_name)) {
            _this4.filterFamilyOptions.push(_this4.jobs[job].poster_name);
          }
          _this4.filterFamilyOptions = _this4.filterFamilyOptions.sort();

          // If the job is filled, get the candidate who is filling the job
          var candidate = null;
          if (_this4.jobs[job].filler) {
            candidate = _this4.candidates.filter(function (element) {
              return element.id == _this4.jobs[job].filler;
            })[0];
          }

          if (_this4.jobs[job].status == 'Requested') {
            _this4.calendarJobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #ff6969; background-color: #ff6969;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + ")" });
          } else if (_this4.jobs[job].status == 'Pending') {
            _this4.calendarJobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + ")" });
          } else if (_this4.jobs[job].status == 'Assigned') {
            _this4.calendarJobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; ', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + " - " + _this4.jobs[job].filler_name + ")" });
            // let candidate = this.candidates.filter(element => {
            //   return element.id == this.jobs[job].filler;
            // })[0];
            // console.log(candidate)
            // console.log(this.candidates.indexOf(candidate))
            // console.log(this.candidates[this.candidates.indexOf(candidate)])

            if (candidate) {
              _this4.candidates[_this4.candidates.indexOf(candidate)].jobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; ', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + ")" });
            }
          } else if (_this4.jobs[job].status == 'In Progress') {
            _this4.calendarJobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + " - " + _this4.jobs[job].filler_name + ")" });
            // let candidate = this.candidates.filter(element => {
            //   return element.id == this.jobs[job].filler;
            // })[0];

            if (candidate) {
              _this4.candidates[_this4.candidates.indexOf(candidate)].jobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + ")" });
            }
          } else if (_this4.jobs[job].status == 'Completed') {
            _this4.calendarJobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + " - " + _this4.jobs[job].filler_name + ")" });

            if (candidate) {
              _this4.candidates[_this4.candidates.indexOf(candidate)].jobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + ")" });
            }
          } else if (_this4.jobs[job].status == 'Approved') {
            _this4.calendarJobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + " - " + _this4.jobs[job].filler_name + ")" });

            if (candidate) {
              _this4.candidates[_this4.candidates.indexOf(candidate)].jobs.push({ 'id': _this4.jobs[job].id, 'startDate': _this4.jobs[job].date + " " + _this4.jobs[job].start_time, 'endDate': _this4.jobs[job].date + " " + _this4.jobs[job].end_time, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': _this4.jobs[job].poster_name + " " + _this4.djangotimeformatAMPM(_this4.jobs[job].start_time) + " - " + _this4.djangotimeformatAMPM(_this4.jobs[job].end_time) + " (" + _this4.jobs[job].status + ")" });
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getApplications: function getApplications(job) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/jobapplications/?job=" + job.id).then(function (res) {
        console.log(res);
        _this5.applications = res.data;

        // this.$modal.show('job-modal')
      }).catch(function (error) {
        return console.log(error);
      });
    },
    refreshApplications: function refreshApplications() {
      this.getApplications(this.job);
    },
    postJob: function postJob() {
      var _this6 = this;

      console.log('Posting job');

      if (this.startHour == 12) {
        this.startHour -= 12;
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        this.startHour += 12;
      }
      this.startHour = ("0" + this.startHour).slice(-2);

      if (this.endHour == 12) {
        this.endHour -= 12;
      }
      // else {
      //   this.endHour -= 1
      // }
      if (this.endAMPM == 'PM') {
        this.endHour += 12;
      }
      this.endHour = ("0" + this.endHour).slice(-2);

      // this.events.push({id: 4, startDate: this.selectedDate, title: 'Enginehire Family'})
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/jobs/', {
        poster: this.user.id,
        poster_name: this.user.employer_name,
        date: this.dateInDjangoFormat(this.selectedDate),
        // start_time: this.convertTimeFormat(`${this.startHour}:${this.startMinute}${this.startAMPM}`),
        // end_time: this.convertTimeFormat(`${this.endHour}:${this.endMinute}${this.endAMPM}`),
        start_time: this.startHour + ":" + this.startMinute + ":00",
        end_time: this.endHour + ":" + this.endMinute + ":00",
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        console.log(res);
        _this6.getJobs();
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteJob: function deleteJob() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/api/jobs/" + this.job.id).then(function (res) {
        console.log(res);
        _this7.getJobs();
        _this7.$modal.hide('job-modal');
        _this7.$modal.hide('delete-job-modal');
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteApplication: function deleteApplication(application) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/api/jobapplications/" + application.id).then(function (res) {
        console.log(res);
        _this8.getApplications(_this8.job);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateStatus: function updateStatus() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/jobs/" + this.job.id + "/", {
        status: this.status
      }).then(function (res) {
        console.log(res);
        _this9.job.status = _this9.status;
        _this9.getJobs();
        _this9.$modal.show('status-updated-modal');
      }).catch(function (error) {
        console.log(error);
      });
    },
    showBroadcastModal: function showBroadcastModal() {
      // this.getCandidates()
      this.$modal.show('broadcast-modal');
    },
    getCandidates: function getCandidates() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/people/?agency=" + this.$store.getters.agencyID + "&is_candidate=true&status=" + this.$store.getters.candidateActiveStatus).then(function (res) {
        _this10.candidates = res.data;

        for (var candidate in _this10.candidates) {
          _this10.candidates[candidate].jobs = [];
          _this10.candidates[candidate].calendarJobs = [];
          _this10.candidates[candidate].currentWeekAvailability = { 'monday': [], 'tuesday': [], 'wednesday': [], 'thursday': [], 'friday': [], 'saturday': [], 'sunday': [] };
        }

        console.log("Candidates", _this10.candidates);
        _this10.candidateEmails = _this10.candidates.map(function (candidate) {
          return candidate.first_name + " " + candidate.last_name + " [" + candidate.email + "]";
        });

        _this10.getJobs();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    selectCandidate: function selectCandidate(candidate) {
      //
      // What happens when clicking on a candidate in the list of candidates
      //
      if (!this.selectedCandidates.includes(candidate)) {
        // If we haven't already selected a time, select it
        this.selectedCandidates.push(candidate);
      } else {
        this.selectedCandidates.splice(this.selectedCandidates.indexOf(candidate), 1);
      }
    },
    broadcast: function broadcast() {
      var _this11 = this;

      // Send out the notification
      for (var candidate in this.selectedCandidates) {
        console.log(this.selectedCandidates[candidate]);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/jobapplications/", {
          applicant: this.selectedCandidates[candidate].id,
          applicant_name: this.selectedCandidates[candidate].first_name + " " + this.selectedCandidates[candidate].last_name,
          job: this.job.id,
          job_title: this.job.poster_name,
          status: 'No Response',
          agency_owner: this.$store.getters.agencyName,
          agency: this.$store.getters.agencyID
        }).then(function (res) {
          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
          var selectedCandidate = _this11.selectedCandidates.filter(function (user) {
            return user.id == res.data.applicant;
          })[0];
          console.log(selectedCandidate);

          // if (this.selectedCandidates[candidate].preferences3.includes('Email')) { // If the candidate wants to be notified via email
          if (selectedCandidate.preferences3.includes('Email')) {
            // If the candidate wants to be notified via email
            _this11.$store.dispatch('sendEmail', {
              subject: "New Opportunity " + new Date(_this11.addCurrentTimeToDate(_this11.job.date)).toDateString() + ", " + _this11.djangotimeformatAMPM(_this11.job.start_time) + " - " + _this11.djangotimeformatAMPM(_this11.job.end_time),
              // message: 'Hello ' + this.selectedCandidates[candidate].first_name + ',\n\n' +
              message: 'Hello ' + selectedCandidate.first_name + ',\n\n' + 'A family has posted a request for a nanny that you might be interested in!\n' + (
              // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
              "To see all the details please go to https://pinknannies.enginehire.io/job/" + _this11.job.id + " \n\n") + ("Date: " + new Date(_this11.addCurrentTimeToDate(_this11.job.date)).toDateString() + "\n") + ("Start Time: " + _this11.djangotimeformatAMPM(_this11.job.start_time) + "\n") + ("End Time: " + _this11.djangotimeformatAMPM(_this11.job.end_time) + "\n\n") + 'Even if you are not interested we would really appreciate it if you could go to the link to let us know!\n\n' + 'Thanks!\n' + 'The Nanny Company Team',
              from: _this11.$store.getters.agencyFromEmail,
              // email: this.selectedCandidates[candidate].email,
              email: selectedCandidate.email,
              reply: _this11.$store.getters.agencyReplyEmail,
              // userID: this.aakashid,
              // userID: this.selectedCandidates[candidate].id,
              userID: selectedCandidate.id
            });
          }

          // Increment the counter for the number of broadcasts this candidate has received
          // let statsArray = this.selectedCandidates[candidate].numberArray
          var statsArray = selectedCandidate.numberArray;
          // console.log(statsArray)
          statsArray[0] += 1;
          // console.log(statsArray)
          // axios.patch(`/api/people/${this.selectedCandidates[candidate].id}/`, {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/" + selectedCandidate.id + "/", {
            numberArray: statsArray
          }).catch(function (error) {
            return console.log(error);
          });

          if (candidate == _this11.selectedCandidates.length - 1) {
            // If we just processed the last candidate in the list
            _this11.getApplications(_this11.job);
            _this11.$modal.show('successfully-broadcasted-modal');
            _this11.$modal.hide('broadcast-modal');

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/jobs/" + _this11.job.id + "/", {
              status: 'Pending'
            }).then(function (res) {
              console.log(res);
              _this11.job.status = 'Pending';
              _this11.status = 'Pending';
            }).catch(function (error) {
              return console.log(error);
            });
          }
        }).catch(function (error) {
          return console.log(error);
        });
      }
      // this.$modal.show('successfully-broadcasted-modal')
      // this.$modal.hide('broadcast-modal')
    },

    // --------------- Group of functions for manually assigning a nanny to a job ----------------
    showCandidateAssignmentModal: function showCandidateAssignmentModal() {
      this.candidateSelection = '';
      // this.candidateEmployerRelationshipStatus = ''
      this.$modal.show('candidate-assignment-modal');
    },
    getCandidateObject: function getCandidateObject(emailName) {
      var _this12 = this;

      //this helper method will allow me to link an invoice to a candidate object
      return this.candidates.filter(function (element) {
        //since the invoice object does not contain an email, I will have to link the payee_id to the appropriate candidate
        return element.email == _this12.extractEmail(emailName);
      });
    },
    extractEmail: function extractEmail(emailName) {
      var emailRegExp = /\[([^)]+)\]/; //this will extract the email within parentheses
      return emailRegExp.exec(emailName)[1];
    },
    assign: function assign() {
      var _this13 = this;

      //
      // Manually assign a nanny to a job
      //
      var selectedCandidateObj = this.getCandidateObject(this.candidateSelection)[0];
      console.log(selectedCandidateObj);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/jobs/" + this.job.id + "/", {
        status: 'Assigned',
        filled: true,
        filler: selectedCandidateObj.id,
        filler_name: selectedCandidateObj.first_name + " " + selectedCandidateObj.last_name,
        filled_date: new Date()
      }).then(function (res) {
        console.log(res);
        _this13.getJob(_this13.job.id);
        _this13.getJobs();
        _this13.candidateSelection = '';
        _this13.$modal.show('nanny-assigned-modal');

        _this13.$store.dispatch('sendEmails', {
          subject: "Nanny Assigned for " + new Date(_this13.job.date).toDateString(),
          message: "Hello " + _this13.job.poster_name + "," + '\n\n' + ("Our nanny " + selectedCandidateObj.first_name + " " + selectedCandidateObj.last_name + " has been assigned to your service request on " + new Date(_this13.job.date).toDateString() + ".\n") + ("To view more details about the nanny, please log into your dashboard (" + _this13.$store.getters.platformLoginURL + ") and click on your service request.\n\n") + 'Please don\'t hesitate to reach out if you have any questions or issues!\n\n' + 'Thank you,\n' + (_this13.$store.getters.agencyHumanName + " Team"),
          from: _this13.$store.getters.agencyFromEmail,
          emails: [_this13.$store.getters.enginehireLoggingEmail, _this13.jobPoster.email],
          reply: _this13.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: _this13.jobPoster.id
        });

        _this13.$store.dispatch('sendEmails', {
          subject: "Job Assigned for " + new Date(_this13.job.date).toDateString(),
          message: "Hello " + selectedCandidateObj.first_name + "," + '\n\n' + ("You have been assigned to a job on " + new Date(_this13.job.date).toDateString() + ".\n") + (
          // `Your family contact is ${this.jobPoster.first_name} ${this.jobPoster.last_name} (${this.jobPoster.phone})\n` +
          "To view more details about the job, please log into your dashboard (" + _this13.$store.getters.platformLoginURL + ") and click on the \"My Jobs\" tab.\n\n") + 'Please don\'t hesitate to reach out if you have any questions or issues!\n\n' + 'Thank you,\n' + (_this13.$store.getters.agencyHumanName + " Team"),
          from: _this13.$store.getters.agencyFromEmail,
          emails: [_this13.$store.getters.enginehireLoggingEmail, selectedCandidateObj.email],
          reply: _this13.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: selectedCandidateObj.id
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      relationships: [],
      relationship: {},
      relationshipCandidates: [],

      candidateEmployerRelationshipStatuses: [],
      candidateEmployerRelationshipStatus: '',

      candidates: [],
      candidateSelection: '',
      candidateEmails: [],
      candidate: {},

      payRate: '',
      contractDuration: '',
      daysHours: '',
      paidTimeOff: '',
      paidVacation: '',
      paidSickDays: '',
      paymentFrequency: '',
      healthInsurance: '',
      mileageReimbursement: '',
      // startDate: '',

      clientNotes: ''
    };
  },
  created: function created() {
    this.candidateEmployerRelationshipStatuses = this.$store.getters.candidateEmployerRelationshipStatuses;
    this.getRelationships();
    this.getCandidates();
  },

  methods: {
    getRelationships: function getRelationships() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/relationships/?employer=' + this.user.id).then(function (res) {
        console.log(res);
        _this.relationships = res.data;

        _this.relationshipCandidates = [];
        for (var relationship in _this.relationships) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?id=' + _this.relationships[relationship].candidate).then(function (res) {
            console.log(res);
            _this.relationshipCandidates.push(res.data[0]);
            // let candidateRelationships = this.relationships.filter(relationship => relationship.candidate == res.data[0].id)
            // for (var candidateRelationship in candidateRelationships) {

            // }
          }).catch(function (error) {
            return console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCandidates: function getCandidates() {
      var _this2 = this;

      // axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true&status=${this.$store.getters.candidateActiveStatus}`)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?agency=' + this.$store.getters.agencyID + '&is_candidate=true').then(function (res) {
        _this2.candidates = res.data;
        console.log("Candidates", _this2.candidates);
        _this2.candidateEmails = _this2.candidates.map(
        // candidate => `${candidate.first_name} ${candidate.last_name} (${candidate.email})`
        function (candidate) {
          return candidate.first_name + ' ' + candidate.last_name + ' [' + candidate.email + ']';
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showCandidateAssignmentModal: function showCandidateAssignmentModal() {
      this.candidateSelection = '';
      this.candidateEmployerRelationshipStatus = '';
      this.$modal.show('candidate-assignment-modal');
    },
    getCandidateObject: function getCandidateObject(emailName) {
      var _this3 = this;

      //this helper method will allow me to link an invoice to a candidate object
      return this.candidates.filter(function (element) {
        //since the invoice object does not contain an email, I will have to link the payee_id to the appropriate candidate
        return element.email == _this3.extractEmail(emailName);
      });
    },
    extractEmail: function extractEmail(emailName) {
      // let emailRegExp = /\(([^)]+)\)/; //this will extract the email within parentheses
      var emailRegExp = /\[([^)]+)\]/; //this will extract the email within the square parentheses (switched to square because some people had brackets in their name)
      return emailRegExp.exec(emailName)[1];
    },
    postRelationship: function postRelationship() {
      var _this4 = this;

      var selectedCandidateObj = this.getCandidateObject(this.candidateSelection)[0];

      console.log(selectedCandidateObj);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/relationships/', {
        candidate: selectedCandidateObj.id,
        candidate_name: selectedCandidateObj.first_name + ' ' + selectedCandidateObj.last_name,
        employer: this.user.id,
        employer_name: this.user.first_name + ' ' + this.user.last_name,
        status: this.candidateEmployerRelationshipStatus,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,

        text7: this.clientNotes
      }).then(function (res) {
        console.log(res);
        _this4.getRelationships();
        _this4.$modal.hide('candidate-assignment-modal');
        _this4.$modal.show('candidate-assigned-modal');

        _this4.$store.dispatch('sendEmails', {
          subject: 'New candidate for you to consider - ' + selectedCandidateObj.first_name,
          message: 'Hello ' + _this4.user.first_name + ',' + '\n\n' + ('We have found a great new candidate for you to consider: ' + selectedCandidateObj.first_name + '!\n') + ('Please log into your dashboard (' + _this4.$store.getters.platformLoginURL + ') to view their profile and let us know what you think.\n\n') + ('Sincerely,\nThe ' + _this4.$store.getters.agencyHumanName + ' Team'),
          from: _this4.$store.getters.agencyFromEmail,
          emails: [_this4.$store.getters.enginehireLoggingEmail, _this4.user.email],
          reply: _this4.$store.getters.agencyReplyEmail,
          userID: _this4.user.id
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },

    // showUpdateStatusModal(relationship, candidate) {
    showUpdateStatusModal: function showUpdateStatusModal(relationship) {
      this.$modal.show('update-status-modal');
      this.relationship = relationship;
      this.candidateEmployerRelationshipStatus = relationship.status;
      // this.candidate = candidate

      this.clientNotes = relationship.text7;
    },
    updateRelationshipStatus: function updateRelationshipStatus(relationship) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + relationship.id + '/', {
        status: this.candidateEmployerRelationshipStatus,

        text7: this.clientNotes
      }).then(function (res) {
        // console.log(res)
        _this5.$modal.hide('update-status-modal');
        _this5.getRelationships();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showOfferModal: function showOfferModal(relationship) {
      this.relationship = relationship;
      this.daysHours = relationship.text3;
      this.payRate = relationship.text4;
      this.paidTimeOff = relationship.text5;
      // this.startDate = relationship.text6
      this.contractDuration = relationship.text6;
      this.paidVacation = relationship.text8;
      this.paidSickDays = relationship.text9;
      this.paymentFrequency = relationship.text10;
      this.healthInsurance = relationship.text11;
      this.mileageReimbursement = relationship.text12;
      this.$modal.show('offer-modal');
    },
    updateOffer: function updateOffer() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + this.relationship.id + '/', {
        text3: this.daysHours,
        text4: this.payRate,
        text5: this.paidTimeOff,
        // text6: this.startDate,
        text6: this.contractDuration,
        // text7 got taken by admin notes for client
        text8: this.paidVacation,
        text9: this.paidSickDays,
        text10: this.paymentFrequency,
        text11: this.healthInsurance,
        text12: this.mileageReimbursement
        // status: 'Offer Extended',
      }).then(function (res) {
        _this6.$modal.hide('offer-modal');
        _this6.$modal.show('offer-updated-modal');
        _this6.getRelationships();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showInterviewModal: function showInterviewModal(relationship) {
      this.relationship = relationship;
      this.date = null;
      this.startHour = 1;
      this.startMinute = '00';
      this.startAMPM = 'AM';
      this.$modal.show('interview-modal');
    },
    setInterview: function setInterview() {
      var _this7 = this;

      // Interview Time -------------------------------
      this.startHour = parseInt(this.startHour);
      if (this.startHour == 12) {
        this.startHour -= 12;
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        console.log(this.startHour);
        this.startHour += 12;
        console.log(this.startHour);
      }
      this.startHour = ("0" + this.startHour).slice(-2);
      console.log(this.startHour);

      var interview = this.dateInDjangoFormat(this.date) + 'T' + this.startHour + ':' + this.startMinute + ':00';
      // -------------------------------------------

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/relationships/' + this.relationship.id + '/', {
        date1: interview,
        interview_type: this.interviewType
      }).then(function (res) {
        // console.log(res)
        _this7.$modal.hide('interview-modal');
        _this7.getRelationships();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showDeleteRelationshipModal: function showDeleteRelationshipModal(relationship) {
      this.relationship = relationship;
      this.$modal.show('delete-relationship-modal');
    },
    deleteRelationship: function deleteRelationship(relationship) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/relationships/' + relationship.id).then(function (res) {
        console.log(res);
        _this8.$modal.hide('delete-relationship-modal');
        _this8.getRelationships();
      });
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // https://www.npmjs.com/package/vuejs-datepicker

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  // props: ['userID'],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_2_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_2_tiptap__["c" /* EditorMenuBar */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      description: '',
      descriptionEditor: null,

      // user: {},
      candidates: [],
      jobs: [],
      job: {},
      title: '',
      startDate: null,
      city: '',
      provincestate: '',
      postalCode: '',
      compensation: '',
      schedule: '',
      pic: '',

      applications: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_2_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_3_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.description = getHTML();
      }
    });

    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h5>1. Family Name</h5><p></p><hr>\
    //     <h5>2. Family Address</h5><p></p><hr>\
    //     <h5>3. Mom’s full name / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>4. Dad’s full name  / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>5. Children’s Full Name & Birthday</h5><p></p><hr>\
    //     <h5>6. Allergies / Special Needs regarding the children</h5><p></p><hr>\
    //     <h5>7. Pets (kind – temperament – indoor/outdoor – care needed)</h5><p></p><hr>\
    //     <h5>8. Children’s interests/hobbies</h5><p></p><hr>\
    //     <h5>9. Behaviour modification strategies</h5><p></p><hr>\
    //     <h5>10. Emergency contact (name, relation & number)</h5><p></p><hr>\
    //     <h5>11. Days & Times required</h5><p></p><hr>\
    //     <h5>12. Start day/end day (contract duration)</h5><p></p><hr>\
    //     <h5>13. Driver’s license/vehicle required?</h5><p></p><hr>\
    //     <h5>14. Open to the Nanny taking the children to activities?</h5><p></p><hr>\
    //     <h5>15. Car Seats provided?</h5><p></p><hr>\
    //     <h5>16. Expectations for your Nanny</h5><p></p><hr>\
    //     <h5>17. Daily Routine for the Nanny</h5><p></p><hr>\
    //     <h5>Process going forward: </h5><p>Medical Release & Transportation Consent must be completed prior to the first shift</p><p>Client to email dates and times – 1-2 weeks in advance</p><p></p><hr>\
    //     <h5>TNC</h5><p>Communication Log to be completed & sent with first shift</p><p>Once the shift is filled send the NOC profile to client</p><p>Build the NOC Family spec sheet – send to Nanny </p><p></p><hr>\
    //     '
    //   )
    // }

    // this.getUser()
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
  },
  created: function created() {
    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h4>1. Family Name</h4><p></p><hr>\
    //     '
    //   )
    // }

    this.getJobs();
    this.getCandidates();
  },

  methods: {
    // getUser() {
    //   // https://www.npmjs.com/package/vue-loading-overlay
    //   let loader = this.$loading.show({
    //     // Optional parameters
    //     container: this.fullPage ? null : this.$refs.formContainer,
    //     // container: this.$refs.formContainer,
    //     // canCancel: true,
    //     canCancel: false,
    //     // onCancel: this.onCancel,
    //   });
    //   // simulate AJAX
    //   setTimeout(() => {
    //     loader.hide()
    //   },2000)

    //   axios.get(`/api/people/?id=${this.userID}`)
    //     .then(res => {
    //       this.user = res.data[0]

    //       if (this.user.richtext1) {
    //         this.descriptionEditor.setContent(this.user.richtext1)
    //       }
    //       else {
    //         this.descriptionEditor.setContent(
    //           '\
    //           '
    //         )
    //       }
    //     })
    // },
    // save() {
    //   axios.patch(`/api/people/${this.user.id}/`, {
    //     richtext1: this.description
    //   })
    //     .then(res => {
    //         console.log(res)
    //         this.getUser()
    //         this.$modal.show('notes-saved-modal')
    //       })
    //       .catch(error => console.log(error))
    // }
    getJobs: function getJobs() {
      var _this2 = this;

      // If we are looking at the jobs of a specific user
      if (this.user) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?poster=' + this.user.id + '&job_type=Long Term').then(function (res) {
          console.log(res.data);
          // if (res.data.length) { // If the job already

          // }
          _this2.jobs = res.data;
          _this2.jobs = _this2.jobs.sort(function (a, b) {
            return a.id < b.id ? 1 : -1;
          });
        }).catch(function (error) {
          return console.log(error);
        });
      }
      // If we haven't been passed a specific user, just look at everyone's jobs
      else {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?agency=' + this.$store.getters.agencyID + '&job_type=Long Term').then(function (res) {
            console.log(res.data);
            // if (res.data.length) { // If the job already

            // }
            _this2.jobs = res.data;
            _this2.jobs = _this2.jobs.sort(function (a, b) {
              return a.id < b.id ? 1 : -1;
            });
          }).catch(function (error) {
            return console.log(error);
          });
        }
    },
    showJobModal: function showJobModal(job) {
      if (job) {
        this.job = job;
        this.title = job.title;
        this.city = job.city;
        this.provincestate = job.provincestate;
        this.postalCode = job.postal_code;
        if (job.date) {
          this.startDate = new Date(this.addCurrentTimeToDate(job.date));
        }
        this.schedule = job.text;
        this.compensation = job.compensation;
        this.descriptionEditor.setContent(this.job.description);
        this.description = this.job.description;
      } else {
        this.job = {};
        this.title = '';
        this.startDate = null;
        this.city = this.user.city;
        this.provincestate = this.user.provincestate;
        this.postalCode = this.user.postal_code;
        this.compensation = '';
        this.schedule = '';
        this.descriptionEditor.setContent('');
        this.description = '';
      }
      this.$modal.show('job-modal');
    },
    handleFileUpload: function handleFileUpload() {
      this.pic = this.$refs.pic.files[0];
    },
    postJob: function postJob() {
      var _this3 = this;

      if (this.startDate) {
        this.startDate = this.dateInDjangoFormat(this.startDate);
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/jobs/', {
        poster: this.user.id,
        poster_name: this.user.first_name + ' ' + this.user.last_name,
        title: this.title,
        city: this.city,
        provincestate: this.provincestate,
        postal_code: this.postalCode,
        status: 'Posted',
        date: this.startDate,
        compensation: this.compensation,
        text: this.schedule,
        description: this.description,
        job_type: 'Long Term',
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      }).then(function (res) {
        _this3.$modal.hide('job-modal');
        _this3.$modal.show('job-posted-modal');
        _this3.getJobs();

        var formData = new FormData();
        if (_this3.pic) {
          formData.append('file1', _this3.pic);
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/'.concat(res.data.id.toString()).concat('/'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    patchJob: function patchJob(job) {
      var _this4 = this;

      if (this.startDate) {
        this.startDate = this.dateInDjangoFormat(this.startDate);
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + job.id + '/', {
        // poster: this.user.id,
        // poster_name: `${this.user.first_name} ${this.user.last_name}`,
        title: this.title,
        city: this.city,
        provincestate: this.provincestate,
        postal_code: this.postalCode,
        // status: 'Posted',
        date: this.startDate,
        compensation: this.compensation,
        text: this.schedule,
        description: this.description
        // agency: this.$store.getters.agencyID,
        // agency_owner: this.$store.getters.agencyName
      }).then(function (res) {
        _this4.$modal.hide('job-modal');
        _this4.$modal.show('job-updated-modal');
        _this4.getJobs();

        var formData = new FormData();
        if (_this4.pic) {
          formData.append('file1', _this4.pic);
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/'.concat(res.data.id.toString()).concat('/'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showApplicantsModal: function showApplicantsModal(job) {
      this.getApplications(job);
      this.$modal.show('applicants-modal');
    },
    getApplications: function getApplications(job) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobapplications/?job=' + job.id).then(function (res) {
        console.log(res);
        _this5.applications = res.data;

        // this.$modal.show('job-modal')
      }).catch(function (error) {
        return console.log(error);
      });
    },
    refreshApplications: function refreshApplications() {
      this.getApplications(this.job);
    },
    getCandidates: function getCandidates() {
      var _this6 = this;

      // axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true&status=Accepted`)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/?agency=' + this.$store.getters.agencyID + '&is_candidate=true&status=' + this.$store.getters.candidateActiveStatus).then(function (res) {
        _this6.candidates = res.data;
        // console.log("Candidates", this.candidates);
        // this.candidateEmails = this.candidates.map(
        //   candidate => `${candidate.first_name} ${candidate.last_name} (${candidate.email})`
        // );
      }).catch(function (error) {
        return console.log(error);
      });
    },

    // broadcast() {
    //   // Send out the notification
    //   for (var candidate in this.selectedCandidates) {
    //     console.log(this.selectedCandidates[candidate])
    //     axios.post(`/api/jobapplications/`, {
    //       applicant: this.selectedCandidates[candidate].id,
    //       applicant_name: `${this.selectedCandidates[candidate].first_name} ${this.selectedCandidates[candidate].last_name}`,
    //       job: this.job.id,
    //       job_title: this.job.poster_name,
    //       status: 'No Response',
    //       agency_owner: this.$store.getters.agencyName,
    //       agency: this.$store.getters.agencyID,
    //     })
    //       .then(res => {
    //         // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
    //         let selectedCandidate = this.selectedCandidates.filter(user => user.id == res.data.applicant)[0]
    //         console.log(selectedCandidate)

    //         // if (this.selectedCandidates[candidate].preferences3.includes('Email')) { // If the candidate wants to be notified via email
    //         if (selectedCandidate.preferences3.includes('Email')) { // If the candidate wants to be notified via email
    //           this.$store.dispatch('sendEmail',
    //             {
    //               subject: `New Opportunity ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}, ${this.djangotimeformatAMPM(this.job.start_time)} - ${this.djangotimeformatAMPM(this.job.end_time)}`,
    //               // message: 'Hello ' + this.selectedCandidates[candidate].first_name + ',\n\n' +
    //               message: 'Hello ' + selectedCandidate.first_name + ',\n\n' +
    //               'A family has posted a request for a nanny that you might be interested in!\n' +
    //               // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
    //               `To see all the details please go to https://pinknannies.enginehire.io/job/${this.job.id} \n\n` +
    //               `Date: ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}\n` +
    //               `Start Time: ${this.djangotimeformatAMPM(this.job.start_time)}\n` +
    //               `End Time: ${this.djangotimeformatAMPM(this.job.end_time)}\n\n` +
    //               'Even if you are not interested we would really appreciate it if you could go to the link to let us know!\n\n' +
    //               'Thanks!\n'+
    //               'The Nanny Company Team',
    //               from: this.$store.getters.agencyFromEmail,
    //               // email: this.selectedCandidates[candidate].email,
    //               email: selectedCandidate.email,
    //               reply: this.$store.getters.agencyReplyEmail,
    //               // userID: this.aakashid,
    //               // userID: this.selectedCandidates[candidate].id,
    //               userID: selectedCandidate.id,
    //             }
    //           )
    //         }

    //         // Increment the counter for the number of broadcasts this candidate has received
    //         // let statsArray = this.selectedCandidates[candidate].numberArray
    //         let statsArray = selectedCandidate.numberArray
    //         // console.log(statsArray)
    //         statsArray[0] += 1
    //         // console.log(statsArray)
    //         // axios.patch(`/api/people/${this.selectedCandidates[candidate].id}/`, {
    //         axios.patch(`/api/people/${selectedCandidate.id}/`, {
    //           numberArray: statsArray
    //         })
    //           .catch(error => console.log(error))

    //         if (candidate == (this.selectedCandidates.length - 1)) { // If we just processed the last candidate in the list
    //           this.getApplications(this.job)
    //           this.$modal.show('successfully-broadcasted-modal')
    //           this.$modal.hide('broadcast-modal')

    //           axios.patch(`/api/jobs/${this.job.id}/`, {
    //             status: 'Pending',
    //           })
    //             .then(res => {
    //               console.log(res)
    //               this.job.status = 'Pending'
    //               this.status = 'Pending'
    //             })
    //             .catch(error => console.log(error))
    //         }
    //       })
    //       .catch(error => console.log(error))
    //   }
    //   // this.$modal.show('successfully-broadcasted-modal')
    //   // this.$modal.hide('broadcast-modal')
    // },
    broadcast: function broadcast(job) {
      var _this7 = this;

      console.log('Broadcasting');
      // Send out the notification
      for (var candidate in this.candidates) {
        this.$store.dispatch('sendEmail', {
          subject: 'New Opportunity - ' + job.title,
          message: 'Hello ' + this.candidates[candidate].first_name + ',\n\n' + 'A family has posted a request for a nanny that you might be interested in!\n' + (
          // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
          'To see all the details please go to ' + this.$store.getters.platformURL + 'job/' + job.id + ' \n\n') + (
          // `Start Date: ${new Date(this.addCurrentTimeToDate(job.date)).toDateString()}\n` +
          'Location: ' + job.city + ', ' + job.provincestate + ', ' + job.postal_code + '\n') + ('Compensation: ' + job.compensation + '\n') + ('Schedule: ' + job.text + '\n\n') +
          // `Description: ${job.description}\n` +
          'If you are interested please go to the link to let us know!\n\n' + 'Thanks,\n' + ('The ' + this.$store.getters.agencyHumanName + ' Team'),
          from: this.$store.getters.agencyFromEmail,
          email: this.candidates[candidate].email,
          reply: this.$store.getters.agencyReplyEmail,
          userID: this.candidates[candidate].id
        });
      }

      if (candidate == this.candidates.length - 1) {
        // If we just processed the last candidate in the list
        // this.getApplications(this.job)
        this.$modal.show('successfully-broadcasted-modal');
        // this.$modal.hide('broadcast-modal')

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + job.id + '/', {
          status: 'Broadcasted'
        }).then(function (res) {
          console.log(res);
          // this.job.status = 'Pending'
          // this.status = 'Pending'
          _this7.getJobs();
        }).catch(function (error) {
          return console.log(error);
        });
      }
    },
    closeJob: function closeJob(job) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + job.id + '/', {
        status: 'Closed'
      }).then(function (res) {
        console.log(res);
        // this.job.status = 'Pending'
        // this.status = 'Pending'
        _this8.getJobs();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    reopenJob: function reopenJob(job) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/jobs/' + job.id + '/', {
        status: 'Posted'
      }).then(function (res) {
        console.log(res);
        // this.job.status = 'Pending'
        // this.status = 'Pending'
        _this9.getJobs();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showDeleteJobModal: function showDeleteJobModal(job) {
      this.job = job;
      this.$modal.show('delete-job-modal');
    },
    deleteJob: function deleteJob() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/jobs/' + this.job.id).then(function (res) {
        console.log(res);
        _this10.getJobs();
        // this.$modal.hide('job-modal')
        _this10.$modal.hide('delete-job-modal');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */]
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      templates: [],
      template: {},

      editing: false,

      status: '',
      // statuses: [],
      type: '',
      types: ['Status Change Notification', 'Registration'
      // 'Status Reminder',
      ],
      selector1Options: ['Candidate', 'Employer'],
      selector1: '',
      // selector2Options: [
      //   '',
      // ],
      selector2: '',
      subject: '',
      body: '',
      name: '',
      fromEmail: this.$store.getters.agencyFromEmail,
      // fromEmail: 'pinknannies@enginehire.io',

      richEditor: null,
      deactivated: false
    };
  },

  computed: {
    statuses: function statuses() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateStatuses;
      } else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerStatuses;
      } else {
        return [];
      }
    },
    selector2Options: function selector2Options() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateTypes;
      } else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerTypes;
      } else {
        return [];
      }
    }
  },
  created: function created() {
    this.getTemplates();
    // this.statuses = this.$store.getters.statuses
  },
  mounted: function mounted() {
    var _this = this;

    this.richEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.body = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.richEditor.destroy();
  },

  methods: {
    getTemplates: function getTemplates() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emailtemplates/?agency=' + this.$store.getters.agencyID).then(function (res) {
        _this2.templates = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showTemplateModal: function showTemplateModal(template) {
      if (template) {
        this.template = template;
        this.subject = template.subject;
        this.status = template.status;
        this.type = template.type;
        this.name = template.name;
        this.body = template.body;
        this.richEditor.setContent(template.body);
        if (template.from_email) {
          this.fromEmail = template.from_email;
        }
        this.selector1 = template.selector1;
        this.selector2 = template.selector2;
        this.deactivated = template.deactivated;
      } else {
        this.subject = '';
        this.status = '';
        this.type = '';
        this.name = '';
        this.body = '';
        this.richEditor.setContent('');
        // this.fromEmail = this.$store.getters.agencyAdminEmail
        this.selector1 = '';
        this.selector2 = '';
        this.deactivated = false;
        this.template = {};
      }
      this.$modal.show('template-modal');
    },
    postTemplate: function postTemplate() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/emailtemplates/', {
        name: this.name,
        status: this.status,
        type: this.type,
        subject: this.subject,
        body: this.body,
        from_email: this.fromEmail,
        selector1: this.selector1,
        selector2: this.selector2,
        deactivated: this.deactivated,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        _this3.getTemplates();
        _this3.$modal.hide('template-modal');
        _this3.$modal.show('template-created-modal');
      });
    },
    updateTemplate: function updateTemplate() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/emailtemplates/' + this.template.id + '/', {
        name: this.name,
        status: this.status,
        type: this.type,
        subject: this.subject,
        body: this.body,
        from_email: this.fromEmail,
        selector1: this.selector1,
        selector2: this.selector2,
        deactivated: this.deactivated
        // agency_owner: this.$store.getters.agencyName,
        // agency: this.$store.getters.agencyID,
      }).then(function (res) {
        _this4.getTemplates();
        _this4.$modal.hide('template-modal');
        _this4.$modal.show('template-updated-modal');
      });
    },
    deleteTemplate: function deleteTemplate() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/emailtemplates/' + this.template.id + '/').then(function (res) {
        _this5.getTemplates();
        _this5.$modal.hide('template-modal');
        _this5.$modal.hide('delete-template-modal');
        _this5.$modal.show('template-deleted-modal');
      });
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      footers: [],
      footer: {},
      userList: [],
      emails: [],

      id: null,
      name: '',
      image: '',
      title: '',
      email: '',
      phone: '',
      address: '',
      facebook: '',
      instagram: '',
      linkedin: '',
      twitter: '',
      website: '',
      youtube: '',
      footerID: null,

      submitClicked: false
    };
  },
  created: function created() {
    this.getFooters();
    this.getAdmins();
  },

  methods: {
    getFooters: function getFooters() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emailfooters/?agency=' + this.$store.getters.agencyID).then(function (res) {
        _this.footers = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },

    // Get all admin accounts related to the company
    getAdmins: function getAdmins() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/', {
        params: {
          agency: this.$store.getters.agencyID,
          is_agent: true
        }
      }).then(function (res) {
        _this2.userList = res.data;

        // Put all admin emails into a list
        _this2.userList.forEach(function (user) {
          _this2.emails.push(user.email);
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showNewFooterModal: function showNewFooterModal() {
      this.$modal.show('new-footer-modal');
    },
    showAddModal: function showAddModal() {
      this.submitClicked = true;
      // Once user picks an email from the list, populate the form with data from the admin's profile
      if (this.email) {
        for (var user in this.userList) {
          if (this.userList[user].email == this.email) {
            console.log(this.userList[user].phone);
            this.name = this.userList[user].first_name + this.userList[user].last_name;
            this.id = this.userList[user].id;
            this.image = this.userList[user].profile_pic;
            this.title = this.userList[user].title;
            this.phone = this.userList[user].phone;
            this.address = this.userList[user].address1 + ', ' + this.userList[user].city + ', ' + this.userList[user].provincestate;
            this.facebook = this.userList[user].facebook;
            this.instagram = this.userList[user].instagram;
            this.twitter = this.userList[user].twitter;
            this.linkedin = this.userList[user].linkedin;
            this.youtube = this.userList[user].youtube;
            this.website = this.userList[user].website;
          }
        }
        this.$modal.hide('new-footer-modal');
        this.$modal.show('create-footer-modal');
      }
    },
    saveNewFooter: function saveNewFooter() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/emailfooters/', {
        name: this.name,
        id: this.id,
        image: this.image,
        email: this.email,
        title: this.title,
        phone: this.phone,
        address: this.address,
        facebook: this.facebook,
        instagram: this.instagram,
        twitter: this.twitter,
        linkedin: this.linkedin,
        youtube: this.youtube,
        website: this.website,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      });
      this.$modal.hide('create-footer-modal');
      this.$modal.show('new-created-modal');
      this.getFooters();
    },
    showEditModal: function showEditModal(footer) {
      this.footer = footer;
      this.name = this.footer.name;
      this.title = this.footer.title;
      this.email = this.footer.email;
      this.phone = this.footer.phone;
      this.address = this.footer.address;
      this.facebook = this.footer.facebook;
      this.instagram = this.footer.instagram;
      this.twitter = this.footer.twitter;
      this.linkedin = this.footer.linkedin;
      this.youtube = this.footer.youtube;
      this.website = this.footer.website;
      this.footerID = this.footer.id;
      this.$modal.show('footer-edit-modal');
    },
    saveChanges: function saveChanges() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/emailfooters/?id=' + this.footerID + '/', {
        name: this.name,
        title: this.title,
        email: this.email,
        phone: this.phone,
        address: this.address,
        facebook: this.facebook,
        instagram: this.instagram,
        twitter: this.twitter,
        linkedin: this.linkedin,
        youtube: this.youtube,
        website: this.website
      });
      this.$modal.hide('footer-edit-modal');
      this.$modal.show('saved-modal');
      this.getFooters();
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */]
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      templates: [],
      template: {},

      editing: false,

      status: '',
      // statuses: [],
      type: '',
      types: [
      // 'Status Change Notification',
      'Candidate Interview 1', 'Candidate Interview 2', 'Client Interview 1', 'Client Interview 2', 'Reference Check'],
      selector1Options: ['Candidate', 'Employer', 'Job'],
      selector1: '',
      // selector2Options: [
      //   '',
      // ],
      selector2: '',
      subject: '',
      body: '',
      richEditor: null,
      name: ''
      // fromEmail: this.$store.getters.agencyAdminEmail,
      // fromEmail: 'pinknannies@enginehire.io',
    };
  },

  computed: {
    // statuses() {
    //   if (this.selector1 == 'Candidate') {
    //     return this.$store.getters.candidateStatuses
    //   }
    //   else if (this.selector1 == 'Employer') {
    //     return this.$store.getters.employerStatuses
    //   }
    //   else {
    //     return []
    //   }
    // },
    // selector2Options() {
    //   if (this.selector1 == 'Candidate') {
    //     return this.$store.getters.candidateTypes
    //   }
    //   else if (this.selector1 == 'Employer') {
    //     return this.$store.getters.employerTypes
    //   }
    //   else {
    //     return []
    //   }
    // },
  },
  created: function created() {
    this.getTemplates();
    // this.statuses = this.$store.getters.statuses
  },
  mounted: function mounted() {
    var _this = this;

    this.richEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.body = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.richEditor.destroy();
  },

  methods: {
    getTemplates: function getTemplates() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/richtemplates/?agency=' + this.$store.getters.agencyID + '&selector1=Interview').then(function (res) {
        _this2.templates = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showTemplateModal: function showTemplateModal(template) {
      if (template) {
        this.template = template;
        // this.subject = template.subject
        // this.status = template.status
        this.type = template.selector2;
        this.name = template.name;
        this.body = template.body;
        this.richEditor.setContent(template.body);
        // if (template.from_email) {
        //   this.fromEmail = template.from_email
        // }
        // this.selector1 = template.selector1
        // this.selector2 = template.selector2
      } else {
        // this.subject = ''
        // this.status = ''
        this.type = '';
        this.name = '';
        this.body = '';
        this.richEditor.setContent('');
        // this.fromEmail = this.$store.getters.agencyAdminEmail
        // this.selector1 = ''
        // this.selector2 = ''
        this.template = {};

        // axios.get(`/api/richtemplates/?selector2=`)
      }
      this.$modal.show('template-modal');
    },
    postTemplate: function postTemplate() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/richtemplates/', {
        name: this.name,
        // status: this.status,
        selector1: 'Interview',
        selector2: this.type,
        // subject: this.subject,
        body: this.body,
        // from_email: this.fromEmail,
        // selector1: this.selector1,
        // selector2: this.selector2,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        _this3.getTemplates();
        _this3.$modal.hide('template-modal');
        _this3.$modal.show('template-created-modal');
      });
    },
    updateTemplate: function updateTemplate() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/richtemplates/' + this.template.id + '/', {
        name: this.name,
        // status: this.status,
        // type: this.type,
        // subject: this.subject,
        body: this.body,
        // from_email: this.fromEmail,
        // selector1: this.selector1,
        selector2: this.type
        // agency_owner: this.$store.getters.agencyName,
        // agency: this.$store.getters.agencyID,
      }).then(function (res) {
        _this4.getTemplates();
        _this4.$modal.hide('template-modal');
        _this4.$modal.show('template-updated-modal');
      });
    },
    deleteTemplate: function deleteTemplate() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/richtemplates/' + this.template.id + '/').then(function (res) {
        _this5.getTemplates();
        _this5.$modal.hide('template-modal');
        _this5.$modal.hide('delete-template-modal');
        _this5.$modal.show('template-deleted-modal');
      });
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      candidateFiles: [],
      employerFiles: [],
      file: '',
      fileName: '',
      selector: '',
      selectors: ['Candidate', 'Employer'],
      selectedFile: {}
    };
  },
  created: function created() {
    this.getFiles();
  },

  methods: {
    getFiles: function getFiles() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/files/?agency=' + this.$store.getters.agencyID + '&selector1=Resource&selector2=Candidate').then(function (res) {
        _this.candidateFiles = res.data;
      }).catch(function (error) {
        return console.log(error);
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/files/?agency=' + this.$store.getters.agencyID + '&selector1=Resource&selector2=Employer').then(function (res) {
        _this.employerFiles = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showUploadFileModal: function showUploadFileModal() {
      this.file = '';
      this.fileName = '';
      this.selector = '';
      this.$modal.show('upload-file-modal');
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/files/', {
        // user: this.user.id,
        name: this.fileName,
        selector1: 'Resource',
        selector2: this.selector,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        var formData = new FormData();
        if (_this2.file) {
          formData.append("file_link", _this2.file);
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/files/' + res.data.id + '/', formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(function (res) {
          _this2.getFiles();
          _this2.$modal.hide('upload-file-modal');
        }).catch(function (error) {
          return console.log(error);
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    showDeleteFileModal: function showDeleteFileModal(file) {
      this.selectedFile = file;
      this.$modal.show('delete-file-modal');
    },
    deleteFile: function deleteFile(file) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/files/' + file.id).then(function (res) {
        _this3.$modal.hide('delete-file-modal');
        _this3.getFiles();
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */]
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data: function data() {
    return {
      templates: [],
      template: {},

      fields: [],
      // label: {},
      field: '',
      fieldsRequired: [],
      fieldRequired: false,
      fieldIndex: null,

      signers: [],
      signer: '',
      signerIndex: null,
      organizationSigner: '',

      editing: false,

      status: '',
      // statuses: [],
      type: '',
      types: ['Status Change Notification'],
      selector1Options: ['Candidate', 'Employer'],
      selector1: '',
      // selector2Options: [
      //   '',
      // ],
      selector2: '',
      access: '',
      accesses: ['Admin',
      // 'User',
      'All'],

      subject: '',
      body: '',
      name: '',
      fromEmail: this.$store.getters.agencyAdminEmail,

      descriptionEditor: null
    };
  },

  computed: {
    statuses: function statuses() {
      if (this.type == 'Candidate') {
        return this.$store.getters.candidateStatuses;
      } else if (this.type == 'Employer') {
        return this.$store.getters.employerStatuses;
      } else {
        return [];
      }
    },
    selector2Options: function selector2Options() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateTypes;
      } else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerTypes;
      } else {
        return [];
      }
    }
  },
  created: function created() {
    this.getTemplates();
    // this.statuses = this.$store.getters.statuses
  },
  mounted: function mounted() {
    var _this = this;

    this.descriptionEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.description = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.descriptionEditor.destroy();
  },

  methods: {
    getTemplates: function getTemplates() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/documenttemplates/?agency=' + this.$store.getters.agencyID).then(function (res) {
        _this2.templates = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showTemplateModal: function showTemplateModal(template) {
      if (template) {
        this.template = template;
        // this.subject = template.subject
        this.status = template.status_trigger;
        this.type = template.type;
        this.name = template.name;
        // this.body = template.body
        // if (template.from_email) {
        //   this.fromEmail = template.from_email
        // }
        // this.selector1 = template.selector1
        // this.selector2 = template.selector2

        this.fields = template.fields;
        this.fieldsRequired = template.fields_required;
        this.signers = template.signer_labels;
        this.organizationSigner = template.organization_signer;
        this.access = template.edit_access;

        this.description = template.body;
        if (template.body) {
          this.descriptionEditor.setContent(template.body);
        }
      } else {
        this.template = {};
        this.status = '';
        this.type = '';
        this.name = '';
        this.fields = [];
        this.fieldsRequired = [];
        this.signers = [];
        this.organizationSigner = '';
        this.access = '';
        this.description = '';
        this.descriptionEditor.setContent('');
      }
      this.$modal.show('template-modal');
    },
    showFieldModal: function showFieldModal(index) {
      if (index || index == 0) {
        this.field = this.fields[index];
        this.fieldRequired = this.fieldsRequired[index];
        this.fieldIndex = index;
        this.$modal.show('field-modal');
      } else {
        this.field = '';
        this.fieldRequired = false;
        this.fieldIndex = null;
        this.$modal.show('field-modal');
      }
    },
    addField: function addField() {
      this.fields.push(this.field);
      this.fieldsRequired.push(this.fieldRequired);
      this.$modal.hide('field-modal');
      this.field = '';
      this.fieldRequired = false;
      this.fieldIndex = null;
    },
    updateField: function updateField() {
      this.fields[this.fieldIndex] = this.field;
      this.fieldsRequired[this.fieldIndex] = this.fieldRequired;
      this.field = '';
      this.fieldRequired = false;
      this.fieldIndex = null;
      this.$modal.hide('field-modal');
    },
    deleteField: function deleteField(index) {
      this.fields.splice(index, 1);
      this.fieldsRequired.splice(index, 1);
    },
    showSignerModal: function showSignerModal(index) {
      if (index || index == 0) {
        this.signer = this.signers[index];
        this.signerIndex = index;
      } else {
        this.signer = '';
        this.signerIndex = null;
      }
      this.$modal.show('signer-modal');
    },
    addSigner: function addSigner() {
      this.signers.push(this.signer);
      this.$modal.hide('signer-modal');
      this.signer = '';
      this.signerIndex = null;
    },
    updateSigner: function updateSigner() {
      this.signers[this.signerIndex] = this.signer;
      this.signer = '';
      this.signerIndex = null;
      this.$modal.hide('signer-modal');
    },
    deleteSigner: function deleteSigner(index) {
      this.signers.splice(index, 1);
    },
    postTemplate: function postTemplate() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/documenttemplates/', {
        name: this.name,
        status_trigger: this.status,
        type: this.type,
        // subject: this.subject,
        body: this.description,
        fields: this.fields,
        fields_required: this.fieldsRequired,
        signer_labels: this.signers,
        organization_signer: this.organizationSigner,
        edit_access: this.access,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        _this3.getTemplates();
        _this3.$modal.hide('template-modal');
        _this3.$modal.show('template-created-modal');
      });
    },
    updateTemplate: function updateTemplate() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/documenttemplates/' + this.template.id + '/', {
        name: this.name,
        status_trigger: this.status,
        type: this.type,
        body: this.description,
        fields: this.fields,
        fields_required: this.fieldsRequired,
        signer_labels: this.signers,
        organization_signer: this.organizationSigner,
        edit_access: this.access
      }).then(function (res) {
        _this4.getTemplates();
        _this4.$modal.hide('template-modal');
        _this4.$modal.show('template-updated-modal');
      });
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      templates: [],
      templateNames: [],
      selectedTemplate: ''
    };
  },
  created: function created() {
    this.getTemplates();
  },

  methods: {
    getTemplates: function getTemplates() {
      var _this = this;

      var typeSelector = '';
      if (this.user.is_candidate) {
        typeSelector = 'Candidate';
      } else if (this.user.is_employer) {
        // typeSelector = 'Client'
        typeSelector = 'Employer';
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/documenttemplates/?agency=' + this.$store.getters.agencyID + '&type=' + typeSelector).then(function (res) {
        _this.templates = res.data;
        _this.templateNames = _this.templates.map(function (template) {
          return '' + template.name;
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    addDocument: function addDocument() {
      var _this2 = this;

      var template = this.templates.filter(function (template) {
        return template.name == _this2.selectedTemplate;
      })[0];

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/documents/', {
        title: template.name,
        template: template.id,
        signing_user: this.user.id,
        status: 'Unsigned',
        body: template.body,
        fields_labels: template.fields,
        fields_required: template.fields_required,
        edit_access: template.edit_access,
        organization_signer: template.organization_signer,
        signer_labels: template.signer_labels,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        _this2.$modal.show('document-added-modal');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      jobs: []
    };
  },
  created: function created() {
    this.getJobs();
  },

  methods: {
    getJobs: function getJobs() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobs/?agency=' + this.$store.getters.agencyID).then(function (res) {
        console.log(res.data);

        _this.jobs = res.data;
        _this.jobs = _this.jobs.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      applications: []
    };
  },
  created: function created() {
    this.getApplications();
  },

  methods: {
    getApplications: function getApplications(job) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/jobapplications/?applicant=' + this.user.id).then(function (res) {
        console.log(res);
        _this.applications = res.data;
        _this.applications = _this.applications.sort(function (a, b) {
          return a.date < b.date ? 1 : -1;
        });

        // this.$modal.show('job-modal')
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userType'],
  data: function data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      phone: ''
    };
  },

  methods: {
    showAddUserModal: function showAddUserModal() {
      this.email = '';
      this.firstName = '';
      this.lastName = '';
      this.phone = '';
      this.$modal.show('add-user-modal');
    },
    addUser: function addUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/create-user/', {
        email: this.email,
        password: this.email,
        agency: this.$store.getters.agencyID
      }).then(function (res) {
        var is_employer = false;
        var is_candidate = false;
        if (_this.userType == 'employer') {
          is_employer = true;
        } else if (_this.userType == 'candidate') {
          is_candidate = true;
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(res.data.pk.toString()) + '/', {
          agency: _this.$store.getters.agencyID,
          agency_owner: _this.$store.getters.agencyName,
          // user_type: authData.user_type,
          // is_employer: this.is_employer,
          is_candidate: is_candidate,
          is_employer: is_employer,
          // status: 'New',
          status: 'Pre Application',
          // numberArray: [0, 0, 0, 0],
          first_name: _this.firstName,
          last_name: _this.lastName,
          phone: _this.phone
        }).then(function (res) {
          console.log(res);

          // this.getAgents()
          // this.$emit('userAdded')
          if (_this.userType == 'employer') {
            _this.$emit('employerAdded');
          } else if (_this.userType == 'candidate') {
            _this.$emit('candidateAdded');
          }
          _this.$modal.hide('add-user-modal');
        }).catch(function (error) {
          return console.log(error);
        });
      });
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      code: '',
      state: '',
      stripeApiKey: 'sk_test_vfHJkSvCd2CPAOv5i6fzdLaU00oWoTNDmA',
      stripeResponse: {},

      failedToConnect: false
    };
  },
  created: function created() {
    var _this = this;

    // https://stackoverflow.com/questions/42309986/vuejs-get-url-query
    this.code = this.$route.query.code;
    this.state = this.$route.query.state;

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
      if (_this.stripeResponse.message != 'Stripe connection successfullly completed!') {
        _this.failedToConnect = true;
      }
    }, 2500);

    this.completeConnection();
  },

  methods: {
    completeConnection: function completeConnection() {
      var _this2 = this;

      // axios.post('https://connect.stripe.com/oauth/token', {

      // })

      // // Set your secret key: remember to switch to your live secret key in production
      // // See your keys here: https://dashboard.stripe.com/account/apikeys
      // const stripe = require('stripe')('sk_test_vfHJkSvCd2CPAOv5i6fzdLaU00oWoTNDmA');

      // stripe.oauth.token({
      //   grant_type: 'authorization_code',
      //   // code: 'ac_123456789',
      //   code: this.code,
      // }).then(function(response) {
      //   // asynchronously called
      //   // this.stripeResponse = response
      //   console.log('Code Posted')
      //   console.log(response)
      //   var connected_account_id = response.stripe_user_id;
      // });

      // axios.post('/complete-stripe-connection-test/', {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/complete-stripe-connection/', {
        authorization_code: this.code
      }).then(function (res) {
        console.log(res);
        _this2.stripeResponse = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      users: [],

      organizationTypeFilter: 'All',
      organizationTypeFilters: [],
      organizationTypes: [],
      focusAreaFilter: 'All',
      focusAreaFilters: [],
      focusAreas: [],
      sizeFilter: 'All',
      sizeFilters: [],
      sizes: [],
      countryFilter: 'All',
      countryFilters: [],
      countries: [],

      alphabeticalOrder: true,

      fullpage: true // this is used for the loading overlay
    };
  },
  created: function created() {
    this.getUserData();

    this.sizes = this.$store.getters.organizationSizes;
    this.organizationTypes = this.$store.getters.organizationTypes;
    this.focusAreas = this.$store.getters.focusAreas;
    this.countries = this.$store.getters.countries;

    if (this.$route.params.type && this.$route.params.type != 'All Organization Types') {
      this.organizationTypeFilters.push(this.$route.params.type);
    }
    if (this.$route.params.country && this.$route.params.country != 'All Countries') {
      this.countryFilters.push(this.$route.params.country);
    }
    if (this.$route.params.topic && this.$route.params.topic != 'All Topic Areas') {
      this.focusAreaFilters.push(this.$route.params.topic);
    }
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  computed: {
    filteredUsers: function filteredUsers() {
      if (!this.users[0]) {
        return this.users;
      }

      var sizeFilteredUsers = [];
      // if (this.sizeFilter != 'All') {
      if (this.sizeFilters.length > 0) {
        for (var user in this.users) {
          // if (this.users[user].size == this.sizeFilter) {
          if (this.sizeFilters.includes(this.users[user].size)) {
            sizeFilteredUsers.push(this.users[user]);
          }
        }
      } else {
        sizeFilteredUsers = this.users;
      }

      var typeFilteredUsers = [];
      // if (this.organizationTypeFilter != 'All') {
      //   for (var user in sizeFilteredUsers) {
      //     if (sizeFilteredUsers[user].organization_type == this.organizationTypeFilter) {
      //       typeFilteredUsers.push(sizeFilteredUsers[user])
      //     }
      //   }
      // }
      if (this.organizationTypeFilters.length > 0) {
        for (var user in sizeFilteredUsers) {
          if (this.organizationTypeFilters.includes(sizeFilteredUsers[user].organization_type)) {
            typeFilteredUsers.push(sizeFilteredUsers[user]);
          }
        }
      } else {
        typeFilteredUsers = sizeFilteredUsers;
      }

      var focusFilteredUsers = [];
      // if (this.focusAreaFilter != 'All') {
      //   for (var user in typeFilteredUsers) {
      //     if (typeFilteredUsers[user].sectors.includes(this.focusAreaFilter)) {
      //       focusFilteredUsers.push(typeFilteredUsers[user])
      //     }
      //   }
      // }
      if (this.focusAreaFilters.length > 0) {
        for (var user in typeFilteredUsers) {
          for (var focusArea in this.focusAreaFilters) {
            if (typeFilteredUsers[user].sectors.includes(this.focusAreaFilters[focusArea])) {
              focusFilteredUsers.push(typeFilteredUsers[user]);
              break;
            }
          }
        }
      } else {
        focusFilteredUsers = typeFilteredUsers;
      }

      var countryFilteredUsers = [];
      // if (this.countryFilter != 'All') {
      if (this.countryFilters.length > 0) {
        for (var user in focusFilteredUsers) {
          // if (focusFilteredUsers[user].country == this.countryFilter) {
          if (this.countryFilters.includes(focusFilteredUsers[user].country)) {
            countryFilteredUsers.push(focusFilteredUsers[user]);
          }
        }
      } else {
        countryFilteredUsers = focusFilteredUsers;
      }

      if (this.alphabeticalOrder) {
        // https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/
        // https://stackoverflow.com/questions/2466356/javascript-object-list-sorting-by-object-property
        // https://stackoverflow.com/questions/6712034/sort-array-by-firstname-alphabetically-in-javascript
        countryFilteredUsers = countryFilteredUsers.sort(function (a, b) {
          return a.employer_name.toUpperCase() > b.employer_name.toUpperCase() ? 1 : -1;
        });
        // https://www.w3schools.com/jsref/jsref_touppercase.asp - Upper and lower case letters were being ordered differently, need to convert first to keep consistency
      }

      return countryFilteredUsers;
    }
  },
  methods: {
    getUserData: function getUserData() {
      var _this = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 3000);

      // axios.get('/api/people/?is_employer=true&agency=4')
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicemployers/?status=Active&agency=' + this.$store.getters.agencyID.toString()).then(function (res) {
        console.log('Getting employers');
        console.log(res.data);
        _this.users = res.data;
        // console.log(this.users[0])

        // this.users = this.users.sort((a, b) => (a.last_name[0] > b.last_name[0]) ? 1 : -1)
        // this.users = this.users.sort((a, b) => (a.last_updated_date > b.last_updated_date) ? 1 : -1)
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogPostForm__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      blogPosts: [],
      categories: [],
      categoryFilter: 'All',
      contributing: false
    };
  },

  components: {
    appBlogPostForm: __WEBPACK_IMPORTED_MODULE_1__BlogPostForm__["a" /* default */]
  },
  created: function created() {
    this.categories = this.$store.getters.blogCategories;

    this.getBlogs();
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  methods: {
    getBlogs: function getBlogs() {
      var _this = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2000);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogposts/?published=true&agency=' + this.$store.getters.agencyID.toString()).then(function (res) {
        _this.blogPosts = res.data;
        _this.blogPosts = _this.blogPosts.sort(function (a, b) {
          return a.created_date < b.created_date ? 1 : -1;
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    contribute: function contribute() {
      this.contributing = true;
    },
    showWhyContributeModal: function showWhyContributeModal() {
      this.$modal.show('why-contribute-modal');
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['postID'],
  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */],
    EditorMenuBubble: __WEBPACK_IMPORTED_MODULE_1_tiptap__["d" /* EditorMenuBubble */]
  },
  data: function data() {
    return {
      userID: null,
      user: {},
      title: '',
      hero: '',
      content: '',
      contentEditor: null,
      categories: [],
      categoryOptions: [],

      blogSuccessfullyPosted: false,

      postID: null, // There should be a post ID when editing a post, but not when creating a new post
      postToEdit: {},

      linkUrl: null,
      linkMenuIsActive: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.contentEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.content = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.contentEditor.destroy();
  },
  created: function created() {
    this.userID = this.$store.getters.userID;
    this.categoryOptions = this.$store.getters.blogCategories;

    // this is for a unique route for editing a job /edit-job/id
    if (this.$route.params.id) {
      this.postID = this.$route.params.id;
    }

    this.getUser();
  },

  methods: {
    getUser: function getUser() {
      var _this2 = this;

      if (this.userID) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/' + this.userID.toString()).then(function (res) {
          console.log(res);
          _this2.user = res.data;

          // If postID is not null, that means we are editing an existing job
          if (_this2.postID) {
            console.log('Editing Blog Post');
            console.log(_this2.postID);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/blogposts/?id='.concat(_this2.postID.toString())).then(function (res) {
              console.log(res.data[0]);
              _this2.postToEdit = res.data[0];

              _this2.title = _this2.postToEdit.title;
              _this2.contentEditor.setContent(_this2.postToEdit.content);
              _this2.content = _this2.postToEdit.content;
              _this2.categories = _this2.postToEdit.categories;
            }).catch(function (error) {
              return console.log(error);
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    // https://serversideup.net/uploading-files-vuejs-axios/
    handleFileUpload: function handleFileUpload() {
      this.hero = this.$refs.hero.files[0];
    },
    createPost: function createPost() {
      var _this3 = this;

      console.log(this.userID);
      console.log(this.title);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/blogposts/', {
        poster: this.userID,
        title: this.title,
        // hero_image: this.hero,
        content: this.content,
        categories: this.categories,

        // agency: 4,
        // agency_owner: 'ThriveHire',
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      }).then(function (res) {
        console.log(res);

        // Email to inform Hayley and I of new blog posts
        _this3.$store.dispatch('sendEmail', {
          subject: 'New Blog Post!',
          message: 'New blog posted with the title: ' + _this3.title + '\nAuthor: ' + _this3.user.email,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          // email: 'aakash@enginehire.ca',
          email: 'info@thrivehire.org',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });
        _this3.$store.dispatch('sendEmail', {
          subject: 'New Blog Post!',
          message: 'New blog posted with the title: ' + _this3.title + '\nAuthor: ' + _this3.user.email,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          email: 'aakash@enginehire.ca',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });

        if (_this3.hero) {
          var formData = new FormData();
          formData.append('hero_image', _this3.hero);

          // https://stackoverflow.com/questions/47787175/reset-input-type-file-using-vue-js
          _this3.$refs.hero.value = null;
          _this3.hero = '';

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogposts/'.concat(res.data.id.toString()).concat('/'), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (res) {
            console.log(res);
            // this.getUser()
          }).catch(function (error) {
            console.log(error);
          });
        }

        _this3.blogSuccessfullyPosted = true;
        // Scroll the window up
        window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      }).catch(function (error) {
        return console.log(error);
      });
    },
    updatePost: function updatePost() {
      var _this4 = this;

      console.log(this.userID);
      console.log(this.title);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogposts/' + this.postID.toString() + '/', {
        // This was only to manually change post authors, normally when editing the author should not change
        // poster: this.userID,
        // poster: 2563, // Malaika
        // poster: 2561, // Tanya
        // poster: 2564, // Sara
        // poster: 2562, // Sarah
        // poster: 2746, // Chantelle
        // poster: 1069, // Hayley
        // poster: 2747, // Zac
        // poster: 2748, // Gautham
        // poster: 2749, // Divya
        // poster: 2711, // Humaira
        // poster: 2936, // Krithika
        // poster: 3054, // blogwriter@thrivehire.co
        title: this.title,
        // hero_image: this.hero,
        content: this.content,
        categories: this.categories,

        published: false // When a blog post is edited, it should no longer be published
        // created_date: '2019-07-31T12:00:00',
      }).then(function (res) {
        console.log(res);

        // Email to inform Hayley and I of updated blog posts
        _this4.$store.dispatch('sendEmail', {
          subject: 'Updated Blog Post!',
          message: 'Blog posted updated with the title: ' + _this4.title + '\nAuthor: ' + _this4.user.email,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          // email: 'aakash@enginehire.ca',
          email: 'info@thrivehire.org',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });
        _this4.$store.dispatch('sendEmail', {
          subject: 'Updated Blog Post!',
          message: 'Blog posted updated with the title: ' + _this4.title + '\nAuthor: ' + _this4.user.email,
          // from: 'info@thrivehire.co',
          from: 'info@thrivehire.co',
          email: 'aakash@enginehire.ca',
          reply: 'info@thrivehire.co',
          // userID: this.aakashid,
          userID: 4 // Hard coding to my production ID for now
        });

        if (_this4.hero) {
          var formData = new FormData();
          formData.append('hero_image', _this4.hero);

          // https://stackoverflow.com/questions/47787175/reset-input-type-file-using-vue-js
          _this4.$refs.hero.value = null;
          _this4.hero = '';

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/blogposts/'.concat(res.data.id.toString()).concat('/'), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (res) {
            console.log(res);
            // this.getUser()
          }).catch(function (error) {
            console.log(error);
          });
        }

        _this4.blogSuccessfullyPosted = true;
        // Scroll the window up
        window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      }).catch(function (error) {
        return console.log(error);
      });
    },


    // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Links/index.vue
    showLinkMenu: function showLinkMenu(attrs) {
      var _this5 = this;

      this.linkUrl = attrs.href;
      this.linkMenuIsActive = true;
      this.$nextTick(function () {
        _this5.$refs.linkInput.focus();
      });
    },
    hideLinkMenu: function hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl: function setLinkUrl(command, url) {
      command({ href: url });
      this.hideLinkMenu();
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogPostForm__ = __webpack_require__(97);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    appBlogPostForm: __WEBPACK_IMPORTED_MODULE_0__BlogPostForm__["a" /* default */]
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogPostForm__ = __webpack_require__(97);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    appBlogPostForm: __WEBPACK_IMPORTED_MODULE_0__BlogPostForm__["a" /* default */]
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listings: []
    };
  },

  components: {
    appList: __WEBPACK_IMPORTED_MODULE_1__EventList__["a" /* default */]
  },
  created: function created() {
    console.log('Event Board Created');
    this.getListings();

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
    }, 2000);

    // Scroll the window back up after saving the step
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  methods: {
    getListings: function getListings() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/events/?agency=' + this.$store.getters.agencyID.toString()).then(function (res) {
        _this.listings = res.data;
        console.log(_this.listings);

        _this.listings = _this.listings.sort(function (a, b) {
          return a.date > b.date ? 1 : -1;
        });
        // Only want to show events happening in the future
        var currentEvents = [];
        for (var listing in _this.listings) {
          if (new Date(_this.listings[listing].date.concat('T00:00:00')) >= new Date()) {
            currentEvents.push(_this.listings[listing]);
          }
        }
        _this.listings = currentEvents;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Map_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listingID: null,
      listing: {},
      employer: {},
      loggedinUser: null,

      timeToLoad: false
    };
  },

  components: {
    appMap: __WEBPACK_IMPORTED_MODULE_2__global_Map_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.listingID = this.$route.params.id;
    this.loggedinUser = this.$store.getters.userID;
    this.getListing();

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
      _this.timeToLoad = true;
    }, 1000);
  },

  methods: {
    getListing: function getListing() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/events/'.concat(this.listingID.toString())).then(function (res) {
        console.log(res.data);
        _this2.listing = res.data;

        //Changes page title to match event title
        document.title = _this2.listing.title;

        //Updates the URL to show the event listing title
        _this2.$router.replace({ name: 'Event', params: { id: _this2.listingID.toString() }, query: { title: _this2.listing.title.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, ' ').trim().split(/\s+/).join('-') } });

        // axios.get('/api/people/'.concat(this.listing.poster.toString()))
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicemployers/'.concat(_this2.listing.poster.toString())).then(function (res) {
          console.log(res.data);
          _this2.employer = res.data;
        }).catch(function (error) {
          return console.log(error);
        });
      }).catch(function (error) {
        return console.log(error);
      });
    },
    deleteListing: function deleteListing() {
      // router.replace({name: 'Employer Dashboard'})
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/events/'.concat(this.listingID.toString()).concat('/')).then(function (res) {
        console.log(res);
        // router.replace('/organization')
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: 'Employer Dashboard' });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    // Scroll the window to the top on load, since most people will get here via footer
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a);

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      team: [],
      teammember: {},

      profilePic: '',
      summary: '',
      summaryEditor: null,

      order: null,
      title: '',
      website: '',
      // video: '',
      // videoId: '',
      twitter: '',
      facebook: '',
      linkedin: '',
      instagram: '',
      youtube: ''
    };
  },

  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_4_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_4_tiptap__["c" /* EditorMenuBar */]
  },
  mounted: function mounted() {
    var _this = this;

    document.title = this.$refs.pageTitle.innerHTML;

    this.summaryEditor = new __WEBPACK_IMPORTED_MODULE_4_tiptap__["a" /* Editor */]({
      content: this.summary,
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_5_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.summary = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.summaryEditor.destroy();
  },
  created: function created() {
    // Scroll the window to the top on load, since most people will get here via footer
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    this.getTeam();
  },

  methods: {
    getTeam: function getTeam() {
      var _this2 = this;

      // axios.get('/api/people/?status=team&agency='+this.$store.getters.agencyID.toString())
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicusers/?status=team&agency=' + this.$store.getters.agencyID.toString())
      // axios.get('/api/publicusers/?present_employer=ThriveHire&agency='+this.$store.getters.agencyID.toString())
      .then(function (res) {
        _this2.team = res.data;
        // this.team = this.team.sort((a, b) => (a.created_date > b.created_date) ? 1 : -1)
        _this2.team = _this2.team.sort(function (a, b) {
          return a.order > b.order ? 1 : -1;
        });
      });
    },
    showEditModal: function showEditModal(teammember) {
      this.teammember = teammember;

      this.summaryEditor.setContent(this.teammember.about_us);
      this.summary = this.teammember.about_us;
      this.order = this.teammember.order;
      this.title = this.teammember.title;
      this.website = this.teammember.website;
      this.facebook = this.teammember.facebook;
      this.twitter = this.teammember.twitter;
      this.instagram = this.teammember.instagram;
      this.youtube = this.teammember.youtube;
      this.linkedin = this.teammember.linkedin;

      this.$modal.show('edit-modal');
    },
    hideEditModal: function hideEditModal() {
      this.$modal.hide('edit-modal');
    },

    // https://serversideup.net/uploading-files-vuejs-axios/
    handleFileUpload: function handleFileUpload() {
      this.profilePic = this.$refs.profile_pic.files[0];
    },
    updateTeamMember: function updateTeamMember() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + this.teammember.id.toString() + '/', {
        about_us: this.summary,
        order: this.order,
        title: this.title,
        website: this.website,
        // video: this.video,
        facebook: this.facebook,
        twitter: this.twitter,
        instagram: this.instagram,
        youtube: this.youtube,
        linkedin: this.linkedin
      }).then(function (res) {
        var formData = new FormData();
        if (_this3.profilePic) {
          formData.append('profile_pic', _this3.profilePic);
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/'.concat(_this3.teammember.id.toString()).concat('/'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (res) {
          _this3.getTeam();

          // https://www.npmjs.com/package/vue-loading-overlay
          var loader = _this3.$loading.show({
            // Optional parameters
            container: _this3.fullPage ? null : _this3.$refs.formContainer,
            // container: this.$refs.formContainer,
            // canCancel: true,
            canCancel: false
            // onCancel: this.onCancel,
          });
          // simulate AJAX
          setTimeout(function () {
            loader.hide();
          }, 2000);

          _this3.hideEditModal();
        });
      });
    },
    setPresentEmployer: function setPresentEmployer(teammember) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/people/' + teammember.id.toString() + '/', {
        present_employer: 'ThriveHire'
      }).then(function (res) {
        _this4.getTeam();
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employers_profile_Modal__ = __webpack_require__(343);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editing: false,
      content: '',
      contentObject: {},
      // postID: null,

      user: {},
      contentEditor: null
    };
  },

  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */],

    Modal: __WEBPACK_IMPORTED_MODULE_3__employers_profile_Modal__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    document.title = this.$refs.pageTitle.innerHTML;

    this.contentEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      content: this.content,
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        // this.json = getJSON()
        // this.html = getHTML()
        _this.content = getHTML();
      }
    });
  },
  created: function created() {
    // Scroll the window to the top on load, since most people will get here via footer
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    this.getContent();

    if (this.$store.getters.isAuthenticated) {
      this.getUser();
    }
  },

  methods: {
    getContent: function getContent() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/contentpages/?agency=4&title=What is Global Health').then(function (res) {
        console.log(res.data);
        _this2.contentObject = res.data;
        _this2.content = _this2.contentObject.content;

        // axios.get('/api/people/'.concat(this.job.poster.toString()))
        //   .then(res => {
        //     console.log(res.data)
        //     this.employer = res.data
        //   })
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getUser: function getUser() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/people/' + this.$store.getters.userID.toString()).then(function (res) {
        _this3.user = res.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8446feac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(915);
function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8446feac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8446feac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // vueDropzone: vue2Dropzone
  },
  data: function data() {
    return {
      imageSrc: "",
      command: null,
      show: false,
      tab: 2
      // dropzoneOptions: {
      //   url: "https://httpbin.org/post",
      //   thumbnailWidth: 200,
      //   dictDefaultMessage: "UPLOAD A FILE"
      // }
    };
  },

  computed: {
    validImage: function validImage() {
      return this.imageSrc.match(/unsplash/) !== null || this.imageSrc.match(/\.(jpeg|jpg|gif|png)$/) != null;
    }
  },
  methods: {
    showModal: function showModal(command) {
      // Add the sent command
      this.command = command;
      this.show = true;
    },

    // vfileUploaded(file) {
    //   // alert("Your image has been uploaded to the server");
    //   // alert("NOTE THIS IS A DUMMY DEMO, THERE IS NO BACKEND");

    //   /** Here is where you get your URL/Base64 string or what ever.*/

    //   this.imageSrc = "https://source.unsplash.com/random/400x100";
    // },

    fileChange: function fileChange(e) {
      var _this = this;

      var file = this.$refs.file.files[0];
      var uploadUrl = "https://httpbin.org/post";
      var formData = new FormData();

      // formData.append("file", this.file);
      formData.append("file", file);

      console.log('File:');
      // console.log(this.file)
      console.log(file);
      console.log(formData);

      console.log("Uploading...");

      // this.imageSrc = "https://source.unsplash.com/random/400x100";

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inline-image-upload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
          // 'X-CSRFTOKEN': 'csrfCookie',
        }
      }).then(function (data) {
        console.log(data);
        // Take the URL/Base64 from `data` returned from server
        // alert("Your image has been uploaded to the server");
        // alert("NOTE THIS IS A DUMMY DEMO, THERE IS NO BACKEND");

        // this.imageSrc = "https://source.unsplash.com/random/400x100";
        _this.imageSrc = 'https://enginehireio-static-and-media.s3.us-east-2.amazonaws.com/media/content/' + file.name.replace(' ', '+');
      }).catch(function (error) {
        console.log(error);
      });
    },
    insertImage: function insertImage() {
      var data = {
        command: this.command,
        data: {
          src: this.imageSrc
          // alt: "YOU CAN ADD ALT",
          // title: "YOU CAN ADD TITLE"
        }
      };

      this.$emit("onConfirm", data);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.show = false;
      this.imageSrc = "";
      this.tab = 1;
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    // Scroll the window to the top on load, since most people will get here via footer
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    // Scroll the window to the top on load, since most people will get here via footer
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: '',
      email: '',
      organization: '',
      message: '',

      submitted: false
    };
  },
  created: function created() {
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted: function mounted() {
    document.title = this.$refs.pageTitle.innerHTML;
  },

  methods: {
    submitMessage: function submitMessage() {
      this.$store.dispatch('sendEmail', {
        subject: 'Contact Form Submission',
        message: 'New contact form submission!\n\n' + 'Name: ' + this.name + '\nEmail: ' + this.email + '\nOrganization: ' + this.organization + '\nMessage: ' + this.message,
        // from: 'info@thrivehire.co',
        from: 'contactform@thrivehire.co',
        email: 'aakash@enginehire.ca',
        reply: 'info@thrivehire.org',
        userID: 4
      });
      this.$store.dispatch('sendEmail', {
        subject: 'Contact Form Submission',
        message: 'New contact form submission!\n\n' + 'Name: ' + this.name + '\nEmail: ' + this.email + '\nOrganization: ' + this.organization + '\nMessage: ' + this.message,
        // from: 'info@thrivehire.co',
        from: 'contactform@thrivehire.co',
        // email: 'aakash@enginehire.ca',
        email: 'info@thrivehire.org',
        reply: 'info@thrivehire.org',
        userID: 4
      });
      this.submitted = true;
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiptap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_CustomLink__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__employers_profile_Modal__ = __webpack_require__(343);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor

// import Icon from 'Components/Icon'






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slug: null,
      found: true,
      editing: false,
      content: {},

      title: '',
      text: '',
      textEditor: null,

      linkUrl: null,
      linkMenuIsActive: false
    };
  },

  components: {
    EditorContent: __WEBPACK_IMPORTED_MODULE_1_tiptap__["b" /* EditorContent */],
    EditorMenuBar: __WEBPACK_IMPORTED_MODULE_1_tiptap__["c" /* EditorMenuBar */],
    EditorMenuBubble: __WEBPACK_IMPORTED_MODULE_1_tiptap__["d" /* EditorMenuBubble */],
    Modal: __WEBPACK_IMPORTED_MODULE_4__employers_profile_Modal__["a" /* default */]
  },
  created: function created() {
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    this.slug = this.$route.params.slug;
    this.getContent();
  },
  mounted: function mounted() {
    var _this = this;

    this.textEditor = new __WEBPACK_IMPORTED_MODULE_1_tiptap__["a" /* Editor */]({
      // content: this.description,
      content: this.content.content,
      autoFocus: true,
      extensions: [new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["a" /* Blockquote */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["c" /* BulletList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["e" /* CodeBlock */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["f" /* HardBreak */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["g" /* Heading */]({ levels: [1, 2, 3, 4, 5] }), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["i" /* HorizontalRule */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["m" /* ListItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["n" /* OrderedList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["p" /* TodoItem */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["q" /* TodoList */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["l" /* Link */](), new __WEBPACK_IMPORTED_MODULE_3__global_CustomLink__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["b" /* Bold */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["d" /* Code */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["k" /* Italic */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["o" /* Strike */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["r" /* Underline */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["h" /* History */](), new __WEBPACK_IMPORTED_MODULE_2_tiptap_extensions__["j" /* Image */]()],
      onUpdate: function onUpdate(_ref) {
        var getJSON = _ref.getJSON,
            getHTML = _ref.getHTML;

        _this.text = getHTML();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.textEditor.destroy();
  },

  methods: {
    getContent: function getContent() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/contentpages/?agency=' + this.$store.getters.agencyID.toString() + '&slug=' + this.slug).then(function (res) {
        console.log(res);
        _this2.content = res.data[0];
        document.title = res.data[0].title;
        if (res.data.length == 0) {
          _this2.found = false;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    edit: function edit() {
      this.title = this.content.title;
      this.textEditor.setContent(this.content.content);
      this.text = this.content.content;
      this.editing = true;

      // Scroll the window up
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    save: function save() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/contentpages/' + this.content.id.toString() + '/', {
        title: this.title,
        content: this.text
      }).then(function (res) {
        console.log(res);
        _this3.getContent();
        _this3.editing = false;

        // Scroll the window up
        window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      }).catch(function (error) {
        console.log(error);
      });
    },
    openModal: function openModal(command) {
      this.$refs.ytmodal.showModal(command);
    },
    addCommand: function addCommand(data) {
      if (data.command !== null) {
        data.command(data.data);
      }
    },


    // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Links/index.vue
    showLinkMenu: function showLinkMenu(attrs) {
      var _this4 = this;

      this.linkUrl = attrs.href;
      this.linkMenuIsActive = true;
      this.$nextTick(function () {
        _this4.$refs.linkInput.focus();
      });
    },
    hideLinkMenu: function hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl: function setLinkUrl(command, url) {
      command({ href: url, target: '_blank' });
      this.hideLinkMenu();
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    createContent: function createContent() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/contentpages/', {
        // poster: 1069, // This is Hayley's admin account
        poster: 4,
        slug: 'what-is-global-health',
        title: 'What is Global Health?',
        // // agency_owner: this.$store.getters.agencyName,
        agency_owner: 'ThriveHire',
        // // agency: this.$store.getters.agencyID,
        agency: 4
      }).then(function (res) {
        console.log(res);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios';
 // Don't have to name it axios, can name it anything - Lecture 348

// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      // password: '',

      validEmail: null
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      // https://www.npmjs.com/package/vue-loading-overlay
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(function () {
        loader.hide();
      }, 2000);

      // axios.post('/password-reset/', {
      // axios.post('/rest-auth/password/reset/', {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/password_reset/reset_password/', {
        email: this.email
      }).then(function (res) {
        console.log(res);
        _this.validEmail = true;
      }).catch(function (error) {
        console.log(error);
        _this.validEmail = false;
      });
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Don't have to name it axios, can name it anything - Lecture 348

// https://www.npmjs.com/package/vue-loading-overlay

// Import component

// Import stylesheet

// Init plugin
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      token: null,
      password: '',

      tokenValid: false,
      passwordResetSuccessfully: null
    };
  },
  created: function created() {
    this.token = this.$route.params.token;
    //  this.getUser()
    this.checkToken(); // When someone visits this page by clicking the link in their email, first step is to check if their token is valid

    // https://www.npmjs.com/package/vue-loading-overlay
    var loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(function () {
      loader.hide();
    }, 2000);
  },

  methods: {
    checkToken: function checkToken() {
      var _this = this;

      console.log(this.token);
      // axios.post('/api/password_reset/reset_password/validate_token/', {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/check-token/', {
        // axios.post('/api/password_reset/reset_password/confirm/', {
        token: this.token
        //   password: 'sefunmiReallyRox'
      }).then(function (res) {
        console.log(res);
        console.log('Token is good');
        _this.tokenValid = true;
      }).catch(function (error) {
        console.log(error);
        console.log('Token is bad');
        _this.tokenValid = false;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/reset-password/', {
        token: this.token,
        password: this.password
      }).then(function (res) {
        console.log(res);
        console.log('Password Reset!');
        _this2.passwordResetSuccessfully = true;
      }).catch(function (error) {
        console.log(error);
        console.log('Password not reset...');
        _this2.passwordResetSuccessfully = false;
      });
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(214);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show error dialog.
To show an error, call this.showErrorDialog(errorObject)
Structure of errorObject:
{
    title: 'String',
    message: 'String',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbacData: object <- This field is optional, it is parameter of onCloseCallback function
}

*/


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ErrorDialog",
  data: function data() {
    return {
      title: "",
      message: "",
      errorObj: null,
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null
    };
  },
  methods: {
    extractErrorContent: function extractErrorContent(content) {
      if (typeof content !== "string") {
        return content;
      }
      var matchArr = content.match(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["a" /* REGEX_EXTRACT_TAG_CONTENT */]);
      if (matchArr != null) {
        return matchArr[1];
      }
      return content;
    },
    closeErrorDialog: function closeErrorDialog() {
      this.$modal.hide("error-dialog");
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showErrorDialog(null);
    },
    showError: function showError(errorDialog) {
      this.title = errorDialog.title;
      this.message = errorDialog.message;
      this.errorObj = errorDialog.errorObj;
      if (errorDialog.messageList) {
        this.messageList = errorDialog.messageList;
      }
      if (!errorDialog.closeLabel) {
        this.closeLabel = "Close";
      } else {
        this.closeLabel = errorDialog.closeLabel;
      }
      this.onCloseCallback = errorDialog.onCloseCallback;
      this.onCloseCallbackData = errorDialog.onCloseCallbackData;
      this.$modal.show("error-dialog");
    },
    getDisplayKey: function getDisplayKey(key) {
      if (key === "reply_address") {
        return "email address";
      } else {
        return key;
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.dialogs.errorDialog;
    }, function (value) {
      if (_this.$store.getters.loadingReqNumber > 0) {
        return;
      }
      if (!value) {
        _this.$modal.hide("error-dialog");
        _this.showErrorDialog(null);
      } else {
        _this.showError(value);
      }
    }, { immediate: true });

    this.$store.watch(function (state) {
      return state.dialogs.loadingReqNumber;
    }, function (value) {
      if (value > 0) {
        return;
      }
      var errorDialog = _this.$store.getters.errorDialog;
      if (errorDialog == null) {
        return;
      }
      _this.showError(errorDialog);
    }, { immediate: true });
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show confirm dialog.
To show an confirm, call this.showConfirmDialog(confirmObject)
Structure of confirmObject:
{
    message: 'String',
    acceptLabel: 'String', <- This field is optional, if not set, use default: Yes
    rejectLabel: 'String',  <- This field is optional, if not set, use default: No
    onAcceptCallback: function reference <- This field is optional, if set, the function will be called after click accept button 
    onAcceptCallbackData: object <- This field is optional, it is parameter of onAcceptCallback function
}

*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ConfirmDialog",
  data: function data() {
    return {
      message: "",
      acceptLabel: "",
      rejectLabel: "",
      onAcceptCallback: null,
      onAcceptCallbackData: null
    };
  },
  methods: {
    onReject: function onReject() {
      this.$modal.hide("confirm-dialog");
      this.showConfirmDialog(null);
    },
    onAccept: function onAccept() {
      console.log("on accept");
      this.$modal.hide("confirm-dialog");
      if (this.onAcceptCallback) {
        if (!this.onAcceptCallbackData) {
          this.onAcceptCallback();
        } else {
          this.onAcceptCallback(this.onAcceptCallbackData);
        }
      }
      this.showConfirmDialog(null);
    }
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.dialogs.confirmDialog;
    }, function (value) {
      if (!value) {
        _this.$modal.hide("confirm-dialog");
        _this.showConfirmDialog(null);
      } else {
        if (_this.isShow) {
          return;
        }
        _this.message = value.message;
        if (!value.acceptLabel) {
          _this.acceptLabel = "Yes";
        } else {
          _this.acceptLabel = value.acceptLabel;
        }
        if (!value.rejectLabel) {
          _this.rejectLabel = "No";
        } else {
          _this.rejectLabel = value.rejectLabel;
        }
        _this.onAcceptCallback = value.onAcceptCallback;
        _this.onAcceptCallbackData = value.onAcceptCallbackData;
        _this.$modal.show("confirm-dialog");
      }
    }, { immediate: true });
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show result dialog.
To show an result, call this.showResultDialog(resultObject)
Structure of resultObject:
{
    title: 'String',
    message: 'String',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbacData: object <- This field is optional, it is parameter of onCloseCallback function
}

*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ResultDialog",
  data: function data() {
    return {
      title: "",
      message: "",
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null,
      innerHtml: null,
      additionalFooter: null
    };
  },
  methods: {
    closeResultDialog: function closeResultDialog() {
      this.$modal.hide("result-dialog");
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showResultDialog(null);
    }
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.dialogs.resultDialog;
    }, function (value) {
      if (!value) {
        _this.$modal.hide("result-dialog");
        _this.showResultDialog(null);
      } else {
        if (_this.isShow) {
          return;
        }
        _this.title = value.title;
        _this.message = value.message;
        if (value.messageList) {
          _this.messageList = value.messageList;
        }
        _this.innerHtml = value.innerHtml;
        _this.additionalFooter = value.additionalFooter;
        if (!value.closeLabel) {
          _this.closeLabel = "Close";
        } else {
          _this.closeLabel = value.closeLabel;
        }
        _this.onCloseCallback = value.onCloseCallback;
        _this.onCloseCallbackData = value.onCloseCallbackData;
        _this.$modal.show("result-dialog");
      }
    }, { immediate: true });
  }
});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {
  inject: {
    '$mapPromise': { default: 'abcdef' }
  },

  provide: function provide() {
    var _this = this;

    // Note: although this mixin is not "providing" anything,
    // components' expect the `$map` property to be present on the component.
    // In order for that to happen, this mixin must intercept the $mapPromise
    // .then(() =>) first before its component does so.
    //
    // Since a provide() on a mixin is executed before a provide() on the
    // component, putting this code in provide() ensures that the $map is
    // already set by the time the
    // component's provide() is called.
    this.$mapPromise.then(function (map) {
      _this.$map = map;
    });

    return {};
  }
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(960)));

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(965)));

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(970)));

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bindProps = __webpack_require__(76);

var _simulateArrowDown = __webpack_require__(361);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    this.$gmapApiPromiseLazy().then(function () {
      var options = (0, _bindProps.getPropsValues)(_this, props);
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);

      var placeholder = props.placeholder,
          place = props.place,
          defaultPlace = props.defaultPlace,
          className = props.className,
          label = props.label,
          selectFirstOnEnter = props.selectFirstOnEnter,
          rest = _objectWithoutProperties(props, ['placeholder', 'place', 'defaultPlace', 'className', 'label', 'selectFirstOnEnter']); // eslint-disable-line


      (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function (event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(975)));

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(364);
module.exports = __webpack_require__(566);


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(365);

__webpack_require__(562);

__webpack_require__(563);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(366);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(118);
__webpack_require__(470);
__webpack_require__(166);
__webpack_require__(471);
__webpack_require__(167);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(170);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
module.exports = __webpack_require__(31);


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(6);
var has = __webpack_require__(27);
var DESCRIPTORS = __webpack_require__(12);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(24);
var META = __webpack_require__(48).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(68);
var setToStringTag = __webpack_require__(64);
var uid = __webpack_require__(53);
var wks = __webpack_require__(9);
var wksExt = __webpack_require__(148);
var wksDefine = __webpack_require__(99);
var enumKeys = __webpack_require__(368);
var isArray = __webpack_require__(79);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var toObject = __webpack_require__(15);
var toIObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(38);
var createDesc = __webpack_require__(52);
var _create = __webpack_require__(56);
var gOPNExt = __webpack_require__(151);
var $GOPD = __webpack_require__(29);
var $GOPS = __webpack_require__(78);
var $DP = __webpack_require__(14);
var $keys = __webpack_require__(54);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(57).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(70).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(47)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(68)('native-function-to-string', Function.toString);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(54);
var gOPS = __webpack_require__(78);
var pIE = __webpack_require__(70);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(56) });


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(14).f });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(150) });


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(28);
var $getOwnPropertyDescriptor = __webpack_require__(29).f;

__webpack_require__(40)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(15);
var $getPrototypeOf = __webpack_require__(30);

__webpack_require__(40)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(15);
var $keys = __webpack_require__(54);

__webpack_require__(40)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(40)('getOwnPropertyNames', function () {
  return __webpack_require__(151).f;
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(48).onFreeze;

__webpack_require__(40)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(48).onFreeze;

__webpack_require__(40)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(48).onFreeze;

__webpack_require__(40)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(40)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(40)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(40)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(152) });


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(153) });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(103).set });


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(65);
var test = {};
test[__webpack_require__(9)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(24)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(154) });


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(30);
var HAS_INSTANCE = __webpack_require__(9)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(14).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(156);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(157);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var has = __webpack_require__(27);
var cof = __webpack_require__(33);
var inheritIfRequired = __webpack_require__(105);
var toPrimitive = __webpack_require__(38);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(57).f;
var gOPD = __webpack_require__(29).f;
var dP = __webpack_require__(14).f;
var $trim = __webpack_require__(66).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(56)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(24)(global, NUMBER, $Number);
}


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(34);
var aNumberValue = __webpack_require__(158);
var repeat = __webpack_require__(106);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(158);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(6).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(159) });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(159);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(157);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(156);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(160);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(107);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(108);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(161) });


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(160) });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(107) });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(108);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(108);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(55);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(28);
var toLength = __webpack_require__(10);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(66)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(80)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(109)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(80)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(10);
var context = __webpack_require__(111);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(112)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(111);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(112)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(106)
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(10);
var context = __webpack_require__(111);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(112)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(25)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(25)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(25)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(25)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(25)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(25)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(25)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(25)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(25)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(25)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(25)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(25)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(25)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(38);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(445);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(24)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(23)(proto, TO_PRIMITIVE, __webpack_require__(448));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(38);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(79) });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(32);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var call = __webpack_require__(162);
var isArrayIter = __webpack_require__(113);
var toLength = __webpack_require__(10);
var createProperty = __webpack_require__(114);
var getIterFn = __webpack_require__(115);

$export($export.S + $export.F * !__webpack_require__(82)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(114);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(28);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(69) != Object || !__webpack_require__(35)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(102);
var cof = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(10);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(15);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(35)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(41)(0);
var STRICT = __webpack_require__(35)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(79);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(41)(1);

$export($export.P + $export.F * !__webpack_require__(35)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(41)(2);

$export($export.P + $export.F * !__webpack_require__(35)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(41)(3);

$export($export.P + $export.F * !__webpack_require__(35)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(41)(4);

$export($export.P + $export.F * !__webpack_require__(35)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(163);

$export($export.P + $export.F * !__webpack_require__(35)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(163);

$export($export.P + $export.F * !__webpack_require__(35)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(77)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(35)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(28);
var toInteger = __webpack_require__(34);
var toLength = __webpack_require__(10);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(35)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(164) });

__webpack_require__(49)('copyWithin');


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(117) });

__webpack_require__(49)('fill');


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(41)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(49)(KEY);


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(41)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(49)(KEY);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(58)('Array');


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var inheritIfRequired = __webpack_require__(105);
var dP = __webpack_require__(14).f;
var gOPN = __webpack_require__(57).f;
var isRegExp = __webpack_require__(81);
var $flags = __webpack_require__(71);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(9)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(24)(global, 'RegExp', $RegExp);
}

__webpack_require__(58)('RegExp');


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(167);
var anObject = __webpack_require__(5);
var $flags = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(12);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(24)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var toLength = __webpack_require__(10);
var advanceStringIndex = __webpack_require__(120);
var regExpExec = __webpack_require__(83);

// @@match logic
__webpack_require__(84)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(10);
var toInteger = __webpack_require__(34);
var advanceStringIndex = __webpack_require__(120);
var regExpExec = __webpack_require__(83);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(84)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var sameValue = __webpack_require__(153);
var regExpExec = __webpack_require__(83);

// @@search logic
__webpack_require__(84)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(81);
var anObject = __webpack_require__(5);
var speciesConstructor = __webpack_require__(72);
var advanceStringIndex = __webpack_require__(120);
var toLength = __webpack_require__(10);
var callRegExpExec = __webpack_require__(83);
var regexpExec = __webpack_require__(119);
var fails = __webpack_require__(7);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(84)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(47);
var global = __webpack_require__(6);
var ctx = __webpack_require__(32);
var classof = __webpack_require__(65);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(59);
var forOf = __webpack_require__(60);
var speciesConstructor = __webpack_require__(72);
var task = __webpack_require__(121).set;
var microtask = __webpack_require__(122)();
var newPromiseCapabilityModule = __webpack_require__(123);
var perform = __webpack_require__(168);
var userAgent = __webpack_require__(85);
var promiseResolve = __webpack_require__(169);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(61)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(64)($Promise, PROMISE);
__webpack_require__(58)(PROMISE);
Wrapper = __webpack_require__(31)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(82)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(174);
var validate = __webpack_require__(62);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(86)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(87);
var buffer = __webpack_require__(124);
var anObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(10);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(6).ArrayBuffer;
var speciesConstructor = __webpack_require__(72);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(58)(ARRAY_BUFFER);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(87).ABV, {
  DataView: __webpack_require__(124).DataView
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(5);
var rApply = (__webpack_require__(6).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(56);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var bind = __webpack_require__(154);
var rConstruct = (__webpack_require__(6).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(14);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(38);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(29).f;
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(5);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(110)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(30);
var has = __webpack_require__(27);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(5);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(29);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(30);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(5);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(176) });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(5);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(14);
var gOPD = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(30);
var has = __webpack_require__(27);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(52);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(103);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(77)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(49)('includes');


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(177);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(10);
var aFunction = __webpack_require__(19);
var arraySpeciesCreate = __webpack_require__(116);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(49)('flatMap');


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(177);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(10);
var toInteger = __webpack_require__(34);
var arraySpeciesCreate = __webpack_require__(116);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(49)('flatten');


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(80)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(178);
var userAgent = __webpack_require__(85);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(178);
var userAgent = __webpack_require__(85);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(66)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(66)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(39);
var toLength = __webpack_require__(10);
var isRegExp = __webpack_require__(81);
var getFlags = __webpack_require__(71);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(110)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99)('asyncIterator');


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99)('observable');


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(176);
var toIObject = __webpack_require__(28);
var gOPD = __webpack_require__(29);
var createProperty = __webpack_require__(114);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(179)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(179)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(14);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(12) && $export($export.P + __webpack_require__(88), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(14);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(12) && $export($export.P + __webpack_require__(88), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(30);
var getOwnPropertyDescriptor = __webpack_require__(29).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(88), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(30);
var getOwnPropertyDescriptor = __webpack_require__(29).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(88), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(180)('Map') });


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(180)('Set') });


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(89)('Map');


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(89)('Set');


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(89)('WeakMap');


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(89)('WeakSet');


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(90)('Map');


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(90)('Set');


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(90)('WeakMap');


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(90)('WeakSet');


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(6) });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(6) });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(33);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(182);
var fround = __webpack_require__(161);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(182) });


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(31);
var global = __webpack_require__(6);
var speciesConstructor = __webpack_require__(72);
var promiseResolve = __webpack_require__(169);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(123);
var perform = __webpack_require__(168);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(30);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(172);
var from = __webpack_require__(181);
var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(30);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(30);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(45);
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(19);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(122)();
var process = __webpack_require__(6).process;
var isNode = __webpack_require__(33)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(6);
var core = __webpack_require__(31);
var microtask = __webpack_require__(122)();
var OBSERVABLE = __webpack_require__(9)('observable');
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(5);
var anInstance = __webpack_require__(59);
var redefineAll = __webpack_require__(61);
var hide = __webpack_require__(23);
var forOf = __webpack_require__(60);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(58)('Observable');


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(6);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(85);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(121);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(118);
var getKeys = __webpack_require__(54);
var redefine = __webpack_require__(24);
var global = __webpack_require__(6);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(67);
var wks = __webpack_require__(9);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(564);
module.exports = __webpack_require__(31).RegExp.escape;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(565)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_dialog__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_data_handling__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bugsnag_js__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue__);


 // https://alligator.io/vuejs/vue-google-maps/
 // Lecture 346

 // Lecture 373, https://vuelidate.js.org/#sub-package-content
 // https://www.npmjs.com/package/vue-js-modal
 // https://vue-multiselect.js.org/






// import CKEditor from '@ckeditor/ckeditor5-vue'; // https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs.html
// import VueCkeditor from 'vueckeditor';

 // https://www.npmjs.com/package/vue-youtube-embed




__WEBPACK_IMPORTED_MODULE_12__bugsnag_js___default.a.start({
  apiKey: "2a6296d189eaeb4e32edf8b81ccbec1e",
  plugins: [new __WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue___default.a()]
});

__WEBPACK_IMPORTED_MODULE_12__bugsnag_js___default.a.getPlugin("vue").installVueErrorHandler(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]);

// https://vsupalov.com/avoid-csrf-errors-axios-django/
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.xsrfCookieName = "csrftoken";
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.xsrfHeaderName = "X-CSRFTOKEN";

// axios.defaults.baseURL = 'http://127.0.0.1:8000' // Lecture 346
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = "https://enginehire.io"; // Lecture 346

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a); // Lecture 373, https://vuelidate.js.org/#sub-package-content
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default.a); // https://www.npmjs.com/package/vue-js-modal
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("multiselect", __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a); // https://vue-multiselect.js.org

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: "AIzaSyAjRmYdMmC9yr1dP8Kqi7FPS_8_CsvT2qc",
    libraries: "places" // necessary for places input
  }
});

// Vue.use( CKEditor );
// Vue.use( VueCkeditor );

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__["a" /* default */]);

// https://scotch.io/tutorials/how-to-create-filters-in-vuejs-with-examples
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("trimSeconds", function (value) {
  // Used for trimming the seconds off an event time (turn 18:00:00 into 18:00)
  return value.slice(0, -3); // https://stackoverflow.com/questions/952924/javascript-chop-slice-trim-off-last-character-in-string
});
// https://stackoverflow.com/questions/44538110/how-to-format-numbers-in-vuejs
// http://numeraljs.com/
var numeral = __webpack_require__(996);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("singleDecimal", function (value) {
  // Used for making something 1 decimal (good for actual distances)
  return numeral(value).format("0.0");
});

// https://vuejs.org/v2/guide/mixins.html#Global-Mixin
// https://stackoverflow.com/questions/42613061/vue-js-making-helper-functions-globally-available-to-single-file-components
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  data: function data() {
    return {
      justTesting: "jsfkhg"
    };
  },

  computed: {
    todayDjangoFormat: function todayDjangoFormat() {
      // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      var today = new Date();
      return today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + today.getDate().toString()).slice(-2);
    },
    todayDatetimeDjangoFormat: function todayDatetimeDjangoFormat() {
      // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      var today = new Date();
      return today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + today.getDate().toString()).slice(-2) + "T" + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    },
    auth: function auth() {
      // Lecture 363
      //
      // Check if someone is logged in
      //
      return __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].getters.isAuthenticated;
    }
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].dispatch("logout");
    },
    checkInteger: function checkInteger(userinput) {
      //
      // Using this function to check if a user has entered an integer in number fields and display an error message if not
      //

      // Don't want to show an error if the field is blank
      if (userinput == null || userinput == "") {
        return false;
      }

      // https://stackoverflow.com/questions/1779013/check-if-string-contains-only-digits
      console.log(userinput);
      // console.log(Number.isInteger(userinput))
      // console.log(!isNaN(userinput)) // https://www.mkyong.com/javascript/check-if-variable-is-a-number-in-javascript/
      console.log(/^\d+$/.test(userinput));
      if (/^\d+$/.test(userinput)) {
        console.log("Is an integer!");
        return false;
      } else {
        console.log("Is not an integer");
        return true;
      }
    },
    dateInDjangoFormat: function dateInDjangoFormat(date) {
      // Want to convert date in the YYYY-MM-DD format for Django storage
      return date.getFullYear().toString() + "-" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + date.getDate().toString()).slice(-2);
    },
    addCurrentTimeToDate: function addCurrentTimeToDate(date) {
      var today = new Date();
      var hourNow = today.getHours();
      // https://stackoverflow.com/questions/18889548/javascript-change-gethours-to-2-digit
      // Need to make sure each of these values is 2 digits, otherwise it breaks the human date generation below
      hourNow = ("0" + hourNow).slice(-2);
      var minuteNow = today.getMinutes();
      minuteNow = ("0" + minuteNow).slice(-2);
      var secondNow = today.getMinutes();
      secondNow = ("0" + secondNow).slice(-2);

      return new Date(date.concat("T").concat(hourNow).concat(":").concat(minuteNow).concat(":").concat(secondNow));
    },
    convertTimeFormat: function convertTimeFormat(str) {
      //convert AM/PM to military time (ie. 19:00:00)
      console.log(str);
      var time = str;
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return sHours + ":" + sMinutes + ":00";
    },

    // https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
    formatAMPM: function formatAMPM(date) {
      // Take a javascript date and spit out the time in AMPM format
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    djangotimeformatAMPM: function djangotimeformatAMPM(djangotime) {
      // Take a django 24 hour time and return it in AMPM format
      // console.log(djangotime)
      if (djangotime) {
        var hours = djangotime.split(":")[0];
        var minutes = djangotime.split(":")[1];
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        // minutes = minutes < 10 ? '0'+minutes : minutes; // minutes are already padded in django time
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      } else {
        return strTime;
      }
    },

    // getAge(birthday) {
    //     var today = new Date();
    //     var birthDate = new Date(birthday);
    //     var age = today.getFullYear() - birthDate.getFullYear();
    //     var m = today.getMonth() - birthDate.getMonth();
    //     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    //     {
    //         age--;
    //     }
    //     return age;
    // },
    getAge: function getAge(birthday) {
      var today = new Date();
      var birthDate = new Date(birthday);

      if (birthDate > today) {
        return "Coming soon!";
      } else {
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
          // if we are in the same month as the birth month, need to check if the birthday has passed or not
          age--;
          m--; // This makes it say 11 months if we are in the birth month but before the birthday
        }
        if (m < 0) {
          m = 12 + m;
        }

        if (age >= 3) {
          return age + " years";
        } else if (age === 1) {
          return age + " year, " + m + " months";
        } else {
          return age + " years, " + m + " months";
        }
      }
    },
    dashboardRedirect: function dashboardRedirect() {
      //
      // Redirect a logged in user to their appropriate dashboard page
      //
      // this.userID = this.$store.getters.userID
      // axios.get('/api/people/'.concat(this.userID))
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/api/people/?id=".concat(__WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].getters.userID)).then(function (res) {
        console.log(res.data);
        var user = res.data[0];

        if (user.is_candidate) {
          __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace({ name: "Candidate Dashboard" });
        } else if (user.is_employer) {
          __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace({ name: "Employer Dashboard" });
        } else if (user.is_agent) {
          __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace({ name: "Agent Dashboard" });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
    // Used for trying to seamlessly log people in with capitalized email addresses
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(568);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(183)))

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d4a6e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(950);
function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d4a6e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("eeb2226c", content, true, {});

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ":root{--agencycolor:#feedef;--coredarkcolor:#f66;--coredarkercolor:#c95151;--secondarycolor:#f59eca;--secondarydarkercolor:#f386bc;--corelightcolor:#fff;--bootstrapgrey:#e9ecef;--skyblue:#bfe7ff;--thrivehiregrey:#d9d9da;--nannycogreen:#0c4524;--gcnorange:#e79271;--gcnteal:#85a2a8}body{font-family:Open Sans,Crimson Text}#app{font-family:Quicksand,Open Sans,Crimson Text;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.top-level-div{padding-bottom:20vh;padding-top:15vh}.invert-top-level-div{padding-bottom:-20vh;padding-top:-100px}.center{text-align:center;display:block;margin-left:auto;margin-right:auto}h1,h2,h3,h4{font-family:Quicksand,Rajdhani,sans-serif;text-transform:uppercase}h1,h2,h3{color:var(--coredarkcolor)}p{margin-bottom:0}.dashboard-heading{font-family:articulatcf-demibold,articulatcf-regular,Open Sans,Lato}pre{font-family:Quicksand,Open Sans,Crimson Text,articulatcf-regular,Lato;font-size:100%;white-space:pre-wrap;margin-bottom:0}pre p{margin-bottom:10px}pre h3,pre h4,pre h5{margin-top:15px}pre img{margin-top:8px;margin-bottom:8px}ul{margin-bottom:0}a:hover{text-decoration:none}input{font-family:Quicksand,Open Sans,Crimson Text}input::placeholder{font-family:Quicksand,Open Sans,Crimson Text;font-size:.8rem}.delete-text{color:red;cursor:pointer}.btn{border:none}.btn-lg{font-size:1.1rem}.btn-primary{background-color:var(--coredarkcolor);font-weight:600}.btn-primary:hover{background-color:var(--thrivehiregrey);color:var(--coredarkcolor)}.btn-outline-primary{color:#5289b9}.btn-secondary{background-color:var(--bootstrapgrey);color:var(--coredarkcolor)}.btn-secondary:hover{background-color:var(--thrivehiregrey);color:var(--coredarkcolor)}.btn-grey{background-color:var(--bootstrapgrey);color:var(--coredarkcolor)}.btn-grey:hover{background-color:var(--coredarkcolor);color:var(--corelightcolor)}.buttons{display:inline-block;transition:all .2s ease;overflow:hidden;border-radius:3px;line-height:16px;font-weight:700}.header-button{align-items:center;height:50px}.header-button button{padding:15px 25px}.button-1{color:var(--coredarkcolor);border:none;background:#fff;font-size:14px}.button-1:hover{color:#fff;cursor:pointer}.button-1-dark,.button-1:hover{background:var(--coredarkcolor)}.button-1-dark{color:var(--corelightcolor);border:none;font-size:14px}.button-1-dark:hover{color:var(--coredarkcolor);cursor:pointer;background:var(--thrivehiregrey)}.landing-button{min-width:165px;font-family:articulatcf-demibold,Montserrat;font-weight:800;margin-top:20px}.mylisting-button{min-width:135px;text-align:center;font-family:Quicksand,Open Sans;font-weight:600;padding:13px 25px;border-radius:0;font-size:12px;-webkit-box-align:center;align-items:center;position:relative;z-index:0;-webkit-box-pack:center;justify-content:center;white-space:nowrap;border:2px solid #0c4524;border:none}a.mylisting-button:hover{text-decoration:none}.dark-button{color:#fff;background:linear-gradient(90deg,var(--coredarkercolor) 50%,var(--coredarkcolor) 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.dark-button:hover{color:#fff;background-position:0 100%}.secondary-button{color:#fff;background:linear-gradient(90deg,var(--secondarydarkercolor) 50%,var(--secondarycolor) 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.secondary-button:hover{color:#fff;background-position:0 100%}.danger-button{color:#fff;background:linear-gradient(90deg,#222 50%,#333 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.danger-button:hover{color:#fff;background-position:0 100%}.nav-item{margin-right:15px;font-size:13px;color:var(--corelightcolor)}.dropleft .dropdown-toggle:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent;border:none}.footer p{margin-bottom:0}.profile-tile{border-radius:6px;box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important;padding:1.5rem;margin-top:40px}.profile-form label,.profile label{font-weight:600;margin-top:15px}.profile label{margin-bottom:2px}.profile .top-label{margin-top:0}.field-of-fields label{color:var(--coredarkcolor);font-weight:600;margin-top:25px;margin-bottom:2px}.field-of-fields .top-label{margin-top:0}.form-check label{font-weight:400;margin-top:2px;color:var(--coredarkcolor)}.invalid label,.invalid small{color:red}.social-icon{margin-right:2px;margin-left:2px;height:25px}.shaded-label{background-color:var(--bootstrapgrey);width:100%;padding:10px;border-bottom:7px solid var(--corelightcolor)}.profile-section{margin-left:10px;margin-right:10px}.dashboard-button{border-right:2px solid #fff;padding-top:6px;padding-bottom:6px;cursor:pointer;font-weight:700}.dashboard-button,.dashboard-button-active{background-color:var(--thrivehiregrey);color:var(--corelightcolor)}.dashboard-button-active{background-color:var(--coredarkcolor)}.editor__content{border:1px solid #ced4da;padding:.375rem .75rem;border-radius:.25rem;color:#495057;font-size:1rem}.ProseMirror:focus{outline:none}.ProseMirror{min-height:100px}.editor__content p{margin-bottom:0}.vdp-datepicker input{border-width:0;width:100%}.vdp-datepicker input[type=text]:focus{box-shadow:none;border:none}.registration-form{height:100vh;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-top:40px;padding-bottom:40px;background-color:#f5f5f5}.form-signup{width:100%;max-width:330px;padding:15px;margin:auto}.form-signup .checkbox{font-weight:400}.form-signup .form-control{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.v--modal-overlay.scrollable .v--modal-box{max-height:90vh;overflow-y:auto}.content-block{max-width:650px;display:block;margin-left:auto;margin-right:auto;margin-top:15px}.content-block img{max-width:100%}.informational-heading,.informational-subheading{margin-top:25px}.informational-list,.informational-text-block{margin-bottom:10px}.multiselect__tag{margin-bottom:0;background-color:var(--coredarkcolor)}.multiselect__option--highlight{background:var(--coredarkcolor)}.listing-tile{background-color:var(--bootstrapgrey);padding:20px 30px}.document{padding:3% 10%}.document p{margin-bottom:15px}.document li,.document p{font-size:1.2rem}.mobile-only{display:none}@media (max-width:768px){.mobile-only{display:inherit}.web-only{display:none}.landing .dropdown-item{color:var(--coredarkcolor);font-size:13px}.navbar{padding-left:0;padding-right:0}h1{font-size:2rem;line-height:1.1}.v--modal-overlay.scrollable .v--modal-box{max-height:80vh;overflow-y:auto}.grouped-buttons{display:flex;flex-direction:column;align-items:center}}.required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Open Sans,Crimson Text;font-weight:600;margin-top:2px}.vld-overlay.is-full-page{z-index:10000}.submit-button-section{margin-top:30px;display:flex;justify-content:flex-end}.text-require-notice{font-size:.8rem;color:var(--coredarkcolor)}.edit-button{float:right;cursor:pointer;width:16px}.form-control-file{font-size:.8rem}.date-picker{padding:0!important}.date-picker input{height:calc(1.5em + .75rem)!important;border-radius:4px!important;padding-left:.75rem}", ""]);

// exports


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97edd80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__(590);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97edd80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var bind = __webpack_require__(186);
var Axios = __webpack_require__(576);
var mergeConfig = __webpack_require__(192);
var defaults = __webpack_require__(189);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(193);
axios.CancelToken = __webpack_require__(588);
axios.isCancel = __webpack_require__(188);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(589);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var buildURL = __webpack_require__(187);
var InterceptorManager = __webpack_require__(577);
var dispatchRequest = __webpack_require__(578);
var mergeConfig = __webpack_require__(192);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);
  config.method = config.method ? config.method.toLowerCase() : 'get';

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var transformData = __webpack_require__(579);
var isCancel = __webpack_require__(188);
var defaults = __webpack_require__(189);
var isAbsoluteURL = __webpack_require__(586);
var combineURLs = __webpack_require__(587);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(191);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(193);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h2',[_vm._v("Search and add a pin")]),_vm._v(" "),_c('label',[_c('gmap-autocomplete',{on:{"place_changed":_vm.setPlace}}),_vm._v(" "),_c('button',{on:{"click":_vm.addMarker}},[_vm._v("Add")])],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"650px"},attrs:{"center":_vm.center,"zoom":2.75}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=m.position}}})}),1),_vm._v(" "),_vm._l((_vm.jobs),function(job){return _c('div',{key:job.id,staticClass:"mt-2"},[_c('p',{staticClass:"mt-4",staticStyle:{"font-size":"22px","font-weight":"600","color":"#E80000","margin-bottom":"0.25rem"}},[_vm._v(_vm._s(job.title))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0rem"}},[_vm._v(_vm._s(job.company))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"18px","font-weight":"400","color":"#999"}},[_vm._v(_vm._s(job.city)+", "+_vm._s(job.provincestate)+", "+_vm._s(job.country_selector)+" ")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"650px","width":"100%"},attrs:{"id":"map"}}),_vm._v(" "),_vm._l((_vm.jobs),function(job){return _c('div',{key:job.id,staticClass:"mt-1 pb-2 pt-1 px-2",staticStyle:{"background-color":"#e9ecef"}},[_c('p',{staticClass:"mt-4",staticStyle:{"font-size":"22px","font-weight":"600","color":"#E80000","margin-bottom":"0.25rem"}},[_vm._v(_vm._s(job.title))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0rem"}},[_vm._v(_vm._s(job.company))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"18px","font-weight":"400","color":"#999"}},[_vm._v(_vm._s(job.city)+", "+_vm._s(job.provincestate)+", "+_vm._s(job.country_selector)+" ")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1831fb81_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1831fb81_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("f0e1d740", content, true, {});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".footer-logo{max-width:225px}", ""]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white","text-align":"center","padding-top":"3.5vh","padding-bottom":"6.5vh"}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"px-4"},[_c('img',{staticClass:"mt-4 footer-logo",attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "GoldCoastNannies_Logo_FullColor-01.png?f6e03e9fae27d085e844dc9bedf6c967";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "NAN_logomark_RGB_Evergreen.png?e8e083e116244aae338d7b5b2a0c8b7e";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "NAN_logomark_RGB_Evergreen_trim.png?5fd28484df54ff82f4030fe297a1671c";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "PinkNannies-Circle.svg?15f79471eac73fffb57bd540f9e741fd";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ttnyc-logo-hires.jpg?37001c7064f42376d82b41f1e0e2fdb4";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ttnyc-logo-old.jpg?6ceca660da900485fdb0b58dbda19e24";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ttnyc-logo.jpg?ed30eaa1c16255a506c034c894b8fc05";

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.1.3
  * (c) 2019 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isExtendedError (constructor, err) {
  return (
    err instanceof constructor ||
    // _name is to support IE9 too
    (err && (err.name === constructor.name || err._name === constructor._name))
  )
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode && parent.$vnode.data;
      if (vnodeData) {
        if (vnodeData.routerView) {
          depth++;
        }
        if (vnodeData.keepAlive && parent._inactive) {
          inactive = true;
        }
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    if (params.pathMatch) { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    return extend({}, raw)
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.props.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  window.history.replaceState({ key: getStateKey() }, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && 'pushState' in window.history
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: getStateKey() }, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

var NavigationDuplicated = /*@__PURE__*/(function (Error) {
  function NavigationDuplicated (normalizedLocation) {
    Error.call(this);
    this.name = this._name = 'NavigationDuplicated';
    // passing the message to super() doesn't seem to work in the transpiled version
    this.message = "Navigating to current location (\"" + (normalizedLocation.fullPath) + "\") is not allowed";
    // add a stack property so services like Sentry can correctly display it
    Object.defineProperty(this, 'stack', {
      value: new Error().stack,
      writable: true,
      configurable: true
    });
    // we could also have used
    // Error.captureStackTrace(this, this.constructor)
    // but it only exists on node and chrome
  }

  if ( Error ) NavigationDuplicated.__proto__ = Error;
  NavigationDuplicated.prototype = Object.create( Error && Error.prototype );
  NavigationDuplicated.prototype.constructor = NavigationDuplicated;

  return NavigationDuplicated;
}(Error));

// support IE9
NavigationDuplicated._name = 'NavigationDuplicated';

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        this$1.ready = true;
        this$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    // after merging https://github.com/vuejs/vue-router/pull/2771 we
    // When the user navigates through history through back/forward buttons
    // we do not want to throw the error. We only throw it if directly calling
    // push/replace. That's why it's not included in isError
    if (!isExtendedError(NavigationDuplicated, err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort(new NavigationDuplicated(route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key, cbs, isValid)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    var this$1 = this;

    History.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(
      supportsPushState ? 'popstate' : 'hashchange',
      function () {
        var current = this$1.current;
        if (!ensureSlash()) {
          return
        }
        this$1.transitionTo(getHash(), function (route) {
          if (supportsScroll) {
            handleScroll(this$1.router, route, current, true);
          }
          if (!supportsPushState) {
            replaceHash(route.fullPath);
          }
        });
      }
    );
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
      href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
    } else { href = decodeURI(href); }
  } else {
    if (searchIndex > -1) {
      href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
    }
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        this$1.index = targetIndex;
        this$1.updateRoute(route);
      },
      function (err) {
        if (isExtendedError(NavigationDuplicated, err)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.1.3';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ae4d18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__(607);
function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ae4d18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(606);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("f51caa2e", content, true, {});

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".landing{height:100vh;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-repeat:no-repeat}", ""]);

// exports


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"landing center"},[_c('img',{staticClass:"center mb-4",staticStyle:{"padding-top":"25vh","width":"80%","max-width":"250px"},attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"grouped-buttons",staticStyle:{"margin-top":"45px","margin-bottom":"25px"}},[_c('router-link',{staticClass:"mylisting-button dark-button mb-2",attrs:{"to":{ name: 'Candidate Application Form' }}},[_vm._v("Nanny/NCS/Private Educator Application Form")]),_vm._v(" "),_c('a',{staticClass:"mylisting-button dark-button mb-2",attrs:{"href":"https://agency.enginehire.io/application-form/33/438"}},[_vm._v("Household Staffing Application")]),_vm._v(" "),_c('router-link',{staticClass:"mylisting-button dark-button mb-2",attrs:{"to":{ name: 'Employer Application Form' }}},[_vm._v("Family Application Form")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617f70b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617f70b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(610);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6800120b", content, true, {});

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".login-form{height:100vh;width:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-top:40px;padding-bottom:40px}.form-signin{width:100%;max-width:330px;padding:15px;margin:auto}.form-signin .checkbox{font-weight:400}.form-signin .form-control{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.form-signin .form-control:focus{z-index:2}.form-signin input[type=email]{margin-bottom:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0}.form-signin input[type=password]{margin-bottom:10px;border-top-left-radius:0;border-top-right-radius:0}", ""]);

// exports


/***/ }),
/* 611 */
/***/ (function(module, exports) {

// // Lecture 348
// import axios from 'axios'

// const instance = axios.create({
//   baseURL: 'http://127.0.0.1:8000'
//   // baseURL: 'https://enginehire.io'
// })

// // instance.defaults.headers.common['SOMETHING'] = 'something'

// export default instance // This axios instance (axios) can now be accessed anywhere

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center login-form"},[(!_vm.auth)?_c('form',{staticClass:"form-signin",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h3',{ref:"pageTitle",staticClass:"mb-3 font-weight-normal",staticStyle:{"color":"var(--coredarkcolor)","margin-bottom":"0"}},[_vm._v("Login")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputEmail"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email","required":"","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Login")]),_vm._v(" "),(_vm.loginError)?_c('p',{staticClass:"pt-2"},[_c('strong',[_vm._v("Sorry, it seems your email or password is incorrect.")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pt-4 text-muted",staticStyle:{"margin-bottom":"0"}},[_vm._v("Don't have a nanny profile?")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_c('router-link',{attrs:{"to":{ name: 'Candidate Application Form' }}},[_vm._v("Join Our Team")])],1),_vm._v(" "),_c('p',{staticClass:"pt-3 text-muted",staticStyle:{"margin-bottom":"0"}},[_vm._v("Not a client yet?")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_c('router-link',{attrs:{"to":{ name: 'Employer Application Form' }}},[_vm._v("Apply now!")])],1)]):_vm._e(),_vm._v(" "),(_vm.auth)?_c('div',{staticClass:"form-signin"},[_c('h4',{ref:"pageTitle",staticClass:"mb-3 font-weight-normal",staticStyle:{"color":"var(--coredarkcolor)","margin-bottom":"0"}},[_vm._v("You are already logged in!")]),_vm._v(" "),(_vm.auth)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.dashboardRedirect()}}},[_vm._v("My Dashboard")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mt-4",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8c19d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(614);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8c19d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateRegistration_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0999fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateRegistration_vue__ = __webpack_require__(618);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a0999fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateRegistration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0999fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateRegistration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("41b5df6c", content, true, {});

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#dark-navbar[data-v-5a0999fa]{display:none}.registration-form[data-v-5a0999fa]{height:100vh;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-top:40px;padding-bottom:40px;background-color:#f5f5f5}.form-signup[data-v-5a0999fa]{width:100%;max-width:330px;padding:15px;margin:auto}.form-signup .checkbox[data-v-5a0999fa]{font-weight:400}.form-signup .form-control[data-v-5a0999fa]{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.form-signup .form-control[data-v-5a0999fa]:focus{z-index:2}.form-signup input[type=email][data-v-5a0999fa],.form-signup input[type=text][data-v-5a0999fa]{margin-bottom:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0}.form-signup input[type=text][data-v-5a0999fa]{border-top-left-radius:0;border-top-right-radius:0}.form-signup input[type=password][data-v-5a0999fa]{margin-bottom:10px;border-top-left-radius:0;border-top-right-radius:0}", ""]);

// exports


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center registration-form"},[_c('form',{staticClass:"form-signup",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h3',{staticClass:"mb-3 font-weight-normal",staticStyle:{"color":"var(--coredarkcolor)"}},[_vm._v("Join Our Team")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputEmail"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email","required":"","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Get Started")]),_vm._v(" "),_c('p',{staticClass:"pt-4",staticStyle:{"margin-bottom":"0"}},[_vm._v("Already have a profile? "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("30d37e5c", content, true, {});

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".selectedTab{background-color:var(--nannycogreen);color:#fff}", ""]);

// exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("383e3ffb", content, true, {});

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".vld-overlay{bottom:0;left:0;position:absolute;right:0;top:0;align-items:center;display:none;justify-content:center;overflow:hidden;z-index:1}.vld-overlay.is-active{display:flex}.vld-overlay.is-full-page{z-index:999;position:fixed}.vld-overlay .vld-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#fff;opacity:.5}.vld-overlay .vld-icon,.vld-parent{position:relative}", ""]);

// exports


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfo_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7d2fcb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfo_vue__ = __webpack_require__(625);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7d2fcb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-lg-3",staticStyle:{"max-width":"180px"}},[(_vm.user.profile_pic == 'https://enginehireio-static-and-media.s3.amazonaws.com/media/profile_pics/default_avatar.jpg' && _vm.user.external_profile_pic)?_c('div',[_c('img',{staticStyle:{"max-width":"150px"},attrs:{"src":_vm.user.external_profile_pic}})]):_c('div',[_c('img',{staticStyle:{"max-width":"150px","border-radius":"50%"},attrs:{"src":_vm.user.profile_pic}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9",staticStyle:{"width":"100%"}},[(_vm.editAccess)?_c('div',[_c('h3',{staticClass:"mt-2",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.user.first_name)+" "),(!_vm.viewOnlyAccess)?_c('span',[_vm._v(_vm._s(_vm.user.last_name))]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('img',{staticClass:"mb-1 ml-1",staticStyle:{"cursor":"pointer"},attrs:{"src":__webpack_require__(36),"alt":"","width":"16px"},on:{"click":function($event){return _vm.editBasicInfo()}}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-2",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.user.phone)+" | "+_vm._s(_vm.user.email)+" ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.user.address1))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.user.address2))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.user.city)),(_vm.user.provincestate)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(_vm.user.provincestate)),(_vm.user.country)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(_vm.user.country))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.postal_code))])]):_vm._e(),_vm._v(" "),(_vm.viewOnlyAccess)?_c('div',[_c('h3',{staticClass:"mt-2",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.user.first_name))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text20))])]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0px"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfoForm_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49248b2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfoForm_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49248b2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(628);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("807a32a2", content, true, {});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".profile-step{border-bottom:3px solid var(--thrivehiregrey)}.profile-step:hover{cursor:pointer}.profile-step h4,.profile-step small{color:var(--thrivehiregrey)}.profile-step small{font-weight:600;text-transform:uppercase}.active-step{border-bottom:3px solid var(--coredarkcolor)}.active-step h4{color:var(--coredarkcolor)}.inactive-step{border-bottom:3px solid var(--thrivehiregrey)}.inactive-step h4{color:var(--thrivehiregrey)}.inactive-step small{color:var(--thrivehiregrey)}.active-step small,.inactive-step small{font-weight:600;text-transform:uppercase}.active-step small{color:gray}.slide-enter-active{animation:slide-in .3s ease-out forwards}.slide-leave-active{animation:slide-out .3s ease-out forwards}@keyframes slide-in{0%{transform:translateY(-30px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes slide-out{0%{transform:translateY(0);opacity:1}to{transform:translateY(-30px);opacity:0}}.invalid label,.invalid small{color:red}", ""]);

// exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production"}).BUILD === 'web' ? __webpack_require__(631).withParams : __webpack_require__(207).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(13);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"profile-form"},[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Edit Personal Information")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Profile Picture")]),_vm._v(" "),_c('input',{ref:"profile_pic",staticClass:"form-control-file",attrs:{"type":"file","id":"profile_pic"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 form-group"},[_c('label',[_vm._v("First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],staticClass:"form-control",attrs:{"type":"text","id":"firstName"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),(_vm.$v.firstName.$invalid && _vm.step1saveClicked)?_c('small',[_vm._v("First name is required.")]):_vm._e(),_vm._v(" "),(_vm.$v.firstName.$error)?_c('small',[_vm._v("First name is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],staticClass:"form-control",attrs:{"type":"text","id":"lastName"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),(_vm.$v.lastName.$error)?_c('small',[_vm._v("Last name is required.")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"phone"}},[_vm._v("Mobile Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text","id":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 form-group"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1),expression:"address1"}],staticClass:"form-control",attrs:{"type":"text","id":"address","placeholder":"Address Line 1"},domProps:{"value":(_vm.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address1=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address2),expression:"address2"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Address Line 2"},domProps:{"value":(_vm.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address2=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"City"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.provinceState),expression:"provinceState"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Province/State"},domProps:{"value":(_vm.provinceState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.provinceState=$event.target.value}}}),_vm._v(" "),_c('multiselect',{staticClass:"mt-2",staticStyle:{"font-family":"'articulatcf-regular'"},attrs:{"options":_vm.countriesOptions,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Country"},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Postal/ZipCode"},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"display":"block","margin-left":"auto"},on:{"click":function($event){$event.preventDefault();return _vm.saveStep1($event)}}},[_vm._v("Save")]),_vm._v(" "),(_vm.$v.firstName.$error || _vm.$v.lastName.$error)?_c('small',[_vm._v("There is an error with your submission.")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfessionalInfo_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a09025c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfessionalInfo_vue__ = __webpack_require__(655);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfessionalInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a09025c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfessionalInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.listFieldsByColumn),function(columnInput,colIndex){return _c('div',{key:'row' + colIndex,class:("col-lg-" + (_vm.listFieldsByColumn.length !== 0 ? 12 / _vm.listFieldsByColumn.length : 12) + " px-4 mb-4")},_vm._l((columnInput),function(item,index){return _c('div',{key:item.model + colIndex + index},[(_vm.isDisplayItem(item))?_c('div',[_c('label',{staticClass:"label-title"},[_vm._v(_vm._s(_vm.getDisplayLabel(item)))]),_vm._v(" "),_c('p',{staticClass:"detail-info",domProps:{"innerHTML":_vm._s(_vm.getDisplayValue(item.model))}})]):_vm._e()])}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DetailSectionColumnLayout',{attrs:{"itemPerColumns":[12, 12],"modelData":_vm.user,"labelKey":"labelDetail","listFields":_vm.$store.getters.professionalInfoFields,"listExcludeFields":[]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfessionalInfoForm_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258600f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfessionalInfoForm_vue__ = __webpack_require__(664);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfessionalInfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258600f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfessionalInfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:"input",staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.maxLength,"placeholder":_vm.placeholder},domProps:{"value":(_vm.inputVal)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputVal=$event.target.value},function($event){return _vm.handleOnInput()}]}}),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e(),_vm._v(" "),(_vm.submitClicked && _vm.validationErrorMessage)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.validationErrorMessage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],staticClass:"form-control",attrs:{"rows":_vm.rows,"maxlength":_vm.maxLength,"placeholder":_vm.placeholder},domProps:{"value":(_vm.inputVal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputVal=$event.target.value}}}),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('datepicker',{staticClass:"date-picker form-control registration-date",attrs:{"disabled-dates":_vm.disabledPastDates,"initial-view":_vm.initialView},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),_vm._l((_vm.optionList),function(option,index){return _c('div',{key:'option' + index,staticClass:"form-check pl-4"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","id":'radio-' + _vm.name + index},domProps:{"value":option,"checked":_vm.isCheck(option, index)},on:{"change":function($event){return _vm.handleOnChange(option, index)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":'radio-' + _vm.name + index}},[_vm._v("\n      "+_vm._s(option)+"\n    ")])])}),_vm._v(" "),(
      _vm.hasOther && _vm.value != null && !_vm.optionListExcludeOther.includes(_vm.value)
    )?_c('div',[_c('input',{staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.getOtherValue},on:{"input":function($event){return _vm.handleOtherTextboxInput($event)}}})]):_vm._e(),_vm._v(" "),(_vm.value == null && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.inputVal=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.optionList),function(option,index){return _c('option',{key:'option' + index},[_vm._v(_vm._s(option))])}),0),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.label === '')?_c('label',{staticClass:"no-margin-top"}):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),_vm._l((_vm.optionList),function(option,index){return _c('div',{key:'option' + index,staticClass:"form-check pl-4"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":'checkbox-' + _vm.name + index},domProps:{"value":option,"checked":_vm.listCheckedOption.includes(option)},on:{"change":function($event){return _vm.onChangeCheck(option, $event.target.checked)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":'checkbox-' + _vm.name + index}},[_vm._v("\n      "+_vm._s(option)+"\n    ")])])}),_vm._v(" "),(_vm.listCheckedOption.length === 0 && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.listFieldsByColumn),function(columnInput,colIndex){return _c('div',{key:'row' + colIndex,class:("col-lg-" + (_vm.listFieldsByColumn.length !== 0 ? 12 / _vm.listFieldsByColumn.length : 12) + " px-4 mb-4")},[_vm._l((columnInput),function(el,index){return [(_vm.isItemShow(_vm.modelData, el))?[(el.type === _vm.FORM_TYPE.TEXTAREA)?_c('TextAreaWithLabel',{key:'textarea' + colIndex + index,attrs:{"label":el.label,"rows":el.rows,"description":el.description,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CHECKBOX)?_c('CheckboxGroup',{key:'checkbox' + colIndex + index,attrs:{"label":el.label,"name":el.model,"description":el.description,"optionList":el.optionList,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.RADIO)?_c('RadioGroup',{key:'radio' + colIndex + index,attrs:{"label":el.label,"name":el.model,"optionList":el.optionList,"description":el.description,"hasOther":el.hasOther,"initialSelection":el.initialSelection,"isBooleanModel":el.isBooleanModel,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DROPDOWN)?_c('DropdownWithLabel',{key:'dropdown' + colIndex + index,attrs:{"label":el.label,"name":el.model,"optionList":el.optionList,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DATEPICKER)?_c('DatePickerWithLabel',{key:'datepicker' + colIndex + index,attrs:{"label":el.label,"initialView":el.initialView,"allowPastDate":el.allowPastDate,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):_c('TextBoxWithLabel',{key:'textbox' + colIndex + index,attrs:{"label":el.label,"maxLength":el.maxLength,"type":el.inputType,"placeholder":el.placeholder,"description":el.description,"validation":el.validation,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}})]:_vm._e()]})],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-of-fields"},[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Edit Professional Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0px"}}),_vm._v(" "),_c('FormGroupColumnLayout',{attrs:{"submitClicked":_vm.submitClicked,"modelData":_vm.professionalInfo,"listFields":_vm.$store.getters.professionalInfoFields,"itemPerColumns":[10, 14]}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"display":"block","margin-left":"auto"},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v("\n    Save\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesiredRole_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b21647c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesiredRole_vue__ = __webpack_require__(666);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesiredRole_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b21647c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesiredRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user.available_date)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 px-4"},[(_vm.user.features[0])?_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("I have the following valid")]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.user.features),function(feature,index){return _c('li',{key:'Feature'+index},[_vm._v(_vm._s(feature))])}),0),_vm._v(" "),(_vm.user.available_date)?_c('label',{},[_vm._v("Available Start Date")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date(_vm.user.available_date).toDateString()))]),_vm._v(" "),(_vm.user.preferences2[0])?_c('label',{},[_vm._v("Days I am available")]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.user.preferences2),function(preference2,index){return _c('li',{key:'Preference2'+index},[_vm._v(_vm._s(preference2))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 px-4"},[(_vm.user.text6)?_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("How long I can commit")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text6))]),_vm._v(" "),(_vm.user.text7)?_c('label',{},[_vm._v("Hours per week I'm looking for")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text7))]),_vm._v(" "),(_vm.user.text8)?_c('label',{},[_vm._v("Schedule considerations")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text8))]),_vm._v(" "),(_vm.user.text1)?_c('label',{},[_vm._v("My ideal nanny family")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text1))]),_vm._v(" "),(_vm.editAccess)?_c('div',[(_vm.user.boolean_selector3)?_c('label',[_vm._v("I have an active profile on a nanny job site.")]):_vm._e(),_vm._v(" "),(!_vm.user.boolean_selector3)?_c('label',[_vm._v("I don't have an active profile on a nanny job site.")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text9))]),_vm._v(" "),(_vm.user.marketing_source)?_c('label',{},[_vm._v("How did I hear about The Nanny Company")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.marketing_source))])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesiredRoleForm_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a75894_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesiredRoleForm_vue__ = __webpack_require__(668);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesiredRoleForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a75894_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesiredRoleForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Edit Placement Details")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 px-4 mb-4"},[_c('label',{},[_vm._v("Which of these do you currently have that are valid (less than 1 year old) requirements?* (Check all that apply)")]),_vm._v(" "),_vm._l((_vm.documentsOptions),function(document,index){return _c('div',{key:'Document'+index,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documents),expression:"documents"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":document,"checked":Array.isArray(_vm.documents)?_vm._i(_vm.documents,document)>-1:(_vm.documents)},on:{"change":function($event){var $$a=_vm.documents,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=document,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.documents=$$a.concat([$$v]))}else{$$i>-1&&(_vm.documents=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.documents=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v(_vm._s(document))])])}),_vm._v(" "),_c('label',[_vm._v("Available Start Date*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"disabled-dates":_vm.disabledDates},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('label',{},[_vm._v("Days available?* (Check all that apply)")]),_vm._v(" "),_vm._l((_vm.daysOptions),function(day,index){return _c('div',{key:'Day'+index,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.days),expression:"days"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":day,"checked":Array.isArray(_vm.days)?_vm._i(_vm.days,day)>-1:(_vm.days)},on:{"change":function($event){var $$a=_vm.days,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.days=$$a.concat([$$v]))}else{$$i>-1&&(_vm.days=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.days=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v(_vm._s(day))])])})],2),_vm._v(" "),_c('div',{staticClass:"col-lg-6 px-4"},[_c('label',[_vm._v("How Long Are You Able to Commit?*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.committment),expression:"committment"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.committment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.committment=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("How Many Hours Per Week Are You Looking For?*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hours),expression:"hours"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hours=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Please Note Any Schedule Considerations Such As School/Current Job Schedule*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.schedule),expression:"schedule"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.schedule)},on:{"input":function($event){if($event.target.composing){ return; }_vm.schedule=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Describe Your Ideal Nanny Family*")]),_vm._v(" "),_c('small',{staticClass:"mb-1",staticStyle:{"display":"block"}},[_vm._v("Age & number of children, personality of parents, schedule, morals, values, etc.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyDescription),expression:"familyDescription"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.familyDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyDescription=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"form-group form-check mb-1 mt-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeProfile),expression:"activeProfile"}],staticClass:"form-check-input",staticStyle:{"margin-top":"4px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.activeProfile)?_vm._i(_vm.activeProfile,true)>-1:(_vm.activeProfile)},on:{"change":function($event){var $$a=_vm.activeProfile,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.activeProfile=$$a.concat([$$v]))}else{$$i>-1&&(_vm.activeProfile=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.activeProfile=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer","margin-top":"0"},on:{"click":function($event){_vm.activeProfile = !_vm.activeProfile}}},[_vm._v("\n          Do you currently have an active profile on any Nanny job sites?*\n        ")])]),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("If yes, which site?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jobSite),expression:"jobSite"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.jobSite)},on:{"input":function($event){if($event.target.composing){ return; }_vm.jobSite=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("How Did You Hear About The Nanny Company Inc.?*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.marketingSource),expression:"marketingSource"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.marketingSource)},on:{"input":function($event){if($event.target.composing){ return; }_vm.marketingSource=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"display":"block","margin-left":"auto"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_References_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016f3249_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_References_vue__ = __webpack_require__(683);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_References_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016f3249_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_References_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"reference-form-modal","width":"90%","height":"auto","scrollable":true},on:{"closed":function($event){return _vm.hideModal()}}},[_c('div',{staticClass:"p-5 field-of-fields"},[(_vm.isAdd)?_c('h3',[_vm._v("Add Reference")]):_vm._e(),_vm._v(" "),(!_vm.isAdd)?_c('h3',[_vm._v("Edit Reference - "+_vm._s(_vm.reference.name))]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('FormGroupColumnLayout',{attrs:{"submitClicked":_vm.submitClicked,"modelData":_vm.reference,"listFields":_vm.$store.getters.referenceListFields,"itemPerColumns":[6, 3]}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),(!_vm.isAdd)?_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.showDeleteReferenceConfirmDialog()}}},[_vm._v("\n        Delete\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.handleClickSaveButton()}}},[_vm._v("\n        Save\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key), content = self.content.slice();
    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key);
    if (found == -1) return this
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this;
    map = OrderedMap.from(map);
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i]);
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
};

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content)
};

var orderedmap = OrderedMap;

/* harmony default export */ __webpack_exports__["a"] = (orderedmap);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dropCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__ = __webpack_require__(50);



// :: (options: ?Object) → Plugin
// Create a plugin that, when added to a ProseMirror instance,
// causes a decoration to show up at the drop position when something
// is dragged over the editor.
//
//   options::- These options are supported:
//
//     color:: ?string
//     The color of the cursor. Defaults to `black`.
//
//     width:: ?number
//     The precise width of the cursor in pixels. Defaults to 1.
//
//     class:: ?string
//     A CSS class name to add to the cursor element.
function dropCursor(options) {
  if ( options === void 0 ) options = {};

  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    view: function view(editorView) { return new DropCursorView(editorView, options) }
  })
}

var DropCursorView = function DropCursorView(editorView, options) {
  var this$1 = this;

  this.editorView = editorView;
  this.width = options.width || 1;
  this.color = options.color || "black";
  this.class = options.class;
  this.cursorPos = null;
  this.element = null;
  this.timeout = null;

  this.handlers = ["dragover", "dragend", "drop", "dragleave"].map(function (name) {
    var handler = function (e) { return this$1[name](e); };
    editorView.dom.addEventListener(name, handler);
    return {name: name, handler: handler}
  });
};

DropCursorView.prototype.destroy = function destroy () {
    var this$1 = this;

  this.handlers.forEach(function (ref) {
      var name = ref.name;
      var handler = ref.handler;

      return this$1.editorView.dom.removeEventListener(name, handler);
    });
};

DropCursorView.prototype.update = function update (editorView, prevState) {
  if (this.cursorPos != null && prevState.doc != editorView.state.doc) { this.updateOverlay(); }
};

DropCursorView.prototype.setCursor = function setCursor (pos) {
  if (pos == this.cursorPos) { return }
  this.cursorPos = pos;
  if (pos == null) {
    this.element.parentNode.removeChild(this.element);
    this.element = null;
  } else {
    this.updateOverlay();
  }
};

DropCursorView.prototype.updateOverlay = function updateOverlay () {
  var $pos = this.editorView.state.doc.resolve(this.cursorPos), rect;
  if (!$pos.parent.inlineContent) {
    var before = $pos.nodeBefore, after = $pos.nodeAfter;
    if (before || after) {
      var nodeRect = this.editorView.nodeDOM(this.cursorPos - (before ?before.nodeSize : 0)).getBoundingClientRect();
      var top = before ? nodeRect.bottom : nodeRect.top;
      if (before && after)
        { top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2; }
      rect = {left: nodeRect.left, right: nodeRect.right, top: top - this.width / 2, bottom: top + this.width / 2};
    }
  }
  if (!rect) {
    var coords = this.editorView.coordsAtPos(this.cursorPos);
    rect = {left: coords.left - this.width / 2, right: coords.left + this.width / 2, top: coords.top, bottom: coords.bottom};
  }

  var parent = this.editorView.dom.offsetParent;
  if (!this.element) {
    this.element = parent.appendChild(document.createElement("div"));
    if (this.class) { this.element.className = this.class; }
    this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none; background-color: " + this.color;
  }
  var parentRect = !parent || parent == document.body && getComputedStyle(parent).position == "static"
      ? {left: -pageXOffset, top: -pageYOffset} : parent.getBoundingClientRect();
  this.element.style.left = (rect.left - parentRect.left) + "px";
  this.element.style.top = (rect.top - parentRect.top) + "px";
  this.element.style.width = (rect.right - rect.left) + "px";
  this.element.style.height = (rect.bottom - rect.top) + "px";
};

DropCursorView.prototype.scheduleRemoval = function scheduleRemoval (timeout) {
    var this$1 = this;

  clearTimeout(this.timeout);
  this.timeout = setTimeout(function () { return this$1.setCursor(null); }, timeout);
};

DropCursorView.prototype.dragover = function dragover (event) {
  if (!this.editorView.editable) { return }
  var pos = this.editorView.posAtCoords({left: event.clientX, top: event.clientY});
  if (pos) {
    var target = pos.pos;
    if (this.editorView.dragging && this.editorView.dragging.slice) {
      target = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["g" /* dropPoint */])(this.editorView.state.doc, target, this.editorView.dragging.slice);
      if (target == null) { target = pos.pos; }
    }
    this.setCursor(target);
    this.scheduleRemoval(5000);
  }
};

DropCursorView.prototype.dragend = function dragend () {
  this.scheduleRemoval(20);
};

DropCursorView.prototype.drop = function drop () {
  this.scheduleRemoval(20);
};

DropCursorView.prototype.dragleave = function dragleave (event) {
  if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget))
    { this.setCursor(null); }
};


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GapCursor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gapCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_model__ = __webpack_require__(37);





// ::- Gap cursor selections are represented using this class. Its
// `$anchor` and `$head` properties both point at the cursor position.
var GapCursor = /*@__PURE__*/(function (Selection) {
  function GapCursor($pos) {
    Selection.call(this, $pos, $pos);
  }

  if ( Selection ) GapCursor.__proto__ = Selection;
  GapCursor.prototype = Object.create( Selection && Selection.prototype );
  GapCursor.prototype.constructor = GapCursor;

  GapCursor.prototype.map = function map (doc, mapping) {
    var $pos = doc.resolve(mapping.map(this.head));
    return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos)
  };

  GapCursor.prototype.content = function content () { return __WEBPACK_IMPORTED_MODULE_3_prosemirror_model__["Slice"].empty };

  GapCursor.prototype.eq = function eq (other) {
    return other instanceof GapCursor && other.head == this.head
  };

  GapCursor.prototype.toJSON = function toJSON () {
    return {type: "gapcursor", pos: this.head}
  };

  GapCursor.fromJSON = function fromJSON (doc, json) {
    if (typeof json.pos != "number") { throw new RangeError("Invalid input for GapCursor.fromJSON") }
    return new GapCursor(doc.resolve(json.pos))
  };

  GapCursor.prototype.getBookmark = function getBookmark () { return new GapBookmark(this.anchor) };

  GapCursor.valid = function valid ($pos) {
    var parent = $pos.parent;
    if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos)) { return false }
    var override = parent.type.spec.allowGapCursor;
    if (override != null) { return override }
    var deflt = parent.contentMatchAt($pos.index()).defaultType;
    return deflt && deflt.isTextblock
  };

  GapCursor.findFrom = function findFrom ($pos, dir, mustMove) {
    if (!mustMove && GapCursor.valid($pos)) { return $pos }

    var pos = $pos.pos, next = null;
    // Scan up from this position
    for (var d = $pos.depth;; d--) {
      var parent = $pos.node(d);
      if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
        next = parent.maybeChild(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
        break
      } else if (d == 0) {
        return null
      }
      pos += dir;
      var $cur = $pos.doc.resolve(pos);
      if (GapCursor.valid($cur)) { return $cur }
    }

    // And then down into the next node
    for (;;) {
      next = dir > 0 ? next.firstChild : next.lastChild;
      if (!next) { break }
      pos += dir;
      var $cur$1 = $pos.doc.resolve(pos);
      if (GapCursor.valid($cur$1)) { return $cur$1 }
    }

    return null
  };

  return GapCursor;
}(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"]));

GapCursor.prototype.visible = false;

__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].jsonID("gapcursor", GapCursor);

var GapBookmark = function GapBookmark(pos) {
  this.pos = pos;
};
GapBookmark.prototype.map = function map (mapping) {
  return new GapBookmark(mapping.map(this.pos))
};
GapBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.pos);
  return GapCursor.valid($pos) ? new GapCursor($pos) : __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near($pos)
};

function closedBefore($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.index(d);
    // At the start of this parent, look at next one
    if (index == 0) { continue }
    // See if the node before (or its first ancestor) is closed
    for (var before = $pos.node(d).child(index - 1);; before = before.lastChild) {
      if ((before.childCount == 0 && !before.inlineContent) || before.isAtom || before.type.spec.isolating) { return true }
      if (before.inlineContent) { return false }
    }
  }
  // Hit start of document
  return true
}

function closedAfter($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.indexAfter(d), parent = $pos.node(d);
    if (index == parent.childCount) { continue }
    for (var after = parent.child(index);; after = after.firstChild) {
      if ((after.childCount == 0 && !after.inlineContent) || after.isAtom || after.type.spec.isolating) { return true }
      if (after.inlineContent) { return false }
    }
  }
  return true
}

// :: () → Plugin
// Create a gap cursor plugin. When enabled, this will capture clicks
// near and arrow-key-motion past places that don't have a normally
// selectable position nearby, and create a gap cursor selection for
// them. The cursor is drawn as an element with class
// `ProseMirror-gapcursor`. You can either include
// `style/gapcursor.css` from the package's directory or add your own
// styles to make it visible.
var gapCursor = function() {
  return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
    props: {
      decorations: drawGapCursor,

      createSelectionBetween: function createSelectionBetween(_view, $anchor, $head) {
        if ($anchor.pos == $head.pos && GapCursor.valid($head)) { return new GapCursor($head) }
      },

      handleClick: handleClick,
      handleKeyDown: handleKeyDown
    }
  })
};

var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["a" /* keydownHandler */])({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1)
});

function arrow(axis, dir) {
  var dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
  return function(state, dispatch, view) {
    var sel = state.selection;
    var $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
    if (sel instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"]) {
      if (!view.endOfTextblock(dirStr)) { return false }
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }
    var $found = GapCursor.findFrom($start, dir, mustMove);
    if (!$found) { return false }
    if (dispatch) { dispatch(state.tr.setSelection(new GapCursor($found))); }
    return true
  }
}

function handleClick(view, pos, event) {
  if (!view.editable) { return false }
  var $pos = view.state.doc.resolve(pos);
  if (!GapCursor.valid($pos)) { return false }
  var ref = view.posAtCoords({left: event.clientX, top: event.clientY});
  var inside = ref.inside;
  if (inside > -1 && __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"].isSelectable(view.state.doc.nodeAt(inside))) { return false }
  view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
  return true
}

function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor)) { return null }
  var node = document.createElement("div");
  node.className = "ProseMirror-gapcursor";
  return __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["b" /* DecorationSet */].create(state.doc, [__WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["a" /* Decoration */].widget(state.selection.head, node, {key: "gapcursor"})])
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return base_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keyName; });
/* unused harmony export shift */
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  229: "q"
};
var base_1 = base;

var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ";",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\"",
  229: "Q"
};
var shift_1 = shift;

var chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent);
var safari = typeof navigator != "undefined" && /Apple Computer/.test(navigator.vendor);
var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent);
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
var brokenModifierNames = chrome && +chrome[1] < 57 || gecko && mac;

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i;

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32);
  shift[i] = String.fromCharCode(i);
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code];

var keyName = function(event) {
  // Don't trust event.key in Chrome when there are modifiers until
  // they fix https://bugs.chromium.org/p/chromium/issues/detail?id=633838
  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) ||
    (safari || ie) && event.shiftKey && event.key && event.key.length == 1;
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified";
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape";
  if (name == "Del") name = "Delete";
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft";
  if (name == "Up") name = "ArrowUp";
  if (name == "Right") name = "ArrowRight";
  if (name == "Down") name = "ArrowDown";
  return name
};

var w3cKeyname = {
	base: base_1,
	shift: shift_1,
	keyName: keyName
};

/* unused harmony default export */ var _unused_webpack_default_export = (w3cKeyname);



/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var high = __webpack_require__(676)
var fault = __webpack_require__(677)

// The lowlight interface, which has to be compatible with highlight.js, as
// this object is passed to highlight.js syntaxes.

function High() {}

High.prototype = high

// Expose.
var low = new High() // Ha!

module.exports = low

low.highlight = highlight
low.highlightAuto = autoHighlight
low.registerLanguage = registerLanguage
low.listLanguages = listLanguages
low.registerAlias = registerAlias
low.getLanguage = getLanguage

var inherit = high.inherit
var own = {}.hasOwnProperty

var defaultPrefix = 'hljs-'
var keyInsensitive = 'case_insensitive'
var keyCachedVariants = 'cached_variants'
var keyTerminatorEnd = 'terminator_end'
var space = ' '
var verticalBar = '|'
var parenOpen = '('
var parenClose = ')'
var backslash = '\\'
var commonKeywords = ['of', 'and', 'for', 'in', 'not', 'or', 'if', 'then']

// Maps of syntaxes.
var languageNames = []
var languages = {}
var aliases = {}

// Highlighting with language detection.
// Accepts a string with the code to highlight.
// Returns an object with the following properties:
//
// *   `language` — Detected language
// *   `relevance` — Integer
// *   `value` — HAST tree with highlighting markup
// *   `secondBest` — Object with the same structure for second-best
//     heuristically detected language, may be absent.
function autoHighlight(value, options) {
  var settings = options || {}
  var subset = settings.subset || languageNames
  var prefix = settings.prefix
  var length = subset.length
  var index = -1
  var result
  var secondBest
  var current
  var name

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  secondBest = normalize({})
  result = normalize({})

  while (++index < length) {
    name = subset[index]

    if (!getLanguage(name)) {
      continue
    }

    current = normalize(coreHighlight(name, value, false, prefix))

    current.language = name

    if (current.relevance > secondBest.relevance) {
      secondBest = current
    }

    if (current.relevance > result.relevance) {
      secondBest = result
      result = current
    }
  }

  if (secondBest.language) {
    result.secondBest = secondBest
  }

  return result
}

// Highlighting `value` in the language `language`.
function highlight(language, value, options) {
  var settings = options || {}
  var prefix = settings.prefix

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix
  }

  return normalize(coreHighlight(language, value, true, prefix))
}

// Register a language.
function registerLanguage(name, syntax) {
  var lang = syntax(low)

  lang.rawDefinition = syntax.bind(null, low)

  languages[name] = lang

  languageNames.push(name)

  if (lang.aliases) {
    registerAlias(name, lang.aliases)
  }
}

// Get a list of all registered languages.
function listLanguages() {
  return languageNames.concat()
}

// Register more aliases for an already registered language.
function registerAlias(name, alias) {
  var map = name
  var key
  var list
  var length
  var index

  if (alias) {
    map = {}
    map[name] = alias
  }

  for (key in map) {
    list = map[key]
    list = typeof list === 'string' ? [list] : list
    length = list.length
    index = -1

    while (++index < length) {
      aliases[list[index]] = key
    }
  }
}

// Core highlighting function.
// Accepts a language name, or an alias, and a string with the code to
// highlight.
// eslint-disable-next-line max-params
function coreHighlight(name, value, ignore, prefix, continuation) {
  var lastMatch = {}
  var continuations = {}
  var stack = []
  var modeBuffer = ''
  var relevance = 0
  var language
  var top
  var current
  var currentChildren
  var offset
  var count
  var match
  var children

  if (typeof name !== 'string') {
    throw fault('Expected `string` for name, got `%s`', name)
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  language = getLanguage(name)
  top = continuation || language
  children = []

  current = top
  currentChildren = children

  if (!language) {
    throw fault('Unknown language: `%s` is not registered', name)
  }

  compileLanguage(language)

  try {
    top.terminators.lastIndex = 0
    offset = 0
    match = top.terminators.exec(value)

    while (match) {
      count = processLexeme(value.slice(offset, match.index), match)
      offset = match.index + count
      top.terminators.lastIndex = offset
      match = top.terminators.exec(value)
    }

    processLexeme(value.slice(offset))
    current = top

    while (current.parent) {
      if (current.className) {
        pop()
      }

      current = current.parent
    }

    return {
      relevance: relevance,
      value: currentChildren,
      illegal: false,
      language: name,
      top: top
    }
  } catch (error) {
    /* istanbul ignore if - Catch-all  */
    if (error.message.indexOf('Illegal') === -1) {
      throw error
    }

    return {relevance: 0, illegal: true, value: addText(value, [])}
  }

  function escapeRe(value) {
    return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'm')
  }

  function doBeginMatch(match) {
    var lexeme = match[0]
    var newMode = match.rule

    if (newMode && newMode.endSameAsBegin) {
      newMode.endRe = escapeRe(lexeme)
    }

    if (newMode.skip) {
      modeBuffer += lexeme
    } else {
      if (newMode.excludeBegin) {
        modeBuffer += lexeme
      }

      addSiblings(processBuffer(), currentChildren)

      if (!newMode.returnBegin && !newMode.excludeBegin) {
        modeBuffer = lexeme
      }
    }

    startNewMode(newMode)

    return newMode.returnBegin ? 0 : lexeme.length
  }

  function doEndMatch(match) {
    var lexeme = match[0]
    var matchPlusRemainder = value.slice(match.index)
    var endMode = endOfMode(top, matchPlusRemainder)

    if (!endMode) {
      return
    }

    var origin = top

    if (origin.skip) {
      modeBuffer += lexeme
    } else {
      if (!(origin.returnEnd || origin.excludeEnd)) {
        modeBuffer += lexeme
      }

      addSiblings(processBuffer(), currentChildren)

      if (origin.excludeEnd) {
        modeBuffer = lexeme
      }
    }

    do {
      if (top.className) {
        pop()
      }

      if (!top.skip && !top.subLanguage) {
        relevance += top.relevance
      }

      top = top.parent
    } while (top !== endMode.parent)

    if (endMode.starts) {
      /* istanbul ignore if - hljs 9.16 added support for this but didn’t use it yet. */
      if (endMode.endSameAsBegin) {
        endMode.starts.endRe = endMode.endRe
      }

      startNewMode(endMode.starts)
    }

    return origin.returnEnd ? 0 : lexeme.length
  }

  function processLexeme(textBeforeMatch, match) {
    var lexeme = match && match[0]
    var processed

    // Add non-matched text to the current mode buffer
    modeBuffer += textBeforeMatch

    if (lexeme === undefined) {
      addSiblings(processBuffer(), currentChildren)
      return 0
    }

    // We've found a 0 width match and we're stuck, so we need to advance
    // this happens when we have badly behaved rules that have optional matchers to the degree that
    // sometimes they can end up matching nothing at all
    // Ref: https://github.com/highlightjs/highlight.js/issues/2140
    /* istanbul ignore if - Unknown what this fixes or which case fixes it */
    if (
      lastMatch.type === 'begin' &&
      match.type === 'end' &&
      lastMatch.index === match.index &&
      lexeme === ''
    ) {
      // Spit the “skipped” character that our regex choked on back into the output sequence
      modeBuffer += value.slice(match.index, match.index + 1)
      return 1
    }

    lastMatch = match

    if (match.type === 'begin') {
      return doBeginMatch(match)
    }

    if (match.type === 'end') {
      processed = doEndMatch(match)

      if (processed !== undefined) {
        return processed
      }
    }

    if (match.type === 'illegal' && !ignore) {
      // Illegal match, we do not continue processing
      throw fault(
        'Illegal lexeme "%s" for mode "%s"',
        lexeme,
        top.className || '<unnamed>'
      )
    }

    // Why might be find ourselves here?
    // Only one occasion now.
    // An end match that was triggered but could not be completed.
    // When might this happen?
    // When an `endSameasBegin` rule sets the end rule to a specific match.
    // Since the overall mode termination rule that’s being used to scan the
    // text isn’t recompiled that means that any match that LOOKS like the end
    // (but is not, because it is not an exact match to the beginning) will end
    // up here.
    // A definite end match, but when `doEndMatch` tries to “reapply” the end
    // rule and fails to match, we wind up here, and just silently ignore the
    // end.
    // This causes no real harm other than stopping a few times too many.
    modeBuffer += lexeme

    return lexeme.length
  }

  // Start a new mode with a `lexeme` to process.
  function startNewMode(mode) {
    var node

    if (mode.className) {
      node = build(mode.className, [])
    }

    // Enter a new mode.
    if (node) {
      currentChildren.push(node)
      stack.push(currentChildren)
      currentChildren = node.children
    }

    top = Object.create(mode, {parent: {value: top}})
  }

  // Process the buffer.
  function processBuffer() {
    var result = top.subLanguage ? processSubLanguage() : processKeywords()
    modeBuffer = ''
    return result
  }

  // Process a sublanguage (returns a list of nodes).
  function processSubLanguage() {
    var explicit = typeof top.subLanguage === 'string'
    var subvalue

    /* istanbul ignore if - support non-loaded sublanguages */
    if (explicit && !languages[top.subLanguage]) {
      return addText(modeBuffer, [])
    }

    if (explicit) {
      subvalue = coreHighlight(
        top.subLanguage,
        modeBuffer,
        true,
        prefix,
        continuations[top.subLanguage]
      )
    } else {
      subvalue = autoHighlight(modeBuffer, {
        subset: top.subLanguage.length === 0 ? undefined : top.subLanguage,
        prefix: prefix
      })
    }

    // If we couldn’t highlight, for example because the requests subset isn’t
    // loaded, return a text node.
    if (!subvalue.language) {
      return [buildText(modeBuffer)]
    }

    // Counting embedded language score towards the host language may be
    // disabled with zeroing the containing mode relevance.
    // Usecase in point is Markdown that allows XML everywhere and makes every
    // XML snippet to have a much larger Markdown score.
    if (top.relevance > 0) {
      relevance += subvalue.relevance
    }

    if (explicit) {
      continuations[top.subLanguage] = subvalue.top
    }

    return [build(subvalue.language, subvalue.value, true)]
  }

  // Process keywords. Returns nodes.
  function processKeywords() {
    var nodes = []
    var lastIndex
    var keyword
    var node
    var submatch

    if (!top.keywords) {
      return addText(modeBuffer, nodes)
    }

    lastIndex = 0

    top.lexemesRe.lastIndex = 0

    keyword = top.lexemesRe.exec(modeBuffer)

    while (keyword) {
      addText(modeBuffer.slice(lastIndex, keyword.index), nodes)

      submatch = keywordMatch(top, keyword)

      if (submatch) {
        relevance += submatch[1]

        node = build(submatch[0], [])

        nodes.push(node)

        addText(keyword[0], node.children)
      } else {
        addText(keyword[0], nodes)
      }

      lastIndex = top.lexemesRe.lastIndex
      keyword = top.lexemesRe.exec(modeBuffer)
    }

    addText(modeBuffer.slice(lastIndex), nodes)

    return nodes
  }

  // Add siblings.
  function addSiblings(siblings, nodes) {
    var length = siblings.length
    var index = -1
    var sibling

    while (++index < length) {
      sibling = siblings[index]

      if (sibling.type === 'text') {
        addText(sibling.value, nodes)
      } else {
        nodes.push(sibling)
      }
    }
  }

  // Add a text.
  function addText(value, nodes) {
    var tail

    if (value) {
      tail = nodes[nodes.length - 1]

      if (tail && tail.type === 'text') {
        tail.value += value
      } else {
        nodes.push(buildText(value))
      }
    }

    return nodes
  }

  // Build a text.
  function buildText(value) {
    return {type: 'text', value: value}
  }

  // Build a span.
  function build(name, contents, noPrefix) {
    return {
      type: 'element',
      tagName: 'span',
      properties: {
        className: [(noPrefix ? '' : prefix) + name]
      },
      children: contents
    }
  }

  // Check if the first word in `keywords` is a keyword.
  function keywordMatch(mode, keywords) {
    var keyword = keywords[0]

    if (language[keyInsensitive]) {
      keyword = keyword.toLowerCase()
    }

    return own.call(mode.keywords, keyword) && mode.keywords[keyword]
  }

  // Check if `lexeme` ends `mode`.
  function endOfMode(mode, lexeme) {
    if (test(mode.endRe, lexeme)) {
      while (mode.endsParent && mode.parent) {
        mode = mode.parent
      }

      return mode
    }

    if (mode.endsWithParent) {
      return endOfMode(mode.parent, lexeme)
    }
  }

  // Exit the current context.
  function pop() {
    /* istanbul ignore next - removed in hljs 9.3 */
    currentChildren = stack.pop() || children
  }
}

// Compile a language.
function compileLanguage(language) {
  compileMode(language)

  // Compile a language mode, optionally with a parent.
  function compileMode(mode, parent) {
    if (mode.compiled) {
      return
    }

    mode.compiled = true

    mode.keywords = mode.keywords || mode.beginKeywords

    if (mode.keywords) {
      mode.keywords = compileKeywords(mode.keywords, language[keyInsensitive])
    }

    mode.lexemesRe = langRe(mode.lexemes || /\w+/, true)

    if (parent) {
      if (mode.beginKeywords) {
        mode.begin =
          '\\b(' + mode.beginKeywords.split(space).join(verticalBar) + ')\\b'
      }

      if (!mode.begin) {
        mode.begin = /\B|\b/
      }

      mode.beginRe = langRe(mode.begin)

      if (mode.endSameAsBegin) {
        mode.end = mode.begin
      }

      if (!mode.end && !mode.endsWithParent) {
        mode.end = /\B|\b/
      }

      if (mode.end) {
        mode.endRe = langRe(mode.end)
      }

      mode[keyTerminatorEnd] = source(mode.end) || ''

      if (mode.endsWithParent && parent[keyTerminatorEnd]) {
        mode[keyTerminatorEnd] +=
          (mode.end ? verticalBar : '') + parent[keyTerminatorEnd]
      }
    }

    if (mode.illegal) {
      mode.illegalRe = langRe(mode.illegal)
    }

    if (mode.relevance === undefined) {
      mode.relevance = 1
    }

    mode.contains = compileContains(mode.contains || [], mode)

    if (mode.starts) {
      compileMode(mode.starts, parent)
    }

    mode.terminators = buildModeRegex(mode)
  }

  function compileContains(contains, mode) {
    var result = []
    var length = contains.length
    var index = -1
    var contained

    while (++index < length) {
      contained = contains[index]
      result = result.concat(
        expandOrCloneMode(contained === 'self' ? mode : contained)
      )
    }

    length = result.length
    index = -1

    while (++index < length) {
      compileMode(result[index], mode)
    }

    return result
  }

  function buildModeRegex(mode) {
    var indices = {}
    var expression
    var regexes = []
    var matcher = {}
    var matchAt = 1
    var term
    var values = mode.contains
    var length = values.length
    var index = -1
    var terminators = []

    while (++index < length) {
      term = values[index]

      addRule(
        term,
        term.beginKeywords ? '\\.?(?:' + term.begin + ')\\.?' : term.begin
      )
    }

    if (mode[keyTerminatorEnd]) {
      addRule('end', mode[keyTerminatorEnd])
    }

    if (mode.illegal) {
      addRule('illegal', mode.illegal)
    }

    length = regexes.length
    index = -1

    while (++index < length) {
      terminators[index] = regexes[index][1]
    }

    expression = langRe(joinRe(terminators, verticalBar), true)

    matcher = {lastIndex: 0, exec: exec}

    return matcher

    function exec(value) {
      var length
      var index
      var rule
      var match
      var submatch

      if (regexes.length === 0) return null

      expression.lastIndex = matcher.lastIndex
      match = expression.exec(value)

      if (!match) {
        return null
      }

      length = match.length
      index = -1

      while (++index < length) {
        submatch = match[index]

        if (submatch !== undefined && indices[index] !== undefined) {
          rule = indices[index]
          break
        }
      }

      // Illegal or end match
      if (typeof rule === 'string') {
        match.type = rule
        match.extra = [mode.illegal, mode.terminator_end]
      } else {
        match.type = 'begin'
        match.rule = rule
      }

      return match
    }

    function addRule(rule, regex) {
      indices[matchAt] = rule
      regexes.push([rule, regex])
      matchAt += new RegExp(regex.toString() + verticalBar).exec('').length
    }
  }

  function joinRe(regexes, separator) {
    var backreferenceRe = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9]\d*)|\\./
    var captures = 0
    var result = ''
    var length = regexes.length
    var index = -1
    var regex
    var offset
    var expression
    var match

    while (++index < length) {
      regex = regexes[index]
      expression = source(regex)
      captures += 1
      offset = captures

      if (index !== 0) {
        result += separator
      }

      result += parenOpen

      while (expression.length > 0) {
        match = backreferenceRe.exec(expression)

        if (match === null) {
          result += expression
          break
        }

        result += expression.slice(0, match.index)
        expression = expression.slice(match.index + match[0].length)

        if (match[0][0] === backslash && match[1]) {
          // Adjust the backreference.
          result += backslash + String(Number(match[1]) + offset)
        } else {
          result += match[0]

          if (match[0] === parenOpen) {
            captures++
          }
        }
      }

      result += parenClose
    }

    return result
  }

  // Create a regex for `value`.
  function langRe(value, global) {
    return new RegExp(
      source(value),
      'm' + (language[keyInsensitive] ? 'i' : '') + (global ? 'g' : '')
    )
  }

  // Get the source of an expression or string.
  function source(re) {
    return (re && re.source) || re
  }
}

function compileKeywords(values, caseInsensitive) {
  var compiled = {}
  var key

  if (typeof values === 'string') {
    flatten('keyword', values)
  } else {
    for (key in values) {
      flatten(key, values[key])
    }
  }

  return compiled

  function flatten(key, value) {
    var val = caseInsensitive ? value.toLowerCase() : value
    all(key, val.split(space))
  }

  function all(key, values) {
    var length = values.length
    var index = -1
    var pair

    while (++index < length) {
      pair = values[index].split(verticalBar)
      compiled[pair[0]] = [key, Number(pair[1]) || common(pair[0]) ? 0 : 1]
    }
  }
}

function common(value) {
  return commonKeywords.indexOf(value.toLowerCase()) !== -1
}

function expandOrCloneMode(mode) {
  var length
  var index
  var variants
  var result

  if (mode.variants && !mode[keyCachedVariants]) {
    variants = mode.variants
    length = variants.length
    index = -1
    result = []

    while (++index < length) {
      result[index] = inherit(mode, {variants: null}, variants[index])
    }

    mode[keyCachedVariants] = result
  }

  // Expand.
  if (mode.cached_variants) return mode.cached_variants

  // Clone.
  if (dependencyOnParent(mode))
    return [inherit(mode, {starts: mode.starts ? inherit(mode.starts) : null})]

  return [mode]
}

function dependencyOnParent(mode) {
  return mode ? mode.endsWithParent || dependencyOnParent(mode.starts) : false
}

// Normalize a syntax result.
function normalize(result) {
  return {
    relevance: result.relevance || 0,
    language: result.language || null,
    value: result.value || []
  }
}

// Check if `expression` matches `lexeme`.
function test(expression, lexeme) {
  var match = expression && expression.exec(lexeme)
  return match && match.index === 0
}

// Get a language by `name`.
function getLanguage(name) {
  name = name.toLowerCase()

  return languages[name] || languages[aliases[name]]
}


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

(function(factory) {

  // Find the global object for export to both the browser and web workers.
  var globalObject = typeof window === 'object' && window ||
                     typeof self === 'object' && self;

  // Setup highlight.js for different environments. First is Node.js or
  // CommonJS.
  // `nodeType` is checked to ensure that `exports` is not a HTML element.
  if(typeof exports !== 'undefined' && !exports.nodeType) {
    factory(exports);
  } else if(globalObject) {
    // Export hljs globally even when using AMD for cases when this script
    // is loaded with others that may still expect a global hljs.
    globalObject.hljs = factory({});

    // Finally register the global hljs with AMD.
    if(true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return globalObject.hljs;
      }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }

}(function(hljs) {
  // Convenience variables for build-in objects
  var ArrayProto = [],
      objectKeys = Object.keys;

  // Global internal variables used within the highlight.js library.
  var languages = {},
      aliases   = {};

  // Regular expressions used throughout the highlight.js library.
  var noHighlightRe    = /^(no-?highlight|plain|text)$/i,
      languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i,
      fixMarkupRe      = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;

  // The object will be assigned by the build tool. It used to synchronize API
  // of external language files with minified version of the highlight.js library.
  var API_REPLACES;

  var spanEndTag = '</span>';

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  var options = {
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: undefined
  };

  // keywords that should have no default relevance value
  var COMMON_KEYWORDS = 'of and for in not or if then'.split(' ')


  /* Utility functions */

  function escape(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tag(node) {
    return node.nodeName.toLowerCase();
  }

  function testRe(re, lexeme) {
    var match = re && re.exec(lexeme);
    return match && match.index === 0;
  }

  function isNotHighlighted(language) {
    return noHighlightRe.test(language);
  }

  function blockLanguage(block) {
    var i, match, length, _class;
    var classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    match = languagePrefixRe.exec(classes);
    if (match) {
      return getLanguage(match[1]) ? match[1] : 'no-highlight';
    }

    classes = classes.split(/\s+/);

    for (i = 0, length = classes.length; i < length; i++) {
      _class = classes[i];

      if (isNotHighlighted(_class) || getLanguage(_class)) {
        return _class;
      }
    }
  }

  function inherit(parent) {  // inherit(parent, override_obj, override_obj, ...)
    var key;
    var result = {};
    var objects = Array.prototype.slice.call(arguments, 1);

    for (key in parent)
      result[key] = parent[key];
    objects.forEach(function(obj) {
      for (key in obj)
        result[key] = obj[key];
    });
    return result;
  }

  /* Stream merging */

  function nodeStream(node) {
    var result = [];
    (function _nodeStream(node, offset) {
      for (var child = node.firstChild; child; child = child.nextSibling) {
        if (child.nodeType === 3)
          offset += child.nodeValue.length;
        else if (child.nodeType === 1) {
          result.push({
            event: 'start',
            offset: offset,
            node: child
          });
          offset = _nodeStream(child, offset);
          // Prevent void elements from having an end tag that would actually
          // double them in the output. There are more void elements in HTML
          // but we list only those realistically expected in code display.
          if (!tag(child).match(/br|hr|img|input/)) {
            result.push({
              event: 'stop',
              offset: offset,
              node: child
            });
          }
        }
      }
      return offset;
    })(node, 0);
    return result;
  }

  function mergeStreams(original, highlighted, value) {
    var processed = 0;
    var result = '';
    var nodeStack = [];

    function selectStream() {
      if (!original.length || !highlighted.length) {
        return original.length ? original : highlighted;
      }
      if (original[0].offset !== highlighted[0].offset) {
        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
      }

      /*
      To avoid starting the stream just before it should stop the order is
      ensured that original always starts first and closes last:

      if (event1 == 'start' && event2 == 'start')
        return original;
      if (event1 == 'start' && event2 == 'stop')
        return highlighted;
      if (event1 == 'stop' && event2 == 'start')
        return original;
      if (event1 == 'stop' && event2 == 'stop')
        return highlighted;

      ... which is collapsed to:
      */
      return highlighted[0].event === 'start' ? original : highlighted;
    }

    function open(node) {
      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value).replace('"', '&quot;') + '"';}
      result += '<' + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join('') + '>';
    }

    function close(node) {
      result += '</' + tag(node) + '>';
    }

    function render(event) {
      (event.event === 'start' ? open : close)(event.node);
    }

    while (original.length || highlighted.length) {
      var stream = selectStream();
      result += escape(value.substring(processed, stream[0].offset));
      processed = stream[0].offset;
      if (stream === original) {
        /*
        On any opening or closing tag of the original markup we first close
        the entire highlighted node stack, then render the original tag along
        with all the following original tags at the same offset and then
        reopen all the tags on the highlighted stack.
        */
        nodeStack.reverse().forEach(close);
        do {
          render(stream.splice(0, 1)[0]);
          stream = selectStream();
        } while (stream === original && stream.length && stream[0].offset === processed);
        nodeStack.reverse().forEach(open);
      } else {
        if (stream[0].event === 'start') {
          nodeStack.push(stream[0].node);
        } else {
          nodeStack.pop();
        }
        render(stream.splice(0, 1)[0]);
      }
    }
    return result + escape(value.substr(processed));
  }

  /* Initialization */

  function dependencyOnParent(mode) {
    if (!mode) return false;

    return mode.endsWithParent || dependencyOnParent(mode.starts)
  }

  function expand_or_clone_mode(mode) {
    if (mode.variants && !mode.cached_variants) {
      mode.cached_variants = mode.variants.map(function(variant) {
        return inherit(mode, {variants: null}, variant);
      });
    }

    // EXPAND
    // if we have variants then essentually "replace" the mode with the variants
    // this happens in compileMode, where this function is called from
    if (mode.cached_variants)
      return mode.cached_variants;

    // CLONE
    // if we have dependencies on parents then we need a unique
    // instance of ourselves, so we can be reused with many
    // different parents without issue
    if (dependencyOnParent(mode))
      return [inherit(mode, { starts: mode.starts ? inherit(mode.starts) : null })]

    // no special dependency issues, just return ourselves
    return [mode]
  }

  function restoreLanguageApi(obj) {
    if(API_REPLACES && !obj.langApiRestored) {
      obj.langApiRestored = true;
      for(var key in API_REPLACES)
        obj[key] && (obj[API_REPLACES[key]] = obj[key]);
      (obj.contains || []).concat(obj.variants || []).forEach(restoreLanguageApi);
    }
  }

  function compileKeywords(rawKeywords, case_insensitive) {
      var compiled_keywords = {};

      if (typeof rawKeywords === 'string') { // string
        splitAndCompile('keyword', rawKeywords);
      } else {
        objectKeys(rawKeywords).forEach(function (className) {
          splitAndCompile(className, rawKeywords[className]);
        });
      }
    return compiled_keywords;

    // ---

    function splitAndCompile(className, str) {
      if (case_insensitive) {
        str = str.toLowerCase();
      }
      str.split(' ').forEach(function(keyword) {
        var pair = keyword.split('|');
        compiled_keywords[pair[0]] = [className, scoreForKeyword(pair[0], pair[1])];
      });
    };
  }

  function scoreForKeyword(keyword, providedScore) {
    // manual scores always win over common keywords
    // so you can force a score of 1 if you really insist
    if (providedScore)
      return Number(providedScore)

    return commonKeyword(keyword) ? 0 : 1;
  }

  function commonKeyword(word) {
    return COMMON_KEYWORDS.indexOf(word.toLowerCase()) != -1
  }

  function compileLanguage(language) {

    function reStr(re) {
        return (re && re.source) || re;
    }

    function langRe(value, global) {
      return new RegExp(
        reStr(value),
        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
      );
    }

    function reCountMatchGroups(re) {
      return (new RegExp(re.toString() + '|')).exec('').length - 1;
    }

    // joinRe logically computes regexps.join(separator), but fixes the
    // backreferences so they continue to match.
    // it also places each individual regular expression into it's own
    // match group, keeping track of the sequencing of those match groups
    // is currently an exercise for the caller. :-)
    function joinRe(regexps, separator) {
      // backreferenceRe matches an open parenthesis or backreference. To avoid
      // an incorrect parse, it additionally matches the following:
      // - [...] elements, where the meaning of parentheses and escapes change
      // - other escape sequences, so we do not misparse escape sequences as
      //   interesting elements
      // - non-matching or lookahead parentheses, which do not capture. These
      //   follow the '(' with a '?'.
      var backreferenceRe = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
      var numCaptures = 0;
      var ret = '';
      for (var i = 0; i < regexps.length; i++) {
        numCaptures += 1;
        var offset = numCaptures;
        var re = reStr(regexps[i]);
        if (i > 0) {
          ret += separator;
        }
        ret += "(";
        while (re.length > 0) {
          var match = backreferenceRe.exec(re);
          if (match == null) {
            ret += re;
            break;
          }
          ret += re.substring(0, match.index);
          re = re.substring(match.index + match[0].length);
          if (match[0][0] == '\\' && match[1]) {
            // Adjust the backreference.
            ret += '\\' + String(Number(match[1]) + offset);
          } else {
            ret += match[0];
            if (match[0] == '(') {
              numCaptures++;
            }
          }
        }
        ret += ")";
      }
      return ret;
    }

    function buildModeRegex(mode) {

      var matchIndexes = {};
      var matcherRe;
      var regexes = [];
      var matcher = {};
      var matchAt = 1;

      function addRule(rule, regex) {
        matchIndexes[matchAt] = rule;
        regexes.push([rule, regex]);
        matchAt += reCountMatchGroups(regex) + 1;
      }

      var term;
      for (var i=0; i < mode.contains.length; i++) {
        var re;
        term = mode.contains[i];
        if (term.beginKeywords) {
          re = '\\.?(?:' + term.begin + ')\\.?';
        } else {
          re = term.begin;
        }
        addRule(term, re);
      }
      if (mode.terminator_end)
        addRule("end", mode.terminator_end);
      if (mode.illegal)
        addRule("illegal", mode.illegal);

      var terminators = regexes.map(function(el) { return el[1] });
      matcherRe = langRe(joinRe(terminators, '|'), true);

      matcher.lastIndex = 0;
      matcher.exec = function(s) {
        var rule;

        if( regexes.length === 0) return null;

        matcherRe.lastIndex = matcher.lastIndex;
        var match = matcherRe.exec(s);
        if (!match) { return null; }

        for(var i = 0; i<match.length; i++) {
          if (match[i] != undefined && matchIndexes["" +i] != undefined ) {
            rule = matchIndexes[""+i];
            break;
          }
        }

        // illegal or end match
        if (typeof rule === "string") {
          match.type = rule;
          match.extra = [mode.illegal, mode.terminator_end];
        } else {
          match.type = "begin";
          match.rule = rule;
        }
        return match;
      }

      return matcher;
    }

    function compileMode(mode, parent) {
      if (mode.compiled)
        return;
      mode.compiled = true;

      mode.keywords = mode.keywords || mode.beginKeywords;
      if (mode.keywords)
        mode.keywords = compileKeywords(mode.keywords, language.case_insensitive)

      mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);

      if (parent) {
        if (mode.beginKeywords) {
          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
        }
        if (!mode.begin)
          mode.begin = /\B|\b/;
        mode.beginRe = langRe(mode.begin);
        if (mode.endSameAsBegin)
          mode.end = mode.begin;
        if (!mode.end && !mode.endsWithParent)
          mode.end = /\B|\b/;
        if (mode.end)
          mode.endRe = langRe(mode.end);
        mode.terminator_end = reStr(mode.end) || '';
        if (mode.endsWithParent && parent.terminator_end)
          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
      }
      if (mode.illegal)
        mode.illegalRe = langRe(mode.illegal);
      if (mode.relevance == null)
        mode.relevance = 1;
      if (!mode.contains) {
        mode.contains = [];
      }
      mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
        return expand_or_clone_mode(c === 'self' ? mode : c);
      }));
      mode.contains.forEach(function(c) {compileMode(c, mode);});

      if (mode.starts) {
        compileMode(mode.starts, parent);
      }

      mode.terminators = buildModeRegex(mode);
    }

    compileMode(language);
  }

  /*
  Core highlighting function. Accepts a language name, or an alias, and a
  string with the code to highlight. Returns an object with the following
  properties:

  - relevance (int)
  - value (an HTML string with highlighting markup)

  */
  function highlight(name, value, ignore_illegals, continuation) {

    function escapeRe(value) {
      return new RegExp(value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'm');
    }

    function endOfMode(mode, lexeme) {
      if (testRe(mode.endRe, lexeme)) {
        while (mode.endsParent && mode.parent) {
          mode = mode.parent;
        }
        return mode;
      }
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, lexeme);
      }
    }

    function keywordMatch(mode, match) {
      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
    }

    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
      if (!leaveOpen && insideSpan === '') return '';
      if (!classname) return insideSpan;

      var classPrefix = noPrefix ? '' : options.classPrefix,
          openSpan    = '<span class="' + classPrefix,
          closeSpan   = leaveOpen ? '' : spanEndTag;

      openSpan += classname + '">';

      return openSpan + insideSpan + closeSpan;
    }

    function processKeywords() {
      var keyword_match, last_index, match, result;

      if (!top.keywords)
        return escape(mode_buffer);

      result = '';
      last_index = 0;
      top.lexemesRe.lastIndex = 0;
      match = top.lexemesRe.exec(mode_buffer);

      while (match) {
        result += escape(mode_buffer.substring(last_index, match.index));
        keyword_match = keywordMatch(top, match);
        if (keyword_match) {
          relevance += keyword_match[1];
          result += buildSpan(keyword_match[0], escape(match[0]));
        } else {
          result += escape(match[0]);
        }
        last_index = top.lexemesRe.lastIndex;
        match = top.lexemesRe.exec(mode_buffer);
      }
      return result + escape(mode_buffer.substr(last_index));
    }

    function processSubLanguage() {
      var explicit = typeof top.subLanguage === 'string';
      if (explicit && !languages[top.subLanguage]) {
        return escape(mode_buffer);
      }

      var result = explicit ?
                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Usecase in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      if (explicit) {
        continuations[top.subLanguage] = result.top;
      }
      return buildSpan(result.language, result.value, false, true);
    }

    function processBuffer() {
      result += (top.subLanguage != null ? processSubLanguage() : processKeywords());
      mode_buffer = '';
    }

    function startNewMode(mode) {
      result += mode.className? buildSpan(mode.className, '', true): '';
      top = Object.create(mode, {parent: {value: top}});
    }


    function doBeginMatch(match) {
      var lexeme = match[0];
      var new_mode = match.rule;

      if (new_mode && new_mode.endSameAsBegin) {
        new_mode.endRe = escapeRe( lexeme );
      }

      if (new_mode.skip) {
        mode_buffer += lexeme;
      } else {
        if (new_mode.excludeBegin) {
          mode_buffer += lexeme;
        }
        processBuffer();
        if (!new_mode.returnBegin && !new_mode.excludeBegin) {
          mode_buffer = lexeme;
        }
      }
      startNewMode(new_mode, lexeme);
      return new_mode.returnBegin ? 0 : lexeme.length;
    }

    function doEndMatch(match) {
      var lexeme = match[0];
      var end_mode = endOfMode(top, lexeme);
      if (!end_mode) { return; }

      var origin = top;
      if (origin.skip) {
        mode_buffer += lexeme;
      } else {
        if (!(origin.returnEnd || origin.excludeEnd)) {
          mode_buffer += lexeme;
        }
        processBuffer();
        if (origin.excludeEnd) {
          mode_buffer = lexeme;
        }
      }
      do {
        if (top.className) {
          result += spanEndTag;
        }
        if (!top.skip && !top.subLanguage) {
          relevance += top.relevance;
        }
        top = top.parent;
      } while (top !== end_mode.parent);
      if (end_mode.starts) {
        if (end_mode.endSameAsBegin) {
          end_mode.starts.endRe = end_mode.endRe;
        }
        startNewMode(end_mode.starts, '');
      }
      return origin.returnEnd ? 0 : lexeme.length;
    }

    var lastMatch = {};
    function processLexeme(text_before_match, match) {

      var lexeme = match && match[0];

      // add non-matched text to the current mode buffer
      mode_buffer += text_before_match;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      // we've found a 0 width match and we're stuck, so we need to advance
      // this happens when we have badly behaved rules that have optional matchers to the degree that
      // sometimes they can end up matching nothing at all
      // Ref: https://github.com/highlightjs/highlight.js/issues/2140
      if (lastMatch.type=="begin" && match.type=="end" && lastMatch.index == match.index && lexeme === "") {
        // spit the "skipped" character that our regex choked on back into the output sequence
        mode_buffer += value.slice(match.index, match.index + 1)
        return 1;
      }
      lastMatch = match;

      if (match.type==="begin") {
        return doBeginMatch(match);
      } else if (match.type==="illegal" && !ignore_illegals) {
        // illegal match, we do not continue processing
        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
      } else if (match.type==="end") {
        var processed = doEndMatch(match);
        if (processed != undefined)
          return processed;
      }

      /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.

      This causes no real harm other than stopping a few times too many.
      */

      mode_buffer += lexeme;
      return lexeme.length;
    }

    var language = getLanguage(name);
    if (!language) {
      throw new Error('Unknown language: "' + name + '"');
    }

    compileLanguage(language);
    var top = continuation || language;
    var continuations = {}; // keep continuations for sub-languages
    var result = '', current;
    for(current = top; current !== language; current = current.parent) {
      if (current.className) {
        result = buildSpan(current.className, '', true) + result;
      }
    }
    var mode_buffer = '';
    var relevance = 0;
    try {
      var match, count, index = 0;
      while (true) {
        top.terminators.lastIndex = index;
        match = top.terminators.exec(value);
        if (!match)
          break;
        count = processLexeme(value.substring(index, match.index), match);
        index = match.index + count;
      }
      processLexeme(value.substr(index));
      for(current = top; current.parent; current = current.parent) { // close dangling modes
        if (current.className) {
          result += spanEndTag;
        }
      }
      return {
        relevance: relevance,
        value: result,
        illegal:false,
        language: name,
        top: top
      };
    } catch (e) {
      if (e.message && e.message.indexOf('Illegal') !== -1) {
        return {
          illegal: true,
          relevance: 0,
          value: escape(value)
        };
      } else {
        throw e;
      }
    }
  }

  /*
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

  */
  function highlightAuto(text, languageSubset) {
    languageSubset = languageSubset || options.languages || objectKeys(languages);
    var result = {
      relevance: 0,
      value: escape(text)
    };
    var second_best = result;
    languageSubset.filter(getLanguage).filter(autoDetection).forEach(function(name) {
      var current = highlight(name, text, false);
      current.language = name;
      if (current.relevance > second_best.relevance) {
        second_best = current;
      }
      if (current.relevance > result.relevance) {
        second_best = result;
        result = current;
      }
    });
    if (second_best.language) {
      result.second_best = second_best;
    }
    return result;
  }

  /*
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

  */
  function fixMarkup(value) {
    return !(options.tabReplace || options.useBR)
      ? value
      : value.replace(fixMarkupRe, function(match, p1) {
          if (options.useBR && match === '\n') {
            return '<br>';
          } else if (options.tabReplace) {
            return p1.replace(/\t/g, options.tabReplace);
          }
          return '';
      });
  }

  function buildClassName(prevClassName, currentLang, resultLang) {
    var language = currentLang ? aliases[currentLang] : resultLang,
        result   = [prevClassName.trim()];

    if (!prevClassName.match(/\bhljs\b/)) {
      result.push('hljs');
    }

    if (prevClassName.indexOf(language) === -1) {
      result.push(language);
    }

    return result.join(' ').trim();
  }

  /*
  Applies highlighting to a DOM node containing code. Accepts a DOM node and
  two optional parameters for fixMarkup.
  */
  function highlightBlock(block) {
    var node, originalStream, result, resultNode, text;
    var language = blockLanguage(block);

    if (isNotHighlighted(language))
        return;

    if (options.useBR) {
      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
    } else {
      node = block;
    }
    text = node.textContent;
    result = language ? highlight(language, text, true) : highlightAuto(text);

    originalStream = nodeStream(node);
    if (originalStream.length) {
      resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      resultNode.innerHTML = result.value;
      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
    }
    result.value = fixMarkup(result.value);

    block.innerHTML = result.value;
    block.className = buildClassName(block.className, language, result.language);
    block.result = {
      language: result.language,
      re: result.relevance
    };
    if (result.second_best) {
      block.second_best = {
        language: result.second_best.language,
        re: result.second_best.relevance
      };
    }
  }

  /*
  Updates highlight.js global options with values passed in the form of an object.
  */
  function configure(user_options) {
    options = inherit(options, user_options);
  }

  /*
  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
  */
  function initHighlighting() {
    if (initHighlighting.called)
      return;
    initHighlighting.called = true;

    var blocks = document.querySelectorAll('pre code');
    ArrayProto.forEach.call(blocks, highlightBlock);
  }

  /*
  Attaches highlighting to the page load event.
  */
  function initHighlightingOnLoad() {
    addEventListener('DOMContentLoaded', initHighlighting, false);
    addEventListener('load', initHighlighting, false);
  }

  function registerLanguage(name, language) {
    var lang = languages[name] = language(hljs);
    restoreLanguageApi(lang);
    lang.rawDefinition = language.bind(null,hljs);

    if (lang.aliases) {
      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
    }
  }

  function listLanguages() {
    return objectKeys(languages);
  }

  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  function autoDetection(name) {
    var lang = getLanguage(name);
    return lang && !lang.disableAutodetect;
  }

  /* Interface definition */

  hljs.highlight = highlight;
  hljs.highlightAuto = highlightAuto;
  hljs.fixMarkup = fixMarkup;
  hljs.highlightBlock = highlightBlock;
  hljs.configure = configure;
  hljs.initHighlighting = initHighlighting;
  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
  hljs.registerLanguage = registerLanguage;
  hljs.listLanguages = listLanguages;
  hljs.getLanguage = getLanguage;
  hljs.autoDetection = autoDetection;
  hljs.inherit = inherit;

  // Common regexps
  hljs.IDENT_RE = '[a-zA-Z]\\w*';
  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

  // Common modes
  hljs.BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]', relevance: 0
  };
  hljs.APOS_STRING_MODE = {
    className: 'string',
    begin: '\'', end: '\'',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"', end: '"',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  };
  hljs.COMMENT = function (begin, end, inherits) {
    var mode = hljs.inherit(
      {
        className: 'comment',
        begin: begin, end: end,
        contains: []
      },
      inherits || {}
    );
    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
    mode.contains.push({
      className: 'doctag',
      begin: '(?:TODO|FIXME|NOTE|BUG|XXX):',
      relevance: 0
    });
    return mode;
  };
  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
  hljs.NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE,
    relevance: 0
  };
  hljs.C_NUMBER_MODE = {
    className: 'number',
    begin: hljs.C_NUMBER_RE,
    relevance: 0
  };
  hljs.BINARY_NUMBER_MODE = {
    className: 'number',
    begin: hljs.BINARY_NUMBER_RE,
    relevance: 0
  };
  hljs.CSS_NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE + '(' +
      '%|em|ex|ch|rem'  +
      '|vw|vh|vmin|vmax' +
      '|cm|mm|in|pt|pc|px' +
      '|deg|grad|rad|turn' +
      '|s|ms' +
      '|Hz|kHz' +
      '|dpi|dpcm|dppx' +
      ')?',
    relevance: 0
  };
  hljs.REGEXP_MODE = {
    className: 'regexp',
    begin: /\//, end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      {
        begin: /\[/, end: /\]/,
        relevance: 0,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  hljs.TITLE_MODE = {
    className: 'title',
    begin: hljs.IDENT_RE,
    relevance: 0
  };
  hljs.UNDERSCORE_TITLE_MODE = {
    className: 'title',
    begin: hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  hljs.METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };

  return hljs;
}));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formatter = __webpack_require__(678)

var fault = create(Error)

module.exports = fault

fault.eval = create(EvalError)
fault.range = create(RangeError)
fault.reference = create(ReferenceError)
fault.syntax = create(SyntaxError)
fault.type = create(TypeError)
fault.uri = create(URIError)

fault.create = create

// Create a new `EConstructor`, with the formatted `format` as a first argument.
function create(EConstructor) {
  FormattedError.displayName = EConstructor.displayName || EConstructor.name

  return FormattedError

  function FormattedError(format) {
    if (format) {
      format = formatter.apply(null, arguments)
    }

    return new EConstructor(format)
  }
}


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

//
// format - printf-like string formatting for JavaScript
// github.com/samsonjs/format
// @_sjs
//
// Copyright 2010 - 2013 Sami Samhuri <sami@samhuri.net>
//
// MIT License
// http://sjs.mit-license.org
//

;(function() {

  //// Export the API
  var namespace;

  // CommonJS / Node module
  if (true) {
    namespace = module.exports = format;
  }

  // Browsers and other environments
  else {
    // Get the global object. Works in ES3, ES5, and ES5 strict mode.
    namespace = (function(){ return this || (1,eval)('this') }());
  }

  namespace.format = format;
  namespace.vsprintf = vsprintf;

  if (typeof console !== 'undefined' && typeof console.log === 'function') {
    namespace.printf = printf;
  }

  function printf(/* ... */) {
    console.log(format.apply(null, arguments));
  }

  function vsprintf(fmt, replacements) {
    return format.apply(null, [fmt].concat(replacements));
  }

  function format(fmt) {
    var argIndex = 1 // skip initial format argument
      , args = [].slice.call(arguments)
      , i = 0
      , n = fmt.length
      , result = ''
      , c
      , escaped = false
      , arg
      , tmp
      , leadingZero = false
      , precision
      , nextArg = function() { return args[argIndex++]; }
      , slurpNumber = function() {
          var digits = '';
          while (/\d/.test(fmt[i])) {
            digits += fmt[i++];
            c = fmt[i];
          }
          return digits.length > 0 ? parseInt(digits) : null;
        }
      ;
    for (; i < n; ++i) {
      c = fmt[i];
      if (escaped) {
        escaped = false;
        if (c == '.') {
          leadingZero = false;
          c = fmt[++i];
        }
        else if (c == '0' && fmt[i + 1] == '.') {
          leadingZero = true;
          i += 2;
          c = fmt[i];
        }
        else {
          leadingZero = true;
        }
        precision = slurpNumber();
        switch (c) {
        case 'b': // number in binary
          result += parseInt(nextArg(), 10).toString(2);
          break;
        case 'c': // character
          arg = nextArg();
          if (typeof arg === 'string' || arg instanceof String)
            result += arg;
          else
            result += String.fromCharCode(parseInt(arg, 10));
          break;
        case 'd': // number in decimal
          result += parseInt(nextArg(), 10);
          break;
        case 'f': // floating point number
          tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
          result += leadingZero ? tmp : tmp.replace(/^0/, '');
          break;
        case 'j': // JSON
          result += JSON.stringify(nextArg());
          break;
        case 'o': // number in octal
          result += '0' + parseInt(nextArg(), 10).toString(8);
          break;
        case 's': // string
          result += nextArg();
          break;
        case 'x': // lowercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16);
          break;
        case 'X': // uppercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16).toUpperCase();
          break;
        default:
          result += c;
          break;
        }
      } else if (c === '%') {
        escaped = true;
      } else {
        result += c;
      }
    }
    return result;
  }

}());


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddMarkStep */
/* unused harmony export MapResult */
/* unused harmony export Mapping */
/* unused harmony export RemoveMarkStep */
/* unused harmony export ReplaceAroundStep */
/* unused harmony export ReplaceStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Step; });
/* unused harmony export StepMap */
/* unused harmony export StepResult */
/* unused harmony export Transform */
/* unused harmony export TransformError */
/* unused harmony export canJoin */
/* unused harmony export canSplit */
/* unused harmony export dropPoint */
/* unused harmony export findWrapping */
/* unused harmony export insertPoint */
/* unused harmony export joinPoint */
/* unused harmony export liftTarget */
/* unused harmony export replaceStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(37);


// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);

function makeRecover(index, offset) { return index + offset * factor16 }
function recoverIndex(value) { return value & lower16 }
function recoverOffset(value) { return (value - (value & lower16)) / factor16 }

// ::- An object representing a mapped position with extra
// information.
var MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  this.ranges = ranges;
  this.inverted = inverted;
};

StepMap.prototype.recover = function recover (value) {
  var diff = 0, index = recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + recoverOffset(value)
};

// : (number, ?number) → MapResult
StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

StepMap.prototype._map = function _map (pos, assoc, simple) {
  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = makeRecover(i / 3, pos - start);
      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new MapResult(pos + diff)
};

StepMap.prototype.touches = function touches (pos, recover) {
  var diff = 0, index = recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
StepMap.prototype.forEach = function forEach (f) {
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
StepMap.prototype.invert = function invert () {
  return new StepMap(this.ranges, !this.inverted)
};

StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
StepMap.offset = function offset (n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

StepMap.empty = new StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new Mapping(this.maps, this.mirror, from, to)
};

Mapping.prototype.copy = function copy () {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
Mapping.prototype.appendMapping = function appendMapping (mapping) {
  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
Mapping.prototype.getMirror = function getMirror (n) {
  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this.mirror[i] == n) { return this.mirror[i + (i % 2 ? -1 : 1)] } } }
};

Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// :: () → Mapping
// Create an inverted version of this mapping.
Mapping.prototype.invert = function invert () {
  var inverse = new Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
Mapping.prototype.map = function map (pos, assoc) {
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

Mapping.prototype._map = function _map (pos, assoc, simple) {
  var deleted = false, recoverables = null;

  for (var i = this.from; i < this.to; i++) {
    var map = this.maps[i], rec = recoverables && recoverables[i];
    if (rec != null && map.touches(pos, rec)) {
      pos = map.recover(rec);
      continue
    }

    var result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this.getMirror(i);
      if (corr != null && corr > i && corr < this.to) {
        if (result.deleted) {
          i = corr;
          pos = this.maps[corr].recover(result.recover);
          continue
        } else {
(recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
        }
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new MapResult(pos, deleted)
};

function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err
}

TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new Mapping;
};

var prototypeAccessors = { before: { configurable: true },docChanged: { configurable: true } };

// :: Node The starting document.
prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
prototypeAccessors.docChanged.get = function () {
  return this.steps.length > 0
};

Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( Transform.prototype, prototypeAccessors );

function mustOverride() { throw new Error("Override me") }

var stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var Step = function Step () {};

Step.prototype.apply = function apply (_doc) { return mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
Step.prototype.getMap = function getMap () { return StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
Step.prototype.invert = function invert (_doc) { return mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
Step.prototype.map = function map (_mapping) { return mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
Step.prototype.toJSON = function toJSON () { return mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
Step.jsonID = function jsonID (id, stepClass) {
  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
StepResult.ok = function ok (doc) { return new StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
StepResult.fail = function fail (message) { return new StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["ReplaceError"]) { return StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var ReplaceStep = /*@__PURE__*/(function (Step) {
  function ReplaceStep(from, to, slice, structure) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceStep.__proto__ = Step;
  ReplaceStep.prototype = Object.create( Step && Step.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && contentBetween(doc, this.from, this.to))
      { return StepResult.fail("Structure replace would overwrite content") }
    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure != this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty
          : new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty
          : new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(Step));

Step.jsonID("replace", ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var ReplaceAroundStep = /*@__PURE__*/(function (Step) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice;
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceAroundStep.__proto__ = Step;
  ReplaceAroundStep.prototype = Object.create( Step && Step.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
                           contentBetween(doc, this.gapTo, this.to)))
      { return StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
    return StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(Step));

Step.jsonID("replaceAround", ReplaceAroundStep);

function contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) &&
    (end == node.childCount || node.canReplace(0, end))
}

// :: (NodeRange) → ?number
// Try to find a target depth to which the content in the given range
// can be lifted. Will not go across
// [isolating](#model.NodeSpec.isolating) parent nodes.
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content))
      { return depth }
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
  }
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
// Try to find a valid way to wrap the content in the given range in a
// node of the given type. May introduce extra nodes around and inside
// the wrapper node, if necessary. Returns null if no valid wrapping
// could be found. When `innerRange` is given, that range's content is
// used as the content to fit into the wrapping, instead of the
// content of `range`.
function findWrapping(range, nodeType, attrs, innerRange) {
  if ( innerRange === void 0 ) innerRange = range;

  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) { return null }
  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
}

function withAttrs(type) { return {type: type, attrs: null} }

function findWrappingOutside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) { return null }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
}

function findWrappingInside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) { return null }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++)
    { innerMatch = innerMatch.matchType(parent.child(i).type); }
  if (!innerMatch || !innerMatch.validEnd) { return null }
  return inside
}

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
Transform.prototype.wrap = function(range, wrappers) {
  var content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  var start = range.start, end = range.end;
  return this.step(new ReplaceAroundStep(start, end, start, end, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(newNode), 0, 0), 1, true))
};

// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
// Check whether splitting at the given position is allowed.
function canSplit(doc, pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = doc.resolve(pos), base = $pos.depth - depth;
  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating ||
      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    { return false }
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d), index$1 = $pos.index(d);
    if (node.type.spec.isolating) { return false }
    var rest = node.content.cutByIndex(index$1, node.childCount);
    var after = (typesAfter && typesAfter[i]) || node;
    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
      { return false }
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
}

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new ReplaceStep(pos, pos, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](before.append(after), depth, depth), true))
};

// :: (Node, number) → bool
// Test whether the blocks before and after a given position can be
// joined.
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) &&
    $pos.parent.canReplace(index, index + 1)
}

function joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b)
}

// :: (Node, number, ?number) → ?number
// Find an ancestor of the given position that can be joined to the
// block before (or after if `dir` is positive). Returns the joinable
// point, if any.
function joinPoint(doc, pos, dir) {
  if ( dir === void 0 ) dir = -1;

  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = (void 0), after = (void 0);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      after = $pos.node(d).maybeChild($pos.index(d) + 1);
    } else {
      before = $pos.node(d).maybeChild($pos.index(d) - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable(before, after)) { return pos }
    if (d == 0) { break }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new ReplaceStep(pos - depth, pos + depth, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

// :: (Node, number, Slice) → ?number
// Finds a position at or around the given position where the given
// slice can be inserted. Will look at parent nodes' nearest boundary
// and try there, even if the original position wasn't directly at the
// start or end of that node. Returns null when no position was found.
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) { return pos }
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      if (pass == 1
          ? $pos.node(d).canReplace(insertPos, insertPos, content)
          : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type))
        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
    }
  }
  return null
}

function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var AddMarkStep = /*@__PURE__*/(function (Step) {
  function AddMarkStep(from, to, mark) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step ) AddMarkStep.__proto__ = Step;
  AddMarkStep.prototype = Object.create( Step && Step.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](mapFragment(oldSlice.content, function (node, parent) {
      if (!parent.type.allowsMarkType(this$1.mark.type)) { return node }
      return node.mark(this$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(Step));

Step.jsonID("addMark", AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var RemoveMarkStep = /*@__PURE__*/(function (Step) {
  function RemoveMarkStep(from, to, mark) {
    Step.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step ) RemoveMarkStep.__proto__ = Step;
  RemoveMarkStep.prototype = Object.create( Step && Step.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(Step));

Step.jsonID("removeMark", RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
Transform.prototype.addMark = function(from, to, mark) {
  var this$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1.step(s); });
  added.forEach(function (s) { return this$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
Transform.prototype.removeMark = function(from, to, mark) {
  var this$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["MarkType"]) {
      var found = mark.isInSet(node.marks);
      if (found) { toRemove = [found]; }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1.step(new RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new ReplaceStep(cur, end, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this.step(new RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true);
    this.replace(cur, cur, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (fitsTrivially($from, $to, slice)) { return new ReplaceStep(from, to, slice) }
  var placed = placeSlice($from, slice);

  var fittedLeft = fitLeft($from, placed);
  var fitted = fitRight($from, $to, fittedLeft);
  if (!fitted) { return null }
  if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
    var d = $to.depth, after = $to.after(d);
    while (d > 1 && after == $to.end(--d)) { ++after; }
    var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);
    if (fittedAfter)
      { return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size) }
  }
  return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty;

  var step = replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"].empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};



function fitLeftInner($from, depth, placed, placedBelow) {
  var content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, openEnd = 0, placedHere = placed[depth];
  if ($from.depth > depth) {
    var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
    openEnd = inner.openEnd + 1;
    content = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($from.node(depth + 1).copy(inner.content));
  }

  if (placedHere) {
    content = content.append(placedHere.content);
    openEnd = placedHere.openEnd;
  }
  if (placedBelow) {
    content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true));
    openEnd = 0;
  }

  return {content: content, openEnd: openEnd}
}

function fitLeft($from, placed) {
  var ref = fitLeftInner($from, 0, placed, false);
  var content = ref.content;
  var openEnd = ref.openEnd;
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](content, $from.depth, openEnd || 0)
}

function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
  var match, count = content.childCount, matchCount = count - (openEnd > 0 ? 1 : 0);
  var parentNode = openStart < 0 ? parent : $from.node(depth);
  if (openStart < 0)
    { match = parentNode.contentMatchAt(matchCount); }
  else if (count == 1 && openEnd > 0)
    { match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth)); }
  else
    { match = parentNode.contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount); }

  var toNode = $to.node(depth);
  if (openEnd > 0 && depth < $to.depth) {
    var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
    var joinable$1 = match.fillBefore(after, true);
    // Can't insert content if there's a single node stretched across this gap
    if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) { joinable$1 = null; }

    if (joinable$1) {
      var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to,
                               depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);
      if (inner) {
        var last = content.lastChild.copy(inner);
        if (joinable$1.size)
          { return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last) }
        else
          { return content.replaceChild(count - 1, last) }
      }
    }
  }
  if (openEnd > 0)
    { match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type); }

  // If we're here, the next level can't be joined, so we see what
  // happens if we leave it open.
  var toIndex = $to.index(depth);
  if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) { return null }
  var joinable = match.fillBefore(toNode.content, true, toIndex);
  for (var i = toIndex; joinable && i < toNode.content.childCount; i++)
    { if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) { joinable = null; } }
  if (!joinable) { return null }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }
  content = content.append(joinable);
  if ($to.depth > depth)
    { content = content.addToEnd(fitRightSeparate($to, depth + 1)); }
  return content
}

function fitRightClosed(node, openEnd, $from, depth, openStart) {
  var match, content = node.content, count = content.childCount;
  if (openStart >= 0)
    { match = $from.node(depth).contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, openStart > 0 ? 1 : 0, count); }
  else
    { match = node.contentMatchAt(count); }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }

  return node.copy(content.append(match.fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true)))
}

function fitRightSeparate($to, depth) {
  var node = $to.node(depth);
  var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));
  if ($to.depth > depth) { fill = fill.addToEnd(fitRightSeparate($to, depth + 1)); }
  return node.copy(fill)
}

function normalizeSlice(content, openStart, openEnd) {
  while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
    content = content.firstChild.content;
    openStart--;
    openEnd--;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](content, openStart, openEnd)
}

// : (ResolvedPos, ResolvedPos, number, Slice) → Slice
function fitRight($from, $to, slice) {
  var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);
  if (!fitted) { return null }
  return normalizeSlice(fitted, slice.openStart, $to.depth)
}

function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

function canMoveText($from, $to, slice) {
  if (!$to.parent.isTextblock) { return false }

  var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd)
      : $from.node($from.depth - (slice.openStart - slice.openEnd));
  if (!parent.isTextblock) { return false }
  for (var i = $to.index(); i < $to.parent.childCount; i++)
    { if (!parent.type.allowsMarks($to.parent.child(i).marks)) { return false } }
  var match;
  if (slice.openEnd) {
    match = parent.contentMatchAt(parent.childCount);
  } else {
    match = parent.contentMatchAt(parent.childCount);
    if (slice.size) { match = match.matchFragment(slice.content, slice.openStart ? 1 : 0); }
  }
  match = match.matchFragment($to.parent.content, $to.index());
  return match && match.validEnd
}

function nodeRight(content, depth) {
  for (var i = 1; i < depth; i++) { content = content.lastChild.content; }
  return content.lastChild
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// So placeSlice splits up a slice into a number of sub-slices,
// along with information on where they can be placed on the given
// left-side edge. It works by walking the open side of the slice,
// from the inside out, and trying to find a landing spot for each
// element, by simultaneously scanning over the gap side. When no
// place is found for an open node's content, it is left in that node.

// : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]
function placeSlice($from, slice) {
  var frontier = new Frontier($from);
  for (var pass = 1; slice.size && pass <= 3; pass++) {
    var value = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass);
    if (pass == 3 && value != slice && value.size) { pass = 0; } // Restart if the 3rd pass made progress but left content
    slice = value;
  }
  while (frontier.open.length) { frontier.closeNode(); }
  return frontier.placed
}

// Helper class that models the open side of the insert position,
// keeping track of the content match and already inserted content
// at each depth.
var Frontier = function Frontier($pos) {
  // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]
  this.open = [];
  for (var d = 0; d <= $pos.depth; d++) {
    var parent = $pos.node(d), match = parent.contentMatchAt($pos.indexAfter(d));
    this.open.push({parent: parent, match: match, content: __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, wrapper: false, openEnd: 0, depth: d});
  }
  this.placed = [];
};

// : (Fragment, number, number, number, ?Node) → Slice
// Tries to place the content of the given slice, and returns a
// slice containing unplaced content.
//
// pass 1: try to fit directly
// pass 2: allow wrapper nodes to be introduced
// pass 3: allow unwrapping of nodes that aren't open
Frontier.prototype.placeSlice = function placeSlice (fragment, openStart, openEnd, pass, parent) {
  if (openStart > 0) {
    var first = fragment.firstChild;
    var inner = this.placeSlice(first.content, Math.max(0, openStart - 1),
                                openEnd && fragment.childCount == 1 ? openEnd - 1 : 0,
                                pass, first);
    if (inner.content != first.content) {
      if (inner.content.size) {
        fragment = fragment.replaceChild(0, first.copy(inner.content));
        openStart = inner.openStart + 1;
      } else {
        if (fragment.childCount == 1) { openEnd = 0; }
        fragment = fragment.cutByIndex(1);
        openStart = 0;
      }
    }
  }
  var result = this.placeContent(fragment, openStart, openEnd, pass, parent);
  if (pass > 2 && result.size && openStart == 0) {
    var child = result.content.firstChild, single = result.content.childCount == 1;
    this.placeContent(child.content, 0, openEnd && single ? openEnd - 1 : 0, pass, child);
    result = single ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty : new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](result.content.cutByIndex(1), 0, openEnd);
  }
  return result
};

Frontier.prototype.placeContent = function placeContent (fragment, openStart, openEnd, pass, parent) {
  var i = 0;
  // Go over the fragment's children
  for (; i < fragment.childCount; i++) {
    var child = fragment.child(i), placed = false, last = i == fragment.childCount - 1;
    // Try each open node in turn, starting from the innermost
    for (var d = this.open.length - 1; d >= 0; d--) {
      var open = this.open[d], wrap = (void 0);

      // If pass > 1, it is allowed to wrap the node to help find a
      // fit, so if findWrapping returns something, we add open
      // nodes to the frontier for that wrapping.
      if (pass > 1 && (wrap = open.match.findWrapping(child.type)) &&
          !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
        while (this.open.length - 1 > d) { this.closeNode(); }
        for (var w = 0; w < wrap.length; w++) {
          open.match = open.match.matchType(wrap[w]);
          d++;
          open = {parent: wrap[w].create(),
                  match: wrap[w].contentMatch,
                  content: __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, wrapper: true, openEnd: 0, depth: d + w};
          this.open.push(open);
        }
      }

      // See if the child fits here
      var match = open.match.matchType(child.type);
      if (!match) {
        var fill = open.match.fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(child));
        if (fill) {
          for (var j = 0; j < fill.childCount; j++) {
            var ch = fill.child(j);
            this.addNode(open, ch, 0);
            match = open.match.matchFragment(ch);
          }
        } else if (parent && open.match.matchType(parent.type)) {
          // Don't continue looking further up if the parent node
          // would fit here.
          break
        } else {
          continue
        }
      }

      // Close open nodes above this one, since we're starting to
      // add to this.
      while (this.open.length - 1 > d) { this.closeNode(); }
      // Strip marks from the child or close its start when necessary
      child = child.mark(open.parent.type.allowedMarks(child.marks));
      if (openStart) {
        child = closeNodeStart(child, openStart, last ? openEnd : 0);
        openStart = 0;
      }
      // Add the child to this open node and adjust its metadata
      this.addNode(open, child, last ? openEnd : 0);
      open.match = match;
      if (last) { openEnd = 0; }
      placed = true;
      break
    }
    // As soon as we've failed to place a node we stop looking at
    // later nodes
    if (!placed) { break }
  }
  // Close the current open node if it's not the the root and we
  // either placed up to the end of the node or the the current
  // slice depth's node type matches the open node's type
  if (this.open.length > 1 &&
      (i > 0 && i == fragment.childCount ||
       parent && this.open[this.open.length - 1].parent.type == parent.type))
    { this.closeNode(); }

  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](fragment.cutByIndex(i), openStart, openEnd)
};

Frontier.prototype.addNode = function addNode (open, node, openEnd) {
  open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
  open.openEnd = openEnd;
};

Frontier.prototype.closeNode = function closeNode () {
  var open = this.open.pop();
  if (open.content.size == 0) ; else if (open.wrapper) {
    this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
  } else {
    this.placed[open.depth] = {depth: open.depth, content: open.content, openEnd: open.openEnd};
  }
};

function closeNodeStart(node, openStart, openEnd) {
  var content = node.content;
  if (openStart > 1) {
    var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
    content = node.content.replaceChild(0, first);
  }
  var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
  return node.copy(fill.append(content))
}

function closeNodeEnd(node, depth) {
  var content = node.content;
  if (depth > 1) {
    var last = closeNodeEnd(node.lastChild, depth - 1);
    content = node.content.replaceChild(node.childCount - 1, last);
  }
  var fill = node.contentMatchAt(node.childCount).fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true);
  return node.copy(content.append(fill))
}

function closeFragmentEnd(fragment, depth) {
  return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining](#model.NodeSpec.defining), or
// including an open parent node from the slice that _is_ marked as
// [defining](#model.NodeSpec.defining).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
Transform.prototype.replaceRange = function(from, to, slice) {
  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (fitsTrivially($from, $to, slice))
    { return this.step(new ReplaceStep(from, to, slice)) }

  var targetDepths = coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  var startSteps = this.steps.length;
  for (var i$2 = targetDepths.length - 1; i$2 >= 0; i$2--) {
    this.replace(from, to, slice);
    if (this.steps.length > startSteps) { break }
    var depth = targetDepths[i$2];
    if (i$2 < 0) { continue }
    from = $from.before(depth); to = $to.after(depth);
  }
  return this
};

function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen) {
    var match = parent.contentMatchAt(0);
    var start = match.fillBefore(fragment).append(fragment);
    fragment = start.append(match.matchFragment(start).fillBefore(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty, true));
  }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
Transform.prototype.deleteRange = function(from, to) {
  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d)
      { return this.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d)) { result.push(d); }
  }
  return result
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return collab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVersion; });
/* unused harmony export rebaseSteps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sendableSteps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(21);


var Rebaseable = function Rebaseable(step, inverted, origin) {
  this.step = step;
  this.inverted = inverted;
  this.origin = origin;
};

// : ([Rebaseable], [Step], Transform) → [Rebaseable]
// Undo a given set of steps, apply a set of other steps, and then
// redo them.
function rebaseSteps(steps, over, transform) {
  for (var i = steps.length - 1; i >= 0; i--) { transform.step(steps[i].inverted); }
  for (var i$1 = 0; i$1 < over.length; i$1++) { transform.step(over[i$1]); }
  var result = [];
  for (var i$2 = 0, mapFrom = steps.length; i$2 < steps.length; i$2++) {
    var mapped = steps[i$2].step.map(transform.mapping.slice(mapFrom));
    mapFrom--;
    if (mapped && !transform.maybeStep(mapped).failed) {
      transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
      result.push(new Rebaseable(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i$2].origin));
    }
  }
  return result
}

// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
var CollabState = function CollabState(version, unconfirmed) {
  // : number
  // The version number of the last update received from the central
  // authority. Starts at 0 or the value of the `version` property
  // in the option object, for the editor's value when the option
  // was enabled.
  this.version = version;

  // : [Rebaseable]
  // The local steps that havent been successfully sent to the
  // server yet.
  this.unconfirmed = unconfirmed;
};

function unconfirmedFrom(transform) {
  var result = [];
  for (var i = 0; i < transform.steps.length; i++)
    { result.push(new Rebaseable(transform.steps[i],
                               transform.steps[i].invert(transform.docs[i]),
                               transform)); }
  return result
}

var collabKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]("collab");

// :: (?Object) → Plugin
//
// Creates a plugin that enables the collaborative editing framework
// for the editor.
//
//   config::- An optional set of options
//
//     version:: ?number
//     The starting version number of the collaborative editing.
//     Defaults to 0.
//
//     clientID:: ?union<number, string>
//     This client's ID, used to distinguish its changes from those of
//     other clients. Defaults to a random 32-bit number.
function collab(config) {
  if ( config === void 0 ) config = {};

  config = {version: config.version || 0,
            clientID: config.clientID == null ? Math.floor(Math.random() * 0xFFFFFFFF) : config.clientID};

  return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: collabKey,

    state: {
      init: function () { return new CollabState(config.version, []); },
      apply: function apply(tr, collab) {
        var newState = tr.getMeta(collabKey);
        if (newState)
          { return newState }
        if (tr.docChanged)
          { return new CollabState(collab.version, collab.unconfirmed.concat(unconfirmedFrom(tr))) }
        return collab
      }
    },

    config: config,
    // This is used to notify the history plugin to not merge steps,
    // so that the history can be rebased.
    historyPreserveItems: true
  })
}

// :: (state: EditorState, steps: [Step], clientIDs: [union<number, string>], options: ?Object) → Transaction
// Create a transaction that represents a set of new steps received from
// the authority. Applying this transaction moves the state forward to
// adjust to the authority's view of the document.
//
//   options::- Additional options.
//
//     mapSelectionBackward:: ?boolean
//     When enabled (the default is `false`), if the current selection
//     is a [text selection](#state.TextSelection), its sides are
//     mapped with a negative bias for this transaction, so that
//     content inserted at the cursor ends up after the cursor. Users
//     usually prefer this, but it isn't done by default for reasons
//     of backwards compatibility.
function receiveTransaction(state, steps, clientIDs, options) {
  // Pushes a set of steps (received from the central authority) into
  // the editor state (which should have the collab plugin enabled).
  // Will recognize its own changes, and confirm unconfirmed steps as
  // appropriate. Remaining unconfirmed steps will be rebased over
  // remote steps.
  var collabState = collabKey.getState(state);
  var version = collabState.version + steps.length;
  var ourID = collabKey.get(state).spec.config.clientID;

  // Find out which prefix of the steps originated with us
  var ours = 0;
  while (ours < clientIDs.length && clientIDs[ours] == ourID) { ++ours; }
  var unconfirmed = collabState.unconfirmed.slice(ours);
  steps = ours ? steps.slice(ours) : steps;

  // If all steps originated with us, we're done.
  if (!steps.length)
    { return state.tr.setMeta(collabKey, new CollabState(version, unconfirmed)) }

  var nUnconfirmed = unconfirmed.length;
  var tr = state.tr;
  if (nUnconfirmed) {
    unconfirmed = rebaseSteps(unconfirmed, steps, tr);
  } else {
    for (var i = 0; i < steps.length; i++) { tr.step(steps[i]); }
    unconfirmed = [];
  }

  var newCollabState = new CollabState(version, unconfirmed);
  if (options && options.mapSelectionBackward && state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) {
    tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].between(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)),
                                          tr.doc.resolve(tr.mapping.map(state.selection.head, -1)), -1));
    tr.updated &= ~1;
  }
  return tr.setMeta("rebased", nUnconfirmed).setMeta("addToHistory", false).setMeta(collabKey, newCollabState)
}

// :: (state: EditorState) → ?{version: number, steps: [Step], clientID: union<number, string>, origins: [Transaction]}
// Provides data describing the editor's unconfirmed steps, which need
// to be sent to the central authority. Returns null when there is
// nothing to send.
//
// `origins` holds the _original_ transactions that produced each
// steps. This can be useful for looking up time stamps and other
// metadata for the steps, but note that the steps may have been
// rebased, whereas the origin transactions are still the old,
// unchanged objects.
function sendableSteps(state) {
  var collabState = collabKey.getState(state);
  if (collabState.unconfirmed.length == 0) { return null }
  return {
    version: collabState.version,
    steps: collabState.unconfirmed.map(function (s) { return s.step; }),
    clientID: collabKey.get(state).spec.config.clientID,
    get origins() { return this._origins || (this._origins = collabState.unconfirmed.map(function (s) { return s.origin; })) }
  }
}

// :: (EditorState) → number
// Get the version up to which the collab plugin has synced with the
// central authority.
function getVersion(state) {
  return collabKey.getState(state).version
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HistoryState */
/* unused harmony export closeHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return redo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return redoDepth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return undo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return undoDepth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rope_sequence__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(21);




// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)

// Used to schedule history compression
var max_empty_items = 500;

var Branch = function Branch(items, eventCount) {
  this.items = items;
  this.eventCount = eventCount;
};

// : (EditorState, bool) → ?{transform: Transform, selection: ?SelectionBookmark, remaining: Branch}
// Pop the latest event off the branch's history and apply it
// to a document transform.
Branch.prototype.popEvent = function popEvent (state, preserveItems) {
    var this$1 = this;

  if (this.eventCount == 0) { return null }

  var end = this.items.length;
  for (;; end--) {
    var next = this.items.get(end - 1);
    if (next.selection) { --end; break }
  }

  var remap, mapFrom;
  if (preserveItems) {
    remap = this.remapping(end, this.items.length);
    mapFrom = remap.maps.length;
  }
  var transform = state.tr;
  var selection, remaining;
  var addAfter = [], addBefore = [];

  this.items.forEach(function (item, i) {
    if (!item.step) {
      if (!remap) {
        remap = this$1.remapping(end, i + 1);
        mapFrom = remap.maps.length;
      }
      mapFrom--;
      addBefore.push(item);
      return
    }

    if (remap) {
      addBefore.push(new Item(item.map));
      var step = item.step.map(remap.slice(mapFrom)), map;

      if (step && transform.maybeStep(step).doc) {
        map = transform.mapping.maps[transform.mapping.maps.length - 1];
        addAfter.push(new Item(map, null, null, addAfter.length + addBefore.length));
      }
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
    } else {
      transform.maybeStep(item.step);
    }

    if (item.selection) {
      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
      remaining = new Branch(this$1.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this$1.eventCount - 1);
      return false
    }
  }, this.items.length, 0);

  return {remaining: remaining, transform: transform, selection: selection}
};

// : (Transform, ?SelectionBookmark, Object) → Branch
// Create a new branch with the given transform added.
Branch.prototype.addTransform = function addTransform (transform, selection, histOptions, preserveItems) {
  var newItems = [], eventCount = this.eventCount;
  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;

  for (var i = 0; i < transform.steps.length; i++) {
    var step = transform.steps[i].invert(transform.docs[i]);
    var item = new Item(transform.mapping.maps[i], step, selection), merged = (void 0);
    if (merged = lastItem && lastItem.merge(item)) {
      item = merged;
      if (i) { newItems.pop(); }
      else { oldItems = oldItems.slice(0, oldItems.length - 1); }
    }
    newItems.push(item);
    if (selection) {
      eventCount++;
      selection = null;
    }
    if (!preserveItems) { lastItem = item; }
  }
  var overflow = eventCount - histOptions.depth;
  if (overflow > DEPTH_OVERFLOW) {
    oldItems = cutOffEvents(oldItems, overflow);
    eventCount -= overflow;
  }
  return new Branch(oldItems.append(newItems), eventCount)
};

Branch.prototype.remapping = function remapping (from, to) {
  var maps = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["a" /* Mapping */];
  this.items.forEach(function (item, i) {
    var mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
        ? mirrorPos = maps.maps.length - item.mirrorOffset : null;
    maps.appendMap(item.map, mirrorPos);
  }, from, to);
  return maps
};

Branch.prototype.addMaps = function addMaps (array) {
  if (this.eventCount == 0) { return this }
  return new Branch(this.items.append(array.map(function (map) { return new Item(map); })), this.eventCount)
};

// : (Transform, number)
// When the collab module receives remote changes, the history has
// to know about those, so that it can adjust the steps that were
// rebased on top of the remote changes, and include the position
// maps for the remote changes in its array of items.
Branch.prototype.rebased = function rebased (rebasedTransform, rebasedCount) {
  if (!this.eventCount) { return this }

  var rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);

  var mapping = rebasedTransform.mapping;
  var newUntil = rebasedTransform.steps.length;
  var eventCount = this.eventCount;
  this.items.forEach(function (item) { if (item.selection) { eventCount--; } }, start);

  var iRebased = rebasedCount;
  this.items.forEach(function (item) {
    var pos = mapping.getMirror(--iRebased);
    if (pos == null) { return }
    newUntil = Math.min(newUntil, pos);
    var map = mapping.maps[pos];
    if (item.step) {
      var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
      var selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
      if (selection) { eventCount++; }
      rebasedItems.push(new Item(map, step, selection));
    } else {
      rebasedItems.push(new Item(map));
    }
  }, start);

  var newMaps = [];
  for (var i = rebasedCount; i < newUntil; i++)
    { newMaps.push(new Item(mapping.maps[i])); }
  var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
  var branch = new Branch(items, eventCount);

  if (branch.emptyItemCount() > max_empty_items)
    { branch = branch.compress(this.items.length - rebasedItems.length); }
  return branch
};

Branch.prototype.emptyItemCount = function emptyItemCount () {
  var count = 0;
  this.items.forEach(function (item) { if (!item.step) { count++; } });
  return count
};

// Compressing a branch means rewriting it to push the air (map-only
// items) out. During collaboration, these naturally accumulate
// because each remote change adds one. The `upto` argument is used
// to ensure that only the items below a given level are compressed,
// because `rebased` relies on a clean, untouched set of items in
// order to associate old items with rebased steps.
Branch.prototype.compress = function compress (upto) {
    if ( upto === void 0 ) upto = this.items.length;

  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
  var items = [], events = 0;
  this.items.forEach(function (item, i) {
    if (i >= upto) {
      items.push(item);
      if (item.selection) { events++; }
    } else if (item.step) {
      var step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
      if (step) {
        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
        if (selection) { events++; }
        var newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
        if (merged = items.length && items[last].merge(newItem))
          { items[last] = merged; }
        else
          { items.push(newItem); }
      }
    } else if (item.map) {
      mapFrom--;
    }
  }, this.items.length, 0);
  return new Branch(__WEBPACK_IMPORTED_MODULE_0_rope_sequence__["a" /* default */].from(items.reverse()), events)
};

Branch.empty = new Branch(__WEBPACK_IMPORTED_MODULE_0_rope_sequence__["a" /* default */].empty, 0);

function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function (item, i) {
    if (item.selection && (n-- == 0)) {
      cutPoint = i;
      return false
    }
  });
  return items.slice(cutPoint)
}

var Item = function Item(map, step, selection, mirrorOffset) {
  // The (forward) step map for this item.
  this.map = map;
  // The inverted step
  this.step = step;
  // If this is non-null, this item is the start of a group, and
  // this selection is the starting selection for the group (the one
  // that was active before the first step was applied)
  this.selection = selection;
  // If this item is the inverse of a previous mapping on the stack,
  // this points at the inverse's offset
  this.mirrorOffset = mirrorOffset;
};

Item.prototype.merge = function merge (other) {
  if (this.step && other.step && !other.selection) {
    var step = other.step.merge(this.step);
    if (step) { return new Item(step.getMap().invert(), step, this.selection) }
  }
};

// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
var HistoryState = function HistoryState(done, undone, prevRanges, prevTime) {
  this.done = done;
  this.undone = undone;
  this.prevRanges = prevRanges;
  this.prevTime = prevTime;
};

var DEPTH_OVERFLOW = 20;

// : (HistoryState, EditorState, Transaction, Object)
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
  var historyTr = tr.getMeta(historyKey), rebased;
  if (historyTr) { return historyTr.historyState }

  if (tr.getMeta(closeHistoryKey)) { history = new HistoryState(history.done, history.undone, null, 0); }

  var appended = tr.getMeta("appendedTransaction");

  if (tr.steps.length == 0) {
    return history
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo)
      { return new HistoryState(history.done.addTransform(tr, null, options, mustPreserveItems(state)),
                              history.undone, rangesFor(tr.mapping.maps[tr.steps.length - 1]), history.prevTime) }
    else
      { return new HistoryState(history.done, history.undone.addTransform(tr, null, options, mustPreserveItems(state)),
                              null, history.prevTime) }
  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    // Group transforms that occur in quick succession into one event.
    var newGroup = !appended && (history.prevTime < (tr.time || 0) - options.newGroupDelay ||
                                 !isAdjacentTo(tr, history.prevRanges));
    var prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps[tr.steps.length - 1]);
    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null,
                                                      options, mustPreserveItems(state)),
                            Branch.empty, prevRanges, tr.time)
  } else if (rebased = tr.getMeta("rebased")) {
    // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new HistoryState(history.done.rebased(tr, rebased),
                            history.undone.rebased(tr, rebased),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  } else {
    return new HistoryState(history.done.addMaps(tr.mapping.maps),
                            history.undone.addMaps(tr.mapping.maps),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  }
}

function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges) { return false }
  if (!transform.docChanged) { return true }
  var adjacent = false;
  transform.mapping.maps[0].forEach(function (start, end) {
    for (var i = 0; i < prevRanges.length; i += 2)
      { if (start <= prevRanges[i + 1] && end >= prevRanges[i])
        { adjacent = true; } }
  });
  return adjacent
}

function rangesFor(map) {
  var result = [];
  map.forEach(function (_from, _to, from, to) { return result.push(from, to); });
  return result
}

function mapRanges(ranges, mapping) {
  if (!ranges) { return null }
  var result = [];
  for (var i = 0; i < ranges.length; i += 2) {
    var from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
    if (from <= to) { result.push(from, to); }
  }
  return result
}

// : (HistoryState, EditorState, (tr: Transaction), bool)
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function histTransaction(history, state, dispatch, redo) {
  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
  if (!pop) { return }

  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(),
                                                                  histOptions, preserveItems);

  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0);
  dispatch(pop.transform.setSelection(selection).setMeta(historyKey, {redo: redo, historyState: newHist}).scrollIntoView());
}

var cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i = 0; i < plugins.length; i++) { if (plugins[i].spec.historyPreserveItems) {
      cachedPreserveItems = true;
      break
    } }
  }
  return cachedPreserveItems
}

// :: (Transaction) → Transaction
// Set a flag on the given transaction that will prevent further steps
// from being appended to an existing history event (so that they
// require a separate undo command to undo).
function closeHistory(tr) {
  return tr.setMeta(closeHistoryKey, true)
}

var historyKey = new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["PluginKey"]("history");
var closeHistoryKey = new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["PluginKey"]("closeHistory");

// :: (?Object) → Plugin
// Returns a plugin that enables the undo history for an editor. The
// plugin will track undo and redo stacks, which can be used with the
// [`undo`](#history.undo) and [`redo`](#history.redo) commands.
//
// You can set an `"addToHistory"` [metadata
// property](#state.Transaction.setMeta) of `false` on a transaction
// to prevent it from being rolled back by undo.
//
//   config::-
//   Supports the following configuration options:
//
//     depth:: ?number
//     The amount of history events that are collected before the
//     oldest events are discarded. Defaults to 100.
//
//     newGroupDelay:: ?number
//     The delay between changes after which a new group should be
//     started. Defaults to 500 (milliseconds). Note that when changes
//     aren't adjacent, a new group is always started.
function history(config) {
  config = {depth: config && config.depth || 100,
            newGroupDelay: config && config.newGroupDelay || 500};
  return new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Plugin"]({
    key: historyKey,

    state: {
      init: function init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0)
      },
      apply: function apply(tr, hist, state) {
        return applyTransaction(hist, state, tr, config)
      }
    },

    config: config
  })
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that undoes the last change, if any.
function undo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.done.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, false); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that redoes the last undone change, if any.
function redo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.undone.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, true); }
  return true
}

// :: (EditorState) → number
// The amount of undoable events available in a given state.
function undoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.done.eventCount : 0
}

// :: (EditorState) → number
// The amount of redoable events available in a given editor state.
function redoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.undone.eventCount : 0
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var GOOD_LEAF_SIZE = 200;

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other);

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0); }
  else
    { this.forEachInvertedInner(f, from, to, 0); }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = [];
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = /*@__PURE__*/(function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this);
    this.values = values;
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    for (var i = from; i < to; i++)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    for (var i = from - 1; i >= to; i--)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([]);

var Append = /*@__PURE__*/(function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length;
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other);
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other);
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

var ropeSequence = RopeSequence;

/* harmony default export */ __webpack_exports__["a"] = (ropeSequence);


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("\n    References\n    "),(_vm.editAccess)?_c('span',{staticStyle:{"float":"right","cursor":"pointer"},on:{"click":function($event){return _vm.showAddReferenceDialog()}}},[_vm._v("+")]):_vm._e()]),_vm._v(" "),(_vm.references.length < 3 && _vm.editAccess)?_c('small',[_vm._v("Please list at least 3 previous placement references; Babysitting,\n    Nannying, Daycare, Church Nursery or Summer Camps")]):_vm._e(),_vm._v(" "),_vm._l((_vm.references),function(reference,index){return _c('div',{key:'ref' + index},[(_vm.editAccess || reference.reference_note)?_c('div',[_c('hr',{staticClass:"ref-separator"}),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("\n        "+_vm._s(reference.name)+"\n        "),(_vm.editAccess)?_c('img',{staticClass:"edit-button",attrs:{"src":__webpack_require__(36)},on:{"click":function($event){return _vm.showEditReferenceDialog(reference)}}}):_vm._e()]),_vm._v(" "),(_vm.editAccess)?_c('DetailSectionColumnLayout',{attrs:{"itemPerColumns":[5, 4],"modelData":reference,"labelKey":"labelDetail","listFields":_vm.$store.getters.referenceListFields,"listExcludeFields":['name']}}):_vm._e(),_vm._v(" "),(_vm.adminOrEmployer && reference.reference_note)?_c('div',[_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showViewReferenceInterviewNotesModal(reference)}}},[_vm._v("\n          View Reference Check Notes\n        ")])]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('button',{staticClass:"mylisting-button dark-button mt-4",on:{"click":function($event){return _vm.showReferenceInterviewNotesModal(reference)}}},[_vm._v("\n        Log Reference Check Notes\n      ")]):_vm._e()],1):_vm._e()])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"reference-interview-notes-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Add Reference Interview Notes")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n              p\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n              H1\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n              H2\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n              H3\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n              List\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n              1. 2. 3...\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n              ---\n            ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('reference-interview-notes-modal')}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),(_vm.reference.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.saveReferenceInterviewNotes(_vm.reference)}}},[_vm._v("\n        Save\n      ")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"view-reference-interview-notes-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.reference.reference_note)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$modal.hide('view-reference-interview-notes-modal')}}},[_vm._v("\n        Done\n      ")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"reference-interview-notes-updated-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Reference notes updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$modal.hide('reference-interview-notes-updated-modal')}}},[_vm._v("\n        Done\n      ")])])]),_vm._v(" "),_c('ReferenceFormDialog',{attrs:{"reference":_vm.reference,"user":_vm.user,"isAdd":_vm.isAddReferenceDialog,"isSendRequest":true},on:{"saved":function($event){return _vm.getReferences()}},model:{value:(_vm.isShowReferenceFormDialog),callback:function ($$v) {_vm.isShowReferenceFormDialog=$$v},expression:"isShowReferenceFormDialog"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6a6194e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__ = __webpack_require__(706);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6a6194e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodeOfConduct_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6921b574_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeOfConduct_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodeOfConduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6921b574_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeOfConduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("17736a90", content, true, {});

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Nanny Code of Conduct")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("A. Punctuality and Reliability")]),_vm._v(" "),_c('p',[_vm._v("We value punctuality and reliability above all else. When interviewing with a GCN team member or one of our families, please arrive early or on time. We understand commuting around Chicagoland comes with weather issues, traffic, and parking grievances, so give yourself extra time to accommodate any issues that may arise. GCN understands situations arise, but in general, do not tolerate tardiness or last-minute cancellations.")]),_vm._v(" "),_c('h4',[_vm._v("B. Responsiveness")]),_vm._v(" "),_c('p',[_vm._v("We truly value our nannies and are happy to provide a free service for professional nannies and household managers. We work diligently to find our nannies great positions and for this to work smoothly, we expect our nannies to answer our emails, texts, and/or calls in a reasonable amount of time. The faster we can get ahold of you to schedule interviews and trials, the quicker you will be hired.")]),_vm._v(" "),_c('h4',[_vm._v("C. Transparency")]),_vm._v(" "),_c('p',[_vm._v("The nanny industry is very intimate profession. Our clients trust our judgement when placing people to work in their homes. Because of this, we are very thorough with our reference and background checks. We understand that sometimes former positions may have ended with hard feelings and things from the past surface on background checks. We appreciate when our candidates are honest and transparent from the beginning about anything that will come up during the screening process.")]),_vm._v(" "),_c('h4',[_vm._v("D. Self-Presentation")]),_vm._v(" "),_c('p',[_vm._v("Our families come to us searching for professional, career nannies and other staff to join their household. Please keep this in mind throughout the interview process. We agree that work out clothes are great, but please refrain from wearing them to an interview. Jeans are fine.")]),_vm._v(" "),_c('h4',[_vm._v("E. Contact with Families")]),_vm._v(" "),_c('p',[_vm._v("During the interview and trial process, all communication with our clients should go through a GCN team member. We respect our clients’ privacy, as well as yours, by not giving out nannies or families contact information. Once work agreement is signed, everyone’s contact information will be included at the top of the agreement for your convenience.")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),(!_vm.signature)?_c('label',{staticClass:"mt-1"},[_vm._v("Please type your name.")]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackgroundCheck_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dfa23dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackgroundCheck_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackgroundCheck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dfa23dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackgroundCheck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("e1c5058e", content, true, {});

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('img',{staticClass:"center",staticStyle:{"width":"210px","padding-bottom":"30px"},attrs:{"src":__webpack_require__(74),"alt":""}}),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Background Check Form")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("By filling out this form you are giving Pink Nannies the rights to run a background check.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[(_vm.document.status == 'Unsigned')?_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Full Name (First, Middle and Last)*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field1),expression:"field1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field1=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Date of Birth (MM-DD-YYYY)*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field2),expression:"field2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field2=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field3),expression:"field3"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Street Address"},domProps:{"value":(_vm.field3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field3=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field4),expression:"field4"}],staticClass:"form-control mt-1",attrs:{"type":"text","placeholder":"Address Line 2"},domProps:{"value":(_vm.field4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field4=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field5),expression:"field5"}],staticClass:"form-control mt-1",attrs:{"type":"text","placeholder":"City"},domProps:{"value":(_vm.field5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field5=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field6),expression:"field6"}],staticClass:"form-control mt-1",attrs:{"type":"text","placeholder":"State"},domProps:{"value":(_vm.field6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field6=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field7),expression:"field7"}],staticClass:"form-control mt-1",attrs:{"type":"text","placeholder":"Zip Code"},domProps:{"value":(_vm.field7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field7=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Driver's License Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field8),expression:"field8"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field8=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Social Security Number (SSN)*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field9),expression:"field9"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field9)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field9=$event.target.value}}})]):_vm._e()]),_vm._v(" "),(_vm.document.status == 'Signed')?_c('div',[_c('p',[_vm._v("Name: "+_vm._s(_vm.document.field1))]),_vm._v(" "),_c('p',[_vm._v("Date of Birth: "+_vm._s(_vm.document.field2))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Address:")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.document.field3))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.document.field4))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("City: "+_vm._s(_vm.document.field5))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("State: "+_vm._s(_vm.document.field6))]),_vm._v(" "),_c('p',[_vm._v("Zip Code: "+_vm._s(_vm.document.field7))]),_vm._v(" "),_c('p',[_vm._v("Driver's License Number: "+_vm._s(_vm.document.field8))]),_vm._v(" "),_c('p',[_vm._v("Social Security Number (SSN): "+_vm._s(_vm.document.field9))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),(!_vm.signature)?_c('label',{staticClass:"mt-1"},[_vm._v("Please type your name.")]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature && _vm.field1 && _vm.field2 && _vm.field3 && _vm.field5 && _vm.field6 && _vm.field7 && _vm.field8 && _vm.field9)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CovidPolicies_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400504b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CovidPolicies_vue__ = __webpack_require__(696);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CovidPolicies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400504b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CovidPolicies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("fefd2dca", content, true, {});

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('img',{staticClass:"center",staticStyle:{"width":"210px","padding-bottom":"30px"},attrs:{"src":__webpack_require__(74),"alt":""}}),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Covid-19 Crisis Policies")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Covid-19 Crisis Policies")]),_c('p',[_vm._v("Covid-19 Sub Agreement")]),_c('p',[_vm._v("1. CDC Compliance. The Covid-19 Crisis is ever changing which makes it the sole responsibility of the sitter and the family to ensure they are meeting the CDC guidelines. Pink Nannies has no way of enforcing these guidelines when a sitter is working in a family’s home as we are strictly a referral service. Please continuously be up to date on the regulations and guidelines and follow them to the best of your ability. Hiring a sitter or Nanny through our Nanny Referral Agency in this time of Crisis is completely at your own risk and your own discretion. Please stay up to date on requirements for employers on what is and what is not allowed/legal to ask of your employed sitter/nanny during this crisis time. We can help provide resources upon request, but ultimately it is the employer’s responsibility.")]),_c('p',[_vm._v("1.B. CDC Hygiene Recommendations. As of March 20th, 2020 the CDC website lists the following ways to prevent the spread of this virus: practice good hygiene, no handshakes, don’t touch your face, disinfect surfaces regularly, increase ventilation by opening doors and windows, adhere to social distancing and try to remain 6ft away from others when possible, stay home if you show any signs of being ill, cover coughs and sneezes, wash hands regularly with soap and water for at least 20 seconds and use sanitizer with 60% alcohol or more.")]),_c('p',[_vm._v("1C. Covid-19 Illness Policy. If you are feeling any symptoms of illness during this Covid crisis, contact our Agency to cancel any shifts for confirmed sitters/nannies and stay at home. You are encouraged to take your temperature before the start of every day to ensure you do not have a fever, we encourage our sitters/nannies to do the same. We want to prevent the spread of this virus as best as we can. There will be no repercussions for cancellations during this time of crisis, and any payment made to our Agency can be used as a credit for future bookings for a period up to 6 months or until after the crisis has passed. You are encouraged to know the signs and symptoms of the virus and stay home if you exhibit any of the signs. They include (according to WHO) but are not limited to fever, chills, cough, tiredness/fatigue, and or difficulty breathing. Symptoms can occur 2-14 days after exposure so if you experience any symptoms, alert our Agency immediately so we can inform the sitter/nanny. We will ask our sitters/nannies to do the same and will do our best to inform you if we have knowledge of possible exposure.")]),_c('p',[_vm._v("1D. Virus Prevention Methods. As of March 20th, 2020, the Ohio Department of Health lists the following as precautions to take to prevent the spread of this virus. Stay home if possible, practice social distancing, getting adequate sleep and meals, washing hands with soap and water for 20 seconds or longer, drying hands with a clean towel or air drying, covering mouth with a tissue or sleeve when coughing or sneezing, avoid touching face, clean and disinfect surfaces often, and practice good hygiene habits.")]),_c('p',[_vm._v("1E. Social Distancing. It is currently the recommendation of the CDC and Ohio Department of Health that we practice social distancing. According the CDC this means staying home from work, school and all activities when you are sick with Covid-19 symptoms which may include fever, cough, and difficulty breathing. They also recommend staying away from others who are sick and limiting close contact with others as much as possible (by about 6ft). As of March 20th, 2020, nannies and sitters are still permitted to work in the home of a family pending the nanny/sitter or family do not show any signs of the virus. When you have a sitter or nanny working in your home, please be respectful by following these guidelines in order to prevent the spread of this virus to others.")]),_c('p',[_vm._v("2.Exposure. Pink Nannies in no way is responsible or liable for preventing the spread of this illness/virus. Any positions you book either temporary or long term are at your own risk as a family/client. We have no control over what a nanny or sitter does in her spare time or if she is following the guidelines set in this agreement. You are free to accept or decline any shifts or positions, nothing is mandatory. If you exhibit any symptoms or suspect a sitter or nanny you are working with has any symptoms please alert us immediately. If your nanny unexpectedly calls off due to exposure of the virus or symptoms, please alert us and we will make every reasonable effort to replace her. We cannot make any guarantees.")]),_c('p',[_vm._v("3.Policies. All other policies located in our Agency Agreement and Fees and Policies Agreement still apply.")]),_c('p',[_vm._v("4. Limited Interaction. In efforts to do our best as an Agency to prevent the spread of this virus, we have decided to temporarily switch all of our interviews to an online platform. This includes interaction with Clients as well as all of our Nanny/Sitter/Tutor interviews. No in person interactions will be conducted until quarantines, bans, and social distancing has been lifted.")]),_c('p',[_vm._v("5. Potential” Shelter in Place” Policy. In the event Ohio invokes a ”Shelter In Place” policy, it is our understanding that nannies are still allowed to work for families that have careers that are “essential“ such as healthcare and safety workers. This will still be at the discretion of the Sitter and the Client together to agree upon as no positions are mandatory and are solely volunteer based. Please keep us informed of any decisions made on confirmed or declined positions due to this virus or this potential Shelter in Place Policy.")]),_c('p',[_vm._v("Please sign below stating you understand and agree to all above terms. Please understand that as an Agency we are doing everything we can to support families in need during this crisis, while still respectfully attempting to follow all CDC guidelines and recommendations. We cannot be liable for the spread of this illness in any way and booking a sitter or nanny in this crisis is completely at your own risk and discretion as a family. Thank you!")]),_c('p'),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),(!_vm.signature)?_c('label',{staticClass:"mt-1"},[_vm._v("Please type your name.")]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DistractedDriving_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25eca02d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DistractedDriving_vue__ = __webpack_require__(700);
function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DistractedDriving_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25eca02d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DistractedDriving_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(699);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("41e5d424", content, true, {});

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('img',{staticClass:"center",staticStyle:{"width":"210px","padding-bottom":"30px"},attrs:{"src":__webpack_require__(74),"alt":""}}),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Distracted Driving Policy")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("PINK Nannies is committed to ending the epidemic of distracted driving, and has created the following rules, which apply to any nanny operating their personal vehicle or a family’s vehicle while children are in the car:")]),_c('p',[_vm._v("• Nannies may not use a hand-held cell phone while operating a vehicle – whether the vehicle is in motion or stopped at a traffic light. This includes, but is not limited to, adjusting a Global Positioning System (GPS), answering or making phone calls, engaging in phone conversations, and reading or responding to emails, instant messages, and text messages.")]),_c('p',[_vm._v("• If a nanny needs to use their phone, they must pull over safely to the side of the road or another safe location.")]),_c('p',[_vm._v("• Additionally, nannies are required to:")]),_c('p',[_vm._v("o Turn cell phones off or put them on silent or vibrate before starting the car.")]),_c('p',[_vm._v("o Consider modifying voice mail greetings to indicate that you are unavailable to answer calls or return messages while driving.")]),_c('p',[_vm._v("o Inform friends and family of this policy as an explanation of why calls may not be returned immediately.")]),_c('p',[_vm._v("Violations of this policy will be considered serious and may result in the imposition of discipline up to and including termination. I acknowledge that I have received a written copy of the Distracted Driving Policy, that I fully understand the terms of this policy, that I agree to abide by these terms, and that I am willing to accept the consequences of failing to follow the policy.")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),(!_vm.signature)?_c('label',{staticClass:"mt-1"},[_vm._v("Please type your name.")]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NannyHandbook_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6bed32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NannyHandbook_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NannyHandbook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6bed32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NannyHandbook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(703);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6540e970", content, true, {});

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('img',{staticClass:"center",staticStyle:{"width":"210px","padding-bottom":"30px"},attrs:{"src":__webpack_require__(74),"alt":""}}),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Nanny Handbook")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),(!_vm.signature)?_c('label',{staticClass:"mt-1"},[_vm._v("Please type your name.")]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('img',{staticClass:"center",attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"width":"","height":_vm.$store.getters.logoHeight,"alt":_vm.$store.getters.agencyHumanName,"id":"ignorePDF"}}),_vm._v(" "),_c('h3',{staticClass:"mt-3",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.document.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('div',{staticClass:"mb-2"},[_c('h3',{staticStyle:{"margin-bottom":"-10px"}},[_vm._v("Admin Only")]),_vm._v(" "),_vm._l((_vm.document.fields_labels),function(field,index){return _c('div',{key:'Field'+index,staticClass:"field-of-fields"},[_c('label',[_vm._v(_vm._s(field)),(_vm.document.fields_required[index] === true)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fields[index]),expression:"fields[index]"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.fields[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fields, index, $event.target.value)}}})])}),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3 mb-3",on:{"click":function($event){return _vm.save()}}},[_vm._v("Update")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('hr')],2):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('div',[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.documentBody)}})]):_c('div',[((_vm.document.status == 'Unsigned' || _vm.document.status == 'Saved') && (_vm.$store.getters.isAgent === true || (_vm.document.edit_access != 'Admin' && _vm.document.signing_user == _vm.user.id)))?_c('div',[(_vm.fields.length)?_c('div',_vm._l((_vm.document.fields_labels),function(field,index){return _c('div',{key:'Field'+index,staticClass:"field-of-fields"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.documentBody[index])}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fields[index]),expression:"fields[index]"}],staticClass:"form-control",attrs:{"rows":"1"},domProps:{"value":(_vm.fields[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fields, index, $event.target.value)}}}),_vm._v(" "),(index == (_vm.fields.length - 1))?_c('pre',{domProps:{"innerHTML":_vm._s(_vm.documentBody[index+1])}}):_vm._e()])}),0):_c('div',[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.documentBody)}})])]):_c('div',[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.documentBody)}})])]),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('div',{staticClass:"mb-5"},[_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.save()}}},[_vm._v("Update")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.document.signer_labels),function(signer_label,index){return _c('div',{key:'Signer'+index},[_c('p',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v(_vm._s(signer_label))]),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signatures[index])?_c('h2',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signatures[index]))]):_vm._e(),_vm._v(" "),(!_vm.signatures[index])?_c('h4',[_vm._v("___________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signers[index]))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signatures[index]),expression:"signatures[index]"}],staticClass:"form-control",staticStyle:{"max-width":"700px"},attrs:{"type":"text"},domProps:{"value":(_vm.signatures[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signatures, index, $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v("Please type your name to sign (you agree that this constitutes the equivalent of signing a physical document)")])]):_vm._e()])}),_vm._v(" "),(_vm.document.signer_labels.length)?_c('div',[(_vm.allSigned)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.document.signer_labels.length)?_c('div',[_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])]):_vm._e(),_vm._v(" "),(_vm.template.organization_signer)?_c('div',[_c('p',{staticStyle:{"font-weight":"600","margin-top":"25px","margin-bottom":"0"}},[_vm._v(_vm._s(_vm.$store.getters.agencyHumanName))]),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.organization_signer)?_c('h2',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.document.organization_signer))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Per: "+_vm._s(_vm.document.organization_signer))])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Documents")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.editAccess)?_c('button',{staticClass:"mylisting-button dark-button mb-3",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("\n    Upload Documents\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.editAccess)?_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("CPR & First Aid"),(_vm.user.file2)?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(_vm.user.file2)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.user.file2,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]):_c('div',{},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("Upload")])])])]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("Resume"),(_vm.user.resume)?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(_vm.user.resume)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.user.resume,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]):_c('div',{},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("Upload")])])])]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("State ID"),(_vm.user.file3)?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(_vm.user.file3)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.user.file3,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]):_c('div',{},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("Upload")])])])]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("Educational Certification"),(_vm.user.file4)?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(_vm.user.file4)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.user.file4,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]):_c('div',{},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("Upload")])])])]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("Trustline"),(_vm.user.file1)?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(_vm.user.file1)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.user.file1,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]):_c('div',{},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("Upload")])])])]):_vm._e(),_vm._v(" "),(_vm.user.file5 && (_vm.$store.getters.isAgent === true || _vm.$store.getters.isEmployer === true))?_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("Background Check"),(_vm.user.file5)?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(_vm.user.file4)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.user.file5,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isAgent === true && !_vm.user.file5)?_c('div',{},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUploadDocumentsModal()}}},[_vm._v("Upload")])]):_vm._e()])]):_vm._e()]),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"row"},[(_vm.documents.length)?_c('div',{staticClass:"col-lg-12"},[_c('h4',{staticClass:"mt-3"},[_vm._v("Sign Documents")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.documents),function(document){return _c('div',{key:document.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[(!document.template)?_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(document.title)),(document.status == 'Signed')?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(document.title == 'Code of Conduct' && document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showCodeOfConductModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.title == 'Code of Conduct' && document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showCodeOfConductModal(document)}}},[_vm._v("View")]):_vm._e(),_vm._v(" "),(document.title == 'Background Check' && document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showBackgroundCheckModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.title == 'Background Check' && document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showBackgroundCheckModal(document)}}},[_vm._v("View")]):_vm._e(),_vm._v(" "),(document.title == 'Nanny Handbook' && document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showNannyHandbookModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.title == 'Nanny Handbook' && document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showNannyHandbookModal(document)}}},[_vm._v("View")]):_vm._e(),_vm._v(" "),(document.title == 'Distracted Driving' && document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showDistractedDrivingModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.title == 'Distracted Driving' && document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showDistractedDrivingModal(document)}}},[_vm._v("View")]):_vm._e(),_vm._v(" "),(document.title == 'Covid Policies' && document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showCovidPoliciesModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.title == 'Covid Policies' && document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showCovidPoliciesModal(document)}}},[_vm._v("View")]):_vm._e()]):_vm._e(),_vm._v(" "),(document.template)?_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(document.title)),(document.status == 'Signed')?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showDocumentModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showDocumentModal(document)}}},[_vm._v("View")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('p',{staticClass:"delete-text mt-2",on:{"click":function($event){return _vm.showDeleteDocumentModal(document)}}},[_vm._v("Delete")]):_vm._e()])])}),_vm._v(" "),(_vm.files.length)?_c('div',{staticClass:"col-lg-12 mt-3"},[_c('h4',[_vm._v("Additional Documents")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.files),function(file){return _c('div',{key:file.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('a',{attrs:{"href":file.file_link,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]),_vm._v(" "),_c('p',{staticClass:"delete-text mt-3",on:{"click":function($event){return _vm.showDeleteFileModal(file)}}},[_vm._v("Remove File")])])])}),_vm._v(" "),_c('div',{staticClass:"col-lg-12 mt-3"},[(_vm.editAccess)?_c('button',{staticClass:"mylisting-button dark-button mb-3",on:{"click":function($event){return _vm.showUploadFileModal()}}},[_vm._v("Upload Additional Documents")]):_vm._e()])],2):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"code-of-conduct-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('code-of-conduct',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('code-of-conduct-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"background-check-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('background-check',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('background-check-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"nanny-handbook-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('nanny-handbook',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('nanny-handbook-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"distracted-driving-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('distracted-driving',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('distracted-driving-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"covid-policies-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('covid-policies',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('covid-policies-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"document-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('document',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('document-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"document-signed-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Your document has been signed.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('document-signed-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"upload-documents-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Upload Documents")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("You don't need to upload them all at once.")]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-lg-4"},[_c('label',{},[_vm._v("CPR & First Aid*")]),_vm._v(" "),_c('input',{ref:"file2",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"file2"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{},[_vm._v("State ID*")]),_vm._v(" "),_c('input',{ref:"file3",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"resume"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{},[_vm._v("Educational Certification*")]),_vm._v(" "),_c('input',{ref:"file4",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"resume"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{},[_vm._v("Resume")]),_vm._v(" "),_c('input',{ref:"resume",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"resume"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{},[_vm._v("Trustline (California Only)")]),_vm._v(" "),_c('input',{ref:"file1",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"file1"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('div',{staticClass:"col-lg-4"},[_c('label',{},[_vm._v("Background Check")]),_vm._v(" "),_c('input',{ref:"file5",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"resume"},on:{"change":function($event){return _vm.handleFileUpload()}}})]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('upload-documents-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.uploadDocuments()}}},[_vm._v("Upload")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"documents-uploaded-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Documents uploaded.")]),_vm._v(" "),_c('p',[_vm._v("It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('documents-uploaded-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-document-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('h3',[_vm._v("Are you sure you want to delete the document "+_vm._s(_vm.document.title)+"?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-document-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteDocument(_vm.document)}}},[_vm._v("Delete Document")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"upload-file-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('h3',[_vm._v("Upload any additional files such as additional resumes, letters of recommendation, educational certificates, etc.")]),_vm._v(" "),_c('label',{},[_vm._v("File Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileName),expression:"fileName"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":"What name do you want to appear with this file?"},domProps:{"value":(_vm.fileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fileName=$event.target.value}}}),_vm._v(" "),_c('input',{ref:"file",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.handleSingleFileUpload()}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('upload-file-modal')}}},[_vm._v("Close")]),_vm._v(" "),(_vm.fileName && _vm.file)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.uploadFile()}}},[_vm._v("Upload File")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-file-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('h3',[_vm._v("Are you sure you want to delete the file "+_vm._s(_vm.selectedFile.name)+"?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-file-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteFile(_vm.selectedFile)}}},[_vm._v("Delete File")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotesForm_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93b242e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotesForm_vue__ = __webpack_require__(708);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93b242e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Edit Notes")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0px"}}),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-2"},[_vm._v("Only admins and clients you share this profile with can see this.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"rows":"10"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mt-3",on:{"click":function($event){return _vm.$emit('infoSaved')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.update()}}},[_vm._v("Update")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experiences_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9864174_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experiences_vue__ = __webpack_require__(710);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experiences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9864174_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experiences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Experience\n    "),(_vm.editAccess)?_c('span',{staticStyle:{"float":"right","cursor":"pointer"},on:{"click":function($event){return _vm.showExperienceModal()}}},[_vm._v("+")]):_vm._e()]),_vm._v(" "),(_vm.experiences.length < 3 && _vm.editAccess)?_c('small',[_vm._v("Please list at least 3 previous childcare experiences. This is very important, it will make up your digital profile/resume that families see!")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.experiences),function(experience){return _c('div',{key:experience.id},[_c('h5',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(experience.title)),(_vm.editAccess)?_c('img',{staticStyle:{"float":"right","cursor":"pointer"},attrs:{"src":__webpack_require__(36),"alt":"","width":"16px"},on:{"click":function($event){return _vm.showExperienceModal(experience)}}}):_vm._e()]),_vm._v(" "),(experience.start_date && experience.end_date && !experience.current_role)?_c('p',[_vm._v(_vm._s(_vm.monthsShort[(new Date(experience.start_date)).getMonth()])+" "+_vm._s((new Date(experience.start_date)).getFullYear())+" - "+_vm._s(_vm.monthsShort[(new Date(experience.end_date)).getMonth()])+" "+_vm._s((new Date(experience.end_date)).getFullYear()))]):_vm._e(),_vm._v(" "),(experience.current_role)?_c('p',[(experience.start_date)?_c('span',[_vm._v(_vm._s(_vm.monthsShort[(new Date(experience.start_date)).getMonth()])+" "+_vm._s((new Date(experience.start_date)).getFullYear())+" - ")]):_vm._e(),_vm._v("Present")]):_vm._e(),_vm._v(" "),(experience.city || experience.country)?_c('small',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(experience.city)+", "+_vm._s(experience.country))]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 mb-4"},[(experience.note)?_c('label',[_vm._v("Expectations: list of expectations I had while working with this family")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(experience.note))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[(experience.text1)?_c('label',[_vm._v("Number of Children Cared for")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(experience.text1))]),_vm._v(" "),(experience.text2)?_c('label',[_vm._v("Ages of Children")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(experience.text2))]),_vm._v(" "),(experience.text3)?_c('label',[_vm._v("Years Worked With Them")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(experience.text3))]),_vm._v(" "),(experience.text4)?_c('label',[_vm._v("How Frequently I Worked For Them")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(experience.text4))])])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"experience-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[(!_vm.experience.id)?_c('h3',[_vm._v("Add Experience")]):_vm._e(),_vm._v(" "),(_vm.experience.id)?_c('h3',[_vm._v("Edit Experience - "+_vm._s(_vm.experience.title))]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 px-4"},[_c('label',[_vm._v("Position")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Currently in this role?")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentRole),expression:"currentRole"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.currentRole)?_vm._i(_vm.currentRole,true)>-1:(_vm.currentRole)},on:{"change":function($event){var $$a=_vm.currentRole,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentRole=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentRole=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentRole=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"margin-top":"1px"}},[_vm._v("\n                  Yes\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startMonth),expression:"startMonth"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthsNumeric),function(month,index){return _c('option',{key:'experienceStartMonth'+index},[_vm._v(_vm._s(month))])}),0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startYear),expression:"startYear"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"YYYY"},domProps:{"value":(_vm.startYear)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startYear=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),(!_vm.currentRole)?_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endMonth),expression:"endMonth"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthsNumeric),function(month,index){return _c('option',{key:'experienceStartMonth'+index},[_vm._v(_vm._s(month))])}),0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endYear),expression:"endYear"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"YYYY"},domProps:{"value":(_vm.endYear)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endYear=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.currentRole)?_c('p',{staticClass:"mt-1"},[_vm._v("Present")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country),expression:"country"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.$store.getters.countries),function(country,index){return _c('option',{key:'countrySelection'+index},[_vm._v(_vm._s(country))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 px-4"},[_c('label',[_vm._v("Number of Children Cared for*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numChildren),expression:"numChildren"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.numChildren)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numChildren=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Ages of Children When Hired*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageChildren),expression:"ageChildren"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.ageChildren)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ageChildren=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Specific Number of Years Worked With Them*")]),_vm._v(" "),_c('small',{staticClass:"mb-1",staticStyle:{"display":"block"}},[_vm._v("Ex. 3 years, 2012-2015")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.years),expression:"years"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.years)},on:{"input":function($event){if($event.target.composing){ return; }_vm.years=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("How Frequently Did You Work For Them?*")]),_vm._v(" "),_c('small',{staticClass:"mb-1",staticStyle:{"display":"block"}},[_vm._v("Ex. Casual Babysitting 1-2x/month, Part-time Nanny 3 days/week")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.frequency),expression:"frequency"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.frequency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.frequency=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Expectations: list of expectations you had while working with this family")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":""},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideExperienceModal()}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.experience.id)?_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.showDeleteExperienceModal()}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(!_vm.experience.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.postExperience()}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.experience.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateExperience(_vm.experience)}}},[_vm._v("Save")]):_vm._e()])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-experience-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Are you sure you want to delete this experience?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-experience-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.experience.id)?_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteExperience(_vm.experience)}}},[_vm._v("Delete")]):_vm._e()])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonalSummaryForm_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b958aa4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonalSummaryForm_vue__ = __webpack_require__(712);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonalSummaryForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b958aa4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonalSummaryForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Edit Personal Summary")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0px"}}),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-2"},[_vm._v("Sell yourself! This is what families will be seeing! What makes you great?")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"rows":"10"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mt-3",on:{"click":function($event){return _vm.$emit('infoSaved')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.update()}}},[_vm._v("Update")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-tile"},[_c('div',{staticClass:"field-of-fields"},[_c('h3',[_vm._v("Feedback")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticClass:"top-label"},[_vm._v("Do you have any feedback on our website and your dashboard and how we can improve your experience? Please let us know!")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.body),expression:"body"}],staticClass:"form-control",attrs:{"rows":"3","placeholder":"If something is not working or you have ideas how to make it better, what you like, dislike, design, general thoughts, anything, we'd love to hear from you. (:"},domProps:{"value":(_vm.body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.body=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("How would you rate your experience? (5 being the best, 1 the worst)")]),_vm._v(" "),_vm._l((_vm.ratingOptions),function(ratingOption,index){return _c('div',{key:'rating'+index,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rating),expression:"rating"}],staticClass:"form-check-input",attrs:{"type":"radio","id":'rating'+index},domProps:{"value":ratingOption,"checked":_vm._q(_vm.rating,ratingOption)},on:{"change":function($event){_vm.rating=ratingOption}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":'rating'+index}},[_vm._v("\n        "+_vm._s(ratingOption)+"\n      ")])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-2",on:{"click":function($event){return _vm.submitFeedback()}}},[_vm._v("Submit Feedback")])],2),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"feedback-submitted-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("We have received your feedback!")]),_vm._v(" "),_c('h4',[_vm._v("Thank you so much, we really appreciate it and will work hard to keep improving your experience. If you have any additional thoughts now or in the future, please don't hesitate to share them!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('feedback-submitted-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('div',{staticClass:"profile"},[_c('div',{staticClass:"profile-tile",staticStyle:{"margin-top":"20px"}},[_c('basic-info',{attrs:{"user":_vm.user},on:{"editBasicInfo":function($event){return _vm.editBasicInfo()}}})],1),_vm._v(" "),_c('div',{staticClass:"profile-tile"},[_c('h3',{},[_vm._v("Personal Summary\n      "),(_vm.editAccess)?_c('span',{staticStyle:{"cursor":"pointer","float":"right"}},[_c('button',{staticClass:"btn btn-light",on:{"click":function($event){return _vm.editPersonalSummary()}}},[_vm._v("Edit")])]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.user.text15)?_c('pre',[_vm._v(_vm._s(_vm.user.text15))]):_vm._e(),_vm._v(" "),(!_vm.user.text15 && _vm.editAccess)?_c('p',[_vm._v("Please write your personal summary! Sell yourself, what makes you great? This is what families will see!")]):_vm._e()]),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"profile-tile"},[_c('h3',{},[_vm._v("Professional Information\n      "),(_vm.editAccess)?_c('img',{staticClass:"mb-1 ml-1",staticStyle:{"cursor":"pointer","float":"right"},attrs:{"src":__webpack_require__(36),"alt":"","width":"16px"},on:{"click":function($event){return _vm.editProfessionalInfo()}}}):_vm._e()]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0px"}}),_vm._v(" "),_c('professional-info',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"profile-tile"},[(_vm.user.id)?_c('div',[_c('references',{attrs:{"user":_vm.user}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"profile-tile"},[(_vm.user.id)?_c('div',[_c('experiences',{attrs:{"user":_vm.user}})],1):_vm._e()]),_vm._v(" "),(_vm.editAccess)?_c('div',{staticClass:"profile-tile"},[(_vm.user.id)?_c('div',[_c('documents',{attrs:{"user":_vm.user},on:{"infoSaved":function($event){return _vm.infoSaved()}}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminOrEmployer)?_c('div',{staticClass:"profile-tile"},[_c('h3',{},[_vm._v("Agency Notes\n      "),(_vm.$store.getters.isAgent === true)?_c('img',{staticClass:"mb-1 ml-1",staticStyle:{"cursor":"pointer","float":"right"},attrs:{"src":__webpack_require__(36),"alt":"","width":"16px"},on:{"click":function($event){return _vm.editNotes()}}}):_vm._e()]),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('strong',[_vm._v("Please keep in mind that clients will see these notes!")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text20))])]):_vm._e(),_vm._v(" "),(_vm.user.status == 'Interview Complete' && _vm.editAccess)?_c('div',[_c('button',{staticClass:"mylisting-button dark-button center mt-5",staticStyle:{"text-transform":"uppercase"},on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("My profile is complete!")])]):_vm._e(),_vm._v(" "),(_vm.user.id && !_vm.$store.getters.isAgent)?_c('div',[_c('feedback',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"basic-info-modal","width":"90%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('basic-info-form',{attrs:{"user":_vm.user},on:{"basicInfoSaved":function($event){return _vm.basicInfoSaved()}}})],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"personal-summary-modal","width":"90%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('personal-summary-form',{attrs:{"user":_vm.user},on:{"infoSaved":function($event){return _vm.infoSaved()}}})],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"professional-info-modal","width":"90%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('professional-info-form',{attrs:{"user":_vm.user},on:{"infoSaved":function($event){return _vm.infoSaved()}}})],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"desired-role-modal","width":"90%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('desired-role-form',{attrs:{"user":_vm.user},on:{"infoSaved":function($event){return _vm.infoSaved()}}})],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"notes-modal","width":"90%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('notes-form',{attrs:{"user":_vm.user},on:{"infoSaved":function($event){return _vm.infoSaved()}}})],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"completed-application-modal","width":"60%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Thank you!")]),_vm._v(" "),_c('p',[_vm._v("We will review your profile and be in touch with you soon.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('completed-application-modal')}}},[_vm._v("Close")])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyJobs_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b92df8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyJobs_vue__ = __webpack_require__(716);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyJobs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b92df8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyJobs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"web-only table table-striped mt-2 mb-5"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.jobs),function(job){return _c('tr',{key:job.id,staticStyle:{"cursor":"pointer"}},[_c('td',[_vm._v(_vm._s(new Date(job.date).toDateString()))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(job.poster_name))]),_vm._v(" "),_c('td',[(job.status == 'Approved')?_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.start_time)))]):_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.actual_start_time)))])]),_vm._v(" "),_c('td',[(job.status == 'Approved')?_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.end_time)))]):_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.actual_end_time)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(job.status))]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{ name: 'Job', params: { id: job.id } },"target":"_blank"}},[_vm._v("View Job Listing")]),_vm._v(" "),(job.status == 'Approved')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showClockInModal(job)}}},[_vm._v("Clock In")]):_vm._e(),_vm._v(" "),(job.status == 'In Progress')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showClockOutModal(job)}}},[_vm._v("Clock Out")]):_vm._e()],1)])}),0)]),_vm._v(" "),_vm._l((_vm.jobs),function(job){return _c('div',{key:job.id,staticClass:"mobile-only mt-3"},[_c('h4',[_vm._v(_vm._s(job.poster_name)+" - "+_vm._s(new Date(job.date).toDateString()))]),_vm._v(" "),_c('hr'),_vm._v(" "),(job.status == 'Approved')?_c('p',[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(job.start_time)))]):_c('p',[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(job.actual_start_time)))]),_vm._v(" "),(job.status == 'Approved')?_c('p',[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(job.end_time)))]):_c('p',[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(job.actual_end_time)))]),_vm._v(" "),(job.text)?_c('pre',[_vm._v("Special Notes: "+_vm._s(job.text))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_vm._v("Current Status: "+_vm._s(job.status))]),_vm._v(" "),_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{ name: 'Job', params: { id: job.id } },"target":"_blank"}},[_vm._v("View Job Listing")]),_vm._v(" "),(job.status == 'Approved')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showClockInModal(job)}}},[_vm._v("Clock In")]):_vm._e(),_vm._v(" "),(job.status == 'In Progress')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showClockOutModal(job)}}},[_vm._v("Clock Out")]):_vm._e(),_vm._v(" "),_c('hr')],1)}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"clockin-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Ready to Begin?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("Family: "+_vm._s(_vm.job.poster_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date().toDateString()))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.formatAMPM( _vm.currentTime )))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control mt-3",attrs:{"rows":"5","placeholder":"Any notes?"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mb-2",on:{"click":function($event){return _vm.$modal.hide('clockin-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.clockin()}}},[_vm._v("Clock In")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"clockout-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Finished?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("Family: "+_vm._s(_vm.job.poster_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date().toDateString()))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.formatAMPM( _vm.currentTime )))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control mt-3",attrs:{"rows":"5","placeholder":"Any notes?"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mb-2",on:{"click":function($event){return _vm.$modal.hide('clockout-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.clockout()}}},[_vm._v("Clock Out")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"successful-clockin-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Thanks!")]),_vm._v(" "),_c('h5',[_vm._v("Hope the job goes well, don't forget to clock out when you are finished!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mb-2",on:{"click":function($event){return _vm.$modal.hide('successful-clockin-modal')}}},[_vm._v("Done")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"successful-clockout-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Thanks!")]),_vm._v(" "),_c('h5',[_vm._v("If there were any issues with recording the time, or anything else, please let us know.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mb-2",on:{"click":function($event){return _vm.$modal.hide('successful-clockout-modal')}}},[_vm._v("Done")])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--nannycogreen)","color":"#fff"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Family")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Start Time")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("End Time")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(718);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("47083f6a", content, true, {});

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".job-listing-tile{padding:22px 20px 20px}", ""]);

// exports


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"profile-form"},[_c('div',{staticClass:"mb-2",class:{ invalid: _vm.$v.title.$error }},[_c('label',[_vm._v("Title*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),(_vm.$v.title.$error)?_c('small',[_vm._v("Job title is required.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n                H1\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n                H2\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n                H3\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n                List\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n                1. 2. 3...\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n                ---\n              ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Key Skills")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.skillsOptions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Select Skills"},model:{value:(_vm.skills),callback:function ($$v) {_vm.skills=$$v},expression:"skills"}}),_vm._v(" "),_c('label',[_vm._v("Topic Areas")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.focusAreaOptions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Select Topic Areas"},model:{value:(_vm.focusAreas),callback:function ($$v) {_vm.focusAreas=$$v},expression:"focusAreas"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Job Type*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.jobType),expression:"jobType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.jobType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.jobTypeOptions),function(jobType,index){return _c('option',{key:'SelectJobType'+index},[_vm._v(_vm._s(jobType))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Compensation Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.compensationType),expression:"compensationType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.compensationType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.compensationTypeOptions),function(compensationType,index){return _c('option',{key:'SelectCompType'+index},[_vm._v(_vm._s(compensationType))])}),0),_vm._v(" "),_c('label',[_vm._v("Compensation Range")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.compensation),expression:"compensation"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.compensation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.compensation=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Application Deadline")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"placeholder":""},model:{value:(_vm.applicationDeadline),callback:function ($$v) {_vm.applicationDeadline=$$v},expression:"applicationDeadline"}}),_vm._v(" "),_c('label',[_vm._v("Application Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.applicationLink),expression:"applicationLink"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.applicationLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.applicationLink=$event.target.value}}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1),expression:"address1"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address1=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address2),expression:"address2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address2=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Postal/Zip Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Province/State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.provinceState),expression:"provinceState"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.provinceState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.provinceState=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country),expression:"country"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.countries),function(country,index){return _c('option',{key:'countrySelection'+index},[_vm._v(_vm._s(country))])}),0)])]),_vm._v(" "),(!_vm.jobID)?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){$event.preventDefault();return _vm.post('live')}}},[_vm._v("Post")]):_vm._e(),_vm._v(" "),(_vm.jobID)?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){$event.preventDefault();return _vm.update()}}},[_vm._v("Save Changes")]):_vm._e(),_vm._v(" "),(_vm.jobID && this.jobToEdit.status === 'draft')?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){$event.preventDefault();return _vm.update('live')}}},[_vm._v("Post Job Live")]):_vm._e(),_vm._v(" "),(!_vm.jobID)?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){$event.preventDefault();return _vm.post('draft')}}},[_vm._v("Save as Draft")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-deck"},_vm._l((_vm.filteredJobs),function(job){return _c('div',{key:job.id,staticClass:"col-lg-4 mb-5"},[_c('div',{staticClass:"card h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"object-fit":"cover"},attrs:{"height":"250px","src":job.file1,"alt":"Card image cap"}}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"var(--coredarkcolor)"},attrs:{"to":{ name: 'Job', params: { id: job.id } }}},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(job.title))])]),_vm._v(" "),(job.date)?_c('p',[_vm._v("Start Date: "+_vm._s(new Date(_vm.addCurrentTimeToDate(job.date)).toDateString()))]):_vm._e(),_vm._v(" "),(job.text)?_c('p',[_vm._v("Schedule: "+_vm._s(job.text))]):_vm._e(),_vm._v(" "),(job.city || job.provincestate || job.postal_code)?_c('p',[_vm._v("Location: "),(job.city)?_c('span',[_vm._v(_vm._s(job.city)+", ")]):_vm._e(),(job.provincestate)?_c('span',[_vm._v(_vm._s(job.provincestate)+", ")]):_vm._e(),_vm._v(_vm._s(job.postal_code))]):_vm._e(),_vm._v(" "),(job.compensation)?_c('p',[_vm._v("Compensation: "+_vm._s(job.compensation))]):_vm._e()],1),_vm._v(" "),_c('router-link',{staticStyle:{"text-decoration":"none","color":"var(--coredarkcolor)"},attrs:{"to":{ name: 'Job', params: { id: job.id } }}},[_c('div',{staticClass:"card-footer"},[_c('small',{staticClass:"center"},[_vm._v("Read More")])])])],1)])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapBoard_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb586f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapBoard_vue__ = __webpack_require__(722);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb586f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.itemLocations[0])?_c('div',[_vm._v("\n    "+_vm._s(_vm.itemLocations)+"\n    "),_c('hr'),_vm._v(" "),_vm._v("\n    "+_vm._s(_vm.showMarkers)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.items)?_c('div',{staticStyle:{"height":"400px","width":"100%"},attrs:{"id":"map"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("42c0df0e", content, true, {});

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "@media (max-width:765px){.grouped-buttons{display:flex;flex-direction:column-reverse;align-items:center}}", ""]);

// exports


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.locationObject.city)?_c('div',{staticStyle:{"height":"250px","width":"100%"},attrs:{"id":"map"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-of-fields container top-level-div",staticStyle:{"max-width":"1000px"}},[(_vm.job.id)?_c('div',[(_vm.job.status == 'Approved')?_c('div',[(_vm.job.filler == _vm.$store.getters.userID)?_c('h3',[_vm._v("Thanks for filling this job!")]):_c('h3',[_vm._v("This job has been filled.")]),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),(_vm.job.job_type == 'Long Term')?_c('h4',{staticClass:"center mb-3"},[_vm._v(_vm._s(_vm.job.title))]):_vm._e(),_vm._v(" "),(_vm.job.job_type == 'Short Term')?_c('h4',[_vm._v(_vm._s(new Date(this.addCurrentTimeToDate(_vm.job.date)).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.job.file1)?_c('img',{attrs:{"src":_vm.job.file1,"alt":"","width":"100%;"}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.job.date)?_c('p',[_vm._v("Start Date: "+_vm._s(new Date(_vm.addCurrentTimeToDate(_vm.job.date)).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.job.city || _vm.job.provincestate || _vm.job.postal_code)?_c('p',[_vm._v("Location: "),(_vm.job.city)?_c('span',[_vm._v(_vm._s(_vm.job.city)+", ")]):_vm._e(),(_vm.job.provincestate)?_c('span',[_vm._v(_vm._s(_vm.job.provincestate)+", ")]):_vm._e(),_vm._v(_vm._s(_vm.job.postal_code))]):_vm._e(),_vm._v(" "),(_vm.job.compensation)?_c('p',[_vm._v("Compensation: "+_vm._s(_vm.job.compensation))]):_vm._e(),_vm._v(" "),(_vm.job.text)?_c('p',[_vm._v("Schedule: "+_vm._s(_vm.job.text))]):_vm._e(),_vm._v(" "),_c('pre',{staticClass:"mt-2",domProps:{"innerHTML":_vm._s(_vm.job.description)}}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.job.city)?_c('app-map',{staticClass:"mt-2",attrs:{"locationObject":_vm.job}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.$store.getters.userID)?_c('div',[_c('p',[_vm._v("Don't have a nanny profile?")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('router-link',{staticClass:"mylisting-button dark-button mb-2",attrs:{"to":{ name: 'Candidate Application Form' }}},[_vm._v("Apply Now!")])],1)]):_vm._e(),_vm._v(" "),((_vm.job.status == 'Requested' || _vm.job.status == 'Pending') && _vm.job.job_type == 'Short Term')?_c('div',[(_vm.$store.getters.isCandidate === true && _vm.loggedinUser.status == 'Accepted')?_c('div',{staticClass:"grouped-buttons"},[(!_vm.application.id)?_c('div',{staticClass:"grouped-buttons"},[_c('button',{staticClass:"mylisting-button danger-button mb-3",on:{"click":function($event){return _vm.setApplicationStatus('Not Interested')}}},[_vm._v("I'M NOT INTERESTED")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mb-3",on:{"click":function($event){return _vm.setApplicationStatus('Maybe')}}},[_vm._v("I MIGHT BE INTERESTED")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-3",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.setApplicationStatus('Interested')}}},[_vm._v("I'M INTERESTED")])]):_vm._e(),_vm._v(" "),(_vm.application.status == 'Not Interested')?_c('h5',[_vm._v("Thanks for letting us know you aren't interested.")]):_vm._e(),_vm._v(" "),(_vm.application.status == 'Maybe')?_c('h5',[_vm._v("Thanks for letting us know you might be interested, we'll be in touch if necessary!")]):_vm._e(),_vm._v(" "),(_vm.application.status == 'Interested')?_c('h5',[_vm._v("Thanks for letting us know you are interested, we'll be in touch if it's a good fit!")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.job.status != 'Approved' && _vm.job.job_type == 'Long Term')?_c('div',[(_vm.$store.getters.isCandidate === true && _vm.loggedinUser.status != 'Rejected')?_c('div',[(!_vm.application.id)?_c('div',{staticClass:"grouped-buttons"},[_c('button',{staticClass:"mylisting-button danger-button mb-3",on:{"click":function($event){return _vm.submitApplication('Not Interested')}}},[_vm._v("I'M NOT INTERESTED")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button mb-3",on:{"click":function($event){return _vm.submitApplication('Maybe')}}},[_vm._v("I MIGHT BE INTERESTED")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-3",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitApplication('Interested')}}},[_vm._v("I'M INTERESTED")])]):_vm._e(),_vm._v(" "),(_vm.application.status == 'Not Interested')?_c('h5',[_vm._v("Thanks for letting us know you aren't interested.")]):_vm._e(),_vm._v(" "),(_vm.application.status == 'Maybe')?_c('h5',[_vm._v("Thanks for letting us know you might be interested, we'll be in touch if necessary!")]):_vm._e(),_vm._v(" "),(_vm.application.status == 'Interested')?_c('h5',[_vm._v("Thanks for letting us know you are interested, we'll be in touch if it's a good fit!")]):_vm._e()]):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"application-status-updated-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thanks for letting us know!")]),_vm._v(" "),(_vm.status === 'Interested')?_c('div',[_c('p',[_vm._v("We are now going to review your profile and if it seems like a good fit for the family, we will share it with them.")]),_vm._v(" "),_c('p',[_vm._v("If they are interested in proceeding we will let you know!")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('application-status-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-accepted-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Congrats, you've accepted this job!")]),_vm._v(" "),_c('h5',[_vm._v("All the details will appear here and in your dashboard.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('job-accepted-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),(!_vm.job.id && !_vm.timeToLoad)?_c('div',[_c('h2',[_vm._v("Loading job...")])]):_vm._e(),_vm._v(" "),(!_vm.job.id && _vm.timeToLoad)?_c('div',[_c('h2',[_vm._v("Please wait, your job's loading.")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".theme-default .cv-header,.theme-default .cv-header-day{background-color:#f0f0f0}.theme-default .cv-header .periodLabel{font-size:1.5em}.theme-default .cv-header button{color:#7f7f7f}.theme-default .cv-header button:disabled{color:#ccc;background-color:#f7f7f7}.theme-default .cv-day.past{background-color:#fafafa}.theme-default .cv-day.outsideOfMonth{background-color:#f7f7f7}.theme-default .cv-day.today{background-color:#ffe}.theme-default .cv-event{border-color:#e0e0f0;border-radius:.5em;background-color:#e7e7ff;text-overflow:ellipsis}.theme-default .cv-event.purple{background-color:#f0e0ff;border-color:#e7d7f7}.theme-default .cv-event.orange{background-color:#ffe7d0;border-color:#f7e0c7}.theme-default .cv-event.continued:before,.theme-default .cv-event.toBeContinued:after{content:\" \\21E2   \";color:#999}.theme-default .cv-event.toBeContinued{border-right-style:none;border-top-right-radius:0;border-bottom-right-radius:0}.theme-default .cv-event.isHovered.hasUrl{text-decoration:underline}.theme-default .cv-event.continued{border-left-style:none;border-top-left-radius:0;border-bottom-left-radius:0}.theme-default .cv-event .endTime,.theme-default .cv-event .startTime{font-weight:700;color:#666}.theme-default .cv-day.draghover{box-shadow:inset 0 0 .2em .2em #ff0}", ""]);

// exports


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.getters.isEmployer !== true)?_c('div',{staticClass:"container top-level-div"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.auth)?_c('div',{staticClass:"mb-5"},[_c('h3',[_vm._v("Sitter Opportunities")]),_vm._v(" "),_c('div',{staticClass:"calendar",staticStyle:{"display":"flex","flex-direction":"column","flex-grow":"1","min-height":"600px"}},[_c('calendar-view',{staticClass:"theme-default holiday-us-traditional holiday-us-official",attrs:{"show-date":_vm.showDate,"date-classes":_vm.selectedDateObj,"events":_vm.calendarJobs},on:{"click-date":_vm.onClickDate,"click-event":_vm.onClickEvent},scopedSlots:_vm._u([{key:"header",fn:function(t){return _c('calendar-view-header',{attrs:{"header-props":t.headerProps},on:{"input":_vm.setShowDate}})}}],null,false,1651163290)})],1)]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"mt-4"},[_vm._v("Full Time Opportunities")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.jobs.length > 0)?_c('div',[_c('app-job-list',{attrs:{"jobs":_vm.jobsLongTerm}})],1):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('job',{staticStyle:{"margin-top":"-15vh","margin-bottom":"-20vh"},attrs:{"passedID":_vm.job.id}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('job-modal')}}},[_vm._v("Close")])],1)])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('h3',[_vm._v("YOUR NEXT OPPORTUNITY AWAITS")]),_vm._v(" "),_c('strong',[_vm._v("We have countless positions available at any given time, and share new opportunities daily!")]),_vm._v(" "),_c('p',[_vm._v("Check out our current openings below and be sure to read the jobs descriptions carefully! Please be sure that you meet those qualifications outlined and are comfortable with the commute, hours, duties and rate prior to expressing interest in a position.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container top-level-div"},[(_vm.$store.getters.userID == _vm.user.id)?_c('div',[_c('h2',{ref:"pageTitle"},[_vm._v("Welcome to "+_vm._s(_vm.$store.getters.agencyHumanName)),(_vm.user.first_name)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(_vm.user.first_name))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}})]):_vm._e(),_vm._v(" "),(_vm.user.id && _vm.tab == 'profile')?_c('div',[_c('app-profile-view',{attrs:{"user":_vm.user},on:{"userUpdated":function($event){return _vm.getUser()}}})],1):_vm._e(),_vm._v(" "),(_vm.user.id && _vm.tab == 'jobs')?_c('div',{staticStyle:{"margin-top":"-12.5vh"}},[_c('job-board')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268dd726_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationForm_vue__ = __webpack_require__(752);
function injectStyle (ssrContext) {
  __webpack_require__(731)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268dd726_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(732);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6d8011c4", content, true, {});

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".form-note{font-weight:500}.ref-separator{margin:1rem}.privacy-note{margin:1rem 0}.referral-service-note{font-weight:400}", ""]);

// exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(734);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("02ce9e8f", content, true, {});

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".header-section[data-v-2bb73fdb]{margin-bottom:0}", ""]);

// exports


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursSelector_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5476022_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DayHoursSelector_vue__ = __webpack_require__(745);
function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5476022"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5476022_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DayHoursSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(737);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3544e3ae", content, true, {});

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".day-checkbox-container[data-v-b5476022]{display:flex;align-items:center}.day-checkbox-container .form-check-input[data-v-b5476022]{margin-top:0}.workday-label[data-v-b5476022]{margin-bottom:.5em}@media only screen and (min-width:768px){.time-from-container[data-v-b5476022],.time-to-container[data-v-b5476022]{padding-left:2em}}", ""]);

// exports


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a7d338_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimePickerWithLabel_vue__ = __webpack_require__(744);
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17a7d338"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a7d338_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimePickerWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(740);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6f7eacd5", content, true, {});

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".time-label[data-v-17a7d338]{display:inline-block;width:3em}", ""]);

// exports


/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "45fc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $some = __webpack_require__("b727").some;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('some');
var USES_TO_LENGTH = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isRegExp = __webpack_require__("44e7");
var getFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var setInternalState = __webpack_require__("69f3").set;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    if (document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aab0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fd6f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"08a1de70-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-timepicker.vue?vue&type=template&id=11d43692&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vue__time-picker time-picker",style:(_vm.inputWidthStyle)},[_c('input',{ref:"input",staticClass:"display-time",class:[_vm.inputClass, {'is-empty': _vm.inputIsEmpty, 'invalid': _vm.hasInvalidInput, 'all-selected': _vm.allValueSelected, 'disabled': _vm.disabled, 'has-custom-icon': _vm.$slots && _vm.$slots.icon }],style:(_vm.inputWidthStyle),attrs:{"type":"text","id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder ? _vm.placeholder : _vm.formatString,"tabindex":_vm.disabled ? -1 : _vm.tabindex,"disabled":_vm.disabled,"readonly":!_vm.manualInput,"autocomplete":_vm.autocomplete},domProps:{"value":_vm.inputIsEmpty ? null : _vm.customDisplayTime},on:{"focus":_vm.onFocus,"change":_vm.onChange,"blur":function($event){_vm.debounceBlur(); _vm.blurEvent()},"mousedown":_vm.onMouseDown,"keydown":[_vm.keyDownHandler,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.escBlur($event)}],"compositionstart":_vm.onCompostionStart,"compositionend":_vm.onCompostionEnd,"paste":_vm.pasteHandler}}),(_vm.showClearBtn || _vm.showDropdownBtn)?_c('div',{staticClass:"controls",attrs:{"tabindex":"-1"}},[(!_vm.isActive && _vm.showClearBtn)?_c('span',{staticClass:"clear-btn",class:{'has-custom-btn': _vm.$slots && _vm.$slots.clearButton },attrs:{"tabindex":"-1"},on:{"click":_vm.clearTime}},[_vm._t("clearButton",[_c('span',{staticClass:"char"},[_vm._v("×")])])],2):_vm._e(),(_vm.showDropdownBtn)?_c('span',{staticClass:"dropdown-btn",class:{'has-custom-btn': _vm.$slots && _vm.$slots.dropdownButton },attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.setDropdownState(_vm.fixedDropdownButton ? !_vm.showDropdown : true, true)},"mousedown":_vm.keepFocusing}},[_vm._t("dropdownButton",[_c('span',{staticClass:"char"},[_vm._v("▾")])])],2):_vm._e()]):_vm._e(),(_vm.$slots && _vm.$slots.icon)?_c('div',{staticClass:"custom-icon"},[_vm._t("icon")],2):_vm._e(),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",attrs:{"tabindex":"-1"},on:{"click":_vm.toggleActive}}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown",class:[_vm.dropdownDirClass],style:(_vm.inputWidthStyle),attrs:{"tabindex":"-1"},on:{"mouseup":_vm.keepFocusing,"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"select-list",style:(_vm.inputWidthStyle),attrs:{"tabindex":"-1"}},[(!_vm.advancedKeyboard)?[_vm._l((_vm.columnsSequence),function(column){return [(column === 'hour')?_c('ul',{key:column,staticClass:"hours",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourLabelText)}}),_vm._l((_vm.hours),function(hr,hIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('hour', hr)))?_c('li',{key:hIndex,class:{active: _vm.hour === hr},attrs:{"disabled":_vm.isDisabled('hour', hr),"data-key":hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){return _vm.select('hour', hr)}}}):_vm._e()]})],2):_vm._e(),(column === 'minute')?_c('ul',{key:column,staticClass:"minutes",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteLabelText)}}),_vm._l((_vm.minutes),function(m,mIndex){return [(!_vm.opts.hideDisabledMinutes || (_vm.opts.hideDisabledMinutes && !_vm.isDisabled('minute', m)))?_c('li',{key:mIndex,class:{active: _vm.minute === m},attrs:{"disabled":_vm.isDisabled('minute', m),"data-key":m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){return _vm.select('minute', m)}}}):_vm._e()]})],2):_vm._e(),(column === 'second')?_c('ul',{key:column,staticClass:"seconds",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondLabelText)}}),_vm._l((_vm.seconds),function(s,sIndex){return [(!_vm.opts.hideDisabledSeconds || (_vm.opts.hideDisabledSeconds && !_vm.isDisabled('second', s)))?_c('li',{key:sIndex,class:{active: _vm.second === s},attrs:{"disabled":_vm.isDisabled('second', s),"data-key":s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){return _vm.select('second', s)}}}):_vm._e()]})],2):_vm._e(),(column === 'apm')?_c('ul',{key:column,staticClass:"apms",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmLabelText)}}),_vm._l((_vm.apms),function(a,aIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('apm', a)))?_c('li',{key:aIndex,class:{active: _vm.apm === a},attrs:{"disabled":_vm.isDisabled('apm', a),"data-key":a},domProps:{"textContent":_vm._s(_vm.apmDisplayText(a))},on:{"click":function($event){return _vm.select('apm', a)}}}):_vm._e()]})],2):_vm._e()]})]:_vm._e(),(_vm.advancedKeyboard)?[_vm._l((_vm.columnsSequence),function(column){return [(column === 'hour')?_c('ul',{key:column,staticClass:"hours",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.hourLabelText)}}),_vm._l((_vm.hours),function(hr,hIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('hour', hr)))?_c('li',{key:hIndex,class:{active: _vm.hour === hr},attrs:{"tabindex":_vm.isDisabled('hour', hr) ? -1 : _vm.tabindex,"data-key":hr,"disabled":_vm.isDisabled('hour', hr)},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){return _vm.select('hour', hr)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('hour')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('hour')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e(),(column === 'minute')?_c('ul',{key:column,staticClass:"minutes",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.minuteLabelText)}}),_vm._l((_vm.minutes),function(m,mIndex){return [(!_vm.opts.hideDisabledMinutes || (_vm.opts.hideDisabledMinutes && !_vm.isDisabled('minute', m)))?_c('li',{key:mIndex,class:{active: _vm.minute === m},attrs:{"tabindex":_vm.isDisabled('minute', m) ? -1 : _vm.tabindex,"data-key":m,"disabled":_vm.isDisabled('minute', m)},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){return _vm.select('minute', m)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('minute')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('minute')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e(),(column === 'second')?_c('ul',{key:column,staticClass:"seconds",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.secondLabelText)}}),_vm._l((_vm.seconds),function(s,sIndex){return [(!_vm.opts.hideDisabledSeconds || (_vm.opts.hideDisabledSeconds && !_vm.isDisabled('second', s)))?_c('li',{key:sIndex,class:{active: _vm.second === s},attrs:{"tabindex":_vm.isDisabled('second', s) ? -1 : _vm.tabindex,"data-key":s,"disabled":_vm.isDisabled('second', s)},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){return _vm.select('second', s)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('second')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('second')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e(),(column === 'apm')?_c('ul',{key:column,staticClass:"apms",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.apmLabelText)}}),_vm._l((_vm.apms),function(a,aIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('apm', a)))?_c('li',{key:aIndex,class:{active: _vm.apm === a},attrs:{"tabindex":_vm.isDisabled('apm', a) ? -1 : _vm.tabindex,"data-key":a,"disabled":_vm.isDisabled('apm', a)},domProps:{"textContent":_vm._s(_vm.apmDisplayText(a))},on:{"click":function($event){return _vm.select('apm', a)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('apm')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('apm')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e()]})]:_vm._e()],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-timepicker.vue?vue&type=template&id=11d43692&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("45fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js








function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-timepicker.vue?vue&type=script&lang=js&


























var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a'],
  BASIC_TYPES: ['hour', 'minute', 'second', 'apm']
};
var DEFAULT_OPTIONS = {
  format: 'HH:mm',
  minuteInterval: 1,
  secondInterval: 1,
  hourRange: null,
  minuteRange: null,
  secondRange: null,
  hideDisabledHours: false,
  hideDisabledMinutes: false,
  hideDisabledSeconds: false,
  hideDisabledItems: false,
  advancedKeyboard: false,
  hideDropdown: false,
  blurDelay: 300,
  manualInputTimeout: 1000,
  dropOffsetHeight: 160
};
/* harmony default export */ var vue_timepickervue_type_script_lang_js_ = ({
  name: 'VueTimepicker',
  props: {
    value: {
      type: [Object, String]
    },
    format: {
      type: String
    },
    minuteInterval: {
      type: [Number, String]
    },
    secondInterval: {
      type: [Number, String]
    },
    hourRange: {
      type: Array
    },
    minuteRange: {
      type: Array
    },
    secondRange: {
      type: Array
    },
    hideDisabledHours: {
      type: Boolean,
      default: false
    },
    hideDisabledMinutes: {
      type: Boolean,
      default: false
    },
    hideDisabledSeconds: {
      type: Boolean,
      default: false
    },
    hideDisabledItems: {
      type: Boolean,
      default: false
    },
    hideClearButton: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeOnComplete: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    inputClass: {
      type: [String, Object, Array]
    },
    placeholder: {
      type: String
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    inputWidth: {
      type: String
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    hourLabel: {
      type: String
    },
    minuteLabel: {
      type: String
    },
    secondLabel: {
      type: String
    },
    apmLabel: {
      type: String
    },
    amText: {
      type: String
    },
    pmText: {
      type: String
    },
    blurDelay: {
      type: [Number, String]
    },
    advancedKeyboard: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    autoScroll: {
      type: Boolean,
      default: false
    },
    dropDirection: {
      type: String,
      default: 'down'
    },
    dropOffsetHeight: {
      type: [Number, String]
    },
    containerId: {
      type: String
    },
    manualInput: {
      type: Boolean,
      default: false
    },
    manualInputTimeout: {
      type: [Number, String]
    },
    hideDropdown: {
      type: Boolean,
      default: false
    },
    fixedDropdownButton: {
      type: Boolean,
      default: false
    },
    debugMode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      timeValue: {},
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      isActive: false,
      showDropdown: false,
      isFocusing: false,
      debounceTimer: undefined,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined,
      bakDisplayTime: undefined,
      doClearApmChecking: false,
      selectionTimer: undefined,
      kbInputTimer: undefined,
      kbInputLog: '',
      bakCurrentPos: undefined,
      forceDropOnTop: false
    };
  },
  computed: {
    opts: function opts() {
      var options = Object.assign({}, DEFAULT_OPTIONS);

      if (this.format && this.format.length) {
        options.format = String(this.format);
      }

      if (this.isNumber(this.minuteInterval)) {
        options.minuteInterval = +this.minuteInterval;
      } // minuteInterval failsafe


      if (!options.minuteInterval || options.minuteInterval < 1 || options.minuteInterval > 60) {
        if (this.debugMode) {
          if (options.minuteInterval > 60) {
            this.debugLog("\"minute-interval\" should be less than 60. Current value is ".concat(this.minuteInterval));
          } else if (options.minuteInterval === 0 || options.minuteInterval < 1) {
            this.debugLog("\"minute-interval\" should be NO less than 1. Current value is ".concat(this.minuteInterval));
          }
        }

        if (options.minuteInterval === 0) {
          options.minuteInterval = 60;
        } else {
          options.minuteInterval = 1;
        }
      }

      if (this.isNumber(this.secondInterval)) {
        options.secondInterval = +this.secondInterval;
      } // secondInterval failsafe


      if (!options.secondInterval || options.secondInterval < 1 || options.secondInterval > 60) {
        if (this.debugMode) {
          if (options.secondInterval > 60) {
            this.debugLog("\"second-interval\" should be less than 60. Current value is ".concat(this.secondInterval));
          } else if (options.secondInterval === 0 || options.secondInterval < 1) {
            this.debugLog("\"second-interval\" should be NO less than 1. Current value is ".concat(this.secondInterval));
          }
        }

        if (options.secondInterval === 0) {
          options.secondInterval = 60;
        } else {
          options.secondInterval = 1;
        }
      }

      if (this.hourRange && Array.isArray(this.hourRange)) {
        options.hourRange = JSON.parse(JSON.stringify(this.hourRange));

        if (!this.hourRange.length && this.debugMode) {
          this.debugLog('The "hour-range" array is empty (length === 0)');
        }
      }

      if (this.minuteRange && Array.isArray(this.minuteRange)) {
        options.minuteRange = JSON.parse(JSON.stringify(this.minuteRange));

        if (!this.minuteRange.length && this.debugMode) {
          this.debugLog('The "minute-range" array is empty (length === 0)');
        }
      }

      if (this.secondRange && Array.isArray(this.secondRange)) {
        options.secondRange = JSON.parse(JSON.stringify(this.secondRange));

        if (!this.secondRange.length && this.debugMode) {
          this.debugLog('The "second-range" array is empty (length === 0)');
        }
      }

      if (this.hideDisabledItems) {
        options.hideDisabledItems = true;
      }

      if (this.hideDisabledHours || this.hideDisabledItems) {
        options.hideDisabledHours = true;
      }

      if (this.hideDisabledMinutes || this.hideDisabledItems) {
        options.hideDisabledMinutes = true;
      }

      if (this.hideDisabledSeconds || this.hideDisabledItems) {
        options.hideDisabledSeconds = true;
      }

      if (this.hideDropdown) {
        if (this.manualInput) {
          options.hideDropdown = true;
        } else if (this.debugMode) {
          this.debugLog('"hide-dropdown" only works with "manual-input" mode');
        }
      }

      if (this.blurDelay && +this.blurDelay > 0) {
        options.blurDelay = +this.blurDelay;
      }

      if (this.manualInputTimeout && +this.manualInputTimeout > 0) {
        options.manualInputTimeout = +this.manualInputTimeout;
      }

      if (this.dropOffsetHeight && +this.dropOffsetHeight > 0) {
        options.dropOffsetHeight = +this.dropOffsetHeight;
      }

      return options;
    },
    useStringValue: function useStringValue() {
      return typeof this.value === 'string';
    },
    formatString: function formatString() {
      return this.opts.format || DEFAULT_OPTIONS.format;
    },
    inUse: function inUse() {
      var _this = this;

      var typesInUse = CONFIG.BASIC_TYPES.filter(function (type) {
        return _this.getTokenByType(type);
      }); // Sort types and tokens by their sequence in the "format" string

      typesInUse.sort(function (l, r) {
        return _this.formatString.indexOf(_this.getTokenByType(l) || null) - _this.formatString.indexOf(_this.getTokenByType(r) || null);
      });
      var tokensInUse = typesInUse.map(function (type) {
        return _this.getTokenByType(type);
      });
      return {
        hour: !!this.hourType,
        minute: !!this.minuteType,
        second: !!this.secondType,
        apm: !!this.apmType,
        types: typesInUse || [],
        tokens: tokensInUse || []
      };
    },
    displayTime: function displayTime() {
      var formatString = String(this.formatString);

      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }

      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }

      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }

      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }

      return formatString;
    },
    customDisplayTime: function customDisplayTime() {
      if (!this.amText && !this.pmText) {
        return this.displayTime;
      }

      return this.displayTime.replace(new RegExp(this.apm, 'g'), this.apmDisplayText(this.apm));
    },
    inputIsEmpty: function inputIsEmpty() {
      return this.formatString === this.displayTime;
    },
    allValueSelected: function allValueSelected() {
      if (this.inUse.hour && !this.hour || this.inUse.minute && !this.minute || this.inUse.second && !this.second || this.inUse.apm && !this.apm) {
        return false;
      }

      return true;
    },
    columnsSequence: function columnsSequence() {
      return this.inUse.types.map(function (type) {
        return type;
      }) || [];
    },
    showClearBtn: function showClearBtn() {
      if (this.hideClearButton || this.disabled) {
        return false;
      }

      return !this.inputIsEmpty;
    },
    showDropdownBtn: function showDropdownBtn() {
      if (this.fixedDropdownButton) {
        return true;
      }

      if (this.opts.hideDropdown && this.isActive && !this.showDropdown) {
        return true;
      }

      return false;
    },
    baseOn12Hours: function baseOn12Hours() {
      return this.hourType === 'h' || this.hourType === 'hh';
    },
    hourRangeIn24HrFormat: function hourRangeIn24HrFormat() {
      var _this2 = this;

      if (!this.hourType || !this.opts.hourRange) {
        return false;
      }

      if (!this.opts.hourRange.length) {
        return [];
      }

      var range = [];
      this.opts.hourRange.forEach(function (value) {
        if (value instanceof Array) {
          if (value.length > 2 && _this2.debugMode) {
            _this2.debugLog("Nested array within \"hour-range\" must contain no more than two items. Only the first two items of ".concat(JSON.stringify(value), " will be taken into account."));
          }

          var start = value[0];
          var end = value[1] || value[0];

          if (_this2.is12hRange(start)) {
            start = _this2.translate12hRange(start);
          }

          if (_this2.is12hRange(end)) {
            end = _this2.translate12hRange(end);
          }

          for (var i = +start; i <= +end; i++) {
            if (i < 0 || i > 24) {
              continue;
            }

            if (!range.includes(i)) {
              range.push(i);
            }
          }
        } else {
          if (_this2.is12hRange(value)) {
            value = _this2.translate12hRange(value);
          } else {
            value = +value;
          }

          if (value < 0 || value > 24) {
            return;
          }

          if (!range.includes(value)) {
            range.push(value);
          }
        }
      });
      range.sort(function (l, r) {
        return l - r;
      });
      return range;
    },
    restrictedHourRange: function restrictedHourRange() {
      // No restriction
      if (!this.hourRangeIn24HrFormat) {
        return false;
      } // 12-Hour


      if (this.baseOn12Hours) {
        var range = this.hourRangeIn24HrFormat.map(function (value) {
          if (value === 12) {
            return '12p';
          } else if (value === 24 || value === 0) {
            return '12a';
          }

          return value > 12 ? "".concat(value % 12, "p") : "".concat(value, "a");
        });
        return range;
      } // 24-Hour


      return this.hourRangeIn24HrFormat;
    },
    validHoursList: function validHoursList() {
      var _this3 = this;

      if (!this.manualInput) {
        return false;
      }

      if (this.restrictedHourRange) {
        var list = [];

        if (this.baseOn12Hours) {
          list = this.restrictedHourRange.map(function (hr) {
            var l = hr.substr(0, hr.length - 1);
            var r = hr.substr(-1);
            return "".concat(_this3.formatValue(_this3.hourType, l)).concat(r);
          });
          var am12Index = list.indexOf('12a');

          if (am12Index > 0) {
            // Make '12a' the first item in h/hh
            list.unshift(list.splice(am12Index, 1)[0]);
          }

          return list;
        }

        list = this.restrictedHourRange.map(function (hr) {
          return _this3.formatValue(_this3.hourType, hr);
        });

        if (list.length > 1 && list[0] && list[0] === '24') {
          // Make '24' the last item in k/kk
          list.push(list.shift());
        }

        return list;
      }

      if (this.baseOn12Hours) {
        return [].concat([], this.hours.map(function (hr) {
          return "".concat(hr, "a");
        }), this.hours.map(function (hr) {
          return "".concat(hr, "p");
        }));
      }

      return this.hours;
    },
    has: function has() {
      var result = {
        customApmText: false
      };
      var apmEnabled = !!this.apmType;

      if (apmEnabled && this.hourRangeIn24HrFormat && this.hourRangeIn24HrFormat.length) {
        var range = [].concat([], this.hourRangeIn24HrFormat);
        result.am = range.some(function (value) {
          return value < 12 || value === 24;
        });
        result.pm = range.some(function (value) {
          return value >= 12 && value < 24;
        });
      } else {
        result.am = apmEnabled;
        result.pm = apmEnabled;
      }

      if (this.amText && this.amText.length || this.pmText && this.pmText.length) {
        result.customApmText = true;
      }

      return result;
    },
    minuteRangeList: function minuteRangeList() {
      if (!this.minuteType || !this.opts.minuteRange) {
        return false;
      }

      if (!this.opts.minuteRange.length) {
        return [];
      }

      return this.renderRangeList(this.opts.minuteRange, 'minute');
    },
    secondRangeList: function secondRangeList() {
      if (!this.secondType || !this.opts.secondRange) {
        return false;
      }

      if (!this.opts.secondRange.length) {
        return [];
      }

      return this.renderRangeList(this.opts.secondRange, 'second');
    },
    hourLabelText: function hourLabelText() {
      return this.hourLabel || this.hourType;
    },
    minuteLabelText: function minuteLabelText() {
      return this.minuteLabel || this.minuteType;
    },
    secondLabelText: function secondLabelText() {
      return this.secondLabel || this.secondType;
    },
    apmLabelText: function apmLabelText() {
      return this.apmLabel || this.apmType;
    },
    inputWidthStyle: function inputWidthStyle() {
      if (!this.inputWidth || !this.inputWidth.length) {
        return;
      }

      return {
        width: this.inputWidth
      };
    },
    tokenRegexBase: function tokenRegexBase() {
      return this.inUse.tokens.join('|');
    },
    tokenChunks: function tokenChunks() {
      if (!this.manualInput && !this.useStringValue) {
        return false;
      }

      var formatString = String(this.formatString);
      var tokensRegxStr = "(".concat(this.tokenRegexBase, ")+?");
      var tokensMatchAll = this.getMatchAllByRegex(formatString, tokensRegxStr);
      var tokenChunks = [];

      var _iterator = _createForOfIteratorHelper(tokensMatchAll),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tkMatch = _step.value;
          var rawToken = tkMatch[0];
          var tokenMatchItem = {
            index: tkMatch.index,
            token: rawToken,
            type: this.getTokenType(rawToken),
            needsCalibrate: rawToken.length < 2,
            len: (rawToken || '').length
          };
          tokenChunks.push(tokenMatchItem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return tokenChunks;
    },
    needsPosCalibrate: function needsPosCalibrate() {
      if (!this.manualInput) {
        return false;
      }

      return this.tokenChunks.some(function (chk) {
        return chk.needsCalibrate;
      });
    },
    tokenChunksPos: function tokenChunksPos() {
      var _this4 = this;

      if (!this.manualInput) {
        return false;
      }

      if (!this.needsPosCalibrate) {
        return this.tokenChunks.map(function (chk) {
          return {
            token: chk.token,
            type: chk.type,
            start: chk.index,
            end: chk.index + chk.len
          };
        });
      }

      var list = [];
      var calibrateLen = 0;
      this.tokenChunks.forEach(function (chk) {
        var chunkCurrentLen; // Adjust for customized AM/PM text

        if (chk.type === 'apm' && _this4.has.customApmText) {
          if (_this4.apm && _this4.apm.length) {
            var customApmText = _this4.apm.toLowerCase() === 'am' ? _this4.amText : _this4.pmText;
            chunkCurrentLen = customApmText && customApmText.length ? customApmText.length : chk.len;
          } else {
            chunkCurrentLen = chk.len;
          } // Others

        } else {
          chunkCurrentLen = _this4[chk.type] && _this4[chk.type].length ? _this4[chk.type].length : chk.len;
        }

        list.push({
          token: chk.token,
          type: chk.type,
          start: chk.index + calibrateLen,
          end: chk.index + calibrateLen + chunkCurrentLen
        });

        if (chk.needsCalibrate && chunkCurrentLen > chk.len) {
          calibrateLen += chunkCurrentLen - chk.len;
        }
      });
      return list;
    },
    invalidValues: function invalidValues() {
      if (this.inputIsEmpty) {
        return [];
      }

      if (!this.restrictedHourRange && !this.minuteRangeList && !this.secondRangeList && this.opts.minuteInterval === 1 && this.opts.secondInterval === 1) {
        return [];
      }

      var result = [];

      if (this.inUse.hour && !this.isEmptyValue(this.hourType, this.hour) && (!this.isValidValue(this.hourType, this.hour) || this.isDisabled('hour', this.hour))) {
        result.push('hour');
      }

      if (this.inUse.minute && !this.isEmptyValue(this.minuteType, this.minute) && (!this.isValidValue(this.minuteType, this.minute) || this.isDisabled('minute', this.minute) || this.notInInterval('minute', this.minute))) {
        result.push('minute');
      }

      if (this.inUse.second && !this.isEmptyValue(this.secondType, this.second) && (!this.isValidValue(this.secondType, this.second) || this.isDisabled('second', this.second) || this.notInInterval('second', this.second))) {
        result.push('second');
      }

      if (this.inUse.apm && !this.isEmptyValue(this.apmType, this.apm) && (!this.isValidValue(this.apmType, this.apm) || this.isDisabled('apm', this.apm))) {
        result.push('apm');
      }

      if (result.length) {
        return result;
      }

      return [];
    },
    hasInvalidInput: function hasInvalidInput() {
      return Boolean(this.invalidValues && this.invalidValues.length);
    },
    autoDirectionEnabled: function autoDirectionEnabled() {
      return this.dropDirection === 'auto';
    },
    dropdownDirClass: function dropdownDirClass() {
      if (this.autoDirectionEnabled) {
        return this.forceDropOnTop ? 'drop-up' : 'drop-down';
      }

      return this.dropDirection === 'up' ? 'drop-up' : 'drop-down';
    }
  },
  watch: {
    'opts.format': function optsFormat(newValue) {
      this.renderFormat(newValue);
    },
    'opts.minuteInterval': function optsMinuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    'opts.secondInterval': function optsSecondInterval(newInteval) {
      this.renderList('second', newInteval);
    },
    value: {
      deep: true,
      handler: function handler() {
        this.readValues();
      }
    },
    displayTime: function displayTime() {
      this.fillValues();
    },
    disabled: function disabled(toDisabled) {
      if (toDisabled) {
        // Force close dropdown and reset status when disabled
        if (this.isActive) {
          this.isActive = false;
        }

        if (this.showDropdown) {
          this.showDropdown = false;
        }
      }
    },
    'invalidValues.length': function invalidValuesLength(newLength, oldLength) {
      if (newLength && newLength >= 1) {
        this.$emit('error', this.invalidValues);
      } else if (oldLength && oldLength >= 1) {
        this.$emit('error', []);
      }
    }
  },
  methods: {
    formatValue: function formatValue(token, i) {
      if (!this.isNumber(i)) {
        return '';
      }

      i = +i;

      switch (token) {
        case 'H':
        case 'h':
        case 'k':
        case 'm':
        case 's':
          if (['h', 'k'].includes(token) && i === 0) {
            return token === 'k' ? '24' : '12';
          }

          return String(i);

        case 'HH':
        case 'mm':
        case 'ss':
        case 'hh':
        case 'kk':
          if (['hh', 'kk'].includes(token) && i === 0) {
            return token === 'kk' ? '24' : '12';
          }

          return i < 10 ? "0".concat(i) : String(i);

        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }

      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }

      return '';
    },
    renderFormat: function renderFormat(newFormat) {
      var _this5 = this;

      newFormat = newFormat || this.opts.format || DEFAULT_OPTIONS.format;
      var hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat);
      var minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat);
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat); // Failsafe checking

      if (!hourType && !minuteType && !this.secondType && !this.apmType) {
        if (this.debugMode && this.format) {
          this.debugLog("No valid tokens found in your defined \"format\" string \"".concat(this.format, "\". Fallback to the default \"HH:mm\" format."));
        }

        hourType = 'HH';
        minuteType = 'mm';
      }

      this.hourType = hourType;
      this.minuteType = minuteType;
      this.hourType ? this.renderHoursList() : this.hours = [];
      this.minuteType ? this.renderList('minute') : this.minutes = [];
      this.secondType ? this.renderList('second') : this.seconds = [];
      this.apmType ? this.renderApmList() : this.apms = [];
      this.$nextTick(function () {
        _this5.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.baseOn12Hours ? 12 : 24;
      var hours = [];

      for (var i = 0; i < hoursCount; i++) {
        if (this.hourType === 'k' || this.hourType === 'kk') {
          hours.push(this.formatValue(this.hourType, i + 1));
        } else {
          hours.push(this.formatValue(this.hourType, i));
        }
      }

      this.hours = hours;
    },
    renderList: function renderList(listType, interval) {
      if (!this.isMinuteOrSecond(listType)) {
        return;
      }

      var isMinute = listType === 'minute';
      interval = interval || (isMinute ? this.opts.minuteInterval || DEFAULT_OPTIONS.minuteInterval : this.opts.secondInterval || DEFAULT_OPTIONS.secondInterval);
      var result = [];

      for (var i = 0; i < 60; i += interval) {
        result.push(this.formatValue(isMinute ? this.minuteType : this.secondType, i));
      }

      isMinute ? this.minutes = result : this.seconds = result;
    },
    renderApmList: function renderApmList() {
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (this.useStringValue) {
        if (this.debugMode) {
          this.debugLog("Received a string value: \"".concat(this.value, "\""));
        }

        this.readStringValues(this.value);
      } else {
        if (this.debugMode) {
          this.debugLog("Received an object value: \"".concat(JSON.stringify(this.value || {}), "\""));
        }

        this.readObjectValues(this.value);
      }
    },
    readObjectValues: function readObjectValues(objValue) {
      var _this6 = this;

      var timeValue = JSON.parse(JSON.stringify(objValue || {}));
      var values = Object.keys(timeValue); // Failsafe for empty `v-model` object

      if (values.length === 0) {
        this.addFallbackValues();
        return;
      }

      CONFIG.BASIC_TYPES.forEach(function (type) {
        var token = _this6.getTokenByType(type);

        if (values.indexOf(token) > -1) {
          var sanitizedValue = _this6.sanitizedValue(token, timeValue[token]);

          _this6[type] = sanitizedValue;
          timeValue[token] = sanitizedValue;
        } else {
          _this6[type] = '';
        }
      });
      this.timeValue = timeValue;
    },
    getMatchAllByRegex: function getMatchAllByRegex(testString, regexString) {
      var str = 'polyfillTest';
      var needsPolyfill = Boolean(!str.matchAll || typeof str.matchAll !== 'function');
      return needsPolyfill ? this.polyfillMatchAll(testString, regexString) : testString.matchAll(new RegExp(regexString, 'g'));
    },
    readStringValues: function readStringValues(stringValue) {
      var _this7 = this;

      // Failsafe for empty `v-model` string
      if (!stringValue || !stringValue.length) {
        this.addFallbackValues();
        return;
      }

      var formatString = String(this.formatString);
      var tokensRegxStr = "(".concat(this.tokenRegexBase, ")+?");
      var othersRegxStr = "[^(".concat(this.tokenRegexBase, ")]+");
      var tokensMatchAll = this.getMatchAllByRegex(formatString, tokensRegxStr);
      var othersMatchAll = this.getMatchAllByRegex(formatString, othersRegxStr);
      var chunks = [];
      var tokenChunks = [];

      var _iterator2 = _createForOfIteratorHelper(tokensMatchAll),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tkMatch = _step2.value;
          var tokenMatchItem = {
            index: tkMatch.index,
            token: tkMatch[0],
            isValueToken: true
          };
          chunks.push(tokenMatchItem);
          tokenChunks.push(tokenMatchItem);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(othersMatchAll),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var otMatch = _step3.value;
          chunks.push({
            index: otMatch.index,
            token: otMatch[0]
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      chunks.sort(function (l, r) {
        return l.index < r.index ? -1 : 1;
      });
      var regexCombo = '';
      chunks.forEach(function (chunk) {
        if (chunk.isValueToken) {
          var tokenRegex = _this7.getTokenRegex(chunk.token) || '';
          regexCombo += tokenRegex;
        } else {
          var safeChars = chunk.token.replace(/\\{0}(\*|\?|\.|\+)/g, '\\$1');
          regexCombo += "(?:".concat(safeChars, ")");
        }
      });
      var comboReg = new RegExp(regexCombo); // Do test before match

      if (comboReg.test(stringValue)) {
        var matchResults = stringValue.match(new RegExp(regexCombo));
        var valueResults = matchResults.slice(1, tokenChunks.length + 1);
        var timeValue = {};
        valueResults.forEach(function (value, vrIndex) {
          if (tokenChunks[vrIndex]) {
            var targetToken = tokenChunks[vrIndex].token;
            timeValue[targetToken] = _this7.setValueFromString(value, targetToken);
          }
        });
        this.timeValue = timeValue;

        if (this.debugMode) {
          var tokenChunksForLog = tokenChunks.map(function (tChunk) {
            return tChunk && tChunk.token;
          });
          this.debugLog("Successfully parsed values ".concat(JSON.stringify(valueResults), "\nfor ").concat(JSON.stringify(tokenChunksForLog), "\nin format pattern '").concat(this.formatString, "'"));
        }
      } else {
        if (this.debugMode) {
          this.debugLog("The input string in \"v-model\" does NOT match the \"format\" pattern\nformat: ".concat(this.formatString, "\nv-model: ").concat(stringValue));
        }
      }
    },
    polyfillMatchAll: function polyfillMatchAll(targetString, regxStr) {
      var matchesList = targetString.match(new RegExp(regxStr, 'g'));
      var result = [];
      var indicesReg = [];

      if (matchesList && matchesList.length) {
        matchesList.forEach(function (matchedItem) {
          var existIndex = indicesReg.findIndex(function (idxItem) {
            return idxItem.str === matchedItem;
          });
          var index;

          if (existIndex >= 0) {
            if (indicesReg[existIndex] && indicesReg[existIndex].regex) {
              index = indicesReg[existIndex].regex.exec(targetString).index;
            }
          } else {
            var itemIndicesRegex = new RegExp(matchedItem, 'g');
            index = itemIndicesRegex.exec(targetString).index;
            indicesReg.push({
              str: String(matchedItem),
              regex: itemIndicesRegex
            });
          }

          result.push({
            0: String(matchedItem),
            index: index
          });
        });
      }

      return result;
    },
    addFallbackValues: function addFallbackValues() {
      var _this8 = this;

      var timeValue = {};
      this.inUse.types.forEach(function (type) {
        timeValue[_this8.getTokenByType(type)] = '';
      });
      this.timeValue = timeValue;
    },
    setValueFromString: function setValueFromString(parsedValue, token) {
      if (!token || !parsedValue) {
        return '';
      }

      var tokenType = this.getTokenType(token);

      if (!tokenType || !tokenType.length) {
        return '';
      }

      var stdValue = parsedValue !== this.getTokenByType(tokenType) ? parsedValue : '';
      this[tokenType] = stdValue;
      return stdValue;
    },
    fillValues: function fillValues(forceEmit) {
      var _this9 = this;

      var fullValues = {};
      var baseHour = this.hour;
      var baseHourType = this.hourType;
      var apmValue; // Hour type or hour value is NOT set in the "format" string

      if (!baseHourType || !this.isNumber(baseHour)) {
        CONFIG.HOUR_TOKENS.forEach(function (token) {
          return fullValues[token] = '';
        });
        apmValue = this.lowerCasedApm(this.apm || '');
        fullValues.a = apmValue;
        fullValues.A = apmValue.toUpperCase(); // Both Hour type and value are set
      } else {
        var hourValue = +baseHour;

        var _apmValue = this.baseOn12Hours && this.apm ? this.lowerCasedApm(this.apm) : false;

        CONFIG.HOUR_TOKENS.forEach(function (token) {
          if (token === baseHourType) {
            fullValues[token] = baseHour;
            return;
          }

          var value;
          var apm;

          switch (token) {
            case 'H':
            case 'HH':
            case 'k':
            case 'kk':
              if (_this9.baseOn12Hours) {
                if (_apmValue === 'pm') {
                  value = hourValue < 12 ? hourValue + 12 : hourValue;
                } else if (['k', 'kk'].includes(token)) {
                  value = hourValue === 12 ? 24 : hourValue;
                } else {
                  value = hourValue % 12;
                }
              } else {
                if (['k', 'kk'].includes(token)) {
                  value = hourValue === 0 ? 24 : hourValue;
                } else {
                  value = hourValue % 24;
                }
              }

              fullValues[token] = _this9.formatValue(token, value);
              break;

            case 'h':
            case 'hh':
              // h <-> hh
              if (_this9.baseOn12Hours) {
                value = hourValue;
                apm = _apmValue || ''; // Read from other hour formats
              } else {
                if (hourValue > 11 && hourValue < 24) {
                  apm = 'pm';
                  value = hourValue === 12 ? 12 : hourValue % 12;
                } else {
                  apm = 'am';
                  value = hourValue % 12 === 0 ? 12 : hourValue;
                }
              }

              fullValues[token] = _this9.formatValue(token, value);
              fullValues.a = apm;
              fullValues.A = apm.toUpperCase();
              break;
          }
        });
      }

      fullValues.m = this.formatValue('m', this.minute);
      fullValues.mm = this.formatValue('mm', this.minute);
      fullValues.s = this.formatValue('s', this.second);
      fullValues.ss = this.formatValue('ss', this.second);
      this.fullValues = fullValues; // On lazy mode, emit `input` and `change` events only when:
      // - The user pick a new value and then close the dropdown
      // - The user click the ("x") clear button

      if (!this.lazy || forceEmit) {
        this.emitTimeValue();
      }

      if (this.closeOnComplete && this.allValueSelected && this.showDropdown) {
        this.toggleActive();
      }
    },
    emitTimeValue: function emitTimeValue() {
      if (!this.fullValues) {
        return;
      }

      if (this.lazy && this.bakDisplayTime === this.displayTime) {
        if (this.debugMode) {
          this.debugLog('The value does not change on `lazy` mode. Skip the emitting `input` and `change` event.');
        }

        return;
      }

      var fullValues = JSON.parse(JSON.stringify(this.fullValues));

      if (this.useStringValue) {
        this.$emit('input', this.inputIsEmpty ? '' : String(this.displayTime));
      } else {
        var tokensInUse = this.inUse.tokens || [];
        var timeValue = {};
        tokensInUse.forEach(function (token) {
          timeValue[token] = fullValues[token] || '';
        });
        this.$emit('input', JSON.parse(JSON.stringify(timeValue)));
      }

      this.$emit('change', {
        data: fullValues,
        displayTime: this.inputIsEmpty ? '' : String(this.displayTime)
      });
    },
    translate12hRange: function translate12hRange(value) {
      var valueT = this.match12hRange(value);

      if (+valueT[1] === 12) {
        return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 0 : 12);
      }

      return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 12 : 0);
    },
    isDisabled: function isDisabled(type, value) {
      if (!this.isBasicType(type) || !this.inUse[type]) {
        return true;
      }

      switch (type) {
        case 'hour':
          return this.isDisabledHour(value);

        case 'minute':
        case 'second':
          if (!this["".concat(type, "RangeList")]) {
            return false;
          }

          return !this["".concat(type, "RangeList")].includes(value);

        case 'apm':
          if (!this.restrictedHourRange) {
            return false;
          }

          return !this.has[this.lowerCasedApm(value)];

        default:
          return true;
      }
    },
    isDisabledHour: function isDisabledHour(value) {
      if (!this.restrictedHourRange) {
        return false;
      }

      if (this.baseOn12Hours) {
        if (!this.apm || !this.apm.length) {
          return false;
        } else {
          var token = this.apm.toLowerCase() === 'am' ? 'a' : 'p';
          return !this.restrictedHourRange.includes("".concat(+value).concat(token));
        }
      } // Fallback for 'HH' and 'H hour format with a `hour-range` in a 12-hour form


      if ((this.hourType === 'HH' || this.hourType === 'H') && +value === 0 && this.restrictedHourRange.includes(24)) {
        return false;
      }

      return !this.restrictedHourRange.includes(+value);
    },
    notInInterval: function notInInterval(section, value) {
      if (!section || !this.isMinuteOrSecond(section)) {
        return;
      }

      if (this.opts["".concat(section, "Interval")] === 1) {
        return false;
      }

      return +value % this.opts["".concat(section, "Interval")] !== 0;
    },
    renderRangeList: function renderRangeList(rawRange, section) {
      var _this10 = this;

      if (!rawRange || !section || !this.isMinuteOrSecond(section)) {
        return [];
      }

      var range = [];
      var formatedValue;
      rawRange.forEach(function (value) {
        if (value instanceof Array) {
          if (value.length > 2 && _this10.debugMode) {
            _this10.debugLog("Nested array within \"".concat(section, "-range\" must contain no more than two items. Only the first two items of ").concat(JSON.stringify(value), " will be taken into account."));
          }

          var start = value[0];
          var end = value[1] || value[0];

          for (var i = +start; i <= +end; i++) {
            if (i < 0 || i > 59) {
              continue;
            }

            formatedValue = _this10.formatValue(_this10.getTokenByType(section), i);

            if (!range.includes(formatedValue)) {
              range.push(formatedValue);
            }
          }
        } else {
          if (+value < 0 || +value > 59) {
            return;
          }

          formatedValue = _this10.formatValue(_this10.getTokenByType(section), value);

          if (!range.includes(formatedValue)) {
            range.push(formatedValue);
          }
        }
      });
      range.sort(function (l, r) {
        return l - r;
      }); // Debug Mode

      if (this.debugMode) {
        var fullList = (section === 'minute' ? this.minutes : this.seconds) || [];
        var validItems = fullList.filter(function (item) {
          return range.includes(item);
        });

        if (!validItems || !validItems.length) {
          if (section === 'minute') {
            this.debugLog("The minute list is empty due to the \"minute-range\" config\nminute-range: ".concat(JSON.stringify(this.minuteRange), "\nminute-interval: ").concat(this.opts.minuteInterval));
          } else {
            this.debugLog("The second list is empty due to the \"second-range\" config\nsecond-range: ".concat(JSON.stringify(this.secondRange), "\nsecond-interval: ").concat(this.opts.secondInterval));
          }
        }
      }

      return range;
    },
    forceApmSelection: function forceApmSelection() {
      if (this.manualInput) {
        // Skip this to allow users to paste a string value from the clipboard in Manual Input mode
        return;
      }

      if (this.apmType && !this.apm) {
        if (this.has.am || this.has.pm) {
          this.doClearApmChecking = true;
          var apmValue = this.has.am ? 'am' : 'pm';
          this.apm = this.apmType === 'A' ? apmValue.toUpperCase() : apmValue;
        }
      }
    },
    emptyApmSelection: function emptyApmSelection() {
      if (this.doClearApmChecking && this.hour === '' && this.minute === '' && this.second === '') {
        this.apm = '';
      }

      this.doClearApmChecking = false;
    },
    apmDisplayText: function apmDisplayText(apmValue) {
      if (this.amText && this.lowerCasedApm(apmValue) === 'am') {
        return this.amText;
      }

      if (this.pmText && this.lowerCasedApm(apmValue) === 'pm') {
        return this.pmText;
      }

      return apmValue;
    },
    toggleActive: function toggleActive() {
      var _this11 = this;

      if (this.disabled) {
        return;
      }

      this.isActive = !this.isActive;

      if (this.isActive) {
        this.isFocusing = true;

        if (this.manualInput) {
          this.$emit('focus');
        }

        if (!this.opts.hideDropdown) {
          this.setDropdownState(true);
        } // Record to check if value did change in the later phase


        if (this.lazy) {
          this.bakDisplayTime = String(this.displayTime || '');
        }

        if (this.manualInput && !this.inputIsEmpty) {
          this.$nextTick(function () {
            if (_this11.$refs.input && _this11.$refs.input.selectionStart === 0 && _this11.$refs.input.selectionEnd === _this11.displayTime.length) {
              // Select the first slot instead of the whole value string when tabbed in
              _this11.selectFirstSlot();
            }
          });
        }
      } else {
        if (this.showDropdown) {
          this.setDropdownState(false);
        } else if (this.manualInput) {
          this.$emit('blur');
        }

        this.isFocusing = false;

        if (this.lazy) {
          this.fillValues(true);
          this.bakDisplayTime = undefined;
        }
      }

      if (this.restrictedHourRange && this.baseOn12Hours) {
        this.showDropdown ? this.forceApmSelection() : this.emptyApmSelection();
      }

      if (this.showDropdown) {
        this.checkForAutoScroll();
      }
    },
    setDropdownState: function setDropdownState(toShow) {
      var fromUserClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (toShow) {
        this.keepFocusing();

        if (this.autoDirectionEnabled) {
          this.checkDropDirection();
        }

        this.showDropdown = true;
        this.$emit('open');

        if (fromUserClick) {
          if (this.fixedDropdownButton) {
            this.isActive = true;
          }

          this.$emit('blur');
          this.checkForAutoScroll();
        }
      } else {
        this.showDropdown = false;
        this.$emit('close');
      }
    },
    blurEvent: function blurEvent() {
      if (this.manualInput && !this.opts.hideDropdown) {
        // hideDropdown's `blur` event is handled somewhere else
        this.$emit('blur');
      }
    },
    select: function select(type, value) {
      if (this.isBasicType(type) && !this.isDisabled(type, value)) {
        this[type] = value;

        if (this.doClearApmChecking) {
          this.doClearApmChecking = false;
        }
      }
    },
    clearTime: function clearTime() {
      if (this.disabled) {
        return;
      }

      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';

      if (this.manualInput && this.$refs && this.$refs.input && this.$refs.input.value.length) {
        this.$refs.input.value = '';
      }

      if (this.lazy) {
        this.fillValues(true);
      }
    },
    //
    // Auto-Scroll
    //
    checkForAutoScroll: function checkForAutoScroll() {
      var _this12 = this;

      if (this.inputIsEmpty) {
        return;
      }

      if (this.autoScroll) {
        this.$nextTick(function () {
          _this12.scrollToSelectedValues();
        });
      } else if (this.advancedKeyboard) {
        // Auto-focus on selected value in the first column for advanced-keyboard
        this.$nextTick(function () {
          var firstColumn = _this12.inUse.types[0];

          _this12.scrollToSelected(firstColumn, true);
        });
      }
    },
    scrollToSelected: function scrollToSelected(column) {
      var allowFallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.timeValue || this.inputIsEmpty) {
        return;
      }

      var targetList = this.$el.querySelectorAll("ul.".concat(column, "s"))[0];
      var targetValue = this.activeItemInCol(column)[0];

      if (!targetValue && allowFallback) {
        // No value selected in the target column, fallback to the first found valid item
        targetValue = this.validItemsInCol(column)[0];
      }

      if (targetList && targetValue) {
        targetList.scrollTop = targetValue.offsetTop || 0;

        if (this.advancedKeyboard) {
          targetValue.focus();
        }
      }
    },
    scrollToSelectedValues: function scrollToSelectedValues() {
      var _this13 = this;

      if (!this.timeValue || this.inputIsEmpty) {
        return;
      }

      this.inUse.types.forEach(function (section) {
        _this13.scrollToSelected(section);
      });
    },
    //
    // Additional Keyboard Navigation
    //
    onFocus: function onFocus() {
      if (this.disabled) {
        return;
      }

      if (!this.isFocusing) {
        this.isFocusing = true;
      }

      if (!this.isActive) {
        this.toggleActive();
      }
    },
    escBlur: function escBlur() {
      if (this.disabled) {
        return;
      }

      window.clearTimeout(this.debounceTimer);
      this.isFocusing = false;
      var inputBox = this.$el.querySelectorAll('input.display-time')[0];

      if (inputBox) {
        inputBox.blur();
      }
    },
    debounceBlur: function debounceBlur() {
      var _this14 = this;

      if (this.disabled) {
        return;
      }

      this.isFocusing = false;
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(function () {
        window.clearTimeout(_this14.debounceTimer);

        _this14.onBlur();
      }, this.opts.blurDelay);
    },
    onBlur: function onBlur() {
      if (!this.disabled && !this.isFocusing && this.isActive) {
        this.toggleActive();
      }
    },
    keepFocusing: function keepFocusing() {
      if (this.disabled) {
        return;
      }

      window.clearTimeout(this.debounceTimer);

      if (!this.isFocusing) {
        this.isFocusing = true;
      }
    },
    validItemsInCol: function validItemsInCol(column) {
      var columnClass = "".concat(column, "s");
      return this.$el.querySelectorAll("ul.".concat(columnClass, " > li:not(.hint):not([disabled])"));
    },
    activeItemInCol: function activeItemInCol(column) {
      var columnClass = "".concat(column, "s");
      return this.$el.querySelectorAll("ul.".concat(columnClass, " > li.active:not(.hint)"));
    },
    getClosestSibling: function getClosestSibling(column, dataKey) {
      var getPrevious = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var siblingsInCol = this.validItemsInCol(column);
      var selfIndex = Array.prototype.findIndex.call(siblingsInCol, function (sbl) {
        return sbl.getAttribute('data-key') === dataKey;
      }); // Already the first item

      if (getPrevious && selfIndex === 0) {
        return siblingsInCol[siblingsInCol.length - 1];
      } // Already the last item


      if (!getPrevious && selfIndex === siblingsInCol.length - 1) {
        return siblingsInCol[0];
      } // Selected value not in the valid values list


      if (selfIndex < 0) {
        return siblingsInCol[0];
      }

      if (getPrevious) {
        return siblingsInCol[selfIndex - 1];
      }

      return siblingsInCol[selfIndex + 1];
    },
    prevItem: function prevItem(column, dataKey) {
      var isManualInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var targetItem = this.getClosestSibling(column, dataKey, true);

      if (targetItem) {
        return isManualInput ? targetItem : targetItem.focus();
      }
    },
    nextItem: function nextItem(column, dataKey) {
      var isManualInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var targetItem = this.getClosestSibling(column, dataKey, false);

      if (targetItem) {
        return isManualInput ? targetItem : targetItem.focus();
      }
    },
    getSideColumnName: function getSideColumnName(currentColumn) {
      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var currentColumnIndex = this.inUse.types.indexOf(currentColumn);

      if (toLeft && currentColumnIndex <= 0) {
        if (this.debugMode) {
          this.debugLog('You\'re in the leftmost list already');
        }

        return;
      } else if (!toLeft && currentColumnIndex === this.inUse.types.length - 1) {
        if (this.debugMode) {
          this.debugLog('You\'re in the rightmost list already');
        }

        return;
      }

      return this.inUse.types[toLeft ? currentColumnIndex - 1 : currentColumnIndex + 1];
    },
    getFirstItemInSideColumn: function getFirstItemInSideColumn(currentColumn) {
      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var targetColumn = this.getSideColumnName(currentColumn, toLeft);

      if (!targetColumn) {
        return;
      }

      var listItems = this.validItemsInCol(targetColumn);

      if (listItems && listItems[0]) {
        return listItems[0];
      }
    },
    getActiveItemInSideColumn: function getActiveItemInSideColumn(currentColumn) {
      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var targetColumn = this.getSideColumnName(currentColumn, toLeft);

      if (!targetColumn) {
        return;
      }

      var activeItems = this.activeItemInCol(targetColumn);

      if (activeItems && activeItems[0]) {
        return activeItems[0];
      }
    },
    toLeftColumn: function toLeftColumn(currentColumn) {
      var targetItem = this.getActiveItemInSideColumn(currentColumn, true) || this.getFirstItemInSideColumn(currentColumn, true);

      if (targetItem) {
        targetItem.focus();
      }
    },
    toRightColumn: function toRightColumn(currentColumn) {
      var targetItem = this.getActiveItemInSideColumn(currentColumn, false) || this.getFirstItemInSideColumn(currentColumn, false);

      if (targetItem) {
        targetItem.focus();
      }
    },
    //
    // Manual Input
    //
    onMouseDown: function onMouseDown() {
      var _this15 = this;

      if (!this.manualInput) {
        return;
      }

      window.clearTimeout(this.selectionTimer);
      this.selectionTimer = window.setTimeout(function () {
        window.clearTimeout(_this15.selectionTimer);

        if (_this15.$refs && _this15.$refs.input) {
          var nearestSlot = _this15.getNearestChunkByPos(_this15.$refs.input.selectionStart || 0);

          _this15.debounceSetInputSelection(nearestSlot);
        }
      }, 50);
    },
    keyDownHandler: function keyDownHandler(evt) {
      if (evt.isComposing || evt.keyCode === 229) {
        // Skip IME inputs
        evt.preventDefault();
        evt.stopPropagation();
        return false;
      } // Numbers


      if (evt.keyCode >= 48 && evt.keyCode <= 57 || evt.keyCode >= 96 && evt.keyCode <= 105) {
        evt.preventDefault();
        this.keyboardInput(evt.key); // A|P|M
      } else if ([65, 80, 77].includes(evt.keyCode)) {
        evt.preventDefault();
        this.keyboardInput(evt.key, true); // Arrow keys
      } else if (evt.keyCode >= 37 && evt.keyCode <= 40) {
        evt.preventDefault();
        this.clearKbInputLog();
        this.arrowHandler(evt); // Delete|Backspace
      } else if (evt.keyCode === 8 || evt.keyCode === 46) {
        evt.preventDefault();
        this.clearKbInputLog();
        this.clearTime(); // Tab
      } else if (evt.keyCode === 9) {
        this.clearKbInputLog();
        this.tabHandler(evt); // Prevent any Non-ESC and non-pasting inputs
      } else if (evt.keyCode !== 27 && !(evt.metaKey || evt.ctrlKey)) {
        evt.preventDefault();
      }
    },
    onCompostionStart: function onCompostionStart(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.bakCurrentPos = this.getCurrentTokenChunk();
      return false;
    },
    onCompostionEnd: function onCompostionEnd(evt) {
      var _this16 = this;

      evt.preventDefault();
      evt.stopPropagation();
      var cpsData = evt.data;
      var inputIsCustomApmText = false;

      if (this.has.customApmText) {
        inputIsCustomApmText = this.isCustomApmText(cpsData);
      }

      if (inputIsCustomApmText) {
        this.setSanitizedValueToSection('apm', inputIsCustomApmText);
      }

      this.$refs.input.value = this.has.customApmText ? this.customDisplayTime : this.displayTime;
      this.$nextTick(function () {
        if (_this16.bakCurrentPos) {
          var bakPos = JSON.parse(JSON.stringify(_this16.bakCurrentPos));

          if (inputIsCustomApmText) {
            bakPos.end = bakPos.start + cpsData.length;
          }

          _this16.debounceSetInputSelection(bakPos);

          _this16.bakCurrentPos = null;
        }
      });
      return false;
    },
    pasteHandler: function pasteHandler(evt) {
      evt.preventDefault();
      var pastingText = (evt.clipboardData || window.clipboardData).getData('text');

      if (this.debugMode) {
        this.debugLog("Pasting value \"".concat(pastingText, "\" from clipboard"));
      }

      if (!pastingText || !pastingText.length) {
        return;
      } // Replace custom AM/PM text (if any)


      if (this.has.customApmText) {
        pastingText = this.replaceCustomApmText(pastingText);
      }

      if (this.inputIsEmpty) {
        this.readStringValues(pastingText);
      } else {
        this.kbInputLog = pastingText.substr(-2, 2);
        this.setKbInput();
        this.debounceClearKbLog();
      }
    },
    arrowHandler: function arrowHandler(evt) {
      var direction = {
        37: 'L',
        38: 'U',
        39: 'R',
        40: 'D'
      }[evt.keyCode];

      if (direction === 'U' || direction === 'D') {
        if (this.inputIsEmpty) {
          this.selectFirstValidValue();
        } else {
          var currentChunk = this.getCurrentTokenChunk();

          if (!currentChunk) {
            this.selectFirstValidValue();
            return;
          }

          var tokenType = currentChunk.type;
          this.getClosestValidItemInCol(tokenType, this[tokenType], direction);
          var newChunkPos = this.getCurrentTokenChunk();
          this.debounceSetInputSelection(newChunkPos);
        }
      } else if (direction === 'R') {
        this.toLateralToken(false);
      } else if (direction === 'L') {
        this.toLateralToken(true);
      }
    },
    tabHandler: function tabHandler(evt) {
      if (!this.inputIsEmpty && this.tokenChunksPos && this.tokenChunksPos.length) {
        var currentChunk = this.getCurrentTokenChunk();

        if (!currentChunk) {
          return;
        }

        var firstChunk = this.tokenChunksPos[0];
        var lastChunk = this.tokenChunksPos[this.tokenChunksPos.length - 1];

        if (evt.shiftKey && currentChunk.token !== firstChunk.token || !evt.shiftKey && currentChunk.token !== lastChunk.token) {
          evt.preventDefault();
          this.toLateralToken(evt.shiftKey);
        }
      }
    },
    keyboardInput: function keyboardInput(newChar) {
      var isApm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var currentChunk = this.getCurrentTokenChunk();

      if (!currentChunk || currentChunk.type !== 'apm' && isApm || currentChunk.type === 'apm' && !isApm) {
        return;
      }

      this.kbInputLog = "".concat(this.kbInputLog.substr(-1)).concat(newChar);
      this.setKbInput();
      this.debounceClearKbLog();
    },
    clearKbInputLog: function clearKbInputLog() {
      window.clearTimeout(this.kbInputTimer);
      this.kbInputLog = '';
    },
    debounceClearKbLog: function debounceClearKbLog() {
      var _this17 = this;

      window.clearTimeout(this.kbInputTimer);
      this.kbInputTimer = window.setTimeout(function () {
        _this17.clearKbInputLog();
      }, this.opts.manualInputTimeout);
    },
    setKbInput: function setKbInput(value) {
      value = value || this.kbInputLog;
      var currentChunk = this.getCurrentTokenChunk();

      if (!currentChunk || !value || !value.length) {
        return;
      }

      var chunkType = currentChunk.type;
      var chunkToken = currentChunk.token;
      var validValue;

      if (chunkType === 'apm') {
        if (this.lowerCasedApm(value).includes('a')) {
          validValue = 'am';
        } else if (this.lowerCasedApm(value).includes('p')) {
          validValue = 'pm';
        }

        if (validValue) {
          validValue = chunkToken === 'A' ? validValue.toUpperCase() : validValue;
        }
      } else {
        if (this.isValidValue(chunkToken, value)) {
          validValue = value;
        } else {
          var lastInputValue = this.formatValue(chunkToken, value.substr(-1));

          if (this.isValidValue(chunkToken, lastInputValue)) {
            validValue = lastInputValue;
          }
        }
      }

      if (validValue) {
        this.setSanitizedValueToSection(chunkType, validValue);
        var newChunkPos = this.getCurrentTokenChunk();
        this.debounceSetInputSelection(newChunkPos);
      }

      if (this.debugMode) {
        if (validValue) {
          this.debugLog("Successfully set value \"".concat(validValue, "\" from latest input \"").concat(value, "\" for the \"").concat(chunkType, "\" slot"));
        } else {
          this.debugLog("Value \"".concat(value, "\" is invalid in the \"").concat(chunkType, "\" slot"));
        }
      }
    },
    // Form Autofill
    onChange: function onChange() {
      if (!this.manualInput || !this.$refs || !this.$refs.input) {
        return;
      }

      var autoFillValue = this.$refs.input.value || '';

      if (autoFillValue && autoFillValue.length) {
        this.readStringValues(autoFillValue);
      }
    },
    getNearestChunkByPos: function getNearestChunkByPos(startPos) {
      if (!this.tokenChunksPos || !this.tokenChunksPos.length) {
        return;
      }

      var nearest;
      var nearestDelta = -1;

      for (var i = 0; i < this.tokenChunksPos.length; i++) {
        var chunk = JSON.parse(JSON.stringify(this.tokenChunksPos[i]));

        if (chunk.start === startPos) {
          return chunk;
        }

        var delta = Math.abs(chunk.start - startPos);

        if (nearestDelta < 0) {
          nearest = chunk;
          nearestDelta = delta;
        } else {
          if (nearestDelta <= delta) {
            return nearest;
          }

          nearestDelta = delta;
          nearest = chunk;
        }
      }

      return nearest;
    },
    selectFirstValidValue: function selectFirstValidValue() {
      if (!this.tokenChunksPos || !this.tokenChunksPos.length) {
        return;
      }

      var firstSlotType = this.tokenChunksPos[0].type;

      if (firstSlotType === 'hour') {
        this.getClosestHourItem();
      } else {
        this.getClosestValidItemInCol(firstSlotType, this[firstSlotType]);
      }

      this.selectFirstSlot();
    },
    getClosestHourItem: function getClosestHourItem(currentValue) {
      var _this18 = this;

      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'U';

      if (!this.validHoursList || !this.validHoursList.length) {
        if (this.debugMode) {
          this.debugLog("No valid hour values found, please check your \"hour-range\" config\nhour-range: ".concat(JSON.stringify(this.hourRange)));
        }

        return;
      }

      if (!currentValue) {
        this.setManualHour(this.validHoursList[0]);
        return;
      }

      var currentIndex = this.validHoursList.findIndex(function (item) {
        if (!_this18.baseOn12Hours) {
          return item === currentValue;
        } else {
          var valueKey = "".concat(currentValue).concat(_this18.lowerCasedApm(_this18.apm) === 'pm' ? 'p' : 'a');
          return item === valueKey;
        }
      });
      var nextIndex;

      if (currentIndex === -1) {
        nextIndex = 0;
      } else if (direction === 'D') {
        nextIndex = currentIndex === 0 ? this.validHoursList.length - 1 : currentIndex - 1;
      } else {
        nextIndex = (currentIndex + 1) % this.validHoursList.length;
      }

      var nextItem = this.validHoursList[nextIndex];
      this.setManualHour(nextItem);
    },
    getClosestValidItemInCol: function getClosestValidItemInCol(column, currentValue) {
      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'U';

      if (column === 'hour') {
        this.getClosestHourItem(currentValue, direction);
      } else {
        var nextItem = direction === 'D' ? this.prevItem(column, this[column], true) : this.nextItem(column, this[column], true);

        if (nextItem) {
          this.select(column, nextItem.getAttribute('data-key'));
        }
      }
    },
    setSanitizedValueToSection: function setSanitizedValueToSection(section, inputValue) {
      if (!section || !this.getTokenByType(section)) {
        return;
      } // NOTE: Disabled values are allowed here, followed by an 'error' event, though


      var sanitizedValue = this.sanitizedValue(this.getTokenByType(section), inputValue);
      this[section] = sanitizedValue;
    },
    setManualHour: function setManualHour(nextItem) {
      if (this.is12hRange(nextItem)) {
        var hourT = this.match12hRange(nextItem);
        var apmValue = hourT[2] === 'a' ? 'AM' : 'PM';
        this.setSanitizedValueToSection('apm', this.apmType === 'a' ? apmValue.toLowerCase() : apmValue);
        this.setSanitizedValueToSection('hour', hourT[1]);
      } else {
        this.setSanitizedValueToSection('hour', nextItem);
      }
    },
    debounceSetInputSelection: function debounceSetInputSelection(_ref) {
      var _this19 = this;

      var _ref$start = _ref.start,
          start = _ref$start === void 0 ? 0 : _ref$start,
          _ref$end = _ref.end,
          end = _ref$end === void 0 ? 0 : _ref$end;
      this.$nextTick(function () {
        _this19.setInputSelectionRange(start, end);
      });
      window.clearTimeout(this.selectionTimer);
      this.selectionTimer = window.setTimeout(function () {
        window.clearTimeout(_this19.selectionTimer); // Double-check selection for 12hr format

        if (_this19.$refs.input && (_this19.$refs.input.selectionStart !== start || _this19.$refs.input.selectionEnd !== end)) {
          _this19.setInputSelectionRange(start, end);
        }
      }, 30);
    },
    setInputSelectionRange: function setInputSelectionRange(start, end) {
      if (this.$refs && this.$refs.input) {
        this.$refs.input.setSelectionRange(start, end);
      }
    },
    getCurrentTokenChunk: function getCurrentTokenChunk() {
      return this.getNearestChunkByPos(this.$refs.input && this.$refs.input.selectionStart || 0);
    },
    selectFirstSlot: function selectFirstSlot() {
      var firstChunkPos = this.getNearestChunkByPos(0);
      this.debounceSetInputSelection(firstChunkPos);
    },
    toLateralToken: function toLateralToken(toLeft) {
      var currentChunk = this.getCurrentTokenChunk();

      if (!currentChunk) {
        this.selectFirstValidValue();
        return;
      }

      var currentChunkIndex = this.tokenChunksPos.findIndex(function (chk) {
        return chk.token === currentChunk.token;
      });

      if (!toLeft && currentChunkIndex >= this.tokenChunksPos.length - 1 || toLeft && currentChunkIndex === 0) {
        if (this.debugMode) {
          if (toLeft) {
            this.debugLog('You\'re in the leftmost slot already');
          } else {
            this.debugLog('You\'re in the rightmost slot already');
          }
        }

        return;
      }

      var targetSlotPos = toLeft ? this.tokenChunksPos[currentChunkIndex - 1] : this.tokenChunksPos[currentChunkIndex + 1];
      this.debounceSetInputSelection(targetSlotPos);
    },
    isCustomApmText: function isCustomApmText(inputData) {
      if (!inputData || !inputData.length) {
        return false;
      }

      if (this.amText && this.amText === inputData) {
        return this.apmType === 'A' ? 'AM' : 'am';
      }

      if (this.pmText && this.pmText === inputData) {
        return this.apmType === 'A' ? 'PM' : 'pm';
      }

      return false;
    },
    replaceCustomApmText: function replaceCustomApmText(inputString) {
      if (this.amText && this.amText.length && inputString.includes(this.amText)) {
        return inputString.replace(new RegExp(this.amText, 'g'), this.apmType === 'A' ? 'AM' : 'am');
      } else if (this.pmText && this.pmText.length && inputString.includes(this.pmText)) {
        return inputString.replace(new RegExp(this.pmText, 'g'), this.apmType === 'A' ? 'PM' : 'pm');
      }

      return inputString;
    },
    checkDropDirection: function checkDropDirection() {
      if (!this.$el) {
        return;
      }

      var container;

      if (this.containerId && this.containerId.length) {
        container = document.getElementById(this.containerId);

        if (!container && this.debugMode) {
          this.debugLog("Container with id \"".concat(this.containerId, "\" not found. Fallback to document body."));
        }
      }

      var el = this.$el;
      var spaceDown;

      if (container && container.offsetHeight) {
        // Valid container found
        spaceDown = container.offsetTop + container.offsetHeight - (el.offsetTop + el.offsetHeight);
      } else {
        // Fallback to document body
        var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
        spaceDown = docHeight - (el.offsetTop + el.offsetHeight);
      }

      this.forceDropOnTop = this.opts.dropOffsetHeight > spaceDown;
    },
    //
    // Helpers
    //
    is12hRange: function is12hRange(value) {
      return /^\d{1,2}(a|p|A|P)$/.test(value);
    },
    match12hRange: function match12hRange(value) {
      return value.match(/^(\d{1,2})(a|p|A|P)$/);
    },
    isNumber: function isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    isBasicType: function isBasicType(type) {
      return CONFIG.BASIC_TYPES.includes(type);
    },
    lowerCasedApm: function lowerCasedApm(apmValue) {
      return (apmValue || '').toLowerCase();
    },
    getTokenRegex: function getTokenRegex(token) {
      switch (token) {
        case 'HH':
          return '([01][0-9]|2[0-3]|H{2})';

        case 'H':
          return '([0-9]{1}|1[0-9]|2[0-3]|H{1})';

        case 'hh':
          return '(0[1-9]|1[0-2]|h{2})';

        case 'h':
          return '([1-9]{1}|1[0-2]|h{1})';

        case 'kk':
          return '(0[1-9]|1[0-9]|2[0-4]|k{2})';

        case 'k':
          return '([1-9]{1}|1[0-9]|2[0-4]|k{1})';

        case 'mm':
          return '([0-5][0-9]|m{2})';

        case 'ss':
          return '([0-5][0-9]|s{2})';

        case 'm':
          return '([0-9]{1}|[1-5][0-9]|m{1})';

        case 's':
          return '([0-9]{1}|[1-5][0-9]|s{1})';

        case 'A':
          return '(AM|PM|A{1})';

        case 'a':
          return '(am|pm|a{1})';

        default:
          return '';
      }
    },
    isEmptyValue: function isEmptyValue(targetToken, testValue) {
      return !testValue || !testValue.length || testValue && testValue === targetToken;
    },
    isValidValue: function isValidValue(targetToken, testValue) {
      if (!targetToken || this.isEmptyValue(targetToken, testValue)) {
        return false;
      }

      var tokenRegexStr = this.getTokenRegex(targetToken);

      if (!tokenRegexStr || !tokenRegexStr.length) {
        return false;
      }

      return new RegExp("^".concat(tokenRegexStr, "$")).test(testValue);
    },
    sanitizedValue: function sanitizedValue(targetToken, inputValue) {
      if (this.isValidValue(targetToken, inputValue)) {
        return inputValue;
      }

      return '';
    },
    getTokenType: function getTokenType(token) {
      return this.inUse.types[this.inUse.tokens.indexOf(token)] || '';
    },
    getTokenByType: function getTokenByType(type) {
      return this["".concat(type, "Type")] || '';
    },
    isMinuteOrSecond: function isMinuteOrSecond(type) {
      return ['minute', 'second'].includes(type);
    },
    debugLog: function debugLog(logText) {
      var _this20 = this;

      if (!logText || !logText.length) {
        return;
      }

      var identifier = '';

      if (this.id) {
        identifier += "#".concat(this.id);
      }

      if (this.name) {
        identifier += "[name=".concat(this.name, "]");
      }

      if (this.inputClass) {
        var inputClasses = [];

        if (typeof this.inputClass === 'string') {
          inputClasses = this.inputClass.split(/\s/g);
        } else if (Array.isArray(this.inputClass)) {
          inputClasses = [].concat([], this.inputClass);
        } else if (_typeof(this.inputClass) === 'object') {
          Object.keys(this.inputClass).forEach(function (clsName) {
            if (_this20.inputClass[clsName]) {
              inputClasses.push(clsName);
            }
          });
        }

        var _iterator4 = _createForOfIteratorHelper(inputClasses),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var inputClass = _step4.value;

            if (inputClass && inputClass.trim().length) {
              identifier += ".".concat(inputClass.trim());
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      var finalLogText = "DEBUG: ".concat(logText).concat(identifier ? "\n\t(".concat(identifier, ")") : '');

      if (window.console.debug && typeof window.console.debug === 'function') {
        window.console.debug(finalLogText);
      } else {
        window.console.log(finalLogText);
      }
    }
  },
  mounted: function mounted() {
    window.clearTimeout(this.debounceTimer);
    window.clearTimeout(this.selectionTimer);
    window.clearTimeout(this.kbInputTimer);
    this.renderFormat();
  },
  beforeDestroy: function beforeDestroy() {
    window.clearTimeout(this.debounceTimer);
    window.clearTimeout(this.selectionTimer);
    window.clearTimeout(this.kbInputTimer);
  }
});
// CONCATENATED MODULE: ./src/vue-timepicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_vue_timepickervue_type_script_lang_js_ = (vue_timepickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/vue-timepicker.vue?vue&type=style&index=0&lang=css&
var vue_timepickervue_type_style_index_0_lang_css_ = __webpack_require__("aab0");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/vue-timepicker.vue






/* normalize component */

var component = normalizeComponent(
  src_vue_timepickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vue_timepicker = (component.exports);
// CONCATENATED MODULE: ./src/index.js

/* harmony default export */ var src_0 = (vue_timepicker);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fd6f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=VueTimepicker.common.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(743);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b27f310e", content, true, {});

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".vue__time-picker{display:inline-block;position:relative;font-size:1em;width:10em;font-family:sans-serif;vertical-align:middle}.vue__time-picker *{-webkit-box-sizing:border-box;box-sizing:border-box}.vue__time-picker input.display-time{border:1px solid #d2d2d2;width:10em;height:2.2em;padding:.3em .5em;font-size:1em}.vue__time-picker input.has-custom-icon{padding-left:1.8em}.vue__time-picker input.display-time.invalid:not(.skip-error-style){border-color:#c03;outline-color:#c03}.vue__time-picker input.display-time.disabled,.vue__time-picker input.display-time:disabled{color:#d2d2d2}.vue__time-picker .controls{position:absolute;top:0;bottom:0;right:0;z-index:3;-webkit-box-orient:horizontal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;pointer-events:none}.vue__time-picker .controls,.vue__time-picker .controls>*{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}.vue__time-picker .controls>*{cursor:pointer;width:auto;-webkit-box-orient:vertical;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 .35em;color:#d2d2d2;line-height:100%;font-style:normal;pointer-events:auto;-webkit-transition:color .2s,opacity .2s;transition:color .2s,opacity .2s}.vue__time-picker .controls>:hover{color:#797979}.vue__time-picker .controls>:active,.vue__time-picker .controls>:focus{outline:0}.vue__time-picker .controls .char{font-size:1.1em;line-height:100%;-webkit-margin-before:-.15em}.vue__time-picker .custom-icon{z-index:2;position:absolute;left:0;top:0;bottom:0;width:1.8em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;pointer-events:none}.vue__time-picker .controls img,.vue__time-picker .controls svg,.vue__time-picker .custom-icon img,.vue__time-picker .custom-icon svg{display:inline-block;vertical-align:middle;margin:0;border:0;outline:0;max-width:1em;height:auto}.vue__time-picker .time-picker-overlay{z-index:4;position:fixed;top:0;left:0;right:0;bottom:0}.vue__time-picker .dropdown{position:absolute;z-index:5;top:calc(2.2em + 2px);left:0;background:#fff;-webkit-box-shadow:0 1px 6px rgba(0,0,0,.15);box-shadow:0 1px 6px rgba(0,0,0,.15);width:10em;height:10em;font-weight:400}.vue__time-picker .dropdown.drop-up{top:auto;bottom:calc(2.2em + 1px)}.vue__time-picker .dropdown .select-list{width:10em;height:10em;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.vue__time-picker .dropdown .select-list:active,.vue__time-picker .dropdown .select-list:focus{outline:0}.vue__time-picker .dropdown ul{padding:0;margin:0;list-style:none;outline:0;-webkit-box-flex:1;-ms-flex:1 1 0.00001px;flex:1 1 0.00001px;overflow-x:hidden;overflow-y:auto}.vue__time-picker .dropdown ul.apms,.vue__time-picker .dropdown ul.minutes,.vue__time-picker .dropdown ul.seconds{border-left:1px solid #fff}.vue__time-picker .dropdown ul li{list-style:none;text-align:center;padding:.3em 0;color:#161616}.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus,.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover{background:rgba(0,0,0,.08);color:#161616;cursor:pointer}.vue__time-picker .dropdown ul li:not([disabled]).active,.vue__time-picker .dropdown ul li:not([disabled]).active:focus,.vue__time-picker .dropdown ul li:not([disabled]).active:hover{background:#41b883;color:#fff}.vue__time-picker .dropdown ul li[disabled],.vue__time-picker .dropdown ul li[disabled]:hover{background:transparent;opacity:.3;cursor:not-allowed}.vue__time-picker .dropdown .hint{color:#a5a5a5;cursor:default;font-size:.8em}", ""]);

// exports


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',{staticClass:"time-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('vue-timepicker',{staticClass:"form-control",attrs:{"format":"HH:mm","disabled":_vm.isDisabled},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(
      (_vm.inputVal == null || _vm.inputVal.HH === '' || _vm.inputVal.mm === '') &&
        _vm.submitClicked &&
        _vm.isRequired &&
        !_vm.isDisabled
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._l((_vm.listDays),function(workday,index){return _c('div',{key:index,staticClass:"row placement-time-row"},[_c('div',{staticClass:"col-md-2 day-checkbox-container"},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.listDayCheck[index]),expression:"listDayCheck[index]"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":'workday' + index},domProps:{"checked":Array.isArray(_vm.listDayCheck[index])?_vm._i(_vm.listDayCheck[index],null)>-1:(_vm.listDayCheck[index])},on:{"change":[function($event){var $$a=_vm.listDayCheck[index],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.listDayCheck, index, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.listDayCheck, index, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.listDayCheck, index, $$c)}},function($event){return _vm.handleDataChange()}]}})]),_vm._v(" "),_c('label',{staticClass:"workday-label",attrs:{"for":'workday' + index}},[_vm._v(_vm._s(workday))])]),_vm._v(" "),_c('TimePickerWithLabel',{attrs:{"label":"From","classList":"col-md-5 time-from-container","isDisabled":_vm.listDayCheck[index] !== true,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.listFrom[index]),callback:function ($$v) {_vm.$set(_vm.listFrom, index, $$v)},expression:"listFrom[index]"}}),_vm._v(" "),_c('TimePickerWithLabel',{attrs:{"label":"To","classList":"col-md-5 time-to-container","isDisabled":_vm.listDayCheck[index] !== true,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.listTo[index]),callback:function ($$v) {_vm.$set(_vm.listTo, index, $$v)},expression:"listTo[index]"}})],1)}),_vm._v(" "),(!_vm.listDayCheck.includes(true) && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalaryRange_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a1254f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalaryRange_vue__ = __webpack_require__(749);
function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a1254f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalaryRange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a1254f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalaryRange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(748);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("ea1e5184", content, true, {});

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".day-checkbox-container[data-v-8a1254f6]{display:flex;align-items:center}.day-checkbox-container .form-check-input[data-v-8a1254f6]{margin-top:0}.workday-label[data-v-8a1254f6]{margin-bottom:.5em}@media only screen and (min-width:768px){.time-from-container[data-v-8a1254f6],.time-to-container[data-v-8a1254f6]{padding-left:2em}}", ""]);

// exports


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('TextBoxWithLabel',{attrs:{"classList":"col-lg-4","label":"From $","type":_vm.TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.rangeMin),callback:function ($$v) {_vm.rangeMin=$$v},expression:"rangeMin"}}),_vm._v(" "),_c('TextBoxWithLabel',{attrs:{"classList":"col-lg-4","label":"To $","type":_vm.TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.rangeMax),callback:function ($$v) {_vm.rangeMax=$$v},expression:"rangeMax"}}),_vm._v(" "),_c('RadioGroup',{attrs:{"classList":"col-lg-4","label":"Per","name":"per","optionList":_vm.$store.getters.salaryOptionList,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.salaryOption),callback:function ($$v) {_vm.salaryOption=$$v},expression:"salaryOption"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_MODEL_MAX_LENGTH; });
var DATA_MODEL_MAX_LENGTH = {
  email: 255,
  email2: 255,
  email_username: 255,
  username: 255,
  first_name: 255,
  last_name: 255,
  name: 255,
  phone: 255,
  phone2: 255,
  title: 255,
  present_employer: 255,
  status: 255,
  salary_range: 255,
  specialty_areas: 500,
  education_institution: 500,
  degree: 500,
  address1: 1024,
  address2: 1024,
  postal_code: 12,
  city: 1024,
  provincestate: 128,
  country: 40,
  website: 1024,
  facebook: 1024,
  twitter: 1024,
  instagram: 1024,
  youtube: 1024,
  linkedin: 1024,
  video: 1024,
  employer_name: 255,
  stripe_customer_id: 255,
  stripe_refresh_token: 255,
  stripe_connect_id: 255,
  organization_type: 255,
  size: 255,
  agency_owner: 255,
  second_status: 200,
  marketing_source: 255,
  bank: 255,
  bank_account_type: 255,
  bank_account_number: 255,
  bank_account_name: 255,
  government_ID_number: 255,
  social_security: 255,
  category: 255
};

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.listRowInput),function(rowInput,rowIndex){return _c('div',{key:'row' + rowIndex,class:{
      row: ![
        _vm.FORM_TYPE.ARRAY_OBJECT,
        _vm.FORM_TYPE.SLOT,
        _vm.FORM_TYPE.HEADER
      ].includes(rowInput[0].type)
    }},[_vm._l((rowInput),function(el,index){return [(_vm.isItemShow(_vm.modelData, el))?[(el.type === _vm.FORM_TYPE.ARRAY_OBJECT)?[(!isNaN(_vm.modelData[el.size]))?[_vm._l((Number(_vm.modelData[el.size])),function(childRowIndex){return [_c('FormGroupRowLayout',{key:'childRowIndex-' + childRowIndex,attrs:{"listFields":el.items,"modelData":_vm.modelData[el.model][childRowIndex - 1],"submitClicked":_vm.submitClicked}})]})]:_vm._e()]:(el.type === _vm.FORM_TYPE.HEADER)?[_c('h3',{key:'header' + rowIndex + index,staticClass:"header-section"},[(!el.isFirst)?_c('hr'):_vm._e(),_vm._v("\n            "+_vm._s(el.label)+"\n          ")])]:(el.type === _vm.FORM_TYPE.SLOT)?[_vm._t(el.name)]:[(el.type === _vm.FORM_TYPE.TEXTAREA)?_c('TextAreaWithLabel',{key:'textarea' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"rows":el.rows,"maxLength":_vm.getMaxLength(el),"description":el.description,"placeholder":el.placeholder,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CHECKBOX)?_c('CheckboxGroup',{key:'checkbox' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"name":el.model,"description":el.description,"optionList":el.optionList,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.RADIO)?_c('RadioGroup',{key:'radio' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"name":el.model,"description":el.description,"optionList":el.optionList,"hasOther":el.hasOther,"initialSelection":el.initialSelection,"isBooleanModel":el.isBooleanModel,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DROPDOWN)?_c('DropdownWithLabel',{key:'dropdown' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"name":el.model,"optionList":el.optionList,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DATEPICKER)?_c('DatePickerWithLabel',{key:'datepicker' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"initialView":el.initialView,"allowPastDate":el.allowPastDate,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DAY_HOURS_SELECTOR)?_c('DayHoursSelector',{key:'day-hours-selector' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"listDays":el.listDays,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.SALARY_RANGE)?_c('SalaryRange',{key:'salary-range' + rowIndex + index,attrs:{"label":el.label,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):_c('TextBoxWithLabel',{key:'textbox' + rowIndex + index,attrs:{"classList":_vm.getClassList(el.itemPerRow),"label":el.label,"maxLength":_vm.getMaxLength(el),"description":el.description,"type":el.inputType,"placeholder":el.placeholder,"validation":el.validation,"submitClicked":_vm.submitClicked,"isRequired":el.isRequired},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}})]]:_vm._e()]})],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 mb-4 field-of-fields",staticStyle:{"width":"75%","display":"block","margin-left":"auto","margin-right":"auto"}},[_c('a',{attrs:{"href":_vm.$store.getters.website}},[_c('img',{staticClass:"center",attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"width":"","height":_vm.$store.getters.logoHeight,"alt":_vm.$store.getters.agencyHumanName,"id":""}})]),_vm._v(" "),_c('h1',{staticClass:"center mt-5"},[_vm._v("Tiny Treasures Candidate Application")]),_vm._v(" "),_c('p',{staticClass:"center mb-4 form-note"},[_vm._v("\n      Please note that we encourage our clients to pay nannies on the books\n      and legally. You must be comfortable with this to be considered as a\n      candidate of TTNA.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("Personal Information")]),_vm._v(" "),_c('p',{staticClass:"text-require-notice"},[_vm._v("Fields marked with an * are required")]),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"listFields":_vm.$store.getters.candidatePersonalInfoListFields,"modelData":_vm.applicationData,"submitClicked":_vm.submitClicked}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("References")]),_vm._v(" "),_c('p',{staticClass:"text-require-notice"},[_vm._v("\n      You must enter at least 3 references. They will be contacted after your\n      interview with us.\n    ")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3 mb-3",on:{"click":function($event){return _vm.showAddReferenceDialog()}}},[_vm._v("\n      Add Reference\n    ")]),_vm._v(" "),_vm._l((_vm.listReferences),function(reference,index){return _c('div',{key:'ref' + index},[_c('hr',{staticClass:"ref-separator"}),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("\n        "+_vm._s(reference.name)+"\n        "),_c('img',{staticClass:"edit-button",attrs:{"src":__webpack_require__(36)},on:{"click":function($event){return _vm.showEditReferenceDialog(reference, index)}}})]),_vm._v(" "),_c('DetailSectionColumnLayout',{attrs:{"itemPerColumns":[5, 4],"modelData":reference,"listFields":_vm.$store.getters.referenceListFields,"listExcludeFields":['name']}})],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("Documents")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"4px"}},[_vm._v("Please upload your professional childcare resume! (PDF or Word doc only please!) *\n    ")]),_vm._v(" "),_c('input',{ref:"resume",staticClass:"form-control-file",attrs:{"type":"file","accept":"application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"},on:{"change":function($event){return _vm.handleUploadResume()}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"4px"}},[_vm._v("Please upload a recent photo of yourself! (PNG or JPG only please!) *\n    ")]),_vm._v(" "),_c('input',{ref:"profile_pic",staticClass:"form-control-file",attrs:{"type":"file","accept":"image/x-png,image/jpeg"},on:{"change":function($event){return _vm.handleUploadProfilePhoto()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"privacy-note"},[_vm._v("\n      Many of Tiny Treasures’ clients are prominent, well-known individuals in\n      the US. Their privacy is very important to them. Tiny Treasures may\n      require you as the candidate to sign a confidentiality form during the\n      interview process. Any job that Tiny Treasures places me on will be held\n      in the strictest confidence. This includes personal family matters as\n      well as the names, addresses and/or telephone numbers of family members.\n    ")]),_vm._v(" "),_c('p',{staticClass:"referral-service-note"},[_vm._v("\n      REFERRAL SERVICE: THERE IS ABSOLUTELY NO FEE TO BE A TINY TREASURES\n      CANDIDATE. APPLICANT UNDERSTANDS AND AGREES THAT TINY TREASURES IS\n      ACTING AS A REFERRAL SERVICE ONLY AND THE DECISION TO EMPLOY YOU IS FROM\n      TINY TREASURES CLIENT SEEKING HOUSEHOLD STAFFING SERVICES. APPLICANT\n      UNDERSTANDS AND AGREES THAT TINY TREASURES DOES NOT GUARANTEE\n      APPLICANT'S REFERRAL, PLACEMENT, EMPLOYMENT, COMPENSATION, OR TERMS OF\n      EMPLOYMENT.\n    ")]),_vm._v(" "),_c('div',{staticClass:"submit-button-section"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("\n        Submit\n      ")])])],2),_vm._v(" "),_c('ReferenceFormDialog',{attrs:{"reference":_vm.reference,"isAdd":_vm.isAddReferenceDialog},on:{"saved":function($event){return _vm.handleUpdateReferences($event)}},model:{value:(_vm.isShowReferenceFormDialog),callback:function ($$v) {_vm.isShowReferenceFormDialog=$$v},expression:"isShowReferenceFormDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141fba1e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(756);
function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-141fba1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141fba1e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(755);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("72c5f733", content, true, {});

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#dark-navbar[data-v-141fba1e]{display:none}.registration-form[data-v-141fba1e]{height:100vh;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-top:40px;padding-bottom:40px;background-color:#f5f5f5}.form-signup[data-v-141fba1e]{width:100%;max-width:330px;padding:15px;margin:auto}.form-signup .checkbox[data-v-141fba1e]{font-weight:400}.form-signup .form-control[data-v-141fba1e]{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.form-signup .form-control[data-v-141fba1e]:focus{z-index:2}.form-signup input[type=email][data-v-141fba1e],.form-signup input[type=text][data-v-141fba1e]{margin-bottom:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0}.form-signup input[type=text][data-v-141fba1e]{border-top-left-radius:0;border-top-right-radius:0}.form-signup input[type=password][data-v-141fba1e]{margin-bottom:10px;border-top-left-radius:0;border-top-right-radius:0}", ""]);

// exports


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center registration-form"},[_c('form',{staticClass:"form-signup",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h3',{ref:"pageTitle",staticClass:"mb-3 font-weight-normal",staticStyle:{"color":"var(--coredarkcolor)"}},[_vm._v("Organization Registration")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputEmail"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email","required":"","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"form-check mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.consent),expression:"consent"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.consent)?_vm._i(_vm.consent,true)>-1:(_vm.consent)},on:{"change":function($event){var $$a=_vm.consent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.consent=$$a.concat([$$v]))}else{$$i>-1&&(_vm.consent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.consent=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n        I consent to the "),_c('router-link',{attrs:{"to":{ name: 'Content', params: { slug: 'terms' } },"target":"_blank"}},[_vm._v("Terms & Conditions")]),_vm._v(" and "),_c('router-link',{attrs:{"to":{ name: 'Content', params: { slug: 'privacy' } },"target":"_blank"}},[_vm._v("Privacy Policy")])],1)]),_vm._v(" "),(_vm.consent)?_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Sign Up")]):_vm._e(),_vm._v(" "),(_vm.registrationError)?_c('p',{staticClass:"pt-2"},[_c('strong',[_vm._v("There is an error with your registration. You may already have an account with this email, try "),_c('router-link',{attrs:{"to":{ name: 'Login' }}},[_vm._v("logging in")]),_vm._v("!")],1)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pt-4",staticStyle:{"margin-bottom":"0"}},[_vm._v("Already have a profile? "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1),_vm._v(" "),_c('p',{staticClass:"pt-1"},[_c('router-link',{attrs:{"to":"/candidate-registration"}},[_vm._v("I'm looking for opportunities")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(758);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4d325bca", content, true, {});

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dashboard-button{border-right:2px solid #fff;padding-top:6px;padding-bottom:6px;cursor:pointer;font-family:articulatcf-demibold,Open Sans,Lato}.dashboard-button,.dashboard-button-active{background-color:var(--thrivehiregrey);color:var(--corelightcolor)}.dashboard-button-active{background-color:var(--coredarkcolor)}.slide-enter-active{animation:slide-in .3s ease-out forwards}.slide-leave-active{animation:slide-out .3s ease-out forwards}@keyframes slide-in{0%{transform:translateY(-30px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes slide-out{0%{transform:translateY(0);opacity:1}to{transform:translateY(-30px);opacity:0}}", ""]);

// exports


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d1fdf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(797);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d1fdf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationView_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a51a78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationView_vue__ = __webpack_require__(764);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a51a78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(762);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0434fbd2", content, true, {});

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".detail-info[data-v-fd211030]{white-space:pre-wrap}", ""]);

// exports


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.listRowInput),function(rowInput,rowIndex){return _c('div',{key:'row' + rowIndex,staticClass:"row"},_vm._l((rowInput),function(item,index){return _c('div',{key:item.model + rowIndex + index,class:_vm.getClassList(item.itemPerRow)},[(item.type === _vm.FORM_TYPE.ARRAY_OBJECT)?[(!isNaN(_vm.modelData[item.size]))?[_vm._l((Number(_vm.modelData[item.size])),function(childRowIndex){return [_c('DetailSectionRowLayout',{key:'childRowIndex-' + childRowIndex,attrs:{"modelData":_vm.modelData[item.model][childRowIndex - 1],"labelKey":"labelDetail","listFields":item.items}})]})]:_vm._e()]:(item.type === _vm.FORM_TYPE.SLOT)?[_vm._t(item.name)]:[(_vm.isDisplayItem(item))?_c('div',[_c('label',[_vm._v(_vm._s(_vm.getDisplayLabel(item)))]),_vm._v(" "),_c('p',{staticClass:"detail-info"},[_vm._v(_vm._s(_vm.getDisplayValue(item, item.model)))])]):_vm._e()]],2)}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-of-fields"},[_c('h2',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('DetailSectionRowLayout',{attrs:{"modelData":_vm.user,"labelKey":"labelDetail","listFields":_vm.$store.getters.familyInformationListFields,"listExcludeFields":['first_name', 'last_name']}},[_c('template',{slot:"children"},[_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("Children")]),_vm._v(" "),_vm._l((_vm.user.children),function(children,index){return _c('div',{key:'ref' + index},[_c('hr',{staticClass:"ref-separator"}),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("\n          "+_vm._s(children.first_name)+" "+_vm._s(children.last_name)+"\n        ")]),_vm._v(" "),_c('DetailSectionRowLayout',{attrs:{"modelData":children,"listFields":_vm.listChildrenFields,"listExcludeFields":['first_name', 'last_name']}})],1)}),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}})],2)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(766);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7614a386", content, true, {});

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".submit-button-section{margin-top:30px;display:flex;justify-content:flex-end}.text-require-notice{font-size:.8rem;color:var(--coredarkcolor)}", ""]);

// exports


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e8cde0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSectionDialog_vue__ = __webpack_require__(768);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e8cde0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSectionDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":_vm.name + '-form-modal',"width":"90%","height":"auto","scrollable":true},on:{"closed":function($event){return _vm.hideModal()}}},[_c('div',{staticClass:"p-5 field-of-fields"},[(_vm.isAdd)?_c('h3',[_vm._v("Add "+_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(!_vm.isAdd)?_c('h3',[_vm._v("Edit "+_vm._s(_vm.name)+" - "+_vm._s(_vm.getObjectTitle))]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"submitClicked":_vm.submitClicked,"modelData":_vm.data,"listFields":_vm.listFields}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),(!_vm.isAdd)?_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.showDeleteDataConfirmDialog()}}},[_vm._v("\n        Delete\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.handleClickSaveButton()}}},[_vm._v("\n        Save\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v(_vm._s(_vm.sectionTitle))]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3 mb-3",on:{"click":function($event){return _vm.showAddObjectDialog()}}},[_vm._v("\n    Add "+_vm._s(_vm.name)+"\n  ")]),_vm._v(" "),_vm._l((_vm.data),function(object,index){return _c('div',{key:'ref' + index},[_c('hr',{staticClass:"ref-separator"}),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("\n      "+_vm._s(object["first_name"])+" "+_vm._s(object["last_name"])+"\n      "),_c('img',{staticClass:"edit-button",attrs:{"src":__webpack_require__(36)},on:{"click":function($event){return _vm.showEditObjectDialog(object, index)}}})]),_vm._v(" "),_c('DetailSectionRowLayout',{attrs:{"modelData":object,"listFields":_vm.listFields,"listExcludeFields":_vm.keyTitles}})],1)}),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('ProfileSectionDialog',{attrs:{"name":_vm.name,"listFields":_vm.listFields,"keyTitles":_vm.keyTitles,"data":_vm.object,"isAdd":_vm.isAddObjectDialog},on:{"saved":function($event){return _vm.handleUpdateObjects($event)}},model:{value:(_vm.isShowObjectFormDialog),callback:function ($$v) {_vm.isShowObjectFormDialog=$$v},expression:"isShowObjectFormDialog"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 mb-4 field-of-fields",staticStyle:{"width":"75%","display":"block","margin-left":"auto","margin-right":"auto"}},[(_vm.$store.getters.userID)?_c('div',[_c('h3',{},[_vm._v("Family Information")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"text-require-notice"},[_vm._v("Fields marked with an * are required")]),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"listFields":_vm.$store.getters.familyInformationListFields,"modelData":_vm.user,"submitClicked":_vm.submitClicked}},[_c('template',{slot:"children"},[_c('ApplicationSectionWithDialog',{attrs:{"sectionTitle":"Children","name":"Children","data":_vm.user.children,"listFields":_vm.listChildrenFields,"keyTitles":['first_name', 'last_name']}})],1)],2),_vm._v(" "),_c('div',{staticClass:"submit-button-section"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("\n          Submit\n        ")])])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"30px"}},[_c('div',{ref:"formContainer",staticClass:"vld-parent"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"20px"}},[(_vm.cardError || !_vm.cardComplete)?_c('button',{staticClass:"mylisting-button disabled-button",staticStyle:{"float":"right","cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Complete")]):_vm._e(),_vm._v(" "),(!_vm.cardError && _vm.cardComplete)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){$event.preventDefault();return _vm.createCustomer()}}},[_vm._v("Complete")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"payment-form"}},[_c('div',{attrs:{"id":"card-element"}}),_vm._v(" "),_c('div',{staticClass:"mt-2",staticStyle:{"font-size":"1rem","font-weight":"700","color":"red"},attrs:{"id":"card-errors","role":"alert"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eca46aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(773);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eca46aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"password-update field-of-fields"},[_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("New Password")]),_c('br'),_vm._v(" "),((_vm.passwordFieldType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.updateInput),expression:"updateInput"}],staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.updateInput)?_vm._i(_vm.updateInput,null)>-1:(_vm.updateInput)},on:{"change":function($event){var $$a=_vm.updateInput,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.updateInput=$$a.concat([$$v]))}else{$$i>-1&&(_vm.updateInput=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.updateInput=$$c}}}}):((_vm.passwordFieldType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.updateInput),expression:"updateInput"}],staticClass:"form-control",attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.updateInput,null)},on:{"change":function($event){_vm.updateInput=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.updateInput),expression:"updateInput"}],staticClass:"form-control",attrs:{"type":_vm.passwordFieldType},domProps:{"value":(_vm.updateInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.updateInput=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Retype Password")]),_c('br'),_vm._v(" "),((_vm.passwordFieldType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.updateInput2),expression:"updateInput2"}],staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.updateInput2)?_vm._i(_vm.updateInput2,null)>-1:(_vm.updateInput2)},on:{"change":function($event){var $$a=_vm.updateInput2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.updateInput2=$$a.concat([$$v]))}else{$$i>-1&&(_vm.updateInput2=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.updateInput2=$$c}}}}):((_vm.passwordFieldType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.updateInput2),expression:"updateInput2"}],staticClass:"form-control",attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.updateInput2,null)},on:{"change":function($event){_vm.updateInput2=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.updateInput2),expression:"updateInput2"}],staticClass:"form-control",attrs:{"type":_vm.passwordFieldType},domProps:{"value":(_vm.updateInput2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.updateInput2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.verifiedUpdate()}}},[_vm._v("Update")]),_vm._v(" "),(!_vm.matchingInput)?_c('p',{staticClass:"mt-1",staticStyle:{"color":"red"}},[_vm._v("*Passwords do not match. ")]):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"password-reset-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Password has been reset successfully")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('password-reset-modal')}}},[_vm._v("Close")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticStyle:{"font-weight":"500","margin-bottom":"0"}},[(_vm.user.status == 'Application Approved')?_c('span',[_vm._v("Step 2: ")]):_vm._e(),_vm._v("Package Selection")]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.user.selector8)?_c('div',[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showPackageSelectionModal()}}},[_vm._v("Select Package")])]):_vm._e(),_vm._v(" "),(_vm.user.selector8)?_c('div',[_c('p',[_vm._v("Package Selected: "+_vm._s(_vm.user.selector8))])]):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"package-selection-modal","width":"95%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Placement Packages")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"center",staticStyle:{"font-size":"1rem"}},[_vm._v("Please note that all placement fees are a minimum of $5,000, and all fees are calculated on the basis of annual compensation.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 py-2 px-2"},[_c('div',{staticClass:"px-5 py-3",staticStyle:{"border":"1px solid black"}},[_c('h4',{staticClass:"mt-4 center mb-4"},[_vm._v("Standard")]),_vm._v(" "),_c('p',[_vm._v("A placement fee of 16% of the employee’s total gross annual compensation package.")]),_vm._v(" "),_c('p',[_vm._v("The following benefits are included as part of the Standard Placement Package:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("One Day Trail Period")]),_vm._v(" "),_c('li',[_vm._v("30-Day Replacement Policy")]),_vm._v(" "),_c('li',[_vm._v("Security Background Investigation")]),_vm._v(" "),_c('li',[_vm._v("Verification of First Aid/CPR Certification")])]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-4 mb-3 center",on:{"click":function($event){return _vm.showConfirmPackageSelectionModal('Standard')}}},[_vm._v("Select Standard")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 py-2 px-2"},[_c('div',{staticClass:"px-5 py-3",staticStyle:{"border":"1px solid black"}},[_c('h4',{staticClass:"mt-4 center mb-4"},[_vm._v("Premiere")]),_vm._v(" "),_c('p',[_vm._v("A placement fee of 18% of the employee’s total gross annual compensation package.")]),_vm._v(" "),_c('p',[_vm._v("The following benefits are included as part of the Premiere Placement Package:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Three Day Trail Period")]),_vm._v(" "),_c('li',[_vm._v("60-Day Replacement Policy")]),_vm._v(" "),_c('li',[_vm._v("Security Background Investigation")]),_vm._v(" "),_c('li',[_vm._v("Criminal History Search Including All Locations Lived in During the Past 7 Years")]),_vm._v(" "),_c('li',[_vm._v("Auxiliary National Criminal Search Including Records for the Past 7 years")]),_vm._v(" "),_c('li',[_vm._v("Global Terrorist Search")]),_vm._v(" "),_c('li',[_vm._v("Verification of First Aid/CPR Certification")]),_vm._v(" "),_c('li',[_vm._v("Professionally Drafted Employment Agreement Tailored to Your Household")]),_vm._v(" "),_c('li',[_vm._v("Professionally Drafted Confidentiality Agreement (Upon Request)")]),_vm._v(" "),_c('li',[_vm._v("10-Panel Drug Test (Upon Request)")])]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-4 mb-3 center",on:{"click":function($event){return _vm.showConfirmPackageSelectionModal('Premiere')}}},[_vm._v("Select Premiere")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 py-2 px-2"},[_c('div',{staticClass:"px-5 py-3",staticStyle:{"border":"1px solid black"}},[_c('h4',{staticClass:"mt-4 center mb-4"},[_vm._v("Elite")]),_vm._v(" "),_c('p',[_vm._v("A placement fee of 20% of the employee’s total gross annual compensation package.")]),_vm._v(" "),_c('p',[_vm._v("The following benefits are included as part of the Elite Placement Package:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Five Day Trail Period")]),_vm._v(" "),_c('li',[_vm._v("120-Day Replacement Policy")]),_vm._v(" "),_c('li',[_vm._v("Security Background Investigation")]),_vm._v(" "),_c('li',[_vm._v("Criminal History Search Including All Locations Lived in During the Past 7 Years")]),_vm._v(" "),_c('li',[_vm._v("Auxiliary National Criminal Search Including Records for the Past 7 years")]),_vm._v(" "),_c('li',[_vm._v("Global Terrorist Search")]),_vm._v(" "),_c('li',[_vm._v("Verification of First Aid/CPR Certification")]),_vm._v(" "),_c('li',[_vm._v("Professionally Drafted Employment Agreement Tailored to Your Household")]),_vm._v(" "),_c('li',[_vm._v("Professionally Drafted Confidentiality Agreement (Upon Request)")]),_vm._v(" "),_c('li',[_vm._v("Degree Verification (Upon Request)")]),_vm._v(" "),_c('li',[_vm._v("10-Panel Drug Test (Upon Request)")]),_vm._v(" "),_c('li',[_vm._v("Do Not Text and Drive Policy")]),_vm._v(" "),_c('li',[_vm._v("Covid-19 Policy Agreement")]),_vm._v(" "),_c('li',[_vm._v("Orientation Binder")]),_vm._v(" "),_c('li',[_vm._v("Themed Weekly Curriculums for your Nanny")]),_vm._v(" "),_c('li',[_vm._v("One Year of Complimentary Temporary Nannies to Fill-In During Your Nanny’s Vacation or Sick Days (Complimentary agency fee. Client is expected to compensate the nanny at her regular hourly rate.)")])]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-4 mb-3 center",on:{"click":function($event){return _vm.showConfirmPackageSelectionModal('Elite')}}},[_vm._v("Select Elite")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('package-selection-modal')}}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"confirm-package-selection-modal","width":"85%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Confirm Selection - "+_vm._s(_vm.packageSelection))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("I have read and am confident of the terms of the package chosen.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('confirm-package-selection-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.selectPackage()}}},[_vm._v("Confirm Selection")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransportationConsent_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a247070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransportationConsent_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransportationConsent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a247070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransportationConsent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(777);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("91708b8e", content, true, {});

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("TRANSPORTATION CONSENT FORM")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("We, "+_vm._s(_vm.document.field1)+" (parents) of "+_vm._s(_vm.document.field2)+" (child/ren), do hereby authorize and direct the scheduled employee of The Nanny Company to transport our child(ren) to and from the frequent pick-up points and/or any other designated destinations, within reason. All transportation is to be consented of in advance by the parents.")]),_vm._v(" "),_c('p',[_vm._v("Further, the Employee has agreed to comply with the Employee Handbook, including that there will be no cell phone use while driving with the child/ren, they have a valid drivers license, and will regularly maintain the reliable vehicle, with the appropriate insurance. The Clients will ensure the car seats are installed properly and the Employee will use them accordingly.")]),_vm._v(" "),_c('p',[_vm._v("We understand and acknowledge that The Nanny Company Inc. assumes no responsibility, obligation or liability of any kind.")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v("Signature of Parent/Guardian (Please Type)")]),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UseofClientVehicle_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3787500_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UseofClientVehicle_vue__ = __webpack_require__(780);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UseofClientVehicle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3787500_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UseofClientVehicle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Consent and Authorization – Use of Client Vehicle(s)")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Client Name(s): "+_vm._s(_vm.document.field1)+" (hereinafter, the “Client”)")]),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.document.body)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("Client")]),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v("Signature of the Client (Please Type)")]),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-top":"25px","margin-bottom":"0"}},[_vm._v("The Nanny Company")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date_secondary).toDateString()))]),_vm._v(" "),(_vm.document.signing_name_secondary)?_c('h4',{staticStyle:{"font-family":"'Arizonia'"}},[_vm._v(_vm._s(_vm.document.signing_name_secondary))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Per: "+_vm._s(_vm.document.signing_name_secondary))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransportChildrenEmployeeVehicle_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45fc0d66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransportChildrenEmployeeVehicle_vue__ = __webpack_require__(782);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransportChildrenEmployeeVehicle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45fc0d66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransportChildrenEmployeeVehicle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Consent and Authorization – Transport of Child(ren) with Employee Vehicle(s)")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Client Name(s): "+_vm._s(_vm.document.field1)+" (hereinafter, the “Client”)")]),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.document.body)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("Client")]),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v("Signature of the Client (Please Type)")]),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-top":"25px","margin-bottom":"0"}},[_vm._v("The Nanny Company")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date_secondary).toDateString()))]),_vm._v(" "),(_vm.document.signing_name_secondary)?_c('h4',{staticStyle:{"font-family":"'Arizonia'"}},[_vm._v(_vm._s(_vm.document.signing_name_secondary))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Per: "+_vm._s(_vm.document.signing_name_secondary))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("MEDICAL RELEASE FORM")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[_c('p',[_vm._v("Child's Name: "+_vm._s(_vm.document.field1))]),_vm._v(" "),_c('p',[_vm._v("Birthdate: "+_vm._s(new Date(_vm.document.field2).toDateString()))]),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field3),expression:"field3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field3=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Parent's Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field4),expression:"field4"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field4=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Cell Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field5),expression:"field5"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field5=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Child's Doctor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field6),expression:"field6"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field6=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Doctor's Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field7),expression:"field7"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field7=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Date of Most Recent Vaccination")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field8),expression:"field8"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field8=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Allergies/Medications")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field9),expression:"field9"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field9)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field9=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Child's Dentist")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field10),expression:"field10"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field10)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field10=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Dentist's Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field11),expression:"field11"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field11)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field11=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Manitoba Health Card Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field12),expression:"field12"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field12)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field12=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Emergency Contact and Relation")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field13),expression:"field13"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field13=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Emergency Contact Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field14),expression:"field14"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field14)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field14=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('div',[_c('p',[_vm._v("Address: "+_vm._s(_vm.document.field3))]),_vm._v(" "),_c('p',[_vm._v("Parent's Name: "+_vm._s(_vm.document.field4))]),_vm._v(" "),_c('p',[_vm._v("Cell Phone: "+_vm._s(_vm.document.field5))]),_vm._v(" "),_c('p',[_vm._v("Child's Doctor: "+_vm._s(_vm.document.field6))]),_vm._v(" "),_c('p',[_vm._v("Doctor's Phone: "+_vm._s(_vm.document.field7))]),_vm._v(" "),_c('p',[_vm._v("Date of Most Recent Vaccination: "+_vm._s(_vm.document.field8))]),_vm._v(" "),_c('p',[_vm._v("Allergies/Medications: "+_vm._s(_vm.document.field9))]),_vm._v(" "),_c('p',[_vm._v("Child's Dentist: "+_vm._s(_vm.document.field10))]),_vm._v(" "),_c('p',[_vm._v("Dentist's Phone: "+_vm._s(_vm.document.field11))]),_vm._v(" "),_c('p',[_vm._v("Manitoba Health Card Number: "+_vm._s(_vm.document.field12))]),_vm._v(" "),_c('p',[_vm._v("Emergency Contact and Relation: "+_vm._s(_vm.document.field13))]),_vm._v(" "),_c('p',[_vm._v("Emergency Contact Phone: "+_vm._s(_vm.document.field14))])]):_vm._e(),_vm._v(" "),_c('pre',{staticClass:"mt-3",staticStyle:{"padding-bottom":"0"},domProps:{"innerHTML":_vm._s(_vm.document.body)}}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v("Signature of Parent/Guardian (Please Type)")]),_vm._v(" "),_c('div',[(!_vm.signature)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")]):_vm._e()])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FamilyAgencyContract_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2f102e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FamilyAgencyContract_vue__ = __webpack_require__(785);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FamilyAgencyContract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2f102e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FamilyAgencyContract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"document"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("CLIENT- AGENCY AGREEMENT PLACEMENT FEE & REFUND POLICY")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Client Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field1),expression:"field1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field1=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field2),expression:"field2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field2=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"10px"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field3),expression:"field3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field3=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('div',[_c('p',[_vm._v("Client Name: "+_vm._s(_vm.document.field1))]),_vm._v(" "),_c('p',[_vm._v("Address: "+_vm._s(_vm.document.field2))]),_vm._v(" "),_c('p',[_vm._v("Email: "+_vm._s(_vm.document.field3))])]):_vm._e(),_vm._v(" "),_c('pre',{staticClass:"mt-3",domProps:{"innerHTML":_vm._s(_vm.document.body)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("Client")]),_vm._v(" "),(_vm.document.status == 'Unsigned')?_c('p',[_vm._v(_vm._s(new Date().toDateString()))]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(new Date(_vm.document.signing_date).toDateString()))]):_vm._e(),_vm._v(" "),(_vm.signature)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.signature))]):_vm._e(),_vm._v(" "),(!_vm.signature)?_c('h4',[_vm._v("___________")]):_vm._e(),_vm._v(" "),(_vm.document.status == 'Signed')?_c('p',[_vm._v(_vm._s(_vm.document.signing_name))]):_vm._e(),_vm._v(" "),(!_vm.document.signing_name)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signature),expression:"signature"}],staticClass:"form-control",staticStyle:{"max-width":"500px"},attrs:{"type":"text"},domProps:{"value":(_vm.signature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signature=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v("Signature of the Client (Please Type)")]),_vm._v(" "),_c('div',[(!_vm.signature || !_vm.field1 || !_vm.field2 || !_vm.field3)?_c('button',{staticClass:"mylisting-button disabled-button mt-3",staticStyle:{"cursor":"not-allowed","color":"gray"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign")]):_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.sign()}}},[_vm._v("Sign")])])]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-top":"25px"}},[_vm._v("Pink Nannies Agency")]),_vm._v(" "),(_vm.document.signing_name_secondary)?_c('h4',{staticStyle:{"font-family":"'Arizonia'","text-transform":"none"}},[_vm._v(_vm._s(_vm.document.signing_name_secondary))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Per: "+_vm._s(_vm.document.signing_name_secondary))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.documents.length || _vm.files.length || _vm.$store.getters.isAgent === true)?_c('div',{staticClass:"profile-tile"},[_c('h4',{staticStyle:{"font-weight":"500","margin-bottom":"0"}},[_vm._v("Documents")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.documents),function(document){return _c('div',{key:document.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 px-3 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[(!document.template)?_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(document.title)),(document.title == 'Medical Release')?_c('span',[_vm._v(" - "+_vm._s(document.field1))]):_vm._e()])]):_vm._e(),_vm._v(" "),(document.template)?_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(document.title)),(document.status == 'Signed')?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"11px","margin-left":"5px","color":"#444"}},[_vm._v("check_circle")])]):_vm._e()]),_vm._v(" "),(document.status == 'Unsigned')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showDocumentModal(document)}}},[_vm._v("Sign")]):_vm._e(),_vm._v(" "),(document.status == 'Signed')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showDocumentModal(document)}}},[_vm._v("View")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('p',{staticClass:"delete-text mt-2",on:{"click":function($event){return _vm.showDeleteDocumentModal(document)}}},[_vm._v("Delete")]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.files),function(file){return _c('div',{key:file.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('a',{attrs:{"href":file.file_link,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('p',{staticClass:"delete-text mt-2",on:{"click":function($event){return _vm.showDeleteFileModal(file)}}},[_vm._v("Delete")]):_vm._e()])])})],2),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('div',[_c('button',{staticClass:"mylisting-button dark-button mt-4",on:{"click":function($event){return _vm.showUploadFileModal()}}},[_vm._v("Upload File")])]):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"upload-file-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('label',{},[_vm._v("File Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileName),expression:"fileName"}],staticClass:"form-control mb-2",attrs:{"type":"text"},domProps:{"value":(_vm.fileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fileName=$event.target.value}}}),_vm._v(" "),_c('input',{ref:"file",staticClass:"form-control-file",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('upload-file-modal')}}},[_vm._v("Close")]),_vm._v(" "),(_vm.fileName && _vm.file)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.uploadFile()}}},[_vm._v("Upload File")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"document-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('document',{attrs:{"user":_vm.user,"document":_vm.document},on:{"documentSigned":function($event){return _vm.documentSigned()},"documentSaved":function($event){return _vm.documentSaved()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('document-modal')}}},[_vm._v("Close")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"document-signed-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Your document has been signed.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('document-signed-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-document-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('h3',[_vm._v("Are you sure you want to delete the document "+_vm._s(_vm.document.title)+"?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-document-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteDocument(_vm.document)}}},[_vm._v("Delete Document")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-file-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('h3',[_vm._v("Are you sure you want to delete the file "+_vm._s(_vm.file.name)+"?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-file-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteFile(_vm.selectedFile)}}},[_vm._v("Delete File")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-document-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('h3',[_vm._v("Are you sure you want to delete the document "+_vm._s(_vm.document.title)+"?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-document-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteDocument(_vm.document)}}},[_vm._v("Delete Document")])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCandidates_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6c46464_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCandidates_vue__ = __webpack_require__(788);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCandidates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6c46464_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCandidates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticStyle:{"font-weight":"500","margin-bottom":"0"}},[_vm._v("My Candidates")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.relationships.length === 0)?_c('p',[_vm._v("No nannies have been linked yet, we're currently searching and you'll be notified shortly!")]):_c('div',{staticClass:"mb-2"},[_c('p',[_vm._v("Click the \"View Profile\" button to learn more about a nanny! (Their profile will open in a new tab)")]),_vm._v(" "),_c('p',[_vm._v("Once you've decided whether or not you'd like to meet them, please click \"I'm Interested\" or \"I'm Not Interested\" to let us know!")])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},_vm._l((_vm.relationships),function(relationship){return _c('div',{key:relationship.id,staticClass:"col-lg-6 mb-4"},[_c('div',{staticClass:"p-4 px-5",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"2px"}},[_c('div',{staticClass:"center"},[_c('h4',{staticClass:"mt-3",staticStyle:{"margin-bottom":"5px"}},[_vm._v(_vm._s(relationship.candidate_name))]),_vm._v(" "),_c('p',[_vm._v("Status: "+_vm._s(relationship.status))]),_vm._v(" "),_c('hr'),_vm._v(" "),(relationship.text7)?_c('p',[_vm._v("Notes: "+_vm._s(relationship.text7))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"25px","margin-bottom":"25px"}},[_c('router-link',{staticClass:"mylisting-button dark-button mt-2",attrs:{"to":{ name: 'Candidate Viewable Dashboard', params: { id: relationship.candidate } },"target":"_blank"}},[_vm._v("View Profile")])],1),_vm._v(" "),(relationship.status == 'Under Consideration')?_c('p',{},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.updateRelationshipStatus('Interested', relationship)}}},[_vm._v("I'm Interested")]),_vm._v(" | "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.updateRelationshipStatus('Not Interested', relationship)}}},[_vm._v("I'm Not Interested")])]):_vm._e(),_vm._v(" "),(relationship.status == 'Interested')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showOfferModal(relationship)}}},[_vm._v("Extend Offer")]):_vm._e()])])])}),0),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"schedule-interview-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thanks for letting us know you are interested!")]),_vm._v(" "),_c('p',[_vm._v("The next step is for us to schedule an interview/trial day with you and the nanny. Please fill in this form:")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Would you prefer to start with a video meeting (Zoom or Facetime) or in person?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.videoOrInPerson),expression:"videoOrInPerson"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.videoOrInPerson)},on:{"input":function($event){if($event.target.composing){ return; }_vm.videoOrInPerson=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Please let us know some upcoming days and times when you are available")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.availability),expression:"availability"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.availability)},on:{"input":function($event){if($event.target.composing){ return; }_vm.availability=$event.target.value}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-5",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitScheduleForm()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"not-interested-feedback-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thanks for letting us know you are not interested in this nanny.")]),_vm._v(" "),_c('p',[_vm._v("Can you please give us some feedback as to why so we can find someone more suitable?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.feedback),expression:"feedback"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.feedback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.feedback=$event.target.value}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-5",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitFeedbackForm()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"extend-offer-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Extend an Offer")]),_vm._v(" "),_c('p',[_vm._v("Thanks for your interest in hiring this nanny. To extend an offer, please fill in the following details:")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[_c('label',{staticClass:"top-label"},[_vm._v("Pay rate")]),_vm._v(" "),_c('small',[_vm._v("Most professional nannies are paid $20-30 per hour, depending on experience.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payRate),expression:"payRate"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.payRate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payRate=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Contract Duration")]),_vm._v(" "),_c('small',[_vm._v("For example, 1 year")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contractDuration),expression:"contractDuration"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.contractDuration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contractDuration=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Schedule/Hours")]),_vm._v(" "),_c('small',[_vm._v("For example, guaranteeing 40 hours whether worked or not. M-F 8:30AM-5PM")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.daysHours),expression:"daysHours"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.daysHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.daysHours=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Paid Holidays")]),_vm._v(" "),_c('small',[_vm._v("For example, New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day and Christmas Day.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidTimeOff),expression:"paidTimeOff"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.paidTimeOff)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paidTimeOff=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Paid Vacation")]),_vm._v(" "),_c('small',[_vm._v("For example, 10 days")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidVacation),expression:"paidVacation"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paidVacation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paidVacation=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Paid Sick Days")]),_vm._v(" "),_c('small',[_vm._v("For example, 5 days")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidSickDays),expression:"paidSickDays"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paidSickDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paidSickDays=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Payment Frequency")]),_vm._v(" "),_c('small',[_vm._v("For example, weekly or bi-Weekly")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentFrequency),expression:"paymentFrequency"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paymentFrequency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paymentFrequency=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Health Insurance Stipend")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.healthInsurance),expression:"healthInsurance"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.healthInsurance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.healthInsurance=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Mileage Reimbursement")]),_vm._v(" "),_c('small',[_vm._v("For on the job travel at the IRS rate of 57.5 cents per mile.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mileageReimbursement),expression:"mileageReimbursement"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.mileageReimbursement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mileageReimbursement=$event.target.value}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('extend-offer-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-5",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.extendOffer()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"submitted-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thanks, we will be in touch shortly!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('submitted-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

(function(t,e){ true?module.exports=e(__webpack_require__(11)):"function"===typeof define&&define.amd?define(["vue"],e):"object"===typeof exports?exports["vue-slider-component"]=e(require("vue")):t["vue-slider-component"]=e(t["Vue"])})("undefined"!==typeof self?self:this,(function(t){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s="fb15")}({"091b":function(t,e,r){var n=r("24fb");e=n(!1),e.push([t.i,".vue-slider-dot{position:absolute;-webkit-transition:all 0s;transition:all 0s;z-index:5}.vue-slider-dot-tooltip{position:absolute;visibility:hidden}.vue-slider-dot-hover:hover .vue-slider-dot-tooltip,.vue-slider-dot-tooltip-show{visibility:visible}.vue-slider-dot-tooltip-top{top:-10px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-dot-tooltip-bottom{bottom:-10px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-dot-tooltip-left{left:-10px;top:50%;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-dot-tooltip-right{right:-10px;top:50%;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}",""]),t.exports=e},"24fb":function(t,e,r){"use strict";function n(t,e){var r=t[1]||"",n=t[3];if(!n)return r;if(e&&"function"===typeof btoa){var i=o(n),s=n.sources.map((function(t){return"/*# sourceURL=".concat(n.sourceRoot||"").concat(t," */")}));return[r].concat(s).concat([i]).join("\n")}return[r].join("\n")}function o(t){var e=btoa(unescape(encodeURIComponent(JSON.stringify(t)))),r="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(e);return"/*# ".concat(r," */")}t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var r=n(e,t);return e[2]?"@media ".concat(e[2]," {").concat(r,"}"):r})).join("")},e.i=function(t,r,n){"string"===typeof t&&(t=[[null,t,""]]);var o={};if(n)for(var i=0;i<this.length;i++){var s=this[i][0];null!=s&&(o[s]=!0)}for(var a=0;a<t.length;a++){var u=[].concat(t[a]);n&&o[u[0]]||(r&&(u[2]?u[2]="".concat(r," and ").concat(u[2]):u[2]=r),e.push(u))}},e}},2638:function(t,e,r){"use strict";function n(){return n=Object.assign||function(t){for(var e,r=1;r<arguments.length;r++)for(var n in e=arguments[r],e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t},n.apply(this,arguments)}var o=["attrs","props","domProps"],i=["class","style","directives"],s=["on","nativeOn"],a=function(t){return t.reduce((function(t,e){for(var r in e)if(t[r])if(-1!==o.indexOf(r))t[r]=n({},t[r],e[r]);else if(-1!==i.indexOf(r)){var a=t[r]instanceof Array?t[r]:[t[r]],l=e[r]instanceof Array?e[r]:[e[r]];t[r]=a.concat(l)}else if(-1!==s.indexOf(r))for(var c in e[r])if(t[r][c]){var f=t[r][c]instanceof Array?t[r][c]:[t[r][c]],d=e[r][c]instanceof Array?e[r][c]:[e[r][c]];t[r][c]=f.concat(d)}else t[r][c]=e[r][c];else if("hook"==r)for(var h in e[r])t[r][h]=t[r][h]?u(t[r][h],e[r][h]):e[r][h];else t[r]=e[r];else t[r]=e[r];return t}),{})},u=function(t,e){return function(){t&&t.apply(this,arguments),e&&e.apply(this,arguments)}};t.exports=a},"499e":function(t,e,r){"use strict";function n(t,e){for(var r=[],n={},o=0;o<e.length;o++){var i=e[o],s=i[0],a=i[1],u=i[2],l=i[3],c={id:t+":"+o,css:a,media:u,sourceMap:l};n[s]?n[s].parts.push(c):r.push(n[s]={id:s,parts:[c]})}return r}r.r(e),r.d(e,"default",(function(){return p}));var o="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var i={},s=o&&(document.head||document.getElementsByTagName("head")[0]),a=null,u=0,l=!1,c=function(){},f=null,d="data-vue-ssr-id",h="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function p(t,e,r,o){l=r,f=o||{};var s=n(t,e);return y(s),function(e){for(var r=[],o=0;o<s.length;o++){var a=s[o],u=i[a.id];u.refs--,r.push(u)}e?(s=n(t,e),y(s)):s=[];for(o=0;o<r.length;o++){u=r[o];if(0===u.refs){for(var l=0;l<u.parts.length;l++)u.parts[l]();delete i[u.id]}}}}function y(t){for(var e=0;e<t.length;e++){var r=t[e],n=i[r.id];if(n){n.refs++;for(var o=0;o<n.parts.length;o++)n.parts[o](r.parts[o]);for(;o<r.parts.length;o++)n.parts.push(m(r.parts[o]));n.parts.length>r.parts.length&&(n.parts.length=r.parts.length)}else{var s=[];for(o=0;o<r.parts.length;o++)s.push(m(r.parts[o]));i[r.id]={id:r.id,refs:1,parts:s}}}}function v(){var t=document.createElement("style");return t.type="text/css",s.appendChild(t),t}function m(t){var e,r,n=document.querySelector("style["+d+'~="'+t.id+'"]');if(n){if(l)return c;n.parentNode.removeChild(n)}if(h){var o=u++;n=a||(a=v()),e=g.bind(null,n,o,!1),r=g.bind(null,n,o,!0)}else n=v(),e=k.bind(null,n),r=function(){n.parentNode.removeChild(n)};return e(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap)return;e(t=n)}else r()}}var b=function(){var t=[];return function(e,r){return t[e]=r,t.filter(Boolean).join("\n")}}();function g(t,e,r,n){var o=r?"":n.css;if(t.styleSheet)t.styleSheet.cssText=b(e,o);else{var i=document.createTextNode(o),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(i,s[e]):t.appendChild(i)}}function k(t,e){var r=e.css,n=e.media,o=e.sourceMap;if(n&&t.setAttribute("media",n),f.ssrId&&t.setAttribute(d,e.id),o&&(r+="\n/*# sourceURL="+o.sources[0]+" */",r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),t.styleSheet)t.styleSheet.cssText=r;else{while(t.firstChild)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(r))}}},"4abb":function(t,e,r){var n=r("7a57");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("b2af7572",n,!0,{sourceMap:!1,shadowMode:!1})},"4ed8":function(t,e,r){var n=r("091b");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("2f6bee1a",n,!0,{sourceMap:!1,shadowMode:!1})},"556c":function(t,e,r){var n=r("eef2");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("1209fd47",n,!0,{sourceMap:!1,shadowMode:!1})},"65d9":function(t,e,r){"use strict";
/**
  * vue-class-component v7.0.1
  * (c) 2015-present Evan You
  * @license MIT
  */function n(t){return t&&"object"===typeof t&&"default"in t?t["default"]:t}Object.defineProperty(e,"__esModule",{value:!0});var o=n(r("8bbf")),i="undefined"!==typeof Reflect&&Reflect.defineMetadata&&Reflect.getOwnMetadataKeys;function s(t,e){a(t,e),Object.getOwnPropertyNames(e.prototype).forEach((function(r){a(t.prototype,e.prototype,r)})),Object.getOwnPropertyNames(e).forEach((function(r){a(t,e,r)}))}function a(t,e,r){var n=r?Reflect.getOwnMetadataKeys(e,r):Reflect.getOwnMetadataKeys(e);n.forEach((function(n){var o=r?Reflect.getOwnMetadata(n,e,r):Reflect.getOwnMetadata(n,e);r?Reflect.defineMetadata(n,o,t,r):Reflect.defineMetadata(n,o,t)}))}var u={__proto__:[]},l=u instanceof Array;function c(t){return function(e,r,n){var o="function"===typeof e?e:e.constructor;o.__decorators__||(o.__decorators__=[]),"number"!==typeof n&&(n=void 0),o.__decorators__.push((function(e){return t(e,r,n)}))}}function f(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return o.extend({mixins:t})}function d(t){var e=typeof t;return null==t||"object"!==e&&"function"!==e}function h(t,e){var r=e.prototype._init;e.prototype._init=function(){var e=this,r=Object.getOwnPropertyNames(t);if(t.$options.props)for(var n in t.$options.props)t.hasOwnProperty(n)||r.push(n);r.forEach((function(r){"_"!==r.charAt(0)&&Object.defineProperty(e,r,{get:function(){return t[r]},set:function(e){t[r]=e},configurable:!0})}))};var n=new e;e.prototype._init=r;var o={};return Object.keys(n).forEach((function(t){void 0!==n[t]&&(o[t]=n[t])})),o}var p=["data","beforeCreate","created","beforeMount","mounted","beforeDestroy","destroyed","beforeUpdate","updated","activated","deactivated","render","errorCaptured","serverPrefetch"];function y(t,e){void 0===e&&(e={}),e.name=e.name||t._componentTag||t.name;var r=t.prototype;Object.getOwnPropertyNames(r).forEach((function(t){if("constructor"!==t)if(p.indexOf(t)>-1)e[t]=r[t];else{var n=Object.getOwnPropertyDescriptor(r,t);void 0!==n.value?"function"===typeof n.value?(e.methods||(e.methods={}))[t]=n.value:(e.mixins||(e.mixins=[])).push({data:function(){var e;return e={},e[t]=n.value,e}}):(n.get||n.set)&&((e.computed||(e.computed={}))[t]={get:n.get,set:n.set})}})),(e.mixins||(e.mixins=[])).push({data:function(){return h(this,t)}});var n=t.__decorators__;n&&(n.forEach((function(t){return t(e)})),delete t.__decorators__);var a=Object.getPrototypeOf(t.prototype),u=a instanceof o?a.constructor:o,l=u.extend(e);return v(l,t,u),i&&s(l,t),l}function v(t,e,r){Object.getOwnPropertyNames(e).forEach((function(n){if("prototype"!==n){var o=Object.getOwnPropertyDescriptor(t,n);if(!o||o.configurable){var i=Object.getOwnPropertyDescriptor(e,n);if(!l){if("cid"===n)return;var s=Object.getOwnPropertyDescriptor(r,n);if(!d(i.value)&&s&&s.value===i.value)return}0,Object.defineProperty(t,n,i)}}}))}function m(t){return"function"===typeof t?y(t):function(e){return y(e,t)}}m.registerHooks=function(t){p.push.apply(p,t)},e.default=m,e.createDecorator=c,e.mixins=f},"7a57":function(t,e,r){var n=r("24fb");e=n(!1),e.push([t.i,".vue-slider{position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}.vue-slider-rail{position:relative;width:100%;height:100%;-webkit-transition-property:width,height,left,right,top,bottom;transition-property:width,height,left,right,top,bottom}.vue-slider-process{position:absolute;z-index:1}",""]),t.exports=e},8875:function(t,e,r){var n,o,i;(function(r,s){o=[],n=s,i="function"===typeof n?n.apply(e,o):n,void 0===i||(t.exports=i)})("undefined"!==typeof self&&self,(function(){function t(){if(document.currentScript)return document.currentScript;try{throw new Error}catch(f){var t,e,r,n=/.*at [^(]*\((.*):(.+):(.+)\)$/gi,o=/@([^@]*):(\d+):(\d+)\s*$/gi,i=n.exec(f.stack)||o.exec(f.stack),s=i&&i[1]||!1,a=i&&i[2]||!1,u=document.location.href.replace(document.location.hash,""),l=document.getElementsByTagName("script");s===u&&(t=document.documentElement.outerHTML,e=new RegExp("(?:[^\\n]+?\\n){0,"+(a-2)+"}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*","i"),r=t.replace(e,"$1").trim());for(var c=0;c<l.length;c++){if("interactive"===l[c].readyState)return l[c];if(l[c].src===s)return l[c];if(s===u&&l[c].innerHTML&&l[c].innerHTML.trim()===r)return l[c]}return null}}return t}))},"8bbf":function(e,r){e.exports=t},eef2:function(t,e,r){var n=r("24fb");e=n(!1),e.push([t.i,".vue-slider-marks{position:relative;width:100%;height:100%}.vue-slider-mark{position:absolute;z-index:1}.vue-slider-ltr .vue-slider-mark,.vue-slider-rtl .vue-slider-mark{width:0;height:100%;top:50%}.vue-slider-ltr .vue-slider-mark-step,.vue-slider-rtl .vue-slider-mark-step{top:0}.vue-slider-ltr .vue-slider-mark-label,.vue-slider-rtl .vue-slider-mark-label{top:100%;margin-top:10px}.vue-slider-ltr .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ltr .vue-slider-mark-step{left:0}.vue-slider-ltr .vue-slider-mark-label{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.vue-slider-rtl .vue-slider-mark{-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.vue-slider-rtl .vue-slider-mark-step{right:0}.vue-slider-rtl .vue-slider-mark-label{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.vue-slider-btt .vue-slider-mark,.vue-slider-ttb .vue-slider-mark{width:100%;height:0;left:50%}.vue-slider-btt .vue-slider-mark-step,.vue-slider-ttb .vue-slider-mark-step{left:0}.vue-slider-btt .vue-slider-mark-label,.vue-slider-ttb .vue-slider-mark-label{left:100%;margin-left:10px}.vue-slider-btt .vue-slider-mark{-webkit-transform:translate(-50%,50%);transform:translate(-50%,50%)}.vue-slider-btt .vue-slider-mark-step{top:0}.vue-slider-btt .vue-slider-mark-label{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-ttb .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ttb .vue-slider-mark-step{bottom:0}.vue-slider-ttb .vue-slider-mark-label{bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.vue-slider-mark-label,.vue-slider-mark-step{position:absolute}",""]),t.exports=e},fb15:function(t,e,r){"use strict";if(r.r(e),r.d(e,"ERROR_TYPE",(function(){return J})),r.d(e,"VueSliderMark",(function(){return U})),r.d(e,"VueSliderDot",(function(){return E})),"undefined"!==typeof window){var n=window.document.currentScript,o=r("8875");n=o(),"currentScript"in document||Object.defineProperty(document,"currentScript",{get:o});var i=n&&n.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);i&&(r.p=i[1])}var s=r("2638"),a=r.n(s);function u(t,e,r,n){var o,i=arguments.length,s=i<3?e:null===n?n=Object.getOwnPropertyDescriptor(e,r):n;if("object"===typeof Reflect&&"function"===typeof Reflect.decorate)s=Reflect.decorate(t,e,r,n);else for(var a=t.length-1;a>=0;a--)(o=t[a])&&(s=(i<3?o(s):i>3?o(e,r,s):o(e,r))||s);return i>3&&s&&Object.defineProperty(e,r,s),s}var l=r("8bbf"),c=r.n(l),f=r("65d9"),d=r.n(f);function h(t,e){return void 0===e&&(e={}),Object(f["createDecorator"])((function(r,n){(r.props||(r.props={}))[n]=e,r.model={prop:n,event:t||n}}))}function p(t){return void 0===t&&(t={}),Object(f["createDecorator"])((function(e,r){(e.props||(e.props={}))[r]=t}))}function y(t,e){void 0===e&&(e={});var r=e.deep,n=void 0!==r&&r,o=e.immediate,i=void 0!==o&&o;return Object(f["createDecorator"])((function(e,r){"object"!==typeof e.watch&&(e.watch=Object.create(null));var o=e.watch;"object"!==typeof o[t]||Array.isArray(o[t])?"undefined"===typeof o[t]&&(o[t]=[]):o[t]=[o[t]],o[t].push({handler:r,deep:n,immediate:i})}))}r("4ed8");function v(t){return v="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},v(t)}function m(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function b(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function g(t,e,r){return e&&b(t.prototype,e),r&&b(t,r),t}function k(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&O(t,e)}function O(t,e){return O=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},O(t,e)}function x(t){var e=P();return function(){var r,n=R(t);if(e){var o=R(this).constructor;r=Reflect.construct(n,arguments,o)}else r=n.apply(this,arguments);return w(this,r)}}function w(t,e){return!e||"object"!==v(e)&&"function"!==typeof e?S(t):e}function S(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function P(){if("undefined"===typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"===typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}function R(t){return R=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},R(t)}var D=function(){var t=function(t){k(r,t);var e=x(r);function r(){return m(this,r),e.apply(this,arguments)}return g(r,[{key:"dragStart",value:function(t){if(this.disabled)return!1;this.$emit("drag-start")}},{key:"render",value:function(){var t=arguments[0];return t("div",{ref:"dot",class:this.dotClasses,on:{mousedown:this.dragStart,touchstart:this.dragStart}},[this.$slots.dot||t("div",{class:this.handleClasses,style:this.dotStyle}),"none"!==this.tooltip?t("div",{class:this.tooltipClasses},[this.$slots.tooltip||t("div",{class:this.tooltipInnerClasses,style:this.tooltipStyle},[t("span",{class:"vue-slider-dot-tooltip-text"},[this.tooltipValue])])]):null])}},{key:"dotClasses",get:function(){return["vue-slider-dot",{"vue-slider-dot-hover":"hover"===this.tooltip||"active"===this.tooltip,"vue-slider-dot-disabled":this.disabled,"vue-slider-dot-focus":this.focus}]}},{key:"handleClasses",get:function(){return["vue-slider-dot-handle",{"vue-slider-dot-handle-disabled":this.disabled,"vue-slider-dot-handle-focus":this.focus}]}},{key:"tooltipClasses",get:function(){return["vue-slider-dot-tooltip",["vue-slider-dot-tooltip-".concat(this.tooltipPlacement)],{"vue-slider-dot-tooltip-show":this.showTooltip}]}},{key:"tooltipInnerClasses",get:function(){return["vue-slider-dot-tooltip-inner",["vue-slider-dot-tooltip-inner-".concat(this.tooltipPlacement)],{"vue-slider-dot-tooltip-inner-disabled":this.disabled,"vue-slider-dot-tooltip-inner-focus":this.focus}]}},{key:"showTooltip",get:function(){switch(this.tooltip){case"always":return!0;case"none":return!1;case"focus":case"active":return!!this.focus;default:return!1}}},{key:"tooltipValue",get:function(){return this.tooltipFormatter?"string"===typeof this.tooltipFormatter?this.tooltipFormatter.replace(/\{value\}/,String(this.value)):this.tooltipFormatter(this.value):this.value}}]),r}(c.a);return u([p({default:0})],t.prototype,"value",void 0),u([p()],t.prototype,"tooltip",void 0),u([p()],t.prototype,"dotStyle",void 0),u([p()],t.prototype,"tooltipStyle",void 0),u([p({type:String,validator:function(t){return["top","right","bottom","left"].indexOf(t)>-1},required:!0})],t.prototype,"tooltipPlacement",void 0),u([p({type:[String,Function]})],t.prototype,"tooltipFormatter",void 0),u([p({type:Boolean,default:!1})],t.prototype,"focus",void 0),u([p({default:!1})],t.prototype,"disabled",void 0),t=u([d.a],t),t}(),E=D;r("556c");function j(t){return j="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},j(t)}function A(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function V(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function M(t,e,r){return e&&V(t.prototype,e),r&&V(t,r),t}function _(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&C(t,e)}function C(t,e){return C=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},C(t,e)}function I(t){var e=T();return function(){var r,n=B(t);if(e){var o=B(this).constructor;r=Reflect.construct(n,arguments,o)}else r=n.apply(this,arguments);return L(this,r)}}function L(t,e){return!e||"object"!==j(e)&&"function"!==typeof e?N(t):e}function N(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function T(){if("undefined"===typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"===typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}function B(t){return B=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},B(t)}var H,z=function(){var t=function(t){_(r,t);var e=I(r);function r(){return A(this,r),e.apply(this,arguments)}return M(r,[{key:"labelClickHandle",value:function(t){t.stopPropagation(),this.$emit("pressLabel",this.mark.pos)}},{key:"render",value:function(){var t=arguments[0],e=this.mark;return t("div",{class:this.marksClasses},[this.$slots.step||t("div",{class:this.stepClasses,style:[this.stepStyle,e.style,e.active?this.stepActiveStyle:null,e.active?e.activeStyle:null]}),this.hideLabel?null:this.$slots.label||t("div",{class:this.labelClasses,style:[this.labelStyle,e.labelStyle,e.active?this.labelActiveStyle:null,e.active?e.labelActiveStyle:null],on:{click:this.labelClickHandle}},[e.label])])}},{key:"marksClasses",get:function(){return["vue-slider-mark",{"vue-slider-mark-active":this.mark.active}]}},{key:"stepClasses",get:function(){return["vue-slider-mark-step",{"vue-slider-mark-step-active":this.mark.active}]}},{key:"labelClasses",get:function(){return["vue-slider-mark-label",{"vue-slider-mark-label-active":this.mark.active}]}}]),r}(c.a);return u([p({required:!0})],t.prototype,"mark",void 0),u([p(Boolean)],t.prototype,"hideLabel",void 0),u([p()],t.prototype,"stepStyle",void 0),u([p()],t.prototype,"stepActiveStyle",void 0),u([p()],t.prototype,"labelStyle",void 0),u([p()],t.prototype,"labelActiveStyle",void 0),t=u([d.a],t),t}(),U=z,F=function(t){return"number"===typeof t?"".concat(t,"px"):t},$=function(t){var e=document.documentElement,r=document.body,n=t.getBoundingClientRect(),o={y:n.top+(window.pageYOffset||e.scrollTop)-(e.clientTop||r.clientTop||0),x:n.left+(window.pageXOffset||e.scrollLeft)-(e.clientLeft||r.clientLeft||0)};return o},W=function(t,e,r){var n="targetTouches"in t?t.targetTouches[0]:t,o=$(e),i={x:n.pageX-o.x,y:n.pageY-o.y};return{x:r?e.offsetWidth-i.x:i.x,y:r?e.offsetHeight-i.y:i.y}};(function(t){t[t["PAGE_UP"]=33]="PAGE_UP",t[t["PAGE_DOWN"]=34]="PAGE_DOWN",t[t["END"]=35]="END",t[t["HOME"]=36]="HOME",t[t["LEFT"]=37]="LEFT",t[t["UP"]=38]="UP",t[t["RIGHT"]=39]="RIGHT",t[t["DOWN"]=40]="DOWN"})(H||(H={}));var G=function(t,e){if(e.hook){var r=e.hook(t);if("function"===typeof r)return r;if(!r)return null}switch(t.keyCode){case H.UP:return function(t){return"ttb"===e.direction?t-1:t+1};case H.RIGHT:return function(t){return"rtl"===e.direction?t-1:t+1};case H.DOWN:return function(t){return"ttb"===e.direction?t+1:t-1};case H.LEFT:return function(t){return"rtl"===e.direction?t+1:t-1};case H.END:return function(){return e.max};case H.HOME:return function(){return e.min};case H.PAGE_UP:return function(t){return t+10};case H.PAGE_DOWN:return function(t){return t-10};default:return null}};function X(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function q(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function K(t,e,r){return e&&q(t.prototype,e),r&&q(t,r),t}var Y,J,Q=function(){function t(e){X(this,t),this.num=e}return K(t,[{key:"decimal",value:function(t,e){var r=this.num,n=this.getDecimalLen(r),o=this.getDecimalLen(t),i=0;switch(e){case"+":i=this.getExponent(n,o),this.num=(this.safeRoundUp(r,i)+this.safeRoundUp(t,i))/i;break;case"-":i=this.getExponent(n,o),this.num=(this.safeRoundUp(r,i)-this.safeRoundUp(t,i))/i;break;case"*":this.num=this.safeRoundUp(this.safeRoundUp(r,this.getExponent(n)),this.safeRoundUp(t,this.getExponent(o)))/this.getExponent(n+o);break;case"/":i=this.getExponent(n,o),this.num=this.safeRoundUp(r,i)/this.safeRoundUp(t,i);break;case"%":i=this.getExponent(n,o),this.num=this.safeRoundUp(r,i)%this.safeRoundUp(t,i)/i;break}return this}},{key:"plus",value:function(t){return this.decimal(t,"+")}},{key:"minus",value:function(t){return this.decimal(t,"-")}},{key:"multiply",value:function(t){return this.decimal(t,"*")}},{key:"divide",value:function(t){return this.decimal(t,"/")}},{key:"remainder",value:function(t){return this.decimal(t,"%")}},{key:"toNumber",value:function(){return this.num}},{key:"getDecimalLen",value:function(t){var e="".concat(t).split("e");return("".concat(e[0]).split(".")[1]||"").length-(e[1]?+e[1]:0)}},{key:"getExponent",value:function(t,e){return Math.pow(10,void 0!==e?Math.max(t,e):t)}},{key:"safeRoundUp",value:function(t,e){return Math.round(t*e)}}]),t}();function Z(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function tt(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?Z(Object(r),!0).forEach((function(e){pt(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):Z(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}function et(t,e){return ot(t)||nt(t,e)||at(t,e)||rt()}function rt(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function nt(t,e){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t)){var r=[],n=!0,o=!1,i=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done);n=!0)if(r.push(s.value),e&&r.length===e)break}catch(u){o=!0,i=u}finally{try{n||null==a["return"]||a["return"]()}finally{if(o)throw i}}return r}}function ot(t){if(Array.isArray(t))return t}function it(t){return lt(t)||ut(t)||at(t)||st()}function st(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function at(t,e){if(t){if("string"===typeof t)return ct(t,e);var r=Object.prototype.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?ct(t,e):void 0}}function ut(t){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}function lt(t){if(Array.isArray(t))return ct(t)}function ct(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=new Array(e);r<e;r++)n[r]=t[r];return n}function ft(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function dt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function ht(t,e,r){return e&&dt(t.prototype,e),r&&dt(t,r),t}function pt(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}(function(t){t[t["VALUE"]=1]="VALUE",t[t["INTERVAL"]=2]="INTERVAL",t[t["MIN"]=3]="MIN",t[t["MAX"]=4]="MAX",t[t["ORDER"]=5]="ORDER"})(J||(J={}));var yt=(Y={},pt(Y,J.VALUE,'The type of the "value" is illegal'),pt(Y,J.INTERVAL,'The prop "interval" is invalid, "(max - min)" must be divisible by "interval"'),pt(Y,J.MIN,'The "value" must be greater than or equal to the "min".'),pt(Y,J.MAX,'The "value" must be less than or equal to the "max".'),pt(Y,J.ORDER,'When "order" is false, the parameters "minRange", "maxRange", "fixed", "enabled" are invalid.'),Y),vt=function(){function t(e){ft(this,t),this.dotsPos=[],this.dotsValue=[],this.cacheRangeDir={},this.data=e.data,this.max=e.max,this.min=e.min,this.interval=e.interval,this.order=e.order,this.marks=e.marks,this.included=e.included,this.process=e.process,this.adsorb=e.adsorb,this.dotOptions=e.dotOptions,this.onError=e.onError,this.order?(this.minRange=e.minRange||0,this.maxRange=e.maxRange||0,this.enableCross=e.enableCross,this.fixed=e.fixed):((e.minRange||e.maxRange||!e.enableCross||e.fixed)&&this.emitError(J.ORDER),this.minRange=0,this.maxRange=0,this.enableCross=!0,this.fixed=!1),this.setValue(e.value)}return ht(t,[{key:"setValue",value:function(t){this.setDotsValue(Array.isArray(t)?it(t):[t],!0)}},{key:"setDotsValue",value:function(t,e){this.dotsValue=t,e&&this.syncDotsPos()}},{key:"setDotsPos",value:function(t){var e=this,r=this.order?it(t).sort((function(t,e){return t-e})):t;this.dotsPos=r,this.setDotsValue(r.map((function(t){return e.getValueByPos(t)})),this.adsorb)}},{key:"getValueByPos",value:function(t){var e=this.parsePos(t);if(this.included){var r=100;this.markList.forEach((function(n){var o=Math.abs(n.pos-t);o<r&&(r=o,e=n.value)}))}return e}},{key:"syncDotsPos",value:function(){var t=this;this.dotsPos=this.dotsValue.map((function(e){return t.parseValue(e)}))}},{key:"getRecentDot",value:function(t){var e=this.dotsPos.map((function(e){return Math.abs(e-t)}));return e.indexOf(Math.min.apply(Math,it(e)))}},{key:"getIndexByValue",value:function(t){return this.data?this.data.indexOf(t):new Q(+t).minus(this.min).divide(this.interval).toNumber()}},{key:"getValueByIndex",value:function(t){return t<0?t=0:t>this.total&&(t=this.total),this.data?this.data[t]:new Q(t).multiply(this.interval).plus(this.min).toNumber()}},{key:"setDotPos",value:function(t,e){t=this.getValidPos(t,e).pos;var r=t-this.dotsPos[e];if(r){var n=new Array(this.dotsPos.length);this.fixed?n=this.getFixedChangePosArr(r,e):this.minRange||this.maxRange?n=this.getLimitRangeChangePosArr(t,r,e):n[e]=r,this.setDotsPos(this.dotsPos.map((function(t,e){return t+(n[e]||0)})))}}},{key:"getFixedChangePosArr",value:function(t,e){var r=this;return this.dotsPos.forEach((function(n,o){if(o!==e){var i=r.getValidPos(n+t,o),s=i.pos,a=i.inRange;a||(t=Math.min(Math.abs(s-n),Math.abs(t))*(t<0?-1:1))}})),this.dotsPos.map((function(e){return t}))}},{key:"getLimitRangeChangePosArr",value:function(t,e,r){var n=this,o=[{index:r,changePos:e}],i=e;return[this.minRange,this.maxRange].forEach((function(s,a){if(!s)return!1;var u=0===a,l=e>0,c=0;c=u?l?1:-1:l?-1:1;var f=function(t,e){var r=Math.abs(t-e);return u?r<n.minRangeDir:r>n.maxRangeDir},d=r+c,h=n.dotsPos[d],p=t;while(n.isPos(h)&&f(h,p)){var y=n.getValidPos(h+i,d),v=y.pos;o.push({index:d,changePos:v-h}),d+=c,p=v,h=n.dotsPos[d]}})),this.dotsPos.map((function(t,e){var r=o.filter((function(t){return t.index===e}));return r.length?r[0].changePos:0}))}},{key:"isPos",value:function(t){return"number"===typeof t}},{key:"getValidPos",value:function(t,e){var r=this.valuePosRange[e],n=!0;return t<r[0]?(t=r[0],n=!1):t>r[1]&&(t=r[1],n=!1),{pos:t,inRange:n}}},{key:"parseValue",value:function(t){if(this.data)t=this.data.indexOf(t);else if("number"===typeof t||"string"===typeof t){if(t=+t,t<this.min)return this.emitError(J.MIN),0;if(t>this.max)return this.emitError(J.MAX),0;if("number"!==typeof t||t!==t)return this.emitError(J.VALUE),0;t=new Q(t).minus(this.min).divide(this.interval).toNumber()}var e=new Q(t).multiply(this.gap).toNumber();return e<0?0:e>100?100:e}},{key:"parsePos",value:function(t){var e=Math.round(t/this.gap);return this.getValueByIndex(e)}},{key:"isActiveByPos",value:function(t){return this.processArray.some((function(e){var r=et(e,2),n=r[0],o=r[1];return t>=n&&t<=o}))}},{key:"getValues",value:function(){if(this.data)return this.data;for(var t=[],e=0;e<=this.total;e++)t.push(new Q(e).multiply(this.interval).plus(this.min).toNumber());return t}},{key:"getRangeDir",value:function(t){return t?new Q(t).divide(new Q(this.data?this.data.length-1:this.max).minus(this.data?0:this.min).toNumber()).multiply(100).toNumber():100}},{key:"emitError",value:function(t){this.onError&&this.onError(t,yt[t])}},{key:"getDotRange",value:function(t,e,r){if(!this.dotOptions)return r;var n=Array.isArray(this.dotOptions)?this.dotOptions[t]:this.dotOptions;return n&&void 0!==n[e]?this.parseValue(n[e]):r}},{key:"markList",get:function(){var t=this;if(!this.marks)return[];var e=function(e,r){var n=t.parseValue(e);return tt({pos:n,value:e,label:e,active:t.isActiveByPos(n)},r)};return!0===this.marks?this.getValues().map((function(t){return e(t)})):"[object Object]"===Object.prototype.toString.call(this.marks)?Object.keys(this.marks).sort((function(t,e){return+t-+e})).map((function(r){var n=t.marks[r];return e(r,"string"!==typeof n?n:{label:n})})):Array.isArray(this.marks)?this.marks.map((function(t){return e(t)})):"function"===typeof this.marks?this.getValues().map((function(e){return{value:e,result:t.marks(e)}})).filter((function(t){var e=t.result;return!!e})).map((function(t){var r=t.value,n=t.result;return e(r,n)})):[]}},{key:"processArray",get:function(){if(this.process){if("function"===typeof this.process)return this.process(this.dotsPos);if(1===this.dotsPos.length)return[[0,this.dotsPos[0]]];if(this.dotsPos.length>1)return[[Math.min.apply(Math,it(this.dotsPos)),Math.max.apply(Math,it(this.dotsPos))]]}return[]}},{key:"total",get:function(){var t=0;return t=this.data?this.data.length-1:new Q(this.max).minus(this.min).divide(this.interval).toNumber(),t-Math.floor(t)!==0?(this.emitError(J.INTERVAL),0):t}},{key:"gap",get:function(){return 100/this.total}},{key:"minRangeDir",get:function(){return this.cacheRangeDir[this.minRange]?this.cacheRangeDir[this.minRange]:this.cacheRangeDir[this.minRange]=this.getRangeDir(this.minRange)}},{key:"maxRangeDir",get:function(){return this.cacheRangeDir[this.maxRange]?this.cacheRangeDir[this.maxRange]:this.cacheRangeDir[this.maxRange]=this.getRangeDir(this.maxRange)}},{key:"valuePosRange",get:function(){var t=this,e=this.dotsPos,r=[];return e.forEach((function(n,o){r.push([Math.max(t.minRange?t.minRangeDir*o:0,t.enableCross?0:e[o-1]||0,t.getDotRange(o,"min",0)),Math.min(t.minRange?100-t.minRangeDir*(e.length-1-o):100,t.enableCross?100:e[o+1]||100,t.getDotRange(o,"max",100))])})),r}},{key:"dotsIndex",get:function(){var t=this;return this.dotsValue.map((function(e){return t.getIndexByValue(e)}))}}]),t}();function mt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function bt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function gt(t,e,r){return e&&bt(t.prototype,e),r&&bt(t,r),t}var kt=function(){function t(e){mt(this,t),this.states=0,this.map=e}return gt(t,[{key:"add",value:function(t){this.states|=t}},{key:"delete",value:function(t){this.states&=~t}},{key:"toggle",value:function(t){this.has(t)?this.delete(t):this.add(t)}},{key:"has",value:function(t){return!!(this.states&t)}}]),t}();r("4abb");function Ot(t){return Ot="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Ot(t)}function xt(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function wt(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?xt(Object(r),!0).forEach((function(e){Et(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):xt(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}function St(t,e){return Dt(t)||Rt(t,e)||Vt(t,e)||Pt()}function Pt(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function Rt(t,e){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t)){var r=[],n=!0,o=!1,i=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done);n=!0)if(r.push(s.value),e&&r.length===e)break}catch(u){o=!0,i=u}finally{try{n||null==a["return"]||a["return"]()}finally{if(o)throw i}}return r}}function Dt(t){if(Array.isArray(t))return t}function Et(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function jt(t){return _t(t)||Mt(t)||Vt(t)||At()}function At(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function Vt(t,e){if(t){if("string"===typeof t)return Ct(t,e);var r=Object.prototype.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?Ct(t,e):void 0}}function Mt(t){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}function _t(t){if(Array.isArray(t))return Ct(t)}function Ct(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=new Array(e);r<e;r++)n[r]=t[r];return n}function It(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Lt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function Nt(t,e,r){return e&&Lt(t.prototype,e),r&&Lt(t,r),t}function Tt(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Bt(t,e)}function Bt(t,e){return Bt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},Bt(t,e)}function Ht(t){var e=Ft();return function(){var r,n=$t(t);if(e){var o=$t(this).constructor;r=Reflect.construct(n,arguments,o)}else r=n.apply(this,arguments);return zt(this,r)}}function zt(t,e){return!e||"object"!==Ot(e)&&"function"!==typeof e?Ut(t):e}function Ut(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Ft(){if("undefined"===typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"===typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}function $t(t){return $t=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},$t(t)}var Wt={None:0,Drag:2,Focus:4},Gt=4,Xt=function(){var t=function(t){Tt(r,t);var e=Ht(r);function r(){var t;return It(this,r),t=e.apply(this,arguments),t.states=new kt(Wt),t.scale=1,t.focusDotIndex=0,t}return Nt(r,[{key:"onValueChanged",value:function(){this.control&&!this.states.has(Wt.Drag)&&this.isNotSync&&this.control.setValue(this.value)}},{key:"created",value:function(){this.initControl()}},{key:"mounted",value:function(){this.bindEvent()}},{key:"beforeDestroy",value:function(){this.unbindEvent()}},{key:"bindEvent",value:function(){document.addEventListener("touchmove",this.dragMove,{passive:!1}),document.addEventListener("touchend",this.dragEnd,{passive:!1}),document.addEventListener("mousedown",this.blurHandle),document.addEventListener("mousemove",this.dragMove),document.addEventListener("mouseup",this.dragEnd),document.addEventListener("mouseleave",this.dragEnd),document.addEventListener("keydown",this.keydownHandle)}},{key:"unbindEvent",value:function(){document.removeEventListener("touchmove",this.dragMove),document.removeEventListener("touchend",this.dragEnd),document.removeEventListener("mousedown",this.blurHandle),document.removeEventListener("mousemove",this.dragMove),document.removeEventListener("mouseup",this.dragEnd),document.removeEventListener("mouseleave",this.dragEnd),document.removeEventListener("keydown",this.keydownHandle)}},{key:"setScale",value:function(){this.scale=new Q(Math.floor(this.isHorizontal?this.$el.offsetWidth:this.$el.offsetHeight)).divide(100).toNumber()}},{key:"initControl",value:function(){var t=this;this.control=new vt({value:this.value,data:this.data,enableCross:this.enableCross,fixed:this.fixed,max:this.max,min:this.min,interval:this.interval,minRange:this.minRange,maxRange:this.maxRange,order:this.order,marks:this.marks,included:this.included,process:this.process,adsorb:this.adsorb,dotOptions:this.dotOptions,onError:this.emitError}),["data","enableCross","fixed","max","min","interval","minRange","maxRange","order","marks","process","adsorb","included","dotOptions"].forEach((function(e){t.$watch(e,(function(r){if("data"===e&&Array.isArray(t.control.data)&&Array.isArray(r)&&t.control.data.length===r.length&&r.every((function(e,r){return e===t.control.data[r]})))return!1;t.control[e]=r,["data","max","min","interval"].indexOf(e)>-1&&t.control.syncDotsPos()}))}))}},{key:"syncValueByPos",value:function(){var t=this.control.dotsValue;this.isDiff(t,Array.isArray(this.value)?this.value:[this.value])&&this.$emit("change",1===t.length?t[0]:jt(t),this.focusDotIndex)}},{key:"isDiff",value:function(t,e){return t.length!==e.length||t.some((function(t,r){return t!==e[r]}))}},{key:"emitError",value:function(t,e){this.silent||console.error("[VueSlider error]: ".concat(e)),this.$emit("error",t,e)}},{key:"dragStartOnProcess",value:function(t){if(this.dragOnClick){this.setScale();var e=this.getPosByEvent(t),r=this.control.getRecentDot(e);if(this.dots[r].disabled)return;this.dragStart(r),this.control.setDotPos(e,this.focusDotIndex),this.lazy||this.syncValueByPos()}}},{key:"dragStart",value:function(t){this.focusDotIndex=t,this.setScale(),this.states.add(Wt.Drag),this.states.add(Wt.Focus),this.$emit("drag-start",this.focusDotIndex)}},{key:"dragMove",value:function(t){if(!this.states.has(Wt.Drag))return!1;t.preventDefault();var e=this.getPosByEvent(t);this.isCrossDot(e),this.control.setDotPos(e,this.focusDotIndex),this.lazy||this.syncValueByPos();var r=this.control.dotsValue;this.$emit("dragging",1===r.length?r[0]:jt(r),this.focusDotIndex)}},{key:"isCrossDot",value:function(t){if(this.canSort){var e=this.focusDotIndex,r=t;r>this.dragRange[1]?(r=this.dragRange[1],this.focusDotIndex++):r<this.dragRange[0]&&(r=this.dragRange[0],this.focusDotIndex--),e!==this.focusDotIndex&&this.control.setDotPos(r,e)}}},{key:"dragEnd",value:function(){var t=this;if(!this.states.has(Wt.Drag))return!1;setTimeout((function(){t.lazy&&t.syncValueByPos(),t.included&&t.isNotSync?t.control.setValue(t.value):t.control.syncDotsPos(),t.states.delete(Wt.Drag),t.useKeyboard||t.states.delete(Wt.Focus),t.$emit("drag-end",t.focusDotIndex)}))}},{key:"blurHandle",value:function(t){if(!this.states.has(Wt.Focus)||!this.$refs.container||this.$refs.container.contains(t.target))return!1;this.states.delete(Wt.Focus)}},{key:"clickHandle",value:function(t){if(!this.clickable||this.disabled)return!1;if(!this.states.has(Wt.Drag)){this.setScale();var e=this.getPosByEvent(t);this.setValueByPos(e)}}},{key:"focus",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.states.add(Wt.Focus),this.focusDotIndex=t}},{key:"blur",value:function(){this.states.delete(Wt.Focus)}},{key:"getValue",value:function(){var t=this.control.dotsValue;return 1===t.length?t[0]:t}},{key:"getIndex",value:function(){var t=this.control.dotsIndex;return 1===t.length?t[0]:t}},{key:"setValue",value:function(t){this.control.setValue(Array.isArray(t)?jt(t):[t]),this.syncValueByPos()}},{key:"setIndex",value:function(t){var e=this,r=Array.isArray(t)?t.map((function(t){return e.control.getValueByIndex(t)})):this.control.getValueByIndex(t);this.setValue(r)}},{key:"setValueByPos",value:function(t){var e=this,r=this.control.getRecentDot(t);if(this.disabled||this.dots[r].disabled)return!1;this.focusDotIndex=r,this.control.setDotPos(t,r),this.syncValueByPos(),this.useKeyboard&&this.states.add(Wt.Focus),setTimeout((function(){e.included&&e.isNotSync?e.control.setValue(e.value):e.control.syncDotsPos()}))}},{key:"keydownHandle",value:function(t){var e=this;if(!this.useKeyboard||!this.states.has(Wt.Focus))return!1;var r=this.included&&this.marks,n=G(t,{direction:this.direction,max:r?this.control.markList.length-1:this.control.total,min:0,hook:this.keydownHook});if(n){t.preventDefault();var o=-1,i=0;r?(this.control.markList.some((function(t,r){return t.value===e.control.dotsValue[e.focusDotIndex]&&(o=n(r),!0)})),o<0?o=0:o>this.control.markList.length-1&&(o=this.control.markList.length-1),i=this.control.markList[o].pos):(o=n(this.control.getIndexByValue(this.control.dotsValue[this.focusDotIndex])),i=this.control.parseValue(this.control.getValueByIndex(o))),this.isCrossDot(i),this.control.setDotPos(i,this.focusDotIndex),this.syncValueByPos()}}},{key:"getPosByEvent",value:function(t){return W(t,this.$el,this.isReverse)[this.isHorizontal?"x":"y"]/this.scale}},{key:"renderSlot",value:function(t,e,r,n){var o=this.$createElement,i=this.$scopedSlots[t];return i?n?i(e):o("template",{slot:t},[i(e)]):r}},{key:"render",value:function(){var t=this,e=arguments[0];return e("div",a()([{ref:"container",class:this.containerClasses,style:this.containerStyles,on:{click:this.clickHandle,touchstart:this.dragStartOnProcess,mousedown:this.dragStartOnProcess}},this.$attrs]),[e("div",{class:"vue-slider-rail",style:this.railStyle},[this.processArray.map((function(r,n){return t.renderSlot("process",r,e("div",{class:"vue-slider-process",key:"process-".concat(n),style:r.style}),!0)})),this.marks?e("div",{class:"vue-slider-marks"},[this.control.markList.map((function(r,n){var o;return t.renderSlot("mark",r,e("vue-slider-mark",{key:"mark-".concat(n),attrs:{mark:r,hideLabel:t.hideLabel,stepStyle:t.stepStyle,stepActiveStyle:t.stepActiveStyle,labelStyle:t.labelStyle,labelActiveStyle:t.labelActiveStyle},style:(o={},Et(o,t.isHorizontal?"height":"width","100%"),Et(o,t.isHorizontal?"width":"height",t.tailSize),Et(o,t.mainDirection,"".concat(r.pos,"%")),o),on:{pressLabel:function(e){return t.clickable&&t.setValueByPos(e)}}},[t.renderSlot("step",r,null),t.renderSlot("label",r,null)]),!0)}))]):null,this.dots.map((function(r,n){var o;return e("vue-slider-dot",{ref:"dot-".concat(n),key:"dot-".concat(n),attrs:{value:r.value,disabled:r.disabled,focus:r.focus,"dot-style":[r.style,r.disabled?r.disabledStyle:null,r.focus?r.focusStyle:null],tooltip:r.tooltip||t.tooltip,"tooltip-style":[t.tooltipStyle,r.tooltipStyle,r.disabled?r.tooltipDisabledStyle:null,r.focus?r.tooltipFocusStyle:null],"tooltip-formatter":Array.isArray(t.tooltipFormatter)?t.tooltipFormatter[n]:t.tooltipFormatter,"tooltip-placement":t.tooltipDirections[n]},style:[t.dotBaseStyle,(o={},Et(o,t.mainDirection,"".concat(r.pos,"%")),Et(o,"transition","".concat(t.mainDirection," ").concat(t.animateTime,"s")),o)],on:{"drag-start":function(){return t.dragStart(n)}}},[t.renderSlot("dot",r,null),t.renderSlot("tooltip",r,null)])})),this.renderSlot("default",{value:this.getValue()},null,!0)])])}},{key:"tailSize",get:function(){return F((this.isHorizontal?this.height:this.width)||Gt)}},{key:"containerClasses",get:function(){return["vue-slider",["vue-slider-".concat(this.direction)],{"vue-slider-disabled":this.disabled}]}},{key:"containerStyles",get:function(){var t=Array.isArray(this.dotSize)?this.dotSize:[this.dotSize,this.dotSize],e=St(t,2),r=e[0],n=e[1],o=this.width?F(this.width):this.isHorizontal?"auto":F(Gt),i=this.height?F(this.height):this.isHorizontal?F(Gt):"auto";return{padding:this.contained?"".concat(n/2,"px ").concat(r/2,"px"):this.isHorizontal?"".concat(n/2,"px 0"):"0 ".concat(r/2,"px"),width:o,height:i}}},{key:"processArray",get:function(){var t=this;return this.control.processArray.map((function(e,r){var n,o=St(e,3),i=o[0],s=o[1],a=o[2];if(i>s){var u=[s,i];i=u[0],s=u[1]}var l=t.isHorizontal?"width":"height";return{start:i,end:s,index:r,style:wt(wt((n={},Et(n,t.isHorizontal?"height":"width","100%"),Et(n,t.isHorizontal?"top":"left",0),Et(n,t.mainDirection,"".concat(i,"%")),Et(n,l,"".concat(s-i,"%")),Et(n,"transitionProperty","".concat(l,",").concat(t.mainDirection)),Et(n,"transitionDuration","".concat(t.animateTime,"s")),n),t.processStyle),a)}}))}},{key:"dotBaseStyle",get:function(){var t,e=Array.isArray(this.dotSize)?this.dotSize:[this.dotSize,this.dotSize],r=St(e,2),n=r[0],o=r[1];return t=this.isHorizontal?Et({transform:"translate(".concat(this.isReverse?"50%":"-50%",", -50%)"),WebkitTransform:"translate(".concat(this.isReverse?"50%":"-50%",", -50%)"),top:"50%"},"ltr"===this.direction?"left":"right","0"):Et({transform:"translate(-50%, ".concat(this.isReverse?"50%":"-50%",")"),WebkitTransform:"translate(-50%, ".concat(this.isReverse?"50%":"-50%",")"),left:"50%"},"btt"===this.direction?"bottom":"top","0"),wt({width:"".concat(n,"px"),height:"".concat(o,"px")},t)}},{key:"mainDirection",get:function(){switch(this.direction){case"ltr":return"left";case"rtl":return"right";case"btt":return"bottom";case"ttb":return"top"}}},{key:"isHorizontal",get:function(){return"ltr"===this.direction||"rtl"===this.direction}},{key:"isReverse",get:function(){return"rtl"===this.direction||"btt"===this.direction}},{key:"tooltipDirections",get:function(){var t=this.tooltipPlacement||(this.isHorizontal?"top":"left");return Array.isArray(t)?t:this.dots.map((function(){return t}))}},{key:"dots",get:function(){var t=this;return this.control.dotsPos.map((function(e,r){return wt({pos:e,index:r,value:t.control.dotsValue[r],focus:t.states.has(Wt.Focus)&&t.focusDotIndex===r,disabled:t.disabled,style:t.dotStyle},(Array.isArray(t.dotOptions)?t.dotOptions[r]:t.dotOptions)||{})}))}},{key:"animateTime",get:function(){return this.states.has(Wt.Drag)?0:this.duration}},{key:"canSort",get:function(){return this.order&&!this.minRange&&!this.maxRange&&!this.fixed&&this.enableCross}},{key:"isNotSync",get:function(){var t=this.control.dotsValue;return Array.isArray(this.value)?this.value.length!==t.length||this.value.some((function(e,r){return e!==t[r]})):this.value!==t[0]}},{key:"dragRange",get:function(){var t=this.dots[this.focusDotIndex-1],e=this.dots[this.focusDotIndex+1];return[t?t.pos:-1/0,e?e.pos:1/0]}}]),r}(c.a);return u([h("change",{default:0})],t.prototype,"value",void 0),u([p({type:Boolean,default:!1})],t.prototype,"silent",void 0),u([p({default:"ltr",validator:function(t){return["ltr","rtl","ttb","btt"].indexOf(t)>-1}})],t.prototype,"direction",void 0),u([p({type:[Number,String]})],t.prototype,"width",void 0),u([p({type:[Number,String]})],t.prototype,"height",void 0),u([p({default:14})],t.prototype,"dotSize",void 0),u([p({default:!1})],t.prototype,"contained",void 0),u([p({type:Number,default:0})],t.prototype,"min",void 0),u([p({type:Number,default:100})],t.prototype,"max",void 0),u([p({type:Number,default:1})],t.prototype,"interval",void 0),u([p({type:Boolean,default:!1})],t.prototype,"disabled",void 0),u([p({type:Boolean,default:!0})],t.prototype,"clickable",void 0),u([p({type:Boolean,default:!1})],t.prototype,"dragOnClick",void 0),u([p({type:Number,default:.5})],t.prototype,"duration",void 0),u([p(Array)],t.prototype,"data",void 0),u([p({type:Boolean,default:!1})],t.prototype,"lazy",void 0),u([p({type:String,validator:function(t){return["none","always","focus","hover","active"].indexOf(t)>-1},default:"active"})],t.prototype,"tooltip",void 0),u([p({type:[String,Array],validator:function(t){return(Array.isArray(t)?t:[t]).every((function(t){return["top","right","bottom","left"].indexOf(t)>-1}))}})],t.prototype,"tooltipPlacement",void 0),u([p({type:[String,Array,Function]})],t.prototype,"tooltipFormatter",void 0),u([p({type:Boolean,default:!1})],t.prototype,"useKeyboard",void 0),u([p(Function)],t.prototype,"keydownHook",void 0),u([p({type:Boolean,default:!0})],t.prototype,"enableCross",void 0),u([p({type:Boolean,default:!1})],t.prototype,"fixed",void 0),u([p({type:Boolean,default:!0})],t.prototype,"order",void 0),u([p(Number)],t.prototype,"minRange",void 0),u([p(Number)],t.prototype,"maxRange",void 0),u([p({type:[Boolean,Object,Array,Function],default:!1})],t.prototype,"marks",void 0),u([p({type:[Boolean,Function],default:!0})],t.prototype,"process",void 0),u([p(Boolean)],t.prototype,"included",void 0),u([p(Boolean)],t.prototype,"adsorb",void 0),u([p(Boolean)],t.prototype,"hideLabel",void 0),u([p()],t.prototype,"dotOptions",void 0),u([p()],t.prototype,"railStyle",void 0),u([p()],t.prototype,"processStyle",void 0),u([p()],t.prototype,"dotStyle",void 0),u([p()],t.prototype,"tooltipStyle",void 0),u([p()],t.prototype,"stepStyle",void 0),u([p()],t.prototype,"stepActiveStyle",void 0),u([p()],t.prototype,"labelStyle",void 0),u([p()],t.prototype,"labelActiveStyle",void 0),u([y("value")],t.prototype,"onValueChanged",null),t=u([d()({data:function(){return{control:null}},components:{VueSliderDot:E,VueSliderMark:U}})],t),t}(),qt=Xt;qt.VueSliderMark=U,qt.VueSliderDot=E;var Kt=qt;e["default"]=Kt}})["default"]}));
//# sourceMappingURL=vue-slider-component.umd.min.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(791);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6256aef8", content, true, {});

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".vue-slider-disabled{opacity:.5;cursor:not-allowed}.vue-slider-rail{background-color:#ccc;border-radius:15px}.vue-slider-process{background-color:#3498db;border-radius:15px}.vue-slider-mark{z-index:4}.vue-slider-mark:first-child .vue-slider-mark-step,.vue-slider-mark:last-child .vue-slider-mark-step{display:none}.vue-slider-mark-step{width:100%;height:100%;border-radius:50%;background-color:rgba(0,0,0,.16)}.vue-slider-mark-label{font-size:14px;white-space:nowrap}.vue-slider-dot-handle{cursor:pointer;width:100%;height:100%;border-radius:50%;background-color:#fff;box-sizing:border-box;box-shadow:.5px .5px 2px 1px rgba(0,0,0,.32)}.vue-slider-dot-handle-focus{box-shadow:0 0 1px 2px rgba(52,152,219,.36)}.vue-slider-dot-handle-disabled{cursor:not-allowed;background-color:#ccc}.vue-slider-dot-tooltip-inner{font-size:14px;white-space:nowrap;padding:2px 5px;min-width:20px;text-align:center;color:#fff;border-radius:5px;border-color:#3498db;background-color:#3498db;box-sizing:content-box}.vue-slider-dot-tooltip-inner:after{content:\"\";position:absolute}.vue-slider-dot-tooltip-inner-top:after{top:100%;left:50%;transform:translate(-50%);height:0;width:0;border:5px solid transparent;border-top-color:inherit}.vue-slider-dot-tooltip-inner-bottom:after{bottom:100%;left:50%;transform:translate(-50%);height:0;width:0;border:5px solid transparent;border-bottom-color:inherit}.vue-slider-dot-tooltip-inner-left:after{left:100%;top:50%;transform:translateY(-50%);height:0;width:0;border:5px solid transparent;border-left-color:inherit}.vue-slider-dot-tooltip-inner-right:after{right:100%;top:50%;transform:translateY(-50%);height:0;width:0;border:5px solid transparent;border-right-color:inherit}.vue-slider-dot-tooltip-wrapper{opacity:0;transition:all .3s}.vue-slider-dot-tooltip-wrapper-show{opacity:1}", ""]);

// exports


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticStyle:{"font-weight":"500","margin-bottom":"0"}},[_vm._v("Service Schedule")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Sunday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.sundayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.sundayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.sundayRange),callback:function ($$v) {_vm.sundayRange=$$v},expression:"sundayRange"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Monday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.mondayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.mondayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.mondayRange),callback:function ($$v) {_vm.mondayRange=$$v},expression:"mondayRange"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Tuesday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.tuesdayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.tuesdayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.tuesdayRange),callback:function ($$v) {_vm.tuesdayRange=$$v},expression:"tuesdayRange"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Wednesday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.wednesdayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.wednesdayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.wednesdayRange),callback:function ($$v) {_vm.wednesdayRange=$$v},expression:"wednesdayRange"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Thursday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.thursdayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.thursdayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.thursdayRange),callback:function ($$v) {_vm.thursdayRange=$$v},expression:"thursdayRange"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Friday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.fridayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.fridayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.fridayRange),callback:function ($$v) {_vm.fridayRange=$$v},expression:"fridayRange"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v("Saturday")]),_vm._v(" "),_c('label',{staticStyle:{"width":"100%","margin-bottom":"0"}},[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.saturdayRange[0]))),_c('span',{staticStyle:{"float":"right"}},[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.saturdayRange[1])))])]),_vm._v(" "),_c('vue-slider',{attrs:{"data":_vm.timeOptions,"enable-cross":false},model:{value:(_vm.saturdayRange),callback:function ($$v) {_vm.saturdayRange=$$v},expression:"saturdayRange"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-1",on:{"click":function($event){return _vm.updateSchedule()}}},[_vm._v("Update Schedule")]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"schedule-updated-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Schedule updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('schedule-updated-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scheduler_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd440446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scheduler_vue__ = __webpack_require__(794);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scheduler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd440446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[(_vm.user.selector1 == 'Permanent' || _vm.user.selector1 == 'Interim')?_c('h4',{staticClass:"pt-1"},[_vm._v("Additional Service Request")]):_c('h4',{staticClass:"pt-1"},[_vm._v("Service Request")]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.selectedDate)?_c('div',[_c('p',[_vm._v("Please select a date.")])]):_vm._e(),_vm._v(" "),(_vm.selectedDate)?_c('div',[_c('h4',[_vm._v(_vm._s(_vm.selectedDate.toDateString()))]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"10px"}},[_vm._v("Start Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startHour),expression:"startHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'StartHour'+index},[_vm._v(_vm._s(hour))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startMinute),expression:"startMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'StartMinute'+index},[_vm._v(_vm._s(minute))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startAMPM),expression:"startAMPM"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startAMPM=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.ampmOptions),function(ampm,index){return _c('option',{key:'StartAMPM'+index},[_vm._v(_vm._s(ampm))])}),0)]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"12px"}},[_vm._v("End Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endHour),expression:"endHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'EndHour'+index},[_vm._v(_vm._s(hour))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endMinute),expression:"endMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'EndMinute'+index},[_vm._v(_vm._s(minute))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endAMPM),expression:"endAMPM"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endAMPM=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.ampmOptions),function(ampm,index){return _c('option',{key:'EndAMPM'+index},[_vm._v(_vm._s(ampm))])}),0)]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"12px"}},[_vm._v("Preferred Nanny/Babysitter Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredNanny),expression:"preferredNanny"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Is there someone you would prefer?"},domProps:{"value":(_vm.preferredNanny)},on:{"input":function($event){if($event.target.composing){ return; }_vm.preferredNanny=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"12px"}},[_vm._v("Special Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Anything in particular we should know about what you need?"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.postJob()}}},[_vm._v("Create Request")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 calendar",staticStyle:{"min-height":"550px"}},[_c('calendar-view',{staticClass:"theme-default holiday-us-traditional holiday-us-official",attrs:{"show-date":_vm.showDate,"date-classes":_vm.selectedDateObj,"events":_vm.calendarJobs},on:{"click-date":_vm.onClickDate,"click-event":_vm.onClickEvent},scopedSlots:_vm._u([{key:"header",fn:function(t){return _c('calendar-view-header',{attrs:{"header-props":t.headerProps},on:{"input":_vm.setShowDate}})}}])})],1)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v(_vm._s(new Date(_vm.job.date).toDateString()))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Status: "+_vm._s(_vm.job.status))]),_vm._v(" "),_c('p',[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.job.start_time)))]),_vm._v(" "),_c('p',[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.job.end_time)))]),_vm._v(" "),(_vm.job.text)?_c('pre',[_vm._v("Notes: "+_vm._s(_vm.job.text))]):_vm._e(),_vm._v(" "),(_vm.job.status != 'Requested')?_c('div',[_c('hr'),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("We are currently processing your request. If you really need to change it please contact us immediately (a cancellation fee may be required).")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('job-modal')}}},[_vm._v("Close")]),_vm._v(" "),(_vm.job.status == 'Requested')?_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.$modal.show('delete-job-modal')}}},[_vm._v("Delete")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"request-submitted-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Your request has been submitted.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('request-submitted-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-job-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Are you sure you want to delete this request?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-job-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteJob()}}},[_vm._v("Delete")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resources_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec4aba5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resources_vue__ = __webpack_require__(796);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec4aba5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.files.length)?_c('div',{staticClass:"profile-tile"},[_c('h3',[_vm._v("Resources")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.files),function(file){return _c('div',{key:file.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('a',{attrs:{"href":file.file_link,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])])])])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"p-4 shadow",staticStyle:{"border-radius":"6px"}},[_c('h2',[_vm._v("Welcome "+_vm._s(_vm.user.first_name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-1",on:{"click":function($event){return _vm.showApplicationModal()}}},[_vm._v("\n      View Application\n    ")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-1",on:{"click":function($event){return _vm.showUpdateApplicationModal()}}},[_vm._v("\n      Update Application\n    ")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-1",on:{"click":function($event){return _vm.showChangePasswordModal()}}},[_vm._v("\n      Change Password\n    ")]),_vm._v(" "),(_vm.user.status == 'Applied')?_c('p',{staticClass:"mt-3"},[_vm._v("\n      Your application is pending administrator review.\n    ")]):_vm._e()]),_vm._v(" "),_c('div',[_c('resources',{attrs:{"user":_vm.user}})],1),_vm._v(" "),(_vm.statuses.indexOf(_vm.user.status) >= _vm.statuses.indexOf('Application Approved'))?_c('div',[_c('documents',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(!_vm.user.stripe_customer_id && _vm.user.selector1 != 'Sitter')?_c('div',{staticClass:"p-4 shadow",staticStyle:{"border-radius":"6px","margin-top":"40px"}},[_c('div',{},[_c('h4',{staticStyle:{"font-weight":"500","margin-bottom":"0"}},[_vm._v("\n        Please Enter Your Payment Information\n      ")]),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-4"},[(_vm.user.selector1 == 'Sitter')?_c('span',[_vm._v("Your information is securely stored and you will only be charged for services you book.")]):_vm._e(),_vm._v(" "),(_vm.user.selector1 == 'Nanny' || _vm.user.selector1 == 'Newborn Care Specialist')?_c('span',[_vm._v("There is a non-refundable fee of $250 due with submission, of which $200 will be applied to your final invoice.")]):_vm._e(),_vm._v(" "),(_vm.user.selector1 == 'Private Educator')?_c('span',[_vm._v("There is a non-refundable fee of $500 due with submission, of which $400 will be applied to your final invoice.")]):_vm._e()]),_vm._v(" "),_c('payments',{attrs:{"email":_vm.user.email,"user":_vm.user},on:{"subscribed":function($event){return _vm.subscribed()}}}),_vm._v(" "),_vm._m(0)],1)]):_vm._e(),_vm._v(" "),(
      _vm.statuses.indexOf(_vm.user.status) >=
        _vm.statuses.indexOf('Documents Signed')
    )?_c('div',{staticClass:"profile-tile"},[_c('my-candidates',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.user.status == 'Active' && _vm.user.selector1 == 'Sitter')?_c('div',{staticClass:"profile-tile"},[_c('scheduler',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.user.id && !_vm.$store.getters.isAgent)?_c('div',[_c('feedback',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"application-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('application',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('application-modal')}}},[_vm._v("\n        Close\n      ")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"update-aplication-modal","width":"80%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('family-form-edit',{attrs:{"user":_vm.user},on:{"infoSaved":function($event){return _vm.infoSaved()}}})],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"change-password-modal","width":"85%","height":"auto","scrollable":true}},[(_vm.user.id)?_c('div',{staticClass:"p-5"},[_c('change-password',{attrs:{"userID":_vm.user.id},on:{"passwordchanged":function($event){return _vm.passwordChanged()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('change-password-modal')}}},[_vm._v("\n        Cancel\n      ")])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"password-changed-confirmation-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Password has been reset successfully.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('password-changed-confirmation-modal')}}},[_vm._v("\n        Close\n      ")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"payment-info-entered-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("\n        Thank you for submitting your payment information, we will be in touch with you shortly!\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('payment-info-entered-modal')}}},[_vm._v("\n        Close\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2",staticStyle:{"margin-bottom":"40px"}},[_c('a',{attrs:{"href":"https://www.stripe.com","target":"_blank"}},[_c('img',{staticStyle:{"float":"right"},attrs:{"src":__webpack_require__(798),"alt":"Powered by Stripe","width":"150px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "powered_by_stripe_outline@2x.png?07453cbacff9869513acbffb2ed7b44c";

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jobs_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19331956_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jobs_vue__ = __webpack_require__(800);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jobs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19331956_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jobs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state == 'joblist')?_c('div',[_c('button',{staticClass:"mylisting-button dark-button mb-5",on:{"click":function($event){return _vm.postState()}}},[_vm._v("Post Opportunity")]),_vm._v(" "),_c('h2',{staticClass:"dashboard-heading"},[_vm._v("Manage Opportunities")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-job-list',{attrs:{"jobs":_vm.jobs},on:{"editJob":function($event){return _vm.editJob($event)}}}),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{name: 'Job Board'}}},[_vm._v("Job Board")])],1)],1):_vm._e(),_vm._v(" "),(_vm.state == 'post')?_c('div',[_c('h2',{staticClass:"dashboard-heading"},[_vm._v("Post New Opportunity")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelPost()}}},[_vm._v("Cancel Post")]),_vm._v(" "),_c('app-job-form',{attrs:{"userID":_vm.userID,"jobID":null},on:{"jobPosted":function($event){return _vm.jobPosted()}}}),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelPost()}}},[_vm._v("Cancel Post")])],1):_vm._e(),_vm._v(" "),(_vm.state == 'edit' && _vm.jobToEdit.id)?_c('div',[_c('h2',{staticClass:"dashboard-heading"},[_vm._v("Edit - "+_vm._s(_vm.jobToEdit.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelEdit()}}},[_vm._v("Cancel Edit")]),_vm._v(" "),_c('app-job-form',{attrs:{"userID":_vm.userID,"jobID":_vm.jobToEdit.id},on:{"jobUpdated":function($event){return _vm.jobUpdated()}}}),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelEdit()}}},[_vm._v("Cancel Edit")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minimalTimezoneSet */
/**
 * @fileoverview
 *
 * This package contains an array of timezones based on conventional options found online.
 * It does not follow any complete data set, but all names are according to the tz format:
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones.
 *
 * More specifically, the fields in the array are:
 * – offset, a string from '-11:00' to '+14:00' representing the UTC offset
 * - label, a readable label that contains the offset and a longer, descriptive name of the timezone
 * - tzCode, the value from the tz standard
 *
 * Install:
 *  `npm install compact-timezone-list --save`
 *   # or
 *  `yarn add compact-timezone-list`
 *
 *
 *  Example:
 *  import timezones from 'compact-timezone-list';
 *  // or
 *  import { minimalTimezoneSet } from 'compact-timezone-list';
 *
 *  Details:
 *  - The default export provides a long list of options, with multiple
 *  suggestions for each UTC offset.
 *  – The `minimalTimezoneSet` export provides one option per offset type, with
 *  a favourite chosen to represent each offset. This is mostly targeted to small,
 *  western-focused apps. But, every UTC offset is included.
 */

/**
 *
 * @type {Array.<{ offset: string, label: string, tzCode: string }>}
 */
/* harmony default export */ __webpack_exports__["a"] = ([
  { offset: '-11:00', label: '(GMT-11:00) Niue', tzCode: 'Pacific/Niue' },
  { offset: '-11:00', label: '(GMT-11:00) Pago Pago', tzCode: 'Pacific/Pago_Pago' },
  { offset: '-10:00', label: '(GMT-10:00) Hawaii Time', tzCode: 'Pacific/Honolulu' },
  { offset: '-10:00', label: '(GMT-10:00) Rarotonga', tzCode: 'Pacific/Rarotonga' },
  { offset: '-10:00', label: '(GMT-10:00) Tahiti', tzCode: 'Pacific/Tahiti' },
  { offset: '-09:30', label: '(GMT-09:30) Marquesas', tzCode: 'Pacific/Marquesas' },
  { offset: '-09:00', label: '(GMT-09:00) Alaska Time', tzCode: 'America/Anchorage' },
  { offset: '-09:00', label: '(GMT-09:00) Gambier', tzCode: 'Pacific/Gambier' },
  { offset: '-08:00', label: '(GMT-08:00) Pacific Time', tzCode: 'America/Los_Angeles' },
  { offset: '-08:00', label: '(GMT-08:00) Pacific Time - Tijuana', tzCode: 'America/Tijuana' },
  { offset: '-08:00', label: '(GMT-08:00) Pacific Time - Vancouver', tzCode: 'America/Vancouver' },
  { offset: '-08:00', label: '(GMT-08:00) Pacific Time - Whitehorse', tzCode: 'America/Whitehorse' },
  { offset: '-08:00', label: '(GMT-08:00) Pitcairn', tzCode: 'Pacific/Pitcairn' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time', tzCode: 'America/Denver' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time - Arizona', tzCode: 'America/Phoenix' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan', tzCode: 'America/Mazatlan' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time - Dawson Creek', tzCode: 'America/Dawson_Creek' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time - Edmonton', tzCode: 'America/Edmonton' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time - Hermosillo', tzCode: 'America/Hermosillo' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time - Yellowknife', tzCode: 'America/Yellowknife' },
  { offset: '-06:00', label: '(GMT-06:00) Belize', tzCode: 'America/Belize' },
  { offset: '-06:00', label: '(GMT-06:00) Central Time', tzCode: 'America/Chicago' },
  { offset: '-06:00', label: '(GMT-06:00) Central Time - Mexico City', tzCode: 'America/Mexico_City' },
  { offset: '-06:00', label: '(GMT-06:00) Central Time - Regina', tzCode: 'America/Regina' },
  { offset: '-06:00', label: '(GMT-06:00) Central Time - Tegucigalpa', tzCode: 'America/Tegucigalpa' },
  { offset: '-06:00', label: '(GMT-06:00) Central Time - Winnipeg', tzCode: 'America/Winnipeg' },
  { offset: '-06:00', label: '(GMT-06:00) Costa Rica', tzCode: 'America/Costa_Rica' },
  { offset: '-06:00', label: '(GMT-06:00) El Salvador', tzCode: 'America/El_Salvador' },
  { offset: '-06:00', label: '(GMT-06:00) Galapagos', tzCode: 'Pacific/Galapagos' },
  { offset: '-06:00', label: '(GMT-06:00) Guatemala', tzCode: 'America/Guatemala' },
  { offset: '-06:00', label: '(GMT-06:00) Managua', tzCode: 'America/Managua' },
  { offset: '-05:00', label: '(GMT-05:00) America Cancun', tzCode: 'America/Cancun' },
  { offset: '-05:00', label: '(GMT-05:00) Bogota', tzCode: 'America/Bogota' },
  { offset: '-05:00', label: '(GMT-05:00) Easter Island', tzCode: 'Pacific/Easter' },
  { offset: '-05:00', label: '(GMT-05:00) Eastern Time', tzCode: 'America/New_York' },
  { offset: '-05:00', label: '(GMT-05:00) Eastern Time - Iqaluit', tzCode: 'America/Iqaluit' },
  { offset: '-05:00', label: '(GMT-05:00) Eastern Time - Toronto', tzCode: 'America/Toronto' },
  { offset: '-05:00', label: '(GMT-05:00) Guayaquil', tzCode: 'America/Guayaquil' },
  { offset: '-05:00', label: '(GMT-05:00) Havana', tzCode: 'America/Havana' },
  { offset: '-05:00', label: '(GMT-05:00) Jamaica', tzCode: 'America/Jamaica' },
  { offset: '-05:00', label: '(GMT-05:00) Lima', tzCode: 'America/Lima' },
  { offset: '-05:00', label: '(GMT-05:00) Nassau', tzCode: 'America/Nassau' },
  { offset: '-05:00', label: '(GMT-05:00) Panama', tzCode: 'America/Panama' },
  { offset: '-05:00', label: '(GMT-05:00) Port-au-Prince', tzCode: 'America/Port-au-Prince' },
  { offset: '-05:00', label: '(GMT-05:00) Rio Branco', tzCode: 'America/Rio_Branco' },
  { offset: '-04:00', label: '(GMT-04:00) Atlantic Time - Halifax', tzCode: 'America/Halifax' },
  { offset: '-04:00', label: '(GMT-04:00) Barbados', tzCode: 'America/Barbados' },
  { offset: '-04:00', label: '(GMT-04:00) Bermuda', tzCode: 'Atlantic/Bermuda' },
  { offset: '-04:00', label: '(GMT-04:00) Boa Vista', tzCode: 'America/Boa_Vista' },
  { offset: '-04:00', label: '(GMT-04:00) Caracas', tzCode: 'America/Caracas' },
  { offset: '-04:00', label: '(GMT-04:00) Curacao', tzCode: 'America/Curacao' },
  { offset: '-04:00', label: '(GMT-04:00) Grand Turk', tzCode: 'America/Grand_Turk' },
  { offset: '-04:00', label: '(GMT-04:00) Guyana', tzCode: 'America/Guyana' },
  { offset: '-04:00', label: '(GMT-04:00) La Paz', tzCode: 'America/La_Paz' },
  { offset: '-04:00', label: '(GMT-04:00) Manaus', tzCode: 'America/Manaus' },
  { offset: '-04:00', label: '(GMT-04:00) Martinique', tzCode: 'America/Martinique' },
  { offset: '-04:00', label: '(GMT-04:00) Port of Spain', tzCode: 'America/Port_of_Spain' },
  { offset: '-04:00', label: '(GMT-04:00) Porto Velho', tzCode: 'America/Porto_Velho' },
  { offset: '-04:00', label: '(GMT-04:00) Puerto Rico', tzCode: 'America/Puerto_Rico' },
  { offset: '-04:00', label: '(GMT-04:00) Santo Domingo', tzCode: 'America/Santo_Domingo' },
  { offset: '-04:00', label: '(GMT-04:00) Thule', tzCode: 'America/Thule' },
  { offset: '-03:30', label: '(GMT-03:30) Newfoundland Time - St. Johns', tzCode: 'America/St_Johns' },
  { offset: '-03:00', label: '(GMT-03:00) Araguaina', tzCode: 'America/Araguaina' },
  { offset: '-03:00', label: '(GMT-03:00) Asuncion', tzCode: 'America/Asuncion' },
  { offset: '-03:00', label: '(GMT-03:00) Belem', tzCode: 'America/Belem' },
  { offset: '-03:00', label: '(GMT-03:00) Buenos Aires', tzCode: 'America/Argentina/Buenos_Aires' },
  { offset: '-03:00', label: '(GMT-03:00) Campo Grande', tzCode: 'America/Campo_Grande' },
  { offset: '-03:00', label: '(GMT-03:00) Cayenne', tzCode: 'America/Cayenne' },
  { offset: '-03:00', label: '(GMT-03:00) Cuiaba', tzCode: 'America/Cuiaba' },
  { offset: '-03:00', label: '(GMT-03:00) Fortaleza', tzCode: 'America/Fortaleza' },
  { offset: '-03:00', label: '(GMT-03:00) Godthab', tzCode: 'America/Godthab' },
  { offset: '-03:00', label: '(GMT-03:00) Maceio', tzCode: 'America/Maceio' },
  { offset: '-03:00', label: '(GMT-03:00) Miquelon', tzCode: 'America/Miquelon' },
  { offset: '-03:00', label: '(GMT-03:00) Montevideo', tzCode: 'America/Montevideo' },
  { offset: '-03:00', label: '(GMT-03:00) Palmer', tzCode: 'Antarctica/Palmer' },
  { offset: '-03:00', label: '(GMT-03:00) Paramaribo', tzCode: 'America/Paramaribo' },
  { offset: '-03:00', label: '(GMT-03:00) Punta Arenas', tzCode: 'America/Punta_Arenas' },
  { offset: '-03:00', label: '(GMT-03:00) Recife', tzCode: 'America/Recife' },
  { offset: '-03:00', label: '(GMT-03:00) Rothera', tzCode: 'Antarctica/Rothera' },
  { offset: '-03:00', label: '(GMT-03:00) Salvador', tzCode: 'America/Bahia' },
  { offset: '-03:00', label: '(GMT-03:00) Santiago', tzCode: 'America/Santiago' },
  { offset: '-03:00', label: '(GMT-03:00) Stanley', tzCode: 'Atlantic/Stanley' },
  { offset: '-02:00', label: '(GMT-02:00) Noronha', tzCode: 'America/Noronha' },
  { offset: '-02:00', label: '(GMT-02:00) Sao Paulo', tzCode: 'America/Sao_Paulo' },
  { offset: '-02:00', label: '(GMT-02:00) South Georgia', tzCode: 'Atlantic/South_Georgia' },
  { offset: '-01:00', label: '(GMT-01:00) Azores', tzCode: 'Atlantic/Azores' },
  { offset: '-01:00', label: '(GMT-01:00) Cape Verde', tzCode: 'Atlantic/Cape_Verde' },
  { offset: '-01:00', label: '(GMT-01:00) Scoresbysund', tzCode: 'America/Scoresbysund' },
  { offset: '+00:00', label: '(GMT+00:00) Abidjan', tzCode: 'Africa/Abidjan' },
  { offset: '+00:00', label: '(GMT+00:00) Accra', tzCode: 'Africa/Accra' },
  { offset: '+00:00', label: '(GMT+00:00) Bissau', tzCode: 'Africa/Bissau' },
  { offset: '+00:00', label: '(GMT+00:00) Canary Islands', tzCode: 'Atlantic/Canary' },
  { offset: '+00:00', label: '(GMT+00:00) Casablanca', tzCode: 'Africa/Casablanca' },
  { offset: '+00:00', label: '(GMT+00:00) Danmarkshavn', tzCode: 'America/Danmarkshavn' },
  { offset: '+00:00', label: '(GMT+00:00) Dublin', tzCode: 'Europe/Dublin' },
  { offset: '+00:00', label: '(GMT+00:00) El Aaiun', tzCode: 'Africa/El_Aaiun' },
  { offset: '+00:00', label: '(GMT+00:00) Faeroe', tzCode: 'Atlantic/Faroe' },
  { offset: '+00:00', label: '(GMT+00:00) GMT (no daylight saving)', tzCode: 'Etc/GMT' },
  { offset: '+00:00', label: '(GMT+00:00) Lisbon', tzCode: 'Europe/Lisbon' },
  { offset: '+00:00', label: '(GMT+00:00) London', tzCode: 'Europe/London' },
  { offset: '+00:00', label: '(GMT+00:00) Monrovia', tzCode: 'Africa/Monrovia' },
  { offset: '+00:00', label: '(GMT+00:00) Reykjavik', tzCode: 'Atlantic/Reykjavik' },
  { offset: '+01:00', label: '(GMT+01:00) Algiers', tzCode: 'Africa/Algiers' },
  { offset: '+01:00', label: '(GMT+01:00) Amsterdam', tzCode: 'Europe/Amsterdam' },
  { offset: '+01:00', label: '(GMT+01:00) Andorra', tzCode: 'Europe/Andorra' },
  { offset: '+01:00', label: '(GMT+01:00) Berlin', tzCode: 'Europe/Berlin' },
  { offset: '+01:00', label: '(GMT+01:00) Brussels', tzCode: 'Europe/Brussels' },
  { offset: '+01:00', label: '(GMT+01:00) Budapest', tzCode: 'Europe/Budapest' },
  { offset: '+01:00', label: '(GMT+01:00) Central European Time - Belgrade', tzCode: 'Europe/Belgrade' },
  { offset: '+01:00', label: '(GMT+01:00) Central European Time - Prague', tzCode: 'Europe/Prague' },
  { offset: '+01:00', label: '(GMT+01:00) Ceuta', tzCode: 'Africa/Ceuta' },
  { offset: '+01:00', label: '(GMT+01:00) Copenhagen', tzCode: 'Europe/Copenhagen' },
  { offset: '+01:00', label: '(GMT+01:00) Gibraltar', tzCode: 'Europe/Gibraltar' },
  { offset: '+01:00', label: '(GMT+01:00) Lagos', tzCode: 'Africa/Lagos' },
  { offset: '+01:00', label: '(GMT+01:00) Luxembourg', tzCode: 'Europe/Luxembourg' },
  { offset: '+01:00', label: '(GMT+01:00) Madrid', tzCode: 'Europe/Madrid' },
  { offset: '+01:00', label: '(GMT+01:00) Malta', tzCode: 'Europe/Malta' },
  { offset: '+01:00', label: '(GMT+01:00) Monaco', tzCode: 'Europe/Monaco' },
  { offset: '+01:00', label: '(GMT+01:00) Ndjamena', tzCode: 'Africa/Ndjamena' },
  { offset: '+01:00', label: '(GMT+01:00) Oslo', tzCode: 'Europe/Oslo' },
  { offset: '+01:00', label: '(GMT+01:00) Paris', tzCode: 'Europe/Paris' },
  { offset: '+01:00', label: '(GMT+01:00) Rome', tzCode: 'Europe/Rome' },
  { offset: '+01:00', label: '(GMT+01:00) Stockholm', tzCode: 'Europe/Stockholm' },
  { offset: '+01:00', label: '(GMT+01:00) Tirane', tzCode: 'Europe/Tirane' },
  { offset: '+01:00', label: '(GMT+01:00) Tunis', tzCode: 'Africa/Tunis' },
  { offset: '+01:00', label: '(GMT+01:00) Vienna', tzCode: 'Europe/Vienna' },
  { offset: '+01:00', label: '(GMT+01:00) Warsaw', tzCode: 'Europe/Warsaw' },
  { offset: '+01:00', label: '(GMT+01:00) Zurich', tzCode: 'Europe/Zurich' },
  { offset: '+02:00', label: '(GMT+02:00) Amman', tzCode: 'Asia/Amman' },
  { offset: '+02:00', label: '(GMT+02:00) Athens', tzCode: 'Europe/Athens' },
  { offset: '+02:00', label: '(GMT+02:00) Beirut', tzCode: 'Asia/Beirut' },
  { offset: '+02:00', label: '(GMT+02:00) Bucharest', tzCode: 'Europe/Bucharest' },
  { offset: '+02:00', label: '(GMT+02:00) Cairo', tzCode: 'Africa/Cairo' },
  { offset: '+02:00', label: '(GMT+02:00) Chisinau', tzCode: 'Europe/Chisinau' },
  { offset: '+02:00', label: '(GMT+02:00) Damascus', tzCode: 'Asia/Damascus' },
  { offset: '+02:00', label: '(GMT+02:00) Gaza', tzCode: 'Asia/Gaza' },
  { offset: '+02:00', label: '(GMT+02:00) Helsinki', tzCode: 'Europe/Helsinki' },
  { offset: '+02:00', label: '(GMT+02:00) Jerusalem', tzCode: 'Asia/Jerusalem' },
  { offset: '+02:00', label: '(GMT+02:00) Johannesburg', tzCode: 'Africa/Johannesburg' },
  { offset: '+02:00', label: '(GMT+02:00) Khartoum', tzCode: 'Africa/Khartoum' },
  { offset: '+02:00', label: '(GMT+02:00) Kiev', tzCode: 'Europe/Kiev' },
  { offset: '+02:00', label: '(GMT+02:00) Maputo', tzCode: 'Africa/Maputo' },
  { offset: '+02:00', label: '(GMT+02:00) Moscow-01 - Kaliningrad', tzCode: 'Europe/Kaliningrad' },
  { offset: '+02:00', label: '(GMT+02:00) Nicosia', tzCode: 'Asia/Nicosia' },
  { offset: '+02:00', label: '(GMT+02:00) Riga', tzCode: 'Europe/Riga' },
  { offset: '+02:00', label: '(GMT+02:00) Sofia', tzCode: 'Europe/Sofia' },
  { offset: '+02:00', label: '(GMT+02:00) Tallinn', tzCode: 'Europe/Tallinn' },
  { offset: '+02:00', label: '(GMT+02:00) Tripoli', tzCode: 'Africa/Tripoli' },
  { offset: '+02:00', label: '(GMT+02:00) Vilnius', tzCode: 'Europe/Vilnius' },
  { offset: '+02:00', label: '(GMT+02:00) Windhoek', tzCode: 'Africa/Windhoek' },
  { offset: '+03:00', label: '(GMT+03:00) Baghdad', tzCode: 'Asia/Baghdad' },
  { offset: '+03:00', label: '(GMT+03:00) Istanbul', tzCode: 'Europe/Istanbul' },
  { offset: '+03:00', label: '(GMT+03:00) Minsk', tzCode: 'Europe/Minsk' },
  { offset: '+03:00', label: '(GMT+03:00) Moscow+00 - Moscow', tzCode: 'Europe/Moscow' },
  { offset: '+03:00', label: '(GMT+03:00) Nairobi', tzCode: 'Africa/Nairobi' },
  { offset: '+03:00', label: '(GMT+03:00) Qatar', tzCode: 'Asia/Qatar' },
  { offset: '+03:00', label: '(GMT+03:00) Riyadh', tzCode: 'Asia/Riyadh' },
  { offset: '+03:00', label: '(GMT+03:00) Syowa', tzCode: 'Antarctica/Syowa' },
  { offset: '+03:30', label: '(GMT+03:30) Tehran', tzCode: 'Asia/Tehran' },
  { offset: '+04:00', label: '(GMT+04:00) Baku', tzCode: 'Asia/Baku' },
  { offset: '+04:00', label: '(GMT+04:00) Dubai', tzCode: 'Asia/Dubai' },
  { offset: '+04:00', label: '(GMT+04:00) Mahe', tzCode: 'Indian/Mahe' },
  { offset: '+04:00', label: '(GMT+04:00) Mauritius', tzCode: 'Indian/Mauritius' },
  { offset: '+04:00', label: '(GMT+04:00) Moscow+01 - Samara', tzCode: 'Europe/Samara' },
  { offset: '+04:00', label: '(GMT+04:00) Reunion', tzCode: 'Indian/Reunion' },
  { offset: '+04:00', label: '(GMT+04:00) Tbilisi', tzCode: 'Asia/Tbilisi' },
  { offset: '+04:00', label: '(GMT+04:00) Yerevan', tzCode: 'Asia/Yerevan' },
  { offset: '+04:30', label: '(GMT+04:30) Kabul', tzCode: 'Asia/Kabul' },
  { offset: '+05:00', label: '(GMT+05:00) Aqtau', tzCode: 'Asia/Aqtau' },
  { offset: '+05:00', label: '(GMT+05:00) Aqtobe', tzCode: 'Asia/Aqtobe' },
  { offset: '+05:00', label: '(GMT+05:00) Ashgabat', tzCode: 'Asia/Ashgabat' },
  { offset: '+05:00', label: '(GMT+05:00) Dushanbe', tzCode: 'Asia/Dushanbe' },
  { offset: '+05:00', label: '(GMT+05:00) Karachi', tzCode: 'Asia/Karachi' },
  { offset: '+05:00', label: '(GMT+05:00) Kerguelen', tzCode: 'Indian/Kerguelen' },
  { offset: '+05:00', label: '(GMT+05:00) Maldives', tzCode: 'Indian/Maldives' },
  { offset: '+05:00', label: '(GMT+05:00) Mawson', tzCode: 'Antarctica/Mawson' },
  { offset: '+05:00', label: '(GMT+05:00) Moscow+02 - Yekaterinburg', tzCode: 'Asia/Yekaterinburg' },
  { offset: '+05:00', label: '(GMT+05:00) Tashkent', tzCode: 'Asia/Tashkent' },
  { offset: '+05:30', label: '(GMT+05:30) Colombo', tzCode: 'Asia/Colombo' },
  { offset: '+05:30', label: '(GMT+05:30) India Standard Time', tzCode: 'Asia/Kolkata' },
  { offset: '+05:45', label: '(GMT+05:45) Kathmandu', tzCode: 'Asia/Kathmandu' },
  { offset: '+06:00', label: '(GMT+06:00) Almaty', tzCode: 'Asia/Almaty' },
  { offset: '+06:00', label: '(GMT+06:00) Bishkek', tzCode: 'Asia/Bishkek' },
  { offset: '+06:00', label: '(GMT+06:00) Chagos', tzCode: 'Indian/Chagos' },
  { offset: '+06:00', label: '(GMT+06:00) Dhaka', tzCode: 'Asia/Dhaka' },
  { offset: '+06:00', label: '(GMT+06:00) Moscow+03 - Omsk', tzCode: 'Asia/Omsk' },
  { offset: '+06:00', label: '(GMT+06:00) Thimphu', tzCode: 'Asia/Thimphu' },
  { offset: '+06:00', label: '(GMT+06:00) Vostok', tzCode: 'Antarctica/Vostok' },
  { offset: '+06:30', label: '(GMT+06:30) Cocos', tzCode: 'Indian/Cocos' },
  { offset: '+06:30', label: '(GMT+06:30) Rangoon', tzCode: 'Asia/Yangon' },
  { offset: '+07:00', label: '(GMT+07:00) Bangkok', tzCode: 'Asia/Bangkok' },
  { offset: '+07:00', label: '(GMT+07:00) Christmas', tzCode: 'Indian/Christmas' },
  { offset: '+07:00', label: '(GMT+07:00) Davis', tzCode: 'Antarctica/Davis' },
  { offset: '+07:00', label: '(GMT+07:00) Hanoi', tzCode: 'Asia/Saigon' },
  { offset: '+07:00', label: '(GMT+07:00) Hovd', tzCode: 'Asia/Hovd' },
  { offset: '+07:00', label: '(GMT+07:00) Jakarta', tzCode: 'Asia/Jakarta' },
  { offset: '+07:00', label: '(GMT+07:00) Moscow+04 - Krasnoyarsk', tzCode: 'Asia/Krasnoyarsk' },
  { offset: '+08:00', label: '(GMT+08:00) Brunei', tzCode: 'Asia/Brunei' },
  { offset: '+08:00', label: '(GMT+08:00) China Time - Beijing', tzCode: 'Asia/Shanghai' },
  { offset: '+08:00', label: '(GMT+08:00) Choibalsan', tzCode: 'Asia/Choibalsan' },
  { offset: '+08:00', label: '(GMT+08:00) Hong Kong', tzCode: 'Asia/Hong_Kong' },
  { offset: '+08:00', label: '(GMT+08:00) Kuala Lumpur', tzCode: 'Asia/Kuala_Lumpur' },
  { offset: '+08:00', label: '(GMT+08:00) Macau', tzCode: 'Asia/Macau' },
  { offset: '+08:00', label: '(GMT+08:00) Makassar', tzCode: 'Asia/Makassar' },
  { offset: '+08:00', label: '(GMT+08:00) Manila', tzCode: 'Asia/Manila' },
  { offset: '+08:00', label: '(GMT+08:00) Moscow+05 - Irkutsk', tzCode: 'Asia/Irkutsk' },
  { offset: '+08:00', label: '(GMT+08:00) Singapore', tzCode: 'Asia/Singapore' },
  { offset: '+08:00', label: '(GMT+08:00) Taipei', tzCode: 'Asia/Taipei' },
  { offset: '+08:00', label: '(GMT+08:00) Ulaanbaatar', tzCode: 'Asia/Ulaanbaatar' },
  { offset: '+08:00', label: '(GMT+08:00) Western Time - Perth', tzCode: 'Australia/Perth' },
  { offset: '+08:30', label: '(GMT+08:30) Pyongyang', tzCode: 'Asia/Pyongyang' },
  { offset: '+09:00', label: '(GMT+09:00) Dili', tzCode: 'Asia/Dili' },
  { offset: '+09:00', label: '(GMT+09:00) Jayapura', tzCode: 'Asia/Jayapura' },
  { offset: '+09:00', label: '(GMT+09:00) Moscow+06 - Yakutsk', tzCode: 'Asia/Yakutsk' },
  { offset: '+09:00', label: '(GMT+09:00) Palau', tzCode: 'Pacific/Palau' },
  { offset: '+09:00', label: '(GMT+09:00) Seoul', tzCode: 'Asia/Seoul' },
  { offset: '+09:00', label: '(GMT+09:00) Tokyo', tzCode: 'Asia/Tokyo' },
  { offset: '+09:30', label: '(GMT+09:30) Central Time - Darwin', tzCode: 'Australia/Darwin' },
  { offset: '+10:00', label: '(GMT+10:00) Dumont D\'Urville', tzCode: 'Antarctica/DumontDUrville' },
  { offset: '+10:00', label: '(GMT+10:00) Eastern Time - Brisbane', tzCode: 'Australia/Brisbane' },
  { offset: '+10:00', label: '(GMT+10:00) Guam', tzCode: 'Pacific/Guam' },
  { offset: '+10:00', label: '(GMT+10:00) Moscow+07 - Vladivostok', tzCode: 'Asia/Vladivostok' },
  { offset: '+10:00', label: '(GMT+10:00) Port Moresby', tzCode: 'Pacific/Port_Moresby' },
  { offset: '+10:00', label: '(GMT+10:00) Truk', tzCode: 'Pacific/Chuuk' },
  { offset: '+10:30', label: '(GMT+10:30) Central Time - Adelaide', tzCode: 'Australia/Adelaide' },
  { offset: '+11:00', label: '(GMT+11:00) Casey', tzCode: 'Antarctica/Casey' },
  { offset: '+11:00', label: '(GMT+11:00) Eastern Time - Hobart', tzCode: 'Australia/Hobart' },
  { offset: '+11:00', label: '(GMT+11:00) Eastern Time - Melbourne, Sydney', tzCode: 'Australia/Sydney' },
  { offset: '+11:00', label: '(GMT+11:00) Efate', tzCode: 'Pacific/Efate' },
  { offset: '+11:00', label: '(GMT+11:00) Guadalcanal', tzCode: 'Pacific/Guadalcanal' },
  { offset: '+11:00', label: '(GMT+11:00) Kosrae', tzCode: 'Pacific/Kosrae' },
  { offset: '+11:00', label: '(GMT+11:00) Moscow+08 - Magadan', tzCode: 'Asia/Magadan' },
  { offset: '+11:00', label: '(GMT+11:00) Norfolk', tzCode: 'Pacific/Norfolk' },
  { offset: '+11:00', label: '(GMT+11:00) Noumea', tzCode: 'Pacific/Noumea' },
  { offset: '+11:00', label: '(GMT+11:00) Ponape', tzCode: 'Pacific/Pohnpei' },
  { offset: '+12:00', label: '(GMT+12:00) Funafuti', tzCode: 'Pacific/Funafuti' },
  { offset: '+12:00', label: '(GMT+12:00) Kwajalein', tzCode: 'Pacific/Kwajalein' },
  { offset: '+12:00', label: '(GMT+12:00) Majuro', tzCode: 'Pacific/Majuro' },
  { offset: '+12:00', label: '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy', tzCode: 'Asia/Kamchatka' },
  { offset: '+12:00', label: '(GMT+12:00) Nauru', tzCode: 'Pacific/Nauru' },
  { offset: '+12:00', label: '(GMT+12:00) Tarawa', tzCode: 'Pacific/Tarawa' },
  { offset: '+12:00', label: '(GMT+12:00) Wake', tzCode: 'Pacific/Wake' },
  { offset: '+12:00', label: '(GMT+12:00) Wallis', tzCode: 'Pacific/Wallis' },
  { offset: '+13:00', label: '(GMT+13:00) Auckland', tzCode: 'Pacific/Auckland' },
  { offset: '+13:00', label: '(GMT+13:00) Enderbury', tzCode: 'Pacific/Enderbury' },
  { offset: '+13:00', label: '(GMT+13:00) Fakaofo', tzCode: 'Pacific/Fakaofo' },
  { offset: '+13:00', label: '(GMT+13:00) Fiji', tzCode: 'Pacific/Fiji' },
  { offset: '+13:00', label: '(GMT+13:00) Tongatapu', tzCode: 'Pacific/Tongatapu' },
  { offset: '+14:00', label: '(GMT+14:00) Apia', tzCode: 'Pacific/Apia' },
  { offset: '+14:00', label: '(GMT+14:00) Kiritimati', tzCode: 'Pacific/Kiritimati' }
]);

/**
 *
 * @type {Array.<{ offset: string, label: string, tzCode: string }>}
 */
var minimalTimezoneSet = [
  { offset: '-11:00', label: '(GMT-11:00) Pago Pago', tzCode: 'Pacific/Pago_Pago' },
  { offset: '-10:00', label: '(GMT-10:00) Hawaii Time', tzCode: 'Pacific/Honolulu' },
  { offset: '-10:00', label: '(GMT-10:00) Tahiti', tzCode: 'Pacific/Tahiti' },
  { offset: '-09:00', label: '(GMT-09:00) Alaska Time', tzCode: 'America/Anchorage' },
  { offset: '-08:00', label: '(GMT-08:00) Pacific Time', tzCode: 'America/Los_Angeles' },
  { offset: '-07:00', label: '(GMT-07:00) Mountain Time', tzCode: 'America/Denver' },
  { offset: '-06:00', label: '(GMT-06:00) Central Time', tzCode: 'America/Chicago' },
  { offset: '-05:00', label: '(GMT-05:00) Eastern Time', tzCode: 'America/New_York' },
  { offset: '-04:00', label: '(GMT-04:00) Atlantic Time - Halifax', tzCode: 'America/Halifax' },
  { offset: '-03:00', label: '(GMT-03:00) Buenos Aires', tzCode: 'America/Argentina/Buenos_Aires' },
  { offset: '-02:00', label: '(GMT-02:00) Sao Paulo', tzCode: 'America/Sao_Paulo' },
  { offset: '-01:00', label: '(GMT-01:00) Azores', tzCode: 'Atlantic/Azores' },
  { offset: '+00:00', label: '(GMT+00:00) London', tzCode: 'Europe/London' },
  { offset: '+01:00', label: '(GMT+01:00) Berlin', tzCode: 'Europe/Berlin' },
  { offset: '+02:00', label: '(GMT+02:00) Helsinki', tzCode: 'Europe/Helsinki' },
  { offset: '+03:00', label: '(GMT+03:00) Istanbul', tzCode: 'Europe/Istanbul' },
  { offset: '+04:00', label: '(GMT+04:00) Dubai', tzCode: 'Asia/Dubai' },
  { offset: '+04:30', label: '(GMT+04:30) Kabul', tzCode: 'Asia/Kabul' },
  { offset: '+05:00', label: '(GMT+05:00) Maldives', tzCode: 'Indian/Maldives' },
  { offset: '+05:30', label: '(GMT+05:30) India Standard Time', tzCode: 'Asia/Calcutta' },
  { offset: '+05:45', label: '(GMT+05:45) Kathmandu', tzCode: 'Asia/Kathmandu' },
  { offset: '+06:00', label: '(GMT+06:00) Dhaka', tzCode: 'Asia/Dhaka' },
  { offset: '+06:30', label: '(GMT+06:30) Cocos', tzCode: 'Indian/Cocos' },
  { offset: '+07:00', label: '(GMT+07:00) Bangkok', tzCode: 'Asia/Bangkok' },
  { offset: '+08:00', label: '(GMT+08:00) Hong Kong', tzCode: 'Asia/Hong_Kong' },
  { offset: '+08:30', label: '(GMT+08:30) Pyongyang', tzCode: 'Asia/Pyongyang' },
  { offset: '+09:00', label: '(GMT+09:00) Tokyo', tzCode: 'Asia/Tokyo' },
  { offset: '+09:30', label: '(GMT+09:30) Central Time - Darwin', tzCode: 'Australia/Darwin' },
  { offset: '+10:00', label: '(GMT+10:00) Eastern Time - Brisbane', tzCode: 'Australia/Brisbane' },
  { offset: '+10:30', label: '(GMT+10:30) Central Time - Adelaide', tzCode: 'Australia/Adelaide' },
  { offset: '+11:00', label: '(GMT+11:00) Eastern Time - Melbourne, Sydney', tzCode: 'Australia/Sydney' },
  { offset: '+12:00', label: '(GMT+12:00) Nauru', tzCode: 'Pacific/Nauru' },
  { offset: '+13:00', label: '(GMT+13:00) Auckland', tzCode: 'Pacific/Auckland' },
  { offset: '+14:00', label: '(GMT+14:00) Kiritimati', tzCode: 'Pacific/Kiritimati' }
];


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"profile-form"},[_c('div',{staticClass:"mb-2",class:{ invalid: _vm.$v.title.$error }},[_c('label',[_vm._v("Title*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),(_vm.$v.title.$error)?_c('small',[_vm._v("Title is required.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n                H1\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n                H2\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n                H3\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n                List\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n                1. 2. 3...\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n                ---\n              ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Topic Areas")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.focusAreasOptions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Select Areas"},model:{value:(_vm.focusAreas),callback:function ($$v) {_vm.focusAreas=$$v},expression:"focusAreas"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Type*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.typeOptions),function(eventType,index){return _c('option',{key:'SelectType'+index},[_vm._v(_vm._s(eventType))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Event Fee?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isFee),expression:"isFee"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isFee=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("Yes")]),_vm._v(" "),_c('option',[_vm._v("No")])]),_vm._v(" "),(_vm.isFee == 'Yes')?_c('div',[_c('label',[_vm._v("Event Fee")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fee),expression:"fee"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fee=$event.target.value}}})]):_vm._e()])]),_vm._v(" "),_c('label',[_vm._v("Registration Information (registration link or email to sign up)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.link),expression:"link"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.link=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Event Date*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"placeholder":"","disabled-dates":_vm.disabledDates},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.multiday),expression:"multiday"}],staticClass:"form-check-input",staticStyle:{"margin-top":"6px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.multiday)?_vm._i(_vm.multiday,true)>-1:(_vm.multiday)},on:{"change":function($event){var $$a=_vm.multiday,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.multiday=$$a.concat([$$v]))}else{$$i>-1&&(_vm.multiday=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.multiday=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n            This is a multi-day event\n          ")])]),_vm._v(" "),(_vm.multiday)?_c('div',[_c('label',[_vm._v("End Date*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"placeholder":"","disabled-dates":_vm.disabledDates},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',[_vm._v("Start Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startHour),expression:"startHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("HH")]),_vm._v(" "),_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'StartHour'+index},[_vm._v(_vm._s(hour))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startMinute),expression:"startMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("MM")]),_vm._v(" "),_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'StartMinute'+index},[_vm._v(_vm._s(minute))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',[_vm._v("End Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endHour),expression:"endHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("HH")]),_vm._v(" "),_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'EndHour'+index},[_vm._v(_vm._s(hour))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endMinute),expression:"endMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("MM")]),_vm._v(" "),_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'EndMinute'+index},[_vm._v(_vm._s(minute))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',[_vm._v("Time Zone")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timezone),expression:"timezone"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timezone=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.timezones),function(timezone,index){return _c('option',{key:'TimeZone'+index},[_vm._v(_vm._s(timezone))])}),0)])])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.virtual),expression:"virtual"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.virtual)?_vm._i(_vm.virtual,true)>-1:(_vm.virtual)},on:{"change":function($event){var $$a=_vm.virtual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.virtual=$$a.concat([$$v]))}else{$$i>-1&&(_vm.virtual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.virtual=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n        This is a virtual event (no physical location)\n      ")])]),_vm._v(" "),(!_vm.virtual)?_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1),expression:"address1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address1=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address2),expression:"address2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address2=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Postal/Zip Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Province/State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.provinceState),expression:"provinceState"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.provinceState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.provinceState=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country),expression:"country"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.countries),function(country,index){return _c('option',{key:'countrySelection'+index},[_vm._v(_vm._s(country))])}),0)])]):_vm._e(),_vm._v(" "),(!_vm.listingID)?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){$event.preventDefault();return _vm.post()}}},[_vm._v("Post")]):_vm._e(),_vm._v(" "),(_vm.listingID)?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){$event.preventDefault();return _vm.update()}}},[_vm._v("Save")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Event Types")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.typeOptions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Event Types"},model:{value:(_vm.typeFilters),callback:function ($$v) {_vm.typeFilters=$$v},expression:"typeFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Countries")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.countries,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Countries"},model:{value:(_vm.countryFilters),callback:function ($$v) {_vm.countryFilters=$$v},expression:"countryFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Topic Areas")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.focusAreaOptions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Topic Areas"},model:{value:(_vm.focusAreaFilters),callback:function ($$v) {_vm.focusAreaFilters=$$v},expression:"focusAreaFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Start Date "),(_vm.dateFilter)?_c('span',{staticStyle:{"cursor":"pointer","color":"gray"},on:{"click":function($event){return _vm.clearDateFilter()}}},[_vm._v("(Clear Filter)")]):_vm._e()]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"placeholder":""},model:{value:(_vm.dateFilter),callback:function ($$v) {_vm.dateFilter=$$v},expression:"dateFilter"}})],1)]),_vm._v(" "),_vm._l((_vm.filteredListings),function(listing){return _c('div',{key:listing.id},[_c('div',{staticClass:"listing-tile mb-1",staticStyle:{"text-decoration":"none"}},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"var(--coredarkcolor)"},attrs:{"to":{ name: 'Event', params: { id: listing.id } }}},[_c('h3',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(listing.title)),(listing.event_type)?_c('span',[_vm._v(" ("+_vm._s(listing.event_type)+")")]):_vm._e()])]),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v(_vm._s(listing.poster_name))]),_vm._v(" "),((listing.poster == _vm.loggedinUser || _vm.$store.getters.isAgent) && (_vm.$router.history.current.path !='/events'))?_c('img',{staticStyle:{"float":"right","cursor":"pointer"},attrs:{"src":__webpack_require__(36),"width":"16px;","alt":"Edit"},on:{"click":function($event){return _vm.editListing(listing)}}}):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"mr-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 mb-2"},[_c('strong',[_vm._v(_vm._s(listing.city)),(listing.city && listing.country)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(listing.country))]),_vm._v(" "),(listing.categories[0])?_c('p',[_vm._v("Topic Areas: "+_vm._s(listing.categories.join(', ')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6",staticStyle:{"text-align":"right"}},[(listing.fee)?_c('p',[_vm._v(_vm._s(listing.fee))]):_vm._e(),_vm._v(" "),(listing.date)?_c('p',[_vm._v(_vm._s(new Date(listing.date.concat('T00:00:00')).toDateString())),(listing.end_date)?_c('span',[_vm._v(" - "+_vm._s(new Date(listing.end_date.concat('T00:00:00')).toDateString()))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('p',[(listing.start_time)?_c('span',[_vm._v(_vm._s(_vm._f("trimSeconds")(listing.start_time)))]):_vm._e(),(listing.end_time)?_c('span',[_vm._v(" - "+_vm._s(_vm._f("trimSeconds")(listing.end_time)))]):_vm._e(),_vm._v(" "+_vm._s(listing.timezone))])])])],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state == 'list')?_c('div',[_c('button',{staticClass:"mylisting-button dark-button mb-5",on:{"click":function($event){return _vm.postState()}}},[_vm._v("Post Event")]),_vm._v(" "),_c('h2',{staticClass:"dashboard-heading"},[_vm._v("Manage Events")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-list',{attrs:{"listings":_vm.listings},on:{"editListing":function($event){return _vm.editListing($event)}}}),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{name: 'Events'}}},[_vm._v("Event Board")])],1)],1):_vm._e(),_vm._v(" "),(_vm.state == 'post')?_c('div',[_c('h2',{staticClass:"dashboard-heading"},[_vm._v("Post New Event")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelPost()}}},[_vm._v("Cancel Post")]),_vm._v(" "),_c('app-form',{attrs:{"userID":_vm.userID,"listingID":null},on:{"eventPosted":function($event){return _vm.listingPosted()}}}),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelPost()}}},[_vm._v("Cancel Post")])],1):_vm._e(),_vm._v(" "),(_vm.state == 'edit' && _vm.listingToEdit.id)?_c('div',[_c('h2',{staticClass:"dashboard-heading"},[_vm._v("Edit - "+_vm._s(_vm.listingToEdit.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelEdit()}}},[_vm._v("Cancel Edit")]),_vm._v(" "),_c('app-form',{attrs:{"userID":_vm.userID,"listingID":_vm.listingToEdit.id},on:{"eventUpdated":function($event){return _vm.listingUpdated()}}}),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cancelEdit()}}},[_vm._v("Cancel Edit")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container top-level-div"},[(_vm.user.id)?_c('div',{key:"profile"},[_c('app-profile',{attrs:{"userID":_vm.user.id}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicProfile_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434c3f38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicProfile_vue__ = __webpack_require__(809);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434c3f38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileView_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d07806_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileView_vue__ = __webpack_require__(808);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d07806_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('div',{staticClass:"profile"},[_c('div',{staticClass:"row pr-3"},[_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4",staticStyle:{"max-width":"175px"}},[(_vm.user.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg')?_c('div',[_c('img',{staticStyle:{"max-height":"150px","max-width":"150px"},attrs:{"src":_vm.user.profile_pic}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 my-auto"},[(_vm.user.employer_name)?_c('h2',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.user.employer_name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[(_vm.user.website)?_c('a',{attrs:{"href":_vm.user.website,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(137),"alt":"youtube"}})]):_vm._e(),_vm._v(" "),(_vm.user.youtube)?_c('a',{attrs:{"href":_vm.user.youtube,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(298),"alt":"youtube"}})]):_vm._e(),_vm._v(" "),(_vm.user.facebook)?_c('a',{attrs:{"href":_vm.user.facebook,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(138),"alt":"facebook"}})]):_vm._e(),_vm._v(" "),(_vm.user.instagram)?_c('a',{attrs:{"href":_vm.user.instagram,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(139),"alt":"instagram"}})]):_vm._e(),_vm._v(" "),(_vm.user.twitter)?_c('a',{attrs:{"href":_vm.user.twitter,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(140),"alt":"twitter"}})]):_vm._e(),_vm._v(" "),(_vm.user.linkedin)?_c('a',{attrs:{"href":_vm.user.linkedin,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(141),"alt":"linkedin"}})]):_vm._e()])])]),_vm._v(" "),(_vm.user.about_us)?_c('label',{staticClass:"shaded-label"},[_vm._v("About Us")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"profile-section"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.user.about_us)}}),_vm._v(" "),(_vm.user.video)?_c('youtube',{attrs:{"video-id":_vm.videoId,"width":"100vw"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 p-4",staticStyle:{"background-color":"var(--bootstrapgrey)"}},[(_vm.user.city)?_c('p',[_vm._v(_vm._s(_vm.user.city))]):_vm._e(),_vm._v(" "),(_vm.user.country)?_c('h4',[_vm._v(_vm._s(_vm.user.country))]):_vm._e(),_vm._v(" "),_c('div',[(_vm.user.address1)?_c('small',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.user.address1))]):_vm._e(),_vm._v(" "),(_vm.user.address2)?_c('small',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.user.address2))]):_vm._e(),_vm._v(" "),(_vm.user.postal_code)?_c('small',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.user.postal_code))]):_vm._e()]),_vm._v(" "),(_vm.user.city)?_c('div',{staticClass:"mt-2",staticStyle:{"height":"250px","width":"100%"},attrs:{"id":"map"}}):_vm._e(),_vm._v(" "),(_vm.user.city)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.user.organization_type)?_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Organization Type")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.organization_type))]),_vm._v(" "),(_vm.user.size)?_c('label',[_vm._v("Organization Size")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.size))]),_vm._v(" "),(_vm.user.id)?_c('span',[(_vm.user.sectors[0])?_c('label',[_vm._v("Organization Sectors")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.user.sectors),function(sector,index){return _c('li',{key:'Sectors'+index},[_vm._v(_vm._s(sector))])}),0),_vm._v(" "),(_vm.user.id)?_c('span',[(_vm.user.features[0])?_c('label',[_vm._v("Organization Values")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.user.features),function(value,index){return _c('li',{key:'Value'+index},[_vm._v(_vm._s(value))])}),0),_vm._v(" "),(_vm.user.id)?_c('span',[(_vm.user.skills2[0])?_c('label',[_vm._v("Top Things Looked for in Candidates")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.user.skills2),function(quality,index){return _c('li',{key:'Quality'+index},[_vm._v(_vm._s(quality))])}),0),_vm._v(" "),(_vm.user.id)?_c('span',[(_vm.user.features2[0])?_c('label',[_vm._v("Work Perks")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.user.features2),function(perk,index){return _c('li',{key:'Value'+index},[_vm._v(_vm._s(perk))])}),0)])]),_vm._v(" "),(_vm.user.projects)?_c('label',{staticClass:"shaded-label"},[_vm._v("Current/Recent Projects")]):_vm._e(),_vm._v(" "),(_vm.user.projects)?_c('pre',{staticClass:"profile-section",domProps:{"innerHTML":_vm._s(_vm.user.projects)}}):_vm._e(),_vm._v(" "),(_vm.user.text_field1)?_c('label',{staticClass:"shaded-label"},[_vm._v("Meet Some Team Members")]):_vm._e(),_vm._v(" "),(_vm.user.text_field1)?_c('pre',{staticClass:"profile-section",domProps:{"innerHTML":_vm._s(_vm.user.text_field1)}}):_vm._e(),_vm._v(" "),(_vm.user.hiring_practices)?_c('label',{staticClass:"shaded-label"},[_vm._v("How to Get Involved")]):_vm._e(),_vm._v(" "),(_vm.user.hiring_practices)?_c('pre',{staticClass:"profile-section",domProps:{"innerHTML":_vm._s(_vm.user.hiring_practices)}}):_vm._e(),_vm._v(" "),(_vm.user.hiring_restrictions)?_c('label',{staticClass:"shaded-label"},[_vm._v("Hiring Restrictions")]):_vm._e(),_vm._v(" "),(_vm.user.hiring_restrictions)?_c('pre',{staticClass:"profile-section",domProps:{"innerHTML":_vm._s(_vm.user.hiring_restrictions)}}):_vm._e(),_vm._v(" "),(_vm.user.hiring_advice)?_c('label',{staticClass:"shaded-label"},[_vm._v("Advice for Candidates")]):_vm._e(),_vm._v(" "),(_vm.user.hiring_advice)?_c('pre',{staticClass:"profile-section",domProps:{"innerHTML":_vm._s(_vm.user.hiring_advice)}}):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('app-profile-view',{attrs:{"user":_vm.user,"city":_vm.user.city}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FamilyForm_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8022ac78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FamilyForm_vue__ = __webpack_require__(813);
function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FamilyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8022ac78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FamilyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(812);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d67d42d4", content, true, {});

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Open Sans,Crimson Text;font-weight:600;margin-top:2px}.form-note{font-weight:500;color:var(--coredarkcolor);margin-top:.5em;margin-bottom:.5em}.fee-note{margin-bottom:-.5em}", ""]);

// exports


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 mb-4 field-of-fields",staticStyle:{"width":"75%","display":"block","margin-left":"auto","margin-right":"auto"}},[_c('a',{attrs:{"href":_vm.$store.getters.website}},[_c('img',{staticClass:"center",attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"width":"","height":_vm.$store.getters.logoHeight,"alt":_vm.$store.getters.agencyHumanName,"id":""}})]),_vm._v(" "),_c('h1',{staticClass:"center mt-5"},[_vm._v("Family Application Form")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.$store.getters.userID)?_c('div',{staticClass:"center mt-5"},[_c('h3',[_vm._v("You are registered!")]),_vm._v(" "),_c('div',{staticClass:"header-button mt-4"},[_c('button',{staticClass:"button button-1-dark",on:{"click":function($event){return _vm.dashboardRedirect()}}},[_vm._v("\n          My Dashboard\n        ")])])]):_vm._e(),_vm._v(" "),(!_vm.$store.getters.userID)?_c('div',[_c('p',{staticClass:"text-require-notice"},[_vm._v("Fields marked with an * are required")]),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"listFields":_vm.$store.getters.familyInformationListFields,"modelData":_vm.familyFormData,"submitClicked":_vm.submitClicked}},[_c('template',{slot:"service-note"},[(_vm.familyFormData.selector1 === _vm.SERVICE_TYPE.NEW_BORN)?_c('div',[_c('p',{staticClass:"form-note"},[_vm._v("\n              Please submit the family application to start your search for a\n              Newborn Care Specialist (aka baby nurse/ night nurse).\n              The agency fee for Newborn Care Specialists is 25% of the\n              candidates gross contracted salary, per candidate. Most infant\n              care specialist require a min of 2 week on assignment. A $250\n              deposit and a family agreement is required to start. This\n              deposit will allow us to guarantee that a NCS will be\n              present at your home when you need them since birthdays can\n              fluctuate. This deposit is non-refundable. The $250 deposit will\n              be deducted from the placement fee which is due before the\n              Newborn Care Specialist starts.\n            ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.tinytreasuresnyc.com/find-newborn-baby-nurse"}},[_vm._v("\n              Learn More Before Registering\n            ")])]):_vm._e(),_vm._v(" "),(_vm.familyFormData.selector1 === _vm.SERVICE_TYPE.NANNY)?_c('div',[_c('p',{staticClass:"form-note"},[_vm._v("\n              Please submit the family application to start your search. There\n              is a non-refundable fee of $250 due with submission, of which\n              $200 will be applied to your final invoice. A placement\n              specialist will contact you within 24 hours or the next business\n              day. If you have any questions please don't hesitate to contact\n              us. 646-290-5566 ext 1.\n            ")]),_vm._v(" "),_c('p',{staticClass:"form-note"},[_vm._v("\n              Have Questions before filling this out. Schedule a call with a\n              Care Specialist (\n              "),_c('a',{attrs:{"href":"https://calendly.com/tinytreasuresnyc/15min"}},[_vm._v("\n                Consultation\n              ")]),_vm._v("\n              )\n            ")])]):_vm._e(),_vm._v(" "),(_vm.familyFormData.selector1 === _vm.SERVICE_TYPE.PRIVATE_EDUCATOR)?_c('div',[_c('p',{staticClass:"form-note"},[_vm._v("\n              We collect a non-refundable fee to start your search. This fee\n              will be credited to your final placement invoice. We never store\n              your card number or CVC number on our site.\n            ")])]):_vm._e()]),_vm._v(" "),_c('template',{slot:"children"},[_c('ApplicationSectionWithDialog',{attrs:{"sectionTitle":"Children","name":"Children","data":_vm.listChildren,"listFields":_vm.listChildrenFields,"keyTitles":['first_name', 'last_name']}})],1),_vm._v(" "),_c('template',{slot:"nanny-form-fee-notice"},[_c('p',{staticClass:"form-note"},[_c('b',[_vm._v(" Your credit card will be charged: $250.00")])]),_vm._v(" "),_c('p',{staticClass:"form-note fee-note"},[_vm._v("\n            We collect a non-refundable fee to start your search. This fee\n            will be credited to your final placement invoice. We never store\n            your card number or CVC number on our site.\n          ")])])],2),_vm._v(" "),_c('div',{staticClass:"submit-button-section"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("\n          Submit\n        ")])])],1):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"update-aplication-modal","width":"80%","height":"auto","scrollable":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermanentNanny_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2491d1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermanentNanny_vue__ = __webpack_require__(817);
function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermanentNanny_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2491d1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermanentNanny_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("00b22b94", content, true, {});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Crimson Text;font-weight:600;margin-top:2px}", ""]);

// exports


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 mb-4 field-of-fields",staticStyle:{"width":"75%","display":"block","margin-left":"auto","margin-right":"auto"}},[_c('h1',{staticClass:"center"},[_vm._v("Client Application - Permanent Nanny")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("Contact Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('label',[_vm._v("Family Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Smith"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}}),_vm._v(" "),(!_vm.familyName && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherFirst),expression:"motherFirst"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.motherFirst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherFirst=$event.target.value}}}),_vm._v(" "),(!_vm.motherFirst && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherLast),expression:"motherLast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.motherLast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherLast=$event.target.value}}}),_vm._v(" "),(!_vm.motherLast && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Email Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherEmail),expression:"motherEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"You will be our primary contact for all communication."},domProps:{"value":(_vm.motherEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherEmail=$event.target.value}}}),_vm._v(" "),(!_vm.motherEmail && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Phone Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherPhone),expression:"motherPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Please include area code."},domProps:{"value":(_vm.motherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherPhone=$event.target.value}}}),_vm._v(" "),(!_vm.motherPhone && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherFirst),expression:"fatherFirst"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fatherFirst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherFirst=$event.target.value}}}),_vm._v(" "),(!_vm.fatherFirst && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherLast),expression:"fatherLast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fatherLast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherLast=$event.target.value}}}),_vm._v(" "),(!_vm.fatherLast && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Email Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherEmail),expression:"fatherEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.fatherEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherEmail=$event.target.value}}}),_vm._v(" "),(!_vm.fatherEmail && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Phone Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherPhone),expression:"fatherPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Please include area code."},domProps:{"value":(_vm.fatherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherPhone=$event.target.value}}}),_vm._v(" "),(!_vm.fatherPhone && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Street Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),(!_vm.address && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("City*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),(!_vm.city && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Postal Code*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}}),_vm._v(" "),(!_vm.postalCode && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('label',[_vm._v("Which is the best and most prompt way we can get into contact with you?*")]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredComm),expression:"preferredComm"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Email"},domProps:{"checked":_vm._q(_vm.preferredComm,"Email")},on:{"change":function($event){_vm.preferredComm="Email"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios1"}},[_vm._v("\n        Email\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredComm),expression:"preferredComm"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Phone"},domProps:{"checked":_vm._q(_vm.preferredComm,"Phone")},on:{"change":function($event){_vm.preferredComm="Phone"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios2"}},[_vm._v("\n        Phone\n      ")])]),_vm._v(" "),(!_vm.preferredComm && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"mt-5"},[_vm._v("Service Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Child Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child1),expression:"child1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child1=$event.target.value}}}),_vm._v(" "),(!_vm.child1 && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child2),expression:"child2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child2=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child3),expression:"child3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child3=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child4),expression:"child4"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child4=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Birthday*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday1),callback:function ($$v) {_vm.birthday1=$$v},expression:"birthday1"}}),_vm._v(" "),(!_vm.birthday1 && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday2),callback:function ($$v) {_vm.birthday2=$$v},expression:"birthday2"}}),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday3),callback:function ($$v) {_vm.birthday3=$$v},expression:"birthday3"}}),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday4),callback:function ($$v) {_vm.birthday4=$$v},expression:"birthday4"}})],1)])]),_vm._v(" "),_c('label',[_vm._v("Days & Times Required*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.schedule),expression:"schedule"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"e.g. Monday & Wednesday 9-5"},domProps:{"value":(_vm.schedule)},on:{"input":function($event){if($event.target.composing){ return; }_vm.schedule=$event.target.value}}}),_vm._v(" "),(!_vm.schedule && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Position Required (check all that apply)*")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.positions),expression:"positions"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"Full-Time"},domProps:{"checked":Array.isArray(_vm.positions)?_vm._i(_vm.positions,"Full-Time")>-1:(_vm.positions)},on:{"change":function($event){var $$a=_vm.positions,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Full-Time",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.positions=$$a.concat([$$v]))}else{$$i>-1&&(_vm.positions=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.positions=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n            Full-Time\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.positions),expression:"positions"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"Part-Time"},domProps:{"checked":Array.isArray(_vm.positions)?_vm._i(_vm.positions,"Part-Time")>-1:(_vm.positions)},on:{"change":function($event){var $$a=_vm.positions,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Part-Time",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.positions=$$a.concat([$$v]))}else{$$i>-1&&(_vm.positions=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.positions=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n            Part-Time\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.positions),expression:"positions"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"Summer"},domProps:{"checked":Array.isArray(_vm.positions)?_vm._i(_vm.positions,"Summer")>-1:(_vm.positions)},on:{"change":function($event){var $$a=_vm.positions,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Summer",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.positions=$$a.concat([$$v]))}else{$$i>-1&&(_vm.positions=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.positions=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n            Summer\n          ")])]),_vm._v(" "),(!_vm.positions[0] && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Anticipated Duration*")]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Short-term (less than 6 months)"},domProps:{"checked":_vm._q(_vm.duration,"Short-term (less than 6 months)")},on:{"change":function($event){_vm.duration="Short-term (less than 6 months)"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios1"}},[_vm._v("\n            Short-term (less than 6 months)\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Long-term (1 year +)"},domProps:{"checked":_vm._q(_vm.duration,"Long-term (1 year +)")},on:{"change":function($event){_vm.duration="Long-term (1 year +)"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios2"}},[_vm._v("\n            Long-term (1 year +)\n          ")])]),_vm._v(" "),(!_vm.duration && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Anticipated Start Date*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"disabled-dates":_vm.disabledDates},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),(!_vm.startDate && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()],1)]),_vm._v(" "),_c('label',[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":"Any other information you feel would help us get to know you a little better."},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("How did you hear about us?*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.referrer),expression:"referrer"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.referrer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("Google")]),_vm._v(" "),_c('option',[_vm._v("Word of Mouth")])]),_vm._v(" "),(!_vm.referrer && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),(_vm.referrer == 'Word of Mouth')?_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Who is the friend who referred you?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referee),expression:"referee"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.referee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.referee=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"30px","margin-bottom":"80px"}},[_c('div',{staticStyle:{"display":"block"}},[_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"130px"}},[(_vm.requiredMissing)?_c('p',{staticClass:"required-message",staticStyle:{"float":"right"}},[_vm._v("A required field is missing, please check the form.")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"required-missing-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("A required field is missing.")]),_vm._v(" "),_c('h4',[_vm._v("Please review the form for error messages!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('required-missing-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"duplicate-email-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Your email is already in our system!")]),_vm._v(" "),_c('h4',[_vm._v("Have you worked with us before? If you think this is an error, please contact us.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('duplicate-email-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"application-submitted-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thank you for submitting your application!")]),_vm._v(" "),_c('h4',[_vm._v("A member of our team will review it and be in touch with you shortly.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideApplicationSubmittedModal()}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NannyOnCall_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9706fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NannyOnCall_vue__ = __webpack_require__(821);
function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NannyOnCall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9706fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NannyOnCall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(820);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("66a8e0d4", content, true, {});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Crimson Text;font-weight:600;margin-top:2px}", ""]);

// exports


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 mb-4 field-of-fields",staticStyle:{"width":"75%","display":"block","margin-left":"auto","margin-right":"auto"}},[_c('h1',{staticClass:"center"},[_vm._v("Client Application - Nanny on Call")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("Contact Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('label',[_vm._v("Family Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Smith"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}}),_vm._v(" "),(!_vm.familyName && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherFirst),expression:"motherFirst"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.motherFirst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherFirst=$event.target.value}}}),_vm._v(" "),(!_vm.motherFirst && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherLast),expression:"motherLast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.motherLast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherLast=$event.target.value}}}),_vm._v(" "),(!_vm.motherLast && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Email Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherEmail),expression:"motherEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"You will be our primary contact for all communication."},domProps:{"value":(_vm.motherEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherEmail=$event.target.value}}}),_vm._v(" "),(!_vm.motherEmail && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Phone Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherPhone),expression:"motherPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Please include area code."},domProps:{"value":(_vm.motherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherPhone=$event.target.value}}}),_vm._v(" "),(!_vm.motherPhone && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherFirst),expression:"fatherFirst"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fatherFirst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherFirst=$event.target.value}}}),_vm._v(" "),(!_vm.fatherFirst && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherLast),expression:"fatherLast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fatherLast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherLast=$event.target.value}}}),_vm._v(" "),(!_vm.fatherLast && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Email Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherEmail),expression:"fatherEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.fatherEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherEmail=$event.target.value}}}),_vm._v(" "),(!_vm.fatherEmail && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Phone Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherPhone),expression:"fatherPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Please include area code."},domProps:{"value":(_vm.fatherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherPhone=$event.target.value}}}),_vm._v(" "),(!_vm.fatherPhone && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Street Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),(!_vm.address && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("City*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),(!_vm.city && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Postal Code*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}}),_vm._v(" "),(!_vm.postalCode && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('label',[_vm._v("Which is the best and most prompt way we can get into contact with you?*")]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredComm),expression:"preferredComm"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Email"},domProps:{"checked":_vm._q(_vm.preferredComm,"Email")},on:{"change":function($event){_vm.preferredComm="Email"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios1"}},[_vm._v("\n        Email\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredComm),expression:"preferredComm"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Phone"},domProps:{"checked":_vm._q(_vm.preferredComm,"Phone")},on:{"change":function($event){_vm.preferredComm="Phone"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios2"}},[_vm._v("\n        Phone\n      ")])]),_vm._v(" "),(!_vm.preferredComm && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"mt-5"},[_vm._v("Service Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Child Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child1),expression:"child1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child1=$event.target.value}}}),_vm._v(" "),(!_vm.child1 && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child2),expression:"child2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child2=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child3),expression:"child3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child3=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child4),expression:"child4"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child4=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Birthday*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday1),callback:function ($$v) {_vm.birthday1=$$v},expression:"birthday1"}}),_vm._v(" "),(!_vm.birthday1 && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday2),callback:function ($$v) {_vm.birthday2=$$v},expression:"birthday2"}}),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday3),callback:function ($$v) {_vm.birthday3=$$v},expression:"birthday3"}}),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday4),callback:function ($$v) {_vm.birthday4=$$v},expression:"birthday4"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Anticipated Start Date*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"disabled-dates":_vm.disabledDates},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),(!_vm.startDate && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()],1)]),_vm._v(" "),_c('label',[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":"Any other information you feel would help us get to know you a little better."},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("How did you hear about us?*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.referrer),expression:"referrer"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.referrer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("Google")]),_vm._v(" "),_c('option',[_vm._v("Word of Mouth")])]),_vm._v(" "),(!_vm.referrer && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),(_vm.referrer == 'Word of Mouth')?_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Who is the friend who referred you?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referee),expression:"referee"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.referee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.referee=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"30px","margin-bottom":"80px"}},[_c('div',{staticStyle:{"display":"block"}},[_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"130px"}},[(_vm.requiredMissing)?_c('p',{staticClass:"required-message",staticStyle:{"float":"right"}},[_vm._v("A required field is missing, please check the form.")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"required-missing-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("A required field is missing.")]),_vm._v(" "),_c('h4',[_vm._v("Please review the form for error messages!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('required-missing-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"duplicate-email-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Your email is already in our system!")]),_vm._v(" "),_c('h4',[_vm._v("Have you worked with us before? If you think this is an error, please contact us")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('duplicate-email-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"application-submitted-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thank you for submitting your application!")]),_vm._v(" "),_c('h4',[_vm._v("A member of our team will review it and be in touch with you shortly.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideApplicationSubmittedModal()}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterimCare_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a68ab28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterimCare_vue__ = __webpack_require__(825);
function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterimCare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a68ab28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterimCare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4cae49cf", content, true, {});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Crimson Text;font-weight:600;margin-top:2px}", ""]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 mb-4 field-of-fields",staticStyle:{"width":"75%","display":"block","margin-left":"auto","margin-right":"auto"}},[_c('h1',{staticClass:"center"},[_vm._v("Client Application - Interim Care")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{},[_vm._v("Contact Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('label',[_vm._v("Family Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Smith"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}}),_vm._v(" "),(!_vm.familyName && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherFirst),expression:"motherFirst"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.motherFirst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherFirst=$event.target.value}}}),_vm._v(" "),(!_vm.motherFirst && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherLast),expression:"motherLast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.motherLast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherLast=$event.target.value}}}),_vm._v(" "),(!_vm.motherLast && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Email Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherEmail),expression:"motherEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"You will be our primary contact for all communication."},domProps:{"value":(_vm.motherEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherEmail=$event.target.value}}}),_vm._v(" "),(!_vm.motherEmail && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Mother's Phone Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motherPhone),expression:"motherPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Please include area code."},domProps:{"value":(_vm.motherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motherPhone=$event.target.value}}}),_vm._v(" "),(!_vm.motherPhone && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherFirst),expression:"fatherFirst"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fatherFirst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherFirst=$event.target.value}}}),_vm._v(" "),(!_vm.fatherFirst && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherLast),expression:"fatherLast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.fatherLast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherLast=$event.target.value}}}),_vm._v(" "),(!_vm.fatherLast && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Email Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherEmail),expression:"fatherEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.fatherEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherEmail=$event.target.value}}}),_vm._v(" "),(!_vm.fatherEmail && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Father's Phone Number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fatherPhone),expression:"fatherPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Please include area code."},domProps:{"value":(_vm.fatherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fatherPhone=$event.target.value}}}),_vm._v(" "),(!_vm.fatherPhone && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Street Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),(!_vm.address && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("City*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),(!_vm.city && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Postal Code*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}}),_vm._v(" "),(!_vm.postalCode && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])])]),_vm._v(" "),_c('label',[_vm._v("Which is the best and most prompt way we can get into contact with you?*")]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredComm),expression:"preferredComm"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Email"},domProps:{"checked":_vm._q(_vm.preferredComm,"Email")},on:{"change":function($event){_vm.preferredComm="Email"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios1"}},[_vm._v("\n        Email\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferredComm),expression:"preferredComm"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Phone"},domProps:{"checked":_vm._q(_vm.preferredComm,"Phone")},on:{"change":function($event){_vm.preferredComm="Phone"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":"exampleRadios2"}},[_vm._v("\n        Phone\n      ")])]),_vm._v(" "),(!_vm.preferredComm && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"mt-5"},[_vm._v("Service Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Child Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child1),expression:"child1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child1=$event.target.value}}}),_vm._v(" "),(!_vm.child1 && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child2),expression:"child2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child2=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child3),expression:"child3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child3=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Child Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.child4),expression:"child4"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.child4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.child4=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Birthday*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday1),callback:function ($$v) {_vm.birthday1=$$v},expression:"birthday1"}}),_vm._v(" "),(!_vm.birthday1 && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday2),callback:function ($$v) {_vm.birthday2=$$v},expression:"birthday2"}}),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday3),callback:function ($$v) {_vm.birthday3=$$v},expression:"birthday3"}}),_vm._v(" "),_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"initial-view":"year"},model:{value:(_vm.birthday4),callback:function ($$v) {_vm.birthday4=$$v},expression:"birthday4"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',[_vm._v("Anticipated Start Date*")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"disabled-dates":_vm.disabledDates},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),(!_vm.startDate && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()],1)]),_vm._v(" "),_c('label',[_vm._v("Family Pets*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pets),expression:"pets"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.pets)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pets=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":"Any other information you feel would help us get to know you a little better."},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("How did you hear about us?*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.referrer),expression:"referrer"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.referrer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("Google")]),_vm._v(" "),_c('option',[_vm._v("Word of Mouth")])]),_vm._v(" "),(!_vm.referrer && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),(_vm.referrer == 'Word of Mouth')?_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Who is the friend who referred you?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referee),expression:"referee"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.referee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.referee=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"30px","margin-bottom":"80px"}},[_c('div',{staticStyle:{"display":"block"}},[_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitApplication()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"130px"}},[(_vm.requiredMissing)?_c('p',{staticClass:"required-message",staticStyle:{"float":"right"}},[_vm._v("A required field is missing, please check the form.")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"required-missing-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("A required field is missing.")]),_vm._v(" "),_c('h4',[_vm._v("Please review the form for error messages!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('required-missing-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"duplicate-email-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Your email is already in our system!")]),_vm._v(" "),_c('h4',[_vm._v("Have you worked with us before? If you think this is an error, please contact us: sarah@goldcoastnannies.company")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('duplicate-email-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"application-submitted-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Thank you for submitting your application!")]),_vm._v(" "),_c('h4',[_vm._v("A member of our team will review it and be in touch with you shortly.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideApplicationSubmittedModal()}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccc90138_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(885);
function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccc90138_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d3174c72", content, true, {});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".newEntryRow{font-weight:700}.activeEntryRow{background-color:var(--agencycolor)!important;font-weight:700}", ""]);

// exports


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e805bec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__(833);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e805bec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67770cfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_vue__ = __webpack_require__(831);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67770cfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.isAuthenticated)?_c('div',[_c('button',{staticClass:"mylisting-button dark-button mb-4",on:{"click":function($event){return _vm.showCommentModal()}}},[_vm._v("Comment")])]):_vm._e(),_vm._v(" "),(_vm.comments.length == 0)?_c('div',{staticClass:"mt-3"},[_c('p',[_vm._v("No comments yet.")])]):_vm._e(),_vm._v(" "),(_vm.comments.length > 0)?_c('div',{staticClass:"mt-3"},_vm._l((_vm.comments),function(comment){return _c('div',{key:comment.id},[_c('p',[_vm._v(_vm._s(comment.content))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Posted by: "+_vm._s(comment.poster_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s((new Date(comment.created_date)).toDateString()))]),_vm._v(" "),(_vm.user.is_agent)?_c('div',[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.unpublishComment(comment)}}},[_vm._v("Unpublish Comment")]),_vm._v(" "),_c('p',{staticClass:"mt-2",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.deleteComment(comment)}}},[_vm._v("Delete Comment")])]):_vm._e(),_vm._v(" "),_c('hr')])}),0):_vm._e(),_vm._v(" "),(_vm.user.is_agent && _vm.unpublishedComments.length > 0)?_c('div',{staticClass:"mt-3"},[_c('h3',[_vm._v("Unpublished Comments")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.unpublishedComments),function(comment){return _c('div',{key:comment.id},[_c('p',[_vm._v(_vm._s(comment.content))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Posted by: "+_vm._s(comment.poster_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s((new Date(comment.created_date)).toDateString()))]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.publishComment(comment)}}},[_vm._v("Publish Comment")]),_vm._v(" "),_c('p',{staticClass:"mt-2",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.deleteComment(comment)}}},[_vm._v("Delete Comment")]),_vm._v(" "),_c('hr')])})],2):_vm._e(),_vm._v(" "),(_vm.user.is_agent && _vm.unpublishedComments.length == 0)?_c('div',[_c('hr'),_vm._v(" "),_c('p',[_vm._v("No unpublished comments.")])]):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"comment-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-4"},[_c('h2',[_vm._v("Add a Comment")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.commentText),expression:"commentText"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.commentText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commentText=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideCommentModal()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.submitComment()}}},[_vm._v("Submit")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"comment-submitted-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-4"},[_c('h2',[_vm._v("Thanks for your comment!")]),_vm._v(" "),_c('p',[_vm._v("It will appear here once it has been reviewed by our administrative team.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.hideCommentSubmittedModal()}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[(!_vm.blogPost.published)?_c('div',[_c('h2',{staticClass:"mb-5"},[_vm._v("This post is pending approval.")])]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isAuthenticated && (_vm.$store.getters.isAgent == 'true' || (_vm.poster.id == _vm.$store.getters.userID)))?_c('div',[_c('button',{staticClass:"mylisting-button dark-button mb-3",on:{"click":function($event){return _vm.editPost()}}},[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.blogPost.hero_image,"alt":"","width":"100%"}}),_vm._v(" "),_c('h1',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.blogPost.title))]),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(new Date(_vm.blogPost.created_date).toDateString()))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.blogPost.content)}}),_vm._v(" "),(_vm.poster.id != 3054)?_c('div',[_c('hr'),_vm._v(" "),_c('h2',[_vm._v("About the Author")])]):_vm._e(),_vm._v(" "),(_vm.poster.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/profile_pics/default_avatar.jpg')?_c('div',{staticClass:"my-3"},[_c('img',{staticStyle:{"max-height":"150px"},attrs:{"src":_vm.poster.profile_pic}})]):_vm._e(),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.poster.first_name)+" "+_vm._s(_vm.poster.last_name)+" "+_vm._s(_vm.poster.employer_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.poster.overview))]),_vm._v(" "),(_vm.poster.is_employer)?_c('div',[_c('div',{staticClass:"mt-2 mb-3"},[(_vm.poster.website)?_c('a',{attrs:{"href":_vm.poster.website,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(137),"alt":"youtube"}})]):_vm._e(),_vm._v(" "),(_vm.poster.youtube)?_c('a',{attrs:{"href":_vm.poster.youtube,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(298),"alt":"youtube"}})]):_vm._e(),_vm._v(" "),(_vm.poster.facebook)?_c('a',{attrs:{"href":_vm.poster.facebook,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(138),"alt":"facebook"}})]):_vm._e(),_vm._v(" "),(_vm.poster.instagram)?_c('a',{attrs:{"href":_vm.poster.instagram,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(139),"alt":"instagram"}})]):_vm._e(),_vm._v(" "),(_vm.poster.twitter)?_c('a',{attrs:{"href":_vm.poster.twitter,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(140),"alt":"twitter"}})]):_vm._e(),_vm._v(" "),(_vm.poster.linkedin)?_c('a',{attrs:{"href":_vm.poster.linkedin,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(141),"alt":"linkedin"}})]):_vm._e()]),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.poster.about_us)}})]):_vm._e(),_vm._v(" "),(_vm.related[0])?_c('div',[_c('hr'),_vm._v(" "),_c('h4',[_vm._v("More from "+_vm._s(_vm.poster.first_name)+" "+_vm._s(_vm.poster.last_name))]),_vm._v(" "),_c('ul',_vm._l((_vm.related),function(article){return _c('li',{key:article.id},[_c('a',{attrs:{"href":article.id}},[_vm._v(_vm._s(article.title))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.postID && _vm.blogPost.id)?_c('div',[_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Comments")]),_vm._v(" "),_c('app-comments',{attrs:{"postID":_vm.postID,"blogPost":_vm.blogPost}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-striped mt-2"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBlogs),function(blog){return _c('tr',{key:blog.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showBlogModal(blog)}}},[_c('td',[_vm._v("\n          "+_vm._s(blog.title)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s((new Date(blog.created_date)).toDateString())+"\n        ")]),_vm._v(" "),_c('td',[(!blog.published)?_c('div',[_c('strong',[_vm._v("Not Published")])]):_c('div',[_vm._v("\n            Published\n          ")])])])}),0)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"blog-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[(!_vm.blog.published)?_c('button',{staticClass:"mylisting-button dark-button mb-2",on:{"click":function($event){return _vm.publish()}}},[_vm._v("Publish")]):_c('button',{staticClass:"mylisting-button dark-button mb-2",on:{"click":function($event){return _vm.unpublish()}}},[_vm._v("Unpublish")]),_vm._v(" "),_c('app-blog-post',{attrs:{"id":_vm.blog.id}}),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.blog.published)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.publish()}}},[_vm._v("Publish")]):_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.unpublish()}}},[_vm._v("Unpublish")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideBlogModal()}}},[_vm._v("Cancel")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Title")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateProfile_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02eadc63_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateProfile_vue__ = __webpack_require__(837);
function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02eadc63_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(836);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("97c417da", content, true, {});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".profile-step{border-bottom:3px solid var(--thrivehiregrey)}.profile-step:hover{cursor:pointer}.profile-step h4,.profile-step small{color:var(--thrivehiregrey)}.profile-step small{font-weight:600;text-transform:uppercase}.active-step{border-bottom:3px solid var(--coredarkcolor)}.active-step h4{color:var(--coredarkcolor)}.inactive-step{border-bottom:3px solid var(--thrivehiregrey)}.inactive-step h4{color:var(--thrivehiregrey)}.inactive-step small{color:var(--thrivehiregrey)}.active-step small,.inactive-step small{font-weight:600;text-transform:uppercase}.active-step small{color:gray}.slide-enter-active{animation:slide-in .3s ease-out forwards}.slide-leave-active{animation:slide-out .3s ease-out forwards}@keyframes slide-in{0%{transform:translateY(-30px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes slide-out{0%{transform:translateY(0);opacity:1}to{transform:translateY(-30px);opacity:0}}.invalid label,.invalid small{color:red}", ""]);

// exports


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateInterview_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d9645e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateInterview_vue__ = __webpack_require__(839);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateInterview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d9645e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateInterview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Phone Interview Notes")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n          p\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n          H1\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n          H2\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n          H3\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n          List\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n          1. 2. 3...\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n          ---\n        ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1),_vm._v(" "),_c('h4',{staticClass:"mt-4"},[_vm._v("Interview Notes")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.richEditor2},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n          p\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n          H1\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n          H2\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n          H3\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n          List\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n          1. 2. 3...\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n          ---\n        ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.richEditor2}})],1),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"notes-saved-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Notes saved!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('notes-saved-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516271bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__(841);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516271bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-striped mt-2"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredEvents),function(event){return _c('tr',{key:event.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showEventModal(event)}}},[_c('td',[_vm._v("\n          "+_vm._s(event.title)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(event.poster_name)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s((new Date(event.date)).toDateString())+"\n        ")])])}),0)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"event-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('hr')])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Title")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Poster")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agents_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49432ebc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agents_vue__ = __webpack_require__(846);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49432ebc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterviewScheduler_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056b3c79_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterviewScheduler_vue__ = __webpack_require__(844);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterviewScheduler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056b3c79_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterviewScheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.interview)?_c('h4',[_vm._v("Interview Time: "+_vm._s(new Date(_vm.interview).toDateString())+" at "+_vm._s(new Date(_vm.interview).toLocaleTimeString()))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row field-of-fields"},[_c('div',{staticClass:"col-lg-6"},[_c('label',{staticClass:"top-label"},[_vm._v("Interview Date")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},attrs:{"disabled-dates":_vm.disabledDates,"id":"signedDate"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',{staticClass:"top-label"},[_vm._v("Interview Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startHour),expression:"startHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'StartHour'+index},[_vm._v(_vm._s(hour))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startMinute),expression:"startMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'StartMinute'+index},[_vm._v(_vm._s(minute))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startAMPM),expression:"startAMPM"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startAMPM=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.ampmOptions),function(ampm,index){return _c('option',{key:'StartAMPM'+index},[_vm._v(_vm._s(ampm))])}),0)])])]),_vm._v(" "),(_vm.date)?_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.setInterview()}}},[_vm._v("Set Interview")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),(_vm.user.first_name || _vm.user.employer_name)?_c('hr'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-lg-6 pr-5"},[_c('div',{staticClass:"input-group",staticStyle:{"max-width":"450px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statuses),function(statusOption,index){return _c('option',{key:index},[_vm._v(_vm._s(statusOption))])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.updateStatus()}}},[_vm._v("Update Status")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('interview-scheduler',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-lg-6 px-4"},[_c('h3',[_vm._v("Notes")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.notes),function(note){return _c('div',{key:note.id},[_c('pre',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showEditNoteModal(note)}}},[_vm._v(_vm._s(note.note))]),_vm._v(" "),_c('small',{},[_vm._v(_vm._s((new Date(note.timestamp)).toDateString())),(note.type)?_c('span',[_vm._v(" ("+_vm._s(note.type)+")")]):_vm._e()]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showAddNoteModal()}}},[_vm._v("Add Note")])],2),_vm._v(" "),_c('div',{staticClass:"col-lg-6 px-4"},[_c('p',{staticClass:"mb-1"},[_vm._v("Registration Date: "+_vm._s(new Date(_vm.user.created_date).toDateString()))]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Last Contacted Date: "+_vm._s(new Date(_vm.user.last_contacted_date).toDateString()))]),_vm._v(" "),_c('h3',[_vm._v("Send Email")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.user.email))]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("From Email")]),_vm._v(" "),_c('multiselect',{staticClass:"mb-2 w-100",attrs:{"options":_vm.$store.getters.agencyAdminEmails,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"","max-height":150},model:{value:(_vm.fromEmail),callback:function ($$v) {_vm.fromEmail=$$v},expression:"fromEmail"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailSubject),expression:"emailSubject"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":"Subject"},domProps:{"value":(_vm.emailSubject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailSubject=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailMessage),expression:"emailMessage"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.emailMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailMessage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"form-group form-check mb-1 mt-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logMessage),expression:"logMessage"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.logMessage)?_vm._i(_vm.logMessage,true)>-1:(_vm.logMessage)},on:{"change":function($event){var $$a=_vm.logMessage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.logMessage=$$a.concat([$$v]))}else{$$i>-1&&(_vm.logMessage=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.logMessage=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer"},on:{"click":function($event){_vm.logMessage = !_vm.logMessage}}},[_vm._v("\n          Log email as note\n        ")])]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.sendEmail()}}},[_vm._v("Send")])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"max-width":"450px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.updatePassword()}}},[_vm._v("Update Password")])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"note-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[(!_vm.note.id)?_c('h2',[_vm._v("Add Note")]):_vm._e(),_vm._v(" "),(_vm.note.id)?_c('h2',[_vm._v("Edit Note")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.noteText),expression:"noteText"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.noteText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.noteText=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideNoteModal()}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.note.id)?_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.deleteNote()}}},[_vm._v("Delete Note")]):_vm._e(),_vm._v(" "),(!_vm.note.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.addNote()}}},[_vm._v("Add Note")]):_vm._e(),_vm._v(" "),(_vm.note.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateNote()}}},[_vm._v("Update Note")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"message-sent-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Message sent.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('message-sent-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"status-updated-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Status updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('status-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"password-reset-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Password reset to "+_vm._s(this.password))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('password-reset-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showAddAdminModal()}}},[_vm._v("Add Administrator")]),_vm._v(" "),_c('table',{staticClass:"table table-striped mt-2"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.agents),function(user){return _c('tr',{key:user.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showAgentModal(user)}}},[_c('td',[_vm._v("\n          "+_vm._s(user.first_name)+" "+_vm._s(user.last_name)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(user.email)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(user.category)+"\n          ")])])}),0)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"admin-panel-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"col dashboard-button text-center",class:{ 'dashboard-button-active': _vm.tab == 'admin' },on:{"click":function($event){_vm.tab = 'admin'}}},[_vm._v("\n          Admin\n        ")])]),_vm._v(" "),_c('div',[_c('panel',{attrs:{"passedUser":_vm.agent},on:{"userUpdated":function($event){return _vm.userUpdated()}}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.showDeleteUserModal(_vm.agent)}}},[_vm._v("Delete")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"add-admin-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[_c('h2',[_vm._v("Add Admin")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticClass:"top-label"},[_vm._v("Email*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Access Level*")]),_vm._v(" "),_c('multiselect',{staticClass:"mb-2 w-100",attrs:{"options":_vm.categories,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Select Access Level","max-height":150},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('agent-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.email && _vm.category)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.addAdmin()}}},[_vm._v("Add")]):_vm._e()],1)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-agent-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Are you sure you want to delete this user?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.agent.email))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideDeleteUserModal()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteUser(_vm.agent)}}},[_vm._v("Delete")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Classification")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailingList_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae3a2d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailingList_vue__ = __webpack_require__(848);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae3a2d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailingList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"row"},[_vm._l((_vm.mailingList),function(email){return _c('div',{key:email.id,staticClass:"col-lg-12"},[(email.category == '')?_c('p',[_vm._v(_vm._s(email.email))]):_vm._e()])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('h3',[_vm._v("Employers")]),_vm._v(" "),_vm._l((_vm.mailingList),function(email){return _c('div',{key:email.id},[(email.category == 'Employer')?_c('p',[_vm._v(_vm._s(email.email))]):_vm._e()])})],2),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('h3',[_vm._v("Candidates")]),_vm._v(" "),_vm._l((_vm.mailingList),function(email){return _c('div',{key:email.id},[(email.category == 'Candidate')?_c('p',[_vm._v(_vm._s(email.email))]):_vm._e()])})],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scheduler_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1694289a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scheduler_vue__ = __webpack_require__(850);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scheduler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1694289a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 calendar"},[_c('calendar-view',{staticClass:"theme-default holiday-us-traditional holiday-us-official",attrs:{"show-date":_vm.showDate,"date-classes":_vm.selectedDateObj,"events":_vm.events},on:{"click-date":_vm.onClickDate},scopedSlots:_vm._u([{key:"header",fn:function(t){return _c('calendar-view-header',{attrs:{"header-props":t.headerProps},on:{"input":_vm.setShowDate}})}}])})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('h3',[_vm._v("Add a Shift")]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.selectedDate)?_c('div',[_c('p',[_vm._v("Please select a date.")])]):_vm._e(),_vm._v(" "),(_vm.selectedDate)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.selectedDate.toDateString()))]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"10px"},attrs:{"for":""}},[_vm._v("Client")]),_vm._v(" "),_c('multiselect',{staticClass:"mb-2 w-100",attrs:{"options":_vm.employers,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Select Client"},model:{value:(_vm.selectedFilterEmployer),callback:function ($$v) {_vm.selectedFilterEmployer=$$v},expression:"selectedFilterEmployer"}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"10px"}},[_vm._v("Start Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startHour),expression:"startHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("HH")]),_vm._v(" "),_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'StartHour'+index},[_vm._v(_vm._s(hour))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startMinute),expression:"startMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("MM")]),_vm._v(" "),_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'StartMinute'+index},[_vm._v(_vm._s(minute))])})],2)]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-top":"10px"}},[_vm._v("End Time")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endHour),expression:"endHour"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("HH")]),_vm._v(" "),_vm._l((_vm.hourOptions),function(hour,index){return _c('option',{key:'EndHour'+index},[_vm._v(_vm._s(hour))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endMinute),expression:"endMinute"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("MM")]),_vm._v(" "),_vm._l((_vm.minuteOptions),function(minute,index){return _c('option',{key:'EndMinute'+index},[_vm._v(_vm._s(minute))])})],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.postJob()}}},[_vm._v("Create Shift")])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationView_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268a575a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationView_vue__ = __webpack_require__(852);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268a575a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field-of-fields"},[_c('h3',{},[_vm._v("Contact Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.first_name))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.last_name))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Email Address")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.email))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.phone))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Workplace")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text12))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Spouse/Partner First Name")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.features[0]))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Spouse/Partner Last Name")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.features[1]))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Spouse/Partner Email Address")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.features[2]))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Spouse/Partner Phone Number")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.features[3]))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',[_c('label',[_vm._v("Spouse/Partner Workplace")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.features[4]))])])])]),_vm._v(" "),_c('div',{staticClass:"row-lg-4"},[_c('label',[_vm._v("Home Address")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.address1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.address2))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.city))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.provincestate))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',[_c('label',[_vm._v("Zip Code")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.postal_code))])])])]),_vm._v(" "),_c('h3',{staticClass:"mt-5"},[_vm._v("Service Information")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"3px","margin-bottom":"-5px"}}),_vm._v(" "),_c('div',{staticClass:"row-lg-4"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date(_vm.user.available_date).toDateString()))])]),_vm._v(" "),_c('div',{staticClass:"row-lg-4"},[_c('label',[_vm._v(" Select the positions that you are trying to fill")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.job_types.join(', ')))])]),_vm._v(" "),_c('div',{staticClass:"row-lg-4"},[_c('label',[_vm._v("List the days and hours the nannies should expect to work")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text1))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{staticClass:"mt-3 mb-2"},[_vm._v("All of the children that will be taken care of.")]),_vm._v(" "),_vm._l((_vm.children),function(child,index){return _c('div',{key:'Child'+index,staticClass:"px-2"},[_c('h5',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v(_vm._s(child.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"-10px"}},[_c('div',{staticClass:"col-lg-6"},[(child.birthday)?_c('label',[_vm._v("Birthday")]):_vm._e(),_vm._v(" "),(child.birthday)?_c('p',[_vm._v(_vm._s(new Date(child.birthday).toDateString())+" (Age: "+_vm._s(_vm.getAge(child.birthday))+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[(child.text3)?_c('label',[_vm._v("Gender")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(child.text3))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[(child.text1)?_c('label',[_vm._v("Description")]):_vm._e(),_vm._v(" "),_c('pre',[_vm._v(_vm._s(child.text1))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[(child.text2)?_c('label',[_vm._v("School")]):_vm._e(),_vm._v(" "),_c('pre',[_vm._v(_vm._s(child.text2))])])]),_vm._v(" "),_c('hr')])})],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('label',[_vm._v("If you have pets, please list the kinds you have")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text7))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('label',[_vm._v("If you have other domestic help, how often do they come")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text10))])])]),_vm._v(" "),_c('div',[_c('label',[_vm._v(" What light housekeeping duties will your nanny be responsible for?")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text2))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v(" How do you handle discipline in your home? How do you want a Nanny to handle discipline?* ")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text6))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("Pick which words best describes your family?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.multiselect1.join(', ')))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("What are the most important qualities you value in a nanny?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.multiselect2.join(', ')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("The nanny will be...")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector4))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("Have you employed a Nanny or Au Pair before?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector5))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("Will they be required to work regularly scheduled shifts?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector6))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("Are you open to having a nanny take your children outside of the home for child related activity?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector7))])])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("What salary range are you offering?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text3))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("What benefits will you be providing?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text4))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Will your nanny be responsible for running any errands or grocery shopping on the job? If yes, please list. ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.text8))])]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0px"}},[_vm._v("Select how important these qualities are to you:*")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("Experience")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector1))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("Education")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector2))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("Personality")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.selector3))])])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Please list any skills or abilities you desire in a nanny.")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text5))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Is there any additional information about your family/family situation that our team should know before beginning your search?")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text11))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Is there anything else that you would like to tell us about your children, family, or the position?")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.user.text12))])]),_vm._v(" "),_c('div',{staticClass:"row-lg-4"},[_c('label',[_vm._v("How did you hear about us?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.marketing_source))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternalProfile_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ae4e18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternalProfile_vue__ = __webpack_require__(854);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternalProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ae4e18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternalProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Welcome Call Notes")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n          p\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n          H1\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n          H2\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n          H3\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n          List\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n          1. 2. 3...\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n          ---\n        ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1),_vm._v(" "),_c('h4',{staticClass:"mt-4"},[_vm._v("Consultation Notes")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.richEditor2},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n          p\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n          H1\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n          H2\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n          H3\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n          List\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n          1. 2. 3...\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n          ---\n        ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.richEditor2}})],1),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"notes-saved-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Notes saved!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('notes-saved-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusStats_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f1337d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusStats_vue__ = __webpack_require__(858);
function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f1337d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(857);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("30f535ba", content, true, {});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".tab{display:inline;margin-left:1vw}.total-header{font-family:Lato;font-weight:600;font-size:1.25vw;height:45px;overflow-wrap:break-word}.stats-block{background-color:var(--bootstrapgrey);padding-top:9px;padding-bottom:9px;margin-right:4px;border-radius:3px;box-shadow:0 .15rem .5rem rgba(0,0,0,.15)!important}.stats-header{font-family:Lato;font-weight:800;font-size:.8vw;height:45px;overflow-wrap:break-word}.user-stat{font-size:1.25vw}@media (max-width:1717px){.stats-header{height:65px}}@media (max-width:1438px){.user-stat{font-size:16px}}@media (max-width:1319px){.user-stat{font-size:14px}}@media (max-width:1238px){.stats-header{height:80px}}@media (max-width:992px){.stats-header{height:20px}}", ""]);

// exports


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"ml-3"},[_c('span',{},[_vm._v("Total: "+_vm._s(_vm.total)+" ")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3 ml-1",staticStyle:{"margin-top":"2px"}},_vm._l((_vm.statArray),function(item,index){return _c('div',{key:index,staticClass:"col-lg-1 stats-block"},[_c('p',{staticClass:"stats-header"},[_vm._v(_vm._s(item[0])+" ")]),_vm._v(" "),_c('p',{staticClass:"user-stat"},[_vm._v(_vm._s(item[1].length)+" ("+_vm._s(_vm._f("singleDecimal")(item[1].length / _vm.total * 100))+"%)")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailLog_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c96c000_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailLog_vue__ = __webpack_require__(860);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c96c000_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.emails),function(email){return _c('div',{key:email.id,staticClass:"mt-3 px-3"},[_c('div',{on:{"click":function($event){return _vm.showEmailModal(email)}}},[_c('p',[_vm._v("Date: "+_vm._s(new Date(email.timestamp)))]),_vm._v(" "),_c('p',[_vm._v("To: "+_vm._s(email.to_email))]),_vm._v(" "),_c('p',[_vm._v("Subject: "+_vm._s(email.subject))])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"email-details-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('p',[_vm._v("Date: "+_vm._s(new Date(_vm.email.timestamp)))]),_vm._v(" "),_c('p',[_vm._v("To: "+_vm._s(_vm.email.to_email))]),_vm._v(" "),_c('p',[_vm._v("Subject: "+_vm._s(_vm.email.subject))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.email.body)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('email-details-modal')}}},[_vm._v("Close")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterCalendar_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30820acf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterCalendar_vue__ = __webpack_require__(862);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30820acf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-lg-12 calendar",staticStyle:{"min-height":"600px"}},[_c('calendar-view',{staticClass:"theme-default holiday-us-traditional holiday-us-official",attrs:{"show-date":_vm.showDate,"date-classes":_vm.selectedDateObj,"events":_vm.calendarJobs},on:{"click-date":_vm.onClickDate,"click-event":_vm.onClickEvent},scopedSlots:_vm._u([{key:"header",fn:function(t){return _c('calendar-view-header',{attrs:{"header-props":t.headerProps},on:{"input":_vm.setShowDate}})}}])})],1)]),_vm._v(" "),_c('table',{staticClass:"web-only table table-striped mt-3 mb-5"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.jobs),function(job){return _c('tr',{key:job.id,staticStyle:{"cursor":"pointer"}},[_c('td',[_vm._v(_vm._s(new Date(_vm.addCurrentTimeToDate(job.date)).toDateString()))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(job.poster_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(job.filler_name))]),_vm._v(" "),_c('td',[(job.status == 'Approved')?_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.start_time)))]):_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.actual_start_time)))])]),_vm._v(" "),_c('td',[(job.status == 'Approved')?_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.end_time)))]):_c('span',[_vm._v(_vm._s(_vm.djangotimeformatAMPM(job.actual_end_time)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(job.status))]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{ name: 'Job', params: { id: job.id } },"target":"_blank"}},[_vm._v("View Job Listing")])],1)])}),0)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v(_vm._s(_vm.job.poster_name)+" - "+_vm._s(new Date(_vm.job.date).toDateString()))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Start Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.job.start_time)))]),_vm._v(" "),_c('p',[_vm._v("End Time: "+_vm._s(_vm.djangotimeformatAMPM(_vm.job.end_time)))]),_vm._v(" "),(_vm.job.text2)?_c('pre',[_vm._v("Preferred Nanny: "+_vm._s(_vm.job.text2))]):_vm._e(),_vm._v(" "),(_vm.job.text)?_c('pre',[_vm._v("Special Notes: "+_vm._s(_vm.job.text))]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 mb-3"},[(_vm.job.filler_name)?_c('h5',[_vm._v("Filled By: "+_vm._s(_vm.job.filler_name))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_vm._v("Current Status: "+_vm._s(_vm.job.status))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statuses),function(statusOption,index){return _c('option',{key:index},[_vm._v(_vm._s(statusOption))])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.updateStatus()}}},[_vm._v("Update Status")])]),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Assign a Nanny")]),_vm._v(" "),_c('div',{staticClass:"input-group mt-1"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidateSelection),expression:"candidateSelection"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.candidateSelection=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.candidateEmails),function(candidateEmail,index){return _c('option',{key:index},[_vm._v(_vm._s(candidateEmail))])}),0),_vm._v(" "),(_vm.candidateSelection)?_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.assign()}}},[_vm._v("Assign")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[(_vm.job.city)?_c('app-map',{attrs:{"locationObject":_vm.job,"latlng1":_vm.job.multiselect2,"latlng2":_vm.job.multiselect3,"accessLevel":"full"}}):_vm._e()],1)]),_vm._v(" "),(_vm.applications.length)?_c('div',[_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.refreshApplications()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('table',{staticClass:"table table-striped mt-2 shadow"},[_c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Broadcast Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.applications),function(application){return _c('tr',{key:application.id,staticStyle:{"cursor":"pointer"}},[_c('td',[_vm._v("\n                "+_vm._s(application.applicant_name)+"\n              ")]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(new Date(application.date).toDateString()))])]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(application.status)+"\n                ")])])}),0)])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('job-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{ name: 'Job', params: { id: _vm.job.id } },"target":"_blank"}},[_vm._v("View Job Listing")]),_vm._v(" "),(!_vm.applications.length)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.showBroadcastModal()}}},[_vm._v("Broadcast")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.$modal.show('delete-job-modal')}}},[_vm._v("Delete Request")])],1)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"status-updated-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Status updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('status-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-job-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Are you sure you want to delete this request?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-job-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteJob()}}},[_vm._v("Delete")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"broadcast-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Please select which nannies you would like to broadcast this to")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.candidates),function(candidate,index){return _c('div',{key:'Candidate'+index},[_c('h5',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectCandidate(candidate)}}},[_vm._v(_vm._s(_vm.candidateEmails[index])+" "),(_vm.selectedCandidates.includes(candidate))?_c('span',[_c('i',{staticClass:"material-icons mt-1",staticStyle:{"font-size":"15px"}},[_vm._v("check_circle")])]):_vm._e()])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('broadcast-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.broadcast()}}},[_vm._v("Broadcast")])],2)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"successfully-broadcasted-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Broadcast sent!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('successfully-broadcasted-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"nanny-assigned-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Nanny assigned!")]),_vm._v(" "),_c('h5',[_vm._v("The client has been notified.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('nanny-assigned-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--nannycogreen)","color":"#fff"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Family")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Nanny")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Start Time")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("End Time")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateEmployerRelationshipManager_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7edd6cac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateEmployerRelationshipManager_vue__ = __webpack_require__(864);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateEmployerRelationshipManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7edd6cac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateEmployerRelationshipManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Assigned Nannies")]),_vm._v(" "),(_vm.relationships.length === 0)?_c('p',[_vm._v("No nannies have been linked to this family.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.relationships),function(relationship){return _c('div',{key:relationship.id,staticClass:"col-lg-4 mb-4"},[_c('div',{staticClass:"p-4",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"2px"}},[_c('div',{staticClass:"center"},[_c('h4',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(relationship.candidate_name))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Status: "+_vm._s(relationship.status))]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[(relationship.created_date)?_c('small',[_vm._v("Linked: "+_vm._s(new Date(relationship.created_date).toDateString()))]):_vm._e()]),_vm._v(" "),(relationship.status == 'Interested')?_c('div',[_c('p',[_vm._v("Client Interview Preference: "+_vm._s(relationship.text1))]),_vm._v(" "),_c('p',[_vm._v("Client Interview Availability: "+_vm._s(relationship.text2))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-2",on:{"click":function($event){return _vm.showUpdateStatusModal(relationship)}}},[_vm._v("Update Status")]),_vm._v(" "),(_vm.$store.getters.candidateEmployerRelationshipStatuses.indexOf(relationship.status) >= _vm.$store.getters.candidateEmployerRelationshipStatuses.indexOf("Offer Extended"))?_c('button',{staticClass:"mylisting-button dark-button mt-2",on:{"click":function($event){return _vm.showOfferModal(relationship)}}},[_vm._v("View Offer")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-bottom":"5px"}},[_c('router-link',{attrs:{"to":{ name: 'Candidate Viewable Dashboard', params: { id: relationship.candidate } },"target":"_blank"}},[_vm._v("View Profile")])],1),_vm._v(" "),_c('p',{staticClass:"mt-2",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.showDeleteRelationshipModal(relationship)}}},[_vm._v("Delete")])])])])}),0),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-3",on:{"click":function($event){return _vm.showCandidateAssignmentModal()}}},[_vm._v("Add Candidate")]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"candidate-assignment-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[_c('h2',[_vm._v("Add Candidate to Family")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('multiselect',{staticClass:"mb-2 w-100",attrs:{"options":_vm.candidateEmails,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Select Candidate","max-height":150},model:{value:(_vm.candidateSelection),callback:function ($$v) {_vm.candidateSelection=$$v},expression:"candidateSelection"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('multiselect',{staticClass:"mb-2 w-100",attrs:{"options":_vm.candidateEmployerRelationshipStatuses,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Select Status","max-height":150},model:{value:(_vm.candidateEmployerRelationshipStatus),callback:function ($$v) {_vm.candidateEmployerRelationshipStatus=$$v},expression:"candidateEmployerRelationshipStatus"}})],1)]),_vm._v(" "),_c('label',[_vm._v("Notes for Family about Candidate")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientNotes),expression:"clientNotes"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.clientNotes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientNotes=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('candidate-assignment-modal')}}},[_vm._v("Close")]),_vm._v(" "),(_vm.candidateSelection && _vm.candidateEmployerRelationshipStatus)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.postRelationship()}}},[_vm._v("Add")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"update-status-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"center"},[_c('h4',{staticClass:"mt-3",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.relationship.candidate_name))]),_vm._v(" "),_c('multiselect',{staticClass:"mb-2 mt-2 w-100 center",staticStyle:{"max-width":"300px"},attrs:{"options":_vm.candidateEmployerRelationshipStatuses,"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Select Status","max-height":150},model:{value:(_vm.candidateEmployerRelationshipStatus),callback:function ($$v) {_vm.candidateEmployerRelationshipStatus=$$v},expression:"candidateEmployerRelationshipStatus"}})],1),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[_c('label',[_vm._v("Notes for Family about Candidate")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientNotes),expression:"clientNotes"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.clientNotes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientNotes=$event.target.value}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('update-status-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-2",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateRelationshipStatus(_vm.relationship)}}},[_vm._v("Update Status")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"offer-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Offer")]),_vm._v(" "),_c('div',{staticClass:"field-of-fields"},[_c('label',{staticClass:"top-label"},[_vm._v("Pay rate")]),_vm._v(" "),_c('small',[_vm._v("For example, $20 per hour or $41,600 per year")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payRate),expression:"payRate"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.payRate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payRate=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Contract Duration")]),_vm._v(" "),_c('small',[_vm._v("For example, 1 year")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contractDuration),expression:"contractDuration"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.contractDuration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contractDuration=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Schedule/Hours")]),_vm._v(" "),_c('small',[_vm._v("For example, guaranteeing 40 hours whether worked or not. M-F 8:30AM-5PM")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.daysHours),expression:"daysHours"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.daysHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.daysHours=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Paid Holidays")]),_vm._v(" "),_c('small',[_vm._v("For example, New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day and Christmas Day.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidTimeOff),expression:"paidTimeOff"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.paidTimeOff)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paidTimeOff=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Paid Vacation")]),_vm._v(" "),_c('small',[_vm._v("For example, 10 days")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidVacation),expression:"paidVacation"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paidVacation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paidVacation=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Paid Sick Days")]),_vm._v(" "),_c('small',[_vm._v("For example, 5 days")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidSickDays),expression:"paidSickDays"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paidSickDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paidSickDays=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Payment Frequency")]),_vm._v(" "),_c('small',[_vm._v("For example, Bi-Weekly")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentFrequency),expression:"paymentFrequency"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paymentFrequency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paymentFrequency=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Health Insurance Stipend")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.healthInsurance),expression:"healthInsurance"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.healthInsurance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.healthInsurance=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Mileage Reimbursement")]),_vm._v(" "),_c('small',[_vm._v("For on the job travel at the IRS rate of $0.58 per mile.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mileageReimbursement),expression:"mileageReimbursement"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.mileageReimbursement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mileageReimbursement=$event.target.value}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('offer-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateOffer(_vm.relationship)}}},[_vm._v("Update")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"offer-updated-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Offer updated!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('offer-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"candidate-assigned-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Candidate to Family link updated!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('candidate-assigned-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-relationship-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Are you sure you want to remove the link between "+_vm._s(_vm.relationship.candidate_name)+" and this family?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-relationship-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteRelationship(_vm.relationship)}}},[_vm._v("Delete")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPosting_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e0c584_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPosting_vue__ = __webpack_require__(866);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPosting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e0c584_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPosting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showJobModal()}}},[_vm._v("Post Job")]):_vm._e(),_vm._v(" "),_vm._l((_vm.jobs),function(job){return _c('div',{key:job.id},[_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(job.title)),(job.status == 'Closed')?_c('span',[_vm._v(" (Closed)")]):_vm._e()]),_vm._v(" "),(job.date)?_c('p',[_vm._v("Start Date: "+_vm._s(new Date(_vm.addCurrentTimeToDate(job.date)).toDateString()))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Location: "+_vm._s(job.city)+", "+_vm._s(job.provincestate)+", "+_vm._s(job.postal_code))]),_vm._v(" "),_c('p',[_vm._v("Compensation: "+_vm._s(job.compensation))]),_vm._v(" "),_c('p',[_vm._v("Schedule: "+_vm._s(job.text))]),_vm._v(" "),_c('pre',{staticClass:"mt-2",domProps:{"innerHTML":_vm._s(job.description)}}),_vm._v(" "),(job.status == 'Posted')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.broadcast(job)}}},[_vm._v("Broadcast")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showApplicantsModal(job)}}},[_vm._v("View Applicants")]),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"cursor":"pointer"}},[_c('span',{on:{"click":function($event){return _vm.showJobModal(job)}}},[_vm._v("Edit Job")]),_vm._v(" | "),(job.status == 'Closed')?_c('span',{on:{"click":function($event){return _vm.reopenJob(job)}}},[_vm._v("Re-Open Job")]):_vm._e(),(job.status != 'Closed')?_c('span',{on:{"click":function($event){return _vm.closeJob(job)}}},[_vm._v("Close Job")]):_vm._e(),_vm._v(" | "),_c('span',{on:{"click":function($event){return _vm.showDeleteJobModal(job)}}},[_vm._v("Delete")])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[(_vm.job.id)?_c('h3',[_vm._v("Edit Job")]):_vm._e(),_vm._v(" "),(!_vm.job.id)?_c('h3',[_vm._v("Post Job")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.provincestate),expression:"provincestate"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.provincestate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.provincestate=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Zip Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postalCode),expression:"postalCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postalCode=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Compensation")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.compensation),expression:"compensation"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.compensation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.compensation=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",staticStyle:{"padding":".37rem .75rem","line-height":"1"},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('label',[_vm._v("Schedule")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.schedule),expression:"schedule"}],staticClass:"form-control",attrs:{"rows":"2"},domProps:{"value":(_vm.schedule)},on:{"input":function($event){if($event.target.composing){ return; }_vm.schedule=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n              p\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n              H1\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n              H2\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n              H3\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n              List\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n              1. 2. 3...\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n              ---\n            ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1),_vm._v(" "),_c('label',{},[_vm._v("Picture")]),_vm._v(" "),_c('input',{ref:"pic",staticClass:"form-control-file",attrs:{"type":"file","id":"pic"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.job.id)?_c('button',{staticClass:"mylisting-button dark-button mb-5",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.postJob()}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.job.id)?_c('button',{staticClass:"mylisting-button dark-button mb-5",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.patchJob(_vm.job)}}},[_vm._v("Save")]):_vm._e()],1)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"applicants-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('table',{staticClass:"table table-striped mt-2"},[_c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Application Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Profile")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.applications),function(application){return _c('tr',{key:application.id,staticStyle:{"cursor":"pointer"}},[_c('td',[_vm._v("\n              "+_vm._s(application.applicant_name)+"\n            ")]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(new Date(application.date).toDateString()))])]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(application.status)+"\n              ")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'Candidate Viewable Dashboard', params: { id: application.applicant } },"target":"_blank"}},[_vm._v("View Profile")])],1)])}),0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('applicants-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"notes-saved-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Notes saved!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('notes-saved-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-posted-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Job posted!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('job-posted-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"job-updated-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Job updated!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('job-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"successfully-broadcasted-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Broadcast sent to "+_vm._s(_vm.candidates.length)+" nannies!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('successfully-broadcasted-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-job-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Are you sure you want to delete this job?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-job-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteJob(_vm.job)}}},[_vm._v("Delete")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplates_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d3386a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplates_vue__ = __webpack_require__(868);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d3386a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Email Templates")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-4",on:{"click":function($event){return _vm.showTemplateModal()}}},[_vm._v("Add Template")]),_vm._v(" "),_vm._l((_vm.templates),function(template,index){return _c('div',{key:'Template'+index},[_c('h3',[_vm._v("Name: "+_vm._s(template.name)),(template.deactivated)?_c('span',[_vm._v(" (DEACTIVATED)")]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"15px"},attrs:{"src":__webpack_require__(36)},on:{"click":function($event){return _vm.showTemplateModal(template)}}})]),_vm._v(" "),_c('h5',[_vm._v("Type: "+_vm._s(template.selector1))]),_vm._v(" "),_c('h5',[_vm._v("Trigger: "+_vm._s(template.type))]),_vm._v(" "),(template.status)?_c('h5',[_vm._v("Status: "+_vm._s(template.status))]):_vm._e(),_vm._v(" "),(template.selector2)?_c('h5',[_vm._v("Category: "+_vm._s(template.selector2))]):_vm._e(),_vm._v(" "),_c('p',{},[_vm._v("Sender Email: "+_vm._s(template.from_email))]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Subject: "+_vm._s(template.subject))]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Give the template a human readable name for your reference"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Subject")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject),expression:"subject"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Body")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.richEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n              p\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n              H1\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n              H2\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n              H3\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n              List\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n              1. 2. 3...\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n              ---\n            ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.richEditor}})],1),_vm._v(" "),_c('p',[_vm._v("Use [[fname]] for first name.")]),_vm._v(" "),_c('label',[_vm._v("Sender Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromEmail),expression:"fromEmail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.fromEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fromEmail=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("Trigger")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.types,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Select Trigger"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.selector1Options,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Select Type"},model:{value:(_vm.selector1),callback:function ($$v) {_vm.selector1=$$v},expression:"selector1"}})],1)]),_vm._v(" "),(_vm.type == 'Status Change Notification' && _vm.selector1)?_c('div',{staticClass:"col"},[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.statuses,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Select Status"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group form-check mb-1 mt-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deactivated),expression:"deactivated"}],staticClass:"form-check-input",staticStyle:{"margin-top":"4px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.deactivated)?_vm._i(_vm.deactivated,true)>-1:(_vm.deactivated)},on:{"change":function($event){var $$a=_vm.deactivated,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.deactivated=$$a.concat([$$v]))}else{$$i>-1&&(_vm.deactivated=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.deactivated=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer","margin-top":"0"},on:{"click":function($event){_vm.deactivated = !_vm.deactivated}}},[_vm._v("\n          Deactivate this template\n        ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.template.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.postTemplate()}}},[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.template.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateTemplate()}}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(_vm.template.id)?_c('p',{staticClass:"mt-1 delete-text",on:{"click":function($event){return _vm.$modal.show('delete-template-modal')}}},[_vm._v("Delete Template")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-created-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template created.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-created-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-updated-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-template-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Are you sure you want to delete this template?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-template-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.deleteTemplate()}}},[_vm._v("Delete")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-deleted-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template deleted.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-deleted-modal')}}},[_vm._v("Close")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailFooters_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea0306a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailFooters_vue__ = __webpack_require__(870);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailFooters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea0306a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailFooters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-lg-3"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showNewFooterModal()}}},[_vm._v("Add New Footer")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.footers),function(footer){return _c('div',{key:footer.id},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3",staticStyle:{"max-width":"180px","border-right":"1px solid var(--coredarkcolor)"}},[_c('img',{staticStyle:{"max-width":"150px","border-radius":"50%"},attrs:{"src":footer.image}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('h3',[_vm._v(_vm._s(footer.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(footer.title))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.email)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.phone)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.address)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3",staticStyle:{"padding-top":"30px"}},[_c('p',[_vm._v(_vm._s(footer.facebook))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(footer.instagram))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.twitter)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.linkedin)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.youtube)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(footer.website)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-2",staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showEditModal(footer)}}},[_vm._v("Edit")])])])])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"new-footer-modal","width":"40%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('label',{staticClass:"form-control-label",attrs:{"for":""}},[_vm._v("Please select a user to create an email footer for:")]),_vm._v(" "),_c('multiselect',{staticClass:"mb-3",attrs:{"options":_vm.emails,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),(!_vm.email && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("Please select an email to continue.")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('new-footer-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showAddModal()}}},[_vm._v("Next")])],1)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"create-footer-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Name: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.facebook),expression:"facebook"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.facebook=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Instagram")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.instagram),expression:"instagram"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.instagram)},on:{"input":function($event){if($event.target.composing){ return; }_vm.instagram=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Twitter")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twitter),expression:"twitter"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.twitter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twitter=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("LinkedIn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.linkedin),expression:"linkedin"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.linkedin=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("YouTube")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.youtube),expression:"youtube"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.youtube)},on:{"input":function($event){if($event.target.composing){ return; }_vm.youtube=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('create-footer-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.saveNewFooter()}}},[_vm._v("Save")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"new-created-modal","width":"40%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("New footer created!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$modal.hide('new-created-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"footer-edit-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('label',{attrs:{"for":""}},[_vm._v("Name: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.facebook),expression:"facebook"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.facebook=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Instagram")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.instagram),expression:"instagram"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.instagram)},on:{"input":function($event){if($event.target.composing){ return; }_vm.instagram=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Twitter")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twitter),expression:"twitter"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.twitter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twitter=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("LinkedIn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.linkedin),expression:"linkedin"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.linkedin=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("YouTube")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.youtube),expression:"youtube"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.youtube)},on:{"input":function($event){if($event.target.composing){ return; }_vm.youtube=$event.target.value}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('footer-edit-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.saveChanges()}}},[_vm._v("Save")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"saved-modal","width":"40%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Changes saved!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$modal.hide('saved-modal')}}},[_vm._v("Close")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterviewTemplates_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23920824_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterviewTemplates_vue__ = __webpack_require__(872);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterviewTemplates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23920824_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterviewTemplates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Interview Templates")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-4",on:{"click":function($event){return _vm.showTemplateModal()}}},[_vm._v("Add Template")]),_vm._v(" "),_vm._l((_vm.templates),function(template,index){return _c('div',{key:'Template'+index},[_c('h3',[_vm._v("Name: "+_vm._s(template.name)+" "),_c('img',{staticStyle:{"width":"15px"},attrs:{"src":__webpack_require__(36)},on:{"click":function($event){return _vm.showTemplateModal(template)}}})]),_vm._v(" "),_c('h5',[_vm._v("Type: "+_vm._s(template.selector2))]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Give the template a human readable name for your reference"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Type")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.types,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Select Type"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1),_vm._v(" "),_c('label',[_vm._v("Body")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.richEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n              p\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n              H1\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n              H2\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n              H3\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n              List\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n              1. 2. 3...\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n              ---\n            ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.richEditor}})],1),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.template.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.postTemplate()}}},[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.template.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateTemplate()}}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(_vm.template.id)?_c('p',{staticClass:"mt-1 delete-text",on:{"click":function($event){return _vm.$modal.show('delete-template-modal')}}},[_vm._v("Delete Template")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-created-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template created.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-created-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-updated-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-updated-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-template-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Are you sure you want to delete this template?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-template-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.deleteTemplate()}}},[_vm._v("Delete")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-deleted-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template deleted.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-deleted-modal')}}},[_vm._v("Close")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceManager_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a38cee1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceManager_vue__ = __webpack_require__(874);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a38cee1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v("Candidate Resources")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.candidateFiles),function(file){return _c('div',{key:file.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('a',{attrs:{"href":file.file_link,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])])])])}),0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticClass:"mb-3"},[_vm._v("Client Resources")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.employerFiles),function(file){return _c('div',{key:file.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"center py-4 mb-3",staticStyle:{"border":"1px solid var(--bootstrapgrey)","border-radius":"3px"}},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('a',{attrs:{"href":file.file_link,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("View")])]),_vm._v(" "),(_vm.$store.getters.isAgent === true)?_c('p',{staticClass:"delete-text mt-2",on:{"click":function($event){return _vm.showDeleteFileModal(file)}}},[_vm._v("Delete")]):_vm._e()])])}),0),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-4",on:{"click":function($event){return _vm.showUploadFileModal()}}},[_vm._v("Upload File")]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"upload-file-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{},[_c('label',{},[_vm._v("File Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileName),expression:"fileName"}],staticClass:"form-control mb-2",attrs:{"type":"text"},domProps:{"value":(_vm.fileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fileName=$event.target.value}}}),_vm._v(" "),_c('input',{ref:"file",staticClass:"form-control-file mb-2",staticStyle:{"font-size":"0.8rem"},attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_vm._l((_vm.selectors),function(option,index){return _c('div',{key:'selector'+index,staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selector),expression:"selector"}],staticClass:"form-check-input",attrs:{"type":"radio","id":'selector'+index},domProps:{"value":option,"checked":_vm._q(_vm.selector,option)},on:{"change":function($event){_vm.selector=option}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":'selector'+index}},[_vm._v("\n            "+_vm._s(option)+"\n          ")])])})],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('upload-file-modal')}}},[_vm._v("Close")]),_vm._v(" "),(_vm.fileName && _vm.file && _vm.selector)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.uploadFile()}}},[_vm._v("Upload File")]):_vm._e()])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-file-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h4',[_vm._v("Are you sure you want to remove "+_vm._s(_vm.selectedFile.name)+"?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('delete-file-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteFile(_vm.selectedFile)}}},[_vm._v("Delete")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTemplates_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc024672_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTemplates_vue__ = __webpack_require__(876);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTemplates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc024672_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTemplates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Document Templates")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-4",on:{"click":function($event){return _vm.showTemplateModal()}}},[_vm._v("Add Template")]),_vm._v(" "),_vm._l((_vm.templates),function(template,index){return _c('div',{key:'Template'+index},[_c('h3',[_vm._v("Name: "+_vm._s(template.name)+" "),_c('img',{staticStyle:{"width":"15px"},attrs:{"src":__webpack_require__(36)},on:{"click":function($event){return _vm.showTemplateModal(template)}}})]),_vm._v(" "),_c('h5',[_vm._v("User Type: "+_vm._s(template.type))]),_vm._v(" "),_c('h5',[_vm._v("Status Trigger: "+_vm._s(template.status_trigger))]),_vm._v(" "),_c('h5',[_vm._v("Edit Access: "+_vm._s(template.edit_access))]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[(_vm.template.id)?_c('h3',[_vm._v("Edit Template")]):_c('h3',[_vm._v("Add Template")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"What is the name/title of the document?"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.fields),function(field,index){return _c('div',{key:'Field'+index},[_c('p',[_vm._v("Field: "+_vm._s(field)),(_vm.fieldsRequired[index])?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(", Field Tag: [[field"+_vm._s(index)+"]] "),_c('button',{staticClass:"btn btn-info",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.showFieldModal(index)}}},[_vm._v("Edit")]),_c('button',{staticClass:"btn btn-danger",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteField(index)}}},[_vm._v("Delete")])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showFieldModal()}}},[_vm._v("Add Field")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Body")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.descriptionEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.paragraph() },on:{"click":function($event){$event.preventDefault();return commands.paragraph($event)}}},[_vm._v("\n              p\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n              H1\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n              H2\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n              H3\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n              List\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n              1. 2. 3...\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n              ---\n            ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.descriptionEditor}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mb-3",on:{"click":function($event){return _vm.showSignerModal()}}},[_vm._v("Add Signer")]),_vm._v(" "),_vm._l((_vm.signers),function(signer,index){return _c('div',{key:'Signer'+index},[_c('p',[_vm._v("Signer "+_vm._s(index + 1)+": "+_vm._s(signer)+" "),_c('button',{staticClass:"btn btn-info",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.showSignerModal(index)}}},[_vm._v("Edit")]),_c('button',{staticClass:"btn btn-danger",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteSigner(index)}}},[_vm._v("Delete")])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Add a signing name on behalf of the organization")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.organizationSigner),expression:"organizationSigner"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.organizationSigner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.organizationSigner=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("User Type")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.selector1Options,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Select Type"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Status Trigger")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.statuses,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Select Status"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',[_vm._v("Edit Access")]),_vm._v(" "),_c('div',{},[_c('multiselect',{attrs:{"options":_vm.accesses,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Who has edit access?"},model:{value:(_vm.access),callback:function ($$v) {_vm.access=$$v},expression:"access"}})],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.template.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.postTemplate()}}},[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.template.id)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateTemplate()}}},[_vm._v("Update")]):_vm._e()],2)]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"field-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[(_vm.fieldIndex || _vm.fieldIndex === 0)?_c('h3',[_vm._v("Edit Field")]):_c('h3',[_vm._v("Add Field")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',[_vm._v("Field Label")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field),expression:"field"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.field)},on:{"input":function($event){if($event.target.composing){ return; }_vm.field=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"form-group form-check mb-1 mt-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldRequired),expression:"fieldRequired"}],staticClass:"form-check-input",staticStyle:{"margin-top":"4px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.fieldRequired)?_vm._i(_vm.fieldRequired,true)>-1:(_vm.fieldRequired)},on:{"change":function($event){var $$a=_vm.fieldRequired,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.fieldRequired=$$a.concat([$$v]))}else{$$i>-1&&(_vm.fieldRequired=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.fieldRequired=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer","margin-top":"0"},on:{"click":function($event){_vm.fieldRequired = !_vm.fieldRequired}}},[_vm._v("\n          This field is required\n        ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('field-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.fieldIndex || _vm.fieldIndex === 0)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateField()}}},[_vm._v("Update")]):_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.addField()}}},[_vm._v("Add")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"signer-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[(_vm.signerIndex || _vm.signerIndex === 0)?_c('h3',[_vm._v("Edit Signer")]):_c('h3',[_vm._v("Add Signer")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',[_vm._v("Signer Label")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signer),expression:"signer"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Eg. Nanny, Client, Mother, etc."},domProps:{"value":(_vm.signer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signer=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-created-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.signerIndex || _vm.signerIndex === 0)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.updateSigner()}}},[_vm._v("Update")]):_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.addSigner()}}},[_vm._v("Add")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-created-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template created.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-created-modal')}}},[_vm._v("Close")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"template-updated-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Template updated.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('template-updated-modal')}}},[_vm._v("Close")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentManager_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f58c34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentManager_vue__ = __webpack_require__(878);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f58c34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multiselect',{attrs:{"options":_vm.templateNames,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":""},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button mt-2",on:{"click":function($event){return _vm.addDocument()}}},[_vm._v("Add Document")]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"document-added-modal","width":"75%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v("Document added!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('document-added-modal')}}},[_vm._v("Close")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jobs_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f23f9c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jobs_vue__ = __webpack_require__(880);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jobs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f23f9c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jobs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-striped mt-2"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.jobs),function(job){return _c('tr',{key:job.id,staticStyle:{"cursor":"pointer"}},[_c('td',[_vm._v("\n          "+_vm._s(job.title)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(job.poster_name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(job.status)+"\n          ")])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Title")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Client")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobApplications_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268c6f2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobApplications_vue__ = __webpack_require__(882);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobApplications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268c6f2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobApplications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-striped mt-2"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.applications),function(application){return _c('tr',{key:application.id,staticStyle:{"cursor":"pointer"}},[_c('td',[_vm._v("\n          "+_vm._s(application.job_title)+"\n        ")]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(new Date(application.date).toDateString()))])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Job")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Application Date")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0a38aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__ = __webpack_require__(884);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0a38aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userType == 'employer')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showAddUserModal()}}},[_vm._v("Add Client")]):_vm._e(),_vm._v(" "),(_vm.userType == 'candidate')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showAddUserModal()}}},[_vm._v("Add Candidate")]):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"add-user-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5 field-of-fields"},[_c('h2',[_vm._v("Add New User")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticClass:"top-label"},[_vm._v("Email*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),_c('label',{},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('add-user-modal')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.email)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.addUser()}}},[_vm._v("Add")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.isAgent === true)?_c('div',{staticStyle:{"background-color":"#fff","padding-left":"2.5%","padding-right":"2.5%","padding-bottom":"10vh","padding-top":"15vh"}},[_c('div',{staticClass:"vld-parent"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Welcome to "+_vm._s(_vm.$store.getters.agencyHumanName)+" Mission Control")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.agent.id)?_c('div',[(_vm.agent.category == 'global' || _vm.agent.agency == 1)?_c('div',[_c('multiselect',{staticClass:"mb-3",attrs:{"options":_vm.selectorOptions,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":""},model:{value:(_vm.selector),callback:function ($$v) {_vm.selector=$$v},expression:"selector"}})],1):_vm._e(),_vm._v(" "),(_vm.agent.category == 'candidates')?_c('div',[_c('multiselect',{staticClass:"mb-3",attrs:{"options":_vm.selectorOptions2,"multiple":false,"searchable":false,"close-on-select":true,"show-labels":false,"placeholder":""},model:{value:(_vm.selector),callback:function ($$v) {_vm.selector=$$v},expression:"selector"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.selector == 'Snapshot')?_c('div',[(_vm.candidates.length > 0)?_c('div',[_c('h4',{staticClass:"ml-2 mt-2",staticStyle:{"margin-bottom":"0"}},[_vm._v("Nannies")]),_vm._v(" "),_c('status-stats',{key:"candidateSnapshot",attrs:{"users":_vm.candidates,"statuses":_vm.$store.getters.candidateStatuses}}),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),(_vm.employers.length > 0)?_c('div',[_c('h4',{staticClass:"ml-2 mt-2",staticStyle:{"margin-bottom":"0"}},[_vm._v("Clients")]),_vm._v(" "),_c('status-stats',{key:"employerSnapshot",attrs:{"users":_vm.employers,"statuses":_vm.$store.getters.employerStatuses}}),_vm._v(" "),_c('hr')],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.selector == 'Nannies')?_c('div',[(_vm.candidates.length > 0)?_c('div',[_c('status-stats',{key:"candidateStats",attrs:{"users":_vm.candidates,"statuses":_vm.$store.getters.candidateStatuses}}),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),_c('div',[_c('add-user',{attrs:{"userType":'candidate'},on:{"candidateAdded":function($event){return _vm.getCandidates()}}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 mt-2"},[_c('multiselect',{attrs:{"options":_vm.$store.getters.candidateStatuses,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Status"},model:{value:(_vm.statusFilters),callback:function ($$v) {_vm.statusFilters=$$v},expression:"statusFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('multiselect',{attrs:{"options":_vm.$store.getters.positions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Positions"},model:{value:(_vm.positionFilters),callback:function ($$v) {_vm.positionFilters=$$v},expression:"positionFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('div',{staticClass:"form-group form-check pt-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hideRejected),expression:"hideRejected"}],staticClass:"form-check-input",staticStyle:{"margin-top":"4px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.hideRejected)?_vm._i(_vm.hideRejected,true)>-1:(_vm.hideRejected)},on:{"change":function($event){var $$a=_vm.hideRejected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hideRejected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hideRejected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hideRejected=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer","margin-top":"0"},on:{"click":function($event){_vm.hideRejected = !_vm.hideRejected}}},[_vm._v("\n              Hide Rejected Candidates\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.sortAlpha(_vm.candidates)}}},[_vm._v("Sort Alphabetically")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.refresh()}}},[_vm._v("Refresh")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidateSearch),expression:"candidateSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search by Name or Email"},domProps:{"value":(_vm.candidateSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.candidateSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSearch),expression:"languageSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search by Language"},domProps:{"value":(_vm.languageSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.languageSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stateSearch),expression:"stateSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search by State"},domProps:{"value":(_vm.stateSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stateSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('multiselect',{attrs:{"options":_vm.$store.getters.availabilityOptions,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Positions"},model:{value:(_vm.liveinoutFilters),callback:function ($$v) {_vm.liveinoutFilters=$$v},expression:"liveinoutFilters"}})],1)]),_vm._v(" "),_c('table',{staticClass:"table table-striped mt-2 shadow"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCandidates),function(user){return _c('tr',{key:user.id,class:{ 'newEntryRow' : user.status == 'Applied'},staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showCandidateModal(user)}}},[_c('td',[_vm._v("\n              "+_vm._s(user.first_name)+" "+_vm._s(user.last_name)+"\n              ")]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(user.email))])]),_vm._v(" "),_c('td',[(user.multiselect2[0])?_c('p',[_vm._v(_vm._s(user.multiselect2.join(', ')))]):_vm._e()]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(user.selector2))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(user.selector3))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(user.provincestate))])]),_vm._v(" "),_c('td',[(user.created_date)?_c('p',[_vm._v(_vm._s(new Date(user.created_date).toDateString()))]):_vm._e()]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(user.status))])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.selector == 'Clients')?_c('div',[(_vm.employers.length > 0)?_c('div',[_c('status-stats',{key:"employerStats",attrs:{"users":_vm.employers,"statuses":_vm.$store.getters.employerStatuses}}),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),_c('div',[_c('add-user',{attrs:{"userType":'employer'},on:{"employerAdded":function($event){return _vm.getEmployers()}}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 mt-2"},[_c('multiselect',{attrs:{"options":_vm.$store.getters.employerStatuses,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Statuses"},model:{value:(_vm.employerStatusFilters),callback:function ($$v) {_vm.employerStatusFilters=$$v},expression:"employerStatusFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('div',{staticClass:"form-group form-check pt-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hideRejected),expression:"hideRejected"}],staticClass:"form-check-input",staticStyle:{"margin-top":"4px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.hideRejected)?_vm._i(_vm.hideRejected,true)>-1:(_vm.hideRejected)},on:{"change":function($event){var $$a=_vm.hideRejected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hideRejected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hideRejected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hideRejected=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer","margin-top":"0"},on:{"click":function($event){_vm.hideRejected = !_vm.hideRejected}}},[_vm._v("\n              Hide Inactive and Lost Clients\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hideCompleted),expression:"hideCompleted"}],staticClass:"form-check-input",staticStyle:{"margin-top":"4px"},attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.hideCompleted)?_vm._i(_vm.hideCompleted,true)>-1:(_vm.hideCompleted)},on:{"change":function($event){var $$a=_vm.hideCompleted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hideCompleted=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hideCompleted=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hideCompleted=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer","margin-top":"0"},on:{"click":function($event){_vm.hideCompleted = !_vm.hideCompleted}}},[_vm._v("\n              Hide Completed Clients\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"}),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('button',{staticClass:"mylisting-button secondary-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.refresh()}}},[_vm._v("Refresh")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientSearch),expression:"clientSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search by Name or Email"},domProps:{"value":(_vm.clientSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientSearch=$event.target.value}}})])]),_vm._v(" "),(_vm.selector == 'Clients')?_c('table',{staticClass:"table table-striped mt-2"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredEmployers),function(user){return _c('tr',{key:user.id,class:{ 'newEntryRow' : user.status == 'Applied' },staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showEmployerModal(user)}}},[_c('td',[_vm._v("\n              "+_vm._s(user.first_name)+" "+_vm._s(user.last_name)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(user.email)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(user.phone)+"\n            ")]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(user.city))])]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(user.provincestate)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(user.selector1)+"\n            ")]),_vm._v(" "),_c('td',[(user.created_date)?_c('p',[_vm._v(_vm._s(new Date(user.created_date).toDateString()))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(user.status)+"\n              ")])])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.selector == 'Jobs')?_c('div',[_c('job-posting')],1):_vm._e(),_vm._v(" "),(_vm.selector=='Email Templates')?_c('div',[_c('email-templates')],1):_vm._e(),_vm._v(" "),(_vm.selector=='Email Footers')?_c('div',[_c('email-footers')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'Email Log')?_c('div',[_c('email-log')],1):_vm._e(),_vm._v(" "),(_vm.selector=='Document Templates')?_c('div',[_c('document-templates')],1):_vm._e(),_vm._v(" "),(_vm.selector=='Interview Templates')?_c('div',[_c('interview-templates')],1):_vm._e(),_vm._v(" "),(_vm.selector=='Resource Manager')?_c('div',[_c('resource-manager')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'Blog')?_c('div',[_c('app-blog')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'My Profile')?_c('div',[_c('app-candidate-profile')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'My Events')?_c('div',[_c('div',{staticClass:"mt-4 container"},[_c('app-my-events',{attrs:{"userID":_vm.$store.getters.userID}})],1)]):_vm._e(),_vm._v(" "),(_vm.selector == 'All Events')?_c('div',[_c('app-events')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'Administrators')?_c('div',[_c('app-agents')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'Mailing List')?_c('div',[_c('app-mailing-list')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'Master Calendar')?_c('div',[_c('master-calendar')],1):_vm._e(),_vm._v(" "),(_vm.selector == 'Payments')?_c('div',{staticClass:"mt-2"},[(!_vm.agent.stripe_customer_id)?_c('div',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.agent.stripe_customer_id)?_c('div',[_c('h4',{staticClass:"mt-4"},[_vm._v("Your account has been successfully connected with Stripe.")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"candidate-modal","width":"95%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"col dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'admin' },on:{"click":function($event){_vm.tab = 'admin'}}},[_vm._v("\n            Admin\n          ")]),_vm._v(" "),_c('div',{staticClass:"col dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'profile' },on:{"click":function($event){_vm.tab = 'profile'}}},[_vm._v("\n            Profile\n          ")]),_vm._v(" "),_c('div',{staticClass:"col dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'interview' },on:{"click":function($event){_vm.tab = 'interview'}}},[_vm._v("\n            Interview\n          ")]),_vm._v(" "),_c('div',{staticClass:"col dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'emails' },on:{"click":function($event){_vm.tab = 'emails'}}},[_vm._v("\n            Email Log\n          ")])]),_vm._v(" "),(_vm.tab == 'admin' && _vm.user.id)?_c('div',[_c('panel',{attrs:{"passedUser":_vm.user},on:{"userUpdated":function($event){return _vm.userUpdated()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('document-manager',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'schedule' && _vm.user.id)?_c('div',[_c('scheduler',{attrs:{"passedUser":_vm.user,"employers":_vm.employerEmails},on:{"userUpdated":function($event){return _vm.userUpdated()}}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'profile')?_c('div',{staticStyle:{"margin-top":"-80px","margin-bottom":"-17.5vh"}},[_c('candidate-dashboard',{attrs:{"userID":_vm.user.id}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'interview' && _vm.user.id)?_c('div',[_c('candidate-interview',{attrs:{"userID":_vm.user.id},on:{"userUpdated":function($event){return _vm.userUpdated()}}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'jobs' && _vm.user.id)?_c('div',[_c('job-applications',{attrs:{"user":_vm.user},on:{"userUpdated":function($event){return _vm.userUpdated()}}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'emails' && _vm.user.id)?_c('div',[_c('email-log',{attrs:{"recipient":_vm.user}})],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideUserModal()}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.showDeleteUserModal(_vm.user)}}},[_vm._v("Delete User")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"employer-modal","width":"95%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"col-lg-2 col-md-2 dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'admin' },on:{"click":function($event){_vm.tab = 'admin'}}},[_vm._v("\n            Admin\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'application' },on:{"click":function($event){_vm.tab = 'application'}}},[_vm._v("\n            Profile\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'documents' },on:{"click":function($event){_vm.tab = 'documents'}}},[_vm._v("\n            Documents\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'job' },on:{"click":function($event){_vm.tab = 'job'}}},[_vm._v("\n            Jobs\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'profile' },on:{"click":function($event){_vm.tab = 'profile'}}},[_vm._v("\n            Intake Notes\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 dashboard-button",class:{ 'dashboard-button-active': _vm.tab == 'emails' },on:{"click":function($event){_vm.tab = 'emails'}}},[_vm._v("\n            Email Log\n          ")])]),_vm._v(" "),(_vm.tab == 'admin' && _vm.user.id)?_c('div',[_c('panel',{attrs:{"passedUser":_vm.user},on:{"userUpdated":function($event){return _vm.userUpdated()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('document-manager',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('candidate-employer-relationship-manager',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'application' && _vm.user.id)?_c('div',[_c('div',{staticStyle:{"margin-top":"-80px","margin-bottom":"-17.5vh"}},[_c('app-employer-dashboard',{attrs:{"employerID":_vm.user.id}})],1)]):_vm._e(),_vm._v(" "),(_vm.tab == 'scheduling' && _vm.user.id)?_c('div',[_c('employer-week-scheduler',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'job' && _vm.user.id)?_c('div',[_c('job-posting',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'documents' && _vm.user.id)?_c('div',[_c('employer-documents',{attrs:{"user":_vm.user}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'profile' && _vm.user.id)?_c('div',[_c('internal-profile',{attrs:{"user":_vm.user,"userID":_vm.user.id}})],1):_vm._e(),_vm._v(" "),(_vm.tab == 'emails' && _vm.user.id)?_c('div',[_c('email-log',{attrs:{"recipient":_vm.user}})],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.$modal.hide('employer-modal')}}},[_vm._v("Close")]),_vm._v(" "),_c('p',{staticClass:"mt-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showDeleteUserModal(_vm.user)}}},[_vm._v("Delete Client")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"delete-user-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Are you sure you want to delete this user?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.user.email))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideDeleteUserModal()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.deleteUser(_vm.user)}}},[_vm._v("Delete")])])]),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"email-modal","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_vm._v("\n        Mailing List: "+_vm._s(_vm.mailingList.join(', '))+"\n        "),_c('hr'),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0"}},[_vm._v("From Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromEmail),expression:"fromEmail"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":"From Email"},domProps:{"value":(_vm.fromEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fromEmail=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailSubject),expression:"emailSubject"}],staticClass:"form-control mb-2",attrs:{"type":"text","placeholder":"Subject"},domProps:{"value":(_vm.emailSubject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailSubject=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailMessage),expression:"emailMessage"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.emailMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailMessage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"form-group form-check mb-1 mt-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logMessage),expression:"logMessage"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":true,"checked":Array.isArray(_vm.logMessage)?_vm._i(_vm.logMessage,true)>-1:(_vm.logMessage)},on:{"change":function($event){var $$a=_vm.logMessage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.logMessage=$$a.concat([$$v]))}else{$$i>-1&&(_vm.logMessage=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.logMessage=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"text-align":"left","cursor":"pointer"},on:{"click":function($event){_vm.logMessage = !_vm.logMessage}}},[_vm._v("\n            Log email as note\n          ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.sendEmail()}}},[_vm._v("Send")])])])],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',{},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Positions Applied")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Languages")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Live In/Out")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("State")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Applied")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Phone")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("City")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("State")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Service Type")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Entered")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://connect.stripe.com/oauth/authorize?response_type=code&redirect_uri=https://tinytreasuresnyc.enginehire.io/stripe-connect-confirmation&client_id=ca_GSLnGgAImYEcEPhXudAbksZuhK7R6e39&scope=read_write&state=300387032","target":"_blank"}},[_c('img',{staticClass:"mt-2",attrs:{"src":__webpack_require__(886),"alt":"Stripe","width":"200px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "light-on-light@2x.png?16b7b8956eac042da4cdfd41c718f470";

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripeConnectConfirmation_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e3c04da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripeConnectConfirmation_vue__ = __webpack_require__(888);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripeConnectConfirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e3c04da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripeConnectConfirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[(_vm.stripeResponse.message='Stripe connection successfullly completed!')?_c('h4',[_vm._v("Your account has been successfully connected with Stripe.")]):_vm._e(),_vm._v(" "),(_vm.failedToConnect)?_c('h4',[_vm._v("There was a problem connecting your account with Stripe, please try again or contact Enginehire.")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"25px"}},[_c('router-link',{staticClass:"mylisting-button dark-button",attrs:{"to":{ name: 'Agent Dashboard' }}},[_vm._v("Return to Dashboard")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationBoard_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae5e9cb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationBoard_vue__ = __webpack_require__(892);
function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae5e9cb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4029b530", content, true, {});

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".filter-label{font-weight:700}", ""]);

// exports


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('h1',{ref:"pageTitle"},[_vm._v("Organizations")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 mt-2"},[_c('label',{staticClass:"filter-label"},[_vm._v("Organization Types")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.organizationTypes,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Organization Types"},model:{value:(_vm.organizationTypeFilters),callback:function ($$v) {_vm.organizationTypeFilters=$$v},expression:"organizationTypeFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('label',{staticClass:"filter-label"},[_vm._v("Organization Sizes")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.sizes,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Organization Sizes"},model:{value:(_vm.sizeFilters),callback:function ($$v) {_vm.sizeFilters=$$v},expression:"sizeFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('label',{staticClass:"filter-label"},[_vm._v("Topic Areas")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.focusAreas,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Focus Areas"},model:{value:(_vm.focusAreaFilters),callback:function ($$v) {_vm.focusAreaFilters=$$v},expression:"focusAreaFilters"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 mt-2"},[_c('label',{staticClass:"filter-label"},[_vm._v("Country")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.countries,"multiple":true,"searchable":true,"close-on-select":false,"show-labels":false,"placeholder":"Filter by Countries"},model:{value:(_vm.countryFilters),callback:function ($$v) {_vm.countryFilters=$$v},expression:"countryFilters"}})],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('div',{staticClass:"row",staticStyle:{"margin-left":"auto","margin-right":"auto","text-align":"center","text-decoration":"none"}},_vm._l((_vm.filteredUsers),function(user){return _c('div',{key:user.id,staticClass:"col-lg-3 mb-4"},[_c('div',{staticClass:"p-4",staticStyle:{"border":"solid 1px var(--thrivehiregrey)","border-radius":"3px","height":"100%"}},[_c('router-link',{staticStyle:{"color":"var(--coredarkcolor)"},attrs:{"to":{ name: 'Employer Public Profile', params: { id: user.id } },"target":"_blank"}},[_c('div',{staticStyle:{"height":"150px"}},[_c('img',{staticStyle:{"max-height":"150px","max-width":"150px"},attrs:{"src":user.profile_pic,"height":"","alt":""}})]),_vm._v(" "),_c('h5',{staticClass:"mt-4",staticStyle:{"font-weight":"700"}},[_vm._v(_vm._s(user.employer_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(user.city)),(user.city)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(user.country))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(user.organization_type)),(user.organization_type && user.size)?_c('span',[_vm._v(" (")]):_vm._e(),_vm._v(_vm._s(user.size)),(user.organization_type && user.size)?_c('span',[_vm._v(")")]):_vm._e()]),_vm._v(" "),(user.sectors[0])?_c('hr'):_vm._e(),_vm._v(" "),_vm._l((user.sectors),function(sector,index){return _c('p',{key:'ShowSectors'+index},[_vm._v(_vm._s(sector))])})],2)],1)])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03fc4091_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__(897);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03fc4091_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(895);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8163d374", content, true, {});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".blog .ProseMirror{min-height:250px}", ""]);

// exports


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-of-fields"},[(!_vm.blogSuccessfullyPosted)?_c('form',[_c('label',[_vm._v("Title*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Hero Image")]),_vm._v(" "),_c('input',{ref:"hero",staticClass:"form-control-file",attrs:{"type":"file","id":"hero"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('div',{staticClass:"editor blog mt-3"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.contentEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n            H1\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n            H2\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n            H3\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n            List\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n            1. 2. 3...\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n            ---\n          ")])])]}}],null,false,1679781704)}),_vm._v(" "),_c('editor-menu-bubble',{staticClass:"menububble mb-1",attrs:{"editor":_vm.contentEditor},on:{"hide":_vm.hideLinkMenu},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
var getMarkAttrs = ref.getMarkAttrs;
var menu = ref.menu;
return [_c('div',{staticClass:"menububble",class:{ 'is-active': menu.isActive },style:(("left: " + (menu.left) + "px; bottom: " + (menu.bottom) + "px;"))},[(_vm.linkMenuIsActive)?_c('form',{staticClass:"menububble__form",on:{"submit":function($event){$event.preventDefault();return _vm.setLinkUrl(commands.link, _vm.linkUrl)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.linkUrl),expression:"linkUrl"}],ref:"linkInput",staticClass:"menububble__input",attrs:{"type":"text","placeholder":"https://"},domProps:{"value":(_vm.linkUrl)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.hideLinkMenu($event)},"input":function($event){if($event.target.composing){ return; }_vm.linkUrl=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",attrs:{"type":"button"},on:{"click":function($event){return _vm.setLinkUrl(commands.link, null)}}},[_c('p',[_vm._v("remove")])])]):[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.link() },on:{"click":function($event){_vm.showLinkMenu(getMarkAttrs('link'))}}},[_c('span',[_vm._v(_vm._s(isActive.link() ? 'Update Link' : 'Add Link'))])])]],2)]}}],null,false,3370125440)}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.contentEditor}})],1),_vm._v(" "),_c('label',[_vm._v("Post Categories")]),_vm._v(" "),_vm._l((_vm.categoryOptions),function(category,index){return _c('div',{key:'SelectCategories'+index,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.categories),expression:"categories"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":category,"checked":Array.isArray(_vm.categories)?_vm._i(_vm.categories,category)>-1:(_vm.categories)},on:{"change":function($event){var $$a=_vm.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=category,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.categories=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v("\n          "+_vm._s(category)+"\n        ")])])}),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.postID)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){$event.preventDefault();return _vm.createPost()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.postID)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){$event.preventDefault();return _vm.updatePost()}}},[_vm._v("Update")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.blogSuccessfullyPosted)?_c('div',[_c('h2',[_vm._v("Thank you for contributing to our blog!")]),_vm._v(" "),_c('h4',{staticClass:"mb-4"},[_vm._v("Our team will review it and get back to you shortly when it is published.")]),_vm._v(" "),_c('router-link',{staticClass:"mylisting-button dark-button mt-5",attrs:{"to":{ name: 'Blog' }}},[_vm._v("Blog")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[(!_vm.contributing)?_c('div',[_c('h1',{ref:"pageTitle"},[_vm._v("Blog")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"filter-label"},[_vm._v("Category")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryFilter),expression:"categoryFilter"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.categories),function(category,index){return _c('option',{key:'category'+index},[_vm._v(_vm._s(category))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticStyle:{"height":"65px"}},[(_vm.$store.getters.userID)?_c('router-link',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right","text-align":"center"},attrs:{"to":{ name: 'New Blog Post' }}},[_vm._v("Contribute")]):_vm._e(),_vm._v(" "),(!_vm.$store.getters.userID)?_c('router-link',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right","text-align":"center"},attrs:{"to":{ name: 'Login' }}},[_vm._v("Contribute")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"float":"right"},attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.showWhyContributeModal()}}},[_vm._v("Why should I contribue?")])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.blogPosts),function(blogPost){return _c('div',{key:blogPost.id,staticClass:"col-md-6 mt-4"},[_c('router-link',{staticStyle:{"color":"var(--coredarkcolor)"},attrs:{"to":{ name: 'Blog Post', params: { id: blogPost.id } },"target":"_blank"}},[_c('div',{staticClass:"p-4",staticStyle:{"border":"1px solid var(--bootstrapgrey)"}},[_c('img',{staticStyle:{"background-size":"cover"},attrs:{"src":blogPost.hero_image,"alt":"","width":"100%","height":""}}),_vm._v(" "),_c('h3',{staticClass:"mt-3"},[_vm._v(_vm._s(blogPost.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date(blogPost.created_date).toDateString()))]),_vm._v(" "),_c('hr')])])],1)}),0),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"why-contribute-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h3',[_vm._v("Want to author an article?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("You can publish an article as a one-time guest writer, or more frequently as an official content contributor (content contributors are featured on our "),_c('router-link',{attrs:{"to":{ name: 'Team' }}},[_vm._v("website")]),_vm._v("!).")],1),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("As an author, you will get to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Put your name on the radar of various Global Health professionals")]),_vm._v(" "),_c('li',[_vm._v("Gain visibility in a global audience ")]),_vm._v(" "),_c('li',[_vm._v("Build your credibility by adding published content in an area you’re passionate about")]),_vm._v(" "),_c('li',[_vm._v("Have your post shared widely through our website, newsletter and social media channels")])]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Interested? Submit a piece and our team will review it and get back to you, or contact us at info@thrivehire.org.")])])])],1):_vm._e(),_vm._v(" "),(_vm.contributing)?_c('div',[_c('h1',[_vm._v("New Blog Post")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-blog-post-form')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewBlogPost_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba5cf3f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewBlogPost_vue__ = __webpack_require__(899);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewBlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba5cf3f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewBlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('h1',[_vm._v("New Blog Post")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-blog-post-form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBlogPost_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5834d9ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBlogPost_vue__ = __webpack_require__(901);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5834d9ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('h1',[_vm._v("Edit Blog Post")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-blog-post-form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBoard_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_709d81c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventBoard_vue__ = __webpack_require__(903);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_709d81c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('h1',{ref:"pageTitle"},[_vm._v("Events")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"30px","margin-top":"20px"}},[(!_vm.$store.getters.isAuthenticated)?_c('router-link',{staticClass:"mylisting-button dark-button",staticStyle:{"text-align":"center"},attrs:{"to":{ name: 'Employer Registration' }}},[_vm._v("Post an Event")]):_vm._e()],1),_vm._v(" "),(_vm.listings.length > 0)?_c('div',[_c('app-list',{attrs:{"listings":_vm.listings}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771a2b46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(905);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771a2b46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-of-fields container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[(_vm.listing.id)?_c('div',[_c('div',{staticClass:"row pr-3"},[_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"row"},[(_vm.employer.profile_pic)?_c('div',{staticClass:"col-lg-4",staticStyle:{"max-width":"175px"}},[(_vm.employer.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg')?_c('div',[_c('router-link',{attrs:{"to":{ name: 'Employer Public Profile', params: { id: _vm.employer.id } }}},[_c('img',{staticStyle:{"max-height":"150px","max-width":"150px"},attrs:{"src":_vm.employer.profile_pic}})])],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 my-auto"},[_c('h2',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.listing.title)),(_vm.listing.event_type)?_c('span',[_vm._v(" ("+_vm._s(_vm.listing.event_type)+")")]):_vm._e()]),_vm._v(" "),(_vm.employer.employer_name)?_c('h4',{staticClass:"mt-2"},[_c('router-link',{attrs:{"to":{ name: 'Employer Public Profile', params: { id: _vm.employer.id } }}},[_vm._v(_vm._s(_vm.employer.employer_name))])],1):_vm._e()])]),_vm._v(" "),(_vm.listing.description)?_c('label',{staticClass:"shaded-label"},[_vm._v("Description")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"profile-section"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.listing.description)}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 p-4",staticStyle:{"background-color":"var(--bootstrapgrey)"}},[(_vm.listing.id)?_c('div',[(_vm.listing.categories[0])?_c('label',{staticStyle:{"margin-top":"0"}},[_vm._v("Focus Areas:")]):_vm._e(),_vm._v(" "),(_vm.listing.categories[0])?_c('p',[_vm._v(_vm._s(_vm.listing.categories.join(', ')))]):_vm._e(),_vm._v(" "),(_vm.listing.date)?_c('label',[_vm._v("Date")]):_vm._e(),_vm._v(" "),(_vm.listing.date)?_c('p',[_vm._v(_vm._s(new Date(_vm.listing.date.concat('T00:00:00')).toDateString())),(_vm.listing.end_date)?_c('span',[_vm._v(" - "+_vm._s(new Date(_vm.listing.end_date.concat('T00:00:00')).toDateString()))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('p',[(_vm.listing.start_time)?_c('span',[_vm._v(_vm._s(_vm._f("trimSeconds")(_vm.listing.start_time)))]):_vm._e(),(_vm.listing.end_time)?_c('span',[_vm._v(" - "+_vm._s(_vm._f("trimSeconds")(_vm.listing.end_time)))]):_vm._e()]),_vm._v(" "),(_vm.listing.fee)?_c('label',[_vm._v("Fee")]):_vm._e(),_vm._v(" "),(_vm.listing.fee)?_c('p',[_vm._v(_vm._s(_vm.listing.fee))]):_vm._e(),_vm._v(" "),(_vm.listing.categories[0] || _vm.listing.fee || _vm.listing.date || _vm.listing.start_time)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.listing.city)?_c('p',[_vm._v(_vm._s(_vm.listing.city))]):_vm._e(),_vm._v(" "),(_vm.listing.country)?_c('h4',[_vm._v(_vm._s(_vm.listing.country))]):_vm._e(),_vm._v(" "),_c('div',[(_vm.listing.address1)?_c('small',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.listing.address1))]):_vm._e(),_vm._v(" "),(_vm.listing.address2)?_c('small',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.listing.address2))]):_vm._e(),_vm._v(" "),(_vm.listing.postal_code)?_c('small',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.listing.postal_code))]):_vm._e()]),_vm._v(" "),(_vm.listing.city)?_c('app-map',{staticClass:"mt-2",attrs:{"locationObject":_vm.listing}}):_vm._e(),_vm._v(" "),(_vm.listing.city)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.listing.link)?_c('div',{staticClass:"mt-4 mb-3"},[_c('a',{staticClass:"mylisting-button dark-button",attrs:{"href":_vm.listing.link,"target":"_blank"}},[_vm._v("EVENT PAGE")])]):_vm._e()],1):_vm._e()])]),_vm._v(" "),((_vm.loggedinUser == _vm.employer.id) || _vm.$store.getters.isAgent == 'true')?_c('div',[_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.deleteListing()}}},[_vm._v("DELETE")])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.listing.id && !_vm.timeToLoad)?_c('div',[_c('h2',[_vm._v("Loading event...")])]):_vm._e(),_vm._v(" "),(!_vm.listing.id && _vm.timeToLoad)?_c('div',[_c('h2',[_vm._v("Sorry, event not found.")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff1f787_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(909);
function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff1f787_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(908);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2d3e9343", content, true, {});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[_c('h1',{staticClass:"dashboard-heading"},[_vm._v("About Us")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("What is ThriveHire?")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("The Challenge")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Our world is facing multiple health challenges — outbreaks of vaccine-preventable diseases like measles, water scarcity, air pollution, and inequitable access to health services represent only a few. ")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("In 2018, 820 million people did not have enough food to eat everyday. Today, antibiotic resistance is on the rise. By 2020, there will be more plastic in the oceans than fish by weight.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("In today’s world, health is no longer confined to national boundaries. And Global Health organizations looking to fight these grand challenges are faced with a difficult obstacle everyday — a need to raise awareness of their work so they can attract and hire the right health policymakers, economists, doctors, nurses, researchers, and public health professionals.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("This is where ThriveHire comes into play. We are a dedicated online platform for organizations focused on finding qualified people to join their teams, and ThriveHire connects job seekers and volunteers with these game-changing organizations.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Our Work")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("When we began this work in 2017, we did it because we realized there was a lack of places to find Global Health organizations, opportunities and career advice. Many organizations and individuals are tackling big issues in Global Health. But we figured it shouldn’t be so difficult for these groups to connect so they can continue creating impactful and sustainable change.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We saw the gap and decided to spark conversations and bring different people in Global Health together.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire is a curated job board presenting carefully selected opportunities to connect people to good work.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire is a directory of organizations and events where people can discover and connect around the biggest health challenges. ")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire is a source of helpful stories filled with practical knowledge to educate and inspire.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("In other words, ThriveHire is not your typical job board. For everyone striving to make an impact, ThriveHire is your platform to share your opinions, work, struggles, and advice. It is your platform to gain knowledge, learn from others, push the boundaries of innovation, and grow your career. ")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Our Goal is to Curate, Inspire & Connect")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We believe that people wanting to address the world’s greatest health challenges should be able to do so. In other words, we believe Global Health professionals should not lose out on opportunities or get discouraged due to a lack of infrastructure in this industry. ")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We believe in you. We want to help you find that perfect opportunity where you’re not only helping to solve the world’s most pressing needs, but you’re also investing in your professional growth. ")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We believe that organizations tackling pressing health issues should also not struggle to find qualified workers who have the right set of experiences, technical and soft skills required to do this work.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("That’s why we’ve curated a collection of carefully selected jobs, events, organizations and candidates. In doing so, we’re growing a community of driven employers and job seekers who are looking to make big differences in areas requiring all of our attention.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Since our launch in late 2018, we have steadily built up a global community of dozens of organizations and thousands of individuals. ")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Join us today. Sign up to "),_c('router-link',{attrs:{"to":{ name: 'Candidate Registration' }}},[_vm._v("join our community")]),_vm._v(", subscribe to our newsletter, and check out our resources to get connected to the latest opportunities and candidates!")],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f552f9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__(911);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f552f9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[_c('h1',{ref:"pageTitle",staticClass:"dashboard-heading"},[_vm._v("Our Team")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.team),function(teammember){return _c('div',{key:teammember.id},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4",staticStyle:{"max-width":"175px"}},[(teammember.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg')?_c('div',[_c('img',{staticStyle:{"max-height":"150px","max-width":"150px"},attrs:{"src":teammember.profile_pic}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 my-auto"},[_c('h2',{staticClass:"mt-2"},[_vm._v(_vm._s(teammember.first_name)+" "+_vm._s(teammember.last_name))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(teammember.title))]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[(teammember.website)?_c('a',{attrs:{"href":teammember.website,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(137),"alt":"website"}})]):_vm._e(),_vm._v(" "),(teammember.facebook)?_c('a',{attrs:{"href":teammember.facebook,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(138),"alt":"facebook"}})]):_vm._e(),_vm._v(" "),(teammember.instagram)?_c('a',{attrs:{"href":teammember.instagram,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(139),"alt":"instagram"}})]):_vm._e(),_vm._v(" "),(teammember.twitter)?_c('a',{attrs:{"href":teammember.twitter,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(140),"alt":"twitter"}})]):_vm._e(),_vm._v(" "),(teammember.linkedin)?_c('a',{attrs:{"href":teammember.linkedin,"target":"_blank"}},[_c('img',{staticClass:"social-icon",attrs:{"src":__webpack_require__(141),"alt":"linkedin"}})]):_vm._e()])])]),_vm._v(" "),_c('pre',{staticClass:"mt-3",domProps:{"innerHTML":_vm._s(teammember.about_us)}}),_vm._v(" "),(_vm.$store.getters.isAgent == 'true')?_c('button',{staticClass:"mylisting-button dark-button mt-3",staticStyle:{"display":"block"},on:{"click":function($event){return _vm.showEditModal(teammember)}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),_c('hr')])})],2),_vm._v(" "),_c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"edit-modal","width":"90%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('label',[_vm._v("Profile Picture")]),_vm._v(" "),(_vm.teammember.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg')?_c('div',{staticClass:"mb-1"},[_c('img',{staticStyle:{"max-height":"150px"},attrs:{"src":_vm.teammember.profile_pic}})]):_vm._e(),_vm._v(" "),_c('input',{ref:"profile_pic",staticClass:"form-control-file",attrs:{"type":"file","id":"profile_pic"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('div',{staticClass:"profile"},[_c('label',[_vm._v("Order")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.order),expression:"order"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.order)},on:{"input":function($event){if($event.target.composing){ return; }_vm.order=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.facebook),expression:"facebook"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.facebook=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Instagram")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.instagram),expression:"instagram"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.instagram)},on:{"input":function($event){if($event.target.composing){ return; }_vm.instagram=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Twitter")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twitter),expression:"twitter"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.twitter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twitter=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("LinkedIn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.linkedin),expression:"linkedin"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.linkedin=$event.target.value}}})]),_vm._v(" "),_c('label',{staticClass:"mt-3"},[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.summaryEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n              H1\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n              H2\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n              H3\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n              List\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n              1. 2. 3...\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n              ---\n            ")])])]}}])}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.summaryEditor}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.updateTeamMember()}}},[_vm._v("Save")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_What_vue__ = __webpack_require__(342);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de3a710a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_What_vue__ = __webpack_require__(916);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_What_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de3a710a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_What_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(914);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("07955c2e", content, true, {});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".modal[data-v-8446feac]{display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,.5)}.modal-content[data-v-8446feac]{width:90%;background-color:#fff;padding:30px;border-radius:8px}.modal-footer[data-v-8446feac]{margin-top:10px}label[data-v-8446feac]{display:block;margin:.25em 0}button[data-v-8446feac]{font-family:inherit;font-size:100%;padding:.5em 1em;color:#fff;text-shadow:0 1px 1px rgba(0,0,0,.2);border:1px solid #999;border:transparent;background-color:#e6e6e6;text-decoration:none;border-radius:2px;cursor:pointer}button.danger[data-v-8446feac]{background:#ca3c3c}button.success[data-v-8446feac]{background:#1cb841}button[data-v-8446feac]:disabled{opacity:.3}button+button[data-v-8446feac]{margin-left:10px}.tab-header[data-v-8446feac]{display:flex;align-items:center;border-bottom:1px solid #222}.tab-header button[data-v-8446feac]{color:#222;background:none;border:0;flex:1;padding:5px 10px;cursor:pointer}.tab-header button.active[data-v-8446feac]{background-color:#222;color:#fff}", ""]);

// exports


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('h1',[_vm._v("Add image")]),_vm._v(" "),_c('header',{staticClass:"tab-header"}),_vm._v(" "),(_vm.tab == 1)?_c('div',[_c('p',[_vm._v("Here is a test image URL")]),_vm._v(" "),_c('pre',[_vm._v("https://i.imgur.com/0ogkTp7.jpg")]),_vm._v(" "),_c('label',{attrs:{"for":"url"}},[_vm._v("Image URL:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.imageSrc),expression:"imageSrc"}],attrs:{"id":"url"},domProps:{"value":(_vm.imageSrc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.imageSrc=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.tab == 2)?_c('div',[_c('input',{ref:"file",staticClass:"mt-3",attrs:{"type":"file","id":"up"},on:{"change":_vm.fileChange}})]):_vm._e(),_vm._v(" "),(_vm.tab == 0)?_c('div'):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"modal-footer"},[_c('button',{staticClass:"mylisting-button success",attrs:{"title":_vm.validImage ? '' : 'Image URL needs to be valid',"disabled":!_vm.validImage},on:{"click":function($event){$event.preventDefault();return _vm.insertImage($event)}}},[_vm._v("\n        Add Image\n      ")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger",on:{"click":function($event){$event.preventDefault();_vm.show = false;}}},[_vm._v("Cancel")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[_c('h1',{ref:"pageTitle",staticClass:"dashboard-heading"},[_vm._v("What is Global Health?")]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.editing)?_c('div',[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.content.content)}}),_vm._v(" "),(_vm.user.is_agent)?_c('div',[_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button"},[_vm._v("Edit")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('div',[_c('div',[_c('div',{staticClass:"editor"},[_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.contentEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n                H1\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n                H2\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n                H3\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n                List\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n                1. 2. 3...\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n                ---\n              ")])])]}}],null,false,3653883464)}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.contentEditor}})],1)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b36174e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__(918);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b36174e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[_c('h1',{ref:"pageTitle",staticClass:"dashboard-heading"},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Effective date: October 15, 2018")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire (“us”, “we”, or “our”) operates the www.thrivehire.org website (hereinafter referred to as the “Service”).")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We use your data to provide and improve your experience on the website. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from www.thrivehire.org.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Definitions")]),_vm._v(" "),_c('strong',{staticClass:"informational-text-block"},[_vm._v("Service")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Service is the www.thrivehire.org website operated by ThriveHire")]),_vm._v(" "),_c('strong',{staticClass:"informational-text-block"},[_vm._v("Personal Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Personal Data means data about a living individual or organization who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).")]),_vm._v(" "),_c('strong',{staticClass:"informational-text-block"},[_vm._v("Usage Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).")]),_vm._v(" "),_c('strong',{staticClass:"informational-text-block"},[_vm._v("Cookies")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Cookies are small text files stored on your device (computer or mobile device) that can be used by websites to make a user’s experience more efficient by collecting anonymous unique identifier data.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Information Collection and Use")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We collect several different types of information for various purposes to provide and improve our Service to you.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Types of Data Collected")]),_vm._v(" "),_c('h4',{staticClass:"informational-subheading"},[_vm._v("Personal Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to:")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We may collect personal information when you:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"informational-subheading"},[_vm._v("Usage Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We may also collect information how the Service is accessed and used (“Usage Data”). This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.")]),_vm._v(" "),_c('h4',{staticClass:"informational-subheading"},[_vm._v("Tracking Cookies Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Cookies are small text files that can be used by websites to make a user’s experience more efficient by collecting anonymous unique identifier data like session information and user preference. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as tags to collect and track information and to improve and analyze our Service.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("This website uses cookies. We use cookies to personalize content, to provide social media features and to analyze our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("You can at any time change or withdraw your consent from the Cookie Declaration on our website.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Use of Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire uses the collected data for various purposes:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Transfer Of Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Your information, including Personal Data, may be located or maintained in servers or computers located outside of your province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("If you are located outside Canada and choose to provide information to us, please note that we transfer the data, including Personal Data, to Canada and process it there.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Disclosure Of Data")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Legal Requirements")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire will never disclose your Personal Data without your consent except for the circumstances mentioned below:")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Security of Data")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Service Providers")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We may employ third party companies and individuals to facilitate our Service (“Service Providers”), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Analytics")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We may use third-party Service Providers to monitor and analyze the use of our Service.")]),_vm._v(" "),_c('strong',{staticClass:"informational-text-block"},[_vm._v("Google Analytics")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Google Analytics is a web analytics service. You can visit their Privacy Policy page here: https://policies.google.com/technologies/partner-sites")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Links to Other Sites")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Changes to This Privacy Policy")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire reserves the right to change this policy and our Terms of Service at any time.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We will let you know of significant changes to our Privacy Policy by sending a notice to the primary email address specified in your email registration, prior to the change becoming effective and update the “effective date” at the top of this Privacy Policy. Non-material changes or clarifications will however take effect immediately.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.")]),_vm._v(" "),_c('h2',{staticClass:"informational-heading"},[_vm._v("Contact Us")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("If you have any questions about this Privacy Policy, please contact us:")]),_vm._v(" "),_vm._m(4)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"informational-list"},[_c('li',[_vm._v("Email address")]),_vm._v(" "),_c('li',[_vm._v("First name and last name")]),_vm._v(" "),_c('li',[_vm._v("Whether you are a job seeker or employer")]),_vm._v(" "),_c('li',[_vm._v("Other information")]),_vm._v(" "),_c('li',[_vm._v("Cookies and Usage Data")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"informational-list"},[_c('li',[_vm._v("Fill out one of our surveys;")]),_vm._v(" "),_c('li',[_vm._v("Sign-up to receive promotional communications; or")]),_vm._v(" "),_c('li',[_vm._v("Contact us with a comment, question or complaint.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"informational-list"},[_c('li',[_vm._v("To provide and maintain the Service")]),_vm._v(" "),_c('li',[_vm._v("To notify you about changes to our Service")]),_vm._v(" "),_c('li',[_vm._v("To allow you to participate in interactive features of our Service when you choose to do so")]),_vm._v(" "),_c('li',[_vm._v("To provide customer care and support")]),_vm._v(" "),_c('li',[_vm._v("To provide analysis or valuable information so that we can improve the Service")]),_vm._v(" "),_c('li',[_vm._v("To monitor the usage of the Service")]),_vm._v(" "),_c('li',[_vm._v("To detect, prevent and address technical issues")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"informational-list"},[_c('li',[_vm._v("To comply with a legal obligation")]),_vm._v(" "),_c('li',[_vm._v("To protect and defend the rights or property of ThriveHire")]),_vm._v(" "),_c('li',[_vm._v("To prevent or investigate possible wrongdoing in connection with the Service")]),_vm._v(" "),_c('li',[_vm._v("To protect the personal safety of users of the Service or the public")]),_vm._v(" "),_c('li',[_vm._v("To protect against legal liability")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"informational-list"},[_c('li',[_vm._v("By email: info@thrivehire.org")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b52510_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b52510_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[_c('h1',{ref:"pageTitle",staticClass:"dashboard-heading"},[_vm._v("Terms & Conditions (\"Terms\")")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Last updated: October 15, 2018")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Please read these Terms and Conditions (“Terms”, “Terms and Conditions”) carefully before using the www.thrivehire.org website (the “Service”) operated by ThriveHire (“us”, “we”, or “our”).")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Links To Other Websites")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Our Service may contain links to third-party websites or services that are not owned or controlled by ThriveHire.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("ThriveHire has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party websites or services. You further acknowledge and agree that ThriveHire shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such websites or services.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We advise that you you read the terms and conditions and privacy policies of any third-party websites or services that you visit.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Governing Law")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("These Terms shall be governed and construed in accordance with the laws of Ontario, Canada, without regard to its conflict of law provisions.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Changes")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Disclaimer")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("We take all reasonable steps to ensure that the information posted on our website is correct. However, we do not guarantee the correctness or completeness of material on this website. We may make changes to the material on this website at any time and without notice. The material on this website may be out of date or, on rare occasions, incorrect, and we make no commitment to ensure that such material is correct or up to date.")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("The material on this website is provided without any conditions or warranties of any kind. To the maximum extent permitted by law, we provide access and use of this website on the basis that we exclude all representations, warranties and conditions, which but for these Terms may have effect in relation to this website.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Liability")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("Neither we nor any other party (whether or not involved in producing, maintaining or delivering this website), shall be liable or responsible for any kind of loss or damage that may result to you or a third party as a result of your or their use of our website. This exclusion shall include servicing or repair costs and, without limitation, any other direct, indirect or consequential loss, and whether in tort or contract or otherwise in connection with this website.")]),_vm._v(" "),_c('h3',{staticClass:"informational-subheading"},[_vm._v("Contact Us")]),_vm._v(" "),_c('p',{staticClass:"informational-text-block"},[_vm._v("If you have any questions about these Terms, please contact us or email us at info@thrivehire.org.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9915fa38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(922);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9915fa38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[_c('h1',{ref:"pageTitle"},[_vm._v("Contact Us")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',{},[_vm._v("Comment? Question? Would you like to explore ways to work together? We'd love to hear from you!")]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.organization),expression:"organization"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Organization (if applicable)"},domProps:{"value":(_vm.organization)},on:{"input":function($event){if($event.target.composing){ return; }_vm.organization=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"form-control mt-2",attrs:{"rows":"6","placeholder":"Message"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.submitMessage()}}},[_vm._v("Submit")]),_vm._v(" "),(_vm.submitted)?_c('h4',{staticClass:"mt-3"},[_vm._v("Thank you for your message! Someone from the ThriveHire team will be in touch with you shortly.")]):_vm._e()]),_vm._v(" "),_c('h4',{staticClass:"mt-5"},[_vm._v("Come Visit Us!")]),_vm._v(" "),_c('p',[_vm._v("KHS45-40 Gould Street")]),_vm._v(" "),_c('p',[_vm._v("Toronto, ON")]),_vm._v(" "),_c('p',[_vm._v("M5B1E9")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056a2fe4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__(927);
function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056a2fe4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(925);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9c1a8534", content, true, {});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ProseMirror{height:4000px}", ""]);

// exports


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiptap_extensions__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @ts-ignore

// const tiptapExtensions = require('tiptap-extensions')

// import { Link } from tiptapExtensions

var CustomLink = function (_Link) {
  _inherits(CustomLink, _Link);

  function CustomLink() {
    _classCallCheck(this, CustomLink);

    return _possibleConstructorReturn(this, (CustomLink.__proto__ || Object.getPrototypeOf(CustomLink)).apply(this, arguments));
  }

  _createClass(CustomLink, [{
    key: 'schema',
    get: function get() {
      return {
        attrs: {
          href: {
            default: null
          },
          target: {
            default: null
          }
        },
        inclusive: false,
        parseDOM: [{
          tag: 'a[href]',
          getAttrs: function getAttrs(dom) {
            return {
              href: dom.getAttribute('href'),
              target: dom.getAttribute('target')
            };
          }
        }],
        toDOM: function toDOM(node) {
          return ['a', _extends({}, node.attrs, {
            target: '__blank',
            rel: 'noopener noreferrer nofollow'
          }), 0];
        }
      };
    }
  }]);

  return CustomLink;
}(__WEBPACK_IMPORTED_MODULE_0_tiptap_extensions__["l" /* Link */]);

// https://codesandbox.io/s/9x8fr


/* harmony default export */ __webpack_exports__["a"] = (CustomLink);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('div',{staticClass:"content-block"},[(_vm.found)?_c('div',[(!_vm.editing)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.content.content)}}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.$store.getters.isAgent === 'true')?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.edit()}}},[_vm._v("Edit")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"editor mt-4"},[_c('Modal',{ref:"ytmodal",on:{"onConfirm":_vm.addCommand}}),_vm._v(" "),_c('editor-menu-bar',{staticClass:"mb-1",attrs:{"editor":_vm.textEditor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
return [_c('div',{staticClass:"menubar"},[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bold() },on:{"click":function($event){$event.preventDefault();return commands.bold($event)}}},[_c('strong',[_vm._v("B")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.italic() },on:{"click":function($event){$event.preventDefault();return commands.italic($event)}}},[_c('i',[_vm._v("Italics")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.underline() },on:{"click":function($event){$event.preventDefault();return commands.underline($event)}}},[_c('u',[_vm._v("U")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",on:{"click":function($event){$event.preventDefault();return _vm.openModal(commands.image);}}},[_vm._v("\n                Image\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 3 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 2 })}}},[_vm._v("\n                H1\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 4 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 3 })}}},[_vm._v("\n                H2\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.heading({ level: 5 }) },on:{"click":function($event){$event.preventDefault();return commands.heading({ level: 4 })}}},[_vm._v("\n                H3\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.bullet_list() },on:{"click":function($event){$event.preventDefault();return commands.bullet_list($event)}}},[_vm._v("\n                List\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.ordered_list() },on:{"click":function($event){$event.preventDefault();return commands.ordered_list($event)}}},[_vm._v("\n                1. 2. 3...\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.horizontal_rule() },on:{"click":function($event){$event.preventDefault();return commands.horizontal_rule($event)}}},[_vm._v("\n                ---\n              ")])])]}}],null,false,1193766800)}),_vm._v(" "),_c('editor-menu-bubble',{staticClass:"menububble mb-1",attrs:{"editor":_vm.textEditor},on:{"hide":_vm.hideLinkMenu},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var isActive = ref.isActive;
var getMarkAttrs = ref.getMarkAttrs;
var menu = ref.menu;
return [_c('div',{staticClass:"menububble",class:{ 'is-active': menu.isActive },style:(("left: " + (menu.left) + "px; bottom: " + (menu.bottom) + "px;"))},[(_vm.linkMenuIsActive)?_c('form',{staticClass:"menububble__form",on:{"submit":function($event){$event.preventDefault();return _vm.setLinkUrl(commands.customlink, _vm.linkUrl)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.linkUrl),expression:"linkUrl"}],ref:"linkInput",staticClass:"menububble__input",attrs:{"type":"text","placeholder":"https://"},domProps:{"value":(_vm.linkUrl)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.hideLinkMenu($event)},"input":function($event){if($event.target.composing){ return; }_vm.linkUrl=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",attrs:{"type":"button"},on:{"click":function($event){return _vm.setLinkUrl(commands.customlink, null)}}},[_c('p',[_vm._v("remove")])])]):[_c('button',{staticClass:"btn btn-grey btn-sm menubar__button",class:{ 'is-active': isActive.link() },on:{"click":function($event){_vm.showLinkMenu(getMarkAttrs('link'))}}},[_c('span',[_vm._v(_vm._s(isActive.link() ? 'Update Link' : 'Add Link'))])])]],2)]}}],null,false,1866164800)}),_vm._v(" "),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.textEditor}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.$store.getters.isAgent)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.found)?_c('div',[_c('h1',[_vm._v("Sorry! Not found.")]),_vm._v(" "),_c('hr')]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateContent_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b032b01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateContent_vue__ = __webpack_require__(929);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b032b01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.createContent()}}},[_vm._v("Create Content")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetRequest_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5138ba5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetRequest_vue__ = __webpack_require__(933);
function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5138ba5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(932);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8086d55c", content, true, {});

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".form-signup input[type=email]{margin-bottom:10px}", ""]);

// exports


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center registration-form"},[_c('form',{staticClass:"form-signup",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(!_vm.validEmail)?_c('div',[_c('h3',{staticClass:"mb-2",staticStyle:{"color":"var(--coredarkcolor)"}},[_vm._v("Reset Password")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Please enter the email address you used to register.")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputEmail"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email Address","required":"","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Reset Password")])]):_vm._e(),_vm._v(" "),(_vm.validEmail)?_c('div',[_c('h3',[_vm._v("Please check your email for instructions to reset your password!")])]):_vm._e(),_vm._v(" "),(_vm.validEmail == false)?_c('div',[_c('p',{staticClass:"mt-2",staticStyle:{"font-weight":"700"}},[_vm._v("Sorry, this email is not valid. Please try again.")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pt-4 pb-5"},[_c('router-link',{attrs:{"to":{ name: 'Login' }}},[_vm._v("I remember, Login")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608832d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__(937);
function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608832d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d115ba6e", content, true, {});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".form-signup input[type=password]{margin-bottom:10px}", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center registration-form"},[_c('form',{staticClass:"form-signup",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(_vm.tokenValid && (_vm.passwordResetSuccessfully == null))?_c('div',[_c('h3',{staticClass:"mb-3",staticStyle:{"color":"var(--coredarkcolor)"}},[_vm._v("Enter New Password")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"New Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Reset")])]):_vm._e(),_vm._v(" "),(!_vm.tokenValid)?_c('div',[_c('p',{staticClass:"mb-3"},[_vm._v("Your reset password link is no longer valid. Please click the button to try again")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'Password Reset Request' }}},[_vm._v("Reset Password")])],1):_vm._e(),_vm._v(" "),(_vm.passwordResetSuccessfully == false)?_c('div',[_c('p',{staticClass:"mb-3"},[_vm._v("Sorry! There was a problem resetting your passwork. Please click the button to try again.")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'Password Reset Request' }}},[_vm._v("Reset Password")])],1):_vm._e(),_vm._v(" "),(_vm.passwordResetSuccessfully == true)?_c('div',[_c('p',{staticClass:"mb-3"},[_vm._v("Your password was successfully reset! Please click the button to log in to your account.")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'Login' }}},[_vm._v("Login")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726fd7a2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorDialog_vue__ = __webpack_require__(941);
function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-726fd7a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726fd7a2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(940);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("78c64be4", content, true, {});

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".error-section[data-v-726fd7a2]{margin-top:.5rem}", ""]);

// exports


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"error-dialog","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.message)?_c('h4',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),(_vm.errorObj && typeof _vm.errorObj !== 'object')?_c('div',[_vm._v("\n      "+_vm._s(_vm.extractErrorContent(_vm.errorObj))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.errorObj && typeof _vm.errorObj === 'object')?_c('div',_vm._l((Object.keys(_vm.errorObj)),function(key,index){return _c('div',{key:index,staticClass:"error-section"},[_c('h4',[_vm._v(_vm._s(_vm.getDisplayKey(key)))]),_vm._v(" "),(Array.isArray(_vm.errorObj[key]))?_c('div',_vm._l((_vm.errorObj[key]),function(value,valIndex){return _c('li',{key:'val-' + valIndex},[_vm._v("\n            "+_vm._s(value)+"\n          ")])}),0):_c('div',[_c('li',[_vm._v(_vm._s(_vm.errorObj[key]))])])])}),0):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.closeErrorDialog()}}},[_vm._v("\n      "+_vm._s(_vm.closeLabel)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d9b562_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__ = __webpack_require__(945);
function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75d9b562"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d9b562_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(944);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("dcbc3a1e", content, true, {});

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"confirm-dialog","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.onReject()}}},[_vm._v("\n      "+_vm._s(_vm.rejectLabel)+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.onAccept()}}},[_vm._v("\n      "+_vm._s(_vm.acceptLabel)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f6af00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultDialog_vue__ = __webpack_require__(949);
function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23f6af00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f6af00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(948);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5770aeaf", content, true, {});

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".additional-items[data-v-23f6af00]{display:inline}", ""]);

// exports


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"z-index":"9999"},attrs:{"name":"result-dialog","width":"80%","height":"auto","scrollable":true}},[_c('div',{staticClass:"p-5"},[(_vm.innerHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.innerHtml)}}):_vm._e(),_vm._v(" "),(!_vm.innerHtml)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(!_vm.innerHtml)?_c('h4',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.closeResultDialog()}}},[_vm._v("\n      "+_vm._s(_vm.closeLabel)+"\n    ")]),_vm._v(" "),(_vm.additionalFooter)?_c('div',{staticClass:"additional-items",domProps:{"innerHTML":_vm._s(_vm.additionalFooter)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
      _vm.$router.history.current.path != '/family-form' &&
        _vm.$router.history.current.path != '/nanny-application-form'
    )?_c('div',{staticStyle:{"padding-left":"15px","padding-right":"15px","position":"absolute","width":"calc(100%)"}},[_c('nav',{staticClass:"web-only navbar navbar-expand-lg navbar-light",staticStyle:{"margin-bottom":"-96px"}},[_c('a',{staticClass:"navbar-brand",staticStyle:{"padding-top":"0"},attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"width":"","height":_vm.$store.getters.logoHeight,"alt":_vm.$store.getters.agencyName,"id":"nav-logo"}})]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":[function($event){_vm.showMobileNav = !_vm.showMobileNav},function($event){$event.stopPropagation();}]}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",class:{ show: _vm.showMobileNav },staticStyle:{"float":"right"},attrs:{"id":"navbarSupportedContent"}},[_c('div',{staticClass:"web-only search-form mr-auto",staticStyle:{"display":"flex","-webkit-box-align":"center","align-items":"center","height":"80px"}}),_vm._v(" "),_c('ul',{staticClass:"navbar-nav"},[(this.$store.getters.isEmployer === false && this.$store.getters.isAgent === true)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'Job Board' }}},[_vm._v("Jobs")])],1):_vm._e(),_vm._v(" "),(!_vm.auth)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'Login' }}},[_vm._v("Sign In")])],1):_vm._e(),_vm._v(" "),(_vm.auth)?_c('li',{staticClass:"nav-item"},[_c('p',{staticClass:"nav-link",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n              Logout\n            ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"header-button"},[(_vm.auth)?_c('button',{staticClass:"button button-1-dark",on:{"click":function($event){return _vm.dashboardRedirect()}}},[_vm._v("\n            My Dashboard\n          ")]):_vm._e()])])]),_vm._v(" "),_c('nav',{staticClass:"mobile-only navbar navbar-light",staticStyle:{"margin-bottom":"-56px"}},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(63)("./" + (_vm.$store.getters.logo)),"width":"","height":_vm.$store.getters.logoHeight,"alt":_vm.$store.getters.agencyName,"id":"nav-logo"}})]),_vm._v(" "),_c('div',{staticClass:"mobile-only dropleft",staticStyle:{"float":"right","margin-top":"4px","background-color":"z-index: 9999"}},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle",staticStyle:{"line-height":"1","padding-bottom":"0.3rem","padding-left":"0.5rem","padding-right":"0.5rem"},attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":[function($event){_vm.showMobileNav = !_vm.showMobileNav},function($event){$event.stopPropagation();}]}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","color":"var(--coredarkcolor)"}},[_vm._v("menu_open")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",class:{ show: _vm.showMobileNav },staticStyle:{"float":"right"},attrs:{"aria-labelledby":"dropdownMenuButton"}},[(this.$store.getters.isEmployer === false)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'Job Board' }}},[_vm._v("Jobs")]):_vm._e(),_vm._v(" "),(!_vm.auth)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'Login' }}},[_vm._v("Sign In")]):_vm._e(),_vm._v(" "),(_vm.auth)?_c('p',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('ErrorDialog'),_vm._v(" "),_c('ResultDialog'),_vm._v(" "),_c('ConfirmDialog'),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreetViewPanorama = exports.MountableMixin = exports.Autocomplete = exports.MapElementFactory = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Cluster = exports.Circle = exports.Polygon = exports.Polyline = exports.Marker = exports.loadGmapApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Vue component imports


exports.install = install;
exports.gmapApi = gmapApi;

var _lazyValue = __webpack_require__(952);

var _lazyValue2 = _interopRequireDefault(_lazyValue);

var _manager = __webpack_require__(953);

var _marker = __webpack_require__(954);

var _marker2 = _interopRequireDefault(_marker);

var _polyline = __webpack_require__(955);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(956);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(957);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(958);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = __webpack_require__(959);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(962);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(967);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(972);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(974);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(355);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

var _mountableMixin = __webpack_require__(145);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var Cluster = undefined;

var GmapApi = null;

// export everything
exports.loadGmapApi = _manager.loadGmapApi;
exports.Marker = _marker2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Cluster = Cluster;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.MapElementFactory = _mapElementFactory2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
exports.StreetViewPanorama = _streetViewPanorama2.default;
function install(Vue, options) {
  // Set defaults
  options = _extends({
    installComponents: true,
    autobindAllEvents: false
  }, options);

  // Update the global `GmapApi`. This will allow
  // components to use the `google` global reactively
  // via:
  //   import {gmapApi} from 'vue2-google-maps'
  //   export default {  computed: { google: gmapApi }  }
  GmapApi = new Vue({ data: { gmapApi: null } });

  var defaultResizeBus = new Vue();

  // Use a lazy to only load the API when
  // a VGM component is loaded
  var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
      this.$gmapOptions = options;
      this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  });
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

function makeGmapApiPromiseLazy(options) {
  // Things to do once the API is loaded
  function onApiLoaded() {
    GmapApi.gmapApi = {};
    return window.google;
  }

  if (options.load) {
    // If library should load the API
    return (0, _lazyValue2.default)(function () {
      // Load the
      // This will only be evaluated once
      if (typeof window === 'undefined') {
        // server side -- never resolve this promise
        return new Promise(function () {}).then(onApiLoaded);
      } else {
        return new Promise(function (resolve, reject) {
          try {
            window['vueGoogleMapsInit'] = resolve;
            (0, _manager.loadGmapApi)(options.load, options.loadCn);
          } catch (err) {
            reject(err);
          }
        }).then(onApiLoaded);
      }
    });
  } else {
    // If library should not handle API, provide
    // end-users with the global `vueGoogleMapsInit: () => undefined`
    // when the Google Maps API has been loaded
    var promise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
      }
      window['vueGoogleMapsInit'] = resolve;
    }).then(onApiLoaded);

    return (0, _lazyValue2.default)(function () {
      return promise;
    });
  }
}

function gmapApi() {
  return GmapApi.gmapApi && window.google;
}

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports.default = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isApiSetUp = false;

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var loadGmapApi = exports.loadGmapApi = function (options, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!isApiSetUp) {
    isApiSetUp = true;

    var googleMapScript = document.createElement('SCRIPT');

    // Allow options to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      throw new Error('options should  be an object');
    }

    // libraries
    if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'https://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.head.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'marker',
  ctr: function ctr() {
    return google.maps.Marker;
  },

  inject: {
    '$clusterPromise': {
      default: null
    }
  },

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      // Repaint will be performed in `updated()` of cluster
      this.$clusterObject.removeMarker(this.$markerObject, true);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    if (this.$clusterPromise) {
      this.$clusterPromise.then(function (co) {
        co.addMarker(inst);
        _this.$clusterObject = co;
      });
    }
  }
});

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,

  name: 'polyline',
  ctr: function ctr() {
    return google.maps.Polyline;
  },

  afterCreate: function afterCreate() {
    var _this = this;

    var clearEvents = function () {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true,
    noBind: true
  },
  paths: {
    type: Array,
    twoWay: true,
    noBind: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,
  mappedProps: props,
  name: 'polygon',
  ctr: function ctr() {
    return google.maps.Polygon;
  },

  beforeCreate: function beforeCreate(options) {
    if (!options.path) delete options.path;
    if (!options.paths) delete options.paths;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    var clearEvents = function () {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        inst.setPaths(paths);

        var updatePaths = function () {
          _this.$emit('paths_changed', inst.getPaths());
        };
        var eventListeners = [];

        var mvcArray = inst.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        inst.setPaths(path);

        var mvcPath = inst.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', inst.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'circle',
  ctr: function ctr() {
    return google.maps.Circle;
  },
  events: events
});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'rectangle',
  ctr: function ctr() {
    return google.maps.Rectangle;
  },
  events: events
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(356);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(961);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(43);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'infoWindow',
  ctr: function ctr() {
    return google.maps.InfoWindow;
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },

  inject: {
    '$markerPromise': {
      default: null
    }
  },

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  beforeCreate: function beforeCreate(options) {
    var _this = this;

    options.content = this.$refs.flyaway;

    if (this.$markerPromise) {
      delete options.position;
      return this.$markerPromise.then(function (mo) {
        _this.$markerObject = mo;
        return mo;
      });
    }
  },


  methods: {
    _openInfoWindow: function _openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindowObject.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindowObject.open(this.$map);
        }
      } else {
        this.$infoWindowObject.close();
      }
    }
  },

  afterCreate: function afterCreate() {
    var _this2 = this;

    this._openInfoWindow();
    this.$watch('opened', function () {
      _this2._openInfoWindow();
    });
  }
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(357);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(966);
function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b6f23878", content, true, {});

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".vue-map-container{position:relative}.vue-map-container .vue-map{left:0;right:0;top:0;bottom:0;position:absolute}.vue-map-hidden{display:none}", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(143);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(76);

var _mountableMixin = __webpack_require__(145);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(358);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(144);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object,
    noBind: true
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number,
    noBind: true
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['bounds_changed', 'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

  provide: function provide() {
    var _this = this;

    this.$mapPromise = new Promise(function (resolve, reject) {
      _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$mapPromise': this.$mapPromise
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        });
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

      return _this2.$mapObject;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: _extends({}, customMethods, linkedMethods)
};

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(359);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(971);
function injectStyle (ssrContext) {
  __webpack_require__(968)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("f6bcaac0", content, true, {});

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".vue-street-view-pano-container{position:relative}.vue-street-view-pano-container .vue-street-view-pano{left:0;right:0;top:0;bottom:0;position:absolute}", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(143);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(76);

var _mountableMixin = __webpack_require__(145);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(358);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(144);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
  replace: false, // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },

  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(973);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(362);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(976);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindProps = __webpack_require__(76);

var _simulateArrowDown = __webpack_require__(361);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _mapElementFactory = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mappedProps = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object,
    // Do not bind -- must check for undefined
    // in the property
    noBind: true
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

var props = {
  selectFirstOnEnter: {
    required: false,
    type: Boolean,
    default: false
  },
  options: {
    type: Object
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    this.$gmapApiPromiseLazy().then(function () {
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = _extends({}, (0, _bindProps.getPropsValues)(_this, mappedProps), _this.options);

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      // Not using `bindEvents` because we also want
      // to return the result of `getPlace()`
      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: _extends({}, (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps), props)
};

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vuelidate = Vuelidate;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _params.withParams;
  }
});
exports.default = exports.validationMixin = void 0;

var _vval = __webpack_require__(978);

var _params = __webpack_require__(207);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NIL = function NIL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (_typeof(val) === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');

  for (var i = 0; i < path.length; i++) {
    if (obj && _typeof(obj) === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true,
      v: false
    }
  });
  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });
  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $anyDirty: function $anyDirty() {
    var _this3 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$anyDirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $anyError: function $anyError() {
    return this.$anyDirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this4 = this;

    return this.ruleKeys.some(function (key) {
      return _this4.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this4.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this5 = this;

    var vals = this.validations;
    return _objectSpread({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this5.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];

    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();

        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }

        params = params.concat(childParams);
      } else {
        params.push({
          path: [],
          name: key,
          params: this.$params[key]
        });
      }
    }

    return params;
  }
};
var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);
var _cachedComponent = null;

var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};

        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });

        return refs;
      }
    },
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
        this._vval = null;
      }
    },
    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();

        if (model) {
          return model[key];
        }
      },
      hasIter: function hasIter() {
        return false;
      }
    }
  });
  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: {
      runRule: function runRule(parent) {
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
        return {
          output: output,
          params: params
        };
      }
    },
    computed: {
      run: function run() {
        var _this6 = this;

        var parent = this.lazyParentModel();

        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();
          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this, function () {
              return _this6.runRule(parent);
            }, null, {
              lazy: true
            });
          }

          var model = this.getModel();

          if (!this._indirectWatcher.dirty && this._lastModel === model) {
            this._indirectWatcher.depend();

            return target.value;
          }

          this._lastModel = model;

          this._indirectWatcher.evaluate();

          this._indirectWatcher.depend();
        } else if (this._indirectWatcher) {
          this._indirectWatcher.teardown();

          this._indirectWatcher = null;
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }

        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }

        return false;
      }
    },
    destroyed: function destroyed() {
      if (this._indirectWatcher) {
        this._indirectWatcher.teardown();

        this._indirectWatcher = null;
      }
    }
  });
  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: _objectSpread({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _objectSpread({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this7 = this;

        return this.keys.filter(function (k) {
          return !_this7.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this8 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8.refProxy(key);
            }
          };
        });
        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var iterDefs = this.hasIter() ? {
          $iter: {
            enumerable: true,
            value: Object.defineProperties({}, _objectSpread({}, keyDefs))
          }
        } : {};
        return Object.defineProperties({}, _objectSpread({}, keyDefs, iterDefs, {
          $model: {
            enumerable: true,
            get: function get() {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                return parent[_this8.prop];
              } else {
                return null;
              }
            },
            set: function set(value) {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                parent[_this8.prop] = value;

                _this8.$touch();
              }
            }
          }
        }, getterDefs, methodDefs));
      },
      children: function children() {
        var _this9 = this;

        return _toConsumableArray(this.nestedKeys.map(function (key) {
          return renderNested(_this9, key);
        })).concat(_toConsumableArray(this.ruleKeys.map(function (key) {
          return renderRule(_this9, key);
        }))).filter(Boolean);
      }
    })
  });
  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            return vm.validations[key]() || false;
          }

        };
      }
    }
  });
  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();

        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this10 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return "".concat(getPath(_this10.rootModel, _this10.getModelKey(key), trackBy));
        } : function (x) {
          return "".concat(x);
        };
      },
      getModelLazy: function getModelLazy() {
        var _this11 = this;

        return function () {
          return _this11.getModel();
        };
      },
      children: function children() {
        var _this12 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _objectSpread({}, def);

        delete validations['$trackBy'];
        var usedTracks = {};
        return this.keys.map(function (key) {
          var track = _this12.tracker(key);

          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }

          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this12.getModelLazy,
            model: model[key],
            rootModel: _this12.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      },
      hasIter: function hasIter() {
        return true;
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }

    var validations = vm.validations[key];

    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NIL,
        prop: key,
        lazyModel: NIL,
        rootModel: root
      });
    }

    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = {
    VBase: VBase,
    Validation: Validation
  };
  return _cachedComponent;
};

var _cachedVue = null;

function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;

  while (Vue.super) {
    Vue = Vue.super;
  }

  _cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;
        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NIL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;

    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;

    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();

      this._vuelidate = null;
    }
  }
};
exports.validationMixin = validationMixin;

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

var _default = Vuelidate;
exports.default = _default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({
    data: vval.args
  });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);

  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};

  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }

  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx, idxInOld, elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx];
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;

      if (isUndef(idxInOld)) {
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];

        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }

  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];

    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }

  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return {
    tag: tag,
    key: key,
    args: args
  };
}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["vue-js-modal"]=t():e["vue-js-modal"]=t()}(window,function(){return function(n){var o={};function i(e){if(o[e])return o[e].exports;var t=o[e]={i:e,l:!1,exports:{}};return n[e].call(t.exports,t,t.exports,i),t.l=!0,t.exports}return i.m=n,i.c=o,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)i.d(n,o,function(e){return t[e]}.bind(null,o));return n},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="/dist/",i(i.s=11)}([function(e,t,n){var o=n(6);"string"==typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);(0,n(4).default)("27d83796",o,!1,{})},function(e,t,n){var o=n(8);"string"==typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);(0,n(4).default)("0e783494",o,!1,{})},function(e,t,n){var o=n(10);"string"==typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);(0,n(4).default)("17757f60",o,!1,{})},function(e,t){e.exports=function(n){var a=[];return a.toString=function(){return this.map(function(e){var t=function(e,t){var n=e[1]||"",o=e[3];if(!o)return n;if(t&&"function"==typeof btoa){var i=(a=o,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),r=o.sources.map(function(e){return"/*# sourceURL="+o.sourceRoot+e+" */"});return[n].concat(r).concat([i]).join("\n")}var a;return[n].join("\n")}(e,n);return e[2]?"@media "+e[2]+"{"+t+"}":t}).join("")},a.i=function(e,t){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},o=0;o<this.length;o++){var i=this[o][0];"number"==typeof i&&(n[i]=!0)}for(o=0;o<e.length;o++){var r=e[o];"number"==typeof r[0]&&n[r[0]]||(t&&!r[2]?r[2]=t:t&&(r[2]="("+r[2]+") and ("+t+")"),a.push(r))}},a}},function(e,t,n){"use strict";function l(e,t){for(var n=[],o={},i=0;i<t.length;i++){var r=t[i],a=r[0],s={id:e+":"+i,css:r[1],media:r[2],sourceMap:r[3]};o[a]?o[a].parts.push(s):n.push(o[a]={id:a,parts:[s]})}return n}n.r(t),n.d(t,"default",function(){return p});var o="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var d={},i=o&&(document.head||document.getElementsByTagName("head")[0]),r=null,a=0,u=!1,s=function(){},c=null,h="data-vue-ssr-id",f="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function p(a,e,t,n){u=t,c=n||{};var s=l(a,e);return v(s),function(e){for(var t=[],n=0;n<s.length;n++){var o=s[n];(i=d[o.id]).refs--,t.push(i)}e?v(s=l(a,e)):s=[];for(n=0;n<t.length;n++){var i;if(0===(i=t[n]).refs){for(var r=0;r<i.parts.length;r++)i.parts[r]();delete d[i.id]}}}}function v(e){for(var t=0;t<e.length;t++){var n=e[t],o=d[n.id];if(o){o.refs++;for(var i=0;i<o.parts.length;i++)o.parts[i](n.parts[i]);for(;i<n.parts.length;i++)o.parts.push(g(n.parts[i]));o.parts.length>n.parts.length&&(o.parts.length=n.parts.length)}else{var r=[];for(i=0;i<n.parts.length;i++)r.push(g(n.parts[i]));d[n.id]={id:n.id,refs:1,parts:r}}}}function m(){var e=document.createElement("style");return e.type="text/css",i.appendChild(e),e}function g(t){var n,o,e=document.querySelector("style["+h+'~="'+t.id+'"]');if(e){if(u)return s;e.parentNode.removeChild(e)}if(f){var i=a++;e=r||(r=m()),n=w.bind(null,e,i,!1),o=w.bind(null,e,i,!0)}else e=m(),n=function(e,t){var n=t.css,o=t.media,i=t.sourceMap;o&&e.setAttribute("media",o);c.ssrId&&e.setAttribute(h,t.id);i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,e),o=function(){e.parentNode.removeChild(e)};return n(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;n(t=e)}else o()}}var b,y=(b=[],function(e,t){return b[e]=t,b.filter(Boolean).join("\n")});function w(e,t,n,o){var i=n?"":o.css;if(e.styleSheet)e.styleSheet.cssText=y(t,i);else{var r=document.createTextNode(i),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(r,a[t]):e.appendChild(r)}}},function(e,t,n){"use strict";var o=n(0);n.n(o).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.vue-modal-resizer {\r\n  display: block;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  width: 12px;\r\n  height: 12px;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 9999999;\r\n  background: transparent;\r\n  cursor: se-resize;\n}\n.vue-modal-resizer::after {\r\n  display: block;\r\n  position: absolute;\r\n  content: '';\r\n  background: transparent;\r\n  left: 0;\r\n  top: 0;\r\n  width: 0;\r\n  height: 0;\r\n  border-bottom: 10px solid #ddd;\r\n  border-left: 10px solid transparent;\n}\n.vue-modal-resizer.clicked::after {\r\n  border-bottom: 10px solid #369be9;\n}\r\n",""])},function(e,t,n){"use strict";var o=n(1);n.n(o).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.v--modal-block-scroll {\r\n  overflow: hidden;\r\n  width: 100vw;\n}\n.v--modal-overlay {\r\n  position: fixed;\r\n  box-sizing: border-box;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  z-index: 999;\r\n  opacity: 1;\n}\n.v--modal-overlay.scrollable {\r\n  height: 100%;\r\n  min-height: 100vh;\r\n  overflow-y: auto;\r\n  -webkit-overflow-scrolling: touch;\n}\n.v--modal-overlay .v--modal-background-click {\r\n  width: 100%;\r\n  min-height: 100%;\r\n  height: auto;\n}\n.v--modal-overlay .v--modal-box {\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-sizing: border-box;\n}\n.v--modal-overlay.scrollable .v--modal-box {\r\n  margin-bottom: 2px;\n}\n.v--modal {\r\n  background-color: white;\r\n  text-align: left;\r\n  border-radius: 3px;\r\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\r\n  padding: 0;\n}\n.v--modal.v--modal-fullscreen {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\n}\n.v--modal-top-right {\r\n  display: block;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\n}\n.overlay-fade-enter-active,\r\n.overlay-fade-leave-active {\r\n  transition: all 0.2s;\n}\n.overlay-fade-enter,\r\n.overlay-fade-leave-active {\r\n  opacity: 0;\n}\n.nice-modal-fade-enter-active,\r\n.nice-modal-fade-leave-active {\r\n  transition: all 0.4s;\n}\n.nice-modal-fade-enter,\r\n.nice-modal-fade-leave-active {\r\n  opacity: 0;\r\n  transform: translateY(-20px);\n}\r\n",""])},function(e,t,n){"use strict";var o=n(2);n.n(o).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.vue-dialog div {\r\n  box-sizing: border-box;\n}\n.vue-dialog .dialog-flex {\r\n  width: 100%;\r\n  height: 100%;\n}\n.vue-dialog .dialog-content {\r\n  flex: 1 0 auto;\r\n  width: 100%;\r\n  padding: 15px;\r\n  font-size: 14px;\n}\n.vue-dialog .dialog-c-title {\r\n  font-weight: 600;\r\n  padding-bottom: 15px;\n}\n.vue-dialog .dialog-c-text {\n}\n.vue-dialog .vue-dialog-buttons {\r\n  display: flex;\r\n  flex: 0 1 auto;\r\n  width: 100%;\r\n  border-top: 1px solid #eee;\n}\n.vue-dialog .vue-dialog-buttons-none {\r\n  width: 100%;\r\n  padding-bottom: 15px;\n}\n.vue-dialog-button {\r\n  font-size: 12px !important;\r\n  background: transparent;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n  line-height: 40px;\r\n  height: 40px;\r\n  color: inherit;\r\n  font: inherit;\r\n  outline: none;\n}\n.vue-dialog-button:hover {\r\n  background: rgba(0, 0, 0, 0.01);\n}\n.vue-dialog-button:active {\r\n  background: rgba(0, 0, 0, 0.025);\n}\n.vue-dialog-button:not(:first-of-type) {\r\n  border-left: 1px solid #eee;\n}\r\n",""])},function(e,t,n){"use strict";n.r(t);var o=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:t.overlayTransition}},[t.visibility.overlay?n("div",{ref:"overlay",class:t.overlayClass,attrs:{"aria-expanded":t.visibility.overlay.toString(),"data-modal":t.name}},[n("div",{staticClass:"v--modal-background-click",on:{mousedown:function(e){return e.target!==e.currentTarget?null:t.handleBackgroundClick(e)},touchstart:function(e){return e.target!==e.currentTarget?null:t.handleBackgroundClick(e)}}},[n("div",{staticClass:"v--modal-top-right"},[t._t("top-right")],2),t._v(" "),n("transition",{attrs:{name:t.transition},on:{"before-enter":t.beforeTransitionEnter,"after-enter":t.afterTransitionEnter,"after-leave":t.afterTransitionLeave}},[t.visibility.modal?n("div",{ref:"modal",class:t.modalClass,style:t.modalStyle},[t._t("default"),t._v(" "),t.resizable&&!t.isAutoHeight?n("resizer",{attrs:{"min-width":t.minWidth,"min-height":t.minHeight},on:{resize:t.handleModalResize}}):t._e()],2):t._e()])],1)]):t._e()])},i=function(){var e=this.$createElement;return(this._self._c||e)("div",{class:this.className})};i._withStripped=o._withStripped=!0;var s=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0;return function(){return(e++).toString()}}(),u=function(e,t,n){return n<e?e:t<n?t:n},r=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return function(i){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,o;t=i,o=r[n=e],n in t?Object.defineProperty(t,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[n]=o})}return i}({id:s(),timestamp:Date.now(),canceled:!1},e)},a={name:"VueJsModalResizer",props:{minHeight:{type:Number,default:0},minWidth:{type:Number,default:0}},data:function(){return{clicked:!1,size:{}}},mounted:function(){this.$el.addEventListener("mousedown",this.start,!1)},computed:{className:function(){return{"vue-modal-resizer":!0,clicked:this.clicked}}},methods:{start:function(e){this.clicked=!0,window.addEventListener("mousemove",this.mousemove,!1),window.addEventListener("mouseup",this.stop,!1),e.stopPropagation(),e.preventDefault()},stop:function(){this.clicked=!1,window.removeEventListener("mousemove",this.mousemove,!1),window.removeEventListener("mouseup",this.stop,!1),this.$emit("resize-stop",{element:this.$el.parentElement,size:this.size})},mousemove:function(e){this.resize(e)},resize:function(e){var t=this.$el.parentElement;if(t){var n=e.clientX-t.offsetLeft,o=e.clientY-t.offsetTop;n=u(this.minWidth,window.innerWidth,n),o=u(this.minHeight,window.innerHeight,o),this.size={width:n,height:o},t.style.width=n+"px",t.style.height=o+"px",this.$emit("resize",{element:t,size:this.size})}}}};n(5);function l(e,t,n,o,i,r,a,s){var l,d="function"==typeof e?e.options:e;if(t&&(d.render=t,d.staticRenderFns=n,d._compiled=!0),o&&(d.functional=!0),r&&(d._scopeId="data-v-"+r),a?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(a)},d._ssrRegister=l):i&&(l=s?function(){i.call(this,this.$root.$options.shadowRoot)}:i),l)if(d.functional){d._injectStyles=l;var u=d.render;d.render=function(e,t){return l.call(t),u(e,t)}}else{var c=d.beforeCreate;d.beforeCreate=c?[].concat(c,l):[l]}return{exports:e,options:d}}var d=l(a,i,[],!1,null,null,null);d.options.__file="src/Resizer.vue";var c=d.exports;function h(e){return(h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var f="[-+]?[0-9]*.?[0-9]+",p=[{name:"px",regexp:new RegExp("^".concat(f,"px$"))},{name:"%",regexp:new RegExp("^".concat(f,"%$"))},{name:"px",regexp:new RegExp("^".concat(f,"$"))}],v=function(e){switch(h(e)){case"number":return{type:"px",value:e};case"string":return function(e){if("auto"===e)return{type:e,value:0};for(var t=0;t<p.length;t++){var n=p[t];if(n.regexp.test(e))return{type:n.name,value:parseFloat(e)}}return{type:"",value:e}}(e);default:return{type:"",value:e}}},m=function(e){if("string"!=typeof e)return 0<=e;var t=v(e);return("%"===t.type||"px"===t.type)&&0<t.value};var g={name:"VueJsModal",props:{name:{required:!0,type:String},delay:{type:Number,default:0},resizable:{type:Boolean,default:!1},adaptive:{type:Boolean,default:!1},draggable:{type:[Boolean,String],default:!1},scrollable:{type:Boolean,default:!1},reset:{type:Boolean,default:!1},overlayTransition:{type:String,default:"overlay-fade"},transition:{type:String},clickToClose:{type:Boolean,default:!0},classes:{type:[String,Array],default:"v--modal"},minWidth:{type:Number,default:0,validator:function(e){return 0<=e}},minHeight:{type:Number,default:0,validator:function(e){return 0<=e}},maxWidth:{type:Number,default:1/0},maxHeight:{type:Number,default:1/0},width:{type:[Number,String],default:600,validator:m},height:{type:[Number,String],default:300,validator:function(e){return"auto"===e||m(e)}},pivotX:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}},pivotY:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}}},components:{Resizer:c},data:function(){return{visible:!1,visibility:{modal:!1,overlay:!1},shift:{left:0,top:0},modal:{width:0,widthType:"px",height:0,heightType:"px",renderedHeight:0},window:{width:0,height:0},mutationObserver:null}},created:function(){this.setInitialSize()},beforeMount:function(){var t=this;if(z.event.$on("toggle",this.handleToggleEvent),window.addEventListener("resize",this.handleWindowResize),this.handleWindowResize(),this.scrollable&&!this.isAutoHeight&&console.warn('Modal "'.concat(this.name,'" has scrollable flag set to true ')+'but height is not "auto" ('.concat(this.height,")")),this.isAutoHeight){var e=function(){if("undefined"!=typeof window)for(var e=["","WebKit","Moz","O","Ms"],t=0;t<e.length;t++){var n=e[t]+"MutationObserver";if(n in window)return window[n]}return!1}();e&&(this.mutationObserver=new e(function(e){t.updateRenderedHeight()}))}this.clickToClose&&window.addEventListener("keyup",this.handleEscapeKeyUp)},beforeDestroy:function(){z.event.$off("toggle",this.handleToggleEvent),window.removeEventListener("resize",this.handleWindowResize),this.clickToClose&&window.removeEventListener("keyup",this.handleEscapeKeyUp),this.scrollable&&document.body.classList.remove("v--modal-block-scroll")},computed:{isAutoHeight:function(){return"auto"===this.modal.heightType},position:function(){var e=this.window,t=this.shift,n=this.pivotX,o=this.pivotY,i=this.trueModalWidth,r=this.trueModalHeight,a=e.width-i,s=e.height-r,l=t.left+n*a,d=t.top+o*s;return{left:parseInt(u(0,a,l)),top:parseInt(u(0,s,d))}},trueModalWidth:function(){var e=this.window,t=this.modal,n=this.adaptive,o=this.minWidth,i=this.maxWidth,r="%"===t.widthType?e.width/100*t.width:t.width,a=Math.min(e.width,i);return n?u(o,a,r):r},trueModalHeight:function(){var e=this.window,t=this.modal,n=this.isAutoHeight,o=this.adaptive,i=this.maxHeight,r="%"===t.heightType?e.height/100*t.height:t.height;if(n)return this.modal.renderedHeight;var a=Math.min(e.height,i);return o?u(this.minHeight,a,r):r},overlayClass:function(){return{"v--modal-overlay":!0,scrollable:this.scrollable&&this.isAutoHeight}},modalClass:function(){return["v--modal-box",this.classes]},modalStyle:function(){return{top:this.position.top+"px",left:this.position.left+"px",width:this.trueModalWidth+"px",height:this.isAutoHeight?"auto":this.trueModalHeight+"px"}}},watch:{visible:function(e){var t=this;e?(this.visibility.overlay=!0,setTimeout(function(){t.visibility.modal=!0,t.$nextTick(function(){t.addDraggableListeners(),t.callAfterEvent(!0)})},this.delay)):(this.visibility.modal=!1,setTimeout(function(){t.visibility.overlay=!1,t.$nextTick(function(){t.removeDraggableListeners(),t.callAfterEvent(!1)})},this.delay))}},methods:{handleToggleEvent:function(e,t,n){if(this.name===e){var o=void 0===t?!this.visible:t;this.toggle(o,n)}},setInitialSize:function(){var e=this.modal,t=v(this.width),n=v(this.height);e.width=t.value,e.widthType=t.type,e.height=n.value,e.heightType=n.type},handleEscapeKeyUp:function(e){27===e.which&&this.visible&&this.$modal.hide(this.name)},handleWindowResize:function(){this.window.width=window.innerWidth,this.window.height=window.innerHeight,this.ensureShiftInWindowBounds()},createModalEvent:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return r(function(i){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,o;t=i,o=r[n=e],n in t?Object.defineProperty(t,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[n]=o})}return i}({name:this.name,ref:this.$refs.modal},e))},handleModalResize:function(e){this.modal.widthType="px",this.modal.width=e.size.width,this.modal.heightType="px",this.modal.height=e.size.height;var t=this.modal.size;this.$emit("resize",this.createModalEvent({size:t}))},toggle:function(e,t){var n=this.reset,o=this.scrollable,i=this.visible;if(i!==e){var r=i?"before-close":"before-open";"before-open"===r?("undefined"!=typeof document&&document.activeElement&&"BODY"!==document.activeElement.tagName&&document.activeElement.blur&&document.activeElement.blur(),n&&(this.setInitialSize(),this.shift.left=0,this.shift.top=0),o&&document.body.classList.add("v--modal-block-scroll")):o&&document.body.classList.remove("v--modal-block-scroll");var a=!1,s=this.createModalEvent({stop:function(){a=!0},state:e,params:t});this.$emit(r,s),a||(this.visible=e)}},getDraggableElement:function(){var e="string"!=typeof this.draggable?".v--modal-box":this.draggable;return e?this.$refs.overlay.querySelector(e):null},handleBackgroundClick:function(){this.clickToClose&&this.toggle(!1)},callAfterEvent:function(e){e?this.connectObserver():this.disconnectObserver();var t=e?"opened":"closed",n=this.createModalEvent({state:e});this.$emit(t,n)},addDraggableListeners:function(){var r=this;if(this.draggable){var e=this.getDraggableElement();if(e){var a=0,s=0,l=0,d=0,u=function(e){return e.touches&&0<e.touches.length?e.touches[0]:e},t=function(e){var t=e.target;if(!t||"INPUT"!==t.nodeName){var n=u(e),o=n.clientX,i=n.clientY;document.addEventListener("mousemove",c),document.addEventListener("touchmove",c),document.addEventListener("mouseup",h),document.addEventListener("touchend",h),a=o,s=i,l=r.shift.left,d=r.shift.top}},c=function(e){var t=u(e),n=t.clientX,o=t.clientY;r.shift.left=l+n-a,r.shift.top=d+o-s,e.preventDefault()},h=function e(t){r.ensureShiftInWindowBounds(),document.removeEventListener("mousemove",c),document.removeEventListener("touchmove",c),document.removeEventListener("mouseup",e),document.removeEventListener("touchend",e),t.preventDefault()};e.addEventListener("mousedown",t),e.addEventListener("touchstart",t)}}},removeDraggableListeners:function(){},updateRenderedHeight:function(){this.$refs.modal&&(this.modal.renderedHeight=this.$refs.modal.getBoundingClientRect().height)},connectObserver:function(){this.mutationObserver&&this.mutationObserver.observe(this.$refs.overlay,{childList:!0,attributes:!0,subtree:!0})},disconnectObserver:function(){this.mutationObserver&&this.mutationObserver.disconnect()},beforeTransitionEnter:function(){this.connectObserver()},afterTransitionEnter:function(){},afterTransitionLeave:function(){},ensureShiftInWindowBounds:function(){var e=this.window,t=this.shift,n=this.pivotX,o=this.pivotY,i=this.trueModalWidth,r=this.trueModalHeight,a=e.width-i,s=e.height-r,l=t.left+n*a,d=t.top+o*s;this.shift.left-=l-u(0,a,l),this.shift.top-=d-u(0,s,d)}}},b=(n(7),l(g,o,[],!1,null,null,null));b.options.__file="src/Modal.vue";var y=b.exports,w=function(){var n=this,e=n.$createElement,o=n._self._c||e;return o("modal",{attrs:{name:"dialog",height:"auto",classes:["v--modal","vue-dialog",this.params.class],width:n.width,"pivot-y":.3,adaptive:!0,clickToClose:n.clickToClose,transition:n.transition},on:{"before-open":n.beforeOpened,"before-close":n.beforeClosed,opened:function(e){n.$emit("opened",e)},closed:function(e){n.$emit("closed",e)}}},[o("div",{staticClass:"dialog-content"},[n.params.title?o("div",{staticClass:"dialog-c-title",domProps:{innerHTML:n._s(n.params.title||"")}}):n._e(),n._v(" "),n.params.component?o(n.params.component,n._b({tag:"component"},"component",n.params.props,!1)):o("div",{staticClass:"dialog-c-text",domProps:{innerHTML:n._s(n.params.text||"")}})],1),n._v(" "),n.buttons?o("div",{staticClass:"vue-dialog-buttons"},n._l(n.buttons,function(e,t){return o("button",{key:t,class:e.class||"vue-dialog-button",style:n.buttonStyle,attrs:{type:"button"},domProps:{innerHTML:n._s(e.title)},on:{click:function(e){e.stopPropagation(),n.click(t,e)}}},[n._v("\n      "+n._s(e.title)+"\n    ")])})):o("div",{staticClass:"vue-dialog-buttons-none"})])};w._withStripped=!0;var x={name:"VueJsDialog",props:{width:{type:[Number,String],default:400},clickToClose:{type:Boolean,default:!0},transition:{type:String,default:"fade"}},data:function(){return{params:{},defaultButtons:[{title:"CLOSE"}]}},computed:{buttons:function(){return this.params.buttons||this.defaultButtons},buttonStyle:function(){return{flex:"1 1 ".concat(100/this.buttons.length,"%")}}},methods:{beforeOpened:function(e){window.addEventListener("keyup",this.onKeyUp),this.params=e.params||{},this.$emit("before-opened",e)},beforeClosed:function(e){window.removeEventListener("keyup",this.onKeyUp),this.params={},this.$emit("before-closed",e)},click:function(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:"click",o=this.buttons[e];o&&"function"==typeof o.handler?o.handler(e,t,{source:n}):this.$modal.hide("dialog")},onKeyUp:function(e){if(13===e.which&&0<this.buttons.length){var t=1===this.buttons.length?0:this.buttons.findIndex(function(e){return e.default});-1!==t&&this.click(t,e,"keypress")}}}},_=(n(9),l(x,w,[],!1,null,null,null));_.options.__file="src/Dialog.vue";var E=_.exports,S=function(){var n=this,e=n.$createElement,o=n._self._c||e;return o("div",{attrs:{id:"modals-container"}},n._l(n.modals,function(t){return o("modal",n._g(n._b({key:t.id,on:{closed:function(e){n.remove(t.id)}}},"modal",t.modalAttrs,!1),t.modalListeners),[o(t.component,n._g(n._b({tag:"component",on:{close:function(e){n.$modal.hide(t.modalAttrs.name)}}},"component",t.componentAttrs,!1),n.$listeners))],1)}))};S._withStripped=!0;var O=l({data:function(){return{modals:[]}},created:function(){this.$root._dynamicContainer=this},methods:{add:function(e){var t=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},r=s(),a=o.name||"_dynamic_modal_"+r;this.modals.push({id:r,modalAttrs:function(i){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,o;t=i,o=r[n=e],n in t?Object.defineProperty(t,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[n]=o})}return i}({},o,{name:a}),modalListeners:i,component:e,componentAttrs:n}),this.$nextTick(function(){t.$modal.show(a)})},remove:function(t){var e=this.modals.findIndex(function(e){return e.id===t});-1!==e&&this.modals.splice(e,1)}}},S,[],!1,null,null,null);O.options.__file="src/ModalsContainer.vue";var k=O.exports;function C(e){return(C="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}n.d(t,"getModalsContainer",function(){return T});var T=function(e,t,n){if(!n._dynamicContainer&&t.injectModalsContainer){var o=(i=document.createElement("div"),document.body.appendChild(i),i);new e({parent:n,render:function(e){return e(k)}}).$mount(o)}var i;return n._dynamicContainer},$={install:function(a){var s=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(!this.installed){this.installed=!0,this.event=new a,this.rootInstance=null;var e=s.componentName||"Modal",l=s.dynamicDefaults||{},i=function(e,t,n,o){var i=n&&n.root?n.root:$.rootInstance,r=T(a,s,i);r?r.add(e,function(i){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,o;t=i,o=r[n=e],n in t?Object.defineProperty(t,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[n]=o})}return i}({},l,t),n,o):console.warn("[vue-js-modal] In order to render dynamic modals, a <modals-container> component must be present on the page.")};a.prototype.$modal={show:function(e){for(var t=arguments.length,n=new Array(1<t?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];switch(C(e)){case"string":return function(e,t){$.event.$emit("toggle",e,!0,t)}.apply(void 0,[e].concat(n));case"object":return s.dynamic?i.apply(void 0,[e].concat(n)):console.warn("[vue-js-modal] $modal() received object as a first argument, but dynamic modals are switched off. https://github.com/euvl/vue-js-modal/#dynamic-modals")}},hide:function(e,t){$.event.$emit("toggle",e,!1,t)},toggle:function(e,t){$.event.$emit("toggle",e,void 0,t)}},a.component(e,y),s.dialog&&a.component("VDialog",E),s.dynamic&&(a.component("ModalsContainer",k),a.mixin({beforeMount:function(){null===$.rootInstance&&($.rootInstance=this.$root)}}))}}},z=t.default=$}])});

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.1.3
 * (c) 2020 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return result.then(function (res) {
    try {
      this$1._actionSubscribers
        .filter(function (sub) { return sub.after; })
        .forEach(function (sub) { return sub.after(action, this$1.state); });
    } catch (e) {
      if (false) {
        console.warn("[vuex] error in after action subscribers: ");
        console.error(e);
      }
    }
    return res
  })
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && "production" !== 'production') {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if (false) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.1.3',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(146);

 // Lecture 364


var state = {
  userToken: null,
  userId: null,
  isAgent: null,
  isCandidate: null,
  isEmployer: null,
  // userProfile: null,
  agencyID: 33,
  agencyName: "TinyTreasuresNYC",
  agency: {},

  userProfile: {},

  stripeAccountID: "acct_1EBYhTFiJiOD1ROq" // TTNYC
};

var mutations = {
  authUser: function authUser(state, userData) {
    console.log("Storing Authentication Data");
    state.userToken = userData.token;
    state.userId = userData.user_id;
    state.isAgent = userData.is_agent;
    state.isCandidate = userData.is_candidate;
    state.isEmployer = userData.is_employer;
  },
  storeUser: function storeUser(state, userData) {
    state.userProfile = userData;
  },
  clearAuthData: function clearAuthData(state) {
    state.userToken = null;
    // state.userProfile = null
    state.userId = null;
    state.isAgent = null;
    state.isCandidate = null;
    state.isEmployer = null;
  }
};

var actions = {
  tryAutoLogin: function tryAutoLogin(_ref) {
    var commit = _ref.commit;

    // Lecture 366
    var stored_token = localStorage.getItem("token");
    if (!stored_token) {
      return;
    }
    // const expirationDate = localStorage.getItem('expirationDate')
    // const now = new Date()
    // if (now >= expirationDate) {
    //   return
    // }
    var is_agent = false;
    var is_candidate = false;
    var is_employer = false;
    var stored_user_id = localStorage.getItem("user_id");
    var stored_is_agent = localStorage.getItem("is_agent");
    if (stored_is_agent === "true") {
      is_agent = true;
    }
    var stored_is_candidate = localStorage.getItem("is_candidate");
    if (stored_is_candidate === "true") {
      is_candidate = true;
    }
    var stored_is_employer = localStorage.getItem("is_employer");
    if (stored_is_employer === "true") {
      is_employer = true;
    }
    commit("authUser", {
      token: stored_token,
      user_id: stored_user_id,
      // is_agent: stored_is_agent,
      // is_candidate: stored_is_candidate,
      // is_employer: stored_is_employer,
      is_agent: is_agent,
      is_candidate: is_candidate,
      is_employer: is_employer
    });
  },
  registerUser: function registerUser(_ref2, authData) {
    var _this = this;

    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise(function (resolve, reject) {
      // axios.post('/optimum/create-user/', {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/create-user/", {
        email: authData.email,
        password: authData.password,
        agency: state.agencyID
        // agency: 'ThriveHire', // The ThriveHire Agency object has an id of 4
        // user_type: authData.user_type,
        // status: authData.status,
        // status: 'New',
        // phone: authData.phone,
      }).then(function (res) {
        console.log("User resgistered!");
        console.log(res);
        console.log(res.data.pk);

        // dispatch('storeAuthentication', authData) // Lecture 360
        dispatch("login", authData) // Lecture 360
        // Need to run login immediately on registration, otherwise the following patch request will not be authenticated
        .then(function () {
          var is_agent = false;
          var is_candidate = false;
          var is_employer = false;
          if (authData.user_type == "agent") {
            _this.is_agent = true;
          } else {
            _this.is_agent = false;
          }
          if (authData.user_type == "candidate") {
            _this.is_candidate = true;
            //                 dispatch('sendEmail', {
            //                   subject: 'Welcome',
            //                   message: '\
            // Welcome to ThriveHire!\n\n\
            // We\'re thrilled to have you joining our community! Through your account, you can start searching and applying to jobs, internships, events and more. For any queries, please email info@thrivehire.org and we\'ll be in touch with you shortly.\n\n\
            // Kind regards,\n\n\
            // The ThriveHire Team',
            //                   from: 'info@thrivehire.co',
            //                   email: authData.email,
            //                   reply: 'info@thrivehire.org',
            //                   userID: res.data.pk,
            //                 })
          } else {
            _this.is_candidate = false;
          }

          if (authData.user_type == "employer") {
            _this.is_employer = true;
            //                 dispatch('sendEmail', {
            //                   subject: 'Welcome',
            //                   message: '\
            // Welcome to ThriveHire!\n\n\
            // Thank you for joining our community. We’re looking forward to working with you and sharing your organization’s impactful work and opportunities.\n\n\
            // We would be happy to set up a short call with you to learn more about your needs, to highlight ways that ThriveHire may benefit you, and to clarify any questions you may have.\n\n\
            // Please schedule a time that is convenient for you for this call here: calendly.com/hmundeva/30min?back=1&month=2020-01\n\n\
            // We’re looking forward to speaking with you!\n\n\
            // Kind regards,\n\n\
            // Hayley Mundeva\n\
            // Founder/CEO, ThriveHire',
            //                   from: 'info@thrivehire.co',
            //                   email: authData.email,
            //                   reply: 'hmundeva@thrivehire.org',
            //                   userID: res.data.pk,
            //                 })
            // dispatch('sendEmail', {
            //   subject: 'New Employer Registration',
            //   message: 'New Employer Email: '+authData.email,
            //   from: 'info@thrivehire.co',
            //   // email: 'aakash@enginehire.ca',
            //   email: 'info@thrivehire.org',
            //   reply: 'info@thrivehire.org',
            //   userID: 4,
            // })
          } else {
            _this.is_employer = false;
          }
          console.log(_this.is_agent);
          console.log(_this.is_candidate);
          console.log(_this.is_employer);
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("/api/people/".concat(res.data.pk.toString()) + "/", {
            agency: state.agencyID,
            agency_owner: state.agencyName,
            // user_type: authData.user_type,
            is_employer: _this.is_employer,
            is_candidate: _this.is_candidate,
            is_agent: _this.is_agent,
            // status: 'New',
            status: authData.status
            // numberArray: [0, 0, 0, 0],
          }).then(function (res) {
            console.log(res);

            dispatch("login", authData) // Lecture 360
            // Once the user's type and agency is set, run log in again
            .then(function () {
              resolve();
            });
          }).catch(function (error) {
            return console.log(error);
          });

          // this.testAction

          // resolve()
        });
      })
      // Problem with registering the user, probably because the email is already in use
      .catch(function (error) {
        console.log(error);
        reject(); // https://forum.vuejs.org/t/resolving-promises/1007
      });
    });
  },
  storeAuthentication: function storeAuthentication(_ref3, authData) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise(function (resolve, reject) {
      localStorage.setItem("token", res.data.token); // Lecture 366
      localStorage.setItem("user_id", res.data.user_id);
      localStorage.setItem("is_agent", res.data.is_agent);

      resolve();
    });
  },
  login: function login(_ref4, authData) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api-token-auth/", {
        username: authData.email,
        password: authData.password,
        agency: state.agencyID
      }).then(function (res) {
        // console.log("Successful Login");
        console.log(res);

        // Need to check if the person logging in actually belongs to this agency
        // If it is a new registration then their agency ID defaults to 1
        if (res.data.agency_id === 1 || res.data.agency_id == state.agencyID) {
          // state.isCandidate = res.data.is_candidate
          // state.isEmployer = res.data.is_employer
          commit("authUser", {
            token: res.data.token,
            user_id: res.data.user_id,
            is_agent: res.data.is_agent,
            is_candidate: res.data.is_candidate,
            is_employer: res.data.is_employer
          });
          // Need to save both of these for the authUser mutation
          localStorage.setItem("token", res.data.token); // Lecture 366
          localStorage.setItem("user_id", res.data.user_id);
          localStorage.setItem("is_agent", res.data.is_agent);
          localStorage.setItem("is_candidate", res.data.is_candidate);
          localStorage.setItem("is_employer", res.data.is_employer);

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/agencies?id=" + state.agencyID).then(function (res) {
            state.agency = res.data;
          }).catch(function (error) {
            return console.log(error);
          });

          // const now = new Date()
          // const expirationDate = new Date(now.getTime() + 3600000) // Covert the date to milliseconds, add an hour, then convert back to a date
          // localStorage.setItem('expirationDate', expirationDate)
          resolve();
          // dispatch('getUser') // Once someone logs in get their user profile, update: don't need to, can just call getUser from the user profile component
          // dispatch('setLogoutTimer') // If we want to auto log people out - Lecture 365, this is less relevant since the DRF token doesn't have an expiration
          console.log("Redirection after logging in");
          console.log(res.data.is_candidate);
          console.log(res.data.is_employer);
          if (res.data.is_candidate && !authData.user_type) {
            // Don't want to redirect on registration
            // router.replace('/user')
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: "Candidate Dashboard" });
          }
          if (res.data.is_employer && !authData.user_type) {
            // Don't want to redirect on registration
            // router.replace('/organization')
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: "Employer Dashboard" });
          }
          if (res.data.is_agent) {
            // router.replace('/agent-dashboard')
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ name: "Agent Dashboard" });
          }
        } else {
          // If someone has logged in with a different agency's account
          reject(); // https://forum.vuejs.org/t/resolving-promises/1007
        }
      })
      // Problem logging in, likely incorrect email or password, or account doesn't exist
      .catch(function (error) {
        console.log(error);
        reject(); // https://forum.vuejs.org/t/resolving-promises/1007
      });
    });
  },
  logout: function logout(_ref5, redirect) {
    var commit = _ref5.commit;

    commit("clearAuthData");
    // router.replace('/login') // After someone logs out send them to the login page - Lecture 364
    // router.push({name: 'Login'}) // https://router.vuejs.org/guide/essentials/navigation.html
    if (redirect != "no-redirect") {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: "Login" }); // https://router.vuejs.org/guide/essentials/navigation.html
    }

    // When someone logs out we want to clear their auth details from the browser, so they have to log back in - Lecture 366
    // localStorage.removeItem('expirationDate')
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("is_agent");
  },
  test: function test(_ref6) {
    var commit = _ref6.commit;

    console.log("Test successful.");
  }
};

var getters = {
  // user (state) {
  //   return state.userProfile
  // },
  userID: function userID(state) {
    return state.userId;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.userToken !== null;
  },
  isAgent: function isAgent(state) {
    return state.isAgent;
  },
  isCandidate: function isCandidate(state) {
    return state.isCandidate;
  },
  isEmployer: function isEmployer(state) {
    return state.isEmployer;
  },
  userAPIURL: function userAPIURL(state) {
    return "/api/people/".concat(state.userId.toString()).concat("/");
  },
  agencyID: function agencyID(state) {
    return state.agencyID;
  },
  agencyName: function agencyName(state) {
    return state.agencyName;
  },
  agency: function agency(state) {
    return state.agency;
  },
  stripeAccountID: function stripeAccountID(state) {
    return state.stripeAccountID;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);




var state = {
  // agencyFromEmail: 'tinytreasuresnyc@enginehire.io',
  agencyFromEmail: "ruka@tinytreasuresnyc.com",
  agencyReplyEmail: "info@tinytreasuresnyc.com",
  enginehireAdminEmail: "aakash@enginehire.ca",
  enginehireLoggingEmail: "enginehirelogs@gmail.com",

  agencyAdminEmail: 'ruka@tinytreasuresnyc.com',
  agencyAdminEmail2: 'recruit@tinytreasuresnyc.com',
  agencyAdminEmail3: 'info@tinytreasuresnyc.com',
  agencyAdminEmails: ['ruka@tinytreasuresnyc.com', 'recruit@tinytreasuresnyc.com', 'info@tinytreasuresnyc.com']

  // agencyAdminEmail: "aakash@enginehire.io",
  // agencyAdminEmail2: "aakash@enginehire.io",
  // agencyAdminEmail3: "aakash@enginehire.io",
  // agencyAdminEmails: ['aakash@enginehire.io', 'aakash@enginehire.io', 'aakash@enginehire.io'],
};

var mutations = {};

var actions = {
  sendEmail: function sendEmail(_ref, emailInfo) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    console.log(emailInfo.email);
    console.log(emailInfo.userID);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/optimum/email/", {
      subject: emailInfo.subject,
      message: emailInfo.message,
      from_address: emailInfo.from,
      to_address: emailInfo.email,
      reply_address: emailInfo.reply,
      user_id: emailInfo.userID
    }).then(function (res) {
      console.log("Email Sent");
      console.log(res);

      dispatch("logEmail", {
        subject: emailInfo.subject,
        message: emailInfo.message,
        from_address: emailInfo.from,
        to_address: res.data.email,
        reply_address: emailInfo.reply,
        user_id: emailInfo.userID
      }); // Lecture 360
    }).catch(function (error) {
      return console.log(error);
    });
  },
  sendEmails: function sendEmails(_ref2, emailInfo) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    //
    // Send the same email to a list of several emails
    //
    console.log(emailInfo.emails);
    console.log(emailInfo.userID);
    for (var emailIndex in emailInfo.emails) {
      console.log(emailInfo.message);
      // console.log(emailIndex)
      // console.log(emailInfo.emails[emailIndex])

      var message = emailInfo.message;
      // If we are sending an html email we want to add the tags and the footer
      if (emailInfo.html) {
        message = "<html><head></head><body>" + emailInfo.message + '<img src="https://s3.us-east-2.amazonaws.com/ttna.enginehire.io/ttna-logo-email-footer.jpg"></body></html>';
        // "</body></html>";
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/optimum/email/", {
        subject: emailInfo.subject,
        // message: emailInfo.message,
        // message: '<html><head></head><body><p>'+emailInfo.message+'</p><img src="https://s3.us-east-2.amazonaws.com/pinknannies.enginehire.io/PN+E-mail+signature-01.png"></body></html>',
        message: message,
        from_address: emailInfo.from,
        to_address: emailInfo.emails[emailIndex],
        reply_address: emailInfo.reply,
        user_id: emailInfo.userID
      }).then(function (res) {
        console.log("Email Sent to " + res.data.email);
        // console.log('Email Sent to ' + emailInfo.emails[emailIndex])
        // console.log(emailInfo.emails)
        // console.log(emailIndex)
        // console.log(emailInfo.emails[emailIndex])
        // console.log(res)
        dispatch("logEmail", {
          subject: emailInfo.subject,
          message: emailInfo.message,
          from_address: emailInfo.from,
          to_address: res.data.email,
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID
        }); // Lecture 360
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  logEmail: function logEmail(_ref3, emailInfo) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    console.log("Logging Email");
    console.log(emailInfo);
    console.log(emailInfo.to_address);
    console.log(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.userID);
    if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) {
      // Don't want to log emails sent to enginehire admin
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/emaillogs/", {
        recipient: emailInfo.user_id,
        sender: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.userID,
        subject: emailInfo.subject,
        body: emailInfo.message,
        to_email: emailInfo.to_address,
        from_email: emailInfo.from_address,
        reply_email: emailInfo.reply_address,
        agency_owner: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.agencyName,
        agency: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.agencyID
      }).then(function (res) {
        console.log(res);
        console.log("Email logged!");
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  htmlify: function htmlify(message) {
    return "<html><head></head><body><h1>" + message + "</h1></body></html>";
  }

  // sendSMS({commit, dispatch}, SMSInfo) {
  //   console.log(SMSInfo)
  //   axios.post('/optimum/email/',
  //       {
  //         subject: emailInfo.subject,
  //         message: emailInfo.message,
  //         from_address: emailInfo.from,
  //         to_address: emailInfo.email,
  //         reply_address: emailInfo.reply,
  //         user_id: emailInfo.userID,
  //       }
  //     )
  //       .then(res => {
  //         console.log('Email Sent')
  //         console.log(res)

  //         dispatch('logSMS',
  //           {
  //             subject: emailInfo.subject,
  //             message: emailInfo.message,
  //             from_address: emailInfo.from,
  //             to_address: res.data.email,
  //             reply_address: emailInfo.reply,
  //             user_id: emailInfo.userID,
  //           }
  //         ) // Lecture 360
  //       })
  //       .catch(error => console.log(error))
  // },

  // commsAlive() {
  //   console.log('Comms Alive!!')
  // },
  // sendMasivSMS({commit}, SMSInfo) {
  //   console.log('Sending Masiv SMS')
  //   console.log(SMSInfo)

  //   // axios.post('https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //   axios.post('https://cors-anywhere.herokuapp.com/https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //     .then(res => {
  //       console.log(res)
  //     })
  //     .catch(error => console.log(error))
  // },

};

var getters = {
  agencyFromEmail: function agencyFromEmail(state) {
    return state.agencyFromEmail;
  },
  agencyReplyEmail: function agencyReplyEmail(state) {
    return state.agencyReplyEmail;
  },
  enginehireAdminEmail: function enginehireAdminEmail(state) {
    return state.enginehireAdminEmail;
  },
  agencyAdminEmail: function agencyAdminEmail(state) {
    return state.agencyAdminEmail;
  },
  agencyAdminEmail2: function agencyAdminEmail2(state) {
    return state.agencyAdminEmail2;
  },
  agencyAdminEmail3: function agencyAdminEmail3(state) {
    return state.agencyAdminEmail3;
  },
  agencyAdminEmails: function agencyAdminEmails(state) {
    return state.agencyAdminEmails;
  },
  enginehireLoggingEmail: function enginehireLoggingEmail(state) {
    return state.enginehireLoggingEmail;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import axios from 'axios'
// import store from '../store'

var state = {
  transportationConsent: '<p>We, <strong>the Parents </strong>of<strong> the Children</strong>, do hereby authorize and direct the scheduled employee of The Nanny Company to transport our child(ren) to and from the frequent pick-up points and/or any other designated destinations, within reason. All transportation is to be consented of in advance by the parents.</p><p></p><p>Further, the Employee has agreed to comply with the Employee Handbook, including that there will be no cell phone use while driving with the child/ren, they have a valid drivers license, and will regularly maintain the reliable vehicle, with the appropriate insurance. The Clients will ensure the car seats are installed properly and the Employee will use them accordingly.</p><p></p><p>We understand and acknowledge that The Nanny Company Inc. assumes no responsibility, obligation or liability of any kind.</p>',
  useofClientVehicle: '<p>Whereas the Client has retained The Nanny Company (“TNC”) to provide care for the Client’s child(ren) (the “services”), which services are provided by qualified employees of the Company and governed by a contract for services between the Client and TNC;&nbsp;</p><p></p><p>And whereas the Employee is subject to an employment agreement and TNC’s policies and employee handbook;&nbsp;</p><p></p><p>The Client and TNC agree as follows:&nbsp;</p><p></p><ol><li><p>The Client expressly authorizes the Employee to use the Client’s vehicle(s) in order to transport the Client’s child(ren) as may be required during the performance of the services.&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will have no liability to the Client or any other party for any loss, damage or injury (whether direct, indirect, or consequential) occasioned by any act or omission of the Employee in operating the vehicle(s). The Client agrees that it will indemnify TNC for any claim or action against TNC in respect of the Employee’s use of the vehicle(s).&nbsp;</p></li><li><p>The Client acknowledges and agrees that the vehicle(s) will be in good working condition and the Client is responsible for maintaining insurance for the vehicle(s). The Client must provide proof of valid insurance to TNC upon the signing of this agreement. The Client acknowledges and agrees that it is responsible for maintaining the vehicle(s), repairing any damage to the vehicle(s), and paying any deductible that may be required in respect of the vehicle(s).&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will not be responsible for any driving violations, parking tickets, and traffic tickets (whether by photo radar or otherwise) that may be incurred are a result of the Employee using the vehicle(s).&nbsp;</p></li><li><p>The Client may revoke its authorization and/or consent to have the Employee use the vehicle(s), on notice to TNC. All communication in respect of these matters shall be between the Client and TNC.&nbsp;</p></li><li><p>TNC retains the right to revoke its agreement to allow the Employee to use the vehicle(s), without notice and in the sole discretion of TNC, following which revocation the prohibition of the use of the vehicle(s) will immediately be operative without exception.&nbsp;</p></li></ol>',
  transportChildrenEmployeeVehicle: '<p>Whereas the Client has retained The Nanny Company (“TNC”) to provide care for the Client’s child(ren) (the “services”), which services are provided by a qualified employee of the Company and governed by a contract for services between the Client and TNC;&nbsp;</p><p></p><p>And whereas the Employee is subject to an employment agreement and TNC’s policies and employee handbook;&nbsp;</p><p></p><p>The Client and TNC agree as follows:&nbsp;</p><p></p><ol><li><p>The Client expressly authorizes the Employee to use their own vehicle(s) in order to transport the Client’s child(ren) as may be required during the performance of the services.&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will have no liability to the Client or any other party for any loss, damage or injury (whether direct, indirect, or consequential) occasioned by any act or omission of the Employee in operating their own vehicle(s). The Client agrees that it will indemnify TNC for any claim or action against TNC in respect of the Employee’s use of their own vehicle(s) to transport the Client’s child(ren).&nbsp;</p></li><li><p>TNC acknowledges that the Employee’s application requires the Employee to have access to and maintain a reliable vehicle and to carry a valid driver’s license in the jurisdiction in which the child(ren) are being transported.&nbsp;</p></li><li><p>The Client agrees to reimburse the Employee for all reasonable and necessary expenses, as set out in the Nanny Company Client Contract.&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will not be responsible for any driving violations, parking tickets, and traffic tickets (whether by photo radar or otherwise) that may be incurred are a result of the Employee using their own vehicle(s) to transport the Client’s child(ren).&nbsp;</p></li><li><p>The Client may revoke its authorization and/or consent to have the Employee use their own vehicle(s), on notice to TNC. All communication in respect of these matters shall be between the Client and TNC.&nbsp;</p></li><li><p>TNC retains the right to revoke its agreement to allow the Employee to use their own vehicle(s), without notice and in the sole discretion of TNC, following which revocation the prohibition of the use of the Employee’s vehicle(s) will immediately be operative without exception.&nbsp;&nbsp;</p></li></ol>',
  medicalRelease: '<p>CONSENT:</p><ol><li><p>Employee agrees to notify a parent when a child is ill or needs medical attention. Occasionally we cannot contact parents and we need to get immediate help for the child. Our procedure is to call for an ambulance, should the situation require.</p></li><li><p>Please sign the consent below so that we can take the appropriate action on behalf of your child.</p></li><li><p>I hereby give consent for my child to be taken to the nearest emergency center when I cannot be contacted, in the care of the employee shifted by the Company or the listed emergency contacts.</p></li><li><p>I hereby give consent for my child named above to receive medical treatment.</p></li></ol>',

  familyAgencyContract: "<p>1. Placements:</p><p>Pink Nannies will refer All Applicants (hereinafter referred to as Candidate) to the Client, as they become available for consideration as a full-time or part-time live in or out Nanny, Household Manager, Personal Assistant, Baby Nurse, or Event Planner. Applicants are screened prior to their referral to the Client only to the extent that they meet the Agency's criteria for a qualified Applicant. Client agrees to screen and interview applicants carefully to determine whether they meet the Client's criteria and can fulfill the Clients expectations for their position. Offers of employment should not be made by Clients before carefully interviewing and screening applicants, and getting authorization to do so by the agency.</p><p>2. Interviewing/Hiring:</p><p>A) The Client agrees that all communication will be facilitated by Pink Nannies during the interview process. All trial days should also be scheduled by a Pink Nannies team member.</p><p>B) Pink Nannies agrees to present at a minimum three qualified candidates. If Client does not hire within the first five Candidates that are presented, a reevaluation meeting will be conducted to decide if Client and Agency should continue working together. At this time, the Agency may require an additional fee of $250 to continue the search based on the circumstances. This placement fee will still remain $2700 for a single family, $3500 for a nanny share.</p><p>C) The Client agrees that all job offers must be made by a Pink Nannies team member. All contract negotiations and signing will be facilitated by Pink Nannies. Clients are welcome to edit our Nanny/Family contract as they feel needed.</p><p>D) If Client initiates contact with our Candidates outside of Pink Nannies, Pink Nannies reserves the right to end the working relationship and not refund fees.</p><p>3. Fees:</p><p>A) The Client agrees to pay the Agency a start up fee of $250 and a placement fee of $2,700 for any Candidate referred by Agency and hired by Client. Placement Fees previously agreed upon as of the date of the execution of this Agreement. Client acknowledges the receipt of said Placement Fee, understands the entirety and agrees to fees stated therein.</p><p>B.) The Client agrees to pay the placement fee in full to Pink Nannies before the candidate begins employment in the Client’s home. This fee will be paid in full once the Client has been given authorization to employ the applicant. Clients who employ their candidate before paying the appropriate placement fee as stated in this agreement will be subject to pay an additional $150 service fee for each week that the referral is late in addition to the agreed upon fee.</p><p>Non Payment of Fees:</p><p>A.) If at any time within one year after an initial meeting between a client and any applicant referred by the agency that the applicant becomes a direct or indirect provider of services to the Client, and the Client does not notify the Agency of the candidate’s employment and/or does not pay the appropriate fee, the client agrees to pay the Agency a $2,500 termination fee in addition to any legal fees or court costs incurred by Pink Nannies in collecting such fees.</p><p>B.) The client agrees to pay the fee in full before the candidate begins employment. If the Client fails to pay the placement fee to the agency before the candidate begins employment, Pink Nannies will have the right to obtain full payment of the placement fee from client, along with attorney's fees and court costs incurred, and will not be obligated to provide the Client with any replacement or guarantee services as specified below in this agreement.</p><p>Refund Policies:</p><p>A.) All fees are non refundable. As for Placement Fees, Pink Nannies has a 4 month guarantee policy, if the Client decides to end the employment agreement for cause, as outlined in their specific Nanny/Family contract, Agency will find a new candidate ASAP for Client. The Client agrees that if they choose to come back to the Agency for a new candidate after the four month period, at this time they will have to re-contract with the Agency and pay the appropriate fees for a new candidate.</p><p>B.) Should Candidate terminate employment agreement without providing the notice Client requires in executed employment contract, Pink Nannies will waive daily temporary placement fee and assist Client free of charge with a finding a temporary Nanny until a replacement Nanny is hired. Client will still be responsible for paying Nanny’s hourly rate. However, if Candidate terminates employment because Client has not upheld their stipulations in the Nanny/Family contract (i.e. not being paid, not following scheduled hours, etc.), Pink Nannies will be not responsible for replacing the Candidate, even within the 4 month period.</p><p>Relationship to Client and Candidate:</p><p>A.) Pink Nannies is a referral service, and does not train, employ, or exercise control, authority or discretion over applicants referred to clients. Pink Nannies disclaims any and all responsibility for any conduct or omissions of any applicant, including any applicant hired by the</p><p>client. The agency is not responsible for losses or damages resulting directly or indirectly from its Clients relationship with any applicant or candidate. Pink Nannies is not responsible for providing insurance or withholding any payroll taxes, and has no employment relationship with its applicants.</p><p>B.) Clients are responsible for making sure their candidates are aware of all the household rules they want the candidate to follow as well as safety concerns and hazards.</p><p>C.) The Client, by signing this agreement, agrees to pay the appropriate fees and follow the appropriate policies in the event the Client hires any of the applicants referred by the Agency. This agreement embodies the entire agreement between Pink Nannies and the Client. There are no other contracts, agreements, understanding, promises, conditions or obligations made or entered by Pink Nannies and its Client other than those contained herein. No Modifications to this Agreement shall be Valid unless they are in writing and signed by both parties.</p>"
};

var mutations = {};

var actions = {};

var getters = {
  transportationConsent: function transportationConsent(state) {
    return state.transportationConsent;
  },
  useofClientVehicle: function useofClientVehicle(state) {
    return state.useofClientVehicle;
  },
  transportChildrenEmployeeVehicle: function transportChildrenEmployeeVehicle(state) {
    return state.transportChildrenEmployeeVehicle;
  },
  medicalRelease: function medicalRelease(state) {
    return state.medicalRelease;
  },
  familyAgencyContract: function familyAgencyContract(state) {
    return state.familyAgencyContract;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);



var educationLevel = ["High School Diploma", "Associates Degree", "Bachelor’s Degree", "Some College Courses", "Master’s Degree", "PHD"];

var positions = ["Full Time Nanny", "Part Time Nanny", "Private Educator", "Occasional work", "Summer Position", "NCS"];

var candidateSkills = ["skill 1", "skill 2", "skill 3"];

var availabilityOptions = ["Live In", "Live Out", "Both"];

var americanStates = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];

var professionalInfoFields = [{
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Do you have Skype or Facetime? *",
  model: "boolean_selector1"
}, {
  label: "What is your Skype or Facetime information? *",
  model: "text1",
  showIf: "boolean_selector1"
}, {
  label: "Emergency Contact",
  model: "selector1",
  isRequired: false
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Are you Legally Authorized to work in the USA? *",
  labelDetail: "Am I Legally Authorized to work in the USA?",
  model: "boolean_selector2"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Are you currently CPR Certified? *",
  labelDetail: "Am I currently CPR Certified?",
  model: "boolean_selector3"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Are you able to give a one-year commitment to the childcare service you will provide? *",
  labelDetail: "Am I able to give a one-year commitment to the childcare service I will provide?",
  model: "boolean_selector4"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Are you a smoker? *",
  labelDetail: "Am I a smoker?",
  model: "boolean_selector5"
}, {
  label: "Do you speak any languages other than English fluently? (Please list all the languages that you speak fluently.) *",
  labelDetail: "Am I speak any languages other than English fluently?",
  model: "selector2"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
  optionList: educationLevel,
  label: "Let's talk education. What's have you completed? (Check all that apply) *",
  labelDetail: "Let's talk education. What's have I completed?",
  model: "multiselect1"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
  optionList: positions,
  label: "Position you are applying for (check all that apply) *",
  labelDetail: "Position I are applying for",
  model: "multiselect2"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  optionList: availabilityOptions,
  label: "Are you looking for a Live-in Position or Live-out Position? *",
  labelDetail: "Am I looking for a Live-in Position or Live-out Position?",
  model: "selector3"
}, {
  label: "Can we call you for Temp or Babysitting positions? *",
  labelDetail: "Can I be called for Temp or Babysitting positions?",
  model: "selector4"
},
// {
//   type: FORM_TYPE.CHECKBOX,
//   optionList: candidateSkills,
//   label: "Skills? (check all that apply) *",
//   labelDetail: "Skills?",
//   model: "multiselect3"
// },
{
  label: "Please list your skills *",
  labelDetail: "Skills",
  model: "text6"
}, {
  label: "Days Available to Work? *",
  labelDetail: "Days Available to Work?",
  model: "text2"
}, {
  label: "Are you open to working on the weekend? *",
  labelDetail: "Am I open to working on the weekend?",
  model: "selector5"
}, {
  label: "Can you swim? Are you a strong swimmer? *",
  labelDetail: "Can I swim? Am I a strong swimmer?",
  model: "selector6"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Can you drive? *",
  labelDetail: "Can I drive?",
  model: "boolean_selector6"
}, {
  label: "Do you have a clean driving record? *",
  labelDetail: "Do I have a clean driving record?",
  model: "selector7"
}, {
  label: "Do you have your own car? *",
  labelDetail: "Do I have my own car?",
  model: "selector8"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Do you have experience with children with special needs? *",
  labelDetail: "Do I have experience with children with special needs?",
  model: "boolean_selector7"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
  label: "Explain? *",
  labelDetail: "Explain?",
  model: "text3",
  showIf: "boolean_selector7"
}, {
  label: "Do you have newborn experience? *",
  labelDetail: "Do I have newborn experience?",
  model: "selector9"
}, {
  label: "Any allergies? *",
  labelDetail: "Any allergies?",
  model: "selector10"
}, {
  label: "Can you work in a home with pets? *",
  labelDetail: "Can I work in a home with pets?",
  model: "selector11"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
  label: "Are you willing to travel? (Do not say yes, if you cannot.) *",
  labelDetail: "Am I willing to travel?",
  model: "boolean_selector8"
}, {
  label: "Desired hourly rates? What is your target pay? *",
  labelDetail: "Desired hourly rates? What is my target pay?",
  model: "selector12"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
  label: "Have you received the COVID vaccine? If you have, when did you receive it, and which vaccine did you receive (ie. Pfizer, Moderna, Johnson & Johnson)? If not, are you scheduled to receive it (if so, when)? *",
  rows: 3,
  model: "text7"
}, {
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
  label: "Tell us about yourself. *",
  rows: 5,
  model: "text4"
}];

var state = {
  experienceOptions: ["2-5 years", "5-10 years", "10 plus years"],
  commitmentOptions: ["Long Term (longer than 1 year)", "Short Term (1 year or less)", "Temporary"],
  availabilityOptions: availabilityOptions,
  drvingStatuses: ["D.L. and Car", "Driver's License only", "Neither"],
  certificationStatuses: ["Yes", "Willing to get certified", "No"],
  vaccinationStatuses: ["Yes", "Willing to get", "No"],
  petsOptions: ["Dog", "Cat", "Neither"],
  travelOptions: ["Domestic", "International", "No travel"],
  candidateStatuses: ["Pre Application", "Applied", "Rejected", "Phone Screen Complete", "Interview Booked", "Interview Complete",
  // "Waiting on Agency Resume",
  // "Agency Resume Complete",
  "Profile Pending Review", "Documentation Complete", "Reference Check Complete", "Accepted",
  // "Temp Care",
  "Trialing", "Offer",
  // "Background Check Complete",
  "Inactive", "Hired"],
  candidateActiveStatus: "Accepted",
  candidateSkills: candidateSkills,
  positions: positions,
  professionalInfoFields: professionalInfoFields,
  candidatePersonalInfoListFields: [{
    label: "First Name *",
    itemPerRow: 2,
    model: "first_name"
  }, {
    label: "Last Name *",
    itemPerRow: 2,
    model: "last_name"
  }, {
    label: "Street Address *",
    model: "address1"
  }, {
    label: "City *",
    itemPerRow: 3,
    model: "city"
  },
  // {
  //   label: "State *",
  //   itemPerRow: 3,
  //   model: "provincestate"
  // },
  {
    label: "State *",
    model: "provincestate",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].DROPDOWN,
    optionList: americanStates,
    itemPerRow: 3
    // isRequired: false
  }, {
    label: "Zip code *",
    itemPerRow: 3,
    maxLength: 12,
    inputType: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["c" /* TEXTBOX_INPUT_TYPE */].POSITIVE_INTEGER,
    model: "postal_code"
  }, {
    label: "Home Number *",
    itemPerRow: 2,
    model: "phone"
  }, {
    label: "Cell phone *",
    itemPerRow: 2,
    model: "phone2"
  }, {
    label: "Email *",
    model: "email",
    validation: [{
      regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      message: "Please enter a valid email."
    }]
  }].concat(professionalInfoFields),
  referenceListFields: [{
    label: "Professional Reference Names? *",
    model: "name"
  }, {
    label: "Location *",
    model: "text1"
  }, {
    label: "Best Number to Contact Reference? *",
    model: "phone"
  }, {
    label: "Best Email",
    model: "email",
    isRequired: false,
    validation: [{
      regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      message: "Please enter a valid email."
    }]
  }, {
    label: "Best time to contact *",
    model: "text2"
  }, {
    label: "Dates of employment? *",
    model: "text3"
  }, {
    label: "Number of children under your care? *",
    labelDetail: "Number of children under my care?",
    model: "selector1",
    inputType: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["c" /* TEXTBOX_INPUT_TYPE */].POSITIVE_INTEGER
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "What were your responsibilities? *",
    labelDetail: "What were my responsibilities?",
    model: "text4"
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Reason/s for Leaving? *",
    model: "text5"
  }]
};

var mutations = {};

var actions = {};

var getters = {
  experienceOptions: function experienceOptions(state) {
    return state.experienceOptions;
  },
  commitmentOptions: function commitmentOptions(state) {
    return state.commitmentOptions;
  },
  availabilityOptions: function availabilityOptions(state) {
    return state.availabilityOptions;
  },
  drvingStatuses: function drvingStatuses(state) {
    return state.drvingStatuses;
  },
  certificationStatuses: function certificationStatuses(state) {
    return state.certificationStatuses;
  },
  vaccinationStatuses: function vaccinationStatuses(state) {
    return state.vaccinationStatuses;
  },
  petsOptions: function petsOptions(state) {
    return state.petsOptions;
  },
  travelOptions: function travelOptions(state) {
    return state.travelOptions;
  },
  candidateStatuses: function candidateStatuses(state) {
    return state.candidateStatuses;
  },
  candidateActiveStatus: function candidateActiveStatus(state) {
    return state.candidateActiveStatus;
  },
  candidateSkills: function candidateSkills(state) {
    return state.candidateSkills;
  },
  professionalInfoFields: function professionalInfoFields(state) {
    return state.professionalInfoFields;
  },
  candidatePersonalInfoListFields: function candidatePersonalInfoListFields(state) {
    return state.candidatePersonalInfoListFields;
  },
  referenceListFields: function referenceListFields(state) {
    return state.referenceListFields;
  },
  positions: function positions(state) {
    return state.positions;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_employer__ = __webpack_require__(96);




var genders = ["Male", "Female", "Other"];

var americanStates = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];

var childrenListFieldsBase = [{ label: "First Name: *", model: "first_name", itemPerRow: 2 }, { label: "Last Name: ", model: "last_name", itemPerRow: 2, isRequired: false }, {
  label: "Gender:",
  model: "gender",
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].DROPDOWN,
  optionList: genders,
  itemPerRow: 2,
  isRequired: false
}, {
  label: "Birth date: ",
  model: "birthday",
  type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].DATEPICKER,
  itemPerRow: 2,
  isRequired: false
}];

var state = {
  employerStatuses: ["Pre Application", "Applied", "Inactive", "Application Approved", "Welcome Call Complete",
  // "Package Selected",
  "Payment Info Entered", "Documents Signed",
  // 'Consultation Booked',
  // "Consultation Complete",
  "Active", "Nanny Assigned", "Lost", "Placement Fee Paid"],
  childrenListFieldsNewBorn: [].concat(childrenListFieldsBase, [{
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Personality, interests and hobbies? ",
    isRequired: false,
    model: "text1"

  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Any special needs, dietary restrictions or allergies? *",
    model: "text2"
  }]),
  childrenListFieldsSitter: [].concat(childrenListFieldsBase, [{
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Personality, interests and hobbies? ",
    isRequired: false,
    model: "text1"
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Any special needs, dietary restrictions or allergies? *",
    model: "text2"
  }]),
  childrenListFieldsNanny: [].concat(childrenListFieldsBase, [{
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Personality, interests and hobbies ",
    isRequired: false,
    model: "text1"
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Any special needs, dietary restrictions or allergies? *",
    model: "text2"
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Any fears that need to be noted?",
    isRequired: false,
    model: "text3"
  }]),
  childrenListFieldsPrivateEducator: [].concat(childrenListFieldsBase, [{
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTBOX,
    label: "Grade Level ",
    model: "text3",
    isRequired: false
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Personality, interests and hobbies ",
    model: "text1",
    isRequired: false
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Any special needs, dietary restrictions or allergies? *",
    model: "text2"
  }]),
  familyInformationListFields: [{
    label: "Type of Service Needed: *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    optionList: Object.values(__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */]),
    model: "selector1",
    initialSelection: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].SLOT,
    name: "service-note"
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].HEADER,
    label: "Contact Information:"
  }, {
    label: "Parent/Guardian 1 First Name: *",
    model: "first_name",
    itemPerRow: 2
  }, {
    label: "Parent/Guardian 1 Last Name: *",
    model: "last_name",
    itemPerRow: 2
  }, {
    label: "Parent/Guardian 1 Email: *",
    model: "email",
    itemPerRow: 2,
    validation: [{
      regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      message: "Please enter a valid email."
    }]
  }, {
    label: "Parent/Guardian 1 Phone: *",
    itemPerRow: 2,
    model: "phone"
  }, {
    label: "Parent/Guardian 1 Occupation: *",
    model: "selector4"
  }, {
    label: "Parent/Guardian 2 First Name: ",
    model: "selector2",
    itemPerRow: 2,
    isRequired: false
  }, {
    label: "Parent/Guardian 2 Last Name: ",
    model: "selector3",
    itemPerRow: 2,
    isRequired: false
  }, {
    label: "Parent/Guardian 2 Email: ",
    model: "email2",
    itemPerRow: 2,
    validation: [{
      regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      message: "Please enter a valid email."
    }],
    isRequired: false
  }, {
    label: "Parent/Guardian 2 Phone: ",
    itemPerRow: 2,
    model: "phone2",
    isRequired: false
  }, {
    label: "Parent/Guardian 2 Occupation: ",
    model: "selector5",
    isRequired: false
  }, {
    label: "Street Address: *",
    model: "address1"
  }, {
    label: "Street Address line 2:",
    model: "address2",
    isRequired: false
  }, {
    label: "City: *",
    itemPerRow: 3,
    model: "city"
  },
  // {
  //   label: "State: *",
  //   itemPerRow: 3,
  //   model: "provincestate"
  // },
  {
    label: "State: *",
    model: "provincestate",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].DROPDOWN,
    optionList: americanStates,
    itemPerRow: 3
    // isRequired: false
  }, {
    label: "Zip Code: *",
    itemPerRow: 3,
    maxLength: 12,
    inputType: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["c" /* TEXTBOX_INPUT_TYPE */].POSITIVE_INTEGER,
    model: "postal_code"
  }, {
    label: "Best time to reach you? *",
    labelDetail: "Best time to reach me? *",
    model: "selector6",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].SITTER, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    label: "If this is a hotel sitting, where will you be staying?",
    labelDetail: "If this is a hotel sitting, where will me be staying?",
    isRequired: false,
    model: "selector7",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].SITTER
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "When do you need the sitter and for how long? *",
    labelDetail: "When do I need the sitter and for how long?",
    model: "text1",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].SITTER
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].SLOT,
    name: "children"
  }, {
    label: "Are you expecting any more children within the next year? *",
    labelDetail: "Am I expecting any more children within the next year?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector1",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    label: "Desired Start Date: *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].DATEPICKER,
    model: "available_date",
    allowPastDate: false,
    initialView: "month",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "What qualities and characteristics are you looking for in a Newborn Care Specialist? *",
    labelDetail: "What qualities and characteristics am I looking for in a Newborn Care Specialist?",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN,
    model: "text2"
  }, {
    label: "Do you have any Pets? *",
    labelDetail: "Do I have any Pets?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector2",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "How many, the type of pets, size (for dogs please list weight) and whether the caregiver would be responsible for any pet care. *",
    showIf: "boolean_selector2",
    model: "text3"
  }, {
    label: "Will the nanny be *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    optionList: ["Live-in", "Live Out", "Weekend, ", "Summer/Temporary", "Mother’s Helper, ", "Traveling Childcare provider", "Governess/Private Educator", "Household Manager"],
    model: "multiselect1",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    label: "Which option best describes what you're looking for? *",
    labelDetail: "Which option best describes what I am looking for?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    optionList: ["Live Out", "Live in", "Traveling"],
    model: "selector19",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    label: "Will you need the nanny to *",
    labelDetail: "Will I need the nanny to",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    optionList: ["Swim", "Drive (Care will be provided)", "Drive-(must own car)"],
    model: "multiselect2",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "What is your desired Weekly Schedule? *",
    labelDetail: "What is my desired Weekly Schedule?",
    model: "text4",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "What responsibilities will the Private Educator/Governess have? *",
    model: "text9",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "What qualities are you looking for in your candidate? *",
    model: "text10",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "What responsibilities will the nanny have? *",
    model: "text5",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    label: "What qualities are you looking for in a nanny? *",
    labelDetail: "What qualities am I looking for in a nanny?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    optionList: ["Cooks for children", "does laundry for children", "Does laundry for family", "Cooks for family", "Does Ironing for kids", "Helps Children with School work", "Help children with remote school work"],
    model: "multiselect3",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Any others?",
    isRequired: false,
    model: "text6",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    label: "Will you need the candidate to *",
    labelDetail: "Will I need the candidate to ",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    optionList: ["Swim", "Drive (Care will be provided)", "Drive-(must own car)"],
    model: "multiselect2",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    label: "What accommodations and benefits will you provide the nanny? *",
    labelDetail: "What accommodations and benefits will I provide the nanny?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    optionList: ["Major Holidays Off", "Paid Vacation", "Paid Travel with family", "Bonus", "Sick/Mental Health/Personal Days", "Private Bathroom", "Private Bedroom", "Mileage Reimbursement (On-the- job Transportation?", "Tuition Reimbursement for Child related course", "Health Care Contribution", "Cell Phone", "401K Contribution"],
    model: "preferences",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    label: "Have you ever employed a nanny before? *",
    labelDetail: "Have I ever employed a nanny before? *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector7",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Please tell us what you liked or about your previous nanny *",
    model: "text7",
    showIf: "boolean_selector7"
  }, {
    label: "Have you employed a Private Educator/Governess before? *",
    labelDetail: "Have I employed a Private Educator/Governess before?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector9",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Please tell us what you liked or disliked about the previous employee? *",
    model: "text7",
    showIf: "boolean_selector9"
  }, {
    label: "Will a car be provided? *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector3",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    label: "Would you consider hiring a person that is not able to drive? *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector4",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    label: "Would you consider hiring a Newborn Care Specialist outside your location? *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector5",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    label: "Are you comfortable paying for their transportation? *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector6",
    showIf: "boolean_selector5"
  }, {
    label: "What accommodations and benefits will you provide the NCS? *",
    labelDetail: "What accommodations and benefits will I provide the NCS?",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    model: "multiselect1",
    optionList: ["Private Bedroom", "Shared Bath", "TV", "Health Insurance", "Paid travel with family", "Paid Vacation", "Major Holidays Off", "Bonus", "Meals"],
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    label: "Please let us know how long you would have the care provider for *",
    labelDetail: "Please let us know how long I would have the care provider for *",
    model: "selector9",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    label: "Candidate Hourly rate *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    model: "preferences2",
    optionList: ["$25-29", "$30-35", "$35+"],
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR]
  }, {
    label: "Salary Compensation Range *",
    model: "selector20",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "Please provide any additional information that can help us in finding your ideal candidate. Do have any teaching styles that you would like them to have? *",
    model: "text10",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }, {
    label: "Per Day Pay Range: *",
    model: "selector11",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN
  }, {
    label: "Do you need us to introduce you to a company to set up payroll for your employee? *",
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].RADIO,
    model: "boolean_selector8",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].SLOT,
    name: "nanny-form-fee-notice",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].TEXTAREA,
    label: "If you have any household pets, please explain (dogs - please list weight)",
    labelDetail: "Explain about any household pets",
    model: "text8",
    isRequired: false,
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    label: "Weekly GROSS Salary Range (estimate) *",
    model: "selector12",
    showIf: "selector1",
    showIfValue: [__WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NEW_BORN, __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY]
  }, {
    label: "Hourly Rate *",
    model: "selector17",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    label: "Overtime Rate *",
    model: "selector18",
    showIf: "selector1",
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    label: "How did you hear about Tiny Treasures NYC? *",
    labelDetail: "How did I hear about Tiny Trasures NYC?",
    model: "marketing_source"
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    model: "confirm1",
    showIf: "selector1",
    optionList: ["Please confirm that you understand that Tiny Treasures Nanny Agency is a household staffing firm that you, the client, is hiring to find vetted and screened professional candidates. The non-refundable registration fee is not the placement fee for finding a candidate. This placement fee is only due if we find you an amazing candidate. Each client will be invoiced based on their search choice. The registration fee will then be credited to the final invoice. This fee is 15%-20% of a candidates gross annual salary. An invoice is sent once you agree to hire our candidate directly or indirectly. Please confirm that you understand our fee schedule."],
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].NANNY
  }, {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_custom_define_type__["b" /* FORM_TYPE */].CHECKBOX,
    model: "confirm1",
    showIf: "selector1",
    optionList: ["Please confirm that you understand that Tiny Treasures Nanny Agency is a household staffing firm that you, the client, is hiring to find vetted and screened professional candidates. The non-refundable registration fee is not the placement fee for finding a candidate. This placement fee is only due if we find you an amazing candidate. Each client will be invoiced based on their search choice. The 80% of the registration fee will then be credited to the final invoice. This fee is 15%-20% of a candidates gross annual salary. An invoice is sent once you agree to hire our candidate directly or indirectly. Please confirm that you understand our fee schedule."],
    showIfValue: __WEBPACK_IMPORTED_MODULE_1__constants_employer__["a" /* SERVICE_TYPE */].PRIVATE_EDUCATOR
  }]
};

var mutations = {};

var actions = {};

var getters = {
  employerStatuses: function employerStatuses(state) {
    return state.employerStatuses;
  },
  familyInformationListFields: function familyInformationListFields(state) {
    return state.familyInformationListFields;
  },
  childrenListFieldsNewBorn: function childrenListFieldsNewBorn(state) {
    return state.childrenListFieldsNewBorn;
  },
  childrenListFieldsSitter: function childrenListFieldsSitter(state) {
    return state.childrenListFieldsSitter;
  },
  childrenListFieldsNanny: function childrenListFieldsNanny(state) {
    return state.childrenListFieldsNanny;
  },
  childrenListFieldsPrivateEducator: function childrenListFieldsPrivateEducator(state) {
    return state.childrenListFieldsPrivateEducator;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  website: 'https://www.tinytreasuresnyc.com/',
  platformURL: 'https://ttna.enginehire.io/',
  platformLoginURL: 'https://ttna.enginehire.io/login',
  agencyHumanName: 'Tiny Treasures',
  agencyShortName: 'TTNA'
};

var mutations = {};

var actions = {};

var getters = {
  website: function website(state) {
    return state.website;
  },
  platformURL: function platformURL(state) {
    return state.platformURL;
  },
  platformLoginURL: function platformLoginURL(state) {
    return state.platformLoginURL;
  },
  agencyHumanName: function agencyHumanName(state) {
    return state.agencyHumanName;
  },
  agencyShortName: function agencyShortName(state) {
    return state.agencyShortName;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  months: [{ short: 'Jan', number: '01' }, { short: 'Feb', number: '02' }, { short: 'Mar', number: '03' }, { short: 'Apr', number: '04' }, { short: 'May', number: '05' }, { short: 'Jun', number: '06' }, { short: 'Jul', number: '07' }, { short: 'Aug', number: '08' }, { short: 'Sep', number: '09' }, { short: 'Oct', number: '10' }, { short: 'Nov', number: '11' }, { short: 'Dec', number: '12' }]
};

var mutations = {};

var actions = {};

var getters = {
  months: function months(state) {
    return state.months;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  errorDialog: null,
  confirmDialog: null,
  resultDialog: null,
  loadingReqNumber: 0
};

var mutations = {
  setErrorDialog: function setErrorDialog(state, payload) {
    state.errorDialog = payload;
  },
  setConfirmDialog: function setConfirmDialog(state, payload) {
    state.confirmDialog = payload;
  },
  setResultDialog: function setResultDialog(state, payload) {
    state.resultDialog = payload;
  },
  increaseLoadingReqNumber: function increaseLoadingReqNumber(state, payload) {
    state.loadingReqNumber += payload;
  }
};

var actions = {
  setErrorDialog: function setErrorDialog(_ref, payload) {
    var commit = _ref.commit;

    commit("setErrorDialog", payload);
  },
  setConfirmDialog: function setConfirmDialog(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setConfirmDialog", payload);
  },
  setResultDialog: function setResultDialog(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setResultDialog", payload);
  },
  increaseLoadingReqNumber: function increaseLoadingReqNumber(_ref4, payload) {
    var commit = _ref4.commit;

    commit("increaseLoadingReqNumber", payload);
  }
};

var getters = {
  loadingReqNumber: function loadingReqNumber(state) {
    return state.loadingReqNumber;
  },
  errorDialog: function errorDialog(state) {
    return state.errorDialog;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  invalidInputError: {
    title: "A required field is missing or a field is invalid.",
    message: "Please review the form for error messages!"
  },
  missingReferenceError: {
    title: "Please add references!",
    message: "You must have at least 3 references."
  },
  invalidImageFileError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a PNG or JPG image."
  },
  invalidResumeFileError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a DOC or DOCX or PDF file."
  },
  missingResumeError: {
    title: "Your professional childcare resume is missing",
    message: "Please upload your professional childcare resume"
  },
  missingProfilePictureError: {
    title: "Your profile picture is missing",
    message: "Please upload a recent photo of yourself!"
  },
  submitSuccess: {
    title: "Thank you for your application to join the Tiny Treasures Family!",
    message: "We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the nannies we select. Thanks for your understanding! You can now safely close this window."
  },
  submitSuccessFamilyForm: {
    title: "Thank you for submitting your application!",
    message: "We will review and get in touch with you shortly!"
  },
  submitReferenceError: {
    title: "Your application has been submitted! BUT",
    message: "There was an error processing your references. Can you please email them to pinknannies@gmail.com? Thanks!"
  },
  submitChildrenError: {
    title: "Your application has been submitted! BUT",
    message: "There was an error processing your children information. Can you please email them to pinknannies@gmail.com? Thanks!"
  },
  submitError: {
    title: "Failed to submit your application",
    message: "There was an error processing your application"
  },
  updateProfessionalInfoError: {
    title: "Failed to update professional information",
    message: "There was an error updating professional information"
  },
  deleteReferenceConfirmDialog: {
    message: "Are you sure you want to delete this reference?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteChildrenConfirmDialog: {
    message: "Are you sure you want to delete this child?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  }
};

var mutations = {};

var actions = {};

var getters = {
  invalidInputError: function invalidInputError(state) {
    return state.invalidInputError;
  },
  missingReferenceError: function missingReferenceError(state) {
    return state.missingReferenceError;
  },
  invalidImageFileError: function invalidImageFileError(state) {
    return state.invalidImageFileError;
  },
  missingResumeError: function missingResumeError(state) {
    return state.missingResumeError;
  },
  missingProfilePictureError: function missingProfilePictureError(state) {
    return state.missingProfilePictureError;
  },
  submitReferenceError: function submitReferenceError(state) {
    return state.submitReferenceError;
  },
  submitSuccess: function submitSuccess(state) {
    return state.submitSuccess;
  },
  submitError: function submitError(state) {
    return state.submitError;
  },
  deleteReferenceConfirmDialog: function deleteReferenceConfirmDialog(state) {
    return state.deleteReferenceConfirmDialog;
  },
  submitSuccessFamilyForm: function submitSuccessFamilyForm(state) {
    return state.submitSuccessFamilyForm;
  },
  deleteChildrenConfirmDialog: function deleteChildrenConfirmDialog(state) {
    return state.deleteChildrenConfirmDialog;
  },
  invalidResumeFileError: function invalidResumeFileError(state) {
    return state.invalidResumeFileError;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    showErrorDialog: function showErrorDialog(error) {
      this.$store.dispatch("setErrorDialog", error);
    },
    hideErrorDialog: function hideErrorDialog() {
      this.$store.dispatch("setErrorDialog", null);
    },
    showConfirmDialog: function showConfirmDialog(confirm) {
      this.$store.dispatch("setConfirmDialog", confirm);
    },
    hideConfirmDialog: function hideConfirmDialog() {
      this.$store.dispatch("setConfirmDialog", null);
    },
    showResultDialog: function showResultDialog(result) {
      this.$store.dispatch("setResultDialog", result);
    },
    hideResultDialog: function hideResultDialog() {
      this.$store.dispatch("setResultDialog", null);
    },
    showLoading: function showLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", 1);
    },
    hideLoading: function hideLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", -1);
    }
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_custom_define_type__ = __webpack_require__(18);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    getValueOfObjectKey: function getValueOfObjectKey(dataObject, key) {
      var tokens = key.split(/[\.\[\]]+/);
      var objValue = dataObject;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var token = _step.value;

          if (token.length === 0) {
            continue;
          }
          objValue = objValue[token];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return objValue;
    },
    isMissingField: function isMissingField(dataObject, fieldName, type) {
      var objValue = this.getValueOfObjectKey(dataObject, fieldName);
      if (objValue == null) {
        return true;
      }
      if (type === __WEBPACK_IMPORTED_MODULE_1__constants_custom_define_type__["b" /* FORM_TYPE */].DAY_HOURS_SELECTOR) {
        /*
        objValue includes 5 element (corresponding with Monday -> Friday)
        Each row of day hours selector includes a checkbox, and two time picker
        If the checkbox is not check, the corresponding value is "" (empty string)
        If the checkbox is checked, but none of the time picker is filled, the value is ","
        If the checkbox is checked, but the 'from' time picker is not filled, the value is ",to"
        If the checkbox is checked, but the 'to' time picker is not filled, the value is "from,"
        */

        // Check if all checkbox is unchecked.
        if (!objValue.some(function (val) {
          return val != null && val !== "";
        })) {
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = objValue[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var val = _step2.value;

              // If value contains ',' => checkbox is checked.
              if (val.includes(",")) {
                var tokens = val.split(",");
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = tokens[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var token = _step3.value;

                    // Check if 'from' or 'to' is missing
                    if (token.trim().length === 0) {
                      return true;
                    }
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }

      if (type === __WEBPACK_IMPORTED_MODULE_1__constants_custom_define_type__["b" /* FORM_TYPE */].SALARY_RANGE) {
        // objValue of salary range includes 3 element (min salary, max salary, salary option)
        // If any of those value is empty => the field is not filled
        if (objValue == null) {
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = objValue[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _val = _step4.value;

              if (_val.trim().length === 0) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      }
      // Empty string
      if (typeof objValue === "string") {
        if (objValue.length === 0) {
          return true;
        }
      }
      if ((typeof objValue === "undefined" ? "undefined" : _typeof(objValue)) === "object") {
        if (Array.isArray(objValue)) {
          // Empty array
          if (objValue.length === 0) {
            return true;
          }
        } else if (!(objValue instanceof Date)) {
          // Empty object
          if (Object.keys(objValue).length === 0) {
            return true;
          }
        }
      }
      return false;
    },
    hasInvalidField: function hasInvalidField(dataObject, listElement) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = listElement[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var element = _step5.value;

          // Ignore the field which is not show
          if (!this.isItemShow(dataObject, element)) {
            continue;
          }
          if (element.validation) {
            var objValue = this.getValueOfObjectKey(dataObject, element.model);
            if (objValue != null && objValue !== "") {
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = element.validation[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var validateItem = _step6.value;

                  if (!validateItem.regex.test(objValue)) {
                    return true;
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            }
          }
          if (element.isRequired === false) {
            continue;
          }
          if (!element.model) {
            continue;
          }
          if (this.isMissingField(dataObject, element.model, element.type)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    hasMissingRequireFieldByKeys: function hasMissingRequireFieldByKeys(dataObject, listRequiredField) {
      var listRequiredCheckbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = listRequiredField[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var requiredField = _step7.value;

          var objValue = this.getValueOfObjectKey(dataObject, requiredField);
          if (objValue == null) {
            return true;
          }
          // Empty string
          if (typeof objValue === "string") {
            if (objValue.length === 0) {
              return true;
            }
          }
          if ((typeof objValue === "undefined" ? "undefined" : _typeof(objValue)) === "object") {
            if (Array.isArray(objValue)) {
              // Empty array
              if (objValue.length === 0) {
                return true;
              }
            } else if (!(objValue instanceof Date)) {
              // Empty object
              if (Object.keys(objValue).length === 0) {
                return true;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      if (listRequiredCheckbox != null) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = listRequiredCheckbox[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var checkboxField = _step8.value;

            var objValue = this.getValueOfObjectKey(dataObject, checkboxField);
            if (objValue != true) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
      return false;
    },
    getFirstNameAndLastName: function getFirstNameAndLastName(name) {
      var trimedName = name.trim();
      if (trimedName.includes(" ")) {
        var spaceIndex = trimedName.indexOf(" ");
        var firstName = trimedName.substr(0, spaceIndex).trim();
        var lastName = trimedName.substr(spaceIndex + 1);
        return { firstName: firstName, lastName: lastName };
      } else {
        return { firstName: trimedName, lastName: "" };
      }
    },
    extractSelectedFields: function extractSelectedFields(inputObject, listFields) {
      var listSelectedKey = listFields.map(function (field) {
        return field.model;
      });
      var result = {};
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = Object.keys(inputObject)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var key = _step9.value;

          if (listSelectedKey.includes(key)) {
            result[key] = inputObject[key];
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return result;
    },
    isUnchangedObject: function isUnchangedObject(object1, object2, listFields) {
      var listSelectedKey = listFields.map(function (field) {
        return field.model;
      });
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = listSelectedKey[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var key = _step10.value;

          if (object1[key] !== object2[key]) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return true;
    },

    // Check if item is showed (Item may not showed if showIf is set)
    isItemShow: function isItemShow(modelData, el) {
      // showIf is not set => item is showed
      if (el.showIf == null) {
        return true;
      }
      /* showIfValue is not set => 
      item is only show if the corresponding value of model for showIf is true (Yes/No radio group)
      */
      if (el.showIfValue == null) {
        return modelData[el.showIf] === true;
      } else {
        /* show if value of dropdown option is in list of option (showIfValue is an array)) */
        if (Array.isArray(el.showIfValue)) {
          return el.showIfValue.includes(modelData[el.showIf]);
        } else {
          /* show if value of dropdown option is one option (showIfValue is string) */
          return modelData[el.showIf] === el.showIfValue;
        }
      }
    },

    // Validate mising file, or file exceed maximum
    isFileValid: function isFileValid(file, isRequired) {
      var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10.24;

      if (file == null) {
        return !isRequired;
      }
      if (file.size > maxSize * 1024 * 1024) {
        return false;
      }
      return true;
    },

    // Validate if a list of file contains any invalid file (missing or file size exceed maximum)
    hasInvalidFile: function hasInvalidFile(uploadFiles, listFileInfo) {
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = listFileInfo[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var item = _step11.value;

          if (!this.isFileValid(uploadFiles[item.model], item.isRequired)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      return false;
    },

    /* This method receive a list of field,
    then filter out all field which is not corresponding with an option.
    In list field input, it contains information of showIf and showIfValue.
    The output will be filtered based on that.
    And it return list of the filtered fields.
    */
    getListFieldModelForOption: function getListFieldModelForOption(listField, option) {
      var _this = this;

      return listField.filter(function (field) {
        // Filter out the fields which does not have model property
        if (!field.model) {
          return false;
        }
        // If showIf is not set, that's mean the field is exist on all options
        if (!field.showIf) {
          return true;
        }
        // showIf is set and showIfValue is not set
        if (field.showIfValue == null) {
          // The existence of item depends on the existence of the refer field (field is specified by showIf)
          var referField = listField.find(function (field2) {
            return field2.model === field.showIf;
          });
          // Check if the refer field is exist,
          if (!referField.showIf) {
            return true;
          }
          if (!referField.showIfValue) {
            // showIfValue is not set => the yes/no radio
            return true;
          } else {
            // Check if the refer field is exist by value of showIfValue
            return _this.isFieldExistForOption(referField, option);
          }
        } else {
          return _this.isFieldExistForOption(field, option);
        }
      });
    },

    /*
    Check if field is exist based on it's showIfValue.
    The input field of this function has both showIf and showIfValue property
    */
    isFieldExistForOption: function isFieldExistForOption(field, option) {
      if (Array.isArray(field.showIfValue)) {
        return field.showIfValue.includes(option);
      } else {
        return field.showIfValue === option;
      }
    }
  }
});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(994)


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Bugsnag = f()}})(function(){var define,module,exports;
var _$breadcrumbTypes_8 = ['navigation', 'request', 'process', 'log', 'user', 'state', 'error', 'manual'];

// Array#reduce
var _$reduce_17 = function (arr, fn, accum) {
  var val = accum;

  for (var i = 0, len = arr.length; i < len; i++) {
    val = fn(val, arr[i], i, arr);
  }

  return val;
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#filter


var _$filter_12 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return !fn(item, i, arr) ? accum : accum.concat(item);
  }, []);
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#includes


var _$includes_13 = function (arr, x) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum === true || item === x;
  }, false);
};

// Array#isArray
var _$isArray_14 = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/* eslint-disable-next-line no-prototype-builtins */
var _hasDontEnumBug = !{
  toString: null
}.propertyIsEnumerable('toString');

var _dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor']; // Object#keys

var _$keys_15 = function (obj) {
  // stripped down version of
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
  var result = [];
  var prop;

  for (prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
  }

  if (!_hasDontEnumBug) return result;

  for (var i = 0, len = _dontEnums.length; i < len; i++) {
    if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
  }

  return result;
};

var _$intRange_24 = function (min, max) {
  if (min === void 0) {
    min = 1;
  }

  if (max === void 0) {
    max = Infinity;
  }

  return function (value) {
    return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
  };
};

/* removed: var _$filter_12 = require('../es-utils/filter'); */;

/* removed: var _$isArray_14 = require('../es-utils/is-array'); */;

var _$listOfFunctions_25 = function (value) {
  return typeof value === 'function' || _$isArray_14(value) && _$filter_12(value, function (f) {
    return typeof f === 'function';
  }).length === value.length;
};

var _$stringWithLength_26 = function (value) {
  return typeof value === 'string' && !!value.length;
};

var _$config_5 = {};
/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;

/* removed: var _$isArray_14 = require('./lib/es-utils/is-array'); */;

/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;

/* removed: var _$intRange_24 = require('./lib/validators/int-range'); */;

/* removed: var _$stringWithLength_26 = require('./lib/validators/string-with-length'); */;

/* removed: var _$listOfFunctions_25 = require('./lib/validators/list-of-functions'); */;

/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;

var defaultErrorTypes = function () {
  return {
    unhandledExceptions: true,
    unhandledRejections: true
  };
};

_$config_5.schema = {
  apiKey: {
    defaultValue: function () {
      return null;
    },
    message: 'is required',
    validate: _$stringWithLength_26
  },
  appVersion: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  appType: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  autoDetectErrors: {
    defaultValue: function () {
      return true;
    },
    message: 'should be true|false',
    validate: function (value) {
      return value === true || value === false;
    }
  },
  enabledErrorTypes: {
    defaultValue: function () {
      return defaultErrorTypes();
    },
    message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
    allowPartialObject: true,
    validate: function (value) {
      // ensure we have an object
      if (typeof value !== 'object' || !value) return false;
      var providedKeys = _$keys_15(value);
      var defaultKeys = _$keys_15(defaultErrorTypes()); // ensure it only has a subset of the allowed keys

      if (_$filter_12(providedKeys, function (k) {
        return _$includes_13(defaultKeys, k);
      }).length < providedKeys.length) return false; // ensure all of the values are boolean

      if (_$filter_12(_$keys_15(value), function (k) {
        return typeof value[k] !== 'boolean';
      }).length > 0) return false;
      return true;
    }
  },
  onError: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onSession: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onBreadcrumb: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  endpoints: {
    defaultValue: function () {
      return {
        notify: 'https://notify.bugsnag.com',
        sessions: 'https://sessions.bugsnag.com'
      };
    },
    message: 'should be an object containing endpoint URLs { notify, sessions }',
    validate: function (val) {
      return (// first, ensure it's an object
        val && typeof val === 'object' && // notify and sessions must always be set
        _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
        _$filter_12(_$keys_15(val), function (k) {
          return !_$includes_13(['notify', 'sessions'], k);
        }).length === 0
      );
    }
  },
  autoTrackSessions: {
    defaultValue: function (val) {
      return true;
    },
    message: 'should be true|false',
    validate: function (val) {
      return val === true || val === false;
    }
  },
  enabledReleaseStages: {
    defaultValue: function () {
      return null;
    },
    message: 'should be an array of strings',
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$filter_12(value, function (f) {
        return typeof f === 'string';
      }).length === value.length;
    }
  },
  releaseStage: {
    defaultValue: function () {
      return 'production';
    },
    message: 'should be a string',
    validate: function (value) {
      return typeof value === 'string' && value.length;
    }
  },
  maxBreadcrumbs: {
    defaultValue: function () {
      return 25;
    },
    message: 'should be a number ≤100',
    validate: function (value) {
      return _$intRange_24(0, 100)(value);
    }
  },
  enabledBreadcrumbTypes: {
    defaultValue: function () {
      return _$breadcrumbTypes_8;
    },
    message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(',') + ")",
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$reduce_17(value, function (accum, maybeType) {
        if (accum === false) return accum;
        return _$includes_13(_$breadcrumbTypes_8, maybeType);
      }, true);
    }
  },
  context: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || typeof value === 'string';
    }
  },
  user: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object with { id, email, name } properties',
    validate: function (value) {
      return value === null || value && _$reduce_17(_$keys_15(value), function (accum, key) {
        return accum && _$includes_13(['id', 'email', 'name'], key);
      }, true);
    }
  },
  metadata: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object',
    validate: function (value) {
      return typeof value === 'object' && value !== null;
    }
  },
  logger: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be null or an object with methods { debug, info, warn, error }',
    validate: function (value) {
      return !value || value && _$reduce_17(['debug', 'info', 'warn', 'error'], function (accum, method) {
        return accum && typeof value[method] === 'function';
      }, true);
    }
  },
  redactedKeys: {
    defaultValue: function () {
      return ['password'];
    },
    message: 'should be an array of strings|regexes',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (s) {
        return typeof s === 'string' || s && typeof s.test === 'function';
      }).length;
    }
  },
  plugins: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of plugin objects',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (p) {
        return p && typeof p === 'object' && typeof p.load === 'function';
      }).length;
    }
  }
};

// extends helper from babel
// https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
var _$assign_11 = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#map


var _$map_16 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum.concat(fn(item, i, arr));
  }, []);
};

var schema = _$config_5.schema;

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

var _$config_1 = {
  releaseStage: _$assign_11({}, schema.releaseStage, {
    defaultValue: function () {
      if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
      return 'production';
    }
  }),
  logger: _$assign_11({}, schema.logger, {
    defaultValue: function () {
      return (// set logger based on browser capability
        typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined
      );
    }
  })
};

var getPrefixedConsole = function () {
  var logger = {};
  var consoleLog = console.log;
  _$map_16(['debug', 'info', 'warn', 'error'], function (method) {
    var consoleMethod = console[method];
    logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
  });
  return logger;
};

var Breadcrumb =
/*#__PURE__*/
function () {
  function Breadcrumb(message, metadata, type, timestamp) {
    if (timestamp === void 0) {
      timestamp = new Date();
    }

    this.type = type;
    this.message = message;
    this.metadata = metadata;
    this.timestamp = timestamp;
  }

  var _proto = Breadcrumb.prototype;

  _proto.toJSON = function toJSON() {
    return {
      type: this.type,
      name: this.message,
      timestamp: this.timestamp,
      metaData: this.metadata
    };
  };

  return Breadcrumb;
}();

var _$Breadcrumb_3 = Breadcrumb;

var _$stackframe_34 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('stackframe', [], factory);
  } else if (typeof _$stackframe_34 === 'object') {
    _$stackframe_34 = factory();
  } else {
    root.StackFrame = factory();
  }
})(this, function () {
  'use strict';

  function _isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  }

  function _getter(p) {
    return function () {
      return this[p];
    };
  }

  var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
  var numericProps = ['columnNumber', 'lineNumber'];
  var stringProps = ['fileName', 'functionName', 'source'];
  var arrayProps = ['args'];
  var props = booleanProps.concat(numericProps, stringProps, arrayProps);

  function StackFrame(obj) {
    if (obj instanceof Object) {
      for (var i = 0; i < props.length; i++) {
        if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
          this['set' + _capitalize(props[i])](obj[props[i]]);
        }
      }
    }
  }

  StackFrame.prototype = {
    getArgs: function () {
      return this.args;
    },
    setArgs: function (v) {
      if (Object.prototype.toString.call(v) !== '[object Array]') {
        throw new TypeError('Args must be an Array');
      }

      this.args = v;
    },
    getEvalOrigin: function () {
      return this.evalOrigin;
    },
    setEvalOrigin: function (v) {
      if (v instanceof StackFrame) {
        this.evalOrigin = v;
      } else if (v instanceof Object) {
        this.evalOrigin = new StackFrame(v);
      } else {
        throw new TypeError('Eval Origin must be an Object or StackFrame');
      }
    },
    toString: function () {
      var functionName = this.getFunctionName() || '{anonymous}';
      var args = '(' + (this.getArgs() || []).join(',') + ')';
      var fileName = this.getFileName() ? '@' + this.getFileName() : '';
      var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
      var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
      return functionName + args + fileName + lineNumber + columnNumber;
    }
  };

  for (var i = 0; i < booleanProps.length; i++) {
    StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);

    StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
      return function (v) {
        this[p] = Boolean(v);
      };
    }(booleanProps[i]);
  }

  for (var j = 0; j < numericProps.length; j++) {
    StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);

    StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
      return function (v) {
        if (!_isNumber(v)) {
          throw new TypeError(p + ' must be a Number');
        }

        this[p] = Number(v);
      };
    }(numericProps[j]);
  }

  for (var k = 0; k < stringProps.length; k++) {
    StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);

    StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
      return function (v) {
        this[p] = String(v);
      };
    }(stringProps[k]);
  }

  return StackFrame;
});

var _$errorStackParser_31 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('error-stack-parser', ['stackframe'], factory);
  } else if (typeof _$errorStackParser_31 === 'object') {
    _$errorStackParser_31 = factory(_$stackframe_34);
  } else {
    root.ErrorStackParser = factory(root.StackFrame);
  }
})(this, function ErrorStackParser(StackFrame) {
  'use strict';

  var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
  var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
  var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
  return {
    /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */
    parse: function ErrorStackParser$$parse(error) {
      if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
        return this.parseOpera(error);
      } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
        return this.parseV8OrIE(error);
      } else if (error.stack) {
        return this.parseFFOrSafari(error);
      } else {
        throw new Error('Cannot parse given Error object');
      }
    },
    // Separate line and column numbers from a string of the form: (URI:Line:Column)
    extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
      // Fail-fast but return locations like "(native)"
      if (urlLike.indexOf(':') === -1) {
        return [urlLike];
      }

      var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
      var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
      return [parts[1], parts[2] || undefined, parts[3] || undefined];
    },
    parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(CHROME_IE_STACK_REGEXP);
      }, this);
      return filtered.map(function (line) {
        if (line.indexOf('(eval ') > -1) {
          // Throw away eval information until we implement stacktrace.js/stackframe#8
          line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
        }

        var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '('); // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
        // case it has spaces in it, as the string is split on \s+ later on

        var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/); // remove the parenthesized location from the line, if it was matched

        sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
        var tokens = sanitizedLine.split(/\s+/).slice(1); // if a location was matched, pass it to extractLocation() otherwise pop the last token

        var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
        var functionName = tokens.join(' ') || undefined;
        var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
        return new StackFrame({
          functionName: functionName,
          fileName: fileName,
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    },
    parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !line.match(SAFARI_NATIVE_CODE_REGEXP);
      }, this);
      return filtered.map(function (line) {
        // Throw away eval information until we implement stacktrace.js/stackframe#8
        if (line.indexOf(' > eval') > -1) {
          line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
        }

        if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
          // Safari eval frames only have function names and nothing else
          return new StackFrame({
            functionName: line
          });
        } else {
          var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
          var matches = line.match(functionNameRegex);
          var functionName = matches && matches[1] ? matches[1] : undefined;
          var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
          return new StackFrame({
            functionName: functionName,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }
      }, this);
    },
    parseOpera: function ErrorStackParser$$parseOpera(e) {
      if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
        return this.parseOpera9(e);
      } else if (!e.stack) {
        return this.parseOpera10(e);
      } else {
        return this.parseOpera11(e);
      }
    },
    parseOpera9: function ErrorStackParser$$parseOpera9(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
      var lines = e.message.split('\n');
      var result = [];

      for (var i = 2, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);

        if (match) {
          result.push(new StackFrame({
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }

      return result;
    },
    parseOpera10: function ErrorStackParser$$parseOpera10(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
      var lines = e.stacktrace.split('\n');
      var result = [];

      for (var i = 0, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);

        if (match) {
          result.push(new StackFrame({
            functionName: match[3] || undefined,
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }

      return result;
    },
    // Opera 10.65+ Error.stack very similar to FF/Safari
    parseOpera11: function ErrorStackParser$$parseOpera11(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
      }, this);
      return filtered.map(function (line) {
        var tokens = line.split('@');
        var locationParts = this.extractLocation(tokens.pop());
        var functionCall = tokens.shift() || '';
        var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
        var argsRaw;

        if (functionCall.match(/\(([^\)]*)\)/)) {
          argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
        }

        var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
        return new StackFrame({
          functionName: functionName,
          args: args,
          fileName: locationParts[0],
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    }
  };
});

var _$errorStackParser_10 = _$errorStackParser_31;

// Given `err` which may be an error, does it have a stack property which is a string?
var _$hasStack_18 = function (err) {
  return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
};

/**
 * Expose `isError`.
 */
var _$isError_32 = isError;
/**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */

function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;

    case '[object Exception]':
      return true;

    case '[object DOMException]':
      return true;

    default:
      return value instanceof Error;
  }
}

var _$iserror_19 = _$isError_32;

var _$jsRuntime_20 = "yes" ? 'browserjs' : typeof navigator !== 'undefined' && navigator.product === 'ReactNative' ? typeof Expo !== 'undefined' ? 'expojs' : 'reactnativejs' : 'nodejs';

/* removed: var _$assign_11 = require('./es-utils/assign'); */;

var add = function (state, section, keyOrObj, maybeVal) {
  var _updates;

  if (!section) return;
  var updates; // addMetadata("section", null) -> clears section

  if (keyOrObj === null) return clear(state, section); // normalise the two supported input types into object form

  if (typeof keyOrObj === 'object') updates = keyOrObj;
  if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates); // exit if we don't have an updates object at this point

  if (!updates) return; // ensure a section with this name exists

  if (!state[section]) state[section] = {}; // merge the updates with the existing section

  state[section] = _$assign_11({}, state[section], updates);
};

var get = function (state, section, key) {
  if (typeof section !== 'string') return undefined;

  if (!key) {
    return state[section];
  }

  if (state[section]) {
    return state[section][key];
  }

  return undefined;
};

var clear = function (state, section, key) {
  if (typeof section !== 'string') return; // clear an entire section

  if (!key) {
    delete state[section];
    return;
  } // clear a single value from a section


  if (state[section]) {
    delete state[section][key];
  }
};

var _$metadataDelegate_22 = {
  add: add,
  get: get,
  clear: clear
};

var _$stackGenerator_33 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('stack-generator', ['stackframe'], factory);
  } else if (typeof _$stackGenerator_33 === 'object') {
    _$stackGenerator_33 = factory(_$stackframe_34);
  } else {
    root.StackGenerator = factory(root.StackFrame);
  }
})(this, function (StackFrame) {
  return {
    backtrace: function StackGenerator$$backtrace(opts) {
      var stack = [];
      var maxStackSize = 10;

      if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
        maxStackSize = opts.maxStackSize;
      }

      var curr = arguments.callee;

      while (curr && stack.length < maxStackSize && curr['arguments']) {
        // Allow V8 optimizations
        var args = new Array(curr['arguments'].length);

        for (var i = 0; i < args.length; ++i) {
          args[i] = curr['arguments'][i];
        }

        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
          stack.push(new StackFrame({
            functionName: RegExp.$1 || undefined,
            args: args
          }));
        } else {
          stack.push(new StackFrame({
            args: args
          }));
        }

        try {
          curr = curr.caller;
        } catch (e) {
          break;
        }
      }

      return stack;
    }
  };
});

/* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */;

/* removed: var _$stackGenerator_33 = require('stack-generator'); */;

/* removed: var _$hasStack_18 = require('./lib/has-stack'); */;

/* removed: var _$map_16 = require('./lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;

/* removed: var _$jsRuntime_20 = require('./lib/js-runtime'); */;

/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;

/* removed: var _$iserror_19 = require('./lib/iserror'); */;

var Event =
/*#__PURE__*/
function () {
  function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
    if (stacktrace === void 0) {
      stacktrace = [];
    }

    if (handledState === void 0) {
      handledState = defaultHandledState();
    }

    this.apiKey = undefined;
    this.context = undefined;
    this.groupingHash = undefined;
    this.originalError = originalError;
    this._handledState = handledState;
    this.severity = this._handledState.severity;
    this.unhandled = this._handledState.unhandled;
    this.app = {};
    this.device = {};
    this.request = {};
    this.breadcrumbs = [];
    this.threads = [];
    this._metadata = {};
    this._user = {};
    this._session = undefined;
    this.errors = [{
      errorClass: ensureString(errorClass),
      errorMessage: ensureString(errorMessage),
      type: _$jsRuntime_20,
      stacktrace: _$reduce_17(stacktrace, function (accum, frame) {
        var f = formatStackframe(frame); // don't include a stackframe if none of its properties are defined

        try {
          if (JSON.stringify(f) === '{}') return accum;
          return accum.concat(f);
        } catch (e) {
          return accum;
        }
      }, [])
    }]; // Flags.
    // Note these are not initialised unless they are used
    // to save unnecessary bytes in the browser bundle

    /* this.attemptImmediateDelivery, default: true */
  }

  var _proto = Event.prototype;

  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };

  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };

  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto.toJSON = function toJSON() {
    return {
      payloadVersion: '4',
      exceptions: _$map_16(this.errors, function (er) {
        return _$assign_11({}, er, {
          message: er.errorMessage
        });
      }),
      severity: this.severity,
      unhandled: this._handledState.unhandled,
      severityReason: this._handledState.severityReason,
      app: this.app,
      device: this.device,
      request: this.request,
      breadcrumbs: this.breadcrumbs,
      context: this.context,
      groupingHash: this.groupingHash,
      metaData: this._metadata,
      user: this._user,
      session: this._session
    };
  };

  return Event;
}(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
// and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)


var formatStackframe = function (frame) {
  var f = {
    file: frame.fileName,
    method: normaliseFunctionName(frame.functionName),
    lineNumber: frame.lineNumber,
    columnNumber: frame.columnNumber,
    code: undefined,
    inProject: undefined
  }; // Some instances result in no file:
  // - calling notify() from chrome's terminal results in no file/method.
  // - non-error exception thrown from global code in FF
  // This adds one.

  if (f.lineNumber > -1 && !f.file && !f.method) {
    f.file = 'global code';
  }

  return f;
};

var normaliseFunctionName = function (name) {
  return /^global code$/i.test(name) ? 'global code' : name;
};

var defaultHandledState = function () {
  return {
    unhandled: false,
    severity: 'warning',
    severityReason: {
      type: 'handledException'
    }
  };
};

var ensureString = function (str) {
  return typeof str === 'string' ? str : '';
}; // Helpers


Event.getStacktrace = function (error, errorFramesToSkip, backtraceFramesToSkip) {
  if (_$hasStack_18(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip); // error wasn't provided or didn't have a stacktrace so try to walk the callstack

  try {
    return _$filter_12(_$stackGenerator_33.backtrace(), function (frame) {
      return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
    }).slice(1 + backtraceFramesToSkip);
  } catch (e) {
    return [];
  }
};

Event.create = function (maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
  if (errorFramesToSkip === void 0) {
    errorFramesToSkip = 0;
  }

  var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger),
      error = _normaliseError[0],
      internalFrames = _normaliseError[1];

  var event;

  try {
    var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
    // tell the getStacktrace() function to skip the number of frames we know will
    // be from our own functions. This is added to the number of frames deep we
    // were told about
    internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
    // this is how many frames should be removed because they come from our library
    1 + errorFramesToSkip);
    event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
  } catch (e) {
    event = new Event(error.name, error.message, [], handledState, maybeError);
  }

  if (error.name === 'InvalidError') {
    event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
  }

  return event;
};

var makeSerialisable = function (err) {
  if (err === null) return 'null';
  if (err === undefined) return 'undefined';
  return err;
};

var normaliseError = function (maybeError, tolerateNonErrors, component, logger) {
  var error;
  var internalFrames = 0;

  var createAndLogInputError = function (reason) {
    if (logger) logger.warn(component + " received a non-error: \"" + reason + "\"");
    var err = new Error(component + " received a non-error. See \"" + component + "\" tab for more detail.");
    err.name = 'InvalidError';
    return err;
  }; // In some cases:
  //
  //  - the promise rejection handler (both in the browser and node)
  //  - the node uncaughtException handler
  //
  // We are really limited in what we can do to get a stacktrace. So we use the
  // tolerateNonErrors option to ensure that the resulting error communicates as
  // such.


  if (!tolerateNonErrors) {
    if (_$iserror_19(maybeError)) {
      error = maybeError;
    } else {
      error = createAndLogInputError(typeof maybeError);
      internalFrames += 2;
    }
  } else {
    switch (typeof maybeError) {
      case 'string':
      case 'number':
      case 'boolean':
        error = new Error(String(maybeError));
        internalFrames += 1;
        break;

      case 'function':
        error = createAndLogInputError('function');
        internalFrames += 2;
        break;

      case 'object':
        if (maybeError !== null && _$iserror_19(maybeError)) {
          error = maybeError;
        } else if (maybeError !== null && hasNecessaryFields(maybeError)) {
          error = new Error(maybeError.message || maybeError.errorMessage);
          error.name = maybeError.name || maybeError.errorClass;
          internalFrames += 1;
        } else {
          error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
          internalFrames += 2;
        }

        break;

      default:
        error = createAndLogInputError('nothing');
        internalFrames += 2;
    }
  }

  if (!_$hasStack_18(error)) {
    // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
    try {
      throw error;
    } catch (e) {
      if (_$hasStack_18(e)) {
        error = e; // if the error only got a stacktrace after we threw it here, we know it
        // will only have one extra internal frame from this function, regardless
        // of whether it went through createAndLogInputError() or not

        internalFrames = 1;
      }
    }
  }

  return [error, internalFrames];
};

var hasNecessaryFields = function (error) {
  return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
};

var _$Event_6 = Event;

// This is a heavily modified/simplified version of
//   https://github.com/othiym23/async-some
// with the logic flipped so that it is akin to the
// synchronous "every" method instead of "some".
// run the asynchronous test function (fn) over each item in the array (arr)
// in series until:
//   - fn(item, cb) => calls cb(null, false)
//   - or the end of the array is reached
// the callback (cb) will be passed (null, false) if any of the items in arr
// caused fn to call back with false, otherwise it will be passed (null, true)
var _$asyncEvery_7 = function (arr, fn, cb) {
  var index = 0;

  var next = function () {
    if (index >= arr.length) return cb(null, true);
    fn(arr[index], function (err, result) {
      if (err) return cb(err);
      if (result === false) return cb(null, false);
      index++;
      next();
    });
  };

  next();
};

/* removed: var _$asyncEvery_7 = require('./async-every'); */;

var _$callbackRunner_9 = function (callbacks, event, onCallbackError, cb) {
  // This function is how we support different kinds of callback:
  //  - synchronous - return value
  //  - node-style async with callback - cb(err, value)
  //  - promise/thenable - resolve(value)
  // It normalises each of these into the lowest common denominator – a node-style callback
  var runMaybeAsyncCallback = function (fn, cb) {
    if (typeof fn !== 'function') return cb(null);

    try {
      // if function appears sync…
      if (fn.length !== 2) {
        var ret = fn(event); // check if it returned a "thenable" (promise)

        if (ret && typeof ret.then === 'function') {
          return ret.then( // resolve
          function (val) {
            return setTimeout(function () {
              return cb(null, val);
            });
          }, // reject
          function (err) {
            setTimeout(function () {
              onCallbackError(err);
              return cb(null, true);
            });
          });
        }

        return cb(null, ret);
      } // if function is async…


      fn(event, function (err, result) {
        if (err) {
          onCallbackError(err);
          return cb(null);
        }

        cb(null, result);
      });
    } catch (e) {
      onCallbackError(e);
      cb(null);
    }
  };

  _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
};

var _$syncCallbackRunner_23 = function (callbacks, callbackArg, callbackType, logger) {
  var ignore = false;
  var cbs = callbacks.slice();

  while (!ignore) {
    if (!cbs.length) break;

    try {
      ignore = cbs.pop()(callbackArg) === false;
    } catch (e) {
      logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
      logger.error(e);
    }
  }

  return ignore;
};

var _$pad_29 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_29 = require('./pad.js'); */;

var env = typeof window === 'object' ? window : self;
var globalCount = 0;

for (var prop in env) {
  if (Object.hasOwnProperty.call(env, prop)) globalCount++;
}

var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);

var _$fingerprint_28 = function fingerprint() {
  return clientId;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_29 = require('./lib/pad.js'); */;

var c = 0,
    blockSize = 4,
    base = 36,
    discreteValues = Math.pow(base, blockSize);

function randomBlock() {
  return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
}

function safeCounter() {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal

  return c - 1;
}

function cuid() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(base),
      // Prevent same-machine collisions.
  counter = _$pad_29(safeCounter().toString(base), blockSize),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_28(),
      // Grab some more chars from Math.random()
  random = randomBlock() + randomBlock();
  return letter + timestamp + counter + print + random;
}

cuid.fingerprint = _$fingerprint_28;
var _$cuid_27 = cuid;

/* removed: var _$cuid_27 = require('@bugsnag/cuid'); */;

var Session =
/*#__PURE__*/
function () {
  function Session() {
    this.id = _$cuid_27();
    this.startedAt = new Date();
    this._handled = 0;
    this._unhandled = 0;
    this._user = {};
    this.app = {};
    this.device = {};
  }

  var _proto = Session.prototype;

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto.toJSON = function toJSON() {
    return {
      id: this.id,
      startedAt: this.startedAt,
      events: {
        handled: this._handled,
        unhandled: this._unhandled
      }
    };
  };

  _proto._track = function _track(event) {
    this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
  };

  return Session;
}();

var _$Session_35 = Session;

/* removed: var _$config_5 = require('./config'); */;

/* removed: var _$Event_6 = require('./event'); */;

/* removed: var _$Breadcrumb_3 = require('./breadcrumb'); */;

/* removed: var _$Session_35 = require('./session'); */;

/* removed: var _$map_16 = require('./lib/es-utils/map'); */;

/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;

/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;

/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;

/* removed: var _$callbackRunner_9 = require('./lib/callback-runner'); */;

/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;

/* removed: var _$syncCallbackRunner_23 = require('./lib/sync-callback-runner'); */;

/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;

var noop = function () {};

var Client =
/*#__PURE__*/
function () {
  function Client(configuration, schema, internalPlugins, notifier) {
    var _this = this;

    if (schema === void 0) {
      schema = _$config_5.schema;
    }

    if (internalPlugins === void 0) {
      internalPlugins = [];
    }

    // notifier id
    this._notifier = notifier; // intialise opts and config

    this._config = {};
    this._schema = schema; // i/o

    this._delivery = {
      sendSession: noop,
      sendEvent: noop
    };
    this._logger = {
      debug: noop,
      info: noop,
      warn: noop,
      error: noop
    }; // plugins

    this._plugins = {}; // state

    this._breadcrumbs = [];
    this._session = null;
    this._metadata = {};
    this._context = undefined;
    this._user = {}; // callbacks:
    //  e: onError
    //  s: onSession
    //  sp: onSessionPayload
    //  b: onBreadcrumb
    // (note these names are minified by hand because object
    // properties are not safe to minify automatically)

    this._cbs = {
      e: [],
      s: [],
      sp: [],
      b: []
    }; // expose internal constructors

    this.Client = Client;
    this.Event = _$Event_6;
    this.Breadcrumb = _$Breadcrumb_3;
    this.Session = _$Session_35;
    this._config = this._configure(configuration, internalPlugins);
    _$map_16(internalPlugins.concat(this._config.plugins), function (pl) {
      if (pl) _this._loadPlugin(pl);
    }); // when notify() is called we need to know how many frames are from our own source
    // this inital value is 1 not 0 because we wrap notify() to ensure it is always
    // bound to have the client as its `this` value – see below.

    this._depth = 1;
    var self = this;
    var notify = this.notify;

    this.notify = function () {
      return notify.apply(self, arguments);
    };
  }

  var _proto = Client.prototype;

  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };

  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };

  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };

  _proto.getContext = function getContext() {
    return this._context;
  };

  _proto.setContext = function setContext(c) {
    this._context = c;
  };

  _proto._configure = function _configure(opts, internalPlugins) {
    var schema = _$reduce_17(internalPlugins, function (schema, plugin) {
      if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
      return schema;
    }, this._schema); // accumulate configuration and error messages

    var _reduce = _$reduce_17(_$keys_15(schema), function (accum, key) {
      var defaultValue = schema[key].defaultValue(opts[key]);

      if (opts[key] !== undefined) {
        var valid = schema[key].validate(opts[key]);

        if (!valid) {
          accum.errors[key] = schema[key].message;
          accum.config[key] = defaultValue;
        } else {
          if (schema[key].allowPartialObject) {
            accum.config[key] = _$assign_11(defaultValue, opts[key]);
          } else {
            accum.config[key] = opts[key];
          }
        }
      } else {
        accum.config[key] = defaultValue;
      }

      return accum;
    }, {
      errors: {},
      config: {}
    }),
        errors = _reduce.errors,
        config = _reduce.config;

    if (schema.apiKey) {
      // missing api key is the only fatal error
      if (!config.apiKey) throw new Error('No Bugsnag API Key set'); // warn about an apikey that is not of the expected format

      if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
    } // update and elevate some options


    this._metadata = _$assign_11({}, config.metadata);
    this._user = _$assign_11({}, config.user);
    this._context = config.context;
    if (config.logger) this._logger = config.logger; // add callbacks

    if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
    if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
    if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession); // finally warn about any invalid config where we fell back to the default

    if (_$keys_15(errors).length) {
      this._logger.warn(generateConfigErrorMessage(errors, opts));
    }

    return config;
  };

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto._loadPlugin = function _loadPlugin(plugin) {
    var result = plugin.load(this); // JS objects are not the safest way to store arbitrarily keyed values,
    // so bookend the key with some characters that prevent tampering with
    // stuff like __proto__ etc. (only store the result if the plugin had a
    // name)

    if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
    return this;
  };

  _proto.getPlugin = function getPlugin(name) {
    return this._plugins["~" + name + "~"];
  };

  _proto._setDelivery = function _setDelivery(d) {
    this._delivery = d(this);
  };

  _proto.startSession = function startSession() {
    var session = new _$Session_35();
    session.app.releaseStage = this._config.releaseStage;
    session.app.version = this._config.appVersion;
    session.app.type = this._config.appType;
    session._user = _$assign_11({}, this._user); // run onSession callbacks

    var ignore = _$syncCallbackRunner_23(this._cbs.s, session, 'onSession', this._logger);

    if (ignore) {
      this._logger.debug('Session not started due to onSession callback');

      return this;
    }

    return this._sessionDelegate.startSession(this, session);
  };

  _proto.addOnError = function addOnError(fn, front) {
    if (front === void 0) {
      front = false;
    }

    this._cbs.e[front ? 'unshift' : 'push'](fn);
  };

  _proto.removeOnError = function removeOnError(fn) {
    this._cbs.e = _$filter_12(this._cbs.e, function (f) {
      return f !== fn;
    });
  };

  _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
    this._cbs.sp.push(fn);
  };

  _proto.addOnSession = function addOnSession(fn) {
    this._cbs.s.push(fn);
  };

  _proto.removeOnSession = function removeOnSession(fn) {
    this._cbs.s = _$filter_12(this._cbs.s, function (f) {
      return f !== fn;
    });
  };

  _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
    if (front === void 0) {
      front = false;
    }

    this._cbs.b[front ? 'unshift' : 'push'](fn);
  };

  _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
    this._cbs.b = _$filter_12(this._cbs.b, function (f) {
      return f !== fn;
    });
  };

  _proto.pauseSession = function pauseSession() {
    return this._sessionDelegate.pauseSession(this);
  };

  _proto.resumeSession = function resumeSession() {
    return this._sessionDelegate.resumeSession(this);
  };

  _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
    // coerce bad values so that the defaults get set
    message = typeof message === 'string' ? message : '';
    type = typeof type === 'string' && _$includes_13(_$breadcrumbTypes_8, type) ? type : 'manual';
    metadata = typeof metadata === 'object' && metadata !== null ? metadata : {}; // if no message, discard

    if (!message) return;
    var crumb = new _$Breadcrumb_3(message, metadata, type); // run onBreadcrumb callbacks

    var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, 'onBreadcrumb', this._logger);

    if (ignore) {
      this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');

      return;
    } // push the valid crumb onto the queue and maintain the length


    this._breadcrumbs.push(crumb);

    if (this._breadcrumbs.length > this._config.maxBreadcrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
    }
  };

  _proto.notify = function notify(maybeError, onError, cb) {
    if (cb === void 0) {
      cb = noop;
    }

    var event = _$Event_6.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);

    this._notify(event, onError, cb);
  };

  _proto._notify = function _notify(event, onError, cb) {
    var _this2 = this;

    if (cb === void 0) {
      cb = noop;
    }

    event.app = _$assign_11({}, event.app, {
      releaseStage: this._config.releaseStage,
      version: this._config.appVersion,
      type: this._config.appType
    });
    event.context = event.context || this._context;
    event._metadata = _$assign_11({}, event._metadata, this._metadata);
    event._user = _$assign_11({}, event._user, this._user);
    event.breadcrumbs = this._breadcrumbs.slice();

    if (this._session) {
      this._session._track(event);

      event._session = this._session;
    } // exit early if events should not be sent on the current releaseStage


    if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
      this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');

      return cb(null, event);
    }

    var originalSeverity = event.severity;

    var onCallbackError = function (err) {
      // errors in callbacks are tolerated but we want to log them out
      _this2._logger.error('Error occurred in onError callback, continuing anyway…');

      _this2._logger.error(err);
    };

    var callbacks = [].concat(this._cbs.e).concat(onError);
    _$callbackRunner_9(callbacks, event, onCallbackError, function (err, shouldSend) {
      if (err) onCallbackError(err);

      if (!shouldSend) {
        _this2._logger.debug('Event not sent due to onError callback');

        return cb(null, event);
      }

      if (_$includes_13(_this2._config.enabledBreadcrumbTypes, 'error')) {
        // only leave a crumb for the error if actually got sent
        Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
          errorClass: event.errors[0].errorClass,
          errorMessage: event.errors[0].errorMessage,
          severity: event.severity
        }, 'error');
      }

      if (originalSeverity !== event.severity) {
        event._handledState.severityReason = {
          type: 'userCallbackSetSeverity'
        };
      }

      _this2._delivery.sendEvent({
        apiKey: event.apiKey || _this2._config.apiKey,
        notifier: _this2._notifier,
        events: [event]
      }, function (err) {
        return cb(err, event);
      });
    });
  };

  return Client;
}();

var generateConfigErrorMessage = function (errors, rawInput) {
  var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function (key) {
    return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
  }).join('\n\n'));
  return er;
};

var stringify = function (val) {
  switch (typeof val) {
    case 'string':
    case 'number':
    case 'object':
      return JSON.stringify(val);

    default:
      return String(val);
  }
};

var _$Client_4 = Client;

var _$safeJsonStringify_30 = function (data, replacer, space, opts) {
  var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
  var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
  return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
};

var MAX_DEPTH = 20;
var MAX_EDGES = 25000;
var MIN_PRESERVED_DEPTH = 8;
var REPLACEMENT_NODE = '...';

function __isError_30(o) {
  return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
}

function throwsMessage(err) {
  return '[Throws: ' + (err ? err.message : '?') + ']';
}

function find(haystack, needle) {
  for (var i = 0, len = haystack.length; i < len; i++) {
    if (haystack[i] === needle) return true;
  }

  return false;
} // returns true if the string `path` starts with any of the provided `paths`


function isDescendent(paths, path) {
  for (var i = 0, len = paths.length; i < len; i++) {
    if (path.indexOf(paths[i]) === 0) return true;
  }

  return false;
}

function shouldRedact(patterns, key) {
  for (var i = 0, len = patterns.length; i < len; i++) {
    if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
    if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
  }

  return false;
}

function __isArray_30(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function safelyGetProp(obj, prop) {
  try {
    return obj[prop];
  } catch (err) {
    return throwsMessage(err);
  }
}

function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
  var seen = []; // store references to objects we have seen before

  var edges = 0;

  function visit(obj, path) {
    function edgesExceeded() {
      return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
    }

    edges++;
    if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
    if (edgesExceeded()) return REPLACEMENT_NODE;
    if (obj === null || typeof obj !== 'object') return obj;
    if (find(seen, obj)) return '[Circular]';
    seen.push(obj);

    if (typeof obj.toJSON === 'function') {
      try {
        // we're not going to count this as an edge because it
        // replaces the value of the currently visited object
        edges--;
        var fResult = visit(obj.toJSON(), path);
        seen.pop();
        return fResult;
      } catch (err) {
        return throwsMessage(err);
      }
    }

    var er = __isError_30(obj);

    if (er) {
      edges--;
      var eResult = visit({
        name: obj.name,
        message: obj.message
      }, path);
      seen.pop();
      return eResult;
    }

    if (__isArray_30(obj)) {
      var aResult = [];

      for (var i = 0, len = obj.length; i < len; i++) {
        if (edgesExceeded()) {
          aResult.push(REPLACEMENT_NODE);
          break;
        }

        aResult.push(visit(obj[i], path.concat('[]')));
      }

      seen.pop();
      return aResult;
    }

    var result = {};

    try {
      for (var prop in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;

        if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
          result[prop] = '[REDACTED]';
          continue;
        }

        if (edgesExceeded()) {
          result[prop] = REPLACEMENT_NODE;
          break;
        }

        result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
      }
    } catch (e) {}

    seen.pop();
    return result;
  }

  return visit(obj, []);
}

var _$jsonPayload_21 = {};
/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;

var EVENT_REDACTION_PATHS = ['events.[].metaData', 'events.[].breadcrumbs.[].metaData', 'events.[].request'];

_$jsonPayload_21.event = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null, {
    redactedPaths: EVENT_REDACTION_PATHS,
    redactedKeys: redactedKeys
  });

  if (payload.length > 10e5) {
    event.events[0]._metadata = {
      notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
    };
    payload = _$safeJsonStringify_30(event, null, null, {
      redactedPaths: EVENT_REDACTION_PATHS,
      redactedKeys: redactedKeys
    });
    if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
  }

  return payload;
};

_$jsonPayload_21.session = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null);
  if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
  return payload;
};

var _$delivery_36 = {};
/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;

_$delivery_36 = function (client, win) {
  if (win === void 0) {
    win = window;
  }

  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      var url = getApiUrl(client._config, 'notify', '4', win);
      var req = new win.XDomainRequest();

      req.onload = function () {
        cb(null);
      };

      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.event(event, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);

          cb(e);
        }
      }, 0);
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      var url = getApiUrl(client._config, 'sessions', '1', win);
      var req = new win.XDomainRequest();

      req.onload = function () {
        cb(null);
      };

      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);

          cb(e);
        }
      }, 0);
    }
  };
};

var getApiUrl = function (config, endpoint, version, win) {
  // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
  // to an ISO string when you use JSON stringify. Simply parsing the result of
  // JSON.stringify is smaller than using a toISOstring() polyfill.
  var isoDate = JSON.parse(JSON.stringify(new Date()));
  var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
  return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
};

var matchPageProtocol = _$delivery_36._matchPageProtocol = function (endpoint, pageProtocol) {
  return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
};

/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;

var _$delivery_37 = function (client, win) {
  if (win === void 0) {
    win = window;
  }

  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      try {
        var url = client._config.endpoints.notify;
        var req = new win.XMLHttpRequest();

        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
        };

        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '4');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.event(event, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      try {
        var url = client._config.endpoints.sessions;
        var req = new win.XMLHttpRequest();

        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
        };

        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '1');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    }
  };
};

var appStart = new Date();
var _$app_38 = {
  load: function (client) {
    client.addOnError(function (event) {
      var now = new Date();
      event.app.duration = now - appStart;
    }, true);
  }
};

/*
 * Sets the default context to be the current URL
 */
var _$context_39 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.context !== undefined) return;
        event.context = win.location.pathname;
      }, true);
    }
  };
};

var _$pad_43 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_43 = require('./pad.js'); */;

var __env_42 = typeof window === 'object' ? window : self;
var __globalCount_42 = 0;

for (var __prop_42 in __env_42) {
  if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
}

var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);

var _$fingerprint_42 = function fingerprint() {
  return __clientId_42;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_43 = require('./lib/pad.js'); */;

var __c_41 = 0,
    __blockSize_41 = 4,
    __base_41 = 36,
    __discreteValues_41 = Math.pow(__base_41, __blockSize_41);

function __randomBlock_41() {
  return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
}

function __safeCounter_41() {
  __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
  __c_41++; // this is not subliminal

  return __c_41 - 1;
}

function __cuid_41() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(__base_41),
      // Prevent same-machine collisions.
  counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_42(),
      // Grab some more chars from Math.random()
  random = __randomBlock_41() + __randomBlock_41();
  return letter + timestamp + counter + print + random;
}

__cuid_41.fingerprint = _$fingerprint_42;
var _$cuid_41 = __cuid_41;

/* removed: var _$cuid_41 = require('@bugsnag/cuid'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';

var getDeviceId = function () {
  try {
    var storage = window.localStorage;
    var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY); // If we get an ID, make sure it looks like a valid cuid. The length can
    // fluctuate slightly, so some leeway is built in

    if (id && /^c[a-z0-9]{20,32}$/.test(id)) {
      return id;
    }

    id = _$cuid_41();
    storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
    return id;
  } catch (err) {// If localStorage is not available (e.g. because it's disabled) then give up
  }
};
/*
 * Automatically detects browser device details
 */


var _$device_40 = function (nav, screen) {
  if (nav === void 0) {
    nav = navigator;
  }

  if (screen === void 0) {
    screen = window.screen;
  }

  return {
    load: function (client) {
      var device = {
        locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
        userAgent: nav.userAgent
      };

      if (screen && screen.orientation && screen.orientation.type) {
        device.orientation = screen.orientation.type;
      } else {
        device.orientation = document.documentElement.clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';
      }

      if (client._config.generateAnonymousId) {
        device.id = getDeviceId();
      }

      client.addOnSession(function (session) {
        session.device = _$assign_11({}, session.device, device);
      }); // add time just as the event is sent

      client.addOnError(function (event) {
        event.device = _$assign_11({}, event.device, device, {
          time: new Date()
        });
      }, true);
    },
    configSchema: {
      generateAnonymousId: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
/*
 * Sets the event request: { url } to be the current href
 */


var _$request_44 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.request && event.request.url) return;
        event.request = _$assign_11({}, event.request, {
          url: win.location.href
        });
      }, true);
    }
  };
};

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;

var _$session_45 = {
  load: function (client) {
    client._sessionDelegate = sessionDelegate;
  }
};
var sessionDelegate = {
  startSession: function (client, session) {
    var sessionClient = client;
    sessionClient._session = session;
    sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled

    if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
      sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');

      return sessionClient;
    }

    sessionClient._delivery.sendSession({
      notifier: sessionClient._notifier,
      device: session.device,
      app: session.app,
      sessions: [{
        id: session.id,
        startedAt: session.startedAt,
        user: session._user
      }]
    });

    return sessionClient;
  },
  resumeSession: function (client) {
    if (client._pausedSession) {
      client._session = client._pausedSession;
      client._pausedSession = null;
      return client;
    } else {
      return client.startSession();
    }
  },
  pauseSession: function (client) {
    client._pausedSession = client._session;
    client._session = null;
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
/*
 * Prevent collection of user IPs
 */


var _$clientIp_46 = {
  load: function (client) {
    if (client._config.collectUserIp) return;
    client.addOnError(function (event) {
      // If user.id is explicitly undefined, it will be missing from the payload. It needs
      // removing so that the following line replaces it
      if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
      event._user = _$assign_11({
        id: '[REDACTED]'
      }, event._user);
      event.request = _$assign_11({
        clientIp: '[REDACTED]'
      }, event.request);
    });
  },
  configSchema: {
    collectUserIp: {
      defaultValue: function () {
        return true;
      },
      message: 'should be true|false',
      validate: function (value) {
        return value === true || value === false;
      }
    }
  }
};

var _$consoleBreadcrumbs_47 = {};
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
/*
 * Leaves breadcrumbs when console log methods are called
 */


_$consoleBreadcrumbs_47.load = function (client) {
  var isDev = /^dev(elopment)?$/.test(client._config.releaseStage);
  if (!client._config.enabledBreadcrumbTypes || !_$includes_13(client._config.enabledBreadcrumbTypes, 'log') || isDev) return;
  _$map_16(CONSOLE_LOG_METHODS, function (method) {
    var original = console[method];

    console[method] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      client.leaveBreadcrumb('Console output', _$reduce_17(args, function (accum, arg, i) {
        // do the best/simplest stringification of each argument
        var stringified = '[Unknown value]'; // this may fail if the input is:
        // - an object whose [[Prototype]] is null (no toString)
        // - an object with a broken toString or @@toPrimitive implementation

        try {
          stringified = String(arg);
        } catch (e) {} // if it stringifies to [object Object] attempt to JSON stringify


        if (stringified === '[object Object]') {
          // catch stringify errors and fallback to [object Object]
          try {
            stringified = JSON.stringify(arg);
          } catch (e) {}
        }

        accum["[" + i + "]"] = stringified;
        return accum;
      }, {
        severity: method.indexOf('group') === 0 ? 'log' : method
      }), 'log');
      original.apply(console, args);
    };

    console[method]._restore = function () {
      console[method] = original;
    };
  });
};

if (false) {
  _$consoleBreadcrumbs_47.destroy = function () {
    return CONSOLE_LOG_METHODS.forEach(function (method) {
      if (typeof console[method]._restore === 'function') console[method]._restore();
    });
  };
}

var CONSOLE_LOG_METHODS = _$filter_12(['log', 'debug', 'info', 'warn', 'error'], function (method) {
  return typeof console !== 'undefined' && typeof console[method] === 'function';
});

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;

var MAX_LINE_LENGTH = 200;
var MAX_SCRIPT_LENGTH = 500000;

var _$inlineScriptContent_48 = function (doc, win) {
  if (doc === void 0) {
    doc = document;
  }

  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!client._config.trackInlineScripts) return;
      var originalLocation = win.location.href;
      var html = '';
      var DOMContentLoaded = false;

      var getHtml = function () {
        return doc.documentElement.outerHTML;
      }; // get whatever HTML exists at this point in time


      html = getHtml();
      var prev = doc.onreadystatechange; // then update it when the DOM content has loaded

      doc.onreadystatechange = function () {
        // IE8 compatible alternative to document#DOMContentLoaded
        if (doc.readyState === 'interactive') {
          html = getHtml();
          DOMContentLoaded = true;
        }

        try {
          prev.apply(this, arguments);
        } catch (e) {}
      };

      var _lastScript = null;

      var updateLastScript = function (script) {
        _lastScript = script;
      };

      var getCurrentScript = function () {
        var script = doc.currentScript || _lastScript;

        if (!script && !DOMContentLoaded) {
          var scripts = doc.scripts || doc.getElementsByTagName('script');
          script = scripts[scripts.length - 1];
        }

        return script;
      };

      var addSurroundingCode = function (lineNumber) {
        // get whatever html has rendered at this point
        if (!DOMContentLoaded || !html) html = getHtml(); // simulate the raw html

        var htmlLines = ['<!-- DOC START -->'].concat(html.split('\n'));
        var zeroBasedLine = lineNumber - 1;
        var start = Math.max(zeroBasedLine - 3, 0);
        var end = Math.min(zeroBasedLine + 3, htmlLines.length);
        return _$reduce_17(htmlLines.slice(start, end), function (accum, line, i) {
          accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
          return accum;
        }, {});
      };

      client.addOnError(function (event) {
        // remove any of our own frames that may be part the stack this
        // happens before the inline script check as it happens for all errors
        event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function (f) {
          return !/__trace__$/.test(f.method);
        });
        var frame = event.errors[0].stacktrace[0]; // if frame.file exists and is not the original location of the page, this can't be an inline script

        if (frame && frame.file && frame.file.replace(/#.*$/, '') !== originalLocation.replace(/#.*$/, '')) return; // grab the last script known to have run

        var currentScript = getCurrentScript();

        if (currentScript) {
          var content = currentScript.innerHTML;
          event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
        } // only attempt to grab some surrounding code if we have a line number


        if (!frame || !frame.lineNumber) return;
        frame.code = addSurroundingCode(frame.lineNumber);
      }, true); // Proxy all the timer functions whose callback is their 0th argument.
      // Keep a reference to the original setTimeout because we need it later

      var _map = _$map_16(['setTimeout', 'setInterval', 'setImmediate', 'requestAnimationFrame'], function (fn) {
        return __proxy(win, fn, function (original) {
          return __traceOriginalScript(original, function (args) {
            return {
              get: function () {
                return args[0];
              },
              replace: function (fn) {
                args[0] = fn;
              }
            };
          });
        });
      }),
          _setTimeout = _map[0]; // Proxy all the host objects whose prototypes have an addEventListener function


      _$map_16(['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'], function (o) {
        if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;

        __proxy(win[o].prototype, 'addEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor);
        });

        __proxy(win[o].prototype, 'removeEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
        });
      });

      function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
        if (alsoCallOriginal === void 0) {
          alsoCallOriginal = false;
        }

        return function () {
          // this is required for removeEventListener to remove anything added with
          // addEventListener before the functions started being wrapped by Bugsnag
          var args = [].slice.call(arguments);

          try {
            var cba = callbackAccessor(args);
            var cb = cba.get();
            if (alsoCallOriginal) fn.apply(this, args);
            if (typeof cb !== 'function') return fn.apply(this, args);

            if (cb.__trace__) {
              cba.replace(cb.__trace__);
            } else {
              var script = getCurrentScript(); // this function mustn't be annonymous due to a bug in the stack
              // generation logic, meaning it gets tripped up
              // see: https://github.com/stacktracejs/stack-generator/issues/6

              cb.__trace__ = function __trace__() {
                // set the script that called this function
                updateLastScript(script); // immediately unset the currentScript synchronously below, however
                // if this cb throws an error the line after will not get run so schedule
                // an almost-immediate aysnc update too

                _setTimeout(function () {
                  updateLastScript(null);
                }, 0);

                var ret = cb.apply(this, arguments);
                updateLastScript(null);
                return ret;
              };

              cb.__trace__.__trace__ = cb.__trace__;
              cba.replace(cb.__trace__);
            }
          } catch (e) {} // swallow these errors on Selenium:
          // Permission denied to access property '__trace__'
          // WebDriverException: Message: Permission denied to access property "handleEvent"
          // IE8 doesn't let you call .apply() on setTimeout/setInterval


          if (fn.apply) return fn.apply(this, args);

          switch (args.length) {
            case 1:
              return fn(args[0]);

            case 2:
              return fn(args[0], args[1]);

            default:
              return fn();
          }
        };
      }
    },
    configSchema: {
      trackInlineScripts: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};

function __proxy(host, name, replacer) {
  var original = host[name];
  if (!original) return original;
  var replacement = replacer(original);
  host[name] = replacement;
  return original;
}

function eventTargetCallbackAccessor(args) {
  var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
  return {
    get: function () {
      return isEventHandlerObj ? args[1].handleEvent : args[1];
    },
    replace: function (fn) {
      if (isEventHandlerObj) {
        args[1].handleEvent = fn;
      } else {
        args[1] = fn;
      }
    }
  };
}

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
/*
 * Leaves breadcrumbs when the user interacts with the DOM
 */


var _$interactionBreadcrumbs_49 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._config.enabledBreadcrumbTypes || !_$includes_13(client._config.enabledBreadcrumbTypes, 'user')) return;
      win.addEventListener('click', function (event) {
        var targetText, targetSelector;

        try {
          targetText = getNodeText(event.target);
          targetSelector = getNodeSelector(event.target, win);
        } catch (e) {
          targetText = '[hidden]';
          targetSelector = '[hidden]';

          client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
        }

        client.leaveBreadcrumb('UI click', {
          targetText: targetText,
          targetSelector: targetSelector
        }, 'user');
      }, true);
    }
  };
}; // extract text content from a element


var getNodeText = function (el) {
  var text = el.textContent || el.innerText || '';
  if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
  text = text.replace(/^\s+|\s+$/g, ''); // trim whitespace

  return truncate(text, 140);
}; // Create a label from tagname, id and css class of the element


function getNodeSelector(el, win) {
  var parts = [el.tagName];
  if (el.id) parts.push('#' + el.id);
  if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.')); // Can't get much more advanced with the current browser

  if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');

  try {
    if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
  } catch (e) {
    // Sometimes the query selector can be invalid just return it as-is
    return parts.join('');
  } // try to get a more specific selector if this one matches more than one element


  if (el.parentNode.childNodes.length > 1) {
    var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
    parts.push(":nth-child(" + index + ")");
  }

  if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join(''); // try prepending the parent node selector

  if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
  return parts.join('');
}

function truncate(value, length) {
  var ommision = '(...)';
  if (value && value.length <= length) return value;
  return value.slice(0, length - ommision.length) + ommision;
}

var _$navigationBreadcrumbs_50 = {};
/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
/*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/


_$navigationBreadcrumbs_50 = function (win) {
  if (win === void 0) {
    win = window;
  }

  var plugin = {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._config.enabledBreadcrumbTypes || !_$includes_13(client._config.enabledBreadcrumbTypes, 'navigation')) return; // returns a function that will drop a breadcrumb with a given name

      var drop = function (name) {
        return function () {
          return client.leaveBreadcrumb(name, {}, 'navigation');
        };
      }; // simple drops – just names, no meta


      win.addEventListener('pagehide', drop('Page hidden'), true);
      win.addEventListener('pageshow', drop('Page shown'), true);
      win.addEventListener('load', drop('Page loaded'), true);
      win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true); // some browsers like to emit popstate when the page loads, so only add the popstate listener after that

      win.addEventListener('load', function () {
        return win.addEventListener('popstate', drop('Navigated back'), true);
      }); // hashchange has some metadata that we care about

      win.addEventListener('hashchange', function (event) {
        var metadata = event.oldURL ? {
          from: relativeLocation(event.oldURL, win),
          to: relativeLocation(event.newURL, win),
          state: getCurrentState(win)
        } : {
          to: relativeLocation(win.location.href, win)
        };
        client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
      }, true); // the only way to know about replaceState/pushState is to wrap them… >_<

      if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
      if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
      client.leaveBreadcrumb('Bugsnag loaded', {}, 'navigation');
    }
  };

  if (false) {
    plugin.destroy = function (win) {
      if (win === void 0) {
        win = window;
      }

      win.history.replaceState._restore();

      win.history.pushState._restore();
    };
  }

  return plugin;
};

if (false) {
  _$navigationBreadcrumbs_50.destroy = function (win) {
    if (win === void 0) {
      win = window;
    }

    win.history.replaceState._restore();

    win.history.pushState._restore();
  };
} // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
// just the path and hash parts, e.g. /pages/01.html?yes=no#section-2


var relativeLocation = function (url, win) {
  var a = win.document.createElement('A');
  a.href = url;
  return "" + a.pathname + a.search + a.hash;
};

var stateChangeToMetadata = function (win, state, title, url) {
  var currentPath = relativeLocation(win.location.href, win);
  return {
    title: title,
    state: state,
    prevState: getCurrentState(win),
    to: url || currentPath,
    from: currentPath
  };
};

var wrapHistoryFn = function (client, target, fn, win) {
  var orig = target[fn];

  target[fn] = function (state, title, url) {
    client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation'); // if throttle plugin is in use, reset the event sent count

    if (typeof client.resetEventCount === 'function') client.resetEventCount(); // if the client is operating in auto session-mode, a new route should trigger a new session

    if (client._config.autoTrackSessions) client.startSession(); // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
    // to '/undefined'. therefore we only pass the url if it's not undefined.

    orig.apply(target, [state, title].concat(url !== undefined ? url : []));
  };

  if (false) {
    target[fn]._restore = function () {
      target[fn] = orig;
    };
  }
};

var getCurrentState = function (win) {
  try {
    return win.history.state;
  } catch (e) {}
};

var BREADCRUMB_TYPE = 'request'; // keys to safely store metadata on the request object

var REQUEST_SETUP_KEY = 'BS~~S';
var REQUEST_URL_KEY = 'BS~~U';
var REQUEST_METHOD_KEY = 'BS~~M';

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
/*
 * Leaves breadcrumbs when network requests occur
 */


var _$networkBreadcrumbs_51 = function (_ignoredUrls, win) {
  if (_ignoredUrls === void 0) {
    _ignoredUrls = [];
  }

  if (win === void 0) {
    win = window;
  }

  var restoreFunctions = [];
  var plugin = {
    load: function (client) {
      if (!client._config.enabledBreadcrumbTypes || !_$includes_13(client._config.enabledBreadcrumbTypes, 'request')) return;
      var ignoredUrls = [client._config.endpoints.notify, client._config.endpoints.sessions].concat(_ignoredUrls);
      monkeyPatchXMLHttpRequest();
      monkeyPatchFetch(); // XMLHttpRequest monkey patch

      function monkeyPatchXMLHttpRequest() {
        if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
        var nativeOpen = win.XMLHttpRequest.prototype.open; // override native open()

        win.XMLHttpRequest.prototype.open = function open(method, url) {
          // store url and HTTP method for later
          this[REQUEST_URL_KEY] = url;
          this[REQUEST_METHOD_KEY] = method; // if we have already setup listeners, it means open() was called twice, we need to remove
          // the listeners and recreate them

          if (this[REQUEST_SETUP_KEY]) {
            this.removeEventListener('load', handleXHRLoad);
            this.removeEventListener('error', handleXHRError);
          } // attach load event listener


          this.addEventListener('load', handleXHRLoad); // attach error event listener

          this.addEventListener('error', handleXHRError);
          this[REQUEST_SETUP_KEY] = true;
          nativeOpen.apply(this, arguments);
        };

        if (false) {
          restoreFunctions.push(function () {
            win.XMLHttpRequest.prototype.open = nativeOpen;
          });
        }
      }

      function handleXHRLoad() {
        if (_$includes_13(ignoredUrls, this[REQUEST_URL_KEY])) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        }

        var metadata = {
          status: this.status,
          request: this[REQUEST_METHOD_KEY] + " " + this[REQUEST_URL_KEY]
        };

        if (this.status >= 400) {
          // contacted server but got an error response
          client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
        }
      }

      function handleXHRError() {
        if (_$includes_13(ignoredUrls, this[REQUEST_URL_KEY])) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        } // failed to contact server


        client.leaveBreadcrumb('XMLHttpRequest error', {
          request: this[REQUEST_METHOD_KEY] + " " + this[REQUEST_URL_KEY]
        }, BREADCRUMB_TYPE);
      } // window.fetch monkey patch


      function monkeyPatchFetch() {
        // only patch it if it exists and if it is not a polyfill (patching a polyfilled
        // fetch() results in duplicate breadcrumbs for the same request because the
        // implementation uses XMLHttpRequest which is also patched)
        if (!('fetch' in win) || win.fetch.polyfill) return;
        var oldFetch = win.fetch;

        win.fetch = function fetch() {
          var _arguments = arguments;
          var urlOrRequest = arguments[0];
          var options = arguments[1];
          var method;
          var url = null;

          if (urlOrRequest && typeof urlOrRequest === 'object') {
            url = urlOrRequest.url;

            if (options && 'method' in options) {
              method = options.method;
            } else if (urlOrRequest && 'method' in urlOrRequest) {
              method = urlOrRequest.method;
            }
          } else {
            url = urlOrRequest;

            if (options && 'method' in options) {
              method = options.method;
            }
          }

          if (method === undefined) {
            method = 'GET';
          }

          return new Promise(function (resolve, reject) {
            // pass through to native fetch
            oldFetch.apply(void 0, _arguments).then(function (response) {
              handleFetchSuccess(response, method, url);
              resolve(response);
            })["catch"](function (error) {
              handleFetchError(method, url);
              reject(error);
            });
          });
        };

        if (false) {
          restoreFunctions.push(function () {
            win.fetch = oldFetch;
          });
        }
      }

      var handleFetchSuccess = function (response, method, url) {
        var metadata = {
          status: response.status,
          request: method + " " + url
        };

        if (response.status >= 400) {
          // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
          client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
        }
      };

      var handleFetchError = function (method, url) {
        client.leaveBreadcrumb('fetch() error', {
          request: method + " " + url
        }, BREADCRUMB_TYPE);
      };
    }
  };

  if (false) {
    plugin.destroy = function () {
      restoreFunctions.forEach(function (fn) {
        return fn();
      });
      restoreFunctions = [];
    };
  }

  return plugin;
};

/* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */;
/*
 * Throttles and dedupes events
 */


var _$throttle_52 = {
  load: function (client) {
    // track sent events for each init of the plugin
    var n = 0; // add onError hook

    client.addOnError(function (event) {
      // have max events been sent already?
      if (n >= client._config.maxEvents) return false;
      n++;
    });

    client.resetEventCount = function () {
      n = 0;
    };
  },
  configSchema: {
    maxEvents: {
      defaultValue: function () {
        return 10;
      },
      message: 'should be a positive integer ≤100',
      validate: function (val) {
        return _$intRange_24(1, 100)(val);
      }
    }
  }
};

var _$stripQueryString_53 = {};
/*
 * Remove query strings (and fragments) from stacktraces
 */
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

_$stripQueryString_53 = {
  load: function (client) {
    client.addOnError(function (event) {
      var allFrames = _$reduce_17(event.errors, function (accum, er) {
        return accum.concat(er.stacktrace);
      }, []);
      _$map_16(allFrames, function (frame) {
        frame.file = strip(frame.file);
      });
    });
  }
};

var strip = _$stripQueryString_53._strip = function (str) {
  return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
};

/*
 * Automatically notifies Bugsnag when window.onerror is called
 */
var _$onerror_54 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!client._config.autoDetectErrors) return;
      if (!client._config.enabledErrorTypes.unhandledExceptions) return;

      function onerror(messageOrEvent, url, lineNo, charNo, error) {
        // Ignore errors with no info due to CORS settings
        if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) {
          client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
        } else {
          // any error sent to window.onerror is unhandled and has severity=error
          var handledState = {
            severity: 'error',
            unhandled: true,
            severityReason: {
              type: 'unhandledException'
            }
          };
          var event; // window.onerror can be called in a number of ways. This big if-else is how we
          // figure out which arguments were supplied, and what kind of values it received.

          if (error) {
            // if the last parameter (error) was supplied, this is a modern browser's
            // way of saying "this value was thrown and not caught"
            event = client.Event.create(error, true, handledState, 'window onerror', 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          } else if ( // This complex case detects "error" events that are typically synthesised
          // by jquery's trigger method (although can be created in other ways). In
          // order to detect this:
          // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
          // - the second argument (url) must either not exist or be something other than a string (if it
          //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
          //    function)
          // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
          typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
            // The jQuery event may have a "type" property, if so use it as part of the error message
            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error'; // attempt to find a message from one of the conventional properties, but
            // default to empty string (the event will fill it with a placeholder)

            var message = messageOrEvent.message || messageOrEvent.detail || '';
            event = client.Event.create({
              name: name,
              message: message
            }, true, handledState, 'window onerror', 1); // provide the original thing onerror received – not our error-like object we passed to _notify

            event.originalError = messageOrEvent; // include the raw input as metadata – it might contain more info than we extracted

            event.addMetadata('window onerror', {
              event: messageOrEvent,
              extraParameters: url
            });
          } else {
            // Lastly, if there was no "error" parameter this event was probably from an old
            // browser that doesn't support that. Instead we need to generate a stacktrace.
            event = client.Event.create(messageOrEvent, true, handledState, 'window onerror', 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          }

          client._notify(event);
        }

        if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
      }

      var prevOnError = win.onerror;
      win.onerror = onerror;
    }
  };
}; // Sometimes the stacktrace has less information than was passed to window.onerror.
// This function will augment the first stackframe with any useful info that was
// received as arguments to the onerror callback.


var decorateStack = function (stack, url, lineNo, charNo) {
  if (!stack[0]) stack.push({});
  var culprit = stack[0];
  if (!culprit.file && typeof url === 'string') culprit.file = url;
  if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;

  if (!culprit.columnNumber) {
    if (isActualNumber(charNo)) {
      culprit.columnNumber = charNo;
    } else if (window.event && isActualNumber(window.event.errorCharacter)) {
      culprit.columnNumber = window.event.errorCharacter;
    }
  }
};

var isActualNumber = function (n) {
  return typeof n === 'number' && String.call(n) !== 'NaN';
};

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$iserror_19 = require('@bugsnag/core/lib/iserror'); */;

var _listener;
/*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */


var _$unhandledRejection_55 = function (win) {
  if (win === void 0) {
    win = window;
  }

  var plugin = {
    load: function (client) {
      if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;

      var listener = function (evt) {
        var error = evt.reason;
        var isBluebird = false; // accessing properties on evt.detail can throw errors (see #394)

        try {
          if (evt.detail && evt.detail.reason) {
            error = evt.detail.reason;
            isBluebird = true;
          }
        } catch (e) {}

        var event = client.Event.create(error, false, {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledPromiseRejection'
          }
        }, 'unhandledrejection handler', 1, client._logger);

        if (isBluebird) {
          _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
        }

        client._notify(event, function (event) {
          if (_$iserror_19(event.originalError) && !event.originalError.stack) {
            var _event$addMetadata;

            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
              name: event.originalError.name,
              message: event.originalError.message,
              code: event.originalError.code
            }, _event$addMetadata));
          }
        });
      };

      if ('addEventListener' in win) {
        win.addEventListener('unhandledrejection', listener);
      } else {
        win.onunhandledrejection = function (reason, promise) {
          listener({
            detail: {
              reason: reason,
              promise: promise
            }
          });
        };
      }

      _listener = listener;
    }
  };

  if (false) {
    plugin.destroy = function (win) {
      if (win === void 0) {
        win = window;
      }

      if (_listener) {
        if ('addEventListener' in win) {
          win.removeEventListener('unhandledrejection', _listener);
        } else {
          win.onunhandledrejection = null;
        }
      }

      _listener = null;
    };
  }

  return plugin;
}; // The stack parser on bluebird stacks in FF get a suprious first frame:
//
// Error: derp
//   b@http://localhost:5000/bluebird.html:22:24
//   a@http://localhost:5000/bluebird.html:18:9
//   @http://localhost:5000/bluebird.html:14:9
//
// results in
//   […]
//     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
//     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
//     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
//     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
//
// so the following reduce/accumulator function removes such frames
//
// Bluebird pads method names with spaces so trim that too…
// https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571


var fixBluebirdStacktrace = function (error) {
  return function (frame) {
    if (frame.file === error.toString()) return;

    if (frame.method) {
      frame.method = frame.method.replace(/^\s+/, '');
    }
  };
};

var _$notifier_2 = {};
var name = 'Bugsnag JavaScript';
var version = '7.5.1';
var url = 'https://github.com/bugsnag/bugsnag-js';

/* removed: var _$Client_4 = require('@bugsnag/core/client'); */;

/* removed: var _$Event_6 = require('@bugsnag/core/event'); */;

/* removed: var _$Session_35 = require('@bugsnag/core/session'); */;

/* removed: var _$Breadcrumb_3 = require('@bugsnag/core/breadcrumb'); */;

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$keys_15 = require('@bugsnag/core/lib/es-utils/keys'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */; // extend the base config schema with some browser-specific options


var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1);

/* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */;

/* removed: var _$unhandledRejection_55 = require('@bugsnag/plugin-window-unhandled-rejection'); */;

/* removed: var _$app_38 = require('@bugsnag/plugin-app-duration'); */;

/* removed: var _$device_40 = require('@bugsnag/plugin-browser-device'); */;

/* removed: var _$context_39 = require('@bugsnag/plugin-browser-context'); */;

/* removed: var _$request_44 = require('@bugsnag/plugin-browser-request'); */;

/* removed: var _$throttle_52 = require('@bugsnag/plugin-simple-throttle'); */;

/* removed: var _$consoleBreadcrumbs_47 = require('@bugsnag/plugin-console-breadcrumbs'); */;

/* removed: var _$networkBreadcrumbs_51 = require('@bugsnag/plugin-network-breadcrumbs'); */;

/* removed: var _$navigationBreadcrumbs_50 = require('@bugsnag/plugin-navigation-breadcrumbs'); */;

/* removed: var _$interactionBreadcrumbs_49 = require('@bugsnag/plugin-interaction-breadcrumbs'); */;

/* removed: var _$inlineScriptContent_48 = require('@bugsnag/plugin-inline-script-content'); */;

/* removed: var _$session_45 = require('@bugsnag/plugin-browser-session'); */;

/* removed: var _$clientIp_46 = require('@bugsnag/plugin-client-ip'); */;

/* removed: var _$stripQueryString_53 = require('@bugsnag/plugin-strip-query-string'); */; // delivery mechanisms


/* removed: var _$delivery_36 = require('@bugsnag/delivery-x-domain-request'); */;

/* removed: var _$delivery_37 = require('@bugsnag/delivery-xml-http-request'); */;

var Bugsnag = {
  _client: null,
  createClient: function (opts) {
    // handle very simple use case where user supplies just the api key as a string
    if (typeof opts === 'string') opts = {
      apiKey: opts
    };
    if (!opts) opts = {};
    var internalPlugins = [// add browser-specific plugins
    _$app_38, _$device_40(), _$context_39(), _$request_44(), _$throttle_52, _$session_45, _$clientIp_46, _$stripQueryString_53, _$onerror_54(), _$unhandledRejection_55(), _$navigationBreadcrumbs_50(), _$interactionBreadcrumbs_49(), _$networkBreadcrumbs_51(), _$consoleBreadcrumbs_47, // this one added last to avoid wrapping functionality before bugsnag uses it
    _$inlineScriptContent_48()]; // configure a client with user supplied options

    var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
      name: name,
      version: version,
      url: url
    }); // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)

    bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);

    bugsnag._logger.debug('Loaded!');

    return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
  },
  start: function (opts) {
    if (Bugsnag._client) {
      Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');

      return Bugsnag._client;
    }

    Bugsnag._client = Bugsnag.createClient(opts);
    return Bugsnag._client;
  }
};
_$map_16(['resetEventCount'].concat(_$keys_15(_$Client_4.prototype)), function (m) {
  if (/^_/.test(m)) return;

  Bugsnag[m] = function () {
    if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
    Bugsnag._client._depth += 1;

    var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);

    Bugsnag._client._depth -= 1;
    return ret;
  };
});
_$notifier_2 = Bugsnag;
_$notifier_2.Client = _$Client_4;
_$notifier_2.Event = _$Event_6;
_$notifier_2.Session = _$Session_35;
_$notifier_2.Breadcrumb = _$Breadcrumb_3; // Export a "default" property for compatibility with ESM imports

_$notifier_2["default"] = Bugsnag;

return _$notifier_2;

});
//# sourceMappingURL=bugsnag.js.map


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.BugsnagPluginVue = f()}})(function(){var define,module,exports;
var _$src_1 = {};
var _this = this;

_$src_1 =
/*#__PURE__*/
function () {
  function BugsnagPluginVue() {
    // Fetch Vue from the window object, if it exists
    var globalVue = typeof window !== 'undefined' && window.Vue;
    this.name = 'vue';
    this.lazy = arguments.length === 0 && !globalVue;

    if (!this.lazy) {
      this.Vue = (arguments.length <= 0 ? undefined : arguments[0]) || globalVue;
      if (!this.Vue) throw new Error('@bugsnag/plugin-vue reference to `Vue` was undefined');
    }
  }

  var _proto = BugsnagPluginVue.prototype;

  _proto.load = function load(client) {
    if (this.Vue) {
      install(this.Vue, client);
      return {
        installVueErrorHandler: function () {
          return client._logger.warn('installVueErrorHandler() was called unnecessarily');
        }
      };
    }

    return {
      installVueErrorHandler: function (Vue) {
        if (!Vue) client._logger.error(new Error('@bugsnag/plugin-vue reference to `Vue` was undefined'));
        install(Vue, client);
      }
    };
  };

  return BugsnagPluginVue;
}();

var install = function (Vue, client) {
  var prev = Vue.config.errorHandler;

  var handler = function (err, vm, info) {
    var handledState = {
      severity: 'error',
      unhandled: true,
      severityReason: {
        type: 'unhandledException'
      }
    };
    var event = client.Event.create(err, true, handledState, 1);
    event.addMetadata('vue', {
      errorInfo: info,
      component: vm ? formatComponentName(vm, true) : undefined,
      props: vm ? vm.$options.propsData : undefined
    });

    client._notify(event);

    if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err);
    if (typeof prev === 'function') prev.call(_this, err, vm, info);
  };

  Vue.config.errorHandler = handler;
}; // taken and reworked from Vue.js source


var formatComponentName = function (vm, includeFile) {
  if (vm.$root === vm) return '<Root>';
  var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
  var name = options.name || options._componentTag;
  var file = options.__file;

  if (!name && file) {
    var match = file.match(/([^/\\]+)\.vue$/);
    name = match && match[1];
  }

  return (name ? '<' + classify(name) + '>' : '<Anonymous>') + (file && includeFile !== false ? ' at ' + file : '');
}; // taken and reworked from Vue.js source


var classify = _$src_1.classify = function (str) {
  return str.replace(/(?:^|[-_])(\w)/g, function (c) {
    return c.toUpperCase();
  }).replace(/[-_]/g, '');
};

return _$src_1;

});
//# sourceMappingURL=bugsnag-vue.js.map


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js